
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4626"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4626"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aTPuV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $7ef6fcd62fb1d91d$export$ffb0004e005737fa; }, function (v) { return $7ef6fcd62fb1d91d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $7ef6fcd62fb1d91d$export$34b9dba7ce09269b; }, function (v) { return $7ef6fcd62fb1d91d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $7ef6fcd62fb1d91d$export$25062201e9e25d76; }, function (v) { return $7ef6fcd62fb1d91d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7ef6fcd62fb1d91d$export$ffb0004e005737fa;
var $7ef6fcd62fb1d91d$export$34b9dba7ce09269b;
var $7ef6fcd62fb1d91d$export$25062201e9e25d76;
"use strict";
var $7ef6fcd62fb1d91d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $7ef6fcd62fb1d91d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $7ef6fcd62fb1d91d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $7ef6fcd62fb1d91d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$7ef6fcd62fb1d91d$export$ffb0004e005737fa = $7ef6fcd62fb1d91d$var$REACT_FRAGMENT_TYPE;
$7ef6fcd62fb1d91d$export$34b9dba7ce09269b = $7ef6fcd62fb1d91d$var$jsxProd;
$7ef6fcd62fb1d91d$export$25062201e9e25d76 = $7ef6fcd62fb1d91d$var$jsxProd;

});

parcelRegister("9qC4w", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.6.4", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\0") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Make sure the the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                // Support: IE <9 only
                // IE doesn't have `contains` on `document` so we need to check for
                // `documentElement` presence.
                // We need to fall back to `a` when `documentElement` is missing
                // as `ownerDocument` of elements within `<template/>` may have
                // a null one - a default behavior of all modern browsers.
                var adown = a.nodeType === 9 && a.documentElement || a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is blurred by
                            // clicking outside of it, it invokes the handler synchronously. If
                            // that handler calls `.remove()` on the element, the data is cleared,
                            // leaving `result` undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("ko9PG", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $ed7dad10c0d7dd15$export$9c16c1426311996d; }, function (v) { return $ed7dad10c0d7dd15$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $ed7dad10c0d7dd15$export$dca3b0875bd9a954; }, function (v) { return $ed7dad10c0d7dd15$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ed7dad10c0d7dd15$export$16fa2f45be04daa8; }, function (v) { return $ed7dad10c0d7dd15$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ed7dad10c0d7dd15$export$ffb0004e005737fa; }, function (v) { return $ed7dad10c0d7dd15$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ed7dad10c0d7dd15$export$e2c29f18771995cb; }, function (v) { return $ed7dad10c0d7dd15$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ed7dad10c0d7dd15$export$221d75b3f55bb0bd; }, function (v) { return $ed7dad10c0d7dd15$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ed7dad10c0d7dd15$export$5f8d39834fd61797; }, function (v) { return $ed7dad10c0d7dd15$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ed7dad10c0d7dd15$export$74bf444e3cd11ea5; }, function (v) { return $ed7dad10c0d7dd15$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $ed7dad10c0d7dd15$export$1ced07cd6b1985ce; }, function (v) { return $ed7dad10c0d7dd15$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $ed7dad10c0d7dd15$export$abd8e32b826d7ea7; }, function (v) { return $ed7dad10c0d7dd15$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $ed7dad10c0d7dd15$export$69a3209f1a06c04d; }, function (v) { return $ed7dad10c0d7dd15$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $ed7dad10c0d7dd15$export$8c538325882c7eec; }, function (v) { return $ed7dad10c0d7dd15$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ed7dad10c0d7dd15$export$e530037191fcd5d7; }, function (v) { return $ed7dad10c0d7dd15$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ed7dad10c0d7dd15$export$fd42f52fd3ae1109; }, function (v) { return $ed7dad10c0d7dd15$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ed7dad10c0d7dd15$export$c8a8987d4410bf2d; }, function (v) { return $ed7dad10c0d7dd15$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $ed7dad10c0d7dd15$export$7d1e3a5e95ceca43; }, function (v) { return $ed7dad10c0d7dd15$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ed7dad10c0d7dd15$export$257a8862b851cb5b; }, function (v) { return $ed7dad10c0d7dd15$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ed7dad10c0d7dd15$export$a8257692ac88316c; }, function (v) { return $ed7dad10c0d7dd15$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ed7dad10c0d7dd15$export$488013bae63b21da; }, function (v) { return $ed7dad10c0d7dd15$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ed7dad10c0d7dd15$export$7c73462e0d25e514; }, function (v) { return $ed7dad10c0d7dd15$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ed7dad10c0d7dd15$export$7568632d0d33d16d; }, function (v) { return $ed7dad10c0d7dd15$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8; }, function (v) { return $ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $ed7dad10c0d7dd15$export$1f96ae73734a86cc; }, function (v) { return $ed7dad10c0d7dd15$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $ed7dad10c0d7dd15$export$9a47ced3238df325; }, function (v) { return $ed7dad10c0d7dd15$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ed7dad10c0d7dd15$export$35808ee640e87ca7; }, function (v) { return $ed7dad10c0d7dd15$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ed7dad10c0d7dd15$export$fae74005e78b1a27; }, function (v) { return $ed7dad10c0d7dd15$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e; }, function (v) { return $ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ed7dad10c0d7dd15$export$6a7bc4e911dc01cf; }, function (v) { return $ed7dad10c0d7dd15$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ed7dad10c0d7dd15$export$6d9c69b0de29b591; }, function (v) { return $ed7dad10c0d7dd15$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $ed7dad10c0d7dd15$export$7f54fc3180508a52; }, function (v) { return $ed7dad10c0d7dd15$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $ed7dad10c0d7dd15$export$f680877a34711e37; }, function (v) { return $ed7dad10c0d7dd15$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ed7dad10c0d7dd15$export$d5a552a76deda3c2; }, function (v) { return $ed7dad10c0d7dd15$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ed7dad10c0d7dd15$export$aaabe4eda9ed9969; }, function (v) { return $ed7dad10c0d7dd15$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ed7dad10c0d7dd15$export$e5c5a5f917a5871c; }, function (v) { return $ed7dad10c0d7dd15$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ed7dad10c0d7dd15$export$1538c33de8887b59; }, function (v) { return $ed7dad10c0d7dd15$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $ed7dad10c0d7dd15$export$fca7f784ae7a249a; }, function (v) { return $ed7dad10c0d7dd15$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $ed7dad10c0d7dd15$export$13e3392192263954; }, function (v) { return $ed7dad10c0d7dd15$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ed7dad10c0d7dd15$export$b8f5890fc79d6aca; }, function (v) { return $ed7dad10c0d7dd15$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ed7dad10c0d7dd15$export$60241385465d0a34; }, function (v) { return $ed7dad10c0d7dd15$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ed7dad10c0d7dd15$export$306c0aa65ff9ec16; }, function (v) { return $ed7dad10c0d7dd15$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ed7dad10c0d7dd15$export$7b286972b8d8ccbf; }, function (v) { return $ed7dad10c0d7dd15$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ed7dad10c0d7dd15$export$83d89fbfd8236492; }, function (v) { return $ed7dad10c0d7dd15$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed7dad10c0d7dd15$export$9c16c1426311996d;
var $ed7dad10c0d7dd15$export$dca3b0875bd9a954;
var $ed7dad10c0d7dd15$export$16fa2f45be04daa8;
var $ed7dad10c0d7dd15$export$ffb0004e005737fa;
var $ed7dad10c0d7dd15$export$e2c29f18771995cb;
var $ed7dad10c0d7dd15$export$221d75b3f55bb0bd;
var $ed7dad10c0d7dd15$export$5f8d39834fd61797;
var $ed7dad10c0d7dd15$export$74bf444e3cd11ea5;
var $ed7dad10c0d7dd15$export$1ced07cd6b1985ce;
var $ed7dad10c0d7dd15$export$abd8e32b826d7ea7;
var $ed7dad10c0d7dd15$export$69a3209f1a06c04d;
var $ed7dad10c0d7dd15$export$8c538325882c7eec;
var $ed7dad10c0d7dd15$export$e530037191fcd5d7;
var $ed7dad10c0d7dd15$export$fd42f52fd3ae1109;
var $ed7dad10c0d7dd15$export$c8a8987d4410bf2d;
var $ed7dad10c0d7dd15$export$7d1e3a5e95ceca43;
var $ed7dad10c0d7dd15$export$257a8862b851cb5b;
var $ed7dad10c0d7dd15$export$a8257692ac88316c;
var $ed7dad10c0d7dd15$export$488013bae63b21da;
var $ed7dad10c0d7dd15$export$7c73462e0d25e514;
var $ed7dad10c0d7dd15$export$7568632d0d33d16d;
var $ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8;
var $ed7dad10c0d7dd15$export$1f96ae73734a86cc;
var $ed7dad10c0d7dd15$export$9a47ced3238df325;
var $ed7dad10c0d7dd15$export$35808ee640e87ca7;
var $ed7dad10c0d7dd15$export$fae74005e78b1a27;
var $ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e;
var $ed7dad10c0d7dd15$export$6a7bc4e911dc01cf;
var $ed7dad10c0d7dd15$export$6d9c69b0de29b591;
var $ed7dad10c0d7dd15$export$7f54fc3180508a52;
var $ed7dad10c0d7dd15$export$f680877a34711e37;
var $ed7dad10c0d7dd15$export$d5a552a76deda3c2;
var $ed7dad10c0d7dd15$export$aaabe4eda9ed9969;
var $ed7dad10c0d7dd15$export$e5c5a5f917a5871c;
var $ed7dad10c0d7dd15$export$1538c33de8887b59;
var $ed7dad10c0d7dd15$export$fca7f784ae7a249a;
var $ed7dad10c0d7dd15$export$13e3392192263954;
var $ed7dad10c0d7dd15$export$b8f5890fc79d6aca;
var $ed7dad10c0d7dd15$export$60241385465d0a34;
var $ed7dad10c0d7dd15$export$306c0aa65ff9ec16;
var $ed7dad10c0d7dd15$export$7b286972b8d8ccbf;
var $ed7dad10c0d7dd15$export$83d89fbfd8236492;

var $4dBQg = parcelRequire("4dBQg");
"use strict";
var $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ed7dad10c0d7dd15$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ed7dad10c0d7dd15$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ed7dad10c0d7dd15$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ed7dad10c0d7dd15$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $ed7dad10c0d7dd15$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ed7dad10c0d7dd15$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ed7dad10c0d7dd15$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ed7dad10c0d7dd15$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ed7dad10c0d7dd15$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ed7dad10c0d7dd15$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $ed7dad10c0d7dd15$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $ed7dad10c0d7dd15$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $ed7dad10c0d7dd15$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $ed7dad10c0d7dd15$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$ed7dad10c0d7dd15$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $ed7dad10c0d7dd15$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $ed7dad10c0d7dd15$var$assign = Object.assign, $ed7dad10c0d7dd15$var$emptyObject = {};
function $ed7dad10c0d7dd15$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $ed7dad10c0d7dd15$var$emptyObject;
    this.updater = updater || $ed7dad10c0d7dd15$var$ReactNoopUpdateQueue;
}
$ed7dad10c0d7dd15$var$Component.prototype.isReactComponent = {};
$ed7dad10c0d7dd15$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$ed7dad10c0d7dd15$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $ed7dad10c0d7dd15$var$ComponentDummy() {}
$ed7dad10c0d7dd15$var$ComponentDummy.prototype = $ed7dad10c0d7dd15$var$Component.prototype;
function $ed7dad10c0d7dd15$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $ed7dad10c0d7dd15$var$emptyObject;
    this.updater = updater || $ed7dad10c0d7dd15$var$ReactNoopUpdateQueue;
}
var $ed7dad10c0d7dd15$var$pureComponentPrototype = $ed7dad10c0d7dd15$var$PureComponent.prototype = new $ed7dad10c0d7dd15$var$ComponentDummy();
$ed7dad10c0d7dd15$var$pureComponentPrototype.constructor = $ed7dad10c0d7dd15$var$PureComponent;
$ed7dad10c0d7dd15$var$assign($ed7dad10c0d7dd15$var$pureComponentPrototype, $ed7dad10c0d7dd15$var$Component.prototype);
$ed7dad10c0d7dd15$var$pureComponentPrototype.isPureReactComponent = !0;
var $ed7dad10c0d7dd15$var$isArrayImpl = Array.isArray;
function $ed7dad10c0d7dd15$var$noop() {}
var $ed7dad10c0d7dd15$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $ed7dad10c0d7dd15$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ed7dad10c0d7dd15$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $ed7dad10c0d7dd15$var$cloneAndReplaceKey(oldElement, newKey) {
    return $ed7dad10c0d7dd15$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $ed7dad10c0d7dd15$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE;
}
function $ed7dad10c0d7dd15$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $ed7dad10c0d7dd15$var$userProvidedKeyEscapeRegex = /\/+/g;
function $ed7dad10c0d7dd15$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $ed7dad10c0d7dd15$var$escape("" + element.key) : index.toString(36);
}
function $ed7dad10c0d7dd15$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($ed7dad10c0d7dd15$var$noop, $ed7dad10c0d7dd15$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $ed7dad10c0d7dd15$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE:
                case $ed7dad10c0d7dd15$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $ed7dad10c0d7dd15$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $ed7dad10c0d7dd15$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $ed7dad10c0d7dd15$var$getElementKey(children, 0) : nameSoFar, $ed7dad10c0d7dd15$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($ed7dad10c0d7dd15$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $ed7dad10c0d7dd15$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($ed7dad10c0d7dd15$var$isValidElement(callback) && (callback = $ed7dad10c0d7dd15$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($ed7dad10c0d7dd15$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($ed7dad10c0d7dd15$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $ed7dad10c0d7dd15$var$getElementKey(nameSoFar, i), invokeCallback += $ed7dad10c0d7dd15$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $ed7dad10c0d7dd15$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $ed7dad10c0d7dd15$var$getElementKey(nameSoFar, i++), invokeCallback += $ed7dad10c0d7dd15$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $ed7dad10c0d7dd15$var$mapIntoArray($ed7dad10c0d7dd15$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $ed7dad10c0d7dd15$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $ed7dad10c0d7dd15$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $ed7dad10c0d7dd15$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $ed7dad10c0d7dd15$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4dBQg && "function" === typeof $4dBQg.emit) {
        $4dBQg.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $ed7dad10c0d7dd15$var$Children = {
    map: $ed7dad10c0d7dd15$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $ed7dad10c0d7dd15$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $ed7dad10c0d7dd15$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $ed7dad10c0d7dd15$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$ed7dad10c0d7dd15$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$ed7dad10c0d7dd15$export$9c16c1426311996d = $ed7dad10c0d7dd15$var$REACT_ACTIVITY_TYPE;
$ed7dad10c0d7dd15$export$dca3b0875bd9a954 = $ed7dad10c0d7dd15$var$Children;
$ed7dad10c0d7dd15$export$16fa2f45be04daa8 = $ed7dad10c0d7dd15$var$Component;
$ed7dad10c0d7dd15$export$ffb0004e005737fa = $ed7dad10c0d7dd15$var$REACT_FRAGMENT_TYPE;
$ed7dad10c0d7dd15$export$e2c29f18771995cb = $ed7dad10c0d7dd15$var$REACT_PROFILER_TYPE;
$ed7dad10c0d7dd15$export$221d75b3f55bb0bd = $ed7dad10c0d7dd15$var$PureComponent;
$ed7dad10c0d7dd15$export$5f8d39834fd61797 = $ed7dad10c0d7dd15$var$REACT_STRICT_MODE_TYPE;
$ed7dad10c0d7dd15$export$74bf444e3cd11ea5 = $ed7dad10c0d7dd15$var$REACT_SUSPENSE_TYPE;
$ed7dad10c0d7dd15$export$1ced07cd6b1985ce = $ed7dad10c0d7dd15$var$ReactSharedInternals;
$ed7dad10c0d7dd15$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$ed7dad10c0d7dd15$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$ed7dad10c0d7dd15$export$8c538325882c7eec = function() {
    return null;
};
$ed7dad10c0d7dd15$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $ed7dad10c0d7dd15$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$ed7dad10c0d7dd15$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $ed7dad10c0d7dd15$var$ReactElement(element.type, key, props);
};
$ed7dad10c0d7dd15$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$ed7dad10c0d7dd15$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$ed7dad10c0d7dd15$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $ed7dad10c0d7dd15$var$ReactElement(type, key, props);
};
$ed7dad10c0d7dd15$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ed7dad10c0d7dd15$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$ed7dad10c0d7dd15$export$a8257692ac88316c = $ed7dad10c0d7dd15$var$isValidElement;
$ed7dad10c0d7dd15$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $ed7dad10c0d7dd15$var$lazyInitializer
    };
};
$ed7dad10c0d7dd15$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$ed7dad10c0d7dd15$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $ed7dad10c0d7dd15$var$ReactSharedInternals.T, currentTransition = {};
    $ed7dad10c0d7dd15$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $ed7dad10c0d7dd15$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($ed7dad10c0d7dd15$var$noop, $ed7dad10c0d7dd15$var$reportGlobalError);
    } catch (error) {
        $ed7dad10c0d7dd15$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $ed7dad10c0d7dd15$var$ReactSharedInternals.T = prevTransition;
    }
};
$ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8 = function() {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useCacheRefresh();
};
$ed7dad10c0d7dd15$export$1f96ae73734a86cc = function(usable) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.use(usable);
};
$ed7dad10c0d7dd15$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$ed7dad10c0d7dd15$export$35808ee640e87ca7 = function(callback, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$ed7dad10c0d7dd15$export$fae74005e78b1a27 = function(Context) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useContext(Context);
};
$ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e = function() {};
$ed7dad10c0d7dd15$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$ed7dad10c0d7dd15$export$6d9c69b0de29b591 = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useEffect(create, deps);
};
$ed7dad10c0d7dd15$export$7f54fc3180508a52 = function(callback) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$ed7dad10c0d7dd15$export$f680877a34711e37 = function() {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useId();
};
$ed7dad10c0d7dd15$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$ed7dad10c0d7dd15$export$aaabe4eda9ed9969 = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$ed7dad10c0d7dd15$export$e5c5a5f917a5871c = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$ed7dad10c0d7dd15$export$1538c33de8887b59 = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useMemo(create, deps);
};
$ed7dad10c0d7dd15$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$ed7dad10c0d7dd15$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$ed7dad10c0d7dd15$export$b8f5890fc79d6aca = function(initialValue) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useRef(initialValue);
};
$ed7dad10c0d7dd15$export$60241385465d0a34 = function(initialState) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useState(initialState);
};
$ed7dad10c0d7dd15$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$ed7dad10c0d7dd15$export$7b286972b8d8ccbf = function() {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useTransition();
};
$ed7dad10c0d7dd15$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("4dBQg", function(module, exports) {
// shim for using process in browser
var $3125baf2b7ca59a6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3125baf2b7ca59a6$var$cachedSetTimeout;
var $3125baf2b7ca59a6$var$cachedClearTimeout;
function $3125baf2b7ca59a6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3125baf2b7ca59a6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3125baf2b7ca59a6$var$cachedSetTimeout = setTimeout;
        else $3125baf2b7ca59a6$var$cachedSetTimeout = $3125baf2b7ca59a6$var$defaultSetTimout;
    } catch (e) {
        $3125baf2b7ca59a6$var$cachedSetTimeout = $3125baf2b7ca59a6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3125baf2b7ca59a6$var$cachedClearTimeout = clearTimeout;
        else $3125baf2b7ca59a6$var$cachedClearTimeout = $3125baf2b7ca59a6$var$defaultClearTimeout;
    } catch (e) {
        $3125baf2b7ca59a6$var$cachedClearTimeout = $3125baf2b7ca59a6$var$defaultClearTimeout;
    }
})();
function $3125baf2b7ca59a6$var$runTimeout(fun) {
    if ($3125baf2b7ca59a6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3125baf2b7ca59a6$var$cachedSetTimeout === $3125baf2b7ca59a6$var$defaultSetTimout || !$3125baf2b7ca59a6$var$cachedSetTimeout) && setTimeout) {
        $3125baf2b7ca59a6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3125baf2b7ca59a6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3125baf2b7ca59a6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3125baf2b7ca59a6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3125baf2b7ca59a6$var$runClearTimeout(marker) {
    if ($3125baf2b7ca59a6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3125baf2b7ca59a6$var$cachedClearTimeout === $3125baf2b7ca59a6$var$defaultClearTimeout || !$3125baf2b7ca59a6$var$cachedClearTimeout) && clearTimeout) {
        $3125baf2b7ca59a6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3125baf2b7ca59a6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3125baf2b7ca59a6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3125baf2b7ca59a6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3125baf2b7ca59a6$var$queue = [];
var $3125baf2b7ca59a6$var$draining = false;
var $3125baf2b7ca59a6$var$currentQueue;
var $3125baf2b7ca59a6$var$queueIndex = -1;
function $3125baf2b7ca59a6$var$cleanUpNextTick() {
    if (!$3125baf2b7ca59a6$var$draining || !$3125baf2b7ca59a6$var$currentQueue) return;
    $3125baf2b7ca59a6$var$draining = false;
    if ($3125baf2b7ca59a6$var$currentQueue.length) $3125baf2b7ca59a6$var$queue = $3125baf2b7ca59a6$var$currentQueue.concat($3125baf2b7ca59a6$var$queue);
    else $3125baf2b7ca59a6$var$queueIndex = -1;
    if ($3125baf2b7ca59a6$var$queue.length) $3125baf2b7ca59a6$var$drainQueue();
}
function $3125baf2b7ca59a6$var$drainQueue() {
    if ($3125baf2b7ca59a6$var$draining) return;
    var timeout = $3125baf2b7ca59a6$var$runTimeout($3125baf2b7ca59a6$var$cleanUpNextTick);
    $3125baf2b7ca59a6$var$draining = true;
    var len = $3125baf2b7ca59a6$var$queue.length;
    while(len){
        $3125baf2b7ca59a6$var$currentQueue = $3125baf2b7ca59a6$var$queue;
        $3125baf2b7ca59a6$var$queue = [];
        while(++$3125baf2b7ca59a6$var$queueIndex < len)if ($3125baf2b7ca59a6$var$currentQueue) $3125baf2b7ca59a6$var$currentQueue[$3125baf2b7ca59a6$var$queueIndex].run();
        $3125baf2b7ca59a6$var$queueIndex = -1;
        len = $3125baf2b7ca59a6$var$queue.length;
    }
    $3125baf2b7ca59a6$var$currentQueue = null;
    $3125baf2b7ca59a6$var$draining = false;
    $3125baf2b7ca59a6$var$runClearTimeout(timeout);
}
$3125baf2b7ca59a6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3125baf2b7ca59a6$var$queue.push(new $3125baf2b7ca59a6$var$Item(fun, args));
    if ($3125baf2b7ca59a6$var$queue.length === 1 && !$3125baf2b7ca59a6$var$draining) $3125baf2b7ca59a6$var$runTimeout($3125baf2b7ca59a6$var$drainQueue);
};
// v8 likes predictible objects
function $3125baf2b7ca59a6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3125baf2b7ca59a6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3125baf2b7ca59a6$var$process.title = "browser";
$3125baf2b7ca59a6$var$process.browser = true;
$3125baf2b7ca59a6$var$process.env = {};
$3125baf2b7ca59a6$var$process.argv = [];
$3125baf2b7ca59a6$var$process.version = ""; // empty string to avoid regexp issues
$3125baf2b7ca59a6$var$process.versions = {};
function $3125baf2b7ca59a6$var$noop() {}
$3125baf2b7ca59a6$var$process.on = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.addListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.once = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.off = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.removeListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.removeAllListeners = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.emit = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.prependListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.prependOnceListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.listeners = function(name) {
    return [];
};
$3125baf2b7ca59a6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3125baf2b7ca59a6$var$process.cwd = function() {
    return "/";
};
$3125baf2b7ca59a6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3125baf2b7ca59a6$var$process.umask = function() {
    return 0;
};

});


parcelRegister("bhIuc", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $8373ca4214e15aed$export$882461b6382ed46c; }, function (v) { return $8373ca4214e15aed$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8373ca4214e15aed$export$757ceba2d55c277e; }, function (v) { return $8373ca4214e15aed$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $8373ca4214e15aed$export$83d89fbfd8236492; }, function (v) { return $8373ca4214e15aed$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8373ca4214e15aed$export$882461b6382ed46c;
var $8373ca4214e15aed$export$757ceba2d55c277e;
var $8373ca4214e15aed$export$83d89fbfd8236492;

var $4dBQg = parcelRequire("4dBQg");
"use strict";

var $1zXL0 = parcelRequire("1zXL0");

var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");
function $8373ca4214e15aed$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8373ca4214e15aed$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $8373ca4214e15aed$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $8373ca4214e15aed$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $8373ca4214e15aed$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $8373ca4214e15aed$var$assertIsMounted(fiber) {
    if ($8373ca4214e15aed$var$getNearestMountedFiber(fiber) !== fiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
}
function $8373ca4214e15aed$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $8373ca4214e15aed$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $8373ca4214e15aed$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $8373ca4214e15aed$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $8373ca4214e15aed$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $8373ca4214e15aed$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $8373ca4214e15aed$var$assign = Object.assign, $8373ca4214e15aed$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $8373ca4214e15aed$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8373ca4214e15aed$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8373ca4214e15aed$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8373ca4214e15aed$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8373ca4214e15aed$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8373ca4214e15aed$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $8373ca4214e15aed$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8373ca4214e15aed$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $8373ca4214e15aed$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $8373ca4214e15aed$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8373ca4214e15aed$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8373ca4214e15aed$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8373ca4214e15aed$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8373ca4214e15aed$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $8373ca4214e15aed$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $8373ca4214e15aed$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $8373ca4214e15aed$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $8373ca4214e15aed$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $8373ca4214e15aed$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $8373ca4214e15aed$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $8373ca4214e15aed$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $8373ca4214e15aed$var$getComponentNameFromType(type.type) || "Memo";
        case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $8373ca4214e15aed$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $8373ca4214e15aed$var$isArrayImpl = Array.isArray, $8373ca4214e15aed$var$ReactSharedInternals = $cQmXV.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8373ca4214e15aed$var$ReactDOMSharedInternals = $3h5eW.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8373ca4214e15aed$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $8373ca4214e15aed$var$valueStack = [], $8373ca4214e15aed$var$index = -1;
function $8373ca4214e15aed$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $8373ca4214e15aed$var$pop(cursor) {
    0 > $8373ca4214e15aed$var$index || (cursor.current = $8373ca4214e15aed$var$valueStack[$8373ca4214e15aed$var$index], $8373ca4214e15aed$var$valueStack[$8373ca4214e15aed$var$index] = null, $8373ca4214e15aed$var$index--);
}
function $8373ca4214e15aed$var$push(cursor, value) {
    $8373ca4214e15aed$var$index++;
    $8373ca4214e15aed$var$valueStack[$8373ca4214e15aed$var$index] = cursor.current;
    cursor.current = value;
}
var $8373ca4214e15aed$var$contextStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$contextFiberStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$rootInstanceStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$hostTransitionProviderCursor = $8373ca4214e15aed$var$createCursor(null);
function $8373ca4214e15aed$var$pushHostContainer(fiber, nextRootInstance) {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$rootInstanceStackCursor, nextRootInstance);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextFiberStackCursor, fiber);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $8373ca4214e15aed$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $8373ca4214e15aed$var$getOwnHostContext(nextRootInstance), fiber = $8373ca4214e15aed$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextStackCursor);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextStackCursor, fiber);
}
function $8373ca4214e15aed$var$popHostContainer() {
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextStackCursor);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextFiberStackCursor);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$rootInstanceStackCursor);
}
function $8373ca4214e15aed$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $8373ca4214e15aed$var$push($8373ca4214e15aed$var$hostTransitionProviderCursor, fiber);
    var context = $8373ca4214e15aed$var$contextStackCursor.current;
    var JSCompiler_inline_result = $8373ca4214e15aed$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextFiberStackCursor, fiber), $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextStackCursor, JSCompiler_inline_result));
}
function $8373ca4214e15aed$var$popHostContext(fiber) {
    $8373ca4214e15aed$var$contextFiberStackCursor.current === fiber && ($8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextStackCursor), $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextFiberStackCursor));
    $8373ca4214e15aed$var$hostTransitionProviderCursor.current === fiber && ($8373ca4214e15aed$var$pop($8373ca4214e15aed$var$hostTransitionProviderCursor), $8373ca4214e15aed$var$HostTransitionContext._currentValue = $8373ca4214e15aed$var$sharedNotPendingObject);
}
var $8373ca4214e15aed$var$prefix, $8373ca4214e15aed$var$suffix;
function $8373ca4214e15aed$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $8373ca4214e15aed$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $8373ca4214e15aed$var$prefix = match && match[1] || "";
        $8373ca4214e15aed$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $8373ca4214e15aed$var$prefix + name + $8373ca4214e15aed$var$suffix;
}
var $8373ca4214e15aed$var$reentry = !1;
function $8373ca4214e15aed$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $8373ca4214e15aed$var$reentry) return "";
    $8373ca4214e15aed$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $8373ca4214e15aed$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $8373ca4214e15aed$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $8373ca4214e15aed$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $8373ca4214e15aed$var$describeBuiltInComponentFrame("Suspense Fallback") : $8373ca4214e15aed$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $8373ca4214e15aed$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $8373ca4214e15aed$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $8373ca4214e15aed$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $8373ca4214e15aed$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $8373ca4214e15aed$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $8373ca4214e15aed$var$hasOwnProperty = Object.prototype.hasOwnProperty, $8373ca4214e15aed$var$scheduleCallback$3 = $1zXL0.unstable_scheduleCallback, $8373ca4214e15aed$var$cancelCallback$1 = $1zXL0.unstable_cancelCallback, $8373ca4214e15aed$var$shouldYield = $1zXL0.unstable_shouldYield, $8373ca4214e15aed$var$requestPaint = $1zXL0.unstable_requestPaint, $8373ca4214e15aed$var$now = $1zXL0.unstable_now, $8373ca4214e15aed$var$getCurrentPriorityLevel = $1zXL0.unstable_getCurrentPriorityLevel, $8373ca4214e15aed$var$ImmediatePriority = $1zXL0.unstable_ImmediatePriority, $8373ca4214e15aed$var$UserBlockingPriority = $1zXL0.unstable_UserBlockingPriority, $8373ca4214e15aed$var$NormalPriority$1 = $1zXL0.unstable_NormalPriority, $8373ca4214e15aed$var$LowPriority = $1zXL0.unstable_LowPriority, $8373ca4214e15aed$var$IdlePriority = $1zXL0.unstable_IdlePriority, $8373ca4214e15aed$var$log$1 = $1zXL0.log, $8373ca4214e15aed$var$unstable_setDisableYieldValue = $1zXL0.unstable_setDisableYieldValue, $8373ca4214e15aed$var$rendererID = null, $8373ca4214e15aed$var$injectedHook = null;
function $8373ca4214e15aed$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $8373ca4214e15aed$var$log$1 && $8373ca4214e15aed$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.setStrictMode) try {
        $8373ca4214e15aed$var$injectedHook.setStrictMode($8373ca4214e15aed$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $8373ca4214e15aed$var$clz32 = Math.clz32 ? Math.clz32 : $8373ca4214e15aed$var$clz32Fallback, $8373ca4214e15aed$var$log = Math.log, $8373ca4214e15aed$var$LN2 = Math.LN2;
function $8373ca4214e15aed$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($8373ca4214e15aed$var$log(x) / $8373ca4214e15aed$var$LN2 | 0) | 0;
}
var $8373ca4214e15aed$var$nextTransitionUpdateLane = 256, $8373ca4214e15aed$var$nextTransitionDeferredLane = 262144, $8373ca4214e15aed$var$nextRetryLane = 4194304;
function $8373ca4214e15aed$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $8373ca4214e15aed$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $8373ca4214e15aed$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8373ca4214e15aed$var$claimNextRetryLane() {
    var lane = $8373ca4214e15aed$var$nextRetryLane;
    $8373ca4214e15aed$var$nextRetryLane <<= 1;
    0 === ($8373ca4214e15aed$var$nextRetryLane & 62914560) && ($8373ca4214e15aed$var$nextRetryLane = 4194304);
    return lane;
}
function $8373ca4214e15aed$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $8373ca4214e15aed$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $8373ca4214e15aed$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $8373ca4214e15aed$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $8373ca4214e15aed$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $8373ca4214e15aed$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $8373ca4214e15aed$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $8373ca4214e15aed$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $8373ca4214e15aed$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $8373ca4214e15aed$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $8373ca4214e15aed$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $8373ca4214e15aed$var$resolveUpdatePriority() {
    var updatePriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $8373ca4214e15aed$var$getEventPriority(updatePriority.type);
}
function $8373ca4214e15aed$var$runWithPriority(priority, fn) {
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        return $8373ca4214e15aed$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $8373ca4214e15aed$var$randomKey = Math.random().toString(36).slice(2), $8373ca4214e15aed$var$internalInstanceKey = "__reactFiber$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalPropsKey = "__reactProps$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalContainerInstanceKey = "__reactContainer$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalEventHandlersKey = "__reactEvents$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalEventHandlerListenersKey = "__reactListeners$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalEventHandlesSetKey = "__reactHandles$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalRootNodeResourcesKey = "__reactResources$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalHoistableMarker = "__reactMarker$" + $8373ca4214e15aed$var$randomKey;
function $8373ca4214e15aed$var$detachDeletedInstance(node) {
    delete node[$8373ca4214e15aed$var$internalInstanceKey];
    delete node[$8373ca4214e15aed$var$internalPropsKey];
    delete node[$8373ca4214e15aed$var$internalEventHandlersKey];
    delete node[$8373ca4214e15aed$var$internalEventHandlerListenersKey];
    delete node[$8373ca4214e15aed$var$internalEventHandlesSetKey];
}
function $8373ca4214e15aed$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$8373ca4214e15aed$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$8373ca4214e15aed$var$internalContainerInstanceKey] || parentNode[$8373ca4214e15aed$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $8373ca4214e15aed$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$8373ca4214e15aed$var$internalInstanceKey]) return parentNode;
                targetNode = $8373ca4214e15aed$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $8373ca4214e15aed$var$getInstanceFromNode(node) {
    if (node = node[$8373ca4214e15aed$var$internalInstanceKey] || node[$8373ca4214e15aed$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $8373ca4214e15aed$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(33));
}
function $8373ca4214e15aed$var$getResourcesFromRoot(root) {
    var resources = root[$8373ca4214e15aed$var$internalRootNodeResourcesKey];
    resources || (resources = root[$8373ca4214e15aed$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $8373ca4214e15aed$var$markNodeAsHoistable(node) {
    node[$8373ca4214e15aed$var$internalHoistableMarker] = !0;
}
var $8373ca4214e15aed$var$allNativeEvents = new Set(), $8373ca4214e15aed$var$registrationNameDependencies = {};
function $8373ca4214e15aed$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $8373ca4214e15aed$var$registerDirectEvent(registrationName, dependencies);
    $8373ca4214e15aed$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $8373ca4214e15aed$var$registerDirectEvent(registrationName, dependencies) {
    $8373ca4214e15aed$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$8373ca4214e15aed$var$allNativeEvents.add(dependencies[registrationName]);
}
var $8373ca4214e15aed$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $8373ca4214e15aed$var$illegalAttributeNameCache = {}, $8373ca4214e15aed$var$validatedAttributeNameCache = {};
function $8373ca4214e15aed$var$isAttributeNameSafe(attributeName) {
    if ($8373ca4214e15aed$var$hasOwnProperty.call($8373ca4214e15aed$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($8373ca4214e15aed$var$hasOwnProperty.call($8373ca4214e15aed$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($8373ca4214e15aed$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $8373ca4214e15aed$var$validatedAttributeNameCache[attributeName] = !0;
    $8373ca4214e15aed$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $8373ca4214e15aed$var$setValueForAttribute(node, name, value) {
    if ($8373ca4214e15aed$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $8373ca4214e15aed$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $8373ca4214e15aed$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $8373ca4214e15aed$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $8373ca4214e15aed$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $8373ca4214e15aed$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $8373ca4214e15aed$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $8373ca4214e15aed$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $8373ca4214e15aed$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $8373ca4214e15aed$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $8373ca4214e15aed$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $8373ca4214e15aed$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $8373ca4214e15aed$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $8373ca4214e15aed$var$getToStringValue(value);
        } else element.value !== "" + $8373ca4214e15aed$var$getToStringValue(value) && (element.value = "" + $8373ca4214e15aed$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $8373ca4214e15aed$var$setDefaultValue(element, type, $8373ca4214e15aed$var$getToStringValue(value)) : null != defaultValue ? $8373ca4214e15aed$var$setDefaultValue(element, type, $8373ca4214e15aed$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $8373ca4214e15aed$var$getToStringValue(name) : element.removeAttribute("name");
}
function $8373ca4214e15aed$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $8373ca4214e15aed$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $8373ca4214e15aed$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $8373ca4214e15aed$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $8373ca4214e15aed$var$track(element);
}
function $8373ca4214e15aed$var$setDefaultValue(node, type, value) {
    "number" === type && $8373ca4214e15aed$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $8373ca4214e15aed$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $8373ca4214e15aed$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $8373ca4214e15aed$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $8373ca4214e15aed$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $8373ca4214e15aed$var$getToStringValue(defaultValue) : "";
}
function $8373ca4214e15aed$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(92));
            if ($8373ca4214e15aed$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $8373ca4214e15aed$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $8373ca4214e15aed$var$track(element);
}
function $8373ca4214e15aed$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $8373ca4214e15aed$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $8373ca4214e15aed$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $8373ca4214e15aed$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $8373ca4214e15aed$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $8373ca4214e15aed$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $8373ca4214e15aed$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $8373ca4214e15aed$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8373ca4214e15aed$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $8373ca4214e15aed$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $8373ca4214e15aed$var$sanitizeURL(url) {
    return $8373ca4214e15aed$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $8373ca4214e15aed$var$noop$1() {}
var $8373ca4214e15aed$var$currentReplayingEvent = null;
function $8373ca4214e15aed$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $8373ca4214e15aed$var$restoreTarget = null, $8373ca4214e15aed$var$restoreQueue = null;
function $8373ca4214e15aed$var$restoreStateOfTarget(target) {
    var internalInstance = $8373ca4214e15aed$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$8373ca4214e15aed$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $8373ca4214e15aed$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$8373ca4214e15aed$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(90));
                            $8373ca4214e15aed$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $8373ca4214e15aed$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $8373ca4214e15aed$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $8373ca4214e15aed$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $8373ca4214e15aed$var$isInsideEventHandler = !1;
function $8373ca4214e15aed$var$batchedUpdates$1(fn, a, b) {
    if ($8373ca4214e15aed$var$isInsideEventHandler) return fn(a, b);
    $8373ca4214e15aed$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($8373ca4214e15aed$var$isInsideEventHandler = !1, null !== $8373ca4214e15aed$var$restoreTarget || null !== $8373ca4214e15aed$var$restoreQueue) {
            if ($8373ca4214e15aed$var$flushSyncWork$1(), $8373ca4214e15aed$var$restoreTarget && (a = $8373ca4214e15aed$var$restoreTarget, fn = $8373ca4214e15aed$var$restoreQueue, $8373ca4214e15aed$var$restoreQueue = $8373ca4214e15aed$var$restoreTarget = null, $8373ca4214e15aed$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$8373ca4214e15aed$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $8373ca4214e15aed$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$8373ca4214e15aed$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $8373ca4214e15aed$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8373ca4214e15aed$var$passiveBrowserEventsSupported = !1;
if ($8373ca4214e15aed$var$canUseDOM) try {
    var $8373ca4214e15aed$var$options = {};
    Object.defineProperty($8373ca4214e15aed$var$options, "passive", {
        get: function() {
            $8373ca4214e15aed$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $8373ca4214e15aed$var$options, $8373ca4214e15aed$var$options);
    window.removeEventListener("test", $8373ca4214e15aed$var$options, $8373ca4214e15aed$var$options);
} catch (e) {
    $8373ca4214e15aed$var$passiveBrowserEventsSupported = !1;
}
var $8373ca4214e15aed$var$root = null, $8373ca4214e15aed$var$startText = null, $8373ca4214e15aed$var$fallbackText = null;
function $8373ca4214e15aed$var$getData() {
    if ($8373ca4214e15aed$var$fallbackText) return $8373ca4214e15aed$var$fallbackText;
    var start, startValue = $8373ca4214e15aed$var$startText, startLength = startValue.length, end, endValue = "value" in $8373ca4214e15aed$var$root ? $8373ca4214e15aed$var$root.value : $8373ca4214e15aed$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $8373ca4214e15aed$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $8373ca4214e15aed$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $8373ca4214e15aed$var$functionThatReturnsTrue() {
    return !0;
}
function $8373ca4214e15aed$var$functionThatReturnsFalse() {
    return !1;
}
function $8373ca4214e15aed$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $8373ca4214e15aed$var$functionThatReturnsTrue : $8373ca4214e15aed$var$functionThatReturnsFalse;
        this.isPropagationStopped = $8373ca4214e15aed$var$functionThatReturnsFalse;
        return this;
    }
    $8373ca4214e15aed$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $8373ca4214e15aed$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $8373ca4214e15aed$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $8373ca4214e15aed$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $8373ca4214e15aed$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8373ca4214e15aed$var$SyntheticEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$EventInterface), $8373ca4214e15aed$var$UIEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    view: 0,
    detail: 0
}), $8373ca4214e15aed$var$SyntheticUIEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$UIEventInterface), $8373ca4214e15aed$var$lastMovementX, $8373ca4214e15aed$var$lastMovementY, $8373ca4214e15aed$var$lastMouseEvent, $8373ca4214e15aed$var$MouseEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8373ca4214e15aed$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $8373ca4214e15aed$var$lastMouseEvent && ($8373ca4214e15aed$var$lastMouseEvent && "mousemove" === event.type ? ($8373ca4214e15aed$var$lastMovementX = event.screenX - $8373ca4214e15aed$var$lastMouseEvent.screenX, $8373ca4214e15aed$var$lastMovementY = event.screenY - $8373ca4214e15aed$var$lastMouseEvent.screenY) : $8373ca4214e15aed$var$lastMovementY = $8373ca4214e15aed$var$lastMovementX = 0, $8373ca4214e15aed$var$lastMouseEvent = event);
        return $8373ca4214e15aed$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $8373ca4214e15aed$var$lastMovementY;
    }
}), $8373ca4214e15aed$var$SyntheticMouseEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$MouseEventInterface), $8373ca4214e15aed$var$DragEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$MouseEventInterface, {
    dataTransfer: 0
}), $8373ca4214e15aed$var$SyntheticDragEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$DragEventInterface), $8373ca4214e15aed$var$FocusEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    relatedTarget: 0
}), $8373ca4214e15aed$var$SyntheticFocusEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$FocusEventInterface), $8373ca4214e15aed$var$AnimationEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8373ca4214e15aed$var$SyntheticAnimationEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$AnimationEventInterface), $8373ca4214e15aed$var$ClipboardEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $8373ca4214e15aed$var$SyntheticClipboardEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$ClipboardEventInterface), $8373ca4214e15aed$var$CompositionEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    data: 0
}), $8373ca4214e15aed$var$SyntheticCompositionEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$CompositionEventInterface), $8373ca4214e15aed$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8373ca4214e15aed$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8373ca4214e15aed$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8373ca4214e15aed$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $8373ca4214e15aed$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $8373ca4214e15aed$var$getEventModifierState() {
    return $8373ca4214e15aed$var$modifierStateGetter;
}
var $8373ca4214e15aed$var$KeyboardEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $8373ca4214e15aed$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $8373ca4214e15aed$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $8373ca4214e15aed$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8373ca4214e15aed$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $8373ca4214e15aed$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $8373ca4214e15aed$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $8373ca4214e15aed$var$SyntheticKeyboardEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$KeyboardEventInterface), $8373ca4214e15aed$var$PointerEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8373ca4214e15aed$var$SyntheticPointerEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$PointerEventInterface), $8373ca4214e15aed$var$TouchEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8373ca4214e15aed$var$getEventModifierState
}), $8373ca4214e15aed$var$SyntheticTouchEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$TouchEventInterface), $8373ca4214e15aed$var$TransitionEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8373ca4214e15aed$var$SyntheticTransitionEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$TransitionEventInterface), $8373ca4214e15aed$var$WheelEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8373ca4214e15aed$var$SyntheticWheelEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$WheelEventInterface), $8373ca4214e15aed$var$ToggleEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $8373ca4214e15aed$var$SyntheticToggleEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$ToggleEventInterface), $8373ca4214e15aed$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $8373ca4214e15aed$var$canUseCompositionEvent = $8373ca4214e15aed$var$canUseDOM && "CompositionEvent" in window, $8373ca4214e15aed$var$documentMode = null;
$8373ca4214e15aed$var$canUseDOM && "documentMode" in document && ($8373ca4214e15aed$var$documentMode = document.documentMode);
var $8373ca4214e15aed$var$canUseTextInputEvent = $8373ca4214e15aed$var$canUseDOM && "TextEvent" in window && !$8373ca4214e15aed$var$documentMode, $8373ca4214e15aed$var$useFallbackCompositionData = $8373ca4214e15aed$var$canUseDOM && (!$8373ca4214e15aed$var$canUseCompositionEvent || $8373ca4214e15aed$var$documentMode && 8 < $8373ca4214e15aed$var$documentMode && 11 >= $8373ca4214e15aed$var$documentMode), $8373ca4214e15aed$var$SPACEBAR_CHAR = String.fromCharCode(32), $8373ca4214e15aed$var$hasSpaceKeypress = !1;
function $8373ca4214e15aed$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $8373ca4214e15aed$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8373ca4214e15aed$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $8373ca4214e15aed$var$isComposing = !1;
function $8373ca4214e15aed$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $8373ca4214e15aed$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $8373ca4214e15aed$var$hasSpaceKeypress = !0;
            return $8373ca4214e15aed$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $8373ca4214e15aed$var$SPACEBAR_CHAR && $8373ca4214e15aed$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $8373ca4214e15aed$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($8373ca4214e15aed$var$isComposing) return "compositionend" === domEventName || !$8373ca4214e15aed$var$canUseCompositionEvent && $8373ca4214e15aed$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $8373ca4214e15aed$var$getData(), $8373ca4214e15aed$var$fallbackText = $8373ca4214e15aed$var$startText = $8373ca4214e15aed$var$root = null, $8373ca4214e15aed$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $8373ca4214e15aed$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $8373ca4214e15aed$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8373ca4214e15aed$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$8373ca4214e15aed$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $8373ca4214e15aed$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $8373ca4214e15aed$var$restoreTarget ? $8373ca4214e15aed$var$restoreQueue ? $8373ca4214e15aed$var$restoreQueue.push(target) : $8373ca4214e15aed$var$restoreQueue = [
        target
    ] : $8373ca4214e15aed$var$restoreTarget = target;
    inst = $8373ca4214e15aed$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $8373ca4214e15aed$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $8373ca4214e15aed$var$activeElement$1 = null, $8373ca4214e15aed$var$activeElementInst$1 = null;
function $8373ca4214e15aed$var$runEventInBatch(dispatchQueue) {
    $8373ca4214e15aed$var$processDispatchQueue(dispatchQueue, 0);
}
function $8373ca4214e15aed$var$getInstIfValueChanged(targetInst) {
    var targetNode = $8373ca4214e15aed$var$getNodeFromInstance(targetInst);
    if ($8373ca4214e15aed$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $8373ca4214e15aed$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $8373ca4214e15aed$var$isInputEventSupported = !1;
if ($8373ca4214e15aed$var$canUseDOM) {
    var $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286;
    if ($8373ca4214e15aed$var$canUseDOM) {
        var $8373ca4214e15aed$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$8373ca4214e15aed$var$isSupported$jscomp$inline_427) {
            var $8373ca4214e15aed$var$element$jscomp$inline_428 = document.createElement("div");
            $8373ca4214e15aed$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $8373ca4214e15aed$var$isSupported$jscomp$inline_427 = "function" === typeof $8373ca4214e15aed$var$element$jscomp$inline_428.oninput;
        }
        $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286 = $8373ca4214e15aed$var$isSupported$jscomp$inline_427;
    } else $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286 = !1;
    $8373ca4214e15aed$var$isInputEventSupported = $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $8373ca4214e15aed$var$stopWatchingForValueChange() {
    $8373ca4214e15aed$var$activeElement$1 && ($8373ca4214e15aed$var$activeElement$1.detachEvent("onpropertychange", $8373ca4214e15aed$var$handlePropertyChange), $8373ca4214e15aed$var$activeElementInst$1 = $8373ca4214e15aed$var$activeElement$1 = null);
}
function $8373ca4214e15aed$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $8373ca4214e15aed$var$getInstIfValueChanged($8373ca4214e15aed$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $8373ca4214e15aed$var$createAndAccumulateChangeEvent(dispatchQueue, $8373ca4214e15aed$var$activeElementInst$1, nativeEvent, $8373ca4214e15aed$var$getEventTarget(nativeEvent));
        $8373ca4214e15aed$var$batchedUpdates$1($8373ca4214e15aed$var$runEventInBatch, dispatchQueue);
    }
}
function $8373ca4214e15aed$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($8373ca4214e15aed$var$stopWatchingForValueChange(), $8373ca4214e15aed$var$activeElement$1 = target, $8373ca4214e15aed$var$activeElementInst$1 = targetInst, $8373ca4214e15aed$var$activeElement$1.attachEvent("onpropertychange", $8373ca4214e15aed$var$handlePropertyChange)) : "focusout" === domEventName && $8373ca4214e15aed$var$stopWatchingForValueChange();
}
function $8373ca4214e15aed$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $8373ca4214e15aed$var$getInstIfValueChanged($8373ca4214e15aed$var$activeElementInst$1);
}
function $8373ca4214e15aed$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $8373ca4214e15aed$var$getInstIfValueChanged(targetInst);
}
function $8373ca4214e15aed$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $8373ca4214e15aed$var$getInstIfValueChanged(targetInst);
}
function $8373ca4214e15aed$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8373ca4214e15aed$var$objectIs = "function" === typeof Object.is ? Object.is : $8373ca4214e15aed$var$is;
function $8373ca4214e15aed$var$shallowEqual(objA, objB) {
    if ($8373ca4214e15aed$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$8373ca4214e15aed$var$hasOwnProperty.call(objB, currentKey) || !$8373ca4214e15aed$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $8373ca4214e15aed$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $8373ca4214e15aed$var$getNodeForCharacterOffset(root, offset) {
    var node = $8373ca4214e15aed$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $8373ca4214e15aed$var$getLeafNode(node);
    }
}
function $8373ca4214e15aed$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $8373ca4214e15aed$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $8373ca4214e15aed$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $8373ca4214e15aed$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $8373ca4214e15aed$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $8373ca4214e15aed$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $8373ca4214e15aed$var$skipSelectionChangeEvent = $8373ca4214e15aed$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $8373ca4214e15aed$var$activeElement = null, $8373ca4214e15aed$var$activeElementInst = null, $8373ca4214e15aed$var$lastSelection = null, $8373ca4214e15aed$var$mouseDown = !1;
function $8373ca4214e15aed$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $8373ca4214e15aed$var$mouseDown || null == $8373ca4214e15aed$var$activeElement || $8373ca4214e15aed$var$activeElement !== $8373ca4214e15aed$var$getActiveElement(doc) || (doc = $8373ca4214e15aed$var$activeElement, "selectionStart" in doc && $8373ca4214e15aed$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $8373ca4214e15aed$var$lastSelection && $8373ca4214e15aed$var$shallowEqual($8373ca4214e15aed$var$lastSelection, doc) || ($8373ca4214e15aed$var$lastSelection = doc, doc = $8373ca4214e15aed$var$accumulateTwoPhaseListeners($8373ca4214e15aed$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $8373ca4214e15aed$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $8373ca4214e15aed$var$activeElement)));
}
function $8373ca4214e15aed$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $8373ca4214e15aed$var$vendorPrefixes = {
    animationend: $8373ca4214e15aed$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $8373ca4214e15aed$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $8373ca4214e15aed$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionEnd")
}, $8373ca4214e15aed$var$prefixedEventNames = {}, $8373ca4214e15aed$var$style = {};
$8373ca4214e15aed$var$canUseDOM && ($8373ca4214e15aed$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $8373ca4214e15aed$var$vendorPrefixes.animationend.animation, delete $8373ca4214e15aed$var$vendorPrefixes.animationiteration.animation, delete $8373ca4214e15aed$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $8373ca4214e15aed$var$vendorPrefixes.transitionend.transition);
function $8373ca4214e15aed$var$getVendorPrefixedEventName(eventName) {
    if ($8373ca4214e15aed$var$prefixedEventNames[eventName]) return $8373ca4214e15aed$var$prefixedEventNames[eventName];
    if (!$8373ca4214e15aed$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $8373ca4214e15aed$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $8373ca4214e15aed$var$style) return $8373ca4214e15aed$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $8373ca4214e15aed$var$ANIMATION_END = $8373ca4214e15aed$var$getVendorPrefixedEventName("animationend"), $8373ca4214e15aed$var$ANIMATION_ITERATION = $8373ca4214e15aed$var$getVendorPrefixedEventName("animationiteration"), $8373ca4214e15aed$var$ANIMATION_START = $8373ca4214e15aed$var$getVendorPrefixedEventName("animationstart"), $8373ca4214e15aed$var$TRANSITION_RUN = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitionrun"), $8373ca4214e15aed$var$TRANSITION_START = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitionstart"), $8373ca4214e15aed$var$TRANSITION_CANCEL = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitioncancel"), $8373ca4214e15aed$var$TRANSITION_END = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitionend"), $8373ca4214e15aed$var$topLevelEventsToReactNames = new Map(), $8373ca4214e15aed$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$8373ca4214e15aed$var$simpleEventPluginEvents.push("scrollEnd");
function $8373ca4214e15aed$var$registerSimpleEvent(domEventName, reactName) {
    $8373ca4214e15aed$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $8373ca4214e15aed$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $8373ca4214e15aed$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4dBQg && "function" === typeof $4dBQg.emit) {
        $4dBQg.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $8373ca4214e15aed$var$concurrentQueues = [], $8373ca4214e15aed$var$concurrentQueuesIndex = 0, $8373ca4214e15aed$var$concurrentlyUpdatedLanes = 0;
function $8373ca4214e15aed$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $8373ca4214e15aed$var$concurrentQueuesIndex, i = $8373ca4214e15aed$var$concurrentlyUpdatedLanes = $8373ca4214e15aed$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        var queue = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        var update = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        var lane = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $8373ca4214e15aed$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $8373ca4214e15aed$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = fiber;
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = queue;
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = update;
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = lane;
    $8373ca4214e15aed$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $8373ca4214e15aed$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
}
function $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $8373ca4214e15aed$var$enqueueUpdate$1(fiber, null, null, lane);
    return $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
}
function $8373ca4214e15aed$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $8373ca4214e15aed$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $8373ca4214e15aed$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $8373ca4214e15aed$var$nestedUpdateCount) throw $8373ca4214e15aed$var$nestedUpdateCount = 0, $8373ca4214e15aed$var$rootWithNestedUpdates = null, Error($8373ca4214e15aed$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $8373ca4214e15aed$var$emptyContextObject = {};
function $8373ca4214e15aed$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8373ca4214e15aed$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $8373ca4214e15aed$var$FiberNode(tag, pendingProps, key, mode);
}
function $8373ca4214e15aed$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $8373ca4214e15aed$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $8373ca4214e15aed$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $8373ca4214e15aed$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $8373ca4214e15aed$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $8373ca4214e15aed$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $8373ca4214e15aed$var$isHostHoistableType(type, pendingProps, $8373ca4214e15aed$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE:
            return $8373ca4214e15aed$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $8373ca4214e15aed$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $8373ca4214e15aed$var$REACT_PROFILER_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $8373ca4214e15aed$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $8373ca4214e15aed$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $8373ca4214e15aed$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $8373ca4214e15aed$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($8373ca4214e15aed$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $8373ca4214e15aed$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $8373ca4214e15aed$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $8373ca4214e15aed$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $8373ca4214e15aed$var$createFiberFromText(content, mode, lanes) {
    content = $8373ca4214e15aed$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $8373ca4214e15aed$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $8373ca4214e15aed$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $8373ca4214e15aed$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $8373ca4214e15aed$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $8373ca4214e15aed$var$CapturedStacks = new WeakMap();
function $8373ca4214e15aed$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $8373ca4214e15aed$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $8373ca4214e15aed$var$getStackByFiberInDevAndProd(source)
        };
        $8373ca4214e15aed$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $8373ca4214e15aed$var$getStackByFiberInDevAndProd(source)
    };
}
var $8373ca4214e15aed$var$forkStack = [], $8373ca4214e15aed$var$forkStackIndex = 0, $8373ca4214e15aed$var$treeForkProvider = null, $8373ca4214e15aed$var$treeForkCount = 0, $8373ca4214e15aed$var$idStack = [], $8373ca4214e15aed$var$idStackIndex = 0, $8373ca4214e15aed$var$treeContextProvider = null, $8373ca4214e15aed$var$treeContextId = 1, $8373ca4214e15aed$var$treeContextOverflow = "";
function $8373ca4214e15aed$var$pushTreeFork(workInProgress, totalChildren) {
    $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex++] = $8373ca4214e15aed$var$treeForkCount;
    $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex++] = $8373ca4214e15aed$var$treeForkProvider;
    $8373ca4214e15aed$var$treeForkProvider = workInProgress;
    $8373ca4214e15aed$var$treeForkCount = totalChildren;
}
function $8373ca4214e15aed$var$pushTreeId(workInProgress, totalChildren, index) {
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextId;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextOverflow;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextProvider;
    $8373ca4214e15aed$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $8373ca4214e15aed$var$treeContextId;
    workInProgress = $8373ca4214e15aed$var$treeContextOverflow;
    var baseLength = 32 - $8373ca4214e15aed$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $8373ca4214e15aed$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $8373ca4214e15aed$var$treeContextId = 1 << 32 - $8373ca4214e15aed$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $8373ca4214e15aed$var$treeContextOverflow = length + workInProgress;
    } else $8373ca4214e15aed$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $8373ca4214e15aed$var$treeContextOverflow = workInProgress;
}
function $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($8373ca4214e15aed$var$pushTreeFork(workInProgress, 1), $8373ca4214e15aed$var$pushTreeId(workInProgress, 1, 0));
}
function $8373ca4214e15aed$var$popTreeContext(workInProgress) {
    for(; workInProgress === $8373ca4214e15aed$var$treeForkProvider;)$8373ca4214e15aed$var$treeForkProvider = $8373ca4214e15aed$var$forkStack[--$8373ca4214e15aed$var$forkStackIndex], $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex] = null, $8373ca4214e15aed$var$treeForkCount = $8373ca4214e15aed$var$forkStack[--$8373ca4214e15aed$var$forkStackIndex], $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex] = null;
    for(; workInProgress === $8373ca4214e15aed$var$treeContextProvider;)$8373ca4214e15aed$var$treeContextProvider = $8373ca4214e15aed$var$idStack[--$8373ca4214e15aed$var$idStackIndex], $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex] = null, $8373ca4214e15aed$var$treeContextOverflow = $8373ca4214e15aed$var$idStack[--$8373ca4214e15aed$var$idStackIndex], $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex] = null, $8373ca4214e15aed$var$treeContextId = $8373ca4214e15aed$var$idStack[--$8373ca4214e15aed$var$idStackIndex], $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex] = null;
}
function $8373ca4214e15aed$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextId;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextOverflow;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextProvider;
    $8373ca4214e15aed$var$treeContextId = suspendedContext.id;
    $8373ca4214e15aed$var$treeContextOverflow = suspendedContext.overflow;
    $8373ca4214e15aed$var$treeContextProvider = workInProgress;
}
var $8373ca4214e15aed$var$hydrationParentFiber = null, $8373ca4214e15aed$var$nextHydratableInstance = null, $8373ca4214e15aed$var$isHydrating = !1, $8373ca4214e15aed$var$hydrationErrors = null, $8373ca4214e15aed$var$rootOrSingletonContext = !1, $8373ca4214e15aed$var$HydrationMismatchException = Error($8373ca4214e15aed$var$formatProdErrorMessage(519));
function $8373ca4214e15aed$var$throwOnHydrationMismatch(fiber) {
    var error = Error($8373ca4214e15aed$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $8373ca4214e15aed$var$queueHydrationError($8373ca4214e15aed$var$createCapturedValueAtFiber(error, fiber));
    throw $8373ca4214e15aed$var$HydrationMismatchException;
}
function $8373ca4214e15aed$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$8373ca4214e15aed$var$internalInstanceKey] = fiber;
    instance[$8373ca4214e15aed$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("cancel", instance);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $8373ca4214e15aed$var$mediaEventTypes.length; type++)$8373ca4214e15aed$var$listenToNonDelegatedEvent($8373ca4214e15aed$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", instance);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", instance);
            $8373ca4214e15aed$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", instance), $8373ca4214e15aed$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $8373ca4214e15aed$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($8373ca4214e15aed$var$listenToNonDelegatedEvent("beforetoggle", instance), $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $8373ca4214e15aed$var$noop$1), instance = !0) : instance = !1;
    instance || $8373ca4214e15aed$var$throwOnHydrationMismatch(fiber, !0);
}
function $8373ca4214e15aed$var$popToNextHostParent(fiber) {
    for($8373ca4214e15aed$var$hydrationParentFiber = fiber.return; $8373ca4214e15aed$var$hydrationParentFiber;)switch($8373ca4214e15aed$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $8373ca4214e15aed$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $8373ca4214e15aed$var$rootOrSingletonContext = !0;
            return;
        default:
            $8373ca4214e15aed$var$hydrationParentFiber = $8373ca4214e15aed$var$hydrationParentFiber.return;
    }
}
function $8373ca4214e15aed$var$popHydrationState(fiber) {
    if (fiber !== $8373ca4214e15aed$var$hydrationParentFiber) return !1;
    if (!$8373ca4214e15aed$var$isHydrating) return $8373ca4214e15aed$var$popToNextHostParent(fiber), $8373ca4214e15aed$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $8373ca4214e15aed$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $8373ca4214e15aed$var$nextHydratableInstance && $8373ca4214e15aed$var$throwOnHydrationMismatch(fiber);
    $8373ca4214e15aed$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(317));
        $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(317));
        $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $8373ca4214e15aed$var$nextHydratableInstance, $8373ca4214e15aed$var$isSingletonScope(fiber.type) ? (fiber = $8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton, $8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton = null, $8373ca4214e15aed$var$nextHydratableInstance = fiber) : $8373ca4214e15aed$var$nextHydratableInstance = tag) : $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$hydrationParentFiber ? $8373ca4214e15aed$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $8373ca4214e15aed$var$resetHydrationState() {
    $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$hydrationParentFiber = null;
    $8373ca4214e15aed$var$isHydrating = !1;
}
function $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $8373ca4214e15aed$var$hydrationErrors;
    null !== queuedErrors && (null === $8373ca4214e15aed$var$workInProgressRootRecoverableErrors ? $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = queuedErrors : $8373ca4214e15aed$var$workInProgressRootRecoverableErrors.push.apply($8373ca4214e15aed$var$workInProgressRootRecoverableErrors, queuedErrors), $8373ca4214e15aed$var$hydrationErrors = null);
    return queuedErrors;
}
function $8373ca4214e15aed$var$queueHydrationError(error) {
    null === $8373ca4214e15aed$var$hydrationErrors ? $8373ca4214e15aed$var$hydrationErrors = [
        error
    ] : $8373ca4214e15aed$var$hydrationErrors.push(error);
}
var $8373ca4214e15aed$var$valueCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null, $8373ca4214e15aed$var$lastContextDependency = null;
function $8373ca4214e15aed$var$pushProvider(providerFiber, context, nextValue) {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $8373ca4214e15aed$var$popProvider(context) {
    context._currentValue = $8373ca4214e15aed$var$valueCursor.current;
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$valueCursor);
}
function $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $8373ca4214e15aed$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $8373ca4214e15aed$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $8373ca4214e15aed$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($8373ca4214e15aed$var$HostTransitionContext) : current = [
                $8373ca4214e15aed$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $8373ca4214e15aed$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $8373ca4214e15aed$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$8373ca4214e15aed$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $8373ca4214e15aed$var$prepareToReadContext(workInProgress) {
    $8373ca4214e15aed$var$currentlyRenderingFiber$1 = workInProgress;
    $8373ca4214e15aed$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $8373ca4214e15aed$var$readContext(context) {
    return $8373ca4214e15aed$var$readContextForConsumer($8373ca4214e15aed$var$currentlyRenderingFiber$1, context);
}
function $8373ca4214e15aed$var$readContextDuringReconciliation(consumer, context) {
    null === $8373ca4214e15aed$var$currentlyRenderingFiber$1 && $8373ca4214e15aed$var$prepareToReadContext(consumer);
    return $8373ca4214e15aed$var$readContextForConsumer(consumer, context);
}
function $8373ca4214e15aed$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $8373ca4214e15aed$var$lastContextDependency) {
        if (null === consumer) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(308));
        $8373ca4214e15aed$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$lastContextDependency.next = context;
    return value;
}
var $8373ca4214e15aed$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $8373ca4214e15aed$var$scheduleCallback$2 = $1zXL0.unstable_scheduleCallback, $8373ca4214e15aed$var$NormalPriority = $1zXL0.unstable_NormalPriority, $8373ca4214e15aed$var$CacheContext = {
    $$typeof: $8373ca4214e15aed$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $8373ca4214e15aed$var$createCache() {
    return {
        controller: new $8373ca4214e15aed$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $8373ca4214e15aed$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $8373ca4214e15aed$var$scheduleCallback$2($8373ca4214e15aed$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $8373ca4214e15aed$var$currentEntangledListeners = null, $8373ca4214e15aed$var$currentEntangledPendingCount = 0, $8373ca4214e15aed$var$currentEntangledLane = 0, $8373ca4214e15aed$var$currentEntangledActionThenable = null;
function $8373ca4214e15aed$var$entangleAsyncAction(transition, thenable) {
    if (null === $8373ca4214e15aed$var$currentEntangledListeners) {
        var entangledListeners = $8373ca4214e15aed$var$currentEntangledListeners = [];
        $8373ca4214e15aed$var$currentEntangledPendingCount = 0;
        $8373ca4214e15aed$var$currentEntangledLane = $8373ca4214e15aed$var$requestTransitionLane();
        $8373ca4214e15aed$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $8373ca4214e15aed$var$currentEntangledPendingCount++;
    thenable.then($8373ca4214e15aed$var$pingEngtangledActionScope, $8373ca4214e15aed$var$pingEngtangledActionScope);
    return thenable;
}
function $8373ca4214e15aed$var$pingEngtangledActionScope() {
    if (0 === --$8373ca4214e15aed$var$currentEntangledPendingCount && null !== $8373ca4214e15aed$var$currentEntangledListeners) {
        null !== $8373ca4214e15aed$var$currentEntangledActionThenable && ($8373ca4214e15aed$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $8373ca4214e15aed$var$currentEntangledListeners;
        $8373ca4214e15aed$var$currentEntangledListeners = null;
        $8373ca4214e15aed$var$currentEntangledLane = 0;
        $8373ca4214e15aed$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $8373ca4214e15aed$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $8373ca4214e15aed$var$prevOnStartTransitionFinish = $8373ca4214e15aed$var$ReactSharedInternals.S;
$8373ca4214e15aed$var$ReactSharedInternals.S = function(transition, returnValue) {
    $8373ca4214e15aed$var$globalMostRecentTransitionTime = $8373ca4214e15aed$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $8373ca4214e15aed$var$entangleAsyncAction(transition, returnValue);
    null !== $8373ca4214e15aed$var$prevOnStartTransitionFinish && $8373ca4214e15aed$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $8373ca4214e15aed$var$resumedCache = $8373ca4214e15aed$var$createCursor(null);
function $8373ca4214e15aed$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $8373ca4214e15aed$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $8373ca4214e15aed$var$workInProgressRoot.pooledCache;
}
function $8373ca4214e15aed$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $8373ca4214e15aed$var$push($8373ca4214e15aed$var$resumedCache, $8373ca4214e15aed$var$resumedCache.current) : $8373ca4214e15aed$var$push($8373ca4214e15aed$var$resumedCache, prevCachePool.pool);
}
function $8373ca4214e15aed$var$getSuspendedCache() {
    var cacheFromPool = $8373ca4214e15aed$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $8373ca4214e15aed$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $8373ca4214e15aed$var$SuspenseException = Error($8373ca4214e15aed$var$formatProdErrorMessage(460)), $8373ca4214e15aed$var$SuspenseyCommitException = Error($8373ca4214e15aed$var$formatProdErrorMessage(474)), $8373ca4214e15aed$var$SuspenseActionException = Error($8373ca4214e15aed$var$formatProdErrorMessage(542)), $8373ca4214e15aed$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $8373ca4214e15aed$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $8373ca4214e15aed$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($8373ca4214e15aed$var$noop$1, $8373ca4214e15aed$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $8373ca4214e15aed$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($8373ca4214e15aed$var$noop$1, $8373ca4214e15aed$var$noop$1);
            else {
                thenableState = $8373ca4214e15aed$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $8373ca4214e15aed$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $8373ca4214e15aed$var$suspendedThenable = thenable;
            throw $8373ca4214e15aed$var$SuspenseException;
    }
}
function $8373ca4214e15aed$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $8373ca4214e15aed$var$suspendedThenable = x, $8373ca4214e15aed$var$SuspenseException;
        throw x;
    }
}
var $8373ca4214e15aed$var$suspendedThenable = null;
function $8373ca4214e15aed$var$getSuspendedThenable() {
    if (null === $8373ca4214e15aed$var$suspendedThenable) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(459));
    var thenable = $8373ca4214e15aed$var$suspendedThenable;
    $8373ca4214e15aed$var$suspendedThenable = null;
    return thenable;
}
function $8373ca4214e15aed$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $8373ca4214e15aed$var$SuspenseException || rejectedReason === $8373ca4214e15aed$var$SuspenseActionException) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(483));
}
var $8373ca4214e15aed$var$thenableState$1 = null, $8373ca4214e15aed$var$thenableIndexCounter$1 = 0;
function $8373ca4214e15aed$var$unwrapThenable(thenable) {
    var index = $8373ca4214e15aed$var$thenableIndexCounter$1;
    $8373ca4214e15aed$var$thenableIndexCounter$1 += 1;
    null === $8373ca4214e15aed$var$thenableState$1 && ($8373ca4214e15aed$var$thenableState$1 = []);
    return $8373ca4214e15aed$var$trackUsedThenable($8373ca4214e15aed$var$thenableState$1, thenable, index);
}
function $8373ca4214e15aed$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $8373ca4214e15aed$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $8373ca4214e15aed$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $8373ca4214e15aed$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $8373ca4214e15aed$var$REACT_LAZY_TYPE && $8373ca4214e15aed$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $8373ca4214e15aed$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $8373ca4214e15aed$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $8373ca4214e15aed$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $8373ca4214e15aed$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $8373ca4214e15aed$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $8373ca4214e15aed$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    return lanes = $8373ca4214e15aed$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8373ca4214e15aed$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    return newChild = $8373ca4214e15aed$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild) || $8373ca4214e15aed$var$getIteratorFn(newChild)) return newChild = $8373ca4214e15aed$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild) || $8373ca4214e15aed$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild) || $8373ca4214e15aed$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $8373ca4214e15aed$var$REACT_LAZY_TYPE && $8373ca4214e15aed$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $8373ca4214e15aed$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE ? (lanes = $8373ca4214e15aed$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $8373ca4214e15aed$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8373ca4214e15aed$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $8373ca4214e15aed$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($8373ca4214e15aed$var$getIteratorFn(newChild)) {
                key = $8373ca4214e15aed$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $8373ca4214e15aed$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $8373ca4214e15aed$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $8373ca4214e15aed$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $8373ca4214e15aed$var$SuspenseException || x === $8373ca4214e15aed$var$SuspenseActionException) throw x;
            var fiber = $8373ca4214e15aed$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $8373ca4214e15aed$var$reconcileChildFibers = $8373ca4214e15aed$var$createChildReconciler(!0), $8373ca4214e15aed$var$mountChildFibers = $8373ca4214e15aed$var$createChildReconciler(!1), $8373ca4214e15aed$var$hasForceUpdate = !1;
function $8373ca4214e15aed$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $8373ca4214e15aed$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8373ca4214e15aed$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($8373ca4214e15aed$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
        $8373ca4214e15aed$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $8373ca4214e15aed$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
}
function $8373ca4214e15aed$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $8373ca4214e15aed$var$markRootEntangled(root, lane);
    }
}
function $8373ca4214e15aed$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $8373ca4214e15aed$var$didReadFromEntangledAsyncAction = !1;
function $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($8373ca4214e15aed$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $8373ca4214e15aed$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $8373ca4214e15aed$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $8373ca4214e15aed$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $8373ca4214e15aed$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($8373ca4214e15aed$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $8373ca4214e15aed$var$currentEntangledLane && ($8373ca4214e15aed$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $8373ca4214e15aed$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $8373ca4214e15aed$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $8373ca4214e15aed$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $8373ca4214e15aed$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$8373ca4214e15aed$var$callCallback(callbacks[updateQueue], context);
}
var $8373ca4214e15aed$var$currentTreeHiddenStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$prevEntangledRenderLanesCursor = $8373ca4214e15aed$var$createCursor(0);
function $8373ca4214e15aed$var$pushHiddenContext(fiber, context) {
    fiber = $8373ca4214e15aed$var$entangledRenderLanes;
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$prevEntangledRenderLanesCursor, fiber);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$currentTreeHiddenStackCursor, context);
    $8373ca4214e15aed$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $8373ca4214e15aed$var$reuseHiddenContextOnStack() {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$prevEntangledRenderLanesCursor, $8373ca4214e15aed$var$entangledRenderLanes);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$currentTreeHiddenStackCursor, $8373ca4214e15aed$var$currentTreeHiddenStackCursor.current);
}
function $8373ca4214e15aed$var$popHiddenContext() {
    $8373ca4214e15aed$var$entangledRenderLanes = $8373ca4214e15aed$var$prevEntangledRenderLanesCursor.current;
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$currentTreeHiddenStackCursor);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$prevEntangledRenderLanesCursor);
}
var $8373ca4214e15aed$var$suspenseHandlerStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$shellBoundary = null;
function $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current & 1);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, handler);
    null === $8373ca4214e15aed$var$shellBoundary && (null === current || null !== $8373ca4214e15aed$var$currentTreeHiddenStackCursor.current ? $8373ca4214e15aed$var$shellBoundary = handler : null !== current.memoizedState && ($8373ca4214e15aed$var$shellBoundary = handler));
}
function $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, fiber);
    null === $8373ca4214e15aed$var$shellBoundary && ($8373ca4214e15aed$var$shellBoundary = fiber);
}
function $8373ca4214e15aed$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current), $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, fiber), null === $8373ca4214e15aed$var$shellBoundary && ($8373ca4214e15aed$var$shellBoundary = fiber)) : $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(fiber);
}
function $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack() {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, $8373ca4214e15aed$var$suspenseHandlerStackCursor.current);
}
function $8373ca4214e15aed$var$popSuspenseHandler(fiber) {
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseHandlerStackCursor);
    $8373ca4214e15aed$var$shellBoundary === fiber && ($8373ca4214e15aed$var$shellBoundary = null);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor);
}
var $8373ca4214e15aed$var$suspenseStackCursor = $8373ca4214e15aed$var$createCursor(0);
function $8373ca4214e15aed$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $8373ca4214e15aed$var$isSuspenseInstancePending(state) || $8373ca4214e15aed$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $8373ca4214e15aed$var$renderLanes = 0, $8373ca4214e15aed$var$currentlyRenderingFiber = null, $8373ca4214e15aed$var$currentHook = null, $8373ca4214e15aed$var$workInProgressHook = null, $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !1, $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $8373ca4214e15aed$var$localIdCounter = 0, $8373ca4214e15aed$var$thenableIndexCounter = 0, $8373ca4214e15aed$var$thenableState = null, $8373ca4214e15aed$var$globalClientIdCounter = 0;
function $8373ca4214e15aed$var$throwInvalidHookError() {
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(321));
}
function $8373ca4214e15aed$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$8373ca4214e15aed$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $8373ca4214e15aed$var$renderLanes = nextRenderLanes;
    $8373ca4214e15aed$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $8373ca4214e15aed$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $8373ca4214e15aed$var$HooksDispatcherOnMount : $8373ca4214e15aed$var$HooksDispatcherOnUpdate;
    $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $8373ca4214e15aed$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $8373ca4214e15aed$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $8373ca4214e15aed$var$finishRenderingHooks(current) {
    $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $8373ca4214e15aed$var$currentHook && null !== $8373ca4214e15aed$var$currentHook.next;
    $8373ca4214e15aed$var$renderLanes = 0;
    $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$currentHook = $8373ca4214e15aed$var$currentlyRenderingFiber = null;
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !1;
    $8373ca4214e15aed$var$thenableIndexCounter = 0;
    $8373ca4214e15aed$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(300));
    null === current || $8373ca4214e15aed$var$didReceiveUpdate || (current = current.dependencies, null !== current && $8373ca4214e15aed$var$checkIfContextChanged(current) && ($8373ca4214e15aed$var$didReceiveUpdate = !0));
}
function $8373ca4214e15aed$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $8373ca4214e15aed$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass && ($8373ca4214e15aed$var$thenableState = null);
        $8373ca4214e15aed$var$thenableIndexCounter = 0;
        $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $8373ca4214e15aed$var$TransitionAwareHostComponent() {
    var dispatcher = $8373ca4214e15aed$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $8373ca4214e15aed$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $8373ca4214e15aed$var$currentHook ? $8373ca4214e15aed$var$currentHook.memoizedState : null) !== dispatcher && ($8373ca4214e15aed$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $8373ca4214e15aed$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $8373ca4214e15aed$var$localIdCounter;
    $8373ca4214e15aed$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $8373ca4214e15aed$var$resetHooksOnUnwind(workInProgress) {
    if ($8373ca4214e15aed$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !1;
    }
    $8373ca4214e15aed$var$renderLanes = 0;
    $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$currentHook = $8373ca4214e15aed$var$currentlyRenderingFiber = null;
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $8373ca4214e15aed$var$thenableIndexCounter = $8373ca4214e15aed$var$localIdCounter = 0;
    $8373ca4214e15aed$var$thenableState = null;
}
function $8373ca4214e15aed$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8373ca4214e15aed$var$workInProgressHook ? $8373ca4214e15aed$var$currentlyRenderingFiber.memoizedState = $8373ca4214e15aed$var$workInProgressHook = hook : $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$workInProgressHook.next = hook;
    return $8373ca4214e15aed$var$workInProgressHook;
}
function $8373ca4214e15aed$var$updateWorkInProgressHook() {
    if (null === $8373ca4214e15aed$var$currentHook) {
        var nextCurrentHook = $8373ca4214e15aed$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $8373ca4214e15aed$var$currentHook.next;
    var nextWorkInProgressHook = null === $8373ca4214e15aed$var$workInProgressHook ? $8373ca4214e15aed$var$currentlyRenderingFiber.memoizedState : $8373ca4214e15aed$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $8373ca4214e15aed$var$workInProgressHook = nextWorkInProgressHook, $8373ca4214e15aed$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $8373ca4214e15aed$var$currentlyRenderingFiber.alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(467));
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(310));
        }
        $8373ca4214e15aed$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $8373ca4214e15aed$var$currentHook.memoizedState,
            baseState: $8373ca4214e15aed$var$currentHook.baseState,
            baseQueue: $8373ca4214e15aed$var$currentHook.baseQueue,
            queue: $8373ca4214e15aed$var$currentHook.queue,
            next: null
        };
        null === $8373ca4214e15aed$var$workInProgressHook ? $8373ca4214e15aed$var$currentlyRenderingFiber.memoizedState = $8373ca4214e15aed$var$workInProgressHook = nextCurrentHook : $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$workInProgressHook.next = nextCurrentHook;
    }
    return $8373ca4214e15aed$var$workInProgressHook;
}
function $8373ca4214e15aed$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $8373ca4214e15aed$var$useThenable(thenable) {
    var index = $8373ca4214e15aed$var$thenableIndexCounter;
    $8373ca4214e15aed$var$thenableIndexCounter += 1;
    null === $8373ca4214e15aed$var$thenableState && ($8373ca4214e15aed$var$thenableState = []);
    thenable = $8373ca4214e15aed$var$trackUsedThenable($8373ca4214e15aed$var$thenableState, thenable, index);
    index = $8373ca4214e15aed$var$currentlyRenderingFiber;
    null === (null === $8373ca4214e15aed$var$workInProgressHook ? index.memoizedState : $8373ca4214e15aed$var$workInProgressHook.next) && (index = index.alternate, $8373ca4214e15aed$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $8373ca4214e15aed$var$HooksDispatcherOnMount : $8373ca4214e15aed$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $8373ca4214e15aed$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $8373ca4214e15aed$var$useThenable(usable);
        if (usable.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return $8373ca4214e15aed$var$readContext(usable);
    }
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(438, String(usable)));
}
function $8373ca4214e15aed$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $8373ca4214e15aed$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $8373ca4214e15aed$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $8373ca4214e15aed$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $8373ca4214e15aed$var$updateReducer(reducer) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    return $8373ca4214e15aed$var$updateReducerImpl(hook, $8373ca4214e15aed$var$currentHook, reducer);
}
function $8373ca4214e15aed$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($8373ca4214e15aed$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($8373ca4214e15aed$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $8373ca4214e15aed$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($8373ca4214e15aed$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $8373ca4214e15aed$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= revertLane, $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= updateLane, $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$8373ca4214e15aed$var$objectIs(pendingQueue, hook.memoizedState) && ($8373ca4214e15aed$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $8373ca4214e15aed$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $8373ca4214e15aed$var$rerenderReducer(reducer) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $8373ca4214e15aed$var$objectIs(newState, hook.memoizedState) || ($8373ca4214e15aed$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $8373ca4214e15aed$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $8373ca4214e15aed$var$currentlyRenderingFiber, hook = $8373ca4214e15aed$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $8373ca4214e15aed$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$8373ca4214e15aed$var$objectIs(($8373ca4214e15aed$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $8373ca4214e15aed$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $8373ca4214e15aed$var$updateEffect($8373ca4214e15aed$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $8373ca4214e15aed$var$workInProgressHook && $8373ca4214e15aed$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $8373ca4214e15aed$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $8373ca4214e15aed$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $8373ca4214e15aed$var$workInProgressRoot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($8373ca4214e15aed$var$renderLanes & 127) || $8373ca4214e15aed$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $8373ca4214e15aed$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $8373ca4214e15aed$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $8373ca4214e15aed$var$checkIfSnapshotChanged(inst) && $8373ca4214e15aed$var$forceStoreRerender(fiber);
}
function $8373ca4214e15aed$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $8373ca4214e15aed$var$checkIfSnapshotChanged(inst) && $8373ca4214e15aed$var$forceStoreRerender(fiber);
    });
}
function $8373ca4214e15aed$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$8373ca4214e15aed$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $8373ca4214e15aed$var$forceStoreRerender(fiber) {
    var root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $8373ca4214e15aed$var$mountStateImpl(initialState) {
    var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8373ca4214e15aed$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $8373ca4214e15aed$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $8373ca4214e15aed$var$updateReducerImpl(hook, $8373ca4214e15aed$var$currentHook, "function" === typeof reducer ? reducer : $8373ca4214e15aed$var$basicStateReducer);
}
function $8373ca4214e15aed$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($8373ca4214e15aed$var$isRenderPhaseUpdate(fiber)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $8373ca4214e15aed$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $8373ca4214e15aed$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $8373ca4214e15aed$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T, currentTransition = {};
        $8373ca4214e15aed$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $8373ca4214e15aed$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $8373ca4214e15aed$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $8373ca4214e15aed$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $8373ca4214e15aed$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $8373ca4214e15aed$var$onActionError(actionQueue, node, error$66);
    }
}
function $8373ca4214e15aed$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $8373ca4214e15aed$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $8373ca4214e15aed$var$onActionError(actionQueue, node, error);
    }) : $8373ca4214e15aed$var$onActionSuccess(actionQueue, node, returnValue);
}
function $8373ca4214e15aed$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $8373ca4214e15aed$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $8373ca4214e15aed$var$runActionStateAction(actionQueue, nextState)));
}
function $8373ca4214e15aed$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $8373ca4214e15aed$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $8373ca4214e15aed$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $8373ca4214e15aed$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $8373ca4214e15aed$var$mountActionState(action, initialStateProp) {
    if ($8373ca4214e15aed$var$isHydrating) {
        var ssrFormState = $8373ca4214e15aed$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $8373ca4214e15aed$var$currentlyRenderingFiber;
                if ($8373ca4214e15aed$var$isHydrating) {
                    if ($8373ca4214e15aed$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $8373ca4214e15aed$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $8373ca4214e15aed$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $8373ca4214e15aed$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $8373ca4214e15aed$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $8373ca4214e15aed$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8373ca4214e15aed$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $8373ca4214e15aed$var$dispatchSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $8373ca4214e15aed$var$mountStateImpl(!1);
    inRootOrSingleton = $8373ca4214e15aed$var$dispatchOptimisticSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $8373ca4214e15aed$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $8373ca4214e15aed$var$dispatchActionState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $8373ca4214e15aed$var$updateActionState(action) {
    var stateHook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    return $8373ca4214e15aed$var$updateActionStateImpl(stateHook, $8373ca4214e15aed$var$currentHook, action);
}
function $8373ca4214e15aed$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $8373ca4214e15aed$var$updateReducerImpl(stateHook, currentStateHook, $8373ca4214e15aed$var$actionStateReducer)[0];
    stateHook = $8373ca4214e15aed$var$updateReducer($8373ca4214e15aed$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $8373ca4214e15aed$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $8373ca4214e15aed$var$SuspenseException) throw $8373ca4214e15aed$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($8373ca4214e15aed$var$currentlyRenderingFiber.flags |= 2048, $8373ca4214e15aed$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $8373ca4214e15aed$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $8373ca4214e15aed$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $8373ca4214e15aed$var$rerenderActionState(action) {
    var stateHook = $8373ca4214e15aed$var$updateWorkInProgressHook(), currentStateHook = $8373ca4214e15aed$var$currentHook;
    if (null !== currentStateHook) return $8373ca4214e15aed$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $8373ca4214e15aed$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $8373ca4214e15aed$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $8373ca4214e15aed$var$updateRef() {
    return $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
}
function $8373ca4214e15aed$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
    $8373ca4214e15aed$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $8373ca4214e15aed$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $8373ca4214e15aed$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $8373ca4214e15aed$var$currentHook && null !== deps && $8373ca4214e15aed$var$areHookInputsEqual(deps, $8373ca4214e15aed$var$currentHook.memoizedState.deps) ? hook.memoizedState = $8373ca4214e15aed$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($8373ca4214e15aed$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $8373ca4214e15aed$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $8373ca4214e15aed$var$mountEffect(create, deps) {
    $8373ca4214e15aed$var$mountEffectImpl(8390656, 8, create, deps);
}
function $8373ca4214e15aed$var$updateEffect(create, deps) {
    $8373ca4214e15aed$var$updateEffectImpl(2048, 8, create, deps);
}
function $8373ca4214e15aed$var$useEffectEventImpl(payload) {
    $8373ca4214e15aed$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $8373ca4214e15aed$var$updateEvent(callback) {
    var ref = $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
    $8373ca4214e15aed$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($8373ca4214e15aed$var$executionContext & 2)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $8373ca4214e15aed$var$updateInsertionEffect(create, deps) {
    return $8373ca4214e15aed$var$updateEffectImpl(4, 2, create, deps);
}
function $8373ca4214e15aed$var$updateLayoutEffect(create, deps) {
    return $8373ca4214e15aed$var$updateEffectImpl(4, 4, create, deps);
}
function $8373ca4214e15aed$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $8373ca4214e15aed$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $8373ca4214e15aed$var$updateEffectImpl(4, 4, $8373ca4214e15aed$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $8373ca4214e15aed$var$mountDebugValue() {}
function $8373ca4214e15aed$var$updateCallback(callback, deps) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8373ca4214e15aed$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $8373ca4214e15aed$var$updateMemo(nextCreate, deps) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8373ca4214e15aed$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($8373ca4214e15aed$var$renderLanes & 1073741824) && 0 === ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $8373ca4214e15aed$var$requestDeferredLane();
    $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= hook;
    $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $8373ca4214e15aed$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($8373ca4214e15aed$var$objectIs(value, prevValue)) return value;
    if (null !== $8373ca4214e15aed$var$currentTreeHiddenStackCursor.current) return hook = $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue), $8373ca4214e15aed$var$objectIs(hook, prevValue) || ($8373ca4214e15aed$var$didReceiveUpdate = !0), hook;
    if (0 === ($8373ca4214e15aed$var$renderLanes & 42) || 0 !== ($8373ca4214e15aed$var$renderLanes & 1073741824) && 0 === ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 261930)) return $8373ca4214e15aed$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $8373ca4214e15aed$var$requestDeferredLane();
    $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= hook;
    $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $8373ca4214e15aed$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T, currentTransition = {};
    $8373ca4214e15aed$var$ReactSharedInternals.T = currentTransition;
    $8373ca4214e15aed$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $8373ca4214e15aed$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $8373ca4214e15aed$var$chainThenableValue(returnValue, finishedState);
            $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $8373ca4214e15aed$var$requestUpdateLane(fiber));
        } else $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, finishedState, $8373ca4214e15aed$var$requestUpdateLane(fiber));
    } catch (error) {
        $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $8373ca4214e15aed$var$requestUpdateLane());
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8373ca4214e15aed$var$noop() {}
function $8373ca4214e15aed$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(476));
    var queue = $8373ca4214e15aed$var$ensureFormComponentIsStateful(formFiber).queue;
    $8373ca4214e15aed$var$startTransition(formFiber, queue, pendingState, $8373ca4214e15aed$var$sharedNotPendingObject, null === action ? $8373ca4214e15aed$var$noop : function() {
        $8373ca4214e15aed$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $8373ca4214e15aed$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $8373ca4214e15aed$var$sharedNotPendingObject,
        baseState: $8373ca4214e15aed$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8373ca4214e15aed$var$basicStateReducer,
            lastRenderedState: $8373ca4214e15aed$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8373ca4214e15aed$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $8373ca4214e15aed$var$requestFormReset$1(formFiber) {
    var stateHook = $8373ca4214e15aed$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $8373ca4214e15aed$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $8373ca4214e15aed$var$requestUpdateLane());
}
function $8373ca4214e15aed$var$useHostTransitionStatus() {
    return $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$HostTransitionContext);
}
function $8373ca4214e15aed$var$updateId() {
    return $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
}
function $8373ca4214e15aed$var$updateRefresh() {
    return $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
}
function $8373ca4214e15aed$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $8373ca4214e15aed$var$requestUpdateLane();
                fiber = $8373ca4214e15aed$var$createUpdate(lane);
                var root$69 = $8373ca4214e15aed$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(root$69, provider, lane), $8373ca4214e15aed$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $8373ca4214e15aed$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $8373ca4214e15aed$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $8373ca4214e15aed$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $8373ca4214e15aed$var$isRenderPhaseUpdate(fiber) ? $8373ca4214e15aed$var$enqueueRenderPhaseUpdate(queue, action) : (action = $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(action, fiber, lane), $8373ca4214e15aed$var$entangleTransitionUpdate(action, queue, lane)));
}
function $8373ca4214e15aed$var$dispatchSetState(fiber, queue, action) {
    var lane = $8373ca4214e15aed$var$requestUpdateLane();
    $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8373ca4214e15aed$var$isRenderPhaseUpdate(fiber)) $8373ca4214e15aed$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($8373ca4214e15aed$var$objectIs(eagerState, currentState)) return $8373ca4214e15aed$var$enqueueUpdate$1(fiber, queue, update, 0), null === $8373ca4214e15aed$var$workInProgressRoot && $8373ca4214e15aed$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $8373ca4214e15aed$var$scheduleUpdateOnFiber(action, fiber, lane), $8373ca4214e15aed$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $8373ca4214e15aed$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $8373ca4214e15aed$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8373ca4214e15aed$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $8373ca4214e15aed$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $8373ca4214e15aed$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $8373ca4214e15aed$var$currentlyRenderingFiber || null !== alternate && alternate === $8373ca4214e15aed$var$currentlyRenderingFiber;
}
function $8373ca4214e15aed$var$enqueueRenderPhaseUpdate(queue, update) {
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $8373ca4214e15aed$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $8373ca4214e15aed$var$markRootEntangled(root, lane);
    }
}
var $8373ca4214e15aed$var$ContextOnlyDispatcher = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: $8373ca4214e15aed$var$throwInvalidHookError,
    useContext: $8373ca4214e15aed$var$throwInvalidHookError,
    useEffect: $8373ca4214e15aed$var$throwInvalidHookError,
    useImperativeHandle: $8373ca4214e15aed$var$throwInvalidHookError,
    useLayoutEffect: $8373ca4214e15aed$var$throwInvalidHookError,
    useInsertionEffect: $8373ca4214e15aed$var$throwInvalidHookError,
    useMemo: $8373ca4214e15aed$var$throwInvalidHookError,
    useReducer: $8373ca4214e15aed$var$throwInvalidHookError,
    useRef: $8373ca4214e15aed$var$throwInvalidHookError,
    useState: $8373ca4214e15aed$var$throwInvalidHookError,
    useDebugValue: $8373ca4214e15aed$var$throwInvalidHookError,
    useDeferredValue: $8373ca4214e15aed$var$throwInvalidHookError,
    useTransition: $8373ca4214e15aed$var$throwInvalidHookError,
    useSyncExternalStore: $8373ca4214e15aed$var$throwInvalidHookError,
    useId: $8373ca4214e15aed$var$throwInvalidHookError,
    useHostTransitionStatus: $8373ca4214e15aed$var$throwInvalidHookError,
    useFormState: $8373ca4214e15aed$var$throwInvalidHookError,
    useActionState: $8373ca4214e15aed$var$throwInvalidHookError,
    useOptimistic: $8373ca4214e15aed$var$throwInvalidHookError,
    useMemoCache: $8373ca4214e15aed$var$throwInvalidHookError,
    useCacheRefresh: $8373ca4214e15aed$var$throwInvalidHookError
};
$8373ca4214e15aed$var$ContextOnlyDispatcher.useEffectEvent = $8373ca4214e15aed$var$throwInvalidHookError;
var $8373ca4214e15aed$var$HooksDispatcherOnMount = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: function(callback, deps) {
        $8373ca4214e15aed$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $8373ca4214e15aed$var$readContext,
    useEffect: $8373ca4214e15aed$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $8373ca4214e15aed$var$mountEffectImpl(4194308, 4, $8373ca4214e15aed$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $8373ca4214e15aed$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $8373ca4214e15aed$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $8373ca4214e15aed$var$dispatchReducerAction.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $8373ca4214e15aed$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $8373ca4214e15aed$var$dispatchSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $8373ca4214e15aed$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        return $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $8373ca4214e15aed$var$mountStateImpl(!1);
        stateHook = $8373ca4214e15aed$var$startTransition.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $8373ca4214e15aed$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $8373ca4214e15aed$var$currentlyRenderingFiber, hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        if ($8373ca4214e15aed$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $8373ca4214e15aed$var$workInProgressRoot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(349));
            0 !== ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 127) || $8373ca4214e15aed$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $8373ca4214e15aed$var$mountEffect($8373ca4214e15aed$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $8373ca4214e15aed$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $8373ca4214e15aed$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook(), identifierPrefix = $8373ca4214e15aed$var$workInProgressRoot.identifierPrefix;
        if ($8373ca4214e15aed$var$isHydrating) {
            var JSCompiler_inline_result = $8373ca4214e15aed$var$treeContextOverflow;
            var idWithLeadingBit = $8373ca4214e15aed$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $8373ca4214e15aed$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $8373ca4214e15aed$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $8373ca4214e15aed$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $8373ca4214e15aed$var$useHostTransitionStatus,
    useFormState: $8373ca4214e15aed$var$mountActionState,
    useActionState: $8373ca4214e15aed$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $8373ca4214e15aed$var$dispatchOptimisticSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $8373ca4214e15aed$var$useMemoCache,
    useCacheRefresh: function() {
        return $8373ca4214e15aed$var$mountWorkInProgressHook().memoizedState = $8373ca4214e15aed$var$refreshCache.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($8373ca4214e15aed$var$executionContext & 2)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $8373ca4214e15aed$var$HooksDispatcherOnUpdate = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: $8373ca4214e15aed$var$updateCallback,
    useContext: $8373ca4214e15aed$var$readContext,
    useEffect: $8373ca4214e15aed$var$updateEffect,
    useImperativeHandle: $8373ca4214e15aed$var$updateImperativeHandle,
    useInsertionEffect: $8373ca4214e15aed$var$updateInsertionEffect,
    useLayoutEffect: $8373ca4214e15aed$var$updateLayoutEffect,
    useMemo: $8373ca4214e15aed$var$updateMemo,
    useReducer: $8373ca4214e15aed$var$updateReducer,
    useRef: $8373ca4214e15aed$var$updateRef,
    useState: function() {
        return $8373ca4214e15aed$var$updateReducer($8373ca4214e15aed$var$basicStateReducer);
    },
    useDebugValue: $8373ca4214e15aed$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        return $8373ca4214e15aed$var$updateDeferredValueImpl(hook, $8373ca4214e15aed$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8373ca4214e15aed$var$updateReducer($8373ca4214e15aed$var$basicStateReducer)[0], start = $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8373ca4214e15aed$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8373ca4214e15aed$var$updateSyncExternalStore,
    useId: $8373ca4214e15aed$var$updateId,
    useHostTransitionStatus: $8373ca4214e15aed$var$useHostTransitionStatus,
    useFormState: $8373ca4214e15aed$var$updateActionState,
    useActionState: $8373ca4214e15aed$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        return $8373ca4214e15aed$var$updateOptimisticImpl(hook, $8373ca4214e15aed$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $8373ca4214e15aed$var$useMemoCache,
    useCacheRefresh: $8373ca4214e15aed$var$updateRefresh
};
$8373ca4214e15aed$var$HooksDispatcherOnUpdate.useEffectEvent = $8373ca4214e15aed$var$updateEvent;
var $8373ca4214e15aed$var$HooksDispatcherOnRerender = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: $8373ca4214e15aed$var$updateCallback,
    useContext: $8373ca4214e15aed$var$readContext,
    useEffect: $8373ca4214e15aed$var$updateEffect,
    useImperativeHandle: $8373ca4214e15aed$var$updateImperativeHandle,
    useInsertionEffect: $8373ca4214e15aed$var$updateInsertionEffect,
    useLayoutEffect: $8373ca4214e15aed$var$updateLayoutEffect,
    useMemo: $8373ca4214e15aed$var$updateMemo,
    useReducer: $8373ca4214e15aed$var$rerenderReducer,
    useRef: $8373ca4214e15aed$var$updateRef,
    useState: function() {
        return $8373ca4214e15aed$var$rerenderReducer($8373ca4214e15aed$var$basicStateReducer);
    },
    useDebugValue: $8373ca4214e15aed$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        return null === $8373ca4214e15aed$var$currentHook ? $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue) : $8373ca4214e15aed$var$updateDeferredValueImpl(hook, $8373ca4214e15aed$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8373ca4214e15aed$var$rerenderReducer($8373ca4214e15aed$var$basicStateReducer)[0], start = $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8373ca4214e15aed$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8373ca4214e15aed$var$updateSyncExternalStore,
    useId: $8373ca4214e15aed$var$updateId,
    useHostTransitionStatus: $8373ca4214e15aed$var$useHostTransitionStatus,
    useFormState: $8373ca4214e15aed$var$rerenderActionState,
    useActionState: $8373ca4214e15aed$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        if (null !== $8373ca4214e15aed$var$currentHook) return $8373ca4214e15aed$var$updateOptimisticImpl(hook, $8373ca4214e15aed$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $8373ca4214e15aed$var$useMemoCache,
    useCacheRefresh: $8373ca4214e15aed$var$updateRefresh
};
$8373ca4214e15aed$var$HooksDispatcherOnRerender.useEffectEvent = $8373ca4214e15aed$var$updateEvent;
function $8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $8373ca4214e15aed$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $8373ca4214e15aed$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8373ca4214e15aed$var$requestUpdateLane(), update = $8373ca4214e15aed$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8373ca4214e15aed$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(payload, inst, lane), $8373ca4214e15aed$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8373ca4214e15aed$var$requestUpdateLane(), update = $8373ca4214e15aed$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8373ca4214e15aed$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(payload, inst, lane), $8373ca4214e15aed$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $8373ca4214e15aed$var$requestUpdateLane(), update = $8373ca4214e15aed$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $8373ca4214e15aed$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(callback, inst, lane), $8373ca4214e15aed$var$entangleTransitions(callback, inst, lane));
    }
};
function $8373ca4214e15aed$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$8373ca4214e15aed$var$shallowEqual(oldProps, newProps) || !$8373ca4214e15aed$var$shallowEqual(oldState, newState) : !0;
}
function $8373ca4214e15aed$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $8373ca4214e15aed$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $8373ca4214e15aed$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $8373ca4214e15aed$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $8373ca4214e15aed$var$defaultOnUncaughtError(error) {
    $8373ca4214e15aed$var$reportGlobalError(error);
}
function $8373ca4214e15aed$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $8373ca4214e15aed$var$defaultOnRecoverableError(error) {
    $8373ca4214e15aed$var$reportGlobalError(error);
}
function $8373ca4214e15aed$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $8373ca4214e15aed$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $8373ca4214e15aed$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $8373ca4214e15aed$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $8373ca4214e15aed$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $8373ca4214e15aed$var$createClassErrorUpdate(lane) {
    lane = $8373ca4214e15aed$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $8373ca4214e15aed$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $8373ca4214e15aed$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $8373ca4214e15aed$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed ? $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $8373ca4214e15aed$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $8373ca4214e15aed$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $8373ca4214e15aed$var$shellBoundary ? $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $8373ca4214e15aed$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $8373ca4214e15aed$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $8373ca4214e15aed$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $8373ca4214e15aed$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $8373ca4214e15aed$var$attachPingListener(root, value, rootRenderLanes);
        $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($8373ca4214e15aed$var$isHydrating) return returnFiber = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $8373ca4214e15aed$var$HydrationMismatchException && (root = Error($8373ca4214e15aed$var$formatProdErrorMessage(422), {
        cause: value
    }), $8373ca4214e15aed$var$queueHydrationError($8373ca4214e15aed$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $8373ca4214e15aed$var$HydrationMismatchException && (returnFiber = Error($8373ca4214e15aed$var$formatProdErrorMessage(423), {
        cause: value
    }), $8373ca4214e15aed$var$queueHydrationError($8373ca4214e15aed$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $8373ca4214e15aed$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $8373ca4214e15aed$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $8373ca4214e15aed$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($8373ca4214e15aed$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $8373ca4214e15aed$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $8373ca4214e15aed$var$workInProgressRootConcurrentErrors ? $8373ca4214e15aed$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $8373ca4214e15aed$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $8373ca4214e15aed$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $8373ca4214e15aed$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $8373ca4214e15aed$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed || !$8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $8373ca4214e15aed$var$createClassErrorUpdate(rootRenderLanes), $8373ca4214e15aed$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $8373ca4214e15aed$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $8373ca4214e15aed$var$SelectiveHydrationException = Error($8373ca4214e15aed$var$formatProdErrorMessage(461)), $8373ca4214e15aed$var$didReceiveUpdate = !1;
function $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $8373ca4214e15aed$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $8373ca4214e15aed$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    nextProps = $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $8373ca4214e15aed$var$checkDidRenderIdHook();
    if (null !== current && !$8373ca4214e15aed$var$didReceiveUpdate) return $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, renderLanes), $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8373ca4214e15aed$var$isHydrating && key && $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$8373ca4214e15aed$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $8373ca4214e15aed$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $8373ca4214e15aed$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $8373ca4214e15aed$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $8373ca4214e15aed$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $8373ca4214e15aed$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($8373ca4214e15aed$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($8373ca4214e15aed$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($8373ca4214e15aed$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $8373ca4214e15aed$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $8373ca4214e15aed$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $8373ca4214e15aed$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $8373ca4214e15aed$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $8373ca4214e15aed$var$pushHiddenContext(workInProgress, prevState) : $8373ca4214e15aed$var$reuseHiddenContextOnStack(), $8373ca4214e15aed$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $8373ca4214e15aed$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($8373ca4214e15aed$var$pushTransition(workInProgress, prevState.cachePool), $8373ca4214e15aed$var$pushHiddenContext(workInProgress, prevState), $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $8373ca4214e15aed$var$pushTransition(workInProgress, null), $8373ca4214e15aed$var$reuseHiddenContextOnStack(), $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress));
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $8373ca4214e15aed$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $8373ca4214e15aed$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $8373ca4214e15aed$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $8373ca4214e15aed$var$pushTransition(workInProgress, null);
    $8373ca4214e15aed$var$reuseHiddenContextOnStack();
    $8373ca4214e15aed$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $8373ca4214e15aed$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8373ca4214e15aed$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $8373ca4214e15aed$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($8373ca4214e15aed$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $8373ca4214e15aed$var$bailoutOffscreenComponent(null, current);
            $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $8373ca4214e15aed$var$nextHydratableInstance) ? (current = $8373ca4214e15aed$var$canHydrateHydrationBoundary(current, $8373ca4214e15aed$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8373ca4214e15aed$var$treeContextProvider ? {
                    id: $8373ca4214e15aed$var$treeContextId,
                    overflow: $8373ca4214e15aed$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8373ca4214e15aed$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $8373ca4214e15aed$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($8373ca4214e15aed$var$formatProdErrorMessage(558));
        } else if ($8373ca4214e15aed$var$didReceiveUpdate || $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $8373ca4214e15aed$var$didReceiveUpdate || didSuspend) {
            nextProps = $8373ca4214e15aed$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $8373ca4214e15aed$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(current, dehydrated), $8373ca4214e15aed$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $8373ca4214e15aed$var$SelectiveHydrationException;
            $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible();
            workInProgress = $8373ca4214e15aed$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(dehydrated.nextSibling), $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$isHydrating = !0, $8373ca4214e15aed$var$hydrationErrors = null, $8373ca4214e15aed$var$rootOrSingletonContext = !1, null !== current && $8373ca4214e15aed$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $8373ca4214e15aed$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $8373ca4214e15aed$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $8373ca4214e15aed$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    Component = $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $8373ca4214e15aed$var$checkDidRenderIdHook();
    if (null !== current && !$8373ca4214e15aed$var$didReceiveUpdate) return $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, renderLanes), $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8373ca4214e15aed$var$isHydrating && nextProps && $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $8373ca4214e15aed$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $8373ca4214e15aed$var$finishRenderingHooks(current);
    Component = $8373ca4214e15aed$var$checkDidRenderIdHook();
    if (null !== current && !$8373ca4214e15aed$var$didReceiveUpdate) return $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, renderLanes), $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8373ca4214e15aed$var$isHydrating && Component && $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $8373ca4214e15aed$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $8373ca4214e15aed$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $8373ca4214e15aed$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $8373ca4214e15aed$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $8373ca4214e15aed$var$readContext(contextType) : $8373ca4214e15aed$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $8373ca4214e15aed$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $8373ca4214e15aed$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $8373ca4214e15aed$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $8373ca4214e15aed$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $8373ca4214e15aed$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $8373ca4214e15aed$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $8373ca4214e15aed$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8373ca4214e15aed$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $8373ca4214e15aed$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $8373ca4214e15aed$var$hasForceUpdate || $8373ca4214e15aed$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $8373ca4214e15aed$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $8373ca4214e15aed$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $8373ca4214e15aed$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $8373ca4214e15aed$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $8373ca4214e15aed$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8373ca4214e15aed$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $8373ca4214e15aed$var$hasForceUpdate || null !== current && null !== current.dependencies && $8373ca4214e15aed$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $8373ca4214e15aed$var$hasForceUpdate || $8373ca4214e15aed$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $8373ca4214e15aed$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $8373ca4214e15aed$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $8373ca4214e15aed$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $8373ca4214e15aed$var$resetHydrationState();
    workInProgress.flags |= 256;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $8373ca4214e15aed$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $8373ca4214e15aed$var$getSuspendedCache()
    };
}
function $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $8373ca4214e15aed$var$workInProgressDeferredLane);
    return current;
}
function $8373ca4214e15aed$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($8373ca4214e15aed$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($8373ca4214e15aed$var$isHydrating) {
            showFallback ? $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $8373ca4214e15aed$var$nextHydratableInstance) ? (current = $8373ca4214e15aed$var$canHydrateHydrationBoundary(current, $8373ca4214e15aed$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8373ca4214e15aed$var$treeContextProvider ? {
                    id: $8373ca4214e15aed$var$treeContextId,
                    overflow: $8373ca4214e15aed$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8373ca4214e15aed$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            $8373ca4214e15aed$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $8373ca4214e15aed$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8373ca4214e15aed$var$SUSPENDED_MARKER, $8373ca4214e15aed$var$bailoutOffscreenComponent(null, nextProps);
        $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $8373ca4214e15aed$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8373ca4214e15aed$var$SUSPENDED_MARKER, workInProgress = $8373ca4214e15aed$var$bailoutOffscreenComponent(null, nextProps));
        else if ($8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress), $8373ca4214e15aed$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($8373ca4214e15aed$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $8373ca4214e15aed$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($8373ca4214e15aed$var$didReceiveUpdate || $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $8373ca4214e15aed$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $8373ca4214e15aed$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $8373ca4214e15aed$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(current, nextProps), $8373ca4214e15aed$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $8373ca4214e15aed$var$SelectiveHydrationException;
            $8373ca4214e15aed$var$isSuspenseInstancePending(nextPrimaryChildren) || $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible();
            workInProgress = $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $8373ca4214e15aed$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(nextPrimaryChildren.nextSibling), $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$isHydrating = !0, $8373ca4214e15aed$var$hydrationErrors = null, $8373ca4214e15aed$var$rootOrSingletonContext = !1, null !== current && $8373ca4214e15aed$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $8373ca4214e15aed$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $8373ca4214e15aed$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $8373ca4214e15aed$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $8373ca4214e15aed$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $8373ca4214e15aed$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $8373ca4214e15aed$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8373ca4214e15aed$var$SUSPENDED_MARKER, $8373ca4214e15aed$var$bailoutOffscreenComponent(current.child, nextProps);
    $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $8373ca4214e15aed$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $8373ca4214e15aed$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $8373ca4214e15aed$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $8373ca4214e15aed$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $8373ca4214e15aed$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, suspenseContext);
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $8373ca4214e15aed$var$isHydrating ? $8373ca4214e15aed$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $8373ca4214e15aed$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $8373ca4214e15aed$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $8373ca4214e15aed$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $8373ca4214e15aed$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $8373ca4214e15aed$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $8373ca4214e15aed$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $8373ca4214e15aed$var$checkIfContextChanged(current) ? !0 : !1;
}
function $8373ca4214e15aed$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, current.memoizedState.cache);
            $8373ca4214e15aed$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $8373ca4214e15aed$var$pushHostContext(workInProgress);
            break;
        case 4:
            $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $8373ca4214e15aed$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $8373ca4214e15aed$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $8373ca4214e15aed$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $8373ca4214e15aed$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, current.memoizedState.cache);
    }
    return $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $8373ca4214e15aed$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $8373ca4214e15aed$var$didReceiveUpdate = !0;
        else {
            if (!$8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $8373ca4214e15aed$var$didReceiveUpdate = !1, $8373ca4214e15aed$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $8373ca4214e15aed$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $8373ca4214e15aed$var$didReceiveUpdate = !1, $8373ca4214e15aed$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $8373ca4214e15aed$var$pushTreeId(workInProgress, $8373ca4214e15aed$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $8373ca4214e15aed$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $8373ca4214e15aed$var$shouldConstruct(current) ? (props = $8373ca4214e15aed$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $8373ca4214e15aed$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $8373ca4214e15aed$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $8373ca4214e15aed$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $8373ca4214e15aed$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $8373ca4214e15aed$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $8373ca4214e15aed$var$getComponentNameFromType(current) || current;
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $8373ca4214e15aed$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $8373ca4214e15aed$var$resolveClassComponentProps(props, workInProgress.pendingProps), $8373ca4214e15aed$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress);
                $8373ca4214e15aed$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, props);
                props !== prevState.cache && $8373ca4214e15aed$var$propagateContextChanges(workInProgress, [
                    $8373ca4214e15aed$var$CacheContext
                ], renderLanes, !0);
                $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $8373ca4214e15aed$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $8373ca4214e15aed$var$createCapturedValueAtFiber(Error($8373ca4214e15aed$var$formatProdErrorMessage(424)), workInProgress);
                        $8373ca4214e15aed$var$queueHydrationError($$typeof);
                        workInProgress = $8373ca4214e15aed$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(current.firstChild);
                        $8373ca4214e15aed$var$hydrationParentFiber = workInProgress;
                        $8373ca4214e15aed$var$isHydrating = !0;
                        $8373ca4214e15aed$var$hydrationErrors = null;
                        $8373ca4214e15aed$var$rootOrSingletonContext = !0;
                        renderLanes = $8373ca4214e15aed$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $8373ca4214e15aed$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $8373ca4214e15aed$var$markRef(current, workInProgress), null === current ? (renderLanes = $8373ca4214e15aed$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $8373ca4214e15aed$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer($8373ca4214e15aed$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress, props[$8373ca4214e15aed$var$internalPropsKey] = current, $8373ca4214e15aed$var$setInitialProperties(props, renderLanes, current), $8373ca4214e15aed$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $8373ca4214e15aed$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $8373ca4214e15aed$var$pushHostContext(workInProgress), null === current && $8373ca4214e15aed$var$isHydrating && (props = workInProgress.stateNode = $8373ca4214e15aed$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $8373ca4214e15aed$var$rootInstanceStackCursor.current), $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$rootOrSingletonContext = !0, $$typeof = $8373ca4214e15aed$var$nextHydratableInstance, $8373ca4214e15aed$var$isSingletonScope(workInProgress.type) ? ($8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(props.firstChild)) : $8373ca4214e15aed$var$nextHydratableInstance = $$typeof), $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $8373ca4214e15aed$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $8373ca4214e15aed$var$isHydrating) {
                if ($$typeof = props = $8373ca4214e15aed$var$nextHydratableInstance) props = $8373ca4214e15aed$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $8373ca4214e15aed$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(props.firstChild), $8373ca4214e15aed$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            }
            $8373ca4214e15aed$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $8373ca4214e15aed$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $8373ca4214e15aed$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, $8373ca4214e15aed$var$TransitionAwareHostComponent, null, null, renderLanes), $8373ca4214e15aed$var$HostTransitionContext._currentValue = $$typeof);
            $8373ca4214e15aed$var$markRef(current, workInProgress);
            $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $8373ca4214e15aed$var$isHydrating) {
                if (current = renderLanes = $8373ca4214e15aed$var$nextHydratableInstance) renderLanes = $8373ca4214e15aed$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $8373ca4214e15aed$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $8373ca4214e15aed$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $8373ca4214e15aed$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $8373ca4214e15aed$var$pushProvider(workInProgress, workInProgress.type, props.value), $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $8373ca4214e15aed$var$prepareToReadContext(workInProgress), $$typeof = $8373ca4214e15aed$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $8373ca4214e15aed$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $8373ca4214e15aed$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $8373ca4214e15aed$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $8373ca4214e15aed$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $8373ca4214e15aed$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $8373ca4214e15aed$var$prepareToReadContext(workInProgress), props = $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$CacheContext), null === current ? ($$typeof = $8373ca4214e15aed$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $8373ca4214e15aed$var$workInProgressRoot, prevState = $8373ca4214e15aed$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $8373ca4214e15aed$var$initializeUpdateQueue(workInProgress), $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress), $8373ca4214e15aed$var$processUpdateQueue(workInProgress, null, null, renderLanes), $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, props)) : (props = prevState.cache, $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, props), props !== $$typeof.cache && $8373ca4214e15aed$var$propagateContextChanges(workInProgress, [
                $8373ca4214e15aed$var$CacheContext
            ], renderLanes, !0))), $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8373ca4214e15aed$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($8373ca4214e15aed$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $8373ca4214e15aed$var$suspendedThenable = $8373ca4214e15aed$var$noopSuspenseyCommitThenable, $8373ca4214e15aed$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $8373ca4214e15aed$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$8373ca4214e15aed$var$preloadResource(resource)) {
        if ($8373ca4214e15aed$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $8373ca4214e15aed$var$suspendedThenable = $8373ca4214e15aed$var$noopSuspenseyCommitThenable, $8373ca4214e15aed$var$SuspenseyCommitException;
    }
}
function $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $8373ca4214e15aed$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $8373ca4214e15aed$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$8373ca4214e15aed$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $8373ca4214e15aed$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $8373ca4214e15aed$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $8373ca4214e15aed$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 1:
            return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext);
            $8373ca4214e15aed$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $8373ca4214e15aed$var$popHydrationState(workInProgress) ? $8373ca4214e15aed$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable());
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($8373ca4214e15aed$var$markUpdate(workInProgress), null !== nextResource ? ($8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($8373ca4214e15aed$var$markUpdate(workInProgress), $8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8373ca4214e15aed$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress), $8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $8373ca4214e15aed$var$popHostContext(workInProgress);
            renderLanes = $8373ca4214e15aed$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(166));
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $8373ca4214e15aed$var$contextStackCursor.current;
                $8373ca4214e15aed$var$popHydrationState(workInProgress) ? $8373ca4214e15aed$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $8373ca4214e15aed$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $8373ca4214e15aed$var$markUpdate(workInProgress));
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $8373ca4214e15aed$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(166));
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $8373ca4214e15aed$var$contextStackCursor.current;
                if ($8373ca4214e15aed$var$popHydrationState(workInProgress)) $8373ca4214e15aed$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer($8373ca4214e15aed$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script></script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    nextResource[$8373ca4214e15aed$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($8373ca4214e15aed$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
                }
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(166));
                current = $8373ca4214e15aed$var$rootInstanceStackCursor.current;
                if ($8373ca4214e15aed$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $8373ca4214e15aed$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $8373ca4214e15aed$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $8373ca4214e15aed$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(557));
                        current[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    } else $8373ca4214e15aed$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(558));
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $8373ca4214e15aed$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(317));
                        type[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    } else $8373ca4214e15aed$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $8373ca4214e15aed$var$popHostContainer(), null === current && $8373ca4214e15aed$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 10:
            return $8373ca4214e15aed$var$popProvider(workInProgress.type), $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 19:
            $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $8373ca4214e15aed$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $8373ca4214e15aed$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$8373ca4214e15aed$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current & 1 | 2);
                            $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $8373ca4214e15aed$var$now() > $8373ca4214e15aed$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $8373ca4214e15aed$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, current), $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$8373ca4214e15aed$var$isHydrating) return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
                    } else 2 * $8373ca4214e15aed$var$now() - newProps.renderingStartTime > $8373ca4214e15aed$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $8373ca4214e15aed$var$now(), current.sibling = null, renderLanes = $8373ca4214e15aed$var$suspenseStackCursor.current, $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), $8373ca4214e15aed$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($8373ca4214e15aed$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $8373ca4214e15aed$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext), $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8373ca4214e15aed$var$unwindWork(current, workInProgress) {
    $8373ca4214e15aed$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext), $8373ca4214e15aed$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $8373ca4214e15aed$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(340));
                $8373ca4214e15aed$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(340));
                $8373ca4214e15aed$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor), null;
        case 4:
            return $8373ca4214e15aed$var$popHostContainer(), null;
        case 10:
            return $8373ca4214e15aed$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), $8373ca4214e15aed$var$popHiddenContext(), null !== current && $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $8373ca4214e15aed$var$unwindInterruptedWork(current, interruptedWork) {
    $8373ca4214e15aed$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext);
            $8373ca4214e15aed$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $8373ca4214e15aed$var$popHostContext(interruptedWork);
            break;
        case 4:
            $8373ca4214e15aed$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $8373ca4214e15aed$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $8373ca4214e15aed$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor);
            break;
        case 10:
            $8373ca4214e15aed$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $8373ca4214e15aed$var$popSuspenseHandler(interruptedWork);
            $8373ca4214e15aed$var$popHiddenContext();
            null !== current && $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$resumedCache);
            break;
        case 24:
            $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext);
    }
}
function $8373ca4214e15aed$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $8373ca4214e15aed$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8373ca4214e15aed$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $8373ca4214e15aed$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8373ca4214e15aed$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8373ca4214e15aed$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $8373ca4214e15aed$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $8373ca4214e15aed$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$8373ca4214e15aed$var$internalPropsKey] = newProps;
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $8373ca4214e15aed$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $8373ca4214e15aed$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $8373ca4214e15aed$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $8373ca4214e15aed$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $8373ca4214e15aed$var$noop$1));
    else if (4 !== tag && (27 === tag && $8373ca4214e15aed$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $8373ca4214e15aed$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $8373ca4214e15aed$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($8373ca4214e15aed$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$8373ca4214e15aed$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $8373ca4214e15aed$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $8373ca4214e15aed$var$setInitialProperties(singleton, type, props);
        singleton[$8373ca4214e15aed$var$internalInstanceKey] = finishedWork;
        singleton[$8373ca4214e15aed$var$internalPropsKey] = props;
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $8373ca4214e15aed$var$offscreenSubtreeIsHidden = !1, $8373ca4214e15aed$var$offscreenSubtreeWasHidden = !1, $8373ca4214e15aed$var$needsFormReset = !1, $8373ca4214e15aed$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $8373ca4214e15aed$var$nextEffect = null;
function $8373ca4214e15aed$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $8373ca4214e15aed$var$eventsEnabled = $8373ca4214e15aed$var$_enabled;
    root = $8373ca4214e15aed$var$getActiveElementDeep(root);
    if ($8373ca4214e15aed$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $8373ca4214e15aed$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $8373ca4214e15aed$var$_enabled = !1;
    for($8373ca4214e15aed$var$nextEffect = firstChild; null !== $8373ca4214e15aed$var$nextEffect;)if (firstChild = $8373ca4214e15aed$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $8373ca4214e15aed$var$nextEffect = root;
    else for(; null !== $8373ca4214e15aed$var$nextEffect;){
        firstChild = $8373ca4214e15aed$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $8373ca4214e15aed$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $8373ca4214e15aed$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $8373ca4214e15aed$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $8373ca4214e15aed$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $8373ca4214e15aed$var$nextEffect = root;
            break;
        }
        $8373ca4214e15aed$var$nextEffect = firstChild.return;
    }
}
function $8373ca4214e15aed$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8373ca4214e15aed$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $8373ca4214e15aed$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $8373ca4214e15aed$var$commitClassCallbacks(finishedWork);
            flags & 512 && $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $8373ca4214e15aed$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $8373ca4214e15aed$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $8373ca4214e15aed$var$commitHostMount(finishedWork);
            flags & 512 && $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8373ca4214e15aed$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8373ca4214e15aed$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $8373ca4214e15aed$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $8373ca4214e15aed$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $8373ca4214e15aed$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $8373ca4214e15aed$var$offscreenSubtreeWasHidden;
                prevProps = $8373ca4214e15aed$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $8373ca4214e15aed$var$offscreenSubtreeWasHidden;
                $8373ca4214e15aed$var$offscreenSubtreeIsHidden = flags;
                ($8373ca4214e15aed$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $8373ca4214e15aed$var$offscreenSubtreeIsHidden = prevProps;
                $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $8373ca4214e15aed$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $8373ca4214e15aed$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $8373ca4214e15aed$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $8373ca4214e15aed$var$hostParent = null, $8373ca4214e15aed$var$hostParentIsContainer = !1;
function $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$8373ca4214e15aed$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $8373ca4214e15aed$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.onCommitFiberUnmount) try {
        $8373ca4214e15aed$var$injectedHook.onCommitFiberUnmount($8373ca4214e15aed$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $8373ca4214e15aed$var$hostParent, prevHostParentIsContainer = $8373ca4214e15aed$var$hostParentIsContainer;
            $8373ca4214e15aed$var$isSingletonScope(deletedFiber.type) && ($8373ca4214e15aed$var$hostParent = deletedFiber.stateNode, $8373ca4214e15aed$var$hostParentIsContainer = !1);
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$releaseSingletonInstance(deletedFiber.stateNode);
            $8373ca4214e15aed$var$hostParent = prevHostParent;
            $8373ca4214e15aed$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $8373ca4214e15aed$var$hostParent;
            prevHostParentIsContainer = $8373ca4214e15aed$var$hostParentIsContainer;
            $8373ca4214e15aed$var$hostParent = null;
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$hostParent = prevHostParent;
            $8373ca4214e15aed$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $8373ca4214e15aed$var$hostParent) {
                if ($8373ca4214e15aed$var$hostParentIsContainer) try {
                    (9 === $8373ca4214e15aed$var$hostParent.nodeType ? $8373ca4214e15aed$var$hostParent.body : "HTML" === $8373ca4214e15aed$var$hostParent.nodeName ? $8373ca4214e15aed$var$hostParent.ownerDocument.body : $8373ca4214e15aed$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $8373ca4214e15aed$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $8373ca4214e15aed$var$hostParent && ($8373ca4214e15aed$var$hostParentIsContainer ? (finishedRoot = $8373ca4214e15aed$var$hostParent, $8373ca4214e15aed$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $8373ca4214e15aed$var$retryIfBlockedOn(finishedRoot)) : $8373ca4214e15aed$var$clearHydrationBoundary($8373ca4214e15aed$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $8373ca4214e15aed$var$hostParent;
            prevHostParentIsContainer = $8373ca4214e15aed$var$hostParentIsContainer;
            $8373ca4214e15aed$var$hostParent = deletedFiber.stateNode.containerInfo;
            $8373ca4214e15aed$var$hostParentIsContainer = !0;
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$hostParent = prevHostParent;
            $8373ca4214e15aed$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $8373ca4214e15aed$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || ($8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $8373ca4214e15aed$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = (prevHostParent = $8373ca4214e15aed$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $8373ca4214e15aed$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $8373ca4214e15aed$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8373ca4214e15aed$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $8373ca4214e15aed$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $8373ca4214e15aed$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $8373ca4214e15aed$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $8373ca4214e15aed$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $8373ca4214e15aed$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($8373ca4214e15aed$var$isSingletonScope(parent.type)) {
                        $8373ca4214e15aed$var$hostParent = parent.stateNode;
                        $8373ca4214e15aed$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $8373ca4214e15aed$var$hostParent = parent.stateNode;
                    $8373ca4214e15aed$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $8373ca4214e15aed$var$hostParent = parent.stateNode.containerInfo;
                    $8373ca4214e15aed$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $8373ca4214e15aed$var$hostParent) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(160));
        $8373ca4214e15aed$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $8373ca4214e15aed$var$hostParent = null;
        $8373ca4214e15aed$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $8373ca4214e15aed$var$currentHoistableRoot = null;
function $8373ca4214e15aed$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($8373ca4214e15aed$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $8373ca4214e15aed$var$commitHookEffectListMount(3, finishedWork), $8373ca4214e15aed$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            flags & 64 && $8373ca4214e15aed$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$8373ca4214e15aed$var$internalHoistableMarker] || currentResource[$8373ca4214e15aed$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $8373ca4214e15aed$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$8373ca4214e15aed$var$internalInstanceKey] = finishedWork;
                                        $8373ca4214e15aed$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $8373ca4214e15aed$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8373ca4214e15aed$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $8373ca4214e15aed$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8373ca4214e15aed$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$8373ca4214e15aed$var$internalInstanceKey] = finishedWork;
                                $8373ca4214e15aed$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $8373ca4214e15aed$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $8373ca4214e15aed$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $8373ca4214e15aed$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $8373ca4214e15aed$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $8373ca4214e15aed$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $8373ca4214e15aed$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $8373ca4214e15aed$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $8373ca4214e15aed$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($8373ca4214e15aed$var$needsFormReset = !0);
            break;
        case 6:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $8373ca4214e15aed$var$tagCaches = null;
            hoistableRoot = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$currentHoistableRoot = $8373ca4214e15aed$var$getHoistableRoot(root.containerInfo);
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$currentHoistableRoot = hoistableRoot;
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $8373ca4214e15aed$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $8373ca4214e15aed$var$needsFormReset && ($8373ca4214e15aed$var$needsFormReset = !1, $8373ca4214e15aed$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$currentHoistableRoot = $8373ca4214e15aed$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            $8373ca4214e15aed$var$currentHoistableRoot = flags;
            break;
        case 12:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($8373ca4214e15aed$var$globalMostRecentFallbackTime = $8373ca4214e15aed$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $8373ca4214e15aed$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $8373ca4214e15aed$var$offscreenSubtreeWasHidden;
            $8373ca4214e15aed$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $8373ca4214e15aed$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $8373ca4214e15aed$var$offscreenSubtreeIsHidden || $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $8373ca4214e15aed$var$hideOrUnhideDehydratedBoundary(instance, !0) : $8373ca4214e15aed$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork), $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
    }
}
function $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($8373ca4214e15aed$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $8373ca4214e15aed$var$getHostSibling(finishedWork);
                    $8373ca4214e15aed$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($8373ca4214e15aed$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $8373ca4214e15aed$var$getHostSibling(finishedWork);
                    $8373ca4214e15aed$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $8373ca4214e15aed$var$getHostSibling(finishedWork);
                    $8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $8373ca4214e15aed$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $8373ca4214e15aed$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $8373ca4214e15aed$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $8373ca4214e15aed$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $8373ca4214e15aed$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $8373ca4214e15aed$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $8373ca4214e15aed$var$safelyDetachRef(finishedWork, finishedWork.return);
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8373ca4214e15aed$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$8373ca4214e15aed$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $8373ca4214e15aed$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $8373ca4214e15aed$var$commitClassCallbacks(finishedWork);
                $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $8373ca4214e15aed$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $8373ca4214e15aed$var$commitHostMount(finishedWork);
                $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $8373ca4214e15aed$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $8373ca4214e15aed$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $8373ca4214e15aed$var$releaseCache(previousCache));
}
function $8373ca4214e15aed$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $8373ca4214e15aed$var$releaseCache(current));
}
function $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8373ca4214e15aed$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $8373ca4214e15aed$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8373ca4214e15aed$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $8373ca4214e15aed$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $8373ca4214e15aed$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8373ca4214e15aed$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $8373ca4214e15aed$var$suspenseyCommitFlag = 8192;
function $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $8373ca4214e15aed$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $8373ca4214e15aed$var$suspenseyCommitFlag && null !== fiber.memoizedState && $8373ca4214e15aed$var$suspendResource(suspendedState, $8373ca4214e15aed$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$currentHoistableRoot = $8373ca4214e15aed$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $8373ca4214e15aed$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $8373ca4214e15aed$var$suspenseyCommitFlag, $8373ca4214e15aed$var$suspenseyCommitFlag = 16777216, $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $8373ca4214e15aed$var$suspenseyCommitFlag = previousHoistableRoot) : $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $8373ca4214e15aed$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8373ca4214e15aed$var$nextEffect = childToDelete;
            $8373ca4214e15aed$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8373ca4214e15aed$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $8373ca4214e15aed$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8373ca4214e15aed$var$nextEffect = childToDelete;
            $8373ca4214e15aed$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8373ca4214e15aed$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $8373ca4214e15aed$var$nextEffect;){
        var fiber = $8373ca4214e15aed$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $8373ca4214e15aed$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $8373ca4214e15aed$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $8373ca4214e15aed$var$nextEffect;){
            cache = $8373ca4214e15aed$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $8373ca4214e15aed$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $8373ca4214e15aed$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $8373ca4214e15aed$var$nextEffect = sibling;
                break a;
            }
            $8373ca4214e15aed$var$nextEffect = returnFiber;
        }
    }
}
var $8373ca4214e15aed$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$CacheContext).controller.signal;
    }
}, $8373ca4214e15aed$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $8373ca4214e15aed$var$executionContext = 0, $8373ca4214e15aed$var$workInProgressRoot = null, $8373ca4214e15aed$var$workInProgress = null, $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0, $8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings = !1, $8373ca4214e15aed$var$workInProgressRootIsPrerendering = !1, $8373ca4214e15aed$var$workInProgressRootDidAttachPingListener = !1, $8373ca4214e15aed$var$entangledRenderLanes = 0, $8373ca4214e15aed$var$workInProgressRootExitStatus = 0, $8373ca4214e15aed$var$workInProgressRootSkippedLanes = 0, $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes = 0, $8373ca4214e15aed$var$workInProgressRootPingedLanes = 0, $8373ca4214e15aed$var$workInProgressDeferredLane = 0, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes = 0, $8373ca4214e15aed$var$workInProgressRootConcurrentErrors = null, $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = null, $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $8373ca4214e15aed$var$globalMostRecentFallbackTime = 0, $8373ca4214e15aed$var$globalMostRecentTransitionTime = 0, $8373ca4214e15aed$var$workInProgressRootRenderTargetTime = Infinity, $8373ca4214e15aed$var$workInProgressTransitions = null, $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed = null, $8373ca4214e15aed$var$pendingEffectsStatus = 0, $8373ca4214e15aed$var$pendingEffectsRoot = null, $8373ca4214e15aed$var$pendingFinishedWork = null, $8373ca4214e15aed$var$pendingEffectsLanes = 0, $8373ca4214e15aed$var$pendingEffectsRemainingLanes = 0, $8373ca4214e15aed$var$pendingPassiveTransitions = null, $8373ca4214e15aed$var$pendingRecoverableErrors = null, $8373ca4214e15aed$var$nestedUpdateCount = 0, $8373ca4214e15aed$var$rootWithNestedUpdates = null;
function $8373ca4214e15aed$var$requestUpdateLane() {
    return 0 !== ($8373ca4214e15aed$var$executionContext & 2) && 0 !== $8373ca4214e15aed$var$workInProgressRootRenderLanes ? $8373ca4214e15aed$var$workInProgressRootRenderLanes & -$8373ca4214e15aed$var$workInProgressRootRenderLanes : null !== $8373ca4214e15aed$var$ReactSharedInternals.T ? $8373ca4214e15aed$var$requestTransitionLane() : $8373ca4214e15aed$var$resolveUpdatePriority();
}
function $8373ca4214e15aed$var$requestDeferredLane() {
    if (0 === $8373ca4214e15aed$var$workInProgressDeferredLane) {
        if (0 === ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 536870912) || $8373ca4214e15aed$var$isHydrating) {
            var lane = $8373ca4214e15aed$var$nextTransitionDeferredLane;
            $8373ca4214e15aed$var$nextTransitionDeferredLane <<= 1;
            0 === ($8373ca4214e15aed$var$nextTransitionDeferredLane & 3932160) && ($8373ca4214e15aed$var$nextTransitionDeferredLane = 262144);
            $8373ca4214e15aed$var$workInProgressDeferredLane = lane;
        } else $8373ca4214e15aed$var$workInProgressDeferredLane = 536870912;
    }
    lane = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $8373ca4214e15aed$var$workInProgressDeferredLane;
}
function $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $8373ca4214e15aed$var$workInProgressRoot && (2 === $8373ca4214e15aed$var$workInProgressSuspendedReason || 9 === $8373ca4214e15aed$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $8373ca4214e15aed$var$prepareFreshStack(root, 0), $8373ca4214e15aed$var$markRootSuspended(root, $8373ca4214e15aed$var$workInProgressRootRenderLanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !1);
    $8373ca4214e15aed$var$markRootUpdated$1(root, lane);
    if (0 === ($8373ca4214e15aed$var$executionContext & 2) || root !== $8373ca4214e15aed$var$workInProgressRoot) root === $8373ca4214e15aed$var$workInProgressRoot && (0 === ($8373ca4214e15aed$var$executionContext & 2) && ($8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $8373ca4214e15aed$var$workInProgressRootExitStatus && $8373ca4214e15aed$var$markRootSuspended(root, $8373ca4214e15aed$var$workInProgressRootRenderLanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !1)), $8373ca4214e15aed$var$ensureRootIsScheduled(root);
}
function $8373ca4214e15aed$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($8373ca4214e15aed$var$executionContext & 6)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $8373ca4214e15aed$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $8373ca4214e15aed$var$renderRootConcurrent(root$jscomp$0, lanes) : $8373ca4214e15aed$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $8373ca4214e15aed$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $8373ca4214e15aed$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$8373ca4214e15aed$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $8373ca4214e15aed$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $8373ca4214e15aed$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($8373ca4214e15aed$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $8373ca4214e15aed$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($8373ca4214e15aed$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $8373ca4214e15aed$var$workInProgressRootRecoverableErrors;
                            $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $8373ca4214e15aed$var$workInProgressRootRecoverableErrors ? $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $8373ca4214e15aed$var$workInProgressRootRecoverableErrors.push.apply($8373ca4214e15aed$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $8373ca4214e15aed$var$prepareFreshStack(root$jscomp$0, 0);
                $8373ca4214e15aed$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $8373ca4214e15aed$var$markRootSuspended(shouldTimeSlice, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !$8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $8373ca4214e15aed$var$globalMostRecentFallbackTime + 300 - $8373ca4214e15aed$var$now(), 10 < exitStatus)) {
                    $8373ca4214e15aed$var$markRootSuspended(shouldTimeSlice, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !$8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $8373ca4214e15aed$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $8373ca4214e15aed$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $8373ca4214e15aed$var$scheduleTimeout($8373ca4214e15aed$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $8373ca4214e15aed$var$workInProgressRootRecoverableErrors, $8373ca4214e15aed$var$workInProgressTransitions, $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $8373ca4214e15aed$var$commitRootWhenReady(shouldTimeSlice, forceSync, $8373ca4214e15aed$var$workInProgressRootRecoverableErrors, $8373ca4214e15aed$var$workInProgressTransitions, $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $8373ca4214e15aed$var$ensureRootIsScheduled(root$jscomp$0);
}
function $8373ca4214e15aed$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $8373ca4214e15aed$var$noop$1
        };
        $8373ca4214e15aed$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $8373ca4214e15aed$var$globalMostRecentFallbackTime - $8373ca4214e15aed$var$now() : (lanes & 4194048) === lanes ? $8373ca4214e15aed$var$globalMostRecentTransitionTime - $8373ca4214e15aed$var$now() : 0;
        timeoutOffset = $8373ca4214e15aed$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $8373ca4214e15aed$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($8373ca4214e15aed$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $8373ca4214e15aed$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $8373ca4214e15aed$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $8373ca4214e15aed$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$8373ca4214e15aed$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $8373ca4214e15aed$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$8373ca4214e15aed$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $8373ca4214e15aed$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $8373ca4214e15aed$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $8373ca4214e15aed$var$flushSyncWork$1() {
    return 0 === ($8373ca4214e15aed$var$executionContext & 6) ? ($8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $8373ca4214e15aed$var$resetWorkInProgressStack() {
    if (null !== $8373ca4214e15aed$var$workInProgress) {
        if (0 === $8373ca4214e15aed$var$workInProgressSuspendedReason) var interruptedWork = $8373ca4214e15aed$var$workInProgress.return;
        else interruptedWork = $8373ca4214e15aed$var$workInProgress, $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null, $8373ca4214e15aed$var$resetHooksOnUnwind(interruptedWork), $8373ca4214e15aed$var$thenableState$1 = null, $8373ca4214e15aed$var$thenableIndexCounter$1 = 0, interruptedWork = $8373ca4214e15aed$var$workInProgress;
        for(; null !== interruptedWork;)$8373ca4214e15aed$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $8373ca4214e15aed$var$workInProgress = null;
    }
}
function $8373ca4214e15aed$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $8373ca4214e15aed$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $8373ca4214e15aed$var$pendingEffectsLanes = 0;
    $8373ca4214e15aed$var$resetWorkInProgressStack();
    $8373ca4214e15aed$var$workInProgressRoot = root;
    $8373ca4214e15aed$var$workInProgress = timeoutHandle = $8373ca4214e15aed$var$createWorkInProgress(root.current, null);
    $8373ca4214e15aed$var$workInProgressRootRenderLanes = lanes;
    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
    $8373ca4214e15aed$var$workInProgressThrownValue = null;
    $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $8373ca4214e15aed$var$workInProgressRootIsPrerendering = $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, lanes);
    $8373ca4214e15aed$var$workInProgressRootDidAttachPingListener = !1;
    $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes = $8373ca4214e15aed$var$workInProgressDeferredLane = $8373ca4214e15aed$var$workInProgressRootPingedLanes = $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes = $8373ca4214e15aed$var$workInProgressRootSkippedLanes = $8373ca4214e15aed$var$workInProgressRootExitStatus = 0;
    $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = $8373ca4214e15aed$var$workInProgressRootConcurrentErrors = null;
    $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $8373ca4214e15aed$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $8373ca4214e15aed$var$entangledRenderLanes = lanes;
    $8373ca4214e15aed$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $8373ca4214e15aed$var$handleThrow(root, thrownValue) {
    $8373ca4214e15aed$var$currentlyRenderingFiber = null;
    $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$ContextOnlyDispatcher;
    thrownValue === $8373ca4214e15aed$var$SuspenseException || thrownValue === $8373ca4214e15aed$var$SuspenseActionException ? (thrownValue = $8373ca4214e15aed$var$getSuspendedThenable(), $8373ca4214e15aed$var$workInProgressSuspendedReason = 3) : thrownValue === $8373ca4214e15aed$var$SuspenseyCommitException ? (thrownValue = $8373ca4214e15aed$var$getSuspendedThenable(), $8373ca4214e15aed$var$workInProgressSuspendedReason = 4) : $8373ca4214e15aed$var$workInProgressSuspendedReason = thrownValue === $8373ca4214e15aed$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $8373ca4214e15aed$var$workInProgressThrownValue = thrownValue;
    null === $8373ca4214e15aed$var$workInProgress && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 1, $8373ca4214e15aed$var$logUncaughtError(root, $8373ca4214e15aed$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $8373ca4214e15aed$var$shouldRemainOnPreviousScreen() {
    var handler = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 4194048) === $8373ca4214e15aed$var$workInProgressRootRenderLanes ? null === $8373ca4214e15aed$var$shellBoundary ? !0 : !1 : ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 62914560) === $8373ca4214e15aed$var$workInProgressRootRenderLanes || 0 !== ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 536870912) ? handler === $8373ca4214e15aed$var$shellBoundary : !1;
}
function $8373ca4214e15aed$var$pushDispatcher() {
    var prevDispatcher = $8373ca4214e15aed$var$ReactSharedInternals.H;
    $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $8373ca4214e15aed$var$ContextOnlyDispatcher : prevDispatcher;
}
function $8373ca4214e15aed$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $8373ca4214e15aed$var$ReactSharedInternals.A;
    $8373ca4214e15aed$var$ReactSharedInternals.A = $8373ca4214e15aed$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible() {
    $8373ca4214e15aed$var$workInProgressRootExitStatus = 4;
    $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings || ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 4194048) !== $8373ca4214e15aed$var$workInProgressRootRenderLanes && null !== $8373ca4214e15aed$var$suspenseHandlerStackCursor.current || ($8373ca4214e15aed$var$workInProgressRootIsPrerendering = !0);
    0 === ($8373ca4214e15aed$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $8373ca4214e15aed$var$workInProgressRoot || $8373ca4214e15aed$var$markRootSuspended($8373ca4214e15aed$var$workInProgressRoot, $8373ca4214e15aed$var$workInProgressRootRenderLanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !1);
}
function $8373ca4214e15aed$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
    $8373ca4214e15aed$var$executionContext |= 2;
    var prevDispatcher = $8373ca4214e15aed$var$pushDispatcher(), prevAsyncDispatcher = $8373ca4214e15aed$var$pushAsyncDispatcher();
    if ($8373ca4214e15aed$var$workInProgressRoot !== root || $8373ca4214e15aed$var$workInProgressRootRenderLanes !== lanes) $8373ca4214e15aed$var$workInProgressTransitions = null, $8373ca4214e15aed$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $8373ca4214e15aed$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $8373ca4214e15aed$var$workInProgressSuspendedReason && null !== $8373ca4214e15aed$var$workInProgress) {
            var unitOfWork = $8373ca4214e15aed$var$workInProgress, thrownValue = $8373ca4214e15aed$var$workInProgressThrownValue;
            switch($8373ca4214e15aed$var$workInProgressSuspendedReason){
                case 8:
                    $8373ca4214e15aed$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $8373ca4214e15aed$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $8373ca4214e15aed$var$workInProgressSuspendedReason;
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $8373ca4214e15aed$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $8373ca4214e15aed$var$workInProgressSuspendedReason, $8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $8373ca4214e15aed$var$workLoopSync();
        exitStatus = $8373ca4214e15aed$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $8373ca4214e15aed$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null;
    $8373ca4214e15aed$var$executionContext = prevExecutionContext;
    $8373ca4214e15aed$var$ReactSharedInternals.H = prevDispatcher;
    $8373ca4214e15aed$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $8373ca4214e15aed$var$workInProgress && ($8373ca4214e15aed$var$workInProgressRoot = null, $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0, $8373ca4214e15aed$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $8373ca4214e15aed$var$workLoopSync() {
    for(; null !== $8373ca4214e15aed$var$workInProgress;)$8373ca4214e15aed$var$performUnitOfWork($8373ca4214e15aed$var$workInProgress);
}
function $8373ca4214e15aed$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
    $8373ca4214e15aed$var$executionContext |= 2;
    var prevDispatcher = $8373ca4214e15aed$var$pushDispatcher(), prevAsyncDispatcher = $8373ca4214e15aed$var$pushAsyncDispatcher();
    $8373ca4214e15aed$var$workInProgressRoot !== root || $8373ca4214e15aed$var$workInProgressRootRenderLanes !== lanes ? ($8373ca4214e15aed$var$workInProgressTransitions = null, $8373ca4214e15aed$var$workInProgressRootRenderTargetTime = $8373ca4214e15aed$var$now() + 500, $8373ca4214e15aed$var$prepareFreshStack(root, lanes)) : $8373ca4214e15aed$var$workInProgressRootIsPrerendering = $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $8373ca4214e15aed$var$workInProgressSuspendedReason && null !== $8373ca4214e15aed$var$workInProgress) {
            lanes = $8373ca4214e15aed$var$workInProgress;
            var thrownValue = $8373ca4214e15aed$var$workInProgressThrownValue;
            b: switch($8373ca4214e15aed$var$workInProgressSuspendedReason){
                case 1:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($8373ca4214e15aed$var$isThenableResolved(thrownValue)) {
                        $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                        $8373ca4214e15aed$var$workInProgressThrownValue = null;
                        $8373ca4214e15aed$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $8373ca4214e15aed$var$workInProgressSuspendedReason && 9 !== $8373ca4214e15aed$var$workInProgressSuspendedReason || $8373ca4214e15aed$var$workInProgressRoot !== root || ($8373ca4214e15aed$var$workInProgressSuspendedReason = 7);
                        $8373ca4214e15aed$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $8373ca4214e15aed$var$isThenableResolved(thrownValue) ? ($8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$replaySuspendedUnitOfWork(lanes)) : ($8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($8373ca4214e15aed$var$workInProgress.tag){
                        case 26:
                            resource = $8373ca4214e15aed$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $8373ca4214e15aed$var$workInProgress;
                            if (resource ? $8373ca4214e15aed$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                                $8373ca4214e15aed$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $8373ca4214e15aed$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($8373ca4214e15aed$var$workInProgress = returnFiber, $8373ca4214e15aed$var$completeUnitOfWork(returnFiber)) : $8373ca4214e15aed$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $8373ca4214e15aed$var$resetWorkInProgressStack();
                    $8373ca4214e15aed$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(462));
            }
        }
        $8373ca4214e15aed$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $8373ca4214e15aed$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null;
    $8373ca4214e15aed$var$ReactSharedInternals.H = prevDispatcher;
    $8373ca4214e15aed$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $8373ca4214e15aed$var$executionContext = prevExecutionContext;
    if (null !== $8373ca4214e15aed$var$workInProgress) return 0;
    $8373ca4214e15aed$var$workInProgressRoot = null;
    $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0;
    $8373ca4214e15aed$var$finishQueueingConcurrentUpdates();
    return $8373ca4214e15aed$var$workInProgressRootExitStatus;
}
function $8373ca4214e15aed$var$workLoopConcurrentByScheduler() {
    for(; null !== $8373ca4214e15aed$var$workInProgress && !$8373ca4214e15aed$var$shouldYield();)$8373ca4214e15aed$var$performUnitOfWork($8373ca4214e15aed$var$workInProgress);
}
function $8373ca4214e15aed$var$performUnitOfWork(unitOfWork) {
    var next = $8373ca4214e15aed$var$beginWork(unitOfWork.alternate, unitOfWork, $8373ca4214e15aed$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork) : $8373ca4214e15aed$var$workInProgress = next;
}
function $8373ca4214e15aed$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $8373ca4214e15aed$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $8373ca4214e15aed$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $8373ca4214e15aed$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $8373ca4214e15aed$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $8373ca4214e15aed$var$resetHooksOnUnwind(next);
        default:
            $8373ca4214e15aed$var$unwindInterruptedWork(current, next), next = $8373ca4214e15aed$var$workInProgress = $8373ca4214e15aed$var$resetWorkInProgress(next, $8373ca4214e15aed$var$entangledRenderLanes), next = $8373ca4214e15aed$var$beginWork(current, next, $8373ca4214e15aed$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork) : $8373ca4214e15aed$var$workInProgress = next;
}
function $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null;
    $8373ca4214e15aed$var$resetHooksOnUnwind(unitOfWork);
    $8373ca4214e15aed$var$thenableState$1 = null;
    $8373ca4214e15aed$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($8373ca4214e15aed$var$throwException(root, returnFiber, unitOfWork, thrownValue, $8373ca4214e15aed$var$workInProgressRootRenderLanes)) {
            $8373ca4214e15aed$var$workInProgressRootExitStatus = 1;
            $8373ca4214e15aed$var$logUncaughtError(root, $8373ca4214e15aed$var$createCapturedValueAtFiber(thrownValue, root.current));
            $8373ca4214e15aed$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $8373ca4214e15aed$var$workInProgress = returnFiber, error;
        $8373ca4214e15aed$var$workInProgressRootExitStatus = 1;
        $8373ca4214e15aed$var$logUncaughtError(root, $8373ca4214e15aed$var$createCapturedValueAtFiber(thrownValue, root.current));
        $8373ca4214e15aed$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($8373ca4214e15aed$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($8373ca4214e15aed$var$workInProgressRootIsPrerendering || 0 !== ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $8373ca4214e15aed$var$unwindUnitOfWork(unitOfWork, root);
    } else $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork);
}
function $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $8373ca4214e15aed$var$unwindUnitOfWork(completedWork, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $8373ca4214e15aed$var$completeWork(completedWork.alternate, completedWork, $8373ca4214e15aed$var$entangledRenderLanes);
        if (null !== next) {
            $8373ca4214e15aed$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $8373ca4214e15aed$var$workInProgress = completedWork;
            return;
        }
        $8373ca4214e15aed$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 5);
}
function $8373ca4214e15aed$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $8373ca4214e15aed$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $8373ca4214e15aed$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $8373ca4214e15aed$var$workInProgress = unitOfWork;
            return;
        }
        $8373ca4214e15aed$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $8373ca4214e15aed$var$workInProgressRootExitStatus = 6;
    $8373ca4214e15aed$var$workInProgress = null;
}
function $8373ca4214e15aed$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $8373ca4214e15aed$var$flushPendingEffects();
    while (0 !== $8373ca4214e15aed$var$pendingEffectsStatus);
    if (0 !== ($8373ca4214e15aed$var$executionContext & 6)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $8373ca4214e15aed$var$concurrentlyUpdatedLanes;
        $8373ca4214e15aed$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $8373ca4214e15aed$var$workInProgressRoot && ($8373ca4214e15aed$var$workInProgress = $8373ca4214e15aed$var$workInProgressRoot = null, $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0);
        $8373ca4214e15aed$var$pendingFinishedWork = finishedWork;
        $8373ca4214e15aed$var$pendingEffectsRoot = root;
        $8373ca4214e15aed$var$pendingEffectsLanes = lanes;
        $8373ca4214e15aed$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $8373ca4214e15aed$var$pendingPassiveTransitions = transitions;
        $8373ca4214e15aed$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $8373ca4214e15aed$var$scheduleCallback$1($8373ca4214e15aed$var$NormalPriority$1, function() {
            $8373ca4214e15aed$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $8373ca4214e15aed$var$ReactSharedInternals.T;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            transitions = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $8373ca4214e15aed$var$executionContext;
            $8373ca4214e15aed$var$executionContext |= 4;
            try {
                $8373ca4214e15aed$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $8373ca4214e15aed$var$executionContext = spawnedLane, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = transitions, $8373ca4214e15aed$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $8373ca4214e15aed$var$pendingEffectsStatus = 1;
        $8373ca4214e15aed$var$flushMutationEffects();
        $8373ca4214e15aed$var$flushLayoutEffects();
        $8373ca4214e15aed$var$flushSpawnedWork();
    }
}
function $8373ca4214e15aed$var$flushMutationEffects() {
    if (1 === $8373ca4214e15aed$var$pendingEffectsStatus) {
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        var root = $8373ca4214e15aed$var$pendingEffectsRoot, finishedWork = $8373ca4214e15aed$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $8373ca4214e15aed$var$ReactSharedInternals.T;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
            $8373ca4214e15aed$var$executionContext |= 4;
            try {
                $8373ca4214e15aed$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $8373ca4214e15aed$var$selectionInformation, curFocusedElem = $8373ca4214e15aed$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $8373ca4214e15aed$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $8373ca4214e15aed$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $8373ca4214e15aed$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $8373ca4214e15aed$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $8373ca4214e15aed$var$_enabled = !!$8373ca4214e15aed$var$eventsEnabled;
                $8373ca4214e15aed$var$selectionInformation = $8373ca4214e15aed$var$eventsEnabled = null;
            } finally{
                $8373ca4214e15aed$var$executionContext = prevExecutionContext, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $8373ca4214e15aed$var$pendingEffectsStatus = 2;
    }
}
function $8373ca4214e15aed$var$flushLayoutEffects() {
    if (2 === $8373ca4214e15aed$var$pendingEffectsStatus) {
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        var root = $8373ca4214e15aed$var$pendingEffectsRoot, finishedWork = $8373ca4214e15aed$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $8373ca4214e15aed$var$ReactSharedInternals.T;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
            $8373ca4214e15aed$var$executionContext |= 4;
            try {
                $8373ca4214e15aed$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $8373ca4214e15aed$var$executionContext = prevExecutionContext, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $8373ca4214e15aed$var$pendingEffectsStatus = 3;
    }
}
function $8373ca4214e15aed$var$flushSpawnedWork() {
    if (4 === $8373ca4214e15aed$var$pendingEffectsStatus || 3 === $8373ca4214e15aed$var$pendingEffectsStatus) {
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        $8373ca4214e15aed$var$requestPaint();
        var root = $8373ca4214e15aed$var$pendingEffectsRoot, finishedWork = $8373ca4214e15aed$var$pendingFinishedWork, lanes = $8373ca4214e15aed$var$pendingEffectsLanes, recoverableErrors = $8373ca4214e15aed$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $8373ca4214e15aed$var$pendingEffectsStatus = 5 : ($8373ca4214e15aed$var$pendingEffectsStatus = 0, $8373ca4214e15aed$var$pendingFinishedWork = $8373ca4214e15aed$var$pendingEffectsRoot = null, $8373ca4214e15aed$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $8373ca4214e15aed$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.onCommitFiberRoot) try {
            $8373ca4214e15aed$var$injectedHook.onCommitFiberRoot($8373ca4214e15aed$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $8373ca4214e15aed$var$ReactSharedInternals.T;
            remainingLanes = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $8373ca4214e15aed$var$ReactSharedInternals.T = finishedWork, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($8373ca4214e15aed$var$pendingEffectsLanes & 3) && $8373ca4214e15aed$var$flushPendingEffects();
        $8373ca4214e15aed$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $8373ca4214e15aed$var$rootWithNestedUpdates ? $8373ca4214e15aed$var$nestedUpdateCount++ : ($8373ca4214e15aed$var$nestedUpdateCount = 0, $8373ca4214e15aed$var$rootWithNestedUpdates = root) : $8373ca4214e15aed$var$nestedUpdateCount = 0;
        $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $8373ca4214e15aed$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $8373ca4214e15aed$var$releaseCache(remainingLanes)));
}
function $8373ca4214e15aed$var$flushPendingEffects() {
    $8373ca4214e15aed$var$flushMutationEffects();
    $8373ca4214e15aed$var$flushLayoutEffects();
    $8373ca4214e15aed$var$flushSpawnedWork();
    return $8373ca4214e15aed$var$flushPassiveEffects();
}
function $8373ca4214e15aed$var$flushPassiveEffects() {
    if (5 !== $8373ca4214e15aed$var$pendingEffectsStatus) return !1;
    var root = $8373ca4214e15aed$var$pendingEffectsRoot, remainingLanes = $8373ca4214e15aed$var$pendingEffectsRemainingLanes;
    $8373ca4214e15aed$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $8373ca4214e15aed$var$lanesToEventPriority($8373ca4214e15aed$var$pendingEffectsLanes), prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T, previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $8373ca4214e15aed$var$ReactSharedInternals.T = null;
        renderPriority = $8373ca4214e15aed$var$pendingPassiveTransitions;
        $8373ca4214e15aed$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $8373ca4214e15aed$var$pendingEffectsRoot, lanes = $8373ca4214e15aed$var$pendingEffectsLanes;
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        $8373ca4214e15aed$var$pendingFinishedWork = $8373ca4214e15aed$var$pendingEffectsRoot = null;
        $8373ca4214e15aed$var$pendingEffectsLanes = 0;
        if (0 !== ($8373ca4214e15aed$var$executionContext & 6)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(331));
        var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
        $8373ca4214e15aed$var$executionContext |= 4;
        $8373ca4214e15aed$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $8373ca4214e15aed$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $8373ca4214e15aed$var$executionContext = prevExecutionContext;
        $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.onPostCommitFiberRoot) try {
            $8373ca4214e15aed$var$injectedHook.onPostCommitFiberRoot($8373ca4214e15aed$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition, $8373ca4214e15aed$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $8373ca4214e15aed$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $8373ca4214e15aed$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $8373ca4214e15aed$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $8373ca4214e15aed$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($8373ca4214e15aed$var$markRootUpdated$1(rootFiber, 2), $8373ca4214e15aed$var$ensureRootIsScheduled(rootFiber));
}
function $8373ca4214e15aed$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $8373ca4214e15aed$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $8373ca4214e15aed$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed || !$8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $8373ca4214e15aed$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $8373ca4214e15aed$var$createClassErrorUpdate(2);
                instance = $8373ca4214e15aed$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($8373ca4214e15aed$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $8373ca4214e15aed$var$markRootUpdated$1(instance, 2), $8373ca4214e15aed$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $8373ca4214e15aed$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $8373ca4214e15aed$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($8373ca4214e15aed$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $8373ca4214e15aed$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $8373ca4214e15aed$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $8373ca4214e15aed$var$workInProgressRoot === root && ($8373ca4214e15aed$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $8373ca4214e15aed$var$workInProgressRootExitStatus || 3 === $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 62914560) === $8373ca4214e15aed$var$workInProgressRootRenderLanes && 300 > $8373ca4214e15aed$var$now() - $8373ca4214e15aed$var$globalMostRecentFallbackTime ? 0 === ($8373ca4214e15aed$var$executionContext & 2) && $8373ca4214e15aed$var$prepareFreshStack(root, 0) : $8373ca4214e15aed$var$workInProgressRootPingedLanes |= pingedLanes, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes === $8373ca4214e15aed$var$workInProgressRootRenderLanes && ($8373ca4214e15aed$var$workInProgressSuspendedRetryLanes = 0));
    $8373ca4214e15aed$var$ensureRootIsScheduled(root);
}
function $8373ca4214e15aed$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $8373ca4214e15aed$var$claimNextRetryLane());
    boundaryFiber = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($8373ca4214e15aed$var$markRootUpdated$1(boundaryFiber, retryLane), $8373ca4214e15aed$var$ensureRootIsScheduled(boundaryFiber));
}
function $8373ca4214e15aed$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $8373ca4214e15aed$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8373ca4214e15aed$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $8373ca4214e15aed$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8373ca4214e15aed$var$scheduleCallback$1(priorityLevel, callback) {
    return $8373ca4214e15aed$var$scheduleCallback$3(priorityLevel, callback);
}
var $8373ca4214e15aed$var$firstScheduledRoot = null, $8373ca4214e15aed$var$lastScheduledRoot = null, $8373ca4214e15aed$var$didScheduleMicrotask = !1, $8373ca4214e15aed$var$mightHavePendingSyncWork = !1, $8373ca4214e15aed$var$isFlushingWork = !1, $8373ca4214e15aed$var$currentEventTransitionLane = 0;
function $8373ca4214e15aed$var$ensureRootIsScheduled(root) {
    root !== $8373ca4214e15aed$var$lastScheduledRoot && null === root.next && (null === $8373ca4214e15aed$var$lastScheduledRoot ? $8373ca4214e15aed$var$firstScheduledRoot = $8373ca4214e15aed$var$lastScheduledRoot = root : $8373ca4214e15aed$var$lastScheduledRoot = $8373ca4214e15aed$var$lastScheduledRoot.next = root);
    $8373ca4214e15aed$var$mightHavePendingSyncWork = !0;
    $8373ca4214e15aed$var$didScheduleMicrotask || ($8373ca4214e15aed$var$didScheduleMicrotask = !0, $8373ca4214e15aed$var$scheduleImmediateRootScheduleTask());
}
function $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$8373ca4214e15aed$var$isFlushingWork && $8373ca4214e15aed$var$mightHavePendingSyncWork) {
        $8373ca4214e15aed$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $8373ca4214e15aed$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $8373ca4214e15aed$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $8373ca4214e15aed$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $8373ca4214e15aed$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $8373ca4214e15aed$var$getNextLanes(root$170, root$170 === $8373ca4214e15aed$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $8373ca4214e15aed$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $8373ca4214e15aed$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $8373ca4214e15aed$var$isFlushingWork = !1;
    }
}
function $8373ca4214e15aed$var$processRootScheduleInImmediateTask() {
    $8373ca4214e15aed$var$processRootScheduleInMicrotask();
}
function $8373ca4214e15aed$var$processRootScheduleInMicrotask() {
    $8373ca4214e15aed$var$mightHavePendingSyncWork = $8373ca4214e15aed$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $8373ca4214e15aed$var$currentEventTransitionLane && $8373ca4214e15aed$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $8373ca4214e15aed$var$currentEventTransitionLane);
    for(var currentTime = $8373ca4214e15aed$var$now(), prev = null, root = $8373ca4214e15aed$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $8373ca4214e15aed$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $8373ca4214e15aed$var$firstScheduledRoot = next : prev.next = next, null === next && ($8373ca4214e15aed$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $8373ca4214e15aed$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $8373ca4214e15aed$var$pendingEffectsStatus && 5 !== $8373ca4214e15aed$var$pendingEffectsStatus || $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $8373ca4214e15aed$var$currentEventTransitionLane && ($8373ca4214e15aed$var$currentEventTransitionLane = 0);
}
function $8373ca4214e15aed$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $8373ca4214e15aed$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $8373ca4214e15aed$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $8373ca4214e15aed$var$workInProgressRoot;
    suspendedLanes = $8373ca4214e15aed$var$workInProgressRootRenderLanes;
    suspendedLanes = $8373ca4214e15aed$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $8373ca4214e15aed$var$workInProgressSuspendedReason || 9 === $8373ca4214e15aed$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $8373ca4214e15aed$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $8373ca4214e15aed$var$cancelCallback$1(pingedLanes);
        switch($8373ca4214e15aed$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $8373ca4214e15aed$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $8373ca4214e15aed$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $8373ca4214e15aed$var$IdlePriority;
                break;
            default:
                suspendedLanes = $8373ca4214e15aed$var$NormalPriority$1;
        }
        pingedLanes = $8373ca4214e15aed$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $8373ca4214e15aed$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $8373ca4214e15aed$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $8373ca4214e15aed$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $8373ca4214e15aed$var$pendingEffectsStatus && 5 !== $8373ca4214e15aed$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($8373ca4214e15aed$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $8373ca4214e15aed$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $8373ca4214e15aed$var$getNextLanes(root, root === $8373ca4214e15aed$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $8373ca4214e15aed$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $8373ca4214e15aed$var$scheduleTaskForRootDuringMicrotask(root, $8373ca4214e15aed$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $8373ca4214e15aed$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $8373ca4214e15aed$var$performSyncWorkOnRoot(root, lanes) {
    if ($8373ca4214e15aed$var$flushPendingEffects()) return null;
    $8373ca4214e15aed$var$performWorkOnRoot(root, lanes, !0);
}
function $8373ca4214e15aed$var$scheduleImmediateRootScheduleTask() {
    $8373ca4214e15aed$var$scheduleMicrotask(function() {
        0 !== ($8373ca4214e15aed$var$executionContext & 6) ? $8373ca4214e15aed$var$scheduleCallback$3($8373ca4214e15aed$var$ImmediatePriority, $8373ca4214e15aed$var$processRootScheduleInImmediateTask) : $8373ca4214e15aed$var$processRootScheduleInMicrotask();
    });
}
function $8373ca4214e15aed$var$requestTransitionLane() {
    if (0 === $8373ca4214e15aed$var$currentEventTransitionLane) {
        var actionScopeLane = $8373ca4214e15aed$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $8373ca4214e15aed$var$nextTransitionUpdateLane, $8373ca4214e15aed$var$nextTransitionUpdateLane <<= 1, 0 === ($8373ca4214e15aed$var$nextTransitionUpdateLane & 261888) && ($8373ca4214e15aed$var$nextTransitionUpdateLane = 256));
        $8373ca4214e15aed$var$currentEventTransitionLane = actionScopeLane;
    }
    return $8373ca4214e15aed$var$currentEventTransitionLane;
}
function $8373ca4214e15aed$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $8373ca4214e15aed$var$sanitizeURL("" + actionProp);
}
function $8373ca4214e15aed$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $8373ca4214e15aed$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $8373ca4214e15aed$var$coerceFormActionProp((nativeEventTarget[$8373ca4214e15aed$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$8373ca4214e15aed$var$internalPropsKey] || null) ? $8373ca4214e15aed$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $8373ca4214e15aed$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $8373ca4214e15aed$var$currentEventTransitionLane) {
                                var formData = submitter ? $8373ca4214e15aed$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $8373ca4214e15aed$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $8373ca4214e15aed$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $8373ca4214e15aed$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $8373ca4214e15aed$var$i$jscomp$inline_1577 = 0; $8373ca4214e15aed$var$i$jscomp$inline_1577 < $8373ca4214e15aed$var$simpleEventPluginEvents.length; $8373ca4214e15aed$var$i$jscomp$inline_1577++){
    var $8373ca4214e15aed$var$eventName$jscomp$inline_1578 = $8373ca4214e15aed$var$simpleEventPluginEvents[$8373ca4214e15aed$var$i$jscomp$inline_1577], $8373ca4214e15aed$var$domEventName$jscomp$inline_1579 = $8373ca4214e15aed$var$eventName$jscomp$inline_1578.toLowerCase(), $8373ca4214e15aed$var$capitalizedEvent$jscomp$inline_1580 = $8373ca4214e15aed$var$eventName$jscomp$inline_1578[0].toUpperCase() + $8373ca4214e15aed$var$eventName$jscomp$inline_1578.slice(1);
    $8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$domEventName$jscomp$inline_1579, "on" + $8373ca4214e15aed$var$capitalizedEvent$jscomp$inline_1580);
}
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$ANIMATION_END, "onAnimationEnd");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$ANIMATION_ITERATION, "onAnimationIteration");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$ANIMATION_START, "onAnimationStart");
$8373ca4214e15aed$var$registerSimpleEvent("dblclick", "onDoubleClick");
$8373ca4214e15aed$var$registerSimpleEvent("focusin", "onFocus");
$8373ca4214e15aed$var$registerSimpleEvent("focusout", "onBlur");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_RUN, "onTransitionRun");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_START, "onTransitionStart");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_CANCEL, "onTransitionCancel");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_END, "onTransitionEnd");
$8373ca4214e15aed$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8373ca4214e15aed$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8373ca4214e15aed$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8373ca4214e15aed$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8373ca4214e15aed$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8373ca4214e15aed$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8373ca4214e15aed$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8373ca4214e15aed$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($8373ca4214e15aed$var$mediaEventTypes));
function $8373ca4214e15aed$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8373ca4214e15aed$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8373ca4214e15aed$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $8373ca4214e15aed$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$8373ca4214e15aed$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$8373ca4214e15aed$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($8373ca4214e15aed$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $8373ca4214e15aed$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $8373ca4214e15aed$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $8373ca4214e15aed$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $8373ca4214e15aed$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$8373ca4214e15aed$var$listeningMarker]) {
        rootContainerElement[$8373ca4214e15aed$var$listeningMarker] = !0;
        $8373ca4214e15aed$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($8373ca4214e15aed$var$nonDelegatedEvents.has(domEventName) || $8373ca4214e15aed$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $8373ca4214e15aed$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$8373ca4214e15aed$var$listeningMarker] || (ownerDocument[$8373ca4214e15aed$var$listeningMarker] = !0, $8373ca4214e15aed$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $8373ca4214e15aed$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($8373ca4214e15aed$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $8373ca4214e15aed$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $8373ca4214e15aed$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $8373ca4214e15aed$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$8373ca4214e15aed$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $8373ca4214e15aed$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $8373ca4214e15aed$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $8373ca4214e15aed$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $8373ca4214e15aed$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $8373ca4214e15aed$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticTouchEvent;
                        break;
                    case $8373ca4214e15aed$var$ANIMATION_END:
                    case $8373ca4214e15aed$var$ANIMATION_ITERATION:
                    case $8373ca4214e15aed$var$ANIMATION_START:
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticAnimationEvent;
                        break;
                    case $8373ca4214e15aed$var$TRANSITION_END:
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $8373ca4214e15aed$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($8373ca4214e15aed$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $8373ca4214e15aed$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($8373ca4214e15aed$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$8373ca4214e15aed$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $8373ca4214e15aed$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $8373ca4214e15aed$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $8373ca4214e15aed$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $8373ca4214e15aed$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $8373ca4214e15aed$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $8373ca4214e15aed$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $8373ca4214e15aed$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $8373ca4214e15aed$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $8373ca4214e15aed$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $8373ca4214e15aed$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $8373ca4214e15aed$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForChangeEvent;
                else if ($8373ca4214e15aed$var$isTextInputElement(reactName)) {
                    if ($8373ca4214e15aed$var$isInputEventSupported) getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $8373ca4214e15aed$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $8373ca4214e15aed$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForChangeEvent) : getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $8373ca4214e15aed$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $8373ca4214e15aed$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $8373ca4214e15aed$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($8373ca4214e15aed$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $8373ca4214e15aed$var$activeElement = handleEventFunc, $8373ca4214e15aed$var$activeElementInst = targetInst, $8373ca4214e15aed$var$lastSelection = null;
                    break;
                case "focusout":
                    $8373ca4214e15aed$var$lastSelection = $8373ca4214e15aed$var$activeElementInst = $8373ca4214e15aed$var$activeElement = null;
                    break;
                case "mousedown":
                    $8373ca4214e15aed$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8373ca4214e15aed$var$mouseDown = !1;
                    $8373ca4214e15aed$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($8373ca4214e15aed$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $8373ca4214e15aed$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($8373ca4214e15aed$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $8373ca4214e15aed$var$isComposing ? $8373ca4214e15aed$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($8373ca4214e15aed$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($8373ca4214e15aed$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $8373ca4214e15aed$var$isComposing && (fallbackData = $8373ca4214e15aed$var$getData()) : ($8373ca4214e15aed$var$root = nativeEventTarget, $8373ca4214e15aed$var$startText = "value" in $8373ca4214e15aed$var$root ? $8373ca4214e15aed$var$root.value : $8373ca4214e15aed$var$root.textContent, $8373ca4214e15aed$var$isComposing = !0)), handleEventFunc = $8373ca4214e15aed$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $8373ca4214e15aed$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $8373ca4214e15aed$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $8373ca4214e15aed$var$canUseTextInputEvent ? $8373ca4214e15aed$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $8373ca4214e15aed$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $8373ca4214e15aed$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $8373ca4214e15aed$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $8373ca4214e15aed$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $8373ca4214e15aed$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $8373ca4214e15aed$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $8373ca4214e15aed$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $8373ca4214e15aed$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($8373ca4214e15aed$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $8373ca4214e15aed$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($8373ca4214e15aed$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $8373ca4214e15aed$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $8373ca4214e15aed$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $8373ca4214e15aed$var$getListener(target, registrationName), null != stateNode && listeners.unshift($8373ca4214e15aed$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $8373ca4214e15aed$var$getListener(target, registrationName), null != stateNode && listeners.push($8373ca4214e15aed$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $8373ca4214e15aed$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $8373ca4214e15aed$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $8373ca4214e15aed$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($8373ca4214e15aed$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($8373ca4214e15aed$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $8373ca4214e15aed$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $8373ca4214e15aed$var$normalizeMarkupForTextOrAttribute(clientText);
    return $8373ca4214e15aed$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $8373ca4214e15aed$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $8373ca4214e15aed$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $8373ca4214e15aed$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $8373ca4214e15aed$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8373ca4214e15aed$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $8373ca4214e15aed$var$setProp(domElement, tag, "name", props.name, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($8373ca4214e15aed$var$setProp(domElement, tag, "encType", props.encType, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "method", props.method, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8373ca4214e15aed$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8373ca4214e15aed$var$noop$1);
            break;
        case "onScroll":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $8373ca4214e15aed$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", domElement);
            $8373ca4214e15aed$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $8373ca4214e15aed$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $8373ca4214e15aed$var$aliases.get(key) || key, $8373ca4214e15aed$var$setValueForAttribute(domElement, key, value);
    }
}
function $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $8373ca4214e15aed$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $8373ca4214e15aed$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $8373ca4214e15aed$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8373ca4214e15aed$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$8373ca4214e15aed$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$8373ca4214e15aed$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $8373ca4214e15aed$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $8373ca4214e15aed$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                    default:
                        $8373ca4214e15aed$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $8373ca4214e15aed$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $8373ca4214e15aed$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $8373ca4214e15aed$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $8373ca4214e15aed$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $8373ca4214e15aed$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $8373ca4214e15aed$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(91));
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $8373ca4214e15aed$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("cancel", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $8373ca4214e15aed$var$mediaEventTypes.length; hasSrc++)$8373ca4214e15aed$var$listenToNonDelegatedEvent($8373ca4214e15aed$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", domElement), $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($8373ca4214e15aed$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $8373ca4214e15aed$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $8373ca4214e15aed$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $8373ca4214e15aed$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $8373ca4214e15aed$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $8373ca4214e15aed$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $8373ca4214e15aed$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $8373ca4214e15aed$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $8373ca4214e15aed$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $8373ca4214e15aed$var$updateOptions(domElement, !!lastProps, tag, !0) : $8373ca4214e15aed$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $8373ca4214e15aed$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $8373ca4214e15aed$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $8373ca4214e15aed$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($8373ca4214e15aed$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $8373ca4214e15aed$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $8373ca4214e15aed$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $8373ca4214e15aed$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $8373ca4214e15aed$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $8373ca4214e15aed$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $8373ca4214e15aed$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $8373ca4214e15aed$var$eventsEnabled = null, $8373ca4214e15aed$var$selectionInformation = null;
function $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $8373ca4214e15aed$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $8373ca4214e15aed$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $8373ca4214e15aed$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $8373ca4214e15aed$var$currentPopstateTransitionEvent = null;
function $8373ca4214e15aed$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $8373ca4214e15aed$var$currentPopstateTransitionEvent) return !1;
        $8373ca4214e15aed$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $8373ca4214e15aed$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $8373ca4214e15aed$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $8373ca4214e15aed$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $8373ca4214e15aed$var$localPromise = "function" === typeof Promise ? Promise : void 0, $8373ca4214e15aed$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8373ca4214e15aed$var$localPromise ? function(callback) {
    return $8373ca4214e15aed$var$localPromise.resolve(null).then(callback).catch($8373ca4214e15aed$var$handleErrorInNextTick);
} : $8373ca4214e15aed$var$scheduleTimeout;
function $8373ca4214e15aed$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $8373ca4214e15aed$var$isSingletonScope(type) {
    return "head" === type;
}
function $8373ca4214e15aed$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $8373ca4214e15aed$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $8373ca4214e15aed$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $8373ca4214e15aed$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$8373ca4214e15aed$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $8373ca4214e15aed$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $8373ca4214e15aed$var$retryIfBlockedOn(hydrationInstance);
}
function $8373ca4214e15aed$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $8373ca4214e15aed$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $8373ca4214e15aed$var$clearContainerSparingly(node);
                $8373ca4214e15aed$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $8373ca4214e15aed$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$8373ca4214e15aed$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $8373ca4214e15aed$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $8373ca4214e15aed$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8373ca4214e15aed$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8373ca4214e15aed$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8373ca4214e15aed$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8373ca4214e15aed$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $8373ca4214e15aed$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $8373ca4214e15aed$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $8373ca4214e15aed$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton = null;
function $8373ca4214e15aed$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $8373ca4214e15aed$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $8373ca4214e15aed$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $8373ca4214e15aed$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(451));
    }
}
function $8373ca4214e15aed$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $8373ca4214e15aed$var$detachDeletedInstance(instance);
}
var $8373ca4214e15aed$var$preloadPropsMap = new Map(), $8373ca4214e15aed$var$preconnectsSet = new Set();
function $8373ca4214e15aed$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $8373ca4214e15aed$var$previousDispatcher = $8373ca4214e15aed$var$ReactDOMSharedInternals.d;
$8373ca4214e15aed$var$ReactDOMSharedInternals.d = {
    f: $8373ca4214e15aed$var$flushSyncWork,
    r: $8373ca4214e15aed$var$requestFormReset,
    D: $8373ca4214e15aed$var$prefetchDNS,
    C: $8373ca4214e15aed$var$preconnect,
    L: $8373ca4214e15aed$var$preload,
    m: $8373ca4214e15aed$var$preloadModule,
    X: $8373ca4214e15aed$var$preinitScript,
    S: $8373ca4214e15aed$var$preinitStyle,
    M: $8373ca4214e15aed$var$preinitModuleScript
};
function $8373ca4214e15aed$var$flushSyncWork() {
    var previousWasRendering = $8373ca4214e15aed$var$previousDispatcher.f(), wasRendering = $8373ca4214e15aed$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $8373ca4214e15aed$var$requestFormReset(form) {
    var formInst = $8373ca4214e15aed$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $8373ca4214e15aed$var$requestFormReset$1(formInst) : $8373ca4214e15aed$var$previousDispatcher.r(form);
}
var $8373ca4214e15aed$var$globalDocument = "undefined" === typeof document ? null : document;
function $8373ca4214e15aed$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $8373ca4214e15aed$var$preconnectsSet.has(limitedEscapedHref) || ($8373ca4214e15aed$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $8373ca4214e15aed$var$setInitialProperties(href, "link", rel), $8373ca4214e15aed$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $8373ca4214e15aed$var$prefetchDNS(href) {
    $8373ca4214e15aed$var$previousDispatcher.D(href);
    $8373ca4214e15aed$var$preconnectAs("dns-prefetch", href, null);
}
function $8373ca4214e15aed$var$preconnect(href, crossOrigin) {
    $8373ca4214e15aed$var$previousDispatcher.C(href, crossOrigin);
    $8373ca4214e15aed$var$preconnectAs("preconnect", href, crossOrigin);
}
function $8373ca4214e15aed$var$preload(href, as, options) {
    $8373ca4214e15aed$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $8373ca4214e15aed$var$getStyleKey(href);
                break;
            case "script":
                key = $8373ca4214e15aed$var$getScriptKey(href);
        }
        $8373ca4214e15aed$var$preloadPropsMap.has(key) || (href = $8373ca4214e15aed$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $8373ca4214e15aed$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $8373ca4214e15aed$var$setInitialProperties(as, "link", href), $8373ca4214e15aed$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $8373ca4214e15aed$var$preloadModule(href, options) {
    $8373ca4214e15aed$var$previousDispatcher.m(href, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $8373ca4214e15aed$var$getScriptKey(href);
        }
        if (!$8373ca4214e15aed$var$preloadPropsMap.has(key) && (href = $8373ca4214e15aed$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $8373ca4214e15aed$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $8373ca4214e15aed$var$setInitialProperties(as, "link", href);
            $8373ca4214e15aed$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $8373ca4214e15aed$var$preinitStyle(href, precedence, options) {
    $8373ca4214e15aed$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $8373ca4214e15aed$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $8373ca4214e15aed$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $8373ca4214e15aed$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $8373ca4214e15aed$var$markNodeAsHoistable(link);
                $8373ca4214e15aed$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $8373ca4214e15aed$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $8373ca4214e15aed$var$preinitScript(src, options) {
    $8373ca4214e15aed$var$previousDispatcher.X(src, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8373ca4214e15aed$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8373ca4214e15aed$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key)), resource || (src = $8373ca4214e15aed$var$assign({
            src: src,
            async: !0
        }, options), (options = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8373ca4214e15aed$var$markNodeAsHoistable(resource), $8373ca4214e15aed$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8373ca4214e15aed$var$preinitModuleScript(src, options) {
    $8373ca4214e15aed$var$previousDispatcher.M(src, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8373ca4214e15aed$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8373ca4214e15aed$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key)), resource || (src = $8373ca4214e15aed$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8373ca4214e15aed$var$markNodeAsHoistable(resource), $8373ca4214e15aed$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8373ca4214e15aed$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $8373ca4214e15aed$var$rootInstanceStackCursor.current) ? $8373ca4214e15aed$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $8373ca4214e15aed$var$getStyleKey(pendingProps.href), pendingProps = $8373ca4214e15aed$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $8373ca4214e15aed$var$getStyleKey(pendingProps.href);
                var styles$243 = $8373ca4214e15aed$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $8373ca4214e15aed$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $8373ca4214e15aed$var$preloadPropsMap.set(type, pendingProps), styles$243 || $8373ca4214e15aed$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $8373ca4214e15aed$var$getScriptKey(pendingProps), pendingProps = $8373ca4214e15aed$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(444, type));
    }
}
function $8373ca4214e15aed$var$getStyleKey(href) {
    return 'href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $8373ca4214e15aed$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $8373ca4214e15aed$var$stylesheetPropsFromRawProps(rawProps) {
    return $8373ca4214e15aed$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $8373ca4214e15aed$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $8373ca4214e15aed$var$setInitialProperties(key, "link", preloadProps), $8373ca4214e15aed$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $8373ca4214e15aed$var$getScriptKey(src) {
    return '[src="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $8373ca4214e15aed$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $8373ca4214e15aed$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $8373ca4214e15aed$var$markNodeAsHoistable(instance), instance;
            var styleProps = $8373ca4214e15aed$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $8373ca4214e15aed$var$markNodeAsHoistable(instance);
            $8373ca4214e15aed$var$setInitialProperties(instance, "style", styleProps);
            $8373ca4214e15aed$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $8373ca4214e15aed$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $8373ca4214e15aed$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $8373ca4214e15aed$var$stylesheetPropsFromRawProps(props);
            (styleProps = $8373ca4214e15aed$var$preloadPropsMap.get(styleProps)) && $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $8373ca4214e15aed$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8373ca4214e15aed$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $8373ca4214e15aed$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $8373ca4214e15aed$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $8373ca4214e15aed$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $8373ca4214e15aed$var$preloadPropsMap.get(instance$249)) instance = $8373ca4214e15aed$var$assign({}, props), $8373ca4214e15aed$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $8373ca4214e15aed$var$markNodeAsHoistable(styleProps);
            $8373ca4214e15aed$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $8373ca4214e15aed$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $8373ca4214e15aed$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $8373ca4214e15aed$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $8373ca4214e15aed$var$tagCaches = null;
function $8373ca4214e15aed$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $8373ca4214e15aed$var$tagCaches) {
        var cache = new Map();
        var caches = $8373ca4214e15aed$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $8373ca4214e15aed$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$8373ca4214e15aed$var$internalHoistableMarker] || node[$8373ca4214e15aed$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $8373ca4214e15aed$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $8373ca4214e15aed$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $8373ca4214e15aed$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $8373ca4214e15aed$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $8373ca4214e15aed$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $8373ca4214e15aed$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $8373ca4214e15aed$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $8373ca4214e15aed$var$stylesheetPropsFromRawProps(props);
            (key = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $8373ca4214e15aed$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8373ca4214e15aed$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $8373ca4214e15aed$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $8373ca4214e15aed$var$estimatedBytesWithinLimit = 0;
function $8373ca4214e15aed$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $8373ca4214e15aed$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $8373ca4214e15aed$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $8373ca4214e15aed$var$estimatedBytesWithinLimit && ($8373ca4214e15aed$var$estimatedBytesWithinLimit = 62500 * $8373ca4214e15aed$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $8373ca4214e15aed$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $8373ca4214e15aed$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $8373ca4214e15aed$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $8373ca4214e15aed$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $8373ca4214e15aed$var$precedencesByRoot = null;
function $8373ca4214e15aed$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $8373ca4214e15aed$var$precedencesByRoot = new Map(), resources.forEach($8373ca4214e15aed$var$insertStylesheetIntoRoot, state), $8373ca4214e15aed$var$precedencesByRoot = null, $8373ca4214e15aed$var$onUnsuspend.call(state));
}
function $8373ca4214e15aed$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $8373ca4214e15aed$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $8373ca4214e15aed$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $8373ca4214e15aed$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $8373ca4214e15aed$var$HostTransitionContext = {
    $$typeof: $8373ca4214e15aed$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $8373ca4214e15aed$var$sharedNotPendingObject,
    _currentValue2: $8373ca4214e15aed$var$sharedNotPendingObject,
    _threadCount: 0
};
function $8373ca4214e15aed$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $8373ca4214e15aed$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8373ca4214e15aed$var$createLaneMap(0);
    this.hiddenUpdates = $8373ca4214e15aed$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $8373ca4214e15aed$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $8373ca4214e15aed$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $8373ca4214e15aed$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $8373ca4214e15aed$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $8373ca4214e15aed$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $8373ca4214e15aed$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $8373ca4214e15aed$var$emptyContextObject;
    parentComponent = $8373ca4214e15aed$var$emptyContextObject;
    return parentComponent;
}
function $8373ca4214e15aed$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $8373ca4214e15aed$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $8373ca4214e15aed$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $8373ca4214e15aed$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(element, rootFiber, lane), $8373ca4214e15aed$var$entangleTransitions(element, rootFiber, lane));
}
function $8373ca4214e15aed$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $8373ca4214e15aed$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $8373ca4214e15aed$var$markRetryLaneImpl(fiber, retryLane);
}
function $8373ca4214e15aed$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $8373ca4214e15aed$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $8373ca4214e15aed$var$requestUpdateLane();
        lane = $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(lane);
        var root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, lane);
        $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $8373ca4214e15aed$var$_enabled = !0;
function $8373ca4214e15aed$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T;
    $8373ca4214e15aed$var$ReactSharedInternals.T = null;
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2, $8373ca4214e15aed$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8373ca4214e15aed$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T;
    $8373ca4214e15aed$var$ReactSharedInternals.T = null;
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 8, $8373ca4214e15aed$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8373ca4214e15aed$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($8373ca4214e15aed$var$_enabled) {
        var blockedOn = $8373ca4214e15aed$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8373ca4214e15aed$var$return_targetInst, targetContainer), $8373ca4214e15aed$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($8373ca4214e15aed$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($8373ca4214e15aed$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $8373ca4214e15aed$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $8373ca4214e15aed$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $8373ca4214e15aed$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $8373ca4214e15aed$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $8373ca4214e15aed$var$ensureRootIsScheduled(fiber);
                                0 === ($8373ca4214e15aed$var$executionContext & 6) && ($8373ca4214e15aed$var$workInProgressRootRenderTargetTime = $8373ca4214e15aed$var$now() + 500, $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, 2), $8373ca4214e15aed$var$flushSyncWork$1(), $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $8373ca4214e15aed$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8373ca4214e15aed$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $8373ca4214e15aed$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $8373ca4214e15aed$var$getEventTarget(nativeEvent);
    return $8373ca4214e15aed$var$findInstanceBlockingTarget(nativeEvent);
}
var $8373ca4214e15aed$var$return_targetInst = null;
function $8373ca4214e15aed$var$findInstanceBlockingTarget(targetNode) {
    $8373ca4214e15aed$var$return_targetInst = null;
    targetNode = $8373ca4214e15aed$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $8373ca4214e15aed$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $8373ca4214e15aed$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $8373ca4214e15aed$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $8373ca4214e15aed$var$return_targetInst = targetNode;
    return null;
}
function $8373ca4214e15aed$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($8373ca4214e15aed$var$getCurrentPriorityLevel()){
                case $8373ca4214e15aed$var$ImmediatePriority:
                    return 2;
                case $8373ca4214e15aed$var$UserBlockingPriority:
                    return 8;
                case $8373ca4214e15aed$var$NormalPriority$1:
                case $8373ca4214e15aed$var$LowPriority:
                    return 32;
                case $8373ca4214e15aed$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $8373ca4214e15aed$var$hasScheduledReplayAttempt = !1, $8373ca4214e15aed$var$queuedFocus = null, $8373ca4214e15aed$var$queuedDrag = null, $8373ca4214e15aed$var$queuedMouse = null, $8373ca4214e15aed$var$queuedPointers = new Map(), $8373ca4214e15aed$var$queuedPointerCaptures = new Map(), $8373ca4214e15aed$var$queuedExplicitHydrationTargets = [], $8373ca4214e15aed$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $8373ca4214e15aed$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $8373ca4214e15aed$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $8373ca4214e15aed$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $8373ca4214e15aed$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $8373ca4214e15aed$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8373ca4214e15aed$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $8373ca4214e15aed$var$getInstanceFromNode(blockedOn), null !== blockedOn && $8373ca4214e15aed$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $8373ca4214e15aed$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $8373ca4214e15aed$var$queuedFocus = $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $8373ca4214e15aed$var$queuedDrag = $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $8373ca4214e15aed$var$queuedMouse = $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $8373ca4214e15aed$var$queuedPointers.set(pointerId, $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $8373ca4214e15aed$var$queuedPointerCaptures.set(pointerId, $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $8373ca4214e15aed$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $8373ca4214e15aed$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $8373ca4214e15aed$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $8373ca4214e15aed$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8373ca4214e15aed$var$runWithPriority(queuedTarget.priority, function() {
                        $8373ca4214e15aed$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $8373ca4214e15aed$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8373ca4214e15aed$var$runWithPriority(queuedTarget.priority, function() {
                        $8373ca4214e15aed$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $8373ca4214e15aed$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $8373ca4214e15aed$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $8373ca4214e15aed$var$currentReplayingEvent = null;
        } else return targetContainers = $8373ca4214e15aed$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $8373ca4214e15aed$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $8373ca4214e15aed$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $8373ca4214e15aed$var$replayUnblockedEvents() {
    $8373ca4214e15aed$var$hasScheduledReplayAttempt = !1;
    null !== $8373ca4214e15aed$var$queuedFocus && $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent($8373ca4214e15aed$var$queuedFocus) && ($8373ca4214e15aed$var$queuedFocus = null);
    null !== $8373ca4214e15aed$var$queuedDrag && $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent($8373ca4214e15aed$var$queuedDrag) && ($8373ca4214e15aed$var$queuedDrag = null);
    null !== $8373ca4214e15aed$var$queuedMouse && $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent($8373ca4214e15aed$var$queuedMouse) && ($8373ca4214e15aed$var$queuedMouse = null);
    $8373ca4214e15aed$var$queuedPointers.forEach($8373ca4214e15aed$var$attemptReplayContinuousQueuedEventInMap);
    $8373ca4214e15aed$var$queuedPointerCaptures.forEach($8373ca4214e15aed$var$attemptReplayContinuousQueuedEventInMap);
}
function $8373ca4214e15aed$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $8373ca4214e15aed$var$hasScheduledReplayAttempt || ($8373ca4214e15aed$var$hasScheduledReplayAttempt = !0, $1zXL0.unstable_scheduleCallback($1zXL0.unstable_NormalPriority, $8373ca4214e15aed$var$replayUnblockedEvents)));
}
var $8373ca4214e15aed$var$lastScheduledReplayQueue = null;
function $8373ca4214e15aed$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $8373ca4214e15aed$var$lastScheduledReplayQueue !== formReplayingQueue && ($8373ca4214e15aed$var$lastScheduledReplayQueue = formReplayingQueue, $1zXL0.unstable_scheduleCallback($1zXL0.unstable_NormalPriority, function() {
        $8373ca4214e15aed$var$lastScheduledReplayQueue === formReplayingQueue && ($8373ca4214e15aed$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $8373ca4214e15aed$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $8373ca4214e15aed$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $8373ca4214e15aed$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $8373ca4214e15aed$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $8373ca4214e15aed$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $8373ca4214e15aed$var$queuedFocus && $8373ca4214e15aed$var$scheduleCallbackIfUnblocked($8373ca4214e15aed$var$queuedFocus, unblocked);
    null !== $8373ca4214e15aed$var$queuedDrag && $8373ca4214e15aed$var$scheduleCallbackIfUnblocked($8373ca4214e15aed$var$queuedDrag, unblocked);
    null !== $8373ca4214e15aed$var$queuedMouse && $8373ca4214e15aed$var$scheduleCallbackIfUnblocked($8373ca4214e15aed$var$queuedMouse, unblocked);
    $8373ca4214e15aed$var$queuedPointers.forEach(unblock);
    $8373ca4214e15aed$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $8373ca4214e15aed$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $8373ca4214e15aed$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $8373ca4214e15aed$var$queuedExplicitHydrationTargets.length && (i = $8373ca4214e15aed$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$8373ca4214e15aed$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $8373ca4214e15aed$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$8373ca4214e15aed$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $8373ca4214e15aed$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$8373ca4214e15aed$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $8373ca4214e15aed$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $8373ca4214e15aed$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $8373ca4214e15aed$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $8373ca4214e15aed$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8373ca4214e15aed$var$ReactDOMHydrationRoot.prototype.render = $8373ca4214e15aed$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(409));
    var current = root.current, lane = $8373ca4214e15aed$var$requestUpdateLane();
    $8373ca4214e15aed$var$updateContainerImpl(current, lane, children, root, null, null);
};
$8373ca4214e15aed$var$ReactDOMHydrationRoot.prototype.unmount = $8373ca4214e15aed$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $8373ca4214e15aed$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $8373ca4214e15aed$var$flushSyncWork$1();
        container[$8373ca4214e15aed$var$internalContainerInstanceKey] = null;
    }
};
function $8373ca4214e15aed$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8373ca4214e15aed$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $8373ca4214e15aed$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $8373ca4214e15aed$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $8373ca4214e15aed$var$queuedExplicitHydrationTargets[i].priority; i++);
        $8373ca4214e15aed$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $8373ca4214e15aed$var$attemptExplicitHydrationTarget(target);
    }
};
var $8373ca4214e15aed$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $cQmXV.version;
if ("19.2.7" !== $8373ca4214e15aed$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(527, $8373ca4214e15aed$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.7"));
$8373ca4214e15aed$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $8373ca4214e15aed$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $8373ca4214e15aed$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $8373ca4214e15aed$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $8373ca4214e15aed$var$ReactSharedInternals,
    reconcilerVersion: "19.2.7"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8373ca4214e15aed$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8373ca4214e15aed$var$hook$jscomp$inline_2348.isDisabled && $8373ca4214e15aed$var$hook$jscomp$inline_2348.supportsFiber) try {
        $8373ca4214e15aed$var$rendererID = $8373ca4214e15aed$var$hook$jscomp$inline_2348.inject($8373ca4214e15aed$var$internals$jscomp$inline_2347), $8373ca4214e15aed$var$injectedHook = $8373ca4214e15aed$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$8373ca4214e15aed$export$882461b6382ed46c = function(container, options) {
    if (!$8373ca4214e15aed$var$isValidContainer(container)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8373ca4214e15aed$var$defaultOnUncaughtError, onCaughtError = $8373ca4214e15aed$var$defaultOnCaughtError, onRecoverableError = $8373ca4214e15aed$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $8373ca4214e15aed$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $8373ca4214e15aed$var$defaultOnDefaultTransitionIndicator);
    container[$8373ca4214e15aed$var$internalContainerInstanceKey] = options.current;
    $8373ca4214e15aed$var$listenToAllSupportedEvents(container);
    return new $8373ca4214e15aed$var$ReactDOMRoot(options);
};
$8373ca4214e15aed$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$8373ca4214e15aed$var$isValidContainer(container)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8373ca4214e15aed$var$defaultOnUncaughtError, onCaughtError = $8373ca4214e15aed$var$defaultOnCaughtError, onRecoverableError = $8373ca4214e15aed$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $8373ca4214e15aed$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $8373ca4214e15aed$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $8373ca4214e15aed$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $8373ca4214e15aed$var$requestUpdateLane();
    isStrictMode = $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $8373ca4214e15aed$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $8373ca4214e15aed$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $8373ca4214e15aed$var$markRootUpdated$1(initialChildren, options);
    $8373ca4214e15aed$var$ensureRootIsScheduled(initialChildren);
    container[$8373ca4214e15aed$var$internalContainerInstanceKey] = initialChildren.current;
    $8373ca4214e15aed$var$listenToAllSupportedEvents(container);
    return new $8373ca4214e15aed$var$ReactDOMHydrationRoot(initialChildren);
};
$8373ca4214e15aed$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("1zXL0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1r3Y4"));

});
parcelRegister("1r3Y4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $10bb63fb0ca7de0b$export$c4744153514ff05d; }, function (v) { return $10bb63fb0ca7de0b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7; }, function (v) { return $10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $10bb63fb0ca7de0b$export$e26fe2ed2fa76875; }, function (v) { return $10bb63fb0ca7de0b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $10bb63fb0ca7de0b$export$502329bbf4b505b1; }, function (v) { return $10bb63fb0ca7de0b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $10bb63fb0ca7de0b$export$6e3807111c4874c4; }, function (v) { return $10bb63fb0ca7de0b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $10bb63fb0ca7de0b$export$c27134553091fb3a; }, function (v) { return $10bb63fb0ca7de0b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $10bb63fb0ca7de0b$export$33ee1acdc04fd2a2; }, function (v) { return $10bb63fb0ca7de0b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $10bb63fb0ca7de0b$export$b00a404bbd5edef2; }, function (v) { return $10bb63fb0ca7de0b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $10bb63fb0ca7de0b$export$d66a1c1c77bd778b; }, function (v) { return $10bb63fb0ca7de0b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $10bb63fb0ca7de0b$export$d3dfb8e4810cb555; }, function (v) { return $10bb63fb0ca7de0b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $10bb63fb0ca7de0b$export$72fdf0e06517287b; }, function (v) { return $10bb63fb0ca7de0b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $10bb63fb0ca7de0b$export$816d2913ae6b83b1; }, function (v) { return $10bb63fb0ca7de0b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $10bb63fb0ca7de0b$export$61bcfe829111a1d0; }, function (v) { return $10bb63fb0ca7de0b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $10bb63fb0ca7de0b$export$7ee8c9beb337bc3f; }, function (v) { return $10bb63fb0ca7de0b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $10bb63fb0ca7de0b$export$b5836b71941fa3ed; }, function (v) { return $10bb63fb0ca7de0b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $10bb63fb0ca7de0b$export$cf845f2c119da08a; }, function (v) { return $10bb63fb0ca7de0b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $10bb63fb0ca7de0b$export$c4744153514ff05d;
var $10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7;
var $10bb63fb0ca7de0b$export$e26fe2ed2fa76875;
var $10bb63fb0ca7de0b$export$502329bbf4b505b1;
var $10bb63fb0ca7de0b$export$6e3807111c4874c4;
var $10bb63fb0ca7de0b$export$c27134553091fb3a;
var $10bb63fb0ca7de0b$export$33ee1acdc04fd2a2;
var $10bb63fb0ca7de0b$export$b00a404bbd5edef2;
var $10bb63fb0ca7de0b$export$d66a1c1c77bd778b;
var $10bb63fb0ca7de0b$export$d3dfb8e4810cb555;
var $10bb63fb0ca7de0b$export$72fdf0e06517287b;
var $10bb63fb0ca7de0b$export$816d2913ae6b83b1;
var $10bb63fb0ca7de0b$export$61bcfe829111a1d0;
var $10bb63fb0ca7de0b$export$7ee8c9beb337bc3f;
var $10bb63fb0ca7de0b$export$b5836b71941fa3ed;
var $10bb63fb0ca7de0b$export$cf845f2c119da08a;
"use strict";
function $10bb63fb0ca7de0b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $10bb63fb0ca7de0b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $10bb63fb0ca7de0b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $10bb63fb0ca7de0b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $10bb63fb0ca7de0b$var$compare(left, last)) rightIndex < length && 0 > $10bb63fb0ca7de0b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $10bb63fb0ca7de0b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $10bb63fb0ca7de0b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$10bb63fb0ca7de0b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $10bb63fb0ca7de0b$var$localPerformance = performance;
    $10bb63fb0ca7de0b$export$c4744153514ff05d = function() {
        return $10bb63fb0ca7de0b$var$localPerformance.now();
    };
} else {
    var $10bb63fb0ca7de0b$var$localDate = Date, $10bb63fb0ca7de0b$var$initialTime = $10bb63fb0ca7de0b$var$localDate.now();
    $10bb63fb0ca7de0b$export$c4744153514ff05d = function() {
        return $10bb63fb0ca7de0b$var$localDate.now() - $10bb63fb0ca7de0b$var$initialTime;
    };
}
var $10bb63fb0ca7de0b$var$taskQueue = [], $10bb63fb0ca7de0b$var$timerQueue = [], $10bb63fb0ca7de0b$var$taskIdCounter = 1, $10bb63fb0ca7de0b$var$currentTask = null, $10bb63fb0ca7de0b$var$currentPriorityLevel = 3, $10bb63fb0ca7de0b$var$isPerformingWork = !1, $10bb63fb0ca7de0b$var$isHostCallbackScheduled = !1, $10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !1, $10bb63fb0ca7de0b$var$needsPaint = !1, $10bb63fb0ca7de0b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $10bb63fb0ca7de0b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $10bb63fb0ca7de0b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $10bb63fb0ca7de0b$var$advanceTimers(currentTime) {
    for(var timer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$timerQueue);
        else if (timer.startTime <= currentTime) $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$timerQueue), timer.sortIndex = timer.expirationTime, $10bb63fb0ca7de0b$var$push($10bb63fb0ca7de0b$var$taskQueue, timer);
        else break;
        timer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue);
    }
}
function $10bb63fb0ca7de0b$var$handleTimeout(currentTime) {
    $10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !1;
    $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
    if (!$10bb63fb0ca7de0b$var$isHostCallbackScheduled) {
        if (null !== $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue)) $10bb63fb0ca7de0b$var$isHostCallbackScheduled = !0, $10bb63fb0ca7de0b$var$isMessageLoopRunning || ($10bb63fb0ca7de0b$var$isMessageLoopRunning = !0, $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue);
            null !== firstTimer && $10bb63fb0ca7de0b$var$requestHostTimeout($10bb63fb0ca7de0b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $10bb63fb0ca7de0b$var$isMessageLoopRunning = !1, $10bb63fb0ca7de0b$var$taskTimeoutID = -1, $10bb63fb0ca7de0b$var$frameInterval = 5, $10bb63fb0ca7de0b$var$startTime = -1;
function $10bb63fb0ca7de0b$var$shouldYieldToHost() {
    return $10bb63fb0ca7de0b$var$needsPaint ? !0 : $10bb63fb0ca7de0b$export$c4744153514ff05d() - $10bb63fb0ca7de0b$var$startTime < $10bb63fb0ca7de0b$var$frameInterval ? !1 : !0;
}
function $10bb63fb0ca7de0b$var$performWorkUntilDeadline() {
    $10bb63fb0ca7de0b$var$needsPaint = !1;
    if ($10bb63fb0ca7de0b$var$isMessageLoopRunning) {
        var currentTime = $10bb63fb0ca7de0b$export$c4744153514ff05d();
        $10bb63fb0ca7de0b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $10bb63fb0ca7de0b$var$isHostCallbackScheduled = !1;
                $10bb63fb0ca7de0b$var$isHostTimeoutScheduled && ($10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !1, $10bb63fb0ca7de0b$var$localClearTimeout($10bb63fb0ca7de0b$var$taskTimeoutID), $10bb63fb0ca7de0b$var$taskTimeoutID = -1);
                $10bb63fb0ca7de0b$var$isPerformingWork = !0;
                var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
                try {
                    b: {
                        $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
                        for($10bb63fb0ca7de0b$var$currentTask = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue); null !== $10bb63fb0ca7de0b$var$currentTask && !($10bb63fb0ca7de0b$var$currentTask.expirationTime > currentTime && $10bb63fb0ca7de0b$var$shouldYieldToHost());){
                            var callback = $10bb63fb0ca7de0b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $10bb63fb0ca7de0b$var$currentTask.callback = null;
                                $10bb63fb0ca7de0b$var$currentPriorityLevel = $10bb63fb0ca7de0b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($10bb63fb0ca7de0b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $10bb63fb0ca7de0b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $10bb63fb0ca7de0b$var$currentTask.callback = continuationCallback;
                                    $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $10bb63fb0ca7de0b$var$currentTask === $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue) && $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$taskQueue);
                                $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
                            } else $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$taskQueue);
                            $10bb63fb0ca7de0b$var$currentTask = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue);
                        }
                        if (null !== $10bb63fb0ca7de0b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue);
                            null !== firstTimer && $10bb63fb0ca7de0b$var$requestHostTimeout($10bb63fb0ca7de0b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $10bb63fb0ca7de0b$var$currentTask = null, $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel, $10bb63fb0ca7de0b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline() : $10bb63fb0ca7de0b$var$isMessageLoopRunning = !1;
        }
    }
}
var $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $10bb63fb0ca7de0b$var$localSetImmediate) $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline = function() {
    $10bb63fb0ca7de0b$var$localSetImmediate($10bb63fb0ca7de0b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $10bb63fb0ca7de0b$var$channel = new MessageChannel(), $10bb63fb0ca7de0b$var$port = $10bb63fb0ca7de0b$var$channel.port2;
    $10bb63fb0ca7de0b$var$channel.port1.onmessage = $10bb63fb0ca7de0b$var$performWorkUntilDeadline;
    $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline = function() {
        $10bb63fb0ca7de0b$var$port.postMessage(null);
    };
} else $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline = function() {
    $10bb63fb0ca7de0b$var$localSetTimeout($10bb63fb0ca7de0b$var$performWorkUntilDeadline, 0);
};
function $10bb63fb0ca7de0b$var$requestHostTimeout(callback, ms) {
    $10bb63fb0ca7de0b$var$taskTimeoutID = $10bb63fb0ca7de0b$var$localSetTimeout(function() {
        callback($10bb63fb0ca7de0b$export$c4744153514ff05d());
    }, ms);
}
$10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7 = 5;
$10bb63fb0ca7de0b$export$e26fe2ed2fa76875 = 1;
$10bb63fb0ca7de0b$export$502329bbf4b505b1 = 4;
$10bb63fb0ca7de0b$export$6e3807111c4874c4 = 3;
$10bb63fb0ca7de0b$export$c27134553091fb3a = null;
$10bb63fb0ca7de0b$export$33ee1acdc04fd2a2 = 2;
$10bb63fb0ca7de0b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$10bb63fb0ca7de0b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $10bb63fb0ca7de0b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$10bb63fb0ca7de0b$export$d3dfb8e4810cb555 = function() {
    return $10bb63fb0ca7de0b$var$currentPriorityLevel;
};
$10bb63fb0ca7de0b$export$72fdf0e06517287b = function(eventHandler) {
    switch($10bb63fb0ca7de0b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    $10bb63fb0ca7de0b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$10bb63fb0ca7de0b$export$816d2913ae6b83b1 = function() {
    $10bb63fb0ca7de0b$var$needsPaint = !0;
};
$10bb63fb0ca7de0b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    $10bb63fb0ca7de0b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$10bb63fb0ca7de0b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $10bb63fb0ca7de0b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $10bb63fb0ca7de0b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $10bb63fb0ca7de0b$var$push($10bb63fb0ca7de0b$var$timerQueue, priorityLevel), null === $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue) && priorityLevel === $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue) && ($10bb63fb0ca7de0b$var$isHostTimeoutScheduled ? ($10bb63fb0ca7de0b$var$localClearTimeout($10bb63fb0ca7de0b$var$taskTimeoutID), $10bb63fb0ca7de0b$var$taskTimeoutID = -1) : $10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !0, $10bb63fb0ca7de0b$var$requestHostTimeout($10bb63fb0ca7de0b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $10bb63fb0ca7de0b$var$push($10bb63fb0ca7de0b$var$taskQueue, priorityLevel), $10bb63fb0ca7de0b$var$isHostCallbackScheduled || $10bb63fb0ca7de0b$var$isPerformingWork || ($10bb63fb0ca7de0b$var$isHostCallbackScheduled = !0, $10bb63fb0ca7de0b$var$isMessageLoopRunning || ($10bb63fb0ca7de0b$var$isMessageLoopRunning = !0, $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$10bb63fb0ca7de0b$export$b5836b71941fa3ed = $10bb63fb0ca7de0b$var$shouldYieldToHost;
$10bb63fb0ca7de0b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
        $10bb63fb0ca7de0b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("cQmXV", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ko9PG"));

});

parcelRegister("3h5eW", function(module, exports) {
"use strict";
function $2627062c24ff394e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2627062c24ff394e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2627062c24ff394e$var$checkDCE();

module.exports = (parcelRequire("gmKll"));

});
parcelRegister("gmKll", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $bea2a63a093f15da$export$69ce8ef3fe5cead0; }, function (v) { return $bea2a63a093f15da$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $bea2a63a093f15da$export$d39a5bbd09211389; }, function (v) { return $bea2a63a093f15da$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bea2a63a093f15da$export$cd75ccfd720a3cd4; }, function (v) { return $bea2a63a093f15da$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $bea2a63a093f15da$export$a0816fa17a9e79be; }, function (v) { return $bea2a63a093f15da$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $bea2a63a093f15da$export$7292efcadded39f3; }, function (v) { return $bea2a63a093f15da$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $bea2a63a093f15da$export$da407abadb9b8f86; }, function (v) { return $bea2a63a093f15da$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $bea2a63a093f15da$export$314cfea32580671c; }, function (v) { return $bea2a63a093f15da$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $bea2a63a093f15da$export$513ccb98c53b8039; }, function (v) { return $bea2a63a093f15da$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $bea2a63a093f15da$export$dbca993bc2d264a; }, function (v) { return $bea2a63a093f15da$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $bea2a63a093f15da$export$4797a8006f0655d0; }, function (v) { return $bea2a63a093f15da$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bea2a63a093f15da$export$c78a37762a8d58e1; }, function (v) { return $bea2a63a093f15da$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $bea2a63a093f15da$export$606f11b2eb45ecc6; }, function (v) { return $bea2a63a093f15da$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $bea2a63a093f15da$export$f7e8a0bf92324b1e; }, function (v) { return $bea2a63a093f15da$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $bea2a63a093f15da$export$83d89fbfd8236492; }, function (v) { return $bea2a63a093f15da$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bea2a63a093f15da$export$69ce8ef3fe5cead0;
var $bea2a63a093f15da$export$d39a5bbd09211389;
var $bea2a63a093f15da$export$cd75ccfd720a3cd4;
var $bea2a63a093f15da$export$a0816fa17a9e79be;
var $bea2a63a093f15da$export$7292efcadded39f3;
var $bea2a63a093f15da$export$da407abadb9b8f86;
var $bea2a63a093f15da$export$314cfea32580671c;
var $bea2a63a093f15da$export$513ccb98c53b8039;
var $bea2a63a093f15da$export$dbca993bc2d264a;
var $bea2a63a093f15da$export$4797a8006f0655d0;
var $bea2a63a093f15da$export$c78a37762a8d58e1;
var $bea2a63a093f15da$export$606f11b2eb45ecc6;
var $bea2a63a093f15da$export$f7e8a0bf92324b1e;
var $bea2a63a093f15da$export$83d89fbfd8236492;
"use strict";

var $cQmXV = parcelRequire("cQmXV");
function $bea2a63a093f15da$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $bea2a63a093f15da$var$noop() {}
var $bea2a63a093f15da$var$Internals = {
    d: {
        f: $bea2a63a093f15da$var$noop,
        r: function() {
            throw Error($bea2a63a093f15da$var$formatProdErrorMessage(522));
        },
        D: $bea2a63a093f15da$var$noop,
        C: $bea2a63a093f15da$var$noop,
        L: $bea2a63a093f15da$var$noop,
        m: $bea2a63a093f15da$var$noop,
        X: $bea2a63a093f15da$var$noop,
        S: $bea2a63a093f15da$var$noop,
        M: $bea2a63a093f15da$var$noop
    },
    p: 0,
    findDOMNode: null
}, $bea2a63a093f15da$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $bea2a63a093f15da$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bea2a63a093f15da$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $bea2a63a093f15da$var$ReactSharedInternals = $cQmXV.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $bea2a63a093f15da$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$bea2a63a093f15da$export$69ce8ef3fe5cead0 = $bea2a63a093f15da$var$Internals;
$bea2a63a093f15da$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($bea2a63a093f15da$var$formatProdErrorMessage(299));
    return $bea2a63a093f15da$var$createPortal$1(children, container, null, key);
};
$bea2a63a093f15da$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $bea2a63a093f15da$var$ReactSharedInternals.T, previousUpdatePriority = $bea2a63a093f15da$var$Internals.p;
    try {
        if ($bea2a63a093f15da$var$ReactSharedInternals.T = null, $bea2a63a093f15da$var$Internals.p = 2, fn) return fn();
    } finally{
        $bea2a63a093f15da$var$ReactSharedInternals.T = previousTransition, $bea2a63a093f15da$var$Internals.p = previousUpdatePriority, $bea2a63a093f15da$var$Internals.d.f();
    }
};
$bea2a63a093f15da$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $bea2a63a093f15da$var$Internals.d.C(href, options));
};
$bea2a63a093f15da$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $bea2a63a093f15da$var$Internals.d.D(href);
};
$bea2a63a093f15da$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $bea2a63a093f15da$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $bea2a63a093f15da$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$bea2a63a093f15da$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $bea2a63a093f15da$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $bea2a63a093f15da$var$Internals.d.M(href);
    }
};
$bea2a63a093f15da$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(as, options.crossOrigin);
        $bea2a63a093f15da$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$bea2a63a093f15da$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $bea2a63a093f15da$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $bea2a63a093f15da$var$Internals.d.m(href);
    }
};
$bea2a63a093f15da$export$4797a8006f0655d0 = function(form) {
    $bea2a63a093f15da$var$Internals.d.r(form);
};
$bea2a63a093f15da$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$bea2a63a093f15da$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $bea2a63a093f15da$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$bea2a63a093f15da$export$f7e8a0bf92324b1e = function() {
    return $bea2a63a093f15da$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$bea2a63a093f15da$export$83d89fbfd8236492 = "19.2.7";

});



parcelRegister("d00aZ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $976b6973b6020089$export$bf730a2d8bf68b42; }, function (v) { return $976b6973b6020089$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $976b6973b6020089$export$bf730a2d8bf68b42;
"use strict";

var $cQmXV = parcelRequire("cQmXV");
function $976b6973b6020089$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $976b6973b6020089$var$objectIs = "function" === typeof Object.is ? Object.is : $976b6973b6020089$var$is, $976b6973b6020089$var$useSyncExternalStore = $cQmXV.useSyncExternalStore, $976b6973b6020089$var$useRef = $cQmXV.useRef, $976b6973b6020089$var$useEffect = $cQmXV.useEffect, $976b6973b6020089$var$useMemo = $cQmXV.useMemo, $976b6973b6020089$var$useDebugValue = $cQmXV.useDebugValue;
$976b6973b6020089$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $976b6973b6020089$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $976b6973b6020089$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($976b6973b6020089$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $976b6973b6020089$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $976b6973b6020089$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $976b6973b6020089$var$useDebugValue(value);
    return value;
};

});

parcelRegister("keGWe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iLKj0 = parcelRequire("iLKj0");
function $ebb66c15cd244f3f$var$emptyFunction() {}
function $ebb66c15cd244f3f$var$emptyFunctionWithReset() {}
$ebb66c15cd244f3f$var$emptyFunctionWithReset.resetWarningCache = $ebb66c15cd244f3f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iLKj0) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ebb66c15cd244f3f$var$emptyFunctionWithReset,
        resetWarningCache: $ebb66c15cd244f3f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iLKj0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $daa089165e95456f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $daa089165e95456f$var$ReactPropTypesSecret;

});


parcelRegister("9fiKv", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $6bb40ef39bebc166$export$2b8d127b894957b9; }, function (v) { return $6bb40ef39bebc166$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $6bb40ef39bebc166$export$cea3a54a6425200c; }, function (v) { return $6bb40ef39bebc166$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $6bb40ef39bebc166$export$a7c73072b1a182ae; }, function (v) { return $6bb40ef39bebc166$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $6bb40ef39bebc166$export$9f27bc3417b4524d; }, function (v) { return $6bb40ef39bebc166$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $6bb40ef39bebc166$export$db77ccec0bb4ccac; }, function (v) { return $6bb40ef39bebc166$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $6bb40ef39bebc166$export$8392c0c9d3dcbd35; }, function (v) { return $6bb40ef39bebc166$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6bb40ef39bebc166$export$ffb0004e005737fa; }, function (v) { return $6bb40ef39bebc166$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $6bb40ef39bebc166$export$b624eff549462981; }, function (v) { return $6bb40ef39bebc166$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $6bb40ef39bebc166$export$7897aa7841a5380c; }, function (v) { return $6bb40ef39bebc166$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $6bb40ef39bebc166$export$602eac185826482c; }, function (v) { return $6bb40ef39bebc166$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $6bb40ef39bebc166$export$e2c29f18771995cb; }, function (v) { return $6bb40ef39bebc166$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6bb40ef39bebc166$export$5f8d39834fd61797; }, function (v) { return $6bb40ef39bebc166$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6bb40ef39bebc166$export$74bf444e3cd11ea5; }, function (v) { return $6bb40ef39bebc166$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $6bb40ef39bebc166$export$92387174baf9b227; }, function (v) { return $6bb40ef39bebc166$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $6bb40ef39bebc166$export$ec112efeb987d9c6; }, function (v) { return $6bb40ef39bebc166$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $6bb40ef39bebc166$export$b706b080d889d2c9; }, function (v) { return $6bb40ef39bebc166$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $6bb40ef39bebc166$export$5be5a87408f70ddc; }, function (v) { return $6bb40ef39bebc166$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $6bb40ef39bebc166$export$45a5e7f76e0caa8d; }, function (v) { return $6bb40ef39bebc166$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $6bb40ef39bebc166$export$455c2e768291efa6; }, function (v) { return $6bb40ef39bebc166$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $6bb40ef39bebc166$export$9522e17588c12572; }, function (v) { return $6bb40ef39bebc166$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $6bb40ef39bebc166$export$2110ac352bb060b9; }, function (v) { return $6bb40ef39bebc166$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $6bb40ef39bebc166$export$56885ab8b9c456ab; }, function (v) { return $6bb40ef39bebc166$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $6bb40ef39bebc166$export$d927fcb6adf8f9de; }, function (v) { return $6bb40ef39bebc166$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $6bb40ef39bebc166$export$b82d16f27459e05a; }, function (v) { return $6bb40ef39bebc166$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $6bb40ef39bebc166$export$522c17b4f5e123e8; }, function (v) { return $6bb40ef39bebc166$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $6bb40ef39bebc166$export$1aabd8a0274ecfd6; }, function (v) { return $6bb40ef39bebc166$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $6bb40ef39bebc166$export$9b621391a187a31a; }, function (v) { return $6bb40ef39bebc166$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $6bb40ef39bebc166$export$f5bbd400c2f4426f; }, function (v) { return $6bb40ef39bebc166$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6bb40ef39bebc166$export$2b8d127b894957b9;
var $6bb40ef39bebc166$export$cea3a54a6425200c;
var $6bb40ef39bebc166$export$a7c73072b1a182ae;
var $6bb40ef39bebc166$export$9f27bc3417b4524d;
var $6bb40ef39bebc166$export$db77ccec0bb4ccac;
var $6bb40ef39bebc166$export$8392c0c9d3dcbd35;
var $6bb40ef39bebc166$export$ffb0004e005737fa;
var $6bb40ef39bebc166$export$b624eff549462981;
var $6bb40ef39bebc166$export$7897aa7841a5380c;
var $6bb40ef39bebc166$export$602eac185826482c;
var $6bb40ef39bebc166$export$e2c29f18771995cb;
var $6bb40ef39bebc166$export$5f8d39834fd61797;
var $6bb40ef39bebc166$export$74bf444e3cd11ea5;
var $6bb40ef39bebc166$export$92387174baf9b227;
var $6bb40ef39bebc166$export$ec112efeb987d9c6;
var $6bb40ef39bebc166$export$b706b080d889d2c9;
var $6bb40ef39bebc166$export$5be5a87408f70ddc;
var $6bb40ef39bebc166$export$45a5e7f76e0caa8d;
var $6bb40ef39bebc166$export$455c2e768291efa6;
var $6bb40ef39bebc166$export$9522e17588c12572;
var $6bb40ef39bebc166$export$2110ac352bb060b9;
var $6bb40ef39bebc166$export$56885ab8b9c456ab;
var $6bb40ef39bebc166$export$d927fcb6adf8f9de;
var $6bb40ef39bebc166$export$b82d16f27459e05a;
var $6bb40ef39bebc166$export$522c17b4f5e123e8;
var $6bb40ef39bebc166$export$1aabd8a0274ecfd6;
var $6bb40ef39bebc166$export$9b621391a187a31a;
var $6bb40ef39bebc166$export$f5bbd400c2f4426f;
"use strict";
var $6bb40ef39bebc166$var$b = "function" === typeof Symbol && Symbol.for, $6bb40ef39bebc166$var$c = $6bb40ef39bebc166$var$b ? Symbol.for("react.element") : 60103, $6bb40ef39bebc166$var$d = $6bb40ef39bebc166$var$b ? Symbol.for("react.portal") : 60106, $6bb40ef39bebc166$var$e = $6bb40ef39bebc166$var$b ? Symbol.for("react.fragment") : 60107, $6bb40ef39bebc166$var$f = $6bb40ef39bebc166$var$b ? Symbol.for("react.strict_mode") : 60108, $6bb40ef39bebc166$var$g = $6bb40ef39bebc166$var$b ? Symbol.for("react.profiler") : 60114, $6bb40ef39bebc166$var$h = $6bb40ef39bebc166$var$b ? Symbol.for("react.provider") : 60109, $6bb40ef39bebc166$var$k = $6bb40ef39bebc166$var$b ? Symbol.for("react.context") : 60110, $6bb40ef39bebc166$var$l = $6bb40ef39bebc166$var$b ? Symbol.for("react.async_mode") : 60111, $6bb40ef39bebc166$var$m = $6bb40ef39bebc166$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6bb40ef39bebc166$var$n = $6bb40ef39bebc166$var$b ? Symbol.for("react.forward_ref") : 60112, $6bb40ef39bebc166$var$p = $6bb40ef39bebc166$var$b ? Symbol.for("react.suspense") : 60113, $6bb40ef39bebc166$var$q = $6bb40ef39bebc166$var$b ? Symbol.for("react.suspense_list") : 60120, $6bb40ef39bebc166$var$r = $6bb40ef39bebc166$var$b ? Symbol.for("react.memo") : 60115, $6bb40ef39bebc166$var$t = $6bb40ef39bebc166$var$b ? Symbol.for("react.lazy") : 60116, $6bb40ef39bebc166$var$v = $6bb40ef39bebc166$var$b ? Symbol.for("react.block") : 60121, $6bb40ef39bebc166$var$w = $6bb40ef39bebc166$var$b ? Symbol.for("react.fundamental") : 60117, $6bb40ef39bebc166$var$x = $6bb40ef39bebc166$var$b ? Symbol.for("react.responder") : 60118, $6bb40ef39bebc166$var$y = $6bb40ef39bebc166$var$b ? Symbol.for("react.scope") : 60119;
function $6bb40ef39bebc166$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6bb40ef39bebc166$var$c:
                switch(a = a.type, a){
                    case $6bb40ef39bebc166$var$l:
                    case $6bb40ef39bebc166$var$m:
                    case $6bb40ef39bebc166$var$e:
                    case $6bb40ef39bebc166$var$g:
                    case $6bb40ef39bebc166$var$f:
                    case $6bb40ef39bebc166$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6bb40ef39bebc166$var$k:
                            case $6bb40ef39bebc166$var$n:
                            case $6bb40ef39bebc166$var$t:
                            case $6bb40ef39bebc166$var$r:
                            case $6bb40ef39bebc166$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6bb40ef39bebc166$var$d:
                return u;
        }
    }
}
function $6bb40ef39bebc166$var$A(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$m;
}
$6bb40ef39bebc166$export$2b8d127b894957b9 = $6bb40ef39bebc166$var$l;
$6bb40ef39bebc166$export$cea3a54a6425200c = $6bb40ef39bebc166$var$m;
$6bb40ef39bebc166$export$a7c73072b1a182ae = $6bb40ef39bebc166$var$k;
$6bb40ef39bebc166$export$9f27bc3417b4524d = $6bb40ef39bebc166$var$h;
$6bb40ef39bebc166$export$db77ccec0bb4ccac = $6bb40ef39bebc166$var$c;
$6bb40ef39bebc166$export$8392c0c9d3dcbd35 = $6bb40ef39bebc166$var$n;
$6bb40ef39bebc166$export$ffb0004e005737fa = $6bb40ef39bebc166$var$e;
$6bb40ef39bebc166$export$b624eff549462981 = $6bb40ef39bebc166$var$t;
$6bb40ef39bebc166$export$7897aa7841a5380c = $6bb40ef39bebc166$var$r;
$6bb40ef39bebc166$export$602eac185826482c = $6bb40ef39bebc166$var$d;
$6bb40ef39bebc166$export$e2c29f18771995cb = $6bb40ef39bebc166$var$g;
$6bb40ef39bebc166$export$5f8d39834fd61797 = $6bb40ef39bebc166$var$f;
$6bb40ef39bebc166$export$74bf444e3cd11ea5 = $6bb40ef39bebc166$var$p;
$6bb40ef39bebc166$export$92387174baf9b227 = function(a) {
    return $6bb40ef39bebc166$var$A(a) || $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$l;
};
$6bb40ef39bebc166$export$ec112efeb987d9c6 = $6bb40ef39bebc166$var$A;
$6bb40ef39bebc166$export$b706b080d889d2c9 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$k;
};
$6bb40ef39bebc166$export$5be5a87408f70ddc = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$h;
};
$6bb40ef39bebc166$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6bb40ef39bebc166$var$c;
};
$6bb40ef39bebc166$export$455c2e768291efa6 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$n;
};
$6bb40ef39bebc166$export$9522e17588c12572 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$e;
};
$6bb40ef39bebc166$export$2110ac352bb060b9 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$t;
};
$6bb40ef39bebc166$export$56885ab8b9c456ab = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$r;
};
$6bb40ef39bebc166$export$d927fcb6adf8f9de = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$d;
};
$6bb40ef39bebc166$export$b82d16f27459e05a = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$g;
};
$6bb40ef39bebc166$export$522c17b4f5e123e8 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$f;
};
$6bb40ef39bebc166$export$1aabd8a0274ecfd6 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$p;
};
$6bb40ef39bebc166$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6bb40ef39bebc166$var$e || a === $6bb40ef39bebc166$var$m || a === $6bb40ef39bebc166$var$g || a === $6bb40ef39bebc166$var$f || a === $6bb40ef39bebc166$var$p || a === $6bb40ef39bebc166$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6bb40ef39bebc166$var$t || a.$$typeof === $6bb40ef39bebc166$var$r || a.$$typeof === $6bb40ef39bebc166$var$h || a.$$typeof === $6bb40ef39bebc166$var$k || a.$$typeof === $6bb40ef39bebc166$var$n || a.$$typeof === $6bb40ef39bebc166$var$w || a.$$typeof === $6bb40ef39bebc166$var$x || a.$$typeof === $6bb40ef39bebc166$var$y || a.$$typeof === $6bb40ef39bebc166$var$v);
};
$6bb40ef39bebc166$export$f5bbd400c2f4426f = $6bb40ef39bebc166$var$z;

});

parcelRegister("Yxlsx", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("fer7P", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $b16d34552d284bce$export$a7c73072b1a182ae; }, function (v) { return $b16d34552d284bce$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b16d34552d284bce$export$9f27bc3417b4524d; }, function (v) { return $b16d34552d284bce$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b16d34552d284bce$export$db77ccec0bb4ccac; }, function (v) { return $b16d34552d284bce$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b16d34552d284bce$export$8392c0c9d3dcbd35; }, function (v) { return $b16d34552d284bce$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b16d34552d284bce$export$ffb0004e005737fa; }, function (v) { return $b16d34552d284bce$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b16d34552d284bce$export$b624eff549462981; }, function (v) { return $b16d34552d284bce$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b16d34552d284bce$export$7897aa7841a5380c; }, function (v) { return $b16d34552d284bce$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b16d34552d284bce$export$602eac185826482c; }, function (v) { return $b16d34552d284bce$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b16d34552d284bce$export$e2c29f18771995cb; }, function (v) { return $b16d34552d284bce$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b16d34552d284bce$export$5f8d39834fd61797; }, function (v) { return $b16d34552d284bce$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b16d34552d284bce$export$74bf444e3cd11ea5; }, function (v) { return $b16d34552d284bce$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $b16d34552d284bce$export$998bcd577473dd93; }, function (v) { return $b16d34552d284bce$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b16d34552d284bce$export$b706b080d889d2c9; }, function (v) { return $b16d34552d284bce$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b16d34552d284bce$export$5be5a87408f70ddc; }, function (v) { return $b16d34552d284bce$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b16d34552d284bce$export$45a5e7f76e0caa8d; }, function (v) { return $b16d34552d284bce$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b16d34552d284bce$export$455c2e768291efa6; }, function (v) { return $b16d34552d284bce$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b16d34552d284bce$export$9522e17588c12572; }, function (v) { return $b16d34552d284bce$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b16d34552d284bce$export$2110ac352bb060b9; }, function (v) { return $b16d34552d284bce$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b16d34552d284bce$export$56885ab8b9c456ab; }, function (v) { return $b16d34552d284bce$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b16d34552d284bce$export$d927fcb6adf8f9de; }, function (v) { return $b16d34552d284bce$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b16d34552d284bce$export$b82d16f27459e05a; }, function (v) { return $b16d34552d284bce$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b16d34552d284bce$export$522c17b4f5e123e8; }, function (v) { return $b16d34552d284bce$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b16d34552d284bce$export$1aabd8a0274ecfd6; }, function (v) { return $b16d34552d284bce$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $b16d34552d284bce$export$3d6c20d97e46b957; }, function (v) { return $b16d34552d284bce$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b16d34552d284bce$export$9b621391a187a31a; }, function (v) { return $b16d34552d284bce$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b16d34552d284bce$export$f5bbd400c2f4426f; }, function (v) { return $b16d34552d284bce$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b16d34552d284bce$export$a7c73072b1a182ae;
var $b16d34552d284bce$export$9f27bc3417b4524d;
var $b16d34552d284bce$export$db77ccec0bb4ccac;
var $b16d34552d284bce$export$8392c0c9d3dcbd35;
var $b16d34552d284bce$export$ffb0004e005737fa;
var $b16d34552d284bce$export$b624eff549462981;
var $b16d34552d284bce$export$7897aa7841a5380c;
var $b16d34552d284bce$export$602eac185826482c;
var $b16d34552d284bce$export$e2c29f18771995cb;
var $b16d34552d284bce$export$5f8d39834fd61797;
var $b16d34552d284bce$export$74bf444e3cd11ea5;
var $b16d34552d284bce$export$998bcd577473dd93;
var $b16d34552d284bce$export$b706b080d889d2c9;
var $b16d34552d284bce$export$5be5a87408f70ddc;
var $b16d34552d284bce$export$45a5e7f76e0caa8d;
var $b16d34552d284bce$export$455c2e768291efa6;
var $b16d34552d284bce$export$9522e17588c12572;
var $b16d34552d284bce$export$2110ac352bb060b9;
var $b16d34552d284bce$export$56885ab8b9c456ab;
var $b16d34552d284bce$export$d927fcb6adf8f9de;
var $b16d34552d284bce$export$b82d16f27459e05a;
var $b16d34552d284bce$export$522c17b4f5e123e8;
var $b16d34552d284bce$export$1aabd8a0274ecfd6;
var $b16d34552d284bce$export$3d6c20d97e46b957;
var $b16d34552d284bce$export$9b621391a187a31a;
var $b16d34552d284bce$export$f5bbd400c2f4426f;
"use strict";
var $b16d34552d284bce$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b16d34552d284bce$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b16d34552d284bce$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b16d34552d284bce$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b16d34552d284bce$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b16d34552d284bce$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b16d34552d284bce$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b16d34552d284bce$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b16d34552d284bce$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b16d34552d284bce$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b16d34552d284bce$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b16d34552d284bce$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $b16d34552d284bce$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $b16d34552d284bce$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b16d34552d284bce$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $b16d34552d284bce$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $b16d34552d284bce$var$REACT_FRAGMENT_TYPE:
                    case $b16d34552d284bce$var$REACT_PROFILER_TYPE:
                    case $b16d34552d284bce$var$REACT_STRICT_MODE_TYPE:
                    case $b16d34552d284bce$var$REACT_SUSPENSE_TYPE:
                    case $b16d34552d284bce$var$REACT_SUSPENSE_LIST_TYPE:
                    case $b16d34552d284bce$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $b16d34552d284bce$var$REACT_CONTEXT_TYPE:
                            case $b16d34552d284bce$var$REACT_FORWARD_REF_TYPE:
                            case $b16d34552d284bce$var$REACT_LAZY_TYPE:
                            case $b16d34552d284bce$var$REACT_MEMO_TYPE:
                                return object;
                            case $b16d34552d284bce$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $b16d34552d284bce$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$b16d34552d284bce$export$a7c73072b1a182ae = $b16d34552d284bce$var$REACT_CONSUMER_TYPE;
$b16d34552d284bce$export$9f27bc3417b4524d = $b16d34552d284bce$var$REACT_CONTEXT_TYPE;
$b16d34552d284bce$export$db77ccec0bb4ccac = $b16d34552d284bce$var$REACT_ELEMENT_TYPE;
$b16d34552d284bce$export$8392c0c9d3dcbd35 = $b16d34552d284bce$var$REACT_FORWARD_REF_TYPE;
$b16d34552d284bce$export$ffb0004e005737fa = $b16d34552d284bce$var$REACT_FRAGMENT_TYPE;
$b16d34552d284bce$export$b624eff549462981 = $b16d34552d284bce$var$REACT_LAZY_TYPE;
$b16d34552d284bce$export$7897aa7841a5380c = $b16d34552d284bce$var$REACT_MEMO_TYPE;
$b16d34552d284bce$export$602eac185826482c = $b16d34552d284bce$var$REACT_PORTAL_TYPE;
$b16d34552d284bce$export$e2c29f18771995cb = $b16d34552d284bce$var$REACT_PROFILER_TYPE;
$b16d34552d284bce$export$5f8d39834fd61797 = $b16d34552d284bce$var$REACT_STRICT_MODE_TYPE;
$b16d34552d284bce$export$74bf444e3cd11ea5 = $b16d34552d284bce$var$REACT_SUSPENSE_TYPE;
$b16d34552d284bce$export$998bcd577473dd93 = $b16d34552d284bce$var$REACT_SUSPENSE_LIST_TYPE;
$b16d34552d284bce$export$b706b080d889d2c9 = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_CONSUMER_TYPE;
};
$b16d34552d284bce$export$5be5a87408f70ddc = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_CONTEXT_TYPE;
};
$b16d34552d284bce$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $b16d34552d284bce$var$REACT_ELEMENT_TYPE;
};
$b16d34552d284bce$export$455c2e768291efa6 = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_FORWARD_REF_TYPE;
};
$b16d34552d284bce$export$9522e17588c12572 = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_FRAGMENT_TYPE;
};
$b16d34552d284bce$export$2110ac352bb060b9 = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_LAZY_TYPE;
};
$b16d34552d284bce$export$56885ab8b9c456ab = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_MEMO_TYPE;
};
$b16d34552d284bce$export$d927fcb6adf8f9de = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_PORTAL_TYPE;
};
$b16d34552d284bce$export$b82d16f27459e05a = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_PROFILER_TYPE;
};
$b16d34552d284bce$export$522c17b4f5e123e8 = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_STRICT_MODE_TYPE;
};
$b16d34552d284bce$export$1aabd8a0274ecfd6 = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_SUSPENSE_TYPE;
};
$b16d34552d284bce$export$3d6c20d97e46b957 = function(object) {
    return $b16d34552d284bce$var$typeOf(object) === $b16d34552d284bce$var$REACT_SUSPENSE_LIST_TYPE;
};
$b16d34552d284bce$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $b16d34552d284bce$var$REACT_FRAGMENT_TYPE || type === $b16d34552d284bce$var$REACT_PROFILER_TYPE || type === $b16d34552d284bce$var$REACT_STRICT_MODE_TYPE || type === $b16d34552d284bce$var$REACT_SUSPENSE_TYPE || type === $b16d34552d284bce$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $b16d34552d284bce$var$REACT_LAZY_TYPE || type.$$typeof === $b16d34552d284bce$var$REACT_MEMO_TYPE || type.$$typeof === $b16d34552d284bce$var$REACT_CONTEXT_TYPE || type.$$typeof === $b16d34552d284bce$var$REACT_CONSUMER_TYPE || type.$$typeof === $b16d34552d284bce$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $b16d34552d284bce$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$b16d34552d284bce$export$f5bbd400c2f4426f = $b16d34552d284bce$var$typeOf;

});

parcelRegister("7VD5U", function(module, exports) {

var $hA3PB = parcelRequire("hA3PB");

var $j50g2 = parcelRequire("j50g2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $hA3PB.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $j50g2;
module.exports = isBuffer;

});
parcelRegister("hA3PB", function(module, exports) {

var $2OCpl = parcelRequire("2OCpl");
/** Detect free variable `self`. */ var $ccc8c54caf903f06$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ccc8c54caf903f06$var$root = $2OCpl || $ccc8c54caf903f06$var$freeSelf || Function("return this")();
module.exports = $ccc8c54caf903f06$var$root;

});
parcelRegister("2OCpl", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $20ce0b4149339ea5$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $20ce0b4149339ea5$var$freeGlobal;

});


parcelRegister("j50g2", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $0395a7fc47eb83dd$var$stubFalse() {
    return false;
}
module.exports = $0395a7fc47eb83dd$var$stubFalse;

});


parcelRegister("5xpOJ", function(module, exports) {

var $2OCpl = parcelRequire("2OCpl");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2OCpl.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("4Z9A5", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("1QaxZ"));

});
parcelRegister("1QaxZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $8cREy.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $8cREy.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $azZ5t.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $azZ5t.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $4FV2b.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $4FV2b.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $4FV2b.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $4FV2b.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $1572d43fc5bcd117$var$_symbol.symbolsStroke;
    }
});

var $1572d43fc5bcd117$var$_arc = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("9RbVb")));

var $1572d43fc5bcd117$var$_area = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("1t7ax")));

var $1572d43fc5bcd117$var$_line = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("gpray")));

var $1572d43fc5bcd117$var$_pie = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("3FYCd")));

var $1572d43fc5bcd117$var$_areaRadial = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("1pD4h")));

var $1572d43fc5bcd117$var$_lineRadial = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("di486")));

var $1572d43fc5bcd117$var$_pointRadial = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("fe4Vz")));

var $4FV2b = parcelRequire("4FV2b");

var $1572d43fc5bcd117$var$_symbol = $1572d43fc5bcd117$var$_interopRequireWildcard((parcelRequire("1RdPl")));

var $1572d43fc5bcd117$var$_asterisk = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("am1NF")));

var $1572d43fc5bcd117$var$_circle = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("4syaK")));

var $1572d43fc5bcd117$var$_cross = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("88HVa")));

var $1572d43fc5bcd117$var$_diamond = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("8SHoI")));

var $1572d43fc5bcd117$var$_diamond2 = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("5D7XV")));

var $1572d43fc5bcd117$var$_plus = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("78F3z")));

var $1572d43fc5bcd117$var$_square = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("afG7o")));

var $1572d43fc5bcd117$var$_square2 = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("8miuZ")));

var $1572d43fc5bcd117$var$_star = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("k6oxB")));

var $1572d43fc5bcd117$var$_triangle = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("iMtTT")));

var $1572d43fc5bcd117$var$_triangle2 = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("ih7wy")));

var $1572d43fc5bcd117$var$_wye = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("kpPvT")));

var $1572d43fc5bcd117$var$_x = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("gO5mD")));

var $1572d43fc5bcd117$var$_basisClosed = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("kH2Rl")));

var $1572d43fc5bcd117$var$_basisOpen = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("7vdA9")));

var $1572d43fc5bcd117$var$_basis = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("26cc0")));

var $8cREy = parcelRequire("8cREy");

var $1572d43fc5bcd117$var$_bundle = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("7eQV3")));

var $1572d43fc5bcd117$var$_cardinalClosed = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("hhExh")));

var $1572d43fc5bcd117$var$_cardinalOpen = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("2xbTZ")));

var $1572d43fc5bcd117$var$_cardinal = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("jG80P")));

var $1572d43fc5bcd117$var$_catmullRomClosed = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("jwPUi")));

var $1572d43fc5bcd117$var$_catmullRomOpen = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("cHdKa")));

var $1572d43fc5bcd117$var$_catmullRom = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("3hKXs")));

var $1572d43fc5bcd117$var$_linearClosed = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("2qq7o")));

var $1572d43fc5bcd117$var$_linear = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("3qh11")));

var $azZ5t = parcelRequire("azZ5t");

var $1572d43fc5bcd117$var$_natural = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("bHMit")));

var $1572d43fc5bcd117$var$_step = $1572d43fc5bcd117$var$_interopRequireWildcard((parcelRequire("kLtHE")));

var $1572d43fc5bcd117$var$_stack = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("KQoR7")));

var $1572d43fc5bcd117$var$_expand = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("g6kLq")));

var $1572d43fc5bcd117$var$_diverging = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("jZ8UH")));

var $1572d43fc5bcd117$var$_none = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("erDhe")));

var $1572d43fc5bcd117$var$_silhouette = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("2xe73")));

var $1572d43fc5bcd117$var$_wiggle = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("gxiCh")));

var $1572d43fc5bcd117$var$_appearance = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("eobXQ")));

var $1572d43fc5bcd117$var$_ascending = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("3eScE")));

var $1572d43fc5bcd117$var$_descending = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("eFBUP")));

var $1572d43fc5bcd117$var$_insideOut = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("5mwJu")));

var $1572d43fc5bcd117$var$_none2 = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("fLVWu")));

var $1572d43fc5bcd117$var$_reverse = $1572d43fc5bcd117$var$_interopRequireDefault((parcelRequire("5mK6I")));
function $1572d43fc5bcd117$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1572d43fc5bcd117$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1572d43fc5bcd117$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1572d43fc5bcd117$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1572d43fc5bcd117$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("9RbVb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72d24fa46b009a3c$var$_default;

var $3HCIk = parcelRequire("3HCIk");

var $72d24fa46b009a3c$var$_constant = $72d24fa46b009a3c$var$_interopRequireDefault((parcelRequire("if9W4")));

var $cLsH5 = parcelRequire("cLsH5");
function $72d24fa46b009a3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $72d24fa46b009a3c$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $72d24fa46b009a3c$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $72d24fa46b009a3c$var$arcStartAngle(d) {
    return d.startAngle;
}
function $72d24fa46b009a3c$var$arcEndAngle(d) {
    return d.endAngle;
}
function $72d24fa46b009a3c$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $72d24fa46b009a3c$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $cLsH5.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $72d24fa46b009a3c$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $cLsH5.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $cLsH5.sqrt)((0, $cLsH5.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $72d24fa46b009a3c$var$_default() {
    var innerRadius = $72d24fa46b009a3c$var$arcInnerRadius, outerRadius = $72d24fa46b009a3c$var$arcOuterRadius, cornerRadius = (0, $72d24fa46b009a3c$var$_constant.default)(0), padRadius = null, startAngle = $72d24fa46b009a3c$var$arcStartAngle, endAngle = $72d24fa46b009a3c$var$arcEndAngle, padAngle = $72d24fa46b009a3c$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $cLsH5.halfPi, a1 = endAngle.apply(this, arguments) - $cLsH5.halfPi, da = (0, $cLsH5.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $3HCIk.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $cLsH5.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $cLsH5.tau - $cLsH5.epsilon) {
            context.moveTo(r1 * (0, $cLsH5.cos)(a0), r1 * (0, $cLsH5.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $cLsH5.epsilon) {
                context.moveTo(r0 * (0, $cLsH5.cos)(a1), r0 * (0, $cLsH5.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $cLsH5.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $cLsH5.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $cLsH5.min)((0, $cLsH5.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $cLsH5.epsilon) {
                var p0 = (0, $cLsH5.asin)(rp / r0 * (0, $cLsH5.sin)(ap)), p1 = (0, $cLsH5.asin)(rp / r1 * (0, $cLsH5.sin)(ap));
                if ((da0 -= p0 * 2) > $cLsH5.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $cLsH5.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $cLsH5.cos)(a01), y01 = r1 * (0, $cLsH5.sin)(a01), x10 = r0 * (0, $cLsH5.cos)(a10), y10 = r0 * (0, $cLsH5.sin)(a10); // Apply rounded corners?
            if (rc > $cLsH5.epsilon) {
                var x11 = r1 * (0, $cLsH5.cos)(a11), y11 = r1 * (0, $cLsH5.sin)(a11), x00 = r0 * (0, $cLsH5.cos)(a00), y00 = r0 * (0, $cLsH5.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $cLsH5.pi && (oc = $72d24fa46b009a3c$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $cLsH5.sin)((0, $cLsH5.acos)((ax * bx + ay * by) / ((0, $cLsH5.sqrt)(ax * ax + ay * ay) * (0, $cLsH5.sqrt)(bx * bx + by * by))) / 2), lc = (0, $cLsH5.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $cLsH5.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $cLsH5.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $cLsH5.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $cLsH5.epsilon) {
                t0 = $72d24fa46b009a3c$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $72d24fa46b009a3c$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $cLsH5.atan2)(t0.y01, t0.x01), (0, $cLsH5.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $cLsH5.atan2)(t0.y01, t0.x01), (0, $cLsH5.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $cLsH5.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $cLsH5.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $cLsH5.atan2)(t1.y11, t1.x11), (0, $cLsH5.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $cLsH5.epsilon) || !(da0 > $cLsH5.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $cLsH5.epsilon) {
                t0 = $72d24fa46b009a3c$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $72d24fa46b009a3c$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $cLsH5.atan2)(t0.y01, t0.x01), (0, $cLsH5.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $cLsH5.atan2)(t0.y01, t0.x01), (0, $cLsH5.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $cLsH5.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $cLsH5.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $cLsH5.atan2)(t1.y11, t1.x11), (0, $cLsH5.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $cLsH5.pi / 2;
        return [
            (0, $cLsH5.cos)(a) * r,
            (0, $cLsH5.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $72d24fa46b009a3c$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $72d24fa46b009a3c$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $72d24fa46b009a3c$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $72d24fa46b009a3c$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $72d24fa46b009a3c$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $72d24fa46b009a3c$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $72d24fa46b009a3c$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("3HCIk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $2b236b0da9da6812$var$_path.default;
    }
});

var $2b236b0da9da6812$var$_path = $2b236b0da9da6812$var$_interopRequireDefault((parcelRequire("l4oYF")));
function $2b236b0da9da6812$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("l4oYF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f56d58b05298b955$var$pi = Math.PI, $f56d58b05298b955$var$tau = 2 * $f56d58b05298b955$var$pi, $f56d58b05298b955$var$epsilon = 1e-6, $f56d58b05298b955$var$tauEpsilon = $f56d58b05298b955$var$tau - $f56d58b05298b955$var$epsilon;
function $f56d58b05298b955$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $f56d58b05298b955$var$path() {
    return new $f56d58b05298b955$var$Path();
}
$f56d58b05298b955$var$Path.prototype = $f56d58b05298b955$var$path.prototype = {
    constructor: $f56d58b05298b955$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $f56d58b05298b955$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $f56d58b05298b955$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($f56d58b05298b955$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $f56d58b05298b955$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $f56d58b05298b955$var$epsilon || Math.abs(this._y1 - y0) > $f56d58b05298b955$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $f56d58b05298b955$var$tau + $f56d58b05298b955$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $f56d58b05298b955$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $f56d58b05298b955$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $f56d58b05298b955$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $f56d58b05298b955$var$_default = $f56d58b05298b955$var$path;
module.exports.default = $f56d58b05298b955$var$_default;

});


parcelRegister("if9W4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d48155b632d2684e$var$_default;
function $d48155b632d2684e$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("cLsH5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $94b021d687e56ebb$var$acos;
module.exports.asin = $94b021d687e56ebb$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $94b021d687e56ebb$var$abs = Math.abs;
module.exports.abs = $94b021d687e56ebb$var$abs;
const $94b021d687e56ebb$var$atan2 = Math.atan2;
module.exports.atan2 = $94b021d687e56ebb$var$atan2;
const $94b021d687e56ebb$var$cos = Math.cos;
module.exports.cos = $94b021d687e56ebb$var$cos;
const $94b021d687e56ebb$var$max = Math.max;
module.exports.max = $94b021d687e56ebb$var$max;
const $94b021d687e56ebb$var$min = Math.min;
module.exports.min = $94b021d687e56ebb$var$min;
const $94b021d687e56ebb$var$sin = Math.sin;
module.exports.sin = $94b021d687e56ebb$var$sin;
const $94b021d687e56ebb$var$sqrt = Math.sqrt;
module.exports.sqrt = $94b021d687e56ebb$var$sqrt;
const $94b021d687e56ebb$var$epsilon = 1e-12;
module.exports.epsilon = $94b021d687e56ebb$var$epsilon;
const $94b021d687e56ebb$var$pi = Math.PI;
module.exports.pi = $94b021d687e56ebb$var$pi;
const $94b021d687e56ebb$var$halfPi = $94b021d687e56ebb$var$pi / 2;
module.exports.halfPi = $94b021d687e56ebb$var$halfPi;
const $94b021d687e56ebb$var$tau = 2 * $94b021d687e56ebb$var$pi;
module.exports.tau = $94b021d687e56ebb$var$tau;
function $94b021d687e56ebb$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $94b021d687e56ebb$var$pi : Math.acos(x);
}
function $94b021d687e56ebb$var$asin(x) {
    return x >= 1 ? $94b021d687e56ebb$var$halfPi : x <= -1 ? -$94b021d687e56ebb$var$halfPi : Math.asin(x);
}

});


parcelRegister("1t7ax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $111e0f77525d107d$var$_default;

var $3HCIk = parcelRequire("3HCIk");

var $111e0f77525d107d$var$_array = $111e0f77525d107d$var$_interopRequireDefault((parcelRequire("942n5")));

var $111e0f77525d107d$var$_constant = $111e0f77525d107d$var$_interopRequireDefault((parcelRequire("if9W4")));

var $111e0f77525d107d$var$_linear = $111e0f77525d107d$var$_interopRequireDefault((parcelRequire("3qh11")));

var $111e0f77525d107d$var$_line = $111e0f77525d107d$var$_interopRequireDefault((parcelRequire("gpray")));

var $2TNKY = parcelRequire("2TNKY");
function $111e0f77525d107d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $111e0f77525d107d$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $111e0f77525d107d$var$_constant.default)(true), context = null, curve = $111e0f77525d107d$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $2TNKY.x : (0, $111e0f77525d107d$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $111e0f77525d107d$var$_constant.default)(0) : (0, $111e0f77525d107d$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $2TNKY.y : (0, $111e0f77525d107d$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $111e0f77525d107d$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $3HCIk.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $111e0f77525d107d$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $111e0f77525d107d$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $111e0f77525d107d$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $111e0f77525d107d$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $111e0f77525d107d$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $111e0f77525d107d$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $111e0f77525d107d$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $111e0f77525d107d$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("942n5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $699653b2fe63c15b$var$_default;
module.exports.slice = void 0;
var $699653b2fe63c15b$var$slice = Array.prototype.slice;
module.exports.slice = $699653b2fe63c15b$var$slice;
function $699653b2fe63c15b$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("3qh11", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $27e0ffb87e9ab1a9$var$_default;
function $27e0ffb87e9ab1a9$var$Linear(context) {
    this._context = context;
}
$27e0ffb87e9ab1a9$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $27e0ffb87e9ab1a9$var$_default(context) {
    return new $27e0ffb87e9ab1a9$var$Linear(context);
}

});

parcelRegister("gpray", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf240e630f6c21cb$var$_default;

var $3HCIk = parcelRequire("3HCIk");

var $bf240e630f6c21cb$var$_array = $bf240e630f6c21cb$var$_interopRequireDefault((parcelRequire("942n5")));

var $bf240e630f6c21cb$var$_constant = $bf240e630f6c21cb$var$_interopRequireDefault((parcelRequire("if9W4")));

var $bf240e630f6c21cb$var$_linear = $bf240e630f6c21cb$var$_interopRequireDefault((parcelRequire("3qh11")));

var $2TNKY = parcelRequire("2TNKY");
function $bf240e630f6c21cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bf240e630f6c21cb$var$_default(x, y) {
    var defined = (0, $bf240e630f6c21cb$var$_constant.default)(true), context = null, curve = $bf240e630f6c21cb$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $2TNKY.x : (0, $bf240e630f6c21cb$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $2TNKY.y : (0, $bf240e630f6c21cb$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $bf240e630f6c21cb$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $3HCIk.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $bf240e630f6c21cb$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $bf240e630f6c21cb$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $bf240e630f6c21cb$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("2TNKY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $21c750730449d1e6$var$x;
module.exports.y = $21c750730449d1e6$var$y;
function $21c750730449d1e6$var$x(p) {
    return p[0];
}
function $21c750730449d1e6$var$y(p) {
    return p[1];
}

});



parcelRegister("3FYCd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ad43863d52ba68a$var$_default;

var $2ad43863d52ba68a$var$_array = $2ad43863d52ba68a$var$_interopRequireDefault((parcelRequire("942n5")));

var $2ad43863d52ba68a$var$_constant = $2ad43863d52ba68a$var$_interopRequireDefault((parcelRequire("if9W4")));

var $2ad43863d52ba68a$var$_descending = $2ad43863d52ba68a$var$_interopRequireDefault((parcelRequire("eZaL1")));

var $2ad43863d52ba68a$var$_identity = $2ad43863d52ba68a$var$_interopRequireDefault((parcelRequire("k8kPj")));

var $cLsH5 = parcelRequire("cLsH5");
function $2ad43863d52ba68a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2ad43863d52ba68a$var$_default() {
    var value = $2ad43863d52ba68a$var$_identity.default, sortValues = $2ad43863d52ba68a$var$_descending.default, sort = null, startAngle = (0, $2ad43863d52ba68a$var$_constant.default)(0), endAngle = (0, $2ad43863d52ba68a$var$_constant.default)($cLsH5.tau), padAngle = (0, $2ad43863d52ba68a$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $2ad43863d52ba68a$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($cLsH5.tau, Math.max(-$cLsH5.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $2ad43863d52ba68a$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $2ad43863d52ba68a$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $2ad43863d52ba68a$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $2ad43863d52ba68a$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("eZaL1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae8f1b5f822350a8$var$_default;
function $ae8f1b5f822350a8$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("k8kPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea84b5c1f78c7fa7$var$_default;
function $ea84b5c1f78c7fa7$var$_default(d) {
    return d;
}

});


parcelRegister("1pD4h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $10766e5511876082$var$_default;

var $10766e5511876082$var$_radial = $10766e5511876082$var$_interopRequireWildcard((parcelRequire("bwh9z")));

var $10766e5511876082$var$_area = $10766e5511876082$var$_interopRequireDefault((parcelRequire("1t7ax")));

var $di486 = parcelRequire("di486");
function $10766e5511876082$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $10766e5511876082$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($10766e5511876082$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $10766e5511876082$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $10766e5511876082$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $10766e5511876082$var$_default() {
    var a = (0, $10766e5511876082$var$_area.default)().curve($10766e5511876082$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $di486.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $di486.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $di486.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $di486.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $10766e5511876082$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("bwh9z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $862ffd2cd2cc35f8$var$curveRadial;

var $862ffd2cd2cc35f8$var$_linear = $862ffd2cd2cc35f8$var$_interopRequireDefault((parcelRequire("3qh11")));
function $862ffd2cd2cc35f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $862ffd2cd2cc35f8$var$curveRadialLinear = $862ffd2cd2cc35f8$var$curveRadial($862ffd2cd2cc35f8$var$_linear.default);
module.exports.curveRadialLinear = $862ffd2cd2cc35f8$var$curveRadialLinear;
function $862ffd2cd2cc35f8$var$Radial(curve) {
    this._curve = curve;
}
$862ffd2cd2cc35f8$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $862ffd2cd2cc35f8$var$curveRadial(curve) {
    function radial(context) {
        return new $862ffd2cd2cc35f8$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("di486", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ad028e5b9c0f0cb$var$_default;
module.exports.lineRadial = $9ad028e5b9c0f0cb$var$lineRadial;

var $9ad028e5b9c0f0cb$var$_radial = $9ad028e5b9c0f0cb$var$_interopRequireWildcard((parcelRequire("bwh9z")));

var $9ad028e5b9c0f0cb$var$_line = $9ad028e5b9c0f0cb$var$_interopRequireDefault((parcelRequire("gpray")));
function $9ad028e5b9c0f0cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ad028e5b9c0f0cb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9ad028e5b9c0f0cb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9ad028e5b9c0f0cb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9ad028e5b9c0f0cb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9ad028e5b9c0f0cb$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $9ad028e5b9c0f0cb$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $9ad028e5b9c0f0cb$var$_default() {
    return $9ad028e5b9c0f0cb$var$lineRadial((0, $9ad028e5b9c0f0cb$var$_line.default)().curve($9ad028e5b9c0f0cb$var$_radial.curveRadialLinear));
}

});


parcelRegister("fe4Vz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b15bfc5518e272a3$var$_default;
function $b15bfc5518e272a3$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("4FV2b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $36773b8ea94ba455$var$link;
module.exports.linkHorizontal = $36773b8ea94ba455$var$linkHorizontal;
module.exports.linkRadial = $36773b8ea94ba455$var$linkRadial;
module.exports.linkVertical = $36773b8ea94ba455$var$linkVertical;

var $3HCIk = parcelRequire("3HCIk");

var $942n5 = parcelRequire("942n5");

var $36773b8ea94ba455$var$_constant = $36773b8ea94ba455$var$_interopRequireDefault((parcelRequire("if9W4")));

var $8cREy = parcelRequire("8cREy");

var $2TNKY = parcelRequire("2TNKY");
function $36773b8ea94ba455$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36773b8ea94ba455$var$linkSource(d) {
    return d.source;
}
function $36773b8ea94ba455$var$linkTarget(d) {
    return d.target;
}
function $36773b8ea94ba455$var$link(curve) {
    let source = $36773b8ea94ba455$var$linkSource;
    let target = $36773b8ea94ba455$var$linkTarget;
    let x = $2TNKY.x;
    let y = $2TNKY.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $942n5.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $3HCIk.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $36773b8ea94ba455$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $36773b8ea94ba455$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $36773b8ea94ba455$var$linkHorizontal() {
    return $36773b8ea94ba455$var$link($8cREy.bumpX);
}
function $36773b8ea94ba455$var$linkVertical() {
    return $36773b8ea94ba455$var$link($8cREy.bumpY);
}
function $36773b8ea94ba455$var$linkRadial() {
    const l = $36773b8ea94ba455$var$link($8cREy.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("8cREy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $5f9910165d537362$var$bumpRadial;
module.exports.bumpX = $5f9910165d537362$var$bumpX;
module.exports.bumpY = $5f9910165d537362$var$bumpY;

var $5f9910165d537362$var$_pointRadial = $5f9910165d537362$var$_interopRequireDefault((parcelRequire("fe4Vz")));
function $5f9910165d537362$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $5f9910165d537362$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $5f9910165d537362$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $5f9910165d537362$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $5f9910165d537362$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $5f9910165d537362$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $5f9910165d537362$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $5f9910165d537362$var$bumpX(context) {
    return new $5f9910165d537362$var$Bump(context, true);
}
function $5f9910165d537362$var$bumpY(context) {
    return new $5f9910165d537362$var$Bump(context, false);
}
function $5f9910165d537362$var$bumpRadial(context) {
    return new $5f9910165d537362$var$BumpRadial(context);
}

});


parcelRegister("1RdPl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15a577777d1e27c2$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $3HCIk = parcelRequire("3HCIk");

var $15a577777d1e27c2$var$_constant = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("if9W4")));

var $15a577777d1e27c2$var$_asterisk = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("am1NF")));

var $15a577777d1e27c2$var$_circle = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("4syaK")));

var $15a577777d1e27c2$var$_cross = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("88HVa")));

var $15a577777d1e27c2$var$_diamond = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("8SHoI")));

var $15a577777d1e27c2$var$_diamond2 = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("5D7XV")));

var $15a577777d1e27c2$var$_plus = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("78F3z")));

var $15a577777d1e27c2$var$_square = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("afG7o")));

var $15a577777d1e27c2$var$_square2 = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("8miuZ")));

var $15a577777d1e27c2$var$_star = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("k6oxB")));

var $15a577777d1e27c2$var$_triangle = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("iMtTT")));

var $15a577777d1e27c2$var$_triangle2 = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("ih7wy")));

var $15a577777d1e27c2$var$_wye = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("kpPvT")));

var $15a577777d1e27c2$var$_x = $15a577777d1e27c2$var$_interopRequireDefault((parcelRequire("gO5mD")));
function $15a577777d1e27c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $15a577777d1e27c2$var$symbolsFill = [
    $15a577777d1e27c2$var$_circle.default,
    $15a577777d1e27c2$var$_cross.default,
    $15a577777d1e27c2$var$_diamond.default,
    $15a577777d1e27c2$var$_square.default,
    $15a577777d1e27c2$var$_star.default,
    $15a577777d1e27c2$var$_triangle.default,
    $15a577777d1e27c2$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $15a577777d1e27c2$var$symbolsFill;
const $15a577777d1e27c2$var$symbolsStroke = [
    $15a577777d1e27c2$var$_circle.default,
    $15a577777d1e27c2$var$_plus.default,
    $15a577777d1e27c2$var$_x.default,
    $15a577777d1e27c2$var$_triangle2.default,
    $15a577777d1e27c2$var$_asterisk.default,
    $15a577777d1e27c2$var$_square2.default,
    $15a577777d1e27c2$var$_diamond2.default
];
module.exports.symbolsStroke = $15a577777d1e27c2$var$symbolsStroke;
function $15a577777d1e27c2$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $15a577777d1e27c2$var$_constant.default)(type || $15a577777d1e27c2$var$_circle.default);
    size = typeof size === "function" ? size : (0, $15a577777d1e27c2$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $3HCIk.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $15a577777d1e27c2$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $15a577777d1e27c2$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("am1NF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
const $789d5aedb7df918a$var$sqrt3 = (0, $cLsH5.sqrt)(3);
var $789d5aedb7df918a$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size + (0, $cLsH5.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $789d5aedb7df918a$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $789d5aedb7df918a$var$_default;

});

parcelRegister("4syaK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
var $33f448dcd33a3053$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size / $cLsH5.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $cLsH5.tau);
    }
};
module.exports.default = $33f448dcd33a3053$var$_default;

});

parcelRegister("88HVa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
var $5ed123e74fca6777$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $5ed123e74fca6777$var$_default;

});

parcelRegister("8SHoI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
const $677507b8d2a130e7$var$tan30 = (0, $cLsH5.sqrt)(1 / 3);
const $677507b8d2a130e7$var$tan30_2 = $677507b8d2a130e7$var$tan30 * 2;
var $677507b8d2a130e7$var$_default = {
    draw (context, size) {
        const y = (0, $cLsH5.sqrt)(size / $677507b8d2a130e7$var$tan30_2);
        const x = y * $677507b8d2a130e7$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $677507b8d2a130e7$var$_default;

});

parcelRegister("5D7XV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
var $4196c61122478a1c$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $4196c61122478a1c$var$_default;

});

parcelRegister("78F3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
var $532920c083585069$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size - (0, $cLsH5.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $532920c083585069$var$_default;

});

parcelRegister("afG7o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
var $776bf9eabf23b461$var$_default = {
    draw (context, size) {
        const w = (0, $cLsH5.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $776bf9eabf23b461$var$_default;

});

parcelRegister("8miuZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
var $615eba4b2b498a2b$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $615eba4b2b498a2b$var$_default;

});

parcelRegister("k6oxB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
const $ea27677e63090045$var$ka = 0.89081309152928522810;
const $ea27677e63090045$var$kr = (0, $cLsH5.sin)($cLsH5.pi / 10) / (0, $cLsH5.sin)(7 * $cLsH5.pi / 10);
const $ea27677e63090045$var$kx = (0, $cLsH5.sin)($cLsH5.tau / 10) * $ea27677e63090045$var$kr;
const $ea27677e63090045$var$ky = -(0, $cLsH5.cos)($cLsH5.tau / 10) * $ea27677e63090045$var$kr;
var $ea27677e63090045$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size * $ea27677e63090045$var$ka);
        const x = $ea27677e63090045$var$kx * r;
        const y = $ea27677e63090045$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $cLsH5.tau * i / 5;
            const c = (0, $cLsH5.cos)(a);
            const s = (0, $cLsH5.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $ea27677e63090045$var$_default;

});

parcelRegister("iMtTT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
const $dac3e74de1482fec$var$sqrt3 = (0, $cLsH5.sqrt)(3);
var $dac3e74de1482fec$var$_default = {
    draw (context, size) {
        const y = -(0, $cLsH5.sqrt)(size / ($dac3e74de1482fec$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$dac3e74de1482fec$var$sqrt3 * y, -y);
        context.lineTo($dac3e74de1482fec$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $dac3e74de1482fec$var$_default;

});

parcelRegister("ih7wy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
const $d4dfa6a819841d3f$var$sqrt3 = (0, $cLsH5.sqrt)(3);
var $d4dfa6a819841d3f$var$_default = {
    draw (context, size) {
        const s = (0, $cLsH5.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $d4dfa6a819841d3f$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $d4dfa6a819841d3f$var$_default;

});

parcelRegister("kpPvT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
const $edce19f13d202520$var$c = -0.5;
const $edce19f13d202520$var$s = (0, $cLsH5.sqrt)(3) / 2;
const $edce19f13d202520$var$k = 1 / (0, $cLsH5.sqrt)(12);
const $edce19f13d202520$var$a = ($edce19f13d202520$var$k / 2 + 1) * 3;
var $edce19f13d202520$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size / $edce19f13d202520$var$a);
        const x0 = r / 2, y0 = r * $edce19f13d202520$var$k;
        const x1 = x0, y1 = r * $edce19f13d202520$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($edce19f13d202520$var$c * x0 - $edce19f13d202520$var$s * y0, $edce19f13d202520$var$s * x0 + $edce19f13d202520$var$c * y0);
        context.lineTo($edce19f13d202520$var$c * x1 - $edce19f13d202520$var$s * y1, $edce19f13d202520$var$s * x1 + $edce19f13d202520$var$c * y1);
        context.lineTo($edce19f13d202520$var$c * x2 - $edce19f13d202520$var$s * y2, $edce19f13d202520$var$s * x2 + $edce19f13d202520$var$c * y2);
        context.lineTo($edce19f13d202520$var$c * x0 + $edce19f13d202520$var$s * y0, $edce19f13d202520$var$c * y0 - $edce19f13d202520$var$s * x0);
        context.lineTo($edce19f13d202520$var$c * x1 + $edce19f13d202520$var$s * y1, $edce19f13d202520$var$c * y1 - $edce19f13d202520$var$s * x1);
        context.lineTo($edce19f13d202520$var$c * x2 + $edce19f13d202520$var$s * y2, $edce19f13d202520$var$c * y2 - $edce19f13d202520$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $edce19f13d202520$var$_default;

});

parcelRegister("gO5mD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cLsH5 = parcelRequire("cLsH5");
var $c3c57a09e1b08df0$var$_default = {
    draw (context, size) {
        const r = (0, $cLsH5.sqrt)(size - (0, $cLsH5.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $c3c57a09e1b08df0$var$_default;

});


parcelRegister("kH2Rl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f10a0a9df94630f6$var$_default;

var $f10a0a9df94630f6$var$_noop = $f10a0a9df94630f6$var$_interopRequireDefault((parcelRequire("hHPsX")));

var $26cc0 = parcelRequire("26cc0");
function $f10a0a9df94630f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f10a0a9df94630f6$var$BasisClosed(context) {
    this._context = context;
}
$f10a0a9df94630f6$var$BasisClosed.prototype = {
    areaStart: $f10a0a9df94630f6$var$_noop.default,
    areaEnd: $f10a0a9df94630f6$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $26cc0.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $f10a0a9df94630f6$var$_default(context) {
    return new $f10a0a9df94630f6$var$BasisClosed(context);
}

});
parcelRegister("hHPsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce3e5fe6e508d00c$var$_default;
function $ce3e5fe6e508d00c$var$_default() {}

});

parcelRegister("26cc0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $1875998882e657eb$var$Basis;
module.exports.default = $1875998882e657eb$var$_default;
module.exports.point = $1875998882e657eb$var$point;
function $1875998882e657eb$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $1875998882e657eb$var$Basis(context) {
    this._context = context;
}
$1875998882e657eb$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $1875998882e657eb$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $1875998882e657eb$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $1875998882e657eb$var$_default(context) {
    return new $1875998882e657eb$var$Basis(context);
}

});


parcelRegister("7vdA9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5765f6c447e5bc8c$var$_default;

var $26cc0 = parcelRequire("26cc0");
function $5765f6c447e5bc8c$var$BasisOpen(context) {
    this._context = context;
}
$5765f6c447e5bc8c$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $26cc0.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $5765f6c447e5bc8c$var$_default(context) {
    return new $5765f6c447e5bc8c$var$BasisOpen(context);
}

});

parcelRegister("7eQV3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26cc0 = parcelRequire("26cc0");
function $5452e3d8b1cd6c18$var$Bundle(context, beta) {
    this._basis = new $26cc0.Basis(context);
    this._beta = beta;
}
$5452e3d8b1cd6c18$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $5452e3d8b1cd6c18$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $26cc0.Basis(context) : new $5452e3d8b1cd6c18$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $5452e3d8b1cd6c18$var$_default;

});

parcelRegister("hhExh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $c95377c590eb4b21$var$CardinalClosed;
module.exports.default = void 0;

var $c95377c590eb4b21$var$_noop = $c95377c590eb4b21$var$_interopRequireDefault((parcelRequire("hHPsX")));

var $jG80P = parcelRequire("jG80P");
function $c95377c590eb4b21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c95377c590eb4b21$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c95377c590eb4b21$var$CardinalClosed.prototype = {
    areaStart: $c95377c590eb4b21$var$_noop.default,
    areaEnd: $c95377c590eb4b21$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $jG80P.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c95377c590eb4b21$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $c95377c590eb4b21$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $c95377c590eb4b21$var$_default;

});
parcelRegister("jG80P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $e53827a2f80e3b07$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $e53827a2f80e3b07$var$point;
function $e53827a2f80e3b07$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $e53827a2f80e3b07$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e53827a2f80e3b07$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $e53827a2f80e3b07$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $e53827a2f80e3b07$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e53827a2f80e3b07$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e53827a2f80e3b07$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e53827a2f80e3b07$var$_default;

});


parcelRegister("2xbTZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $1d87e559d6b5d378$var$CardinalOpen;
module.exports.default = void 0;

var $jG80P = parcelRequire("jG80P");
function $1d87e559d6b5d378$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$1d87e559d6b5d378$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $jG80P.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $1d87e559d6b5d378$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $1d87e559d6b5d378$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $1d87e559d6b5d378$var$_default;

});

parcelRegister("jwPUi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hhExh = parcelRequire("hhExh");

var $e37945266fa7ad23$var$_noop = $e37945266fa7ad23$var$_interopRequireDefault((parcelRequire("hHPsX")));

var $3hKXs = parcelRequire("3hKXs");
function $e37945266fa7ad23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e37945266fa7ad23$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$e37945266fa7ad23$var$CatmullRomClosed.prototype = {
    areaStart: $e37945266fa7ad23$var$_noop.default,
    areaEnd: $e37945266fa7ad23$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $3hKXs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e37945266fa7ad23$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $e37945266fa7ad23$var$CatmullRomClosed(context, alpha) : new $hhExh.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $e37945266fa7ad23$var$_default;

});
parcelRegister("3hKXs", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $cLsH5 = parcelRequire("cLsH5");

var $jG80P = parcelRequire("jG80P");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $cLsH5.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $cLsH5.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $jG80P.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("cHdKa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2xbTZ = parcelRequire("2xbTZ");

var $3hKXs = parcelRequire("3hKXs");
function $93e42965f3e7e8c2$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$93e42965f3e7e8c2$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $3hKXs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $93e42965f3e7e8c2$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $93e42965f3e7e8c2$var$CatmullRomOpen(context, alpha) : new $2xbTZ.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $93e42965f3e7e8c2$var$_default;

});

parcelRegister("2qq7o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c424500cb15d791$var$_default;

var $1c424500cb15d791$var$_noop = $1c424500cb15d791$var$_interopRequireDefault((parcelRequire("hHPsX")));
function $1c424500cb15d791$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c424500cb15d791$var$LinearClosed(context) {
    this._context = context;
}
$1c424500cb15d791$var$LinearClosed.prototype = {
    areaStart: $1c424500cb15d791$var$_noop.default,
    areaEnd: $1c424500cb15d791$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $1c424500cb15d791$var$_default(context) {
    return new $1c424500cb15d791$var$LinearClosed(context);
}

});

parcelRegister("azZ5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $7b3c8eefb75878c6$var$monotoneX;
module.exports.monotoneY = $7b3c8eefb75878c6$var$monotoneY;
function $7b3c8eefb75878c6$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $7b3c8eefb75878c6$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($7b3c8eefb75878c6$var$sign(s0) + $7b3c8eefb75878c6$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $7b3c8eefb75878c6$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $7b3c8eefb75878c6$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $7b3c8eefb75878c6$var$MonotoneX(context) {
    this._context = context;
}
$7b3c8eefb75878c6$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $7b3c8eefb75878c6$var$point(this, this._t0, $7b3c8eefb75878c6$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $7b3c8eefb75878c6$var$point(this, $7b3c8eefb75878c6$var$slope2(this, t1 = $7b3c8eefb75878c6$var$slope3(this, x, y)), t1);
                break;
            default:
                $7b3c8eefb75878c6$var$point(this, this._t0, t1 = $7b3c8eefb75878c6$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $7b3c8eefb75878c6$var$MonotoneY(context) {
    this._context = new $7b3c8eefb75878c6$var$ReflectContext(context);
}
($7b3c8eefb75878c6$var$MonotoneY.prototype = Object.create($7b3c8eefb75878c6$var$MonotoneX.prototype)).point = function(x, y) {
    $7b3c8eefb75878c6$var$MonotoneX.prototype.point.call(this, y, x);
};
function $7b3c8eefb75878c6$var$ReflectContext(context) {
    this._context = context;
}
$7b3c8eefb75878c6$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $7b3c8eefb75878c6$var$monotoneX(context) {
    return new $7b3c8eefb75878c6$var$MonotoneX(context);
}
function $7b3c8eefb75878c6$var$monotoneY(context) {
    return new $7b3c8eefb75878c6$var$MonotoneY(context);
}

});

parcelRegister("bHMit", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88592ca4db9364b5$var$_default;
function $88592ca4db9364b5$var$Natural(context) {
    this._context = context;
}
$88592ca4db9364b5$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $88592ca4db9364b5$var$controlPoints(x), py = $88592ca4db9364b5$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $88592ca4db9364b5$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $88592ca4db9364b5$var$_default(context) {
    return new $88592ca4db9364b5$var$Natural(context);
}

});

parcelRegister("kLtHE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1df3cdad81a7e7b$var$_default;
module.exports.stepAfter = $f1df3cdad81a7e7b$var$stepAfter;
module.exports.stepBefore = $f1df3cdad81a7e7b$var$stepBefore;
function $f1df3cdad81a7e7b$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$f1df3cdad81a7e7b$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $f1df3cdad81a7e7b$var$_default(context) {
    return new $f1df3cdad81a7e7b$var$Step(context, 0.5);
}
function $f1df3cdad81a7e7b$var$stepBefore(context) {
    return new $f1df3cdad81a7e7b$var$Step(context, 0);
}
function $f1df3cdad81a7e7b$var$stepAfter(context) {
    return new $f1df3cdad81a7e7b$var$Step(context, 1);
}

});

parcelRegister("KQoR7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $08ccf1856ff16481$var$_default;

var $08ccf1856ff16481$var$_array = $08ccf1856ff16481$var$_interopRequireDefault((parcelRequire("942n5")));

var $08ccf1856ff16481$var$_constant = $08ccf1856ff16481$var$_interopRequireDefault((parcelRequire("if9W4")));

var $08ccf1856ff16481$var$_none = $08ccf1856ff16481$var$_interopRequireDefault((parcelRequire("erDhe")));

var $08ccf1856ff16481$var$_none2 = $08ccf1856ff16481$var$_interopRequireDefault((parcelRequire("fLVWu")));
function $08ccf1856ff16481$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $08ccf1856ff16481$var$stackValue(d, key) {
    return d[key];
}
function $08ccf1856ff16481$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $08ccf1856ff16481$var$_default() {
    var keys = (0, $08ccf1856ff16481$var$_constant.default)([]), order = $08ccf1856ff16481$var$_none2.default, offset = $08ccf1856ff16481$var$_none.default, value = $08ccf1856ff16481$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $08ccf1856ff16481$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $08ccf1856ff16481$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $08ccf1856ff16481$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $08ccf1856ff16481$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $08ccf1856ff16481$var$_none2.default : typeof _ === "function" ? _ : (0, $08ccf1856ff16481$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $08ccf1856ff16481$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("erDhe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8420de07c6b2fed$var$_default;
function $a8420de07c6b2fed$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("fLVWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7b830f2348589fb$var$_default;
function $b7b830f2348589fb$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("g6kLq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb8d5025ec72708e$var$_default;

var $bb8d5025ec72708e$var$_none = $bb8d5025ec72708e$var$_interopRequireDefault((parcelRequire("erDhe")));
function $bb8d5025ec72708e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bb8d5025ec72708e$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $bb8d5025ec72708e$var$_none.default)(series, order);
}

});

parcelRegister("jZ8UH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8caa0e0e579762d$var$_default;
function $e8caa0e0e579762d$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("2xe73", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d899c573f4b8c57$var$_default;

var $1d899c573f4b8c57$var$_none = $1d899c573f4b8c57$var$_interopRequireDefault((parcelRequire("erDhe")));
function $1d899c573f4b8c57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d899c573f4b8c57$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $1d899c573f4b8c57$var$_none.default)(series, order);
}

});

parcelRegister("gxiCh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c09e2b447e5360e0$var$_default;

var $c09e2b447e5360e0$var$_none = $c09e2b447e5360e0$var$_interopRequireDefault((parcelRequire("erDhe")));
function $c09e2b447e5360e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c09e2b447e5360e0$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $c09e2b447e5360e0$var$_none.default)(series, order);
}

});

parcelRegister("eobXQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a79c966dbe07b3d8$var$_default;

var $a79c966dbe07b3d8$var$_none = $a79c966dbe07b3d8$var$_interopRequireDefault((parcelRequire("fLVWu")));
function $a79c966dbe07b3d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a79c966dbe07b3d8$var$_default(series) {
    var peaks = series.map($a79c966dbe07b3d8$var$peak);
    return (0, $a79c966dbe07b3d8$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $a79c966dbe07b3d8$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("3eScE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25bcb984fadeb6a1$var$_default;
module.exports.sum = $25bcb984fadeb6a1$var$sum;

var $25bcb984fadeb6a1$var$_none = $25bcb984fadeb6a1$var$_interopRequireDefault((parcelRequire("fLVWu")));
function $25bcb984fadeb6a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25bcb984fadeb6a1$var$_default(series) {
    var sums = series.map($25bcb984fadeb6a1$var$sum);
    return (0, $25bcb984fadeb6a1$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $25bcb984fadeb6a1$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("eFBUP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aae24e45b0bcfbf3$var$_default;

var $aae24e45b0bcfbf3$var$_ascending = $aae24e45b0bcfbf3$var$_interopRequireDefault((parcelRequire("3eScE")));
function $aae24e45b0bcfbf3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aae24e45b0bcfbf3$var$_default(series) {
    return (0, $aae24e45b0bcfbf3$var$_ascending.default)(series).reverse();
}

});

parcelRegister("5mwJu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e7865d6cd018ba8$var$_default;

var $3e7865d6cd018ba8$var$_appearance = $3e7865d6cd018ba8$var$_interopRequireDefault((parcelRequire("eobXQ")));

var $3eScE = parcelRequire("3eScE");
function $3e7865d6cd018ba8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e7865d6cd018ba8$var$_default(series) {
    var n = series.length, i, j, sums = series.map($3eScE.sum), order = (0, $3e7865d6cd018ba8$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("5mK6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e82c5c27907dfed$var$_default;

var $3e82c5c27907dfed$var$_none = $3e82c5c27907dfed$var$_interopRequireDefault((parcelRequire("fLVWu")));
function $3e82c5c27907dfed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e82c5c27907dfed$var$_default(series) {
    return (0, $3e82c5c27907dfed$var$_none.default)(series).reverse();
}

});



parcelRegister("1Ixht", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $1403b764ad8a718c$export$a7c73072b1a182ae; }, function (v) { return $1403b764ad8a718c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $1403b764ad8a718c$export$9f27bc3417b4524d; }, function (v) { return $1403b764ad8a718c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $1403b764ad8a718c$export$db77ccec0bb4ccac; }, function (v) { return $1403b764ad8a718c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $1403b764ad8a718c$export$8392c0c9d3dcbd35; }, function (v) { return $1403b764ad8a718c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1403b764ad8a718c$export$ffb0004e005737fa; }, function (v) { return $1403b764ad8a718c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $1403b764ad8a718c$export$b624eff549462981; }, function (v) { return $1403b764ad8a718c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $1403b764ad8a718c$export$7897aa7841a5380c; }, function (v) { return $1403b764ad8a718c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $1403b764ad8a718c$export$602eac185826482c; }, function (v) { return $1403b764ad8a718c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $1403b764ad8a718c$export$e2c29f18771995cb; }, function (v) { return $1403b764ad8a718c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1403b764ad8a718c$export$5f8d39834fd61797; }, function (v) { return $1403b764ad8a718c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1403b764ad8a718c$export$74bf444e3cd11ea5; }, function (v) { return $1403b764ad8a718c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $1403b764ad8a718c$export$998bcd577473dd93; }, function (v) { return $1403b764ad8a718c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $1403b764ad8a718c$export$92387174baf9b227; }, function (v) { return $1403b764ad8a718c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $1403b764ad8a718c$export$ec112efeb987d9c6; }, function (v) { return $1403b764ad8a718c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $1403b764ad8a718c$export$b706b080d889d2c9; }, function (v) { return $1403b764ad8a718c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $1403b764ad8a718c$export$5be5a87408f70ddc; }, function (v) { return $1403b764ad8a718c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $1403b764ad8a718c$export$45a5e7f76e0caa8d; }, function (v) { return $1403b764ad8a718c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $1403b764ad8a718c$export$455c2e768291efa6; }, function (v) { return $1403b764ad8a718c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $1403b764ad8a718c$export$9522e17588c12572; }, function (v) { return $1403b764ad8a718c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $1403b764ad8a718c$export$2110ac352bb060b9; }, function (v) { return $1403b764ad8a718c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $1403b764ad8a718c$export$56885ab8b9c456ab; }, function (v) { return $1403b764ad8a718c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $1403b764ad8a718c$export$d927fcb6adf8f9de; }, function (v) { return $1403b764ad8a718c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $1403b764ad8a718c$export$b82d16f27459e05a; }, function (v) { return $1403b764ad8a718c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $1403b764ad8a718c$export$522c17b4f5e123e8; }, function (v) { return $1403b764ad8a718c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $1403b764ad8a718c$export$1aabd8a0274ecfd6; }, function (v) { return $1403b764ad8a718c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $1403b764ad8a718c$export$3d6c20d97e46b957; }, function (v) { return $1403b764ad8a718c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $1403b764ad8a718c$export$9b621391a187a31a; }, function (v) { return $1403b764ad8a718c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $1403b764ad8a718c$export$f5bbd400c2f4426f; }, function (v) { return $1403b764ad8a718c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1403b764ad8a718c$export$a7c73072b1a182ae;
var $1403b764ad8a718c$export$9f27bc3417b4524d;
var $1403b764ad8a718c$export$db77ccec0bb4ccac;
var $1403b764ad8a718c$export$8392c0c9d3dcbd35;
var $1403b764ad8a718c$export$ffb0004e005737fa;
var $1403b764ad8a718c$export$b624eff549462981;
var $1403b764ad8a718c$export$7897aa7841a5380c;
var $1403b764ad8a718c$export$602eac185826482c;
var $1403b764ad8a718c$export$e2c29f18771995cb;
var $1403b764ad8a718c$export$5f8d39834fd61797;
var $1403b764ad8a718c$export$74bf444e3cd11ea5;
var $1403b764ad8a718c$export$998bcd577473dd93;
var $1403b764ad8a718c$export$92387174baf9b227;
var $1403b764ad8a718c$export$ec112efeb987d9c6;
var $1403b764ad8a718c$export$b706b080d889d2c9;
var $1403b764ad8a718c$export$5be5a87408f70ddc;
var $1403b764ad8a718c$export$45a5e7f76e0caa8d;
var $1403b764ad8a718c$export$455c2e768291efa6;
var $1403b764ad8a718c$export$9522e17588c12572;
var $1403b764ad8a718c$export$2110ac352bb060b9;
var $1403b764ad8a718c$export$56885ab8b9c456ab;
var $1403b764ad8a718c$export$d927fcb6adf8f9de;
var $1403b764ad8a718c$export$b82d16f27459e05a;
var $1403b764ad8a718c$export$522c17b4f5e123e8;
var $1403b764ad8a718c$export$1aabd8a0274ecfd6;
var $1403b764ad8a718c$export$3d6c20d97e46b957;
var $1403b764ad8a718c$export$9b621391a187a31a;
var $1403b764ad8a718c$export$f5bbd400c2f4426f;
"use strict";
var $1403b764ad8a718c$var$b = Symbol.for("react.element"), $1403b764ad8a718c$var$c = Symbol.for("react.portal"), $1403b764ad8a718c$var$d = Symbol.for("react.fragment"), $1403b764ad8a718c$var$e = Symbol.for("react.strict_mode"), $1403b764ad8a718c$var$f = Symbol.for("react.profiler"), $1403b764ad8a718c$var$g = Symbol.for("react.provider"), $1403b764ad8a718c$var$h = Symbol.for("react.context"), $1403b764ad8a718c$var$k = Symbol.for("react.server_context"), $1403b764ad8a718c$var$l = Symbol.for("react.forward_ref"), $1403b764ad8a718c$var$m = Symbol.for("react.suspense"), $1403b764ad8a718c$var$n = Symbol.for("react.suspense_list"), $1403b764ad8a718c$var$p = Symbol.for("react.memo"), $1403b764ad8a718c$var$q = Symbol.for("react.lazy"), $1403b764ad8a718c$var$t = Symbol.for("react.offscreen"), $1403b764ad8a718c$var$u;
$1403b764ad8a718c$var$u = Symbol.for("react.module.reference");
function $1403b764ad8a718c$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $1403b764ad8a718c$var$b:
                switch(a = a.type, a){
                    case $1403b764ad8a718c$var$d:
                    case $1403b764ad8a718c$var$f:
                    case $1403b764ad8a718c$var$e:
                    case $1403b764ad8a718c$var$m:
                    case $1403b764ad8a718c$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1403b764ad8a718c$var$k:
                            case $1403b764ad8a718c$var$h:
                            case $1403b764ad8a718c$var$l:
                            case $1403b764ad8a718c$var$q:
                            case $1403b764ad8a718c$var$p:
                            case $1403b764ad8a718c$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $1403b764ad8a718c$var$c:
                return r;
        }
    }
}
$1403b764ad8a718c$export$a7c73072b1a182ae = $1403b764ad8a718c$var$h;
$1403b764ad8a718c$export$9f27bc3417b4524d = $1403b764ad8a718c$var$g;
$1403b764ad8a718c$export$db77ccec0bb4ccac = $1403b764ad8a718c$var$b;
$1403b764ad8a718c$export$8392c0c9d3dcbd35 = $1403b764ad8a718c$var$l;
$1403b764ad8a718c$export$ffb0004e005737fa = $1403b764ad8a718c$var$d;
$1403b764ad8a718c$export$b624eff549462981 = $1403b764ad8a718c$var$q;
$1403b764ad8a718c$export$7897aa7841a5380c = $1403b764ad8a718c$var$p;
$1403b764ad8a718c$export$602eac185826482c = $1403b764ad8a718c$var$c;
$1403b764ad8a718c$export$e2c29f18771995cb = $1403b764ad8a718c$var$f;
$1403b764ad8a718c$export$5f8d39834fd61797 = $1403b764ad8a718c$var$e;
$1403b764ad8a718c$export$74bf444e3cd11ea5 = $1403b764ad8a718c$var$m;
$1403b764ad8a718c$export$998bcd577473dd93 = $1403b764ad8a718c$var$n;
$1403b764ad8a718c$export$92387174baf9b227 = function() {
    return !1;
};
$1403b764ad8a718c$export$ec112efeb987d9c6 = function() {
    return !1;
};
$1403b764ad8a718c$export$b706b080d889d2c9 = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$h;
};
$1403b764ad8a718c$export$5be5a87408f70ddc = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$g;
};
$1403b764ad8a718c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1403b764ad8a718c$var$b;
};
$1403b764ad8a718c$export$455c2e768291efa6 = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$l;
};
$1403b764ad8a718c$export$9522e17588c12572 = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$d;
};
$1403b764ad8a718c$export$2110ac352bb060b9 = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$q;
};
$1403b764ad8a718c$export$56885ab8b9c456ab = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$p;
};
$1403b764ad8a718c$export$d927fcb6adf8f9de = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$c;
};
$1403b764ad8a718c$export$b82d16f27459e05a = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$f;
};
$1403b764ad8a718c$export$522c17b4f5e123e8 = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$e;
};
$1403b764ad8a718c$export$1aabd8a0274ecfd6 = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$m;
};
$1403b764ad8a718c$export$3d6c20d97e46b957 = function(a) {
    return $1403b764ad8a718c$var$v(a) === $1403b764ad8a718c$var$n;
};
$1403b764ad8a718c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1403b764ad8a718c$var$d || a === $1403b764ad8a718c$var$f || a === $1403b764ad8a718c$var$e || a === $1403b764ad8a718c$var$m || a === $1403b764ad8a718c$var$n || a === $1403b764ad8a718c$var$t || "object" === typeof a && null !== a && (a.$$typeof === $1403b764ad8a718c$var$q || a.$$typeof === $1403b764ad8a718c$var$p || a.$$typeof === $1403b764ad8a718c$var$g || a.$$typeof === $1403b764ad8a718c$var$h || a.$$typeof === $1403b764ad8a718c$var$l || a.$$typeof === $1403b764ad8a718c$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$1403b764ad8a718c$export$f5bbd400c2f4426f = $1403b764ad8a718c$var$v;

});

parcelRegister("f4CML", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("iVlgB"));

});
parcelRegister("iVlgB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $dc6e0c06a2a92de8$var$_tickFormat.default;
    }
});

var $dc6e0c06a2a92de8$var$_band = $dc6e0c06a2a92de8$var$_interopRequireWildcard((parcelRequire("jIbY6")));

var $dc6e0c06a2a92de8$var$_identity = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("go4ub")));

var $dc6e0c06a2a92de8$var$_linear = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("jOaL3")));

var $dc6e0c06a2a92de8$var$_log = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("lgZ06")));

var $dc6e0c06a2a92de8$var$_symlog = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("j6nO0")));

var $dc6e0c06a2a92de8$var$_ordinal = $dc6e0c06a2a92de8$var$_interopRequireWildcard((parcelRequire("c9qMa")));

var $dc6e0c06a2a92de8$var$_pow = $dc6e0c06a2a92de8$var$_interopRequireWildcard((parcelRequire("kpRKB")));

var $dc6e0c06a2a92de8$var$_radial = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("pDRfk")));

var $dc6e0c06a2a92de8$var$_quantile = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("kEh47")));

var $dc6e0c06a2a92de8$var$_quantize = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("i2qUz")));

var $dc6e0c06a2a92de8$var$_threshold = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("kda9Y")));

var $dc6e0c06a2a92de8$var$_time = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("ba19f")));

var $dc6e0c06a2a92de8$var$_utcTime = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("fy5x8")));

var $dc6e0c06a2a92de8$var$_sequential = $dc6e0c06a2a92de8$var$_interopRequireWildcard((parcelRequire("6doRD")));

var $dc6e0c06a2a92de8$var$_sequentialQuantile = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("5Kjlt")));

var $dc6e0c06a2a92de8$var$_diverging = $dc6e0c06a2a92de8$var$_interopRequireWildcard((parcelRequire("7PlAi")));

var $dc6e0c06a2a92de8$var$_tickFormat = $dc6e0c06a2a92de8$var$_interopRequireDefault((parcelRequire("6kKCb")));
function $dc6e0c06a2a92de8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dc6e0c06a2a92de8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dc6e0c06a2a92de8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dc6e0c06a2a92de8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dc6e0c06a2a92de8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("jIbY6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e59b690a4559319d$var$band;
module.exports.point = $e59b690a4559319d$var$point;

var $5I0XU = parcelRequire("5I0XU");

var $lO6tR = parcelRequire("lO6tR");

var $e59b690a4559319d$var$_ordinal = $e59b690a4559319d$var$_interopRequireDefault((parcelRequire("c9qMa")));
function $e59b690a4559319d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e59b690a4559319d$var$band() {
    var scale = (0, $e59b690a4559319d$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $5I0XU.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $e59b690a4559319d$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $lO6tR.initRange.apply(rescale(), arguments);
}
function $e59b690a4559319d$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $e59b690a4559319d$var$pointish(copy());
    };
    return scale;
}
function $e59b690a4559319d$var$point() {
    return $e59b690a4559319d$var$pointish($e59b690a4559319d$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("5I0XU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $f23Vr.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $9gEy4.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $9gEy4.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $f23Vr.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $f23Vr.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $4281cf7a9a607114$var$_zip.default;
    }
});

var $4281cf7a9a607114$var$_bisect = $4281cf7a9a607114$var$_interopRequireWildcard((parcelRequire("1mzMJ")));

var $4281cf7a9a607114$var$_ascending = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $4281cf7a9a607114$var$_bisector = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("hSaj1")));

var $4281cf7a9a607114$var$_count = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("aBgLB")));

var $4281cf7a9a607114$var$_cross = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("8Ctnx")));

var $4281cf7a9a607114$var$_cumsum = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("kWtFi")));

var $4281cf7a9a607114$var$_descending = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("eqqzl")));

var $4281cf7a9a607114$var$_deviation = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("2DXBx")));

var $4281cf7a9a607114$var$_extent = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("3w5H3")));

var $f23Vr = parcelRequire("f23Vr");

var $4281cf7a9a607114$var$_group = $4281cf7a9a607114$var$_interopRequireWildcard((parcelRequire("8kXcs")));

var $4281cf7a9a607114$var$_groupSort = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("8qXSm")));

var $4281cf7a9a607114$var$_bin = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("kSpBU")));

var $4281cf7a9a607114$var$_freedmanDiaconis = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("eeeAs")));

var $4281cf7a9a607114$var$_scott = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("7V5dH")));

var $4281cf7a9a607114$var$_sturges = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("gaupO")));

var $4281cf7a9a607114$var$_max = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("lMubT")));

var $4281cf7a9a607114$var$_maxIndex = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("gW6zi")));

var $4281cf7a9a607114$var$_mean = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("cQlEr")));

var $4281cf7a9a607114$var$_median = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("hDO9D")));

var $4281cf7a9a607114$var$_merge = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("7jEBE")));

var $4281cf7a9a607114$var$_min = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("8ZXHU")));

var $4281cf7a9a607114$var$_minIndex = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("5qlmc")));

var $4281cf7a9a607114$var$_mode = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("hQr8U")));

var $4281cf7a9a607114$var$_nice = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("h3t38")));

var $4281cf7a9a607114$var$_pairs = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("g0T78")));

var $4281cf7a9a607114$var$_permute = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("kLlfz")));

var $4281cf7a9a607114$var$_quantile = $4281cf7a9a607114$var$_interopRequireWildcard((parcelRequire("4qcrW")));

var $4281cf7a9a607114$var$_quickselect = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("d96yE")));

var $4281cf7a9a607114$var$_range = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("hBzCD")));

var $4281cf7a9a607114$var$_rank = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("gPL3x")));

var $4281cf7a9a607114$var$_least = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("6VgDI")));

var $4281cf7a9a607114$var$_leastIndex = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("dDS45")));

var $4281cf7a9a607114$var$_greatest = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("abwAa")));

var $4281cf7a9a607114$var$_greatestIndex = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("fsWFb")));

var $4281cf7a9a607114$var$_scan = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("ibpc9")));

var $4281cf7a9a607114$var$_shuffle = $4281cf7a9a607114$var$_interopRequireWildcard((parcelRequire("1vTwt")));

var $4281cf7a9a607114$var$_sum = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("kGghl")));

var $4281cf7a9a607114$var$_ticks = $4281cf7a9a607114$var$_interopRequireWildcard((parcelRequire("eQ5L4")));

var $4281cf7a9a607114$var$_transpose = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("aFh3x")));

var $4281cf7a9a607114$var$_variance = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("bpHVI")));

var $4281cf7a9a607114$var$_zip = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("iV5HV")));

var $4281cf7a9a607114$var$_every = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("2hFhI")));

var $4281cf7a9a607114$var$_some = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("9ZNA7")));

var $4281cf7a9a607114$var$_filter = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("izgdo")));

var $4281cf7a9a607114$var$_map = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("hWCAV")));

var $4281cf7a9a607114$var$_reduce = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("dFfVi")));

var $4281cf7a9a607114$var$_reverse = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("da2Ox")));

var $4281cf7a9a607114$var$_sort = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("5gqcG")));

var $4281cf7a9a607114$var$_difference = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("km2gi")));

var $4281cf7a9a607114$var$_disjoint = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("foheD")));

var $4281cf7a9a607114$var$_intersection = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("aD32h")));

var $4281cf7a9a607114$var$_subset = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("3Pw2C")));

var $4281cf7a9a607114$var$_superset = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("2lLS8")));

var $4281cf7a9a607114$var$_union = $4281cf7a9a607114$var$_interopRequireDefault((parcelRequire("2laTX")));

var $9gEy4 = parcelRequire("9gEy4");
function $4281cf7a9a607114$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4281cf7a9a607114$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4281cf7a9a607114$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4281cf7a9a607114$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4281cf7a9a607114$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("1mzMJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $0fe39aa7ad60da07$var$_ascending = $0fe39aa7ad60da07$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $0fe39aa7ad60da07$var$_bisector = $0fe39aa7ad60da07$var$_interopRequireDefault((parcelRequire("hSaj1")));

var $0fe39aa7ad60da07$var$_number = $0fe39aa7ad60da07$var$_interopRequireDefault((parcelRequire("aOmZU")));
function $0fe39aa7ad60da07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0fe39aa7ad60da07$var$ascendingBisect = (0, $0fe39aa7ad60da07$var$_bisector.default)($0fe39aa7ad60da07$var$_ascending.default);
const $0fe39aa7ad60da07$var$bisectRight = $0fe39aa7ad60da07$var$ascendingBisect.right;
module.exports.bisectRight = $0fe39aa7ad60da07$var$bisectRight;
const $0fe39aa7ad60da07$var$bisectLeft = $0fe39aa7ad60da07$var$ascendingBisect.left;
module.exports.bisectLeft = $0fe39aa7ad60da07$var$bisectLeft;
const $0fe39aa7ad60da07$var$bisectCenter = (0, $0fe39aa7ad60da07$var$_bisector.default)($0fe39aa7ad60da07$var$_number.default).center;
module.exports.bisectCenter = $0fe39aa7ad60da07$var$bisectCenter;
var $0fe39aa7ad60da07$var$_default = $0fe39aa7ad60da07$var$bisectRight;
module.exports.default = $0fe39aa7ad60da07$var$_default;

});
parcelRegister("hlYzn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca2361ad0822c72c$var$ascending;
function $ca2361ad0822c72c$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("hSaj1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d02f7956dfb51f52$var$bisector;

var $d02f7956dfb51f52$var$_ascending = $d02f7956dfb51f52$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $d02f7956dfb51f52$var$_descending = $d02f7956dfb51f52$var$_interopRequireDefault((parcelRequire("eqqzl")));
function $d02f7956dfb51f52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d02f7956dfb51f52$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $d02f7956dfb51f52$var$_ascending.default;
        compare2 = (d, x)=>(0, $d02f7956dfb51f52$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $d02f7956dfb51f52$var$_ascending.default || f === $d02f7956dfb51f52$var$_descending.default ? f : $d02f7956dfb51f52$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $d02f7956dfb51f52$var$zero() {
    return 0;
}

});
parcelRegister("eqqzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8081a758b7da3c2$var$descending;
function $a8081a758b7da3c2$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("aOmZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7df069bb5ec806a3$var$number;
module.exports.numbers = $7df069bb5ec806a3$var$numbers;
function $7df069bb5ec806a3$var$number(x) {
    return x === null ? NaN : +x;
}
function* $7df069bb5ec806a3$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("aBgLB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b7a5d9c59ca299f$var$count;
function $7b7a5d9c59ca299f$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("8Ctnx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6468a94d61d6929f$var$cross;
function $6468a94d61d6929f$var$length(array) {
    return array.length | 0;
}
function $6468a94d61d6929f$var$empty(length) {
    return !(length > 0);
}
function $6468a94d61d6929f$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $6468a94d61d6929f$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $6468a94d61d6929f$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $6468a94d61d6929f$var$reducer(values.pop());
    values = values.map($6468a94d61d6929f$var$arrayify);
    const lengths = values.map($6468a94d61d6929f$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($6468a94d61d6929f$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("kWtFi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3f03c508bd85e59$var$cumsum;
function $f3f03c508bd85e59$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("2DXBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ecd757c0de6f75d$var$deviation;

var $1ecd757c0de6f75d$var$_variance = $1ecd757c0de6f75d$var$_interopRequireDefault((parcelRequire("bpHVI")));
function $1ecd757c0de6f75d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1ecd757c0de6f75d$var$deviation(values, valueof) {
    const v = (0, $1ecd757c0de6f75d$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("bpHVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84f41b175d581309$var$variance;
function $84f41b175d581309$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("3w5H3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28f8c6d7684aa065$var$extent;
function $28f8c6d7684aa065$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("f23Vr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $af1a1675c5469f64$var$fcumsum;
module.exports.fsum = $af1a1675c5469f64$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $af1a1675c5469f64$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $af1a1675c5469f64$var$Adder;
function $af1a1675c5469f64$var$fsum(values, valueof) {
    const adder = new $af1a1675c5469f64$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $af1a1675c5469f64$var$fcumsum(values, valueof) {
    const adder = new $af1a1675c5469f64$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("8kXcs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $611e1cd944718d69$var$group;
module.exports.flatGroup = $611e1cd944718d69$var$flatGroup;
module.exports.flatRollup = $611e1cd944718d69$var$flatRollup;
module.exports.groups = $611e1cd944718d69$var$groups;
module.exports.index = $611e1cd944718d69$var$index;
module.exports.indexes = $611e1cd944718d69$var$indexes;
module.exports.rollup = $611e1cd944718d69$var$rollup;
module.exports.rollups = $611e1cd944718d69$var$rollups;

var $9gEy4 = parcelRequire("9gEy4");

var $611e1cd944718d69$var$_identity = $611e1cd944718d69$var$_interopRequireDefault((parcelRequire("hUyXO")));
function $611e1cd944718d69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $611e1cd944718d69$var$group(values, ...keys) {
    return $611e1cd944718d69$var$nest(values, $611e1cd944718d69$var$_identity.default, $611e1cd944718d69$var$_identity.default, keys);
}
function $611e1cd944718d69$var$groups(values, ...keys) {
    return $611e1cd944718d69$var$nest(values, Array.from, $611e1cd944718d69$var$_identity.default, keys);
}
function $611e1cd944718d69$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $611e1cd944718d69$var$flatGroup(values, ...keys) {
    return $611e1cd944718d69$var$flatten($611e1cd944718d69$var$groups(values, ...keys), keys);
}
function $611e1cd944718d69$var$flatRollup(values, reduce, ...keys) {
    return $611e1cd944718d69$var$flatten($611e1cd944718d69$var$rollups(values, reduce, ...keys), keys);
}
function $611e1cd944718d69$var$rollup(values, reduce, ...keys) {
    return $611e1cd944718d69$var$nest(values, $611e1cd944718d69$var$_identity.default, reduce, keys);
}
function $611e1cd944718d69$var$rollups(values, reduce, ...keys) {
    return $611e1cd944718d69$var$nest(values, Array.from, reduce, keys);
}
function $611e1cd944718d69$var$index(values, ...keys) {
    return $611e1cd944718d69$var$nest(values, $611e1cd944718d69$var$_identity.default, $611e1cd944718d69$var$unique, keys);
}
function $611e1cd944718d69$var$indexes(values, ...keys) {
    return $611e1cd944718d69$var$nest(values, Array.from, $611e1cd944718d69$var$unique, keys);
}
function $611e1cd944718d69$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $611e1cd944718d69$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $9gEy4.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("9gEy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $6bf50fc0e33a6cb9$var$InternMap extends Map {
    constructor(entries, key = $6bf50fc0e33a6cb9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($6bf50fc0e33a6cb9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($6bf50fc0e33a6cb9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($6bf50fc0e33a6cb9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($6bf50fc0e33a6cb9$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $6bf50fc0e33a6cb9$var$InternMap;
class $6bf50fc0e33a6cb9$var$InternSet extends Set {
    constructor(values, key = $6bf50fc0e33a6cb9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($6bf50fc0e33a6cb9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($6bf50fc0e33a6cb9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($6bf50fc0e33a6cb9$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $6bf50fc0e33a6cb9$var$InternSet;
function $6bf50fc0e33a6cb9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $6bf50fc0e33a6cb9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $6bf50fc0e33a6cb9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $6bf50fc0e33a6cb9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("hUyXO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0a2c9b2fc2a8f4a$var$identity;
function $d0a2c9b2fc2a8f4a$var$identity(x) {
    return x;
}

});


parcelRegister("8qXSm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $623f32805d0bb406$var$groupSort;

var $623f32805d0bb406$var$_ascending = $623f32805d0bb406$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $623f32805d0bb406$var$_group = $623f32805d0bb406$var$_interopRequireWildcard((parcelRequire("8kXcs")));

var $623f32805d0bb406$var$_sort = $623f32805d0bb406$var$_interopRequireDefault((parcelRequire("5gqcG")));
function $623f32805d0bb406$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($623f32805d0bb406$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $623f32805d0bb406$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $623f32805d0bb406$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $623f32805d0bb406$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $623f32805d0bb406$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $623f32805d0bb406$var$_sort.default)((0, $623f32805d0bb406$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $623f32805d0bb406$var$_ascending.default)(av, bv) || (0, $623f32805d0bb406$var$_ascending.default)(ak, bk)) : (0, $623f32805d0bb406$var$_sort.default)((0, $623f32805d0bb406$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $623f32805d0bb406$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("5gqcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $3d52c5dfd767d38b$var$ascendingDefined;
module.exports.compareDefined = $3d52c5dfd767d38b$var$compareDefined;
module.exports.default = $3d52c5dfd767d38b$var$sort;

var $3d52c5dfd767d38b$var$_ascending = $3d52c5dfd767d38b$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $3d52c5dfd767d38b$var$_permute = $3d52c5dfd767d38b$var$_interopRequireDefault((parcelRequire("kLlfz")));
function $3d52c5dfd767d38b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3d52c5dfd767d38b$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $3d52c5dfd767d38b$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$3d52c5dfd767d38b$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $3d52c5dfd767d38b$var$_permute.default)(values, index);
    }
    return values.sort($3d52c5dfd767d38b$var$compareDefined(f));
}
function $3d52c5dfd767d38b$var$compareDefined(compare = $3d52c5dfd767d38b$var$_ascending.default) {
    if (compare === $3d52c5dfd767d38b$var$_ascending.default) return $3d52c5dfd767d38b$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $3d52c5dfd767d38b$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("kLlfz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1d8ae46df45c717$var$permute;
function $f1d8ae46df45c717$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("kSpBU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f32cb778281cd1a4$var$bin;

var $1rG6g = parcelRequire("1rG6g");

var $f32cb778281cd1a4$var$_bisect = $f32cb778281cd1a4$var$_interopRequireDefault((parcelRequire("1mzMJ")));

var $f32cb778281cd1a4$var$_constant = $f32cb778281cd1a4$var$_interopRequireDefault((parcelRequire("hAgph")));

var $f32cb778281cd1a4$var$_extent = $f32cb778281cd1a4$var$_interopRequireDefault((parcelRequire("3w5H3")));

var $f32cb778281cd1a4$var$_identity = $f32cb778281cd1a4$var$_interopRequireDefault((parcelRequire("hUyXO")));

var $f32cb778281cd1a4$var$_nice = $f32cb778281cd1a4$var$_interopRequireDefault((parcelRequire("h3t38")));

var $f32cb778281cd1a4$var$_ticks = $f32cb778281cd1a4$var$_interopRequireWildcard((parcelRequire("eQ5L4")));

var $f32cb778281cd1a4$var$_sturges = $f32cb778281cd1a4$var$_interopRequireDefault((parcelRequire("gaupO")));
function $f32cb778281cd1a4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f32cb778281cd1a4$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f32cb778281cd1a4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f32cb778281cd1a4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f32cb778281cd1a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f32cb778281cd1a4$var$bin() {
    var value = $f32cb778281cd1a4$var$_identity.default, domain = $f32cb778281cd1a4$var$_extent.default, threshold = $f32cb778281cd1a4$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $f32cb778281cd1a4$var$_extent.default) [x0, x1] = (0, $f32cb778281cd1a4$var$_nice.default)(x0, x1, tn);
            tz = (0, $f32cb778281cd1a4$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $f32cb778281cd1a4$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $f32cb778281cd1a4$var$_extent.default) {
                    const step = (0, $f32cb778281cd1a4$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $f32cb778281cd1a4$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $f32cb778281cd1a4$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $f32cb778281cd1a4$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $f32cb778281cd1a4$var$_constant.default)($1rG6g.slice.call(_)) : (0, $f32cb778281cd1a4$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("1rG6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $10d8f841faf4fdf4$var$array = Array.prototype;
var $10d8f841faf4fdf4$var$slice = $10d8f841faf4fdf4$var$array.slice;
module.exports.slice = $10d8f841faf4fdf4$var$slice;
var $10d8f841faf4fdf4$var$map = $10d8f841faf4fdf4$var$array.map;
module.exports.map = $10d8f841faf4fdf4$var$map;

});

parcelRegister("hAgph", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccd2868117fe0d9f$var$constant;
function $ccd2868117fe0d9f$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("h3t38", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6a94018fd0660c0$var$nice;

var $eQ5L4 = parcelRequire("eQ5L4");
function $c6a94018fd0660c0$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $eQ5L4.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("eQ5L4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $acda63748c814d9d$var$ticks;
module.exports.tickIncrement = $acda63748c814d9d$var$tickIncrement;
module.exports.tickStep = $acda63748c814d9d$var$tickStep;
var $acda63748c814d9d$var$e10 = Math.sqrt(50), $acda63748c814d9d$var$e5 = Math.sqrt(10), $acda63748c814d9d$var$e2 = Math.sqrt(2);
function $acda63748c814d9d$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $acda63748c814d9d$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $acda63748c814d9d$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $acda63748c814d9d$var$e10 ? 10 : error >= $acda63748c814d9d$var$e5 ? 5 : error >= $acda63748c814d9d$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $acda63748c814d9d$var$e10 ? 10 : error >= $acda63748c814d9d$var$e5 ? 5 : error >= $acda63748c814d9d$var$e2 ? 2 : 1);
}
function $acda63748c814d9d$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $acda63748c814d9d$var$e10) step1 *= 10;
    else if (error >= $acda63748c814d9d$var$e5) step1 *= 5;
    else if (error >= $acda63748c814d9d$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("gaupO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc552c61157b963d$var$thresholdSturges;

var $bc552c61157b963d$var$_count = $bc552c61157b963d$var$_interopRequireDefault((parcelRequire("aBgLB")));
function $bc552c61157b963d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bc552c61157b963d$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $bc552c61157b963d$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("eeeAs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a5bdb032eb5c48cc$var$thresholdFreedmanDiaconis;

var $a5bdb032eb5c48cc$var$_count = $a5bdb032eb5c48cc$var$_interopRequireDefault((parcelRequire("aBgLB")));

var $a5bdb032eb5c48cc$var$_quantile = $a5bdb032eb5c48cc$var$_interopRequireDefault((parcelRequire("4qcrW")));
function $a5bdb032eb5c48cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a5bdb032eb5c48cc$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $a5bdb032eb5c48cc$var$_quantile.default)(values, 0.75) - (0, $a5bdb032eb5c48cc$var$_quantile.default)(values, 0.25)) * Math.pow((0, $a5bdb032eb5c48cc$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("4qcrW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33833f5c2a6abb6a$var$quantile;
module.exports.quantileSorted = $33833f5c2a6abb6a$var$quantileSorted;

var $33833f5c2a6abb6a$var$_max = $33833f5c2a6abb6a$var$_interopRequireDefault((parcelRequire("lMubT")));

var $33833f5c2a6abb6a$var$_min = $33833f5c2a6abb6a$var$_interopRequireDefault((parcelRequire("8ZXHU")));

var $33833f5c2a6abb6a$var$_quickselect = $33833f5c2a6abb6a$var$_interopRequireDefault((parcelRequire("d96yE")));

var $33833f5c2a6abb6a$var$_number = $33833f5c2a6abb6a$var$_interopRequireWildcard((parcelRequire("aOmZU")));
function $33833f5c2a6abb6a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($33833f5c2a6abb6a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $33833f5c2a6abb6a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $33833f5c2a6abb6a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $33833f5c2a6abb6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33833f5c2a6abb6a$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $33833f5c2a6abb6a$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $33833f5c2a6abb6a$var$_min.default)(values);
    if (p >= 1) return (0, $33833f5c2a6abb6a$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $33833f5c2a6abb6a$var$_max.default)((0, $33833f5c2a6abb6a$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $33833f5c2a6abb6a$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $33833f5c2a6abb6a$var$quantileSorted(values, p, valueof = $33833f5c2a6abb6a$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("lMubT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fdb57ff1902a5b03$var$max;
function $fdb57ff1902a5b03$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("8ZXHU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68d255d75ec946a9$var$min;
function $68d255d75ec946a9$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("d96yE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $992133e49d80ea2e$var$quickselect;

var $5gqcG = parcelRequire("5gqcG");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $992133e49d80ea2e$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $5gqcG.ascendingDefined : (0, $5gqcG.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $992133e49d80ea2e$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $992133e49d80ea2e$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $992133e49d80ea2e$var$swap(array, left, right);
        while(i < j){
            $992133e49d80ea2e$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $992133e49d80ea2e$var$swap(array, left, j);
        else ++j, $992133e49d80ea2e$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $992133e49d80ea2e$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("7V5dH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c41e7da44736fb9$var$thresholdScott;

var $5c41e7da44736fb9$var$_count = $5c41e7da44736fb9$var$_interopRequireDefault((parcelRequire("aBgLB")));

var $5c41e7da44736fb9$var$_deviation = $5c41e7da44736fb9$var$_interopRequireDefault((parcelRequire("2DXBx")));
function $5c41e7da44736fb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5c41e7da44736fb9$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $5c41e7da44736fb9$var$_count.default)(values)) / (3.49 * (0, $5c41e7da44736fb9$var$_deviation.default)(values)));
}

});

parcelRegister("gW6zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c5472872392867bc$var$maxIndex;
function $c5472872392867bc$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("cQlEr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $959b22dad20dc229$var$mean;
function $959b22dad20dc229$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("hDO9D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd7cfbc95dedd95e$var$median;

var $cd7cfbc95dedd95e$var$_quantile = $cd7cfbc95dedd95e$var$_interopRequireDefault((parcelRequire("4qcrW")));
function $cd7cfbc95dedd95e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cd7cfbc95dedd95e$var$median(values, valueof) {
    return (0, $cd7cfbc95dedd95e$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("7jEBE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5539ce4ddcd06c3b$var$merge;
function* $5539ce4ddcd06c3b$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $5539ce4ddcd06c3b$var$merge(arrays) {
    return Array.from($5539ce4ddcd06c3b$var$flatten(arrays));
}

});

parcelRegister("5qlmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f2ff289d3c501fa$var$minIndex;
function $3f2ff289d3c501fa$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("hQr8U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cfdc58f630d5ebde$var$mode;

var $9gEy4 = parcelRequire("9gEy4");
function $cfdc58f630d5ebde$var$mode(values, valueof) {
    const counts = new $9gEy4.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("g0T78", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba8765e9eb8ae39e$var$pairs;
module.exports.pair = $ba8765e9eb8ae39e$var$pair;
function $ba8765e9eb8ae39e$var$pairs(values, pairof = $ba8765e9eb8ae39e$var$pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $ba8765e9eb8ae39e$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("hBzCD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd1186328302aafb$var$range;
function $cd1186328302aafb$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("gPL3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c415e91d9086021c$var$rank;

var $c415e91d9086021c$var$_ascending = $c415e91d9086021c$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $5gqcG = parcelRequire("5gqcG");
function $c415e91d9086021c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c415e91d9086021c$var$rank(values, valueof = $c415e91d9086021c$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $c415e91d9086021c$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $c415e91d9086021c$var$_ascending.default ? (i, j)=>(0, $5gqcG.ascendingDefined)(V[i], V[j]) : (0, $5gqcG.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("6VgDI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50a4f93abea3f577$var$least;

var $50a4f93abea3f577$var$_ascending = $50a4f93abea3f577$var$_interopRequireDefault((parcelRequire("hlYzn")));
function $50a4f93abea3f577$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $50a4f93abea3f577$var$least(values, compare = $50a4f93abea3f577$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $50a4f93abea3f577$var$_ascending.default)(value, minValue) < 0 : (0, $50a4f93abea3f577$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("dDS45", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ee8db115516811f$var$leastIndex;

var $9ee8db115516811f$var$_ascending = $9ee8db115516811f$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $9ee8db115516811f$var$_minIndex = $9ee8db115516811f$var$_interopRequireDefault((parcelRequire("5qlmc")));
function $9ee8db115516811f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ee8db115516811f$var$leastIndex(values, compare = $9ee8db115516811f$var$_ascending.default) {
    if (compare.length === 1) return (0, $9ee8db115516811f$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("abwAa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76a434a87c58a983$var$greatest;

var $76a434a87c58a983$var$_ascending = $76a434a87c58a983$var$_interopRequireDefault((parcelRequire("hlYzn")));
function $76a434a87c58a983$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76a434a87c58a983$var$greatest(values, compare = $76a434a87c58a983$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $76a434a87c58a983$var$_ascending.default)(value, maxValue) > 0 : (0, $76a434a87c58a983$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("fsWFb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b426f9d4b9aefe3e$var$greatestIndex;

var $b426f9d4b9aefe3e$var$_ascending = $b426f9d4b9aefe3e$var$_interopRequireDefault((parcelRequire("hlYzn")));

var $b426f9d4b9aefe3e$var$_maxIndex = $b426f9d4b9aefe3e$var$_interopRequireDefault((parcelRequire("gW6zi")));
function $b426f9d4b9aefe3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b426f9d4b9aefe3e$var$greatestIndex(values, compare = $b426f9d4b9aefe3e$var$_ascending.default) {
    if (compare.length === 1) return (0, $b426f9d4b9aefe3e$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("ibpc9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d3cccc43a87dfeef$var$scan;

var $d3cccc43a87dfeef$var$_leastIndex = $d3cccc43a87dfeef$var$_interopRequireDefault((parcelRequire("dDS45")));
function $d3cccc43a87dfeef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d3cccc43a87dfeef$var$scan(values, compare) {
    const index = (0, $d3cccc43a87dfeef$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("1vTwt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $11a3c15b69074c2c$var$shuffler;
var $11a3c15b69074c2c$var$_default = $11a3c15b69074c2c$var$shuffler(Math.random);
module.exports.default = $11a3c15b69074c2c$var$_default;
function $11a3c15b69074c2c$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("kGghl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0e45b894b907cc5$var$sum;
function $f0e45b894b907cc5$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("aFh3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c3af6b8a883d782$var$transpose;

var $7c3af6b8a883d782$var$_min = $7c3af6b8a883d782$var$_interopRequireDefault((parcelRequire("8ZXHU")));
function $7c3af6b8a883d782$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c3af6b8a883d782$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $7c3af6b8a883d782$var$_min.default)(matrix, $7c3af6b8a883d782$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $7c3af6b8a883d782$var$length(d) {
    return d.length;
}

});

parcelRegister("iV5HV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc61fa3ad0f0e6b3$var$zip;

var $dc61fa3ad0f0e6b3$var$_transpose = $dc61fa3ad0f0e6b3$var$_interopRequireDefault((parcelRequire("aFh3x")));
function $dc61fa3ad0f0e6b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dc61fa3ad0f0e6b3$var$zip() {
    return (0, $dc61fa3ad0f0e6b3$var$_transpose.default)(arguments);
}

});

parcelRegister("2hFhI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a9d319305259336$var$every;
function $1a9d319305259336$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("9ZNA7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74704566afeacb09$var$some;
function $74704566afeacb09$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("izgdo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d84812d81929da90$var$filter;
function $d84812d81929da90$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("hWCAV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d105ca846a2aa60a$var$map;
function $d105ca846a2aa60a$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("dFfVi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f2b74b965cb8b83$var$reduce;
function $9f2b74b965cb8b83$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("da2Ox", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $994e6462f91d95af$var$reverse;
function $994e6462f91d95af$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("km2gi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed179de5907113a2$var$difference;

var $9gEy4 = parcelRequire("9gEy4");
function $ed179de5907113a2$var$difference(values, ...others) {
    values = new $9gEy4.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("foheD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3467773650d40ac$var$disjoint;

var $9gEy4 = parcelRequire("9gEy4");
function $b3467773650d40ac$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $9gEy4.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("aD32h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7bcfe6c0a13e84a1$var$intersection;

var $9gEy4 = parcelRequire("9gEy4");
function $7bcfe6c0a13e84a1$var$intersection(values, ...others) {
    values = new $9gEy4.InternSet(values);
    others = others.map($7bcfe6c0a13e84a1$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $7bcfe6c0a13e84a1$var$set(values) {
    return values instanceof $9gEy4.InternSet ? values : new $9gEy4.InternSet(values);
}

});

parcelRegister("3Pw2C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c9efd3f809c2d09$var$subset;

var $2c9efd3f809c2d09$var$_superset = $2c9efd3f809c2d09$var$_interopRequireDefault((parcelRequire("2lLS8")));
function $2c9efd3f809c2d09$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2c9efd3f809c2d09$var$subset(values, other) {
    return (0, $2c9efd3f809c2d09$var$_superset.default)(other, values);
}

});
parcelRegister("2lLS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b62ad5df9945a10$var$superset;
function $1b62ad5df9945a10$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $1b62ad5df9945a10$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $1b62ad5df9945a10$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $1b62ad5df9945a10$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("2laTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b45ffbcb9fa61ad$var$union;

var $9gEy4 = parcelRequire("9gEy4");
function $1b45ffbcb9fa61ad$var$union(...others) {
    const set = new $9gEy4.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("lO6tR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $fe034b6a7aebdd88$var$initInterpolator;
module.exports.initRange = $fe034b6a7aebdd88$var$initRange;
function $fe034b6a7aebdd88$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $fe034b6a7aebdd88$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("c9qMa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d8b186c18db8057$var$ordinal;
module.exports.implicit = void 0;

var $5I0XU = parcelRequire("5I0XU");

var $lO6tR = parcelRequire("lO6tR");
const $8d8b186c18db8057$var$implicit = Symbol("implicit");
module.exports.implicit = $8d8b186c18db8057$var$implicit;
function $8d8b186c18db8057$var$ordinal() {
    var index = new $5I0XU.InternMap(), domain = [], range = [], unknown = $8d8b186c18db8057$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $8d8b186c18db8057$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $5I0XU.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8d8b186c18db8057$var$ordinal(domain, range).unknown(unknown);
    };
    $lO6tR.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("go4ub", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bee25e04da70d569$var$identity;

var $jOaL3 = parcelRequire("jOaL3");

var $bee25e04da70d569$var$_number = $bee25e04da70d569$var$_interopRequireDefault((parcelRequire("lPOmz")));
function $bee25e04da70d569$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bee25e04da70d569$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $bee25e04da70d569$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $bee25e04da70d569$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $bee25e04da70d569$var$_number.default) : [
        0,
        1
    ];
    return (0, $jOaL3.linearish)(scale);
}

});
parcelRegister("jOaL3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e6bb082093904363$var$linear;
module.exports.linearish = $e6bb082093904363$var$linearish;

var $5I0XU = parcelRequire("5I0XU");

var $e6bb082093904363$var$_continuous = $e6bb082093904363$var$_interopRequireWildcard((parcelRequire("1zBvV")));

var $lO6tR = parcelRequire("lO6tR");

var $e6bb082093904363$var$_tickFormat = $e6bb082093904363$var$_interopRequireDefault((parcelRequire("6kKCb")));
function $e6bb082093904363$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e6bb082093904363$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e6bb082093904363$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e6bb082093904363$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e6bb082093904363$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e6bb082093904363$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $5I0XU.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $e6bb082093904363$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $5I0XU.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $e6bb082093904363$var$linear() {
    var scale = (0, $e6bb082093904363$var$_continuous.default)();
    scale.copy = function() {
        return (0, $e6bb082093904363$var$_continuous.copy)(scale, $e6bb082093904363$var$linear());
    };
    $lO6tR.initRange.apply(scale, arguments);
    return $e6bb082093904363$var$linearish(scale);
}

});
parcelRegister("1zBvV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $125628ce8cadae67$var$copy;
module.exports.default = $125628ce8cadae67$var$continuous;
module.exports.identity = $125628ce8cadae67$var$identity;
module.exports.transformer = $125628ce8cadae67$var$transformer;

var $5I0XU = parcelRequire("5I0XU");

var $5IGzK = parcelRequire("5IGzK");

var $125628ce8cadae67$var$_constant = $125628ce8cadae67$var$_interopRequireDefault((parcelRequire("cuVoq")));

var $125628ce8cadae67$var$_number = $125628ce8cadae67$var$_interopRequireDefault((parcelRequire("lPOmz")));
function $125628ce8cadae67$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $125628ce8cadae67$var$unit = [
    0,
    1
];
function $125628ce8cadae67$var$identity(x) {
    return x;
}
function $125628ce8cadae67$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $125628ce8cadae67$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $125628ce8cadae67$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $125628ce8cadae67$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $125628ce8cadae67$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $125628ce8cadae67$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $125628ce8cadae67$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $125628ce8cadae67$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $5I0XU.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $125628ce8cadae67$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $125628ce8cadae67$var$transformer() {
    var domain = $125628ce8cadae67$var$unit, range = $125628ce8cadae67$var$unit, interpolate = $5IGzK.interpolate, transform, untransform, unknown, clamp = $125628ce8cadae67$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $125628ce8cadae67$var$identity) clamp = $125628ce8cadae67$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $125628ce8cadae67$var$polymap : $125628ce8cadae67$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $5IGzK.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $125628ce8cadae67$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $5IGzK.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $125628ce8cadae67$var$identity, rescale()) : clamp !== $125628ce8cadae67$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $125628ce8cadae67$var$continuous() {
    return $125628ce8cadae67$var$transformer()($125628ce8cadae67$var$identity, $125628ce8cadae67$var$identity);
}

});
parcelRegister("5IGzK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $dWRlu.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $dWRlu.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $42a21672e96000a7$var$_quantize.default;
    }
});

var $42a21672e96000a7$var$_value = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("g45Ed")));

var $42a21672e96000a7$var$_array = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("hgNy5")));

var $42a21672e96000a7$var$_basis = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("8dabo")));

var $42a21672e96000a7$var$_basisClosed = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("k5Vl0")));

var $42a21672e96000a7$var$_date = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("74nvB")));

var $42a21672e96000a7$var$_discrete = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("iRE5g")));

var $42a21672e96000a7$var$_hue = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("cvycw")));

var $42a21672e96000a7$var$_number = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("likoE")));

var $42a21672e96000a7$var$_numberArray = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("erJWs")));

var $42a21672e96000a7$var$_object = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("9fw2q")));

var $42a21672e96000a7$var$_round = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("djiCT")));

var $42a21672e96000a7$var$_string = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("3oWB9")));

var $dWRlu = parcelRequire("dWRlu");

var $42a21672e96000a7$var$_zoom = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("6fdTX")));

var $42a21672e96000a7$var$_rgb = $42a21672e96000a7$var$_interopRequireWildcard((parcelRequire("9WRbG")));

var $42a21672e96000a7$var$_hsl = $42a21672e96000a7$var$_interopRequireWildcard((parcelRequire("k6RL1")));

var $42a21672e96000a7$var$_lab = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("ie1Sm")));

var $42a21672e96000a7$var$_hcl = $42a21672e96000a7$var$_interopRequireWildcard((parcelRequire("7cfy1")));

var $42a21672e96000a7$var$_cubehelix = $42a21672e96000a7$var$_interopRequireWildcard((parcelRequire("3husi")));

var $42a21672e96000a7$var$_piecewise = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("eIJGP")));

var $42a21672e96000a7$var$_quantize = $42a21672e96000a7$var$_interopRequireDefault((parcelRequire("kQRuP")));
function $42a21672e96000a7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($42a21672e96000a7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $42a21672e96000a7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $42a21672e96000a7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $42a21672e96000a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("g45Ed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb216690028331ac$var$_default;

var $iVONV = parcelRequire("iVONV");

var $bb216690028331ac$var$_rgb = $bb216690028331ac$var$_interopRequireDefault((parcelRequire("9WRbG")));

var $hgNy5 = parcelRequire("hgNy5");

var $bb216690028331ac$var$_date = $bb216690028331ac$var$_interopRequireDefault((parcelRequire("74nvB")));

var $bb216690028331ac$var$_number = $bb216690028331ac$var$_interopRequireDefault((parcelRequire("likoE")));

var $bb216690028331ac$var$_object = $bb216690028331ac$var$_interopRequireDefault((parcelRequire("9fw2q")));

var $bb216690028331ac$var$_string = $bb216690028331ac$var$_interopRequireDefault((parcelRequire("3oWB9")));

var $bb216690028331ac$var$_constant = $bb216690028331ac$var$_interopRequireDefault((parcelRequire("8p02I")));

var $bb216690028331ac$var$_numberArray = $bb216690028331ac$var$_interopRequireWildcard((parcelRequire("erJWs")));
function $bb216690028331ac$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bb216690028331ac$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bb216690028331ac$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bb216690028331ac$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bb216690028331ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bb216690028331ac$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $bb216690028331ac$var$_constant.default)(b) : (t === "number" ? $bb216690028331ac$var$_number.default : t === "string" ? (c = (0, $iVONV.color)(b)) ? (b = c, $bb216690028331ac$var$_rgb.default) : $bb216690028331ac$var$_string.default : b instanceof $iVONV.color ? $bb216690028331ac$var$_rgb.default : b instanceof Date ? $bb216690028331ac$var$_date.default : (0, $bb216690028331ac$var$_numberArray.isNumberArray)(b) ? $bb216690028331ac$var$_numberArray.default : Array.isArray(b) ? $hgNy5.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $bb216690028331ac$var$_object.default : $bb216690028331ac$var$_number.default)(a, b);
}

});
parcelRegister("iVONV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $dc84f584f1d85c96$var$_color.rgb;
    }
});

var $dc84f584f1d85c96$var$_color = $dc84f584f1d85c96$var$_interopRequireWildcard((parcelRequire("ewNFb")));

var $dc84f584f1d85c96$var$_lab = $dc84f584f1d85c96$var$_interopRequireWildcard((parcelRequire("ax3uy")));

var $dc84f584f1d85c96$var$_cubehelix = $dc84f584f1d85c96$var$_interopRequireDefault((parcelRequire("7Y0yj")));
function $dc84f584f1d85c96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dc84f584f1d85c96$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dc84f584f1d85c96$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dc84f584f1d85c96$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dc84f584f1d85c96$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("ewNFb", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("7DTJ5")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("7DTJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $590766fc6e22f2c9$var$_default;
module.exports.extend = $590766fc6e22f2c9$var$extend;
function $590766fc6e22f2c9$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $590766fc6e22f2c9$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("ax3uy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $7aafb1d9219143a2$var$Hcl;
module.exports.Lab = $7aafb1d9219143a2$var$Lab;
module.exports.default = $7aafb1d9219143a2$var$lab;
module.exports.gray = $7aafb1d9219143a2$var$gray;
module.exports.hcl = $7aafb1d9219143a2$var$hcl;
module.exports.lch = $7aafb1d9219143a2$var$lch;

var $7aafb1d9219143a2$var$_define = $7aafb1d9219143a2$var$_interopRequireWildcard((parcelRequire("7DTJ5")));

var $ewNFb = parcelRequire("ewNFb");

var $1xXlv = parcelRequire("1xXlv");
function $7aafb1d9219143a2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7aafb1d9219143a2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7aafb1d9219143a2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7aafb1d9219143a2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $7aafb1d9219143a2$var$K = 18, $7aafb1d9219143a2$var$Xn = 0.96422, $7aafb1d9219143a2$var$Yn = 1, $7aafb1d9219143a2$var$Zn = 0.82521, $7aafb1d9219143a2$var$t0 = 4 / 29, $7aafb1d9219143a2$var$t1 = 6 / 29, $7aafb1d9219143a2$var$t2 = 3 * $7aafb1d9219143a2$var$t1 * $7aafb1d9219143a2$var$t1, $7aafb1d9219143a2$var$t3 = $7aafb1d9219143a2$var$t1 * $7aafb1d9219143a2$var$t1 * $7aafb1d9219143a2$var$t1;
function $7aafb1d9219143a2$var$labConvert(o) {
    if (o instanceof $7aafb1d9219143a2$var$Lab) return new $7aafb1d9219143a2$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $7aafb1d9219143a2$var$Hcl) return $7aafb1d9219143a2$var$hcl2lab(o);
    if (!(o instanceof $ewNFb.Rgb)) o = (0, $ewNFb.rgbConvert)(o);
    var r = $7aafb1d9219143a2$var$rgb2lrgb(o.r), g = $7aafb1d9219143a2$var$rgb2lrgb(o.g), b = $7aafb1d9219143a2$var$rgb2lrgb(o.b), y = $7aafb1d9219143a2$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $7aafb1d9219143a2$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $7aafb1d9219143a2$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $7aafb1d9219143a2$var$Xn);
        z = $7aafb1d9219143a2$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $7aafb1d9219143a2$var$Zn);
    }
    return new $7aafb1d9219143a2$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $7aafb1d9219143a2$var$gray(l, opacity) {
    return new $7aafb1d9219143a2$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $7aafb1d9219143a2$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $7aafb1d9219143a2$var$labConvert(l) : new $7aafb1d9219143a2$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $7aafb1d9219143a2$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $7aafb1d9219143a2$var$_define.default)($7aafb1d9219143a2$var$Lab, $7aafb1d9219143a2$var$lab, (0, $7aafb1d9219143a2$var$_define.extend)($ewNFb.Color, {
    brighter (k) {
        return new $7aafb1d9219143a2$var$Lab(this.l + $7aafb1d9219143a2$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $7aafb1d9219143a2$var$Lab(this.l - $7aafb1d9219143a2$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $7aafb1d9219143a2$var$Xn * $7aafb1d9219143a2$var$lab2xyz(x);
        y = $7aafb1d9219143a2$var$Yn * $7aafb1d9219143a2$var$lab2xyz(y);
        z = $7aafb1d9219143a2$var$Zn * $7aafb1d9219143a2$var$lab2xyz(z);
        return new $ewNFb.Rgb($7aafb1d9219143a2$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $7aafb1d9219143a2$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $7aafb1d9219143a2$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $7aafb1d9219143a2$var$xyz2lab(t) {
    return t > $7aafb1d9219143a2$var$t3 ? Math.pow(t, 1 / 3) : t / $7aafb1d9219143a2$var$t2 + $7aafb1d9219143a2$var$t0;
}
function $7aafb1d9219143a2$var$lab2xyz(t) {
    return t > $7aafb1d9219143a2$var$t1 ? t * t * t : $7aafb1d9219143a2$var$t2 * (t - $7aafb1d9219143a2$var$t0);
}
function $7aafb1d9219143a2$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $7aafb1d9219143a2$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $7aafb1d9219143a2$var$hclConvert(o) {
    if (o instanceof $7aafb1d9219143a2$var$Hcl) return new $7aafb1d9219143a2$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $7aafb1d9219143a2$var$Lab)) o = $7aafb1d9219143a2$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $7aafb1d9219143a2$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $1xXlv.degrees;
    return new $7aafb1d9219143a2$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $7aafb1d9219143a2$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $7aafb1d9219143a2$var$hclConvert(l) : new $7aafb1d9219143a2$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $7aafb1d9219143a2$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $7aafb1d9219143a2$var$hclConvert(h) : new $7aafb1d9219143a2$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $7aafb1d9219143a2$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $7aafb1d9219143a2$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $7aafb1d9219143a2$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $1xXlv.radians;
    return new $7aafb1d9219143a2$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $7aafb1d9219143a2$var$_define.default)($7aafb1d9219143a2$var$Hcl, $7aafb1d9219143a2$var$hcl, (0, $7aafb1d9219143a2$var$_define.extend)($ewNFb.Color, {
    brighter (k) {
        return new $7aafb1d9219143a2$var$Hcl(this.h, this.c, this.l + $7aafb1d9219143a2$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $7aafb1d9219143a2$var$Hcl(this.h, this.c, this.l - $7aafb1d9219143a2$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $7aafb1d9219143a2$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("1xXlv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $1206e85a9082fc90$var$radians = Math.PI / 180;
module.exports.radians = $1206e85a9082fc90$var$radians;
const $1206e85a9082fc90$var$degrees = 180 / Math.PI;
module.exports.degrees = $1206e85a9082fc90$var$degrees;

});


parcelRegister("7Y0yj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $5cce90b1f6355202$var$Cubehelix;
module.exports.default = $5cce90b1f6355202$var$cubehelix;

var $5cce90b1f6355202$var$_define = $5cce90b1f6355202$var$_interopRequireWildcard((parcelRequire("7DTJ5")));

var $ewNFb = parcelRequire("ewNFb");

var $1xXlv = parcelRequire("1xXlv");
function $5cce90b1f6355202$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5cce90b1f6355202$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5cce90b1f6355202$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5cce90b1f6355202$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $5cce90b1f6355202$var$A = -0.14861, $5cce90b1f6355202$var$B = 1.78277, $5cce90b1f6355202$var$C = -0.29227, $5cce90b1f6355202$var$D = -0.90649, $5cce90b1f6355202$var$E = 1.97294, $5cce90b1f6355202$var$ED = $5cce90b1f6355202$var$E * $5cce90b1f6355202$var$D, $5cce90b1f6355202$var$EB = $5cce90b1f6355202$var$E * $5cce90b1f6355202$var$B, $5cce90b1f6355202$var$BC_DA = $5cce90b1f6355202$var$B * $5cce90b1f6355202$var$C - $5cce90b1f6355202$var$D * $5cce90b1f6355202$var$A;
function $5cce90b1f6355202$var$cubehelixConvert(o) {
    if (o instanceof $5cce90b1f6355202$var$Cubehelix) return new $5cce90b1f6355202$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $ewNFb.Rgb)) o = (0, $ewNFb.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($5cce90b1f6355202$var$BC_DA * b + $5cce90b1f6355202$var$ED * r - $5cce90b1f6355202$var$EB * g) / ($5cce90b1f6355202$var$BC_DA + $5cce90b1f6355202$var$ED - $5cce90b1f6355202$var$EB), bl = b - l, k = ($5cce90b1f6355202$var$E * (g - l) - $5cce90b1f6355202$var$C * bl) / $5cce90b1f6355202$var$D, s = Math.sqrt(k * k + bl * bl) / ($5cce90b1f6355202$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $1xXlv.degrees - 120 : NaN;
    return new $5cce90b1f6355202$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $5cce90b1f6355202$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $5cce90b1f6355202$var$cubehelixConvert(h) : new $5cce90b1f6355202$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $5cce90b1f6355202$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $5cce90b1f6355202$var$_define.default)($5cce90b1f6355202$var$Cubehelix, $5cce90b1f6355202$var$cubehelix, (0, $5cce90b1f6355202$var$_define.extend)($ewNFb.Color, {
    brighter (k) {
        k = k == null ? $ewNFb.brighter : Math.pow($ewNFb.brighter, k);
        return new $5cce90b1f6355202$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $ewNFb.darker : Math.pow($ewNFb.darker, k);
        return new $5cce90b1f6355202$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $1xXlv.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $ewNFb.Rgb(255 * (l + a * ($5cce90b1f6355202$var$A * cosh + $5cce90b1f6355202$var$B * sinh)), 255 * (l + a * ($5cce90b1f6355202$var$C * cosh + $5cce90b1f6355202$var$D * sinh)), 255 * (l + a * ($5cce90b1f6355202$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("9WRbG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $iVONV = parcelRequire("iVONV");

var $73e2c9bf11f1bff3$var$_basis = $73e2c9bf11f1bff3$var$_interopRequireDefault((parcelRequire("8dabo")));

var $73e2c9bf11f1bff3$var$_basisClosed = $73e2c9bf11f1bff3$var$_interopRequireDefault((parcelRequire("k5Vl0")));

var $73e2c9bf11f1bff3$var$_color = $73e2c9bf11f1bff3$var$_interopRequireWildcard((parcelRequire("f2fuZ")));
function $73e2c9bf11f1bff3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($73e2c9bf11f1bff3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $73e2c9bf11f1bff3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $73e2c9bf11f1bff3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $73e2c9bf11f1bff3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $73e2c9bf11f1bff3$var$_default = function rgbGamma(y) {
    var color = (0, $73e2c9bf11f1bff3$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $iVONV.rgb)(start)).r, (end = (0, $iVONV.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $73e2c9bf11f1bff3$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $73e2c9bf11f1bff3$var$_default;
function $73e2c9bf11f1bff3$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $iVONV.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $73e2c9bf11f1bff3$var$rgbBasis = $73e2c9bf11f1bff3$var$rgbSpline($73e2c9bf11f1bff3$var$_basis.default);
module.exports.rgbBasis = $73e2c9bf11f1bff3$var$rgbBasis;
var $73e2c9bf11f1bff3$var$rgbBasisClosed = $73e2c9bf11f1bff3$var$rgbSpline($73e2c9bf11f1bff3$var$_basisClosed.default);
module.exports.rgbBasisClosed = $73e2c9bf11f1bff3$var$rgbBasisClosed;

});
parcelRegister("8dabo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $5fa76fb97952ec4a$var$basis;
module.exports.default = $5fa76fb97952ec4a$var$_default;
function $5fa76fb97952ec4a$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $5fa76fb97952ec4a$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $5fa76fb97952ec4a$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("k5Vl0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea10c05fcb2a5f51$var$_default;

var $8dabo = parcelRequire("8dabo");
function $ea10c05fcb2a5f51$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $8dabo.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("f2fuZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af2310abfb4210fb$var$nogamma;
module.exports.gamma = $af2310abfb4210fb$var$gamma;
module.exports.hue = $af2310abfb4210fb$var$hue;

var $af2310abfb4210fb$var$_constant = $af2310abfb4210fb$var$_interopRequireDefault((parcelRequire("8p02I")));
function $af2310abfb4210fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $af2310abfb4210fb$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $af2310abfb4210fb$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $af2310abfb4210fb$var$hue(a, b) {
    var d = b - a;
    return d ? $af2310abfb4210fb$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $af2310abfb4210fb$var$_constant.default)(isNaN(a) ? b : a);
}
function $af2310abfb4210fb$var$gamma(y) {
    return (y = +y) === 1 ? $af2310abfb4210fb$var$nogamma : function(a, b) {
        return b - a ? $af2310abfb4210fb$var$exponential(a, b, y) : (0, $af2310abfb4210fb$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $af2310abfb4210fb$var$nogamma(a, b) {
    var d = b - a;
    return d ? $af2310abfb4210fb$var$linear(a, d) : (0, $af2310abfb4210fb$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("8p02I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $61e0b1039c48fe60$var$_default = (x)=>()=>x;
module.exports.default = $61e0b1039c48fe60$var$_default;

});



parcelRegister("hgNy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c92a5da269303148$var$_default;
module.exports.genericArray = $c92a5da269303148$var$genericArray;

var $c92a5da269303148$var$_value = $c92a5da269303148$var$_interopRequireDefault((parcelRequire("g45Ed")));

var $c92a5da269303148$var$_numberArray = $c92a5da269303148$var$_interopRequireWildcard((parcelRequire("erJWs")));
function $c92a5da269303148$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c92a5da269303148$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c92a5da269303148$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c92a5da269303148$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c92a5da269303148$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c92a5da269303148$var$_default(a, b) {
    return ((0, $c92a5da269303148$var$_numberArray.isNumberArray)(b) ? $c92a5da269303148$var$_numberArray.default : $c92a5da269303148$var$genericArray)(a, b);
}
function $c92a5da269303148$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $c92a5da269303148$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("erJWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a847396327fe0af1$var$_default;
module.exports.isNumberArray = $a847396327fe0af1$var$isNumberArray;
function $a847396327fe0af1$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $a847396327fe0af1$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("74nvB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $525b2474eb316103$var$_default;
function $525b2474eb316103$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("likoE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f80b19bd87054168$var$_default;
function $f80b19bd87054168$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("9fw2q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bbe5de20a0a5cad$var$_default;

var $6bbe5de20a0a5cad$var$_value = $6bbe5de20a0a5cad$var$_interopRequireDefault((parcelRequire("g45Ed")));
function $6bbe5de20a0a5cad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6bbe5de20a0a5cad$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $6bbe5de20a0a5cad$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("3oWB9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $27a1115c26119f08$var$_default;

var $27a1115c26119f08$var$_number = $27a1115c26119f08$var$_interopRequireDefault((parcelRequire("likoE")));
function $27a1115c26119f08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $27a1115c26119f08$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $27a1115c26119f08$var$reB = new RegExp($27a1115c26119f08$var$reA.source, "g");
function $27a1115c26119f08$var$zero(b) {
    return function() {
        return b;
    };
}
function $27a1115c26119f08$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $27a1115c26119f08$var$_default(a, b) {
    var bi = $27a1115c26119f08$var$reA.lastIndex = $27a1115c26119f08$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $27a1115c26119f08$var$reA.exec(a)) && (bm = $27a1115c26119f08$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $27a1115c26119f08$var$_number.default)(am, bm)
            });
        }
        bi = $27a1115c26119f08$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $27a1115c26119f08$var$one(q[0].x) : $27a1115c26119f08$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("iRE5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbbc4514f386b5e1$var$_default;
function $dbbc4514f386b5e1$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("cvycw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $91b2e8e2d9dcde7b$var$_default;

var $f2fuZ = parcelRequire("f2fuZ");
function $91b2e8e2d9dcde7b$var$_default(a, b) {
    var i = (0, $f2fuZ.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("djiCT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b0b7f81153b7047$var$_default;
function $9b0b7f81153b7047$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("dWRlu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $a27a12758f348e38$var$_number = $a27a12758f348e38$var$_interopRequireDefault((parcelRequire("likoE")));

var $awphg = parcelRequire("awphg");
function $a27a12758f348e38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a27a12758f348e38$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $a27a12758f348e38$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $a27a12758f348e38$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $a27a12758f348e38$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $a27a12758f348e38$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $a27a12758f348e38$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $a27a12758f348e38$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $a27a12758f348e38$var$interpolateTransformCss = $a27a12758f348e38$var$interpolateTransform($awphg.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $a27a12758f348e38$var$interpolateTransformCss;
var $a27a12758f348e38$var$interpolateTransformSvg = $a27a12758f348e38$var$interpolateTransform($awphg.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $a27a12758f348e38$var$interpolateTransformSvg;

});
parcelRegister("awphg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $7a90801ead252a11$var$parseCss;
module.exports.parseSvg = $7a90801ead252a11$var$parseSvg;

var $7a90801ead252a11$var$_decompose = $7a90801ead252a11$var$_interopRequireWildcard((parcelRequire("5BDRQ")));
function $7a90801ead252a11$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7a90801ead252a11$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7a90801ead252a11$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7a90801ead252a11$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $7a90801ead252a11$var$svgNode;
/* eslint-disable no-undef */ function $7a90801ead252a11$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $7a90801ead252a11$var$_decompose.identity : (0, $7a90801ead252a11$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $7a90801ead252a11$var$parseSvg(value) {
    if (value == null) return $7a90801ead252a11$var$_decompose.identity;
    if (!$7a90801ead252a11$var$svgNode) $7a90801ead252a11$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $7a90801ead252a11$var$svgNode.setAttribute("transform", value);
    if (!(value = $7a90801ead252a11$var$svgNode.transform.baseVal.consolidate())) return $7a90801ead252a11$var$_decompose.identity;
    value = value.matrix;
    return (0, $7a90801ead252a11$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("5BDRQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $414f554b85550262$var$_default;
module.exports.identity = void 0;
var $414f554b85550262$var$degrees = 180 / Math.PI;
var $414f554b85550262$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $414f554b85550262$var$identity;
function $414f554b85550262$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $414f554b85550262$var$degrees,
        skewX: Math.atan(skewX) * $414f554b85550262$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("6fdTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $48beed549c43d015$var$epsilon2 = 1e-12;
function $48beed549c43d015$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $48beed549c43d015$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $48beed549c43d015$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $48beed549c43d015$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $48beed549c43d015$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $48beed549c43d015$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $48beed549c43d015$var$tanh(rho * s + r0) - $48beed549c43d015$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $48beed549c43d015$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $48beed549c43d015$var$_default;

});

parcelRegister("k6RL1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $iVONV = parcelRequire("iVONV");

var $ea3e114395ad3f02$var$_color = $ea3e114395ad3f02$var$_interopRequireWildcard((parcelRequire("f2fuZ")));
function $ea3e114395ad3f02$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ea3e114395ad3f02$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ea3e114395ad3f02$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ea3e114395ad3f02$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ea3e114395ad3f02$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $iVONV.hsl)(start)).h, (end = (0, $iVONV.hsl)(end)).h), s = (0, $ea3e114395ad3f02$var$_color.default)(start.s, end.s), l = (0, $ea3e114395ad3f02$var$_color.default)(start.l, end.l), opacity = (0, $ea3e114395ad3f02$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $ea3e114395ad3f02$var$_default = $ea3e114395ad3f02$var$hsl($ea3e114395ad3f02$var$_color.hue);
module.exports.default = $ea3e114395ad3f02$var$_default;
var $ea3e114395ad3f02$var$hslLong = $ea3e114395ad3f02$var$hsl($ea3e114395ad3f02$var$_color.default);
module.exports.hslLong = $ea3e114395ad3f02$var$hslLong;

});

parcelRegister("ie1Sm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d44afd4c401e6e87$var$lab;

var $iVONV = parcelRequire("iVONV");

var $d44afd4c401e6e87$var$_color = $d44afd4c401e6e87$var$_interopRequireDefault((parcelRequire("f2fuZ")));
function $d44afd4c401e6e87$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d44afd4c401e6e87$var$lab(start, end) {
    var l = (0, $d44afd4c401e6e87$var$_color.default)((start = (0, $iVONV.lab)(start)).l, (end = (0, $iVONV.lab)(end)).l), a = (0, $d44afd4c401e6e87$var$_color.default)(start.a, end.a), b = (0, $d44afd4c401e6e87$var$_color.default)(start.b, end.b), opacity = (0, $d44afd4c401e6e87$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("7cfy1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $iVONV = parcelRequire("iVONV");

var $53d5b6d5fc968676$var$_color = $53d5b6d5fc968676$var$_interopRequireWildcard((parcelRequire("f2fuZ")));
function $53d5b6d5fc968676$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($53d5b6d5fc968676$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $53d5b6d5fc968676$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $53d5b6d5fc968676$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $53d5b6d5fc968676$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $iVONV.hcl)(start)).h, (end = (0, $iVONV.hcl)(end)).h), c = (0, $53d5b6d5fc968676$var$_color.default)(start.c, end.c), l = (0, $53d5b6d5fc968676$var$_color.default)(start.l, end.l), opacity = (0, $53d5b6d5fc968676$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $53d5b6d5fc968676$var$_default = $53d5b6d5fc968676$var$hcl($53d5b6d5fc968676$var$_color.hue);
module.exports.default = $53d5b6d5fc968676$var$_default;
var $53d5b6d5fc968676$var$hclLong = $53d5b6d5fc968676$var$hcl($53d5b6d5fc968676$var$_color.default);
module.exports.hclLong = $53d5b6d5fc968676$var$hclLong;

});

parcelRegister("3husi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $iVONV = parcelRequire("iVONV");

var $263a95721149f0e6$var$_color = $263a95721149f0e6$var$_interopRequireWildcard((parcelRequire("f2fuZ")));
function $263a95721149f0e6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($263a95721149f0e6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $263a95721149f0e6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $263a95721149f0e6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $263a95721149f0e6$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $iVONV.cubehelix)(start)).h, (end = (0, $iVONV.cubehelix)(end)).h), s = (0, $263a95721149f0e6$var$_color.default)(start.s, end.s), l = (0, $263a95721149f0e6$var$_color.default)(start.l, end.l), opacity = (0, $263a95721149f0e6$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $263a95721149f0e6$var$_default = $263a95721149f0e6$var$cubehelix($263a95721149f0e6$var$_color.hue);
module.exports.default = $263a95721149f0e6$var$_default;
var $263a95721149f0e6$var$cubehelixLong = $263a95721149f0e6$var$cubehelix($263a95721149f0e6$var$_color.default);
module.exports.cubehelixLong = $263a95721149f0e6$var$cubehelixLong;

});

parcelRegister("eIJGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab789dc38d9eb185$var$piecewise;

var $ab789dc38d9eb185$var$_value = $ab789dc38d9eb185$var$_interopRequireDefault((parcelRequire("g45Ed")));
function $ab789dc38d9eb185$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ab789dc38d9eb185$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $ab789dc38d9eb185$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("kQRuP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2e2293765fda2ad$var$_default;
function $f2e2293765fda2ad$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("cuVoq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9194ce6d47961a08$var$constants;
function $9194ce6d47961a08$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("lPOmz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe556d735b59d3c5$var$number;
function $fe556d735b59d3c5$var$number(x) {
    return +x;
}

});


parcelRegister("6kKCb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49c8c513258f26c5$var$tickFormat;

var $5I0XU = parcelRequire("5I0XU");

var $9Co04 = parcelRequire("9Co04");
function $49c8c513258f26c5$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $5I0XU.tickStep)(start, stop, count), precision;
    specifier = (0, $9Co04.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $9Co04.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $9Co04.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $9Co04.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $9Co04.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $9Co04.format)(specifier);
}

});
parcelRegister("9Co04", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $700a479860477abc$var$_precisionRound.default;
    }
});

var $700a479860477abc$var$_defaultLocale = $700a479860477abc$var$_interopRequireWildcard((parcelRequire("iU1oN")));

var $700a479860477abc$var$_locale = $700a479860477abc$var$_interopRequireDefault((parcelRequire("2etRE")));

var $700a479860477abc$var$_formatSpecifier = $700a479860477abc$var$_interopRequireWildcard((parcelRequire("hXa1z")));

var $700a479860477abc$var$_precisionFixed = $700a479860477abc$var$_interopRequireDefault((parcelRequire("e9kxe")));

var $700a479860477abc$var$_precisionPrefix = $700a479860477abc$var$_interopRequireDefault((parcelRequire("gRWuP")));

var $700a479860477abc$var$_precisionRound = $700a479860477abc$var$_interopRequireDefault((parcelRequire("6Krqn")));
function $700a479860477abc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $700a479860477abc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($700a479860477abc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $700a479860477abc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $700a479860477abc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("iU1oN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc2e8ac681fe2118$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $dc2e8ac681fe2118$var$_locale = $dc2e8ac681fe2118$var$_interopRequireDefault((parcelRequire("2etRE")));
function $dc2e8ac681fe2118$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dc2e8ac681fe2118$var$locale;
var $dc2e8ac681fe2118$var$format;
module.exports.format = $dc2e8ac681fe2118$var$format;
var $dc2e8ac681fe2118$var$formatPrefix;
module.exports.formatPrefix = $dc2e8ac681fe2118$var$formatPrefix;
$dc2e8ac681fe2118$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $dc2e8ac681fe2118$var$defaultLocale(definition) {
    $dc2e8ac681fe2118$var$locale = (0, $dc2e8ac681fe2118$var$_locale.default)(definition);
    module.exports.format = $dc2e8ac681fe2118$var$format = $dc2e8ac681fe2118$var$locale.format;
    module.exports.formatPrefix = $dc2e8ac681fe2118$var$formatPrefix = $dc2e8ac681fe2118$var$locale.formatPrefix;
    return $dc2e8ac681fe2118$var$locale;
}

});
parcelRegister("2etRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a040e074bebf957$var$_default;

var $1a040e074bebf957$var$_exponent = $1a040e074bebf957$var$_interopRequireDefault((parcelRequire("78aeb")));

var $1a040e074bebf957$var$_formatGroup = $1a040e074bebf957$var$_interopRequireDefault((parcelRequire("hHUCC")));

var $1a040e074bebf957$var$_formatNumerals = $1a040e074bebf957$var$_interopRequireDefault((parcelRequire("aCSBo")));

var $1a040e074bebf957$var$_formatSpecifier = $1a040e074bebf957$var$_interopRequireDefault((parcelRequire("hXa1z")));

var $1a040e074bebf957$var$_formatTrim = $1a040e074bebf957$var$_interopRequireDefault((parcelRequire("7u4ae")));

var $1a040e074bebf957$var$_formatTypes = $1a040e074bebf957$var$_interopRequireDefault((parcelRequire("doDo3")));

var $dCImZ = parcelRequire("dCImZ");

var $1a040e074bebf957$var$_identity = $1a040e074bebf957$var$_interopRequireDefault((parcelRequire("SZND5")));
function $1a040e074bebf957$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1a040e074bebf957$var$map = Array.prototype.map, $1a040e074bebf957$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $1a040e074bebf957$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $1a040e074bebf957$var$_identity.default : (0, $1a040e074bebf957$var$_formatGroup.default)($1a040e074bebf957$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $1a040e074bebf957$var$_identity.default : (0, $1a040e074bebf957$var$_formatNumerals.default)($1a040e074bebf957$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $1a040e074bebf957$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$1a040e074bebf957$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $1a040e074bebf957$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $1a040e074bebf957$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $1a040e074bebf957$var$prefixes[8 + $dCImZ.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $1a040e074bebf957$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1a040e074bebf957$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $1a040e074bebf957$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("78aeb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $531136c443ee7fad$var$_default;

var $aqHcy = parcelRequire("aqHcy");
function $531136c443ee7fad$var$_default(x) {
    return x = (0, $aqHcy.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("aqHcy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $797dd7fc0fa99503$var$_default;
module.exports.formatDecimalParts = $797dd7fc0fa99503$var$formatDecimalParts;
function $797dd7fc0fa99503$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $797dd7fc0fa99503$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("hHUCC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce425fc4730d5863$var$_default;
function $ce425fc4730d5863$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("aCSBo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7bc7cedbaf4f8141$var$_default;
function $7bc7cedbaf4f8141$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("hXa1z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $d11fb8f7422baaf8$var$FormatSpecifier;
module.exports.default = $d11fb8f7422baaf8$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d11fb8f7422baaf8$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d11fb8f7422baaf8$var$formatSpecifier(specifier) {
    if (!(match = $d11fb8f7422baaf8$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d11fb8f7422baaf8$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d11fb8f7422baaf8$var$formatSpecifier.prototype = $d11fb8f7422baaf8$var$FormatSpecifier.prototype; // instanceof
function $d11fb8f7422baaf8$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d11fb8f7422baaf8$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("7u4ae", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $572e909f8c9abbda$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $572e909f8c9abbda$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("doDo3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c0c11b4edf36d7d$var$_formatDecimal = $9c0c11b4edf36d7d$var$_interopRequireDefault((parcelRequire("aqHcy")));

var $9c0c11b4edf36d7d$var$_formatPrefixAuto = $9c0c11b4edf36d7d$var$_interopRequireDefault((parcelRequire("dCImZ")));

var $9c0c11b4edf36d7d$var$_formatRounded = $9c0c11b4edf36d7d$var$_interopRequireDefault((parcelRequire("4b1Iv")));
function $9c0c11b4edf36d7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9c0c11b4edf36d7d$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $9c0c11b4edf36d7d$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $9c0c11b4edf36d7d$var$_formatRounded.default)(x * 100, p),
    "r": $9c0c11b4edf36d7d$var$_formatRounded.default,
    "s": $9c0c11b4edf36d7d$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $9c0c11b4edf36d7d$var$_default;

});
parcelRegister("dCImZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9eb13dea074f05f3$var$_default;
module.exports.prefixExponent = void 0;

var $aqHcy = parcelRequire("aqHcy");
var $9eb13dea074f05f3$var$prefixExponent;
module.exports.prefixExponent = $9eb13dea074f05f3$var$prefixExponent;
function $9eb13dea074f05f3$var$_default(x, p) {
    var d = (0, $aqHcy.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $9eb13dea074f05f3$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $aqHcy.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("4b1Iv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30a98574ae244fdb$var$_default;

var $aqHcy = parcelRequire("aqHcy");
function $30a98574ae244fdb$var$_default(x, p) {
    var d = (0, $aqHcy.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("SZND5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a54fb594baf8170$var$_default;
function $0a54fb594baf8170$var$_default(x) {
    return x;
}

});



parcelRegister("e9kxe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4d1d5c2fb3ca355$var$_default;

var $a4d1d5c2fb3ca355$var$_exponent = $a4d1d5c2fb3ca355$var$_interopRequireDefault((parcelRequire("78aeb")));
function $a4d1d5c2fb3ca355$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a4d1d5c2fb3ca355$var$_default(step) {
    return Math.max(0, -(0, $a4d1d5c2fb3ca355$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("gRWuP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c47ef8b1aa33070c$var$_default;

var $c47ef8b1aa33070c$var$_exponent = $c47ef8b1aa33070c$var$_interopRequireDefault((parcelRequire("78aeb")));
function $c47ef8b1aa33070c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c47ef8b1aa33070c$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $c47ef8b1aa33070c$var$_exponent.default)(value) / 3))) * 3 - (0, $c47ef8b1aa33070c$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("6Krqn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e9c4fdb560720f9$var$_default;

var $4e9c4fdb560720f9$var$_exponent = $4e9c4fdb560720f9$var$_interopRequireDefault((parcelRequire("78aeb")));
function $4e9c4fdb560720f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4e9c4fdb560720f9$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $4e9c4fdb560720f9$var$_exponent.default)(max) - (0, $4e9c4fdb560720f9$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("lgZ06", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7ca6909612b645c$var$log;
module.exports.loggish = $f7ca6909612b645c$var$loggish;

var $5I0XU = parcelRequire("5I0XU");

var $9Co04 = parcelRequire("9Co04");

var $f7ca6909612b645c$var$_nice = $f7ca6909612b645c$var$_interopRequireDefault((parcelRequire("de0PY")));

var $1zBvV = parcelRequire("1zBvV");

var $lO6tR = parcelRequire("lO6tR");
function $f7ca6909612b645c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7ca6909612b645c$var$transformLog(x) {
    return Math.log(x);
}
function $f7ca6909612b645c$var$transformExp(x) {
    return Math.exp(x);
}
function $f7ca6909612b645c$var$transformLogn(x) {
    return -Math.log(-x);
}
function $f7ca6909612b645c$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $f7ca6909612b645c$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $f7ca6909612b645c$var$powp(base) {
    return base === 10 ? $f7ca6909612b645c$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $f7ca6909612b645c$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $f7ca6909612b645c$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $f7ca6909612b645c$var$loggish(transform) {
    const scale = transform($f7ca6909612b645c$var$transformLog, $f7ca6909612b645c$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $f7ca6909612b645c$var$logp(base), pows = $f7ca6909612b645c$var$powp(base);
        if (domain()[0] < 0) {
            logs = $f7ca6909612b645c$var$reflect(logs), pows = $f7ca6909612b645c$var$reflect(pows);
            transform($f7ca6909612b645c$var$transformLogn, $f7ca6909612b645c$var$transformExpn);
        } else transform($f7ca6909612b645c$var$transformLog, $f7ca6909612b645c$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $5I0XU.ticks)(u, v, n);
        } else z = (0, $5I0XU.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $9Co04.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $9Co04.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $f7ca6909612b645c$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $f7ca6909612b645c$var$log() {
    const scale = $f7ca6909612b645c$var$loggish((0, $1zBvV.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $1zBvV.copy)(scale, $f7ca6909612b645c$var$log()).base(scale.base());
    $lO6tR.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("de0PY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a0d3b6a2afc0108$var$nice;
function $9a0d3b6a2afc0108$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("j6nO0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de810b1e7dc34a33$var$symlog;
module.exports.symlogish = $de810b1e7dc34a33$var$symlogish;

var $jOaL3 = parcelRequire("jOaL3");

var $1zBvV = parcelRequire("1zBvV");

var $lO6tR = parcelRequire("lO6tR");
function $de810b1e7dc34a33$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $de810b1e7dc34a33$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $de810b1e7dc34a33$var$symlogish(transform) {
    var c = 1, scale = transform($de810b1e7dc34a33$var$transformSymlog(c), $de810b1e7dc34a33$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($de810b1e7dc34a33$var$transformSymlog(c = +_), $de810b1e7dc34a33$var$transformSymexp(c)) : c;
    };
    return (0, $jOaL3.linearish)(scale);
}
function $de810b1e7dc34a33$var$symlog() {
    var scale = $de810b1e7dc34a33$var$symlogish((0, $1zBvV.transformer)());
    scale.copy = function() {
        return (0, $1zBvV.copy)(scale, $de810b1e7dc34a33$var$symlog()).constant(scale.constant());
    };
    return $lO6tR.initRange.apply(scale, arguments);
}

});

parcelRegister("kpRKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edcfd634e93ffc59$var$pow;
module.exports.powish = $edcfd634e93ffc59$var$powish;
module.exports.sqrt = $edcfd634e93ffc59$var$sqrt;

var $jOaL3 = parcelRequire("jOaL3");

var $1zBvV = parcelRequire("1zBvV");

var $lO6tR = parcelRequire("lO6tR");
function $edcfd634e93ffc59$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $edcfd634e93ffc59$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $edcfd634e93ffc59$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $edcfd634e93ffc59$var$powish(transform) {
    var scale = transform($1zBvV.identity, $1zBvV.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($1zBvV.identity, $1zBvV.identity) : exponent === 0.5 ? transform($edcfd634e93ffc59$var$transformSqrt, $edcfd634e93ffc59$var$transformSquare) : transform($edcfd634e93ffc59$var$transformPow(exponent), $edcfd634e93ffc59$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $jOaL3.linearish)(scale);
}
function $edcfd634e93ffc59$var$pow() {
    var scale = $edcfd634e93ffc59$var$powish((0, $1zBvV.transformer)());
    scale.copy = function() {
        return (0, $1zBvV.copy)(scale, $edcfd634e93ffc59$var$pow()).exponent(scale.exponent());
    };
    $lO6tR.initRange.apply(scale, arguments);
    return scale;
}
function $edcfd634e93ffc59$var$sqrt() {
    return $edcfd634e93ffc59$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("pDRfk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $04d140d849fcd48e$var$radial;

var $04d140d849fcd48e$var$_continuous = $04d140d849fcd48e$var$_interopRequireDefault((parcelRequire("1zBvV")));

var $lO6tR = parcelRequire("lO6tR");

var $jOaL3 = parcelRequire("jOaL3");

var $04d140d849fcd48e$var$_number = $04d140d849fcd48e$var$_interopRequireDefault((parcelRequire("lPOmz")));
function $04d140d849fcd48e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $04d140d849fcd48e$var$square(x) {
    return Math.sign(x) * x * x;
}
function $04d140d849fcd48e$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $04d140d849fcd48e$var$radial() {
    var squared = (0, $04d140d849fcd48e$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $04d140d849fcd48e$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($04d140d849fcd48e$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $04d140d849fcd48e$var$_number.default)).map($04d140d849fcd48e$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $04d140d849fcd48e$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $lO6tR.initRange.apply(scale, arguments);
    return (0, $jOaL3.linearish)(scale);
}

});

parcelRegister("kEh47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f084c7ec409f92e8$var$quantile;

var $5I0XU = parcelRequire("5I0XU");

var $lO6tR = parcelRequire("lO6tR");
function $f084c7ec409f92e8$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $5I0XU.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $5I0XU.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($5I0XU.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $f084c7ec409f92e8$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $lO6tR.initRange.apply(scale, arguments);
}

});

parcelRegister("i2qUz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d21d49f07e2cce3a$var$quantize;

var $5I0XU = parcelRequire("5I0XU");

var $jOaL3 = parcelRequire("jOaL3");

var $lO6tR = parcelRequire("lO6tR");
function $d21d49f07e2cce3a$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $5I0XU.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $d21d49f07e2cce3a$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $lO6tR.initRange.apply((0, $jOaL3.linearish)(scale), arguments);
}

});

parcelRegister("kda9Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb6ce70f8f4d314d$var$threshold;

var $5I0XU = parcelRequire("5I0XU");

var $lO6tR = parcelRequire("lO6tR");
function $eb6ce70f8f4d314d$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $5I0XU.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $eb6ce70f8f4d314d$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $lO6tR.initRange.apply(scale, arguments);
}

});

parcelRegister("ba19f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $820184db388aa551$var$calendar;
module.exports.default = $820184db388aa551$var$time;

var $jomHG = parcelRequire("jomHG");

var $77c3y = parcelRequire("77c3y");

var $820184db388aa551$var$_continuous = $820184db388aa551$var$_interopRequireWildcard((parcelRequire("1zBvV")));

var $lO6tR = parcelRequire("lO6tR");

var $820184db388aa551$var$_nice = $820184db388aa551$var$_interopRequireDefault((parcelRequire("de0PY")));
function $820184db388aa551$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $820184db388aa551$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($820184db388aa551$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $820184db388aa551$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $820184db388aa551$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $820184db388aa551$var$date(t) {
    return new Date(t);
}
function $820184db388aa551$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $820184db388aa551$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $820184db388aa551$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $820184db388aa551$var$number)) : domain().map($820184db388aa551$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $820184db388aa551$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $820184db388aa551$var$_continuous.copy)(scale, $820184db388aa551$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $820184db388aa551$var$time() {
    return $lO6tR.initRange.apply($820184db388aa551$var$calendar($jomHG.timeTicks, $jomHG.timeTickInterval, $jomHG.timeYear, $jomHG.timeMonth, $jomHG.timeWeek, $jomHG.timeDay, $jomHG.timeHour, $jomHG.timeMinute, $jomHG.timeSecond, $77c3y.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("jomHG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $jLnIv.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $jLnIv.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $jLnIv.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $jLnIv.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $jLnIv.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $jLnIv.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $jLnIv.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $jLnIv.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $jLnIv.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $jLnIv.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $iNAYF.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $iNAYF.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $jLnIv.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $jLnIv.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $jLnIv.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $jLnIv.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $jLnIv.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $jLnIv.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $iNAYF.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $iNAYF.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $IPLfx.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $e1e1deb0f0693ead$var$_utcYear.utcYears;
    }
});

var $e1e1deb0f0693ead$var$_interval = $e1e1deb0f0693ead$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $e1e1deb0f0693ead$var$_millisecond = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("hSvo1")));

var $e1e1deb0f0693ead$var$_second = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("jgXh0")));

var $e1e1deb0f0693ead$var$_minute = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("2AU1L")));

var $e1e1deb0f0693ead$var$_hour = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("euYCh")));

var $e1e1deb0f0693ead$var$_day = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("jULCx")));

var $jLnIv = parcelRequire("jLnIv");

var $e1e1deb0f0693ead$var$_month = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("6LTQr")));

var $e1e1deb0f0693ead$var$_year = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("dWURl")));

var $e1e1deb0f0693ead$var$_utcMinute = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("4UKP3")));

var $e1e1deb0f0693ead$var$_utcHour = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("eU35Q")));

var $e1e1deb0f0693ead$var$_utcDay = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("hkCM3")));

var $IPLfx = parcelRequire("IPLfx");

var $e1e1deb0f0693ead$var$_utcMonth = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("c5FMf")));

var $e1e1deb0f0693ead$var$_utcYear = $e1e1deb0f0693ead$var$_interopRequireWildcard((parcelRequire("2J1OA")));

var $iNAYF = parcelRequire("iNAYF");
function $e1e1deb0f0693ead$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e1e1deb0f0693ead$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e1e1deb0f0693ead$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e1e1deb0f0693ead$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e1e1deb0f0693ead$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("jXwUs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e87d0e27aeb75aa6$var$newInterval;
var $e87d0e27aeb75aa6$var$t0 = new Date(), $e87d0e27aeb75aa6$var$t1 = new Date();
function $e87d0e27aeb75aa6$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $e87d0e27aeb75aa6$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $e87d0e27aeb75aa6$var$t0.setTime(+start), $e87d0e27aeb75aa6$var$t1.setTime(+end);
            floori($e87d0e27aeb75aa6$var$t0), floori($e87d0e27aeb75aa6$var$t1);
            return Math.floor(count($e87d0e27aeb75aa6$var$t0, $e87d0e27aeb75aa6$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("hSvo1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $d03fd37d4a909bec$var$_interval = $d03fd37d4a909bec$var$_interopRequireDefault((parcelRequire("jXwUs")));
function $d03fd37d4a909bec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d03fd37d4a909bec$var$millisecond = (0, $d03fd37d4a909bec$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$d03fd37d4a909bec$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $d03fd37d4a909bec$var$millisecond;
    return (0, $d03fd37d4a909bec$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $d03fd37d4a909bec$var$_default = $d03fd37d4a909bec$var$millisecond;
module.exports.default = $d03fd37d4a909bec$var$_default;
var $d03fd37d4a909bec$var$milliseconds = $d03fd37d4a909bec$var$millisecond.range;
module.exports.milliseconds = $d03fd37d4a909bec$var$milliseconds;

});

parcelRegister("jgXh0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $e07d7d68b2b30dae$var$_interval = $e07d7d68b2b30dae$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $e07d7d68b2b30dae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e07d7d68b2b30dae$var$second = (0, $e07d7d68b2b30dae$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $eQHTI.durationSecond);
}, function(start, end) {
    return (end - start) / $eQHTI.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $e07d7d68b2b30dae$var$_default = $e07d7d68b2b30dae$var$second;
module.exports.default = $e07d7d68b2b30dae$var$_default;
var $e07d7d68b2b30dae$var$seconds = $e07d7d68b2b30dae$var$second.range;
module.exports.seconds = $e07d7d68b2b30dae$var$seconds;

});
parcelRegister("eQHTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $acf7f926befd3e39$var$durationSecond = 1000;
module.exports.durationSecond = $acf7f926befd3e39$var$durationSecond;
const $acf7f926befd3e39$var$durationMinute = $acf7f926befd3e39$var$durationSecond * 60;
module.exports.durationMinute = $acf7f926befd3e39$var$durationMinute;
const $acf7f926befd3e39$var$durationHour = $acf7f926befd3e39$var$durationMinute * 60;
module.exports.durationHour = $acf7f926befd3e39$var$durationHour;
const $acf7f926befd3e39$var$durationDay = $acf7f926befd3e39$var$durationHour * 24;
module.exports.durationDay = $acf7f926befd3e39$var$durationDay;
const $acf7f926befd3e39$var$durationWeek = $acf7f926befd3e39$var$durationDay * 7;
module.exports.durationWeek = $acf7f926befd3e39$var$durationWeek;
const $acf7f926befd3e39$var$durationMonth = $acf7f926befd3e39$var$durationDay * 30;
module.exports.durationMonth = $acf7f926befd3e39$var$durationMonth;
const $acf7f926befd3e39$var$durationYear = $acf7f926befd3e39$var$durationDay * 365;
module.exports.durationYear = $acf7f926befd3e39$var$durationYear;

});


parcelRegister("2AU1L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $1e3a6777107ae8ca$var$_interval = $1e3a6777107ae8ca$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $1e3a6777107ae8ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1e3a6777107ae8ca$var$minute = (0, $1e3a6777107ae8ca$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $eQHTI.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $eQHTI.durationMinute);
}, function(start, end) {
    return (end - start) / $eQHTI.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $1e3a6777107ae8ca$var$_default = $1e3a6777107ae8ca$var$minute;
module.exports.default = $1e3a6777107ae8ca$var$_default;
var $1e3a6777107ae8ca$var$minutes = $1e3a6777107ae8ca$var$minute.range;
module.exports.minutes = $1e3a6777107ae8ca$var$minutes;

});

parcelRegister("euYCh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $a8e2e332b8749655$var$_interval = $a8e2e332b8749655$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $a8e2e332b8749655$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a8e2e332b8749655$var$hour = (0, $a8e2e332b8749655$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $eQHTI.durationSecond - date.getMinutes() * $eQHTI.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $eQHTI.durationHour);
}, function(start, end) {
    return (end - start) / $eQHTI.durationHour;
}, function(date) {
    return date.getHours();
});
var $a8e2e332b8749655$var$_default = $a8e2e332b8749655$var$hour;
module.exports.default = $a8e2e332b8749655$var$_default;
var $a8e2e332b8749655$var$hours = $a8e2e332b8749655$var$hour.range;
module.exports.hours = $a8e2e332b8749655$var$hours;

});

parcelRegister("jULCx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $e7f82fb8c3724df3$var$_interval = $e7f82fb8c3724df3$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $e7f82fb8c3724df3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e7f82fb8c3724df3$var$day = (0, $e7f82fb8c3724df3$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $eQHTI.durationMinute) / $eQHTI.durationDay, (date)=>date.getDate() - 1);
var $e7f82fb8c3724df3$var$_default = $e7f82fb8c3724df3$var$day;
module.exports.default = $e7f82fb8c3724df3$var$_default;
var $e7f82fb8c3724df3$var$days = $e7f82fb8c3724df3$var$day.range;
module.exports.days = $e7f82fb8c3724df3$var$days;

});

parcelRegister("jLnIv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $e634cdc5b96d6fc9$var$_interval = $e634cdc5b96d6fc9$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $e634cdc5b96d6fc9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e634cdc5b96d6fc9$var$weekday(i) {
    return (0, $e634cdc5b96d6fc9$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $eQHTI.durationMinute) / $eQHTI.durationWeek;
    });
}
var $e634cdc5b96d6fc9$var$sunday = $e634cdc5b96d6fc9$var$weekday(0);
module.exports.sunday = $e634cdc5b96d6fc9$var$sunday;
var $e634cdc5b96d6fc9$var$monday = $e634cdc5b96d6fc9$var$weekday(1);
module.exports.monday = $e634cdc5b96d6fc9$var$monday;
var $e634cdc5b96d6fc9$var$tuesday = $e634cdc5b96d6fc9$var$weekday(2);
module.exports.tuesday = $e634cdc5b96d6fc9$var$tuesday;
var $e634cdc5b96d6fc9$var$wednesday = $e634cdc5b96d6fc9$var$weekday(3);
module.exports.wednesday = $e634cdc5b96d6fc9$var$wednesday;
var $e634cdc5b96d6fc9$var$thursday = $e634cdc5b96d6fc9$var$weekday(4);
module.exports.thursday = $e634cdc5b96d6fc9$var$thursday;
var $e634cdc5b96d6fc9$var$friday = $e634cdc5b96d6fc9$var$weekday(5);
module.exports.friday = $e634cdc5b96d6fc9$var$friday;
var $e634cdc5b96d6fc9$var$saturday = $e634cdc5b96d6fc9$var$weekday(6);
module.exports.saturday = $e634cdc5b96d6fc9$var$saturday;
var $e634cdc5b96d6fc9$var$sundays = $e634cdc5b96d6fc9$var$sunday.range;
module.exports.sundays = $e634cdc5b96d6fc9$var$sundays;
var $e634cdc5b96d6fc9$var$mondays = $e634cdc5b96d6fc9$var$monday.range;
module.exports.mondays = $e634cdc5b96d6fc9$var$mondays;
var $e634cdc5b96d6fc9$var$tuesdays = $e634cdc5b96d6fc9$var$tuesday.range;
module.exports.tuesdays = $e634cdc5b96d6fc9$var$tuesdays;
var $e634cdc5b96d6fc9$var$wednesdays = $e634cdc5b96d6fc9$var$wednesday.range;
module.exports.wednesdays = $e634cdc5b96d6fc9$var$wednesdays;
var $e634cdc5b96d6fc9$var$thursdays = $e634cdc5b96d6fc9$var$thursday.range;
module.exports.thursdays = $e634cdc5b96d6fc9$var$thursdays;
var $e634cdc5b96d6fc9$var$fridays = $e634cdc5b96d6fc9$var$friday.range;
module.exports.fridays = $e634cdc5b96d6fc9$var$fridays;
var $e634cdc5b96d6fc9$var$saturdays = $e634cdc5b96d6fc9$var$saturday.range;
module.exports.saturdays = $e634cdc5b96d6fc9$var$saturdays;

});

parcelRegister("6LTQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $4ee2737fabd3ab94$var$_interval = $4ee2737fabd3ab94$var$_interopRequireDefault((parcelRequire("jXwUs")));
function $4ee2737fabd3ab94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4ee2737fabd3ab94$var$month = (0, $4ee2737fabd3ab94$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $4ee2737fabd3ab94$var$_default = $4ee2737fabd3ab94$var$month;
module.exports.default = $4ee2737fabd3ab94$var$_default;
var $4ee2737fabd3ab94$var$months = $4ee2737fabd3ab94$var$month.range;
module.exports.months = $4ee2737fabd3ab94$var$months;

});

parcelRegister("dWURl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $a27ccc417e7c4c2b$var$_interval = $a27ccc417e7c4c2b$var$_interopRequireDefault((parcelRequire("jXwUs")));
function $a27ccc417e7c4c2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a27ccc417e7c4c2b$var$year = (0, $a27ccc417e7c4c2b$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$a27ccc417e7c4c2b$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $a27ccc417e7c4c2b$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $a27ccc417e7c4c2b$var$_default = $a27ccc417e7c4c2b$var$year;
module.exports.default = $a27ccc417e7c4c2b$var$_default;
var $a27ccc417e7c4c2b$var$years = $a27ccc417e7c4c2b$var$year.range;
module.exports.years = $a27ccc417e7c4c2b$var$years;

});

parcelRegister("4UKP3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $3940b65bb1c9d840$var$_interval = $3940b65bb1c9d840$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $3940b65bb1c9d840$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3940b65bb1c9d840$var$utcMinute = (0, $3940b65bb1c9d840$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $eQHTI.durationMinute);
}, function(start, end) {
    return (end - start) / $eQHTI.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $3940b65bb1c9d840$var$_default = $3940b65bb1c9d840$var$utcMinute;
module.exports.default = $3940b65bb1c9d840$var$_default;
var $3940b65bb1c9d840$var$utcMinutes = $3940b65bb1c9d840$var$utcMinute.range;
module.exports.utcMinutes = $3940b65bb1c9d840$var$utcMinutes;

});

parcelRegister("eU35Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $ad98b1ed49496478$var$_interval = $ad98b1ed49496478$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $ad98b1ed49496478$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ad98b1ed49496478$var$utcHour = (0, $ad98b1ed49496478$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $eQHTI.durationHour);
}, function(start, end) {
    return (end - start) / $eQHTI.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $ad98b1ed49496478$var$_default = $ad98b1ed49496478$var$utcHour;
module.exports.default = $ad98b1ed49496478$var$_default;
var $ad98b1ed49496478$var$utcHours = $ad98b1ed49496478$var$utcHour.range;
module.exports.utcHours = $ad98b1ed49496478$var$utcHours;

});

parcelRegister("hkCM3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $c9e261aa84fbc483$var$_interval = $c9e261aa84fbc483$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $c9e261aa84fbc483$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c9e261aa84fbc483$var$utcDay = (0, $c9e261aa84fbc483$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $eQHTI.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $c9e261aa84fbc483$var$_default = $c9e261aa84fbc483$var$utcDay;
module.exports.default = $c9e261aa84fbc483$var$_default;
var $c9e261aa84fbc483$var$utcDays = $c9e261aa84fbc483$var$utcDay.range;
module.exports.utcDays = $c9e261aa84fbc483$var$utcDays;

});

parcelRegister("IPLfx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $086c42d9770a1697$var$_interval = $086c42d9770a1697$var$_interopRequireDefault((parcelRequire("jXwUs")));

var $eQHTI = parcelRequire("eQHTI");
function $086c42d9770a1697$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $086c42d9770a1697$var$utcWeekday(i) {
    return (0, $086c42d9770a1697$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $eQHTI.durationWeek;
    });
}
var $086c42d9770a1697$var$utcSunday = $086c42d9770a1697$var$utcWeekday(0);
module.exports.utcSunday = $086c42d9770a1697$var$utcSunday;
var $086c42d9770a1697$var$utcMonday = $086c42d9770a1697$var$utcWeekday(1);
module.exports.utcMonday = $086c42d9770a1697$var$utcMonday;
var $086c42d9770a1697$var$utcTuesday = $086c42d9770a1697$var$utcWeekday(2);
module.exports.utcTuesday = $086c42d9770a1697$var$utcTuesday;
var $086c42d9770a1697$var$utcWednesday = $086c42d9770a1697$var$utcWeekday(3);
module.exports.utcWednesday = $086c42d9770a1697$var$utcWednesday;
var $086c42d9770a1697$var$utcThursday = $086c42d9770a1697$var$utcWeekday(4);
module.exports.utcThursday = $086c42d9770a1697$var$utcThursday;
var $086c42d9770a1697$var$utcFriday = $086c42d9770a1697$var$utcWeekday(5);
module.exports.utcFriday = $086c42d9770a1697$var$utcFriday;
var $086c42d9770a1697$var$utcSaturday = $086c42d9770a1697$var$utcWeekday(6);
module.exports.utcSaturday = $086c42d9770a1697$var$utcSaturday;
var $086c42d9770a1697$var$utcSundays = $086c42d9770a1697$var$utcSunday.range;
module.exports.utcSundays = $086c42d9770a1697$var$utcSundays;
var $086c42d9770a1697$var$utcMondays = $086c42d9770a1697$var$utcMonday.range;
module.exports.utcMondays = $086c42d9770a1697$var$utcMondays;
var $086c42d9770a1697$var$utcTuesdays = $086c42d9770a1697$var$utcTuesday.range;
module.exports.utcTuesdays = $086c42d9770a1697$var$utcTuesdays;
var $086c42d9770a1697$var$utcWednesdays = $086c42d9770a1697$var$utcWednesday.range;
module.exports.utcWednesdays = $086c42d9770a1697$var$utcWednesdays;
var $086c42d9770a1697$var$utcThursdays = $086c42d9770a1697$var$utcThursday.range;
module.exports.utcThursdays = $086c42d9770a1697$var$utcThursdays;
var $086c42d9770a1697$var$utcFridays = $086c42d9770a1697$var$utcFriday.range;
module.exports.utcFridays = $086c42d9770a1697$var$utcFridays;
var $086c42d9770a1697$var$utcSaturdays = $086c42d9770a1697$var$utcSaturday.range;
module.exports.utcSaturdays = $086c42d9770a1697$var$utcSaturdays;

});

parcelRegister("c5FMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $8cd65bba3cbb4ae1$var$_interval = $8cd65bba3cbb4ae1$var$_interopRequireDefault((parcelRequire("jXwUs")));
function $8cd65bba3cbb4ae1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8cd65bba3cbb4ae1$var$utcMonth = (0, $8cd65bba3cbb4ae1$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $8cd65bba3cbb4ae1$var$_default = $8cd65bba3cbb4ae1$var$utcMonth;
module.exports.default = $8cd65bba3cbb4ae1$var$_default;
var $8cd65bba3cbb4ae1$var$utcMonths = $8cd65bba3cbb4ae1$var$utcMonth.range;
module.exports.utcMonths = $8cd65bba3cbb4ae1$var$utcMonths;

});

parcelRegister("2J1OA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $1fc13128e13bd9b8$var$_interval = $1fc13128e13bd9b8$var$_interopRequireDefault((parcelRequire("jXwUs")));
function $1fc13128e13bd9b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1fc13128e13bd9b8$var$utcYear = (0, $1fc13128e13bd9b8$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$1fc13128e13bd9b8$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $1fc13128e13bd9b8$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $1fc13128e13bd9b8$var$_default = $1fc13128e13bd9b8$var$utcYear;
module.exports.default = $1fc13128e13bd9b8$var$_default;
var $1fc13128e13bd9b8$var$utcYears = $1fc13128e13bd9b8$var$utcYear.range;
module.exports.utcYears = $1fc13128e13bd9b8$var$utcYears;

});

parcelRegister("iNAYF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $5I0XU = parcelRequire("5I0XU");

var $eQHTI = parcelRequire("eQHTI");

var $daf97c8f075a706e$var$_millisecond = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("hSvo1")));

var $daf97c8f075a706e$var$_second = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("jgXh0")));

var $daf97c8f075a706e$var$_minute = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("2AU1L")));

var $daf97c8f075a706e$var$_hour = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("euYCh")));

var $daf97c8f075a706e$var$_day = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("jULCx")));

var $jLnIv = parcelRequire("jLnIv");

var $daf97c8f075a706e$var$_month = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("6LTQr")));

var $daf97c8f075a706e$var$_year = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("dWURl")));

var $daf97c8f075a706e$var$_utcMinute = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("4UKP3")));

var $daf97c8f075a706e$var$_utcHour = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("eU35Q")));

var $daf97c8f075a706e$var$_utcDay = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("hkCM3")));

var $IPLfx = parcelRequire("IPLfx");

var $daf97c8f075a706e$var$_utcMonth = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("c5FMf")));

var $daf97c8f075a706e$var$_utcYear = $daf97c8f075a706e$var$_interopRequireDefault((parcelRequire("2J1OA")));
function $daf97c8f075a706e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $daf97c8f075a706e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $daf97c8f075a706e$var$_second.default,
            1,
            $eQHTI.durationSecond
        ],
        [
            $daf97c8f075a706e$var$_second.default,
            5,
            5 * $eQHTI.durationSecond
        ],
        [
            $daf97c8f075a706e$var$_second.default,
            15,
            15 * $eQHTI.durationSecond
        ],
        [
            $daf97c8f075a706e$var$_second.default,
            30,
            30 * $eQHTI.durationSecond
        ],
        [
            minute,
            1,
            $eQHTI.durationMinute
        ],
        [
            minute,
            5,
            5 * $eQHTI.durationMinute
        ],
        [
            minute,
            15,
            15 * $eQHTI.durationMinute
        ],
        [
            minute,
            30,
            30 * $eQHTI.durationMinute
        ],
        [
            hour,
            1,
            $eQHTI.durationHour
        ],
        [
            hour,
            3,
            3 * $eQHTI.durationHour
        ],
        [
            hour,
            6,
            6 * $eQHTI.durationHour
        ],
        [
            hour,
            12,
            12 * $eQHTI.durationHour
        ],
        [
            day,
            1,
            $eQHTI.durationDay
        ],
        [
            day,
            2,
            2 * $eQHTI.durationDay
        ],
        [
            week,
            1,
            $eQHTI.durationWeek
        ],
        [
            month,
            1,
            $eQHTI.durationMonth
        ],
        [
            month,
            3,
            3 * $eQHTI.durationMonth
        ],
        [
            year,
            1,
            $eQHTI.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $5I0XU.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $5I0XU.tickStep)(start / $eQHTI.durationYear, stop / $eQHTI.durationYear, count));
        if (i === 0) return $daf97c8f075a706e$var$_millisecond.default.every(Math.max((0, $5I0XU.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$daf97c8f075a706e$var$utcTicks, $daf97c8f075a706e$var$utcTickInterval] = $daf97c8f075a706e$var$ticker($daf97c8f075a706e$var$_utcYear.default, $daf97c8f075a706e$var$_utcMonth.default, $IPLfx.utcSunday, $daf97c8f075a706e$var$_utcDay.default, $daf97c8f075a706e$var$_utcHour.default, $daf97c8f075a706e$var$_utcMinute.default);
module.exports.utcTickInterval = $daf97c8f075a706e$var$utcTickInterval;
module.exports.utcTicks = $daf97c8f075a706e$var$utcTicks;
const [$daf97c8f075a706e$var$timeTicks, $daf97c8f075a706e$var$timeTickInterval] = $daf97c8f075a706e$var$ticker($daf97c8f075a706e$var$_year.default, $daf97c8f075a706e$var$_month.default, $jLnIv.sunday, $daf97c8f075a706e$var$_day.default, $daf97c8f075a706e$var$_hour.default, $daf97c8f075a706e$var$_minute.default);
module.exports.timeTickInterval = $daf97c8f075a706e$var$timeTickInterval;
module.exports.timeTicks = $daf97c8f075a706e$var$timeTicks;

});


parcelRegister("77c3y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $52e28a005deeeb8b$var$_defaultLocale.utcParse;
    }
});

var $52e28a005deeeb8b$var$_defaultLocale = $52e28a005deeeb8b$var$_interopRequireWildcard((parcelRequire("8eBCR")));

var $52e28a005deeeb8b$var$_locale = $52e28a005deeeb8b$var$_interopRequireDefault((parcelRequire("4Jbam")));

var $52e28a005deeeb8b$var$_isoFormat = $52e28a005deeeb8b$var$_interopRequireDefault((parcelRequire("dvBix")));

var $52e28a005deeeb8b$var$_isoParse = $52e28a005deeeb8b$var$_interopRequireDefault((parcelRequire("aPCDQ")));
function $52e28a005deeeb8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52e28a005deeeb8b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($52e28a005deeeb8b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $52e28a005deeeb8b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $52e28a005deeeb8b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("8eBCR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5fecd1420a639673$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $5fecd1420a639673$var$_locale = $5fecd1420a639673$var$_interopRequireDefault((parcelRequire("4Jbam")));
function $5fecd1420a639673$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5fecd1420a639673$var$locale;
var $5fecd1420a639673$var$timeFormat;
module.exports.timeFormat = $5fecd1420a639673$var$timeFormat;
var $5fecd1420a639673$var$timeParse;
module.exports.timeParse = $5fecd1420a639673$var$timeParse;
var $5fecd1420a639673$var$utcFormat;
module.exports.utcFormat = $5fecd1420a639673$var$utcFormat;
var $5fecd1420a639673$var$utcParse;
module.exports.utcParse = $5fecd1420a639673$var$utcParse;
$5fecd1420a639673$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $5fecd1420a639673$var$defaultLocale(definition) {
    $5fecd1420a639673$var$locale = (0, $5fecd1420a639673$var$_locale.default)(definition);
    module.exports.timeFormat = $5fecd1420a639673$var$timeFormat = $5fecd1420a639673$var$locale.format;
    module.exports.timeParse = $5fecd1420a639673$var$timeParse = $5fecd1420a639673$var$locale.parse;
    module.exports.utcFormat = $5fecd1420a639673$var$utcFormat = $5fecd1420a639673$var$locale.utcFormat;
    module.exports.utcParse = $5fecd1420a639673$var$utcParse = $5fecd1420a639673$var$locale.utcParse;
    return $5fecd1420a639673$var$locale;
}

});
parcelRegister("4Jbam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $371406bc230c5776$var$formatLocale;

var $jomHG = parcelRequire("jomHG");
function $371406bc230c5776$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $371406bc230c5776$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $371406bc230c5776$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $371406bc230c5776$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $371406bc230c5776$var$formatRe(locale_periods), periodLookup = $371406bc230c5776$var$formatLookup(locale_periods), weekdayRe = $371406bc230c5776$var$formatRe(locale_weekdays), weekdayLookup = $371406bc230c5776$var$formatLookup(locale_weekdays), shortWeekdayRe = $371406bc230c5776$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $371406bc230c5776$var$formatLookup(locale_shortWeekdays), monthRe = $371406bc230c5776$var$formatRe(locale_months), monthLookup = $371406bc230c5776$var$formatLookup(locale_months), shortMonthRe = $371406bc230c5776$var$formatRe(locale_shortMonths), shortMonthLookup = $371406bc230c5776$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $371406bc230c5776$var$formatDayOfMonth,
        "e": $371406bc230c5776$var$formatDayOfMonth,
        "f": $371406bc230c5776$var$formatMicroseconds,
        "g": $371406bc230c5776$var$formatYearISO,
        "G": $371406bc230c5776$var$formatFullYearISO,
        "H": $371406bc230c5776$var$formatHour24,
        "I": $371406bc230c5776$var$formatHour12,
        "j": $371406bc230c5776$var$formatDayOfYear,
        "L": $371406bc230c5776$var$formatMilliseconds,
        "m": $371406bc230c5776$var$formatMonthNumber,
        "M": $371406bc230c5776$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $371406bc230c5776$var$formatUnixTimestamp,
        "s": $371406bc230c5776$var$formatUnixTimestampSeconds,
        "S": $371406bc230c5776$var$formatSeconds,
        "u": $371406bc230c5776$var$formatWeekdayNumberMonday,
        "U": $371406bc230c5776$var$formatWeekNumberSunday,
        "V": $371406bc230c5776$var$formatWeekNumberISO,
        "w": $371406bc230c5776$var$formatWeekdayNumberSunday,
        "W": $371406bc230c5776$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $371406bc230c5776$var$formatYear,
        "Y": $371406bc230c5776$var$formatFullYear,
        "Z": $371406bc230c5776$var$formatZone,
        "%": $371406bc230c5776$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $371406bc230c5776$var$formatUTCDayOfMonth,
        "e": $371406bc230c5776$var$formatUTCDayOfMonth,
        "f": $371406bc230c5776$var$formatUTCMicroseconds,
        "g": $371406bc230c5776$var$formatUTCYearISO,
        "G": $371406bc230c5776$var$formatUTCFullYearISO,
        "H": $371406bc230c5776$var$formatUTCHour24,
        "I": $371406bc230c5776$var$formatUTCHour12,
        "j": $371406bc230c5776$var$formatUTCDayOfYear,
        "L": $371406bc230c5776$var$formatUTCMilliseconds,
        "m": $371406bc230c5776$var$formatUTCMonthNumber,
        "M": $371406bc230c5776$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $371406bc230c5776$var$formatUnixTimestamp,
        "s": $371406bc230c5776$var$formatUnixTimestampSeconds,
        "S": $371406bc230c5776$var$formatUTCSeconds,
        "u": $371406bc230c5776$var$formatUTCWeekdayNumberMonday,
        "U": $371406bc230c5776$var$formatUTCWeekNumberSunday,
        "V": $371406bc230c5776$var$formatUTCWeekNumberISO,
        "w": $371406bc230c5776$var$formatUTCWeekdayNumberSunday,
        "W": $371406bc230c5776$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $371406bc230c5776$var$formatUTCYear,
        "Y": $371406bc230c5776$var$formatUTCFullYear,
        "Z": $371406bc230c5776$var$formatUTCZone,
        "%": $371406bc230c5776$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $371406bc230c5776$var$parseDayOfMonth,
        "e": $371406bc230c5776$var$parseDayOfMonth,
        "f": $371406bc230c5776$var$parseMicroseconds,
        "g": $371406bc230c5776$var$parseYear,
        "G": $371406bc230c5776$var$parseFullYear,
        "H": $371406bc230c5776$var$parseHour24,
        "I": $371406bc230c5776$var$parseHour24,
        "j": $371406bc230c5776$var$parseDayOfYear,
        "L": $371406bc230c5776$var$parseMilliseconds,
        "m": $371406bc230c5776$var$parseMonthNumber,
        "M": $371406bc230c5776$var$parseMinutes,
        "p": parsePeriod,
        "q": $371406bc230c5776$var$parseQuarter,
        "Q": $371406bc230c5776$var$parseUnixTimestamp,
        "s": $371406bc230c5776$var$parseUnixTimestampSeconds,
        "S": $371406bc230c5776$var$parseSeconds,
        "u": $371406bc230c5776$var$parseWeekdayNumberMonday,
        "U": $371406bc230c5776$var$parseWeekNumberSunday,
        "V": $371406bc230c5776$var$parseWeekNumberISO,
        "w": $371406bc230c5776$var$parseWeekdayNumberSunday,
        "W": $371406bc230c5776$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $371406bc230c5776$var$parseYear,
        "Y": $371406bc230c5776$var$parseFullYear,
        "Z": $371406bc230c5776$var$parseZone,
        "%": $371406bc230c5776$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $371406bc230c5776$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $371406bc230c5776$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $371406bc230c5776$var$utcDate($371406bc230c5776$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $jomHG.utcMonday.ceil(week) : (0, $jomHG.utcMonday)(week);
                    week = $jomHG.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $371406bc230c5776$var$localDate($371406bc230c5776$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $jomHG.timeMonday.ceil(week) : (0, $jomHG.timeMonday)(week);
                    week = $jomHG.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $371406bc230c5776$var$utcDate($371406bc230c5776$var$newDate(d.y, 0, 1)).getUTCDay() : $371406bc230c5776$var$localDate($371406bc230c5776$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $371406bc230c5776$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $371406bc230c5776$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $371406bc230c5776$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $371406bc230c5776$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $371406bc230c5776$var$numberRe = /^\s*\d+/, // note: ignores next directive
$371406bc230c5776$var$percentRe = /^%/, $371406bc230c5776$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $371406bc230c5776$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $371406bc230c5776$var$requote(s) {
    return s.replace($371406bc230c5776$var$requoteRe, "\\$&");
}
function $371406bc230c5776$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($371406bc230c5776$var$requote).join("|") + ")", "i");
}
function $371406bc230c5776$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $371406bc230c5776$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseWeekNumberSunday(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseWeekNumberISO(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseWeekNumberMonday(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseFullYear(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseYear(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseQuarter(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseMonthNumber(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseDayOfMonth(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseDayOfYear(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseHour24(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseMinutes(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseSeconds(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseMilliseconds(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseMicroseconds(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseLiteralPercent(d, string, i) {
    var n = $371406bc230c5776$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $371406bc230c5776$var$parseUnixTimestamp(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $371406bc230c5776$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $371406bc230c5776$var$formatDayOfMonth(d, p) {
    return $371406bc230c5776$var$pad(d.getDate(), p, 2);
}
function $371406bc230c5776$var$formatHour24(d, p) {
    return $371406bc230c5776$var$pad(d.getHours(), p, 2);
}
function $371406bc230c5776$var$formatHour12(d, p) {
    return $371406bc230c5776$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $371406bc230c5776$var$formatDayOfYear(d, p) {
    return $371406bc230c5776$var$pad(1 + $jomHG.timeDay.count((0, $jomHG.timeYear)(d), d), p, 3);
}
function $371406bc230c5776$var$formatMilliseconds(d, p) {
    return $371406bc230c5776$var$pad(d.getMilliseconds(), p, 3);
}
function $371406bc230c5776$var$formatMicroseconds(d, p) {
    return $371406bc230c5776$var$formatMilliseconds(d, p) + "000";
}
function $371406bc230c5776$var$formatMonthNumber(d, p) {
    return $371406bc230c5776$var$pad(d.getMonth() + 1, p, 2);
}
function $371406bc230c5776$var$formatMinutes(d, p) {
    return $371406bc230c5776$var$pad(d.getMinutes(), p, 2);
}
function $371406bc230c5776$var$formatSeconds(d, p) {
    return $371406bc230c5776$var$pad(d.getSeconds(), p, 2);
}
function $371406bc230c5776$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $371406bc230c5776$var$formatWeekNumberSunday(d, p) {
    return $371406bc230c5776$var$pad($jomHG.timeSunday.count((0, $jomHG.timeYear)(d) - 1, d), p, 2);
}
function $371406bc230c5776$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $jomHG.timeThursday)(d) : $jomHG.timeThursday.ceil(d);
}
function $371406bc230c5776$var$formatWeekNumberISO(d, p) {
    d = $371406bc230c5776$var$dISO(d);
    return $371406bc230c5776$var$pad($jomHG.timeThursday.count((0, $jomHG.timeYear)(d), d) + ((0, $jomHG.timeYear)(d).getDay() === 4), p, 2);
}
function $371406bc230c5776$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $371406bc230c5776$var$formatWeekNumberMonday(d, p) {
    return $371406bc230c5776$var$pad($jomHG.timeMonday.count((0, $jomHG.timeYear)(d) - 1, d), p, 2);
}
function $371406bc230c5776$var$formatYear(d, p) {
    return $371406bc230c5776$var$pad(d.getFullYear() % 100, p, 2);
}
function $371406bc230c5776$var$formatYearISO(d, p) {
    d = $371406bc230c5776$var$dISO(d);
    return $371406bc230c5776$var$pad(d.getFullYear() % 100, p, 2);
}
function $371406bc230c5776$var$formatFullYear(d, p) {
    return $371406bc230c5776$var$pad(d.getFullYear() % 10000, p, 4);
}
function $371406bc230c5776$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $jomHG.timeThursday)(d) : $jomHG.timeThursday.ceil(d);
    return $371406bc230c5776$var$pad(d.getFullYear() % 10000, p, 4);
}
function $371406bc230c5776$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $371406bc230c5776$var$pad(z / 60 | 0, "0", 2) + $371406bc230c5776$var$pad(z % 60, "0", 2);
}
function $371406bc230c5776$var$formatUTCDayOfMonth(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCDate(), p, 2);
}
function $371406bc230c5776$var$formatUTCHour24(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCHours(), p, 2);
}
function $371406bc230c5776$var$formatUTCHour12(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $371406bc230c5776$var$formatUTCDayOfYear(d, p) {
    return $371406bc230c5776$var$pad(1 + $jomHG.utcDay.count((0, $jomHG.utcYear)(d), d), p, 3);
}
function $371406bc230c5776$var$formatUTCMilliseconds(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $371406bc230c5776$var$formatUTCMicroseconds(d, p) {
    return $371406bc230c5776$var$formatUTCMilliseconds(d, p) + "000";
}
function $371406bc230c5776$var$formatUTCMonthNumber(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $371406bc230c5776$var$formatUTCMinutes(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCMinutes(), p, 2);
}
function $371406bc230c5776$var$formatUTCSeconds(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCSeconds(), p, 2);
}
function $371406bc230c5776$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $371406bc230c5776$var$formatUTCWeekNumberSunday(d, p) {
    return $371406bc230c5776$var$pad($jomHG.utcSunday.count((0, $jomHG.utcYear)(d) - 1, d), p, 2);
}
function $371406bc230c5776$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $jomHG.utcThursday)(d) : $jomHG.utcThursday.ceil(d);
}
function $371406bc230c5776$var$formatUTCWeekNumberISO(d, p) {
    d = $371406bc230c5776$var$UTCdISO(d);
    return $371406bc230c5776$var$pad($jomHG.utcThursday.count((0, $jomHG.utcYear)(d), d) + ((0, $jomHG.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $371406bc230c5776$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $371406bc230c5776$var$formatUTCWeekNumberMonday(d, p) {
    return $371406bc230c5776$var$pad($jomHG.utcMonday.count((0, $jomHG.utcYear)(d) - 1, d), p, 2);
}
function $371406bc230c5776$var$formatUTCYear(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $371406bc230c5776$var$formatUTCYearISO(d, p) {
    d = $371406bc230c5776$var$UTCdISO(d);
    return $371406bc230c5776$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $371406bc230c5776$var$formatUTCFullYear(d, p) {
    return $371406bc230c5776$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $371406bc230c5776$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $jomHG.utcThursday)(d) : $jomHG.utcThursday.ceil(d);
    return $371406bc230c5776$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $371406bc230c5776$var$formatUTCZone() {
    return "+0000";
}
function $371406bc230c5776$var$formatLiteralPercent() {
    return "%";
}
function $371406bc230c5776$var$formatUnixTimestamp(d) {
    return +d;
}
function $371406bc230c5776$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("dvBix", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $8eBCR = parcelRequire("8eBCR");
var $9d5b1a3e7000c62e$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $9d5b1a3e7000c62e$var$isoSpecifier;
function $9d5b1a3e7000c62e$var$formatIsoNative(date) {
    return date.toISOString();
}
var $9d5b1a3e7000c62e$var$formatIso = Date.prototype.toISOString ? $9d5b1a3e7000c62e$var$formatIsoNative : (0, $8eBCR.utcFormat)($9d5b1a3e7000c62e$var$isoSpecifier);
var $9d5b1a3e7000c62e$var$_default = $9d5b1a3e7000c62e$var$formatIso;
module.exports.default = $9d5b1a3e7000c62e$var$_default;

});

parcelRegister("aPCDQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dvBix = parcelRequire("dvBix");

var $8eBCR = parcelRequire("8eBCR");
function $7e2ca43a5b1583ba$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $7e2ca43a5b1583ba$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $7e2ca43a5b1583ba$var$parseIsoNative : (0, $8eBCR.utcParse)($dvBix.isoSpecifier);
var $7e2ca43a5b1583ba$var$_default = $7e2ca43a5b1583ba$var$parseIso;
module.exports.default = $7e2ca43a5b1583ba$var$_default;

});



parcelRegister("fy5x8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b51e52d425d1ddc7$var$utcTime;

var $jomHG = parcelRequire("jomHG");

var $77c3y = parcelRequire("77c3y");

var $ba19f = parcelRequire("ba19f");

var $lO6tR = parcelRequire("lO6tR");
function $b51e52d425d1ddc7$var$utcTime() {
    return $lO6tR.initRange.apply((0, $ba19f.calendar)($jomHG.utcTicks, $jomHG.utcTickInterval, $jomHG.utcYear, $jomHG.utcMonth, $jomHG.utcWeek, $jomHG.utcDay, $jomHG.utcHour, $jomHG.utcMinute, $jomHG.utcSecond, $77c3y.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("6doRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $48673e7c075570df$var$copy;
module.exports.default = $48673e7c075570df$var$sequential;
module.exports.sequentialLog = $48673e7c075570df$var$sequentialLog;
module.exports.sequentialPow = $48673e7c075570df$var$sequentialPow;
module.exports.sequentialSqrt = $48673e7c075570df$var$sequentialSqrt;
module.exports.sequentialSymlog = $48673e7c075570df$var$sequentialSymlog;

var $5IGzK = parcelRequire("5IGzK");

var $1zBvV = parcelRequire("1zBvV");

var $lO6tR = parcelRequire("lO6tR");

var $jOaL3 = parcelRequire("jOaL3");

var $lgZ06 = parcelRequire("lgZ06");

var $j6nO0 = parcelRequire("j6nO0");

var $kpRKB = parcelRequire("kpRKB");
function $48673e7c075570df$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $1zBvV.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($5IGzK.interpolate);
    scale.rangeRound = range($5IGzK.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $48673e7c075570df$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $48673e7c075570df$var$sequential() {
    var scale = (0, $jOaL3.linearish)($48673e7c075570df$var$transformer()($1zBvV.identity));
    scale.copy = function() {
        return $48673e7c075570df$var$copy(scale, $48673e7c075570df$var$sequential());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $48673e7c075570df$var$sequentialLog() {
    var scale = (0, $lgZ06.loggish)($48673e7c075570df$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $48673e7c075570df$var$copy(scale, $48673e7c075570df$var$sequentialLog()).base(scale.base());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $48673e7c075570df$var$sequentialSymlog() {
    var scale = (0, $j6nO0.symlogish)($48673e7c075570df$var$transformer());
    scale.copy = function() {
        return $48673e7c075570df$var$copy(scale, $48673e7c075570df$var$sequentialSymlog()).constant(scale.constant());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $48673e7c075570df$var$sequentialPow() {
    var scale = (0, $kpRKB.powish)($48673e7c075570df$var$transformer());
    scale.copy = function() {
        return $48673e7c075570df$var$copy(scale, $48673e7c075570df$var$sequentialPow()).exponent(scale.exponent());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $48673e7c075570df$var$sequentialSqrt() {
    return $48673e7c075570df$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("5Kjlt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42f04138aed6d86c$var$sequentialQuantile;

var $5I0XU = parcelRequire("5I0XU");

var $1zBvV = parcelRequire("1zBvV");

var $lO6tR = parcelRequire("lO6tR");
function $42f04138aed6d86c$var$sequentialQuantile() {
    var domain = [], interpolator = $1zBvV.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $5I0XU.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($5I0XU.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $5I0XU.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $42f04138aed6d86c$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("7PlAi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b2e0a0bdd69b6a8$var$diverging;
module.exports.divergingLog = $5b2e0a0bdd69b6a8$var$divergingLog;
module.exports.divergingPow = $5b2e0a0bdd69b6a8$var$divergingPow;
module.exports.divergingSqrt = $5b2e0a0bdd69b6a8$var$divergingSqrt;
module.exports.divergingSymlog = $5b2e0a0bdd69b6a8$var$divergingSymlog;

var $5IGzK = parcelRequire("5IGzK");

var $1zBvV = parcelRequire("1zBvV");

var $lO6tR = parcelRequire("lO6tR");

var $jOaL3 = parcelRequire("jOaL3");

var $lgZ06 = parcelRequire("lgZ06");

var $6doRD = parcelRequire("6doRD");

var $j6nO0 = parcelRequire("j6nO0");

var $kpRKB = parcelRequire("kpRKB");
function $5b2e0a0bdd69b6a8$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $1zBvV.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $5IGzK.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($5IGzK.interpolate);
    scale.rangeRound = range($5IGzK.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $5b2e0a0bdd69b6a8$var$diverging() {
    var scale = (0, $jOaL3.linearish)($5b2e0a0bdd69b6a8$var$transformer()($1zBvV.identity));
    scale.copy = function() {
        return (0, $6doRD.copy)(scale, $5b2e0a0bdd69b6a8$var$diverging());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $5b2e0a0bdd69b6a8$var$divergingLog() {
    var scale = (0, $lgZ06.loggish)($5b2e0a0bdd69b6a8$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $6doRD.copy)(scale, $5b2e0a0bdd69b6a8$var$divergingLog()).base(scale.base());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $5b2e0a0bdd69b6a8$var$divergingSymlog() {
    var scale = (0, $j6nO0.symlogish)($5b2e0a0bdd69b6a8$var$transformer());
    scale.copy = function() {
        return (0, $6doRD.copy)(scale, $5b2e0a0bdd69b6a8$var$divergingSymlog()).constant(scale.constant());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $5b2e0a0bdd69b6a8$var$divergingPow() {
    var scale = (0, $kpRKB.powish)($5b2e0a0bdd69b6a8$var$transformer());
    scale.copy = function() {
        return (0, $6doRD.copy)(scale, $5b2e0a0bdd69b6a8$var$divergingPow()).exponent(scale.exponent());
    };
    return $lO6tR.initInterpolator.apply(scale, arguments);
}
function $5b2e0a0bdd69b6a8$var$divergingSqrt() {
    return $5b2e0a0bdd69b6a8$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("bdrlo", function(module, exports) {
module.exports = JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');

});

parcelRegister("gOYUZ", function(module, exports) {
(function() {
    var debug = false;
    var root = this;
    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };
    if (0, module.exports) exports = module.exports = EXIF;
    exports.EXIF = EXIF;
    var ExifTags = EXIF.Tags = {
        // version tags
        0x9000: "ExifVersion",
        0xA000: "FlashpixVersion",
        // colorspace tags
        0xA001: "ColorSpace",
        // image configuration
        0xA002: "PixelXDimension",
        0xA003: "PixelYDimension",
        0x9101: "ComponentsConfiguration",
        0x9102: "CompressedBitsPerPixel",
        // user information
        0x927C: "MakerNote",
        0x9286: "UserComment",
        // related file
        0xA004: "RelatedSoundFile",
        // date and time
        0x9003: "DateTimeOriginal",
        0x9004: "DateTimeDigitized",
        0x9290: "SubsecTime",
        0x9291: "SubsecTimeOriginal",
        0x9292: "SubsecTimeDigitized",
        // picture-taking conditions
        0x829A: "ExposureTime",
        0x829D: "FNumber",
        0x8822: "ExposureProgram",
        0x8824: "SpectralSensitivity",
        0x8827: "ISOSpeedRatings",
        0x8828: "OECF",
        0x9201: "ShutterSpeedValue",
        0x9202: "ApertureValue",
        0x9203: "BrightnessValue",
        0x9204: "ExposureBias",
        0x9205: "MaxApertureValue",
        0x9206: "SubjectDistance",
        0x9207: "MeteringMode",
        0x9208: "LightSource",
        0x9209: "Flash",
        0x9214: "SubjectArea",
        0x920A: "FocalLength",
        0xA20B: "FlashEnergy",
        0xA20C: "SpatialFrequencyResponse",
        0xA20E: "FocalPlaneXResolution",
        0xA20F: "FocalPlaneYResolution",
        0xA210: "FocalPlaneResolutionUnit",
        0xA214: "SubjectLocation",
        0xA215: "ExposureIndex",
        0xA217: "SensingMethod",
        0xA300: "FileSource",
        0xA301: "SceneType",
        0xA302: "CFAPattern",
        0xA401: "CustomRendered",
        0xA402: "ExposureMode",
        0xA403: "WhiteBalance",
        0xA404: "DigitalZoomRation",
        0xA405: "FocalLengthIn35mmFilm",
        0xA406: "SceneCaptureType",
        0xA407: "GainControl",
        0xA408: "Contrast",
        0xA409: "Saturation",
        0xA40A: "Sharpness",
        0xA40B: "DeviceSettingDescription",
        0xA40C: "SubjectDistanceRange",
        // other tags
        0xA005: "InteroperabilityIFDPointer",
        0xA420: "ImageUniqueID" // Identifier assigned uniquely to each image
    };
    var TiffTags = EXIF.TiffTags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x8769: "ExifIFDPointer",
        0x8825: "GPSInfoIFDPointer",
        0xA005: "InteroperabilityIFDPointer",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x011C: "PlanarConfiguration",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x0128: "ResolutionUnit",
        0x0111: "StripOffsets",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x0201: "JPEGInterchangeFormat",
        0x0202: "JPEGInterchangeFormatLength",
        0x012D: "TransferFunction",
        0x013E: "WhitePoint",
        0x013F: "PrimaryChromaticities",
        0x0211: "YCbCrCoefficients",
        0x0214: "ReferenceBlackWhite",
        0x0132: "DateTime",
        0x010E: "ImageDescription",
        0x010F: "Make",
        0x0110: "Model",
        0x0131: "Software",
        0x013B: "Artist",
        0x8298: "Copyright"
    };
    var GPSTags = EXIF.GPSTags = {
        0x0000: "GPSVersionID",
        0x0001: "GPSLatitudeRef",
        0x0002: "GPSLatitude",
        0x0003: "GPSLongitudeRef",
        0x0004: "GPSLongitude",
        0x0005: "GPSAltitudeRef",
        0x0006: "GPSAltitude",
        0x0007: "GPSTimeStamp",
        0x0008: "GPSSatellites",
        0x0009: "GPSStatus",
        0x000A: "GPSMeasureMode",
        0x000B: "GPSDOP",
        0x000C: "GPSSpeedRef",
        0x000D: "GPSSpeed",
        0x000E: "GPSTrackRef",
        0x000F: "GPSTrack",
        0x0010: "GPSImgDirectionRef",
        0x0011: "GPSImgDirection",
        0x0012: "GPSMapDatum",
        0x0013: "GPSDestLatitudeRef",
        0x0014: "GPSDestLatitude",
        0x0015: "GPSDestLongitudeRef",
        0x0016: "GPSDestLongitude",
        0x0017: "GPSDestBearingRef",
        0x0018: "GPSDestBearing",
        0x0019: "GPSDestDistanceRef",
        0x001A: "GPSDestDistance",
        0x001B: "GPSProcessingMethod",
        0x001C: "GPSAreaInformation",
        0x001D: "GPSDateStamp",
        0x001E: "GPSDifferential"
    };
    // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",
        0x0202: "JpegIFByteCount",
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };
    var StringValues = EXIF.StringValues = {
        ExposureProgram: {
            0: "Not defined",
            1: "Manual",
            2: "Normal program",
            3: "Aperture priority",
            4: "Shutter priority",
            5: "Creative program",
            6: "Action program",
            7: "Portrait mode",
            8: "Landscape mode"
        },
        MeteringMode: {
            0: "Unknown",
            1: "Average",
            2: "CenterWeightedAverage",
            3: "Spot",
            4: "MultiSpot",
            5: "Pattern",
            6: "Partial",
            255: "Other"
        },
        LightSource: {
            0: "Unknown",
            1: "Daylight",
            2: "Fluorescent",
            3: "Tungsten (incandescent light)",
            4: "Flash",
            9: "Fine weather",
            10: "Cloudy weather",
            11: "Shade",
            12: "Daylight fluorescent (D 5700 - 7100K)",
            13: "Day white fluorescent (N 4600 - 5400K)",
            14: "Cool white fluorescent (W 3900 - 4500K)",
            15: "White fluorescent (WW 3200 - 3700K)",
            17: "Standard light A",
            18: "Standard light B",
            19: "Standard light C",
            20: "D55",
            21: "D65",
            22: "D75",
            23: "D50",
            24: "ISO studio tungsten",
            255: "Other"
        },
        Flash: {
            0x0000: "Flash did not fire",
            0x0001: "Flash fired",
            0x0005: "Strobe return light not detected",
            0x0007: "Strobe return light detected",
            0x0009: "Flash fired, compulsory flash mode",
            0x000D: "Flash fired, compulsory flash mode, return light not detected",
            0x000F: "Flash fired, compulsory flash mode, return light detected",
            0x0010: "Flash did not fire, compulsory flash mode",
            0x0018: "Flash did not fire, auto mode",
            0x0019: "Flash fired, auto mode",
            0x001D: "Flash fired, auto mode, return light not detected",
            0x001F: "Flash fired, auto mode, return light detected",
            0x0020: "No flash function",
            0x0041: "Flash fired, red-eye reduction mode",
            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
            0x0047: "Flash fired, red-eye reduction mode, return light detected",
            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059: "Flash fired, auto mode, red-eye reduction mode",
            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
            1: "Not defined",
            2: "One-chip color area sensor",
            3: "Two-chip color area sensor",
            4: "Three-chip color area sensor",
            5: "Color sequential area sensor",
            7: "Trilinear sensor",
            8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
            0: "Standard",
            1: "Landscape",
            2: "Portrait",
            3: "Night scene"
        },
        SceneType: {
            1: "Directly photographed"
        },
        CustomRendered: {
            0: "Normal process",
            1: "Custom process"
        },
        WhiteBalance: {
            0: "Auto white balance",
            1: "Manual white balance"
        },
        GainControl: {
            0: "None",
            1: "Low gain up",
            2: "High gain up",
            3: "Low gain down",
            4: "High gain down"
        },
        Contrast: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        Saturation: {
            0: "Normal",
            1: "Low saturation",
            2: "High saturation"
        },
        Sharpness: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        SubjectDistanceRange: {
            0: "Unknown",
            1: "Macro",
            2: "Close view",
            3: "Distant view"
        },
        FileSource: {
            3: "DSC"
        },
        Components: {
            0: "",
            1: "Y",
            2: "Cb",
            3: "Cr",
            4: "R",
            5: "G",
            6: "B"
        }
    };
    function addEvent(element, event, handler) {
        if (element.addEventListener) element.addEventListener(event, handler, false);
        else if (element.attachEvent) element.attachEvent("on" + event, handler);
    }
    function imageHasData(img) {
        return !!img.exifdata;
    }
    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ""; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, "");
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for(var i = 0; i < len; i++)view[i] = binary.charCodeAt(i);
        return buffer;
    }
    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) callback(this.response);
        };
        http.send();
    }
    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
                var xmpdata = findXMPinJPEG(binFile);
                img.xmpdata = xmpdata || {};
            }
            if (callback) callback.call(img);
        }
        if (img.src) {
            if (/^data\:/i.test(img.src)) {
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);
            } else if (/^blob\:/i.test(img.src)) {
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function(blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) handleBinaryFile(http.response);
                    else throw "Could not load image";
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };
            fileReader.readAsArrayBuffer(img);
        }
    }
    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, marker;
        while(offset < length){
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }
            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);
            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data
            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");
                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
            // offset += 2 + file.getShortAt(offset+2, true);
            } else offset += 2 + dataView.getUint16(offset + 2);
        }
    }
    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength;
        var isFieldSegmentStart = function(dataView, offset) {
            return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
        };
        while(offset < length){
            if (isFieldSegmentStart(dataView, offset)) {
                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) // Always 4
                nameHeaderLength = 4;
                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
                return readIPTCData(file, startOffset, sectionLength);
            }
            // Not the marker, continue searching
            offset++;
        }
    }
    var IptcFieldMap = {
        0x78: "caption",
        0x6E: "credit",
        0x19: "keywords",
        0x37: "dateCreated",
        0x50: "byline",
        0x55: "bylineTitle",
        0x7A: "captionWriter",
        0x69: "headline",
        0x74: "copyright",
        0x0F: "category"
    };
    function readIPTCData(file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset + sectionLength){
            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) data[fieldName].push(fieldValue);
                        else data[fieldName] = [
                            data[fieldName],
                            fieldValue
                        ];
                    } else data[fieldName] = fieldValue;
                }
            }
            segmentStartPos++;
        }
        return data;
    }
    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd), tags = {}, entryOffset, tag, i;
        for(i = 0; i < entries; i++){
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }
    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd), numValues = file.getUint32(entryOffset + 4, !bigEnd), valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart, offset, vals, val, n1, numerator, denominator;
        switch(type){
            case 1:
            case 7:
                if (numValues == 1) return file.getUint8(entryOffset + 8, !bigEnd);
                else {
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getUint8(offset + n1);
                    return vals;
                }
            case 2:
                offset = numValues > 4 ? valueOffset : entryOffset + 8;
                return getStringFromDB(file, offset, numValues - 1);
            case 3:
                if (numValues == 1) return file.getUint16(entryOffset + 8, !bigEnd);
                else {
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getUint16(offset + 2 * n1, !bigEnd);
                    return vals;
                }
            case 4:
                if (numValues == 1) return file.getUint32(entryOffset + 8, !bigEnd);
                else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getUint32(valueOffset + 4 * n1, !bigEnd);
                    return vals;
                }
            case 5:
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++){
                        numerator = file.getUint32(valueOffset + 8 * n1, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n1, !bigEnd);
                        vals[n1] = new Number(numerator / denominator);
                        vals[n1].numerator = numerator;
                        vals[n1].denominator = denominator;
                    }
                    return vals;
                }
            case 9:
                if (numValues == 1) return file.getInt32(entryOffset + 8, !bigEnd);
                else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getInt32(valueOffset + 4 * n1, !bigEnd);
                    return vals;
                }
            case 10:
                if (numValues == 1) return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getInt32(valueOffset + 8 * n1, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n1, !bigEnd);
                    return vals;
                }
        }
    }
    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */ function getNextIFDOffset(dataView, dirStart, bigEnd) {
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);
        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }
    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd) {
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart + firstIFDOffset, bigEnd);
        if (!IFD1OffsetPointer) // console.log('******** IFD1Offset is empty, image thumb not found ********');
        return {};
        else if (IFD1OffsetPointer > dataView.byteLength) // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
        return {};
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd);
        // EXIF 2.3 specification for JPEG format thumbnail
        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
        if (thumbTags["Compression"]) // console.log('Thumbnail image found!');
        switch(thumbTags["Compression"]){
            case 6:
                // console.log('Thumbnail image format is JPEG');
                if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                    // extract the thumbnail
                    var tOffset = tiffStart + thumbTags.JpegIFOffset;
                    var tLength = thumbTags.JpegIFByteCount;
                    thumbTags["blob"] = new Blob([
                        new Uint8Array(dataView.buffer, tOffset, tLength)
                    ], {
                        type: "image/jpeg"
                    });
                }
                break;
            case 1:
                console.log("Thumbnail image format is TIFF, which is not implemented.");
                break;
            default:
                console.log("Unknown thumbnail image format '%s'", thumbTags["Compression"]);
        }
        else if (thumbTags["PhotometricInterpretation"] == 2) console.log("Thumbnail image format is RGB, which is not implemented.");
        return thumbTags;
    }
    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for(n = start; n < start + length; n++)outstr += String.fromCharCode(buffer.getUint8(n));
        return outstr;
    }
    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }
        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) bigEnd = false;
        else if (file.getUint16(tiffOffset) == 0x4D4D) bigEnd = true;
        else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }
        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }
        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }
        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for(tag in exifData){
                switch(tag){
                    case "LightSource":
                    case "Flash":
                    case "MeteringMode":
                    case "ExposureProgram":
                    case "SensingMethod":
                    case "SceneCaptureType":
                    case "SceneType":
                    case "CustomRendered":
                    case "WhiteBalance":
                    case "GainControl":
                    case "Contrast":
                    case "Saturation":
                    case "Sharpness":
                    case "SubjectDistanceRange":
                    case "FileSource":
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;
                    case "ExifVersion":
                    case "FlashpixVersion":
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;
                    case "ComponentsConfiguration":
                        exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }
        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for(tag in gpsData){
                switch(tag){
                    case "GPSVersionID":
                        gpsData[tag] = gpsData[tag][0] + "." + gpsData[tag][1] + "." + gpsData[tag][2] + "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }
        // extract thumbnail
        tags["thumbnail"] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
        return tags;
    }
    function findXMPinJPEG(file) {
        if (!("DOMParser" in self)) // console.warn('XML parsing not supported without DOMParser');
        return;
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, dom = new DOMParser();
        while(offset < length - 4)if (getStringFromDB(dataView, offset, 4) == "http") {
            var startOffset = offset - 1;
            var sectionLength = dataView.getUint16(offset - 2) - 1;
            var xmpString = getStringFromDB(dataView, startOffset, sectionLength);
            var xmpEndIndex = xmpString.indexOf("xmpmeta>") + 8;
            xmpString = xmpString.substring(xmpString.indexOf("<x:xmpmeta"), xmpEndIndex);
            var indexOfXmp = xmpString.indexOf("x:xmpmeta") + 10;
            //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
            //Without these namespaces, XML is thought to be invalid by parsers
            xmpString = xmpString.slice(0, indexOfXmp) + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" ' + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" ' + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" ' + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" ' + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" ' + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" ' + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" ' + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" ' + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" ' + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" ' + xmpString.slice(indexOfXmp);
            var domDocument = dom.parseFromString(xmpString, "text/xml");
            return xml2Object(domDocument);
        } else offset++;
    }
    function xml2json(xml) {
        var json = {};
        if (xml.nodeType == 1) {
            if (xml.attributes.length > 0) {
                json["@attributes"] = {};
                for(var j = 0; j < xml.attributes.length; j++){
                    var attribute = xml.attributes.item(j);
                    json["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType == 3) return xml.nodeValue;
        // deal with children
        if (xml.hasChildNodes()) for(var i = 0; i < xml.childNodes.length; i++){
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;
            if (json[nodeName] == null) json[nodeName] = xml2json(child);
            else {
                if (json[nodeName].push == null) {
                    var old = json[nodeName];
                    json[nodeName] = [];
                    json[nodeName].push(old);
                }
                json[nodeName].push(xml2json(child));
            }
        }
        return json;
    }
    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) for(var i = 0; i < xml.children.length; i++){
                var item = xml.children.item(i);
                var attributes = item.attributes;
                for(var idx in attributes){
                    var itemAtt = attributes[idx];
                    var dataKey = itemAtt.nodeName;
                    var dataValue = itemAtt.nodeValue;
                    if (dataKey !== undefined) obj[dataKey] = dataValue;
                }
                var nodeName = item.nodeName;
                if (typeof obj[nodeName] == "undefined") obj[nodeName] = xml2json(item);
                else {
                    if (typeof obj[nodeName].push == "undefined") {
                        var old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(xml2json(item));
                }
            }
            else obj = xml.textContent;
            return obj;
        } catch (e) {
            console.log(e.message);
        }
    }
    EXIF.enableXmp = function() {
        EXIF.isXmpEnabled = true;
    };
    EXIF.disableXmp = function() {
        EXIF.isXmpEnabled = false;
    };
    EXIF.getData = function(img, callback) {
        if ((self.Image && img instanceof self.Image || self.HTMLImageElement && img instanceof self.HTMLImageElement) && !img.complete) return false;
        if (!imageHasData(img)) getImageData(img, callback);
        else if (callback) callback.call(img);
        return true;
    };
    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    };
    EXIF.getIptcTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    };
    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a, data = img.exifdata, tags = {};
        for(a in data)if (data.hasOwnProperty(a)) tags[a] = data[a];
        return tags;
    };
    EXIF.getAllIptcTags = function(img) {
        if (!imageHasData(img)) return {};
        var a, data = img.iptcdata, tags = {};
        for(a in data)if (data.hasOwnProperty(a)) tags[a] = data[a];
        return tags;
    };
    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a, data = img.exifdata, strPretty = "";
        for(a in data)if (data.hasOwnProperty(a)) {
            if (typeof data[a] == "object") {
                if (data[a] instanceof Number) strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                else strPretty += a + " : [" + data[a].length + " values]\r\n";
            } else strPretty += a + " : " + data[a] + "\r\n";
        }
        return strPretty;
    };
    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    };
    if (typeof define === "function" && define.amd) define("exif-js", [], function() {
        return EXIF;
    });
}).call(this);

});

parcelRegister("1ZXxd", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("aEGIN", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $60KC5.default;
    }
});

var $60KC5 = parcelRequire("60KC5");

});
parcelRegister("60KC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4606e6976b439f3d$export$2e2bcd8739ae039; });

var $cQmXV = parcelRequire("cQmXV");

var $4dsMU = parcelRequire("4dsMU");

var $7uT18 = parcelRequire("7uT18");
"use client";
function $4606e6976b439f3d$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $7uT18.jsx)((0, $4dsMU.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $4dsMU.default).muiName;
    return /*#__PURE__*/ $cQmXV.memo(/*#__PURE__*/ $cQmXV.forwardRef(Component));
}

});
parcelRegister("4dsMU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $311eb4f8dad023b0$export$2e2bcd8739ae039; });

var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");

var $7U6VQ = parcelRequire("7U6VQ");

var $kZnRZ = parcelRequire("kZnRZ");

var $dGUQw = parcelRequire("dGUQw");

var $9acxQ = parcelRequire("9acxQ");

var $20gtU = parcelRequire("20gtU");

var $7uT18 = parcelRequire("7uT18");
"use client";
const $311eb4f8dad023b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $7U6VQ.default)(color)}`,
            `fontSize${(0, $7U6VQ.default)(fontSize)}`
        ]
    };
    return (0, $iryXh.default)(slots, (0, $20gtU.getSvgIconUtilityClass), classes);
};
const $311eb4f8dad023b0$var$SvgIconRoot = (0, $kZnRZ.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $7U6VQ.default)(ownerState.color)}`],
            styles[`fontSize${(0, $7U6VQ.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $dGUQw.default)(({ theme: theme })=>({
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        flexShrink: 0,
        transition: theme.transitions?.create?.("fill", {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: "currentColor"
                }
            },
            {
                props: {
                    fontSize: "inherit"
                },
                style: {
                    fontSize: "inherit"
                }
            },
            {
                props: {
                    fontSize: "small"
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || "1.25rem"
                }
            },
            {
                props: {
                    fontSize: "medium"
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || "1.5rem"
                }
            },
            {
                props: {
                    fontSize: "large"
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || "2.1875rem"
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: "action"
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: "disabled"
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: "inherit"
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $311eb4f8dad023b0$var$SvgIcon = /*#__PURE__*/ $cQmXV.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24", ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $cQmXV.isValidElement(children) && children.type === "svg";
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $311eb4f8dad023b0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7uT18.jsxs)($311eb4f8dad023b0$var$SvgIconRoot, {
        as: component,
        className: (0, $jYj5L.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $7uT18.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$311eb4f8dad023b0$var$SvgIcon.muiName = "SvgIcon";
var $311eb4f8dad023b0$export$2e2bcd8739ae039 = $311eb4f8dad023b0$var$SvgIcon;

});
parcelRegister("jYj5L", function(module, exports) {

$parcel$export(module.exports, "clsx", function () { return $772fd6e40f1fbf40$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $772fd6e40f1fbf40$export$2e2bcd8739ae039; });
function $772fd6e40f1fbf40$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $772fd6e40f1fbf40$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $772fd6e40f1fbf40$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $772fd6e40f1fbf40$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $772fd6e40f1fbf40$export$2e2bcd8739ae039 = $772fd6e40f1fbf40$export$4f5d2d50c9deca37;

});

parcelRegister("iryXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6d5dcfd90a83e7d$export$2e2bcd8739ae039; });
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $d6d5dcfd90a83e7d$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = "";
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? "" : " ") + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += " " + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("7U6VQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c1323e4fadbdd31$export$2e2bcd8739ae039; });

var $3Lcme = parcelRequire("3Lcme");
var $5c1323e4fadbdd31$export$2e2bcd8739ae039 = (0, $3Lcme.default);

});
parcelRegister("3Lcme", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bcf58d1058cce90$export$2e2bcd8739ae039; });

var $bcPiE = parcelRequire("bcPiE");
function $2bcf58d1058cce90$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $bcPiE.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("bcPiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82889bc64ce6687b$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $82889bc64ce6687b$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append("args[]", arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});



parcelRegister("kZnRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47c0538f6ab5df8$export$2e2bcd8739ae039; });

var $73gTt = parcelRequire("73gTt");

var $bnMBi = parcelRequire("bnMBi");

var $dUHEu = parcelRequire("dUHEu");

var $k8hCU = parcelRequire("k8hCU");

"use client";
const $f47c0538f6ab5df8$var$styled = (0, $73gTt.default)({
    themeId: (0, $dUHEu.default),
    defaultTheme: $bnMBi.default,
    rootShouldForwardProp: $k8hCU.default
});
var $f47c0538f6ab5df8$export$2e2bcd8739ae039 = $f47c0538f6ab5df8$var$styled;

});
parcelRegister("73gTt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5225eaf48501478d$export$2e2bcd8739ae039; });

var $2rvNX = parcelRequire("2rvNX");

var $aRKlE = parcelRequire("aRKlE");

var $3Lcme = parcelRequire("3Lcme");

var $ceZdU = parcelRequire("ceZdU");

var $lGH00 = parcelRequire("lGH00");

var $l4G5A = parcelRequire("l4G5A");

var $62jxo = parcelRequire("62jxo");
const $5225eaf48501478d$export$35e57303dbd8a66 = (0, $lGH00.default)();
function $5225eaf48501478d$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
function $5225eaf48501478d$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === "object" && serialized.styles && !serialized.styles.startsWith("@layer") // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $5225eaf48501478d$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $5225eaf48501478d$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $5225eaf48501478d$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $5225eaf48501478d$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === "function" ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$5225eaf48501478d$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $5225eaf48501478d$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $5225eaf48501478d$var$shallowLayer((0, $2rvNX.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $5225eaf48501478d$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $5225eaf48501478d$var$shallowLayer((0, $2rvNX.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $5225eaf48501478d$var$shallowLayer((0, $2rvNX.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $5225eaf48501478d$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === "function") {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === "function") {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $5225eaf48501478d$var$shallowLayer((0, $2rvNX.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $5225eaf48501478d$var$shallowLayer((0, $2rvNX.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $5225eaf48501478d$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $5225eaf48501478d$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $5225eaf48501478d$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $5225eaf48501478d$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $5225eaf48501478d$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $2rvNX.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $l4G5A.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $5225eaf48501478d$var$defaultOverridesResolver($5225eaf48501478d$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith("Mui") || !!componentSlot ? "components" : "custom";
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $5225eaf48501478d$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($5225eaf48501478d$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $2rvNX.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $5225eaf48501478d$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === "function") return function styleFunctionProcessor(props) {
                return $5225eaf48501478d$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $aRKlE.isPlainObject)(style)) {
                const serialized = (0, $62jxo.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $5225eaf48501478d$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $5225eaf48501478d$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $5225eaf48501478d$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? "theme" : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $5225eaf48501478d$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? "theme" : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $l4G5A.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill("");
                const placeholdersTail = new Array(expressionsTail.length).fill("");
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $5225eaf48501478d$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $3Lcme.default)(componentSlot || "")}`;
    return `Styled(${(0, $ceZdU.default)(tag)})`;
}
function $5225eaf48501478d$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $5225eaf48501478d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $5225eaf48501478d$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $5225eaf48501478d$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("2rvNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c76c6205a839806$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $1c76c6205a839806$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $1c76c6205a839806$export$13a2d3ef13012b32; });
/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $bGX4g = parcelRequire("bGX4g");

var $hTGQX = parcelRequire("hTGQX");

var $gUe5M = parcelRequire("gUe5M");
var $5XE8m = parcelRequire("5XE8m");


var $9C2yv = parcelRequire("9C2yv");
function $1c76c6205a839806$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $bGX4g.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $1c76c6205a839806$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $1c76c6205a839806$var$wrapper = [];
function $1c76c6205a839806$export$13a2d3ef13012b32(styles) {
    $1c76c6205a839806$var$wrapper[0] = styles;
    return (0, $hTGQX.serializeStyles)($1c76c6205a839806$var$wrapper);
}

});
parcelRegister("bGX4g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88316f94f8b6cf33$export$2e2bcd8739ae039; });
parcelRequire("b68Mk");
parcelRequire("cQmXV");
parcelRequire("kClbU");

var $4bph3 = parcelRequire("4bph3");

parcelRequire("g545G");
parcelRequire("4Y1DZ");
var $88316f94f8b6cf33$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $88316f94f8b6cf33$var$newStyled = (0, $4bph3.default).bind();
$88316f94f8b6cf33$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $88316f94f8b6cf33$var$newStyled[tagName] = $88316f94f8b6cf33$var$newStyled(tagName);
});
var $88316f94f8b6cf33$export$2e2bcd8739ae039 = $88316f94f8b6cf33$var$newStyled;

});
parcelRegister("b68Mk", function(module, exports) {
function $81471072d8960c58$var$_extends() {
    module.exports = $81471072d8960c58$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $81471072d8960c58$var$_extends.apply(this, arguments);
}
module.exports = $81471072d8960c58$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kClbU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f027cb5f3c6d3851$export$2e2bcd8739ae039; });

var $4nfrh = parcelRequire("4nfrh");
var $f027cb5f3c6d3851$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f027cb5f3c6d3851$var$isPropValid = /* #__PURE__ */ (0, $4nfrh.default)(function(prop) {
    return $f027cb5f3c6d3851$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $f027cb5f3c6d3851$export$2e2bcd8739ae039 = $f027cb5f3c6d3851$var$isPropValid;

});
parcelRegister("4nfrh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32f5493f5b65e766$export$2e2bcd8739ae039; });
function $32f5493f5b65e766$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $32f5493f5b65e766$export$2e2bcd8739ae039 = $32f5493f5b65e766$var$memoize;

});


parcelRegister("4bph3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30bbcb6aa2e1e7c4$export$2e2bcd8739ae039; });

var $jNuvi = parcelRequire("jNuvi");

var $cQmXV = parcelRequire("cQmXV");

var $kClbU = parcelRequire("kClbU");
parcelRequire("gUe5M");
var $5XE8m = parcelRequire("5XE8m");

var $g545G = parcelRequire("g545G");

var $4Y1DZ = parcelRequire("4Y1DZ");
var $30bbcb6aa2e1e7c4$var$testOmitPropsOnStringTag = (0, $kClbU.default);
var $30bbcb6aa2e1e7c4$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $30bbcb6aa2e1e7c4$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $30bbcb6aa2e1e7c4$var$testOmitPropsOnStringTag : $30bbcb6aa2e1e7c4$var$testOmitPropsOnComponent;
};
var $30bbcb6aa2e1e7c4$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $30bbcb6aa2e1e7c4$var$useInsertionEffect = $cQmXV.useInsertionEffect ? $cQmXV.useInsertionEffect : function useInsertionEffect(create) {
    create();
};
function $30bbcb6aa2e1e7c4$var$useInsertionEffectMaybe(create) {
    $30bbcb6aa2e1e7c4$var$useInsertionEffect(create);
}
var $30bbcb6aa2e1e7c4$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $30bbcb6aa2e1e7c4$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $g545G.registerStyles)(cache, serialized, isStringTag);
    var rules = $30bbcb6aa2e1e7c4$var$useInsertionEffectMaybe(function() {
        return (0, $g545G.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $30bbcb6aa2e1e7c4$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $30bbcb6aa2e1e7c4$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $30bbcb6aa2e1e7c4$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $5XE8m.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $cQmXV.useContext)((0, $5XE8m.T));
            }
            if (typeof props.className === "string") className = (0, $g545G.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $4Y1DZ.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $30bbcb6aa2e1e7c4$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $cQmXV.createElement)((0, $cQmXV.Fragment), null, /*#__PURE__*/ (0, $cQmXV.createElement)($30bbcb6aa2e1e7c4$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ (0, $cQmXV.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $jNuvi.default)({}, options, nextOptions, {
                shouldForwardProp: $30bbcb6aa2e1e7c4$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $30bbcb6aa2e1e7c4$export$2e2bcd8739ae039 = $30bbcb6aa2e1e7c4$var$createStyled;

});
parcelRegister("jNuvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e69a41570260c349$export$2e2bcd8739ae039; });
function $e69a41570260c349$export$2e2bcd8739ae039() {
    $e69a41570260c349$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e69a41570260c349$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("gUe5M", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $c4eccebadf61f38c$export$98f03c5d19621d70; });
$parcel$export(module.exports, "keyframes", function () { return $c4eccebadf61f38c$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("5XE8m")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("5XE8m")).w; });

var $cQmXV = parcelRequire("cQmXV");
parcelRequire("6hsLN");

var $5XE8m = parcelRequire("5XE8m");
parcelRequire("b68Mk");
parcelRequire("aKMoF");
parcelRequire("iSQ8t");


var $g545G = parcelRequire("g545G");

var $4Y1DZ = parcelRequire("4Y1DZ");

var $hW5F0 = parcelRequire("hW5F0");
var $c4eccebadf61f38c$var$pkg = {
    name: "@emotion/react",
    version: "11.8.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/babel-plugin": "^11.7.1",
        "@emotion/cache": "^11.7.1",
        "@emotion/serialize": "^1.0.2",
        "@emotion/sheet": "^1.1.0",
        "@emotion/utils": "^1.1.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.7.1",
        "@emotion/css-prettifier": "1.0.1",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.8.1",
        "@types/react": "^16.9.11",
        dtslint: "^0.3.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact"
    }
};
var $c4eccebadf61f38c$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $5XE8m.h).call(props, "css")) // $FlowFixMe
    return (0, $cQmXV.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $5XE8m.E);
    createElementArgArray[1] = (0, $5XE8m.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $cQmXV.createElement).apply(null, createElementArgArray);
};
var $c4eccebadf61f38c$var$useInsertionEffect = $cQmXV.useInsertionEffect ? $cQmXV.useInsertionEffect : (0, $cQmXV.useLayoutEffect);
var $c4eccebadf61f38c$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $c4eccebadf61f38c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $5XE8m.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $4Y1DZ.serializeStyles)([
        styles
    ], undefined, (0, $cQmXV.useContext)((0, $5XE8m.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $cQmXV.useRef)();
    $c4eccebadf61f38c$var$useInsertionEffect(function() {
        var key = cache.key + "-global";
        var sheet = new (0, $hW5F0.StyleSheet)({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    $c4eccebadf61f38c$var$useInsertionEffect(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $g545G.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $c4eccebadf61f38c$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $4Y1DZ.serializeStyles)(args);
}
var $c4eccebadf61f38c$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $c4eccebadf61f38c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $c4eccebadf61f38c$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $c4eccebadf61f38c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $g545G.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $c4eccebadf61f38c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $5XE8m.u)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $g545G.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $c4eccebadf61f38c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $5XE8m.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $4Y1DZ.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $g545G.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $c4eccebadf61f38c$var$merge(cache.registered, css, $c4eccebadf61f38c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $cQmXV.useContext)((0, $5XE8m.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $cQmXV.createElement)((0, $cQmXV.Fragment), null, /*#__PURE__*/ (0, $cQmXV.createElement)($c4eccebadf61f38c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $c4eccebadf61f38c$var$isBrowser, $c4eccebadf61f38c$var$isJest, $c4eccebadf61f38c$var$globalContext, $c4eccebadf61f38c$var$globalKey;

});
parcelRegister("6hsLN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $492aa5b2daaec85e$export$2e2bcd8739ae039; });

var $hW5F0 = parcelRequire("hW5F0");

var $dZPYz = parcelRequire("dZPYz");
parcelRequire("d1HKX");
parcelRequire("4nfrh");
var $492aa5b2daaec85e$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $dZPYz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $dZPYz.token)(character)) break;
        (0, $dZPYz.next)();
    }
    return (0, $dZPYz.slice)(begin, (0, $dZPYz.position));
};
var $492aa5b2daaec85e$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $dZPYz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $dZPYz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $492aa5b2daaec85e$var$identifierWithPointTracking((0, $dZPYz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $dZPYz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $dZPYz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $dZPYz.from)(character);
    }
    while (character = (0, $dZPYz.next)());
    return parsed;
};
var $492aa5b2daaec85e$var$getRules = function getRules(value, points) {
    return (0, $dZPYz.dealloc)($492aa5b2daaec85e$var$toRules((0, $dZPYz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $492aa5b2daaec85e$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $492aa5b2daaec85e$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$492aa5b2daaec85e$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $492aa5b2daaec85e$var$fixedElements.set(element, true);
    var points = [];
    var rules = $492aa5b2daaec85e$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $492aa5b2daaec85e$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $492aa5b2daaec85e$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $492aa5b2daaec85e$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($492aa5b2daaec85e$var$ignoreFlag) > -1;
};
var $492aa5b2daaec85e$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? children[0].children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($492aa5b2daaec85e$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $492aa5b2daaec85e$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $492aa5b2daaec85e$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$492aa5b2daaec85e$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $492aa5b2daaec85e$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $492aa5b2daaec85e$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$492aa5b2daaec85e$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $492aa5b2daaec85e$var$nullifyElement(element);
    } else if ($492aa5b2daaec85e$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $492aa5b2daaec85e$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $492aa5b2daaec85e$var$prefix(value, length) {
    switch((0, $dZPYz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $dZPYz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $dZPYz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MOZ) + value + (0, $dZPYz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + value + value;
        // order
        case 6165:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.replace)(value, /(\w+).+(:[^]+)/, (0, $dZPYz.WEBKIT) + "box-$1$2" + (0, $dZPYz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + "flex-item-" + (0, $dZPYz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + "flex-line-pack" + (0, $dZPYz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + (0, $dZPYz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + (0, $dZPYz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $dZPYz.WEBKIT) + "box-" + (0, $dZPYz.replace)(value, "-grow", "") + (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + (0, $dZPYz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $dZPYz.WEBKIT) + (0, $dZPYz.replace)(value, /([^-])(transform)/g, "$1" + (0, $dZPYz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $dZPYz.replace)((0, $dZPYz.replace)((0, $dZPYz.replace)(value, /(zoom-|grab)/, (0, $dZPYz.WEBKIT) + "$1"), /(image-set)/, (0, $dZPYz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $dZPYz.replace)(value, /(image-set\([^]*)/, (0, $dZPYz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $dZPYz.replace)((0, $dZPYz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $dZPYz.WEBKIT) + "box-pack:$3" + (0, $dZPYz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $dZPYz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $dZPYz.replace)(value, /(.+)-inline(.+)/, (0, $dZPYz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $dZPYz.strlen)(value) - 1 - length > 6) switch((0, $dZPYz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $dZPYz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $dZPYz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $dZPYz.WEBKIT) + "$2-$3" + "$1" + (0, $dZPYz.MOZ) + ((0, $dZPYz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $dZPYz.indexof)(value, "stretch") ? $492aa5b2daaec85e$var$prefix((0, $dZPYz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $dZPYz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $dZPYz.charat)(value, (0, $dZPYz.strlen)(value) - 3 - (~(0, $dZPYz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $dZPYz.replace)(value, ":", ":" + (0, $dZPYz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $dZPYz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $dZPYz.WEBKIT) + ((0, $dZPYz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $dZPYz.WEBKIT) + "$2$3" + "$1" + (0, $dZPYz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $dZPYz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + (0, $dZPYz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + (0, $dZPYz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + (0, $dZPYz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $dZPYz.WEBKIT) + value + (0, $dZPYz.MS) + value + value;
    }
    return value;
}
var $492aa5b2daaec85e$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $dZPYz.DECLARATION:
                element["return"] = $492aa5b2daaec85e$var$prefix(element.value, element.length);
                break;
            case 0, $dZPYz.KEYFRAMES:
                return (0, $dZPYz.serialize)([
                    (0, $dZPYz.copy)(element, {
                        value: (0, $dZPYz.replace)(element.value, "@", "@" + (0, $dZPYz.WEBKIT))
                    })
                ], callback);
            case 0, $dZPYz.RULESET:
                if (element.length) return (0, $dZPYz.combine)(element.props, function(value) {
                    switch((0, $dZPYz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $dZPYz.serialize)([
                                (0, $dZPYz.copy)(element, {
                                    props: [
                                        (0, $dZPYz.replace)(value, /:(read-\w+)/, ":" + (0, $dZPYz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $dZPYz.serialize)([
                                (0, $dZPYz.copy)(element, {
                                    props: [
                                        (0, $dZPYz.replace)(value, /:(plac\w+)/, ":" + (0, $dZPYz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $dZPYz.copy)(element, {
                                    props: [
                                        (0, $dZPYz.replace)(value, /:(plac\w+)/, ":" + (0, $dZPYz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $dZPYz.copy)(element, {
                                    props: [
                                        (0, $dZPYz.replace)(value, /:(plac\w+)/, (0, $dZPYz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $492aa5b2daaec85e$var$defaultStylisPlugins = [
    $492aa5b2daaec85e$var$prefixer
];
var $492aa5b2daaec85e$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $492aa5b2daaec85e$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $492aa5b2daaec85e$var$compat,
        $492aa5b2daaec85e$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $dZPYz.stringify),
        (0, $dZPYz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $dZPYz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $dZPYz.serialize)((0, $dZPYz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $hW5F0.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $492aa5b2daaec85e$export$2e2bcd8739ae039 = $492aa5b2daaec85e$var$createCache;

});
parcelRegister("hW5F0", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $d0ec3e7ca55a88a3$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $d0ec3e7ca55a88a3$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $d0ec3e7ca55a88a3$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $d0ec3e7ca55a88a3$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($d0ec3e7ca55a88a3$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $d0ec3e7ca55a88a3$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("dZPYz", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $f90fe41aaaad6526$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $f90fe41aaaad6526$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $f90fe41aaaad6526$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $f90fe41aaaad6526$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $f90fe41aaaad6526$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $f90fe41aaaad6526$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $f90fe41aaaad6526$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $f90fe41aaaad6526$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $f90fe41aaaad6526$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $f90fe41aaaad6526$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $f90fe41aaaad6526$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $f90fe41aaaad6526$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $f90fe41aaaad6526$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $f90fe41aaaad6526$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $f90fe41aaaad6526$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $f90fe41aaaad6526$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $f90fe41aaaad6526$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $f90fe41aaaad6526$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $f90fe41aaaad6526$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $f90fe41aaaad6526$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $f90fe41aaaad6526$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $f90fe41aaaad6526$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $f90fe41aaaad6526$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $f90fe41aaaad6526$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $f90fe41aaaad6526$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $f90fe41aaaad6526$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $f90fe41aaaad6526$export$38bcb760f1d4871c; });
var $f90fe41aaaad6526$export$71ad59f2e432cfe8 = "-ms-";
var $f90fe41aaaad6526$export$2c0f367103c8d01c = "-moz-";
var $f90fe41aaaad6526$export$39dfd62a25e0fe93 = "-webkit-";
var $f90fe41aaaad6526$export$a29989082612d0d9 = "comm";
var $f90fe41aaaad6526$export$aa3a2e812ca8570d = "rule";
var $f90fe41aaaad6526$export$527d108ccf083c2b = "decl";
var $f90fe41aaaad6526$export$d3d35020fa5b54f0 = "@page";
var $f90fe41aaaad6526$export$500415a86c544f73 = "@media";
var $f90fe41aaaad6526$export$a763edbf796b780a = "@import";
var $f90fe41aaaad6526$export$2790aeb8b4e5c826 = "@charset";
var $f90fe41aaaad6526$export$1cc683e23b84b133 = "@viewport";
var $f90fe41aaaad6526$export$9447a5efea57e862 = "@supports";
var $f90fe41aaaad6526$export$ef011b4e114b1fba = "@document";
var $f90fe41aaaad6526$export$6aad947bda0f3f46 = "@namespace";
var $f90fe41aaaad6526$export$b44a8529a35fcb60 = "@keyframes";
var $f90fe41aaaad6526$export$2c16de31893252e6 = "@font-face";
var $f90fe41aaaad6526$export$3d846dd52e150c6f = "@counter-style";
var $f90fe41aaaad6526$export$22314bfbb57653fe = "@font-feature-values";
var $f90fe41aaaad6526$export$2335f513bbd82c6d = Math.abs;
var $f90fe41aaaad6526$export$6788812c4e6611e6 = String.fromCharCode;
var $f90fe41aaaad6526$export$e6e34fd1f2686227 = Object.assign;
function $f90fe41aaaad6526$export$d6af199866bfb566(e, r) {
    return $f90fe41aaaad6526$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 0)) << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 1)) << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 2)) << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 3) : 0;
}
function $f90fe41aaaad6526$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f90fe41aaaad6526$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f90fe41aaaad6526$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $f90fe41aaaad6526$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f90fe41aaaad6526$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f90fe41aaaad6526$export$36776f635604f274(e) {
    return e.length;
}
function $f90fe41aaaad6526$export$f9084667e487ed46(e) {
    return e.length;
}
function $f90fe41aaaad6526$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f90fe41aaaad6526$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $f90fe41aaaad6526$export$53f1d5ea8de3d7c = 1;
var $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1;
var $f90fe41aaaad6526$export$f24224f1c91d8156 = 0;
var $f90fe41aaaad6526$export$5880b8b5730aff45 = 0;
var $f90fe41aaaad6526$export$c0306caf338ac095 = 0;
var $f90fe41aaaad6526$export$30a86d91af8ff6e6 = "";
function $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $f90fe41aaaad6526$export$53f1d5ea8de3d7c,
        column: $f90fe41aaaad6526$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $f90fe41aaaad6526$export$784d13d8ee351f07(e, r) {
    return $f90fe41aaaad6526$export$e6e34fd1f2686227($f90fe41aaaad6526$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $f90fe41aaaad6526$export$eba6f6f03b0a92e7() {
    return $f90fe41aaaad6526$export$c0306caf338ac095;
}
function $f90fe41aaaad6526$export$232faf9add678146() {
    $f90fe41aaaad6526$export$c0306caf338ac095 = $f90fe41aaaad6526$export$5880b8b5730aff45 > 0 ? $f90fe41aaaad6526$export$a9db5e087081082d($f90fe41aaaad6526$export$30a86d91af8ff6e6, --$f90fe41aaaad6526$export$5880b8b5730aff45) : 0;
    if ($f90fe41aaaad6526$export$4e0c71f277ca26b3--, $f90fe41aaaad6526$export$c0306caf338ac095 === 10) $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1, $f90fe41aaaad6526$export$53f1d5ea8de3d7c--;
    return $f90fe41aaaad6526$export$c0306caf338ac095;
}
function $f90fe41aaaad6526$export$48cfd1e771a65c4f() {
    $f90fe41aaaad6526$export$c0306caf338ac095 = $f90fe41aaaad6526$export$5880b8b5730aff45 < $f90fe41aaaad6526$export$f24224f1c91d8156 ? $f90fe41aaaad6526$export$a9db5e087081082d($f90fe41aaaad6526$export$30a86d91af8ff6e6, $f90fe41aaaad6526$export$5880b8b5730aff45++) : 0;
    if ($f90fe41aaaad6526$export$4e0c71f277ca26b3++, $f90fe41aaaad6526$export$c0306caf338ac095 === 10) $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1, $f90fe41aaaad6526$export$53f1d5ea8de3d7c++;
    return $f90fe41aaaad6526$export$c0306caf338ac095;
}
function $f90fe41aaaad6526$export$4d3fb11e950abb9e() {
    return $f90fe41aaaad6526$export$a9db5e087081082d($f90fe41aaaad6526$export$30a86d91af8ff6e6, $f90fe41aaaad6526$export$5880b8b5730aff45);
}
function $f90fe41aaaad6526$export$e88cb2efb12ae807() {
    return $f90fe41aaaad6526$export$5880b8b5730aff45;
}
function $f90fe41aaaad6526$export$58adb3bec8346d0f(e, r) {
    return $f90fe41aaaad6526$export$2f35ab04d2335697($f90fe41aaaad6526$export$30a86d91af8ff6e6, e, r);
}
function $f90fe41aaaad6526$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f90fe41aaaad6526$export$2de70f21292aac9e(e) {
    return $f90fe41aaaad6526$export$53f1d5ea8de3d7c = $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1, $f90fe41aaaad6526$export$f24224f1c91d8156 = $f90fe41aaaad6526$export$36776f635604f274($f90fe41aaaad6526$export$30a86d91af8ff6e6 = e), $f90fe41aaaad6526$export$5880b8b5730aff45 = 0, [];
}
function $f90fe41aaaad6526$export$45918ac1574455b1(e) {
    return $f90fe41aaaad6526$export$30a86d91af8ff6e6 = "", e;
}
function $f90fe41aaaad6526$export$410ac95b9ec204b8(e) {
    return $f90fe41aaaad6526$export$87c2784dc9fc4ab($f90fe41aaaad6526$export$58adb3bec8346d0f($f90fe41aaaad6526$export$5880b8b5730aff45 - 1, $f90fe41aaaad6526$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f90fe41aaaad6526$export$660b2ee2d4fb4eff(e) {
    return $f90fe41aaaad6526$export$45918ac1574455b1($f90fe41aaaad6526$export$5f8c09e3ae6f64e1($f90fe41aaaad6526$export$2de70f21292aac9e(e)));
}
function $f90fe41aaaad6526$export$7af1228ff777d175(e) {
    while($f90fe41aaaad6526$export$c0306caf338ac095 = $f90fe41aaaad6526$export$4d3fb11e950abb9e())if ($f90fe41aaaad6526$export$c0306caf338ac095 < 33) $f90fe41aaaad6526$export$48cfd1e771a65c4f();
    else break;
    return $f90fe41aaaad6526$export$9e1725a4cfeada27(e) > 2 || $f90fe41aaaad6526$export$9e1725a4cfeada27($f90fe41aaaad6526$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f90fe41aaaad6526$export$5f8c09e3ae6f64e1(e) {
    while($f90fe41aaaad6526$export$48cfd1e771a65c4f())switch($f90fe41aaaad6526$export$9e1725a4cfeada27($f90fe41aaaad6526$export$c0306caf338ac095)){
        case 0:
            $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$c2ab62c7bf24634($f90fe41aaaad6526$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$410ac95b9ec204b8($f90fe41aaaad6526$export$c0306caf338ac095), e);
            break;
        default:
            $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$6788812c4e6611e6($f90fe41aaaad6526$export$c0306caf338ac095), e);
    }
    return e;
}
function $f90fe41aaaad6526$export$955ba06d119e085e(e, r) {
    while(--r && $f90fe41aaaad6526$export$48cfd1e771a65c4f())if ($f90fe41aaaad6526$export$c0306caf338ac095 < 48 || $f90fe41aaaad6526$export$c0306caf338ac095 > 102 || $f90fe41aaaad6526$export$c0306caf338ac095 > 57 && $f90fe41aaaad6526$export$c0306caf338ac095 < 65 || $f90fe41aaaad6526$export$c0306caf338ac095 > 70 && $f90fe41aaaad6526$export$c0306caf338ac095 < 97) break;
    return $f90fe41aaaad6526$export$58adb3bec8346d0f(e, $f90fe41aaaad6526$export$e88cb2efb12ae807() + (r < 6 && $f90fe41aaaad6526$export$4d3fb11e950abb9e() == 32 && $f90fe41aaaad6526$export$48cfd1e771a65c4f() == 32));
}
function $f90fe41aaaad6526$export$c889f2fcc19dbf12(e) {
    while($f90fe41aaaad6526$export$48cfd1e771a65c4f())switch($f90fe41aaaad6526$export$c0306caf338ac095){
        case e:
            return $f90fe41aaaad6526$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f90fe41aaaad6526$export$c889f2fcc19dbf12($f90fe41aaaad6526$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f90fe41aaaad6526$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f90fe41aaaad6526$export$48cfd1e771a65c4f();
            break;
    }
    return $f90fe41aaaad6526$export$5880b8b5730aff45;
}
function $f90fe41aaaad6526$export$4254d4e2b3745c4c(e, r) {
    while($f90fe41aaaad6526$export$48cfd1e771a65c4f())if (e + $f90fe41aaaad6526$export$c0306caf338ac095 === 57) break;
    else if (e + $f90fe41aaaad6526$export$c0306caf338ac095 === 84 && $f90fe41aaaad6526$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f90fe41aaaad6526$export$58adb3bec8346d0f(r, $f90fe41aaaad6526$export$5880b8b5730aff45 - 1) + "*" + $f90fe41aaaad6526$export$6788812c4e6611e6(e === 47 ? e : $f90fe41aaaad6526$export$48cfd1e771a65c4f());
}
function $f90fe41aaaad6526$export$c2ab62c7bf24634(e) {
    while(!$f90fe41aaaad6526$export$9e1725a4cfeada27($f90fe41aaaad6526$export$4d3fb11e950abb9e()))$f90fe41aaaad6526$export$48cfd1e771a65c4f();
    return $f90fe41aaaad6526$export$58adb3bec8346d0f(e, $f90fe41aaaad6526$export$5880b8b5730aff45);
}
function $f90fe41aaaad6526$export$ef7acd7185315e22(e) {
    return $f90fe41aaaad6526$export$45918ac1574455b1($f90fe41aaaad6526$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f90fe41aaaad6526$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f90fe41aaaad6526$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var O = g;
    while(w)switch(h = $, $ = $f90fe41aaaad6526$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $f90fe41aaaad6526$export$a9db5e087081082d(O, l - 1) == 58) {
                if ($f90fe41aaaad6526$export$f8e21b1e77979a08(O += $f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            O += $f90fe41aaaad6526$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            O += $f90fe41aaaad6526$export$7af1228ff777d175(h);
            break;
        case 92:
            O += $f90fe41aaaad6526$export$955ba06d119e085e($f90fe41aaaad6526$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f90fe41aaaad6526$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$4a34f930e789283c($f90fe41aaaad6526$export$4254d4e2b3745c4c($f90fe41aaaad6526$export$48cfd1e771a65c4f(), $f90fe41aaaad6526$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    O += "/";
            }
            break;
        case 123 * b:
            u[f++] = $f90fe41aaaad6526$export$36776f635604f274(O) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (p > 0 && $f90fe41aaaad6526$export$36776f635604f274(O) - l) $f90fe41aaaad6526$export$10d8903dec122b9d(p > 32 ? $f90fe41aaaad6526$export$f8483753829ec8f3(O + ";", n, a, l - 1) : $f90fe41aaaad6526$export$f8483753829ec8f3($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(O, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    O += ";";
                default:
                    $f90fe41aaaad6526$export$10d8903dec122b9d(y = $f90fe41aaaad6526$export$3307ffa7023ede1e(O, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $f90fe41aaaad6526$export$98e6a39c04603d36(O, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $f90fe41aaaad6526$export$a9db5e087081082d(O, 3) === 110 ? 100 : v){
                            case 100:
                            case 109:
                            case 115:
                                $f90fe41aaaad6526$export$98e6a39c04603d36(e, y, y, n && $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $f90fe41aaaad6526$export$98e6a39c04603d36(O, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = O = "", l = t;
            break;
        case 58:
            l = 1 + $f90fe41aaaad6526$export$36776f635604f274(O), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $f90fe41aaaad6526$export$232faf9add678146() == 125) continue;
            }
            switch(O += $f90fe41aaaad6526$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (O += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($f90fe41aaaad6526$export$36776f635604f274(O) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f90fe41aaaad6526$export$4d3fb11e950abb9e() === 45) O += $f90fe41aaaad6526$export$410ac95b9ec204b8($f90fe41aaaad6526$export$48cfd1e771a65c4f());
                    v = $f90fe41aaaad6526$export$4d3fb11e950abb9e(), o = l = $f90fe41aaaad6526$export$36776f635604f274(g = O += $f90fe41aaaad6526$export$c2ab62c7bf24634($f90fe41aaaad6526$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $f90fe41aaaad6526$export$36776f635604f274(O) == 2) b = 0;
            }
    }
    return s;
}
function $f90fe41aaaad6526$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $f90fe41aaaad6526$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var k = 0, g = $f90fe41aaaad6526$export$2f35ab04d2335697(e, v + 1, v = $f90fe41aaaad6526$export$2335f513bbd82c6d(w = u[b])), m = e; k < h; ++k)if (m = $f90fe41aaaad6526$export$87c2784dc9fc4ab(w > 0 ? p[k] + " " + g : $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(g, /&\f/g, p[k]))) f[d++] = m;
    return $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, s === 0 ? $f90fe41aaaad6526$export$aa3a2e812ca8570d : i, f, o, l);
}
function $f90fe41aaaad6526$export$4a34f930e789283c(e, r, a) {
    return $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, $f90fe41aaaad6526$export$a29989082612d0d9, $f90fe41aaaad6526$export$6788812c4e6611e6($f90fe41aaaad6526$export$eba6f6f03b0a92e7()), $f90fe41aaaad6526$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $f90fe41aaaad6526$export$f8483753829ec8f3(e, r, a, n) {
    return $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, $f90fe41aaaad6526$export$527d108ccf083c2b, $f90fe41aaaad6526$export$2f35ab04d2335697(e, 0, n), $f90fe41aaaad6526$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $f90fe41aaaad6526$export$82e9f45cca5ba907(n, c, s) {
    switch($f90fe41aaaad6526$export$d6af199866bfb566(n, c)){
        case 5103:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $f90fe41aaaad6526$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$2c0f367103c8d01c + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($f90fe41aaaad6526$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "box-$1$2" + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-item-" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$f90fe41aaaad6526$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "grid-row-" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-line-pack" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "box-" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "-grow", "") + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "box-pack:$3" + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$f90fe41aaaad6526$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "grid-column-align" + $f90fe41aaaad6526$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $f90fe41aaaad6526$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f90fe41aaaad6526$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f90fe41aaaad6526$export$f8e21b1e77979a08(s, "span") ? $f90fe41aaaad6526$export$4659b591c19bdf3d(s, /\d+/) : +$f90fe41aaaad6526$export$4659b591c19bdf3d(s, /\d+/) - +$f90fe41aaaad6526$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f90fe41aaaad6526$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f90fe41aaaad6526$export$36776f635604f274(n) - 1 - c > 6) switch($f90fe41aaaad6526$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($f90fe41aaaad6526$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f90fe41aaaad6526$export$2c0f367103c8d01c + ($f90fe41aaaad6526$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$f90fe41aaaad6526$export$f8e21b1e77979a08(n, "stretch") ? $f90fe41aaaad6526$export$82e9f45cca5ba907($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $f90fe41aaaad6526$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($f90fe41aaaad6526$export$a9db5e087081082d(n, c + 6) === 121) return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, ":", ":" + $f90fe41aaaad6526$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($f90fe41aaaad6526$export$a9db5e087081082d(n, $f90fe41aaaad6526$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + ($f90fe41aaaad6526$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, ":", ":" + $f90fe41aaaad6526$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $f90fe41aaaad6526$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $f90fe41aaaad6526$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f90fe41aaaad6526$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f90fe41aaaad6526$export$a763edbf796b780a:
        case $f90fe41aaaad6526$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f90fe41aaaad6526$export$a29989082612d0d9:
            return "";
        case $f90fe41aaaad6526$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f90fe41aaaad6526$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f90fe41aaaad6526$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $f90fe41aaaad6526$export$36776f635604f274(a = $f90fe41aaaad6526$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f90fe41aaaad6526$export$5a7767152ae0305f(e) {
    var r = $f90fe41aaaad6526$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $f90fe41aaaad6526$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f90fe41aaaad6526$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $f90fe41aaaad6526$export$527d108ccf083c2b:
                n.return = $f90fe41aaaad6526$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $f90fe41aaaad6526$export$b44a8529a35fcb60:
                return $f90fe41aaaad6526$export$dfdc1655ccc5b9cb([
                    $f90fe41aaaad6526$export$784d13d8ee351f07(n, {
                        value: $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $f90fe41aaaad6526$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f90fe41aaaad6526$export$aa3a2e812ca8570d:
                if (n.length) return $f90fe41aaaad6526$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($f90fe41aaaad6526$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $f90fe41aaaad6526$export$dfdc1655ccc5b9cb([
                                $f90fe41aaaad6526$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $f90fe41aaaad6526$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $f90fe41aaaad6526$export$dfdc1655ccc5b9cb([
                                $f90fe41aaaad6526$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $f90fe41aaaad6526$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f90fe41aaaad6526$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $f90fe41aaaad6526$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $f90fe41aaaad6526$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f90fe41aaaad6526$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f90fe41aaaad6526$export$1be1fc439b849fdf($f90fe41aaaad6526$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($f90fe41aaaad6526$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f90fe41aaaad6526$export$2f35ab04d2335697(r, 1, $f90fe41aaaad6526$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $f90fe41aaaad6526$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f90fe41aaaad6526$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $f90fe41aaaad6526$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("d1HKX", function(module, exports) {
var $97bd4f7ce8469a47$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $97bd4f7ce8469a47$export$2e2bcd8739ae039 = $97bd4f7ce8469a47$var$weakMemoize;

});


parcelRegister("5XE8m", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $457198328a9091c7$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $457198328a9091c7$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $457198328a9091c7$export$971d5caa766a69d7; });
$parcel$export(module.exports, "u", function () { return $457198328a9091c7$export$3b14a55fb2447963; });
$parcel$export(module.exports, "c", function () { return $457198328a9091c7$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $457198328a9091c7$export$a9c23c6ac3fc3eca; });

var $cQmXV = parcelRequire("cQmXV");

var $6hsLN = parcelRequire("6hsLN");

var $jNuvi = parcelRequire("jNuvi");

var $aKMoF = parcelRequire("aKMoF");

var $fgIfp = parcelRequire("fgIfp");

var $g545G = parcelRequire("g545G");

var $4Y1DZ = parcelRequire("4Y1DZ");
var $457198328a9091c7$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $457198328a9091c7$var$EmotionCacheContext = /* #__PURE__ */ (0, $cQmXV.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $6hsLN.default)({
    key: "css"
}) : null);
var $457198328a9091c7$export$e7094788287c5e9b = $457198328a9091c7$var$EmotionCacheContext.Provider;
var $457198328a9091c7$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $cQmXV.useContext)($457198328a9091c7$var$EmotionCacheContext);
};
var $457198328a9091c7$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $cQmXV.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $cQmXV.useContext)($457198328a9091c7$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $457198328a9091c7$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $cQmXV.createContext)({});
var $457198328a9091c7$export$407448d2b89b1813 = function useTheme() {
    return (0, $cQmXV.useContext)($457198328a9091c7$export$971d5caa766a69d7);
};
var $457198328a9091c7$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $jNuvi.default)({}, outerTheme, theme);
};
var $457198328a9091c7$var$createCacheWithTheme = /* #__PURE__ */ (0, $aKMoF.default)(function(outerTheme) {
    return (0, $aKMoF.default)(function(theme) {
        return $457198328a9091c7$var$getTheme(outerTheme, theme);
    });
});
var $457198328a9091c7$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = (0, $cQmXV.useContext)($457198328a9091c7$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $457198328a9091c7$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $cQmXV.createElement)($457198328a9091c7$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $457198328a9091c7$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = (0, $cQmXV.useContext)($457198328a9091c7$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $cQmXV.createElement)(Component, (0, $jNuvi.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $cQmXV.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $fgIfp.default)(WithTheme, Component);
}
var $457198328a9091c7$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $457198328a9091c7$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $457198328a9091c7$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $457198328a9091c7$var$getLastPart(match[1]);
    return undefined;
};
var $457198328a9091c7$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $457198328a9091c7$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $457198328a9091c7$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $457198328a9091c7$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($457198328a9091c7$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $457198328a9091c7$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $457198328a9091c7$var$useInsertionEffect = $cQmXV.useInsertionEffect ? $cQmXV.useInsertionEffect : function useInsertionEffect(create) {
    create();
};
function $457198328a9091c7$export$3b14a55fb2447963(create) {
    $457198328a9091c7$var$useInsertionEffect(create);
}
var $457198328a9091c7$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $457198328a9091c7$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $457198328a9091c7$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($457198328a9091c7$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$457198328a9091c7$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $457198328a9091c7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $g545G.registerStyles)(cache, serialized, isStringTag);
    var rules = $457198328a9091c7$export$3b14a55fb2447963(function() {
        return (0, $g545G.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $457198328a9091c7$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $457198328a9091c7$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$457198328a9091c7$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $g545G.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $4Y1DZ.serializeStyles)(registeredStyles, undefined, (0, $cQmXV.useContext)($457198328a9091c7$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($457198328a9091c7$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $457198328a9091c7$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $cQmXV.createElement)((0, $cQmXV.Fragment), null, /*#__PURE__*/ (0, $cQmXV.createElement)($457198328a9091c7$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ (0, $cQmXV.createElement)(WrappedComponent, newProps));
});

});
parcelRegister("aKMoF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d43bde3e02aba22$export$2e2bcd8739ae039; });
var $7d43bde3e02aba22$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $7d43bde3e02aba22$export$2e2bcd8739ae039 = $7d43bde3e02aba22$var$weakMemoize;

});

parcelRegister("fgIfp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1daac48925d88e1$export$2e2bcd8739ae039; });

var $iSQ8t = parcelRequire("iSQ8t");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $b1daac48925d88e1$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSQ8t)))(targetComponent, sourceComponent);
};
var $b1daac48925d88e1$export$2e2bcd8739ae039 = $b1daac48925d88e1$var$hoistNonReactStatics;

});
parcelRegister("iSQ8t", function(module, exports) {
"use strict";

var $2UMqt = parcelRequire("2UMqt");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $dbf5b6306a11b711$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $dbf5b6306a11b711$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $dbf5b6306a11b711$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $dbf5b6306a11b711$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $dbf5b6306a11b711$var$TYPE_STATICS = {};
$dbf5b6306a11b711$var$TYPE_STATICS[$2UMqt.ForwardRef] = $dbf5b6306a11b711$var$FORWARD_REF_STATICS;
$dbf5b6306a11b711$var$TYPE_STATICS[$2UMqt.Memo] = $dbf5b6306a11b711$var$MEMO_STATICS;
function $dbf5b6306a11b711$var$getStatics(component) {
    // React v16.11 and below
    if ($2UMqt.isMemo(component)) return $dbf5b6306a11b711$var$MEMO_STATICS;
     // React v16.12 and above
    return $dbf5b6306a11b711$var$TYPE_STATICS[component["$$typeof"]] || $dbf5b6306a11b711$var$REACT_STATICS;
}
var $dbf5b6306a11b711$var$defineProperty = Object.defineProperty;
var $dbf5b6306a11b711$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $dbf5b6306a11b711$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $dbf5b6306a11b711$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $dbf5b6306a11b711$var$getPrototypeOf = Object.getPrototypeOf;
var $dbf5b6306a11b711$var$objectPrototype = Object.prototype;
function $dbf5b6306a11b711$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($dbf5b6306a11b711$var$objectPrototype) {
            var inheritedComponent = $dbf5b6306a11b711$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $dbf5b6306a11b711$var$objectPrototype) $dbf5b6306a11b711$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $dbf5b6306a11b711$var$getOwnPropertyNames(sourceComponent);
        if ($dbf5b6306a11b711$var$getOwnPropertySymbols) keys = keys.concat($dbf5b6306a11b711$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $dbf5b6306a11b711$var$getStatics(targetComponent);
        var sourceStatics = $dbf5b6306a11b711$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$dbf5b6306a11b711$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $dbf5b6306a11b711$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $dbf5b6306a11b711$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $dbf5b6306a11b711$var$hoistNonReactStatics;

});
parcelRegister("2UMqt", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9fiKv"));

});



parcelRegister("g545G", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $bb50494a1603a50f$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $bb50494a1603a50f$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $bb50494a1603a50f$export$6f077d94b33a01aa; });
var $bb50494a1603a50f$var$isBrowser = true;
function $bb50494a1603a50f$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $bb50494a1603a50f$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $bb50494a1603a50f$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $bb50494a1603a50f$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $bb50494a1603a50f$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("4Y1DZ", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $39de0a7f819e6d25$export$6321afa313b251b5; });

var $8tCsM = parcelRequire("8tCsM");

var $l9rZ6 = parcelRequire("l9rZ6");

var $4nfrh = parcelRequire("4nfrh");
var $39de0a7f819e6d25$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $39de0a7f819e6d25$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $39de0a7f819e6d25$var$hyphenateRegex = /[A-Z]|^ms/g;
var $39de0a7f819e6d25$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $39de0a7f819e6d25$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $39de0a7f819e6d25$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $39de0a7f819e6d25$var$processStyleName = /* #__PURE__ */ (0, $4nfrh.default)(function(styleName) {
    return $39de0a7f819e6d25$var$isCustomProperty(styleName) ? styleName : styleName.replace($39de0a7f819e6d25$var$hyphenateRegex, "-$&").toLowerCase();
});
var $39de0a7f819e6d25$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($39de0a7f819e6d25$var$animationRegex, function(match, p1, p2) {
                $39de0a7f819e6d25$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $39de0a7f819e6d25$var$cursor
                };
                return p1;
            });
    }
    if ((0, $l9rZ6.default)[key] !== 1 && !$39de0a7f819e6d25$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $39de0a7f819e6d25$var$contentValuePattern, $39de0a7f819e6d25$var$contentValues, $39de0a7f819e6d25$var$oldProcessStyleValue, $39de0a7f819e6d25$var$msPattern, $39de0a7f819e6d25$var$hyphenPattern, $39de0a7f819e6d25$var$hyphenatedCache;
var $39de0a7f819e6d25$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $39de0a7f819e6d25$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $39de0a7f819e6d25$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $39de0a7f819e6d25$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $39de0a7f819e6d25$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $39de0a7f819e6d25$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $39de0a7f819e6d25$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $39de0a7f819e6d25$var$cursor;
                var result = interpolation(mergedProps);
                $39de0a7f819e6d25$var$cursor = previousCursor;
                return $39de0a7f819e6d25$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $39de0a7f819e6d25$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $39de0a7f819e6d25$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($39de0a7f819e6d25$var$isProcessableValue(value)) string += $39de0a7f819e6d25$var$processStyleName(_key) + ":" + $39de0a7f819e6d25$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($39de0a7f819e6d25$var$isProcessableValue(value[_i])) string += $39de0a7f819e6d25$var$processStyleName(_key) + ":" + $39de0a7f819e6d25$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $39de0a7f819e6d25$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $39de0a7f819e6d25$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $39de0a7f819e6d25$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $39de0a7f819e6d25$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $39de0a7f819e6d25$var$cursor;
var $39de0a7f819e6d25$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $39de0a7f819e6d25$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $39de0a7f819e6d25$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $39de0a7f819e6d25$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $39de0a7f819e6d25$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $39de0a7f819e6d25$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $8tCsM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $39de0a7f819e6d25$var$cursor
    };
};

});
parcelRegister("8tCsM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62bede2b909cae48$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $62bede2b909cae48$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $62bede2b909cae48$export$2e2bcd8739ae039 = $62bede2b909cae48$var$murmur2;

});

parcelRegister("l9rZ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f66025604cf38684$export$2e2bcd8739ae039; });
var $f66025604cf38684$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $f66025604cf38684$export$2e2bcd8739ae039 = $f66025604cf38684$var$unitlessKeys;

});






parcelRegister("hTGQX", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $d078d07982120b6c$export$6321afa313b251b5; });

var $bQ2CZ = parcelRequire("bQ2CZ");

var $g4KjM = parcelRequire("g4KjM");

var $kD5RU = parcelRequire("kD5RU");
var $d078d07982120b6c$var$isDevelopment = false;
var $d078d07982120b6c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $d078d07982120b6c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $d078d07982120b6c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $d078d07982120b6c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $d078d07982120b6c$var$processStyleName = /* #__PURE__ */ (0, $kD5RU.default)(function(styleName) {
    return $d078d07982120b6c$var$isCustomProperty(styleName) ? styleName : styleName.replace($d078d07982120b6c$var$hyphenateRegex, "-$&").toLowerCase();
});
var $d078d07982120b6c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($d078d07982120b6c$var$animationRegex, function(match, p1, p2) {
                $d078d07982120b6c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $d078d07982120b6c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $g4KjM.default)[key] !== 1 && !$d078d07982120b6c$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $d078d07982120b6c$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $d078d07982120b6c$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $d078d07982120b6c$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $d078d07982120b6c$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $d078d07982120b6c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $d078d07982120b6c$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $d078d07982120b6c$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $d078d07982120b6c$var$cursor;
                var result = interpolation(mergedProps);
                $d078d07982120b6c$var$cursor = previousCursor;
                return $d078d07982120b6c$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $d078d07982120b6c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $d078d07982120b6c$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($d078d07982120b6c$var$isProcessableValue(asString)) string += $d078d07982120b6c$var$processStyleName(key) + ":" + $d078d07982120b6c$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $d078d07982120b6c$var$isDevelopment) throw new Error($d078d07982120b6c$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($d078d07982120b6c$var$isProcessableValue(value[_i])) string += $d078d07982120b6c$var$processStyleName(key) + ":" + $d078d07982120b6c$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $d078d07982120b6c$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $d078d07982120b6c$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $d078d07982120b6c$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $d078d07982120b6c$var$cursor;
function $d078d07982120b6c$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $d078d07982120b6c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $d078d07982120b6c$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $d078d07982120b6c$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $d078d07982120b6c$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $d078d07982120b6c$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $bQ2CZ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $d078d07982120b6c$var$cursor
    };
}

});
parcelRegister("bQ2CZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89e696df62938bee$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $89e696df62938bee$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("g4KjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb40f2dc7227f967$export$2e2bcd8739ae039; });
var $bb40f2dc7227f967$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("kD5RU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f04c00882d90f8c9$export$2e2bcd8739ae039; });
function $f04c00882d90f8c9$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("9C2yv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ff9a526564c6961$export$2e2bcd8739ae039; });
parcelRequire("cQmXV");


var $gUe5M = parcelRequire("gUe5M");

var $7uT18 = parcelRequire("7uT18");
"use client";
function $6ff9a526564c6961$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $6ff9a526564c6961$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($6ff9a526564c6961$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $gUe5M.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("7uT18", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aTPuV"));

});



parcelRegister("aRKlE", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $7e92ce6bbae76e4d$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $7e92ce6bbae76e4d$export$2e2bcd8739ae039; });

var $cQmXV = parcelRequire("cQmXV");

var $fkTZW = parcelRequire("fkTZW");
function $7e92ce6bbae76e4d$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $7e92ce6bbae76e4d$var$deepClone(source) {
    if (/*#__PURE__*/ $cQmXV.isValidElement(source) || (0, $fkTZW.isValidElementType)(source) || !$7e92ce6bbae76e4d$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $7e92ce6bbae76e4d$var$deepClone(source[key]);
    });
    return output;
}
function $7e92ce6bbae76e4d$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($7e92ce6bbae76e4d$export$53b83ca8eaab0383(target) && $7e92ce6bbae76e4d$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $cQmXV.isValidElement(source[key]) || (0, $fkTZW.isValidElementType)(source[key])) output[key] = source[key];
        else if ($7e92ce6bbae76e4d$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $7e92ce6bbae76e4d$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $7e92ce6bbae76e4d$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $7e92ce6bbae76e4d$export$53b83ca8eaab0383(source[key]) ? $7e92ce6bbae76e4d$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("fkTZW", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fer7P"));

});


parcelRegister("ceZdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e96488c248ce359$export$2e2bcd8739ae039; });

var $fkTZW = parcelRequire("fkTZW");
function $8e96488c248ce359$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || fallback;
}
function $8e96488c248ce359$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $8e96488c248ce359$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $8e96488c248ce359$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $8e96488c248ce359$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $fkTZW.ForwardRef:
            return $8e96488c248ce359$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $fkTZW.Memo:
            return $8e96488c248ce359$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("lGH00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc9edff52d54d069$export$2e2bcd8739ae039; });

var $aRKlE = parcelRequire("aRKlE");

var $REUWe = parcelRequire("REUWe");

var $b2Zls = parcelRequire("b2Zls");

var $4YYlY = parcelRequire("4YYlY");

var $5YmAa = parcelRequire("5YmAa");

var $l4G5A = parcelRequire("l4G5A");

var $7AgjI = parcelRequire("7AgjI");

var $3UZvg = parcelRequire("3UZvg");
function $fc9edff52d54d069$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $REUWe.default)(breakpointsInput);
    const spacing = (0, $5YmAa.default)(spacingInput);
    let muiTheme = (0, $aRKlE.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: {
            mode: "light",
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $4YYlY.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $b2Zls.default)(muiTheme);
    muiTheme.applyStyles = (0, $3UZvg.default);
    muiTheme = args.reduce((acc, argument)=>(0, $aRKlE.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $7AgjI.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $l4G5A.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $fc9edff52d54d069$export$2e2bcd8739ae039 = $fc9edff52d54d069$var$createTheme;

});
parcelRegister("REUWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a14b0afce568dcd$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $0a14b0afce568dcd$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $0a14b0afce568dcd$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $0a14b0afce568dcd$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5, ...other } = breakpoints;
    const sortedValues = $0a14b0afce568dcd$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("b2Zls", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $80af7775d0ef423a$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $80af7775d0ef423a$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $80af7775d0ef423a$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $80af7775d0ef423a$export$2e2bcd8739ae039; });

function $80af7775d0ef423a$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith("@container")).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $80af7775d0ef423a$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === "@" || value.startsWith("@") && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $80af7775d0ef423a$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $80af7775d0ef423a$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes("not all and")) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("4YYlY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a0b94f1acde700b$export$2e2bcd8739ae039; });
const $3a0b94f1acde700b$var$shape = {
    borderRadius: 4
};
var $3a0b94f1acde700b$export$2e2bcd8739ae039 = $3a0b94f1acde700b$var$shape;

});

parcelRegister("5YmAa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $459412bd697600f4$export$2e2bcd8739ae039; });

var $4wEav = parcelRequire("4wEav");
function $459412bd697600f4$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $4wEav.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("4wEav", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $34b94f326b00409f$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $34b94f326b00409f$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $34b94f326b00409f$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $34b94f326b00409f$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $34b94f326b00409f$export$6f98e8eaf0be1996; });


var $3DlSW = parcelRequire("3DlSW");

var $2GmrW = parcelRequire("2GmrW");

var $5H3Nw = parcelRequire("5H3Nw");

var $gmGiA = parcelRequire("gmGiA");
const $34b94f326b00409f$var$properties = {
    m: "margin",
    p: "padding"
};
const $34b94f326b00409f$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $34b94f326b00409f$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $34b94f326b00409f$var$getCssProperties = (0, $gmGiA.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($34b94f326b00409f$var$aliases[prop]) prop = $34b94f326b00409f$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $34b94f326b00409f$var$properties[a];
    const direction = $34b94f326b00409f$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $34b94f326b00409f$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $34b94f326b00409f$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $34b94f326b00409f$var$spacingKeys = [
    ...$34b94f326b00409f$export$aab52a0dde05ad8a,
    ...$34b94f326b00409f$export$f8397d44f03ab6ad
];
function $34b94f326b00409f$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $2GmrW.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === "number" || typeof themeSpacing === "string") return (val)=>{
        if (typeof val === "string") return val;
        if (typeof themeSpacing === "string") return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === "string") return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === "number") return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $34b94f326b00409f$export$1def6f833384e3d1(theme) {
    return $34b94f326b00409f$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $34b94f326b00409f$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    return transformer(propValue);
}
function $34b94f326b00409f$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $34b94f326b00409f$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $34b94f326b00409f$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $34b94f326b00409f$var$getCssProperties(prop);
    const styleFromPropValue = $34b94f326b00409f$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3DlSW.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $34b94f326b00409f$var$style(props, keys) {
    const transformer = $34b94f326b00409f$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$34b94f326b00409f$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $5H3Nw.default), {});
}
function $34b94f326b00409f$export$7ede87f9b603dd3c(props) {
    return $34b94f326b00409f$var$style(props, $34b94f326b00409f$export$aab52a0dde05ad8a);
}
$34b94f326b00409f$export$7ede87f9b603dd3c.propTypes = {};
$34b94f326b00409f$export$7ede87f9b603dd3c.filterProps = $34b94f326b00409f$export$aab52a0dde05ad8a;
function $34b94f326b00409f$export$6f98e8eaf0be1996(props) {
    return $34b94f326b00409f$var$style(props, $34b94f326b00409f$export$f8397d44f03ab6ad);
}
$34b94f326b00409f$export$6f98e8eaf0be1996.propTypes = {};
$34b94f326b00409f$export$6f98e8eaf0be1996.filterProps = $34b94f326b00409f$export$f8397d44f03ab6ad;
function $34b94f326b00409f$var$spacing(props) {
    return $34b94f326b00409f$var$style(props, $34b94f326b00409f$var$spacingKeys);
}
$34b94f326b00409f$var$spacing.propTypes = {};
$34b94f326b00409f$var$spacing.filterProps = $34b94f326b00409f$var$spacingKeys;
var $34b94f326b00409f$export$2e2bcd8739ae039 = $34b94f326b00409f$var$spacing;

});
parcelRegister("3DlSW", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $2a55fd8fbad8ec49$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $2a55fd8fbad8ec49$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $2a55fd8fbad8ec49$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $2a55fd8fbad8ec49$export$8922c90b6e020726; });


var $aRKlE = parcelRequire("aRKlE");

var $5H3Nw = parcelRequire("5H3Nw");

var $b2Zls = parcelRequire("b2Zls");
const $2a55fd8fbad8ec49$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2a55fd8fbad8ec49$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$2a55fd8fbad8ec49$export$68c286be0e7e55b7[key]}px)`
};
const $2a55fd8fbad8ec49$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === "number" ? key : $2a55fd8fbad8ec49$export$68c286be0e7e55b7[key] || key;
                if (typeof result === "number") result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $2a55fd8fbad8ec49$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2a55fd8fbad8ec49$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $2a55fd8fbad8ec49$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $b2Zls.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $b2Zls.getContainerQuery)(theme.containerQueries ? theme : $2a55fd8fbad8ec49$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $2a55fd8fbad8ec49$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2a55fd8fbad8ec49$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2a55fd8fbad8ec49$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $5H3Nw.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2a55fd8fbad8ec49$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2a55fd8fbad8ec49$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2a55fd8fbad8ec49$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2a55fd8fbad8ec49$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $aRKlE.default)(prev, next), {});
    return $2a55fd8fbad8ec49$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2a55fd8fbad8ec49$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2a55fd8fbad8ec49$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2a55fd8fbad8ec49$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2a55fd8fbad8ec49$export$2e2bcd8739ae039 = $2a55fd8fbad8ec49$var$breakpoints;

});
parcelRegister("5H3Nw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4253ea0864a8d7d3$export$2e2bcd8739ae039; });

var $aRKlE = parcelRequire("aRKlE");
function $4253ea0864a8d7d3$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $aRKlE.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $4253ea0864a8d7d3$export$2e2bcd8739ae039 = $4253ea0864a8d7d3$var$merge;

});


parcelRegister("2GmrW", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $1f40eb117c8af2e1$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $1f40eb117c8af2e1$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $1f40eb117c8af2e1$export$2e2bcd8739ae039; });

var $3Lcme = parcelRequire("3Lcme");


var $3DlSW = parcelRequire("3DlSW");
function $1f40eb117c8af2e1$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $1f40eb117c8af2e1$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $1f40eb117c8af2e1$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $1f40eb117c8af2e1$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $1f40eb117c8af2e1$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $1f40eb117c8af2e1$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $1f40eb117c8af2e1$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $3Lcme.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3DlSW.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $1f40eb117c8af2e1$export$2e2bcd8739ae039 = $1f40eb117c8af2e1$var$style;

});

parcelRegister("gmGiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be9f8318cdb979a1$export$2e2bcd8739ae039; });
function $be9f8318cdb979a1$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("l4G5A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f57a9ebb72a2c7b2$export$2e2bcd8739ae039; });

var $3Lcme = parcelRequire("3Lcme");

var $5H3Nw = parcelRequire("5H3Nw");

var $2GmrW = parcelRequire("2GmrW");

var $3DlSW = parcelRequire("3DlSW");

var $b2Zls = parcelRequire("b2Zls");

var $7AgjI = parcelRequire("7AgjI");
function $f57a9ebb72a2c7b2$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $f57a9ebb72a2c7b2$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $f57a9ebb72a2c7b2$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $2GmrW.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $2GmrW.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $2GmrW.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $3Lcme.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3DlSW.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $7AgjI.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3DlSW.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $f57a9ebb72a2c7b2$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $5H3Nw.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $3DlSW.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($f57a9ebb72a2c7b2$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $5H3Nw.default)(css, breakpointsValues);
                        }
                    } else css = (0, $5H3Nw.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                "@layer sx": (0, $b2Zls.sortContainerQueries)(theme, (0, $3DlSW.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $b2Zls.sortContainerQueries)(theme, (0, $3DlSW.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $f57a9ebb72a2c7b2$var$styleFunctionSx = $f57a9ebb72a2c7b2$export$7d53d8bf2911e013();
$f57a9ebb72a2c7b2$var$styleFunctionSx.filterProps = [
    "sx"
];
var $f57a9ebb72a2c7b2$export$2e2bcd8739ae039 = $f57a9ebb72a2c7b2$var$styleFunctionSx;

});
parcelRegister("7AgjI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58588d6d2b989c90$export$2e2bcd8739ae039; });

var $4wEav = parcelRequire("4wEav");

var $h2cHs = parcelRequire("h2cHs");

var $4o3a3 = parcelRequire("4o3a3");

var $bYYrc = parcelRequire("bYYrc");

var $hjVGl = parcelRequire("hjVGl");
const $58588d6d2b989c90$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $h2cHs.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $h2cHs.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $h2cHs.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $h2cHs.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $h2cHs.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $h2cHs.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $h2cHs.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $bYYrc.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $bYYrc.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $bYYrc.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $4wEav.padding)
    },
    pt: {
        style: (0, $4wEav.padding)
    },
    pr: {
        style: (0, $4wEav.padding)
    },
    pb: {
        style: (0, $4wEav.padding)
    },
    pl: {
        style: (0, $4wEav.padding)
    },
    px: {
        style: (0, $4wEav.padding)
    },
    py: {
        style: (0, $4wEav.padding)
    },
    padding: {
        style: (0, $4wEav.padding)
    },
    paddingTop: {
        style: (0, $4wEav.padding)
    },
    paddingRight: {
        style: (0, $4wEav.padding)
    },
    paddingBottom: {
        style: (0, $4wEav.padding)
    },
    paddingLeft: {
        style: (0, $4wEav.padding)
    },
    paddingX: {
        style: (0, $4wEav.padding)
    },
    paddingY: {
        style: (0, $4wEav.padding)
    },
    paddingInline: {
        style: (0, $4wEav.padding)
    },
    paddingInlineStart: {
        style: (0, $4wEav.padding)
    },
    paddingInlineEnd: {
        style: (0, $4wEav.padding)
    },
    paddingBlock: {
        style: (0, $4wEav.padding)
    },
    paddingBlockStart: {
        style: (0, $4wEav.padding)
    },
    paddingBlockEnd: {
        style: (0, $4wEav.padding)
    },
    m: {
        style: (0, $4wEav.margin)
    },
    mt: {
        style: (0, $4wEav.margin)
    },
    mr: {
        style: (0, $4wEav.margin)
    },
    mb: {
        style: (0, $4wEav.margin)
    },
    ml: {
        style: (0, $4wEav.margin)
    },
    mx: {
        style: (0, $4wEav.margin)
    },
    my: {
        style: (0, $4wEav.margin)
    },
    margin: {
        style: (0, $4wEav.margin)
    },
    marginTop: {
        style: (0, $4wEav.margin)
    },
    marginRight: {
        style: (0, $4wEav.margin)
    },
    marginBottom: {
        style: (0, $4wEav.margin)
    },
    marginLeft: {
        style: (0, $4wEav.margin)
    },
    marginX: {
        style: (0, $4wEav.margin)
    },
    marginY: {
        style: (0, $4wEav.margin)
    },
    marginInline: {
        style: (0, $4wEav.margin)
    },
    marginInlineStart: {
        style: (0, $4wEav.margin)
    },
    marginInlineEnd: {
        style: (0, $4wEav.margin)
    },
    marginBlock: {
        style: (0, $4wEav.margin)
    },
    marginBlockStart: {
        style: (0, $4wEav.margin)
    },
    marginBlockEnd: {
        style: (0, $4wEav.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $4o3a3.gap)
    },
    rowGap: {
        style: (0, $4o3a3.rowGap)
    },
    columnGap: {
        style: (0, $4o3a3.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $hjVGl.sizingTransform)
    },
    maxWidth: {
        style: (0, $hjVGl.maxWidth)
    },
    minWidth: {
        transform: (0, $hjVGl.sizingTransform)
    },
    height: {
        transform: (0, $hjVGl.sizingTransform)
    },
    maxHeight: {
        transform: (0, $hjVGl.sizingTransform)
    },
    minHeight: {
        transform: (0, $hjVGl.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: "font"
    },
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $58588d6d2b989c90$export$2e2bcd8739ae039 = $58588d6d2b989c90$var$defaultSxConfig;

});
parcelRegister("h2cHs", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $c66c7986096481a9$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $c66c7986096481a9$export$7a57f79000377ca2; });


var $2GmrW = parcelRequire("2GmrW");

var $eVyTV = parcelRequire("eVyTV");

var $4wEav = parcelRequire("4wEav");

var $3DlSW = parcelRequire("3DlSW");
function $c66c7986096481a9$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $c66c7986096481a9$var$createBorderStyle(prop, transform) {
    return (0, $2GmrW.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $c66c7986096481a9$export$1edee58a52776cd9 = $c66c7986096481a9$var$createBorderStyle("border", $c66c7986096481a9$export$34e2febe53ae29cc);
const $c66c7986096481a9$export$f9a7b6bd24892946 = $c66c7986096481a9$var$createBorderStyle("borderTop", $c66c7986096481a9$export$34e2febe53ae29cc);
const $c66c7986096481a9$export$5abca33e6be905d2 = $c66c7986096481a9$var$createBorderStyle("borderRight", $c66c7986096481a9$export$34e2febe53ae29cc);
const $c66c7986096481a9$export$e2ce9f12a980a822 = $c66c7986096481a9$var$createBorderStyle("borderBottom", $c66c7986096481a9$export$34e2febe53ae29cc);
const $c66c7986096481a9$export$47658cca1a909427 = $c66c7986096481a9$var$createBorderStyle("borderLeft", $c66c7986096481a9$export$34e2febe53ae29cc);
const $c66c7986096481a9$export$e7fb0694ba2404fc = $c66c7986096481a9$var$createBorderStyle("borderColor");
const $c66c7986096481a9$export$126a92c968acdb85 = $c66c7986096481a9$var$createBorderStyle("borderTopColor");
const $c66c7986096481a9$export$85cc51cb8fbb8c0e = $c66c7986096481a9$var$createBorderStyle("borderRightColor");
const $c66c7986096481a9$export$340b0327727f6d1a = $c66c7986096481a9$var$createBorderStyle("borderBottomColor");
const $c66c7986096481a9$export$60beef91a985b4bf = $c66c7986096481a9$var$createBorderStyle("borderLeftColor");
const $c66c7986096481a9$export$f9258c55612cbed7 = $c66c7986096481a9$var$createBorderStyle("outline", $c66c7986096481a9$export$34e2febe53ae29cc);
const $c66c7986096481a9$export$621fe586efeb64b9 = $c66c7986096481a9$var$createBorderStyle("outlineColor");
const $c66c7986096481a9$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $4wEav.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $4wEav.getValue)(transformer, propValue)
            });
        return (0, $3DlSW.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c66c7986096481a9$export$7a57f79000377ca2.propTypes = {};
$c66c7986096481a9$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $c66c7986096481a9$var$borders = (0, $eVyTV.default)($c66c7986096481a9$export$1edee58a52776cd9, $c66c7986096481a9$export$f9a7b6bd24892946, $c66c7986096481a9$export$5abca33e6be905d2, $c66c7986096481a9$export$e2ce9f12a980a822, $c66c7986096481a9$export$47658cca1a909427, $c66c7986096481a9$export$e7fb0694ba2404fc, $c66c7986096481a9$export$126a92c968acdb85, $c66c7986096481a9$export$85cc51cb8fbb8c0e, $c66c7986096481a9$export$340b0327727f6d1a, $c66c7986096481a9$export$60beef91a985b4bf, $c66c7986096481a9$export$7a57f79000377ca2, $c66c7986096481a9$export$f9258c55612cbed7, $c66c7986096481a9$export$621fe586efeb64b9);
var $c66c7986096481a9$export$2e2bcd8739ae039 = $c66c7986096481a9$var$borders;

});
parcelRegister("eVyTV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ade1763372ef794b$export$2e2bcd8739ae039; });

var $5H3Nw = parcelRequire("5H3Nw");
function $ade1763372ef794b$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $5H3Nw.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $ade1763372ef794b$export$2e2bcd8739ae039 = $ade1763372ef794b$var$compose;

});


parcelRegister("4o3a3", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $331bdb115fea1358$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $331bdb115fea1358$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $331bdb115fea1358$export$8a833ffa5f5dbeda; });

var $2GmrW = parcelRequire("2GmrW");

var $eVyTV = parcelRequire("eVyTV");

var $4wEav = parcelRequire("4wEav");

var $3DlSW = parcelRequire("3DlSW");

const $331bdb115fea1358$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $4wEav.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $4wEav.getValue)(transformer, propValue)
            });
        return (0, $3DlSW.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$331bdb115fea1358$export$5df9adcb0db95e1e.propTypes = {};
$331bdb115fea1358$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $331bdb115fea1358$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $4wEav.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $4wEav.getValue)(transformer, propValue)
            });
        return (0, $3DlSW.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$331bdb115fea1358$export$ec60d70ff941a580.propTypes = {};
$331bdb115fea1358$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $331bdb115fea1358$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $4wEav.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $4wEav.getValue)(transformer, propValue)
            });
        return (0, $3DlSW.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$331bdb115fea1358$export$8a833ffa5f5dbeda.propTypes = {};
$331bdb115fea1358$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $331bdb115fea1358$export$baf44164ca3a34e8 = (0, $2GmrW.default)({
    prop: "gridColumn"
});
const $331bdb115fea1358$export$8f7213a1cd01e832 = (0, $2GmrW.default)({
    prop: "gridRow"
});
const $331bdb115fea1358$export$b0e0abbc49ba668 = (0, $2GmrW.default)({
    prop: "gridAutoFlow"
});
const $331bdb115fea1358$export$bcd8b929d4b4142 = (0, $2GmrW.default)({
    prop: "gridAutoColumns"
});
const $331bdb115fea1358$export$e5039a674e14c828 = (0, $2GmrW.default)({
    prop: "gridAutoRows"
});
const $331bdb115fea1358$export$42bd9088661ffb03 = (0, $2GmrW.default)({
    prop: "gridTemplateColumns"
});
const $331bdb115fea1358$export$920682ae05b999bc = (0, $2GmrW.default)({
    prop: "gridTemplateRows"
});
const $331bdb115fea1358$export$1b88fbdd482fd33a = (0, $2GmrW.default)({
    prop: "gridTemplateAreas"
});
const $331bdb115fea1358$export$bdb486e40d52d26f = (0, $2GmrW.default)({
    prop: "gridArea"
});
const $331bdb115fea1358$var$grid = (0, $eVyTV.default)($331bdb115fea1358$export$5df9adcb0db95e1e, $331bdb115fea1358$export$ec60d70ff941a580, $331bdb115fea1358$export$8a833ffa5f5dbeda, $331bdb115fea1358$export$baf44164ca3a34e8, $331bdb115fea1358$export$8f7213a1cd01e832, $331bdb115fea1358$export$b0e0abbc49ba668, $331bdb115fea1358$export$bcd8b929d4b4142, $331bdb115fea1358$export$e5039a674e14c828, $331bdb115fea1358$export$42bd9088661ffb03, $331bdb115fea1358$export$920682ae05b999bc, $331bdb115fea1358$export$1b88fbdd482fd33a, $331bdb115fea1358$export$bdb486e40d52d26f);
var $331bdb115fea1358$export$2e2bcd8739ae039 = $331bdb115fea1358$var$grid;

});

parcelRegister("bYYrc", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $8b942dfb90409179$export$dbaffd4420ea0ac6; });

var $2GmrW = parcelRequire("2GmrW");

var $eVyTV = parcelRequire("eVyTV");
function $8b942dfb90409179$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $8b942dfb90409179$export$35e9368ef982300f = (0, $2GmrW.default)({
    prop: "color",
    themeKey: "palette",
    transform: $8b942dfb90409179$export$dbaffd4420ea0ac6
});
const $8b942dfb90409179$export$2506f56c10355b33 = (0, $2GmrW.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $8b942dfb90409179$export$dbaffd4420ea0ac6
});
const $8b942dfb90409179$export$8c5a050822fd698c = (0, $2GmrW.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $8b942dfb90409179$export$dbaffd4420ea0ac6
});
const $8b942dfb90409179$var$palette = (0, $eVyTV.default)($8b942dfb90409179$export$35e9368ef982300f, $8b942dfb90409179$export$2506f56c10355b33, $8b942dfb90409179$export$8c5a050822fd698c);
var $8b942dfb90409179$export$2e2bcd8739ae039 = $8b942dfb90409179$var$palette;

});

parcelRegister("hjVGl", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $c9c0f472fc8996b3$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $c9c0f472fc8996b3$export$488fda99655ff65a; });

var $2GmrW = parcelRequire("2GmrW");

var $eVyTV = parcelRequire("eVyTV");

var $3DlSW = parcelRequire("3DlSW");
function $c9c0f472fc8996b3$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $c9c0f472fc8996b3$export$7e3df82ee760448c = (0, $2GmrW.default)({
    prop: "width",
    transform: $c9c0f472fc8996b3$export$8afece71750ec241
});
const $c9c0f472fc8996b3$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $3DlSW.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $c9c0f472fc8996b3$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $3DlSW.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$c9c0f472fc8996b3$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $c9c0f472fc8996b3$export$ee148fbbe8357dd2 = (0, $2GmrW.default)({
    prop: "minWidth",
    transform: $c9c0f472fc8996b3$export$8afece71750ec241
});
const $c9c0f472fc8996b3$export$ac607276a8fe9f0a = (0, $2GmrW.default)({
    prop: "height",
    transform: $c9c0f472fc8996b3$export$8afece71750ec241
});
const $c9c0f472fc8996b3$export$dc0d8bd0b94f8570 = (0, $2GmrW.default)({
    prop: "maxHeight",
    transform: $c9c0f472fc8996b3$export$8afece71750ec241
});
const $c9c0f472fc8996b3$export$a43cf604e12f3b17 = (0, $2GmrW.default)({
    prop: "minHeight",
    transform: $c9c0f472fc8996b3$export$8afece71750ec241
});
const $c9c0f472fc8996b3$export$ffed9f14fb65e276 = (0, $2GmrW.default)({
    prop: "size",
    cssProperty: "width",
    transform: $c9c0f472fc8996b3$export$8afece71750ec241
});
const $c9c0f472fc8996b3$export$905076ed6620e671 = (0, $2GmrW.default)({
    prop: "size",
    cssProperty: "height",
    transform: $c9c0f472fc8996b3$export$8afece71750ec241
});
const $c9c0f472fc8996b3$export$6ccc93f785106a58 = (0, $2GmrW.default)({
    prop: "boxSizing"
});
const $c9c0f472fc8996b3$var$sizing = (0, $eVyTV.default)($c9c0f472fc8996b3$export$7e3df82ee760448c, $c9c0f472fc8996b3$export$488fda99655ff65a, $c9c0f472fc8996b3$export$ee148fbbe8357dd2, $c9c0f472fc8996b3$export$ac607276a8fe9f0a, $c9c0f472fc8996b3$export$dc0d8bd0b94f8570, $c9c0f472fc8996b3$export$a43cf604e12f3b17, $c9c0f472fc8996b3$export$6ccc93f785106a58);
var $c9c0f472fc8996b3$export$2e2bcd8739ae039 = $c9c0f472fc8996b3$var$sizing;

});



parcelRegister("3UZvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2da64f4d54cefb57$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $2da64f4d54cefb57$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== "function") return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === "&") return styles;
        if (selector.includes("data-") || selector.includes(".")) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("62jxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $465215be03c42b5b$export$2e2bcd8739ae039; });

var $2rvNX = parcelRequire("2rvNX");
function $465215be03c42b5b$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $2rvNX.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== "function") variant.style = (0, $2rvNX.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("bnMBi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84978abfe40d34d5$export$2e2bcd8739ae039; });

var $7LQic = parcelRequire("7LQic");
"use client";
const $84978abfe40d34d5$var$defaultTheme = (0, $7LQic.default)();
var $84978abfe40d34d5$export$2e2bcd8739ae039 = $84978abfe40d34d5$var$defaultTheme;

});
parcelRegister("7LQic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a857c681956f5f9$export$2e2bcd8739ae039; });

var $jBFBH = parcelRequire("jBFBH");

var $1D058 = parcelRequire("1D058");

var $dxwqG = parcelRequire("dxwqG");
// eslint-disable-next-line consistent-return
function $5a857c681956f5f9$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $jBFBH.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $5a857c681956f5f9$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || "light";
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== "boolean" && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!("colorSchemes" in options)) // Behaves exactly as v5
        return (0, $dxwqG.default)(options, ...args);
        let paletteOptions = palette;
        if (!("palette" in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === "dark") // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: "dark"
                };
            }
        }
        const theme = (0, $dxwqG.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === "light") {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $5a857c681956f5f9$var$attachColorScheme(theme, "dark", colorSchemesInput.dark);
        }
        if (theme.palette.mode === "dark") {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $5a857c681956f5f9$var$attachColorScheme(theme, "light", colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !("light" in colorSchemesInput) && defaultColorSchemeInput === "light") colorSchemesInput.light = true;
    return (0, $1D058.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== "boolean" && cssVariables
    }, ...args);
}

});
parcelRegister("jBFBH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e461bf52cfb5519d$export$2e2bcd8739ae039; });

var $bcPiE = parcelRequire("bcPiE");

var $aRKlE = parcelRequire("aRKlE");

var $kMbdT = parcelRequire("kMbdT");

var $4jhNG = parcelRequire("4jhNG");

var $36wNo = parcelRequire("36wNo");

var $cQoBX = parcelRequire("cQoBX");

var $kPefw = parcelRequire("kPefw");

var $5lszh = parcelRequire("5lszh");

var $8eHX8 = parcelRequire("8eHX8");

var $2UC73 = parcelRequire("2UC73");

var $j28zz = parcelRequire("j28zz");
function $e461bf52cfb5519d$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: "rgba(0, 0, 0, 0.87)",
            // Secondary text.
            secondary: "rgba(0, 0, 0, 0.6)",
            // Disabled text have even lower visual prominence.
            disabled: "rgba(0, 0, 0, 0.38)"
        },
        // The color used to divide different elements.
        divider: "rgba(0, 0, 0, 0.12)",
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $4jhNG.default).white,
            default: (0, $4jhNG.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: "rgba(0, 0, 0, 0.54)",
            // The color of an hovered action.
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: "rgba(0, 0, 0, 0.26)",
            // The background color of a disabled action.
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $e461bf52cfb5519d$export$a43af521ac8c3202 = $e461bf52cfb5519d$var$getLight();
function $e461bf52cfb5519d$var$getDark() {
    return {
        text: {
            primary: (0, $4jhNG.default).white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
        },
        divider: "rgba(255, 255, 255, 0.12)",
        background: {
            paper: "#121212",
            default: "#121212"
        },
        action: {
            active: (0, $4jhNG.default).white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: 0.08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: 0.16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $e461bf52cfb5519d$export$55ce6f3a06c59543 = $e461bf52cfb5519d$var$getDark();
function $e461bf52cfb5519d$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $kMbdT.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $kMbdT.darken)(intent.main, tonalOffsetDark);
    }
}
function $e461bf52cfb5519d$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $8eHX8.default)[200],
        light: (0, $8eHX8.default)[50],
        dark: (0, $8eHX8.default)[400]
    };
    return {
        main: (0, $8eHX8.default)[700],
        light: (0, $8eHX8.default)[400],
        dark: (0, $8eHX8.default)[800]
    };
}
function $e461bf52cfb5519d$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $cQoBX.default)[200],
        light: (0, $cQoBX.default)[50],
        dark: (0, $cQoBX.default)[400]
    };
    return {
        main: (0, $cQoBX.default)[500],
        light: (0, $cQoBX.default)[300],
        dark: (0, $cQoBX.default)[700]
    };
}
function $e461bf52cfb5519d$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kPefw.default)[500],
        light: (0, $kPefw.default)[300],
        dark: (0, $kPefw.default)[700]
    };
    return {
        main: (0, $kPefw.default)[700],
        light: (0, $kPefw.default)[400],
        dark: (0, $kPefw.default)[800]
    };
}
function $e461bf52cfb5519d$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2UC73.default)[400],
        light: (0, $2UC73.default)[300],
        dark: (0, $2UC73.default)[700]
    };
    return {
        main: (0, $2UC73.default)[700],
        light: (0, $2UC73.default)[500],
        dark: (0, $2UC73.default)[900]
    };
}
function $e461bf52cfb5519d$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $j28zz.default)[400],
        light: (0, $j28zz.default)[300],
        dark: (0, $j28zz.default)[700]
    };
    return {
        main: (0, $j28zz.default)[800],
        light: (0, $j28zz.default)[500],
        dark: (0, $j28zz.default)[900]
    };
}
function $e461bf52cfb5519d$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5lszh.default)[400],
        light: (0, $5lszh.default)[300],
        dark: (0, $5lszh.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $5lszh.default)[500],
        dark: (0, $5lszh.default)[900]
    };
}
function $e461bf52cfb5519d$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $e461bf52cfb5519d$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $e461bf52cfb5519d$var$getDefaultSecondary(mode);
    const error = palette.error || $e461bf52cfb5519d$var$getDefaultError(mode);
    const info = palette.info || $e461bf52cfb5519d$var$getDefaultInfo(mode);
    const success = palette.success || $e461bf52cfb5519d$var$getDefaultSuccess(mode);
    const warning = palette.warning || $e461bf52cfb5519d$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kMbdT.getContrastRatio)(background, $e461bf52cfb5519d$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $e461bf52cfb5519d$export$55ce6f3a06c59543.text.primary : $e461bf52cfb5519d$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $bcPiE.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $bcPiE.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $e461bf52cfb5519d$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $e461bf52cfb5519d$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === "light") modeHydrated = $e461bf52cfb5519d$var$getLight();
    else if (mode === "dark") modeHydrated = $e461bf52cfb5519d$var$getDark();
    const paletteOutput = (0, $aRKlE.default)({
        // A collection of common colors.
        common: {
            ...(0, $4jhNG.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $36wNo.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("kMbdT", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", function () { return $f200ff05976d07b4$export$427365fc3db6fc5e; });
$parcel$export(module.exports, "hslToRgb", function () { return $f200ff05976d07b4$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getContrastRatio", function () { return $f200ff05976d07b4$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $f200ff05976d07b4$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "private_safeAlpha", function () { return $f200ff05976d07b4$export$34109543fc7f43f8; });
$parcel$export(module.exports, "darken", function () { return $f200ff05976d07b4$export$4b073707ff63303; });
$parcel$export(module.exports, "private_safeDarken", function () { return $f200ff05976d07b4$export$eaaef2dca3e9e512; });
$parcel$export(module.exports, "lighten", function () { return $f200ff05976d07b4$export$c0816ed86df316af; });
$parcel$export(module.exports, "private_safeLighten", function () { return $f200ff05976d07b4$export$aeeda94ef1d01275; });
$parcel$export(module.exports, "private_safeEmphasize", function () { return $f200ff05976d07b4$export$11bb74ba10c85505; });

var $bcPiE = parcelRequire("bcPiE");

var $c8ins = parcelRequire("c8ins");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f200ff05976d07b4$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $c8ins.default)(value, min, max);
}
function $f200ff05976d07b4$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $f200ff05976d07b4$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $f200ff05976d07b4$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $f200ff05976d07b4$export$677b39864803984e($f200ff05976d07b4$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if (![
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].includes(type)) throw new Error((0, $bcPiE.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if (![
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].includes(colorSpace)) throw new Error((0, $bcPiE.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $f200ff05976d07b4$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $f200ff05976d07b4$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes("hsl") && idx !== 0 ? `${val}%` : val).join(" ");
};
const $f200ff05976d07b4$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $f200ff05976d07b4$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $f200ff05976d07b4$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes("rgb")) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes("hsl")) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes("color")) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $f200ff05976d07b4$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith("#")) return color;
    const { values: values } = $f200ff05976d07b4$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$f200ff05976d07b4$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $f200ff05976d07b4$export$29fb7152bd3f781a(color) {
    color = $f200ff05976d07b4$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $f200ff05976d07b4$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $f200ff05976d07b4$export$c852d90bf7403b62(color) {
    color = $f200ff05976d07b4$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $f200ff05976d07b4$export$677b39864803984e($f200ff05976d07b4$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $f200ff05976d07b4$export$d061e26956a60b0a(foreground, background) {
    const lumA = $f200ff05976d07b4$export$c852d90bf7403b62(foreground);
    const lumB = $f200ff05976d07b4$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $f200ff05976d07b4$export$58f0f39f63f3cf42(color, value) {
    color = $f200ff05976d07b4$export$677b39864803984e(color);
    value = $f200ff05976d07b4$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f200ff05976d07b4$export$211a73f2b8c10ce4(color);
}
function $f200ff05976d07b4$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $f200ff05976d07b4$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $f200ff05976d07b4$export$4b073707ff63303(color, coefficient) {
    color = $f200ff05976d07b4$export$677b39864803984e(color);
    coefficient = $f200ff05976d07b4$var$clampWrapper(coefficient);
    if (color.type.includes("hsl")) color.values[2] *= 1 - coefficient;
    else if (color.type.includes("rgb") || color.type.includes("color")) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f200ff05976d07b4$export$211a73f2b8c10ce4(color);
}
function $f200ff05976d07b4$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $f200ff05976d07b4$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f200ff05976d07b4$export$c0816ed86df316af(color, coefficient) {
    color = $f200ff05976d07b4$export$677b39864803984e(color);
    coefficient = $f200ff05976d07b4$var$clampWrapper(coefficient);
    if (color.type.includes("hsl")) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes("rgb")) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes("color")) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f200ff05976d07b4$export$211a73f2b8c10ce4(color);
}
function $f200ff05976d07b4$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $f200ff05976d07b4$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f200ff05976d07b4$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $f200ff05976d07b4$export$c852d90bf7403b62(color) > 0.5 ? $f200ff05976d07b4$export$4b073707ff63303(color, coefficient) : $f200ff05976d07b4$export$c0816ed86df316af(color, coefficient);
}
function $f200ff05976d07b4$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $f200ff05976d07b4$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f200ff05976d07b4$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f200ff05976d07b4$export$677b39864803984e(background);
    const overlayColor = $f200ff05976d07b4$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f200ff05976d07b4$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("c8ins", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d547cbbc15af7c3$export$2e2bcd8739ae039; });
function $8d547cbbc15af7c3$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $8d547cbbc15af7c3$export$2e2bcd8739ae039 = $8d547cbbc15af7c3$var$clamp;

});


parcelRegister("4jhNG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3236be89ebe3f9c7$export$2e2bcd8739ae039; });
const $3236be89ebe3f9c7$var$common = {
    black: "#000",
    white: "#fff"
};
var $3236be89ebe3f9c7$export$2e2bcd8739ae039 = $3236be89ebe3f9c7$var$common;

});

parcelRegister("36wNo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $242b5f2e6fb34673$export$2e2bcd8739ae039; });
const $242b5f2e6fb34673$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $242b5f2e6fb34673$export$2e2bcd8739ae039 = $242b5f2e6fb34673$var$grey;

});

parcelRegister("cQoBX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $959d6ea2dfef0ff9$export$2e2bcd8739ae039; });
const $959d6ea2dfef0ff9$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $959d6ea2dfef0ff9$export$2e2bcd8739ae039 = $959d6ea2dfef0ff9$var$purple;

});

parcelRegister("kPefw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2939fad81bebc7b$export$2e2bcd8739ae039; });
const $f2939fad81bebc7b$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f2939fad81bebc7b$export$2e2bcd8739ae039 = $f2939fad81bebc7b$var$red;

});

parcelRegister("5lszh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e4512f488d74f6e$export$2e2bcd8739ae039; });
const $3e4512f488d74f6e$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $3e4512f488d74f6e$export$2e2bcd8739ae039 = $3e4512f488d74f6e$var$orange;

});

parcelRegister("8eHX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff1b9aa82647aef$export$2e2bcd8739ae039; });
const $5ff1b9aa82647aef$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $5ff1b9aa82647aef$export$2e2bcd8739ae039 = $5ff1b9aa82647aef$var$blue;

});

parcelRegister("2UC73", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21ee601e98e3b399$export$2e2bcd8739ae039; });
const $21ee601e98e3b399$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $21ee601e98e3b399$export$2e2bcd8739ae039 = $21ee601e98e3b399$var$lightBlue;

});

parcelRegister("j28zz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb4da990472fc6c$export$2e2bcd8739ae039; });
const $ddb4da990472fc6c$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ddb4da990472fc6c$export$2e2bcd8739ae039 = $ddb4da990472fc6c$var$green;

});


parcelRegister("1D058", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12f97f33ac6f5259$export$2e2bcd8739ae039; });

var $bcPiE = parcelRequire("bcPiE");

var $aRKlE = parcelRequire("aRKlE");

var $5YmAa = parcelRequire("5YmAa");
var $1kyhE = parcelRequire("1kyhE");

var $4wEav = parcelRequire("4wEav");

var $f9lEP = parcelRequire("f9lEP");
var $68TO7 = parcelRequire("68TO7");
var $bLnRd = parcelRequire("bLnRd");

var $l4G5A = parcelRequire("l4G5A");
var $7AgjI = parcelRequire("7AgjI");

var $kMbdT = parcelRequire("kMbdT");

var $dxwqG = parcelRequire("dxwqG");

var $h7tta = parcelRequire("h7tta");

var $gMwbt = parcelRequire("gMwbt");

var $aVfSE = parcelRequire("aVfSE");

var $2X84T = parcelRequire("2X84T");
function $12f97f33ac6f5259$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $12f97f33ac6f5259$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $12f97f33ac6f5259$var$toRgb(color) {
    if (typeof color !== "string" || !color.startsWith("hsl")) return color;
    return (0, $kMbdT.hslToRgb)(color);
}
function $12f97f33ac6f5259$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $kMbdT.private_safeColorChannel)($12f97f33ac6f5259$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + "\n" + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $12f97f33ac6f5259$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === "number") return `${spacingInput}px`;
    if (typeof spacingInput === "string" || typeof spacingInput === "function" || Array.isArray(spacingInput)) return spacingInput;
    return "8px";
}
const $12f97f33ac6f5259$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $12f97f33ac6f5259$export$65418b4d9082cc44 = (cssVarPrefix = "mui")=>(0, $1kyhE.default)(cssVarPrefix);
function $12f97f33ac6f5259$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === "dark" ? "dark" : "light";
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $h7tta.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $dxwqG.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $h7tta.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $h7tta.getOverlays)(mode)
    };
    return muiTheme;
}
function $12f97f33ac6f5259$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = "mui", shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $gMwbt.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? "media" : undefined, rootSelector: rootSelector = ":root", ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== "light" ? "light" : firstColorScheme);
    const getCssVar = $12f97f33ac6f5259$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === "dark" && !("dark" in colorSchemesInput) || defaultColorScheme === "light" && !("light" in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $bcPiE.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $12f97f33ac6f5259$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $12f97f33ac6f5259$var$attachColorScheme(colorSchemes, builtInLight, undefined, "light");
    if (builtInDark && !colorSchemes.dark) $12f97f33ac6f5259$var$attachColorScheme(colorSchemes, builtInDark, undefined, "dark");
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $bLnRd.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $12f97f33ac6f5259$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split("-");
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === "light") {
            $12f97f33ac6f5259$var$setColor(palette.common, "background", "#fff");
            $12f97f33ac6f5259$var$setColor(palette.common, "onBackground", "#000");
        }
        if (palette.mode === "dark") {
            $12f97f33ac6f5259$var$setColor(palette.common, "background", "#000");
            $12f97f33ac6f5259$var$setColor(palette.common, "onBackground", "#fff");
        }
        // assign component variables
        $12f97f33ac6f5259$var$assignNode(palette, [
            "Alert",
            "AppBar",
            "Avatar",
            "Button",
            "Chip",
            "FilledInput",
            "LinearProgress",
            "Skeleton",
            "Slider",
            "SnackbarContent",
            "SpeedDialAction",
            "StepConnector",
            "StepContent",
            "Switch",
            "TableCell",
            "Tooltip"
        ]);
        if (palette.mode === "light") {
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorColor", (0, $kMbdT.private_safeDarken)(palette.error.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoColor", (0, $kMbdT.private_safeDarken)(palette.info.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successColor", (0, $kMbdT.private_safeDarken)(palette.success.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningColor", (0, $kMbdT.private_safeDarken)(palette.warning.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.error.main)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.info.main)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.success.main)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorStandardBg", (0, $kMbdT.private_safeLighten)(palette.error.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoStandardBg", (0, $kMbdT.private_safeLighten)(palette.info.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successStandardBg", (0, $kMbdT.private_safeLighten)(palette.success.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningStandardBg", (0, $kMbdT.private_safeLighten)(palette.warning.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            $12f97f33ac6f5259$var$setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-100"));
            $12f97f33ac6f5259$var$setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-400"));
            $12f97f33ac6f5259$var$setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-300"));
            $12f97f33ac6f5259$var$setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-A100"));
            $12f97f33ac6f5259$var$setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-400"));
            $12f97f33ac6f5259$var$setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-700"));
            $12f97f33ac6f5259$var$setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-700"));
            $12f97f33ac6f5259$var$setColor(palette.FilledInput, "bg", "rgba(0, 0, 0, 0.06)");
            $12f97f33ac6f5259$var$setColor(palette.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)");
            $12f97f33ac6f5259$var$setColor(palette.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)");
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "primaryBg", (0, $kMbdT.private_safeLighten)(palette.primary.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "secondaryBg", (0, $kMbdT.private_safeLighten)(palette.secondary.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "errorBg", (0, $kMbdT.private_safeLighten)(palette.error.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "infoBg", (0, $kMbdT.private_safeLighten)(palette.info.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "successBg", (0, $kMbdT.private_safeLighten)(palette.success.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "warningBg", (0, $kMbdT.private_safeLighten)(palette.warning.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.11)`);
            $12f97f33ac6f5259$var$setColor(palette.Slider, "primaryTrack", (0, $kMbdT.private_safeLighten)(palette.primary.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "secondaryTrack", (0, $kMbdT.private_safeLighten)(palette.secondary.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "errorTrack", (0, $kMbdT.private_safeLighten)(palette.error.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "infoTrack", (0, $kMbdT.private_safeLighten)(palette.info.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "successTrack", (0, $kMbdT.private_safeLighten)(palette.success.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "warningTrack", (0, $kMbdT.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $kMbdT.private_safeEmphasize)(palette.background.default, 0.8);
            $12f97f33ac6f5259$var$setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            $12f97f33ac6f5259$var$setColor(palette.SnackbarContent, "color", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $12f97f33ac6f5259$var$setColor(palette.SpeedDialAction, "fabHoverBg", (0, $kMbdT.private_safeEmphasize)(palette.background.paper, 0.15));
            $12f97f33ac6f5259$var$setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-400"));
            $12f97f33ac6f5259$var$setColor(palette.StepContent, "border", setCssVarColor("palette-grey-400"));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "defaultColor", setCssVarColor("palette-common-white"));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-100"));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "primaryDisabledColor", (0, $kMbdT.private_safeLighten)(palette.primary.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "secondaryDisabledColor", (0, $kMbdT.private_safeLighten)(palette.secondary.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "errorDisabledColor", (0, $kMbdT.private_safeLighten)(palette.error.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "infoDisabledColor", (0, $kMbdT.private_safeLighten)(palette.info.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "successDisabledColor", (0, $kMbdT.private_safeLighten)(palette.success.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "warningDisabledColor", (0, $kMbdT.private_safeLighten)(palette.warning.main, 0.62));
            $12f97f33ac6f5259$var$setColor(palette.TableCell, "border", (0, $kMbdT.private_safeLighten)((0, $kMbdT.private_safeAlpha)(palette.divider, 1), 0.88));
            $12f97f33ac6f5259$var$setColor(palette.Tooltip, "bg", (0, $kMbdT.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === "dark") {
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorColor", (0, $kMbdT.private_safeLighten)(palette.error.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoColor", (0, $kMbdT.private_safeLighten)(palette.info.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successColor", (0, $kMbdT.private_safeLighten)(palette.success.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningColor", (0, $kMbdT.private_safeLighten)(palette.warning.light, 0.6));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-dark"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-dark"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-dark"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-dark"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningFilledColor", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorStandardBg", (0, $kMbdT.private_safeDarken)(palette.error.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoStandardBg", (0, $kMbdT.private_safeDarken)(palette.info.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successStandardBg", (0, $kMbdT.private_safeDarken)(palette.success.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningStandardBg", (0, $kMbdT.private_safeDarken)(palette.warning.light, 0.9));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            $12f97f33ac6f5259$var$setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            $12f97f33ac6f5259$var$setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-900"));
            $12f97f33ac6f5259$var$setColor(palette.AppBar, "darkBg", setCssVarColor("palette-background-paper")); // specific for dark mode
            $12f97f33ac6f5259$var$setColor(palette.AppBar, "darkColor", setCssVarColor("palette-text-primary")); // specific for dark mode
            $12f97f33ac6f5259$var$setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-600"));
            $12f97f33ac6f5259$var$setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-800"));
            $12f97f33ac6f5259$var$setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-700"));
            $12f97f33ac6f5259$var$setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-700"));
            $12f97f33ac6f5259$var$setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-300"));
            $12f97f33ac6f5259$var$setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-300"));
            $12f97f33ac6f5259$var$setColor(palette.FilledInput, "bg", "rgba(255, 255, 255, 0.09)");
            $12f97f33ac6f5259$var$setColor(palette.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)");
            $12f97f33ac6f5259$var$setColor(palette.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)");
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "primaryBg", (0, $kMbdT.private_safeDarken)(palette.primary.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "secondaryBg", (0, $kMbdT.private_safeDarken)(palette.secondary.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "errorBg", (0, $kMbdT.private_safeDarken)(palette.error.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "infoBg", (0, $kMbdT.private_safeDarken)(palette.info.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "successBg", (0, $kMbdT.private_safeDarken)(palette.success.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.LinearProgress, "warningBg", (0, $kMbdT.private_safeDarken)(palette.warning.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.13)`);
            $12f97f33ac6f5259$var$setColor(palette.Slider, "primaryTrack", (0, $kMbdT.private_safeDarken)(palette.primary.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "secondaryTrack", (0, $kMbdT.private_safeDarken)(palette.secondary.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "errorTrack", (0, $kMbdT.private_safeDarken)(palette.error.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "infoTrack", (0, $kMbdT.private_safeDarken)(palette.info.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "successTrack", (0, $kMbdT.private_safeDarken)(palette.success.main, 0.5));
            $12f97f33ac6f5259$var$setColor(palette.Slider, "warningTrack", (0, $kMbdT.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $kMbdT.private_safeEmphasize)(palette.background.default, 0.98);
            $12f97f33ac6f5259$var$setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            $12f97f33ac6f5259$var$setColor(palette.SnackbarContent, "color", $12f97f33ac6f5259$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $12f97f33ac6f5259$var$setColor(palette.SpeedDialAction, "fabHoverBg", (0, $kMbdT.private_safeEmphasize)(palette.background.paper, 0.15));
            $12f97f33ac6f5259$var$setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-600"));
            $12f97f33ac6f5259$var$setColor(palette.StepContent, "border", setCssVarColor("palette-grey-600"));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "defaultColor", setCssVarColor("palette-grey-300"));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-600"));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "primaryDisabledColor", (0, $kMbdT.private_safeDarken)(palette.primary.main, 0.55));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "secondaryDisabledColor", (0, $kMbdT.private_safeDarken)(palette.secondary.main, 0.55));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "errorDisabledColor", (0, $kMbdT.private_safeDarken)(palette.error.main, 0.55));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "infoDisabledColor", (0, $kMbdT.private_safeDarken)(palette.info.main, 0.55));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "successDisabledColor", (0, $kMbdT.private_safeDarken)(palette.success.main, 0.55));
            $12f97f33ac6f5259$var$setColor(palette.Switch, "warningDisabledColor", (0, $kMbdT.private_safeDarken)(palette.warning.main, 0.55));
            $12f97f33ac6f5259$var$setColor(palette.TableCell, "border", (0, $kMbdT.private_safeDarken)((0, $kMbdT.private_safeAlpha)(palette.divider, 1), 0.68));
            $12f97f33ac6f5259$var$setColor(palette.Tooltip, "bg", (0, $kMbdT.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $12f97f33ac6f5259$var$setColorChannel(palette.background, "default");
        // added for consistency with the `background.default` token
        $12f97f33ac6f5259$var$setColorChannel(palette.background, "paper");
        $12f97f33ac6f5259$var$setColorChannel(palette.common, "background");
        $12f97f33ac6f5259$var$setColorChannel(palette.common, "onBackground");
        $12f97f33ac6f5259$var$setColorChannel(palette, "divider");
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== "tonalOffset" && colors && typeof colors === "object") {
                // Silent the error for custom palettes.
                if (colors.main) $12f97f33ac6f5259$var$setColor(palette[color], "mainChannel", (0, $kMbdT.private_safeColorChannel)($12f97f33ac6f5259$var$toRgb(colors.main)));
                if (colors.light) $12f97f33ac6f5259$var$setColor(palette[color], "lightChannel", (0, $kMbdT.private_safeColorChannel)($12f97f33ac6f5259$var$toRgb(colors.light)));
                if (colors.dark) $12f97f33ac6f5259$var$setColor(palette[color], "darkChannel", (0, $kMbdT.private_safeColorChannel)($12f97f33ac6f5259$var$toRgb(colors.dark)));
                if (colors.contrastText) $12f97f33ac6f5259$var$setColor(palette[color], "contrastTextChannel", (0, $kMbdT.private_safeColorChannel)($12f97f33ac6f5259$var$toRgb(colors.contrastText)));
                if (color === "text") {
                    // Text colors: text.primary, text.secondary
                    $12f97f33ac6f5259$var$setColorChannel(palette[color], "primary");
                    $12f97f33ac6f5259$var$setColorChannel(palette[color], "secondary");
                }
                if (color === "action") {
                    // Action colors: action.active, action.selected
                    if (colors.active) $12f97f33ac6f5259$var$setColorChannel(palette[color], "active");
                    if (colors.selected) $12f97f33ac6f5259$var$setColorChannel(palette[color], "selected");
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $aRKlE.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $aVfSE.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $68TO7.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $5YmAa.default)(input.spacing, (0, $4wEav.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $f9lEP.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $7AgjI.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $l4G5A.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $2X84T.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("1kyhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f8240bc76c929f9$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $0f8240bc76c929f9$export$2e2bcd8739ae039(prefix = "") {
    function appendVar(...vars) {
        if (!vars.length) return "";
        const value = vars[0];
        if (typeof value === "string" && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ""}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ""}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("f9lEP", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", function () { return $b0787f0547b94e5e$export$858538ff6c0d421d; });
/* eslint-disable import/prefer-default-export */ function $b0787f0547b94e5e$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === "media") return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith("data-") && !selector.includes("%s")) return `[${selector}="${colorScheme}"] &`;
            if (selector === "class") return `.${colorScheme} &`;
            if (selector === "data") return `[data-${colorScheme}] &`;
            return `${selector.replace("%s", colorScheme)} &`;
        }
        return "&";
    };
}

});

parcelRegister("68TO7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $012776d516b092a2$export$2e2bcd8739ae039; });

var $aRKlE = parcelRequire("aRKlE");

var $7yV3o = parcelRequire("7yV3o");
function $012776d516b092a2$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = "light", ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $7yV3o.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $7yV3o.default)(scheme, parserConfig);
        themeVars = (0, $aRKlE.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $7yV3o.default)(defaultScheme, parserConfig);
        themeVars = (0, $aRKlE.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === "class") rule = ".%s";
        if (selector === "data") rule = "[data-%s]";
        if (selector?.startsWith("data-") && !selector.includes("%s")) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === "media") {
                if (theme.defaultColorScheme === colorScheme) return ":root";
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ":root": cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace("%s", String(colorScheme))}`;
                return rule.replace("%s", String(colorScheme));
            }
        }
        return ":root";
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $aRKlE.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || "light";
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === "string" ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $012776d516b092a2$export$2e2bcd8739ae039 = $012776d516b092a2$var$prepareCssVars;

});
parcelRegister("7yV3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5817f713ea5fc3af$export$2e2bcd8739ae039; });
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $5817f713ea5fc3af$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === "object") temp[k] = value;
        } else if (temp && typeof temp === "object") {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $5817f713ea5fc3af$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === "object" && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $5817f713ea5fc3af$var$getCssValue = (keys, value)=>{
    if (typeof value === "number") {
        if ([
            "lineHeight",
            "fontWeight",
            "opacity",
            "zIndex"
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes("opacity")) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $5817f713ea5fc3af$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $5817f713ea5fc3af$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === "string" || typeof value === "number") {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ""}${keys.join("-")}`;
                const resolvedValue = $5817f713ea5fc3af$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $5817f713ea5fc3af$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $5817f713ea5fc3af$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === "vars" // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("bLnRd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89069712c2902bee$export$2e2bcd8739ae039; });
function $89069712c2902bee$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === "object") vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ""}${value.fontVariant ? `${value.fontVariant} ` : ""}${value.fontWeight ? `${value.fontWeight} ` : ""}${value.fontStretch ? `${value.fontStretch} ` : ""}${value.fontSize || ""}${value.lineHeight ? `/${value.lineHeight} ` : ""}${value.fontFamily || ""}`;
    });
    return vars;
}

});

parcelRegister("dxwqG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db7833cc2788a36$export$2e2bcd8739ae039; });

var $bcPiE = parcelRequire("bcPiE");

var $aRKlE = parcelRequire("aRKlE");

var $l4G5A = parcelRequire("l4G5A");
var $7AgjI = parcelRequire("7AgjI");

var $lGH00 = parcelRequire("lGH00");


var $40eOk = parcelRequire("40eOk");

var $jBFBH = parcelRequire("jBFBH");

var $5JSeR = parcelRequire("5JSeR");

var $5aOhM = parcelRequire("5aOhM");

var $jN8g2 = parcelRequire("jN8g2");

var $frVLB = parcelRequire("frVLB");

var $2X84T = parcelRequire("2X84T");
function $9db7833cc2788a36$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $bcPiE.default)(20));
    const palette = (0, $jBFBH.default)(paletteInput);
    const systemTheme = (0, $lGH00.default)(options);
    let muiTheme = (0, $aRKlE.default)(systemTheme, {
        mixins: (0, $40eOk.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $5aOhM.default).slice(),
        typography: (0, $5JSeR.default)(palette, typographyInput),
        transitions: (0, $jN8g2.default)(transitionsInput),
        zIndex: {
            ...(0, $frVLB.default)
        }
    });
    muiTheme = (0, $aRKlE.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $aRKlE.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $7AgjI.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $l4G5A.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $2X84T.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $9db7833cc2788a36$var$warnedOnce = false;
function $9db7833cc2788a36$export$c469355549431d9b(...args) {
    return $9db7833cc2788a36$var$createThemeNoVars(...args);
}
var $9db7833cc2788a36$export$2e2bcd8739ae039 = $9db7833cc2788a36$var$createThemeNoVars;

});
parcelRegister("40eOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ea2a6a288092cbc$export$2e2bcd8739ae039; });
function $2ea2a6a288092cbc$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("5JSeR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42db3a6b294545be$export$2e2bcd8739ae039; });

var $aRKlE = parcelRequire("aRKlE");
function $42db3a6b294545be$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $42db3a6b294545be$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $42db3a6b294545be$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $42db3a6b294545be$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $42db3a6b294545be$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === "function" ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $42db3a6b294545be$var$defaultFontFamily ? {
                letterSpacing: `${$42db3a6b294545be$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $42db3a6b294545be$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $42db3a6b294545be$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $aRKlE.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("5aOhM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c44e49dfb7d5a03$export$2e2bcd8739ae039; });
const $3c44e49dfb7d5a03$var$shadowKeyUmbraOpacity = 0.2;
const $3c44e49dfb7d5a03$var$shadowKeyPenumbraOpacity = 0.14;
const $3c44e49dfb7d5a03$var$shadowAmbientShadowOpacity = 0.12;
function $3c44e49dfb7d5a03$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$3c44e49dfb7d5a03$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$3c44e49dfb7d5a03$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$3c44e49dfb7d5a03$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $3c44e49dfb7d5a03$var$shadows = [
    "none",
    $3c44e49dfb7d5a03$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $3c44e49dfb7d5a03$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $3c44e49dfb7d5a03$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $3c44e49dfb7d5a03$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $3c44e49dfb7d5a03$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $3c44e49dfb7d5a03$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $3c44e49dfb7d5a03$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $3c44e49dfb7d5a03$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $3c44e49dfb7d5a03$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $3c44e49dfb7d5a03$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $3c44e49dfb7d5a03$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $3c44e49dfb7d5a03$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $3c44e49dfb7d5a03$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $3c44e49dfb7d5a03$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $3c44e49dfb7d5a03$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $3c44e49dfb7d5a03$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $3c44e49dfb7d5a03$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $3c44e49dfb7d5a03$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $3c44e49dfb7d5a03$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $3c44e49dfb7d5a03$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $3c44e49dfb7d5a03$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $3c44e49dfb7d5a03$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $3c44e49dfb7d5a03$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $3c44e49dfb7d5a03$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $3c44e49dfb7d5a03$export$2e2bcd8739ae039 = $3c44e49dfb7d5a03$var$shadows;

});

parcelRegister("jN8g2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e688ffb72fa44a3f$export$2e2bcd8739ae039; });
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $e688ffb72fa44a3f$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $e688ffb72fa44a3f$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $e688ffb72fa44a3f$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $e688ffb72fa44a3f$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $e688ffb72fa44a3f$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$e688ffb72fa44a3f$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$e688ffb72fa44a3f$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $e688ffb72fa44a3f$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $e688ffb72fa44a3f$var$formatMs(delay)}`).join(",");
    };
    return {
        getAutoHeightDuration: $e688ffb72fa44a3f$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("frVLB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f62feb8e149763$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $b3f62feb8e149763$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $b3f62feb8e149763$export$2e2bcd8739ae039 = $b3f62feb8e149763$var$zIndex;

});

parcelRegister("2X84T", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", function () { return $22675b9727c89616$export$32c2afa5f91892aa; });
/* eslint-disable import/prefer-default-export */ 
var $aRKlE = parcelRequire("aRKlE");
function $22675b9727c89616$var$isSerializable(val) {
    return (0, $aRKlE.isPlainObject)(val) || typeof val === "undefined" || typeof val === "string" || typeof val === "boolean" || typeof val === "number" || Array.isArray(val);
}
function $22675b9727c89616$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$22675b9727c89616$var$isSerializable(value) || key.startsWith("unstable_")) delete object[key];
            else if ((0, $aRKlE.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("h7tta", function(module, exports) {

$parcel$export(module.exports, "getOpacity", function () { return $c769f31fb3209a37$export$c85e0347fceb69ba; });
$parcel$export(module.exports, "getOverlays", function () { return $c769f31fb3209a37$export$dd191566510330d3; });
$parcel$export(module.exports, "default", function () { return $c769f31fb3209a37$export$2e2bcd8739ae039; });

var $jBFBH = parcelRequire("jBFBH");

var $kQVC1 = parcelRequire("kQVC1");
const $c769f31fb3209a37$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return "none";
    const overlay = (0, $kQVC1.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $c769f31fb3209a37$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === "dark" ? 0.5 : 0.42,
        inputUnderline: mode === "dark" ? 0.7 : 0.42,
        switchTrackDisabled: mode === "dark" ? 0.2 : 0.12,
        switchTrack: mode === "dark" ? 0.3 : 0.38
    };
}
function $c769f31fb3209a37$export$dd191566510330d3(mode) {
    return mode === "dark" ? $c769f31fb3209a37$var$defaultDarkOverlays : [];
}
function $c769f31fb3209a37$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: "light"
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $jBFBH.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$c769f31fb3209a37$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $c769f31fb3209a37$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("kQVC1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2e55a9154a1421f$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $f2e55a9154a1421f$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("gMwbt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c37a18198d45dbf1$export$2e2bcd8739ae039; });
function $c37a18198d45dbf1$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === "palette" && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("aVfSE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f3b8bca016699cb$export$2e2bcd8739ae039; });

var $4P1rr = parcelRequire("4P1rr");
var $7f3b8bca016699cb$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ":root";
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === "class") rule = ".%s";
        if (selector === "data") rule = "[data-%s]";
        if (selector?.startsWith("data-") && !selector.includes("%s")) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === "dark") {
                const excludedVariables = {};
                (0, $4P1rr.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === "media") return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace("%s", colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace("%s", colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== "media") return `${root}, ${rule.replace("%s", String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === "media") return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace("%s", String(colorScheme));
        }
        return root;
    };

});
parcelRegister("4P1rr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $382d0b21ff8c3215$export$2e2bcd8739ae039; });
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $382d0b21ff8c3215$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ""}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkColor`
    ];
var $382d0b21ff8c3215$export$2e2bcd8739ae039 = $382d0b21ff8c3215$var$excludeVariablesFromRoot;

});





parcelRegister("dUHEu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2125dbca22c4d7e$export$2e2bcd8739ae039; });
var $a2125dbca22c4d7e$export$2e2bcd8739ae039 = "$$material";

});

parcelRegister("k8hCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea823a3ef6498a69$export$2e2bcd8739ae039; });

var $llWbP = parcelRequire("llWbP");
const $ea823a3ef6498a69$var$rootShouldForwardProp = (prop)=>(0, $llWbP.default)(prop) && prop !== "classes";
var $ea823a3ef6498a69$export$2e2bcd8739ae039 = $ea823a3ef6498a69$var$rootShouldForwardProp;

});
parcelRegister("llWbP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8b8b26c257dfc8a$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $f8b8b26c257dfc8a$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $f8b8b26c257dfc8a$export$2e2bcd8739ae039 = $f8b8b26c257dfc8a$var$slotShouldForwardProp;

});



parcelRegister("dGUQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f7b4b0d1e5ffe43$export$2e2bcd8739ae039; });

var $kiwvF = parcelRequire("kiwvF");
const $9f7b4b0d1e5ffe43$var$memoTheme = (0, $kiwvF.default);
var $9f7b4b0d1e5ffe43$export$2e2bcd8739ae039 = $9f7b4b0d1e5ffe43$var$memoTheme;

});
parcelRegister("kiwvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec6eb4d67a9fd6a5$export$2e2bcd8739ae039; });

var $62jxo = parcelRequire("62jxo");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $ec6eb4d67a9fd6a5$var$arg = {
    theme: undefined
};
function $ec6eb4d67a9fd6a5$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $ec6eb4d67a9fd6a5$var$arg.theme = props.theme;
            value = (0, $62jxo.default)(styleFn($ec6eb4d67a9fd6a5$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("9acxQ", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $6abec762bc913930$export$2440da353cedad43; });
parcelRequire("cQmXV");


var $8JX34 = parcelRequire("8JX34");

var $7uT18 = parcelRequire("7uT18");
"use client";
function $6abec762bc913930$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $8JX34.default), {
        ...props
    });
}
var $6abec762bc913930$export$2e2bcd8739ae039 = $6abec762bc913930$var$DefaultPropsProvider;
function $6abec762bc913930$export$2440da353cedad43(params) {
    return (0, $8JX34.useDefaultProps)(params);
}

});
parcelRegister("8JX34", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $65d05486dcf70eda$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $65d05486dcf70eda$export$2e2bcd8739ae039; });

var $cQmXV = parcelRequire("cQmXV");


var $9zYTc = parcelRequire("9zYTc");

var $7uT18 = parcelRequire("7uT18");
"use client";
const $65d05486dcf70eda$var$PropsContext = /*#__PURE__*/ $cQmXV.createContext(undefined);
function $65d05486dcf70eda$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $7uT18.jsx)($65d05486dcf70eda$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $65d05486dcf70eda$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $9zYTc.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $9zYTc.default)(config, props);
    return props;
}
function $65d05486dcf70eda$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $cQmXV.useContext($65d05486dcf70eda$var$PropsContext);
    return $65d05486dcf70eda$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $65d05486dcf70eda$export$2e2bcd8739ae039 = $65d05486dcf70eda$var$DefaultPropsProvider;

});
parcelRegister("9zYTc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f969d45ec05d44d$export$2e2bcd8739ae039; });
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $6f969d45ec05d44d$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === "components" || propName === "slots") output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === "componentsProps" || propName === "slotProps") {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $6f969d45ec05d44d$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});



parcelRegister("20gtU", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $17585dbcd910bd4b$export$c7c50641356bdfa5; });

var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $17585dbcd910bd4b$export$c7c50641356bdfa5(slot) {
    return (0, $jQsHx.default)("MuiSvgIcon", slot);
}
const $17585dbcd910bd4b$var$svgIconClasses = (0, $9FFKn.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $17585dbcd910bd4b$export$2e2bcd8739ae039 = $17585dbcd910bd4b$var$svgIconClasses;

});
parcelRegister("9FFKn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01d12aa31332bdfa$export$2e2bcd8739ae039; });

var $jQsHx = parcelRequire("jQsHx");
function $01d12aa31332bdfa$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $jQsHx.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("jQsHx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e729231ba73a6168$export$2e2bcd8739ae039; });

var $62K0D = parcelRequire("62K0D");
const $e729231ba73a6168$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $e729231ba73a6168$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $e729231ba73a6168$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $62K0D.default).generate(componentName)}-${slot}`;
}
function $e729231ba73a6168$export$34c0130b1f3e8ae3(slot) {
    return $e729231ba73a6168$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("62K0D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46669e791f87e069$export$2e2bcd8739ae039; });
const $46669e791f87e069$var$defaultGenerator = (componentName)=>componentName;
const $46669e791f87e069$var$createClassNameGenerator = ()=>{
    let generate = $46669e791f87e069$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $46669e791f87e069$var$defaultGenerator;
        }
    };
};
const $46669e791f87e069$var$ClassNameGenerator = $46669e791f87e069$var$createClassNameGenerator();
var $46669e791f87e069$export$2e2bcd8739ae039 = $46669e791f87e069$var$ClassNameGenerator;

});







parcelRegister("1Spf6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $15de6a39776cbd22$var$ReactIs, $15de6a39776cbd22$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("keGWe"))();

});

// Vendor + app stylesheets, imported in the same cascade order the old index.html
// declared them (Bootstrap base first, then app overrides). Parcel bundles these
// deterministically into a single CSS bundle.

var $7uT18 = parcelRequire("7uT18");







// Bootstrap 4's JS is a jQuery plugin and expects `window.jQuery` to exist when it
// evaluates. This module is imported before `bootstrap.bundle.min.js` in index.js so
// the global is in place first (ES modules evaluate imports in order).

var $9qC4w = parcelRequire("9qC4w");
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9qC4w)));


var $ac95c7fc4d8a465d$exports = {};
/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
!function(t, e) {
    e($ac95c7fc4d8a465d$exports, (parcelRequire("9qC4w")));
}($ac95c7fc4d8a465d$exports, function(t, e) {
    "use strict";
    function n(t) {
        return t && "object" == typeof t && "default" in t ? t : {
            default: t
        };
    }
    var i = n(e);
    function o(t, e) {
        for(var n = 0; n < e.length; n++){
            var i = e[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
        }
    }
    function r(t, e, n) {
        return e && o(t.prototype, e), n && o(t, n), Object.defineProperty(t, "prototype", {
            writable: !1
        }), t;
    }
    function a() {
        return a = Object.assign ? Object.assign.bind() : function(t) {
            for(var e = 1; e < arguments.length; e++){
                var n = arguments[e];
                for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
            }
            return t;
        }, a.apply(this, arguments);
    }
    function s(t, e) {
        return s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t;
        }, s(t, e);
    }
    var l = "transitionend";
    var u = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function(t) {
            do t += ~~(1e6 * Math.random());
            while (document.getElementById(t));
            return t;
        },
        getSelectorFromElement: function(t) {
            var e = t.getAttribute("data-target");
            if (!e || "#" === e) {
                var n = t.getAttribute("href");
                e = n && "#" !== n ? n.trim() : "";
            }
            try {
                return document.querySelector(e) ? e : null;
            } catch (t) {
                return null;
            }
        },
        getTransitionDurationFromElement: function(t) {
            if (!t) return 0;
            var e = i.default(t).css("transition-duration"), n = i.default(t).css("transition-delay"), o = parseFloat(e), r = parseFloat(n);
            return o || r ? (e = e.split(",")[0], n = n.split(",")[0], 1e3 * (parseFloat(e) + parseFloat(n))) : 0;
        },
        reflow: function(t) {
            return t.offsetHeight;
        },
        triggerTransitionEnd: function(t) {
            i.default(t).trigger(l);
        },
        supportsTransitionEnd: function() {
            return Boolean(l);
        },
        isElement: function(t) {
            return (t[0] || t).nodeType;
        },
        typeCheckConfig: function(t, e, n) {
            for(var i in n)if (Object.prototype.hasOwnProperty.call(n, i)) {
                var o = n[i], r = e[i], a = r && u.isElement(r) ? "element" : null === (s = r) || "undefined" == typeof s ? "" + s : ({}).toString.call(s).match(/\s([a-z]+)/i)[1].toLowerCase();
                if (!new RegExp(o).test(a)) throw new Error(t.toUpperCase() + ': Option "' + i + '" provided type "' + a + '" but expected type "' + o + '".');
            }
            var s;
        },
        findShadowRoot: function(t) {
            if (!document.documentElement.attachShadow) return null;
            if ("function" == typeof t.getRootNode) {
                var e = t.getRootNode();
                return e instanceof ShadowRoot ? e : null;
            }
            return t instanceof ShadowRoot ? t : t.parentNode ? u.findShadowRoot(t.parentNode) : null;
        },
        jQueryDetection: function() {
            if ("undefined" == typeof i.default) throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var t = i.default.fn.jquery.split(" ")[0].split(".");
            if (t[0] < 2 && t[1] < 9 || 1 === t[0] && 9 === t[1] && t[2] < 1 || t[0] >= 4) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
    };
    u.jQueryDetection(), i.default.fn.emulateTransitionEnd = function(t) {
        var e = this, n = !1;
        return i.default(this).one(u.TRANSITION_END, function() {
            n = !0;
        }), setTimeout(function() {
            n || u.triggerTransitionEnd(e);
        }, t), this;
    }, i.default.event.special[u.TRANSITION_END] = {
        bindType: l,
        delegateType: l,
        handle: function(t) {
            if (i.default(t.target).is(this)) return t.handleObj.handler.apply(this, arguments);
        }
    };
    var f = "bs.alert", d = i.default.fn.alert, c = function() {
        function t(t) {
            this._element = t;
        }
        var e = t.prototype;
        return e.close = function(t) {
            var e = this._element;
            t && (e = this._getRootElement(t)), this._triggerCloseEvent(e).isDefaultPrevented() || this._removeElement(e);
        }, e.dispose = function() {
            i.default.removeData(this._element, f), this._element = null;
        }, e._getRootElement = function(t) {
            var e = u.getSelectorFromElement(t), n = !1;
            return e && (n = document.querySelector(e)), n || (n = i.default(t).closest(".alert")[0]), n;
        }, e._triggerCloseEvent = function(t) {
            var e = i.default.Event("close.bs.alert");
            return i.default(t).trigger(e), e;
        }, e._removeElement = function(t) {
            var e = this;
            if (i.default(t).removeClass("show"), i.default(t).hasClass("fade")) {
                var n = u.getTransitionDurationFromElement(t);
                i.default(t).one(u.TRANSITION_END, function(n) {
                    return e._destroyElement(t, n);
                }).emulateTransitionEnd(n);
            } else this._destroyElement(t);
        }, e._destroyElement = function(t) {
            i.default(t).detach().trigger("closed.bs.alert").remove();
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(f);
                o || (o = new t(this), n.data(f, o)), "close" === e && o[e](this);
            });
        }, t._handleDismiss = function(t) {
            return function(e) {
                e && e.preventDefault(), t.close(this);
            };
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.alert.data-api", '[data-dismiss="alert"]', c._handleDismiss(new c)), i.default.fn.alert = c._jQueryInterface, i.default.fn.alert.Constructor = c, i.default.fn.alert.noConflict = function() {
        return i.default.fn.alert = d, c._jQueryInterface;
    };
    var h = "bs.button", p = i.default.fn.button, m = "active", g = '[data-toggle^="button"]', _ = 'input:not([type="hidden"])', v = ".btn", b = function() {
        function t(t) {
            this._element = t, this.shouldAvoidTriggerChange = !1;
        }
        var e = t.prototype;
        return e.toggle = function() {
            var t = !0, e = !0, n = i.default(this._element).closest('[data-toggle="buttons"]')[0];
            if (n) {
                var o = this._element.querySelector(_);
                if (o) {
                    if ("radio" === o.type) {
                        if (o.checked && this._element.classList.contains(m)) t = !1;
                        else {
                            var r = n.querySelector(".active");
                            r && i.default(r).removeClass(m);
                        }
                    }
                    t && ("checkbox" !== o.type && "radio" !== o.type || (o.checked = !this._element.classList.contains(m)), this.shouldAvoidTriggerChange || i.default(o).trigger("change")), o.focus(), e = !1;
                }
            }
            this._element.hasAttribute("disabled") || this._element.classList.contains("disabled") || (e && this._element.setAttribute("aria-pressed", !this._element.classList.contains(m)), t && i.default(this._element).toggleClass(m));
        }, e.dispose = function() {
            i.default.removeData(this._element, h), this._element = null;
        }, t._jQueryInterface = function(e, n) {
            return this.each(function() {
                var o = i.default(this), r = o.data(h);
                r || (r = new t(this), o.data(h, r)), r.shouldAvoidTriggerChange = n, "toggle" === e && r[e]();
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.button.data-api", g, function(t) {
        var e = t.target, n = e;
        if (i.default(e).hasClass("btn") || (e = i.default(e).closest(v)[0]), !e || e.hasAttribute("disabled") || e.classList.contains("disabled")) t.preventDefault();
        else {
            var o = e.querySelector(_);
            if (o && (o.hasAttribute("disabled") || o.classList.contains("disabled"))) return void t.preventDefault();
            "INPUT" !== n.tagName && "LABEL" === e.tagName || b._jQueryInterface.call(i.default(e), "toggle", "INPUT" === n.tagName);
        }
    }).on("focus.bs.button.data-api blur.bs.button.data-api", g, function(t) {
        var e = i.default(t.target).closest(v)[0];
        i.default(e).toggleClass("focus", /^focus(in)?$/.test(t.type));
    }), i.default(window).on("load.bs.button.data-api", function() {
        for(var t = [].slice.call(document.querySelectorAll('[data-toggle="buttons"] .btn')), e = 0, n = t.length; e < n; e++){
            var i = t[e], o = i.querySelector(_);
            o.checked || o.hasAttribute("checked") ? i.classList.add(m) : i.classList.remove(m);
        }
        for(var r = 0, a = (t = [].slice.call(document.querySelectorAll('[data-toggle="button"]'))).length; r < a; r++){
            var s = t[r];
            "true" === s.getAttribute("aria-pressed") ? s.classList.add(m) : s.classList.remove(m);
        }
    }), i.default.fn.button = b._jQueryInterface, i.default.fn.button.Constructor = b, i.default.fn.button.noConflict = function() {
        return i.default.fn.button = p, b._jQueryInterface;
    };
    var y = "carousel", E = "bs.carousel", w = i.default.fn[y], T = "active", C = "next", S = "prev", N = "slid.bs.carousel", D = ".active.carousel-item", A = {
        interval: 5e3,
        keyboard: !0,
        slide: !1,
        pause: "hover",
        wrap: !0,
        touch: !0
    }, k = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean"
    }, I = {
        TOUCH: "touch",
        PEN: "pen"
    }, O = function() {
        function t(t, e) {
            this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, this._isSliding = !1, this.touchTimeout = null, this.touchStartX = 0, this.touchDeltaX = 0, this._config = this._getConfig(e), this._element = t, this._indicatorsElement = this._element.querySelector(".carousel-indicators"), this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0, this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent), this._addEventListeners();
        }
        var e = t.prototype;
        return e.next = function() {
            this._isSliding || this._slide(C);
        }, e.nextWhenVisible = function() {
            var t = i.default(this._element);
            !document.hidden && t.is(":visible") && "hidden" !== t.css("visibility") && this.next();
        }, e.prev = function() {
            this._isSliding || this._slide(S);
        }, e.pause = function(t) {
            t || (this._isPaused = !0), this._element.querySelector(".carousel-item-next, .carousel-item-prev") && (u.triggerTransitionEnd(this._element), this.cycle(!0)), clearInterval(this._interval), this._interval = null;
        }, e.cycle = function(t) {
            t || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), this._config.interval && !this._isPaused && (this._updateInterval(), this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval));
        }, e.to = function(t) {
            var e = this;
            this._activeElement = this._element.querySelector(D);
            var n = this._getItemIndex(this._activeElement);
            if (!(t > this._items.length - 1 || t < 0)) {
                if (this._isSliding) i.default(this._element).one(N, function() {
                    return e.to(t);
                });
                else {
                    if (n === t) return this.pause(), void this.cycle();
                    var o = t > n ? C : S;
                    this._slide(o, this._items[t]);
                }
            }
        }, e.dispose = function() {
            i.default(this._element).off(".bs.carousel"), i.default.removeData(this._element, E), this._items = null, this._config = null, this._element = null, this._interval = null, this._isPaused = null, this._isSliding = null, this._activeElement = null, this._indicatorsElement = null;
        }, e._getConfig = function(t) {
            return t = a({}, A, t), u.typeCheckConfig(y, t, k), t;
        }, e._handleSwipe = function() {
            var t = Math.abs(this.touchDeltaX);
            if (!(t <= 40)) {
                var e = t / this.touchDeltaX;
                this.touchDeltaX = 0, e > 0 && this.prev(), e < 0 && this.next();
            }
        }, e._addEventListeners = function() {
            var t = this;
            this._config.keyboard && i.default(this._element).on("keydown.bs.carousel", function(e) {
                return t._keydown(e);
            }), "hover" === this._config.pause && i.default(this._element).on("mouseenter.bs.carousel", function(e) {
                return t.pause(e);
            }).on("mouseleave.bs.carousel", function(e) {
                return t.cycle(e);
            }), this._config.touch && this._addTouchEventListeners();
        }, e._addTouchEventListeners = function() {
            var t = this;
            if (this._touchSupported) {
                var e = function(e) {
                    t._pointerEvent && I[e.originalEvent.pointerType.toUpperCase()] ? t.touchStartX = e.originalEvent.clientX : t._pointerEvent || (t.touchStartX = e.originalEvent.touches[0].clientX);
                }, n = function(e) {
                    t._pointerEvent && I[e.originalEvent.pointerType.toUpperCase()] && (t.touchDeltaX = e.originalEvent.clientX - t.touchStartX), t._handleSwipe(), "hover" === t._config.pause && (t.pause(), t.touchTimeout && clearTimeout(t.touchTimeout), t.touchTimeout = setTimeout(function(e) {
                        return t.cycle(e);
                    }, 500 + t._config.interval));
                };
                i.default(this._element.querySelectorAll(".carousel-item img")).on("dragstart.bs.carousel", function(t) {
                    return t.preventDefault();
                }), this._pointerEvent ? (i.default(this._element).on("pointerdown.bs.carousel", function(t) {
                    return e(t);
                }), i.default(this._element).on("pointerup.bs.carousel", function(t) {
                    return n(t);
                }), this._element.classList.add("pointer-event")) : (i.default(this._element).on("touchstart.bs.carousel", function(t) {
                    return e(t);
                }), i.default(this._element).on("touchmove.bs.carousel", function(e) {
                    return function(e) {
                        t.touchDeltaX = e.originalEvent.touches && e.originalEvent.touches.length > 1 ? 0 : e.originalEvent.touches[0].clientX - t.touchStartX;
                    }(e);
                }), i.default(this._element).on("touchend.bs.carousel", function(t) {
                    return n(t);
                }));
            }
        }, e._keydown = function(t) {
            if (!/input|textarea/i.test(t.target.tagName)) switch(t.which){
                case 37:
                    t.preventDefault(), this.prev();
                    break;
                case 39:
                    t.preventDefault(), this.next();
            }
        }, e._getItemIndex = function(t) {
            return this._items = t && t.parentNode ? [].slice.call(t.parentNode.querySelectorAll(".carousel-item")) : [], this._items.indexOf(t);
        }, e._getItemByDirection = function(t, e) {
            var n = t === C, i = t === S, o = this._getItemIndex(e), r = this._items.length - 1;
            if ((i && 0 === o || n && o === r) && !this._config.wrap) return e;
            var a = (o + (t === S ? -1 : 1)) % this._items.length;
            return -1 === a ? this._items[this._items.length - 1] : this._items[a];
        }, e._triggerSlideEvent = function(t, e) {
            var n = this._getItemIndex(t), o = this._getItemIndex(this._element.querySelector(D)), r = i.default.Event("slide.bs.carousel", {
                relatedTarget: t,
                direction: e,
                from: o,
                to: n
            });
            return i.default(this._element).trigger(r), r;
        }, e._setActiveIndicatorElement = function(t) {
            if (this._indicatorsElement) {
                var e = [].slice.call(this._indicatorsElement.querySelectorAll(".active"));
                i.default(e).removeClass(T);
                var n = this._indicatorsElement.children[this._getItemIndex(t)];
                n && i.default(n).addClass(T);
            }
        }, e._updateInterval = function() {
            var t = this._activeElement || this._element.querySelector(D);
            if (t) {
                var e = parseInt(t.getAttribute("data-interval"), 10);
                e ? (this._config.defaultInterval = this._config.defaultInterval || this._config.interval, this._config.interval = e) : this._config.interval = this._config.defaultInterval || this._config.interval;
            }
        }, e._slide = function(t, e) {
            var n, o, r, a = this, s = this._element.querySelector(D), l = this._getItemIndex(s), f = e || s && this._getItemByDirection(t, s), d = this._getItemIndex(f), c = Boolean(this._interval);
            if (t === C ? (n = "carousel-item-left", o = "carousel-item-next", r = "left") : (n = "carousel-item-right", o = "carousel-item-prev", r = "right"), f && i.default(f).hasClass(T)) this._isSliding = !1;
            else if (!this._triggerSlideEvent(f, r).isDefaultPrevented() && s && f) {
                this._isSliding = !0, c && this.pause(), this._setActiveIndicatorElement(f), this._activeElement = f;
                var h = i.default.Event(N, {
                    relatedTarget: f,
                    direction: r,
                    from: l,
                    to: d
                });
                if (i.default(this._element).hasClass("slide")) {
                    i.default(f).addClass(o), u.reflow(f), i.default(s).addClass(n), i.default(f).addClass(n);
                    var p = u.getTransitionDurationFromElement(s);
                    i.default(s).one(u.TRANSITION_END, function() {
                        i.default(f).removeClass(n + " " + o).addClass(T), i.default(s).removeClass("active " + o + " " + n), a._isSliding = !1, setTimeout(function() {
                            return i.default(a._element).trigger(h);
                        }, 0);
                    }).emulateTransitionEnd(p);
                } else i.default(s).removeClass(T), i.default(f).addClass(T), this._isSliding = !1, i.default(this._element).trigger(h);
                c && this.cycle();
            }
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this).data(E), o = a({}, A, i.default(this).data());
                "object" == typeof e && (o = a({}, o, e));
                var r = "string" == typeof e ? e : o.slide;
                if (n || (n = new t(this, o), i.default(this).data(E, n)), "number" == typeof e) n.to(e);
                else if ("string" == typeof r) {
                    if ("undefined" == typeof n[r]) throw new TypeError('No method named "' + r + '"');
                    n[r]();
                } else o.interval && o.ride && (n.pause(), n.cycle());
            });
        }, t._dataApiClickHandler = function(e) {
            var n = u.getSelectorFromElement(this);
            if (n) {
                var o = i.default(n)[0];
                if (o && i.default(o).hasClass("carousel")) {
                    var r = a({}, i.default(o).data(), i.default(this).data()), s = this.getAttribute("data-slide-to");
                    s && (r.interval = !1), t._jQueryInterface.call(i.default(o), r), s && i.default(o).data(E).to(s), e.preventDefault();
                }
            }
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return A;
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.carousel.data-api", "[data-slide], [data-slide-to]", O._dataApiClickHandler), i.default(window).on("load.bs.carousel.data-api", function() {
        for(var t = [].slice.call(document.querySelectorAll('[data-ride="carousel"]')), e = 0, n = t.length; e < n; e++){
            var o = i.default(t[e]);
            O._jQueryInterface.call(o, o.data());
        }
    }), i.default.fn[y] = O._jQueryInterface, i.default.fn[y].Constructor = O, i.default.fn[y].noConflict = function() {
        return i.default.fn[y] = w, O._jQueryInterface;
    };
    var x = "collapse", j = "bs.collapse", L = i.default.fn[x], P = "show", F = "collapse", R = "collapsing", B = "collapsed", H = "width", M = '[data-toggle="collapse"]', q = {
        toggle: !0,
        parent: ""
    }, Q = {
        toggle: "boolean",
        parent: "(string|element)"
    }, W = function() {
        function t(t, e) {
            this._isTransitioning = !1, this._element = t, this._config = this._getConfig(e), this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + t.id + '"],[data-toggle="collapse"][data-target="#' + t.id + '"]'));
            for(var n = [].slice.call(document.querySelectorAll(M)), i = 0, o = n.length; i < o; i++){
                var r = n[i], a = u.getSelectorFromElement(r), s = [].slice.call(document.querySelectorAll(a)).filter(function(e) {
                    return e === t;
                });
                null !== a && s.length > 0 && (this._selector = a, this._triggerArray.push(r));
            }
            this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), this._config.toggle && this.toggle();
        }
        var e = t.prototype;
        return e.toggle = function() {
            i.default(this._element).hasClass(P) ? this.hide() : this.show();
        }, e.show = function() {
            var e, n, o = this;
            if (!(this._isTransitioning || i.default(this._element).hasClass(P) || (this._parent && 0 === (e = [].slice.call(this._parent.querySelectorAll(".show, .collapsing")).filter(function(t) {
                return "string" == typeof o._config.parent ? t.getAttribute("data-parent") === o._config.parent : t.classList.contains(F);
            })).length && (e = null), e && (n = i.default(e).not(this._selector).data(j)) && n._isTransitioning))) {
                var r = i.default.Event("show.bs.collapse");
                if (i.default(this._element).trigger(r), !r.isDefaultPrevented()) {
                    e && (t._jQueryInterface.call(i.default(e).not(this._selector), "hide"), n || i.default(e).data(j, null));
                    var a = this._getDimension();
                    i.default(this._element).removeClass(F).addClass(R), this._element.style[a] = 0, this._triggerArray.length && i.default(this._triggerArray).removeClass(B).attr("aria-expanded", !0), this.setTransitioning(!0);
                    var s = "scroll" + (a[0].toUpperCase() + a.slice(1)), l = u.getTransitionDurationFromElement(this._element);
                    i.default(this._element).one(u.TRANSITION_END, function() {
                        i.default(o._element).removeClass(R).addClass("collapse show"), o._element.style[a] = "", o.setTransitioning(!1), i.default(o._element).trigger("shown.bs.collapse");
                    }).emulateTransitionEnd(l), this._element.style[a] = this._element[s] + "px";
                }
            }
        }, e.hide = function() {
            var t = this;
            if (!this._isTransitioning && i.default(this._element).hasClass(P)) {
                var e = i.default.Event("hide.bs.collapse");
                if (i.default(this._element).trigger(e), !e.isDefaultPrevented()) {
                    var n = this._getDimension();
                    this._element.style[n] = this._element.getBoundingClientRect()[n] + "px", u.reflow(this._element), i.default(this._element).addClass(R).removeClass("collapse show");
                    var o = this._triggerArray.length;
                    if (o > 0) for(var r = 0; r < o; r++){
                        var a = this._triggerArray[r], s = u.getSelectorFromElement(a);
                        null !== s && (i.default([].slice.call(document.querySelectorAll(s))).hasClass(P) || i.default(a).addClass(B).attr("aria-expanded", !1));
                    }
                    this.setTransitioning(!0), this._element.style[n] = "";
                    var l = u.getTransitionDurationFromElement(this._element);
                    i.default(this._element).one(u.TRANSITION_END, function() {
                        t.setTransitioning(!1), i.default(t._element).removeClass(R).addClass(F).trigger("hidden.bs.collapse");
                    }).emulateTransitionEnd(l);
                }
            }
        }, e.setTransitioning = function(t) {
            this._isTransitioning = t;
        }, e.dispose = function() {
            i.default.removeData(this._element, j), this._config = null, this._parent = null, this._element = null, this._triggerArray = null, this._isTransitioning = null;
        }, e._getConfig = function(t) {
            return (t = a({}, q, t)).toggle = Boolean(t.toggle), u.typeCheckConfig(x, t, Q), t;
        }, e._getDimension = function() {
            return i.default(this._element).hasClass(H) ? H : "height";
        }, e._getParent = function() {
            var e, n = this;
            u.isElement(this._config.parent) ? (e = this._config.parent, "undefined" != typeof this._config.parent.jquery && (e = this._config.parent[0])) : e = document.querySelector(this._config.parent);
            var o = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]', r = [].slice.call(e.querySelectorAll(o));
            return i.default(r).each(function(e, i) {
                n._addAriaAndCollapsedClass(t._getTargetFromElement(i), [
                    i
                ]);
            }), e;
        }, e._addAriaAndCollapsedClass = function(t, e) {
            var n = i.default(t).hasClass(P);
            e.length && i.default(e).toggleClass(B, !n).attr("aria-expanded", n);
        }, t._getTargetFromElement = function(t) {
            var e = u.getSelectorFromElement(t);
            return e ? document.querySelector(e) : null;
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(j), r = a({}, q, n.data(), "object" == typeof e && e ? e : {});
                if (!o && r.toggle && "string" == typeof e && /show|hide/.test(e) && (r.toggle = !1), o || (o = new t(this, r), n.data(j, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return q;
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.collapse.data-api", M, function(t) {
        "A" === t.currentTarget.tagName && t.preventDefault();
        var e = i.default(this), n = u.getSelectorFromElement(this), o = [].slice.call(document.querySelectorAll(n));
        i.default(o).each(function() {
            var t = i.default(this), n = t.data(j) ? "toggle" : e.data();
            W._jQueryInterface.call(t, n);
        });
    }), i.default.fn[x] = W._jQueryInterface, i.default.fn[x].Constructor = W, i.default.fn[x].noConflict = function() {
        return i.default.fn[x] = L, W._jQueryInterface;
    };
    var U = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator, V = function() {
        for(var t = [
            "Edge",
            "Trident",
            "Firefox"
        ], e = 0; e < t.length; e += 1)if (U && navigator.userAgent.indexOf(t[e]) >= 0) return 1;
        return 0;
    }(), Y = U && window.Promise ? function(t) {
        var e = !1;
        return function() {
            e || (e = !0, window.Promise.resolve().then(function() {
                e = !1, t();
            }));
        };
    } : function(t) {
        var e = !1;
        return function() {
            e || (e = !0, setTimeout(function() {
                e = !1, t();
            }, V));
        };
    };
    function z(t) {
        return t && "[object Function]" === ({}).toString.call(t);
    }
    function K(t, e) {
        if (1 !== t.nodeType) return [];
        var n = t.ownerDocument.defaultView.getComputedStyle(t, null);
        return e ? n[e] : n;
    }
    function X(t) {
        return "HTML" === t.nodeName ? t : t.parentNode || t.host;
    }
    function G(t) {
        if (!t) return document.body;
        switch(t.nodeName){
            case "HTML":
            case "BODY":
                return t.ownerDocument.body;
            case "#document":
                return t.body;
        }
        var e = K(t), n = e.overflow, i = e.overflowX, o = e.overflowY;
        return /(auto|scroll|overlay)/.test(n + o + i) ? t : G(X(t));
    }
    function $(t) {
        return t && t.referenceNode ? t.referenceNode : t;
    }
    var J = U && !(!window.MSInputMethodContext || !document.documentMode), Z = U && /MSIE 10/.test(navigator.userAgent);
    function tt(t) {
        return 11 === t ? J : 10 === t ? Z : J || Z;
    }
    function et(t) {
        if (!t) return document.documentElement;
        for(var e = tt(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling;)n = (t = t.nextElementSibling).offsetParent;
        var i = n && n.nodeName;
        return i && "BODY" !== i && "HTML" !== i ? -1 !== [
            "TH",
            "TD",
            "TABLE"
        ].indexOf(n.nodeName) && "static" === K(n, "position") ? et(n) : n : t ? t.ownerDocument.documentElement : document.documentElement;
    }
    function nt(t) {
        return null !== t.parentNode ? nt(t.parentNode) : t;
    }
    function it(t, e) {
        if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;
        var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, i = n ? t : e, o = n ? e : t, r = document.createRange();
        r.setStart(i, 0), r.setEnd(o, 0);
        var a, s, l = r.commonAncestorContainer;
        if (t !== l && e !== l || i.contains(o)) return "BODY" === (s = (a = l).nodeName) || "HTML" !== s && et(a.firstElementChild) !== a ? et(l) : l;
        var u = nt(t);
        return u.host ? it(u.host, e) : it(t, nt(e).host);
    }
    function ot(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top", n = "top" === e ? "scrollTop" : "scrollLeft", i = t.nodeName;
        if ("BODY" === i || "HTML" === i) {
            var o = t.ownerDocument.documentElement, r = t.ownerDocument.scrollingElement || o;
            return r[n];
        }
        return t[n];
    }
    function rt(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = ot(e, "top"), o = ot(e, "left"), r = n ? -1 : 1;
        return t.top += i * r, t.bottom += i * r, t.left += o * r, t.right += o * r, t;
    }
    function at(t, e) {
        var n = "x" === e ? "Left" : "Top", i = "Left" === n ? "Right" : "Bottom";
        return parseFloat(t["border" + n + "Width"]) + parseFloat(t["border" + i + "Width"]);
    }
    function st(t, e, n, i) {
        return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], tt(10) ? parseInt(n["offset" + t]) + parseInt(i["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(i["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0);
    }
    function lt(t) {
        var e = t.body, n = t.documentElement, i = tt(10) && getComputedStyle(n);
        return {
            height: st("Height", e, n, i),
            width: st("Width", e, n, i)
        };
    }
    var ut = function(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }, ft = function() {
        function t(t, e) {
            for(var n = 0; n < e.length; n++){
                var i = e[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
            }
        }
        return function(e, n, i) {
            return n && t(e.prototype, n), i && t(e, i), e;
        };
    }(), dt = function(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n, t;
    }, ct = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var n = arguments[e];
            for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
        return t;
    };
    function ht(t) {
        return ct({}, t, {
            right: t.left + t.width,
            bottom: t.top + t.height
        });
    }
    function pt(t) {
        var e = {};
        try {
            if (tt(10)) {
                e = t.getBoundingClientRect();
                var n = ot(t, "top"), i = ot(t, "left");
                e.top += n, e.left += i, e.bottom += n, e.right += i;
            } else e = t.getBoundingClientRect();
        } catch (t) {}
        var o = {
            left: e.left,
            top: e.top,
            width: e.right - e.left,
            height: e.bottom - e.top
        }, r = "HTML" === t.nodeName ? lt(t.ownerDocument) : {}, a = r.width || t.clientWidth || o.width, s = r.height || t.clientHeight || o.height, l = t.offsetWidth - a, u = t.offsetHeight - s;
        if (l || u) {
            var f = K(t);
            l -= at(f, "x"), u -= at(f, "y"), o.width -= l, o.height -= u;
        }
        return ht(o);
    }
    function mt(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = tt(10), o = "HTML" === e.nodeName, r = pt(t), a = pt(e), s = G(t), l = K(e), u = parseFloat(l.borderTopWidth), f = parseFloat(l.borderLeftWidth);
        n && o && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0));
        var d = ht({
            top: r.top - a.top - u,
            left: r.left - a.left - f,
            width: r.width,
            height: r.height
        });
        if (d.marginTop = 0, d.marginLeft = 0, !i && o) {
            var c = parseFloat(l.marginTop), h = parseFloat(l.marginLeft);
            d.top -= u - c, d.bottom -= u - c, d.left -= f - h, d.right -= f - h, d.marginTop = c, d.marginLeft = h;
        }
        return (i && !n ? e.contains(s) : e === s && "BODY" !== s.nodeName) && (d = rt(d, e)), d;
    }
    function gt(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = t.ownerDocument.documentElement, i = mt(t, n), o = Math.max(n.clientWidth, window.innerWidth || 0), r = Math.max(n.clientHeight, window.innerHeight || 0), a = e ? 0 : ot(n), s = e ? 0 : ot(n, "left"), l = {
            top: a - i.top + i.marginTop,
            left: s - i.left + i.marginLeft,
            width: o,
            height: r
        };
        return ht(l);
    }
    function _t(t) {
        var e = t.nodeName;
        if ("BODY" === e || "HTML" === e) return !1;
        if ("fixed" === K(t, "position")) return !0;
        var n = X(t);
        return !!n && _t(n);
    }
    function vt(t) {
        if (!t || !t.parentElement || tt()) return document.documentElement;
        for(var e = t.parentElement; e && "none" === K(e, "transform");)e = e.parentElement;
        return e || document.documentElement;
    }
    function bt(t, e, n, i) {
        var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], r = {
            top: 0,
            left: 0
        }, a = o ? vt(t) : it(t, $(e));
        if ("viewport" === i) r = gt(a, o);
        else {
            var s = void 0;
            "scrollParent" === i ? "BODY" === (s = G(X(e))).nodeName && (s = t.ownerDocument.documentElement) : s = "window" === i ? t.ownerDocument.documentElement : i;
            var l = mt(s, a, o);
            if ("HTML" !== s.nodeName || _t(a)) r = l;
            else {
                var u = lt(t.ownerDocument), f = u.height, d = u.width;
                r.top += l.top - l.marginTop, r.bottom = f + l.top, r.left += l.left - l.marginLeft, r.right = d + l.left;
            }
        }
        var c = "number" == typeof (n = n || 0);
        return r.left += c ? n : n.left || 0, r.top += c ? n : n.top || 0, r.right -= c ? n : n.right || 0, r.bottom -= c ? n : n.bottom || 0, r;
    }
    function yt(t) {
        return t.width * t.height;
    }
    function Et(t, e, n, i, o) {
        var r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === t.indexOf("auto")) return t;
        var a = bt(n, i, r, o), s = {
            top: {
                width: a.width,
                height: e.top - a.top
            },
            right: {
                width: a.right - e.right,
                height: a.height
            },
            bottom: {
                width: a.width,
                height: a.bottom - e.bottom
            },
            left: {
                width: e.left - a.left,
                height: a.height
            }
        }, l = Object.keys(s).map(function(t) {
            return ct({
                key: t
            }, s[t], {
                area: yt(s[t])
            });
        }).sort(function(t, e) {
            return e.area - t.area;
        }), u = l.filter(function(t) {
            var e = t.width, i = t.height;
            return e >= n.clientWidth && i >= n.clientHeight;
        }), f = u.length > 0 ? u[0].key : l[0].key, d = t.split("-")[1];
        return f + (d ? "-" + d : "");
    }
    function wt(t, e, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, o = i ? vt(e) : it(e, $(n));
        return mt(n, o, i);
    }
    function Tt(t) {
        var e = t.ownerDocument.defaultView.getComputedStyle(t), n = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0), i = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);
        return {
            width: t.offsetWidth + i,
            height: t.offsetHeight + n
        };
    }
    function Ct(t) {
        var e = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return t.replace(/left|right|bottom|top/g, function(t) {
            return e[t];
        });
    }
    function St(t, e, n) {
        n = n.split("-")[0];
        var i = Tt(t), o = {
            width: i.width,
            height: i.height
        }, r = -1 !== [
            "right",
            "left"
        ].indexOf(n), a = r ? "top" : "left", s = r ? "left" : "top", l = r ? "height" : "width", u = r ? "width" : "height";
        return o[a] = e[a] + e[l] / 2 - i[l] / 2, o[s] = n === s ? e[s] - i[u] : e[Ct(s)], o;
    }
    function Nt(t, e) {
        return Array.prototype.find ? t.find(e) : t.filter(e)[0];
    }
    function Dt(t, e, n) {
        return (void 0 === n ? t : t.slice(0, function(t, e, n) {
            if (Array.prototype.findIndex) return t.findIndex(function(t) {
                return t.name === n;
            });
            var i = Nt(t, function(t) {
                return t.name === n;
            });
            return t.indexOf(i);
        }(t, 0, n))).forEach(function(t) {
            t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var n = t.function || t.fn;
            t.enabled && z(n) && (e.offsets.popper = ht(e.offsets.popper), e.offsets.reference = ht(e.offsets.reference), e = n(e, t));
        }), e;
    }
    function At() {
        if (!this.state.isDestroyed) {
            var t = {
                instance: this,
                styles: {},
                arrowStyles: {},
                attributes: {},
                flipped: !1,
                offsets: {}
            };
            t.offsets.reference = wt(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = Et(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = St(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = Dt(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
        }
    }
    function kt(t, e) {
        return t.some(function(t) {
            var n = t.name;
            return t.enabled && n === e;
        });
    }
    function It(t) {
        for(var e = [
            !1,
            "ms",
            "Webkit",
            "Moz",
            "O"
        ], n = t.charAt(0).toUpperCase() + t.slice(1), i = 0; i < e.length; i++){
            var o = e[i], r = o ? "" + o + n : t;
            if ("undefined" != typeof document.body.style[r]) return r;
        }
        return null;
    }
    function Ot() {
        return this.state.isDestroyed = !0, kt(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[It("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
    }
    function xt(t) {
        var e = t.ownerDocument;
        return e ? e.defaultView : window;
    }
    function jt(t, e, n, i) {
        var o = "BODY" === t.nodeName, r = o ? t.ownerDocument.defaultView : t;
        r.addEventListener(e, n, {
            passive: !0
        }), o || jt(G(r.parentNode), e, n, i), i.push(r);
    }
    function Lt(t, e, n, i) {
        n.updateBound = i, xt(t).addEventListener("resize", n.updateBound, {
            passive: !0
        });
        var o = G(t);
        return jt(o, "scroll", n.updateBound, n.scrollParents), n.scrollElement = o, n.eventsEnabled = !0, n;
    }
    function Pt() {
        this.state.eventsEnabled || (this.state = Lt(this.reference, this.options, this.state, this.scheduleUpdate));
    }
    function Ft() {
        var t, e;
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (t = this.reference, e = this.state, xt(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(t) {
            t.removeEventListener("scroll", e.updateBound);
        }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e));
    }
    function Rt(t) {
        return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
    }
    function Bt(t, e) {
        Object.keys(e).forEach(function(n) {
            var i = "";
            -1 !== [
                "width",
                "height",
                "top",
                "right",
                "bottom",
                "left"
            ].indexOf(n) && Rt(e[n]) && (i = "px"), t.style[n] = e[n] + i;
        });
    }
    var Ht = U && /Firefox/i.test(navigator.userAgent);
    function Mt(t, e, n) {
        var i = Nt(t, function(t) {
            return t.name === e;
        }), o = !!i && t.some(function(t) {
            return t.name === n && t.enabled && t.order < i.order;
        });
        if (!o) {
            var r = "`" + e + "`", a = "`" + n + "`";
            console.warn(a + " modifier is required by " + r + " modifier in order to work, be sure to include it before " + r + "!");
        }
        return o;
    }
    var qt = [
        "auto-start",
        "auto",
        "auto-end",
        "top-start",
        "top",
        "top-end",
        "right-start",
        "right",
        "right-end",
        "bottom-end",
        "bottom",
        "bottom-start",
        "left-end",
        "left",
        "left-start"
    ], Qt = qt.slice(3);
    function Wt(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = Qt.indexOf(t), i = Qt.slice(n + 1).concat(Qt.slice(0, n));
        return e ? i.reverse() : i;
    }
    var Ut = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function() {},
        onUpdate: function() {},
        modifiers: {
            shift: {
                order: 100,
                enabled: !0,
                fn: function(t) {
                    var e = t.placement, n = e.split("-")[0], i = e.split("-")[1];
                    if (i) {
                        var o = t.offsets, r = o.reference, a = o.popper, s = -1 !== [
                            "bottom",
                            "top"
                        ].indexOf(n), l = s ? "left" : "top", u = s ? "width" : "height", f = {
                            start: dt({}, l, r[l]),
                            end: dt({}, l, r[l] + r[u] - a[u])
                        };
                        t.offsets.popper = ct({}, a, f[i]);
                    }
                    return t;
                }
            },
            offset: {
                order: 200,
                enabled: !0,
                fn: function(t, e) {
                    var n, i = e.offset, o = t.placement, r = t.offsets, a = r.popper, s = r.reference, l = o.split("-")[0];
                    return n = Rt(+i) ? [
                        +i,
                        0
                    ] : function(t, e, n, i) {
                        var o = [
                            0,
                            0
                        ], r = -1 !== [
                            "right",
                            "left"
                        ].indexOf(i), a = t.split(/(\+|\-)/).map(function(t) {
                            return t.trim();
                        }), s = a.indexOf(Nt(a, function(t) {
                            return -1 !== t.search(/,|\s/);
                        }));
                        a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
                        var l = /\s*,\s*|\s+/, u = -1 !== s ? [
                            a.slice(0, s).concat([
                                a[s].split(l)[0]
                            ]),
                            [
                                a[s].split(l)[1]
                            ].concat(a.slice(s + 1))
                        ] : [
                            a
                        ];
                        return u = u.map(function(t, i) {
                            var o = (1 === i ? !r : r) ? "height" : "width", a = !1;
                            return t.reduce(function(t, e) {
                                return "" === t[t.length - 1] && -1 !== [
                                    "+",
                                    "-"
                                ].indexOf(e) ? (t[t.length - 1] = e, a = !0, t) : a ? (t[t.length - 1] += e, a = !1, t) : t.concat(e);
                            }, []).map(function(t) {
                                return function(t, e, n, i) {
                                    var o = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), r = +o[1], a = o[2];
                                    return r ? 0 === a.indexOf("%") ? ht("%p" === a ? n : i)[e] / 100 * r : "vh" === a || "vw" === a ? ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * r : r : t;
                                }(t, o, e, n);
                            });
                        }), u.forEach(function(t, e) {
                            t.forEach(function(n, i) {
                                Rt(n) && (o[e] += n * ("-" === t[i - 1] ? -1 : 1));
                            });
                        }), o;
                    }(i, a, s, l), "left" === l ? (a.top += n[0], a.left -= n[1]) : "right" === l ? (a.top += n[0], a.left += n[1]) : "top" === l ? (a.left += n[0], a.top -= n[1]) : "bottom" === l && (a.left += n[0], a.top += n[1]), t.popper = a, t;
                },
                offset: 0
            },
            preventOverflow: {
                order: 300,
                enabled: !0,
                fn: function(t, e) {
                    var n = e.boundariesElement || et(t.instance.popper);
                    t.instance.reference === n && (n = et(n));
                    var i = It("transform"), o = t.instance.popper.style, r = o.top, a = o.left, s = o[i];
                    o.top = "", o.left = "", o[i] = "";
                    var l = bt(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);
                    o.top = r, o.left = a, o[i] = s, e.boundaries = l;
                    var u = e.priority, f = t.offsets.popper, d = {
                        primary: function(t) {
                            var n = f[t];
                            return f[t] < l[t] && !e.escapeWithReference && (n = Math.max(f[t], l[t])), dt({}, t, n);
                        },
                        secondary: function(t) {
                            var n = "right" === t ? "left" : "top", i = f[n];
                            return f[t] > l[t] && !e.escapeWithReference && (i = Math.min(f[n], l[t] - ("right" === t ? f.width : f.height))), dt({}, n, i);
                        }
                    };
                    return u.forEach(function(t) {
                        var e = -1 !== [
                            "left",
                            "top"
                        ].indexOf(t) ? "primary" : "secondary";
                        f = ct({}, f, d[e](t));
                    }), t.offsets.popper = f, t;
                },
                priority: [
                    "left",
                    "right",
                    "top",
                    "bottom"
                ],
                padding: 5,
                boundariesElement: "scrollParent"
            },
            keepTogether: {
                order: 400,
                enabled: !0,
                fn: function(t) {
                    var e = t.offsets, n = e.popper, i = e.reference, o = t.placement.split("-")[0], r = Math.floor, a = -1 !== [
                        "top",
                        "bottom"
                    ].indexOf(o), s = a ? "right" : "bottom", l = a ? "left" : "top", u = a ? "width" : "height";
                    return n[s] < r(i[l]) && (t.offsets.popper[l] = r(i[l]) - n[u]), n[l] > r(i[s]) && (t.offsets.popper[l] = r(i[s])), t;
                }
            },
            arrow: {
                order: 500,
                enabled: !0,
                fn: function(t, e) {
                    var n;
                    if (!Mt(t.instance.modifiers, "arrow", "keepTogether")) return t;
                    var i = e.element;
                    if ("string" == typeof i) {
                        if (!(i = t.instance.popper.querySelector(i))) return t;
                    } else if (!t.instance.popper.contains(i)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
                    var o = t.placement.split("-")[0], r = t.offsets, a = r.popper, s = r.reference, l = -1 !== [
                        "left",
                        "right"
                    ].indexOf(o), u = l ? "height" : "width", f = l ? "Top" : "Left", d = f.toLowerCase(), c = l ? "left" : "top", h = l ? "bottom" : "right", p = Tt(i)[u];
                    s[h] - p < a[d] && (t.offsets.popper[d] -= a[d] - (s[h] - p)), s[d] + p > a[h] && (t.offsets.popper[d] += s[d] + p - a[h]), t.offsets.popper = ht(t.offsets.popper);
                    var m = s[d] + s[u] / 2 - p / 2, g = K(t.instance.popper), _ = parseFloat(g["margin" + f]), v = parseFloat(g["border" + f + "Width"]), b = m - t.offsets.popper[d] - _ - v;
                    return b = Math.max(Math.min(a[u] - p, b), 0), t.arrowElement = i, t.offsets.arrow = (dt(n = {}, d, Math.round(b)), dt(n, c, ""), n), t;
                },
                element: "[x-arrow]"
            },
            flip: {
                order: 600,
                enabled: !0,
                fn: function(t, e) {
                    if (kt(t.instance.modifiers, "inner")) return t;
                    if (t.flipped && t.placement === t.originalPlacement) return t;
                    var n = bt(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed), i = t.placement.split("-")[0], o = Ct(i), r = t.placement.split("-")[1] || "", a = [];
                    switch(e.behavior){
                        case "flip":
                            a = [
                                i,
                                o
                            ];
                            break;
                        case "clockwise":
                            a = Wt(i);
                            break;
                        case "counterclockwise":
                            a = Wt(i, !0);
                            break;
                        default:
                            a = e.behavior;
                    }
                    return a.forEach(function(s, l) {
                        if (i !== s || a.length === l + 1) return t;
                        i = t.placement.split("-")[0], o = Ct(i);
                        var u = t.offsets.popper, f = t.offsets.reference, d = Math.floor, c = "left" === i && d(u.right) > d(f.left) || "right" === i && d(u.left) < d(f.right) || "top" === i && d(u.bottom) > d(f.top) || "bottom" === i && d(u.top) < d(f.bottom), h = d(u.left) < d(n.left), p = d(u.right) > d(n.right), m = d(u.top) < d(n.top), g = d(u.bottom) > d(n.bottom), _ = "left" === i && h || "right" === i && p || "top" === i && m || "bottom" === i && g, v = -1 !== [
                            "top",
                            "bottom"
                        ].indexOf(i), b = !!e.flipVariations && (v && "start" === r && h || v && "end" === r && p || !v && "start" === r && m || !v && "end" === r && g), y = !!e.flipVariationsByContent && (v && "start" === r && p || v && "end" === r && h || !v && "start" === r && g || !v && "end" === r && m), E = b || y;
                        (c || _ || E) && (t.flipped = !0, (c || _) && (i = a[l + 1]), E && (r = function(t) {
                            return "end" === t ? "start" : "start" === t ? "end" : t;
                        }(r)), t.placement = i + (r ? "-" + r : ""), t.offsets.popper = ct({}, t.offsets.popper, St(t.instance.popper, t.offsets.reference, t.placement)), t = Dt(t.instance.modifiers, t, "flip"));
                    }), t;
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport",
                flipVariations: !1,
                flipVariationsByContent: !1
            },
            inner: {
                order: 700,
                enabled: !1,
                fn: function(t) {
                    var e = t.placement, n = e.split("-")[0], i = t.offsets, o = i.popper, r = i.reference, a = -1 !== [
                        "left",
                        "right"
                    ].indexOf(n), s = -1 === [
                        "top",
                        "left"
                    ].indexOf(n);
                    return o[a ? "left" : "top"] = r[n] - (s ? o[a ? "width" : "height"] : 0), t.placement = Ct(e), t.offsets.popper = ht(o), t;
                }
            },
            hide: {
                order: 800,
                enabled: !0,
                fn: function(t) {
                    if (!Mt(t.instance.modifiers, "hide", "preventOverflow")) return t;
                    var e = t.offsets.reference, n = Nt(t.instance.modifiers, function(t) {
                        return "preventOverflow" === t.name;
                    }).boundaries;
                    if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
                        if (!0 === t.hide) return t;
                        t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
                    } else {
                        if (!1 === t.hide) return t;
                        t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
                    }
                    return t;
                }
            },
            computeStyle: {
                order: 850,
                enabled: !0,
                fn: function(t, e) {
                    var n = e.x, i = e.y, o = t.offsets.popper, r = Nt(t.instance.modifiers, function(t) {
                        return "applyStyle" === t.name;
                    }).gpuAcceleration;
                    void 0 !== r && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                    var a, s, l = void 0 !== r ? r : e.gpuAcceleration, u = et(t.instance.popper), f = pt(u), d = {
                        position: o.position
                    }, c = function(t, e) {
                        var n = t.offsets, i = n.popper, o = n.reference, r = Math.round, a = Math.floor, s = function(t) {
                            return t;
                        }, l = r(o.width), u = r(i.width), f = -1 !== [
                            "left",
                            "right"
                        ].indexOf(t.placement), d = -1 !== t.placement.indexOf("-"), c = e ? f || d || l % 2 == u % 2 ? r : a : s, h = e ? r : s;
                        return {
                            left: c(l % 2 == 1 && u % 2 == 1 && !d && e ? i.left - 1 : i.left),
                            top: h(i.top),
                            bottom: h(i.bottom),
                            right: c(i.right)
                        };
                    }(t, window.devicePixelRatio < 2 || !Ht), h = "bottom" === n ? "top" : "bottom", p = "right" === i ? "left" : "right", m = It("transform");
                    if (s = "bottom" === h ? "HTML" === u.nodeName ? -u.clientHeight + c.bottom : -f.height + c.bottom : c.top, a = "right" === p ? "HTML" === u.nodeName ? -u.clientWidth + c.right : -f.width + c.right : c.left, l && m) d[m] = "translate3d(" + a + "px, " + s + "px, 0)", d[h] = 0, d[p] = 0, d.willChange = "transform";
                    else {
                        var g = "bottom" === h ? -1 : 1, _ = "right" === p ? -1 : 1;
                        d[h] = s * g, d[p] = a * _, d.willChange = h + ", " + p;
                    }
                    var v = {
                        "x-placement": t.placement
                    };
                    return t.attributes = ct({}, v, t.attributes), t.styles = ct({}, d, t.styles), t.arrowStyles = ct({}, t.offsets.arrow, t.arrowStyles), t;
                },
                gpuAcceleration: !0,
                x: "bottom",
                y: "right"
            },
            applyStyle: {
                order: 900,
                enabled: !0,
                fn: function(t) {
                    var e, n;
                    return Bt(t.instance.popper, t.styles), e = t.instance.popper, n = t.attributes, Object.keys(n).forEach(function(t) {
                        !1 !== n[t] ? e.setAttribute(t, n[t]) : e.removeAttribute(t);
                    }), t.arrowElement && Object.keys(t.arrowStyles).length && Bt(t.arrowElement, t.arrowStyles), t;
                },
                onLoad: function(t, e, n, i, o) {
                    var r = wt(o, e, t, n.positionFixed), a = Et(n.placement, r, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                    return e.setAttribute("x-placement", a), Bt(e, {
                        position: n.positionFixed ? "fixed" : "absolute"
                    }), n;
                },
                gpuAcceleration: void 0
            }
        }
    }, Vt = function() {
        function t(e, n) {
            var i = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            ut(this, t), this.scheduleUpdate = function() {
                return requestAnimationFrame(i.update);
            }, this.update = Y(this.update.bind(this)), this.options = ct({}, t.Defaults, o), this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
            }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(ct({}, t.Defaults.modifiers, o.modifiers)).forEach(function(e) {
                i.options.modifiers[e] = ct({}, t.Defaults.modifiers[e] || {}, o.modifiers ? o.modifiers[e] : {});
            }), this.modifiers = Object.keys(this.options.modifiers).map(function(t) {
                return ct({
                    name: t
                }, i.options.modifiers[t]);
            }).sort(function(t, e) {
                return t.order - e.order;
            }), this.modifiers.forEach(function(t) {
                t.enabled && z(t.onLoad) && t.onLoad(i.reference, i.popper, i.options, t, i.state);
            }), this.update();
            var r = this.options.eventsEnabled;
            r && this.enableEventListeners(), this.state.eventsEnabled = r;
        }
        return ft(t, [
            {
                key: "update",
                value: function() {
                    return At.call(this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    return Ot.call(this);
                }
            },
            {
                key: "enableEventListeners",
                value: function() {
                    return Pt.call(this);
                }
            },
            {
                key: "disableEventListeners",
                value: function() {
                    return Ft.call(this);
                }
            }
        ]), t;
    }();
    Vt.Utils = ("undefined" != typeof window ? window : $parcel$global).PopperUtils, Vt.placements = qt, Vt.Defaults = Ut;
    var Yt = Vt, zt = "dropdown", Kt = "bs.dropdown", Xt = i.default.fn[zt], Gt = new RegExp("38|40|27"), $t = "disabled", Jt = "show", Zt = "dropdown-menu-right", te = "hide.bs.dropdown", ee = "hidden.bs.dropdown", ne = "click.bs.dropdown.data-api", ie = "keydown.bs.dropdown.data-api", oe = '[data-toggle="dropdown"]', re = ".dropdown-menu", ae = {
        offset: 0,
        flip: !0,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    }, se = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    }, le = function() {
        function t(t, e) {
            this._element = t, this._popper = null, this._config = this._getConfig(e), this._menu = this._getMenuElement(), this._inNavbar = this._detectNavbar(), this._addEventListeners();
        }
        var e = t.prototype;
        return e.toggle = function() {
            if (!this._element.disabled && !i.default(this._element).hasClass($t)) {
                var e = i.default(this._menu).hasClass(Jt);
                t._clearMenus(), e || this.show(!0);
            }
        }, e.show = function(e) {
            if (void 0 === e && (e = !1), !(this._element.disabled || i.default(this._element).hasClass($t) || i.default(this._menu).hasClass(Jt))) {
                var n = {
                    relatedTarget: this._element
                }, o = i.default.Event("show.bs.dropdown", n), r = t._getParentFromElement(this._element);
                if (i.default(r).trigger(o), !o.isDefaultPrevented()) {
                    if (!this._inNavbar && e) {
                        if ("undefined" == typeof Yt) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                        var a = this._element;
                        "parent" === this._config.reference ? a = r : u.isElement(this._config.reference) && (a = this._config.reference, "undefined" != typeof this._config.reference.jquery && (a = this._config.reference[0])), "scrollParent" !== this._config.boundary && i.default(r).addClass("position-static"), this._popper = new Yt(a, this._menu, this._getPopperConfig());
                    }
                    "ontouchstart" in document.documentElement && 0 === i.default(r).closest(".navbar-nav").length && i.default(document.body).children().on("mouseover", null, i.default.noop), this._element.focus(), this._element.setAttribute("aria-expanded", !0), i.default(this._menu).toggleClass(Jt), i.default(r).toggleClass(Jt).trigger(i.default.Event("shown.bs.dropdown", n));
                }
            }
        }, e.hide = function() {
            if (!this._element.disabled && !i.default(this._element).hasClass($t) && i.default(this._menu).hasClass(Jt)) {
                var e = {
                    relatedTarget: this._element
                }, n = i.default.Event(te, e), o = t._getParentFromElement(this._element);
                i.default(o).trigger(n), n.isDefaultPrevented() || (this._popper && this._popper.destroy(), i.default(this._menu).toggleClass(Jt), i.default(o).toggleClass(Jt).trigger(i.default.Event(ee, e)));
            }
        }, e.dispose = function() {
            i.default.removeData(this._element, Kt), i.default(this._element).off(".bs.dropdown"), this._element = null, this._menu = null, null !== this._popper && (this._popper.destroy(), this._popper = null);
        }, e.update = function() {
            this._inNavbar = this._detectNavbar(), null !== this._popper && this._popper.scheduleUpdate();
        }, e._addEventListeners = function() {
            var t = this;
            i.default(this._element).on("click.bs.dropdown", function(e) {
                e.preventDefault(), e.stopPropagation(), t.toggle();
            });
        }, e._getConfig = function(t) {
            return t = a({}, this.constructor.Default, i.default(this._element).data(), t), u.typeCheckConfig(zt, t, this.constructor.DefaultType), t;
        }, e._getMenuElement = function() {
            if (!this._menu) {
                var e = t._getParentFromElement(this._element);
                e && (this._menu = e.querySelector(re));
            }
            return this._menu;
        }, e._getPlacement = function() {
            var t = i.default(this._element.parentNode), e = "bottom-start";
            return t.hasClass("dropup") ? e = i.default(this._menu).hasClass(Zt) ? "top-end" : "top-start" : t.hasClass("dropright") ? e = "right-start" : t.hasClass("dropleft") ? e = "left-start" : i.default(this._menu).hasClass(Zt) && (e = "bottom-end"), e;
        }, e._detectNavbar = function() {
            return i.default(this._element).closest(".navbar").length > 0;
        }, e._getOffset = function() {
            var t = this, e = {};
            return "function" == typeof this._config.offset ? e.fn = function(e) {
                return e.offsets = a({}, e.offsets, t._config.offset(e.offsets, t._element)), e;
            } : e.offset = this._config.offset, e;
        }, e._getPopperConfig = function() {
            var t = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            };
            return "static" === this._config.display && (t.modifiers.applyStyle = {
                enabled: !1
            }), a({}, t, this._config.popperConfig);
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this).data(Kt);
                if (n || (n = new t(this, "object" == typeof e ? e : null), i.default(this).data(Kt, n)), "string" == typeof e) {
                    if ("undefined" == typeof n[e]) throw new TypeError('No method named "' + e + '"');
                    n[e]();
                }
            });
        }, t._clearMenus = function(e) {
            if (!e || 3 !== e.which && ("keyup" !== e.type || 9 === e.which)) for(var n = [].slice.call(document.querySelectorAll(oe)), o = 0, r = n.length; o < r; o++){
                var a = t._getParentFromElement(n[o]), s = i.default(n[o]).data(Kt), l = {
                    relatedTarget: n[o]
                };
                if (e && "click" === e.type && (l.clickEvent = e), s) {
                    var u = s._menu;
                    if (i.default(a).hasClass(Jt) && !(e && ("click" === e.type && /input|textarea/i.test(e.target.tagName) || "keyup" === e.type && 9 === e.which) && i.default.contains(a, e.target))) {
                        var f = i.default.Event(te, l);
                        i.default(a).trigger(f), f.isDefaultPrevented() || ("ontouchstart" in document.documentElement && i.default(document.body).children().off("mouseover", null, i.default.noop), n[o].setAttribute("aria-expanded", "false"), s._popper && s._popper.destroy(), i.default(u).removeClass(Jt), i.default(a).removeClass(Jt).trigger(i.default.Event(ee, l)));
                    }
                }
            }
        }, t._getParentFromElement = function(t) {
            var e, n = u.getSelectorFromElement(t);
            return n && (e = document.querySelector(n)), e || t.parentNode;
        }, t._dataApiKeydownHandler = function(e) {
            if (!(/input|textarea/i.test(e.target.tagName) ? 32 === e.which || 27 !== e.which && (40 !== e.which && 38 !== e.which || i.default(e.target).closest(re).length) : !Gt.test(e.which)) && !this.disabled && !i.default(this).hasClass($t)) {
                var n = t._getParentFromElement(this), o = i.default(n).hasClass(Jt);
                if (o || 27 !== e.which) {
                    if (e.preventDefault(), e.stopPropagation(), !o || 27 === e.which || 32 === e.which) return 27 === e.which && i.default(n.querySelector(oe)).trigger("focus"), void i.default(this).trigger("click");
                    var r = [].slice.call(n.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)")).filter(function(t) {
                        return i.default(t).is(":visible");
                    });
                    if (0 !== r.length) {
                        var a = r.indexOf(e.target);
                        38 === e.which && a > 0 && a--, 40 === e.which && a < r.length - 1 && a++, a < 0 && (a = 0), r[a].focus();
                    }
                }
            }
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return ae;
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return se;
                }
            }
        ]), t;
    }();
    i.default(document).on(ie, oe, le._dataApiKeydownHandler).on(ie, re, le._dataApiKeydownHandler).on(ne + " keyup.bs.dropdown.data-api", le._clearMenus).on(ne, oe, function(t) {
        t.preventDefault(), t.stopPropagation(), le._jQueryInterface.call(i.default(this), "toggle");
    }).on(ne, ".dropdown form", function(t) {
        t.stopPropagation();
    }), i.default.fn[zt] = le._jQueryInterface, i.default.fn[zt].Constructor = le, i.default.fn[zt].noConflict = function() {
        return i.default.fn[zt] = Xt, le._jQueryInterface;
    };
    var ue = "bs.modal", fe = i.default.fn.modal, de = "modal-open", ce = "fade", he = "show", pe = "modal-static", me = "hidden.bs.modal", ge = "show.bs.modal", _e = "focusin.bs.modal", ve = "resize.bs.modal", be = "click.dismiss.bs.modal", ye = "keydown.dismiss.bs.modal", Ee = "mousedown.dismiss.bs.modal", we = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Te = {
        backdrop: !0,
        keyboard: !0,
        focus: !0,
        show: !0
    }, Ce = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    }, Se = function() {
        function t(t, e) {
            this._config = this._getConfig(e), this._element = t, this._dialog = t.querySelector(".modal-dialog"), this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, this._isTransitioning = !1, this._scrollbarWidth = 0;
        }
        var e = t.prototype;
        return e.toggle = function(t) {
            return this._isShown ? this.hide() : this.show(t);
        }, e.show = function(t) {
            var e = this;
            if (!this._isShown && !this._isTransitioning) {
                var n = i.default.Event(ge, {
                    relatedTarget: t
                });
                i.default(this._element).trigger(n), n.isDefaultPrevented() || (this._isShown = !0, i.default(this._element).hasClass(ce) && (this._isTransitioning = !0), this._checkScrollbar(), this._setScrollbar(), this._adjustDialog(), this._setEscapeEvent(), this._setResizeEvent(), i.default(this._element).on(be, '[data-dismiss="modal"]', function(t) {
                    return e.hide(t);
                }), i.default(this._dialog).on(Ee, function() {
                    i.default(e._element).one("mouseup.dismiss.bs.modal", function(t) {
                        i.default(t.target).is(e._element) && (e._ignoreBackdropClick = !0);
                    });
                }), this._showBackdrop(function() {
                    return e._showElement(t);
                }));
            }
        }, e.hide = function(t) {
            var e = this;
            if (t && t.preventDefault(), this._isShown && !this._isTransitioning) {
                var n = i.default.Event("hide.bs.modal");
                if (i.default(this._element).trigger(n), this._isShown && !n.isDefaultPrevented()) {
                    this._isShown = !1;
                    var o = i.default(this._element).hasClass(ce);
                    if (o && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), i.default(document).off(_e), i.default(this._element).removeClass(he), i.default(this._element).off(be), i.default(this._dialog).off(Ee), o) {
                        var r = u.getTransitionDurationFromElement(this._element);
                        i.default(this._element).one(u.TRANSITION_END, function(t) {
                            return e._hideModal(t);
                        }).emulateTransitionEnd(r);
                    } else this._hideModal();
                }
            }
        }, e.dispose = function() {
            [
                window,
                this._element,
                this._dialog
            ].forEach(function(t) {
                return i.default(t).off(".bs.modal");
            }), i.default(document).off(_e), i.default.removeData(this._element, ue), this._config = null, this._element = null, this._dialog = null, this._backdrop = null, this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, this._isTransitioning = null, this._scrollbarWidth = null;
        }, e.handleUpdate = function() {
            this._adjustDialog();
        }, e._getConfig = function(t) {
            return t = a({}, Te, t), u.typeCheckConfig("modal", t, Ce), t;
        }, e._triggerBackdropTransition = function() {
            var t = this, e = i.default.Event("hidePrevented.bs.modal");
            if (i.default(this._element).trigger(e), !e.isDefaultPrevented()) {
                var n = this._element.scrollHeight > document.documentElement.clientHeight;
                n || (this._element.style.overflowY = "hidden"), this._element.classList.add(pe);
                var o = u.getTransitionDurationFromElement(this._dialog);
                i.default(this._element).off(u.TRANSITION_END), i.default(this._element).one(u.TRANSITION_END, function() {
                    t._element.classList.remove(pe), n || i.default(t._element).one(u.TRANSITION_END, function() {
                        t._element.style.overflowY = "";
                    }).emulateTransitionEnd(t._element, o);
                }).emulateTransitionEnd(o), this._element.focus();
            }
        }, e._showElement = function(t) {
            var e = this, n = i.default(this._element).hasClass(ce), o = this._dialog ? this._dialog.querySelector(".modal-body") : null;
            this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), i.default(this._dialog).hasClass("modal-dialog-scrollable") && o ? o.scrollTop = 0 : this._element.scrollTop = 0, n && u.reflow(this._element), i.default(this._element).addClass(he), this._config.focus && this._enforceFocus();
            var r = i.default.Event("shown.bs.modal", {
                relatedTarget: t
            }), a = function() {
                e._config.focus && e._element.focus(), e._isTransitioning = !1, i.default(e._element).trigger(r);
            };
            if (n) {
                var s = u.getTransitionDurationFromElement(this._dialog);
                i.default(this._dialog).one(u.TRANSITION_END, a).emulateTransitionEnd(s);
            } else a();
        }, e._enforceFocus = function() {
            var t = this;
            i.default(document).off(_e).on(_e, function(e) {
                document !== e.target && t._element !== e.target && 0 === i.default(t._element).has(e.target).length && t._element.focus();
            });
        }, e._setEscapeEvent = function() {
            var t = this;
            this._isShown ? i.default(this._element).on(ye, function(e) {
                t._config.keyboard && 27 === e.which ? (e.preventDefault(), t.hide()) : t._config.keyboard || 27 !== e.which || t._triggerBackdropTransition();
            }) : this._isShown || i.default(this._element).off(ye);
        }, e._setResizeEvent = function() {
            var t = this;
            this._isShown ? i.default(window).on(ve, function(e) {
                return t.handleUpdate(e);
            }) : i.default(window).off(ve);
        }, e._hideModal = function() {
            var t = this;
            this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._showBackdrop(function() {
                i.default(document.body).removeClass(de), t._resetAdjustments(), t._resetScrollbar(), i.default(t._element).trigger(me);
            });
        }, e._removeBackdrop = function() {
            this._backdrop && (i.default(this._backdrop).remove(), this._backdrop = null);
        }, e._showBackdrop = function(t) {
            var e = this, n = i.default(this._element).hasClass(ce) ? ce : "";
            if (this._isShown && this._config.backdrop) {
                if (this._backdrop = document.createElement("div"), this._backdrop.className = "modal-backdrop", n && this._backdrop.classList.add(n), i.default(this._backdrop).appendTo(document.body), i.default(this._element).on(be, function(t) {
                    e._ignoreBackdropClick ? e._ignoreBackdropClick = !1 : t.target === t.currentTarget && ("static" === e._config.backdrop ? e._triggerBackdropTransition() : e.hide());
                }), n && u.reflow(this._backdrop), i.default(this._backdrop).addClass(he), !t) return;
                if (!n) return void t();
                var o = u.getTransitionDurationFromElement(this._backdrop);
                i.default(this._backdrop).one(u.TRANSITION_END, t).emulateTransitionEnd(o);
            } else if (!this._isShown && this._backdrop) {
                i.default(this._backdrop).removeClass(he);
                var r = function() {
                    e._removeBackdrop(), t && t();
                };
                if (i.default(this._element).hasClass(ce)) {
                    var a = u.getTransitionDurationFromElement(this._backdrop);
                    i.default(this._backdrop).one(u.TRANSITION_END, r).emulateTransitionEnd(a);
                } else r();
            } else t && t();
        }, e._adjustDialog = function() {
            var t = this._element.scrollHeight > document.documentElement.clientHeight;
            !this._isBodyOverflowing && t && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), this._isBodyOverflowing && !t && (this._element.style.paddingRight = this._scrollbarWidth + "px");
        }, e._resetAdjustments = function() {
            this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
        }, e._checkScrollbar = function() {
            var t = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(t.left + t.right) < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth();
        }, e._setScrollbar = function() {
            var t = this;
            if (this._isBodyOverflowing) {
                var e = [].slice.call(document.querySelectorAll(we)), n = [].slice.call(document.querySelectorAll(".sticky-top"));
                i.default(e).each(function(e, n) {
                    var o = n.style.paddingRight, r = i.default(n).css("padding-right");
                    i.default(n).data("padding-right", o).css("padding-right", parseFloat(r) + t._scrollbarWidth + "px");
                }), i.default(n).each(function(e, n) {
                    var o = n.style.marginRight, r = i.default(n).css("margin-right");
                    i.default(n).data("margin-right", o).css("margin-right", parseFloat(r) - t._scrollbarWidth + "px");
                });
                var o = document.body.style.paddingRight, r = i.default(document.body).css("padding-right");
                i.default(document.body).data("padding-right", o).css("padding-right", parseFloat(r) + this._scrollbarWidth + "px");
            }
            i.default(document.body).addClass(de);
        }, e._resetScrollbar = function() {
            var t = [].slice.call(document.querySelectorAll(we));
            i.default(t).each(function(t, e) {
                var n = i.default(e).data("padding-right");
                i.default(e).removeData("padding-right"), e.style.paddingRight = n || "";
            });
            var e = [].slice.call(document.querySelectorAll(".sticky-top"));
            i.default(e).each(function(t, e) {
                var n = i.default(e).data("margin-right");
                "undefined" != typeof n && i.default(e).css("margin-right", n).removeData("margin-right");
            });
            var n = i.default(document.body).data("padding-right");
            i.default(document.body).removeData("padding-right"), document.body.style.paddingRight = n || "";
        }, e._getScrollbarWidth = function() {
            var t = document.createElement("div");
            t.className = "modal-scrollbar-measure", document.body.appendChild(t);
            var e = t.getBoundingClientRect().width - t.clientWidth;
            return document.body.removeChild(t), e;
        }, t._jQueryInterface = function(e, n) {
            return this.each(function() {
                var o = i.default(this).data(ue), r = a({}, Te, i.default(this).data(), "object" == typeof e && e ? e : {});
                if (o || (o = new t(this, r), i.default(this).data(ue, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e](n);
                } else r.show && o.show(n);
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return Te;
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(t) {
        var e, n = this, o = u.getSelectorFromElement(this);
        o && (e = document.querySelector(o));
        var r = i.default(e).data(ue) ? "toggle" : a({}, i.default(e).data(), i.default(this).data());
        "A" !== this.tagName && "AREA" !== this.tagName || t.preventDefault();
        var s = i.default(e).one(ge, function(t) {
            t.isDefaultPrevented() || s.one(me, function() {
                i.default(n).is(":visible") && n.focus();
            });
        });
        Se._jQueryInterface.call(i.default(e), r, this);
    }), i.default.fn.modal = Se._jQueryInterface, i.default.fn.modal.Constructor = Se, i.default.fn.modal.noConflict = function() {
        return i.default.fn.modal = fe, Se._jQueryInterface;
    };
    var Ne = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ], De = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i, Ae = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function ke(t, e, n) {
        if (0 === t.length) return t;
        if (n && "function" == typeof n) return n(t);
        for(var i = (new window.DOMParser).parseFromString(t, "text/html"), o = Object.keys(e), r = [].slice.call(i.body.querySelectorAll("*")), a = function(t, n) {
            var i = r[t], a = i.nodeName.toLowerCase();
            if (-1 === o.indexOf(i.nodeName.toLowerCase())) return i.parentNode.removeChild(i), "continue";
            var s = [].slice.call(i.attributes), l = [].concat(e["*"] || [], e[a] || []);
            s.forEach(function(t) {
                (function(t, e) {
                    var n = t.nodeName.toLowerCase();
                    if (-1 !== e.indexOf(n)) return -1 === Ne.indexOf(n) || Boolean(De.test(t.nodeValue) || Ae.test(t.nodeValue));
                    for(var i = e.filter(function(t) {
                        return t instanceof RegExp;
                    }), o = 0, r = i.length; o < r; o++)if (i[o].test(n)) return !0;
                    return !1;
                })(t, l) || i.removeAttribute(t.nodeName);
            });
        }, s = 0, l = r.length; s < l; s++)a(s);
        return i.body.innerHTML;
    }
    var Ie = "tooltip", Oe = "bs.tooltip", xe = i.default.fn.tooltip, je = new RegExp("(^|\\s)bs-tooltip\\S+", "g"), Le = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ], Pe = "fade", Fe = "show", Re = "show", Be = "out", He = "hover", Me = "focus", qe = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left"
    }, Qe = {
        animation: !0,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        selector: !1,
        placement: "top",
        offset: 0,
        container: !1,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        customClass: "",
        sanitize: !0,
        sanitizeFn: null,
        whiteList: {
            "*": [
                "class",
                "dir",
                "id",
                "lang",
                "role",
                /^aria-[\w-]*$/i
            ],
            a: [
                "target",
                "href",
                "title",
                "rel"
            ],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: [
                "src",
                "srcset",
                "alt",
                "title",
                "width",
                "height"
            ],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        },
        popperConfig: null
    }, We = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        customClass: "(string|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)"
    }, Ue = {
        HIDE: "hide.bs.tooltip",
        HIDDEN: "hidden.bs.tooltip",
        SHOW: "show.bs.tooltip",
        SHOWN: "shown.bs.tooltip",
        INSERTED: "inserted.bs.tooltip",
        CLICK: "click.bs.tooltip",
        FOCUSIN: "focusin.bs.tooltip",
        FOCUSOUT: "focusout.bs.tooltip",
        MOUSEENTER: "mouseenter.bs.tooltip",
        MOUSELEAVE: "mouseleave.bs.tooltip"
    }, Ve = function() {
        function t(t, e) {
            if ("undefined" == typeof Yt) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
            this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, this._popper = null, this.element = t, this.config = this._getConfig(e), this.tip = null, this._setListeners();
        }
        var e = t.prototype;
        return e.enable = function() {
            this._isEnabled = !0;
        }, e.disable = function() {
            this._isEnabled = !1;
        }, e.toggleEnabled = function() {
            this._isEnabled = !this._isEnabled;
        }, e.toggle = function(t) {
            if (this._isEnabled) {
                if (t) {
                    var e = this.constructor.DATA_KEY, n = i.default(t.currentTarget).data(e);
                    n || (n = new this.constructor(t.currentTarget, this._getDelegateConfig()), i.default(t.currentTarget).data(e, n)), n._activeTrigger.click = !n._activeTrigger.click, n._isWithActiveTrigger() ? n._enter(null, n) : n._leave(null, n);
                } else {
                    if (i.default(this.getTipElement()).hasClass(Fe)) return void this._leave(null, this);
                    this._enter(null, this);
                }
            }
        }, e.dispose = function() {
            clearTimeout(this._timeout), i.default.removeData(this.element, this.constructor.DATA_KEY), i.default(this.element).off(this.constructor.EVENT_KEY), i.default(this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler), this.tip && i.default(this.tip).remove(), this._isEnabled = null, this._timeout = null, this._hoverState = null, this._activeTrigger = null, this._popper && this._popper.destroy(), this._popper = null, this.element = null, this.config = null, this.tip = null;
        }, e.show = function() {
            var t = this;
            if ("none" === i.default(this.element).css("display")) throw new Error("Please use show on visible elements");
            var e = i.default.Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                i.default(this.element).trigger(e);
                var n = u.findShadowRoot(this.element), o = i.default.contains(null !== n ? n : this.element.ownerDocument.documentElement, this.element);
                if (e.isDefaultPrevented() || !o) return;
                var r = this.getTipElement(), a = u.getUID(this.constructor.NAME);
                r.setAttribute("id", a), this.element.setAttribute("aria-describedby", a), this.setContent(), this.config.animation && i.default(r).addClass(Pe);
                var s = "function" == typeof this.config.placement ? this.config.placement.call(this, r, this.element) : this.config.placement, l = this._getAttachment(s);
                this.addAttachmentClass(l);
                var f = this._getContainer();
                i.default(r).data(this.constructor.DATA_KEY, this), i.default.contains(this.element.ownerDocument.documentElement, this.tip) || i.default(r).appendTo(f), i.default(this.element).trigger(this.constructor.Event.INSERTED), this._popper = new Yt(this.element, r, this._getPopperConfig(l)), i.default(r).addClass(Fe), i.default(r).addClass(this.config.customClass), "ontouchstart" in document.documentElement && i.default(document.body).children().on("mouseover", null, i.default.noop);
                var d = function() {
                    t.config.animation && t._fixTransition();
                    var e = t._hoverState;
                    t._hoverState = null, i.default(t.element).trigger(t.constructor.Event.SHOWN), e === Be && t._leave(null, t);
                };
                if (i.default(this.tip).hasClass(Pe)) {
                    var c = u.getTransitionDurationFromElement(this.tip);
                    i.default(this.tip).one(u.TRANSITION_END, d).emulateTransitionEnd(c);
                } else d();
            }
        }, e.hide = function(t) {
            var e = this, n = this.getTipElement(), o = i.default.Event(this.constructor.Event.HIDE), r = function() {
                e._hoverState !== Re && n.parentNode && n.parentNode.removeChild(n), e._cleanTipClass(), e.element.removeAttribute("aria-describedby"), i.default(e.element).trigger(e.constructor.Event.HIDDEN), null !== e._popper && e._popper.destroy(), t && t();
            };
            if (i.default(this.element).trigger(o), !o.isDefaultPrevented()) {
                if (i.default(n).removeClass(Fe), "ontouchstart" in document.documentElement && i.default(document.body).children().off("mouseover", null, i.default.noop), this._activeTrigger.click = !1, this._activeTrigger.focus = !1, this._activeTrigger.hover = !1, i.default(this.tip).hasClass(Pe)) {
                    var a = u.getTransitionDurationFromElement(n);
                    i.default(n).one(u.TRANSITION_END, r).emulateTransitionEnd(a);
                } else r();
                this._hoverState = "";
            }
        }, e.update = function() {
            null !== this._popper && this._popper.scheduleUpdate();
        }, e.isWithContent = function() {
            return Boolean(this.getTitle());
        }, e.addAttachmentClass = function(t) {
            i.default(this.getTipElement()).addClass("bs-tooltip-" + t);
        }, e.getTipElement = function() {
            return this.tip = this.tip || i.default(this.config.template)[0], this.tip;
        }, e.setContent = function() {
            var t = this.getTipElement();
            this.setElementContent(i.default(t.querySelectorAll(".tooltip-inner")), this.getTitle()), i.default(t).removeClass("fade show");
        }, e.setElementContent = function(t, e) {
            "object" != typeof e || !e.nodeType && !e.jquery ? this.config.html ? (this.config.sanitize && (e = ke(e, this.config.whiteList, this.config.sanitizeFn)), t.html(e)) : t.text(e) : this.config.html ? i.default(e).parent().is(t) || t.empty().append(e) : t.text(i.default(e).text());
        }, e.getTitle = function() {
            var t = this.element.getAttribute("data-original-title");
            return t || (t = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title), t;
        }, e._getPopperConfig = function(t) {
            var e = this;
            return a({}, {
                placement: t,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: ".arrow"
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function(t) {
                    t.originalPlacement !== t.placement && e._handlePopperPlacementChange(t);
                },
                onUpdate: function(t) {
                    return e._handlePopperPlacementChange(t);
                }
            }, this.config.popperConfig);
        }, e._getOffset = function() {
            var t = this, e = {};
            return "function" == typeof this.config.offset ? e.fn = function(e) {
                return e.offsets = a({}, e.offsets, t.config.offset(e.offsets, t.element)), e;
            } : e.offset = this.config.offset, e;
        }, e._getContainer = function() {
            return !1 === this.config.container ? document.body : u.isElement(this.config.container) ? i.default(this.config.container) : i.default(document).find(this.config.container);
        }, e._getAttachment = function(t) {
            return qe[t.toUpperCase()];
        }, e._setListeners = function() {
            var t = this;
            this.config.trigger.split(" ").forEach(function(e) {
                if ("click" === e) i.default(t.element).on(t.constructor.Event.CLICK, t.config.selector, function(e) {
                    return t.toggle(e);
                });
                else if ("manual" !== e) {
                    var n = e === He ? t.constructor.Event.MOUSEENTER : t.constructor.Event.FOCUSIN, o = e === He ? t.constructor.Event.MOUSELEAVE : t.constructor.Event.FOCUSOUT;
                    i.default(t.element).on(n, t.config.selector, function(e) {
                        return t._enter(e);
                    }).on(o, t.config.selector, function(e) {
                        return t._leave(e);
                    });
                }
            }), this._hideModalHandler = function() {
                t.element && t.hide();
            }, i.default(this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler), this.config.selector ? this.config = a({}, this.config, {
                trigger: "manual",
                selector: ""
            }) : this._fixTitle();
        }, e._fixTitle = function() {
            var t = typeof this.element.getAttribute("data-original-title");
            (this.element.getAttribute("title") || "string" !== t) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""), this.element.setAttribute("title", ""));
        }, e._enter = function(t, e) {
            var n = this.constructor.DATA_KEY;
            (e = e || i.default(t.currentTarget).data(n)) || (e = new this.constructor(t.currentTarget, this._getDelegateConfig()), i.default(t.currentTarget).data(n, e)), t && (e._activeTrigger["focusin" === t.type ? Me : He] = !0), i.default(e.getTipElement()).hasClass(Fe) || e._hoverState === Re ? e._hoverState = Re : (clearTimeout(e._timeout), e._hoverState = Re, e.config.delay && e.config.delay.show ? e._timeout = setTimeout(function() {
                e._hoverState === Re && e.show();
            }, e.config.delay.show) : e.show());
        }, e._leave = function(t, e) {
            var n = this.constructor.DATA_KEY;
            (e = e || i.default(t.currentTarget).data(n)) || (e = new this.constructor(t.currentTarget, this._getDelegateConfig()), i.default(t.currentTarget).data(n, e)), t && (e._activeTrigger["focusout" === t.type ? Me : He] = !1), e._isWithActiveTrigger() || (clearTimeout(e._timeout), e._hoverState = Be, e.config.delay && e.config.delay.hide ? e._timeout = setTimeout(function() {
                e._hoverState === Be && e.hide();
            }, e.config.delay.hide) : e.hide());
        }, e._isWithActiveTrigger = function() {
            for(var t in this._activeTrigger)if (this._activeTrigger[t]) return !0;
            return !1;
        }, e._getConfig = function(t) {
            var e = i.default(this.element).data();
            return Object.keys(e).forEach(function(t) {
                -1 !== Le.indexOf(t) && delete e[t];
            }), "number" == typeof (t = a({}, this.constructor.Default, e, "object" == typeof t && t ? t : {})).delay && (t.delay = {
                show: t.delay,
                hide: t.delay
            }), "number" == typeof t.title && (t.title = t.title.toString()), "number" == typeof t.content && (t.content = t.content.toString()), u.typeCheckConfig(Ie, t, this.constructor.DefaultType), t.sanitize && (t.template = ke(t.template, t.whiteList, t.sanitizeFn)), t;
        }, e._getDelegateConfig = function() {
            var t = {};
            if (this.config) for(var e in this.config)this.constructor.Default[e] !== this.config[e] && (t[e] = this.config[e]);
            return t;
        }, e._cleanTipClass = function() {
            var t = i.default(this.getTipElement()), e = t.attr("class").match(je);
            null !== e && e.length && t.removeClass(e.join(""));
        }, e._handlePopperPlacementChange = function(t) {
            this.tip = t.instance.popper, this._cleanTipClass(), this.addAttachmentClass(this._getAttachment(t.placement));
        }, e._fixTransition = function() {
            var t = this.getTipElement(), e = this.config.animation;
            null === t.getAttribute("x-placement") && (i.default(t).removeClass(Pe), this.config.animation = !1, this.hide(), this.show(), this.config.animation = e);
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(Oe), r = "object" == typeof e && e;
                if ((o || !/dispose|hide/.test(e)) && (o || (o = new t(this, r), n.data(Oe, o)), "string" == typeof e)) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return Qe;
                }
            },
            {
                key: "NAME",
                get: function() {
                    return Ie;
                }
            },
            {
                key: "DATA_KEY",
                get: function() {
                    return Oe;
                }
            },
            {
                key: "Event",
                get: function() {
                    return Ue;
                }
            },
            {
                key: "EVENT_KEY",
                get: function() {
                    return ".bs.tooltip";
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return We;
                }
            }
        ]), t;
    }();
    i.default.fn.tooltip = Ve._jQueryInterface, i.default.fn.tooltip.Constructor = Ve, i.default.fn.tooltip.noConflict = function() {
        return i.default.fn.tooltip = xe, Ve._jQueryInterface;
    };
    var Ye = "bs.popover", ze = i.default.fn.popover, Ke = new RegExp("(^|\\s)bs-popover\\S+", "g"), Xe = a({}, Ve.Default, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    }), Ge = a({}, Ve.DefaultType, {
        content: "(string|element|function)"
    }), $e = {
        HIDE: "hide.bs.popover",
        HIDDEN: "hidden.bs.popover",
        SHOW: "show.bs.popover",
        SHOWN: "shown.bs.popover",
        INSERTED: "inserted.bs.popover",
        CLICK: "click.bs.popover",
        FOCUSIN: "focusin.bs.popover",
        FOCUSOUT: "focusout.bs.popover",
        MOUSEENTER: "mouseenter.bs.popover",
        MOUSELEAVE: "mouseleave.bs.popover"
    }, Je = function(t) {
        var e, n;
        function o() {
            return t.apply(this, arguments) || this;
        }
        n = t, (e = o).prototype = Object.create(n.prototype), e.prototype.constructor = e, s(e, n);
        var a = o.prototype;
        return a.isWithContent = function() {
            return this.getTitle() || this._getContent();
        }, a.addAttachmentClass = function(t) {
            i.default(this.getTipElement()).addClass("bs-popover-" + t);
        }, a.getTipElement = function() {
            return this.tip = this.tip || i.default(this.config.template)[0], this.tip;
        }, a.setContent = function() {
            var t = i.default(this.getTipElement());
            this.setElementContent(t.find(".popover-header"), this.getTitle());
            var e = this._getContent();
            "function" == typeof e && (e = e.call(this.element)), this.setElementContent(t.find(".popover-body"), e), t.removeClass("fade show");
        }, a._getContent = function() {
            return this.element.getAttribute("data-content") || this.config.content;
        }, a._cleanTipClass = function() {
            var t = i.default(this.getTipElement()), e = t.attr("class").match(Ke);
            null !== e && e.length > 0 && t.removeClass(e.join(""));
        }, o._jQueryInterface = function(t) {
            return this.each(function() {
                var e = i.default(this).data(Ye), n = "object" == typeof t ? t : null;
                if ((e || !/dispose|hide/.test(t)) && (e || (e = new o(this, n), i.default(this).data(Ye, e)), "string" == typeof t)) {
                    if ("undefined" == typeof e[t]) throw new TypeError('No method named "' + t + '"');
                    e[t]();
                }
            });
        }, r(o, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return Xe;
                }
            },
            {
                key: "NAME",
                get: function() {
                    return "popover";
                }
            },
            {
                key: "DATA_KEY",
                get: function() {
                    return Ye;
                }
            },
            {
                key: "Event",
                get: function() {
                    return $e;
                }
            },
            {
                key: "EVENT_KEY",
                get: function() {
                    return ".bs.popover";
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return Ge;
                }
            }
        ]), o;
    }(Ve);
    i.default.fn.popover = Je._jQueryInterface, i.default.fn.popover.Constructor = Je, i.default.fn.popover.noConflict = function() {
        return i.default.fn.popover = ze, Je._jQueryInterface;
    };
    var Ze = "scrollspy", tn = "bs.scrollspy", en = i.default.fn[Ze], nn = "active", on = "position", rn = ".nav, .list-group", an = {
        offset: 10,
        method: "auto",
        target: ""
    }, sn = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    }, ln = function() {
        function t(t, e) {
            var n = this;
            this._element = t, this._scrollElement = "BODY" === t.tagName ? window : t, this._config = this._getConfig(e), this._selector = this._config.target + " .nav-link," + this._config.target + " .list-group-item," + this._config.target + " .dropdown-item", this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, i.default(this._scrollElement).on("scroll.bs.scrollspy", function(t) {
                return n._process(t);
            }), this.refresh(), this._process();
        }
        var e = t.prototype;
        return e.refresh = function() {
            var t = this, e = this._scrollElement === this._scrollElement.window ? "offset" : on, n = "auto" === this._config.method ? e : this._config.method, o = n === on ? this._getScrollTop() : 0;
            this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight(), [].slice.call(document.querySelectorAll(this._selector)).map(function(t) {
                var e, r = u.getSelectorFromElement(t);
                if (r && (e = document.querySelector(r)), e) {
                    var a = e.getBoundingClientRect();
                    if (a.width || a.height) return [
                        i.default(e)[n]().top + o,
                        r
                    ];
                }
                return null;
            }).filter(Boolean).sort(function(t, e) {
                return t[0] - e[0];
            }).forEach(function(e) {
                t._offsets.push(e[0]), t._targets.push(e[1]);
            });
        }, e.dispose = function() {
            i.default.removeData(this._element, tn), i.default(this._scrollElement).off(".bs.scrollspy"), this._element = null, this._scrollElement = null, this._config = null, this._selector = null, this._offsets = null, this._targets = null, this._activeTarget = null, this._scrollHeight = null;
        }, e._getConfig = function(t) {
            if ("string" != typeof (t = a({}, an, "object" == typeof t && t ? t : {})).target && u.isElement(t.target)) {
                var e = i.default(t.target).attr("id");
                e || (e = u.getUID(Ze), i.default(t.target).attr("id", e)), t.target = "#" + e;
            }
            return u.typeCheckConfig(Ze, t, sn), t;
        }, e._getScrollTop = function() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        }, e._getScrollHeight = function() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        }, e._getOffsetHeight = function() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        }, e._process = function() {
            var t = this._getScrollTop() + this._config.offset, e = this._getScrollHeight(), n = this._config.offset + e - this._getOffsetHeight();
            if (this._scrollHeight !== e && this.refresh(), t >= n) {
                var i = this._targets[this._targets.length - 1];
                this._activeTarget !== i && this._activate(i);
            } else {
                if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0) return this._activeTarget = null, void this._clear();
                for(var o = this._offsets.length; o--;)this._activeTarget !== this._targets[o] && t >= this._offsets[o] && ("undefined" == typeof this._offsets[o + 1] || t < this._offsets[o + 1]) && this._activate(this._targets[o]);
            }
        }, e._activate = function(t) {
            this._activeTarget = t, this._clear();
            var e = this._selector.split(",").map(function(e) {
                return e + '[data-target="' + t + '"],' + e + '[href="' + t + '"]';
            }), n = i.default([].slice.call(document.querySelectorAll(e.join(","))));
            n.hasClass("dropdown-item") ? (n.closest(".dropdown").find(".dropdown-toggle").addClass(nn), n.addClass(nn)) : (n.addClass(nn), n.parents(rn).prev(".nav-link, .list-group-item").addClass(nn), n.parents(rn).prev(".nav-item").children(".nav-link").addClass(nn)), i.default(this._scrollElement).trigger("activate.bs.scrollspy", {
                relatedTarget: t
            });
        }, e._clear = function() {
            [].slice.call(document.querySelectorAll(this._selector)).filter(function(t) {
                return t.classList.contains(nn);
            }).forEach(function(t) {
                return t.classList.remove(nn);
            });
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this).data(tn);
                if (n || (n = new t(this, "object" == typeof e && e), i.default(this).data(tn, n)), "string" == typeof e) {
                    if ("undefined" == typeof n[e]) throw new TypeError('No method named "' + e + '"');
                    n[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return an;
                }
            }
        ]), t;
    }();
    i.default(window).on("load.bs.scrollspy.data-api", function() {
        for(var t = [].slice.call(document.querySelectorAll('[data-spy="scroll"]')), e = t.length; e--;){
            var n = i.default(t[e]);
            ln._jQueryInterface.call(n, n.data());
        }
    }), i.default.fn[Ze] = ln._jQueryInterface, i.default.fn[Ze].Constructor = ln, i.default.fn[Ze].noConflict = function() {
        return i.default.fn[Ze] = en, ln._jQueryInterface;
    };
    var un = "bs.tab", fn = i.default.fn.tab, dn = "active", cn = "fade", hn = "show", pn = ".active", mn = "> li > .active", gn = function() {
        function t(t) {
            this._element = t;
        }
        var e = t.prototype;
        return e.show = function() {
            var t = this;
            if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && i.default(this._element).hasClass(dn) || i.default(this._element).hasClass("disabled") || this._element.hasAttribute("disabled"))) {
                var e, n, o = i.default(this._element).closest(".nav, .list-group")[0], r = u.getSelectorFromElement(this._element);
                if (o) {
                    var a = "UL" === o.nodeName || "OL" === o.nodeName ? mn : pn;
                    n = (n = i.default.makeArray(i.default(o).find(a)))[n.length - 1];
                }
                var s = i.default.Event("hide.bs.tab", {
                    relatedTarget: this._element
                }), l = i.default.Event("show.bs.tab", {
                    relatedTarget: n
                });
                if (n && i.default(n).trigger(s), i.default(this._element).trigger(l), !l.isDefaultPrevented() && !s.isDefaultPrevented()) {
                    r && (e = document.querySelector(r)), this._activate(this._element, o);
                    var f = function() {
                        var e = i.default.Event("hidden.bs.tab", {
                            relatedTarget: t._element
                        }), o = i.default.Event("shown.bs.tab", {
                            relatedTarget: n
                        });
                        i.default(n).trigger(e), i.default(t._element).trigger(o);
                    };
                    e ? this._activate(e, e.parentNode, f) : f();
                }
            }
        }, e.dispose = function() {
            i.default.removeData(this._element, un), this._element = null;
        }, e._activate = function(t, e, n) {
            var o = this, r = (!e || "UL" !== e.nodeName && "OL" !== e.nodeName ? i.default(e).children(pn) : i.default(e).find(mn))[0], a = n && r && i.default(r).hasClass(cn), s = function() {
                return o._transitionComplete(t, r, n);
            };
            if (r && a) {
                var l = u.getTransitionDurationFromElement(r);
                i.default(r).removeClass(hn).one(u.TRANSITION_END, s).emulateTransitionEnd(l);
            } else s();
        }, e._transitionComplete = function(t, e, n) {
            if (e) {
                i.default(e).removeClass(dn);
                var o = i.default(e.parentNode).find("> .dropdown-menu .active")[0];
                o && i.default(o).removeClass(dn), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !1);
            }
            i.default(t).addClass(dn), "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !0), u.reflow(t), t.classList.contains(cn) && t.classList.add(hn);
            var r = t.parentNode;
            if (r && "LI" === r.nodeName && (r = r.parentNode), r && i.default(r).hasClass("dropdown-menu")) {
                var a = i.default(t).closest(".dropdown")[0];
                if (a) {
                    var s = [].slice.call(a.querySelectorAll(".dropdown-toggle"));
                    i.default(s).addClass(dn);
                }
                t.setAttribute("aria-expanded", !0);
            }
            n && n();
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(un);
                if (o || (o = new t(this), n.data(un, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.tab.data-api", '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]', function(t) {
        t.preventDefault(), gn._jQueryInterface.call(i.default(this), "show");
    }), i.default.fn.tab = gn._jQueryInterface, i.default.fn.tab.Constructor = gn, i.default.fn.tab.noConflict = function() {
        return i.default.fn.tab = fn, gn._jQueryInterface;
    };
    var _n = "bs.toast", vn = i.default.fn.toast, bn = "hide", yn = "show", En = "showing", wn = "click.dismiss.bs.toast", Tn = {
        animation: !0,
        autohide: !0,
        delay: 500
    }, Cn = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    }, Sn = function() {
        function t(t, e) {
            this._element = t, this._config = this._getConfig(e), this._timeout = null, this._setListeners();
        }
        var e = t.prototype;
        return e.show = function() {
            var t = this, e = i.default.Event("show.bs.toast");
            if (i.default(this._element).trigger(e), !e.isDefaultPrevented()) {
                this._clearTimeout(), this._config.animation && this._element.classList.add("fade");
                var n = function() {
                    t._element.classList.remove(En), t._element.classList.add(yn), i.default(t._element).trigger("shown.bs.toast"), t._config.autohide && (t._timeout = setTimeout(function() {
                        t.hide();
                    }, t._config.delay));
                };
                if (this._element.classList.remove(bn), u.reflow(this._element), this._element.classList.add(En), this._config.animation) {
                    var o = u.getTransitionDurationFromElement(this._element);
                    i.default(this._element).one(u.TRANSITION_END, n).emulateTransitionEnd(o);
                } else n();
            }
        }, e.hide = function() {
            if (this._element.classList.contains(yn)) {
                var t = i.default.Event("hide.bs.toast");
                i.default(this._element).trigger(t), t.isDefaultPrevented() || this._close();
            }
        }, e.dispose = function() {
            this._clearTimeout(), this._element.classList.contains(yn) && this._element.classList.remove(yn), i.default(this._element).off(wn), i.default.removeData(this._element, _n), this._element = null, this._config = null;
        }, e._getConfig = function(t) {
            return t = a({}, Tn, i.default(this._element).data(), "object" == typeof t && t ? t : {}), u.typeCheckConfig("toast", t, this.constructor.DefaultType), t;
        }, e._setListeners = function() {
            var t = this;
            i.default(this._element).on(wn, '[data-dismiss="toast"]', function() {
                return t.hide();
            });
        }, e._close = function() {
            var t = this, e = function() {
                t._element.classList.add(bn), i.default(t._element).trigger("hidden.bs.toast");
            };
            if (this._element.classList.remove(yn), this._config.animation) {
                var n = u.getTransitionDurationFromElement(this._element);
                i.default(this._element).one(u.TRANSITION_END, e).emulateTransitionEnd(n);
            } else e();
        }, e._clearTimeout = function() {
            clearTimeout(this._timeout), this._timeout = null;
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(_n);
                if (o || (o = new t(this, "object" == typeof e && e), n.data(_n, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e](this);
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return Cn;
                }
            },
            {
                key: "Default",
                get: function() {
                    return Tn;
                }
            }
        ]), t;
    }();
    i.default.fn.toast = Sn._jQueryInterface, i.default.fn.toast.Constructor = Sn, i.default.fn.toast.noConflict = function() {
        return i.default.fn.toast = vn, Sn._jQueryInterface;
    }, t.Alert = c, t.Button = b, t.Carousel = O, t.Collapse = W, t.Dropdown = le, t.Modal = Se, t.Popover = Je, t.Scrollspy = ln, t.Tab = gn, t.Toast = Sn, t.Tooltip = Ve, t.Util = u, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});


parcelRequire("cQmXV");
var $3e75b56ae88591f4$exports = {};
"use strict";
function $3e75b56ae88591f4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3e75b56ae88591f4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3e75b56ae88591f4$var$checkDCE();

$3e75b56ae88591f4$exports = (parcelRequire("bhIuc"));



var $cQmXV = parcelRequire("cQmXV");
var $e184e13c9f06c781$exports = {};
"use strict";

$e184e13c9f06c781$exports = (parcelRequire("d00aZ"));


var $b83e93e5ef3de8b0$var$__defProp = Object.defineProperty;
var $b83e93e5ef3de8b0$var$__defProps = Object.defineProperties;
var $b83e93e5ef3de8b0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b83e93e5ef3de8b0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b83e93e5ef3de8b0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b83e93e5ef3de8b0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b83e93e5ef3de8b0$var$__defNormalProp = (obj, key, value)=>key in obj ? $b83e93e5ef3de8b0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b83e93e5ef3de8b0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b83e93e5ef3de8b0$var$__hasOwnProp.call(b, prop)) $b83e93e5ef3de8b0$var$__defNormalProp(a, prop, b[prop]);
    if ($b83e93e5ef3de8b0$var$__getOwnPropSymbols) {
        for (var prop of $b83e93e5ef3de8b0$var$__getOwnPropSymbols(b))if ($b83e93e5ef3de8b0$var$__propIsEnum.call(b, prop)) $b83e93e5ef3de8b0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b83e93e5ef3de8b0$var$__spreadProps = (a, b)=>$b83e93e5ef3de8b0$var$__defProps(a, $b83e93e5ef3de8b0$var$__getOwnPropDescs(b));
var $b83e93e5ef3de8b0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b83e93e5ef3de8b0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b83e93e5ef3de8b0$var$__getOwnPropSymbols) {
        for (var prop of $b83e93e5ef3de8b0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b83e93e5ef3de8b0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $b83e93e5ef3de8b0$var$IS_REACT_19 = /* @__PURE__ */ $cQmXV.version.startsWith("19");
var $b83e93e5ef3de8b0$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($b83e93e5ef3de8b0$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $b83e93e5ef3de8b0$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $b83e93e5ef3de8b0$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $b83e93e5ef3de8b0$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $b83e93e5ef3de8b0$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $b83e93e5ef3de8b0$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $b83e93e5ef3de8b0$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $b83e93e5ef3de8b0$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $b83e93e5ef3de8b0$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $b83e93e5ef3de8b0$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $b83e93e5ef3de8b0$var$ForwardRef = $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE;
var $b83e93e5ef3de8b0$var$Memo = $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE;
function $b83e93e5ef3de8b0$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $b83e93e5ef3de8b0$var$REACT_FRAGMENT_TYPE || type === $b83e93e5ef3de8b0$var$REACT_PROFILER_TYPE || type === $b83e93e5ef3de8b0$var$REACT_STRICT_MODE_TYPE || type === $b83e93e5ef3de8b0$var$REACT_SUSPENSE_TYPE || type === $b83e93e5ef3de8b0$var$REACT_SUSPENSE_LIST_TYPE || type === $b83e93e5ef3de8b0$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $b83e93e5ef3de8b0$var$REACT_LAZY_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $b83e93e5ef3de8b0$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $b83e93e5ef3de8b0$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $b83e93e5ef3de8b0$var$REACT_FRAGMENT_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_PROFILER_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_STRICT_MODE_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_SUSPENSE_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE:
                            case $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE:
                            case $b83e93e5ef3de8b0$var$REACT_LAZY_TYPE:
                            case $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE:
                                return object;
                            case $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $b83e93e5ef3de8b0$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $b83e93e5ef3de8b0$var$isContextConsumer(object) {
    return $b83e93e5ef3de8b0$var$IS_REACT_19 ? $b83e93e5ef3de8b0$var$typeOf(object) === $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE : $b83e93e5ef3de8b0$var$typeOf(object) === $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE;
}
function $b83e93e5ef3de8b0$var$isMemo(object) {
    return $b83e93e5ef3de8b0$var$typeOf(object) === $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $b83e93e5ef3de8b0$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $b83e93e5ef3de8b0$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $b83e93e5ef3de8b0$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $b83e93e5ef3de8b0$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $b83e93e5ef3de8b0$var$verify(mapStateToProps, "mapStateToProps");
    $b83e93e5ef3de8b0$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $b83e93e5ef3de8b0$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $b83e93e5ef3de8b0$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $b83e93e5ef3de8b0$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $b83e93e5ef3de8b0$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $b83e93e5ef3de8b0$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $b83e93e5ef3de8b0$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $b83e93e5ef3de8b0$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $b83e93e5ef3de8b0$var$verifyPlainObject(value, displayName, methodName) {
    if (!$b83e93e5ef3de8b0$var$isPlainObject(value)) $b83e93e5ef3de8b0$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $b83e93e5ef3de8b0$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $b83e93e5ef3de8b0$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $b83e93e5ef3de8b0$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $b83e93e5ef3de8b0$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $b83e93e5ef3de8b0$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $b83e93e5ef3de8b0$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $b83e93e5ef3de8b0$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $b83e93e5ef3de8b0$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $b83e93e5ef3de8b0$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $b83e93e5ef3de8b0$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $b83e93e5ef3de8b0$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $b83e93e5ef3de8b0$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $b83e93e5ef3de8b0$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $b83e93e5ef3de8b0$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $b83e93e5ef3de8b0$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $b83e93e5ef3de8b0$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $b83e93e5ef3de8b0$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $b83e93e5ef3de8b0$var$__spreadValues($b83e93e5ef3de8b0$var$__spreadValues($b83e93e5ef3de8b0$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $b83e93e5ef3de8b0$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $b83e93e5ef3de8b0$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$b83e93e5ef3de8b0$var$defaultMergeProps : typeof mergeProps === "function" ? $b83e93e5ef3de8b0$var$wrapMergePropsFunc(mergeProps) : $b83e93e5ef3de8b0$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $b83e93e5ef3de8b0$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $b83e93e5ef3de8b0$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $b83e93e5ef3de8b0$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $b83e93e5ef3de8b0$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $b83e93e5ef3de8b0$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $b83e93e5ef3de8b0$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $b83e93e5ef3de8b0$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $b83e93e5ef3de8b0$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $b83e93e5ef3de8b0$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $b83e93e5ef3de8b0$var$isDOM = /* @__PURE__ */ $b83e93e5ef3de8b0$var$canUseDOM();
var $b83e93e5ef3de8b0$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $b83e93e5ef3de8b0$var$isReactNative = /* @__PURE__ */ $b83e93e5ef3de8b0$var$isRunningInReactNative();
var $b83e93e5ef3de8b0$var$getUseIsomorphicLayoutEffect = ()=>$b83e93e5ef3de8b0$var$isDOM || $b83e93e5ef3de8b0$var$isReactNative ? $cQmXV.useLayoutEffect : $cQmXV.useEffect;
var $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $b83e93e5ef3de8b0$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $b83e93e5ef3de8b0$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b83e93e5ef3de8b0$export$d36bdfa510afb180(objA, objB) {
    if ($b83e93e5ef3de8b0$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$b83e93e5ef3de8b0$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $b83e93e5ef3de8b0$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b83e93e5ef3de8b0$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b83e93e5ef3de8b0$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $b83e93e5ef3de8b0$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $b83e93e5ef3de8b0$var$TYPE_STATICS = {
    [$b83e93e5ef3de8b0$var$ForwardRef]: $b83e93e5ef3de8b0$var$FORWARD_REF_STATICS,
    [$b83e93e5ef3de8b0$var$Memo]: $b83e93e5ef3de8b0$var$MEMO_STATICS
};
function $b83e93e5ef3de8b0$var$getStatics(component) {
    if ($b83e93e5ef3de8b0$var$isMemo(component)) return $b83e93e5ef3de8b0$var$MEMO_STATICS;
    return $b83e93e5ef3de8b0$var$TYPE_STATICS[component["$$typeof"]] || $b83e93e5ef3de8b0$var$REACT_STATICS;
}
var $b83e93e5ef3de8b0$var$defineProperty = Object.defineProperty;
var $b83e93e5ef3de8b0$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b83e93e5ef3de8b0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b83e93e5ef3de8b0$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b83e93e5ef3de8b0$var$getPrototypeOf = Object.getPrototypeOf;
var $b83e93e5ef3de8b0$var$objectPrototype = Object.prototype;
function $b83e93e5ef3de8b0$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($b83e93e5ef3de8b0$var$objectPrototype) {
            const inheritedComponent = $b83e93e5ef3de8b0$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b83e93e5ef3de8b0$var$objectPrototype) $b83e93e5ef3de8b0$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $b83e93e5ef3de8b0$var$getOwnPropertyNames(sourceComponent);
        if ($b83e93e5ef3de8b0$var$getOwnPropertySymbols) keys = keys.concat($b83e93e5ef3de8b0$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $b83e93e5ef3de8b0$var$getStatics(targetComponent);
        const sourceStatics = $b83e93e5ef3de8b0$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$b83e93e5ef3de8b0$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $b83e93e5ef3de8b0$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $b83e93e5ef3de8b0$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $b83e93e5ef3de8b0$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $b83e93e5ef3de8b0$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $b83e93e5ef3de8b0$var$getContext() {
    var _a;
    if (!$cQmXV.createContext) return {};
    const contextMap = (_a = $b83e93e5ef3de8b0$var$gT[$b83e93e5ef3de8b0$var$ContextKey]) != null ? _a : $b83e93e5ef3de8b0$var$gT[$b83e93e5ef3de8b0$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($cQmXV.createContext);
    if (!realContext) {
        realContext = $cQmXV.createContext(null);
        contextMap.set($cQmXV.createContext, realContext);
    }
    return realContext;
}
var $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 = /* @__PURE__ */ $b83e93e5ef3de8b0$var$getContext();
// src/components/connect.tsx
var $b83e93e5ef3de8b0$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $b83e93e5ef3de8b0$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $b83e93e5ef3de8b0$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $b83e93e5ef3de8b0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $b83e93e5ef3de8b0$var$strictEqual(a, b) {
    return a === b;
}
var $b83e93e5ef3de8b0$var$hasWarnedAboutDeprecatedPureOption = false;
function $b83e93e5ef3de8b0$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $b83e93e5ef3de8b0$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $b83e93e5ef3de8b0$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $b83e93e5ef3de8b0$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $b83e93e5ef3de8b0$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $b83e93e5ef3de8b0$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $b83e93e5ef3de8b0$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $b83e93e5ef3de8b0$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $cQmXV.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $b83e93e5ef3de8b0$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $cQmXV.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $cQmXV.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $cQmXV.useMemo(()=>{
                return $b83e93e5ef3de8b0$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $cQmXV.useMemo(()=>{
                if (!shouldHandleStateChanges) return $b83e93e5ef3de8b0$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $b83e93e5ef3de8b0$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $cQmXV.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $b83e93e5ef3de8b0$var$__spreadProps($b83e93e5ef3de8b0$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $cQmXV.useRef(void 0);
            const lastWrapperProps = $cQmXV.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $cQmXV.useRef(void 0);
            const renderIsScheduled = $cQmXV.useRef(false);
            const isMounted = $cQmXV.useRef(false);
            const latestSubscriptionCallbackError = $cQmXV.useRef(void 0);
            $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $cQmXV.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $cQmXV.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $b83e93e5ef3de8b0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffectWithArgs($b83e93e5ef3de8b0$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $cQmXV.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $cQmXV.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $cQmXV.createElement(WrappedComponent, $b83e93e5ef3de8b0$var$__spreadProps($b83e93e5ef3de8b0$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $cQmXV.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $cQmXV.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $cQmXV.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $cQmXV.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $cQmXV.createElement(Connect, $b83e93e5ef3de8b0$var$__spreadProps($b83e93e5ef3de8b0$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $b83e93e5ef3de8b0$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $b83e93e5ef3de8b0$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $b83e93e5ef3de8b0$export$64605811ab45167f = $b83e93e5ef3de8b0$var$_connect;
var $b83e93e5ef3de8b0$export$8807b5ba46f9d0b7 = $b83e93e5ef3de8b0$var$_connect;
// src/components/Provider.tsx
function $b83e93e5ef3de8b0$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $cQmXV.useMemo(()=>{
        const subscription = $b83e93e5ef3de8b0$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $cQmXV.useMemo(()=>store.getState(), [
        store
    ]);
    $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $b83e93e5ef3de8b0$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $cQmXV.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $b83e93e5ef3de8b0$export$2881499e37b75b9a = $b83e93e5ef3de8b0$var$Provider;
// src/hooks/useReduxContext.ts
function $b83e93e5ef3de8b0$var$createReduxContextHook(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $cQmXV.useContext(context);
        return contextValue;
    };
}
var $b83e93e5ef3de8b0$var$useReduxContext = /* @__PURE__ */ $b83e93e5ef3de8b0$var$createReduxContextHook();
// src/hooks/useStore.ts
function $b83e93e5ef3de8b0$export$671dba69185d0304(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 ? $b83e93e5ef3de8b0$var$useReduxContext : // @ts-ignore
    $b83e93e5ef3de8b0$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $b83e93e5ef3de8b0$export$6ccbb43953eebf8 = /* @__PURE__ */ $b83e93e5ef3de8b0$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $b83e93e5ef3de8b0$export$bc9b55530897c558(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    const useStore2 = context === $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 ? $b83e93e5ef3de8b0$export$6ccbb43953eebf8 : $b83e93e5ef3de8b0$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $b83e93e5ef3de8b0$export$8ad76b76a4c905f8 = /* @__PURE__ */ $b83e93e5ef3de8b0$export$bc9b55530897c558();
var $b83e93e5ef3de8b0$var$refEquality = (a, b)=>a === b;
function $b83e93e5ef3de8b0$export$2b53f90d2bd1cbfb(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 ? $b83e93e5ef3de8b0$var$useReduxContext : $b83e93e5ef3de8b0$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $b83e93e5ef3de8b0$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $cQmXV.useRef(true);
        const wrappedSelector = $cQmXV.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $e184e13c9f06c781$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $cQmXV.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $b83e93e5ef3de8b0$export$2105062e25df4afe = /* @__PURE__ */ $b83e93e5ef3de8b0$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $b83e93e5ef3de8b0$export$712ea50be43a7858 = $b83e93e5ef3de8b0$var$defaultNoopBatch;


function $e9bcd870dc67024b$export$2e2bcd8739ae039(o, p) {
    $e9bcd870dc67024b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e9bcd870dc67024b$export$2e2bcd8739ae039(o, p);
}


function $17897257a8e91c2f$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $e9bcd870dc67024b$export$2e2bcd8739ae039)(subClass, superClass);
}



var $cQmXV = parcelRequire("cQmXV");

var $1Spf6 = parcelRequire("1Spf6");

var $jNuvi = parcelRequire("jNuvi");
function $5344b827b291c7d3$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $5344b827b291c7d3$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $5344b827b291c7d3$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $5344b827b291c7d3$var$isAbsolute(to);
    var isFromAbs = from && $5344b827b291c7d3$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $5344b827b291c7d3$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $5344b827b291c7d3$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $5344b827b291c7d3$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $5344b827b291c7d3$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$5344b827b291c7d3$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $5344b827b291c7d3$export$2e2bcd8739ae039 = $5344b827b291c7d3$var$resolvePathname;


function $9349e69ea1339174$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $9349e69ea1339174$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $9349e69ea1339174$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $9349e69ea1339174$var$valueOf(a);
        var bValue = $9349e69ea1339174$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $9349e69ea1339174$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $9349e69ea1339174$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $9349e69ea1339174$export$2e2bcd8739ae039 = $9349e69ea1339174$var$valueEqual;



var $5419295210f48b37$var$isProduction = true;
var $5419295210f48b37$var$prefix = "Invariant failed";
function $5419295210f48b37$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($5419295210f48b37$var$isProduction) throw new Error($5419295210f48b37$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($5419295210f48b37$var$prefix, ": ").concat(provided) : $5419295210f48b37$var$prefix;
    throw new Error(value);
}


function $45e6502123b39884$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $45e6502123b39884$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $45e6502123b39884$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $45e6502123b39884$var$stripBasename(path, prefix) {
    return $45e6502123b39884$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $45e6502123b39884$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $45e6502123b39884$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $45e6502123b39884$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $45e6502123b39884$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $45e6502123b39884$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $jNuvi.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $5344b827b291c7d3$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $45e6502123b39884$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9349e69ea1339174$export$2e2bcd8739ae039)(a.state, b.state);
}
function $45e6502123b39884$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $45e6502123b39884$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $45e6502123b39884$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $45e6502123b39884$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $45e6502123b39884$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $45e6502123b39884$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $45e6502123b39884$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $45e6502123b39884$var$PopStateEvent = "popstate";
var $45e6502123b39884$var$HashChangeEvent = "hashchange";
function $45e6502123b39884$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $45e6502123b39884$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$45e6502123b39884$var$canUseDOM && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $45e6502123b39884$var$supportsHistory();
    var needsHashChangeListener = !$45e6502123b39884$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $45e6502123b39884$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $45e6502123b39884$var$stripTrailingSlash($45e6502123b39884$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $45e6502123b39884$var$stripBasename(path, basename);
        return $45e6502123b39884$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $45e6502123b39884$var$createTransitionManager();
    function setState(nextState) {
        (0, $jNuvi.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($45e6502123b39884$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($45e6502123b39884$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($45e6502123b39884$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $45e6502123b39884$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($45e6502123b39884$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($45e6502123b39884$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($45e6502123b39884$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($45e6502123b39884$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $45e6502123b39884$var$HashChangeEvent$1 = "hashchange";
var $45e6502123b39884$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $45e6502123b39884$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $45e6502123b39884$var$stripLeadingSlash,
        decodePath: $45e6502123b39884$var$addLeadingSlash
    },
    slash: {
        encodePath: $45e6502123b39884$var$addLeadingSlash,
        decodePath: $45e6502123b39884$var$addLeadingSlash
    }
};
function $45e6502123b39884$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $45e6502123b39884$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $45e6502123b39884$var$pushHashPath(path) {
    window.location.hash = path;
}
function $45e6502123b39884$var$replaceHashPath(path) {
    window.location.replace($45e6502123b39884$var$stripHash(window.location.href) + "#" + path);
}
function $45e6502123b39884$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$45e6502123b39884$var$canUseDOM && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $45e6502123b39884$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $45e6502123b39884$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $45e6502123b39884$var$stripTrailingSlash($45e6502123b39884$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $45e6502123b39884$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($45e6502123b39884$var$getHashPath());
        if (basename) path = $45e6502123b39884$var$stripBasename(path, basename);
        return $45e6502123b39884$export$90c043f1c57770b8(path);
    }
    var transitionManager = $45e6502123b39884$var$createTransitionManager();
    function setState(nextState) {
        (0, $jNuvi.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $45e6502123b39884$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $45e6502123b39884$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $45e6502123b39884$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($45e6502123b39884$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($45e6502123b39884$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $45e6502123b39884$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $45e6502123b39884$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $45e6502123b39884$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $45e6502123b39884$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $45e6502123b39884$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $45e6502123b39884$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $45e6502123b39884$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $45e6502123b39884$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($45e6502123b39884$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $45e6502123b39884$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $45e6502123b39884$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $45e6502123b39884$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($45e6502123b39884$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($45e6502123b39884$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($45e6502123b39884$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $45e6502123b39884$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $45e6502123b39884$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $45e6502123b39884$var$createTransitionManager();
    function setState(nextState) {
        (0, $jNuvi.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $45e6502123b39884$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $45e6502123b39884$export$90c043f1c57770b8(entry, undefined, createKey()) : $45e6502123b39884$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $45e6502123b39884$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $45e6502123b39884$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $jNuvi = parcelRequire("jNuvi");
var $b7d24e21982fde27$exports = {};
var $863f3576fb1768dd$exports = {};
$863f3576fb1768dd$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $b7d24e21982fde27$exports = $b7d24e21982fde27$var$pathToRegexp;
$b7d24e21982fde27$exports.parse = $b7d24e21982fde27$var$parse;
$b7d24e21982fde27$exports.compile = $b7d24e21982fde27$var$compile;
$b7d24e21982fde27$exports.tokensToFunction = $b7d24e21982fde27$var$tokensToFunction;
$b7d24e21982fde27$exports.tokensToRegExp = $b7d24e21982fde27$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $b7d24e21982fde27$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $b7d24e21982fde27$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $b7d24e21982fde27$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $b7d24e21982fde27$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $b7d24e21982fde27$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $b7d24e21982fde27$var$compile(str, options) {
    return $b7d24e21982fde27$var$tokensToFunction($b7d24e21982fde27$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $b7d24e21982fde27$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $b7d24e21982fde27$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $b7d24e21982fde27$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $b7d24e21982fde27$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $b7d24e21982fde27$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($863f3576fb1768dd$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $b7d24e21982fde27$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $b7d24e21982fde27$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $b7d24e21982fde27$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $b7d24e21982fde27$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $b7d24e21982fde27$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($b7d24e21982fde27$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $b7d24e21982fde27$var$flags(options));
    return $b7d24e21982fde27$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$stringToRegexp(path, keys, options) {
    return $b7d24e21982fde27$var$tokensToRegExp($b7d24e21982fde27$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$tokensToRegExp(tokens, keys, options) {
    if (!$863f3576fb1768dd$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $b7d24e21982fde27$var$escapeString(token);
        else {
            var prefix = $b7d24e21982fde27$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $b7d24e21982fde27$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $b7d24e21982fde27$var$attachKeys(new RegExp("^" + route, $b7d24e21982fde27$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$pathToRegexp(path, keys, options) {
    if (!$863f3576fb1768dd$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $b7d24e21982fde27$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($863f3576fb1768dd$exports(path)) return $b7d24e21982fde27$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $b7d24e21982fde27$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


parcelRequire("2UMqt");
function $0c76a414426a4728$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $iSQ8t = parcelRequire("iSQ8t");
var $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $6f5d68f762d5488a$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $6f5d68f762d5488a$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $6f5d68f762d5488a$var$commonjsGlobal[key] = ($6f5d68f762d5488a$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $6f5d68f762d5488a$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $6f5d68f762d5488a$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $6f5d68f762d5488a$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $6f5d68f762d5488a$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $6f5d68f762d5488a$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $6f5d68f762d5488a$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($6f5d68f762d5488a$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $6f5d68f762d5488a$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $6f5d68f762d5488a$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext || $6f5d68f762d5488a$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $6f5d68f762d5488a$var$createNamedContext = function createNamedContext(name) {
    var context = $6f5d68f762d5488a$var$createContext();
    context.displayName = name;
    return context;
};
var $6f5d68f762d5488a$export$c213558b66925821 = /*#__PURE__*/ $6f5d68f762d5488a$var$createNamedContext("Router-History");
var $6f5d68f762d5488a$export$63baa8ccbe60bb07 = /*#__PURE__*/ $6f5d68f762d5488a$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $6f5d68f762d5488a$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $6f5d68f762d5488a$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $45e6502123b39884$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
var $6f5d68f762d5488a$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $6f5d68f762d5488a$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $6f5d68f762d5488a$var$messageType;
var $6f5d68f762d5488a$var$cache = {};
var $6f5d68f762d5488a$var$cacheLimit = 10000;
var $6f5d68f762d5488a$var$cacheCount = 0;
function $6f5d68f762d5488a$var$compilePath(path) {
    if ($6f5d68f762d5488a$var$cache[path]) return $6f5d68f762d5488a$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($b7d24e21982fde27$exports))).compile(path);
    if ($6f5d68f762d5488a$var$cacheCount < $6f5d68f762d5488a$var$cacheLimit) {
        $6f5d68f762d5488a$var$cache[path] = generator;
        $6f5d68f762d5488a$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $6f5d68f762d5488a$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $6f5d68f762d5488a$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $6f5d68f762d5488a$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $45e6502123b39884$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $6f5d68f762d5488a$export$82476f982757e71e(to, computedMatch.params) : (0, $jNuvi.default)({}, to, {
            pathname: $6f5d68f762d5488a$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $45e6502123b39884$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $45e6502123b39884$export$c3e8bb440bd55b18)(prevLocation, (0, $jNuvi.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $6f5d68f762d5488a$var$cache$1 = {};
var $6f5d68f762d5488a$var$cacheLimit$1 = 10000;
var $6f5d68f762d5488a$var$cacheCount$1 = 0;
function $6f5d68f762d5488a$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $6f5d68f762d5488a$var$cache$1[cacheKey] || ($6f5d68f762d5488a$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($b7d24e21982fde27$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($6f5d68f762d5488a$var$cacheCount$1 < $6f5d68f762d5488a$var$cacheLimit$1) {
        pathCache[path] = result;
        $6f5d68f762d5488a$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $6f5d68f762d5488a$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $6f5d68f762d5488a$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $6f5d68f762d5488a$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(children) === 0;
}
function $6f5d68f762d5488a$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $6f5d68f762d5488a$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $6f5d68f762d5488a$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $jNuvi.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $6f5d68f762d5488a$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
function $6f5d68f762d5488a$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $6f5d68f762d5488a$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $jNuvi.default)({}, location, {
        pathname: $6f5d68f762d5488a$var$addLeadingSlash(basename) + location.pathname
    });
}
function $6f5d68f762d5488a$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $6f5d68f762d5488a$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $jNuvi.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $6f5d68f762d5488a$var$createURL(location) {
    return typeof location === "string" ? location : (0, $45e6502123b39884$export$fe53371bee54353d)(location);
}
function $6f5d68f762d5488a$var$staticHandler(methodName) {
    return function() {
        (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    };
}
function $6f5d68f762d5488a$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $6f5d68f762d5488a$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $6f5d68f762d5488a$var$noop;
        };
        _this.handleBlock = function() {
            return $6f5d68f762d5488a$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $6f5d68f762d5488a$var$addBasename(basename, (0, $45e6502123b39884$export$90c043f1c57770b8)(location));
        context.url = $6f5d68f762d5488a$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $6f5d68f762d5488a$var$addLeadingSlash(basename + $6f5d68f762d5488a$var$createURL(path));
            },
            action: "POP",
            location: $6f5d68f762d5488a$var$stripBasename(basename, (0, $45e6502123b39884$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $6f5d68f762d5488a$var$staticHandler("go"),
            goBack: $6f5d68f762d5488a$var$staticHandler("goBack"),
            goForward: $6f5d68f762d5488a$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$55185c17a0fcbe46, (0, $jNuvi.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $6f5d68f762d5488a$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $6f5d68f762d5488a$export$81336c211d5ff295(location.pathname, (0, $jNuvi.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $6f5d68f762d5488a$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Component, (0, $jNuvi.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSQ8t)))(C, Component);
}
var $6f5d68f762d5488a$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext;
function $6f5d68f762d5488a$export$3420e1dc2c4a518c() {
    return $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$c213558b66925821);
}
function $6f5d68f762d5488a$export$45d76561a5302f2b() {
    return $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$63baa8ccbe60bb07).location;
}
function $6f5d68f762d5488a$export$99eaa27ddbbb95ef() {
    var match = $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $6f5d68f762d5488a$export$632be4bb944c1bc7(path) {
    var location = $6f5d68f762d5488a$export$45d76561a5302f2b();
    var match = $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$63baa8ccbe60bb07).match;
    return path ? $6f5d68f762d5488a$export$81336c211d5ff295(location.pathname, path) : match;
}
var $6f5d68f762d5488a$var$global$1, $6f5d68f762d5488a$var$key, $6f5d68f762d5488a$var$buildNames, $6f5d68f762d5488a$var$initialBuildName, $6f5d68f762d5488a$var$secondaryBuildName;




var $cQmXV = parcelRequire("cQmXV");




var $jNuvi = parcelRequire("jNuvi");


/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $50f22649d61cdefc$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $45e6502123b39884$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $50f22649d61cdefc$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $45e6502123b39884$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
var $50f22649d61cdefc$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $50f22649d61cdefc$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $45e6502123b39884$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $50f22649d61cdefc$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $50f22649d61cdefc$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef;
if (typeof $50f22649d61cdefc$var$forwardRef === "undefined") $50f22649d61cdefc$var$forwardRef = $50f22649d61cdefc$var$forwardRefShim;
function $50f22649d61cdefc$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $50f22649d61cdefc$var$LinkAnchor = $50f22649d61cdefc$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $jNuvi.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$50f22649d61cdefc$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($50f22649d61cdefc$var$forwardRefShim !== $50f22649d61cdefc$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $50f22649d61cdefc$export$a6c7ac8248d6e38a = $50f22649d61cdefc$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $50f22649d61cdefc$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $50f22649d61cdefc$var$normalizeToLocation($50f22649d61cdefc$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $jNuvi.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $50f22649d61cdefc$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $45e6502123b39884$export$fe53371bee54353d)(context.location) === (0, $45e6502123b39884$export$fe53371bee54353d)($50f22649d61cdefc$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($50f22649d61cdefc$var$forwardRefShim !== $50f22649d61cdefc$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(component, props);
    });
});
var $50f22649d61cdefc$var$toType, $50f22649d61cdefc$var$refType;
var $50f22649d61cdefc$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $50f22649d61cdefc$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef;
if (typeof $50f22649d61cdefc$var$forwardRef$1 === "undefined") $50f22649d61cdefc$var$forwardRef$1 = $50f22649d61cdefc$var$forwardRefShim$1;
function $50f22649d61cdefc$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $50f22649d61cdefc$export$b0d92dbee9b5b60d = $50f22649d61cdefc$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $50f22649d61cdefc$var$normalizeToLocation($50f22649d61cdefc$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $6f5d68f762d5488a$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $50f22649d61cdefc$var$joinClassnames(className, activeClassName);
            style = (0, $jNuvi.default)({}, style, activeStyle);
        }
        var props = (0, $jNuvi.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($50f22649d61cdefc$var$forwardRefShim$1 !== $50f22649d61cdefc$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($50f22649d61cdefc$export$a6c7ac8248d6e38a, props);
    });
});
var $50f22649d61cdefc$var$ariaCurrentType;



var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");
"use client";
var $896e8f74d1491439$var$L = (t)=>typeof t == "number" && !isNaN(t), $896e8f74d1491439$var$N = (t)=>typeof t == "string", $896e8f74d1491439$var$P = (t)=>typeof t == "function", $896e8f74d1491439$var$ut = (t)=>$896e8f74d1491439$var$N(t) || $896e8f74d1491439$var$L(t), $896e8f74d1491439$var$z = (t)=>$896e8f74d1491439$var$N(t) || $896e8f74d1491439$var$P(t) ? t : null, $896e8f74d1491439$var$yt = (t, o)=>t === !1 || $896e8f74d1491439$var$L(t) && t > 0 ? t : o, $896e8f74d1491439$var$F = (t)=>(0, $cQmXV.isValidElement)(t) || $896e8f74d1491439$var$N(t) || $896e8f74d1491439$var$P(t) || $896e8f74d1491439$var$L(t);
function $896e8f74d1491439$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $896e8f74d1491439$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, $cQmXV.useRef)(0);
        return (0, $cQmXV.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $cQmXV.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? $896e8f74d1491439$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, s);
    };
}
function $896e8f74d1491439$var$tt(t, o) {
    return {
        content: $896e8f74d1491439$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $896e8f74d1491439$var$ot(t, o, e = !1) {
    return (0, $cQmXV.isValidElement)(t) && !$896e8f74d1491439$var$N(t.type) ? (0, $cQmXV.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $896e8f74d1491439$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $896e8f74d1491439$var$gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $896e8f74d1491439$var$bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, $jYj5L.default)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $896e8f74d1491439$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $jYj5L.default)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var $896e8f74d1491439$var$Qt = 1, $896e8f74d1491439$var$st = ()=>`${$896e8f74d1491439$var$Qt++}`;
function $896e8f74d1491439$var$vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($896e8f74d1491439$var$tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($896e8f74d1491439$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $896e8f74d1491439$var$z(n.className || f.toastClassName),
                progressClassName: $896e8f74d1491439$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $896e8f74d1491439$var$yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || $896e8f74d1491439$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $896e8f74d1491439$var$F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $896e8f74d1491439$var$L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var $896e8f74d1491439$var$I = new Map, $896e8f74d1491439$var$U = [], $896e8f74d1491439$var$rt = new Set, $896e8f74d1491439$var$Wt = (t)=>$896e8f74d1491439$var$rt.forEach((o)=>o(t)), $896e8f74d1491439$var$ht = ()=>$896e8f74d1491439$var$I.size > 0;
function $896e8f74d1491439$var$Gt() {
    $896e8f74d1491439$var$U.forEach((t)=>$896e8f74d1491439$var$nt(t.content, t.options)), $896e8f74d1491439$var$U = [];
}
var $896e8f74d1491439$var$Ct = (t, { containerId: o })=>{
    var e;
    return (e = $896e8f74d1491439$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $896e8f74d1491439$var$X(t, o) {
    var r;
    if (o) return !!((r = $896e8f74d1491439$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $896e8f74d1491439$var$I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $896e8f74d1491439$var$xt(t) {
    if (!$896e8f74d1491439$var$ht()) {
        $896e8f74d1491439$var$U = $896e8f74d1491439$var$U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $896e8f74d1491439$var$ut(t)) $896e8f74d1491439$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $896e8f74d1491439$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $896e8f74d1491439$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $896e8f74d1491439$var$Et = (t = {})=>{
    $896e8f74d1491439$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $896e8f74d1491439$var$nt(t, o) {
    $896e8f74d1491439$var$F(t) && ($896e8f74d1491439$var$ht() || $896e8f74d1491439$var$U.push({
        content: t,
        options: o
    }), $896e8f74d1491439$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $896e8f74d1491439$var$Pt(t) {
    var o;
    (o = $896e8f74d1491439$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $896e8f74d1491439$var$it(t, o) {
    $896e8f74d1491439$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $896e8f74d1491439$var$It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $896e8f74d1491439$var$vt(o, t, $896e8f74d1491439$var$Wt);
            $896e8f74d1491439$var$I.set(o, r);
            let a = r.observe(e);
            return $896e8f74d1491439$var$Gt(), ()=>{
                a(), $896e8f74d1491439$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $896e8f74d1491439$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $896e8f74d1491439$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $896e8f74d1491439$var$St(t) {
    return $896e8f74d1491439$var$rt.add(t), ()=>{
        $896e8f74d1491439$var$rt.delete(t);
    };
}
function $896e8f74d1491439$var$qt(t) {
    return t && ($896e8f74d1491439$var$N(t.toastId) || $896e8f74d1491439$var$L(t.toastId)) ? t.toastId : $896e8f74d1491439$var$st();
}
function $896e8f74d1491439$var$H(t, o) {
    return $896e8f74d1491439$var$nt(t, o), o.toastId;
}
function $896e8f74d1491439$var$Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $896e8f74d1491439$var$qt(o)
    };
}
function $896e8f74d1491439$var$W(t) {
    return (o, e)=>$896e8f74d1491439$var$H(o, $896e8f74d1491439$var$Q(t, e));
}
function $896e8f74d1491439$export$b410431fab84fa58(t, o) {
    return $896e8f74d1491439$var$H(t, $896e8f74d1491439$var$Q("default", o));
}
$896e8f74d1491439$export$b410431fab84fa58.loading = (t, o)=>$896e8f74d1491439$var$H(t, $896e8f74d1491439$var$Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $896e8f74d1491439$var$Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = $896e8f74d1491439$var$N(o) ? $896e8f74d1491439$export$b410431fab84fa58.loading(o, a) : $896e8f74d1491439$export$b410431fab84fa58.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            $896e8f74d1491439$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = $896e8f74d1491439$var$N(g) ? {
            render: g
        } : g;
        return l ? $896e8f74d1491439$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $896e8f74d1491439$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $896e8f74d1491439$var$P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
$896e8f74d1491439$export$b410431fab84fa58.promise = $896e8f74d1491439$var$Kt;
$896e8f74d1491439$export$b410431fab84fa58.success = $896e8f74d1491439$var$W("success");
$896e8f74d1491439$export$b410431fab84fa58.info = $896e8f74d1491439$var$W("info");
$896e8f74d1491439$export$b410431fab84fa58.error = $896e8f74d1491439$var$W("error");
$896e8f74d1491439$export$b410431fab84fa58.warning = $896e8f74d1491439$var$W("warning");
$896e8f74d1491439$export$b410431fab84fa58.warn = $896e8f74d1491439$export$b410431fab84fa58.warning;
$896e8f74d1491439$export$b410431fab84fa58.dark = (t, o)=>$896e8f74d1491439$var$H(t, $896e8f74d1491439$var$Q("default", {
        theme: "dark",
        ...o
    }));
function $896e8f74d1491439$var$Yt(t) {
    $896e8f74d1491439$var$xt(t);
}
$896e8f74d1491439$export$b410431fab84fa58.dismiss = $896e8f74d1491439$var$Yt;
$896e8f74d1491439$export$b410431fab84fa58.clearWaitingQueue = $896e8f74d1491439$var$Et;
$896e8f74d1491439$export$b410431fab84fa58.isActive = $896e8f74d1491439$var$X;
$896e8f74d1491439$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $896e8f74d1491439$var$Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $896e8f74d1491439$var$st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, $896e8f74d1491439$var$H(s, l);
    }
};
$896e8f74d1491439$export$b410431fab84fa58.done = (t)=>{
    $896e8f74d1491439$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$896e8f74d1491439$export$b410431fab84fa58.onChange = $896e8f74d1491439$var$St;
$896e8f74d1491439$export$b410431fab84fa58.play = (t)=>$896e8f74d1491439$var$it(!0, t);
$896e8f74d1491439$export$b410431fab84fa58.pause = (t)=>$896e8f74d1491439$var$it(!1, t);
function $896e8f74d1491439$var$kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $cQmXV.useRef)($896e8f74d1491439$var$It(t)).current;
    r(t);
    let a = (s = (0, $cQmXV.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $896e8f74d1491439$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $896e8f74d1491439$var$Nt(t) {
    let [o, e] = (0, $cQmXV.useState)(!1), [r, a] = (0, $cQmXV.useState)(!1), l = (0, $cQmXV.useRef)(null), s = (0, $cQmXV.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $896e8f74d1491439$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $cQmXV.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $896e8f74d1491439$var$G = typeof window != "undefined" ? (0, $cQmXV.useLayoutEffect) : (0, $cQmXV.useEffect);
var $896e8f74d1491439$var$K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $896e8f74d1491439$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $896e8f74d1491439$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $896e8f74d1491439$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $896e8f74d1491439$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $896e8f74d1491439$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $896e8f74d1491439$export$4f13f83fd8bb1dac = {
    info: $896e8f74d1491439$var$no,
    warning: $896e8f74d1491439$var$ro,
    success: $896e8f74d1491439$var$io,
    error: $896e8f74d1491439$var$lo,
    spinner: $896e8f74d1491439$var$fo
}, $896e8f74d1491439$var$co = (t)=>t in $896e8f74d1491439$export$4f13f83fd8bb1dac;
function $896e8f74d1491439$var$wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($896e8f74d1491439$var$P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, $cQmXV.isValidElement)(r) ? a = (0, $cQmXV.cloneElement)(r, l) : e ? a = $896e8f74d1491439$export$4f13f83fd8bb1dac.spinner() : $896e8f74d1491439$var$co(o) && (a = $896e8f74d1491439$export$4f13f83fd8bb1dac[o](l))), a;
}
var $896e8f74d1491439$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = $896e8f74d1491439$var$Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, $jYj5L.default)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = $896e8f74d1491439$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $jYj5L.default)(M, E), mt = $896e8f74d1491439$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($896e8f74d1491439$var$P(s) ? V = s(Z) : (0, $cQmXV.isValidElement)(s) ? V = (0, $cQmXV.cloneElement)(s, Z) : V = $896e8f74d1491439$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $jYj5L.default)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), $896e8f74d1491439$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var $896e8f74d1491439$var$j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $896e8f74d1491439$export$d20e79fdc3899e95 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("bounce", !0)), $896e8f74d1491439$export$d8dc01b5c85a37b9 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("slide", !0)), $896e8f74d1491439$export$65cfd44a2050f99 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("zoom")), $896e8f74d1491439$export$4d2fae537bd90431 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("flip"));
var $896e8f74d1491439$var$vo = {
    position: "top-right",
    transition: $896e8f74d1491439$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $896e8f74d1491439$var$dt(t) {
    let o = {
        ...$896e8f74d1491439$var$vo,
        ...t
    }, e = t.stacked, [r, a] = (0, $cQmXV.useState)(!0), l = (0, $cQmXV.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = $896e8f74d1491439$var$kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, $jYj5L.default)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $896e8f74d1491439$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $jYj5L.default)(p, $896e8f74d1491439$var$z(T));
    }
    function E() {
        e && (a(!0), $896e8f74d1491439$export$b410431fab84fa58.play());
    }
    return $896e8f74d1491439$var$G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $cQmXV.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $896e8f74d1491439$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $896e8f74d1491439$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), $896e8f74d1491439$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var $896e8f74d1491439$var$Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $896e8f74d1491439$var$$t = new Map, $896e8f74d1491439$var$Rt = (t, o)=>{
    $896e8f74d1491439$var$G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $896e8f74d1491439$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $896e8f74d1491439$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $896e8f74d1491439$export$f2815235e76a62b9(t) {
    return $896e8f74d1491439$var$Rt($896e8f74d1491439$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$dt, {
        ...t
    });
}



// Drop-in replacement for the abandoned `react-s-alert` package, removed during the
// React 19 upgrade (it peer-locked to React 15/16). The app calls
// Alert.success/error/warning/info(message, options?) in ~23 places and mounts a single
// <Alert/> container in src/index.js; here we back the same API with react-toastify and
// re-export a ToastContainer to mount instead.
// Map the few react-s-alert positions used in the codebase to react-toastify equivalents.
const $8e06ecfa6b5e89ed$var$POSITION_MAP = {
    top: "top-center",
    "top-left": "top-left",
    "top-right": "top-right",
    bottom: "bottom-center",
    "bottom-left": "bottom-left",
    "bottom-right": "bottom-right"
};
const $8e06ecfa6b5e89ed$var$normalize = (opts)=>{
    if (!opts) return undefined;
    const out = {};
    if (typeof opts.timeout === "number") out.autoClose = opts.timeout;
    if (opts.position && $8e06ecfa6b5e89ed$var$POSITION_MAP[opts.position]) out.position = $8e06ecfa6b5e89ed$var$POSITION_MAP[opts.position];
    return out;
};
const $8e06ecfa6b5e89ed$var$Alert = {
    success: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).success(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    error: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).error(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    warning: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).warn(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    info: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).info(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    // react-s-alert exposed close(id) / closeAll(); toast.dismiss() closes all when id is absent.
    close: (id)=>id != null ? (0, $896e8f74d1491439$export$b410431fab84fa58).dismiss(id) : (0, $896e8f74d1491439$export$b410431fab84fa58).dismiss(),
    closeAll: ()=>(0, $896e8f74d1491439$export$b410431fab84fa58).dismiss()
};
var $8e06ecfa6b5e89ed$export$2e2bcd8739ae039 = $8e06ecfa6b5e89ed$var$Alert;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
class $c4ecd91a3fcb0ac8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, info) {
        // No remote error reporting is configured; log for local debugging.
        console.error("ErrorBoundary caught an error:", error, info);
    }
    handleReload = ()=>{
        window.location.reload();
    };
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            style: {
                padding: "48px 24px",
                textAlign: "center",
                maxWidth: 480,
                margin: "40px auto"
            },
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    style: {
                        fontSize: 48,
                        lineHeight: 1,
                        marginBottom: 16
                    },
                    children: "\u26A0\uFE0F"
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("h3", {
                    style: {
                        marginBottom: 8
                    },
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    style: {
                        color: "#666",
                        marginBottom: 24
                    },
                    children: "This page ran into an unexpected error. Reload to try again, or use the menu to open another page."
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                    className: "btn btn-primary",
                    onClick: this.handleReload,
                    children: "Reload"
                })
            ]
        });
    }
}


const $67f64b78c4102acd$var$STATE = "state";
const $67f64b78c4102acd$export$ea32cbdd559da174 = ()=>{
    try {
        const serializedState = localStorage.getItem($67f64b78c4102acd$var$STATE);
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
};
const $67f64b78c4102acd$export$fb931cd598921492 = (state)=>{
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem($67f64b78c4102acd$var$STATE, serializedState);
    } catch (error) {
        console.error("State wasn't saved");
    }
};


function $ccb28fa1a7ecc481$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $ccb28fa1a7ecc481$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ccb28fa1a7ecc481$export$2e2bcd8739ae039(obj);
}



function $942d99e408f6e993$export$2e2bcd8739ae039(input, hint) {
    if ((0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $8f99ccc7d9abb291$export$2e2bcd8739ae039(arg) {
    var key = (0, $942d99e408f6e993$export$2e2bcd8739ae039)(arg, "string");
    return (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $8a87dbb78c4121a9$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $8f99ccc7d9abb291$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $f163cd56d32104d1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f163cd56d32104d1$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f163cd56d32104d1$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f163cd56d32104d1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $3ea067e0471763f5$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $3ea067e0471763f5$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $3ea067e0471763f5$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $3ea067e0471763f5$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $3ea067e0471763f5$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $3ea067e0471763f5$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $3ea067e0471763f5$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $3ea067e0471763f5$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $3ea067e0471763f5$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($3ea067e0471763f5$var$isDate(val)) return "date";
    if ($3ea067e0471763f5$var$isError(val)) return "error";
    var constructorName = $3ea067e0471763f5$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $3ea067e0471763f5$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $3ea067e0471763f5$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $3ea067e0471763f5$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $3ea067e0471763f5$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $3ea067e0471763f5$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(1));
        return enhancer($3ea067e0471763f5$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$3ea067e0471763f5$var$isPlainObject(action)) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $3ea067e0471763f5$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$3ea067e0471763f5$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $3ea067e0471763f5$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$3ea067e0471763f5$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $3ea067e0471763f5$export$8928921ea2d3b126 = $3ea067e0471763f5$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $3ea067e0471763f5$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $3ea067e0471763f5$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $3ea067e0471763f5$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$3ea067e0471763f5$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $3ea067e0471763f5$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $3ea067e0471763f5$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $3ea067e0471763f5$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $3ea067e0471763f5$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $3ea067e0471763f5$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $3ea067e0471763f5$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $3ea067e0471763f5$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $3ea067e0471763f5$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $3ea067e0471763f5$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $3ea067e0471763f5$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $3ea067e0471763f5$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $3ea067e0471763f5$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $3ea067e0471763f5$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $3ea067e0471763f5$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


var $84dc5bf6a82842e2$export$1e511d4a378977f5;
var $84dc5bf6a82842e2$export$d32324a03b6bde1b;
var $84dc5bf6a82842e2$export$321b1ffcca858b2b;
"use strict";

var $84dc5bf6a82842e2$require$compose = $3ea067e0471763f5$export$f672e0b6f7222cd7;
$84dc5bf6a82842e2$export$1e511d4a378977f5 = true;
$84dc5bf6a82842e2$export$d32324a03b6bde1b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === "object") return $84dc5bf6a82842e2$require$compose;
    return $84dc5bf6a82842e2$require$compose.apply(null, arguments);
};
$84dc5bf6a82842e2$export$321b1ffcca858b2b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $4db2afaa32fd3fcb$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $4db2afaa32fd3fcb$var$thunk = $4db2afaa32fd3fcb$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$4db2afaa32fd3fcb$var$thunk.withExtraArgument = $4db2afaa32fd3fcb$var$createThunkMiddleware;
var $4db2afaa32fd3fcb$export$2e2bcd8739ae039 = $4db2afaa32fd3fcb$var$thunk;


const $7e11c65b70d794b3$export$1fa6c04dd35d59ff = {
    LOGIN: "LOGIN",
    REGISTER: "REGISTER",
    LOGOUT: "LOGOUT",
    UPDATE_ME: "UPDATE_ME",
    SET_DEFAULT_TEMPLATE: "SET_DEFAULT_TEMPLATE"
};
const $7e11c65b70d794b3$export$d4c72bab9d6cc13a = {
    me: undefined,
    defaultTemplate: null
};


const $e9ab468ed108e06a$var$inText = (translate, localization)=>(module)=>(key)=>translate[module][key] && translate[module][key][localization] || key;
const $e9ab468ed108e06a$export$1650419e431d3ba3 = (state = (0, $7e11c65b70d794b3$export$d4c72bab9d6cc13a), action)=>{
    const itf = state && state.translate ? $e9ab468ed108e06a$var$inText(state.translate, state.localization) : ()=>()=>"";
    state = Object.assign({}, state, {
        inText: itf
    });
    switch(action.type){
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGIN:
            window.location.replace("/");
            return Object.assign({}, state, {
                me: action.body
            });
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).REGISTER:
            window.location.replace("/");
            return Object.assign({}, state, {
                me: action.body
            });
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGOUT:
            window.location.replace("/login");
            window.location.reload(true);
            localStorage.getItem("visitCurrentPage") && localStorage.removeItem("visitCurrentPage");
            localStorage.getItem("visitCurrentFilter") && localStorage.removeItem("visitCurrentFilter");
            return Object.assign({}, state, {
                me: null
            });
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).UPDATE_ME:
            return Object.assign({}, state, {
                me: action.body
            });
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).SET_DEFAULT_TEMPLATE:
            return Object.assign({}, state, {
                defaultTemplate: action.body
            });
        default:
            return state;
    }
};



function $81aca8a46f6ecb51$export$6fec604aa7293d0c() {
    const persistedState = (0, $67f64b78c4102acd$export$ea32cbdd559da174)();
    const store = (0, $3ea067e0471763f5$export$f51a9068ac82ea43)((0, $e9ab468ed108e06a$export$1650419e431d3ba3), persistedState, (0, $84dc5bf6a82842e2$export$d32324a03b6bde1b)((0, $3ea067e0471763f5$export$9ff26e0402cc7b7)((0, $4db2afaa32fd3fcb$export$2e2bcd8739ae039))));
    if (null) null.accept("../reducers", ()=>{
        store.replaceReducer((0, $e9ab468ed108e06a$export$1650419e431d3ba3));
    });
    return store;
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");


var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
var $ec66791105d99c56$exports = {};
$ec66791105d99c56$exports = new URL("logo.ceec54e0.svg", import.meta.url).toString();





var $cQmXV = parcelRequire("cQmXV");
const $422de08ffd33db6b$export$214e5fb64d34c1fc = /*#__PURE__*/ (0, $cQmXV.createContext)();


const $fc3f36407bc5ec6c$export$72266474e9355649 = {
    overview: {
        uk: "\u041E\u0433\u043B\u044F\u0434",
        en: "Overview",
        hy: "\u0531\u056F\u0576\u0561\u0580\u056F",
        ka: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0"
    },
    photo_report: {
        uk: "\u0424\u043E\u0442\u043E \u0437\u0432\u0456\u0442",
        en: "Photo report",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u056B \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E4\u10DD\u10E2\u10DD \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8"
    },
    all_reports: {
        uk: "BI \u0437\u0432\u0456\u0442\u0438",
        en: "BI reports",
        hy: "BI \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "BI \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    supervisors: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Supervisors",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    tasks: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    my_uploads: {
        uk: "\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "My Uploads",
        hy: "\u053B\u0574 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8"
    },
    answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    task_uploading: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        en: "Task uploading",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    visit: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    documents: {
        uk: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        en: "Documents",
        hy: "\u0553\u0561\u057D\u057F\u0561\u0569\u0572\u0569\u0565\u0580",
        ka: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    logout: {
        uk: "\u0412\u0438\u0445\u0456\u0434",
        en: "Logout",
        hy: "\u0534\u0578\u0582\u0580\u057D \u0563\u0561\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E1\u10D5\u10DA\u10D0"
    },
    pt_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    pt_networks: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    pt_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    pt_countries: {
        uk: "\u041A\u0440\u0430\u0457\u043D\u0438",
        en: "Countries",
        hy: "\u0535\u0580\u056F\u0580\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D8"
    },
    pt_counties: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438",
        en: "Counties",
        hy: "\u0544\u0561\u0580\u0566\u0565\u0580",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8"
    },
    pt_localities: {
        uk: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0456 \u043F\u0443\u043D\u043A\u0442\u0438",
        en: "Localities",
        hy: "\u0532\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0565\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    pt_point_groups: {
        uk: "\u0413\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A",
        en: "Point groups",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    pt_surveys: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$7926257c0571e339 = {
    my_profile: {
        uk: "\u041C\u0456\u0439 \u043F\u0440\u043E\u0444\u0430\u0439\u043B",
        en: "My profile",
        hy: "\u053B\u0574 \u057A\u0580\u0578\u0586\u056B\u056C\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8"
    },
    my_help: {
        uk: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
        en: "Help",
        hy: "\u0555\u0563\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D3\u10D0\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D0"
    },
    name: {
        uk: "\u0406\u043C\u044F",
        en: "Name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    surname: {
        uk: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
        en: "Surname",
        hy: "\u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
        ka: "\u10D2\u10D5\u10D0\u10E0\u10D8"
    },
    position: {
        uk: "\u041F\u043E\u0441\u0430\u0434\u0430",
        en: "Position",
        hy: "\u054A\u0561\u0577\u057F\u0578\u0576",
        ka: "\u10DE\u10DD\u10D6\u10D8\u10EA\u10D8\u10D0"
    },
    my_region: {
        uk: "\u041C\u0456\u0439 \u0440\u0435\u0433\u0456\u043E\u043D",
        en: "My region",
        hy: "\u053B\u0574 \u0574\u0561\u0580\u0566\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    telegram: {
        uk: "\u0422\u0435\u043B\u0435\u0433\u0440\u0430\u043C ID",
        en: "Telegram ID",
        hy: "\u054F\u0565\u056C\u0565\u0563\u0580\u0561\u0574 ID",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10D2\u10E0\u10D0\u10DB ID"
    },
    language: {
        uk: "\u041C\u043E\u0432\u0430",
        en: "Language",
        hy: "\u053C\u0565\u0566\u0578\u0582",
        ka: "\u10D4\u10DC\u10D0"
    },
    save: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    save_success: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456",
        en: "Data saved successfully",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u056B\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    save_success_reload: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456. \u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u0431\u0443\u0434\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0430...",
        en: "Data saved successfully. The page will be reloaded...",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u056B\u0576\u0589 \u0537\u057B\u0568 \u056F\u057E\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u056B...",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0. \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u10D2\u10D0\u10D3\u10D0\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0..."
    },
    exit: {
        uk: "\u0412\u0438\u0445\u0456\u0434",
        en: "Logout",
        hy: "\u0534\u0578\u0582\u0580\u057D \u0563\u0561\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E1\u10D5\u10DA\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$33bf88bbb69ebeac = {
    custom_filter: {
        uk: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0438\u0439 \u0444\u0456\u043B\u044C\u0442\u0440",
        en: "Customer filter",
        hy: "\u0540\u0561\u057F\u0578\u0582\u056F \u0586\u056B\u056C\u057F\u0580",
        ka: "\u10DB\u10DD\u10E0\u10D2\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8"
    },
    merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    merchandisers: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Merchandisers",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    clients: {
        uk: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438",
        en: "clients",
        hy: "\u0570\u0561\u0573\u0561\u056D\u0578\u0580\u0564\u0576\u0565\u0580",
        ka: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    comment: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440 ...",
        en: "Comment ...",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576 ...",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8 ..."
    },
    point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    group_point_select_placeholder: {
        uk: "\u0413\u0440\u0443\u043F\u0430 \u0442\u043E\u0447\u043E\u043A",
        en: "Group of points",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    networks: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    created_by: {
        uk: "\u041A\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u056C \u0567",
        ka: "\u10E8\u10D4\u10DB\u10E5\u10DB\u10DC\u10D4\u10DA\u10D8"
    },
    region: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D",
        en: "Region",
        hy: "\u0544\u0561\u0580\u0566",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    city: {
        uk: "\u041C\u0456\u0441\u0442\u043E",
        en: "City",
        hy: "\u0554\u0561\u0572\u0561\u0584",
        ka: "\u10E5\u10D0\u10DA\u10D0\u10E5\u10D8"
    },
    country: {
        uk: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u0440\u0430\u0457\u043D\u0443",
        en: "Select country",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0565\u0580\u056F\u056B\u0580\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E5\u10D5\u10D4\u10E7\u10D0\u10DC\u10D0"
    },
    countries: {
        uk: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u0440\u0430\u0457\u043D\u0443",
        en: "Select country",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0565\u0580\u056F\u056B\u0580\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E5\u10D5\u10D4\u10E7\u10D0\u10DC\u10D0"
    },
    brand: {
        uk: "\u0411\u0440\u0435\u043D\u0434",
        en: "Brand",
        hy: "\u0532\u0580\u0565\u0576\u0564",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D8"
    },
    brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    product: {
        uk: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
        en: "Product",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8"
    },
    products: {
        uk: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    category: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        en: "Category",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "\u0421ategories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    subcategories: {
        uk: "\u041F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        en: "Sub category",
        hy: "\u0535\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561",
        ka: "\u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    tag: {
        uk: "\u0422\u0435\u0433",
        en: "Tag",
        hy: "\u0539\u0565\u0563",
        ka: "\u10E2\u10D4\u10D2\u10D8"
    },
    tags: {
        uk: "\u0422\u0435\u0433\u0438",
        en: "Tags",
        hy: "\u0539\u0565\u0563\u0565\u0580",
        ka: "\u10E2\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    component: {
        uk: "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442",
        en: "\u0421omponent",
        hy: "\u0532\u0561\u0572\u0561\u0564\u0580\u056B\u0579",
        ka: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10DC\u10D4\u10DC\u10E2\u10D8"
    },
    template: {
        uk: "\u0428\u0430\u0431\u043B\u043E\u043D",
        en: "Template",
        hy: "\u0541\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8"
    },
    task_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441: \u0432\u0441\u0456",
        en: "Status: all",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u055D \u0562\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8: \u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    task_negative: {
        uk: "\u041D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Negative answer",
        hy: "\u0532\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    task_deadline: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u0534\u0565\u0564\u056C\u0561\u0575\u0576",
        ka: "\u10D3\u10D4\u10D3\u10DA\u10D0\u10D8\u10DC\u10D8"
    },
    additional_filters: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
        en: "Additional filters",
        hy: "\u053C\u0580\u0561\u0581\u0578\u0582\u0581\u056B\u0579 \u0586\u056B\u056C\u057F\u0580\u0565\u0580",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8"
    },
    apply: {
        uk: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Apply",
        hy: "\u053F\u056B\u0580\u0561\u057C\u0565\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    filter_reset: {
        uk: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
        en: "Reset the filters",
        hy: "\u0536\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0565\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    filter_save: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440",
        en: "Save the filter",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    filter_remove: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440",
        en: "Remove the filter",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    filter_name_placeholder: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0444\u0456\u043B\u044C\u0442\u0440\u0443",
        en: "Filter name",
        hy: "\u0556\u056B\u056C\u057F\u0580\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    date_range: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0435\u0440\u0456\u043E\u0434",
        en: "Select a certain period",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8"
    },
    date_today: {
        uk: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        en: "Today",
        hy: "\u0531\u0575\u057D\u0585\u0580",
        ka: "\u10D3\u10E6\u10D4\u10E1"
    },
    date_yesterday: {
        uk: "\u0412\u0447\u043E\u0440\u0430",
        en: "Yesterday",
        hy: "\u0535\u0580\u0565\u056F",
        ka: "\u10D2\u10E3\u10E8\u10D8\u10DC"
    },
    date_current_week: {
        uk: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Current week",
        hy: "\u0538\u0576\u0569\u0561\u0581\u056B\u056F \u0577\u0561\u0562\u0561\u0569",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    date_last_week: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Last week",
        hy: "\u0531\u0576\u0581\u0561\u056E \u0577\u0561\u0562\u0561\u0569",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    date_\u0441urrent_month: {
        uk: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Current month",
        hy: "\u0538\u0576\u0569\u0561\u0581\u056B\u056F \u0561\u0574\u056B\u057D",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D7\u10D5\u10D4"
    },
    date_last_month: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Last month",
        hy: "\u0531\u0576\u0581\u0561\u056E \u0561\u0574\u056B\u057D",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10D7\u10D5\u10D4"
    },
    date_last_half_year: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u043F\u0456\u0432 \u0440\u043E\u043A\u0443",
        en: "Last half a year",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 \u056F\u0565\u057D \u057F\u0561\u0580\u056B",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10D4\u10DA\u10D8"
    },
    photo_review_type_group: {
        uk: "\u0413\u0440\u0443\u043F\u043E\u0432\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434",
        en: "View Group",
        hy: "\u053D\u0574\u0562\u0561\u0575\u056B\u0576 \u057F\u0565\u057D\u0584",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10E3\u10E0\u10D8 \u10EE\u10D4\u10D3\u10D8"
    },
    photo_review_type_single: {
        uk: "\u0406\u043D\u0434\u0438\u0432\u0456\u0434\u0443\u0430\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434",
        en: "View Single",
        hy: "\u0531\u0576\u0570\u0561\u057F\u0561\u056F\u0561\u0576 \u057F\u0565\u057D\u0584",
        ka: "\u10D8\u10DC\u10D3\u10D8\u10D5\u10D8\u10D3\u10E3\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D4\u10D3\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$f544127b46daf517 = {
    export: {
        uk: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438",
        en: "Export",
        hy: "\u0531\u0580\u057F\u0561\u0570\u0561\u0576\u0565\u056C",
        ka: "\u10D4\u10E5\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    download: {
        uk: "\u0421\u043A\u0430\u0447\u0430\u0442\u0438",
        en: "Download",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    downloadAll: {
        uk: "\u0421\u043A\u0430\u0447\u0430\u0442\u0438 \u0432\u0441\u0456",
        en: "Download All",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4 \u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    downloading: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Downloading",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0567",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4\u10DD\u10D1\u10E1"
    },
    confirmation_msg: {
        uk: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u043D\u0456 \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440?",
        en: "Are you sure that you want to delete the filter?",
        hy: "\u0540\u0561\u0574\u0578\u0566\u057E\u0561\u056E \u0565\u0584, \u0578\u0580 \u0581\u0561\u0576\u056F\u0561\u0576\u0578\u0582\u0574 \u0565\u0584 \u057B\u0576\u057B\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0568?",
        ka: "\u10D3\u10D0\u10E0\u10EC\u10DB\u10E3\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D7, \u10E0\u10DD\u10DB \u10D2\u10E1\u10E3\u10E0\u10D7 \u10EC\u10D0\u10E8\u10D0\u10DA\u10DD\u10D7 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8?"
    },
    remove_confirmation_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440 \u0434\u043B\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F",
        en: "Need to select a filter to delete",
        hy: "\u054B\u0576\u057B\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580 \u0561\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0568\u0576\u057F\u0580\u0565\u056C \u0586\u056B\u056C\u057F\u0580",
        ka: "\u10EC\u10D0\u10E1\u10D0\u10E8\u10DA\u10D4\u10DA\u10D0\u10D3 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E0\u10E9\u10D4\u10D5\u10D0"
    },
    remove_success_msg: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439",
        en: "The filter is deleted",
        hy: "\u0556\u056B\u056C\u057F\u0580\u0568 \u057B\u0576\u057B\u057E\u0561\u056E \u0567",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8 \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    valid_error_msg: {
        uk: "\u0406\u043C'\u044F \u0444\u0456\u043B\u044C\u0442\u0440\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C!",
        en: "The filter's name cannot be empty!",
        hy: "\u0556\u056B\u056C\u057F\u0580\u056B \u0561\u0576\u0578\u0582\u0576\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C!",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8!"
    },
    newtask_success_msg: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437\u0431\u0435\u0440e\u0436\u0435\u043D\u0435",
        en: "The task is saved",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    task_object_item_id_msg: {
        uk: "object_id \u0430\u0431\u043E object_type \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0456",
        en: "object_id or object_type not found",
        hy: "object_id \u056F\u0561\u0574 object_type \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "object_id \u10D0\u10DC object_type \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    task_reject_msg: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u043E",
        en: "Rejection",
        hy: "\u0544\u0565\u0580\u056A\u0578\u0582\u0574",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0"
    },
    task_accept_msg: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u043E",
        en: "Approval",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    back: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    },
    yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    cancel: {
        uk: "\u0412\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$f8552c1840a0c709 = {
    records_count: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u0456\u0432",
        en: "Records count",
        hy: "\u0533\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    start_date: {
        uk: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
        en: "Start date",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0580\u056F\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    deadline_date: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u0435\u0434\u043B\u0430\u0439\u043D\u0430",
        en: "Deadline date",
        hy: "\u0531\u057E\u0561\u0580\u057F\u056B \u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10D5\u10D0\u10D3\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    filter_overdue_tasks: {
        uk: "\u0412\u0456\u0434\u0444\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u043A\u043E\u0432\u0430\u043D\u0456 \u0437\u0430\u0434\u0430\u0447\u0456",
        en: "Filter overdue tasks",
        hy: "\u0536\u057F\u0565\u056C \u0578\u0582\u0577\u0561\u0581\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568",
        ka: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8"
    },
    filter_tasks_with_negative_responses: {
        uk: "\u0412\u0456\u0434\u0444\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0434\u0430\u0447\u0456 \u0437 \u043D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0438\u043C\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044F\u043C\u0438",
        en: "Filter tasks with negative responses",
        hy: "\u0536\u057F\u0565\u056C \u0562\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0578\u057E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8\u10E1 \u10DB\u10E5\u10DD\u10DC\u10D4 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8"
    },
    creation_date_from: {
        uk: "\u0414\u0430\u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437",
        en: "Creation date from",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u057D\u056F\u057D\u0561\u056E",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0\u10DC"
    },
    creation_date_to: {
        uk: "\u0414\u0430\u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u043E",
        en: "Creation date to",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10DB\u10D3\u10D4"
    },
    search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A ...",
        en: "Search ...",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574 ...",
        ka: "\u10EB\u10D8\u10D4\u10D1\u10D0 ..."
    },
    filter_reset_btn: {
        uk: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
        en: "Reset filters",
        hy: "\u0536\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    create_btn: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
        en: "Create",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u056C",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D0"
    },
    to_point_btn: {
        uk: "\u043D\u0430 \u0442\u043E\u0447\u043A\u0443",
        en: "to point",
        hy: "\u0564\u0565\u057A\u056B \u056F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D6\u10D4"
    },
    to_network_btn: {
        uk: "\u043D\u0430 \u043C\u0435\u0440\u0435\u0436\u0443",
        en: "to network",
        hy: "\u0564\u0565\u057A\u056B \u0581\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D6\u10D4"
    },
    apply_btn: {
        uk: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Apply",
        hy: "\u053F\u056B\u0580\u0561\u057C\u0565\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$7066f9cb49bf9586 = {
    name: {
        uk: "\u0406\u043C\u044F",
        en: "Name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    date_of_enrollment: {
        uk: "\u0414\u0430\u0442\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F",
        en: "Date of joining",
        hy: "\u0544\u056B\u0561\u0576\u0561\u056C\u0578\u0582 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D2\u10D0\u10EC\u10D4\u10D5\u10E0\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    deactivation_date: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u0457",
        en: "Deactivation date",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    date_till_newbie: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u043E \u043D\u043E\u0432\u0430\u0447\u043A\u0430",
        en: "Date till newbie",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E \u0574\u056B\u0576\u0579\u0587 \u0576\u0578\u0580\u0565\u056F\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u056B \u0561\u057E\u0561\u0580\u057F\u0568",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0\u10DB\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8\u10E1 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4"
    },
    surname: {
        uk: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
        en: "Surname",
        hy: "\u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
        ka: "\u10D2\u10D5\u10D0\u10E0\u10D8"
    },
    phone_number: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone number",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D\u0561\u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"
    },
    movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10DB\u10DD\u10EB\u10E0\u10D0\u10DD\u10D1\u10D0"
    },
    password: {
        uk: "\u041F\u0430\u0440\u043E\u043B\u044C",
        en: "Password",
        hy: "\u0533\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C",
        ka: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8"
    },
    repeat_password: {
        uk: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
        en: "Repeat password",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568",
        ka: "\u10D2\u10D0\u10D8\u10DB\u10D4\u10DD\u10E0\u10D4\u10D7 \u10DE\u10D0\u10E0\u10DD\u10DA\u10D8"
    },
    status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    save_changes_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
        en: "Save changes",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
        ka: "\u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$7c2d9af61f6af587 = {
    heading: {
        uk: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438",
        en: "Routes",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8"
    },
    legend: {
        uk: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0442\u043E\u0447\u043A\u0443 \u043D\u0430 \u0434\u0435\u043D\u044C. \u0412\u0438\u043D\u044F\u0442\u043A\u0438 \u0443\u0441\u043F\u0430\u0434\u043A\u043E\u0432\u0443\u044E\u0442\u044C \u0442\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u043F\u043B\u0430\u043D.",
        en: "Drag a point onto a day. Overrides inherit the weekly plan.",
        hy: "\u0554\u0561\u0577\u0565\u0584 \u056F\u0565\u057F\u0568 \u0585\u0580\u057E\u0561 \u057E\u0580\u0561\u0589 \u0532\u0561\u0581\u0561\u057C\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568 \u056A\u0561\u057C\u0561\u0576\u0563\u0578\u0582\u0574 \u0565\u0576 \u0577\u0561\u0562\u0561\u0569\u0561\u056F\u0561\u0576 \u057A\u056C\u0561\u0576\u0568\u0589",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10D3\u10E6\u10D4\u10D6\u10D4. \u10D2\u10D0\u10DB\u10DD\u10DC\u10D0\u10D9\u10DA\u10D8\u10E1\u10D4\u10D1\u10D8 \u10DB\u10D4\u10DB\u10D9\u10D5\u10D8\u10D3\u10E0\u10D4\u10DD\u10D1\u10D8\u10D7 \u10D8\u10E6\u10D4\u10D1\u10D4\u10DC \u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0\u10E1."
    },
    search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0442\u043E\u0447\u043E\u043A\u2026",
        en: "Search points\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C \u056F\u0565\u057F\u0565\u0580\u2026",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    no_points_found: {
        uk: "\u0422\u043E\u0447\u043E\u043A \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No points found",
        hy: "\u053F\u0565\u057F\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    scope_title: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0442\u043E\u0447\u043A\u0443 \u0434\u043E\u2026",
        en: "Add point to\u2026",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u056F\u0565\u057F\u0568\u2026",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0\u2026"
    },
    scope_every: {
        uk: "\u041A\u043E\u0436\u0435\u043D {day}",
        en: "Every {day}",
        hy: "\u0531\u0574\u0565\u0576 {day}",
        ka: "\u10E7\u10DD\u10D5\u10D4\u10DA {day}"
    },
    scope_nth: {
        uk: "\u041B\u0438\u0448\u0435 {ord} {day} \u0449\u043E\u043C\u0456\u0441\u044F\u0446\u044F",
        en: "Only the {ord} {day} of each month",
        hy: "\u0531\u0574\u057D\u057E\u0561 {ord} {day}-\u0568",
        ka: "\u10D7\u10D5\u10D8\u10E1 {ord} {day}"
    },
    scope_date: {
        uk: "\u041B\u0438\u0448\u0435 {date}",
        en: "Only on {date}",
        hy: "\u0544\u056B\u0561\u0575\u0576 {date}",
        ka: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 {date}"
    },
    cancel: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    badge_weekly: {
        uk: "\u0429\u043E\u0442\u0438\u0436\u043D\u044F",
        en: "Weekly",
        hy: "\u0547\u0561\u0562\u0561\u0569\u0561\u056F\u0561\u0576",
        ka: "\u10E7\u10DD\u10D5\u10D4\u10DA\u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    badge_date: {
        uk: "\u0420\u0430\u0437\u043E\u0432\u043E",
        en: "One-off",
        hy: "\u0544\u0565\u056F\u0561\u0576\u0563\u0561\u0574\u0575\u0561",
        ka: "\u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8"
    },
    ord_first: {
        uk: "1-\u0439",
        en: "1st",
        hy: "1-\u056B\u0576",
        ka: "1-\u10DA\u10D8"
    },
    ord_second: {
        uk: "2-\u0439",
        en: "2nd",
        hy: "2-\u0580\u0564",
        ka: "2-\u10D4"
    },
    ord_third: {
        uk: "3-\u0439",
        en: "3rd",
        hy: "3-\u0580\u0564",
        ka: "3-\u10D4"
    },
    ord_fourth: {
        uk: "4-\u0439",
        en: "4th",
        hy: "4-\u0580\u0564",
        ka: "4-\u10D4"
    },
    ord_fifth: {
        uk: "5-\u0439",
        en: "5th",
        hy: "5-\u0580\u0564",
        ka: "5-\u10D4"
    }
};
const $fc3f36407bc5ec6c$export$38fc5682710cdf86 = {
    data_successfully_saved: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456",
        en: "Data successfully saved",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u056B\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    view_btn: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        en: "View",
        hy: "\u0534\u056B\u057F\u0565\u056C",
        ka: "\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    edit_btn: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        en: "Edit",
        hy: "\u053D\u0574\u0562\u0561\u0563\u0580\u0565\u056C",
        ka: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    "routes": {
        uk: "Ma\u0440\u0448\u0440\u0443\u0442\u0438",
        en: "Routes",
        hy: "\u0544\u0561\u0580\u0584\u0578\u0582\u057F\u0576\u0565\u0580",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8"
    },
    route: {
        uk: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442",
        en: "Route",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8"
    },
    assignment: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Assignment",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    visits: {
        uk: "\u0412i\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0545\u0551\u0535\u0550",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    presence: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
        en: "Absence",
        hy: "\u0546\u0535\u0550\u053F\u0531\u0545\u0548\u0552\u0539\u0545\u0548\u0552\u0546",
        ka: "\u10D3\u10D0\u10E1\u10EC\u10E0\u10D4\u10D1\u10D0"
    },
    network_title: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    title_title: {
        uk: "\u0422\u0438\u0442\u0443\u043B",
        en: "Title",
        hy: "\u054F\u056B\u057F\u0572\u0578\u057D",
        ka: "\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    start_title: {
        uk: "\u0421\u0440\u0442",
        en: "Start",
        hy: "\u054D\u056F\u056B\u0566\u0562",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0"
    },
    end_title: {
        uk: "\u041A\u0456\u043D\u0435\u0446\u044C",
        en: "End",
        hy: "\u0531\u057E\u0561\u0580\u057F",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10E1\u10E0\u10E3\u10DA\u10D8"
    },
    number_of_images_title: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
        en: "Number of images",
        hy: "\u0546\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    number_of_tags_title: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0442\u0435\u0433\u0456\u0432",
        en: "Number of tags",
        hy: "\u0539\u0565\u0563\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F",
        ka: "\u10E2\u10D4\u10D2\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    completion_title: {
        uk: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
        en: "Completion",
        hy: "\u0531\u057E\u0561\u0580\u057F\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0"
    },
    point_title: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    points_title: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    day_title: {
        uk: "\u0414\u0435\u043D\u044C",
        en: "Day",
        hy: "\u0555\u0580",
        ka: "\u10D3\u10E6\u10D4"
    },
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10DB\u10DD\u10EB\u10E0\u10D0\u10DD\u10D1\u10D0"
    },
    connected: {
        uk: "\u041F\u0440\u0438\u0454\u0434\u043D\u0430\u0432\u0441\u044F",
        en: "Connected",
        hy: "\u0544\u056B\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    deactivated: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u0438\u0439",
        en: "Deactivated",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    till_newbie: {
        uk: "\u0414\u043E \u043D\u043E\u0432\u0430\u0447\u043A\u0456\u0432",
        en: "Till Newbie",
        hy: "\u0544\u056B\u0576\u0579\u0587 \u0576\u0578\u0580\u0565\u056F",
        ka: "\u10D3\u10D0\u10DB\u10EC\u10E7\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4"
    },
    user_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$37c2c40e726df6 = {
    user_name: {
        uk: "\u0406\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
        en: "User name",
        hy: "\u0555\u0563\u057F\u0561\u057F\u056B\u0580\u0578\u057B \u0561\u0576\u0578\u0582\u0576\u0568",
        ka: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    phone_number: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10DB\u10DD\u10EB\u10E0\u10D0\u10DD\u10D1\u10D0"
    },
    user_state: {
        uk: "\u0421\u0442\u0430\u043D",
        en: "User State",
        hy: "\u0555\u0563\u057F\u0561\u057F\u056B\u0580\u0578\u057B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0"
    },
    date_join: {
        uk: "\u0414\u0430\u0442\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F",
        en: "Date of joining",
        hy: "\u0544\u056B\u0561\u0576\u0561\u056C\u0578\u0582 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D2\u10D0\u10EC\u10D4\u10D5\u10E0\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$437eb927da0bf418 = {
    query: {
        uk: "\u0417\u0430\u043F\u0438\u0442",
        en: "Request",
        hy: "\u0540\u0561\u0575\u057F",
        ka: "\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0"
    },
    date_from: {
        uk: "\u0414\u0430\u0442\u0430 \u0437",
        en: "Date from",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u057D\u056F\u057D\u0561\u056E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0\u10DC"
    },
    date_to: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u043E",
        en: "Date to",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10DB\u10D3\u10D4"
    },
    reason: {
        uk: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
        en: "Reason",
        hy: "\u054A\u0561\u057F\u0573\u0561\u057C",
        ka: "\u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    add_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438",
        en: "Add",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    absence_history: {
        uk: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0435\u0439",
        en: "Absence history",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u057A\u0561\u057F\u0574\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0"
    },
    absence_reason: {
        uk: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456",
        en: "Please enter the reason of absence",
        hy: "\u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0576\u0577\u0565\u056C \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u057A\u0561\u057F\u0573\u0561\u057C\u0568",
        ka: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10DD\u10D7 \u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    absence_short_reason_title: {
        uk: "\u0412\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u0448\u0432\u0438\u0434\u043A\u0438\u0445 \u043F\u0440\u0438\u0447\u0438\u043D \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456",
        en: "Quick absence reasons",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u0561\u0580\u0561\u0563 \u057A\u0561\u057F\u0573\u0561\u057C\u0576\u0565\u0580",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10E1\u10D0\u10E1\u10EC\u10E0\u10D0\u10E4\u10DD \u10DB\u10D8\u10D6\u10D4\u10D6\u10D4\u10D1\u10D8"
    },
    absence_short_reason: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u0432\u0438\u0434\u043A\u0438\u0439 \u0432\u0430\u0440\u0456\u0430\u043D\u0442 \u043F\u0440\u0438\u0447\u0438\u043D\u0438 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456",
        en: "You can choose a quick reason for absence",
        hy: "\u0534\u0578\u0582\u0584 \u056F\u0561\u0580\u0578\u0572 \u0565\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u0561\u0580\u0561\u0563 \u057A\u0561\u057F\u0573\u0561\u057C",
        ka: "\u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10D0\u10D8\u10E0\u10E9\u10D8\u10DD\u10D7 \u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10E1\u10D0\u10E1\u10EC\u10E0\u10D0\u10E4\u10DD \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$3241045aa1844a20 = {
    monday: {
        uk: "\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        en: "Monday",
        hy: "\u0535\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    tuesday: {
        uk: "\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        en: "Tuesday",
        hy: "\u0535\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    wednesday: {
        uk: "\u0421\u0435\u0440\u0435\u0434\u0430",
        en: "Wednesday",
        hy: "\u0549\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    thursday: {
        uk: "\u0427\u0435\u0442\u0432\u0435\u0440",
        en: "Thursday",
        hy: "\u0540\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    friday: {
        uk: "\u041F\u044F\u0442\u043D\u0438\u0446\u044F",
        en: "Friday",
        hy: "\u0548\u0582\u0580\u0562\u0561\u0569",
        ka: "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8"
    },
    saturday: {
        uk: "\u0421\u0443\u0431\u043E\u0442\u0430",
        en: "Saturday",
        hy: "\u0547\u0561\u0562\u0561\u0569",
        ka: "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    sunday: {
        uk: "\u041D\u0435\u0434\u0456\u043B\u044F",
        en: "Sunday",
        hy: "\u053F\u056B\u0580\u0561\u056F\u056B",
        ka: "\u10D9\u10D5\u10D8\u10E0\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$b56eeb2175b87a73 = {
    point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    created_by: {
        uk: "\u041A\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u0567",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    merchendiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchendiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    name: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    task_title: {
        uk: "\u0422\u0438\u0442\u0443\u043B",
        en: "Title",
        hy: "\u054E\u0565\u0580\u0576\u0561\u0563\u056B\u0580",
        ka: "\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    task_group_points_title: {
        uk: "\u0422\u0438\u0442\u0443\u043B \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Upload title",
        hy: "\u054E\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u057E\u0565\u0580\u0576\u0561\u0563\u056B\u0580",
        ka: "\u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    finishing: {
        uk: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
        en: "Finishing",
        hy: "\u0531\u057E\u0561\u0580\u057F",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0"
    },
    status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    date_creation: {
        uk: "\u0414\u0430\u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        en: "Date of creation",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    print_report: {
        uk: "\u0414\u0440\u0443\u043A\u0443\u0432\u0430\u0442\u0438 \u0437\u0432\u0456\u0442",
        en: "Print report",
        hy: "\u054F\u057A\u0565\u056C \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8\u10E1 \u10D3\u10D0\u10D1\u10D4\u10ED\u10D3\u10D5\u10D0"
    },
    responses: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Responses",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    first_page: {
        uk: "\u041F\u0435\u0440\u0448\u0430",
        en: "First",
        hy: "\u0531\u057C\u0561\u057B\u056B\u0576",
        ka: "\u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8"
    },
    previous_page: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F",
        en: "Previous",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564",
        ka: "\u10EC\u10D8\u10DC\u10D0"
    },
    next_page: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430",
        en: "Next",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8"
    },
    last_page: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F",
        en: "Last",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576",
        ka: "\u10D1\u10DD\u10DA\u10DD"
    },
    description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    addresses: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u0430",
        en: "Addresses",
        hy: "\u0540\u0561\u057D\u0581\u0565\u0576\u0565\u0580",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D4\u10D1\u10D8"
    },
    network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    answer_saved: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0430",
        en: "The answer is saved",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    task_saved: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0435",
        en: "The task is saved",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    date_saved: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456",
        en: "The data is successfully saved",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0565\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    download_btn: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
        en: "Download",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    approv_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        en: "To approve",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0"
    },
    remove_btn: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u054B\u0576\u057B\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    cancel_btn: {
        uk: "\u0412\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    back_btn: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    },
    task_details_title: {
        uk: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Details of the task",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u0574\u0561\u0576\u0580\u0561\u0574\u0561\u057D\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8"
    },
    task_created_by_err_msg: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0442\u0456\u043B\u044C\u043A\u0438 \u0457\u0457 \u0430\u0432\u0442\u043E\u0440",
        en: "Remove the task can only be done by its author",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u056F\u0561\u0580\u0578\u0572 \u0567 \u057B\u0576\u057B\u0565\u056C \u0574\u056B\u0561\u0575\u0576 \u0564\u0580\u0561 \u0570\u0565\u0572\u056B\u0576\u0561\u056F\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DB\u10D8\u10E1\u10D8 \u10D0\u10D5\u10E2\u10DD\u10E0\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0"
    },
    new_task_group_btn_text: {
        uk: "\u041D\u0430 \u0433\u0440\u0443\u043F\u0443 \u0442\u043E\u0447\u043E\u043A",
        en: "Per group of points",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    new_task_single_btn_text: {
        uk: "\u041D\u0430 \u0442\u043E\u0447\u043A\u0443",
        en: "Per one point",
        hy: "\u0544\u0565\u056F \u056F\u0565\u057F\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10D4\u10E0\u10D7\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    yes: {
        uk: "\u0442\u0430\u043A",
        en: "yes",
        hy: "\u0561\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    no: {
        uk: "\u043D\u0456",
        en: "no",
        hy: "\u0578\u0579",
        ka: "\u10D0\u10E0\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$d84a8a9f170b88dd = {
    drag_msg: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u044E\u0434\u0438",
        en: "Click or drag the image here",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0576\u056F\u0561\u0580\u0568 \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D3\u10D0\u10D0\u10D9\u10DA\u10D8\u10D9\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E1\u10E3\u10E0\u10D0\u10D7\u10D8 \u10D0\u10E5"
    },
    new_order: {
        uk: "\u041D\u043E\u0432\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
        en: "New order",
        hy: "\u0546\u0578\u0580 \u0570\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    group_point_label: {
        uk: "\u0413\u0440\u0443\u043F\u0430 \u0442\u043E\u0447\u043E\u043A",
        en: "Group of points",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    task_template: {
        uk: "\u0428\u0430\u0431\u043B\u043E\u043D",
        en: "Template",
        hy: "\u0541\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8"
    },
    start_date: {
        uk: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
        en: "The start date",
        hy: "\u054D\u056F\u0566\u0562\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    end_date: {
        uk: "\u0414\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
        en: "The end date",
        hy: "\u0531\u057E\u0561\u0580\u057F\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$d35a16c4e31da536 = {
    apply_btn: {
        uk: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Apply",
        hy: "\u053F\u056B\u0580\u0561\u057C\u0565\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    reject_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0"
    },
    reset_filters_btn: {
        uk: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
        en: "Reset the filters",
        hy: "\u0536\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    records_count: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u0456\u0432",
        en: "Records count",
        hy: "\u0533\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    responsible_supervisor: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Responsible supervisor",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582 \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    view_btn: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        en: "View",
        hy: "\u0534\u056B\u057F\u0565\u056C",
        ka: "\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    photo_title: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    details_task: {
        uk: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Details of the task",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u0574\u0561\u0576\u0580\u0561\u0574\u0561\u057D\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8"
    },
    title_task: {
        uk: "\u0422\u0438\u0442\u0443\u043B",
        en: "Title",
        hy: "\u054E\u0565\u0580\u0576\u0561\u0563\u056B\u0580",
        ka: "\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    description_task: {
        uk: "\u041E\u043F\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Description of the task",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u0576\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    tags_task: {
        uk: "\u0422\u0435\u0433\u0438",
        en: "Tags",
        hy: "\u0539\u0565\u0563\u0565\u0580",
        ka: "\u10E2\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    images_task: {
        uk: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Images",
        hy: "\u0546\u056F\u0561\u0580\u0576\u0565\u0580",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D4\u10D1\u10D8"
    },
    deadline_task: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u054E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10D5\u10D0\u10D3\u10D0"
    },
    details_response_task: {
        uk: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Response Details",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u0574\u0561\u0576\u0580\u0561\u0574\u0561\u057D\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8"
    },
    date_response_task: {
        uk: "\u0414\u0430\u0442\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Response Date",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    text_response_task: {
        uk: "\u0422\u0435\u043A\u0441\u0442 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Response Text",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u057F\u0565\u0584\u057D\u057F",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    photo_response_task: {
        uk: "\u0424\u043E\u0442\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Response Photo",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10E4\u10DD\u10E2\u10DD"
    },
    yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    visit_id: {
        uk: "\u041D\u043E\u043C\u0435\u0440 \u0412\u0456\u0437\u0438\u0442\u0443",
        en: "Visit ID",
        hy: "\u0531\u0575\u0581\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 ID"
    },
    back_btn: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    }
};
const $fc3f36407bc5ec6c$export$5f49f978abb09725 = {
    import_tab: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442",
        en: "Import",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    import_advanced_tab: {
        uk: "\u0420\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0438\u0439 \u0456\u043C\u043F\u043E\u0440\u0442",
        en: "Advanced Import",
        hy: "\u0538\u0576\u0564\u056C\u0561\u0575\u0576\u057E\u0561\u056E \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    import_matrix_tab: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442: \u0430\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u044F",
        en: "Import: Assortment Matrix",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574. \u054F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0561",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8: \u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0"
    },
    import_downloads_tab: {
        uk: "\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "My Uploads",
        hy: "\u053B\u0574 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8"
    },
    type_loading: {
        uk: "\u0422\u0438\u043F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Loading Type",
        hy: "\u0532\u0565\u057C\u0576\u0574\u0561\u0576 \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    click_or_drag_file: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B",
        en: "Click or Drag a File",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0586\u0561\u0575\u056C\u0568",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8"
    },
    download_btn: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
        en: "Download",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    add_record_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0441",
        en: "Add Record",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0563\u0580\u0561\u057C\u0578\u0582\u0574",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    back_btn: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    },
    status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    name_title: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    line_title: {
        uk: "\u0420\u044F\u0434\u043E\u043A",
        en: "Line",
        hy: "\u054F\u0578\u0572",
        ka: "\u10EE\u10D0\u10D6\u10D8"
    },
    start_date_title: {
        uk: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
        en: "Start Date",
        hy: "\u054D\u056F\u0566\u0562\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    end_date_title: {
        uk: "\u0414\u0430\u0442\u0430 \u043A\u0456\u043D\u0446\u044F",
        en: "End Date",
        hy: "\u0531\u057E\u0561\u0580\u057F\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    photo_title: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    description_title: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    added_points_text_label_suf: {
        uk: "\u0414\u043E\u0434\u0430\u043D\u043E",
        en: "Added",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u057E\u0565\u056C \u0567",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    added_points_text_label_pref: {
        uk: "\u0442\u043E\u0447\u043A\u0430(\u0442\u043E\u0447\u043E\u043A)",
        en: "point(points)",
        hy: "\u056F\u0565\u057F(\u0565\u0580)",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8(\u10D4\u10D1\u10D8)"
    },
    type_tasks_title: {
        uk: "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447",
        en: "Type of tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    download_date_title: {
        uk: "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Download date",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    loading_errors_title: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Loading errors",
        hy: "\u0532\u0565\u057C\u0576\u0574\u0561\u0576 \u057D\u056D\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8"
    },
    need_title_task_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u0442\u0438\u0442\u0443\u043B \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "You need to enter the title of the task",
        hy: "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u057E\u0565\u0580\u0576\u0561\u0563\u056B\u0580\u0568",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10DD\u10D7 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    download_was_delete_msg: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Download has been successfully deleted",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057B\u0576\u057B\u057E\u0565\u056C \u0567",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10EC\u10D0\u10D8\u10E8\u10D0\u10DA\u10D0"
    },
    need_choose_task_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D",
        en: "You need to choose a template",
        hy: "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0568\u0576\u057F\u0580\u0565\u056C \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0"
    },
    need_choose_point_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0442\u043E\u0447\u043A\u0443",
        en: "Point is required field",
        hy: "\u053F\u0565\u057F\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    need_choose_point_group_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0433\u0440\u0443\u043F\u0443 \u0442\u043E\u0447\u043E\u043A",
        en: "Group of points is required field",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0578\u0582\u0574\u0562\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    create_success_group_task_msg: {
        uk: "\u0412\u0430\u0448\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u044E\u044E\u0442\u044C\u0441\u044F \u0442\u0430 \u0431\u0443\u0434\u0443\u0442\u044C \u0433\u043E\u0442\u043E\u0432\u0456 \u0437\u0430 \u043A\u0456\u043B\u044C\u043A\u0430 \u0445\u0432\u0438\u043B\u0438\u043D.",
        en: "Creating your tasks. They will be ready in a couple of minutes.",
        hy: "\u0541\u0565\u0580 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568 \u057D\u057F\u0565\u0572\u056E\u057E\u0578\u0582\u0574 \u0565\u0576\u0589 \u0534\u0580\u0561\u0576\u0584 \u057A\u0561\u057F\u0580\u0561\u057D\u057F \u056F\u056C\u056B\u0576\u0565\u0576 \u0574\u056B \u0584\u0561\u0576\u056B \u0580\u0578\u057A\u0565\u0578\u0582\u0574\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D8\u10E5\u10DB\u10DC\u10D4\u10D1\u10D0. \u10D8\u10E1\u10D8\u10DC\u10D8 \u10DB\u10D6\u10D0\u10D3 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10EC\u10E3\u10D7\u10E8\u10D8."
    },
    need_choose_point_group_name_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u0442\u0438\u0442\u0443\u043B \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Group of points title is required field",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u056B \u057E\u0565\u0580\u0576\u0561\u0563\u056B\u0580\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    empty_field_msg: {
        uk: "\u0426\u0435 \u043F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
        en: "This field cannot be empty",
        hy: "\u0531\u0575\u057D \u0564\u0561\u0577\u057F\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C",
        ka: "\u10D4\u10E1 \u10D5\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8"
    },
    download_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Download name",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    select_download_type: {
        uk: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Choose the download type",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0576\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u057F\u0565\u057D\u0561\u056F\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    click_drag_img: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u044E\u0434\u0438",
        en: "Click or drag the image here",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0576\u056F\u0561\u0580\u0568 \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E1\u10E3\u10E0\u10D0\u10D7\u10D8 \u10D0\u10E5"
    },
    only_one_photo_allowed_for_type_point: {
        uk: "\u0414\u043B\u044F \u0442\u0438\u043F\u0443 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F '\u0422\u043E\u0447\u043A\u0430' \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0435 \u043B\u0438\u0448\u0435 \u043E\u0434\u043D\u0435 \u0444\u043E\u0442\u043E",
        en: "For upload type 'Point', only one photo is allowed",
        hy: "\xab\u053F\u0565\u057F\xbb \u057F\u0565\u057D\u0561\u056F\u056B \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0570\u0561\u0574\u0561\u0580 \u0569\u0578\u0582\u0575\u056C\u0561\u057F\u0580\u057E\u0578\u0582\u0574 \u0567 \u0574\u056B\u0561\u0575\u0576 \u0574\u0565\u056F \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "'\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8' \u10E2\u10D8\u10DE\u10D8\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D3\u10D0\u10E8\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10D4\u10E0\u10D7\u10D8 \u10E4\u10DD\u10E2\u10DD"
    },
    complete_at_least_one_task_msg: {
        uk: "\u0417\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u043D\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0430\u0431\u043E \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0444\u0430\u0439\u043B \u0434\u043B\u044F \u0456\u043C\u043F\u043E\u0440\u0442\u0443",
        en: "Complete at least one task or select a file to import",
        hy: "\u053C\u0580\u0561\u0581\u0580\u0565\u0584 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 \u0574\u0565\u056F \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584 \u056F\u0561\u0574 \u0568\u0576\u057F\u0580\u0565\u0584 \u0586\u0561\u0575\u056C \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0574\u0561\u0576 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E8\u10D4\u10D0\u10D5\u10E1\u10D4\u10D7 \u10E1\u10E3\u10DA \u10DB\u10EA\u10D8\u10E0\u10D4 \u10D4\u10E0\u10D7\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D0\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    network_label: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    point_label: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    remove_btn: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    addresses_label: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u0430",
        en: "Addresses",
        hy: "\u0540\u0561\u057D\u0581\u0565\u0576\u0565\u0580",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D4\u10D1\u10D8"
    },
    code_label: {
        uk: "\u041A\u043E\u0434",
        en: "Code",
        hy: "\u053F\u0578\u0564",
        ka: "\u10D9\u10DD\u10D3\u10D8"
    },
    location_label: {
        uk: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Location",
        hy: "\u0533\u057F\u0576\u057E\u0565\u056C\u0578\u0582 \u057E\u0561\u0575\u0580",
        ka: "\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0"
    },
    coordinates_label: {
        uk: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438",
        en: "Coordinates",
        hy: "\u053F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8"
    },
    view_the_point: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0442\u043E\u0447\u043A\u0438",
        en: "View the point",
        hy: "\u0534\u056B\u057F\u0565\u056C \u056F\u0565\u057F\u0568",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    grouping_btn_name: {
        uk: "\u0413\u0440\u0443\u043F\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Grouping",
        hy: "\u053D\u0574\u0562\u0561\u057E\u0578\u0580\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D0"
    },
    new_group_btn_name: {
        uk: "\u041D\u043E\u0432\u0430 \u0433\u0440\u0443\u043F\u0430",
        en: "New Group",
        hy: "\u0546\u0578\u0580 \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    grouping_popup_title: {
        uk: "\u0413\u0440\u0443\u043F\u0443\u0432\u0430\u043D\u043D\u044F \u0442\u043E\u0440\u0433\u043E\u0432\u0438\u0445 \u0442\u043E\u0447\u043E\u043A",
        en: "Grouping of trade points",
        hy: "\u0531\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0561\u057E\u0578\u0580\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D0"
    },
    new_group_popup_title: {
        uk: "\u0406\u0441\u043D\u0443\u044E\u0447\u0456 \u0433\u0440\u0443\u043F\u0438",
        en: "Existing groups",
        hy: "\u0531\u057C\u056F\u0561 \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    new_group_popup_new_title: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043D\u043E\u0432\u043E\u0457 \u0433\u0440\u0443\u043F\u0438",
        en: "Creating a new group",
        hy: "\u0546\u0578\u0580 \u056D\u0574\u0562\u056B \u057D\u057F\u0565\u0572\u056E\u0578\u0582\u0574",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0"
    },
    new_group_popup_edit_title: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0433\u0440\u0443\u043F\u0438",
        en: "Editing group",
        hy: "\u053D\u0574\u0562\u056B \u056D\u0574\u0562\u0561\u0563\u0580\u0578\u0582\u0574",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    new_group_popup_field_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0433\u0440\u0443\u043F\u0438",
        en: "Group Name",
        hy: "\u053D\u0574\u0562\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    new_group_popup_field_group_textarea_name: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438",
        en: "Trade points",
        hy: "\u0531\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    group_popup_filter_name_label: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0442\u043E\u0447\u043E\u043A",
        en: "Points filter",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u0586\u056B\u056C\u057F\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8"
    },
    new_group_popup_field_group_available_users: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043B\u044F",
        en: "Available for",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0"
    },
    new_group_popup_field_name_placeholder: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u0433\u0440\u0443\u043F\u0438. \u041C\u0456\u043D\u0456\u043C\u0443\u043C 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
        en: "Enter the name of the group. Minimum 5 characters",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u056D\u0574\u0562\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574\u0568\u0589 \u0531\u057C\u0576\u057E\u0561\u0566\u0576 5 \u0576\u0577\u0561\u0576",
        ka: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8. \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB 5 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD"
    },
    group_popup_filter_name_placeholder: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u0442\u043E\u0440\u0433\u043E\u0432\u0438\u0445 \u0442\u043E\u0447\u043E\u043A (\u043C\u0456\u043D 3 \u0441\u0438\u043C\u0432\u043E\u043B\u0438)",
        en: "Filtering trade points (min 3 characters)",
        hy: "\u0531\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u056B \u0566\u057F\u0578\u0582\u0574 (\u0576\u057E\u0561\u0566\u0561\u0563\u0578\u0582\u0575\u0576\u0568 3 \u0576\u0577\u0561\u0576)",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D0\u10EA\u10D8\u10D0 (\u10DB\u10D8\u10DC. 3 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD)"
    },
    new_group_popup_field_group_add_all_btn_text: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u043E\u0447\u043A\u0438",
        en: "Add all points",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0562\u0578\u056C\u0578\u0580 \u056F\u0565\u057F\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    new_group_popup_field_group_placeholder: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u0440\u0433\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Choose trade points from the list",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u0568 \u0581\u0561\u0576\u056F\u056B\u0581",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC"
    },
    group_popup_filter_name_empty_placeholder: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0438\u0445 \u0442\u043E\u0447\u043E\u043A \u0449\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C \u0432\u0430\u0448\u043E\u043C\u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No trade points matching your filter were found.",
        hy: "\u0541\u0565\u0580 \u0586\u056B\u056C\u057F\u0580\u056B\u0576 \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0572 \u0561\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10E2\u10E7\u10D5\u10D8\u10E1\u10D8 \u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0."
    },
    new_group_popup_field_users_placeholder: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u043E\u043C\u0443 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Choose who has access to the group from the list",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0581\u0561\u0576\u056F\u056B\u0581, \u0578\u0582\u0574 \u0570\u0561\u0574\u0561\u0580 \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567 \u056D\u0578\u0582\u0574\u0562\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC, \u10D5\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1\u10D0\u10EA \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    new_group_popup_error_text: {
        uk: "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
        en: "The field cannot be empty",
        hy: "\u0534\u0561\u0577\u057F\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C",
        ka: "\u10D5\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8"
    },
    new_group_popup_error_text_minimum: {
        uk: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
        en: "Minimum 5 characters",
        hy: "\u0531\u057C\u0576\u057E\u0561\u0566\u0576 5 \u0576\u0577\u0561\u0576",
        ka: "\u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB 5 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD"
    },
    new_group_popup_success_save_text: {
        uk: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "Successfully saved",
        hy: "\u0540\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u056C \u0567",
        ka: "\u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10D0"
    },
    new_group_popup_success_deleted_text: {
        uk: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Successfully deleted",
        hy: "\u0540\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057B\u0576\u057B\u057E\u0565\u056C \u0567",
        ka: "\u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10EC\u10D0\u10D8\u10E8\u10D0\u10DA\u10D0"
    },
    new_group_popup_failed_deleted_text: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F, \u0434\u0438\u0432\u0456\u0442\u044C\u0441\u044F \u0434\u0435\u0442\u0430\u043B\u0456 \u0432 \u043A\u043E\u043D\u0441\u043E\u043B\u0456",
        en: "Failed to delete, check the console",
        hy: "\u054B\u0576\u057B\u0578\u0582\u0574\u0568 \u0571\u0561\u056D\u0578\u0572\u057E\u0565\u0581, \u057D\u057F\u0578\u0582\u0563\u0565\u0584 console-\u0568",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0, \u10D2\u10D0\u10D3\u10D0\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D7 \u10D9\u10DD\u10DC\u10E1\u10DD\u10DA\u10D8"
    },
    new_group_popup_user_validate_error_text: {
        uk: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u0434\u043B\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u0446\u0456\u0454\u0457 \u0434\u0456\u0457",
        en: "You do not have permission to perform this action.",
        hy: "\u0534\u0578\u0582\u0584 \u0579\u0578\u0582\u0576\u0565\u0584 \u0561\u0575\u057D \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u056F\u0561\u057F\u0561\u0580\u0565\u056C\u0578\u0582 \u0569\u0578\u0582\u0575\u056C\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10E0 \u10D2\u10D0\u10E5\u10D5\u10D7 \u10D0\u10DB \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0."
    },
    new_group_popup_error_save_text: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043D\u043E\u0432\u043E\u0457 \u0433\u0440\u0443\u043F\u043F\u0438",
        en: "Error creating a new group",
        hy: "\u054D\u056D\u0561\u056C \u0576\u0578\u0580 \u056D\u0578\u0582\u0574\u0562 \u057D\u057F\u0565\u0572\u056E\u0565\u056C\u056B\u057D",
        ka: "\u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1\u10D0\u10E1"
    },
    new_group_popup_error_update_text: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0433\u0440\u0443\u043F\u043F\u0438",
        en: "Error updating group",
        hy: "\u054D\u056D\u0561\u056C \u056D\u0578\u0582\u0574\u0562\u0568 \u0569\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C\u056B\u057D",
        ka: "\u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1"
    },
    new_group_popup_delete_approve_text: {
        uk: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438?",
        en: "Are you sure you want to delete?",
        hy: "\u0540\u0561\u0574\u0578\u0566\u057E\u0561\u056E \u0565\u0584, \u0578\u0580 \u0578\u0582\u0566\u0578\u0582\u0574 \u0565\u0584 \u057B\u0576\u057B\u0565\u056C?",
        ka: "\u10D3\u10D0\u10E0\u10EC\u10DB\u10E3\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D7, \u10E0\u10DD\u10DB \u10D2\u10E1\u10E3\u10E0\u10D7 \u10EC\u10D0\u10E8\u10DA\u10D0?"
    },
    new_group_popup_btn_save_name: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    no_group_found_msg: {
        uk: "\u0416\u043E\u0434\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 \u043D\u0435 \u0437\u043D\u0430\u0438\u0306\u0434\u0435\u043D\u0430",
        en: "No group found",
        hy: "\u053D\u0578\u0582\u0574\u0562 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    selected_point_row_has_error: {
        uk: "\u041F\u0440\u0438 \u0432\u0438\u0431\u043E\u0440\u0456 \u0442\u043E\u0447\u043A\u0438 \u0432\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
        en: "An error occurred while selecting the point",
        hy: "\u053F\u0565\u057F\u0568 \u0568\u0576\u057F\u0580\u0565\u056C\u056B\u057D \u057D\u056D\u0561\u056C \u057F\u0565\u0572\u056B \u0578\u0582\u0576\u0565\u0581\u0561\u057E",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D8\u10E1\u10D0\u10E1 \u10DB\u10DD\u10EE\u10D3\u10D0 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0"
    },
    file_successfully_uploaded: {
        uk: "\u0424\u0430\u0439\u043B \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0438\u0439",
        en: "File Successfully Uploaded",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u0565\u0581",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D0\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D0"
    },
    file_error_uploaded: {
        uk: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0446\u0456 \u0444\u0430\u0439\u043B\u0430",
        en: "An error occurred while loading the file.",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u0562\u0565\u057C\u0576\u0565\u056C\u056B\u057D \u057D\u056D\u0561\u056C \u057F\u0565\u0572\u056B \u0578\u0582\u0576\u0565\u0581\u0561\u057E\u0589",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1\u10D0\u10E1 \u10DB\u10DD\u10EE\u10D3\u10D0 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0."
    },
    import_group_dragdrop_label: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B \u0441\u044E\u0434\u0438 \u0430\u0431\u043E \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u0440\u0433\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Click or drag the file here or select the trade points from the list",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0586\u0561\u0575\u056C\u0568 \u0561\u0575\u057D\u057F\u0565\u0572, \u056F\u0561\u0574 \u0568\u0576\u057F\u0580\u0565\u0584 \u0561\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u0568 \u0581\u0561\u0576\u056F\u056B\u0581",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10D0\u10E5, \u10D0\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC"
    },
    import_group_dragdrop_approve_file_text: {
        uk: "\u0422\u0456\u043B\u044C\u043A\u0438 .csv,.xlsx \u0444\u0430\u0439\u043B",
        en: "Only .csv,.xlsx file",
        hy: "\u0544\u056B\u0561\u0575\u0576 .csv, .xlsx \u0586\u0561\u0575\u056C",
        ka: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 .csv, .xlsx \u10E4\u10D0\u10D8\u10DA\u10D8"
    },
    confirm_clear_all_points_before_change: {
        uk: "\u0412\u0438 \u0434\u043E\u0434\u0430\u043B\u0438 \u0432\u0441\u0456 \u043F\u043E\u0456\u043D\u0442\u0438. \u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A \u0442\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438? (\u041E\u041A \u2014 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0438, \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u2014 \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u0438)",
        en: "You added all points. Clear the list and proceed? (OK \u2014 clear, Cancel \u2014 keep)",
        hy: "\u0534\u0578\u0582\u0584 \u0561\u057E\u0565\u056C\u0561\u0581\u0580\u0565\u056C \u0565\u0584 \u0562\u0578\u056C\u0578\u0580 \u056F\u0565\u057F\u0565\u0580\u0568\u0589 \u0544\u0561\u0584\u0580\u0565\u056C \u0581\u0561\u0576\u056F\u0568 \u0587 \u0577\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C\u0589 (OK \u2014 \u0574\u0561\u0584\u0580\u0565\u056C, \u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C \u2014 \u057A\u0561\u0570\u0565\u056C)",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8. \u10D2\u10D0\u10D5\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10DD\u10D7 \u10E1\u10D8\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10D5\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10DD\u10D7? (OK \u2014 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0, \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0 \u2014 \u10E8\u10D4\u10DC\u10D0\u10E0\u10E9\u10E3\u10DC\u10D4\u10D1\u10D0)"
    },
    confirm_reset_or_keep_points: {
        uk: "\u0412 \u0441\u043F\u0438\u0441\u043A\u0443 \u0454 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u043F\u043E\u0456\u043D\u0442\u0438. \u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0456 \u0434\u043E \u0456\u0441\u043D\u0443\u044E\u0447\u0438\u0445? (\u041E\u041A \u2014 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u0456\u0441\u043D\u0443\u044E\u0447\u0438\u0445, \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u2014 \u0441\u043A\u0438\u043D\u0443\u0442\u0438)",
        en: "Points exist in the list. Add new ones to existing? (OK \u2014 add to existing, Cancel \u2014 reset)",
        hy: "\u0551\u0561\u0576\u056F\u0578\u0582\u0574 \u056F\u0561\u0576 \u0568\u0576\u057F\u0580\u057E\u0561\u056E \u056F\u0565\u057F\u0565\u0580\u0589 \u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0576\u0578\u0580\u0565\u0580\u0568 \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0578\u0582\u0576\u0565\u0581\u0578\u0572\u0576\u0565\u0580\u056B\u0576\u0589 (OK \u2014 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0561\u057C\u056F\u0561\u0576\u0565\u0580\u056B\u0576, \u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C \u2014 \u0566\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C)",
        ka: "\u10E1\u10D8\u10D0\u10E8\u10D8 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1 \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8. \u10D3\u10D0\u10D5\u10D0\u10DB\u10D0\u10E2\u10DD\u10D7 \u10D0\u10EE\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D7\u10D0\u10DC? (OK \u2014 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D7\u10D0\u10DC, \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0 \u2014 \u10D2\u10D0\u10D3\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0)"
    },
    confirm_clear_all_points_before_change: {
        uk: "\u0412\u0438 \u0434\u043E\u0434\u0430\u043B\u0438 \u0432\u0441\u0456 \u043F\u043E\u0456\u043D\u0442\u0438. \u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A \u0442\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438? (\u041E\u041A \u2014 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0438, \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u2014 \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u0438)",
        en: "You added all points. Clear the list and proceed? (OK \u2014 clear, Cancel \u2014 keep)",
        hy: "\u0534\u0578\u0582\u0584 \u0561\u057E\u0565\u056C\u0561\u0581\u0580\u0565\u056C \u0565\u0584 \u0562\u0578\u056C\u0578\u0580 \u056F\u0565\u057F\u0565\u0580\u0568\u0589 \u0544\u0561\u0584\u0580\u0565\u056C \u0581\u0561\u0576\u056F\u0568 \u0587 \u0577\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C\u0589 (OK \u2014 \u0574\u0561\u0584\u0580\u0565\u056C, \u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C \u2014 \u057A\u0561\u0570\u0565\u056C)",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8. \u10D2\u10D0\u10D5\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10DD\u10D7 \u10E1\u10D8\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10D5\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10DD\u10D7? (OK \u2014 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0, \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0 \u2014 \u10E8\u10D4\u10DC\u10D0\u10E0\u10E9\u10E3\u10DC\u10D4\u10D1\u10D0)"
    },
    confirm_reset_or_keep_points: {
        uk: "\u0412 \u0441\u043F\u0438\u0441\u043A\u0443 \u0454 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u043F\u043E\u0456\u043D\u0442\u0438. \u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0456 \u0434\u043E \u0456\u0441\u043D\u0443\u044E\u0447\u0438\u0445? (\u041E\u041A \u2014 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u0456\u0441\u043D\u0443\u044E\u0447\u0438\u0445, \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u2014 \u0441\u043A\u0438\u043D\u0443\u0442\u0438)",
        en: "Points exist in the list. Add new ones to existing? (OK \u2014 add to existing, Cancel \u2014 reset)",
        hy: "\u0551\u0561\u0576\u056F\u0578\u0582\u0574 \u056F\u0561\u0576 \u0568\u0576\u057F\u0580\u057E\u0561\u056E \u056F\u0565\u057F\u0565\u0580\u0589 \u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0576\u0578\u0580\u0565\u0580\u0568 \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0578\u0582\u0576\u0565\u0581\u0578\u0572\u0576\u0565\u0580\u056B\u0576\u0589 (OK \u2014 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0561\u057C\u056F\u0561\u0576\u0565\u0580\u056B\u0576, \u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C \u2014 \u0566\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C)",
        ka: "\u10E1\u10D8\u10D0\u10E8\u10D8 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1 \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8. \u10D3\u10D0\u10D5\u10D0\u10DB\u10D0\u10E2\u10DD\u10D7 \u10D0\u10EE\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D7\u10D0\u10DC? (OK \u2014 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D7\u10D0\u10DC, \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0 \u2014 \u10D2\u10D0\u10D3\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0)"
    }
};
const $fc3f36407bc5ec6c$export$2cbd0be658ac061c = {
    file_deleted: {
        uk: "\u0424\u0430\u0439\u043B \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439",
        en: "File Deleted",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u057B\u0576\u057B\u057E\u0561\u056E \u0567",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8 \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    file_name_cannot_be_empty: {
        uk: "\u0406\u043C'\u044F \u0444\u0430\u0439\u043B\u0443 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
        en: "File Name Cannot Be Empty",
        hy: "\u0556\u0561\u0575\u056C\u056B \u0561\u0576\u0578\u0582\u0576\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8"
    },
    need_to_add_file: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0444\u0430\u0439\u043B",
        en: "Need to Add File",
        hy: "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0586\u0561\u0575\u056C",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    file_successfully_uploaded: {
        uk: "\u0424\u0430\u0439\u043B \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0438\u0439",
        en: "File Successfully Uploaded",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u0565\u0581",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D0\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D0"
    },
    add_file: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0444\u0430\u0439\u043B",
        en: "Add File",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0586\u0561\u0575\u056C",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    file_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0444\u0430\u0439\u043B\u0443",
        en: "File Name",
        hy: "\u0556\u0561\u0575\u056C\u056B \u0561\u0576\u0578\u0582\u0576",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    click_or_drag_files_here: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B\u0438 \u0441\u044E\u0434\u0438",
        en: "Click or Drag Files Here",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0586\u0561\u0575\u056C\u0565\u0580\u0568 \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E5"
    },
    download_file_btn: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u0430\u0439\u043B",
        en: "Download File",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0586\u0561\u0575\u056C\u0568",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    creation_time: {
        uk: "\u0427\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        en: "Creation Time",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u056A\u0561\u0574\u0561\u0576\u0561\u056F",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D3\u10E0\u10DD"
    },
    search: {
        uk: "\u041F\u043E\u0448\u0443\u043A",
        en: "Search",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$ce86776e5caf6dd0 = {
    merchendiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchendiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    responsible_supervisor: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Responsible supervisor",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582 \u057E\u0565\u0580\u0561\u056F\u0561\u0581\u0578\u0582",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    start_visit: {
        uk: "\u0421\u0442\u0430\u0440\u0442 \u0432\u0456\u0437\u0438\u0442\u0443",
        en: "The start of the visit",
        hy: "\u0531\u0575\u0581\u056B \u057D\u056F\u056B\u0566\u0562\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0"
    },
    end_visit: {
        uk: "\u041A\u0456\u043D\u0435\u0446\u044C \u0432\u0456\u0437\u0438\u0442\u0443",
        en: "The end of the visit",
        hy: "\u0531\u0575\u0581\u056B \u0561\u057E\u0561\u0580\u057F\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10E1\u10D0\u10E1\u10E0\u10E3\u10DA\u10D8"
    },
    comment: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    price: {
        uk: "\u0426\u0456\u043D\u0430",
        en: "Price",
        hy: "\u0533\u056B\u0576",
        ka: "\u10E4\u10D0\u10E1\u10D8"
    },
    sales_price: {
        uk: "\u0426\u0456\u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
        en: "Sales price",
        hy: "\u054E\u0561\u0573\u0561\u057C\u0584\u056B \u0563\u056B\u0576",
        ka: "\u10D2\u10D0\u10E7\u10D8\u10D3\u10D5\u10D8\u10E1 \u10E4\u10D0\u10E1\u10D8"
    },
    price_monitoring: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0446\u0456\u043D",
        en: "Price monitoring",
        hy: "\u0533\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    approve_reject_label_block: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F/\u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
        en: "Approval/Rejection Status",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0574\u0561\u0576/\u0574\u0565\u0580\u056A\u0574\u0561\u0576 \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D8\u10E1/\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    approv_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        en: "To approve",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    approved_by: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved by",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    rejected_by: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Rejected by",
        hy: "\u0544\u0565\u0580\u056A\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8\u10D0"
    },
    app_reject_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    answer: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    linkedTasks: {
        uk: "\u041F\u043E\u0432\u044F\u0437\u0430\u043D\u0456 \u0437\u0430\u0434\u0430\u0447\u0456",
        en: "Linked tasks",
        hy: "\u053F\u0561\u057A\u0561\u056F\u0581\u057E\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    linkedVisit: {
        uk: "\u0412\u0456\u0437\u0438\u0442",
        en: "Visit",
        hy: "\u0531\u0575\u0581",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    created_by: {
        uk: "\u041A\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0456\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    approved: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    rejected: {
        uk: "\u0412\u0456\u0434\u0445\u0456\u043B\u0435\u043D\u043E",
        en: "Rejected",
        hy: "\u0544\u0565\u0580\u056A\u057E\u0561\u056E",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$62d0a6d9a23c818 = {
    login_success_msg: {
        uk: "\u0412\u0438 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0443\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
        en: "You have successfully logged in to the system",
        hy: "\u0534\u0578\u0582\u0584 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u0574\u0578\u0582\u057F\u0584 \u0563\u0578\u0580\u056E\u0565\u0581\u056B\u0584 \u0570\u0561\u0574\u0561\u056F\u0561\u0580\u0563",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10EE\u10D5\u10D4\u10D3\u10D8\u10D7 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0\u10E8\u10D8"
    },
    login_error_msg: {
        uk: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454 \u0430\u0431\u043E \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443.",
        en: "User does not exist or incorrect login data.",
        hy: "\u0555\u0563\u057F\u0561\u057F\u0565\u0580\u0568 \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0579\u0578\u0582\u0576\u056B \u056F\u0561\u0574 \u0574\u0578\u0582\u057F\u0584\u056B \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u057D\u056D\u0561\u056C \u0565\u0576\u0589",
        ka: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1 \u10D0\u10DC \u10E8\u10D4\u10E1\u10D5\u10DA\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8\u10D0."
    }
};
const $fc3f36407bc5ec6c$export$34f353d91e697be5 = {
    page_title: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    table_timespent: {
        uk: "\u0427\u0430\u0441",
        en: "Time",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F",
        ka: "\u10D3\u10E0\u10DD"
    },
    author_way: {
        uk: "\u0410\u0432\u0442\u043E\u0440/\u041F\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443",
        en: "Author/On the route",
        hy: "\u0540\u0565\u0572\u056B\u0576\u0561\u056F/\u0535\u0580\u0569\u0578\u0582\u0572\u0578\u057E",
        ka: "\u10D0\u10D5\u10E2\u10DD\u10E0\u10D8/\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D6\u10D4"
    },
    merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054E\u0565\u0580\u0561\u056F\u0561\u0581\u0578\u0582",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    approved_by: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved by",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    point_started_title: {
        uk: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E",
        en: "Started",
        hy: "\u054D\u056F\u057D\u057E\u0561\u056E \u0567",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    point_agoby_title: {
        uk: "\u0442\u043E\u043C\u0443",
        en: "ago by",
        hy: "\u0561\u057C\u0561\u057B\u055D",
        ka: "\u10EC\u10D8\u10DC"
    },
    seconds: {
        uk: "\u0441\u0435\u043A\u0443\u043D\u0434",
        en: "seconds",
        hy: "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        ka: "\u10EC\u10D0\u10DB\u10D8"
    },
    minutes: {
        uk: "\u0445\u0432\u0438\u043B\u0438\u043D",
        en: "minutes",
        hy: "\u0580\u0578\u057A\u0565",
        ka: "\u10EC\u10E3\u10D7\u10D8"
    },
    hours: {
        uk: "\u0433\u043E\u0434\u0438\u043D",
        en: "hours",
        hy: "\u056A\u0561\u0574",
        ka: "\u10E1\u10D0\u10D0\u10D7\u10D8"
    },
    days: {
        uk: "\u0434\u043D\u0456\u0432",
        en: "days",
        hy: "\u0585\u0580",
        ka: "\u10D3\u10E6\u10D4"
    },
    months: {
        uk: "\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
        en: "months",
        hy: "\u0561\u0574\u056B\u057D",
        ka: "\u10D7\u10D5\u10D4"
    },
    years: {
        uk: "\u0440\u043E\u043A\u0456\u0432",
        en: "years",
        hy: "\u057F\u0561\u0580\u056B",
        ka: "\u10EC\u10D4\u10DA\u10D8"
    },
    status_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    progress_label: {
        uk: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441, %",
        en: "Progress, %",
        hy: "\u0531\u057C\u0561\u057B\u0568\u0576\u0569\u0561\u0581, %",
        ka: "\u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8, %"
    },
    approved_label_popup: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    pending_label_popup: {
        uk: "\u041D\u0430 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u0456",
        en: "Pending",
        hy: "\u054D\u057A\u0561\u057D\u0574\u0561\u0576 \u0574\u0565\u057B",
        ka: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8"
    },
    rejected_label_popup: {
        uk: "\u041D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0456",
        en: "Not executed",
        hy: "\u0549\u056F\u0561\u057F\u0561\u0580\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10E3\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8"
    },
    approved_single_visit_name: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    no_approved_single_visit_name: {
        uk: "\u041D\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Not approved",
        hy: "\u0549\u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10E3\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D4\u10DA\u10D8"
    },
    on_verification_single_visit_name: {
        uk: "\u041D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456",
        en: "On verification",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0583\u0578\u0582\u056C\u0578\u0582\u0574",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10E8\u10D8"
    },
    back_to_btn_label: {
        uk: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E \u0432\u0456\u0437\u0438\u0442\u0456\u0432",
        en: "Back to visits",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C \u0561\u0575\u0581\u0565\u0580\u056B\u0576",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D6\u10D4"
    },
    orders_tab_name: {
        uk: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Orders",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D4\u10D1\u10D8"
    },
    returns_tab_name: {
        uk: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Returns",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    payments_tab_name: {
        uk: "\u041F\u043B\u0430\u0442\u0435\u0436\u0456",
        en: "Payments",
        hy: "\u054E\u0573\u0561\u0580\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8"
    },
    zvit_tab_name: {
        uk: "\u0417\u0432\u0456\u0442\u0438",
        en: "Reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    task_tab_name: {
        uk: "\u0417\u0430\u0434\u0430\u0447\u0456",
        en: "Tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    monitoring_tab_name: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433",
        en: "Monitoring",
        hy: "\u0544\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    log_tab_name: {
        uk: "\u0416\u0443\u0440\u043D\u0430\u043B \u043F\u043E\u0434\u0456\u0439",
        en: "Event log",
        hy: "\u053B\u0580\u0561\u0564\u0561\u0580\u0571\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u056B \u0574\u0561\u057F\u0575\u0561\u0576",
        ka: "\u10D8\u10D5\u10D4\u10DC\u10D7\u10D4\u10D1\u10D8\u10E1 \u10DF\u10E3\u10E0\u10DC\u10D0\u10DA\u10D8"
    },
    surveys_tab_name: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    surveys_summary_surveys_label: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    surveys_summary_answers_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    surveys_summary_photos_label: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photos",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8"
    },
    surveys_tab_products: {
        uk: "\u0422\u043E\u0432\u0430\u0440\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    surveys_tab_brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    surveys_tab_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    surveys_tab_other: {
        uk: "\u0406\u043D\u0448\u0435",
        en: "Other",
        hy: "\u0531\u0575\u056C",
        ka: "\u10E1\u10EE\u10D5\u10D0"
    },
    surveys_answer_type_bool: {
        uk: "\u0422\u0430\u043A/\u041D\u0456",
        en: "Bool",
        hy: "\u0531\u0575\u0578/\u0548\u0579",
        ka: "\u10D3\u10D8\u10D0\u10EE/\u10D0\u10E0\u10D0"
    },
    surveys_answer_type_numeric: {
        uk: "\u0427\u0438\u0441\u043B\u043E",
        en: "Numeric",
        hy: "\u0539\u057E\u0561\u0575\u056B\u0576",
        ka: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7\u10D8"
    },
    surveys_answer_type_dropdown: {
        uk: "\u0421\u043F\u0438\u0441\u043E\u043A",
        en: "Dropdown",
        hy: "\u0551\u0561\u0576\u056F",
        ka: "\u10E1\u10D8\u10D0"
    },
    surveys_answer_type_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442",
        en: "Text",
        hy: "\u054F\u0565\u0584\u057D\u057F",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    surveys_answer_type_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    surveys_answer_type_photo: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    surveys_answer_bool_yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    surveys_answer_bool_no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    surveys_photo_label: {
        uk: "\u0444\u043E\u0442\u043E",
        en: "photos",
        hy: "\u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    surveys_empty_products: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0438\u0442\u0430\u043D\u044C \u043F\u043E \u0442\u043E\u0432\u0430\u0440\u0430\u0445",
        en: "No product questions",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0575\u0561\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_empty_brands: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0438\u0442\u0430\u043D\u044C \u043F\u043E \u0431\u0440\u0435\u043D\u0434\u0430\u0445",
        en: "No brand questions",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0575\u0561\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_empty_categories: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0438\u0442\u0430\u043D\u044C \u043F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u0445",
        en: "No category questions",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0575\u0561\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_empty_other: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0456\u043D\u0448\u0438\u0445 \u043F\u0438\u0442\u0430\u043D\u044C",
        en: "No other questions",
        hy: "\u0531\u0575\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10E1\u10EE\u10D5\u10D0 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_modal_close: {
        uk: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
        en: "Close",
        hy: "\u0553\u0561\u056F\u0565\u056C",
        ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    surveys_search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u2026",
        en: "Search survey\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u2026",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    surveys_reset_btn: {
        uk: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438",
        en: "Reset",
        hy: "\u0536\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    surveys_entity_search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A\u2026",
        en: "Search\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C\u2026",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    surveys_no_results: {
        uk: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C",
        en: "No results found",
        hy: "\u0531\u0580\u0564\u0575\u0578\u0582\u0576\u0584\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    surveys_show_more: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0449\u0435",
        en: "Show more",
        hy: "\u0551\u0578\u0582\u0575\u0581 \u057F\u0561\u056C \u0561\u057E\u0565\u056C\u056B\u0576",
        ka: "\u10DB\u10D4\u10E2\u10D8\u10E1 \u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    task_has_empty_error: {
        uk: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u0438\u043D \u0456\u0442\u0435\u043C",
        en: "Please select at least one item",
        hy: "\u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0561\u057C\u0576\u057E\u0561\u0566\u0576 \u0574\u0565\u056F \u0574\u056B\u0561\u057E\u0578\u0580",
        ka: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10D0\u10D8\u10E0\u10E9\u10D8\u10DD\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB \u10D4\u10E0\u10D7\u10D8 \u10D4\u10E0\u10D7\u10D4\u10E3\u10DA\u10D8"
    },
    task_has_answer_error: {
        uk: "\u0417\u0430\u0434\u0430\u0447\u0430 \u043D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "The task has no answer",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u0579\u0578\u0582\u0576\u056B",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1"
    },
    approv_task_product_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
        en: "To approve the product",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C \u0561\u057A\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_task_product_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
        en: "Reject the product",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C \u0561\u057A\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    approv_task_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0437\u0430\u0434\u0430\u0447\u0443",
        en: "To approve the task",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_task_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0437\u0430\u0434\u0430\u0447\u0443",
        en: "Reject the task",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    approv_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        en: "To approve",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    task_tab_type_label: {
        uk: "\u0422\u0438\u043F",
        en: "Type",
        hy: "\u054F\u0565\u057D\u0561\u056F",
        ka: "\u10E2\u10D8\u10DE\u10D8"
    },
    task_tab_task_name_label: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0437\u0430\u0434\u0430\u0447\u0456",
        en: "Name of the task",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    task_tab_info_label: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    task_tab_deadline_label: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u054E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10D3\u10D4\u10D3\u10DA\u10D0\u10D8\u10DC\u10D8"
    },
    task_tab_createdby_label: {
        uk: "\u041A\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    task_tab_count_photo_label: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0444\u043E\u0442\u043E",
        en: "Number of photos",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    task_tab_status_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    task_tab_answer_status_yes_label: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    task_tab_answer_status_no_label: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    task_tab_answer_status_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    task_tab_answer_comment_label: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment ",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    task_tab_answer_tags_label: {
        uk: "\u0422\u0435\u0433\u0438",
        en: "Tags ",
        hy: "\u0539\u0565\u0563\u0565\u0580",
        ka: "\u10D7\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    approve_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Visit approved",
        hy: "\u0531\u0575\u0581\u0568 \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    already_approve_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0432\u0436\u0435 \u0431\u0443\u043B\u043E \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Visit already approved",
        hy: "\u0531\u0575\u0581\u0576 \u0561\u0580\u0564\u0565\u0576 \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10E3\u10D9\u10D5\u10D4 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    reject_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Visit rejected",
        hy: "\u0531\u0575\u0581\u0568 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8\u10D0"
    },
    already_reject_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0432\u0436\u0435 \u0431\u0443\u043B\u043E \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Visit already rejected",
        hy: "\u0531\u0575\u0581\u0576 \u0561\u0580\u0564\u0565\u0576 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10E3\u10D9\u10D5\u10D4 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8\u10D0"
    },
    monitoring_tab_pname_label: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    monitoring_tab_pcode_label: {
        uk: "\u041A\u043E\u0434 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
        en: "Product code",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u056B \u056F\u0578\u0564",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D8"
    },
    monitoring_tab_price_label: {
        uk: "\u0426\u0456\u043D\u0430",
        en: "Price",
        hy: "\u0533\u056B\u0576",
        ka: "\u10E4\u10D0\u10E1\u10D8"
    },
    monitoring_tab_sale_price_label: {
        uk: "\u0426\u0456\u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
        en: "Sale Price",
        hy: "\u054E\u0561\u0573\u0561\u057C\u0584\u056B \u0563\u056B\u0576",
        ka: "\u10D2\u10D0\u10E7\u10D8\u10D3\u10D5\u10D8\u10E1 \u10E4\u10D0\u10E1\u10D8"
    },
    monitoring_tab_photo_label: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo URL",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u056B \u0570\u0572\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 URL"
    },
    monitoring_tab_comment_label: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    monitoring_tab_event_monitoring_label: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433",
        en: "Monitoring",
        hy: "\u0544\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    monitoring_tab_event_photos_in_answers_label: {
        uk: "\u0424\u043E\u0442\u043E \u0443 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044F\u0445",
        en: "Photos in answers",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10E8\u10D8"
    },
    monitoring_tab_event_photos_in_reports_label: {
        uk: "\u0424\u043E\u0442\u043E \u0443 \u0437\u0432\u0456\u0442\u0430\u0445",
        en: "Photos in reports",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580 \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10E8\u10D8"
    },
    monitoring_tab_event_reports_done_label: {
        uk: "\u0417\u0432\u0456\u0442\u0456\u0432 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
        en: "Reports done",
        hy: "\u053F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_tasks_done_label: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u044C \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
        en: "Tasks done",
        hy: "\u053F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_tasks_not_done_label: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u044C \u043D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
        en: "Tasks not done",
        hy: "\u0549\u056F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E3\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_answers_not_supervised_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439 \u043D\u0435 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
        en: "Answers not supervised",
        hy: "\u0549\u057E\u0565\u0580\u057D\u057F\u0578\u0582\u0563\u057E\u0561\u056E \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E3\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_answers_supervised_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
        en: "Answers supervised",
        hy: "\u054E\u0565\u0580\u057D\u057F\u0578\u0582\u0563\u057E\u0561\u056E \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    monitoring_tab_selected_label: {
        uk: "\u041E\u0431\u0440\u0430\u043D\u043E",
        en: "Selected",
        hy: "\u0538\u0576\u057F\u0580\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8"
    },
    orders_product_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order Name",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    orders_product_status_changed: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u043C\u0456\u043D\u0435\u043D\u043E",
        en: "Status changed ",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u0568 \u0583\u0578\u056D\u057E\u0565\u056C \u0567",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8 \u10E8\u10D4\u10D8\u10EA\u10D5\u10D0\u10DA\u10D0"
    },
    orders_product_status_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    orders_product_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status ",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    orders_product_total: {
        uk: "\u0412\u0441\u044C\u043E\u0433\u043E",
        en: "Total ",
        hy: "\u0538\u0576\u0564\u0561\u0574\u0565\u0576\u0568",
        ka: "\u10EF\u10D0\u10DB\u10D8"
    },
    orders_currency_total: {
        uk: "\u0433\u0440\u043D.",
        en: "grn.",
        hy: "\u0563\u0580\u0576.",
        ka: "\u10D2\u10E0\u10DC."
    },
    orders_popup_order_id_title: {
        uk: "ID \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order ID",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B ID",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 ID"
    },
    orders_popup_details_title: {
        uk: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order details",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u0574\u0561\u0576\u0580\u0561\u0574\u0561\u057D\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8"
    },
    orders_popup_sales_rep_label: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0438\u0439 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A",
        en: "Sales Rep",
        hy: "\u054E\u0561\u0573\u0561\u057C\u0584\u056B \u0576\u0565\u0580\u056F\u0561\u0575\u0561\u0581\u0578\u0582\u0581\u056B\u0579",
        ka: "\u10D2\u10D0\u10E7\u10D8\u10D3\u10D5\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E0\u10DB\u10DD\u10DB\u10D0\u10D3\u10D2\u10D4\u10DC\u10D4\u10DA\u10D8"
    },
    orders_popup_order_status_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order Status",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    orders_popup_counterparty_label: {
        uk: "\u041A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442",
        en: "Counterparty",
        hy: "\u053F\u0578\u0576\u057F\u0580\u0561\u0563\u0565\u0576\u057F",
        ka: "\u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10D2\u10D4\u10DC\u10E2\u10D8"
    },
    orders_popup_order_type_label: {
        uk: "\u0422\u0438\u043F \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order Type",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    orders_popup_order_table_label: {
        uk: "\u0422\u0430\u0431\u043B\u0438\u0446\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432",
        en: "Products Table",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0561\u0572\u0575\u0578\u0582\u057D\u0561\u056F",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1 \u10EA\u10EE\u10E0\u10D8\u10DA\u10D8"
    },
    orders_popup_order_table_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    orders_popup_order_table_quantity: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
        en: "Quantity",
        hy: "\u0554\u0561\u0576\u0561\u056F",
        ka: "\u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    orders_popup_order_table_amount: {
        uk: "\u0421\u0443\u043C\u0430",
        en: "Amount",
        hy: "\u0533\u0578\u0582\u0574\u0561\u0580",
        ka: "\u10D7\u10D0\u10DC\u10EE\u10D0"
    },
    orders_popup_created_time_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        en: "Created Date & Time",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0587 \u056A\u0561\u0574",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0 \u10D3\u10E0\u10DD"
    },
    orders_popup_delivery_time_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
        en: "Delivery Date",
        hy: "\u0531\u057C\u0561\u0584\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    orders_popup_tracked_geolocation_label: {
        uk: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u0430 \u0433\u0435\u043E\u043B\u043E\u043A\u0430\u0446\u0456\u044F",
        en: "Tracked Geolocation",
        hy: "\u0540\u0565\u057F\u0561\u0563\u056E\u057E\u0561\u056E \u0561\u0577\u056D\u0561\u0580\u0570\u0561\u0563\u0580\u0561\u056F\u0561\u0576 \u0564\u056B\u0580\u0584",
        ka: "\u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8\u10E1 \u10D2\u10D4\u10DD\u10DA\u10DD\u10D9\u10D0\u10EA\u10D8\u10D0"
    },
    orders_popup_custom_fields_label: {
        uk: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0456 \u043F\u043E\u043B\u044F",
        en: "Custom Fields",
        hy: "\u0540\u0561\u057F\u0578\u0582\u056F \u0564\u0561\u0577\u057F\u0565\u0580",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D5\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    orders_popup_comment_label: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    orders_popup_visit_label: {
        uk: "\u0412\u0456\u0437\u0438\u0442",
        en: "Visit",
        hy: "\u0531\u0575\u0581",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    orders_physical_return_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0444\u0456\u0437\u0438\u0447\u043D\u043E\u0433\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Physical Return Date",
        hy: "\u0556\u056B\u0566\u056B\u056F\u0561\u056F\u0561\u0576 \u057E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10E4\u10D8\u10D6\u10D8\u10D9\u10E3\u10E0\u10D8 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    orders_status_return_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Return Status",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    orders_return_id_label: {
        uk: "ID \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Return ID",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u056B ID",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 ID"
    },
    orders_return_crated_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        en: "Created Date & Time",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0587 \u056A\u0561\u0574",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0 \u10D3\u10E0\u10DD"
    },
    orders_payment_id_label: {
        uk: "ID \u043E\u043F\u043B\u0430\u0442\u0438",
        en: "Payment ID",
        hy: "\u054E\u0573\u0561\u0580\u0574\u0561\u0576 ID",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 ID"
    },
    orders_payment_amount_label: {
        uk: "\u0421\u0443\u043C\u0430",
        en: "Amount",
        hy: "\u0533\u0578\u0582\u0574\u0561\u0580",
        ka: "\u10D7\u10D0\u10DC\u10EE\u10D0"
    },
    orders_payment_debt_label: {
        uk: "\u0411\u043E\u0440\u0433",
        en: "Debt",
        hy: "\u054A\u0561\u0580\u057F\u0584",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$ac552071080927b0 = {
    // section + generic
    section_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    new_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438",
        en: "New",
        hy: "\u0546\u0578\u0580",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8"
    },
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    delete_btn: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Delete",
        hy: "\u054B\u0576\u057B\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    back_btn: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    },
    edit_btn: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        en: "Edit",
        hy: "\u053D\u0574\u0562\u0561\u0563\u0580\u0565\u056C",
        ka: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    view_btn: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        en: "View",
        hy: "\u0534\u056B\u057F\u0565\u056C",
        ka: "\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A",
        en: "Search",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    confirm_delete: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u0437\u0430\u043F\u0438\u0441?",
        en: "Delete this record?",
        hy: "\u054B\u0576\u057B\u0565\u056C \u0561\u0575\u057D \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568?",
        ka: "\u10EC\u10D0\u10D5\u10E8\u10D0\u10DA\u10DD \u10D4\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8?"
    },
    saved: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "Saved",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    save_error: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
        en: "Error while saving",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0574\u0561\u0576 \u057D\u056D\u0561\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0"
    },
    deleted: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Deleted",
        hy: "\u054B\u0576\u057B\u057E\u0561\u056E \u0567",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    empty: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445",
        en: "No data",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    required: {
        uk: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435 \u043F\u043E\u043B\u0435",
        en: "Required",
        hy: "\u054A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8"
    },
    // shared field labels
    f_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    f_code: {
        uk: "\u041A\u043E\u0434",
        en: "Code",
        hy: "\u053F\u0578\u0564",
        ka: "\u10D9\u10DD\u10D3\u10D8"
    },
    f_image: {
        uk: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Image",
        hy: "\u0546\u056F\u0561\u0580",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8"
    },
    f_logo: {
        uk: "\u041B\u043E\u0433\u043E\u0442\u0438\u043F",
        en: "Logo",
        hy: "\u053C\u0578\u0563\u0578",
        ka: "\u10DA\u10DD\u10D2\u10DD"
    },
    f_address: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u0430",
        en: "Address",
        hy: "\u0540\u0561\u057D\u0581\u0565",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8"
    },
    f_network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    f_category: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        en: "Category",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    f_country: {
        uk: "\u041A\u0440\u0430\u0457\u043D\u0430",
        en: "Country",
        hy: "\u0535\u0580\u056F\u056B\u0580",
        ka: "\u10E5\u10D5\u10D4\u10E7\u10D0\u10DC\u10D0"
    },
    f_county: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D",
        en: "County",
        hy: "\u0544\u0561\u0580\u0566",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    f_locality: {
        uk: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0439 \u043F\u0443\u043D\u043A\u0442",
        en: "Locality",
        hy: "\u0532\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10E3\u10DC\u10E5\u10E2\u10D8"
    },
    f_location: {
        uk: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438",
        en: "Coordinates",
        hy: "\u053F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8"
    },
    f_lat: {
        uk: "\u0428\u0438\u0440\u043E\u0442\u0430",
        en: "Latitude",
        hy: "\u053C\u0561\u0575\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D2\u10D0\u10DC\u10D4\u10D3\u10D8"
    },
    f_lng: {
        uk: "\u0414\u043E\u0432\u0433\u043E\u0442\u0430",
        en: "Longitude",
        hy: "\u0535\u0580\u056F\u0561\u0575\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D2\u10E0\u10EB\u10D4\u10D3\u10D8"
    },
    f_minutes: {
        uk: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0456 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
        en: "Recommended minutes",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0580\u056F\u057E\u0578\u0572 \u0580\u0578\u057A\u0565\u0576\u0565\u0580",
        ka: "\u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EC\u10E3\u10D7\u10D4\u10D1\u10D8"
    },
    f_merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    f_supervisors: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Supervisors",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    f_is_active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    f_available_tasks: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u043B\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        en: "Available for tasks",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    f_additional_info: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
        en: "Additional info",
        hy: "\u053C\u0580\u0561\u0581\u0578\u0582\u0581\u056B\u0579 \u057F\u0565\u0572\u0565\u056F\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0"
    },
    filter_created_by_me: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u043C\u043D\u043E\u044E",
        en: "Created by me",
        hy: "\u053B\u0574 \u057D\u057F\u0565\u0572\u056E\u0561\u056E",
        ka: "\u10E9\u10D4\u10DB \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8"
    },
    kv_key: {
        uk: "\u041C\u0456\u0442\u043A\u0430",
        en: "Label",
        hy: "\u054A\u056B\u057F\u0561\u056F",
        ka: "\u10D8\u10D0\u10E0\u10DA\u10D8\u10E7\u10D8"
    },
    kv_value: {
        uk: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
        en: "Value",
        hy: "\u0531\u0580\u056A\u0565\u0584",
        ka: "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"
    },
    kv_add: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u043B\u0435",
        en: "Add field",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0564\u0561\u0577\u057F",
        ka: "\u10D5\u10D4\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    f_price_monitoring: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0446\u0456\u043D",
        en: "Price monitoring",
        hy: "\u0533\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    f_pm_components: {
        uk: "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0438 \u043C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433\u0443",
        en: "Price monitoring components",
        hy: "\u0533\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563\u056B \u0562\u0561\u0572\u0561\u0564\u0580\u056B\u0579\u0576\u0565\u0580",
        ka: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8\u10E1 \u10D9\u10DD\u10DB\u10DE\u10DD\u10DC\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    f_pm_required: {
        uk: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0438",
        en: "Required components",
        hy: "\u054A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0562\u0561\u0572\u0561\u0564\u0580\u056B\u0579\u0576\u0565\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10DD\u10DB\u10DE\u10DD\u10DC\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    f_send_outforz: {
        uk: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0442\u0438 \u0432 Outforz",
        en: "Send to Outforz",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u0565\u056C Outforz",
        ka: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0 Outforz-\u10E8\u10D8"
    },
    f_auto_approve: {
        uk: "\u0410\u0432\u0442\u043E\u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0456\u0432",
        en: "Auto-approve reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u056B \u0561\u057E\u057F\u0578\u0570\u0561\u057D\u057F\u0561\u057F\u0578\u0582\u0574",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    f_status_outforz: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0434\u043B\u044F Outforz",
        en: "Status to send to Outforz",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F Outforz-\u056B\u0576 \u0578\u0582\u0572\u0561\u0580\u056F\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8 Outforz-\u10E8\u10D8 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0\u10D3"
    },
    f_default_tags: {
        uk: "\u0422\u0435\u0433\u0438 \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
        en: "Default tags",
        hy: "\u053F\u0561\u0576\u056D\u0561\u0564\u0580\u057E\u0561\u056E \u0569\u0565\u0563\u0565\u0580",
        ka: "\u10DC\u10D0\u10D2\u10E3\u10DA\u10D8\u10E1\u10EE\u10DB\u10D4\u10D5\u10D8 \u10E2\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    f_created_by: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0438\u0432",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0578\u0572",
        ka: "\u10E8\u10D4\u10DB\u10E5\u10DB\u10DC\u10D4\u10DA\u10D8"
    },
    f_available_supervisors: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0430\u043C",
        en: "Available for supervisors",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B\u0576",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    f_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    // per-entity title keys
    networks_title: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    countries_title: {
        uk: "\u041A\u0440\u0430\u0457\u043D\u0438",
        en: "Countries",
        hy: "\u0535\u0580\u056F\u0580\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D8"
    },
    counties_title: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438",
        en: "Counties",
        hy: "\u0544\u0561\u0580\u0566\u0565\u0580",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8"
    },
    localities_title: {
        uk: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0456 \u043F\u0443\u043D\u043A\u0442\u0438",
        en: "Localities",
        hy: "\u0532\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0565\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10E3\u10DC\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    categories_title: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u0442\u043E\u0447\u043E\u043A",
        en: "Point categories",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    points_title: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    point_groups_title: {
        uk: "\u0413\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A",
        en: "Point groups",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    // status pill
    active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    inactive: {
        uk: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Inactive",
        hy: "\u0548\u0579 \u0561\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    f_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    activate_btn: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Activate",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10D0"
    },
    deactivate_btn: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Deactivate",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0"
    },
    confirm_deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0437\u0430\u043F\u0438\u0441?",
        en: "Deactivate this record?",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C \u0561\u0575\u057D \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568?",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D0\u10DB \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1?"
    },
    // form sections
    sec_basic: {
        uk: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
        en: "Basic info",
        hy: "\u0540\u056B\u0574\u0576\u0561\u056F\u0561\u0576 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10EB\u10D8\u10E0\u10D8\u10D7\u10D0\u10D3\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0"
    },
    sec_location: {
        uk: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Location",
        hy: "\u054F\u0565\u0572\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0"
    },
    sec_assignment: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0456",
        en: "Assignment",
        hy: "\u0540\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D3\u10D0\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0"
    },
    sec_options: {
        uk: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438",
        en: "Options",
        hy: "\u0538\u0576\u057F\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8"
    },
    // location picker
    search_address: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0430\u0434\u0440\u0435\u0441\u0438",
        en: "Search address",
        hy: "\u0540\u0561\u057D\u0581\u0565\u056B \u0578\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    search_btn: {
        uk: "\u0417\u043D\u0430\u0439\u0442\u0438",
        en: "Search",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    searching: {
        uk: "\u041F\u043E\u0448\u0443\u043A\u2026",
        en: "Searching\u2026",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574\u2026",
        ka: "\u10D8\u10EB\u10D4\u10D1\u10DC\u10D4\u10D1\u10D0\u2026"
    },
    not_found: {
        uk: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Not found",
        hy: "\u0549\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    remove_image: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    crop_confirm: {
        uk: "\u041E\u0431\u0440\u0456\u0437\u0430\u0442\u0438",
        en: "Crop",
        hy: "\u053F\u057F\u0580\u0565\u056C",
        ka: "\u10DB\u10DD\u10ED\u10E0\u10D0"
    },
    crop_cancel: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    // personnel management
    merchandisers_title: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Merchandisers",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    supervisors_title: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Supervisors",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    f_phone: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    f_movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10D0"
    },
    f_first_name: {
        uk: "\u0406\u043C'\u044F",
        en: "First name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    f_last_name: {
        uk: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
        en: "Last name",
        hy: "\u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
        ka: "\u10D2\u10D5\u10D0\u10E0\u10D8"
    },
    // surveys
    surveys_title: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    sec_schedule: {
        uk: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434",
        en: "Schedule",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0581\u0578\u0582\u0575\u0581",
        ka: "\u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8"
    },
    sec_audience: {
        uk: "\u0410\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u044F",
        en: "Audience",
        hy: "\u053C\u057D\u0561\u0580\u0561\u0576",
        ka: "\u10D0\u10E3\u10D3\u10D8\u10E2\u10DD\u10E0\u10D8\u10D0"
    },
    sec_questions: {
        uk: "\u041F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Questions",
        hy: "\u0540\u0561\u0580\u0581\u0565\u0580",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    sec_targeting: {
        uk: "\u0422\u0430\u0440\u0433\u0435\u0442\u0438\u043D\u0433 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
        en: "Targeting (optional)",
        hy: "\u0539\u056B\u0580\u0561\u056D\u0561\u057E\u0578\u0580\u0578\u0582\u0574 (\u0578\u0579 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580)",
        ka: "\u10D7\u10D0\u10E0\u10D2\u10D4\u10D7\u10D8\u10E0\u10D4\u10D1\u10D0 (\u10D0\u10E0\u10D0\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD)"
    },
    no_dropdown_options: {
        uk: "\u0412\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u0449\u0435 \u043D\u0435 \u0434\u043E\u0434\u0430\u043D\u0456",
        en: "No options yet",
        hy: "\u054F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0576\u0565\u0580 \u0564\u0565\u057C \u0579\u056F\u0561\u0576",
        ka: "\u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D4\u10D1\u10D8 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    f_title: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Title",
        hy: "\u054E\u0565\u0580\u0576\u0561\u0563\u056B\u0580",
        ka: "\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    f_description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    f_active_from: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u0437",
        en: "Active from",
        hy: "\u0531\u056F\u057F\u056B\u057E \u0567 \u057D\u056F\u057D\u0561\u056E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8\u10D0 \u10D3\u10D0\u10DC"
    },
    f_active_to: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u0434\u043E",
        en: "Active to",
        hy: "\u0531\u056F\u057F\u056B\u057E \u0567 \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8\u10D0 \u10DB\u10D3\u10D4"
    },
    f_form_organization_mode: {
        uk: "\u0420\u0435\u0436\u0438\u043C \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0457 \u0444\u043E\u0440\u043C\u0438",
        en: "Form organization mode",
        hy: "\u0541\u0587\u056B \u056F\u0561\u0566\u0574\u0561\u056F\u0565\u0580\u057A\u0574\u0561\u0576 \u057C\u0565\u056A\u056B\u0574",
        ka: "\u10E4\u10DD\u10E0\u10DB\u10D8\u10E1 \u10DD\u10E0\u10D2\u10D0\u10DC\u10D8\u10D6\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D4\u10DF\u10D8\u10DB\u10D8"
    },
    f_audience: {
        uk: "\u0410\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u044F",
        en: "Audience",
        hy: "\u053C\u057D\u0561\u0580\u0561\u0576",
        ka: "\u10D0\u10E3\u10D3\u10D8\u10E2\u10DD\u10E0\u10D8\u10D0"
    },
    f_questions: {
        uk: "\u041F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Questions",
        hy: "\u0540\u0561\u0580\u0581\u0565\u0580",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    audience_target_type: {
        uk: "\u0422\u0438\u043F \u0430\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u0457",
        en: "Target type",
        hy: "\u0539\u056B\u0580\u0561\u056D\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10E1\u10D0\u10DB\u10D8\u10D6\u10DC\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    target_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    target_point_groups: {
        uk: "\u0413\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A",
        en: "Point groups",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    target_networks: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    mode_products: {
        uk: "\u0422\u043E\u0432\u0430\u0440\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    mode_brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    mode_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    mode_subcategories: {
        uk: "\u041F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Subcategories",
        hy: "\u0535\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    question_add_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Add question",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0570\u0561\u0580\u0581",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    question_remove_btn: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Remove question",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0570\u0561\u0580\u0581\u0568",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    f_question_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442 \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Question text",
        hy: "\u0540\u0561\u0580\u0581\u056B \u057F\u0565\u0584\u057D\u057F",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    f_answer_type: {
        uk: "\u0422\u0438\u043F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answer type",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    answer_numeric: {
        uk: "\u0427\u0438\u0441\u043B\u043E\u0432\u0435",
        en: "Numeric",
        hy: "\u0539\u057E\u0561\u0575\u056B\u0576",
        ka: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7\u10D8"
    },
    answer_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u0435",
        en: "Text",
        hy: "\u054F\u0565\u0584\u057D\u057F\u0561\u0575\u056B\u0576",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10E3\u10E0\u10D8"
    },
    answer_photo: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    answer_dropdown: {
        uk: "\u0421\u043F\u0438\u0441\u043E\u043A",
        en: "Dropdown",
        hy: "\u0551\u0561\u0576\u056F",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E1\u10D0\u10E8\u10DA\u10D4\u10DA\u10D8"
    },
    answer_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    answer_boolean: {
        uk: "\u0422\u0430\u043A/\u041D\u0456",
        en: "Boolean",
        hy: "\u0531\u0575\u0578/\u0548\u0579",
        ka: "\u10D3\u10D8\u10D0\u10EE/\u10D0\u10E0\u10D0"
    },
    f_required: {
        uk: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
        en: "Required",
        hy: "\u054A\u0561\u0580\u057F\u0561\u0564\u056B\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD"
    },
    f_priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    priority_low: {
        uk: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
        en: "Low",
        hy: "\u0551\u0561\u056E\u0580",
        ka: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8"
    },
    priority_medium: {
        uk: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
        en: "Medium",
        hy: "\u0544\u056B\u057B\u056B\u0576",
        ka: "\u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD"
    },
    priority_high: {
        uk: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
        en: "High",
        hy: "\u0532\u0561\u0580\u0571\u0580",
        ka: "\u10DB\u10D0\u10E6\u10D0\u10DA\u10D8"
    },
    f_question_mode: {
        uk: "\u0420\u0435\u0436\u0438\u043C \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Question mode",
        hy: "\u0540\u0561\u0580\u0581\u056B \u057C\u0565\u056A\u056B\u0574",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10E0\u10D4\u10DF\u10D8\u10DB\u10D8"
    },
    f_products_source: {
        uk: "\u0414\u0436\u0435\u0440\u0435\u043B\u043E \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
        en: "Products source",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0561\u0572\u0562\u0575\u0578\u0582\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1 \u10EC\u10E7\u10D0\u10E0\u10DD"
    },
    source_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    source_assortment_matrix: {
        uk: "\u0410\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u044F",
        en: "Assortment matrix",
        hy: "\u054F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0561",
        ka: "\u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0"
    },
    f_all_products: {
        uk: "\u0423\u0441\u0456 \u0442\u043E\u0432\u0430\u0440\u0438",
        en: "All products",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0561\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8"
    },
    f_all_brands: {
        uk: "\u0423\u0441\u0456 \u0431\u0440\u0435\u043D\u0434\u0438",
        en: "All brands",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0562\u0580\u0565\u0576\u0564\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10D1\u10E0\u10D4\u10DC\u10D3\u10D8"
    },
    f_all_categories: {
        uk: "\u0423\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "All categories",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    f_all_subcategories: {
        uk: "\u0423\u0441\u0456 \u043F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "All subcategories",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0565\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    f_products: {
        uk: "\u0422\u043E\u0432\u0430\u0440\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    f_brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    f_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    f_subcategories: {
        uk: "\u041F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Subcategories",
        hy: "\u0535\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    f_dropdown_options: {
        uk: "\u0412\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Dropdown options",
        hy: "\u0551\u0561\u0576\u056F\u056B \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0576\u0565\u0580",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E1\u10D0\u10E8\u10DA\u10D4\u10DA\u10D8 \u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    option_add_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0430\u0440\u0456\u0430\u043D\u0442",
        en: "Add option",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F",
        ka: "\u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    option_label_ph: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Label",
        hy: "\u054A\u056B\u057F\u0561\u056F",
        ka: "\u10DA\u10D4\u10D8\u10D1\u10DA\u10D8"
    },
    option_value_ph: {
        uk: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
        en: "Value",
        hy: "\u0531\u0580\u056A\u0565\u0584",
        ka: "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"
    },
    no_questions: {
        uk: "\u041F\u0438\u0442\u0430\u043D\u043D\u044F \u0449\u0435 \u043D\u0435 \u0434\u043E\u0434\u0430\u043D\u0456",
        en: "No questions yet",
        hy: "\u0540\u0561\u0580\u0581\u0565\u0580 \u0564\u0565\u057C \u0579\u056F\u0561\u0576",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    }
};
const $fc3f36407bc5ec6c$export$9cbb0f231a0ab7ea = {
    title: {
        uk: "\u041E\u0433\u043B\u044F\u0434",
        en: "Overview",
        hy: "\u0531\u056F\u0576\u0561\u0580\u056F",
        ka: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0"
    },
    active_merchandisers: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Active merchandisers",
        hy: "\u0531\u056F\u057F\u056B\u057E \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    active_supervisors: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Active supervisors",
        hy: "\u0531\u056F\u057F\u056B\u057E \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    visits: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    reports: {
        uk: "\u0417\u0432\u0456\u0442\u0438",
        en: "Reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    trend_title: {
        uk: "\u0414\u0438\u043D\u0430\u043C\u0456\u043A\u0430 \u0437\u0430 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Monthly activity",
        hy: "\u0531\u0574\u057D\u0561\u056F\u0561\u0576 \u0561\u056F\u057F\u056B\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D7\u10D5\u10D8\u10E3\u10E0\u10D8 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D0"
    },
    top_merchandisers: {
        uk: "\u0422\u043E\u043F \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Top merchandisers",
        hy: "\u053C\u0561\u057E\u0561\u0563\u0578\u0582\u0575\u0576 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E2\u10DD\u10DE \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    by_merchandiser: {
        uk: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430\u043C\u0438",
        en: "Statistics by merchandiser",
        hy: "\u054E\u056B\u0573\u0561\u056F\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0568\u057D\u057F \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u056B",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10D8\u10E1\u10E2\u10D8\u10D9\u10D0 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7"
    },
    search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430\u2026",
        en: "Search merchandiser\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u2026",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    col_merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    col_visits: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    col_reports: {
        uk: "\u0417\u0432\u0456\u0442\u0438",
        en: "Reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    col_answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    loading: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
        en: "Loading\u2026",
        hy: "\u0532\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0567\u2026",
        ka: "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0\u2026"
    },
    empty: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445",
        en: "No data",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443.",
        en: "Failed to load statistics.",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u057E\u056B\u0573\u0561\u056F\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568:",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10D8\u10E1\u10E2\u10D8\u10D9\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0."
    },
    retry: {
        uk: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    }
};



const $cca4416321e611bf$export$596d806903d1f59e = (user)=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGIN,
            body: user
        });
const $cca4416321e611bf$export$6503ec6e8aabbaf = (user)=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).REGISTER,
            body: user
        });
const $cca4416321e611bf$export$a0973bcfe11b05c9 = ()=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGOUT
        });
const $cca4416321e611bf$export$953a134f6e0e87ac = (user)=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).UPDATE_ME,
            body: user
        });
const $cca4416321e611bf$export$d81a4a2300dc817f = (template)=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).SET_DEFAULT_TEMPLATE,
            body: template
        });


const $daf81e188ce7b288$var$MENU = [
    {
        type: "section",
        label: {
            uk: "\u041E\u0433\u043B\u044F\u0434",
            en: "Overview",
            hy: "\u0531\u056F\u0576\u0561\u0580\u056F",
            ka: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0"
        },
        role: [
            "all"
        ]
    },
    {
        name: "overview",
        path: "/overview",
        icon: "dashboard",
        role: [
            "all"
        ]
    },
    {
        type: "section",
        label: {
            uk: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
            en: "Main",
            hy: "\u0540\u056B\u0574\u0576\u0561\u056F\u0561\u0576",
            ka: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8"
        },
        role: [
            "all"
        ]
    },
    {
        name: "photo_report",
        path: "/photo-review",
        icon: "photo_camera",
        role: [
            "all"
        ]
    },
    {
        name: "visit",
        path: "/visit",
        icon: "location_on",
        role: [
            "all"
        ]
    },
    {
        name: "all_reports",
        path: "/bi-report",
        icon: "bar_chart",
        role: [
            "all"
        ]
    },
    {
        type: "section",
        label: {
            uk: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F",
            en: "Management",
            hy: "\u053F\u0561\u057C\u0561\u057E\u0561\u0580\u0578\u0582\u0574",
            ka: "\u10DB\u10D0\u10E0\u10D7\u10D5\u10D0"
        },
        role: [
            "all"
        ]
    },
    {
        name: "tasks",
        path: "/task",
        icon: "task",
        role: [
            "all"
        ]
    },
    {
        name: "answers",
        path: "/task-review",
        icon: "quiz",
        role: [
            "all"
        ]
    },
    {
        name: "my_uploads",
        path: "/tasks-import/3",
        icon: "upload",
        role: [
            "supervisor_manager"
        ]
    },
    {
        name: "task_uploading",
        path: "/tasks-import",
        icon: "cloud_upload",
        role: [
            "supervisor_manager"
        ]
    },
    {
        type: "section",
        label: {
            uk: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u043E\u043C",
            en: "Personnel management",
            hy: "\u0531\u0576\u0571\u0576\u0561\u056F\u0561\u0566\u0574\u056B \u056F\u0561\u057C\u0561\u057E\u0561\u0580\u0578\u0582\u0574",
            ka: "\u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0"
        },
        role: [
            "all"
        ]
    },
    {
        name: "merchandiser",
        path: "/merchandiser",
        icon: "badge",
        role: [
            "all"
        ]
    },
    {
        name: "supervisors",
        path: "/supervisors",
        icon: "supervisor_account",
        role: [
            "supervisor_manager"
        ]
    },
    {
        type: "section",
        label: {
            uk: "\u0414\u0430\u043D\u0456",
            en: "Data",
            hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580",
            ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8"
        },
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "documents",
        path: "/document",
        icon: "description",
        role: [
            "all"
        ]
    },
    {
        type: "section",
        label: {
            uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
            en: "Surveys",
            hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
            ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
        },
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_surveys",
        path: "/surveys",
        icon: "checklist",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        type: "section",
        label: {
            uk: "\u0422\u043E\u0447\u043A\u0438",
            en: "Points",
            hy: "\u053F\u0565\u057F\u0565\u0580",
            ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
        },
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_points",
        path: "/points",
        icon: "pin_drop",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_networks",
        path: "/networks",
        icon: "hub",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_categories",
        path: "/categories",
        icon: "category",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_countries",
        path: "/countries",
        icon: "public",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_counties",
        path: "/counties",
        icon: "map",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_localities",
        path: "/localities",
        icon: "location_city",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_point_groups",
        path: "/point_groups",
        icon: "workspaces",
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    }
];
const $daf81e188ce7b288$var$hasRole = (itemRole, userRole)=>{
    if (Array.isArray(itemRole)) return itemRole.includes(userRole) || itemRole.includes("all");
    return itemRole === userRole || itemRole === "all";
};
class $daf81e188ce7b288$var$Aside extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            hide: localStorage.getItem("hiddenAside") === "1" || false
        };
        this.aside = null;
    }
    static contextType = (0, $422de08ffd33db6b$export$214e5fb64d34c1fc);
    componentDidMount() {
        window.addEventListener("resize", this.findHeight);
        this.findHeight();
        if (this.props.location.pathname === "/k-form") this.setState({
            hide: true
        });
        if (this.props.location.pathname === "/photo-review") this.setState({
            hide: true
        });
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.findHeight);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sidebar !== this.props.sidebar) this.setState({
            hide: this.props.sidebar
        });
        if (prevProps.location.pathname !== this.props.location.pathname && this.props.location.pathname === "/photo-review") this.setState({
            hide: this.props.location.pathname
        });
    }
    findHeight = ()=>{
        this.setState({
            windowH: window.innerHeight
        });
    };
    hide = ()=>{
        const { hide: hide } = this.state;
        this.setState({
            hide: !hide
        }, ()=>{
            localStorage.setItem("hiddenAside", hide ? "0" : "1");
            this.aside.style.display = "none";
            let elem = document.getElementsByClassName("modal-backdrop show")[0];
            if (elem) {
                document.body.className = document.body.className.replace("modal-open", "");
                elem.parentNode.removeChild(elem);
            }
        });
    };
    logout = ()=>this.props.dispatch((0, $cca4416321e611bf$export$a0973bcfe11b05c9)());
    getLabel = (name)=>{
        const { me: me } = this.props;
        if (!(0, $fc3f36407bc5ec6c$export$72266474e9355649)[name]) return name;
        return (0, $fc3f36407bc5ec6c$export$72266474e9355649)[name][me.language] || (0, $fc3f36407bc5ec6c$export$72266474e9355649)[name]["uk"] || name;
    };
    menuItem = (item)=>{
        const { me: me } = this.props;
        const { hide: hide } = this.state;
        if (item.type === "section") {
            if (!$daf81e188ce7b288$var$hasRole(item.role, me.role)) return null;
            const label = item.label[me.language] || item.label["en"] || item.label["uk"];
            // Rendered as a group splitter: a labelled header when expanded, a divider
            // line (label hidden via CSS) with a hover title when collapsed/folded.
            return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "md-nav-section",
                title: label,
                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "md-nav-section-label",
                    children: label
                })
            }, `section-${label}`);
        }
        if (!$daf81e188ce7b288$var$hasRole(item.role, me.role)) return null;
        const { name: name, path: path, icon: icon } = item;
        const label = this.getLabel(name);
        const isCurrent = this.props.location.pathname === path;
        const onClickFn = ()=>{
            if (window.innerWidth <= 922) this.hide();
            else if (hide) this.setState({
                hide: false
            });
        };
        return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
            to: path,
            onClick: onClickFn,
            title: label,
            className: `md-nav-item${isCurrent ? " md-nav-item-active" : ""}`,
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "md-nav-icon",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "md-nav-item-text",
                    children: label
                })
            ]
        }, `m-i-${name}`);
    };
    render() {
        const { hide: hide } = this.state;
        const { me: me } = this.props;
        if (!me) return null;
        const logoutLabel = (0, $fc3f36407bc5ec6c$export$72266474e9355649)["logout"][me.language] || (0, $fc3f36407bc5ec6c$export$72266474e9355649)["logout"]["uk"];
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            id: "aside",
            ref: (el)=>this.aside = el,
            className: `app-aside modal nav-dropdown ${hide ? "folded" : ""}`,
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "left md-nav-rail",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-nav-logo",
                        onClick: this.hide,
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ec66791105d99c56$exports))),
                            alt: "PicSell",
                            className: "md-nav-logo-img"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-nav-scroll",
                        children: $daf81e188ce7b288$var$MENU.map(this.menuItem)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-nav-bottom",
                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
                            className: "md-nav-item",
                            onClick: this.logout,
                            title: logoutLabel,
                            style: {
                                cursor: "pointer"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "md-nav-icon",
                                    children: "logout"
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "md-nav-item-text",
                                    children: logoutLabel
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
$daf81e188ce7b288$var$Aside = (0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me,
        sidebar: state.sidebar
    }))($daf81e188ce7b288$var$Aside);
var $daf81e188ce7b288$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)($daf81e188ce7b288$var$Aside);



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");




"use strict";
function $73106adb55132987$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $4dBQg = parcelRequire("4dBQg");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c2bf92a64ef6699d$var$toString } = Object.prototype;
const { getPrototypeOf: $c2bf92a64ef6699d$var$getPrototypeOf } = Object;
const { iterator: $c2bf92a64ef6699d$var$iterator, toStringTag: $c2bf92a64ef6699d$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c2bf92a64ef6699d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c2bf92a64ef6699d$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($c2bf92a64ef6699d$var$hasOwnProperty(obj, prop)) return true;
        obj = $c2bf92a64ef6699d$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c2bf92a64ef6699d$var$getSafeProp = (obj, prop)=>obj != null && $c2bf92a64ef6699d$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $c2bf92a64ef6699d$var$kindOf = ((cache)=>(thing)=>{
        const str = $c2bf92a64ef6699d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c2bf92a64ef6699d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c2bf92a64ef6699d$var$kindOf(thing) === type;
};
const $c2bf92a64ef6699d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c2bf92a64ef6699d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c2bf92a64ef6699d$var$isUndefined = $c2bf92a64ef6699d$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c2bf92a64ef6699d$var$isBuffer(val) {
    return val !== null && !$c2bf92a64ef6699d$var$isUndefined(val) && val.constructor !== null && !$c2bf92a64ef6699d$var$isUndefined(val.constructor) && $c2bf92a64ef6699d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c2bf92a64ef6699d$var$isArrayBuffer = $c2bf92a64ef6699d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c2bf92a64ef6699d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c2bf92a64ef6699d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c2bf92a64ef6699d$var$isString = $c2bf92a64ef6699d$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c2bf92a64ef6699d$var$isFunction = $c2bf92a64ef6699d$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c2bf92a64ef6699d$var$isNumber = $c2bf92a64ef6699d$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c2bf92a64ef6699d$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c2bf92a64ef6699d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c2bf92a64ef6699d$var$isPlainObject = (val)=>{
    if (!$c2bf92a64ef6699d$var$isObject(val)) return false;
    const prototype = $c2bf92a64ef6699d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c2bf92a64ef6699d$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$c2bf92a64ef6699d$var$hasOwnInPrototypeChain(val, $c2bf92a64ef6699d$var$toStringTag) && !$c2bf92a64ef6699d$var$hasOwnInPrototypeChain(val, $c2bf92a64ef6699d$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c2bf92a64ef6699d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c2bf92a64ef6699d$var$isObject(val) || $c2bf92a64ef6699d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c2bf92a64ef6699d$var$isDate = $c2bf92a64ef6699d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c2bf92a64ef6699d$var$isFile = $c2bf92a64ef6699d$var$kindOfTest("File");
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c2bf92a64ef6699d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== "undefined");
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c2bf92a64ef6699d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== "undefined";
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c2bf92a64ef6699d$var$isBlob = $c2bf92a64ef6699d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c2bf92a64ef6699d$var$isFileList = $c2bf92a64ef6699d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c2bf92a64ef6699d$var$isStream = (val)=>$c2bf92a64ef6699d$var$isObject(val) && $c2bf92a64ef6699d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c2bf92a64ef6699d$var$getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    return {};
}
const $c2bf92a64ef6699d$var$G = $c2bf92a64ef6699d$var$getGlobal();
const $c2bf92a64ef6699d$var$FormDataCtor = typeof $c2bf92a64ef6699d$var$G.FormData !== "undefined" ? $c2bf92a64ef6699d$var$G.FormData : undefined;
const $c2bf92a64ef6699d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c2bf92a64ef6699d$var$FormDataCtor && thing instanceof $c2bf92a64ef6699d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c2bf92a64ef6699d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c2bf92a64ef6699d$var$isFunction(thing.append)) return false;
    const kind = $c2bf92a64ef6699d$var$kindOf(thing);
    return kind === "formdata" || // detect form-data instance
    kind === "object" && $c2bf92a64ef6699d$var$isFunction(thing.toString) && thing.toString() === "[object FormData]";
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c2bf92a64ef6699d$var$isURLSearchParams = $c2bf92a64ef6699d$var$kindOfTest("URLSearchParams");
const [$c2bf92a64ef6699d$var$isReadableStream, $c2bf92a64ef6699d$var$isRequest, $c2bf92a64ef6699d$var$isResponse, $c2bf92a64ef6699d$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c2bf92a64ef6699d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c2bf92a64ef6699d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c2bf92a64ef6699d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c2bf92a64ef6699d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c2bf92a64ef6699d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c2bf92a64ef6699d$var$findKey(obj, key) {
    if ($c2bf92a64ef6699d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c2bf92a64ef6699d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c2bf92a64ef6699d$var$isContextDefined = (context)=>!$c2bf92a64ef6699d$var$isUndefined(context) && context !== $c2bf92a64ef6699d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c2bf92a64ef6699d$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c2bf92a64ef6699d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === "__proto__" || key === "constructor" || key === "prototype") return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === "string" && $c2bf92a64ef6699d$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c2bf92a64ef6699d$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c2bf92a64ef6699d$var$isPlainObject(existing) && $c2bf92a64ef6699d$var$isPlainObject(val)) result[targetKey] = $c2bf92a64ef6699d$var$merge(existing, val);
        else if ($c2bf92a64ef6699d$var$isPlainObject(val)) result[targetKey] = $c2bf92a64ef6699d$var$merge({}, val);
        else if ($c2bf92a64ef6699d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c2bf92a64ef6699d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c2bf92a64ef6699d$var$isBuffer(source)) continue;
        $c2bf92a64ef6699d$var$forEach(source, assignValue);
        if (typeof source !== "object" || $c2bf92a64ef6699d$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c2bf92a64ef6699d$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c2bf92a64ef6699d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c2bf92a64ef6699d$var$forEach(b, (val, key)=>{
        if (thisArg && $c2bf92a64ef6699d$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $73106adb55132987$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c2bf92a64ef6699d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c2bf92a64ef6699d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, "constructor", {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, "super", {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c2bf92a64ef6699d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c2bf92a64ef6699d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c2bf92a64ef6699d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c2bf92a64ef6699d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c2bf92a64ef6699d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c2bf92a64ef6699d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c2bf92a64ef6699d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c2bf92a64ef6699d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c2bf92a64ef6699d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c2bf92a64ef6699d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c2bf92a64ef6699d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c2bf92a64ef6699d$var$isHTMLForm = $c2bf92a64ef6699d$var$kindOfTest("HTMLFormElement");
const $c2bf92a64ef6699d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c2bf92a64ef6699d$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c2bf92a64ef6699d$var$isRegExp = $c2bf92a64ef6699d$var$kindOfTest("RegExp");
const $c2bf92a64ef6699d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c2bf92a64ef6699d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c2bf92a64ef6699d$var$freezeMethods = (obj)=>{
    $c2bf92a64ef6699d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c2bf92a64ef6699d$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c2bf92a64ef6699d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c2bf92a64ef6699d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c2bf92a64ef6699d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c2bf92a64ef6699d$var$noop = ()=>{};
const $c2bf92a64ef6699d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c2bf92a64ef6699d$var$isSpecCompliantForm(thing) {
    return !!(thing && $c2bf92a64ef6699d$var$isFunction(thing.append) && thing[$c2bf92a64ef6699d$var$toStringTag] === "FormData" && thing[$c2bf92a64ef6699d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c2bf92a64ef6699d$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c2bf92a64ef6699d$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c2bf92a64ef6699d$var$isBuffer(source)) return source;
            if (!("toJSON" in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $c2bf92a64ef6699d$var$isArray(source) ? [] : {};
                $c2bf92a64ef6699d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$c2bf92a64ef6699d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c2bf92a64ef6699d$var$isAsyncFn = $c2bf92a64ef6699d$var$kindOfTest("AsyncFunction");
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c2bf92a64ef6699d$var$isThenable = (thing)=>thing && ($c2bf92a64ef6699d$var$isObject(thing) || $c2bf92a64ef6699d$var$isFunction(thing)) && $c2bf92a64ef6699d$var$isFunction(thing.then) && $c2bf92a64ef6699d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c2bf92a64ef6699d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c2bf92a64ef6699d$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c2bf92a64ef6699d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c2bf92a64ef6699d$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $c2bf92a64ef6699d$var$isFunction($c2bf92a64ef6699d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c2bf92a64ef6699d$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($c2bf92a64ef6699d$var$_global) : typeof $4dBQg !== "undefined" && $4dBQg.nextTick || $c2bf92a64ef6699d$var$_setImmediate;
// *********************
const $c2bf92a64ef6699d$var$isIterable = (thing)=>thing != null && $c2bf92a64ef6699d$var$isFunction(thing[$c2bf92a64ef6699d$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c2bf92a64ef6699d$var$isSafeIterable = (thing)=>thing != null && $c2bf92a64ef6699d$var$hasOwnInPrototypeChain(thing, $c2bf92a64ef6699d$var$iterator) && $c2bf92a64ef6699d$var$isIterable(thing);
var $c2bf92a64ef6699d$export$2e2bcd8739ae039 = {
    isArray: $c2bf92a64ef6699d$var$isArray,
    isArrayBuffer: $c2bf92a64ef6699d$var$isArrayBuffer,
    isBuffer: $c2bf92a64ef6699d$var$isBuffer,
    isFormData: $c2bf92a64ef6699d$var$isFormData,
    isArrayBufferView: $c2bf92a64ef6699d$var$isArrayBufferView,
    isString: $c2bf92a64ef6699d$var$isString,
    isNumber: $c2bf92a64ef6699d$var$isNumber,
    isBoolean: $c2bf92a64ef6699d$var$isBoolean,
    isObject: $c2bf92a64ef6699d$var$isObject,
    isPlainObject: $c2bf92a64ef6699d$var$isPlainObject,
    isEmptyObject: $c2bf92a64ef6699d$var$isEmptyObject,
    isReadableStream: $c2bf92a64ef6699d$var$isReadableStream,
    isRequest: $c2bf92a64ef6699d$var$isRequest,
    isResponse: $c2bf92a64ef6699d$var$isResponse,
    isHeaders: $c2bf92a64ef6699d$var$isHeaders,
    isUndefined: $c2bf92a64ef6699d$var$isUndefined,
    isDate: $c2bf92a64ef6699d$var$isDate,
    isFile: $c2bf92a64ef6699d$var$isFile,
    isReactNativeBlob: $c2bf92a64ef6699d$var$isReactNativeBlob,
    isReactNative: $c2bf92a64ef6699d$var$isReactNative,
    isBlob: $c2bf92a64ef6699d$var$isBlob,
    isRegExp: $c2bf92a64ef6699d$var$isRegExp,
    isFunction: $c2bf92a64ef6699d$var$isFunction,
    isStream: $c2bf92a64ef6699d$var$isStream,
    isURLSearchParams: $c2bf92a64ef6699d$var$isURLSearchParams,
    isTypedArray: $c2bf92a64ef6699d$var$isTypedArray,
    isFileList: $c2bf92a64ef6699d$var$isFileList,
    forEach: $c2bf92a64ef6699d$var$forEach,
    merge: $c2bf92a64ef6699d$var$merge,
    extend: $c2bf92a64ef6699d$var$extend,
    trim: $c2bf92a64ef6699d$var$trim,
    stripBOM: $c2bf92a64ef6699d$var$stripBOM,
    inherits: $c2bf92a64ef6699d$var$inherits,
    toFlatObject: $c2bf92a64ef6699d$var$toFlatObject,
    kindOf: $c2bf92a64ef6699d$var$kindOf,
    kindOfTest: $c2bf92a64ef6699d$var$kindOfTest,
    endsWith: $c2bf92a64ef6699d$var$endsWith,
    toArray: $c2bf92a64ef6699d$var$toArray,
    forEachEntry: $c2bf92a64ef6699d$var$forEachEntry,
    matchAll: $c2bf92a64ef6699d$var$matchAll,
    isHTMLForm: $c2bf92a64ef6699d$var$isHTMLForm,
    hasOwnProperty: $c2bf92a64ef6699d$var$hasOwnProperty,
    hasOwnProp: $c2bf92a64ef6699d$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c2bf92a64ef6699d$var$hasOwnInPrototypeChain,
    getSafeProp: $c2bf92a64ef6699d$var$getSafeProp,
    reduceDescriptors: $c2bf92a64ef6699d$var$reduceDescriptors,
    freezeMethods: $c2bf92a64ef6699d$var$freezeMethods,
    toObjectSet: $c2bf92a64ef6699d$var$toObjectSet,
    toCamelCase: $c2bf92a64ef6699d$var$toCamelCase,
    noop: $c2bf92a64ef6699d$var$noop,
    toFiniteNumber: $c2bf92a64ef6699d$var$toFiniteNumber,
    findKey: $c2bf92a64ef6699d$var$findKey,
    global: $c2bf92a64ef6699d$var$_global,
    isContextDefined: $c2bf92a64ef6699d$var$isContextDefined,
    isSpecCompliantForm: $c2bf92a64ef6699d$var$isSpecCompliantForm,
    toJSONObject: $c2bf92a64ef6699d$var$toJSONObject,
    isAsyncFn: $c2bf92a64ef6699d$var$isAsyncFn,
    isThenable: $c2bf92a64ef6699d$var$isThenable,
    setImmediate: $c2bf92a64ef6699d$var$_setImmediate,
    asap: $c2bf92a64ef6699d$var$asap,
    isIterable: $c2bf92a64ef6699d$var$isIterable,
    isSafeIterable: $c2bf92a64ef6699d$var$isSafeIterable
};









"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $0cad027e2ffba15a$var$ignoreDuplicateOf = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $0cad027e2ffba15a$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $0cad027e2ffba15a$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};



"use strict";
function $fedefcd4ca7e05ca$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $fedefcd4ca7e05ca$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g");
// eslint-disable-next-line no-control-regex
const $fedefcd4ca7e05ca$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function $fedefcd4ca7e05ca$var$sanitizeValue(value, invalidChars) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$fedefcd4ca7e05ca$var$sanitizeValue(item, invalidChars));
    return $fedefcd4ca7e05ca$var$trimSPorHTAB(String(value).replace(invalidChars, ""));
}
const $fedefcd4ca7e05ca$export$9e344cffce061a22 = (value)=>$fedefcd4ca7e05ca$var$sanitizeValue(value, $fedefcd4ca7e05ca$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $fedefcd4ca7e05ca$export$59dd66c2a12d8f62 = (value)=>$fedefcd4ca7e05ca$var$sanitizeValue(value, $fedefcd4ca7e05ca$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $fedefcd4ca7e05ca$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $fedefcd4ca7e05ca$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


"use strict";
const $f2bfae2f47cdd2a8$var$$internals = Symbol("internals");
function $f2bfae2f47cdd2a8$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $f2bfae2f47cdd2a8$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value) ? value.map($f2bfae2f47cdd2a8$var$normalizeValue) : (0, $fedefcd4ca7e05ca$export$9e344cffce061a22)(String(value));
}
function $f2bfae2f47cdd2a8$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $f2bfae2f47cdd2a8$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $f2bfae2f47cdd2a8$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $f2bfae2f47cdd2a8$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $f2bfae2f47cdd2a8$var$buildAccessors(obj, header) {
    const accessorName = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $f2bfae2f47cdd2a8$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $f2bfae2f47cdd2a8$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $f2bfae2f47cdd2a8$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$f2bfae2f47cdd2a8$var$isValidHeaderName(header)) setHeaders((0, $0cad027e2ffba15a$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(header) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError("Object iterator must return a key-value pair");
                key = entry[0];
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $f2bfae2f47cdd2a8$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $f2bfae2f47cdd2a8$var$parseTokens(value);
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $f2bfae2f47cdd2a8$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $f2bfae2f47cdd2a8$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $f2bfae2f47cdd2a8$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $f2bfae2f47cdd2a8$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $f2bfae2f47cdd2a8$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $f2bfae2f47cdd2a8$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $f2bfae2f47cdd2a8$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $f2bfae2f47cdd2a8$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$f2bfae2f47cdd2a8$var$$internals] = this[$f2bfae2f47cdd2a8$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $f2bfae2f47cdd2a8$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $f2bfae2f47cdd2a8$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$f2bfae2f47cdd2a8$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).reduceDescriptors($f2bfae2f47cdd2a8$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).freezeMethods($f2bfae2f47cdd2a8$var$AxiosHeaders);
var $f2bfae2f47cdd2a8$export$2e2bcd8739ae039 = $f2bfae2f47cdd2a8$var$AxiosHeaders;


"use strict";
const $ea1e0e5414f1ba5b$var$REDACTED = "[REDACTED ****]";
function $ea1e0e5414f1ba5b$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(source, "toJSON")) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(prototype, "toJSON")) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $ea1e0e5414f1ba5b$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== "object") return source;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(source) && $ea1e0e5414f1ba5b$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $ea1e0e5414f1ba5b$var$REDACTED : visit(value);
                if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $ea1e0e5414f1ba5b$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $ea1e0e5414f1ba5b$var$AxiosError(error.message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, "cause", {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, "message", {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = "AxiosError";
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config, "redact") ? config.redact : undefined;
        const serializedConfig = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $ea1e0e5414f1ba5b$var$redactConfig(config, redactKeys) : (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_OPTION = "ERR_BAD_OPTION";
$ea1e0e5414f1ba5b$var$AxiosError.ECONNABORTED = "ECONNABORTED";
$ea1e0e5414f1ba5b$var$AxiosError.ETIMEDOUT = "ETIMEDOUT";
$ea1e0e5414f1ba5b$var$AxiosError.ECONNREFUSED = "ECONNREFUSED";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_NETWORK = "ERR_NETWORK";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_DEPRECATED = "ERR_DEPRECATED";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_CANCELED = "ERR_CANCELED";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_INVALID_URL = "ERR_INVALID_URL";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
var $ea1e0e5414f1ba5b$export$2e2bcd8739ae039 = $ea1e0e5414f1ba5b$var$AxiosError;


// eslint-disable-next-line strict
var $4b784fc05ded8112$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $46b8ab9ed5acde5f$export$a143d493d941bafc;
var $46b8ab9ed5acde5f$export$e4cf37d7f6fb9e0a;
var $46b8ab9ed5acde5f$export$f99ded8fe4b79145;
var $46b8ab9ed5acde5f$export$599f31c3813fae4d;
"use strict";
var $9f15c0b4b37a5ac3$export$a48f0734ac7c2329;
var $9f15c0b4b37a5ac3$export$d622b2ad8d90c771;
var $9f15c0b4b37a5ac3$export$6100ba28696e12de;
"use strict";
$9f15c0b4b37a5ac3$export$a48f0734ac7c2329 = $9f15c0b4b37a5ac3$var$byteLength;
$9f15c0b4b37a5ac3$export$d622b2ad8d90c771 = $9f15c0b4b37a5ac3$var$toByteArray;
$9f15c0b4b37a5ac3$export$6100ba28696e12de = $9f15c0b4b37a5ac3$var$fromByteArray;
var $9f15c0b4b37a5ac3$var$lookup = [];
var $9f15c0b4b37a5ac3$var$revLookup = [];
var $9f15c0b4b37a5ac3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $9f15c0b4b37a5ac3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $9f15c0b4b37a5ac3$var$i = 0, $9f15c0b4b37a5ac3$var$len = $9f15c0b4b37a5ac3$var$code.length; $9f15c0b4b37a5ac3$var$i < $9f15c0b4b37a5ac3$var$len; ++$9f15c0b4b37a5ac3$var$i){
    $9f15c0b4b37a5ac3$var$lookup[$9f15c0b4b37a5ac3$var$i] = $9f15c0b4b37a5ac3$var$code[$9f15c0b4b37a5ac3$var$i];
    $9f15c0b4b37a5ac3$var$revLookup[$9f15c0b4b37a5ac3$var$code.charCodeAt($9f15c0b4b37a5ac3$var$i)] = $9f15c0b4b37a5ac3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9f15c0b4b37a5ac3$var$revLookup["-".charCodeAt(0)] = 62;
$9f15c0b4b37a5ac3$var$revLookup["_".charCodeAt(0)] = 63;
function $9f15c0b4b37a5ac3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9f15c0b4b37a5ac3$var$byteLength(b64) {
    var lens = $9f15c0b4b37a5ac3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9f15c0b4b37a5ac3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9f15c0b4b37a5ac3$var$toByteArray(b64) {
    var tmp;
    var lens = $9f15c0b4b37a5ac3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9f15c0b4b37a5ac3$var$Arr($9f15c0b4b37a5ac3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i)] << 18 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i)] << 2 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i)] << 10 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9f15c0b4b37a5ac3$var$tripletToBase64(num) {
    return $9f15c0b4b37a5ac3$var$lookup[num >> 18 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[num >> 12 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[num >> 6 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[num & 0x3F];
}
function $9f15c0b4b37a5ac3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9f15c0b4b37a5ac3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $9f15c0b4b37a5ac3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9f15c0b4b37a5ac3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9f15c0b4b37a5ac3$var$lookup[tmp >> 2] + $9f15c0b4b37a5ac3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9f15c0b4b37a5ac3$var$lookup[tmp >> 10] + $9f15c0b4b37a5ac3$var$lookup[tmp >> 4 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $da651c57892e471c$export$aafa59e2e03f2942;
var $da651c57892e471c$export$68d8715fc104d294;
$da651c57892e471c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$da651c57892e471c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $46b8ab9ed5acde5f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$46b8ab9ed5acde5f$export$a143d493d941bafc = $46b8ab9ed5acde5f$var$Buffer;
$46b8ab9ed5acde5f$export$e4cf37d7f6fb9e0a = $46b8ab9ed5acde5f$var$SlowBuffer;
$46b8ab9ed5acde5f$export$f99ded8fe4b79145 = 50;
const $46b8ab9ed5acde5f$var$K_MAX_LENGTH = 0x7fffffff;
$46b8ab9ed5acde5f$export$599f31c3813fae4d = $46b8ab9ed5acde5f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $46b8ab9ed5acde5f$var$Buffer.TYPED_ARRAY_SUPPORT = $46b8ab9ed5acde5f$var$typedArraySupport();
if (!$46b8ab9ed5acde5f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $46b8ab9ed5acde5f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($46b8ab9ed5acde5f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($46b8ab9ed5acde5f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $46b8ab9ed5acde5f$var$createBuffer(length) {
    if (length > $46b8ab9ed5acde5f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $46b8ab9ed5acde5f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $46b8ab9ed5acde5f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $46b8ab9ed5acde5f$var$allocUnsafe(arg);
    }
    return $46b8ab9ed5acde5f$var$from(arg, encodingOrOffset, length);
}
$46b8ab9ed5acde5f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $46b8ab9ed5acde5f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $46b8ab9ed5acde5f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $46b8ab9ed5acde5f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($46b8ab9ed5acde5f$var$isInstance(value, ArrayBuffer) || value && $46b8ab9ed5acde5f$var$isInstance(value.buffer, ArrayBuffer)) return $46b8ab9ed5acde5f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($46b8ab9ed5acde5f$var$isInstance(value, SharedArrayBuffer) || value && $46b8ab9ed5acde5f$var$isInstance(value.buffer, SharedArrayBuffer))) return $46b8ab9ed5acde5f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $46b8ab9ed5acde5f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $46b8ab9ed5acde5f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $46b8ab9ed5acde5f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $46b8ab9ed5acde5f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $46b8ab9ed5acde5f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($46b8ab9ed5acde5f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($46b8ab9ed5acde5f$var$Buffer, Uint8Array);
function $46b8ab9ed5acde5f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $46b8ab9ed5acde5f$var$alloc(size, fill, encoding) {
    $46b8ab9ed5acde5f$var$assertSize(size);
    if (size <= 0) return $46b8ab9ed5acde5f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $46b8ab9ed5acde5f$var$createBuffer(size).fill(fill, encoding) : $46b8ab9ed5acde5f$var$createBuffer(size).fill(fill);
    return $46b8ab9ed5acde5f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $46b8ab9ed5acde5f$var$Buffer.alloc = function(size, fill, encoding) {
    return $46b8ab9ed5acde5f$var$alloc(size, fill, encoding);
};
function $46b8ab9ed5acde5f$var$allocUnsafe(size) {
    $46b8ab9ed5acde5f$var$assertSize(size);
    return $46b8ab9ed5acde5f$var$createBuffer(size < 0 ? 0 : $46b8ab9ed5acde5f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $46b8ab9ed5acde5f$var$Buffer.allocUnsafe = function(size) {
    return $46b8ab9ed5acde5f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $46b8ab9ed5acde5f$var$Buffer.allocUnsafeSlow = function(size) {
    return $46b8ab9ed5acde5f$var$allocUnsafe(size);
};
function $46b8ab9ed5acde5f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$46b8ab9ed5acde5f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $46b8ab9ed5acde5f$var$byteLength(string, encoding) | 0;
    let buf = $46b8ab9ed5acde5f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $46b8ab9ed5acde5f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $46b8ab9ed5acde5f$var$checked(array.length) | 0;
    const buf = $46b8ab9ed5acde5f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $46b8ab9ed5acde5f$var$fromArrayView(arrayView) {
    if ($46b8ab9ed5acde5f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $46b8ab9ed5acde5f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $46b8ab9ed5acde5f$var$fromArrayLike(arrayView);
}
function $46b8ab9ed5acde5f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $46b8ab9ed5acde5f$var$Buffer.prototype);
    return buf;
}
function $46b8ab9ed5acde5f$var$fromObject(obj) {
    if ($46b8ab9ed5acde5f$var$Buffer.isBuffer(obj)) {
        const len = $46b8ab9ed5acde5f$var$checked(obj.length) | 0;
        const buf = $46b8ab9ed5acde5f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $46b8ab9ed5acde5f$var$numberIsNaN(obj.length)) return $46b8ab9ed5acde5f$var$createBuffer(0);
        return $46b8ab9ed5acde5f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $46b8ab9ed5acde5f$var$fromArrayLike(obj.data);
}
function $46b8ab9ed5acde5f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $46b8ab9ed5acde5f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $46b8ab9ed5acde5f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $46b8ab9ed5acde5f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $46b8ab9ed5acde5f$var$Buffer.alloc(+length);
}
$46b8ab9ed5acde5f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $46b8ab9ed5acde5f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$46b8ab9ed5acde5f$var$Buffer.compare = function compare(a, b) {
    if ($46b8ab9ed5acde5f$var$isInstance(a, Uint8Array)) a = $46b8ab9ed5acde5f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($46b8ab9ed5acde5f$var$isInstance(b, Uint8Array)) b = $46b8ab9ed5acde5f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(a) || !$46b8ab9ed5acde5f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$46b8ab9ed5acde5f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$46b8ab9ed5acde5f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $46b8ab9ed5acde5f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $46b8ab9ed5acde5f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($46b8ab9ed5acde5f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(buf)) buf = $46b8ab9ed5acde5f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $46b8ab9ed5acde5f$var$byteLength(string, encoding) {
    if ($46b8ab9ed5acde5f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $46b8ab9ed5acde5f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $46b8ab9ed5acde5f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $46b8ab9ed5acde5f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $46b8ab9ed5acde5f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$46b8ab9ed5acde5f$var$Buffer.byteLength = $46b8ab9ed5acde5f$var$byteLength;
function $46b8ab9ed5acde5f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $46b8ab9ed5acde5f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $46b8ab9ed5acde5f$var$utf8Slice(this, start, end);
        case "ascii":
            return $46b8ab9ed5acde5f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $46b8ab9ed5acde5f$var$latin1Slice(this, start, end);
        case "base64":
            return $46b8ab9ed5acde5f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $46b8ab9ed5acde5f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$46b8ab9ed5acde5f$var$Buffer.prototype._isBuffer = true;
function $46b8ab9ed5acde5f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$46b8ab9ed5acde5f$var$swap(this, i, i + 1);
    return this;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $46b8ab9ed5acde5f$var$swap(this, i, i + 3);
        $46b8ab9ed5acde5f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $46b8ab9ed5acde5f$var$swap(this, i, i + 7);
        $46b8ab9ed5acde5f$var$swap(this, i + 1, i + 6);
        $46b8ab9ed5acde5f$var$swap(this, i + 2, i + 5);
        $46b8ab9ed5acde5f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $46b8ab9ed5acde5f$var$utf8Slice(this, 0, length);
    return $46b8ab9ed5acde5f$var$slowToString.apply(this, arguments);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.toLocaleString = $46b8ab9ed5acde5f$var$Buffer.prototype.toString;
$46b8ab9ed5acde5f$var$Buffer.prototype.equals = function equals(b) {
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $46b8ab9ed5acde5f$var$Buffer.compare(this, b) === 0;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $46b8ab9ed5acde5f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($46b8ab9ed5acde5f$var$customInspectSymbol) $46b8ab9ed5acde5f$var$Buffer.prototype[$46b8ab9ed5acde5f$var$customInspectSymbol] = $46b8ab9ed5acde5f$var$Buffer.prototype.inspect;
$46b8ab9ed5acde5f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($46b8ab9ed5acde5f$var$isInstance(target, Uint8Array)) target = $46b8ab9ed5acde5f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $46b8ab9ed5acde5f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($46b8ab9ed5acde5f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $46b8ab9ed5acde5f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($46b8ab9ed5acde5f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $46b8ab9ed5acde5f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $46b8ab9ed5acde5f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $46b8ab9ed5acde5f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $46b8ab9ed5acde5f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $46b8ab9ed5acde5f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $46b8ab9ed5acde5f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($46b8ab9ed5acde5f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $46b8ab9ed5acde5f$var$utf8Write(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $46b8ab9ed5acde5f$var$asciiWrite(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$asciiToBytes(string), buf, offset, length);
}
function $46b8ab9ed5acde5f$var$base64Write(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$base64ToBytes(string), buf, offset, length);
}
function $46b8ab9ed5acde5f$var$ucs2Write(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$46b8ab9ed5acde5f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $46b8ab9ed5acde5f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $46b8ab9ed5acde5f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $46b8ab9ed5acde5f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $46b8ab9ed5acde5f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $46b8ab9ed5acde5f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$46b8ab9ed5acde5f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $46b8ab9ed5acde5f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9f15c0b4b37a5ac3$export$6100ba28696e12de(buf);
    else return $9f15c0b4b37a5ac3$export$6100ba28696e12de(buf.slice(start, end));
}
function $46b8ab9ed5acde5f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $46b8ab9ed5acde5f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $46b8ab9ed5acde5f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $46b8ab9ed5acde5f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $46b8ab9ed5acde5f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $46b8ab9ed5acde5f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $46b8ab9ed5acde5f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $46b8ab9ed5acde5f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $46b8ab9ed5acde5f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $46b8ab9ed5acde5f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $46b8ab9ed5acde5f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $46b8ab9ed5acde5f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $46b8ab9ed5acde5f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$46b8ab9ed5acde5f$var$Buffer.prototype.readUintLE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUintBE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint8 = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint16LE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint16BE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint32LE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint32BE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigUInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigUInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 8, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 8, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $46b8ab9ed5acde5f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUintLE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUintBE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint8 = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint16LE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint16BE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint32LE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint32BE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $46b8ab9ed5acde5f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $46b8ab9ed5acde5f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $46b8ab9ed5acde5f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $46b8ab9ed5acde5f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigUInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigUInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $46b8ab9ed5acde5f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $46b8ab9ed5acde5f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $da651c57892e471c$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeFloat(this, value, offset, true, noAssert);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeFloat(this, value, offset, false, noAssert);
};
function $46b8ab9ed5acde5f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $da651c57892e471c$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeDouble(this, value, offset, true, noAssert);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$46b8ab9ed5acde5f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$46b8ab9ed5acde5f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$46b8ab9ed5acde5f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $46b8ab9ed5acde5f$var$Buffer.isBuffer(val) ? val : $46b8ab9ed5acde5f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $46b8ab9ed5acde5f$var$errors = {};
function $46b8ab9ed5acde5f$var$E(sym, getMessage, Base) {
    $46b8ab9ed5acde5f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$46b8ab9ed5acde5f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$46b8ab9ed5acde5f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$46b8ab9ed5acde5f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $46b8ab9ed5acde5f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $46b8ab9ed5acde5f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $46b8ab9ed5acde5f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $46b8ab9ed5acde5f$var$checkBounds(buf, offset, byteLength) {
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $46b8ab9ed5acde5f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $46b8ab9ed5acde5f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $46b8ab9ed5acde5f$var$checkBounds(buf, offset, byteLength);
}
function $46b8ab9ed5acde5f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $46b8ab9ed5acde5f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $46b8ab9ed5acde5f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $46b8ab9ed5acde5f$var$validateNumber(value, type);
        throw new $46b8ab9ed5acde5f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $46b8ab9ed5acde5f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $46b8ab9ed5acde5f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $46b8ab9ed5acde5f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $46b8ab9ed5acde5f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($46b8ab9ed5acde5f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $46b8ab9ed5acde5f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $46b8ab9ed5acde5f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $46b8ab9ed5acde5f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $46b8ab9ed5acde5f$var$base64ToBytes(str) {
    return $9f15c0b4b37a5ac3$export$d622b2ad8d90c771($46b8ab9ed5acde5f$var$base64clean(str));
}
function $46b8ab9ed5acde5f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $46b8ab9ed5acde5f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $46b8ab9ed5acde5f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $46b8ab9ed5acde5f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $46b8ab9ed5acde5f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $46b8ab9ed5acde5f$var$BufferBigIntNotDefined : fn;
}
function $46b8ab9ed5acde5f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $8470289dbcea46c9$require$Buffer = $46b8ab9ed5acde5f$export$a143d493d941bafc;
"use strict";
const $8470289dbcea46c9$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $8470289dbcea46c9$var$isVisitable(thing) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $8470289dbcea46c9$var$removeBrackets(key) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $8470289dbcea46c9$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $8470289dbcea46c9$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $8470289dbcea46c9$var$isFlatArray(arr) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($8470289dbcea46c9$var$isVisitable);
}
const $8470289dbcea46c9$var$predicates = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFlatObject((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $8470289dbcea46c9$var$toFormData(obj, formData, options) {
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4b784fc05ded8112$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const maxDepth = options.maxDepth === undefined ? $8470289dbcea46c9$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === "function") return new _Blob([
                value
            ]);
            if (typeof $8470289dbcea46c9$require$Buffer !== "undefined") return $8470289dbcea46c9$require$Buffer.from(value);
            throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Object is too deeply nested (" + depth + " levels). Max depth: " + maxDepth, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($8470289dbcea46c9$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === "object") {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value) && $8470289dbcea46c9$var$isFlatArray(value) || ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFileList(value) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $8470289dbcea46c9$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $8470289dbcea46c9$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($8470289dbcea46c9$var$isVisitable(value)) return true;
        formData.append($8470289dbcea46c9$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($8470289dbcea46c9$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $8470289dbcea46c9$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $8470289dbcea46c9$export$2e2bcd8739ae039 = $8470289dbcea46c9$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $2984ab788188fc29$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $2984ab788188fc29$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8470289dbcea46c9$export$2e2bcd8739ae039)(params, this, options);
}
const $2984ab788188fc29$var$prototype = $2984ab788188fc29$var$AxiosURLSearchParams.prototype;
$2984ab788188fc29$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$2984ab788188fc29$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $2984ab788188fc29$var$encode) : $2984ab788188fc29$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $2984ab788188fc29$export$2e2bcd8739ae039 = $2984ab788188fc29$var$AxiosURLSearchParams;


"use strict";
function $9fdbd2405fb5a936$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $9fdbd2405fb5a936$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || "";
    const _options = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(_options, "encode") || $9fdbd2405fb5a936$export$c564cdbbe6da493;
    const serializeFn = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(_options, "serialize");
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $2984ab788188fc29$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $f212a01b1e58726a$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $f212a01b1e58726a$export$2e2bcd8739ae039 = $f212a01b1e58726a$var$InterceptorManager;





"use strict";
var $76ece2fc1dbc15e7$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






"use strict";
var $edc0ec2fa4fda0f2$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $2984ab788188fc29$export$2e2bcd8739ae039);


"use strict";
var $011e1ac7a2545910$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $94b766e74d8de5cc$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $a0f199a78f0a0f37$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $edc0ec2fa4fda0f2$export$2e2bcd8739ae039,
        FormData: $011e1ac7a2545910$export$2e2bcd8739ae039,
        Blob: $94b766e74d8de5cc$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $203661fd244d1f21$exports = {};

$parcel$export($203661fd244d1f21$exports, "hasBrowserEnv", function () { return $203661fd244d1f21$export$c4996c4b7b93b0bf; });
$parcel$export($203661fd244d1f21$exports, "navigator", function () { return $203661fd244d1f21$export$ec7c8efa7f5790ae; });
$parcel$export($203661fd244d1f21$exports, "hasStandardBrowserEnv", function () { return $203661fd244d1f21$export$c0bcc9250309d66; });
$parcel$export($203661fd244d1f21$exports, "hasStandardBrowserWebWorkerEnv", function () { return $203661fd244d1f21$export$c81692cf5af97dac; });
$parcel$export($203661fd244d1f21$exports, "origin", function () { return $203661fd244d1f21$export$f710a83a91838a36; });
const $203661fd244d1f21$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $203661fd244d1f21$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $203661fd244d1f21$export$c0bcc9250309d66 = $203661fd244d1f21$export$c4996c4b7b93b0bf && (!$203661fd244d1f21$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($203661fd244d1f21$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $203661fd244d1f21$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $203661fd244d1f21$export$f710a83a91838a36 = $203661fd244d1f21$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $cce75ba43a375f9c$export$2e2bcd8739ae039 = {
    ...$203661fd244d1f21$exports,
    ...(0, $a0f199a78f0a0f37$export$2e2bcd8739ae039)
};


"use strict";
function $11bf77d4b4b7132f$export$2e2bcd8739ae039(data, options) {
    return (0, $8470289dbcea46c9$export$2e2bcd8739ae039)(data, new (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).isNode && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






"use strict";
const $b89d98899f472588$var$MAX_DEPTH = (0, $8470289dbcea46c9$export$659081b45d03227d);
function $b89d98899f472588$var$throwIfDepthExceeded(index) {
    if (index > $b89d98899f472588$var$MAX_DEPTH) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("FormData field is too deeply nested (" + index + " levels). Max depth: " + $b89d98899f472588$var$MAX_DEPTH, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $b89d98899f472588$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $b89d98899f472588$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === "[]" ? "" : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $b89d98899f472588$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $b89d98899f472588$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $b89d98899f472588$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $b89d98899f472588$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(formData) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($b89d98899f472588$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $b89d98899f472588$export$2e2bcd8739ae039 = $b89d98899f472588$var$formDataToJSON;


"use strict";
const $184c4cdd344f1efc$var$own = (obj, key)=>obj != null && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $184c4cdd344f1efc$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $184c4cdd344f1efc$var$defaults = {
    transitional: (0, $76ece2fc1dbc15e7$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $b89d98899f472588$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBuffer(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isStream(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFile(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBlob(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $184c4cdd344f1efc$var$own(this, "formSerializer");
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $11bf77d4b4b7132f$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const env = $184c4cdd344f1efc$var$own(this, "env");
                    const _FormData = env && env.FormData;
                    return (0, $8470289dbcea46c9$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $184c4cdd344f1efc$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $184c4cdd344f1efc$var$own(this, "transitional") || $184c4cdd344f1efc$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $184c4cdd344f1efc$var$own(this, "responseType");
            const JSONRequested = responseType === "json";
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isResponse(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $184c4cdd344f1efc$var$own(this, "parseReviver"));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).from(e, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $184c4cdd344f1efc$var$own(this, "response"));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch",
    "query"
], (method)=>{
    $184c4cdd344f1efc$var$defaults.headers[method] = {};
});
var $184c4cdd344f1efc$export$2e2bcd8739ae039 = $184c4cdd344f1efc$var$defaults;



"use strict";
function $80af61ecafd50432$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $184c4cdd344f1efc$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $6e6cee9820798cde$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




"use strict";
class $a5df0d634bea0233$var$CanceledError extends (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? "canceled" : message, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = "CanceledError";
        this.__CANCEL__ = true;
    }
}
var $a5df0d634bea0233$export$2e2bcd8739ae039 = $a5df0d634bea0233$var$CanceledError;







"use strict";
function $689903c39f023422$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Request failed with status code " + response.status, response.status >= 400 && response.status < 500 ? (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





"use strict";
function $16df5e6ad05e5e91$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $1a263c1daccc761b$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $1a263c1daccc761b$export$2e2bcd8739ae039 = $1a263c1daccc761b$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $c1a93cb7d352d968$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $c1a93cb7d352d968$export$2e2bcd8739ae039 = $c1a93cb7d352d968$var$throttle;



const $574ee5c20ce465fe$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $1a263c1daccc761b$export$2e2bcd8739ae039)(50, 250);
    return (0, $c1a93cb7d352d968$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== "number") return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $574ee5c20ce465fe$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $574ee5c20ce465fe$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).asap(()=>fn(...args));






var $54cb450fa094077a$export$2e2bcd8739ae039 = (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin), (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $0c2a5c079e8404e1$export$2e2bcd8739ae039 = (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === "undefined") return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push("secure");
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join("; ");
    },
    read (name) {
        if (typeof document === "undefined") return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(";");
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, "");
            const eq = cookie.indexOf("=");
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000, "/");
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $7d7627e70192e49a$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== "string") return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $a9b1899b57910fee$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
const $6361e242ceddf2ba$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $6361e242ceddf2ba$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $6361e242ceddf2ba$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $6361e242ceddf2ba$var$normalizeURLForProtocolCheck(url) {
    return $6361e242ceddf2ba$var$stripLeadingC0ControlOrSpace(url).replace($6361e242ceddf2ba$var$httpProtocolControlCharacters, "");
}
function $6361e242ceddf2ba$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === "string" && $6361e242ceddf2ba$var$malformedHttpProtocol.test($6361e242ceddf2ba$var$normalizeURLForProtocolCheck(url))) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)('Invalid URL: missing "//" after protocol', (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
}
function $6361e242ceddf2ba$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $6361e242ceddf2ba$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $7d7627e70192e49a$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $6361e242ceddf2ba$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $a9b1899b57910fee$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




"use strict";
const $30616137bb4dc682$var$headersToObject = (thing)=>thing instanceof (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $30616137bb4dc682$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, "hasOwnProperty", {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, "transitional") ? config2.transitional : undefined;
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, "transitional") ? config1.transitional : undefined;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($30616137bb4dc682$var$headersToObject(a), $30616137bb4dc682$var$headersToObject(b), prop, true)
    };
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
        const merge = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, "validateStatus") && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption("validateStatusUndefinedResolves") === false) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, "validateStatus")) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




const $2e7700064c1edbb3$var$FORM_DATA_CONTENT_HEADERS = [
    "content-type",
    "content-length"
];
function $2e7700064c1edbb3$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== "content-only") {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($2e7700064c1edbb3$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $2e7700064c1edbb3$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $2e7700064c1edbb3$var$resolveConfig(config) {
    const newConfig = (0, $30616137bb4dc682$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own("data");
    let withXSRFToken = own("withXSRFToken");
    const xsrfHeaderName = own("xsrfHeaderName");
    const xsrfCookieName = own("xsrfCookieName");
    let headers = own("headers");
    const auth = own("auth");
    const baseURL = own("baseURL");
    const allowAbsoluteUrls = own("allowAbsoluteUrls");
    const url = own("url");
    newConfig.headers = headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $9fdbd2405fb5a936$export$2e2bcd8739ae039)((0, $6361e242ceddf2ba$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own("params"), own("paramsSerializer"));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(auth, "username") || "";
        const password = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(auth, "password") || "";
        try {
            headers.set("Authorization", "Basic " + btoa(username + ":" + (password ? $2e7700064c1edbb3$var$encodeUTF8(password) : "")));
        } catch (e) {
            throw (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).from(e, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $2e7700064c1edbb3$var$setFormDataHeaders(headers, data.getHeaders(), own("formDataHeaderPolicy"));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $54cb450fa094077a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $0c2a5c079e8404e1$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $2e7700064c1edbb3$export$2e2bcd8739ae039 = $2e7700064c1edbb3$var$resolveConfig;



const $d113720e80db7587$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $d113720e80db7587$export$2e2bcd8739ae039 = $d113720e80db7587$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $2e7700064c1edbb3$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $689903c39f023422$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith("file:"))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Request aborted", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : "Network Error";
            const err = new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(msg, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $76ece2fc1dbc15e7$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach((0, $fedefcd4ca7e05ca$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $574ee5c20ce465fe$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $574ee5c20ce465fe$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $16df5e6ad05e5e91$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $cce75ba43a375f9c$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8e0bffe21a94187f$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039) ? err : new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener("abort", onabort, {
            once: true
        }));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $8e0bffe21a94187f$export$2e2bcd8739ae039 = $8e0bffe21a94187f$var$composeSignals;


const $ccf1b4b4dd341368$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ccf1b4b4dd341368$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ccf1b4b4dd341368$var$readStream(iterable))yield* $ccf1b4b4dd341368$export$71b051935044bd5d(chunk, chunkSize);
};
const $ccf1b4b4dd341368$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ccf1b4b4dd341368$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ccf1b4b4dd341368$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $64ab4e5d2b8b685e$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $64ab4e5d2b8b685e$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $64ab4e5d2b8b685e$var$isHexDigit(str.charCodeAt(i + 1)) && $64ab4e5d2b8b685e$var$isHexDigit(str.charCodeAt(i + 2));
function $64ab4e5d2b8b685e$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== "string") return 0;
    if (!url.startsWith("data:")) return 0;
    const comma = url.indexOf(",");
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $64ab4e5d2b8b685e$var$isHexDigit(a) && $64ab4e5d2b8b685e$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $64ab4e5d2b8b685e$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $6abdf23ff0a1f127$export$a4ad2735b021c132 = "1.18.1";



const $dfd83a5db13fb7d7$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $dfd83a5db13fb7d7$var$isFunction } = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $dfd83a5db13fb7d7$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $dfd83a5db13fb7d7$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $dfd83a5db13fb7d7$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $dfd83a5db13fb7d7$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf("://");
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes("@") || urlToCheck.includes(":");
};
const $dfd83a5db13fb7d7$var$factory = (env)=>{
    const globalObject = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).global !== undefined && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).global !== null ? (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $dfd83a5db13fb7d7$var$isFunction(envFetch) : typeof fetch === "function";
    const isRequestSupported = $dfd83a5db13fb7d7$var$isFunction(Request);
    const isResponseSupported = $dfd83a5db13fb7d7$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $dfd83a5db13fb7d7$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $dfd83a5db13fb7d7$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: "POST",
            get duplex () {
                duplexAccessed = true;
                return "half";
            }
        });
        const hasContentType = request.headers.has("Content-Type");
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $dfd83a5db13fb7d7$var$test(()=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            "text",
            "arrayBuffer",
            "blob",
            "formData",
            "stream"
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin, {
                method: "POST",
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $2e7700064c1edbb3$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + "").toLowerCase() : "text";
        let composedSignal = (0, $8e0bffe21a94187f$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Request body larger than maxBodyLength limit", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own("auth");
            if (configAuth) {
                const username = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(configAuth, "username") || "";
                const password = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(configAuth, "password") || "";
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($dfd83a5db13fb7d7$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $dfd83a5db13fb7d7$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $dfd83a5db13fb7d7$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = "";
                    parsedURL.password = "";
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete("authorization");
                headers.set("Authorization", "Basic " + btoa($dfd83a5db13fb7d7$var$encodeUTF8((auth.username || "") + ":" + (auth.password || ""))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === "string" && url.startsWith("data:")) {
                const estimated = (0, $64ab4e5d2b8b685e$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== "get" && method !== "head") {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === "number" && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $ccf1b4b4dd341368$export$b0119225647bd83)(stream, $dfd83a5db13fb7d7$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== "get" && method !== "head" && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: "POST",
                        body: data,
                        duplex: "half"
                    });
                    let contentTypeHeader;
                    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $574ee5c20ce465fe$export$d9fadd12586c18d6)(requestContentLength, (0, $574ee5c20ce465fe$export$c1b28109d46c3592)((0, $574ee5c20ce465fe$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== "get" && method !== "head") data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== "get" && method !== "head") throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Stream request bodies are not supported by the current fetch implementation", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete("content-type");
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set("User-Agent", "axios/" + (0, $6abdf23ff0a1f127$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $fedefcd4ca7e05ca$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    "status",
                    "statusText",
                    "headers"
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $574ee5c20ce465fe$export$d9fadd12586c18d6)(responseContentLength, (0, $574ee5c20ce465fe$export$c1b28109d46c3592)((0, $574ee5c20ce465fe$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $ccf1b4b4dd341368$export$b0119225647bd83)(response.body, $dfd83a5db13fb7d7$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || "text";
            let responseData = await resolvers[(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(resolvers, responseType) || "text"](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === "number") materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === "number") materializedSize = responseData.size;
                    else if (typeof responseData === "string") materializedSize = typeof TextEncoder === "function" ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === "number" && materializedSize > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $689903c39f023422$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, "cause", {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Network Error", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, "cause", {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $dfd83a5db13fb7d7$var$seedCache = new Map();
const $dfd83a5db13fb7d7$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $dfd83a5db13fb7d7$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $dfd83a5db13fb7d7$var$factory(env));
        map = target;
    }
    return target;
};
const $dfd83a5db13fb7d7$var$adapter = $dfd83a5db13fb7d7$export$3105c6651375d4fa();
var $dfd83a5db13fb7d7$export$2e2bcd8739ae039 = $dfd83a5db13fb7d7$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $537fd1576cc57544$var$knownAdapters = {
    http: (0, $4b784fc05ded8112$export$2e2bcd8739ae039),
    xhr: (0, $d113720e80db7587$export$2e2bcd8739ae039),
    fetch: {
        get: $dfd83a5db13fb7d7$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach($537fd1576cc57544$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, "name", {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $537fd1576cc57544$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $537fd1576cc57544$var$isResolvedHandle = (adapter)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $537fd1576cc57544$var$getAdapter(adapters, config) {
    adapters = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$537fd1576cc57544$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $537fd1576cc57544$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
        let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($537fd1576cc57544$var$renderReason).join("\n") : " " + $537fd1576cc57544$var$renderReason(reasons[0]) : "as no adapter specified";
        throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $537fd1576cc57544$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $537fd1576cc57544$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $537fd1576cc57544$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f8407ebbdfc354ed$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(null, config);
}
function $f8407ebbdfc354ed$export$2e2bcd8739ae039(config) {
    $f8407ebbdfc354ed$var$throwIfCancellationRequested(config);
    config.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $80af61ecafd50432$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $537fd1576cc57544$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $184c4cdd344f1efc$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $f8407ebbdfc354ed$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $80af61ecafd50432$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $6e6cee9820798cde$export$2e2bcd8739ae039)(reason)) {
            $f8407ebbdfc354ed$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $80af61ecafd50432$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






"use strict";
const $160fd64fd0d48ee8$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $160fd64fd0d48ee8$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $160fd64fd0d48ee8$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $160fd64fd0d48ee8$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $6abdf23ff0a1f127$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$160fd64fd0d48ee8$var$deprecatedWarnings[opt]) {
            $160fd64fd0d48ee8$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$160fd64fd0d48ee8$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $160fd64fd0d48ee8$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object" || options === null) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("options must be an object", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $160fd64fd0d48ee8$export$2e2bcd8739ae039 = {
    assertOptions: $160fd64fd0d48ee8$var$assertOptions,
    validators: $160fd64fd0d48ee8$var$validators
};




"use strict";
const $9a007e79cde364ce$var$validators = (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $9a007e79cde364ce$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $f212a01b1e58726a$export$2e2bcd8739ae039)(),
            response: new (0, $f212a01b1e58726a$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return "";
                    const firstNewlineIndex = dummy.stack.indexOf("\n");
                    return firstNewlineIndex === -1 ? "" : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf("\n");
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf("\n", firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? "" : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += "\n" + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $30616137bb4dc682$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            forcedJSONParsing: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            clarifyTimeoutError: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            legacyInterceptorReqResOrdering: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            advertiseZstdAcceptEncoding: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            validateStatusUndefinedResolves: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $9a007e79cde364ce$var$validators.function,
                serialize: $9a007e79cde364ce$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $9a007e79cde364ce$var$validators.spelling("baseURL"),
            withXsrfToken: $9a007e79cde364ce$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "query",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $76ece2fc1dbc15e7$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f8407ebbdfc354ed$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f8407ebbdfc354ed$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $30616137bb4dc682$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $6361e242ceddf2ba$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $9fdbd2405fb5a936$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9a007e79cde364ce$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $30616137bb4dc682$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config, "data") ? config.data : undefined
        }));
    };
});
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch",
    "query"
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $30616137bb4dc682$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $9a007e79cde364ce$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== "query") $9a007e79cde364ce$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $9a007e79cde364ce$export$2e2bcd8739ae039 = $9a007e79cde364ce$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fc3444b47ee8f8bb$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fc3444b47ee8f8bb$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fc3444b47ee8f8bb$export$2e2bcd8739ae039 = $fc3444b47ee8f8bb$var$CancelToken;






"use strict";
function $3d241cd593ab10a8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $17f11fafd04806be$export$2e2bcd8739ae039(payload) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $77aa84cf79cf2933$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($77aa84cf79cf2933$var$HttpStatusCode).forEach(([key, value])=>{
    $77aa84cf79cf2933$var$HttpStatusCode[value] = key;
});
var $77aa84cf79cf2933$export$2e2bcd8739ae039 = $77aa84cf79cf2933$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $6af2f97559267bd3$var$createInstance(defaultConfig) {
    const context = new (0, $9a007e79cde364ce$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $73106adb55132987$export$2e2bcd8739ae039)((0, $9a007e79cde364ce$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).extend(instance, (0, $9a007e79cde364ce$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $6af2f97559267bd3$var$createInstance((0, $30616137bb4dc682$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $6af2f97559267bd3$var$axios = $6af2f97559267bd3$var$createInstance((0, $184c4cdd344f1efc$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$6af2f97559267bd3$var$axios.Axios = (0, $9a007e79cde364ce$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$6af2f97559267bd3$var$axios.CanceledError = (0, $a5df0d634bea0233$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.CancelToken = (0, $fc3444b47ee8f8bb$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.isCancel = (0, $6e6cee9820798cde$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.VERSION = (0, $6abdf23ff0a1f127$export$a4ad2735b021c132);
$6af2f97559267bd3$var$axios.toFormData = (0, $8470289dbcea46c9$export$2e2bcd8739ae039);
// Expose AxiosError class
$6af2f97559267bd3$var$axios.AxiosError = (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$6af2f97559267bd3$var$axios.Cancel = $6af2f97559267bd3$var$axios.CanceledError;
// Expose all/spread
$6af2f97559267bd3$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$6af2f97559267bd3$var$axios.spread = (0, $3d241cd593ab10a8$export$2e2bcd8739ae039);
// Expose isAxiosError
$6af2f97559267bd3$var$axios.isAxiosError = (0, $17f11fafd04806be$export$2e2bcd8739ae039);
// Expose mergeConfig
$6af2f97559267bd3$var$axios.mergeConfig = (0, $30616137bb4dc682$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.AxiosHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.formToJSON = (thing)=>(0, $b89d98899f472588$export$2e2bcd8739ae039)((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$6af2f97559267bd3$var$axios.getAdapter = (0, $537fd1576cc57544$export$2e2bcd8739ae039).getAdapter;
$6af2f97559267bd3$var$axios.HttpStatusCode = (0, $77aa84cf79cf2933$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.default = $6af2f97559267bd3$var$axios;
var // this module should only have a default export
$6af2f97559267bd3$export$2e2bcd8739ae039 = $6af2f97559267bd3$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $53dded68048b5996$export$1c00760e9e5a4e95, AxiosError: $53dded68048b5996$export$c1fbed17c2f6a328, CanceledError: $53dded68048b5996$export$1ab0c6b20d94fa14, isCancel: $53dded68048b5996$export$3b22524397b493c6, CancelToken: $53dded68048b5996$export$fd08e3cb425f0d61, VERSION: $53dded68048b5996$export$a4ad2735b021c132, all: $53dded68048b5996$export$84bf76cd7afc7469, Cancel: $53dded68048b5996$export$848c9b7ead0df967, isAxiosError: $53dded68048b5996$export$fbafdbe06a5b5a9a, spread: $53dded68048b5996$export$3ae0fd4797ed47c8, toFormData: $53dded68048b5996$export$10ae0d317ea97f8b, AxiosHeaders: $53dded68048b5996$export$4e7d6ff0f3e6520, HttpStatusCode: $53dded68048b5996$export$a972f69c851492b3, formToJSON: $53dded68048b5996$export$86d7c59254d6a2c9, getAdapter: $53dded68048b5996$export$17ddc20a97d669e2, mergeConfig: $53dded68048b5996$export$7ec1ebcfa9d8bd6a, create: $53dded68048b5996$export$185802fd694ee1f5 } = (0, $6af2f97559267bd3$export$2e2bcd8739ae039);



const $91ea30cb49819b9a$export$498d10c55d12eec5 = "https://dev.api.picsell.com.ua/login/";
const $91ea30cb49819b9a$export$8cc80cbeeab961c9 = "https://dev.api.picsell.com.ua/web/v1/";
const $91ea30cb49819b9a$export$d5a0ec7c9e524fbb = undefined;
const $91ea30cb49819b9a$export$be750171172fb886 = 50;
const $91ea30cb49819b9a$export$8e5d48d2b3bed316 = 500;
const $91ea30cb49819b9a$export$da688e121885cf48 = {
    merchandiser: "merchandisers",
    merchandisers: "merchandisers/",
    supervisor: "supervisors/",
    created_by: "supervisors-and-supervisor-managers/",
    filters: "filters/",
    route: "routes",
    task: "tasks",
    clients: "clients/",
    point: "points",
    points: "points",
    point_groups: "point_groups",
    visit: "visits",
    network: "networks/",
    point__network: "networks/",
    networks: "networks/",
    point__networks: "networks/",
    county: "counties/",
    locality: "localities",
    country: "countries/",
    countries: "countries/",
    categories_point: "categories_point/",
    language: "language",
    brand: "brands",
    brands: "brands",
    product: "products",
    products: "products",
    categories: "categories/",
    subcategory: "subcategories/",
    subcategories: "subcategories/",
    tag: "tags/",
    tags: "tags/",
    component: "components",
    company: "companies",
    template: "templates/",
    absence_reason_templates: "absence-reason-templates/"
};
const $91ea30cb49819b9a$export$a6a26ddb3e5b4d30 = {
    task_negative: [
        {
            id: true,
            name: "\u0422\u0410\u041A"
        },
        {
            id: false,
            name: "\u041D\u0406"
        }
    ],
    task_deadline: [
        {
            id: true,
            name: "\u0422\u0410\u041A"
        },
        {
            id: false,
            name: "\u041D\u0406"
        }
    ],
    task_status: [
        {
            id: "no_answers",
            name: "\u041D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0456"
        },
        {
            id: "on_review",
            name: "\u041D\u0430 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u0456"
        },
        {
            id: "done",
            name: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u0456"
        }
    ]
};
const $91ea30cb49819b9a$export$846d38fa3865c245 = {
    filters: {
        action: "list",
        title: (c)=>c.label,
        selectTitle: "custom_filter"
    },
    merchandiser: {
        action: "list",
        title: (c)=>c.first_name + " " + c.last_name,
        selectTitle: "merchandiser"
    },
    merchandisers: {
        action: "list",
        title: (c)=>c.first_name + " " + c.last_name,
        selectTitle: "merchandisers"
    },
    supervisor: {
        action: "list",
        title: (c)=>c.first_name + " " + c.last_name,
        selectTitle: "supervisor"
    },
    point: {
        action: "list",
        title: (c)=>c.name + " " + c.address,
        selectTitle: "point"
    },
    points: {
        action: "list",
        title: (c)=>c.name + " " + c.address,
        selectTitle: "points"
    },
    point_groups: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "group_point_select_placeholder"
    },
    network: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "network"
    },
    point__network: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "network"
    },
    point__networks: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "network"
    },
    networks: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "networks"
    },
    created_by: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "created_by"
    },
    county: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "region"
    },
    locality: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "city"
    },
    country: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "country"
    },
    countries: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "countries"
    },
    categories_point: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "category"
    },
    brand: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "brand"
    },
    brands: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "brands"
    },
    product: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "product"
    },
    products: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "products"
    },
    category: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "category"
    },
    categories: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "categories"
    },
    subcategory: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "subcategories"
    },
    subcategories: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "subcategories"
    },
    tag: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "tag"
    },
    tags: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "tags"
    },
    component: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "component"
    },
    template: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "template"
    },
    absence_reason_templates: {
        action: "list",
        title: (c)=>c.reason,
        selectTitle: "absence_reason_templates"
    },
    task_status: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "task_status"
    },
    task_negative: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "task_negative"
    },
    task_deadline: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "task_deadline"
    },
    date_range: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "date_range"
    }
};
const $91ea30cb49819b9a$export$7ac3753ee4f78186 = {
    sizePerPage: 50,
    page: 1,
    totalDataSize: 0,
    sizePerPageList: [
        50,
        100,
        1000
    ],
    pageStartIndex: 1,
    paginationSize: 3,
    prePage: "Previous",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    paging: false
};



const $c9936523dc38c641$var$HEADERS = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "X-Frame-Options": "deny"
};
const $c9936523dc38c641$var$GENERIC_ERROR = {
    uk: "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
    en: "Something went wrong. Please try again.",
    hy: "\u053B\u0576\u0579-\u0578\u0580 \u0562\u0561\u0576 \u057D\u056D\u0561\u056C \u0563\u0576\u0561\u0581\u0589 \u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0583\u0578\u0580\u0571\u0565\u056C \u056F\u0580\u056F\u056B\u0576\u0589",
    ka: "\u10E0\u10D0\u10E6\u10D0\u10EA \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10DB\u10DD\u10EE\u10D3\u10D0. \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10E1\u10EA\u10D0\u10D3\u10DD\u10D7 \u10D7\u10D0\u10D5\u10D8\u10D3\u10D0\u10DC."
};
// Safe read of persisted auth state — never throws on missing/corrupt localStorage
// (loadState is try/catch wrapped and returns undefined on failure).
function $c9936523dc38c641$var$readState() {
    return (0, $67f64b78c4102acd$export$ea32cbdd559da174)() || null;
}
// Benign stand-in handed to a callback when a request fails, so loading states clear
// without crashing the caller: `.id`/`.detail` are undefined (success paths skip) and
// `.results`/`.count` satisfy the many list callers that .map/.length over them.
function $c9936523dc38c641$var$failedResponse() {
    return {
        results: [],
        count: 0
    };
}
function $c9936523dc38c641$var$notifyFailure(state) {
    const lang = state?.me?.language || "en";
    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error($c9936523dc38c641$var$GENERIC_ERROR[lang] || $c9936523dc38c641$var$GENERIC_ERROR.en);
}
// Expired/invalid token: clear the user and bounce to login. Covers any 401/403, not
// just the exact "Invalid token." body string the app used to match on.
function $c9936523dc38c641$var$handleUnauthorized() {
    (0, $67f64b78c4102acd$export$fb931cd598921492)({
        me: null
    });
    window.location.replace("/login");
}
function $c9936523dc38c641$export$848feb93d8f32b9b(body = {}, cb, customHeaders = {}, isBlob = false) {
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    if (customHeaders) Object.entries(customHeaders).map((header)=>{
        headers.append(header[0], header[1]);
    });
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    if ([
        "POST",
        "PATCH",
        "PUT"
    ].indexOf(body.method) !== -1) params.body = JSON.stringify(body.post);
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    if (body.outforz) url = "https://dev.api.outforz.com/api/contents/";
    if (isBlob) fetch(url, params).then((response)=>{
        if (!response || response.status === 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            if (cb) cb();
            return null;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return null;
        }
        return response.blob();
    }).then((blob)=>{
        if (!blob) return; // failure already handled above
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "export.zip";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
        if (cb) cb();
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        if (cb) cb();
    });
    else fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        if (response.status === 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        // 400/204 callers expect the raw Response (they parse it themselves).
        if (response.status === 400) {
            cb(response);
            return;
        }
        if (response.status === 204) {
            cb(response);
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null; // empty / non-JSON body — don't let .json() reject silently
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
}
function $c9936523dc38c641$export$46f383001bf60e04(body = {}, cb, customHeaders = {}, isBlob = false) {
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    if (customHeaders) Object.entries(customHeaders).map((header)=>{
        headers.append(header[0], header[1]);
    });
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    if ([
        "POST",
        "PATCH",
        "PUT"
    ].indexOf(body.method) !== -1) params.body = JSON.stringify(body.post);
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    if (body.outforz) url = "https://dev.api.outforz.com/api/contents/";
    if (isBlob) fetch(url, params).then((response)=>{
        if (!response || response.status === 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            if (cb) cb();
            return null;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return null;
        }
        return response.blob();
    }).then((blob)=>{
        if (!blob) return;
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "export.zip";
        document.body.appendChild(a);
        a.click();
        a.remove();
        if (cb) cb();
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        if (cb) cb();
    });
    else fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        if (response.status === 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 400) {
            cb(response);
            return;
        }
        // httpRequest intentionally hands 200/204 back as the raw Response.
        if (response.status === 204 || response.status === 200) {
            cb(response);
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
}
const $c9936523dc38c641$export$ae8c526ac59e8cc8 = async (body = {}, cb)=>{
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    if ([
        "POST",
        "PATCH",
        "PUT"
    ].indexOf(body.method) !== -1) params.body = JSON.stringify(body.post);
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    if (body.outforz) url = "https://dev.api.outforz.com/api/contents/";
    fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        if (response.status === 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
};
function $c9936523dc38c641$export$73693bad9f5880b0(body = {}) {
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let params = {
        method: "POST",
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    params.body = JSON.stringify(body);
    return new Promise((resolve, reject)=>{
        fetch(`${(0, $91ea30cb49819b9a$export$498d10c55d12eec5)}`, params).then((response)=>response.json()).then(resolve).catch(reject);
    });
}
function $c9936523dc38c641$export$e9af2f996ea0b059(body = {}, cb) {
    const headers = new Headers();
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    // No Content-Type: the browser sets multipart/form-data; boundary automatically.
    const params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default",
        body: body.post
    };
    const url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        if (response.status === 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 400) {
            cb(response);
            return;
        }
        if (response.status === 204) {
            cb(response);
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
}
function $c9936523dc38c641$export$a3c8e1472dc2ed84(body = {}, cb) {
    const headers = new Headers();
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    params.body = body.post;
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    fetch(url, params).then((response)=>{
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            throw new Error("Unauthorized");
        }
        if (!response.ok) // Surface the server error message; fall back to a generic toast if the
        // error body isn't JSON (so a non-JSON 5xx doesn't get swallowed silently).
        return response.json().then((errData)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(String(errData?.error || $c9936523dc38c641$var$GENERIC_ERROR[state?.me?.language || "en"] || $c9936523dc38c641$var$GENERIC_ERROR.en), {
                position: "top"
            });
            throw errData;
        }, ()=>{
            $c9936523dc38c641$var$notifyFailure(state);
            throw new Error("Upload failed");
        });
        return response.json();
    }).then((res)=>{
        cb(res);
    }).catch((err)=>{
        console.error("Upload failed:", err);
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
var $89dd00a53749c0ac$exports = {};
$89dd00a53749c0ac$exports = new URL("avatar.4169fcdf.jpg", import.meta.url).toString();



var $Yxlsx = parcelRequire("Yxlsx");

const $6f1c09625235f1f0$export$3241045aa1844a20 = {
    0: "monday",
    1: "tuesday",
    2: "wednesday",
    3: "thursday",
    4: "friday",
    5: "saturday",
    6: "sunday"
};
const $6f1c09625235f1f0$export$bb34f3538ba26c7e = {
    3: "Low",
    2: "Medium",
    1: "High",
    0: "Required"
};
const $6f1c09625235f1f0$export$8e11240bfd4abd6 = {
    "on_foot": "On foot",
    "motorcycle": "Motorcycle",
    "bike/scooter": "Bike or scooter",
    "automobile": "Automobile",
    "public_transport": "Public transport"
};
const $6f1c09625235f1f0$export$d0cb6a45517a7efd = [
    {
        value: 3,
        label: "Low"
    },
    {
        value: 2,
        label: "Medium"
    },
    {
        value: 1,
        label: "High"
    },
    {
        value: 0,
        label: "Required"
    }
];
const $6f1c09625235f1f0$export$1c3f0fce8ac301f1 = [
    {
        value: "boolean",
        label: "boolean"
    },
    {
        value: "photo",
        label: "photo"
    },
    {
        value: "text",
        label: "text"
    }
];
const $6f1c09625235f1f0$export$dd427c62fc59153a = [
    {
        value: "on_foot",
        label: "On foot"
    },
    {
        value: "motorcycle",
        label: "Motorcycle"
    },
    {
        value: "bike/scooter",
        label: "Bike or scooter"
    },
    {
        value: "automobile",
        label: "Automobile"
    },
    {
        value: "public_transport",
        label: "Public transport"
    }
];
const $6f1c09625235f1f0$export$fcbd761be6b3946e = [
    {
        value: true,
        label: "Active"
    },
    {
        value: false,
        label: "Not Active"
    }
];
const $6f1c09625235f1f0$export$d473fe3206ac7fed = [
    {
        value: "direct",
        label: "NKA Direct"
    },
    {
        value: "indirect",
        label: "NKA Indirect"
    }
];
const $6f1c09625235f1f0$export$9fa78f64b50a636c = [
    {
        value: "photo",
        label: "photo"
    },
    {
        value: "price",
        label: "price"
    },
    {
        value: "sale_price",
        label: "sale_price"
    },
    {
        value: "comment",
        label: "comment"
    }
];
const $6f1c09625235f1f0$export$18af5ff50af8d1b5 = [
    {
        value: "created",
        label: "created"
    },
    {
        value: "ready_for_neural_network",
        label: "ready_for_neural_network"
    },
    {
        value: "in_neural_network",
        label: "in_neural_network"
    },
    {
        value: "got_an_error_in_neural_network",
        label: "got_an_error_in_neural_network"
    },
    {
        value: "open",
        label: "open"
    },
    {
        value: "in_progress",
        label: "in_progress"
    },
    {
        value: "review",
        label: "review"
    },
    {
        value: "done",
        label: "done"
    },
    {
        value: "closed",
        label: "closed"
    }
];
const $6f1c09625235f1f0$export$a32e78025ed8daad = {
    boolean: "\u0442\u0430\u043A/\u043D\u0456",
    photo: "\u0444\u043E\u0442\u043E",
    text: "\u0442\u0435\u043A\u0441\u0442"
};


var $930bed3725aa77d7$exports = {};
$930bed3725aa77d7$exports = new URL("company.de195c03.png", import.meta.url).toString();


var $50ec5b37110e6f17$exports = {};
$50ec5b37110e6f17$exports = new URL("dots-horizontal-icon.0069ff9b.svg", import.meta.url).toString();








const $b79edb411f97c469$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $b79edb411f97c469$export$42e4bea151150eee(value) {
    return value;
}
function $b79edb411f97c469$export$94cf74715c9eb9b9() {
    return "";
}
function $b79edb411f97c469$export$ed2c0e82729e0a87(id) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
        href: `/visit/${id}`,
        className: "btn btn-sm btn-outline-primary",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                className: "fa fa-external-link can_open"
            }),
            " ",
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "view_btn", $b79edb411f97c469$var$me.language)
        ]
    });
}
function $b79edb411f97c469$export$7da962032bea416d(id, history) {
    history.push(`/visit/${id}`);
}
function $b79edb411f97c469$export$740e95a8bcb6fc23(id, history) {
    // history.push(`/task/${id}`);
    const url = `/task/${id}`;
    window.open(url, "_blank");
}
function $b79edb411f97c469$export$4d720b473d623c57(id) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("a", {
        href: `/task/${id}`,
        className: "btn btn-sm btn-outline-primary",
        target: "_blank",
        children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
            className: "fa fa-external-link can_open"
        })
    });
}
function $b79edb411f97c469$export$d6542303192de6db(id) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
        href: `/route/${id}`,
        className: "btn btn-sm btn-outline-primary",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                className: "fa fa-external-link can_open"
            }),
            " ",
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "view_btn", $b79edb411f97c469$var$me.language)
        ]
    });
}
function $b79edb411f97c469$export$281930d8a4ea9324(id) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
        href: `/merchandiser/${id}`,
        className: "btn btn-sm btn-outline-primary",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                className: "fa fa-external-link can_open"
            }),
            " ",
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "view_btn", $b79edb411f97c469$var$me.language)
        ]
    });
}
function $b79edb411f97c469$export$a74f05c2c46ea846(id) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
        href: `/point/${id}`,
        className: "btn btn-sm btn-outline-primary",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                className: "fa fa-external-link can_open"
            }),
            " ",
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "view_btn", $b79edb411f97c469$var$me.language)
        ]
    });
}
function $b79edb411f97c469$export$9f048bf86ee2e9d2(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        children: (item.points || []).map((i, idx)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
                children: i.point?.name
            }, (i.point?.name || "") + idx))
    });
}
function $b79edb411f97c469$export$ae8c54d47e00baf9(i, item) {
    return item.points?.length || 0;
}
function $b79edb411f97c469$export$105684a3041cb6f3(i, item) {
    return item.point ? item.point.name + " - " + item.point.address : "";
}
function $b79edb411f97c469$export$3470fb9eaf0b9df3(i, item, cb) {
    if (!item.point) return;
    let date = "";
    if (item.start) {
        let newDate = new Date(item.start);
        date = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(newDate).format("DD/MM/yyyy");
    }
    const author = `${item.user?.first_name || ""} ${item.user?.last_name || ""}`.trim();
    return /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
        href: `/visit/${item.id}`,
        onClick: ()=>{
            if (cb) cb(i);
        },
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("strong", {
                children: `${item.point.locality?.name || ""} - ${item.point.name} - ${item.point.address} - ${date}`
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                className: "added-by",
                children: (0, $3b579ca6158bc61b$export$f76670bfb9d67b64)(item.start, (0, $fc3f36407bc5ec6c$export$34f353d91e697be5), $b79edb411f97c469$var$me.language, author)
            })
        ]
    });
}
function $b79edb411f97c469$export$13ebfc76bc2797eb(i, item) {
    if (!item.point) return;
    let date = "";
    if (item.start) {
        let newDate = new Date(item.start);
        date = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(newDate).format("DD.MM.yyyy HH:mm");
    }
    const author = `${item.user?.first_name || ""} ${item.user?.last_name || ""}`.trim();
    const visitFullName = `${item.point.locality?.name || ""} - ${item.point.name} - ${item.point.address}`;
    const visitDate = date;
    return {
        name: visitFullName,
        date: visitDate,
        author: author
    };
}
function $b79edb411f97c469$export$8bafef2117b24af6(i, item) {
    if (!item.collect_status_reports) return;
    const values = [
        item.collect_status_reports.completed_reports >= 0 ? item.collect_status_reports.completed_reports : 0,
        item.collect_status_reports.on_review_reports >= 0 ? item.collect_status_reports.on_review_reports : 0,
        item.collect_status_reports.not_completed_reports >= 0 ? item.collect_status_reports.not_completed_reports : 0
    ];
    const total = values.reduce((sum, value)=>sum + value, 0);
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: `vt-status-bar ${total === 0 ? "vt-status-bar--empty" : ""}`,
        children: values.map((value, index)=>{
            const percentage = total > 0 ? value / total * 100 : 0;
            const cls = index === 0 ? "vt-seg--approved" : index === 1 ? "vt-seg--pending" : "vt-seg--rejected";
            const label = index === 0 ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "approved_label_popup", $b79edb411f97c469$var$me.language) : index === 1 ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "pending_label_popup", $b79edb411f97c469$var$me.language) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "rejected_label_popup", $b79edb411f97c469$var$me.language);
            return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: `vt-seg ${cls}`,
                style: {
                    width: `${percentage}%`,
                    display: percentage === 0 ? "none" : "flex"
                },
                title: `${label}: ${value}`,
                children: value
            }, index);
        })
    });
}
function $b79edb411f97c469$export$4e1468365cefb5e6(i, item) {
    if (!item.collect_status_reports?.progress_reports) return;
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "vt-progress",
        children: item.collect_status_reports.progress_reports
    });
}
function $b79edb411f97c469$export$1ca6f3165be21213(i, item, cb) {
    if (!item.id) return;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "vt-action-menu",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                className: "vt-action-trigger",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "material-symbols-outlined",
                    children: "more_horiz"
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "vt-action-dropdown",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "vt-action-option vt-action-option--approve",
                        onClick: ()=>cb(item, "approve"),
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "check_circle"
                            }),
                            "Approve"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "vt-action-option vt-action-option--reject",
                        onClick: ()=>cb(item, "reject"),
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "cancel"
                            }),
                            "Reject"
                        ]
                    })
                ]
            })
        ]
    });
}
function $b79edb411f97c469$export$907f4281a0c616d7(i, item, cb) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "visit-item-action",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($50ec5b37110e6f17$exports))),
                alt: "visit action nav",
                className: "visit-action-icon"
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("ul", {
                className: "visit-action-nav",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                        onClick: ()=>{
                            cb(item, "ACCEPT");
                        },
                        children: "Approve"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                        onClick: ()=>{
                            cb(item, "REJECT");
                        },
                        children: "Reject"
                    })
                ]
            })
        ]
    });
}
function $b79edb411f97c469$export$bba4d72e1a6638cc(i, item) {
    const className = item.is_approved ? "vt-dot vt-dot--approved" : item.is_approved === false ? "vt-dot vt-dot--rejected" : "vt-dot vt-dot--pending";
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        className: className
    });
}
function $b79edb411f97c469$export$f35ccf6735d96c0e(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        children: item?.tags?.map((i, idx)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "label rounded primary",
                children: i.name
            }, i.name + idx))
    });
}
function $b79edb411f97c469$export$75c35e4cb6dee965(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        children: item.components && item.components.map((i, idx)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "label rounded primary",
                children: i.name
            }, i.name + idx))
    });
}
function $b79edb411f97c469$export$b523d1688d2a81e9(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        children: item.negative_answers_count
    });
}
function $b79edb411f97c469$export$744c1575f41df3f5(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        children: item.last_answer && item.last_answer.answer
    });
}
function $b79edb411f97c469$export$1664ae65e1862c28(i, item) {
    const statusClass = item.status?.replace(/\s+/g, "-").toLowerCase() || "";
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        className: `tbl-status-chip tbl-status-chip--${statusClass}`,
        children: item.status
    });
}
function $b79edb411f97c469$export$9b1227f6f21745df(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        children: item?.tags?.map((i, idx)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "label rounded primary",
                children: i.name
            }, i.name + idx))
    });
}
function $b79edb411f97c469$export$2a939cfc6449d94d(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        children: item.locality && item.locality.name && item.locality.name
    });
}
function $b79edb411f97c469$export$8181b7546ec825dd(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        className: `tbl-status-chip ${item.is_active ? "tbl-status-chip--completed" : "tbl-status-chip--cancelled"}`,
        children: item.is_active ? "Active" : "Not Active"
    });
}
function $b79edb411f97c469$export$8ecd76f1dc39c193(i, item) {
    return item && item.image_count;
}
function $b79edb411f97c469$export$75b1fe4b0cd8c2c9(i, item) {
    return item?.tags?.length;
}
function $b79edb411f97c469$export$d2d39d1adcc883a2(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
        className: "dayLabel",
        children: [
            " ",
            item && (0, $6f1c09625235f1f0$export$3241045aa1844a20)[item.day_of_the_week]
        ]
    });
}
function $b79edb411f97c469$export$c1c72f42e43ef7e9(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
        children: [
            " ",
            item && (0, $6f1c09625235f1f0$export$8e11240bfd4abd6)[item.movement]
        ]
    });
}
function $b79edb411f97c469$export$c86d3ca66f38ed60(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
        className: "merch-user-cell",
        children: [
            item.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                className: "merch-avatar",
                src: item.photo,
                onError: (e)=>{
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                }
            }) : null,
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "merch-avatar-fallback",
                style: item.photo ? {
                    display: "none"
                } : {},
                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "material-symbols-outlined",
                    children: "person"
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                className: "merch-user-name",
                children: [
                    item && item.first_name,
                    " ",
                    item && item.last_name
                ]
            })
        ]
    });
}
function $b79edb411f97c469$export$83b02d1bc3b143d2(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        className: `merch-status-chip ${item.is_active ? "merch-status-chip--active" : "merch-status-chip--inactive"}`,
        children: item.is_active ? "Active" : "Not Active"
    });
}
function $b79edb411f97c469$export$43d108cb566ddefd(i, item, cb) {
    if (item.point && item.point.responsible_supervisors?.length) {
        let user = item.point.responsible_supervisors[0];
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            className: "tbl-user-cell",
            children: [
                user.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                    className: "tbl-user-avatar",
                    src: user.photo,
                    onError: (e)=>{
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                    }
                }) : null,
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "tbl-user-avatar-fallback",
                    style: user.photo ? {
                        display: "none"
                    } : {},
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "person"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                    className: "tbl-user-name",
                    children: [
                        user.first_name,
                        " ",
                        user.last_name
                    ]
                })
            ]
        });
    }
}
function $b79edb411f97c469$export$99f62f7c9ad8c7ce(i, item) {
    const user = item.created_by;
    if (user) return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
        className: "tbl-user-cell",
        children: [
            user.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                className: "tbl-user-avatar",
                src: user.photo,
                onError: (e)=>{
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                }
            }) : null,
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "tbl-user-avatar-fallback",
                style: user.photo ? {
                    display: "none"
                } : {},
                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "material-symbols-outlined",
                    children: "person"
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                className: "tbl-user-name",
                children: [
                    user.first_name,
                    " ",
                    user.last_name
                ]
            })
        ]
    });
}
function $b79edb411f97c469$export$7f6290e025a69ad2(i, item) {
    const user = item.point?.responsible_merchandiser;
    if (user) return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
        className: "tbl-user-cell",
        children: [
            user.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                className: "tbl-user-avatar",
                src: user.photo,
                onError: (e)=>{
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                }
            }) : null,
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "tbl-user-avatar-fallback",
                style: user.photo ? {
                    display: "none"
                } : {},
                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "material-symbols-outlined",
                    children: "person"
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                className: "tbl-user-name",
                children: [
                    user.first_name,
                    " ",
                    user.last_name
                ]
            })
        ]
    });
}
function $b79edb411f97c469$export$829751009cf59fbd(i, item, cb) {
    if (!item.user) return;
    return /*#__PURE__*/ (0, $7uT18.jsx)("a", {
        href: `/visit/${item.id}`,
        onClick: ()=>{
            if (cb) cb(item.id);
        },
        children: item.user.first_name + " " + item.user.last_name
    });
}
function $b79edb411f97c469$export$7fb42650ba730a60(i, item) {
    if (item.point && item.point.responsible_merchandiser) {
        let user = item.point.responsible_merchandiser;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            children: [
                user.phone_number,
                " "
            ]
        });
    }
}
function $b79edb411f97c469$export$c2dc1fe4fd2f6ef2(i, item) {
    if (!item.network) return null;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
        className: "tbl-user-cell",
        children: [
            item.network.image ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                className: "tbl-user-avatar",
                src: item.network.image,
                onError: (e)=>{
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                }
            }) : null,
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "tbl-user-avatar-fallback",
                style: item.network.image ? {
                    display: "none"
                } : {},
                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "material-symbols-outlined",
                    children: "store"
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "tbl-user-name",
                children: item.network.name
            })
        ]
    });
}
function $b79edb411f97c469$export$6d56db8f73608157(i, item) {
    return item.network && item.network.name && item.network.name;
}
function $b79edb411f97c469$export$149fc3ca3854b024(id) {
    let networkName = "";
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "GET",
        url: (0, $91ea30cb49819b9a$export$da688e121885cf48)["network"]
    }, (response)=>{
        networkName = response?.find((item)=>item.id === id)?.name;
    });
    return networkName || "\u2014";
}
function $b79edb411f97c469$export$6b5a18fc371da38a(i, item) {
    if (!item.date_joined) return;
    let date = new Date(item.date_joined);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("DD/MM/yyyy");
}
function $b79edb411f97c469$export$2615b096aa5889ca(i, item) {
    if (!item.date_till_newbie) return;
    let date = new Date(item.date_till_newbie);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("DD/MM/yyyy");
}
function $b79edb411f97c469$export$531029b4f5a1dc80(i, item) {
    if (!item.date_deactivated) return;
    let date = new Date(item.date_deactivated);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("DD/MM/yyyy");
}
function $b79edb411f97c469$export$4f156e78e4624fdc(i, item) {
    if (!item.time_spent) return;
    const seconds = item.time_spent;
    let minutes = Math.floor(seconds / 60);
    let remainingSeconds = Math.floor(seconds % 60);
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "vt-time",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "material-symbols-outlined",
                children: "schedule"
            }),
            minutes,
            "m ",
            remainingSeconds,
            "s"
        ]
    });
}
function $b79edb411f97c469$export$59c169eede4fa7cb(item) {
    if (!item?.time_spent) return;
    const seconds = item.time_spent;
    let minutes = Math.floor(seconds / 60);
    if (minutes > 60) {
        minutes = Math.floor(minutes / 60);
        return `${minutes}h`;
    } else return `${minutes}m`;
}
function $b79edb411f97c469$export$d12cdf29102185cf(i, item, cb) {
    if (!item.approved_by) return;
    return /*#__PURE__*/ (0, $7uT18.jsx)("a", {
        href: `/visit/${item.id}`,
        onClick: ()=>{
            if (cb) cb(item.id);
        },
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            className: "approved-by",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                    className: "w-32 img-circle avatar-crop",
                    src: item.approved_by.photo ? item.approved_by.photo : (0, (/*@__PURE__*/$parcel$interopDefault($89dd00a53749c0ac$exports)))
                }),
                " ",
                item.approved_by.first_name,
                item.approved_by.last_name
            ]
        })
    });
}
function $b79edb411f97c469$export$1718d4b40b6ea71e(i, item) {
    if (!item.start) return;
    let date = new Date(item.start);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("DD/MM/yyyy");
}
function $b79edb411f97c469$export$450de2dd43fb03(i, item) {
    if (!item.end) return;
    let date = new Date(item.end);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("DD/MM/yyyy");
}
function $b79edb411f97c469$export$99df5a72dfc0a4c5(i, item) {
    if (!item.end) return;
    let date = new Date(item.created);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("DD/MM/yyyy");
}
function $b79edb411f97c469$export$236fe9b998ba9793(item) {
    if (!item || !item.created) return "\u2014";
    // Humanized, unambiguous format, e.g. "20 Jul 2026, 14:30".
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(new Date(item.created)).format("DD MMM YYYY, HH:mm");
}
function $b79edb411f97c469$export$990db37eaff487f0(i, item) {
    if (item.additional_info?.sale_price && item.additional_info.sale_price !== "None") {
        let sale_price = item.additional_info.sale_price;
        return /*#__PURE__*/ (0, $7uT18.jsx)("p", {
            children: sale_price
        });
    }
}
function $b79edb411f97c469$export$18a83674ba417afe(i, item) {
    if (item.additional_info?.price && item.additional_info.price !== "None") {
        let price = item.additional_info.price;
        return /*#__PURE__*/ (0, $7uT18.jsx)("p", {
            children: price
        });
    }
}
function $b79edb411f97c469$export$542a0fc0e045874(i, item) {
    if (item?.visit?.user) {
        let user = item.visit.user;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            className: "tbl-user-cell",
            children: [
                user.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                    className: "tbl-user-avatar",
                    src: user.photo,
                    onError: (e)=>{
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                    }
                }) : null,
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "tbl-user-avatar-fallback",
                    style: user.photo ? {
                        display: "none"
                    } : {},
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "person"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                    className: "tbl-user-name",
                    children: [
                        user.first_name,
                        " ",
                        user.last_name,
                        " ",
                        user.phone && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                            children: [
                                ", ",
                                user.phone
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
function $b79edb411f97c469$export$ed8c8c6a3de01cc6(type, item) {
    if (!item.approved_by) return;
    if (type === "name") return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            children: [
                item.approved_by.first_name,
                " ",
                item.approved_by.last_name
            ]
        })
    });
}
function $b79edb411f97c469$export$fa1c0d6984eb64ab(i, item) {
    if (item.visit && item.visit.point && item.visit.point.responsible_supervisors) {
        let user = item.visit.point.responsible_supervisors[0];
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            className: "tbl-user-cell",
            children: [
                user?.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                    className: "tbl-user-avatar",
                    src: user.photo,
                    onError: (e)=>{
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                    }
                }) : null,
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "tbl-user-avatar-fallback",
                    style: user?.photo ? {
                        display: "none"
                    } : {},
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "person"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                    className: "tbl-user-name",
                    children: [
                        user?.first_name,
                        " ",
                        user?.last_name,
                        (user?.phone || user?.phone_number) && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                            children: [
                                ", ",
                                user?.phone || user?.phone_number
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
function $b79edb411f97c469$export$3db7e6804ccca05c(item) {
    if (item?.task && item?.task.created_by) {
        let user = item?.task.created_by;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                    className: "w-32 img-circle avatar-crop",
                    src: user?.photo ? user?.photo : (0, (/*@__PURE__*/$parcel$interopDefault($89dd00a53749c0ac$exports)))
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                    children: [
                        user?.first_name,
                        " ",
                        user?.last_name
                    ]
                }),
                (user?.phone || user?.phone_number) && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                    children: [
                        " ,",
                        user?.phone || user?.phone_number
                    ]
                })
            ]
        });
    }
}
function $b79edb411f97c469$export$4f500e0c26949ef4(i, item) {
    item.network = item.task?.network;
    return item.network && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                className: "w-32 img-circle avatar-crop",
                src: item.network.image ? item.network.image : (0, (/*@__PURE__*/$parcel$interopDefault($930bed3725aa77d7$exports)))
            }),
            " ",
            item.network.name
        ]
    });
}
function $b79edb411f97c469$export$991779a709c15111(i, item) {
    if (item?.visit?.point) {
        let point = item.visit.point;
        return /*#__PURE__*/ (0, $7uT18.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
            to: "/point/" + point.id,
            target: "_blank",
            children: point.name
        });
    }
    return null;
}
function $b79edb411f97c469$export$ecb8412bb70195a7(i, item) {
    if (item?.task?.point) {
        let point = item.task.point;
        return /*#__PURE__*/ (0, $7uT18.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
            to: "/point/" + point.id,
            target: "_blank",
            children: point.name
        });
    }
    return null;
}
function $b79edb411f97c469$export$fb4d46cce654803b(i, item) {
    if (item?.task?.point) {
        let point = item.task.point;
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: "answers-row-item-link",
            children: point.name
        });
    }
    return null;
}
function $b79edb411f97c469$export$a985788839f3e1fb(item) {
    if (item.point) {
        let point = item.point;
        return /*#__PURE__*/ (0, $7uT18.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
            to: "/point/" + point.id,
            target: "_blank",
            children: point.name
        });
    }
}
function $b79edb411f97c469$export$6804b7f2414f8637(item) {
    if (item.point) {
        let point = item.point;
        return /*#__PURE__*/ (0, $7uT18.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
            to: "/point/" + point.id,
            target: "_blank",
            children: point.name
        });
    }
}
function $b79edb411f97c469$export$e11fec1cbe9a7ef6(i, item) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        children: (0, $6f1c09625235f1f0$export$bb34f3538ba26c7e)[item.task?.priority] ? (0, $6f1c09625235f1f0$export$bb34f3538ba26c7e)[item.task.priority] : ""
    });
}
function $b79edb411f97c469$export$4e4cb19dd88cd821(date) {
    if (!date) return;
    date = new Date(date);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("DD/MM/yyyy HH:mm");
}
function $b79edb411f97c469$export$7611a908c607f975(date) {
    date = new Date(date);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("yyyy-MM-DD");
}
function $b79edb411f97c469$export$1d2cbc16815d0cad(date) {
    date = new Date(date);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("yyyy-MM-DDTHH:mm:ss");
}
function $b79edb411f97c469$export$c038e2aee7415d32(date) {
    date = new Date(date);
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("yyyy-MM-DDT23:59:59");
}





const $3b579ca6158bc61b$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $3b579ca6158bc61b$export$b25c9bd295a2cb07(items, entity) {
    if (!Array.isArray(items)) return;
    items.forEach((item, idx)=>{
        let label = item?.name || "";
        if (entity === "merchandiser") label = item.first_name + " " + item.last_name;
        if (entity === "merchandisers") label = item.first_name + " " + item.last_name;
        if (entity === "supervisor") label = item.first_name + " " + item.last_name;
        if (entity === "created_by") label = item.first_name + " " + item.last_name;
        if (entity === "point" || entity === "points") label = item.name + ", " + item.locality.name;
        if (entity === "component") label = (0, $6f1c09625235f1f0$export$a32e78025ed8daad)?.[item.name] || item.name;
        if (entity === "absence_reason_templates") {
            label = item.reason;
            item.id = idx + 1;
        }
        items[idx] = {
            ...item,
            value: item.id,
            label: label
        };
        if (entity === "component") items[idx] = {
            ...item,
            value: item.id,
            label: label,
            name: label
        };
        else items[idx] = {
            ...item,
            value: item.id,
            label: label
        };
    });
    return items;
}
function $3b579ca6158bc61b$export$9df10f3a4586f4ff(value, SET) {
    let r = SET.find((o)=>{
        return o.value === value;
    });
    return r ? {
        value: value,
        label: r.label
    } : null;
}
function $3b579ca6158bc61b$export$2792442c660f5382(values, SET) {
    let list = [];
    let r = null;
    if (values && values.length > 0) values.map((value)=>{
        r = SET.find((o)=>{
            return o.value === value;
        });
        if (r) list.push(r);
    });
    return list;
}
function $3b579ca6158bc61b$export$e9dfd7d5a7d2342e(objects) {
    return objects.map((i)=>i.value);
}
function $3b579ca6158bc61b$export$3b30e4292f44b8c3(oldDate, days) {
    var date = new Date(oldDate);
    var b = date.getDate() + days;
    return date.setDate(b);
}
function $3b579ca6158bc61b$export$3c3bae935e39250a(oldDate, days) {
    return (0, $b79edb411f97c469$export$7611a908c607f975)($3b579ca6158bc61b$export$3b30e4292f44b8c3(oldDate, days));
}
function $3b579ca6158bc61b$export$f996c1bb09f018d3(oldDate, days) {
    return (0, $b79edb411f97c469$export$c038e2aee7415d32)($3b579ca6158bc61b$export$3b30e4292f44b8c3(oldDate, days));
}
function $3b579ca6158bc61b$export$ed8107b92751e3f2() {
    let start = new Date();
    start = start.setDate(start.getDate() - 14);
    start = (0, $b79edb411f97c469$export$7611a908c607f975)(start);
    let end = new Date();
    return {
        start: start,
        end: end
    };
}
function $3b579ca6158bc61b$export$728929c44bc0c14b(entity, entityFilter) {
    const excludeKeys = [
        "start",
        "end",
        "task_status",
        "createdDateFrom",
        "createdDateTo",
        "searchText",
        "newFilter",
        "filters",
        "isChange"
    ];
    let url = "";
    let isData = false;
    if (entityFilter) {
        for (const [key, value] of Object.entries(entityFilter))if (!excludeKeys.includes(key)) {
            if (entity === "visits/photos_from_reports") {
                isData = value?.toString().length > 0 ? value : false;
                if ([
                    "tag",
                    "brand",
                    "subcategory"
                ].includes(key) && isData) url += `&${key}=${value.name}`;
                else if (key === "product" && isData) url += `&${key}=${value.code}`;
                else if (key === "products" && isData) {
                    if (Array.isArray(value)) url += `&${key}=${value.map((el)=>el.code).join()}`;
                } else if (key === "point__networks" && isData) {
                    if (Array.isArray(value)) url += `&${key}=${value.map((el)=>el.id).join()}`;
                } else if (key === "users" && isData || key === "points" && isData) {
                    if (Array.isArray(value)) url += `&${key}=${value.map((el)=>el.id).join()}`;
                } else if (isData) {
                    if (Array.isArray(value)) url += `&${key}=${value.map((el)=>el.name).join()}`;
                    else url += `&${key}=${value}`;
                }
            } else if (entity === "merchandiser") url += `?${key}=${value}`;
            else if (entity === "visit") {
                let selfKey = key;
                if (key === "date_range" && value) url;
                // if (key === "supervisor" && value) selfKey = "supervisors";
                if (Array.isArray(value) && key != "date_range") url += `&${selfKey}=${value.map((el)=>el.id).join()}`;
                else if (value && key != "date_range") url += `&${selfKey}=${value}`;
            } else if (value) url += `&${key}=${value}`;
        }
        // if (entityFilter.createdDateFrom && entityFilter.createdDateTo) {
        //   let createdDateFrom = entityFilter.createdDateFrom ? dateFormat2(entityFilter.createdDateFrom) : "";
        //   let createdDateTo = entityFilter.createdDateTo ? dateFormat2(dateChange(entityFilter.createdDateTo, 1)) : "";
        //
        //   url += `&created__range=${createdDateFrom},${createdDateTo}`;
        // }
        if (entityFilter.createdDateFrom) {
            let createdDateFrom = entityFilter.createdDateFrom ? (0, $b79edb411f97c469$export$7611a908c607f975)(entityFilter.createdDateFrom) : "";
            url += `&created__gte=${createdDateFrom}`;
        }
        if (entityFilter.createdDateTo) {
            let createdDateTo = entityFilter.createdDateTo ? (0, $b79edb411f97c469$export$7611a908c607f975)($3b579ca6158bc61b$export$3b30e4292f44b8c3(entityFilter.createdDateTo, 1)) : "";
            url += `&created__lte=${createdDateTo}`;
        }
        if (entity !== "answers/photos_on_review") {
            if (entityFilter.start && entity === "visit") url += `&start__gte=${(0, $b79edb411f97c469$export$1d2cbc16815d0cad)(entityFilter.start)}`;
            if (entityFilter.end && entity === "visit") url += `&end__lte=${(0, $b79edb411f97c469$export$1d2cbc16815d0cad)(entityFilter.end)}`;
            if (entityFilter.start && entity !== "visit") url += `&start__gte=${(0, $b79edb411f97c469$export$7611a908c607f975)(entityFilter.start)}`; // === moment(entityFilter.start).format("YYYY-MM-DD");
            if (entityFilter.end && entity !== "visit") url += `&end__lte=${(0, $b79edb411f97c469$export$7611a908c607f975)($3b579ca6158bc61b$export$3b30e4292f44b8c3(entityFilter.end, 1))}`;
        }
        if (entity === "answers/photos_on_review" && entityFilter.start && entityFilter.end) {
            let start = (0, $b79edb411f97c469$export$7611a908c607f975)(entityFilter.start);
            let end = (0, $b79edb411f97c469$export$7611a908c607f975)($3b579ca6158bc61b$export$3b30e4292f44b8c3(entityFilter.end, 1));
            url += "&created__range=" + start + "," + end;
        }
        if (entity === "task") {
            if (entityFilter.task_deadline) url += `&is_expired=${entityFilter.task_deadline}`;
            if (entityFilter.task_negative) url += `&with_negative_answers=${entityFilter.task_negative}`;
            if (!!entityFilter.task_status) url += `&${entityFilter.task_status}=true`;
            if (!!entityFilter.searchText) url += `&search=${entityFilter.searchText}`;
        }
    }
    return url;
}
function $3b579ca6158bc61b$export$6daeeb4cea31fc5(type, post, task_type = "single") {
    let errors = {};
    if (!post.title) errors.title = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_title_task_msg", $3b579ca6158bc61b$var$me.language);
    if (!post.template) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_task_msg", $3b579ca6158bc61b$var$me.language);
    if (task_type === "single") {
        if (!post.point) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_point_msg", $3b579ca6158bc61b$var$me.language);
    } else if (task_type === "point_groups") {
        if (!post.point_groups) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_point_group_msg", $3b579ca6158bc61b$var$me.language);
        if (!post.title_group_uploads) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_point_group_name_msg", $3b579ca6158bc61b$var$me.language);
    }
    return {
        validate: Object.values(errors).length === 0,
        errors: errors
    };
}
function $3b579ca6158bc61b$export$73d9c7f6399747fc(imgUrl, cb) {
    (0, $6af2f97559267bd3$export$2e2bcd8739ae039)({
        method: "get",
        url: imgUrl,
        headers: {
            "Content-Type": "image/jpeg",
            "Access-Control-Allow-Origin": "*"
        },
        responseType: "blob"
    }).then((r)=>{
        var reader = new FileReader();
        reader.readAsDataURL(r.data);
        reader.onloadend = function() {
            var base64data = reader.result;
            cb(base64data);
        };
    });
}
function $3b579ca6158bc61b$var$get_url_extension(url) {
    return url.split(/[#?]/)[0].split(".").pop().trim();
}
function $3b579ca6158bc61b$export$320fa92043a195a9(imageUrl, blob) {
    return blob.replace("data:image/jpeg;base64,", "data:image/jpg;base64,");
}
const $3b579ca6158bc61b$export$d73ee8ef04f5226a = (group, name, lang)=>{
    const entry = group[name];
    if (!entry) return null;
    // Prefer the requested language, then fall back to English, then Ukrainian,
    // so newly-added languages (e.g. hy, ka) never render blank for untranslated keys.
    return entry[lang] || entry.en || entry.uk || null;
};
const $3b579ca6158bc61b$export$f76670bfb9d67b64 = (startDateString, group, lang, author)=>{
    const startDate = new Date(startDateString);
    const now = new Date();
    const elapsedMilliseconds = now - startDate;
    const seconds = Math.floor(elapsedMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);
    let unit, value;
    if (seconds < 60) {
        unit = "seconds";
        value = seconds;
    } else if (minutes < 60) {
        unit = "minutes";
        value = minutes;
    } else if (hours < 24) {
        unit = "hours";
        value = hours;
    } else if (days < 30) {
        unit = "days";
        value = days;
    } else if (months < 12) {
        unit = "months";
        value = months;
    } else {
        unit = "years";
        value = years > 1 ? "more than 1 year" : "1 year";
    }
    const translatedUnit = $3b579ca6158bc61b$export$d73ee8ef04f5226a(group, unit, lang);
    const translatedStart = $3b579ca6158bc61b$export$d73ee8ef04f5226a(group, "point_started_title", lang);
    const translatedAgo = $3b579ca6158bc61b$export$d73ee8ef04f5226a(group, "point_agoby_title", lang);
    return `${translatedStart} ${value} ${translatedUnit} ${translatedAgo} ${author}`;
};
function $3b579ca6158bc61b$export$547caeb1f7e674d3(imgUrl, owner, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "POST",
        url: "images/convert_image_to_base64/",
        post: {
            image: imgUrl
        }
    }, (object)=>{
        const base64 = $3b579ca6158bc61b$export$320fa92043a195a9(imgUrl, object.image);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: owner,
                image: base64
            }
        }, (image)=>{
            if (image && image.id) cb(image);
            else console.log(image);
        });
    });
}
const $3b579ca6158bc61b$export$d6f5c7e166773679 = async (imgUrl, owner, cb)=>{
    let imgId = null;
    await (0, $c9936523dc38c641$export$ae8c526ac59e8cc8)({
        method: "POST",
        url: "images/convert_image_to_base64/",
        post: {
            image: imgUrl
        }
    }, async (object)=>{
        const base64 = $3b579ca6158bc61b$export$320fa92043a195a9(imgUrl, object.image);
        await (0, $c9936523dc38c641$export$ae8c526ac59e8cc8)({
            method: "POST",
            url: "images/",
            post: {
                owner: owner,
                image: base64
            }
        }, (image)=>{
            if (image?.id) {
                cb(image);
                imgId = image?.id;
            } else console.log(image);
        });
    });
};
function $3b579ca6158bc61b$export$c29ae74e18ca569f(imagepath) {
    function toDataUrl(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
    }
    toDataUrl(imagepath, function(myBase64) {
        console.log("myBase64", myBase64); // myBase64 is the base64 string
    });
}
const $3b579ca6158bc61b$export$de8d7796f5e34b0c = {
    fieldIsRequired: $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "empty_field_msg", $3b579ca6158bc61b$var$me?.language ? $3b579ca6158bc61b$var$me.language : "en")
};
const $3b579ca6158bc61b$export$ddec11078e1d813a = (message = $3b579ca6158bc61b$export$de8d7796f5e34b0c.fieldIsRequired)=>{
    return message;
};
const $3b579ca6158bc61b$export$e5432d4c8eb97ea7 = ()=>{
    const data = localStorage.getItem("state");
    const user = JSON.parse(data);
    return user.me.role === "supervisor_manager" ? true : false;
};


function $7a6285dfd06c7e2f$export$2e2bcd8739ae039() {
    const { me: me } = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state);
    const dispatch = (0, $b83e93e5ef3de8b0$export$8ad76b76a4c905f8)();
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const [imgError, setImgError] = (0, $cQmXV.useState)(false);
    const ref = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(()=>{
        const handleClick = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClick);
        return ()=>document.removeEventListener("mousedown", handleClick);
    }, []);
    const callLogout = ()=>{
        dispatch((0, $cca4416321e611bf$export$a0973bcfe11b05c9)());
    };
    const initials = me?.first_name && me?.last_name ? `${me.first_name[0]}${me.last_name[0]}`.toUpperCase() : me?.first_name ? me.first_name[0].toUpperCase() : "?";
    const fullName = `${me?.first_name || ""} ${me?.last_name || ""}`.trim();
    const roleLabel = me?.role === "supervisor_manager" ? "Supervisor Manager" : me?.role === "supervisor" ? "Supervisor" : me?.role || "";
    const avatarNode = ()=>{
        if (me?.photo && !imgError) return /*#__PURE__*/ (0, $7uT18.jsx)("img", {
            src: me.photo,
            alt: fullName,
            onError: ()=>setImgError(true)
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: "md-nav-icon md-avatar-icon",
            children: "person"
        });
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "md-header-user",
        ref: ref,
        onClick: ()=>setOpen((v)=>!v),
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "md-avatar",
                children: avatarNode()
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "md-avatar-name",
                children: fullName
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "md-nav-icon",
                style: {
                    fontSize: "18px",
                    color: "var(--md-on-surface-variant)"
                },
                children: open ? "expand_less" : "expand_more"
            }),
            open && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "md-user-dropdown",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "md-dropdown-user-header",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "md-avatar md-avatar--lg",
                                children: avatarNode()
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-dropdown-user-info",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "md-dropdown-user-name",
                                        children: fullName
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "md-dropdown-user-role",
                                        children: roleLabel
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-dropdown-divider"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                        className: "md-dropdown-item",
                        to: "/profile",
                        onClick: ()=>setOpen(false),
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "md-nav-icon",
                                children: "manage_accounts"
                            }),
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), "my_profile", me?.language)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-dropdown-divider"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "md-dropdown-item md-dropdown-item--danger",
                        onClick: callLogout,
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "md-nav-icon",
                                children: "logout"
                            }),
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), "exit", me?.language)
                        ]
                    })
                ]
            })
        ]
    });
}


class $42ea7091a6245ec3$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    render() {
        const { me: me } = this.props;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "app-header md-top-bar",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "md-top-bar-inner",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                        "data-toggle": "modal",
                        "data-target": "#aside",
                        className: "md-mobile-menu-btn d-lg-none",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "md-nav-icon",
                            children: "menu"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-top-bar-company",
                        children: me && me.company && me.company.name
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-top-bar-actions",
                        children: me && /*#__PURE__*/ (0, $7uT18.jsx)((0, $7a6285dfd06c7e2f$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        });
    }
}






const $a1d7e4e3ae62364a$export$c84671f46d6a1ca = (props)=>{
    const updateLangFn = ()=>{
        setLang((prevState)=>({
                ...prevState,
                updateLang: !prevState.updateLang
            }));
    };
    const [lang, setLang] = (0, $cQmXV.useState)({
        updateLang: false,
        updateLangFn: updateLangFn
    });
    const me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "theme-1-light",
        children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $422de08ffd33db6b$export$214e5fb64d34c1fc).Provider, {
            value: lang,
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $daf81e188ce7b288$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    id: "content",
                    className: "app-content box-shadow-z3",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $42ea7091a6245ec3$export$2e2bcd8739ae039), {
                            me: me
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "app-body",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $c4ecd91a3fcb0ac8$export$2e2bcd8739ae039), {
                                children: props.children
                            }, location.pathname)
                        })
                    ]
                })
            ]
        })
    });
};



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



class $0c0a79c705228dbe$var$ForgotPassword extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            email: "",
            errors: {}
        };
    }
    render() {
        const { email: email, errors: errors } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "md-login-page",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "md-login-card",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-login-logo",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ec66791105d99c56$exports))),
                            alt: "PicSell"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "md-login-description",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                style: {
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    color: "var(--md-on-surface)",
                                    marginBottom: "8px"
                                },
                                children: "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                children: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0441\u0432\u043E\u044E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u043D\u0438\u0436\u0447\u0435, \u0456 \u043C\u0438 \u043D\u0430\u0434\u0456\u0448\u043B\u0435\u043C\u043E \u0432\u0430\u043C \u0456\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u0457 \u0449\u043E\u0434\u043E \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "md-login-field",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                children: "E-mail"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                type: "email",
                                placeholder: "email@example.com",
                                value: email,
                                onChange: (e)=>this.setState({
                                        email: e.target.value,
                                        errors: {}
                                    })
                            }),
                            errors.email && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                style: {
                                    color: "var(--md-error)",
                                    fontSize: "12px",
                                    marginTop: "4px",
                                    display: "block"
                                },
                                children: errors.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        className: "md-login-btn",
                        onClick: this.reset,
                        children: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-login-back",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: "\u2190 \u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0432\u0445\u043E\u0434\u0443"
                        })
                    })
                ]
            })
        });
    }
}
var $0c0a79c705228dbe$export$2e2bcd8739ae039 = (0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        inText: (key)=>state.inText("forgot-password")(key)
    }))($0c0a79c705228dbe$var$ForgotPassword);



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");








class $d840257e31fd14f4$var$Login extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            phone_number: "",
            password: "",
            loading: false,
            errors: {}
        };
    }
    handleKeyPress = (e)=>{
        if (e.nativeEvent.keyCode === 13) this.login();
    };
    change = (field)=>{
        this.setState(field, ()=>{
            this.setState({
                errors: {}
            });
        });
    };
    login = ()=>{
        const { dispatch: dispatch, history: history } = this.props;
        let { phone_number: phone_number, password: password } = this.state;
        phone_number = phone_number.trim();
        this.setState({
            loading: true
        });
        (0, $c9936523dc38c641$export$73693bad9f5880b0)({
            phone_number: phone_number,
            password: password
        }).then((res)=>{
            if (res.user) {
                if (res.user.role == "supervisor" || res.user.role == "supervisor_manager") {
                    res.user.key = res.key;
                    res.user.company = res.related.company;
                    res.user.client = res.related.client;
                    res.user.county = res.related.county;
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$62d0a6d9a23c818), "login_success_msg", "en"));
                    dispatch((0, $cca4416321e611bf$export$596d806903d1f59e)(res.user));
                    history.replace("/photo-review");
                    window.location.reload();
                } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error("Currently just users with SUPERVISOR role allowed to enter the system");
            } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$62d0a6d9a23c818), "login_error_msg", "en"));
        }).catch((err)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(String(err));
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
    };
    render() {
        const { phone_number: phone_number, password: password, loading: loading } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "md-login-page",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "md-login-card",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-login-logo",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ec66791105d99c56$exports))),
                            alt: "PicSell"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "md-login-subtitle",
                        children: "\u0412\u0445\u0456\u0434 \u0434\u043E PicSell Dashboard"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "md-login-field",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                children: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                type: "tel",
                                placeholder: "+380\u2026",
                                value: phone_number,
                                onChange: (e)=>this.change({
                                        phone_number: e.target.value
                                    }),
                                onKeyPress: this.handleKeyPress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "md-login-field",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                children: "\u041F\u0430\u0440\u043E\u043B\u044C"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                type: "password",
                                placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                value: password,
                                onChange: (e)=>this.change({
                                        password: e.target.value
                                    }),
                                onKeyPress: this.handleKeyPress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "md-login-btn",
                        onClick: this.login,
                        disabled: loading,
                        children: [
                            loading && /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-spinner fa-pulse fa-fw"
                            }),
                            "\u0423\u0432\u0456\u0439\u0442\u0438"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                            to: "/forgot-password",
                            className: "md-login-forgot",
                            children: "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"
                        })
                    })
                ]
            })
        });
    }
}
$d840257e31fd14f4$var$Login = (0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($d840257e31fd14f4$var$Login);
var $d840257e31fd14f4$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)($d840257e31fd14f4$var$Login);



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
const $9b4ba9aeb2db83c0$export$53f1cd6809577fc5 = (props)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "box row page-header",
        children: props.children
    });
const $9b4ba9aeb2db83c0$export$7f365262018175ea = (props)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "col-sm-6 text-left",
        children: /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
            className: "page-header-title",
            children: props.children
        })
    });
const $9b4ba9aeb2db83c0$export$dc78206a797fc4b8 = (props)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "col-sm-6 text-right",
        children: props.children
    });


class $d24c7edf7011cb65$var$View extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            list: []
        };
    }
    componentDidMount() {
        this.load();
    }
    load = ()=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "reports/"
        }, (r)=>{
            console.log(r);
            this.setState({
                list: r
            });
        });
    };
    render() {
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "box p-4",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "row",
                    children: this.state.list.map((i, j)=>{
                        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "col-md-12 bi-report",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("h4", {
                                    children: i.name
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("iframe", {
                                        src: i.url,
                                        width: "100%"
                                    })
                                })
                            ]
                        });
                    })
                })
            })
        });
    }
}
var $d24c7edf7011cb65$export$2e2bcd8739ae039 = $d24c7edf7011cb65$var$View;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
var $59913a149d1b8b97$exports = {};
$59913a149d1b8b97$exports = new URL("nav1.2443e9d1.svg", import.meta.url).toString();


var $41ab9b7e8cfe6521$exports = {};
$41ab9b7e8cfe6521$exports = new URL("nav2.4fd57679.svg", import.meta.url).toString();


var $3573dd7d5a6f9af8$exports = {};
$3573dd7d5a6f9af8$exports = new URL("nav3.a66264b4.svg", import.meta.url).toString();


var $71aa5c318e75d303$exports = {};
$71aa5c318e75d303$exports = new URL("nav4.7e0df318.svg", import.meta.url).toString();


var $1c4585f01b06c8b5$exports = {};
$1c4585f01b06c8b5$exports = new URL("logout.895f6ec1.png", import.meta.url).toString();


var $859a76cbd8e402e2$exports = {};
$859a76cbd8e402e2$exports = new URL("inbound.46d0b689.png", import.meta.url).toString();


function $1eb3b389e47a6059$export$2e2bcd8739ae039(name) {
    if (name == "nav1") return 0, (/*@__PURE__*/$parcel$interopDefault($59913a149d1b8b97$exports));
    if (name == "nav2") return 0, (/*@__PURE__*/$parcel$interopDefault($41ab9b7e8cfe6521$exports));
    if (name == "nav3") return 0, (/*@__PURE__*/$parcel$interopDefault($3573dd7d5a6f9af8$exports));
    if (name == "nav4") return 0, (/*@__PURE__*/$parcel$interopDefault($71aa5c318e75d303$exports));
    if (name == "form-upload") return 0, (/*@__PURE__*/$parcel$interopDefault($859a76cbd8e402e2$exports));
    if (name == "logout") return 0, (/*@__PURE__*/$parcel$interopDefault($1c4585f01b06c8b5$exports));
}




var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

var $107ef154586a6500$exports = {};
$107ef154586a6500$exports = new URL("avatar.e9912696.png", import.meta.url).toString();


var $34c1b6fc7380f55b$exports = {};
$34c1b6fc7380f55b$exports = new URL("avatar2.b4aed81d.png", import.meta.url).toString();


var $133fecb469a399cb$exports = {};
$133fecb469a399cb$exports = new URL("avatar3.1cb7f009.png", import.meta.url).toString();



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");


var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

const $42efd8b8c405ef9c$export$96e9906d6d93a972 = (props)=>{
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: `status ` + props.status
    });
};


const $3a12bc34b26161da$export$1f44aaf2ec115b54 = ({ item: item })=>{
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "user",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "avatar",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                    src: item.avatar,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                children: /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    className: "user_name",
                    children: item.name
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                children: /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    className: "location",
                    children: item.location
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                children: /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    className: "",
                    children: item.time_start
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                children: /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    children: item.time_end
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $42efd8b8c405ef9c$export$96e9906d6d93a972), {
                status: item.status
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                children: /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    children: item.num1
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                children: /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    children: item.num2
                })
            })
        ]
    }, item.id + item.name);
};


// const avatar={};
// const avatar2={};
// const avatar3={};
const $8564b2bba3f6f2be$var$users = [
    {
        id: 1,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($107ef154586a6500$exports))),
        name: "OsinniiD",
        location: "Watsons, \u0412\u043E\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0441\u044C\u043A\u0430",
        time_start: "14:19",
        time_end: "14:35",
        status: "yellow",
        num1: 419,
        num2: 420
    },
    {
        id: 2,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($34c1b6fc7380f55b$exports))),
        name: "OsinniiD",
        location: "Watsons, \u0412\u043E\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0441\u044C\u043A\u0430",
        time_start: "14:21",
        time_end: "14:27",
        status: "green",
        num1: 419,
        num2: 420
    },
    {
        id: 3,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($133fecb469a399cb$exports))),
        name: "OsinniiD",
        location: "Watsons, \u0412\u043E\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0441\u044C\u043A\u0430",
        time_start: "14:21",
        time_end: "14:22",
        status: "green",
        num1: 419,
        num2: 420
    },
    {
        id: 4,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($107ef154586a6500$exports))),
        name: "OsinniiD",
        location: "Watsons, \u0412\u043E\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0441\u044C\u043A\u0430",
        time_start: "14:54",
        time_end: "14:55",
        status: "yellow",
        num1: 419,
        num2: 420
    },
    {
        id: 5,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($34c1b6fc7380f55b$exports))),
        name: "OsinniiD",
        location: "Watsons, \u0412\u043E\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0441\u044C\u043A\u0430",
        time_start: "14:12",
        time_end: "15:15",
        status: "yellow",
        num1: 419,
        num2: 420
    },
    {
        id: 6,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($133fecb469a399cb$exports))),
        name: "OsinniiD",
        location: "Watsons, \u0412\u043E\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0441\u044C\u043A\u0430",
        time_start: "14:19",
        time_end: "14:25",
        status: "green",
        num1: 419,
        num2: 420
    }
];
const $8564b2bba3f6f2be$export$5134630abfb689e3 = ()=>{
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "default_card",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
                children: "Visits"
            }),
            $8564b2bba3f6f2be$var$users.map((item)=>/*#__PURE__*/ (0, $7uT18.jsx)((0, $3a12bc34b26161da$export$1f44aaf2ec115b54), {
                    item: item
                }))
        ]
    });
};



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

var $1Spf6 = parcelRequire("1Spf6");

var $3h5eW = parcelRequire("3h5eW");
var $3b0df4630db937bd$exports = {};
"use strict";
var $3b0df4630db937bd$var$has = Object.prototype.hasOwnProperty, $3b0df4630db937bd$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $3b0df4630db937bd$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $3b0df4630db937bd$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $3b0df4630db937bd$var$Events().__proto__) $3b0df4630db937bd$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $3b0df4630db937bd$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $3b0df4630db937bd$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $3b0df4630db937bd$var$EE(fn, context || emitter, once), evt = $3b0df4630db937bd$var$prefix ? $3b0df4630db937bd$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $3b0df4630db937bd$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $3b0df4630db937bd$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $3b0df4630db937bd$var$EventEmitter() {
    this._events = new $3b0df4630db937bd$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($3b0df4630db937bd$var$has.call(events, name)) names.push($3b0df4630db937bd$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $3b0df4630db937bd$var$prefix ? $3b0df4630db937bd$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $3b0df4630db937bd$var$prefix ? $3b0df4630db937bd$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $3b0df4630db937bd$var$prefix ? $3b0df4630db937bd$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $3b0df4630db937bd$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $3b0df4630db937bd$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $3b0df4630db937bd$var$prefix ? $3b0df4630db937bd$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $3b0df4630db937bd$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $3b0df4630db937bd$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $3b0df4630db937bd$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3b0df4630db937bd$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $3b0df4630db937bd$var$prefix ? $3b0df4630db937bd$var$prefix + event : event;
        if (this._events[evt]) $3b0df4630db937bd$var$clearEvent(this, evt);
    } else {
        this._events = new $3b0df4630db937bd$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$3b0df4630db937bd$var$EventEmitter.prototype.off = $3b0df4630db937bd$var$EventEmitter.prototype.removeListener;
$3b0df4630db937bd$var$EventEmitter.prototype.addListener = $3b0df4630db937bd$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$3b0df4630db937bd$var$EventEmitter.prefixed = $3b0df4630db937bd$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$3b0df4630db937bd$var$EventEmitter.EventEmitter = $3b0df4630db937bd$var$EventEmitter;
$3b0df4630db937bd$exports = $3b0df4630db937bd$var$EventEmitter;


// do not edit .js files directly - edit src/index.jst
var $b35facf8edac1181$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b35facf8edac1181$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $b35facf8edac1181$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($b35facf8edac1181$export$406cfe323c8bb8e4 || ($b35facf8edac1181$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $b35facf8edac1181$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $b35facf8edac1181$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.CALLBACK = "__googleMapsCallback";
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $b35facf8edac1181$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($b35facf8edac1181$export$3b0d6d7590275603.instance) {
            if (!$b35facf8edac1181$var$fastDeepEqual(this.options, $b35facf8edac1181$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($b35facf8edac1181$export$3b0d6d7590275603.instance.options)}`);
            return $b35facf8edac1181$export$3b0d6d7590275603.instance;
        }
        $b35facf8edac1181$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $b35facf8edac1181$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $b35facf8edac1181$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $b35facf8edac1181$export$406cfe323c8bb8e4.LOADING;
        return $b35facf8edac1181$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     */ createUrl() {
        let url = this.url;
        url += `?callback=${this.CALLBACK}`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const url = this.createUrl();
        const script = document.createElement("script");
        script.id = this.id;
        script.type = "text/javascript";
        script.src = url;
        script.onerror = this.loadErrorCallback.bind(this);
        script.defer = true;
        script.async = true;
        if (this.nonce) script.nonce = this.nonce;
        document.head.appendChild(script);
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.log(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    setCallback() {
        window.__googleMapsCallback = this.callback.bind(this);
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setCallback();
                this.setScript();
            }
        }
    }
}


var $cdd0a6fb98543113$exports = {};
"use strict";
$cdd0a6fb98543113$exports = $cdd0a6fb98543113$var$Point;
/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */ function $cdd0a6fb98543113$var$Point(x, y) {
    this.x = x;
    this.y = y;
}
$cdd0a6fb98543113$var$Point.prototype = {
    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */ clone: function() {
        return new $cdd0a6fb98543113$var$Point(this.x, this.y);
    },
    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ add: function(p) {
        return this.clone()._add(p);
    },
    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ sub: function(p) {
        return this.clone()._sub(p);
    },
    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ multByPoint: function(p) {
        return this.clone()._multByPoint(p);
    },
    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ divByPoint: function(p) {
        return this.clone()._divByPoint(p);
    },
    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */ mult: function(k) {
        return this.clone()._mult(k);
    },
    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */ div: function(k) {
        return this.clone()._div(k);
    },
    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */ rotate: function(a) {
        return this.clone()._rotate(a);
    },
    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */ rotateAround: function(a, p) {
        return this.clone()._rotateAround(a, p);
    },
    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */ matMult: function(m) {
        return this.clone()._matMult(m);
    },
    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */ unit: function() {
        return this.clone()._unit();
    },
    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */ perp: function() {
        return this.clone()._perp();
    },
    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */ round: function() {
        return this.clone()._round();
    },
    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */ mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */ equals: function(other) {
        return this.x === other.x && this.y === other.y;
    },
    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */ dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },
    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */ distSqr: function(p) {
        var dx = p.x - this.x, dy = p.y - this.y;
        return dx * dx + dy * dy;
    },
    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */ angle: function() {
        return Math.atan2(this.y, this.x);
    },
    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */ angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },
    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */ angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },
    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */ angleWithSep: function(x, y) {
        return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
    },
    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y, y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },
    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },
    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },
    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },
    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },
    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },
    _unit: function() {
        this._div(this.mag());
        return this;
    },
    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },
    _rotate: function(angle) {
        var cos = Math.cos(angle), sin = Math.sin(angle), x = cos * this.x - sin * this.y, y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle), sin = Math.sin(angle), x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y), y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },
    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};
/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */ $cdd0a6fb98543113$var$Point.convert = function(a) {
    if (a instanceof $cdd0a6fb98543113$var$Point) return a;
    if (Array.isArray(a)) return new $cdd0a6fb98543113$var$Point(a[0], a[1]);
    return a;
};


function $37af810246127036$var$a() {
    return ($37af810246127036$var$a = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var o = arguments[t];
            for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $37af810246127036$var$p(e, t) {
    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function $37af810246127036$var$l(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
var $37af810246127036$var$u = {
    width: "100%",
    height: "100%",
    left: 0,
    top: 0,
    margin: 0,
    padding: 0,
    position: "absolute"
}, $37af810246127036$var$h = function(t) {
    function o() {
        return t.apply(this, arguments) || this;
    }
    $37af810246127036$var$p(o, t);
    var n = o.prototype;
    return n.shouldComponentUpdate = function() {
        return !1;
    }, n.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            ref: this.props.registerChild,
            style: $37af810246127036$var$u
        });
    }, o;
}((0, $cQmXV.Component)), $37af810246127036$var$c = function(e) {
    function t(t) {
        var o;
        return (o = e.call(this) || this).gmapInstance = t, o;
    }
    $37af810246127036$var$p(t, e);
    var o = t.prototype;
    return o.getChildren = function() {
        return this.gmapInstance.props.children;
    }, o.getMousePosition = function() {
        return this.gmapInstance.mouse_;
    }, o.getUpdateCounter = function() {
        return this.gmapInstance.updateCounter_;
    }, o.dispose = function() {
        this.gmapInstance = null, this.removeAllListeners();
    }, t;
}((0, (/*@__PURE__*/$parcel$interopDefault($3b0df4630db937bd$exports)))), $37af810246127036$var$d = function(e, t) {
    for(var o = $37af810246127036$var$a({}, e), n = 0; n < t.length; n++){
        var r = t[n];
        r in o && delete o[r];
    }
    return o;
}, $37af810246127036$var$m = Object.prototype.hasOwnProperty;
function $37af810246127036$var$g(e, t) {
    return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
}
function $37af810246127036$var$_(e, t) {
    if ($37af810246127036$var$g(e, t)) return !0;
    if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
    var o = Object.keys(e), n = Object.keys(t);
    if (o.length !== n.length) return !1;
    for(var r = 0; r < o.length; r++)if (!$37af810246127036$var$m.call(t, o[r]) || !$37af810246127036$var$g(e[o[r]], t[o[r]])) return !1;
    return !0;
}
var $37af810246127036$var$f = {
    width: "100%",
    height: "100%",
    left: 0,
    top: 0,
    margin: 0,
    padding: 0,
    position: "absolute"
}, $37af810246127036$var$v = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    backgroundColor: "transparent",
    position: "absolute"
}, $37af810246127036$var$M = function(t) {
    function o(o) {
        var n;
        return (n = t.call(this, o) || this)._getState = function() {
            return {
                children: n.props.dispatcher.getChildren(),
                updateCounter: n.props.dispatcher.getUpdateCounter()
            };
        }, n._onChangeHandler = function() {
            if (n.dimensionsCache_) {
                var e = (n.state.children || []).length, t = n._getState();
                n.setState(t, function() {
                    return (t.children || []).length !== e && n._onMouseChangeHandler();
                });
            }
        }, n._onChildClick = function() {
            n.props.onChildClick && n.hoverChildProps_ && n.props.onChildClick(n.hoverKey_, n.hoverChildProps_);
        }, n._onChildMouseDown = function() {
            n.props.onChildMouseDown && n.hoverChildProps_ && n.props.onChildMouseDown(n.hoverKey_, n.hoverChildProps_);
        }, n._onChildMouseEnter = function(e, t) {
            n.dimensionsCache_ && (n.props.onChildMouseEnter && n.props.onChildMouseEnter(e, t), n.hoverChildProps_ = t, n.hoverKey_ = e, n.setState({
                hoverKey: e
            }));
        }, n._onChildMouseLeave = function() {
            if (n.dimensionsCache_) {
                var e = n.hoverKey_;
                null != e && (n.props.onChildMouseLeave && n.props.onChildMouseLeave(e, n.hoverChildProps_), n.hoverKey_ = null, n.hoverChildProps_ = null, n.setState({
                    hoverKey: null
                }));
            }
        }, n._onMouseAllow = function(e) {
            e || n._onChildMouseLeave(), n.allowMouse_ = e;
        }, n._onMouseChangeHandler = function() {
            n.allowMouse_ && n._onMouseChangeHandlerRaf();
        }, n._onMouseChangeHandlerRaf = function() {
            if (n.dimensionsCache_) {
                var t = n.props.dispatcher.getMousePosition();
                if (t) {
                    var o = [], r = n.props.getHoverDistance();
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.forEach(n.state.children, function(e, i) {
                        if (e && (void 0 !== e.props.latLng || void 0 !== e.props.lat || void 0 !== e.props.lng)) {
                            var s = null != e.key ? e.key : i, a = n.props.distanceToMouse(n.dimensionsCache_[s], t, e.props);
                            a < r && o.push({
                                key: s,
                                dist: a,
                                props: e.props
                            });
                        }
                    }), o.length) {
                        o.sort(function(e, t) {
                            return e.dist - t.dist;
                        });
                        var i = o[0].key, s = o[0].props;
                        n.hoverKey_ !== i && (n._onChildMouseLeave(), n._onChildMouseEnter(i, s));
                    } else n._onChildMouseLeave();
                } else n._onChildMouseLeave();
            }
        }, n._getDimensions = function(e) {
            return n.dimensionsCache_[e];
        }, n.dimensionsCache_ = {}, n.hoverKey_ = null, n.hoverChildProps_ = null, n.allowMouse_ = !0, n.state = $37af810246127036$var$a({}, n._getState(), {
            hoverKey: null
        }), n;
    }
    $37af810246127036$var$p(o, t);
    var n = o.prototype;
    return n.componentDidMount = function() {
        this.props.dispatcher.on("kON_CHANGE", this._onChangeHandler), this.props.dispatcher.on("kON_MOUSE_POSITION_CHANGE", this._onMouseChangeHandler), this.props.dispatcher.on("kON_CLICK", this._onChildClick), this.props.dispatcher.on("kON_MDOWN", this._onChildMouseDown);
    }, n.shouldComponentUpdate = function(e, t) {
        return !0 === this.props.experimental ? !$37af810246127036$var$_(this.props, e) || !$37af810246127036$var$_($37af810246127036$var$d(this.state, [
            "hoverKey"
        ]), $37af810246127036$var$d(t, [
            "hoverKey"
        ])) : !$37af810246127036$var$_(this.props, e) || !$37af810246127036$var$_(this.state, t);
    }, n.componentWillUnmount = function() {
        this.props.dispatcher.removeListener("kON_CHANGE", this._onChangeHandler), this.props.dispatcher.removeListener("kON_MOUSE_POSITION_CHANGE", this._onMouseChangeHandler), this.props.dispatcher.removeListener("kON_CLICK", this._onChildClick), this.props.dispatcher.removeListener("kON_MDOWN", this._onChildMouseDown), this.dimensionsCache_ = null;
    }, n.render = function() {
        var t = this, o = this.props.style || $37af810246127036$var$f;
        this.dimensionsCache_ = {};
        var n = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.map(this.state.children, function(o, n) {
            if (o) {
                if (void 0 === o.props.latLng && void 0 === o.props.lat && void 0 === o.props.lng) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(o, {
                    $geoService: t.props.geoService,
                    $onMouseAllow: t._onMouseAllow,
                    $prerender: t.props.prerender
                });
                var r = void 0 !== o.props.latLng ? o.props.latLng : {
                    lat: o.props.lat,
                    lng: o.props.lng
                }, i = t.props.insideMapPanes ? t.props.geoService.fromLatLngToDivPixel(r) : t.props.geoService.fromLatLngToCenterPixel(r), s = {
                    left: i.x,
                    top: i.y
                };
                if (void 0 !== o.props.seLatLng || void 0 !== o.props.seLat && void 0 !== o.props.seLng) {
                    var p = void 0 !== o.props.seLatLng ? o.props.seLatLng : {
                        lat: o.props.seLat,
                        lng: o.props.seLng
                    }, l = t.props.insideMapPanes ? t.props.geoService.fromLatLngToDivPixel(p) : t.props.geoService.fromLatLngToCenterPixel(p);
                    s.width = l.x - i.x, s.height = l.y - i.y;
                }
                var u = t.props.geoService.fromLatLngToContainerPixel(r), h = null != o.key ? o.key : n;
                return t.dimensionsCache_[h] = $37af810246127036$var$a({
                    x: u.x,
                    y: u.y
                }, r), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    key: h,
                    style: $37af810246127036$var$a({}, $37af810246127036$var$v, s),
                    className: o.props.$markerHolderClassName
                }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(o, {
                    $hover: h === t.state.hoverKey,
                    $getDimensions: t._getDimensions,
                    $dimensionKey: h,
                    $geoService: t.props.geoService,
                    $onMouseAllow: t._onMouseAllow,
                    $prerender: t.props.prerender
                }));
            }
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            style: o
        }, n);
    }, o;
}((0, $cQmXV.Component));
$37af810246127036$var$M.propTypes = {
    geoService: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    distanceToMouse: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    dispatcher: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    onChildClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    getHoverDistance: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    insideMapPanes: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    prerender: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool
}, $37af810246127036$var$M.defaultProps = {
    insideMapPanes: !1,
    prerender: !1
};
var $37af810246127036$var$y = {
    width: "50%",
    height: "50%",
    left: "50%",
    top: "50%",
    margin: 0,
    padding: 0,
    position: "absolute"
};
function $37af810246127036$var$C(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        style: $37af810246127036$var$y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($37af810246127036$var$M, $37af810246127036$var$a({}, t, {
        prerender: !0
    })));
}
var $37af810246127036$var$w, $37af810246127036$var$L, $37af810246127036$var$b, $37af810246127036$var$D = new Promise(function(e) {
    $37af810246127036$var$b = e;
}), $37af810246127036$var$z = function(e, t) {
    if (!e) return $37af810246127036$var$D;
    if ($37af810246127036$var$L) return $37af810246127036$var$L;
    e.libraries || (e.libraries = []);
    var o = [].concat(e.libraries);
    t && (0 !== o.length && o.includes("visualization") || o.push("visualization"), console.warn("heatmapLibrary will be deprecated in the future. Please use { libraries: ['visualization'] } in bootstrapURLKeys property instead"));
    var n;
    if ("undefined" == typeof window) throw new Error("google map cannot be loaded outside browser env");
    var r = e.key, s = function(e, t) {
        if (null == e) return {};
        var o, n, r = {}, i = Object.keys(e);
        for(n = 0; n < i.length; n++)t.indexOf(o = i[n]) >= 0 || (r[o] = e[o]);
        return r;
    }(e, [
        "key"
    ]);
    return $37af810246127036$var$w || ($37af810246127036$var$w = new (0, $b35facf8edac1181$export$3b0d6d7590275603)($37af810246127036$var$a({
        apiKey: r || ""
    }, s, {
        libraries: o
    }))), $37af810246127036$var$L = $37af810246127036$var$w.load().then(function() {
        return $37af810246127036$var$b(window.google.maps), window.google.maps;
    }), $37af810246127036$var$b($37af810246127036$var$L), $37af810246127036$var$L;
};
function $37af810246127036$var$k(e, t, o) {
    var n = o - t;
    return e === o ? e : ((e - t) % n + n) % n + t;
}
var $37af810246127036$var$O = function() {
    function e(e, t) {
        if (isNaN(e) || isNaN(t)) throw new Error("Invalid LatLng object: (" + e + ", " + t + ")");
        this.lat = +e, this.lng = +t;
    }
    return e.prototype.wrap = function() {
        return new e(this.lat, $37af810246127036$var$k(this.lng, -180, 180));
    }, e;
}();
$37af810246127036$var$O.convert = function(e) {
    return e instanceof $37af810246127036$var$O ? e : Array.isArray(e) ? new $37af810246127036$var$O(e[0], e[1]) : "lng" in e && "lat" in e ? new $37af810246127036$var$O(e.lat, e.lng) : e;
};
var $37af810246127036$var$x = function() {
    function e(e, t, o) {
        this.tileSize = e || 512, this._minZoom = t || 0, this._maxZoom = o || 52, this.latRange = [
            -85.05113,
            85.05113
        ], this.width = 0, this.height = 0, this.zoom = 0, this.center = new $37af810246127036$var$O(0, 0), this.angle = 0;
    }
    var t, o = e.prototype;
    return o.zoomScale = function(e) {
        return Math.pow(2, e);
    }, o.scaleZoom = function(e) {
        return Math.log(e) / Math.LN2;
    }, o.project = function(e, t) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($cdd0a6fb98543113$exports)))(this.lngX(e.lng, t), this.latY(e.lat, t));
    }, o.unproject = function(e, t) {
        return new $37af810246127036$var$O(this.yLat(e.y, t), this.xLng(e.x, t));
    }, o.lngX = function(e, t) {
        return (180 + e) * (t || this.worldSize) / 360;
    }, o.latY = function(e, t) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e * Math.PI / 360))) * (t || this.worldSize) / 360;
    }, o.xLng = function(e, t) {
        return 360 * e / (t || this.worldSize) - 180;
    }, o.yLat = function(e, t) {
        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e / (t || this.worldSize)) * Math.PI / 180)) - 90;
    }, o.locationPoint = function(e) {
        var t = this.project(e);
        return this.centerPoint._sub(this.point._sub(t)._rotate(this.angle));
    }, o.pointLocation = function(e) {
        var t = this.centerPoint._sub(e)._rotate(-this.angle);
        return this.unproject(this.point.sub(t));
    }, t = [
        {
            key: "minZoom",
            get: function() {
                return this._minZoom;
            },
            set: function(e) {
                this._minZoom = e, this.zoom = Math.max(this.zoom, e);
            }
        },
        {
            key: "maxZoom",
            get: function() {
                return this._maxZoom;
            },
            set: function(e) {
                this._maxZoom = e, this.zoom = Math.min(this.zoom, e);
            }
        },
        {
            key: "worldSize",
            get: function() {
                return this.tileSize * this.scale;
            }
        },
        {
            key: "centerPoint",
            get: function() {
                return new (0, (/*@__PURE__*/$parcel$interopDefault($cdd0a6fb98543113$exports)))(0, 0);
            }
        },
        {
            key: "size",
            get: function() {
                return new (0, (/*@__PURE__*/$parcel$interopDefault($cdd0a6fb98543113$exports)))(this.width, this.height);
            }
        },
        {
            key: "bearing",
            get: function() {
                return -this.angle / Math.PI * 180;
            },
            set: function(e) {
                this.angle = -$37af810246127036$var$k(e, -180, 180) * Math.PI / 180;
            }
        },
        {
            key: "zoom",
            get: function() {
                return this._zoom;
            },
            set: function(e) {
                var t = Math.min(Math.max(e, this.minZoom), this.maxZoom);
                this._zoom = t, this.scale = this.zoomScale(t), this.tileZoom = Math.floor(t), this.zoomFraction = t - this.tileZoom;
            }
        },
        {
            key: "x",
            get: function() {
                return this.lngX(this.center.lng);
            }
        },
        {
            key: "y",
            get: function() {
                return this.latY(this.center.lat);
            }
        },
        {
            key: "point",
            get: function() {
                return new (0, (/*@__PURE__*/$parcel$interopDefault($cdd0a6fb98543113$exports)))(this.x, this.y);
            }
        }
    ], function(e, t) {
        for(var o = 0; o < t.length; o++){
            var n = t[o];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }(e.prototype, t), e;
}(), $37af810246127036$var$T = function() {
    function e(e) {
        this.hasSize_ = !1, this.hasView_ = !1, this.transform_ = new $37af810246127036$var$x(e || 512);
    }
    var t = e.prototype;
    return t.setView = function(e, t, o) {
        this.transform_.center = $37af810246127036$var$O.convert(e), this.transform_.zoom = +t, this.transform_.bearing = +o, this.hasView_ = !0;
    }, t.setViewSize = function(e, t) {
        this.transform_.width = e, this.transform_.height = t, this.hasSize_ = !0;
    }, t.setMapCanvasProjection = function(e, t) {
        this.maps_ = e, this.mapCanvasProjection_ = t;
    }, t.canProject = function() {
        return this.hasSize_ && this.hasView_;
    }, t.hasSize = function() {
        return this.hasSize_;
    }, t.fromLatLngToCenterPixel = function(e) {
        return this.transform_.locationPoint($37af810246127036$var$O.convert(e));
    }, t.fromLatLngToDivPixel = function(e) {
        if (this.mapCanvasProjection_) {
            var t = new this.maps_.LatLng(e.lat, e.lng);
            return this.mapCanvasProjection_.fromLatLngToDivPixel(t);
        }
        return this.fromLatLngToCenterPixel(e);
    }, t.fromLatLngToContainerPixel = function(e) {
        if (this.mapCanvasProjection_) {
            var t = new this.maps_.LatLng(e.lat, e.lng);
            return this.mapCanvasProjection_.fromLatLngToContainerPixel(t);
        }
        var o = this.fromLatLngToCenterPixel(e);
        return o.x -= this.transform_.worldSize * Math.round(o.x / this.transform_.worldSize), o.x += this.transform_.width / 2, o.y += this.transform_.height / 2, o;
    }, t.fromContainerPixelToLatLng = function(e) {
        if (this.mapCanvasProjection_) {
            var t = this.mapCanvasProjection_.fromContainerPixelToLatLng(e);
            return {
                lat: t.lat(),
                lng: t.lng()
            };
        }
        var o = $37af810246127036$var$a({}, e);
        o.x -= this.transform_.width / 2, o.y -= this.transform_.height / 2;
        var n = this.transform_.pointLocation((0, (/*@__PURE__*/$parcel$interopDefault($cdd0a6fb98543113$exports))).convert(o));
        return n.lng -= 360 * Math.round(n.lng / 360), n;
    }, t.getWidth = function() {
        return this.transform_.width;
    }, t.getHeight = function() {
        return this.transform_.height;
    }, t.getZoom = function() {
        return this.transform_.zoom;
    }, t.getCenter = function() {
        return this.transform_.pointLocation({
            x: 0,
            y: 0
        });
    }, t.getBounds = function(e, t) {
        var o = e && e[0] || 0, n = e && e[1] || 0, r = e && e[2] || 0, i = e && e[3] || 0;
        if (this.getWidth() - n - i > 0 && this.getHeight() - o - r > 0) {
            var a = this.transform_.pointLocation((0, (/*@__PURE__*/$parcel$interopDefault($cdd0a6fb98543113$exports))).convert({
                x: i - this.getWidth() / 2,
                y: o - this.getHeight() / 2
            })), p = this.transform_.pointLocation((0, (/*@__PURE__*/$parcel$interopDefault($cdd0a6fb98543113$exports))).convert({
                x: this.getWidth() / 2 - n,
                y: this.getHeight() / 2 - r
            })), l = [
                a.lat,
                a.lng,
                p.lat,
                p.lng,
                p.lat,
                a.lng,
                a.lat,
                p.lng
            ];
            return t && (l = l.map(function(e) {
                return Math.round(e * t) / t;
            })), l;
        }
        return [
            0,
            0,
            0,
            0
        ];
    }, e;
}();
function $37af810246127036$var$S(e) {
    if (window.requestAnimationFrame) return window.requestAnimationFrame(e);
    var t = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
    return t ? t(e) : window.setTimeout(e, 1e3 / 60);
}
var $37af810246127036$var$E = Math.log2 ? Math.log2 : function(e) {
    return Math.log(e) / Math.LN2;
};
function $37af810246127036$var$P(e, t) {
    return Object.keys(e).reduce(function(o, n) {
        return t(e[n]) && (o[n] = e[n]), o;
    }, {});
}
var $37af810246127036$var$A = function(e) {
    if (null !== e && "object" == typeof e) {
        if (0 === Object.keys(e).length) return !0;
    } else if (null == e || "" === e) return !0;
    return !1;
}, $37af810246127036$var$I = Object.prototype.toString;
function $37af810246127036$var$N(e) {
    return "number" == typeof e || function(e) {
        return !!e && "object" == typeof e;
    }(e) && "[object Number]" === $37af810246127036$var$I.call(e);
}
var $37af810246127036$var$Z = null;
function $37af810246127036$var$j() {
    if ($37af810246127036$var$Z) return $37af810246127036$var$Z;
    if ("undefined" != typeof navigator) {
        var e = navigator.userAgent.indexOf("MSIE") > -1, t = navigator.userAgent.indexOf("Firefox") > -1, o = navigator.userAgent.toLowerCase().indexOf("op") > -1, n = navigator.userAgent.indexOf("Chrome") > -1, r = navigator.userAgent.indexOf("Safari") > -1;
        return n && r && (r = !1), n && o && (n = !1), $37af810246127036$var$Z = {
            isExplorer: e,
            isFirefox: t,
            isOpera: o,
            isChrome: n,
            isSafari: r
        };
    }
    return $37af810246127036$var$Z = {
        isChrome: !0,
        isExplorer: !1,
        isFirefox: !1,
        isOpera: !1,
        isSafari: !1
    };
}
var $37af810246127036$var$U = function(e) {
    return Function.prototype.toString.call(e);
};
function $37af810246127036$var$H(e) {
    if (!e || "object" != typeof e) return !1;
    var t = "function" == typeof e.constructor ? Object.getPrototypeOf(e) : Object.prototype;
    if (null === t) return !0;
    var o = t.constructor;
    return "function" == typeof o && o instanceof o && $37af810246127036$var$U(o) === $37af810246127036$var$U(Object);
}
function $37af810246127036$var$K(e, t, o, n) {
    e.addEventListener(t, o, function() {
        var e = !1;
        try {
            var t = Object.defineProperty({}, "passive", {
                get: function() {
                    e = !0;
                }
            });
            window.addEventListener("test", t, t), window.removeEventListener("test", t, t);
        } catch (t) {
            e = !1;
        }
        return e;
    }() ? {
        capture: n,
        passive: !0
    } : n);
}
var $37af810246127036$var$R, $37af810246127036$var$G = !("undefined" == typeof window || !window.document || !window.document.createElement);
$37af810246127036$var$R = $37af810246127036$var$G ? window : "undefined" != typeof self ? self : void 0;
var $37af810246127036$var$B, $37af810246127036$var$W = "undefined" != typeof document && document.attachEvent, $37af810246127036$var$V = !1;
if ($37af810246127036$var$G && !$37af810246127036$var$W) {
    var $37af810246127036$var$F = function() {
        var e = $37af810246127036$var$R.requestAnimationFrame || $37af810246127036$var$R.mozRequestAnimationFrame || $37af810246127036$var$R.webkitRequestAnimationFrame || function(e) {
            return $37af810246127036$var$R.setTimeout(e, 20);
        };
        return function(t) {
            return e(t);
        };
    }(), $37af810246127036$var$$ = ($37af810246127036$var$B = $37af810246127036$var$R.cancelAnimationFrame || $37af810246127036$var$R.mozCancelAnimationFrame || $37af810246127036$var$R.webkitCancelAnimationFrame || $37af810246127036$var$R.clearTimeout, function(e) {
        return $37af810246127036$var$B(e);
    }), $37af810246127036$var$q = function(e) {
        var t = e.__resizeTriggers__, o = t.firstElementChild, n = t.lastElementChild, r = o.firstElementChild;
        n.scrollLeft = n.scrollWidth, n.scrollTop = n.scrollHeight, r.style.width = o.offsetWidth + 1 + "px", r.style.height = o.offsetHeight + 1 + "px", o.scrollLeft = o.scrollWidth, o.scrollTop = o.scrollHeight;
    }, $37af810246127036$var$Y = function(e) {
        var t = this;
        $37af810246127036$var$q(this), this.__resizeRAF__ && $37af810246127036$var$$(this.__resizeRAF__), this.__resizeRAF__ = $37af810246127036$var$F(function() {
            (function(e) {
                return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height;
            })(t) && (t.__resizeLast__.width = t.offsetWidth, t.__resizeLast__.height = t.offsetHeight, t.__resizeListeners__.forEach(function(o) {
                o.call(t, e);
            }));
        });
    }, $37af810246127036$var$X = !1, $37af810246127036$var$J = "", $37af810246127036$var$Q = "animationstart", $37af810246127036$var$ee = "Webkit Moz O ms".split(" "), $37af810246127036$var$te = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ");
    if ($37af810246127036$var$G) {
        var $37af810246127036$var$oe = document.createElement("fakeelement");
        if (void 0 !== $37af810246127036$var$oe.style.animationName && ($37af810246127036$var$X = !0), !1 === $37af810246127036$var$X) {
            for(var $37af810246127036$var$ne = 0; $37af810246127036$var$ne < $37af810246127036$var$ee.length; $37af810246127036$var$ne++)if (void 0 !== $37af810246127036$var$oe.style[$37af810246127036$var$ee[$37af810246127036$var$ne] + "AnimationName"]) {
                $37af810246127036$var$J = "-" + $37af810246127036$var$ee[$37af810246127036$var$ne].toLowerCase() + "-", $37af810246127036$var$Q = $37af810246127036$var$te[$37af810246127036$var$ne], $37af810246127036$var$X = !0;
                break;
            }
        }
    }
    var $37af810246127036$var$re = "resizeanim", $37af810246127036$var$ie = "@" + $37af810246127036$var$J + "keyframes " + $37af810246127036$var$re + " { from { opacity: 0; } to { opacity: 0; } } ", $37af810246127036$var$se = $37af810246127036$var$J + "animation: 1ms " + $37af810246127036$var$re + "; ";
}
var $37af810246127036$var$ae = void 0 !== (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).createPortal, $37af810246127036$var$pe = $37af810246127036$var$ae ? (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).createPortal : (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).unstable_renderSubtreeIntoContainer, $37af810246127036$var$le = function(e) {
    return $37af810246127036$var$H(e) ? e : {
        lat: e[0],
        lng: e[1]
    };
}, $37af810246127036$var$ue = function(e, t) {
    return t < e ? e : t;
}, $37af810246127036$var$he = function(t) {
    function o(o) {
        var r;
        if ((r = t.call(this, o) || this)._getMinZoom = function() {
            if (r.geoService_.getWidth() > 0 || r.geoService_.getHeight() > 0) {
                var e = Math.ceil(r.geoService_.getWidth() / 256) + 2, t = Math.ceil(r.geoService_.getHeight() / 256) + 2, o = Math.max(e, t);
                return Math.ceil($37af810246127036$var$E(o));
            }
            return 3;
        }, r._computeMinZoom = function(e) {
            return $37af810246127036$var$A(e) ? r._getMinZoom() : e;
        }, r._mapDomResizeCallback = function() {
            if (r.resetSizeOnIdle_ = !0, r.maps_) {
                var e = r.props.center || r.props.defaultCenter, t = r.map_.getCenter();
                r.maps_.event.trigger(r.map_, "resize"), r.map_.setCenter(r.props.resetBoundsOnResize ? e : t);
            }
        }, r._setLayers = function(e) {
            e.forEach(function(e) {
                r.layers_[e] = new r.maps_[e], r.layers_[e].setMap(r.map_);
            });
        }, r._renderPortal = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($37af810246127036$var$M, {
                experimental: r.props.experimental,
                onChildClick: r._onChildClick,
                onChildMouseDown: r._onChildMouseDown,
                onChildMouseEnter: r._onChildMouseEnter,
                onChildMouseLeave: r._onChildMouseLeave,
                geoService: r.geoService_,
                insideMapPanes: !0,
                distanceToMouse: r.props.distanceToMouse,
                getHoverDistance: r._getHoverDistance,
                dispatcher: r.markersDispatcher_
            });
        }, r._initMap = function() {
            if (!r.initialized_) {
                r.initialized_ = !0;
                var e = $37af810246127036$var$le(r.props.center || r.props.defaultCenter);
                r.geoService_.setView(e, r.props.zoom || r.props.defaultZoom, 0), r._onBoundsChanged();
                var t = $37af810246127036$var$a({}, r.props.apiKey && {
                    key: r.props.apiKey
                }, r.props.bootstrapURLKeys);
                r.props.googleMapLoader(t, r.props.heatmapLibrary).then(function(e) {
                    if (r.mounted_) {
                        var t, o, i = r.geoService_.getCenter(), s = {
                            zoom: r.props.zoom || r.props.defaultZoom,
                            center: new e.LatLng(i.lat, i.lng)
                        };
                        r.props.heatmap.positions && (Object.assign($37af810246127036$var$l(r), {
                            heatmap: (t = e, o = r.props.heatmap, new t.visualization.HeatmapLayer({
                                data: o.positions.reduce(function(e, o) {
                                    var n = o.weight, r = void 0 === n ? 1 : n;
                                    return e.push({
                                        location: new t.LatLng(o.lat, o.lng),
                                        weight: r
                                    }), e;
                                }, [])
                            }))
                        }), function(e, t) {
                            var o = t.options, n = void 0 === o ? {} : o;
                            Object.keys(n).map(function(t) {
                                return e.set(t, n[t]);
                            });
                        }(r.heatmap, r.props.heatmap));
                        var p = $37af810246127036$var$P(e, $37af810246127036$var$H), u = "function" == typeof r.props.options ? r.props.options(p) : r.props.options, h = !$37af810246127036$var$A(r.props.draggable) && {
                            draggable: r.props.draggable
                        }, c = r._computeMinZoom(u.minZoom);
                        r.minZoom_ = c;
                        var d = $37af810246127036$var$a({}, {
                            overviewMapControl: !1,
                            streetViewControl: !1,
                            rotateControl: !0,
                            mapTypeControl: !1,
                            styles: [
                                {
                                    featureType: "poi",
                                    elementType: "labels",
                                    stylers: [
                                        {
                                            visibility: "off"
                                        }
                                    ]
                                }
                            ],
                            minZoom: 3
                        }, {
                            minZoom: c
                        }, u, s);
                        r.defaultDraggableOption_ = $37af810246127036$var$A(d.draggable) ? r.defaultDraggableOption_ : d.draggable;
                        var m = $37af810246127036$var$a({}, d, h);
                        m.minZoom = $37af810246127036$var$ue(m.minZoom, c);
                        var g = new e.Map((0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(r.googleMapDom_), m);
                        r.map_ = g, r.maps_ = e, r._setLayers(r.props.layerTypes);
                        var _ = e.version.match(/^3\.(\d+)\./), f = _ && Number(_[1]), v = $37af810246127036$var$l(r), M = Object.assign(new e.OverlayView, {
                            onAdd: function() {
                                var t = "undefined" != typeof screen ? screen.width + "px" : "2000px", o = "undefined" != typeof screen ? screen.height + "px" : "2000px", n = document.createElement("div");
                                if (n.style.backgroundColor = "transparent", n.style.position = "absolute", n.style.left = "0px", n.style.top = "0px", n.style.width = t, n.style.height = o, v.props.overlayViewDivStyle) {
                                    var r = v.props.overlayViewDivStyle;
                                    "object" == typeof r && Object.keys(r).forEach(function(e) {
                                        n.style[e] = r[e];
                                    });
                                }
                                this.getPanes().overlayMouseTarget.appendChild(n), v.geoService_.setMapCanvasProjection(e, M.getProjection()), $37af810246127036$var$ae ? v.setState({
                                    overlay: n
                                }) : $37af810246127036$var$pe(v, v._renderPortal(), n, function() {
                                    return v.setState({
                                        overlay: n
                                    });
                                });
                            },
                            onRemove: function() {
                                var e = v.state.overlay;
                                e && !$37af810246127036$var$ae && (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).unmountComponentAtNode(e), v.setState({
                                    overlay: null
                                });
                            },
                            draw: function() {
                                if (v.updateCounter_++, v._onBoundsChanged(g, e, !v.props.debounced), v.googleApiLoadedCalled_ || (v._onGoogleApiLoaded({
                                    map: g,
                                    maps: e,
                                    ref: v.googleMapDom_
                                }), v.googleApiLoadedCalled_ = !0), v.mouse_) {
                                    var t = v.geoService_.fromContainerPixelToLatLng(v.mouse_);
                                    v.mouse_.lat = t.lat, v.mouse_.lng = t.lng;
                                }
                                v._onChildMouseMove(), v.markersDispatcher_ && (v.markersDispatcher_.emit("kON_CHANGE"), v.fireMouseEventOnIdle_ && v.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE"));
                            }
                        });
                        r.overlay_ = M, M.setMap(g), r.props.heatmap.positions && r.heatmap.setMap(g), r.props.onTilesLoaded && e.event.addListener(g, "tilesloaded", function() {
                            v._onTilesLoaded();
                        }), e.event.addListener(g, "zoom_changed", function() {
                            v.geoService_.getZoom() !== g.getZoom() && (v.zoomAnimationInProgress_ || (v.zoomAnimationInProgress_ = !0, v._onZoomAnimationStart(g.zoom)), f < 32) && ((new Date).getTime() - r.zoomControlClickTime_ < 300 ? $37af810246127036$var$S(function() {
                                return $37af810246127036$var$S(function() {
                                    v.updateCounter_++, v._onBoundsChanged(g, e);
                                });
                            }) : (v.updateCounter_++, v._onBoundsChanged(g, e)));
                        }), e.event.addListener(g, "idle", function() {
                            if (r.resetSizeOnIdle_) {
                                r._setViewSize();
                                var t = r._computeMinZoom(u.minZoom);
                                t !== r.minZoom_ && (r.minZoom_ = t, g.setOptions({
                                    minZoom: t
                                })), r.resetSizeOnIdle_ = !1;
                            }
                            v.zoomAnimationInProgress_ && (v.zoomAnimationInProgress_ = !1, v._onZoomAnimationEnd(g.zoom)), v.updateCounter_++, v._onBoundsChanged(g, e), v.dragTime_ = 0, v.markersDispatcher_ && v.markersDispatcher_.emit("kON_CHANGE");
                        }), e.event.addListener(g, "mouseover", function() {
                            v.mouseInMap_ = !0;
                        }), e.event.addListener(g, "click", function() {
                            v.mouseInMap_ = !0;
                        }), e.event.addListener(g, "mouseout", function() {
                            v.mouseInMap_ = !1, v.mouse_ = null, v.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE");
                        }), e.event.addListener(g, "drag", function() {
                            v.dragTime_ = (new Date).getTime(), v._onDrag(g);
                        }), e.event.addListener(g, "dragend", function() {
                            var t = e.event.addListener(g, "idle", function() {
                                e.event.removeListener(t), v._onDragEnd(g);
                            });
                        }), e.event.addListener(g, "maptypeid_changed", function() {
                            v._onMapTypeIdChange(g.getMapTypeId());
                        });
                    }
                }).catch(function(e) {
                    throw r._onGoogleApiLoaded({
                        map: null,
                        maps: null,
                        ref: r.googleMapDom_
                    }), console.error(e), e;
                });
            }
        }, r._onGoogleApiLoaded = function() {
            var e;
            r.props.onGoogleApiLoaded && (e = r.props).onGoogleApiLoaded.apply(e, arguments);
        }, r._getHoverDistance = function() {
            return r.props.hoverDistance;
        }, r._onDrag = function() {
            var e;
            return r.props.onDrag && (e = r.props).onDrag.apply(e, arguments);
        }, r._onDragEnd = function() {
            var e;
            return r.props.onDragEnd && (e = r.props).onDragEnd.apply(e, arguments);
        }, r._onMapTypeIdChange = function() {
            var e;
            return r.props.onMapTypeIdChange && (e = r.props).onMapTypeIdChange.apply(e, arguments);
        }, r._onZoomAnimationStart = function() {
            var e;
            return r.props.onZoomAnimationStart && (e = r.props).onZoomAnimationStart.apply(e, arguments);
        }, r._onZoomAnimationEnd = function() {
            var e;
            return r.props.onZoomAnimationEnd && (e = r.props).onZoomAnimationEnd.apply(e, arguments);
        }, r._onTilesLoaded = function() {
            return r.props.onTilesLoaded && r.props.onTilesLoaded();
        }, r._onChildClick = function() {
            var e;
            if (r.props.onChildClick) return (e = r.props).onChildClick.apply(e, arguments);
        }, r._onChildMouseDown = function(e, t) {
            r.childMouseDownArgs_ = [
                e,
                t
            ], r.props.onChildMouseDown && r.props.onChildMouseDown(e, t, $37af810246127036$var$a({}, r.mouse_));
        }, r._onChildMouseUp = function() {
            var e;
            r.childMouseDownArgs_ && (r.props.onChildMouseUp && (e = r.props).onChildMouseUp.apply(e, r.childMouseDownArgs_.concat([
                $37af810246127036$var$a({}, r.mouse_)
            ])), r.childMouseDownArgs_ = null, r.childMouseUpTime_ = (new Date).getTime());
        }, r._onChildMouseMove = function() {
            var e;
            r.childMouseDownArgs_ && r.props.onChildMouseMove && (e = r.props).onChildMouseMove.apply(e, r.childMouseDownArgs_.concat([
                $37af810246127036$var$a({}, r.mouse_)
            ]));
        }, r._onChildMouseEnter = function() {
            var e;
            if (r.props.onChildMouseEnter) return (e = r.props).onChildMouseEnter.apply(e, arguments);
        }, r._onChildMouseLeave = function() {
            var e;
            if (r.props.onChildMouseLeave) return (e = r.props).onChildMouseLeave.apply(e, arguments);
        }, r._setViewSize = function() {
            if (r.mounted_) {
                if (document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement) r.geoService_.setViewSize(window.innerWidth, window.innerHeight);
                else {
                    var e = (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(r.googleMapDom_);
                    r.geoService_.setViewSize(e.clientWidth, e.clientHeight);
                }
                r._onBoundsChanged();
            }
        }, r._onWindowResize = function() {
            r.resetSizeOnIdle_ = !0;
        }, r._onMapMouseMove = function(e) {
            if (r.mouseInMap_) {
                var t = (new Date).getTime();
                t - r.mouseMoveTime_ > 50 && (r.boundingRect_ = e.currentTarget.getBoundingClientRect()), r.mouseMoveTime_ = t;
                var o = e.clientX - r.boundingRect_.left, n = e.clientY - r.boundingRect_.top;
                r.mouse_ || (r.mouse_ = {
                    x: 0,
                    y: 0,
                    lat: 0,
                    lng: 0
                }), r.mouse_.x = o, r.mouse_.y = n;
                var i = r.geoService_.fromContainerPixelToLatLng(r.mouse_);
                r.mouse_.lat = i.lat, r.mouse_.lng = i.lng, r._onChildMouseMove(), t - r.dragTime_ < 100 ? r.fireMouseEventOnIdle_ = !0 : (r.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE"), r.fireMouseEventOnIdle_ = !1);
            }
        }, r._onClick = function() {
            var e;
            return r.props.onClick && !r.childMouseDownArgs_ && (new Date).getTime() - r.childMouseUpTime_ > 300 && 0 === r.dragTime_ && (e = r.props).onClick.apply(e, arguments);
        }, r._onMapClick = function(e) {
            r.markersDispatcher_ && (r._onMapMouseMove(e), (new Date).getTime() - r.dragTime_ > 100 && (r.mouse_ && r._onClick($37af810246127036$var$a({}, r.mouse_, {
                event: e
            })), r.markersDispatcher_.emit("kON_CLICK", e)));
        }, r._onMapMouseDownNative = function(e) {
            r.mouseInMap_ && r._onMapMouseDown(e);
        }, r._onMapMouseDown = function(e) {
            r.markersDispatcher_ && (new Date).getTime() - r.dragTime_ > 100 && (r._onMapMouseMove(e), r.markersDispatcher_.emit("kON_MDOWN", e));
        }, r._onMapMouseDownCapture = function() {
            $37af810246127036$var$j().isChrome && (r.zoomControlClickTime_ = (new Date).getTime());
        }, r._onKeyDownCapture = function() {
            $37af810246127036$var$j().isChrome && (r.zoomControlClickTime_ = (new Date).getTime());
        }, r._isCenterDefined = function(e) {
            return e && ($37af810246127036$var$H(e) && $37af810246127036$var$N(e.lat) && $37af810246127036$var$N(e.lng) || 2 === e.length && $37af810246127036$var$N(e[0]) && $37af810246127036$var$N(e[1]));
        }, r._onBoundsChanged = function(e, t, o) {
            if (e) {
                var n = e.getCenter();
                r.geoService_.setView([
                    n.lat(),
                    n.lng()
                ], e.getZoom(), 0);
            }
            if ((r.props.onChange || r.props.onBoundsChange) && r.geoService_.canProject()) {
                var i = r.geoService_.getZoom(), s = r.geoService_.getBounds(), p = r.geoService_.getCenter();
                if (!function(e, t, o) {
                    if (e && t) {
                        for(var n = 0; n !== e.length; ++n)if (Math.abs(e[n] - t[n]) > 1e-5) return !1;
                        return !0;
                    }
                    return !1;
                }(s, r.prevBounds_) && !1 !== o) {
                    var l = r.geoService_.getBounds(r.props.margin);
                    r.props.onBoundsChange && r.props.onBoundsChange(r.centerIsObject_ ? $37af810246127036$var$a({}, p) : [
                        p.lat,
                        p.lng
                    ], i, s, l), r.props.onChange && r.props.onChange({
                        center: $37af810246127036$var$a({}, p),
                        zoom: i,
                        bounds: {
                            nw: {
                                lat: s[0],
                                lng: s[1]
                            },
                            se: {
                                lat: s[2],
                                lng: s[3]
                            },
                            sw: {
                                lat: s[4],
                                lng: s[5]
                            },
                            ne: {
                                lat: s[6],
                                lng: s[7]
                            }
                        },
                        marginBounds: {
                            nw: {
                                lat: l[0],
                                lng: l[1]
                            },
                            se: {
                                lat: l[2],
                                lng: l[3]
                            },
                            sw: {
                                lat: l[4],
                                lng: l[5]
                            },
                            ne: {
                                lat: l[6],
                                lng: l[7]
                            }
                        },
                        size: r.geoService_.hasSize() ? {
                            width: r.geoService_.getWidth(),
                            height: r.geoService_.getHeight()
                        } : {
                            width: 0,
                            height: 0
                        }
                    }), r.prevBounds_ = s;
                }
            }
        }, r._registerChild = function(e) {
            r.googleMapDom_ = e;
        }, r.mounted_ = !1, r.initialized_ = !1, r.googleApiLoadedCalled_ = !1, r.map_ = null, r.maps_ = null, r.prevBounds_ = null, r.heatmap = null, r.layers_ = {}, r.mouse_ = null, r.mouseMoveTime_ = 0, r.boundingRect_ = null, r.mouseInMap_ = !0, r.dragTime_ = 0, r.fireMouseEventOnIdle_ = !1, r.updateCounter_ = 0, r.markersDispatcher_ = new $37af810246127036$var$c($37af810246127036$var$l(r)), r.geoService_ = new $37af810246127036$var$T(256), r.centerIsObject_ = $37af810246127036$var$H(r.props.center), r.minZoom_ = 3, r.defaultDraggableOption_ = !0, r.zoomControlClickTime_ = 0, r.childMouseDownArgs_ = null, r.childMouseUpTime_ = 0, r.googleMapDom_ = null, r._isCenterDefined(r.props.center || r.props.defaultCenter)) {
            var i = $37af810246127036$var$le(r.props.center || r.props.defaultCenter);
            r.geoService_.setView(i, r.props.zoom || r.props.defaultZoom, 0);
        }
        return r.zoomAnimationInProgress_ = !1, r.state = {
            overlay: null
        }, r;
    }
    $37af810246127036$var$p(o, t);
    var r = o.prototype;
    return r.componentDidMount = function() {
        var e = this;
        this.mounted_ = !0, $37af810246127036$var$K(window, "resize", this._onWindowResize, !1), $37af810246127036$var$K(window, "keydown", this._onKeyDownCapture, !0);
        var t = (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(this.googleMapDom_);
        t && $37af810246127036$var$K(t, "mousedown", this._onMapMouseDownNative, !0), $37af810246127036$var$K(window, "mouseup", this._onChildMouseUp, !1);
        var o = $37af810246127036$var$a({}, this.props.apiKey && {
            key: this.props.apiKey
        }, this.props.bootstrapURLKeys);
        this.props.googleMapLoader(o, this.props.heatmapLibrary), setTimeout(function() {
            e._setViewSize(), e._isCenterDefined(e.props.center || e.props.defaultCenter) && e._initMap();
        }, 0, this), this.props.resetBoundsOnResize && function(e, t) {
            if (void 0 === e.parentNode) {
                var o = document.createElement("div");
                e.parentNode = o;
            }
            e = e.parentNode, $37af810246127036$var$W ? e.attachEvent("onresize", t) : (e.__resizeTriggers__ || ("static" == getComputedStyle(e).position && (e.style.position = "relative"), function() {
                if (!$37af810246127036$var$V) {
                    var e = ($37af810246127036$var$ie || "") + ".resize-triggers { " + ($37af810246127036$var$se || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', t = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
                    o.type = "text/css", o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e)), t.appendChild(o), $37af810246127036$var$V = !0;
                }
            }(), e.__resizeLast__ = {}, e.__resizeListeners__ = [], (e.__resizeTriggers__ = document.createElement("div")).className = "resize-triggers", e.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>', e.appendChild(e.__resizeTriggers__), $37af810246127036$var$q(e), $37af810246127036$var$K(e, "scroll", $37af810246127036$var$Y, !0), $37af810246127036$var$Q && e.__resizeTriggers__.addEventListener($37af810246127036$var$Q, function(t) {
                t.animationName == $37af810246127036$var$re && $37af810246127036$var$q(e);
            })), e.__resizeListeners__.push(t));
        }(t, this._mapDomResizeCallback);
    }, r.shouldComponentUpdate = function(e, t) {
        return !$37af810246127036$var$_($37af810246127036$var$d(this.props, [
            "draggable"
        ]), $37af810246127036$var$d(e, [
            "draggable"
        ])) || !$37af810246127036$var$_(this.state, t);
    }, r.componentDidUpdate = function(e) {
        var t = this;
        if (!this._isCenterDefined(e.center) && this._isCenterDefined(this.props.center) && setTimeout(function() {
            return t._initMap();
        }, 0), this.map_) {
            var o = this.geoService_.getCenter();
            if (this._isCenterDefined(this.props.center)) {
                var n = $37af810246127036$var$le(this.props.center), r = this._isCenterDefined(e.center) ? $37af810246127036$var$le(e.center) : null;
                (!r || Math.abs(n.lat - r.lat) + Math.abs(n.lng - r.lng) > 1e-5) && Math.abs(n.lat - o.lat) + Math.abs(n.lng - o.lng) > 1e-5 && this.map_.panTo({
                    lat: n.lat,
                    lng: n.lng
                });
            }
            if ($37af810246127036$var$A(this.props.zoom) || Math.abs(this.props.zoom - e.zoom) > 0 && this.map_.setZoom(this.props.zoom), !$37af810246127036$var$A(e.draggable) && $37af810246127036$var$A(this.props.draggable) ? this.map_.setOptions({
                draggable: this.defaultDraggableOption_
            }) : $37af810246127036$var$_(e.draggable, this.props.draggable) || this.map_.setOptions({
                draggable: this.props.draggable
            }), !$37af810246127036$var$A(this.props.options) && !$37af810246127036$var$_(e.options, this.props.options)) {
                var i = $37af810246127036$var$P(this.maps_, $37af810246127036$var$H), s = "function" == typeof this.props.options ? this.props.options(i) : this.props.options;
                if ("minZoom" in (s = $37af810246127036$var$d(s, [
                    "zoom",
                    "center",
                    "draggable"
                ]))) {
                    var a = this._computeMinZoom(s.minZoom);
                    s.minZoom = $37af810246127036$var$ue(s.minZoom, a);
                }
                this.map_.setOptions(s);
            }
            $37af810246127036$var$_(this.props.layerTypes, e.layerTypes) || (Object.keys(this.layers_).forEach(function(e) {
                t.layers_[e].setMap(null), delete t.layers_[e];
            }), this._setLayers(this.props.layerTypes)), this.heatmap && !$37af810246127036$var$_(this.props.heatmap.positions, e.heatmap.positions) && this.heatmap.setData(this.props.heatmap.positions.map(function(e) {
                return {
                    location: new t.maps_.LatLng(e.lat, e.lng),
                    weight: e.weight
                };
            })), this.heatmap && !$37af810246127036$var$_(this.props.heatmap.options, e.heatmap.options) && Object.keys(this.props.heatmap.options).forEach(function(e) {
                t.heatmap.set(e, t.props.heatmap.options[e]);
            });
        }
        this.markersDispatcher_.emit("kON_CHANGE"), $37af810246127036$var$_(this.props.hoverDistance, e.hoverDistance) || this.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE");
    }, r.componentWillUnmount = function() {
        this.mounted_ = !1;
        var e, t, o = (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(this.googleMapDom_);
        o && o.removeEventListener("mousedown", this._onMapMouseDownNative, !0), window.removeEventListener("resize", this._onWindowResize), window.removeEventListener("keydown", this._onKeyDownCapture), window.removeEventListener("mouseup", this._onChildMouseUp, !1), this.props.resetBoundsOnResize && (t = this._mapDomResizeCallback, e = (e = o).parentNode, $37af810246127036$var$W ? e.detachEvent("onresize", t) : (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1), e.__resizeListeners__.length || (e.removeEventListener("scroll", $37af810246127036$var$Y), e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__)))), this.overlay_ && this.overlay_.setMap(null), this.maps_ && this.map_ && this.props.shouldUnregisterMapOnUnmount && (this.map_.setOptions({
            scrollwheel: !1
        }), this.maps_.event.clearInstanceListeners(this.map_)), this.props.shouldUnregisterMapOnUnmount && (this.map_ = null, this.maps_ = null), this.markersDispatcher_.dispose(), this.resetSizeOnIdle_ = !1, this.props.shouldUnregisterMapOnUnmount && (delete this.map_, delete this.markersDispatcher_);
    }, r.render = function() {
        var t = this.state.overlay, o = t ? null : (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($37af810246127036$var$C, {
            experimental: this.props.experimental,
            onChildClick: this._onChildClick,
            onChildMouseDown: this._onChildMouseDown,
            onChildMouseEnter: this._onChildMouseEnter,
            onChildMouseLeave: this._onChildMouseLeave,
            geoService: this.geoService_,
            insideMapPanes: !1,
            distanceToMouse: this.props.distanceToMouse,
            getHoverDistance: this._getHoverDistance,
            dispatcher: this.markersDispatcher_
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            style: this.props.style,
            onMouseMove: this._onMapMouseMove,
            onMouseDownCapture: this._onMapMouseDownCapture,
            onClick: this._onMapClick
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($37af810246127036$var$h, {
            registerChild: this._registerChild
        }), $37af810246127036$var$ae && t && $37af810246127036$var$pe(this._renderPortal(), t), o);
    }, o;
}((0, $cQmXV.Component));
function $37af810246127036$var$ce(e) {
    var t = e.lng, o = Math.sin(e.lat * Math.PI / 180), n = t / 360 + .5, r = .5 - .25 * Math.log((1 + o) / (1 - o)) / Math.PI;
    return {
        x: n,
        y: r = r < 0 ? 0 : r > 1 ? 1 : r
    };
}
function $37af810246127036$var$de(e) {
    var t = e.x, o = Math.PI - 2 * Math.PI * e.y;
    return {
        lat: 180 / Math.PI * Math.atan(.5 * (Math.exp(o) - Math.exp(-o))),
        lng: 360 * t - 180
    };
}
function $37af810246127036$var$me(e, t, o, n) {
    var r = $37af810246127036$var$ce(e), i = $37af810246127036$var$ce(t), s = r.x < i.x ? i.x - r.x : 1 - r.x + i.x, a = i.y - r.y;
    if (s <= 0 && a <= 0) return null;
    var p = $37af810246127036$var$E(o / 256 / Math.abs(s)), l = $37af810246127036$var$E(n / 256 / Math.abs(a)), u = Math.floor(1e-9 + Math.min(p, l)), h = {
        x: r.x < i.x ? .5 * (r.x + i.x) : r.x + i.x - 1 > 0 ? .5 * (r.x + i.x - 1) : .5 * (1 + r.x + i.x),
        y: .5 * (r.y + i.y)
    }, c = Math.pow(2, u), d = o / c / 256 / 2, m = n / c / 256 / 2, g = $37af810246127036$var$de({
        x: h.x - d,
        y: h.y - m
    }), _ = $37af810246127036$var$de({
        x: h.x + d,
        y: h.y + m
    });
    return {
        center: $37af810246127036$var$de(h),
        zoom: u,
        newBounds: {
            nw: g,
            se: _
        }
    };
}
function $37af810246127036$export$dd147e3f412d56db(e) {
    var t = e.ne, o = e.sw;
    return {
        nw: {
            lat: t.lat,
            lng: o.lng
        },
        se: {
            lat: o.lat,
            lng: t.lng
        }
    };
}
function $37af810246127036$export$ec38ee66035b8041(e) {
    var t = e.nw, o = e.se;
    return {
        ne: {
            lat: t.lat,
            lng: o.lng
        },
        sw: {
            lat: o.lat,
            lng: t.lng
        }
    };
}
function $37af810246127036$export$39d6891aa0da3250(e, t) {
    var o, n = e.nw, r = e.se, i = e.ne, s = e.sw, p = t.width, l = t.height;
    if (n && r) o = $37af810246127036$var$me(n, r, p, l);
    else {
        var u = $37af810246127036$export$dd147e3f412d56db({
            ne: i,
            sw: s
        });
        o = $37af810246127036$var$me(u.nw, u.se, p, l);
    }
    return $37af810246127036$var$a({}, o, {
        newBounds: $37af810246127036$var$a({}, o.newBounds, $37af810246127036$export$ec38ee66035b8041(o.newBounds))
    });
}
function $37af810246127036$export$60948347be70cf9e(e, t, o) {
    var n = function(e, t) {
        var o = function(e, t) {
            var o, n = t.lat, r = t.lng, i = (o = n * Math.PI / 180, {
                metersPerLatDegree: 111132.92 - 559.82 * Math.cos(2 * o) + 1.175 * Math.cos(4 * o) - .0023 * Math.cos(6 * o),
                metersPerLngDegree: 111412.84 * Math.cos(o) - 93.5 * Math.cos(3 * o) + .118 * Math.cos(5 * o)
            }), s = .5 * e / i.metersPerLatDegree, a = .5 * e / i.metersPerLngDegree;
            return {
                nw: {
                    lat: n - s,
                    lng: r - a
                },
                se: {
                    lat: n + s,
                    lng: r + a
                }
            };
        }(e, {
            lat: t.lat,
            lng: t.lng
        }), n = o.se, r = $37af810246127036$var$ce(o.nw), i = $37af810246127036$var$ce(n);
        return {
            w: Math.abs(i.x - r.x),
            h: Math.abs(i.y - r.y)
        };
    }(e, {
        lat: t.lat,
        lng: t.lng
    }), r = n.w, i = n.h, s = Math.pow(2, o);
    return {
        w: r * s * 256,
        h: i * s * 256
    };
}
function $37af810246127036$export$a64cf281f839414b(e, t) {
    var o = e.x, n = Math.PI - 2 * Math.PI * e.y / Math.pow(2, t);
    return {
        lat: 180 / Math.PI * Math.atan(.5 * (Math.exp(n) - Math.exp(-n))),
        lng: o / Math.pow(2, t) * 360 - 180
    };
}
function $37af810246127036$export$bf89fb35221bcc98(e, t) {
    var o = $37af810246127036$var$ce({
        lat: e.lat,
        lng: e.lng
    }), n = Math.pow(2, t);
    return {
        x: Math.floor(o.x * n),
        y: Math.floor(o.y * n)
    };
}
function $37af810246127036$export$3198a55f41e7e139(e, t) {
    for(var o = e.from, n = e.to, r = Math.pow(2, t), i = [], s = o.x; s !== (n.x + 1) % r; s = (s + 1) % r)for(var a = o.y; a !== (n.y + 1) % r; a = (a + 1) % r)i.push([
        t,
        s,
        a
    ]);
    return i;
}
$37af810246127036$var$he.propTypes = {
    apiKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    bootstrapURLKeys: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    defaultCenter: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).shape({
            lat: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
            lng: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number
        })
    ]),
    center: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).shape({
            lat: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
            lng: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number
        })
    ]),
    defaultZoom: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    zoom: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    onBoundsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseMove: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onChildMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onZoomAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onZoomAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onDrag: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onMapTypeIdChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onTilesLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    distanceToMouse: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    hoverDistance: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    debounced: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).array,
    googleMapLoader: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    onGoogleApiLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    yesIWantToUseGoogleMapApiInternals: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    draggable: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    resetBoundsOnResize: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    layerTypes: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string),
    shouldUnregisterMapOnUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool
}, $37af810246127036$var$he.defaultProps = {
    distanceToMouse: function(e, t) {
        return Math.sqrt((e.x - t.x) * (e.x - t.x) + (e.y - t.y) * (e.y - t.y));
    },
    hoverDistance: 30,
    debounced: !0,
    options: function() {
        return {
            overviewMapControl: !1,
            streetViewControl: !1,
            rotateControl: !0,
            mapTypeControl: !1,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                }
            ],
            minZoom: 3
        };
    },
    googleMapLoader: $37af810246127036$var$z,
    yesIWantToUseGoogleMapApiInternals: !1,
    style: {
        width: "100%",
        height: "100%",
        margin: 0,
        padding: 0,
        position: "relative"
    },
    layerTypes: [],
    heatmap: {},
    heatmapLibrary: !1,
    shouldUnregisterMapOnUnmount: !0
}, $37af810246127036$var$he.googleMapLoader = $37af810246127036$var$z;
var $37af810246127036$export$2e2bcd8739ae039 = $37af810246127036$var$he;




const $4bf4fc8475d604b3$var$LocationPin = ({ title: title = "", text: text = "", imageSrc: imageSrc = "" })=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "pin",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                        src: imageSrc,
                        alt: title
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $42efd8b8c405ef9c$export$96e9906d6d93a972), {
                        status: "green"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                        className: "pin_name",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                        className: "pin-location",
                        children: text
                    })
                ]
            })
        ]
    });
const $4bf4fc8475d604b3$var$Map = ({ location: location, zoomLevel: zoomLevel, title: title, imageSrc: imageSrc })=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "map",
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "google-map",
            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $37af810246127036$export$2e2bcd8739ae039), {
                bootstrapURLKeys: {
                    key: "AIzaSyBDjCcVGg_oXNHGEzI1d8YZhjUpg-V7zwA"
                },
                defaultCenter: location,
                defaultZoom: zoomLevel,
                children: /*#__PURE__*/ (0, $7uT18.jsx)($4bf4fc8475d604b3$var$LocationPin, {
                    lat: location.lat,
                    lng: location.lng,
                    text: location.address,
                    title: title,
                    imageSrc: imageSrc
                })
            })
        })
    });
var $4bf4fc8475d604b3$export$2e2bcd8739ae039 = $4bf4fc8475d604b3$var$Map;



const $ba5c583cc1faf304$var$location = {
    address: "\u0432\u0443\u043B. \u0425\u0440\u0435\u0449\u0430\u0442\u0438\u043A 23",
    lat: 50.437808,
    lng: 30.521208
};
const $ba5c583cc1faf304$export$899a4373faf58448 = ()=>{
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "default_card map_block",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
                children: "Map"
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "location_list",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "location_item"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "location_item"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "location_item"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "location_item"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "location_item"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "location_item"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "map_selected",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                        children: "selected:"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {}),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {}),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {})
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $4bf4fc8475d604b3$export$2e2bcd8739ae039), {
                location: $ba5c583cc1faf304$var$location,
                zoomLevel: 13
            })
        ]
    });
};



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

const $d114fdbcda9d2586$export$bac3506438e44f8d = ()=>{
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "statistics_block default_card",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
                children: "Statistics"
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "statistics_wrapper",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "bg_blue one"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "bg_coral two"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "bg_dark_blue three"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "bg_green four"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "bg_orange five"
                    })
                ]
            })
        ]
    });
};


class $fac304098907a952$var$View extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {};
    }
    componentDidMount() {}
    render() {
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "box p-4",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("h5", {
                        className: "mt-3 mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                src: (0, $1eb3b389e47a6059$export$2e2bcd8739ae039)("nav1"),
                                className: "title_icon"
                            }),
                            " Dashboard"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "content_wrap dashboard pt-5",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "page_info",
                                children: /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                    children: "for 28.10.20"
                                })
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "col-md-7",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $8564b2bba3f6f2be$export$5134630abfb689e3), {})
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "col-md-5",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $ba5c583cc1faf304$export$899a4373faf58448), {}),
                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $d114fdbcda9d2586$export$bac3506438e44f8d), {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
var $fac304098907a952$export$2e2bcd8739ae039 = $fac304098907a952$var$View;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

var $1Spf6 = parcelRequire("1Spf6");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $418c8561bd4b31f8$var$extendStatics = function(d, b) {
    $418c8561bd4b31f8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $418c8561bd4b31f8$var$extendStatics(d, b);
};
function $418c8561bd4b31f8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $418c8561bd4b31f8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $418c8561bd4b31f8$export$18ce0697a983be9b = function() {
    $418c8561bd4b31f8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $418c8561bd4b31f8$export$18ce0697a983be9b.apply(this, arguments);
};
function $418c8561bd4b31f8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $418c8561bd4b31f8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $418c8561bd4b31f8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $418c8561bd4b31f8$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $418c8561bd4b31f8$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $418c8561bd4b31f8$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $418c8561bd4b31f8$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $418c8561bd4b31f8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $418c8561bd4b31f8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $418c8561bd4b31f8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $418c8561bd4b31f8$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $418c8561bd4b31f8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $418c8561bd4b31f8$export$45d3717a4c69092e(o, m, p);
}
function $418c8561bd4b31f8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $418c8561bd4b31f8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $418c8561bd4b31f8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($418c8561bd4b31f8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $418c8561bd4b31f8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $418c8561bd4b31f8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $418c8561bd4b31f8$export$10c90e4f7922046c(v) {
    return this instanceof $418c8561bd4b31f8$export$10c90e4f7922046c ? (this.v = v, this) : new $418c8561bd4b31f8$export$10c90e4f7922046c(v);
}
function $418c8561bd4b31f8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $418c8561bd4b31f8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $418c8561bd4b31f8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $418c8561bd4b31f8$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $418c8561bd4b31f8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $418c8561bd4b31f8$export$19a8beecd37a4c45 === "function" ? $418c8561bd4b31f8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $418c8561bd4b31f8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $418c8561bd4b31f8$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $418c8561bd4b31f8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $418c8561bd4b31f8$export$45d3717a4c69092e(result, mod, k);
    }
    $418c8561bd4b31f8$var$__setModuleDefault(result, mod);
    return result;
}
function $418c8561bd4b31f8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $418c8561bd4b31f8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $418c8561bd4b31f8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $418c8561bd4b31f8$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


var $7fe4ad8c6ceff6e0$export$db0345794bfc14ed = new Map([
    [
        "avi",
        "video/avi"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "ico",
        "image/x-icon"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ]
]);
function $7fe4ad8c6ceff6e0$export$8cc09085015f0dc7(file, path) {
    var f = $7fe4ad8c6ceff6e0$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $7fe4ad8c6ceff6e0$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $7fe4ad8c6ceff6e0$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $ca2457eb18239b68$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $ca2457eb18239b68$export$a36e16046ae8f1bb(evt) {
    return (0, $418c8561bd4b31f8$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $418c8561bd4b31f8$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                $ca2457eb18239b68$var$isDragEvt(evt) && evt.dataTransfer ? $ca2457eb18239b68$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $ca2457eb18239b68$var$getInputFiles(evt)
            ];
        });
    });
}
function $ca2457eb18239b68$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $ca2457eb18239b68$var$getInputFiles(evt) {
    var files = $ca2457eb18239b68$var$isInput(evt.target) ? evt.target.files ? $ca2457eb18239b68$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $7fe4ad8c6ceff6e0$export$8cc09085015f0dc7)(file);
    });
}
function $ca2457eb18239b68$var$isInput(value) {
    return value !== null;
}
function $ca2457eb18239b68$var$getDataTransferFiles(dt, type) {
    return (0, $418c8561bd4b31f8$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $418c8561bd4b31f8$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $ca2457eb18239b68$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($ca2457eb18239b68$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $ca2457eb18239b68$var$noIgnoredFiles($ca2457eb18239b68$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $ca2457eb18239b68$var$noIgnoredFiles($ca2457eb18239b68$var$fromList(dt.files).map(function(file) {
                            return (0, $7fe4ad8c6ceff6e0$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $ca2457eb18239b68$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $ca2457eb18239b68$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $ca2457eb18239b68$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $ca2457eb18239b68$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $ca2457eb18239b68$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $ca2457eb18239b68$var$fromDirEntry(entry);
    return $ca2457eb18239b68$var$fromDataTransferItem(item);
}
function $ca2457eb18239b68$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $418c8561bd4b31f8$export$afc72e2116322959)(acc, Array.isArray(files) ? $ca2457eb18239b68$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $ca2457eb18239b68$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $7fe4ad8c6ceff6e0$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $ca2457eb18239b68$var$fromEntry(entry) {
    return (0, $418c8561bd4b31f8$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $418c8561bd4b31f8$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $ca2457eb18239b68$var$fromDirEntry(entry) : $ca2457eb18239b68$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $ca2457eb18239b68$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $418c8561bd4b31f8$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $418c8561bd4b31f8$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($ca2457eb18239b68$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $ca2457eb18239b68$var$fromFileEntry(entry) {
    return (0, $418c8561bd4b31f8$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $418c8561bd4b31f8$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $7fe4ad8c6ceff6e0$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $eda9012d949b6ba2$export$1e511d4a378977f5;
var $eda9012d949b6ba2$export$2e2bcd8739ae039;
"use strict";
$eda9012d949b6ba2$export$1e511d4a378977f5 = true;
$eda9012d949b6ba2$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $4b74acc2ffce95e9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4b74acc2ffce95e9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4b74acc2ffce95e9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4b74acc2ffce95e9$var$_typeof(obj);
}
function $4b74acc2ffce95e9$export$b511db3632effe58(file, accept) {
    return file.type === "application/x-moz-file" || (0, $eda9012d949b6ba2$export$2e2bcd8739ae039)(file, accept);
}
function $4b74acc2ffce95e9$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($4b74acc2ffce95e9$var$isDefined(file.size)) {
        if ($4b74acc2ffce95e9$var$isDefined(minSize) && $4b74acc2ffce95e9$var$isDefined(maxSize)) return file.size >= minSize && file.size <= maxSize;
        else if ($4b74acc2ffce95e9$var$isDefined(minSize)) return file.size >= minSize;
        else if ($4b74acc2ffce95e9$var$isDefined(maxSize)) return file.size <= maxSize;
    }
    return true;
}
function $4b74acc2ffce95e9$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $4b74acc2ffce95e9$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple;
    if (!multiple && files.length > 1) return false;
    return files.every(function(file) {
        return $4b74acc2ffce95e9$export$b511db3632effe58(file, accept) && $4b74acc2ffce95e9$export$860631d45ba43fd9(file, minSize, maxSize);
    });
} // React's synthetic events has event.isPropagationStopped,
function $4b74acc2ffce95e9$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $4b74acc2ffce95e9$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $4b74acc2ffce95e9$export$f9006bf02b243736(item) {
    return $4b74acc2ffce95e9$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $4b74acc2ffce95e9$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $4b74acc2ffce95e9$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $4b74acc2ffce95e9$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $4b74acc2ffce95e9$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $4b74acc2ffce95e9$var$isIe(userAgent) || $4b74acc2ffce95e9$var$isEdge(userAgent);
}
function $4b74acc2ffce95e9$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$4b74acc2ffce95e9$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $4b74acc2ffce95e9$export$8d6d6472146de265(event);
        });
    };
}


function $c89956014bc8c37c$var$_toConsumableArray(arr) {
    return $c89956014bc8c37c$var$_arrayWithoutHoles(arr) || $c89956014bc8c37c$var$_iterableToArray(arr) || $c89956014bc8c37c$var$_nonIterableSpread();
}
function $c89956014bc8c37c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $c89956014bc8c37c$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $c89956014bc8c37c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $c89956014bc8c37c$var$_slicedToArray(arr, i) {
    return $c89956014bc8c37c$var$_arrayWithHoles(arr) || $c89956014bc8c37c$var$_iterableToArrayLimit(arr, i) || $c89956014bc8c37c$var$_nonIterableRest();
}
function $c89956014bc8c37c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $c89956014bc8c37c$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c89956014bc8c37c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c89956014bc8c37c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c89956014bc8c37c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c89956014bc8c37c$var$ownKeys(source, true).forEach(function(key) {
            $c89956014bc8c37c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c89956014bc8c37c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c89956014bc8c37c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c89956014bc8c37c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c89956014bc8c37c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c89956014bc8c37c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $c89956014bc8c37c$var$Dropzone = (0, $cQmXV.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $c89956014bc8c37c$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    var _useDropzone = $c89956014bc8c37c$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $c89956014bc8c37c$var$_objectWithoutProperties(_useDropzone, [
        "open"
    ]);
    (0, $cQmXV.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $cQmXV.Fragment), null, children($c89956014bc8c37c$var$_objectSpread({}, props, {
        open: open
    })));
});
$c89956014bc8c37c$var$Dropzone.displayName = "Dropzone";
$c89956014bc8c37c$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func
};
var $c89956014bc8c37c$export$2e2bcd8739ae039 = $c89956014bc8c37c$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */ var $c89956014bc8c37c$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    rejectedFiles: []
};
function $c89956014bc8c37c$export$cd49c0ecc5be9f36() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, accept = _ref2.accept, _ref2$disabled = _ref2.disabled, disabled = _ref2$disabled === void 0 ? false : _ref2$disabled, _ref2$getFilesFromEve = _ref2.getFilesFromEvent, getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? (0, $ca2457eb18239b68$export$a36e16046ae8f1bb) : _ref2$getFilesFromEve, _ref2$maxSize = _ref2.maxSize, maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize, _ref2$minSize = _ref2.minSize, minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize, _ref2$multiple = _ref2.multiple, multiple = _ref2$multiple === void 0 ? true : _ref2$multiple, onDragEnter = _ref2.onDragEnter, onDragLeave = _ref2.onDragLeave, onDragOver = _ref2.onDragOver, onDrop = _ref2.onDrop, onDropAccepted = _ref2.onDropAccepted, onDropRejected = _ref2.onDropRejected, onFileDialogCancel = _ref2.onFileDialogCancel, _ref2$preventDropOnDo = _ref2.preventDropOnDocument, preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo, _ref2$noClick = _ref2.noClick, noClick = _ref2$noClick === void 0 ? false : _ref2$noClick, _ref2$noKeyboard = _ref2.noKeyboard, noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard, _ref2$noDrag = _ref2.noDrag, noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag, _ref2$noDragEventsBub = _ref2.noDragEventsBubbling, noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;
    var rootRef = (0, $cQmXV.useRef)(null);
    var inputRef = (0, $cQmXV.useRef)(null);
    var _useReducer = (0, $cQmXV.useReducer)($c89956014bc8c37c$var$reducer, $c89956014bc8c37c$var$initialState), _useReducer2 = $c89956014bc8c37c$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $cQmXV.useCallback)(function() {
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch
    ]); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    if (typeof onFileDialogCancel === "function") onFileDialogCancel();
                }
            }
        }, 300);
    };
    (0, $cQmXV.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancel
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $cQmXV.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        inputRef
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $cQmXV.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $cQmXV.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $cQmXV.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $4b74acc2ffce95e9$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        inputRef,
        noClick
    ]);
    var dragTargetsRef = (0, $cQmXV.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $cQmXV.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $4b74acc2ffce95e9$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $4b74acc2ffce95e9$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $cQmXV.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event); // Count the dropzone and any children that are entered.
        if (dragTargetsRef.current.indexOf(event.target) === -1) dragTargetsRef.current = [].concat($c89956014bc8c37c$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $4b74acc2ffce95e9$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $4b74acc2ffce95e9$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $cQmXV.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        if (event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if ((0, $4b74acc2ffce95e9$export$52f1fc875a1e5986)(event) && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $cQmXV.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return target !== event.target && rootRef.current && rootRef.current.contains(target);
        });
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: "setDraggedFiles",
            draggedFiles: []
        });
        if ((0, $4b74acc2ffce95e9$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var onDropCb = (0, $cQmXV.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $4b74acc2ffce95e9$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $4b74acc2ffce95e9$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var acceptedFiles = [];
            var rejectedFiles = [];
            files.forEach(function(file) {
                if ((0, $4b74acc2ffce95e9$export$b511db3632effe58)(file, accept) && (0, $4b74acc2ffce95e9$export$860631d45ba43fd9)(file, minSize, maxSize)) acceptedFiles.push(file);
                else rejectedFiles.push(file);
            });
            if (!multiple && acceptedFiles.length > 1) rejectedFiles.push.apply(rejectedFiles, $c89956014bc8c37c$var$_toConsumableArray(acceptedFiles.splice(0))); // Reject everything and empty accepted files
            dispatch({
                acceptedFiles: acceptedFiles,
                rejectedFiles: rejectedFiles,
                type: "setFiles"
            });
            if (onDrop) onDrop(acceptedFiles, rejectedFiles, event);
            if (rejectedFiles.length > 0 && onDropRejected) onDropRejected(rejectedFiles, event);
            if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
        });
        dispatch({
            type: "reset"
        });
    }, [
        multiple,
        accept,
        minSize,
        maxSize,
        getFilesFromEvent,
        onDrop,
        onDropAccepted,
        onDropRejected,
        noDragEventsBubbling
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $cQmXV.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onKeyDown = _ref3.onKeyDown, onFocus = _ref3.onFocus, onBlur = _ref3.onBlur, onClick = _ref3.onClick, onDragEnter = _ref3.onDragEnter, onDragOver = _ref3.onDragOver, onDragLeave = _ref3.onDragLeave, onDrop = _ref3.onDrop, rest = $c89956014bc8c37c$var$_objectWithoutProperties(_ref3, [
                "refKey",
                "onKeyDown",
                "onFocus",
                "onBlur",
                "onClick",
                "onDragEnter",
                "onDragOver",
                "onDragLeave",
                "onDrop"
            ]);
            return $c89956014bc8c37c$var$_objectSpread($c89956014bc8c37c$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onDrop, onDropCb))
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}, {}, rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $cQmXV.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $cQmXV.useMemo)(function() {
        return function() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey, onChange = _ref4.onChange, onClick = _ref4.onClick, rest = $c89956014bc8c37c$var$_objectWithoutProperties(_ref4, [
                "refKey",
                "onChange",
                "onClick"
            ]);
            var inputProps = $c89956014bc8c37c$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $4b74acc2ffce95e9$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                autoComplete: "off",
                tabIndex: -1
            }, refKey, inputRef);
            return $c89956014bc8c37c$var$_objectSpread({}, inputProps, {}, rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && (0, $4b74acc2ffce95e9$export$6a0bb4322c81a197)({
        files: draggedFiles,
        accept: accept,
        minSize: minSize,
        maxSize: maxSize,
        multiple: multiple
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return $c89956014bc8c37c$var$_objectSpread({}, state, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $c89956014bc8c37c$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $c89956014bc8c37c$var$_objectSpread({}, state, {
                isFocused: true
            });
        case "blur":
            return $c89956014bc8c37c$var$_objectSpread({}, state, {
                isFocused: false
            });
        case "openDialog":
            return $c89956014bc8c37c$var$_objectSpread({}, state, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $c89956014bc8c37c$var$_objectSpread({}, state, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $c89956014bc8c37c$var$_objectSpread({}, state, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case "setFiles":
            return $c89956014bc8c37c$var$_objectSpread({}, state, {
                acceptedFiles: action.acceptedFiles,
                rejectedFiles: action.rejectedFiles
            });
        case "reset":
            return $c89956014bc8c37c$var$_objectSpread({}, state, {
                isFileDialogActive: false,
                isDragActive: false,
                draggedFiles: [],
                acceptedFiles: [],
                rejectedFiles: []
            });
        default:
            return state;
    }
}




var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
class $fb116da65c30f288$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
    }
    componentDidMount = ()=>{
        if (this.props.isShow) document.body.classList.add("opened");
    };
    componentWillUnmount = ()=>{
        if (document.body.classList.value === "opened") document.body.classList.remove("opened");
    };
    render() {
        const { title: title = "", onClose: onClose, isShow: isShow, customClass: customClass = "", isSingle: isSingle = false, previewNavigationData: previewNavigationData = "", moveNext: moveNext = "", isSupervised: isSupervised } = this.props;
        if (!isShow) return null;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            id: "s-f-m-a",
            className: `modal fade ${isShow ? "show" : ""} scrollableHorizontal`,
            "data-backdrop": "true",
            style: {
                display: isShow ? "block" : "none"
            },
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: `modal-dialog modal-xl ${customClass} ${isShow ? "fade-down-big" : ""}`,
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "modal-content",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "modal-body text-center",
                            children: isShow && this.props.children
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "header-modal",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                        className: "fa fa-times"
                    })
                }),
                isSingle && isSupervised ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "single-photo-review-nav",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            title: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0456\u0439 \u0437\u0432\u0456\u0442",
                            className: "btn btn-primary white",
                            disabled: previewNavigationData.currentIndex === 0,
                            onClick: ()=>{
                                moveNext(-1);
                            },
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-angle-left"
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            title: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0437\u0432\u0456\u0442",
                            className: "btn btn-primary white",
                            disabled: previewNavigationData.currentIndex === previewNavigationData.lastIndex - 1,
                            onClick: ()=>{
                                moveNext(1);
                            },
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-angle-right"
                            })
                        })
                    ]
                }) : ""
            ]
        });
    }
}






const $8410c4bcf771fa83$var$PAGE_SIZE = 25;
class $8410c4bcf771fa83$var$View extends (0, $cQmXV.Component) {
    _debounce = null;
    constructor(props){
        super(props);
        this.state = {
            file: null,
            name: "",
            list: [],
            count: 0,
            loading: false,
            search: "",
            ordering: "-created",
            page: 1,
            errors: [],
            isModal: false
        };
    }
    onDrop = (files)=>{
        this.setState({
            files: files
        });
    };
    componentDidMount() {
        this.load();
    }
    load = ()=>{
        const { page: page, search: search, ordering: ordering } = this.state;
        const parts = [
            `page=${page}`,
            `page_size=${$8410c4bcf771fa83$var$PAGE_SIZE}`
        ];
        if (search) parts.push(`search=${encodeURIComponent(search)}`);
        if (ordering) parts.push(`ordering=${encodeURIComponent(ordering)}`);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `documents/?${parts.join("&")}`
        }, (r)=>{
            this.setState({
                list: r && r.results || [],
                count: r && r.count || 0
            });
        });
    };
    onSearch = (e)=>{
        const search = e.target.value;
        this.setState({
            search: search,
            page: 1
        });
        clearTimeout(this._debounce);
        this._debounce = setTimeout(this.load, 500);
    };
    toggleSort = (key)=>{
        this.setState((s)=>({
                ordering: s.ordering === key ? "-" + key : key,
                page: 1
            }), this.load);
    };
    sortArrow = (key)=>this.state.ordering === key ? " \u2191" : this.state.ordering === "-" + key ? " \u2193" : "";
    goPage = (page)=>this.setState({
            page: page
        }, this.load);
    delete = (id)=>{
        const lang = this.props.currentUser.language;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: "documents/" + id + "/"
        }, (r)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "file_deleted", lang), {
                position: "bottom-right"
            });
            this.load();
        });
    };
    validate = ()=>{
        let errors = [];
        const lang = this.props.currentUser.language;
        if (!this.state.name) errors.push((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "file_name_cannot_be_empty", lang));
        if (!this.state.file) errors.push((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "need_to_add_file", lang));
        this.setState({
            errors: errors
        });
        return errors.length == 0;
    };
    submit = ()=>{
        const lang = this.props.currentUser.language;
        if (this.validate()) {
            var formData = new FormData();
            formData.append("document", this.state.file);
            formData.append("title", this.state.name);
            (0, $c9936523dc38c641$export$a3c8e1472dc2ed84)({
                method: "POST",
                url: "documents/",
                post: formData
            }, (r)=>{
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "file_successfully_uploaded", lang), {
                    position: "bottom-right"
                });
                this.setState({
                    file: null,
                    name: "",
                    isModal: false
                });
                this.load();
            });
        }
    };
    uploadFile = (acceptedFiles)=>{
        this.setState({
            file: acceptedFiles[0]
        });
    };
    onChange = (property, value)=>{
        let state = this.state;
        state[property] = value;
        this.setState(state);
    };
    modalClose = ()=>{
        this.setState({
            isModal: false
        });
    };
    getFileExtension = (url)=>{
        if (!url) return "";
        const name = url.split("/").pop().split("?")[0];
        const ext = name.split(".").pop().toLowerCase();
        return ext;
    };
    getFileIcon = (url)=>{
        const ext = this.getFileExtension(url);
        const map = {
            pdf: "picture_as_pdf",
            doc: "description",
            docx: "description",
            xls: "table_chart",
            xlsx: "table_chart",
            csv: "table_chart",
            png: "image",
            jpg: "image",
            jpeg: "image",
            gif: "image",
            svg: "image",
            zip: "folder_zip",
            rar: "folder_zip"
        };
        return map[ext] || "draft";
    };
    render() {
        let { file: file, isModal: isModal } = this.state;
        const { currentUser: currentUser } = this.props;
        const pages = Math.max(1, Math.ceil(this.state.count / $8410c4bcf771fa83$var$PAGE_SIZE));
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid doc-page",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "box p-4 doc-page-card",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "doc-top-bar",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                type: "text",
                                className: "doc-search-input",
                                placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", currentUser.language),
                                value: this.state.search,
                                onChange: this.onSearch
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                className: "doc-add-btn",
                                onClick: ()=>this.setState({
                                        isModal: true
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "upload_file"
                                    }),
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "add_file", currentUser.language)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
                        isShow: isModal,
                        onClose: ()=>this.modalClose(),
                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "doc-modal",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("h3", {
                                    className: "doc-modal-title",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "upload_file"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "add_file", currentUser.language)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "doc-modal-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "doc-modal-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "file_name", currentUser.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "doc-modal-input",
                                            placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "file_name", currentUser.language),
                                            value: this.state.name,
                                            onChange: (e)=>this.onChange("name", e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $c89956014bc8c37c$export$2e2bcd8739ae039), {
                                    onDrop: this.uploadFile,
                                    styles: {
                                        dropzone: {
                                            minHeight: 150,
                                            maxHeight: 250
                                        }
                                    },
                                    children: ({ getRootProps: getRootProps, getInputProps: getInputProps })=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "doc-dropzone",
                                            ...getRootProps(),
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    ...getInputProps()
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined doc-dropzone-icon",
                                                    children: "cloud_upload"
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    className: "doc-dropzone-text",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "click_or_drag_files_here", currentUser.language)
                                                }),
                                                file && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "doc-dropzone-file",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "material-symbols-outlined",
                                                            children: "attach_file"
                                                        }),
                                                        file.name
                                                    ]
                                                })
                                            ]
                                        })
                                }),
                                this.state.errors.length > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "doc-modal-errors",
                                    children: this.state.errors.map((i)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "doc-modal-error",
                                            children: i
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "doc-modal-submit",
                                    onClick: ()=>this.submit(),
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "upload"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "download_file_btn", currentUser.language)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "doc-table-wrap",
                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                            className: "doc-table",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("th", {
                                                className: "doc-sortable",
                                                onClick: ()=>this.toggleSort("title"),
                                                children: [
                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "file_name", currentUser.language),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "doc-sort-arrow",
                                                        children: this.sortArrow("title")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("th", {
                                                className: "doc-sortable",
                                                onClick: ()=>this.toggleSort("created"),
                                                children: [
                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "creation_time", currentUser.language),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "doc-sort-arrow",
                                                        children: this.sortArrow("created")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                                style: {
                                                    width: "120px"
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("tbody", {
                                    children: [
                                        this.state.list.map((item, index)=>/*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "doc-file-cell",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: `material-symbols-outlined doc-file-icon doc-file-icon--${this.getFileExtension(item.document)}`,
                                                                    children: this.getFileIcon(item.document)
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "doc-file-name",
                                                                    children: item.title
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "doc-date",
                                                            children: (0, $b79edb411f97c469$export$236fe9b998ba9793)(item)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "doc-actions",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                                                    href: item.document,
                                                                    target: "_blank",
                                                                    className: "doc-action-btn doc-action-btn--download",
                                                                    title: "Download",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "download"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                    className: "doc-action-btn doc-action-btn--delete",
                                                                    onClick: ()=>this.delete(item.id),
                                                                    title: "Delete",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "delete"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, index)),
                                        this.state.list.length === 0 && /*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                colSpan: "3",
                                                children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "doc-empty",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "material-symbols-outlined",
                                                            children: "folder_open"
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                            children: "No documents yet"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    this.state.count > $8410c4bcf771fa83$var$PAGE_SIZE && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "doc-pagination",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                disabled: this.state.page <= 1,
                                onClick: ()=>this.goPage(this.state.page - 1),
                                children: "\u2039"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                children: [
                                    this.state.page,
                                    " / ",
                                    pages
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                disabled: this.state.page >= pages,
                                onClick: ()=>this.goPage(this.state.page + 1),
                                children: "\u203A"
                            })
                        ]
                    })
                ]
            })
        });
    }
}
var $8410c4bcf771fa83$export$2e2bcd8739ae039 = $8410c4bcf771fa83$var$View;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
/*!
  react-datepicker v8.10.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 
var $jYj5L = parcelRequire("jYj5L");

var $cQmXV = parcelRequire("cQmXV");
function $c3722476b0177c39$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $323ff4a8891a305c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $323ff4a8891a305c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $323ff4a8891a305c$export$2e2bcd8739ae039(o);
}


function $6fa742dea810721f$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $4a2c59df8ce8ec4a$export$2e2bcd8739ae039(argument) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $323ff4a8891a305c$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $7673c17aa450eb5a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $5bb85bfc30deb6e2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}



var $37b4e01bec3ef150$var$MILLISECONDS_IN_HOUR = 3600000;
function $37b4e01bec3ef150$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5bb85bfc30deb6e2$export$2e2bcd8739ae039)(dirtyDate, amount * $37b4e01bec3ef150$var$MILLISECONDS_IN_HOUR);
}




var $e31fea38bddb47f1$var$MILLISECONDS_IN_MINUTE = 60000;
function $e31fea38bddb47f1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5bb85bfc30deb6e2$export$2e2bcd8739ae039)(dirtyDate, amount * $e31fea38bddb47f1$var$MILLISECONDS_IN_MINUTE);
}




function $7c9b1f48527a8c80$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}




function $89d674319e089593$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    var months = amount * 3;
    return (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(dirtyDate, months);
}




function $9a5c8f3ee6846b06$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5bb85bfc30deb6e2$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}




function $445df110012de010$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(dirtyDate, days);
}




function $3be43e7bd0fc6a53$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $77119a34c3522634$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $50f4ae9c8a4444b9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $7ff80392ecde5177$var$MILLISECONDS_IN_DAY = 86400000;
function $7ff80392ecde5177$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $50f4ae9c8a4444b9$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $50f4ae9c8a4444b9$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $77119a34c3522634$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $77119a34c3522634$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $7ff80392ecde5177$var$MILLISECONDS_IN_DAY);
}



function $76606760696271a2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}



function $36bfab3978e1f56e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}




function $90e60b4024450c4f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var quarterDiff = (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)(dateLeft) - (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)(dateRight);
    return yearDiff * 4 + quarterDiff;
}



function $9aba1be5bd320e42$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $7804a10fe760ec3b$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $7804a10fe760ec3b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $7804a10fe760ec3b$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $7ff80392ecde5177$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($7804a10fe760ec3b$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



function $9cb23f9a8214e7bc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $e94aac2d6eb5844d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

var $c247dce96e65a454$var$defaultOptions = {};
function $c247dce96e65a454$export$430a3269e24b912e() {
    return $c247dce96e65a454$var$defaultOptions;
}
function $c247dce96e65a454$export$95365be1b0704abc(newOptions) {
    $c247dce96e65a454$var$defaultOptions = newOptions;
}





function $1bb33ac6bbfb9138$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $106ecc1962037161$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $6bf94078b78e666b$export$2e2bcd8739ae039(value) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $323ff4a8891a305c$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $7c5206d262b35399$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $6bf94078b78e666b$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}





function $e9a9c836df5b70e9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5bb85bfc30deb6e2$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $ff70ccbe3a0457cd$var$MILLISECONDS_IN_DAY = 86400000;
function $ff70ccbe3a0457cd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $ff70ccbe3a0457cd$var$MILLISECONDS_IN_DAY) + 1;
}





function $7575cea2c5511580$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $00cd9f71611ba4c4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $7575cea2c5511580$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $7575cea2c5511580$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $fedcd59d4af21a85$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $00cd9f71611ba4c4$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $7575cea2c5511580$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $016b7d35ebea9d26$var$MILLISECONDS_IN_WEEK = 604800000;
function $016b7d35ebea9d26$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $7575cea2c5511580$export$2e2bcd8739ae039)(date).getTime() - (0, $fedcd59d4af21a85$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $016b7d35ebea9d26$var$MILLISECONDS_IN_WEEK) + 1;
}








function $9e846820c0405309$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $96b20d8c66a714fc$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $9e846820c0405309$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $9e846820c0405309$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $77184822292b0ce1$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $96b20d8c66a714fc$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $9e846820c0405309$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $fb12f3854e3ffe67$var$MILLISECONDS_IN_WEEK = 604800000;
function $fb12f3854e3ffe67$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $9e846820c0405309$export$2e2bcd8739ae039)(date, options).getTime() - (0, $77184822292b0ce1$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $fb12f3854e3ffe67$var$MILLISECONDS_IN_WEEK) + 1;
}



function $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $d50fc7129a7dc1c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $d50fc7129a7dc1c2$export$2e2bcd8739ae039 = $d50fc7129a7dc1c2$var$formatters;


var $81eea67819539a3d$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $81eea67819539a3d$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $96b20d8c66a714fc$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $00cd9f71611ba4c4$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $fb12f3854e3ffe67$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $016b7d35ebea9d26$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $ff70ccbe3a0457cd$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $81eea67819539a3d$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $81eea67819539a3d$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $81eea67819539a3d$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $81eea67819539a3d$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $81eea67819539a3d$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $81eea67819539a3d$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $d50fc7129a7dc1c2$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $81eea67819539a3d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $81eea67819539a3d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $81eea67819539a3d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $81eea67819539a3d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $81eea67819539a3d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $81eea67819539a3d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $81eea67819539a3d$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $81eea67819539a3d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $81eea67819539a3d$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $81eea67819539a3d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $81eea67819539a3d$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(minutes, 2);
}
function $81eea67819539a3d$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $81eea67819539a3d$var$formatTimezone(offset, dirtyDelimiter);
}
function $81eea67819539a3d$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $4cd60cd0bcbdfc6c$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $81eea67819539a3d$export$2e2bcd8739ae039 = $81eea67819539a3d$var$formatters;


var $3f719b11ecff903a$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $3f719b11ecff903a$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $3f719b11ecff903a$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $3f719b11ecff903a$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3f719b11ecff903a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3f719b11ecff903a$var$timeLongFormatter(timePattern, formatLong));
};
var $3f719b11ecff903a$var$longFormatters = {
    p: $3f719b11ecff903a$var$timeLongFormatter,
    P: $3f719b11ecff903a$var$dateTimeLongFormatter
};
var $3f719b11ecff903a$export$2e2bcd8739ae039 = $3f719b11ecff903a$var$longFormatters;



var $b82cc3056e9710f3$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $b82cc3056e9710f3$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $b82cc3056e9710f3$export$c6cc36aa33304772(token) {
    return $b82cc3056e9710f3$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $b82cc3056e9710f3$export$c6b49d6dceb604a1(token) {
    return $b82cc3056e9710f3$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $b82cc3056e9710f3$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $1f8933abec2397e1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $1f8933abec2397e1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1f8933abec2397e1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $1f8933abec2397e1$export$2e2bcd8739ae039 = $1f8933abec2397e1$var$formatDistance;


function $6261bd4ca8ae4123$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $c41f059a2b43a297$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $c41f059a2b43a297$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $c41f059a2b43a297$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $c41f059a2b43a297$var$formatLong = {
    date: (0, $6261bd4ca8ae4123$export$2e2bcd8739ae039)({
        formats: $c41f059a2b43a297$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6261bd4ca8ae4123$export$2e2bcd8739ae039)({
        formats: $c41f059a2b43a297$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6261bd4ca8ae4123$export$2e2bcd8739ae039)({
        formats: $c41f059a2b43a297$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $c41f059a2b43a297$export$2e2bcd8739ae039 = $c41f059a2b43a297$var$formatLong;


var $1f471e029c5a1dd8$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $1f471e029c5a1dd8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1f471e029c5a1dd8$var$formatRelativeLocale[token];
};
var $1f471e029c5a1dd8$export$2e2bcd8739ae039 = $1f471e029c5a1dd8$var$formatRelative;


function $a9c9c2bfe829ca54$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $1f96e70d085b26c3$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $1f96e70d085b26c3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1f96e70d085b26c3$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $1f96e70d085b26c3$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $1f96e70d085b26c3$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $1f96e70d085b26c3$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $1f96e70d085b26c3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $1f96e70d085b26c3$var$localize = {
    ordinalNumber: $1f96e70d085b26c3$var$ordinalNumber,
    era: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $1f96e70d085b26c3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $1f96e70d085b26c3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $1f96e70d085b26c3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $1f96e70d085b26c3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $1f96e70d085b26c3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1f96e70d085b26c3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $1f96e70d085b26c3$export$2e2bcd8739ae039 = $1f96e70d085b26c3$var$localize;


function $bcaf83ab272105ab$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $bcaf83ab272105ab$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $bcaf83ab272105ab$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $bcaf83ab272105ab$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $bcaf83ab272105ab$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $a51d42a24daf46ae$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $2ece111fc833c7d8$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $2ece111fc833c7d8$var$parseOrdinalNumberPattern = /\d+/i;
var $2ece111fc833c7d8$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $2ece111fc833c7d8$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $2ece111fc833c7d8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $2ece111fc833c7d8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2ece111fc833c7d8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $2ece111fc833c7d8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2ece111fc833c7d8$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $2ece111fc833c7d8$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $2ece111fc833c7d8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $2ece111fc833c7d8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $2ece111fc833c7d8$var$match = {
    ordinalNumber: (0, $a51d42a24daf46ae$export$2e2bcd8739ae039)({
        matchPattern: $2ece111fc833c7d8$var$matchOrdinalNumberPattern,
        parsePattern: $2ece111fc833c7d8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $2ece111fc833c7d8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2ece111fc833c7d8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $2ece111fc833c7d8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2ece111fc833c7d8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $2ece111fc833c7d8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2ece111fc833c7d8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $2ece111fc833c7d8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2ece111fc833c7d8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $2ece111fc833c7d8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2ece111fc833c7d8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $2ece111fc833c7d8$export$2e2bcd8739ae039 = $2ece111fc833c7d8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $f6f46bb25bed6f18$var$locale = {
    code: "en-US",
    formatDistance: (0, $1f8933abec2397e1$export$2e2bcd8739ae039),
    formatLong: (0, $c41f059a2b43a297$export$2e2bcd8739ae039),
    formatRelative: (0, $1f471e029c5a1dd8$export$2e2bcd8739ae039),
    localize: (0, $1f96e70d085b26c3$export$2e2bcd8739ae039),
    match: (0, $2ece111fc833c7d8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f6f46bb25bed6f18$export$2e2bcd8739ae039 = $f6f46bb25bed6f18$var$locale;


var $0c24da20d808f530$export$2e2bcd8739ae039 = (0, $f6f46bb25bed6f18$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $389aa0de6ef8ea63$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $389aa0de6ef8ea63$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $389aa0de6ef8ea63$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $389aa0de6ef8ea63$var$doubleQuoteRegExp = /''/g;
var $389aa0de6ef8ea63$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $389aa0de6ef8ea63$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $0c24da20d808f530$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $7c5206d262b35399$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $77119a34c3522634$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $e9a9c836df5b70e9$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($389aa0de6ef8ea63$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $3f719b11ecff903a$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($389aa0de6ef8ea63$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $389aa0de6ef8ea63$var$cleanEscapedString(substring);
        var formatter = (0, $81eea67819539a3d$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $b82cc3056e9710f3$export$c6b49d6dceb604a1)(substring)) (0, $b82cc3056e9710f3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $b82cc3056e9710f3$export$c6cc36aa33304772)(substring)) (0, $b82cc3056e9710f3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($389aa0de6ef8ea63$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $389aa0de6ef8ea63$var$cleanEscapedString(input) {
    var matched = input.match($389aa0de6ef8ea63$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($389aa0de6ef8ea63$var$doubleQuoteRegExp, "'");
}



function $95441081375ffd7b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}



function $d5cc598bb4539215$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    return day;
}



function $373f86827073914d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}






function $9080fd1fb2f1a15e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $b9fb6c7772eed60c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    return (0, $9080fd1fb2f1a15e$export$2e2bcd8739ae039)(dirtyDate, {
        weekStartsOn: 1
    });
}





function $f050271a1f74a2aa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $b9fb6c7772eed60c$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $b9fb6c7772eed60c$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $afea2be21c6c2523$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $f050271a1f74a2aa$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $b9fb6c7772eed60c$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $a184b08fb8bdcfc5$var$MILLISECONDS_IN_WEEK = 604800000;
function $a184b08fb8bdcfc5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $b9fb6c7772eed60c$export$2e2bcd8739ae039)(date).getTime() - (0, $afea2be21c6c2523$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $a184b08fb8bdcfc5$var$MILLISECONDS_IN_WEEK) + 1;
}



function $0c41b951b8dcebdb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}



function $e9c247d1af5f4312$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}



function $f5b59a09917da604$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}



function $994a08207c4a21f1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}



function $d3820647cfc034b1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    return (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}



function $391444e1d96e3f3c$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



function $ae272f68d81c87cd$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}



function $4e3c6086dc9f5ab6$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}



function $168de819440c8efe$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $50f4ae9c8a4444b9$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $50f4ae9c8a4444b9$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $220f9910290fb891$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}



function $4f8d6b475f0f5819$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $2078a34d45e826cb$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfQuarter = (0, $4f8d6b475f0f5819$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, $4f8d6b475f0f5819$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}



function $573f65e9a2f6d5ed$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}



function $3e1c7f28d9d32516$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}




function $dc4798a3ea96654e$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $323ff4a8891a305c$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}




function $f3f34c97f63bbab1$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $323ff4a8891a305c$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}


function $c756e802fc2db5a9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $054366e3f0c7b637$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $c756e802fc2db5a9$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $c756e802fc2db5a9$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $6992f1d9e119c66f$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $054366e3f0c7b637$export$2e2bcd8739ae039)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $101a6bb002d60c43$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}







function $726c6072af10bfc2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $20ae9ae43c86e642$export$2e2bcd8739ae039(t, e) {
    return $20ae9ae43c86e642$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $20ae9ae43c86e642$export$2e2bcd8739ae039(t, e);
}


function $c463cd9acef0adef$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $20ae9ae43c86e642$export$2e2bcd8739ae039)(t, e);
}


function $e368fa4119d8534f$export$2e2bcd8739ae039(t) {
    return $e368fa4119d8534f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e368fa4119d8534f$export$2e2bcd8739ae039(t);
}


function $a428a4b08c584f3d$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a428a4b08c584f3d$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $cf1b2e4f5b28c1ee$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $323ff4a8891a305c$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $726c6072af10bfc2$export$2e2bcd8739ae039)(t);
}


function $2105d24c6e9e2bd4$export$2e2bcd8739ae039(t) {
    var r = (0, $a428a4b08c584f3d$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e368fa4119d8534f$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e368fa4119d8534f$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $cf1b2e4f5b28c1ee$export$2e2bcd8739ae039)(this, e);
    };
}


function $0d5f6ada18dad214$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}




function $2db789c20e27a38b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $323ff4a8891a305c$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $323ff4a8891a305c$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $ff2ac0c2dd3dbf98$export$2e2bcd8739ae039(t) {
    var i = (0, $2db789c20e27a38b$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $323ff4a8891a305c$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $3236a3fb7f4960b5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $ff2ac0c2dd3dbf98$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $3236a3fb7f4960b5$export$2e2bcd8739ae039(e, r, t) {
    return r && $3236a3fb7f4960b5$var$_defineProperties(e.prototype, r), t && $3236a3fb7f4960b5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $9cbfcff58c663426$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ff2ac0c2dd3dbf98$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $fa2a4bd693beea2e$var$TIMEZONE_UNIT_PRIORITY = 10;
var $fa2a4bd693beea2e$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, Setter);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $fa2a4bd693beea2e$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($fa2a4bd693beea2e$export$81d53e3678089a6);
var $fa2a4bd693beea2e$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this2), "priority", $fa2a4bd693beea2e$var$TIMEZONE_UNIT_PRIORITY);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($fa2a4bd693beea2e$export$81d53e3678089a6);












var $ff33e3143f41408e$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, Parser);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $fa2a4bd693beea2e$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $450de7c1a6df66a3$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $f71639cea6804f2f$export$dfd9b671c89acc8e = 7;
var $f71639cea6804f2f$export$3913210603d8e9ae = 365.2425;
var $f71639cea6804f2f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $f71639cea6804f2f$export$91246f0b9bd9beff = 60000;
var $f71639cea6804f2f$export$7f72910d6dfd237a = 3600000;
var $f71639cea6804f2f$export$397c2d5776aa9055 = 1000;
var $f71639cea6804f2f$export$4dec998e48f9c246 = -$f71639cea6804f2f$export$81caae6e1cc7a622;
var $f71639cea6804f2f$export$f2f5ae5a8e2d8f9f = 60;
var $f71639cea6804f2f$export$3c58128db900d44e = 3;
var $f71639cea6804f2f$export$80d7e435f744f319 = 12;
var $f71639cea6804f2f$export$4db7641526e3241f = 4;
var $f71639cea6804f2f$export$698aec755e92c695 = 3600;
var $f71639cea6804f2f$export$a77c1a7ebebe2a5a = 60;
var $f71639cea6804f2f$export$815a9362476d2fe3 = $f71639cea6804f2f$export$698aec755e92c695 * 24;
var $f71639cea6804f2f$export$34804a017b31e2fe = $f71639cea6804f2f$export$815a9362476d2fe3 * 7;
var $f71639cea6804f2f$export$7271e9e3478110d1 = $f71639cea6804f2f$export$815a9362476d2fe3 * $f71639cea6804f2f$export$3913210603d8e9ae;
var $f71639cea6804f2f$export$8e6600bbdee7dabb = $f71639cea6804f2f$export$7271e9e3478110d1 / 12;
var $f71639cea6804f2f$export$be1dccf2de902d31 = $f71639cea6804f2f$export$8e6600bbdee7dabb * 3;


var $dae7d02b46289c66$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $dae7d02b46289c66$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $58a27c86bb7d1ce4$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $f71639cea6804f2f$export$7f72910d6dfd237a) + minutes * (0, $f71639cea6804f2f$export$91246f0b9bd9beff) + seconds * (0, $f71639cea6804f2f$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $58a27c86bb7d1ce4$export$d931c43c4608a164(dateString) {
    return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $58a27c86bb7d1ce4$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $58a27c86bb7d1ce4$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388((0, $dae7d02b46289c66$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $58a27c86bb7d1ce4$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $58a27c86bb7d1ce4$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $58a27c86bb7d1ce4$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $5e08f0810321a1f0$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $58a27c86bb7d1ce4$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));












var $b1c1843ffa6bc804$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $96b20d8c66a714fc$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $58a27c86bb7d1ce4$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $9e846820c0405309$export$2e2bcd8739ae039)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $9e846820c0405309$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $0d5019f7688e9b5e$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $58a27c86bb7d1ce4$export$2c9307b2e29c533c)(4, dateString);
                return (0, $58a27c86bb7d1ce4$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $7575cea2c5511580$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $da2ba9043c238efd$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $58a27c86bb7d1ce4$export$2c9307b2e29c533c)(4, dateString);
                return (0, $58a27c86bb7d1ce4$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $c167e9ea18789475$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $3a57e853e1c0883b$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $ca488a0228b2851b$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $dffad12ac8b2fba4$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));















function $5b3fb9fc477704aa$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $fb12f3854e3ffe67$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $7fa6386ff1594260$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $9e846820c0405309$export$2e2bcd8739ae039)((0, $5b3fb9fc477704aa$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));















function $f692be160f495bd3$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $016b7d35ebea9d26$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $263fc4db8a7c4694$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $7575cea2c5511580$export$2e2bcd8739ae039)((0, $f692be160f495bd3$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $2663d4247f9ae162$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $2663d4247f9ae162$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $2663d4247f9ae162$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $58a27c86bb7d1ce4$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $2663d4247f9ae162$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $2663d4247f9ae162$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $661b0f4200354011$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $58a27c86bb7d1ce4$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));













function $d9c3b39eff540aa3$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $254dfdc7dbb6a6a9$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $d9c3b39eff540aa3$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $7fe1953a43028d1d$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $d9c3b39eff540aa3$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $c22d1aa7da560ed3$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $d9c3b39eff540aa3$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));













function $92b24caf03e05898$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $029e6d63716611ed$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $92b24caf03e05898$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $d818babb011fa521$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $58a27c86bb7d1ce4$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $a5b31052e3c4a503$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $58a27c86bb7d1ce4$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $bbeec8fc30eb716d$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $58a27c86bb7d1ce4$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $a172b7a4474b6868$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $59debe3a0dcb9e77$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $edf2e6b828bb359b$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $74063f202bf4abdf$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $c948daca5548f598$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $8a504a2eea187cba$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $58a27c86bb7d1ce4$export$cc7cc9e2a3ff9388)((0, $dae7d02b46289c66$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $78077835ddf548e3$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $58a27c86bb7d1ce4$export$4f84e3a82c7b538)((0, $58a27c86bb7d1ce4$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $8b578cee3576e6b3$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));











var $9dc302aa397fbdf2$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $58a27c86bb7d1ce4$export$6497f4c0ecdfba8e)((0, $dae7d02b46289c66$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $801724ac0cd659b9$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $58a27c86bb7d1ce4$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));










var $73a3f67ddaf55a2e$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $c463cd9acef0adef$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $2105d24c6e9e2bd4$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $0d5f6ada18dad214$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $9cbfcff58c663426$export$2e2bcd8739ae039)((0, $726c6072af10bfc2$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $3236a3fb7f4960b5$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $58a27c86bb7d1ce4$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $ff33e3143f41408e$export$7acfa6ed01010e37));


var $167390bc92896864$export$19131010e7fd8373 = {
    G: new (0, $450de7c1a6df66a3$export$8e5a1d3f85a9688)(),
    y: new (0, $5e08f0810321a1f0$export$48d352de7cd4a988)(),
    Y: new (0, $b1c1843ffa6bc804$export$b8ef38dfcf05d5db)(),
    R: new (0, $0d5019f7688e9b5e$export$951d1df011fde06f)(),
    u: new (0, $da2ba9043c238efd$export$bad9d2ea38e8f1a)(),
    Q: new (0, $c167e9ea18789475$export$5cb0f701186dde1d)(),
    q: new (0, $3a57e853e1c0883b$export$300c0c2990e20e6d)(),
    M: new (0, $ca488a0228b2851b$export$400dd8b40ef138a3)(),
    L: new (0, $dffad12ac8b2fba4$export$1d7eaa53eaa5deba)(),
    w: new (0, $7fa6386ff1594260$export$c4005ffc174e07c0)(),
    I: new (0, $263fc4db8a7c4694$export$6fc8dbedd560a6af)(),
    d: new (0, $2663d4247f9ae162$export$e8d4b28a20981dd2)(),
    D: new (0, $661b0f4200354011$export$6cfe0d613455f615)(),
    E: new (0, $254dfdc7dbb6a6a9$export$1b03c8b76262f7bd)(),
    e: new (0, $7fe1953a43028d1d$export$44d1c127ab42c480)(),
    c: new (0, $c22d1aa7da560ed3$export$e447a647caaaec1d)(),
    i: new (0, $029e6d63716611ed$export$693fb1e525095b2a)(),
    a: new (0, $d818babb011fa521$export$8d1e08492351df91)(),
    b: new (0, $a5b31052e3c4a503$export$73ca2bd0a17d273)(),
    B: new (0, $bbeec8fc30eb716d$export$bb9212adf05373db)(),
    h: new (0, $a172b7a4474b6868$export$8a04050a727a1756)(),
    H: new (0, $59debe3a0dcb9e77$export$e56f4dea2c3e56dd)(),
    K: new (0, $edf2e6b828bb359b$export$cbbe855312f87d77)(),
    k: new (0, $74063f202bf4abdf$export$6008046d2b34b6a5)(),
    m: new (0, $c948daca5548f598$export$2b52670d9e2be53)(),
    s: new (0, $8a504a2eea187cba$export$94d46d540cf1366a)(),
    S: new (0, $78077835ddf548e3$export$b8e6f8b2d70893b1)(),
    X: new (0, $8b578cee3576e6b3$export$104d901d49fea29b)(),
    x: new (0, $9dc302aa397fbdf2$export$12910e5204b52b9)(),
    t: new (0, $801724ac0cd659b9$export$2cd8bf877a05e96)(),
    T: new (0, $73a3f67ddaf55a2e$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $813f06b351d00f10$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $813f06b351d00f10$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $813f06b351d00f10$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $813f06b351d00f10$var$doubleQuoteRegExp = /''/g;
var $813f06b351d00f10$var$notWhitespaceRegExp = /\S/;
var $813f06b351d00f10$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $813f06b351d00f10$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $0c24da20d808f530$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $fa2a4bd693beea2e$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($813f06b351d00f10$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $3f719b11ecff903a$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $3f719b11ecff903a$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($813f06b351d00f10$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $6992f1d9e119c66f$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $b82cc3056e9710f3$export$c6b49d6dceb604a1)(token)) (0, $b82cc3056e9710f3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $b82cc3056e9710f3$export$c6cc36aa33304772)(token)) (0, $b82cc3056e9710f3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $167390bc92896864$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($813f06b351d00f10$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $813f06b351d00f10$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $323ff4a8891a305c$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $813f06b351d00f10$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $e9a9c836df5b70e9$export$2e2bcd8739ae039)(date, (0, $77119a34c3522634$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $6992f1d9e119c66f$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $101a6bb002d60c43$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $813f06b351d00f10$var$cleanEscapedString(input) {
    return input.match($813f06b351d00f10$var$escapedStringRegExp)[1].replace($813f06b351d00f10$var$doubleQuoteRegExp, "'");
}




function $2b88b3fd22a2cf62$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $c3722476b0177c39$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $2b88b3fd22a2cf62$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $2b88b3fd22a2cf62$var$parseYear(dateStrings.date, additionalDigits);
        date = $2b88b3fd22a2cf62$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $2b88b3fd22a2cf62$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $2b88b3fd22a2cf62$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $2b88b3fd22a2cf62$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $2b88b3fd22a2cf62$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $2b88b3fd22a2cf62$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $2b88b3fd22a2cf62$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $2b88b3fd22a2cf62$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($2b88b3fd22a2cf62$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($2b88b3fd22a2cf62$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($2b88b3fd22a2cf62$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $2b88b3fd22a2cf62$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $2b88b3fd22a2cf62$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $2b88b3fd22a2cf62$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($2b88b3fd22a2cf62$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $2b88b3fd22a2cf62$var$parseDateUnit(captures[1]);
    var month = $2b88b3fd22a2cf62$var$parseDateUnit(captures[2]) - 1;
    var day = $2b88b3fd22a2cf62$var$parseDateUnit(captures[3]);
    var week = $2b88b3fd22a2cf62$var$parseDateUnit(captures[4]);
    var dayOfWeek = $2b88b3fd22a2cf62$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$2b88b3fd22a2cf62$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $2b88b3fd22a2cf62$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$2b88b3fd22a2cf62$var$validateDate(year, month, day) || !$2b88b3fd22a2cf62$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $2b88b3fd22a2cf62$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $2b88b3fd22a2cf62$var$parseTime(timeString) {
    var captures = timeString.match($2b88b3fd22a2cf62$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $2b88b3fd22a2cf62$var$parseTimeUnit(captures[1]);
    var minutes = $2b88b3fd22a2cf62$var$parseTimeUnit(captures[2]);
    var seconds = $2b88b3fd22a2cf62$var$parseTimeUnit(captures[3]);
    if (!$2b88b3fd22a2cf62$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $f71639cea6804f2f$export$7f72910d6dfd237a) + minutes * (0, $f71639cea6804f2f$export$91246f0b9bd9beff) + seconds * 1000;
}
function $2b88b3fd22a2cf62$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $2b88b3fd22a2cf62$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($2b88b3fd22a2cf62$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$2b88b3fd22a2cf62$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $f71639cea6804f2f$export$7f72910d6dfd237a) + minutes * (0, $f71639cea6804f2f$export$91246f0b9bd9beff));
}
function $2b88b3fd22a2cf62$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $2b88b3fd22a2cf62$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $2b88b3fd22a2cf62$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $2b88b3fd22a2cf62$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($2b88b3fd22a2cf62$var$daysInMonths[month] || ($2b88b3fd22a2cf62$var$isLeapYearIndex(year) ? 29 : 28));
}
function $2b88b3fd22a2cf62$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($2b88b3fd22a2cf62$var$isLeapYearIndex(year) ? 366 : 365);
}
function $2b88b3fd22a2cf62$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $2b88b3fd22a2cf62$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $2b88b3fd22a2cf62$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}




function $f99cdc67abc4da3e$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}




function $e9455667210155a3$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}





function $e187b71d8ee2e981$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $0f0a320b378f0016$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $e187b71d8ee2e981$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $c6e017e14073270e$export$2e2bcd8739ae039(dirtyDate, dirtyQuarter) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var quarter = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $0f0a320b378f0016$export$2e2bcd8739ae039)(date, date.getMonth() + diff * 3);
}




function $766cbbced0102e4b$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}




function $b7d4ce01e5e313b8$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}



function $ef4a4204aeb604fa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $12cf19278c96c089$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $904a2da106dc6f87$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $9450df79fe1987af$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $7913aededcc910d4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $89d674319e089593$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $431b62272382e5d5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $445df110012de010$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $a2cd0767d0b3f015$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c3722476b0177c39$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $88ea4014521d2d61$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $88ea4014521d2d61$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $88ea4014521d2d61$export$803cd8101b6c182b = /*#__PURE__*/ $88ea4014521d2d61$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $88ea4014521d2d61$export$27b07d8a310ed8b5[0], side + "-" + $88ea4014521d2d61$export$27b07d8a310ed8b5[1]), []);
const $88ea4014521d2d61$export$96ec731ed4dcb222 = Math.min;
const $88ea4014521d2d61$export$8960430cfd85939f = Math.max;
const $88ea4014521d2d61$export$2077e0241d6afd3c = Math.round;
const $88ea4014521d2d61$export$a3fe094919f356fd = Math.floor;
const $88ea4014521d2d61$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $88ea4014521d2d61$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $88ea4014521d2d61$export$7d15b64cf5a3a4c4(start, value, end) {
    return $88ea4014521d2d61$export$8960430cfd85939f(start, $88ea4014521d2d61$export$96ec731ed4dcb222(value, end));
}
function $88ea4014521d2d61$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $88ea4014521d2d61$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $88ea4014521d2d61$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $88ea4014521d2d61$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $88ea4014521d2d61$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $88ea4014521d2d61$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function $88ea4014521d2d61$export$2b57e0052a6d6d4c(placement) {
    return $88ea4014521d2d61$export$8a000a963141ac32($88ea4014521d2d61$export$f28e8f882010718a(placement));
}
function $88ea4014521d2d61$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $88ea4014521d2d61$export$f0989780f32bfcda(placement);
    const alignmentAxis = $88ea4014521d2d61$export$2b57e0052a6d6d4c(placement);
    const length = $88ea4014521d2d61$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $88ea4014521d2d61$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $88ea4014521d2d61$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $88ea4014521d2d61$export$496432a3699e50b1(placement) {
    const oppositePlacement = $88ea4014521d2d61$export$9c5e28bad23365fa(placement);
    return [
        $88ea4014521d2d61$export$2b182c584985588b(placement),
        oppositePlacement,
        $88ea4014521d2d61$export$2b182c584985588b(oppositePlacement)
    ];
}
function $88ea4014521d2d61$export$2b182c584985588b(placement) {
    return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
const $88ea4014521d2d61$var$lrPlacement = [
    "left",
    "right"
];
const $88ea4014521d2d61$var$rlPlacement = [
    "right",
    "left"
];
const $88ea4014521d2d61$var$tbPlacement = [
    "top",
    "bottom"
];
const $88ea4014521d2d61$var$btPlacement = [
    "bottom",
    "top"
];
function $88ea4014521d2d61$var$getSideList(side, isStart, rtl) {
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? $88ea4014521d2d61$var$rlPlacement : $88ea4014521d2d61$var$lrPlacement;
            return isStart ? $88ea4014521d2d61$var$lrPlacement : $88ea4014521d2d61$var$rlPlacement;
        case "left":
        case "right":
            return isStart ? $88ea4014521d2d61$var$tbPlacement : $88ea4014521d2d61$var$btPlacement;
        default:
            return [];
    }
}
function $88ea4014521d2d61$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $88ea4014521d2d61$export$f0989780f32bfcda(placement);
    let list = $88ea4014521d2d61$var$getSideList($88ea4014521d2d61$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($88ea4014521d2d61$export$2b182c584985588b));
    }
    return list;
}
function $88ea4014521d2d61$export$9c5e28bad23365fa(placement) {
    const side = $88ea4014521d2d61$export$3c915306cb7fc97a(placement);
    return $88ea4014521d2d61$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $88ea4014521d2d61$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $88ea4014521d2d61$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $88ea4014521d2d61$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $88ea4014521d2d61$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $c525f07740bbb28d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $88ea4014521d2d61$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $88ea4014521d2d61$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $88ea4014521d2d61$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $88ea4014521d2d61$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === "end" ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c525f07740bbb28d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $88ea4014521d2d61$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $88ea4014521d2d61$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $88ea4014521d2d61$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $c525f07740bbb28d$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c525f07740bbb28d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $c525f07740bbb28d$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c525f07740bbb28d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $c525f07740bbb28d$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c525f07740bbb28d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c525f07740bbb28d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $88ea4014521d2d61$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $88ea4014521d2d61$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $88ea4014521d2d61$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $88ea4014521d2d61$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $88ea4014521d2d61$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c525f07740bbb28d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $88ea4014521d2d61$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $88ea4014521d2d61$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $88ea4014521d2d61$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $88ea4014521d2d61$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c525f07740bbb28d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $88ea4014521d2d61$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $88ea4014521d2d61$export$803cd8101b6c182b) ? $c525f07740bbb28d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $88ea4014521d2d61$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $88ea4014521d2d61$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $88ea4014521d2d61$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $88ea4014521d2d61$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c525f07740bbb28d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $88ea4014521d2d61$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $88ea4014521d2d61$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $88ea4014521d2d61$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $88ea4014521d2d61$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $88ea4014521d2d61$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $88ea4014521d2d61$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== (0, $88ea4014521d2d61$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $88ea4014521d2d61$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $88ea4014521d2d61$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c525f07740bbb28d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c525f07740bbb28d$var$isAnySideFullyClipped(overflow) {
    return (0, $88ea4014521d2d61$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c525f07740bbb28d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $c525f07740bbb28d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c525f07740bbb28d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c525f07740bbb28d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c525f07740bbb28d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c525f07740bbb28d$var$getBoundingRect(rects) {
    const minX = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $88ea4014521d2d61$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $88ea4014521d2d61$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c525f07740bbb28d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $88ea4014521d2d61$export$ee05aea0aeecbad4)($c525f07740bbb28d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c525f07740bbb28d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $c525f07740bbb28d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $88ea4014521d2d61$export$ee05aea0aeecbad4)($c525f07740bbb28d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $88ea4014521d2d61$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $88ea4014521d2d61$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $88ea4014521d2d61$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $88ea4014521d2d61$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $88ea4014521d2d61$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $c525f07740bbb28d$var$originSides = /*#__PURE__*/ new Set([
    "left",
    "top"
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c525f07740bbb28d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $88ea4014521d2d61$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $88ea4014521d2d61$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = $c525f07740bbb28d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c525f07740bbb28d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c525f07740bbb28d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c525f07740bbb28d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $88ea4014521d2d61$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $88ea4014521d2d61$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $88ea4014521d2d61$export$7d15b64cf5a3a4c4)(coord + overflow[axis === "y" ? "top" : "left"], coord, coord - overflow[axis === "y" ? "bottom" : "right"]);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c525f07740bbb28d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $88ea4014521d2d61$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $88ea4014521d2d61$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = $c525f07740bbb28d$var$originSides.has((0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c525f07740bbb28d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $88ea4014521d2d61$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $88ea4014521d2d61$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $88ea4014521d2d61$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $88ea4014521d2d61$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $88ea4014521d2d61$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $a4d8f0d03f4d0e92$var$hasWindow() {
    return typeof window !== "undefined";
}
function $a4d8f0d03f4d0e92$export$651544f548703224(node) {
    if ($a4d8f0d03f4d0e92$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $a4d8f0d03f4d0e92$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $a4d8f0d03f4d0e92$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($a4d8f0d03f4d0e92$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $a4d8f0d03f4d0e92$export$8ee0fc9ee280b4ee(value) {
    if (!$a4d8f0d03f4d0e92$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $a4d8f0d03f4d0e92$export$38b2d434cce3ea22(value).Node;
}
function $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d(value) {
    if (!$a4d8f0d03f4d0e92$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $a4d8f0d03f4d0e92$export$38b2d434cce3ea22(value).Element;
}
function $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa(value) {
    if (!$a4d8f0d03f4d0e92$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $a4d8f0d03f4d0e92$export$38b2d434cce3ea22(value).HTMLElement;
}
function $a4d8f0d03f4d0e92$export$af51f0f06c0f328a(value) {
    if (!$a4d8f0d03f4d0e92$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $a4d8f0d03f4d0e92$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $a4d8f0d03f4d0e92$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $a4d8f0d03f4d0e92$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function $a4d8f0d03f4d0e92$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($a4d8f0d03f4d0e92$export$651544f548703224(element));
}
function $a4d8f0d03f4d0e92$export$89e651af02346cd4(element) {
    try {
        if (element.matches(":popover-open")) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(":modal");
    } catch (_e) {
        return false;
    }
}
const $a4d8f0d03f4d0e92$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $a4d8f0d03f4d0e92$var$containRe = /paint|layout|strict|content/;
const $a4d8f0d03f4d0e92$var$isNotNone = (value)=>!!value && value !== "none";
let $a4d8f0d03f4d0e92$var$isWebKitValue;
function $a4d8f0d03f4d0e92$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d(elementOrCss) ? $a4d8f0d03f4d0e92$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $a4d8f0d03f4d0e92$var$isNotNone(css.transform) || $a4d8f0d03f4d0e92$var$isNotNone(css.translate) || $a4d8f0d03f4d0e92$var$isNotNone(css.scale) || $a4d8f0d03f4d0e92$var$isNotNone(css.rotate) || $a4d8f0d03f4d0e92$var$isNotNone(css.perspective) || !$a4d8f0d03f4d0e92$export$78551043582a6a98() && ($a4d8f0d03f4d0e92$var$isNotNone(css.backdropFilter) || $a4d8f0d03f4d0e92$var$isNotNone(css.filter)) || $a4d8f0d03f4d0e92$var$willChangeRe.test(css.willChange || "") || $a4d8f0d03f4d0e92$var$containRe.test(css.contain || "");
}
function $a4d8f0d03f4d0e92$export$940d8225183e1404(element) {
    let currentNode = $a4d8f0d03f4d0e92$export$4e12058fc4d51d56(element);
    while($a4d8f0d03f4d0e92$export$1b3bfaa9684536aa(currentNode) && !$a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51(currentNode)){
        if ($a4d8f0d03f4d0e92$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($a4d8f0d03f4d0e92$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $a4d8f0d03f4d0e92$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $a4d8f0d03f4d0e92$export$78551043582a6a98() {
    if ($a4d8f0d03f4d0e92$var$isWebKitValue == null) $a4d8f0d03f4d0e92$var$isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
    return $a4d8f0d03f4d0e92$var$isWebKitValue;
}
function $a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($a4d8f0d03f4d0e92$export$651544f548703224(node));
}
function $a4d8f0d03f4d0e92$export$3735103072e4a80(element) {
    return $a4d8f0d03f4d0e92$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $a4d8f0d03f4d0e92$export$dc8fc79fa2800137(element) {
    if ($a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $a4d8f0d03f4d0e92$export$4e12058fc4d51d56(node) {
    if ($a4d8f0d03f4d0e92$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $a4d8f0d03f4d0e92$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $a4d8f0d03f4d0e92$export$e495491855dc5418(node);
    return $a4d8f0d03f4d0e92$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $a4d8f0d03f4d0e92$export$7cd01a57c8ca906c(node) {
    const parentNode = $a4d8f0d03f4d0e92$export$4e12058fc4d51d56(node);
    if ($a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($a4d8f0d03f4d0e92$export$1b3bfaa9684536aa(parentNode) && $a4d8f0d03f4d0e92$export$989e911fa9af580a(parentNode)) return parentNode;
    return $a4d8f0d03f4d0e92$export$7cd01a57c8ca906c(parentNode);
}
function $a4d8f0d03f4d0e92$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $a4d8f0d03f4d0e92$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $a4d8f0d03f4d0e92$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $a4d8f0d03f4d0e92$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $a4d8f0d03f4d0e92$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $a4d8f0d03f4d0e92$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $a4d8f0d03f4d0e92$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $a4d8f0d03f4d0e92$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $ac9032e133ae40c9$var$getCssDimensions(element) {
    const css = (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $88ea4014521d2d61$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $88ea4014521d2d61$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $ac9032e133ae40c9$var$unwrapElement(element) {
    return !(0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $ac9032e133ae40c9$var$getScale(element) {
    const domElement = $ac9032e133ae40c9$var$unwrapElement(element);
    if (!(0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(domElement)) return (0, $88ea4014521d2d61$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $ac9032e133ae40c9$var$getCssDimensions(domElement);
    let x = ($ ? (0, $88ea4014521d2d61$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $88ea4014521d2d61$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $ac9032e133ae40c9$var$noOffsets = /*#__PURE__*/ (0, $88ea4014521d2d61$export$a397704b5e280835)(0);
function $ac9032e133ae40c9$var$getVisualOffsets(element) {
    const win = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(element);
    if (!(0, $a4d8f0d03f4d0e92$export$78551043582a6a98)() || !win.visualViewport) return $ac9032e133ae40c9$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $ac9032e133ae40c9$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(element);
}
function $ac9032e133ae40c9$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $ac9032e133ae40c9$var$unwrapElement(element);
    let scale = (0, $88ea4014521d2d61$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(offsetParent)) scale = $ac9032e133ae40c9$var$getScale(offsetParent);
        } else scale = $ac9032e133ae40c9$var$getScale(element);
    }
    const visualOffsets = $ac9032e133ae40c9$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $ac9032e133ae40c9$var$getVisualOffsets(domElement) : (0, $88ea4014521d2d61$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $a4d8f0d03f4d0e92$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $ac9032e133ae40c9$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $a4d8f0d03f4d0e92$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $88ea4014521d2d61$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $ac9032e133ae40c9$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $a4d8f0d03f4d0e92$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $ac9032e133ae40c9$var$getBoundingClientRect((0, $a4d8f0d03f4d0e92$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $ac9032e133ae40c9$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $ac9032e133ae40c9$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $ac9032e133ae40c9$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $a4d8f0d03f4d0e92$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $a4d8f0d03f4d0e92$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $88ea4014521d2d61$export$a397704b5e280835)(1);
    const offsets = (0, $88ea4014521d2d61$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $a4d8f0d03f4d0e92$export$651544f548703224)(offsetParent) !== "body" || (0, $a4d8f0d03f4d0e92$export$989e911fa9af580a)(documentElement)) scroll = (0, $a4d8f0d03f4d0e92$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $ac9032e133ae40c9$var$getBoundingClientRect(offsetParent);
            scale = $ac9032e133ae40c9$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $ac9032e133ae40c9$var$getHTMLOffset(documentElement, scroll) : (0, $88ea4014521d2d61$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $ac9032e133ae40c9$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $ac9032e133ae40c9$var$getDocumentRect(html) {
    const scroll = (0, $a4d8f0d03f4d0e92$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $88ea4014521d2d61$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $88ea4014521d2d61$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $ac9032e133ae40c9$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(body).direction === "rtl") x += (0, $88ea4014521d2d61$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $ac9032e133ae40c9$var$SCROLLBAR_MAX = 25;
function $ac9032e133ae40c9$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = "viewport";
    const isLayoutViewport = rootBoundary === "layoutViewport";
    const win = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(element);
    const html = (0, $a4d8f0d03f4d0e92$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $a4d8f0d03f4d0e92$export$78551043582a6a98)() || strategy === "fixed";
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $ac9032e133ae40c9$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === "stable both-edges" ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $ac9032e133ae40c9$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $ac9032e133ae40c9$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $ac9032e133ae40c9$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $ac9032e133ae40c9$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ac9032e133ae40c9$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport" || clippingAncestor === "layoutViewport") rect = $ac9032e133ae40c9$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === "document") rect = $ac9032e133ae40c9$var$getDocumentRect((0, $a4d8f0d03f4d0e92$export$e495491855dc5418)(element));
    else if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $ac9032e133ae40c9$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $ac9032e133ae40c9$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $88ea4014521d2d61$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $ac9032e133ae40c9$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $a4d8f0d03f4d0e92$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(el) && (0, $a4d8f0d03f4d0e92$export$651544f548703224)(el) !== "body");
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $a4d8f0d03f4d0e92$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(currentNode) && !(0, $a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $a4d8f0d03f4d0e92$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? "fixed" : "";
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === "fixed" || lastPosition === "absolute" && computedStyle.position === "static");
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $a4d8f0d03f4d0e92$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $ac9032e133ae40c9$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $a4d8f0d03f4d0e92$export$89e651af02346cd4)(element) ? [] : $ac9032e133ae40c9$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $ac9032e133ae40c9$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $ac9032e133ae40c9$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $88ea4014521d2d61$export$8960430cfd85939f)(rect.top, top);
        right = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $88ea4014521d2d61$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $ac9032e133ae40c9$var$getDimensions(element) {
    const { width: width, height: height } = $ac9032e133ae40c9$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $ac9032e133ae40c9$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $a4d8f0d03f4d0e92$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $ac9032e133ae40c9$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $88ea4014521d2d61$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $a4d8f0d03f4d0e92$export$651544f548703224)(offsetParent) !== "body" || (0, $a4d8f0d03f4d0e92$export$989e911fa9af580a)(documentElement)) scroll = (0, $a4d8f0d03f4d0e92$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $ac9032e133ae40c9$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $ac9032e133ae40c9$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $ac9032e133ae40c9$var$getHTMLOffset(documentElement, scroll) : (0, $88ea4014521d2d61$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $ac9032e133ae40c9$var$isStaticPositioned(element) {
    return (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(element).position === "static";
}
function $ac9032e133ae40c9$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(element) || (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $a4d8f0d03f4d0e92$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $ac9032e133ae40c9$var$getOffsetParent(element, polyfill) {
    const win = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(element);
    if ((0, $a4d8f0d03f4d0e92$export$89e651af02346cd4)(element)) return win;
    if (!(0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $a4d8f0d03f4d0e92$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$ac9032e133ae40c9$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $a4d8f0d03f4d0e92$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $ac9032e133ae40c9$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $a4d8f0d03f4d0e92$export$71535ffaa902797f)(offsetParent) && $ac9032e133ae40c9$var$isStaticPositioned(offsetParent))offsetParent = $ac9032e133ae40c9$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51)(offsetParent) && $ac9032e133ae40c9$var$isStaticPositioned(offsetParent) && !(0, $a4d8f0d03f4d0e92$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $a4d8f0d03f4d0e92$export$940d8225183e1404)(element) || win;
}
const $ac9032e133ae40c9$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $ac9032e133ae40c9$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $ac9032e133ae40c9$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $ac9032e133ae40c9$var$isRTL(element) {
    return (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(element).direction === "rtl";
}
const $ac9032e133ae40c9$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $ac9032e133ae40c9$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $a4d8f0d03f4d0e92$export$e495491855dc5418,
    getClippingRect: $ac9032e133ae40c9$var$getClippingRect,
    getOffsetParent: $ac9032e133ae40c9$var$getOffsetParent,
    getElementRects: $ac9032e133ae40c9$var$getElementRects,
    getClientRects: $ac9032e133ae40c9$var$getClientRects,
    getDimensions: $ac9032e133ae40c9$var$getDimensions,
    getScale: $ac9032e133ae40c9$var$getScale,
    isElement: $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d,
    isRTL: $ac9032e133ae40c9$var$isRTL
};
function $ac9032e133ae40c9$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $ac9032e133ae40c9$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $a4d8f0d03f4d0e92$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $88ea4014521d2d61$export$a3fe094919f356fd)(top);
        const insetRight = (0, $88ea4014521d2d61$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $88ea4014521d2d61$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $88ea4014521d2d61$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $88ea4014521d2d61$export$8960430cfd85939f)(0, (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$ac9032e133ae40c9$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener("resize", handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener("resize", handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $ac9032e133ae40c9$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $ac9032e133ae40c9$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $a4d8f0d03f4d0e92$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $a4d8f0d03f4d0e92$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update);
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $ac9032e133ae40c9$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $ac9032e133ae40c9$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $ac9032e133ae40c9$var$getBoundingClientRect(reference);
        if (prevRefRect && !$ac9032e133ae40c9$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $ac9032e133ae40c9$export$37b6bde19b108ecc = (0, $c525f07740bbb28d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $ac9032e133ae40c9$export$cc800923e997bb8 = (0, $c525f07740bbb28d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $ac9032e133ae40c9$export$91fb6ecbd551914 = (0, $c525f07740bbb28d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $ac9032e133ae40c9$export$fba63a578e423eb = (0, $c525f07740bbb28d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $ac9032e133ae40c9$export$8a83211c878a3f1f = (0, $c525f07740bbb28d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $ac9032e133ae40c9$export$346677f925de839c = (0, $c525f07740bbb28d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $ac9032e133ae40c9$export$fe8985bb6374093c = (0, $c525f07740bbb28d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $ac9032e133ae40c9$export$f2120bbfa5450bd2 = (0, $c525f07740bbb28d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $ac9032e133ae40c9$export$18c8ad048e32c7d5 = (0, $c525f07740bbb28d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $ac9032e133ae40c9$export$7bf07e38f3dc4b69 = (0, $c525f07740bbb28d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $ac9032e133ae40c9$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$ac9032e133ae40c9$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $c525f07740bbb28d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");
var $c729ef3ccf3d54b8$var$isClient = typeof document !== "undefined";
var $c729ef3ccf3d54b8$var$noop = function noop() {};
var $c729ef3ccf3d54b8$var$index = $c729ef3ccf3d54b8$var$isClient ? (0, $cQmXV.useLayoutEffect) : $c729ef3ccf3d54b8$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $c729ef3ccf3d54b8$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$c729ef3ccf3d54b8$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$c729ef3ccf3d54b8$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $c729ef3ccf3d54b8$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $c729ef3ccf3d54b8$var$roundByDPR(element, value) {
    const dpr = $c729ef3ccf3d54b8$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $c729ef3ccf3d54b8$var$useLatestRef(value) {
    const ref = $cQmXV.useRef(value);
    $c729ef3ccf3d54b8$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $c729ef3ccf3d54b8$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $cQmXV.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $cQmXV.useState(middleware);
    if (!$c729ef3ccf3d54b8$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $cQmXV.useState(null);
    const [_floating, _setFloating] = $cQmXV.useState(null);
    const setReference = $cQmXV.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $cQmXV.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $cQmXV.useRef(null);
    const floatingRef = $cQmXV.useRef(null);
    const dataRef = $cQmXV.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $c729ef3ccf3d54b8$var$useLatestRef(whileElementsMounted);
    const platformRef = $c729ef3ccf3d54b8$var$useLatestRef(platform);
    const openRef = $c729ef3ccf3d54b8$var$useLatestRef(open);
    const update = $cQmXV.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $ac9032e133ae40c9$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$c729ef3ccf3d54b8$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $3h5eW.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $c729ef3ccf3d54b8$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $cQmXV.useRef(false);
    $c729ef3ccf3d54b8$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $c729ef3ccf3d54b8$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $cQmXV.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $cQmXV.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $cQmXV.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $c729ef3ccf3d54b8$var$roundByDPR(elements.floating, data.x);
        const y = $c729ef3ccf3d54b8$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$c729ef3ccf3d54b8$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $cQmXV.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c729ef3ccf3d54b8$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $ac9032e133ae40c9$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $ac9032e133ae40c9$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c729ef3ccf3d54b8$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c729ef3ccf3d54b8$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c729ef3ccf3d54b8$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c729ef3ccf3d54b8$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c729ef3ccf3d54b8$export$346677f925de839c = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c729ef3ccf3d54b8$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c729ef3ccf3d54b8$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c729ef3ccf3d54b8$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $ac9032e133ae40c9$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c729ef3ccf3d54b8$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $c729ef3ccf3d54b8$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");

/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $5d6cf80714d2ed15$var$candidateSelectors = [
    "input:not([inert]):not([inert] *)",
    "select:not([inert]):not([inert] *)",
    "textarea:not([inert]):not([inert] *)",
    "a[href]:not([inert]):not([inert] *)",
    "area[href]:not([inert]):not([inert] *)",
    "button:not([inert]):not([inert] *)",
    "[tabindex]:not(slot):not([inert]):not([inert] *)",
    "audio[controls]:not([inert]):not([inert] *)",
    "video[controls]:not([inert]):not([inert] *)",
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    "details>summary:first-of-type:not([inert]):not([inert] *)",
    "details:not([inert]):not([inert] *)"
];
var $5d6cf80714d2ed15$var$candidateSelector = /* #__PURE__ */ $5d6cf80714d2ed15$var$candidateSelectors.join(",");
var $5d6cf80714d2ed15$var$NoElement = typeof Element === "undefined";
var $5d6cf80714d2ed15$var$matches = $5d6cf80714d2ed15$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $5d6cf80714d2ed15$var$getRootNode = !$5d6cf80714d2ed15$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $5d6cf80714d2ed15$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === "function" ? node.closest("[inert]") : $5d6cf80714d2ed15$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $5d6cf80714d2ed15$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $5d6cf80714d2ed15$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($5d6cf80714d2ed15$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($5d6cf80714d2ed15$var$candidateSelector));
    if (includeContainer && $5d6cf80714d2ed15$var$matches.call(el, $5d6cf80714d2ed15$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $5d6cf80714d2ed15$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($5d6cf80714d2ed15$var$_isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $5d6cf80714d2ed15$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $5d6cf80714d2ed15$var$matches.call(element, $5d6cf80714d2ed15$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$5d6cf80714d2ed15$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $5d6cf80714d2ed15$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $5d6cf80714d2ed15$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $5d6cf80714d2ed15$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $5d6cf80714d2ed15$var$isContentEditable(node)) && !$5d6cf80714d2ed15$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $5d6cf80714d2ed15$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $5d6cf80714d2ed15$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$5d6cf80714d2ed15$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $5d6cf80714d2ed15$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $5d6cf80714d2ed15$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $5d6cf80714d2ed15$var$isHiddenInput = function isHiddenInput(node) {
    return $5d6cf80714d2ed15$var$isInput(node) && node.type === "hidden";
};
var $5d6cf80714d2ed15$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $5d6cf80714d2ed15$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $5d6cf80714d2ed15$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $5d6cf80714d2ed15$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $5d6cf80714d2ed15$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $5d6cf80714d2ed15$var$isRadio = function isRadio(node) {
    return $5d6cf80714d2ed15$var$isInput(node) && node.type === "radio";
};
var $5d6cf80714d2ed15$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $5d6cf80714d2ed15$var$isRadio(node) && !$5d6cf80714d2ed15$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $5d6cf80714d2ed15$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $5d6cf80714d2ed15$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $5d6cf80714d2ed15$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $5d6cf80714d2ed15$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $5d6cf80714d2ed15$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === "full-native") {
        if ("checkVisibility" in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === "hidden" || visibility === "collapse") return true;
    var isDirectSummary = $5d6cf80714d2ed15$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($5d6cf80714d2ed15$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === "full-native" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $5d6cf80714d2ed15$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $5d6cf80714d2ed15$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($5d6cf80714d2ed15$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $5d6cf80714d2ed15$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $5d6cf80714d2ed15$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $5d6cf80714d2ed15$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $5d6cf80714d2ed15$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $5d6cf80714d2ed15$var$isHiddenInput(node) || $5d6cf80714d2ed15$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $5d6cf80714d2ed15$var$isDetailsWithSummary(node) || $5d6cf80714d2ed15$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $5d6cf80714d2ed15$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($5d6cf80714d2ed15$var$isNonTabbableRadio(node) || $5d6cf80714d2ed15$export$a4672efddb4181b8(node) < 0 || !$5d6cf80714d2ed15$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $5d6cf80714d2ed15$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $5d6cf80714d2ed15$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $5d6cf80714d2ed15$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $5d6cf80714d2ed15$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($5d6cf80714d2ed15$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $5d6cf80714d2ed15$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $5d6cf80714d2ed15$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $5d6cf80714d2ed15$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $5d6cf80714d2ed15$var$isShadowRootTabbable
    });
    else candidates = $5d6cf80714d2ed15$var$getCandidates(container, options.includeContainer, $5d6cf80714d2ed15$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $5d6cf80714d2ed15$var$_sortByOrder(candidates);
};
var $5d6cf80714d2ed15$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $5d6cf80714d2ed15$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $5d6cf80714d2ed15$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $5d6cf80714d2ed15$var$getCandidates(container, options.includeContainer, $5d6cf80714d2ed15$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $5d6cf80714d2ed15$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($5d6cf80714d2ed15$var$matches.call(node, $5d6cf80714d2ed15$var$candidateSelector) === false) return false;
    return $5d6cf80714d2ed15$var$isNodeMatchingSelectorTabbable(options, node);
};
var $5d6cf80714d2ed15$var$focusableCandidateSelector = /* #__PURE__ */ $5d6cf80714d2ed15$var$candidateSelectors.concat("iframe:not([inert]):not([inert] *)").join(",");
var $5d6cf80714d2ed15$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($5d6cf80714d2ed15$var$matches.call(node, $5d6cf80714d2ed15$var$focusableCandidateSelector) === false) return false;
    return $5d6cf80714d2ed15$var$isNodeMatchingSelectorFocusable(options, node);
};


// Avoid Chrome DevTools blue warning.
function $995b10da1f78ffb1$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $995b10da1f78ffb1$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
function $995b10da1f78ffb1$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $995b10da1f78ffb1$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($995b10da1f78ffb1$export$867a782338812cb4()) || re.test($995b10da1f78ffb1$export$7935961ef7719cb0());
}
function $995b10da1f78ffb1$export$9ac100e40613ea10() {
    return $995b10da1f78ffb1$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $995b10da1f78ffb1$export$c8f880a2d81914c4() {
    return $995b10da1f78ffb1$export$7935961ef7719cb0().includes("jsdom/");
}
const $995b10da1f78ffb1$var$FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
const $995b10da1f78ffb1$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $995b10da1f78ffb1$var$ARROW_LEFT = "ArrowLeft";
const $995b10da1f78ffb1$var$ARROW_RIGHT = "ArrowRight";
const $995b10da1f78ffb1$var$ARROW_UP = "ArrowUp";
const $995b10da1f78ffb1$var$ARROW_DOWN = "ArrowDown";
function $995b10da1f78ffb1$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $995b10da1f78ffb1$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $a4d8f0d03f4d0e92$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $995b10da1f78ffb1$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $995b10da1f78ffb1$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $995b10da1f78ffb1$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $995b10da1f78ffb1$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $995b10da1f78ffb1$export$42ad131c32f0fb8d(element) {
    return (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(element) && element.matches($995b10da1f78ffb1$var$TYPEABLE_SELECTOR);
}
function $995b10da1f78ffb1$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $995b10da1f78ffb1$export$42ad131c32f0fb8d(element);
}
function $995b10da1f78ffb1$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $995b10da1f78ffb1$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(":focus-visible");
    } catch (_e) {
        return true;
    }
}
function $995b10da1f78ffb1$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($995b10da1f78ffb1$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $995b10da1f78ffb1$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $995b10da1f78ffb1$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$995b10da1f78ffb1$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $995b10da1f78ffb1$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $995b10da1f78ffb1$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $995b10da1f78ffb1$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $995b10da1f78ffb1$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $995b10da1f78ffb1$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $995b10da1f78ffb1$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($995b10da1f78ffb1$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $995b10da1f78ffb1$export$29bf1b5f2c56cf63(event) {
    if ($995b10da1f78ffb1$export$c8f880a2d81914c4()) return false;
    return !$995b10da1f78ffb1$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $995b10da1f78ffb1$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $995b10da1f78ffb1$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
var $995b10da1f78ffb1$var$isClient = typeof document !== "undefined";
var $995b10da1f78ffb1$var$noop = function noop() {};
var $995b10da1f78ffb1$export$bb3b3b3acfd7447f = $995b10da1f78ffb1$var$isClient ? (0, $cQmXV.useLayoutEffect) : $995b10da1f78ffb1$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $995b10da1f78ffb1$var$SafeReact = {
    ...$cQmXV
};
function $995b10da1f78ffb1$export$bcd07ba85a740103(value) {
    const ref = $cQmXV.useRef(value);
    $995b10da1f78ffb1$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $995b10da1f78ffb1$var$useInsertionEffect = $995b10da1f78ffb1$var$SafeReact.useInsertionEffect;
const $995b10da1f78ffb1$var$useSafeInsertionEffect = $995b10da1f78ffb1$var$useInsertionEffect || ((fn)=>fn());
function $995b10da1f78ffb1$export$7f54fc3180508a52(callback) {
    const ref = $cQmXV.useRef(()=>{});
    $995b10da1f78ffb1$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $cQmXV.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $995b10da1f78ffb1$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $995b10da1f78ffb1$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $995b10da1f78ffb1$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $995b10da1f78ffb1$export$b585558af466e926(listRef, disabledIndices) {
    return $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $995b10da1f78ffb1$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $995b10da1f78ffb1$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $995b10da1f78ffb1$var$ARROW_UP) {
        stop && $995b10da1f78ffb1$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($995b10da1f78ffb1$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $995b10da1f78ffb1$var$ARROW_DOWN) {
        stop && $995b10da1f78ffb1$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($995b10da1f78ffb1$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $88ea4014521d2d61$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $995b10da1f78ffb1$var$ARROW_LEFT : $995b10da1f78ffb1$var$ARROW_RIGHT)) {
            stop && $995b10da1f78ffb1$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $995b10da1f78ffb1$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($995b10da1f78ffb1$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $995b10da1f78ffb1$var$ARROW_RIGHT : $995b10da1f78ffb1$var$ARROW_LEFT)) {
            stop && $995b10da1f78ffb1$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $995b10da1f78ffb1$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($995b10da1f78ffb1$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $88ea4014521d2d61$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($995b10da1f78ffb1$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $995b10da1f78ffb1$var$ARROW_RIGHT : $995b10da1f78ffb1$var$ARROW_LEFT) ? maxIndex : $995b10da1f78ffb1$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $995b10da1f78ffb1$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $995b10da1f78ffb1$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $995b10da1f78ffb1$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $995b10da1f78ffb1$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === "function") return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
const $995b10da1f78ffb1$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $995b10da1f78ffb1$var$getTabbableIn(container, dir) {
    const list = (0, $5d6cf80714d2ed15$export$17100aea90429aa7)(container, $995b10da1f78ffb1$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $995b10da1f78ffb1$export$da980962bd2147a4($995b10da1f78ffb1$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $995b10da1f78ffb1$export$28f33206776129a7(referenceElement) {
    return $995b10da1f78ffb1$var$getTabbableIn($995b10da1f78ffb1$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $995b10da1f78ffb1$export$2e5518c3303f364a(referenceElement) {
    return $995b10da1f78ffb1$var$getTabbableIn($995b10da1f78ffb1$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $995b10da1f78ffb1$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$995b10da1f78ffb1$export$2344b14b097df817(containerElement, relatedTarget);
}
function $995b10da1f78ffb1$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $5d6cf80714d2ed15$export$17100aea90429aa7)(container, $995b10da1f78ffb1$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $995b10da1f78ffb1$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}



var $7uT18 = parcelRequire("7uT18");



var $3h5eW = parcelRequire("3h5eW");


/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $b4dc2c56860261c6$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $cQmXV.useRef(undefined);
    const refEffect = $cQmXV.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === "function") {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === "function" ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $cQmXV.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $b4dc2c56860261c6$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $b4dc2c56860261c6$var$FloatingListContext = /*#__PURE__*/ $cQmXV.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $b4dc2c56860261c6$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $cQmXV.useState(()=>new Set());
    const register = $cQmXV.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $cQmXV.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $cQmXV.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($b4dc2c56860261c6$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FloatingListContext.Provider, {
        value: $cQmXV.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $b4dc2c56860261c6$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $cQmXV.useContext($b4dc2c56860261c6$var$FloatingListContext);
    const [index, setIndex] = $cQmXV.useState(null);
    const componentRef = $cQmXV.useRef(null);
    const ref = $cQmXV.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $cQmXV.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $b4dc2c56860261c6$var$FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
const $b4dc2c56860261c6$var$ACTIVE_KEY = "active";
const $b4dc2c56860261c6$var$SELECTED_KEY = "selected";
const $b4dc2c56860261c6$var$ARROW_LEFT = "ArrowLeft";
const $b4dc2c56860261c6$var$ARROW_RIGHT = "ArrowRight";
const $b4dc2c56860261c6$var$ARROW_UP = "ArrowUp";
const $b4dc2c56860261c6$var$ARROW_DOWN = "ArrowDown";
function $b4dc2c56860261c6$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $cQmXV.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        ...computedProps
    });
}
const $b4dc2c56860261c6$var$CompositeContext = /*#__PURE__*/ $cQmXV.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $b4dc2c56860261c6$var$horizontalKeys = [
    $b4dc2c56860261c6$var$ARROW_LEFT,
    $b4dc2c56860261c6$var$ARROW_RIGHT
];
const $b4dc2c56860261c6$var$verticalKeys = [
    $b4dc2c56860261c6$var$ARROW_UP,
    $b4dc2c56860261c6$var$ARROW_DOWN
];
const $b4dc2c56860261c6$var$allKeys = [
    ...$b4dc2c56860261c6$var$horizontalKeys,
    ...$b4dc2c56860261c6$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $b4dc2c56860261c6$export$43586241d9db0c6d = /*#__PURE__*/ $cQmXV.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = "both", loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $cQmXV.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $cQmXV.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $cQmXV.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$b4dc2c56860261c6$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $995b10da1f78ffb1$export$53f691ee0acc6058)(elementsRef, disabledIndices);
        const maxIndex = (0, $995b10da1f78ffb1$export$b585558af466e926)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $b4dc2c56860261c6$var$ARROW_LEFT : $b4dc2c56860261c6$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $b4dc2c56860261c6$var$ARROW_RIGHT : $b4dc2c56860261c6$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $995b10da1f78ffb1$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $995b10da1f78ffb1$export$446656ed0410fd9)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $995b10da1f78ffb1$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $995b10da1f78ffb1$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $995b10da1f78ffb1$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== "function" ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, $995b10da1f78ffb1$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $995b10da1f78ffb1$export$dab2b2ce7761f8e4)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $b4dc2c56860261c6$var$ARROW_DOWN ? "bl" : event.key === horizontalEndKey ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $b4dc2c56860261c6$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $b4dc2c56860261c6$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $b4dc2c56860261c6$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $b4dc2c56860261c6$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $b4dc2c56860261c6$var$allKeys : ({
            horizontal: $b4dc2c56860261c6$var$horizontalKeys,
            vertical: $b4dc2c56860261c6$var$verticalKeys,
            both: $b4dc2c56860261c6$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $995b10da1f78ffb1$export$3fc3ea4a67cf714)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $995b10da1f78ffb1$export$75effb89758ec596)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $b4dc2c56860261c6$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $b4dc2c56860261c6$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $cQmXV.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $cQmXV.useContext($b4dc2c56860261c6$var$CompositeContext);
    const { ref: ref, index: index } = $b4dc2c56860261c6$export$dcdc7ff5149f7d1a();
    const mergedRef = $b4dc2c56860261c6$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $b4dc2c56860261c6$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $b4dc2c56860261c6$var$SafeReact = {
    ...$cQmXV
};
let $b4dc2c56860261c6$var$serverHandoffComplete = false;
let $b4dc2c56860261c6$var$count = 0;
const $b4dc2c56860261c6$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $b4dc2c56860261c6$var$count++;
function $b4dc2c56860261c6$var$useFloatingId() {
    const [id, setId] = $cQmXV.useState(()=>$b4dc2c56860261c6$var$serverHandoffComplete ? $b4dc2c56860261c6$var$genId() : undefined);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (id == null) setId($b4dc2c56860261c6$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $cQmXV.useEffect(()=>{
        $b4dc2c56860261c6$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $b4dc2c56860261c6$var$useReactId = $b4dc2c56860261c6$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $b4dc2c56860261c6$export$f680877a34711e37 = $b4dc2c56860261c6$var$useReactId || $b4dc2c56860261c6$var$useFloatingId;
let $b4dc2c56860261c6$var$devMessageSet;
function $b4dc2c56860261c6$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $b4dc2c56860261c6$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $b4dc2c56860261c6$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $b4dc2c56860261c6$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $b4dc2c56860261c6$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $b4dc2c56860261c6$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $b4dc2c56860261c6$export$33511391554732bc = /*#__PURE__*/ $cQmXV.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $b4dc2c56860261c6$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $cQmXV.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        const isRTL = (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split("-");
    const isVerticalSide = side === "top" || side === "bottom";
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ (0, $7uT18.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(" "),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : "none",
                d: dValue
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $7uT18.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $b4dc2c56860261c6$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $b4dc2c56860261c6$var$FloatingNodeContext = /*#__PURE__*/ $cQmXV.createContext(null);
const $b4dc2c56860261c6$var$FloatingTreeContext = /*#__PURE__*/ $cQmXV.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $b4dc2c56860261c6$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $cQmXV.useContext($b4dc2c56860261c6$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $b4dc2c56860261c6$export$db0c2a7c7a2a4f69 = ()=>$cQmXV.useContext($b4dc2c56860261c6$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $b4dc2c56860261c6$export$9b136e0e758a42f4(customParentId) {
    const id = $b4dc2c56860261c6$export$f680877a34711e37();
    const tree = $b4dc2c56860261c6$export$db0c2a7c7a2a4f69();
    const reactParentId = $b4dc2c56860261c6$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $b4dc2c56860261c6$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $b4dc2c56860261c6$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FloatingNodeContext.Provider, {
        value: $cQmXV.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $b4dc2c56860261c6$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $cQmXV.useRef([]);
    const addNode = $cQmXV.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $cQmXV.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $cQmXV.useState(()=>$b4dc2c56860261c6$var$createEventEmitter());
    return /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FloatingTreeContext.Provider, {
        value: $cQmXV.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $b4dc2c56860261c6$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $b4dc2c56860261c6$var$safePolygonIdentifier = /*#__PURE__*/ $b4dc2c56860261c6$var$createAttribute("safe-polygon");
function $b4dc2c56860261c6$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $995b10da1f78ffb1$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === "number") return value;
    if (typeof value === "function") {
        const result = value();
        if (typeof result === "number") return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $b4dc2c56860261c6$var$getRestMs(value) {
    if (typeof value === "function") return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $b4dc2c56860261c6$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $b4dc2c56860261c6$export$db0c2a7c7a2a4f69();
    const parentId = $b4dc2c56860261c6$export$165209eae06d3488();
    const handleCloseRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(handleClose);
    const delayRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(delay);
    const openRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(open);
    const restMsRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(restMs);
    const pointerTypeRef = $cQmXV.useRef();
    const timeoutRef = $cQmXV.useRef(-1);
    const handlerRef = $cQmXV.useRef();
    const restTimeoutRef = $cQmXV.useRef(-1);
    const blockMouseMoveRef = $cQmXV.useRef(true);
    const performedPointerEventsMutationRef = $cQmXV.useRef(false);
    const unbindMouseMoveRef = $cQmXV.useRef(()=>{});
    const restTimeoutPendingRef = $cQmXV.useRef(false);
    const isHoverOpen = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $cQmXV.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
                $b4dc2c56860261c6$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $cQmXV.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $cQmXV.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $b4dc2c56860261c6$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($b4dc2c56860261c6$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(()=>{
        return dataRef.current.openEvent ? [
            "click",
            "mousedown"
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $cQmXV.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $995b10da1f78ffb1$export$81cf264172d31e51)(pointerTypeRef.current) || $b4dc2c56860261c6$var$getRestMs(restMsRef.current) > 0 && !$b4dc2c56860261c6$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $b4dc2c56860261c6$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else if (!open) onOpenChange(true, event, "hover");
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.floating);
            $b4dc2c56860261c6$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $995b10da1f78ffb1$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener("mouseleave", onScrollMouseLeave);
            if (move) reference.addEventListener("mousemove", onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener("mouseenter", onReferenceMouseEnter);
            reference.addEventListener("mouseleave", onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener("mouseleave", onScrollMouseLeave);
                floating.addEventListener("mouseenter", onFloatingMouseEnter);
                floating.addEventListener("mouseleave", onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener("mouseleave", onScrollMouseLeave);
                if (move) reference.removeEventListener("mousemove", onReferenceMouseEnter);
                reference.removeEventListener("mouseenter", onReferenceMouseEnter);
                reference.removeEventListener("mouseleave", onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener("mouseleave", onScrollMouseLeave);
                    floating.removeEventListener("mouseenter", onFloatingMouseEnter);
                    floating.removeEventListener("mouseleave", onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($b4dc2c56860261c6$var$safePolygonIdentifier, "");
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $cQmXV.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
            $b4dc2c56860261c6$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $cQmXV.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, $995b10da1f78ffb1$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || $b4dc2c56860261c6$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $b4dc2c56860261c6$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $b4dc2c56860261c6$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $b4dc2c56860261c6$var$NOOP = ()=>{};
const $b4dc2c56860261c6$var$FloatingDelayGroupContext = /*#__PURE__*/ $cQmXV.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $b4dc2c56860261c6$var$NOOP,
    setState: $b4dc2c56860261c6$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $b4dc2c56860261c6$export$e2411914b150383d = ()=>$cQmXV.useContext($b4dc2c56860261c6$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $b4dc2c56860261c6$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $cQmXV.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $cQmXV.useRef(null);
    const setCurrentId = $cQmXV.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FloatingDelayGroupContext.Provider, {
        value: $cQmXV.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $b4dc2c56860261c6$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $b4dc2c56860261c6$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $b4dc2c56860261c6$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (setCurrentId === $b4dc2c56860261c6$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $b4dc2c56860261c6$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $cQmXV.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $b4dc2c56860261c6$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $cQmXV.useRef(delay);
    const initialDelayRef = $cQmXV.useRef(delay);
    const currentIdRef = $cQmXV.useRef(null);
    const currentContextRef = $cQmXV.useRef(null);
    const timeoutIdRef = $cQmXV.useRef(-1);
    return /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$NextFloatingDelayGroupContext.Provider, {
        value: $cQmXV.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $b4dc2c56860261c6$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $cQmXV.useContext($b4dc2c56860261c6$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $cQmXV.useState(false);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $b4dc2c56860261c6$var$getDelay(initialDelayRef.current, "close")
        };
        if (prevId !== null && prevId !== floatingId) {
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $cQmXV.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $b4dc2c56860261c6$var$rafId = 0;
function $b4dc2c56860261c6$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($b4dc2c56860261c6$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $b4dc2c56860261c6$var$rafId = requestAnimationFrame(exec);
}
function $b4dc2c56860261c6$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $a4d8f0d03f4d0e92$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $b4dc2c56860261c6$var$getTarget(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $b4dc2c56860261c6$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const $b4dc2c56860261c6$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    "aria-hidden": /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $b4dc2c56860261c6$var$getCounterMap(control) {
    if (control === "inert") return $b4dc2c56860261c6$var$counters.inert;
    if (control === "aria-hidden") return $b4dc2c56860261c6$var$counters["aria-hidden"];
    return $b4dc2c56860261c6$var$counters.none;
}
let $b4dc2c56860261c6$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $b4dc2c56860261c6$var$markerMap = {};
let $b4dc2c56860261c6$var$lockCount$1 = 0;
const $b4dc2c56860261c6$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
function $b4dc2c56860261c6$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $a4d8f0d03f4d0e92$export$af51f0f06c0f328a)(node) ? node.host : $b4dc2c56860261c6$var$unwrapHost(node.parentNode);
}
const $b4dc2c56860261c6$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $b4dc2c56860261c6$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $b4dc2c56860261c6$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $b4dc2c56860261c6$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$b4dc2c56860261c6$var$markerMap[markerName]) $b4dc2c56860261c6$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $b4dc2c56860261c6$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $a4d8f0d03f4d0e92$export$651544f548703224)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterMap = $b4dc2c56860261c6$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $b4dc2c56860261c6$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === "inert" ? "" : "true");
            }
        });
    }
    $b4dc2c56860261c6$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = $b4dc2c56860261c6$var$getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$b4dc2c56860261c6$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $b4dc2c56860261c6$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $b4dc2c56860261c6$var$lockCount$1--;
        if (!$b4dc2c56860261c6$var$lockCount$1) {
            $b4dc2c56860261c6$var$counters.inert = new WeakMap();
            $b4dc2c56860261c6$var$counters["aria-hidden"] = new WeakMap();
            $b4dc2c56860261c6$var$counters.none = new WeakMap();
            $b4dc2c56860261c6$var$uncontrolledElementsSet = new WeakSet();
            $b4dc2c56860261c6$var$markerMap = {};
        }
    };
}
function $b4dc2c56860261c6$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $b4dc2c56860261c6$var$getDocument(avoidElements[0]).body;
    return $b4dc2c56860261c6$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const $b4dc2c56860261c6$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
const $b4dc2c56860261c6$var$FocusGuard = /*#__PURE__*/ $cQmXV.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $cQmXV.useState();
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if ((0, $995b10da1f78ffb1$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$b4dc2c56860261c6$var$createAttribute("focus-guard")]: "",
        style: $b4dc2c56860261c6$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $b4dc2c56860261c6$var$HIDDEN_OWNER_STYLES = {
    clipPath: "inset(50%)",
    position: "fixed",
    top: 0,
    left: 0
};
const $b4dc2c56860261c6$var$PortalContext = /*#__PURE__*/ $cQmXV.createContext(null);
const $b4dc2c56860261c6$var$attr = /*#__PURE__*/ $b4dc2c56860261c6$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $b4dc2c56860261c6$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $b4dc2c56860261c6$export$f680877a34711e37();
    const portalContext = $b4dc2c56860261c6$var$usePortalContext();
    const [portalNode, setPortalNode] = $cQmXV.useState(null);
    const portalNodeRef = $cQmXV.useRef(null);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($b4dc2c56860261c6$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $a4d8f0d03f4d0e92$export$8ee0fc9ee280b4ee)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($b4dc2c56860261c6$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $b4dc2c56860261c6$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $b4dc2c56860261c6$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $cQmXV.useState(null);
    const beforeOutsideRef = $cQmXV.useRef(null);
    const afterOutsideRef = $cQmXV.useRef(null);
    const beforeInsideRef = $cQmXV.useRef(null);
    const afterInsideRef = $cQmXV.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $cQmXV.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $995b10da1f78ffb1$export$6e0c4e272f3faa2)(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? (0, $995b10da1f78ffb1$export$a65f4028abb17f36) : (0, $995b10da1f78ffb1$export$3995dd353b80da11);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $cQmXV.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $995b10da1f78ffb1$export$a65f4028abb17f36)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsxs)($b4dc2c56860261c6$var$PortalContext.Provider, {
        value: $cQmXV.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $995b10da1f78ffb1$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $995b10da1f78ffb1$export$2e5518c3303f364a)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $b4dc2c56860261c6$var$HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ $3h5eW.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $995b10da1f78ffb1$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $995b10da1f78ffb1$export$28f33206776129a7)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
                    }
                }
            })
        ]
    });
}
const $b4dc2c56860261c6$var$usePortalContext = ()=>$cQmXV.useContext($b4dc2c56860261c6$var$PortalContext);
function $b4dc2c56860261c6$var$useLiteMergeRefs(refs) {
    return $cQmXV.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $b4dc2c56860261c6$var$LIST_LIMIT = 20;
let $b4dc2c56860261c6$var$previouslyFocusedElements = [];
function $b4dc2c56860261c6$var$clearDisconnectedPreviouslyFocusedElements() {
    $b4dc2c56860261c6$var$previouslyFocusedElements = $b4dc2c56860261c6$var$previouslyFocusedElements.filter((elementRef)=>{
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function $b4dc2c56860261c6$var$addPreviouslyFocusedElement(element) {
    $b4dc2c56860261c6$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $a4d8f0d03f4d0e92$export$651544f548703224)(element) !== "body") {
        $b4dc2c56860261c6$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($b4dc2c56860261c6$var$previouslyFocusedElements.length > $b4dc2c56860261c6$var$LIST_LIMIT) $b4dc2c56860261c6$var$previouslyFocusedElements = $b4dc2c56860261c6$var$previouslyFocusedElements.slice(-$b4dc2c56860261c6$var$LIST_LIMIT);
    }
}
function $b4dc2c56860261c6$var$getPreviouslyFocusedElement() {
    $b4dc2c56860261c6$var$clearDisconnectedPreviouslyFocusedElements();
    const elementRef = $b4dc2c56860261c6$var$previouslyFocusedElements[$b4dc2c56860261c6$var$previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function $b4dc2c56860261c6$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $995b10da1f78ffb1$export$6324a2bbae6a332f)();
    if ((0, $5d6cf80714d2ed15$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $5d6cf80714d2ed15$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
function $b4dc2c56860261c6$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes("floating") && !((_floatingFocusElement = floatingFocusElement.getAttribute("role")) != null && _floatingFocusElement.includes("dialog"))) return;
    const options = (0, $995b10da1f78ffb1$export$6324a2bbae6a332f)();
    const focusableElements = (0, $5d6cf80714d2ed15$export$ecc6d1fcdff4f700)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute("data-tabindex") || "";
        return (0, $5d6cf80714d2ed15$export$bebd5a1431fec25d)(element, options) || element.hasAttribute("data-tabindex") && !dataTabIndex.startsWith("-");
    });
    const tabIndex = floatingFocusElement.getAttribute("tabindex");
    if (orderRef.current.includes("floating") || tabbableContent.length === 0) {
        if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
    } else if (tabIndex !== "-1" || floatingFocusElement.hasAttribute("data-tabindex") && floatingFocusElement.getAttribute("data-tabindex") !== "-1") {
        floatingFocusElement.setAttribute("tabindex", "-1");
        floatingFocusElement.setAttribute("data-tabindex", "-1");
    }
}
const $b4dc2c56860261c6$var$VisuallyHiddenDismiss = /*#__PURE__*/ $cQmXV.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $b4dc2c56860261c6$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $b4dc2c56860261c6$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $995b10da1f78ffb1$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $b4dc2c56860261c6$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(order);
    const initialFocusRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(initialFocus);
    const returnFocusRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(returnFocus);
    const tree = $b4dc2c56860261c6$export$db0c2a7c7a2a4f69();
    const portalContext = $b4dc2c56860261c6$var$usePortalContext();
    const startDismissButtonRef = $cQmXV.useRef(null);
    const endDismissButtonRef = $cQmXV.useRef(null);
    const preventReturnFocusRef = $cQmXV.useRef(false);
    const isPointerDownRef = $cQmXV.useRef(false);
    const tabbableIndexRef = $cQmXV.useRef(-1);
    const blurTimeoutRef = $cQmXV.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $995b10da1f78ffb1$export$9b0901b5e9b45fc7)(floating);
    const getTabbableContent = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $5d6cf80714d2ed15$export$17100aea90429aa7)(container, (0, $995b10da1f78ffb1$export$6324a2bbae6a332f)()) : [];
    });
    const getTabbableElements = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $cQmXV.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $995b10da1f78ffb1$export$2344b14b097df817)(floatingFocusElement, (0, $995b10da1f78ffb1$export$da980962bd2147a4)((0, $995b10da1f78ffb1$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $b4dc2c56860261c6$var$enqueueFocus(els[els.length - 1]);
                    else $b4dc2c56860261c6$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                    $b4dc2c56860261c6$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $cQmXV.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $cQmXV.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $995b10da1f78ffb1$export$2344b14b097df817)(domReference, relatedTarget) || (0, $995b10da1f78ffb1$export$2344b14b097df817)(floating, relatedTarget) || (0, $995b10da1f78ffb1$export$2344b14b097df817)(relatedTarget, floating) || (0, $995b10da1f78ffb1$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($b4dc2c56860261c6$var$createAttribute("focus-guard")) || tree && ((0, $995b10da1f78ffb1$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $995b10da1f78ffb1$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $995b10da1f78ffb1$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $995b10da1f78ffb1$export$5d8eb345316b65c0)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $995b10da1f78ffb1$export$9b0901b5e9b45fc7)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $b4dc2c56860261c6$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $995b10da1f78ffb1$export$da980962bd2147a4)((0, $995b10da1f78ffb1$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $b4dc2c56860261c6$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $b4dc2c56860261c6$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener("focusout", markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener("focusout", markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = $cQmXV.useRef(null);
    const afterGuardRef = $cQmXV.useRef(null);
    const mergedBeforeGuardRef = $b4dc2c56860261c6$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $b4dc2c56860261c6$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $cQmXV.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $b4dc2c56860261c6$var$createAttribute("portal") + "]")) || []);
        const ancestors = tree ? (0, $995b10da1f78ffb1$export$5d8eb345316b65c0)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, $995b10da1f78ffb1$export$259ba5ae38188551)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $b4dc2c56860261c6$var$markOthers(insideElements, !useInert, useInert) : $b4dc2c56860261c6$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !(0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $995b10da1f78ffb1$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $995b10da1f78ffb1$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $b4dc2c56860261c6$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $995b10da1f78ffb1$export$da980962bd2147a4)(doc);
        $b4dc2c56860261c6$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                "hover",
                "safe-polygon"
            ].includes(reason) && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $995b10da1f78ffb1$export$60278871457622de)(event) || (0, $995b10da1f78ffb1$export$29bf1b5f2c56cf63)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement("div").focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on("openchange", onOpenChange);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, $b4dc2c56860261c6$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === "boolean") {
                const el = domReference || $b4dc2c56860261c6$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $995b10da1f78ffb1$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $995b10da1f78ffb1$export$2344b14b097df817)(floating, activeEl) || tree && (0, $995b10da1f78ffb1$export$1f1998cc3c6b56fb)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, $995b10da1f78ffb1$export$2344b14b097df817)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $b4dc2c56860261c6$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $cQmXV.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask($b4dc2c56860261c6$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $b4dc2c56860261c6$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss"
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $b4dc2c56860261c6$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $995b10da1f78ffb1$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $995b10da1f78ffb1$export$28f33206776129a7)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton("start"),
            children,
            renderDismissButton("end"),
            shouldRenderGuards && /*#__PURE__*/ (0, $7uT18.jsx)($b4dc2c56860261c6$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $b4dc2c56860261c6$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $995b10da1f78ffb1$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $995b10da1f78ffb1$export$2e5518c3303f364a)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $b4dc2c56860261c6$var$lockCount = 0;
const $b4dc2c56860261c6$var$scrollbarProperty = "--floating-ui-scrollbar-width";
function $b4dc2c56860261c6$var$enableScrollLock() {
    const platform = (0, $995b10da1f78ffb1$export$867a782338812cb4)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === "MacIntel" && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    bodyStyle.setProperty($b4dc2c56860261c6$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0"
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        bodyStyle.removeProperty($b4dc2c56860261c6$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $b4dc2c56860261c6$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $b4dc2c56860261c6$export$a35954495955337b = /*#__PURE__*/ $cQmXV.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!lockScroll) return;
        $b4dc2c56860261c6$var$lockCount++;
        if ($b4dc2c56860261c6$var$lockCount === 1) $b4dc2c56860261c6$var$cleanup = $b4dc2c56860261c6$var$enableScrollLock();
        return ()=>{
            $b4dc2c56860261c6$var$lockCount--;
            if ($b4dc2c56860261c6$var$lockCount === 0) $b4dc2c56860261c6$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $b4dc2c56860261c6$var$isButtonTarget(event) {
    return (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === "BUTTON";
}
function $b4dc2c56860261c6$var$isAnchorTarget(event) {
    return (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === "A";
}
function $b4dc2c56860261c6$var$isSpaceIgnored(element) {
    return (0, $995b10da1f78ffb1$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $b4dc2c56860261c6$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $cQmXV.useRef();
    const didKeyDownRef = $cQmXV.useRef(false);
    const reference = $cQmXV.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, $995b10da1f78ffb1$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $995b10da1f78ffb1$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $b4dc2c56860261c6$var$isButtonTarget(event)) return;
                if (event.key === " " && !$b4dc2c56860261c6$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($b4dc2c56860261c6$var$isAnchorTarget(event)) return;
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $b4dc2c56860261c6$var$isButtonTarget(event) || $b4dc2c56860261c6$var$isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $b4dc2c56860261c6$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $b4dc2c56860261c6$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $b4dc2c56860261c6$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $cQmXV.useRef(false);
    const cleanupListenerRef = $cQmXV.useRef(null);
    const [pointerType, setPointerType] = $cQmXV.useState();
    const [reactive, setReactive] = $cQmXV.useState([]);
    const setReference = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$b4dc2c56860261c6$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($b4dc2c56860261c6$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $995b10da1f78ffb1$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $cQmXV.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event);
            if (!(0, $995b10da1f78ffb1$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $b4dc2c56860261c6$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $cQmXV.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $cQmXV.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $cQmXV.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $cQmXV.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $b4dc2c56860261c6$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $b4dc2c56860261c6$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $b4dc2c56860261c6$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $b4dc2c56860261c6$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $b4dc2c56860261c6$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = $cQmXV.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $b4dc2c56860261c6$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $b4dc2c56860261c6$var$normalizeProp(capture);
    const isComposingRef = $cQmXV.useRef(false);
    const closeOnEscapeKeyDown = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $995b10da1f78ffb1$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $995b10da1f78ffb1$export$94781ce41a161222)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $b4dc2c56860261c6$var$createAttribute("inert") + "]";
        const markers = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $a4d8f0d03f4d0e92$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51)(nextParent) || !(0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(target) && !(0, $995b10da1f78ffb1$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $995b10da1f78ffb1$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $995b10da1f78ffb1$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(target) && floating) {
            const lastTraversableNode = (0, $a4d8f0d03f4d0e92$export$d1162fb0b6d4cd51)(target);
            const style = (0, $a4d8f0d03f4d0e92$export$3735103072e4a80)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === "rtl";
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $995b10da1f78ffb1$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $995b10da1f78ffb1$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $995b10da1f78ffb1$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $995b10da1f78ffb1$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $995b10da1f78ffb1$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $cQmXV.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $a4d8f0d03f4d0e92$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $a4d8f0d03f4d0e92$export$3b57c1601291186b)(elements.domReference);
            if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $a4d8f0d03f4d0e92$export$3b57c1601291186b)(elements.floating));
            if (!(0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $a4d8f0d03f4d0e92$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll);
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $cQmXV.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $cQmXV.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$b4dc2c56860261c6$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, "reference-press");
                },
                ...referencePressEvent !== "click" && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, "reference-press");
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $cQmXV.useMemo(()=>{
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [$b4dc2c56860261c6$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $b4dc2c56860261c6$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $b4dc2c56860261c6$export$f680877a34711e37();
    const dataRef = $cQmXV.useRef({});
    const [events] = $cQmXV.useState(()=>$b4dc2c56860261c6$var$createEventEmitter());
    const nested = $b4dc2c56860261c6$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $cQmXV.useState(elementsProp.reference);
    const onOpenChange = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $cQmXV.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $cQmXV.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $cQmXV.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $b4dc2c56860261c6$export$4e02a5c1d08bac65(_temp) {
    var _elementsOption$refer, _elementsOption$float;
    let { elements: elementsOption, ...options } = _temp === void 0 ? {} : _temp;
    const { nodeId: nodeId } = options;
    const internalRootContext = $b4dc2c56860261c6$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: (_elementsOption$refer = elementsOption == null ? void 0 : elementsOption.reference) != null ? _elementsOption$refer : null,
            floating: (_elementsOption$float = elementsOption == null ? void 0 : elementsOption.floating) != null ? _elementsOption$float : null
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $cQmXV.useState(null);
    const [positionReference, _setPositionReference] = $cQmXV.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $cQmXV.useRef(null);
    const tree = $b4dc2c56860261c6$export$db0c2a7c7a2a4f69();
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $c729ef3ccf3d54b8$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $cQmXV.useCallback((node)=>{
        const computedPositionReference = (0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $cQmXV.useCallback((node)=>{
        if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $cQmXV.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $cQmXV.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $cQmXV.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $cQmXV.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $b4dc2c56860261c6$var$isMacSafari() {
    return (0, $995b10da1f78ffb1$export$9ac100e40613ea10)() && (0, $995b10da1f78ffb1$export$95df08bae54cb4df)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $b4dc2c56860261c6$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $cQmXV.useRef(false);
    const timeoutRef = $cQmXV.useRef(-1);
    const keyboardModalityRef = $cQmXV.useRef(true);
    $cQmXV.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $a4d8f0d03f4d0e92$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $995b10da1f78ffb1$export$da980962bd2147a4)((0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener("blur", onBlur);
        if ($b4dc2c56860261c6$var$isMacSafari()) {
            win.addEventListener("keydown", onKeyDown, true);
            win.addEventListener("pointerdown", onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener("blur", onBlur);
            if ($b4dc2c56860261c6$var$isMacSafari()) {
                win.removeEventListener("keydown", onKeyDown, true);
                win.removeEventListener("pointerdown", onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $cQmXV.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $cQmXV.useEffect(()=>{
        return ()=>{
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $cQmXV.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $995b10da1f78ffb1$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($b4dc2c56860261c6$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $995b10da1f78ffb1$export$42ad131c32f0fb8d)(target)) return;
                    } else if (!(0, $995b10da1f78ffb1$export$65750043c2fb2f40)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($b4dc2c56860261c6$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $995b10da1f78ffb1$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $995b10da1f78ffb1$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $995b10da1f78ffb1$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $b4dc2c56860261c6$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$b4dc2c56860261c6$var$ACTIVE_KEY]: _, [$b4dc2c56860261c6$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1,
            [$b4dc2c56860261c6$var$FOCUSABLE_ATTRIBUTE]: ""
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $b4dc2c56860261c6$var$ACTIVE_KEY,
                    $b4dc2c56860261c6$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $b4dc2c56860261c6$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $cQmXV.useCallback((userProps)=>$b4dc2c56860261c6$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $cQmXV.useCallback((userProps)=>$b4dc2c56860261c6$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $cQmXV.useCallback((userProps)=>$b4dc2c56860261c6$var$mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $cQmXV.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $b4dc2c56860261c6$var$ESCAPE = "Escape";
function $b4dc2c56860261c6$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $b4dc2c56860261c6$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $b4dc2c56860261c6$var$ARROW_UP || key === $b4dc2c56860261c6$var$ARROW_DOWN;
    const horizontal = key === $b4dc2c56860261c6$var$ARROW_LEFT || key === $b4dc2c56860261c6$var$ARROW_RIGHT;
    return $b4dc2c56860261c6$var$doSwitch(orientation, vertical, horizontal);
}
function $b4dc2c56860261c6$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $b4dc2c56860261c6$var$ARROW_DOWN;
    const horizontal = rtl ? key === $b4dc2c56860261c6$var$ARROW_LEFT : key === $b4dc2c56860261c6$var$ARROW_RIGHT;
    return $b4dc2c56860261c6$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $b4dc2c56860261c6$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $b4dc2c56860261c6$var$ARROW_LEFT : key === $b4dc2c56860261c6$var$ARROW_RIGHT;
    const horizontal = key === $b4dc2c56860261c6$var$ARROW_DOWN;
    return $b4dc2c56860261c6$var$doSwitch(orientation, vertical, horizontal);
}
function $b4dc2c56860261c6$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $b4dc2c56860261c6$var$ARROW_RIGHT : key === $b4dc2c56860261c6$var$ARROW_LEFT;
    const horizontal = key === $b4dc2c56860261c6$var$ARROW_UP;
    if (orientation === "both" || orientation === "horizontal" && cols && cols > 1) return key === $b4dc2c56860261c6$var$ESCAPE;
    return $b4dc2c56860261c6$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $b4dc2c56860261c6$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $995b10da1f78ffb1$export$9b0901b5e9b45fc7)(elements.floating);
    const floatingFocusElementRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(floatingFocusElement);
    const parentId = $b4dc2c56860261c6$export$165209eae06d3488();
    const tree = $b4dc2c56860261c6$export$db0c2a7c7a2a4f69();
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $995b10da1f78ffb1$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $cQmXV.useRef(focusItemOnOpen);
    const indexRef = $cQmXV.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $cQmXV.useRef(null);
    const isPointerModalityRef = $cQmXV.useRef(true);
    const previousOnNavigateRef = $cQmXV.useRef(onNavigate);
    const previousMountedRef = $cQmXV.useRef(!!elements.floating);
    const previousOpenRef = $cQmXV.useRef(open);
    const forceSyncFocusRef = $cQmXV.useRef(false);
    const forceScrollIntoViewRef = $cQmXV.useRef(false);
    const disabledIndicesRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(disabledIndices);
    const latestOpenRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(open);
    const scrollItemIntoViewRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(scrollItemIntoView);
    const selectedIndexRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(selectedIndex);
    const [activeId, setActiveId] = $cQmXV.useState();
    const [virtualId, setVirtualId] = $cQmXV.useState();
    const focusItem = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith("-fui-option")) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $b4dc2c56860261c6$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $b4dc2c56860261c6$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $995b10da1f78ffb1$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current) : (0, $995b10da1f78ffb1$export$b585558af466e926)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $995b10da1f78ffb1$export$75effb89758ec596)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $995b10da1f78ffb1$export$da980962bd2147a4)((0, $995b10da1f78ffb1$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $995b10da1f78ffb1$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $cQmXV.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget: currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType: pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === "touch") return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $cQmXV.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $b4dc2c56860261c6$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$b4dc2c56860261c6$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, $a4d8f0d03f4d0e92$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit("virtualfocus", elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $995b10da1f78ffb1$export$53f691ee0acc6058)(listRef, disabledIndices);
        const maxIndex = (0, $995b10da1f78ffb1$export$b585558af466e926)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === "Home") {
                (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === "End") {
                (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $995b10da1f78ffb1$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $995b10da1f78ffb1$export$446656ed0410fd9)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $995b10da1f78ffb1$export$446656ed0410fd9)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $995b10da1f78ffb1$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $995b10da1f78ffb1$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== "function" ? disabledIndices : null) || listRef.current.map((_, index)=>(0, $995b10da1f78ffb1$export$446656ed0410fd9)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $995b10da1f78ffb1$export$dab2b2ce7761f8e4)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $b4dc2c56860261c6$var$ARROW_DOWN ? "bl" : event.key === (rtl ? $b4dc2c56860261c6$var$ARROW_LEFT : $b4dc2c56860261c6$var$ARROW_RIGHT) ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === "both") return;
        }
        if ($b4dc2c56860261c6$var$isMainOrientationKey(event.key, orientation)) {
            (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $995b10da1f78ffb1$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $b4dc2c56860261c6$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($b4dc2c56860261c6$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $995b10da1f78ffb1$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $995b10da1f78ffb1$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $995b10da1f78ffb1$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $995b10da1f78ffb1$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $995b10da1f78ffb1$export$75effb89758ec596)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $cQmXV.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $cQmXV.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $cQmXV.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $995b10da1f78ffb1$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $995b10da1f78ffb1$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith("Arrow");
                const isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $b4dc2c56860261c6$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $b4dc2c56860261c6$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $b4dc2c56860261c6$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $b4dc2c56860261c6$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $995b10da1f78ffb1$export$e7e88d43cb97db79)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $b4dc2c56860261c6$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = (0, $995b10da1f78ffb1$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $b4dc2c56860261c6$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $b4dc2c56860261c6$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const defaultReferenceId = $b4dc2c56860261c6$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $cQmXV.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $995b10da1f78ffb1$export$9b0901b5e9b45fc7)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $b4dc2c56860261c6$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $b4dc2c56860261c6$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $cQmXV.useMemo(()=>{
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return {
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role === "select" && {
                "aria-autocomplete": "none"
            },
            ...role === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $cQmXV.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $cQmXV.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: "option",
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
            case "combobox":
                return {
                    ...commonProps,
                    "aria-selected": selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $b4dc2c56860261c6$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $b4dc2c56860261c6$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $b4dc2c56860261c6$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $cQmXV.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $cQmXV.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $b4dc2c56860261c6$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $cQmXV.useState("unmounted");
    const isMounted = $b4dc2c56860261c6$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $3h5eW.flushSync(()=>{
                    setStatus("open");
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $b4dc2c56860261c6$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $cQmXV.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $cQmXV.useState(()=>({
            ...$b4dc2c56860261c6$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$b4dc2c56860261c6$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $b4dc2c56860261c6$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(unstable_initial);
    const openRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(unstable_open);
    const closeRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(unstable_close);
    const commonRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(unstable_common);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        const initialStyles = $b4dc2c56860261c6$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $b4dc2c56860261c6$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $b4dc2c56860261c6$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $b4dc2c56860261c6$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($b4dc2c56860261c6$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($b4dc2c56860261c6$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $b4dc2c56860261c6$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $cQmXV.useRef(-1);
    const stringRef = $cQmXV.useRef("");
    const prevIndexRef = $cQmXV.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $cQmXV.useRef(null);
    const onMatch = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(unstable_onMatch);
    const onTypingChange = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(unstable_onTypingChange);
    const findMatchRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(findMatch);
    const ignoreKeysRef = (0, $995b10da1f78ffb1$export$bcd07ba85a740103)(ignoreKeys);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        if (open) {
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    (0, $995b10da1f78ffb1$export$bb3b3b3acfd7447f)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, $995b10da1f78ffb1$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    const reference = $cQmXV.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $cQmXV.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $b4dc2c56860261c6$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $b4dc2c56860261c6$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $88ea4014521d2d61$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, platform: platform, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $c729ef3ccf3d54b8$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await platform.detectOverflow($b4dc2c56860261c6$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = (0, $88ea4014521d2d61$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $88ea4014521d2d61$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $88ea4014521d2d61$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $88ea4014521d2d61$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $88ea4014521d2d61$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $3h5eW.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await platform.detectOverflow($b4dc2c56860261c6$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $b4dc2c56860261c6$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $995b10da1f78ffb1$export$7f54fc3180508a52)(unstable_onChange);
    const controlledScrollingRef = $cQmXV.useRef(false);
    const prevScrollTopRef = $cQmXV.useRef(null);
    const initialOverflowRef = $cQmXV.useRef(null);
    $cQmXV.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $3h5eW.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $995b10da1f78ffb1$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $cQmXV.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $3h5eW.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $cQmXV.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $b4dc2c56860261c6$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$b4dc2c56860261c6$var$getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function $b4dc2c56860261c6$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $b4dc2c56860261c6$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $b4dc2c56860261c6$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== "undefined" ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $b4dc2c56860261c6$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $b4dc2c56860261c6$var$getTarget(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = $b4dc2c56860261c6$var$contains(elements.floating, target);
            const isOverReferenceEl = $b4dc2c56860261c6$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $b4dc2c56860261c6$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $a4d8f0d03f4d0e92$export$45a5e7f76e0caa8d)(event.relatedTarget) && $b4dc2c56860261c6$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $b4dc2c56860261c6$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($b4dc2c56860261c6$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$b4dc2c56860261c6$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $3h5eW = parcelRequire("3h5eW");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f45070adf3eddf53$var$_extendStatics = function extendStatics(d, b) {
    $f45070adf3eddf53$var$_extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f45070adf3eddf53$var$_extendStatics(d, b);
};
function $f45070adf3eddf53$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f45070adf3eddf53$var$_extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f45070adf3eddf53$var$_assign = function __assign() {
    $f45070adf3eddf53$var$_assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f45070adf3eddf53$var$_assign.apply(this, arguments);
};
function $f45070adf3eddf53$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $f45070adf3eddf53$export$946daa762919616e = function(_a) {
    var _b = _a.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a.showTime, showTime = _c === void 0 ? false : _c, className = _a.className, children = _a.children, inline = _a.inline;
    var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: className,
        "aria-label": ariaLabel,
        role: inline ? undefined : "dialog",
        "aria-modal": inline ? undefined : "true"
    }, children);
};
var $f45070adf3eddf53$var$useDetectClickOutside = function(onClickOutside, ignoreClass) {
    var ref = (0, $cQmXV.useRef)(null);
    var onClickOutsideRef = (0, $cQmXV.useRef)(onClickOutside);
    (0, $cQmXV.useEffect)(function() {
        onClickOutsideRef.current = onClickOutside;
    }, [
        onClickOutside
    ]);
    var handleClickOutside = (0, $cQmXV.useCallback)(function(event) {
        var _a;
        var target = event.composed && event.composedPath && event.composedPath().find(function(eventTarget) {
            return eventTarget instanceof Node;
        }) || event.target;
        if (ref.current && !ref.current.contains(target)) {
            if (!(ignoreClass && target instanceof HTMLElement && target.classList.contains(ignoreClass))) (_a = onClickOutsideRef.current) === null || _a === void 0 || _a.call(onClickOutsideRef, event);
        }
    }, [
        ignoreClass
    ]);
    (0, $cQmXV.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return ref;
};
var $f45070adf3eddf53$var$ClickOutsideWrapper = function(_a) {
    var children = _a.children, onClickOutside = _a.onClickOutside, className = _a.className, containerRef = _a.containerRef, style = _a.style, ignoreClass = _a.ignoreClass;
    var detectRef = $f45070adf3eddf53$var$useDetectClickOutside(onClickOutside, ignoreClass);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: className,
        style: style,
        ref: function(node) {
            detectRef.current = node;
            if (containerRef) containerRef.current = node;
        }
    }, children);
};
var $f45070adf3eddf53$var$KeyType;
(function(KeyType) {
    KeyType["ArrowUp"] = "ArrowUp";
    KeyType["ArrowDown"] = "ArrowDown";
    KeyType["ArrowLeft"] = "ArrowLeft";
    KeyType["ArrowRight"] = "ArrowRight";
    KeyType["PageUp"] = "PageUp";
    KeyType["PageDown"] = "PageDown";
    KeyType["Home"] = "Home";
    KeyType["End"] = "End";
    KeyType["Enter"] = "Enter";
    KeyType["Space"] = " ";
    KeyType["Tab"] = "Tab";
    KeyType["Escape"] = "Escape";
    KeyType["Backspace"] = "Backspace";
    KeyType["X"] = "x";
})($f45070adf3eddf53$var$KeyType || ($f45070adf3eddf53$var$KeyType = {}));
function $f45070adf3eddf53$var$getLocaleScope() {
    // Use this cast to avoid messing with users globalThis (like window) and the rest of keys in the globalThis object we don't care about
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope;
}
var $f45070adf3eddf53$var$DEFAULT_YEAR_ITEM_NUMBER = 12;
// ** Date Constructors **
function $f45070adf3eddf53$var$newDate(value) {
    if (value == null) return new Date();
    var d = typeof value === "string" ? (0, $2b88b3fd22a2cf62$export$2e2bcd8739ae039)(value) : (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(value);
    return $f45070adf3eddf53$var$isValid(d) ? d : new Date();
}
/**
 * Parses a date.
 *
 * @param value - The string representing the Date in a parsable form, e.g., ISO 1861
 * @param dateFormat - The date format.
 * @param locale - The locale.
 * @param strictParsing - The strict parsing flag.
 * @param refDate - The base date to be passed to date-fns parse() function.
 * @returns - The parsed date or null.
 */ function $f45070adf3eddf53$var$parseDate(value, dateFormat, locale, strictParsing, refDate) {
    if (refDate === void 0) refDate = $f45070adf3eddf53$var$newDate();
    var localeObject = $f45070adf3eddf53$var$getLocaleObject(locale) || $f45070adf3eddf53$var$getLocaleObject($f45070adf3eddf53$export$f09106e7c6677ec5());
    var formats = Array.isArray(dateFormat) ? dateFormat : [
        dateFormat
    ];
    for(var _i = 0, formats_1 = formats; _i < formats_1.length; _i++){
        var format_1 = formats_1[_i];
        var parsedDate = (0, $813f06b351d00f10$export$2e2bcd8739ae039)(value, format_1, refDate, {
            locale: localeObject,
            useAdditionalWeekYearTokens: true,
            useAdditionalDayOfYearTokens: true
        });
        if ($f45070adf3eddf53$var$isValid(parsedDate) && (!strictParsing || value === $f45070adf3eddf53$var$formatDate(parsedDate, format_1, locale))) return parsedDate;
    }
    return null;
}
/**
 * Checks if a given date is valid and not before the minimum date.
 * @param date - The date to be checked.
 * @param minDate - The minimum date allowed. If not provided, defaults to "1/1/1800".
 * @returns A boolean value indicating whether the date is valid and not before the minimum date.
 */ function $f45070adf3eddf53$var$isValid(date, minDate) {
    /* the fallback date is essential to not break test case
     * `should auto update calendar when the updated date text is after props.minDate`
     * and backward compatibility respectfully
     */ return (0, $7c5206d262b35399$export$2e2bcd8739ae039)(date) && !(0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(date, new Date("1/1/1800"));
}
// ** Date Formatting **
/**
 * Formats a date.
 *
 * @param date - The date.
 * @param formatStr - The format string.
 * @param locale - The locale.
 * @returns - The formatted date.
 */ function $f45070adf3eddf53$var$formatDate(date, formatStr, locale) {
    if (locale === "en") return (0, $389aa0de6ef8ea63$export$2e2bcd8739ae039)(date, formatStr, {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
    var localeObj = locale ? $f45070adf3eddf53$var$getLocaleObject(locale) : undefined;
    if (locale && !localeObj) console.warn('A locale object was not found for the provided string ["'.concat(locale, '"].'));
    localeObj = localeObj || $f45070adf3eddf53$var$getLocaleObject($f45070adf3eddf53$export$f09106e7c6677ec5());
    return (0, $389aa0de6ef8ea63$export$2e2bcd8739ae039)(date, formatStr, {
        locale: localeObj,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
}
/**
 * Safely formats a date.
 *
 * @param date - The date.
 * @param options - An object containing the dateFormat and locale.
 * @returns - The formatted date or an empty string.
 */ function $f45070adf3eddf53$var$safeDateFormat(date, _a) {
    var dateFormat = _a.dateFormat, locale = _a.locale;
    var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat; // Cast to string because it's impossible to get `string | string[] | undefined` here and typescript doesn't know that
    return date && $f45070adf3eddf53$var$formatDate(date, formatStr, locale) || "";
}
/**
 * Used as a delimiter to separate two dates when formatting a date range
 */ var $f45070adf3eddf53$var$DATE_RANGE_SEPARATOR = " - ";
/**
 * Safely formats a date range.
 *
 * @param startDate - The start date.
 * @param endDate - The end date.
 * @param props - The props.
 * @returns - The formatted date range or an empty string.
 */ function $f45070adf3eddf53$var$safeDateRangeFormat(startDate, endDate, props) {
    if (!startDate && !endDate) return "";
    var formattedStartDate = startDate ? $f45070adf3eddf53$var$safeDateFormat(startDate, props) : "";
    var formattedEndDate = endDate ? $f45070adf3eddf53$var$safeDateFormat(endDate, props) : "";
    var dateRangeSeparator = props.rangeSeparator || $f45070adf3eddf53$var$DATE_RANGE_SEPARATOR;
    return "".concat(formattedStartDate).concat(dateRangeSeparator).concat(formattedEndDate);
}
/**
 * Safely formats multiple dates.
 *
 * @param dates - The dates.
 * @param props - The props.
 * @returns - The formatted dates or an empty string.
 */ function $f45070adf3eddf53$var$safeMultipleDatesFormat(dates, props) {
    if (!(dates === null || dates === void 0 ? void 0 : dates.length)) return "";
    var formattedFirstDate = dates[0] ? $f45070adf3eddf53$var$safeDateFormat(dates[0], props) : "";
    if (dates.length === 1) return formattedFirstDate;
    if (dates.length === 2 && dates[1]) {
        var formattedSecondDate = $f45070adf3eddf53$var$safeDateFormat(dates[1], props);
        return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
    }
    var extraDatesCount = dates.length - 1;
    return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
// ** Date Setters **
/**
 * Sets the time for a given date.
 *
 * @param date - The date.
 * @param time - An object containing the hour, minute, and second.
 * @returns - The date with the time set.
 */ function $f45070adf3eddf53$var$setTime(date, _a) {
    var _b = _a.hour, hour = _b === void 0 ? 0 : _b, _c = _a.minute, minute = _c === void 0 ? 0 : _c, _d = _a.second, second = _d === void 0 ? 0 : _d;
    return (0, $f99cdc67abc4da3e$export$2e2bcd8739ae039)((0, $e9455667210155a3$export$2e2bcd8739ae039)((0, $766cbbced0102e4b$export$2e2bcd8739ae039)(date, second), minute), hour);
}
/**
 * Gets the week of the year for a given date.
 *
 * @param date - The date.
 * @returns - The week of the year.
 */ function $f45070adf3eddf53$var$getWeek(date) {
    return (0, $a184b08fb8bdcfc5$export$2e2bcd8739ae039)(date);
}
/**
 * Gets the day of the week code for a given day.
 *
 * @param day - The day.
 * @param locale - The locale.
 * @returns - The day of the week code.
 */ function $f45070adf3eddf53$var$getDayOfWeekCode(day, locale) {
    return $f45070adf3eddf53$var$formatDate(day, "ddd", locale);
}
// *** Start of ***
/**
 * Gets the start of the day for a given date.
 *
 * @param date - The date.
 * @returns - The start of the day.
 */ function $f45070adf3eddf53$var$getStartOfDay(date) {
    return (0, $50f4ae9c8a4444b9$export$2e2bcd8739ae039)(date);
}
/**
 * Gets the start of the week for a given date.
 *
 * @param date - The date.
 * @param locale - The locale.
 * @param calendarStartDay - The day the calendar starts on.
 * @returns - The start of the week.
 */ function $f45070adf3eddf53$var$getStartOfWeek(date, locale, calendarStartDay) {
    var localeObj = locale ? $f45070adf3eddf53$var$getLocaleObject(locale) : $f45070adf3eddf53$var$getLocaleObject($f45070adf3eddf53$export$f09106e7c6677ec5());
    return (0, $9080fd1fb2f1a15e$export$2e2bcd8739ae039)(date, {
        locale: localeObj,
        weekStartsOn: calendarStartDay
    });
}
/**
 * Gets the start of the month for a given date.
 *
 * @param date - The date.
 * @returns - The start of the month.
 */ function $f45070adf3eddf53$var$getStartOfMonth(date) {
    return (0, $ef4a4204aeb604fa$export$2e2bcd8739ae039)(date);
}
/**
 * Gets the start of the year for a given date.
 *
 * @param date - The date.
 * @returns - The start of the year.
 */ function $f45070adf3eddf53$var$getStartOfYear(date) {
    return (0, $12cf19278c96c089$export$2e2bcd8739ae039)(date);
}
/**
 * Gets the start of the quarter for a given date.
 *
 * @param date - The date.
 * @returns - The start of the quarter.
 */ function $f45070adf3eddf53$var$getStartOfQuarter(date) {
    return (0, $4f8d6b475f0f5819$export$2e2bcd8739ae039)(date);
}
/**
 * Gets the start of today.
 *
 * @returns - The start of today.
 */ function $f45070adf3eddf53$var$getStartOfToday() {
    return (0, $50f4ae9c8a4444b9$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate());
}
// *** End of ***
/**
 * Gets the end of the day for a given date.
 *
 * @param date - The date.
 * @returns - The end of the day.
 */ function $f45070adf3eddf53$var$getEndOfDay(date) {
    return (0, $9cb23f9a8214e7bc$export$2e2bcd8739ae039)(date);
}
/**
 * Gets the end of the week for a given date.
 *
 * @param date - The date.
 * @returns - The end of the week.
 */ function $f45070adf3eddf53$var$getEndOfWeek(date) {
    return (0, $1bb33ac6bbfb9138$export$2e2bcd8739ae039)(date);
}
/**
 * Gets the end of the month for a given date.
 *
 * @param date - The date.
 * @returns - The end of the month.
 */ function $f45070adf3eddf53$var$getEndOfMonth(date) {
    return (0, $e94aac2d6eb5844d$export$2e2bcd8739ae039)(date);
}
/**
 * Checks if two dates are in the same year.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same year, false otherwise.
 */ function $f45070adf3eddf53$var$isSameYear(date1, date2) {
    if (date1 && date2) return (0, $573f65e9a2f6d5ed$export$2e2bcd8739ae039)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same month.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same month, false otherwise.
 */ function $f45070adf3eddf53$var$isSameMonth(date1, date2) {
    if (date1 && date2) return (0, $220f9910290fb891$export$2e2bcd8739ae039)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same quarter.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same quarter, false otherwise.
 */ function $f45070adf3eddf53$var$isSameQuarter(date1, date2) {
    if (date1 && date2) return (0, $2078a34d45e826cb$export$2e2bcd8739ae039)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are on the same day.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are on the same day, false otherwise.
 */ function $f45070adf3eddf53$var$isSameDay(date1, date2) {
    if (date1 && date2) return (0, $168de819440c8efe$export$2e2bcd8739ae039)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are equal.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are equal, false otherwise.
 */ function $f45070adf3eddf53$var$isEqual(date1, date2) {
    if (date1 && date2) return (0, $4e3c6086dc9f5ab6$export$2e2bcd8739ae039)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if a day is within a date range.
 *
 * @param day - The day to check.
 * @param startDate - The start date of the range.
 * @param endDate - The end date of the range.
 * @returns - True if the day is within the range, false otherwise.
 */ function $f45070adf3eddf53$var$isDayInRange(day, startDate, endDate) {
    var valid;
    var start = (0, $50f4ae9c8a4444b9$export$2e2bcd8739ae039)(startDate);
    var end = (0, $9cb23f9a8214e7bc$export$2e2bcd8739ae039)(endDate);
    try {
        valid = (0, $3e1c7f28d9d32516$export$2e2bcd8739ae039)(day, {
            start: start,
            end: end
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
// ** Date Localization **
/**
 * Registers a locale.
 *
 * @param localeName - The name of the locale.
 * @param localeData - The data of the locale.
 */ function $f45070adf3eddf53$export$bab6a7822cc1e2cd(localeName, localeData) {
    var scope = $f45070adf3eddf53$var$getLocaleScope();
    if (!scope.__localeData__) scope.__localeData__ = {};
    scope.__localeData__[localeName] = localeData;
}
/**
 * Sets the default locale.
 *
 * @param localeName - The name of the locale.
 */ function $f45070adf3eddf53$export$a1a5025df4e9ba34(localeName) {
    var scope = $f45070adf3eddf53$var$getLocaleScope();
    scope.__localeId__ = localeName;
}
/**
 * Gets the default locale.
 *
 * @returns - The default locale.
 */ function $f45070adf3eddf53$export$f09106e7c6677ec5() {
    var scope = $f45070adf3eddf53$var$getLocaleScope();
    return scope.__localeId__;
}
/**
 * Gets the locale object.
 *
 * @param localeSpec - The locale specification.
 * @returns - The locale object.
 */ function $f45070adf3eddf53$var$getLocaleObject(localeSpec) {
    if (typeof localeSpec === "string") {
        // Treat it as a locale name registered by registerLocale
        var scope = $f45070adf3eddf53$var$getLocaleScope();
        // Null was replaced with undefined to avoid type coercion
        return scope.__localeData__ ? scope.__localeData__[localeSpec] : undefined;
    } else // Treat it as a raw date-fns locale object
    return localeSpec;
}
/**
 * Formats the weekday in a given locale.
 *
 * @param date - The date to format.
 * @param formatFunc - The formatting function.
 * @param locale - The locale to use for formatting.
 * @returns - The formatted weekday.
 */ function $f45070adf3eddf53$var$getFormattedWeekdayInLocale(date, formatFunc, locale) {
    return formatFunc($f45070adf3eddf53$var$formatDate(date, "EEEE", locale));
}
/**
 * Gets the minimum weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The minimum weekday.
 */ function $f45070adf3eddf53$var$getWeekdayMinInLocale(date, locale) {
    return $f45070adf3eddf53$var$formatDate(date, "EEEEEE", locale);
}
/**
 * Gets the short weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short weekday.
 */ function $f45070adf3eddf53$var$getWeekdayShortInLocale(date, locale) {
    return $f45070adf3eddf53$var$formatDate(date, "EEE", locale);
}
/**
 * Gets the month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The month.
 */ function $f45070adf3eddf53$var$getMonthInLocale(month, locale) {
    return $f45070adf3eddf53$var$formatDate((0, $0f0a320b378f0016$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), month), "LLLL", locale);
}
/**
 * Gets the short month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short month.
 */ function $f45070adf3eddf53$var$getMonthShortInLocale(month, locale) {
    return $f45070adf3eddf53$var$formatDate((0, $0f0a320b378f0016$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), month), "LLL", locale);
}
/**
 * Gets the short quarter in a given locale.
 *
 * @param quarter - The quarter to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short quarter.
 */ function $f45070adf3eddf53$var$getQuarterShortInLocale(quarter, locale) {
    return $f45070adf3eddf53$var$formatDate((0, $c6e017e14073270e$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), quarter), "QQQ", locale);
}
/**
 * Checks if a day is disabled.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is disabled, false otherwise.
 */ function $f45070adf3eddf53$var$isDayDisabled(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $f45070adf3eddf53$var$isOutOfBounds(day, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludeDate) {
        if (excludeDate instanceof Date) return $f45070adf3eddf53$var$isSameDay(day, excludeDate);
        else return $f45070adf3eddf53$var$isSameDay(day, excludeDate.date);
    }) || excludeDateIntervals && excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $3e1c7f28d9d32516$export$2e2bcd8739ae039)(day, {
            start: start,
            end: end
        });
    }) || includeDates && !includeDates.some(function(includeDate) {
        return $f45070adf3eddf53$var$isSameDay(day, includeDate);
    }) || includeDateIntervals && !includeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $3e1c7f28d9d32516$export$2e2bcd8739ae039)(day, {
            start: start,
            end: end
        });
    }) || filterDate && !filterDate($f45070adf3eddf53$var$newDate(day)) || false;
}
/**
 * Checks if a day is excluded.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is excluded, false otherwise.
 */ function $f45070adf3eddf53$var$isDayExcluded(day, _a) {
    var _b = _a === void 0 ? {} : _a, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
    if (excludeDateIntervals && excludeDateIntervals.length > 0) return excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $3e1c7f28d9d32516$export$2e2bcd8739ae039)(day, {
            start: start,
            end: end
        });
    });
    return excludeDates && excludeDates.some(function(excludeDate) {
        var _a;
        if (excludeDate instanceof Date) return $f45070adf3eddf53$var$isSameDay(day, excludeDate);
        else return $f45070adf3eddf53$var$isSameDay(day, (_a = excludeDate.date) !== null && _a !== void 0 ? _a : new Date());
    }) || false;
}
function $f45070adf3eddf53$var$isMonthDisabled(month, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return $f45070adf3eddf53$var$isOutOfBounds(month, {
        minDate: minDate ? (0, $ef4a4204aeb604fa$export$2e2bcd8739ae039)(minDate) : undefined,
        maxDate: maxDate ? (0, $e94aac2d6eb5844d$export$2e2bcd8739ae039)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $f45070adf3eddf53$var$isSameMonth(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $f45070adf3eddf53$var$isSameMonth(month, includeDate);
    }) || filterDate && !filterDate($f45070adf3eddf53$var$newDate(month)) || false;
}
function $f45070adf3eddf53$var$isMonthInRange(startDate, endDate, m, day) {
    var startDateYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(startDate);
    var startDateMonth = (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(startDate);
    var endDateYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(endDate);
    var endDateMonth = (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(endDate);
    var dayYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
/**
 * To check if a date's month and year are disabled/excluded
 * @param date Date to check
 * @returns {boolean} true if month and year are disabled/excluded, false otherwise
 */ function $f45070adf3eddf53$var$isMonthYearDisabled(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
    return $f45070adf3eddf53$var$isOutOfBounds(date, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludedDate) {
        return $f45070adf3eddf53$var$isSameMonth(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
    }) || includeDates && !includeDates.some(function(includedDate) {
        return $f45070adf3eddf53$var$isSameMonth(includedDate, date);
    }) || false;
}
function $f45070adf3eddf53$var$isQuarterDisabled(quarter, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $f45070adf3eddf53$var$isOutOfBounds(quarter, {
        minDate: minDate,
        maxDate: maxDate
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $f45070adf3eddf53$var$isSameQuarter(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $f45070adf3eddf53$var$isSameQuarter(quarter, includeDate);
    }) || filterDate && !filterDate($f45070adf3eddf53$var$newDate(quarter)) || false;
}
function $f45070adf3eddf53$var$isYearInRange(year, start, end) {
    if (!start || !end) return false;
    if (!(0, $7c5206d262b35399$export$2e2bcd8739ae039)(start) || !(0, $7c5206d262b35399$export$2e2bcd8739ae039)(end)) return false;
    var startYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(start);
    var endYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(end);
    return startYear <= year && endYear >= year;
}
function $f45070adf3eddf53$var$isYearDisabled(year, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    var date = new Date(year, 0, 1);
    return $f45070adf3eddf53$var$isOutOfBounds(date, {
        minDate: minDate ? (0, $12cf19278c96c089$export$2e2bcd8739ae039)(minDate) : undefined,
        maxDate: maxDate ? (0, $106ecc1962037161$export$2e2bcd8739ae039)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $f45070adf3eddf53$var$isSameYear(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $f45070adf3eddf53$var$isSameYear(date, includeDate);
    }) || filterDate && !filterDate($f45070adf3eddf53$var$newDate(date)) || false;
}
function $f45070adf3eddf53$var$isQuarterInRange(startDate, endDate, q, day) {
    var startDateYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(startDate);
    var startDateQuarter = (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)(startDate);
    var endDateYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(endDate);
    var endDateQuarter = (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)(endDate);
    var dayYear = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateQuarter <= q && q <= endDateQuarter;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
function $f45070adf3eddf53$var$isOutOfBounds(day, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, minDate = _c.minDate, maxDate = _c.maxDate;
    return (_b = minDate && (0, $7ff80392ecde5177$export$2e2bcd8739ae039)(day, minDate) < 0 || maxDate && (0, $7ff80392ecde5177$export$2e2bcd8739ae039)(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function $f45070adf3eddf53$var$isTimeInList(time, times) {
    return times.some(function(listTime) {
        return (0, $373f86827073914d$export$2e2bcd8739ae039)(listTime) === (0, $373f86827073914d$export$2e2bcd8739ae039)(time) && (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(listTime) === (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(time) && (0, $f5b59a09917da604$export$2e2bcd8739ae039)(listTime) === (0, $f5b59a09917da604$export$2e2bcd8739ae039)(time);
    });
}
function $f45070adf3eddf53$var$isTimeDisabled(time, _a) {
    var _b = _a === void 0 ? {} : _a, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
    return excludeTimes && $f45070adf3eddf53$var$isTimeInList(time, excludeTimes) || includeTimes && !$f45070adf3eddf53$var$isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function $f45070adf3eddf53$var$isTimeInDisabledRange(time, _a) {
    var minTime = _a.minTime, maxTime = _a.maxTime;
    if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
    var baseTime = $f45070adf3eddf53$var$newDate();
    baseTime = (0, $f99cdc67abc4da3e$export$2e2bcd8739ae039)(baseTime, (0, $373f86827073914d$export$2e2bcd8739ae039)(time));
    baseTime = (0, $e9455667210155a3$export$2e2bcd8739ae039)(baseTime, (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(time));
    baseTime = (0, $766cbbced0102e4b$export$2e2bcd8739ae039)(baseTime, (0, $f5b59a09917da604$export$2e2bcd8739ae039)(time));
    var min = $f45070adf3eddf53$var$newDate();
    min = (0, $f99cdc67abc4da3e$export$2e2bcd8739ae039)(min, (0, $373f86827073914d$export$2e2bcd8739ae039)(minTime));
    min = (0, $e9455667210155a3$export$2e2bcd8739ae039)(min, (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(minTime));
    min = (0, $766cbbced0102e4b$export$2e2bcd8739ae039)(min, (0, $f5b59a09917da604$export$2e2bcd8739ae039)(minTime));
    var max = $f45070adf3eddf53$var$newDate();
    max = (0, $f99cdc67abc4da3e$export$2e2bcd8739ae039)(max, (0, $373f86827073914d$export$2e2bcd8739ae039)(maxTime));
    max = (0, $e9455667210155a3$export$2e2bcd8739ae039)(max, (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(maxTime));
    max = (0, $766cbbced0102e4b$export$2e2bcd8739ae039)(max, (0, $f5b59a09917da604$export$2e2bcd8739ae039)(maxTime));
    var valid;
    try {
        valid = !(0, $3e1c7f28d9d32516$export$2e2bcd8739ae039)(baseTime, {
            start: min,
            end: max
        });
    } catch (err) {
        /* istanbul ignore next - date-fns historically threw on invalid intervals */ valid = false;
    }
    return valid;
}
function $f45070adf3eddf53$var$monthDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousMonth = (0, $9450df79fe1987af$export$2e2bcd8739ae039)(day, 1);
    return minDate && (0, $76606760696271a2$export$2e2bcd8739ae039)(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $76606760696271a2$export$2e2bcd8739ae039)(includeDate, previousMonth) > 0;
    }) || false;
}
function $f45070adf3eddf53$var$monthDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextMonth = (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(day, 1);
    return maxDate && (0, $76606760696271a2$export$2e2bcd8739ae039)(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $76606760696271a2$export$2e2bcd8739ae039)(nextMonth, includeDate) > 0;
    }) || false;
}
function $f45070adf3eddf53$var$quarterDisabledBefore(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var firstDateOfYear = (0, $12cf19278c96c089$export$2e2bcd8739ae039)(date);
    var previousQuarter = (0, $7913aededcc910d4$export$2e2bcd8739ae039)(firstDateOfYear, 1);
    return minDate && (0, $90e60b4024450c4f$export$2e2bcd8739ae039)(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $90e60b4024450c4f$export$2e2bcd8739ae039)(includeDate, previousQuarter) > 0;
    }) || false;
}
function $f45070adf3eddf53$var$quarterDisabledAfter(date, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var lastDateOfYear = (0, $106ecc1962037161$export$2e2bcd8739ae039)(date);
    var nextQuarter = (0, $89d674319e089593$export$2e2bcd8739ae039)(lastDateOfYear, 1);
    return maxDate && (0, $90e60b4024450c4f$export$2e2bcd8739ae039)(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $90e60b4024450c4f$export$2e2bcd8739ae039)(nextQuarter, includeDate) > 0;
    }) || false;
}
function $f45070adf3eddf53$var$yearDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousYear = (0, $a2cd0767d0b3f015$export$2e2bcd8739ae039)(day, 1);
    return minDate && (0, $9aba1be5bd320e42$export$2e2bcd8739ae039)(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $9aba1be5bd320e42$export$2e2bcd8739ae039)(includeDate, previousYear) > 0;
    }) || false;
}
function $f45070adf3eddf53$var$yearsDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $f45070adf3eddf53$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var previousYear = $f45070adf3eddf53$var$getStartOfYear((0, $a2cd0767d0b3f015$export$2e2bcd8739ae039)(day, yearItemNumber));
    var endPeriod = $f45070adf3eddf53$var$getYearsPeriod(previousYear, yearItemNumber).endPeriod;
    var minDateYear = minDate && (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(minDate);
    return minDateYear && minDateYear > endPeriod || false;
}
function $f45070adf3eddf53$var$yearDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextYear = (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(day, 1);
    return maxDate && (0, $9aba1be5bd320e42$export$2e2bcd8739ae039)(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $9aba1be5bd320e42$export$2e2bcd8739ae039)(nextYear, includeDate) > 0;
    }) || false;
}
function $f45070adf3eddf53$var$yearsDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $f45070adf3eddf53$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var nextYear = (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(day, yearItemNumber);
    var startPeriod = $f45070adf3eddf53$var$getYearsPeriod(nextYear, yearItemNumber).startPeriod;
    var maxDateYear = maxDate && (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(maxDate);
    return maxDateYear && maxDateYear < startPeriod || false;
}
function $f45070adf3eddf53$var$getEffectiveMinDate(_a) {
    var minDate = _a.minDate, includeDates = _a.includeDates;
    if (includeDates && minDate) {
        var minDates = includeDates.filter(function(includeDate) {
            return (0, $7ff80392ecde5177$export$2e2bcd8739ae039)(includeDate, minDate) >= 0;
        });
        return (0, $f3f34c97f63bbab1$export$2e2bcd8739ae039)(minDates);
    } else if (includeDates) return (0, $f3f34c97f63bbab1$export$2e2bcd8739ae039)(includeDates);
    else return minDate;
}
function $f45070adf3eddf53$var$getEffectiveMaxDate(_a) {
    var maxDate = _a.maxDate, includeDates = _a.includeDates;
    if (includeDates && maxDate) {
        var maxDates = includeDates.filter(function(includeDate) {
            return (0, $7ff80392ecde5177$export$2e2bcd8739ae039)(includeDate, maxDate) <= 0;
        });
        return (0, $dc4798a3ea96654e$export$2e2bcd8739ae039)(maxDates);
    } else if (includeDates) return (0, $dc4798a3ea96654e$export$2e2bcd8739ae039)(includeDates);
    else return maxDate;
}
/**
 * Get a map of highlighted dates with their corresponding classes.
 * @param highlightDates The dates to highlight.
 * @param defaultClassName The default class to use for highlighting.
 * @returns A map with dates as keys and arrays of class names as values.
 */ function $f45070adf3eddf53$var$getHighLightDaysMap(highlightDates, defaultClassName) {
    var _a;
    if (highlightDates === void 0) highlightDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for(var i = 0, len = highlightDates.length; i < len; i++){
        var obj = highlightDates[i];
        if ((0, $6bf94078b78e666b$export$2e2bcd8739ae039)(obj)) {
            var key = $f45070adf3eddf53$var$formatDate(obj, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(defaultClassName)) {
                classNamesArr.push(defaultClassName);
                dateClasses.set(key, classNamesArr);
            }
        } else if (typeof obj === "object") {
            var keys = Object.keys(obj);
            var className = (_a = keys[0]) !== null && _a !== void 0 ? _a : "";
            var arrOfDates = obj[className];
            if (typeof className === "string" && Array.isArray(arrOfDates)) for(var k = 0, len_1 = arrOfDates.length; k < len_1; k++){
                var dateK = arrOfDates[k];
                if (dateK) {
                    var key = $f45070adf3eddf53$var$formatDate(dateK, "MM.dd.yyyy");
                    var classNamesArr = dateClasses.get(key) || [];
                    if (!classNamesArr.includes(className)) {
                        classNamesArr.push(className);
                        dateClasses.set(key, classNamesArr);
                    }
                }
            }
        }
    }
    return dateClasses;
}
/**
 * Compare the two arrays
 * @param array1 The first array to compare.
 * @param array2 The second array to compare.
 * @returns true, if the passed arrays are equal, false otherwise.
 */ function $f45070adf3eddf53$var$arraysAreEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    return array1.every(function(value, index) {
        return value === array2[index];
    });
}
/**
 * Assign the custom class to each date
 * @param holidayDates array of object containing date and name of the holiday
 * @param defaultClassName className to be added.
 * @returns Map containing date as key and array of className and holiday name as value
 */ function $f45070adf3eddf53$var$getHolidaysMap(holidayDates, defaultClassName) {
    if (holidayDates === void 0) holidayDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--holidays";
    var dateClasses = new Map();
    holidayDates.forEach(function(holiday) {
        var dateObj = holiday.date, holidayName = holiday.holidayName;
        if (!(0, $6bf94078b78e666b$export$2e2bcd8739ae039)(dateObj)) return;
        var key = $f45070adf3eddf53$var$formatDate(dateObj, "MM.dd.yyyy");
        var classNamesObj = dateClasses.get(key) || {
            className: "",
            holidayNames: []
        };
        if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && $f45070adf3eddf53$var$arraysAreEqual(classNamesObj["holidayNames"], [
            holidayName
        ])) return;
        classNamesObj["className"] = defaultClassName;
        var holidayNameArr = classNamesObj["holidayNames"];
        classNamesObj["holidayNames"] = holidayNameArr ? $f45070adf3eddf53$var$__spreadArray($f45070adf3eddf53$var$__spreadArray([], holidayNameArr, true), [
            holidayName
        ], false) : [
            holidayName
        ];
        dateClasses.set(key, classNamesObj);
    });
    return dateClasses;
}
/**
 * Determines the times to inject after a given start of day, current time, and multiplier.
 * @param startOfDay The start of the day.
 * @param currentTime The current time.
 * @param currentMultiplier The current multiplier.
 * @param intervals The intervals.
 * @param injectedTimes The times to potentially inject.
 * @returns An array of times to inject.
 */ function $f45070adf3eddf53$var$timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for(var i = 0; i < l; i++){
        var injectedTime = startOfDay;
        var injectedTimeValue = injectedTimes[i];
        if (injectedTimeValue) {
            injectedTime = (0, $37b4e01bec3ef150$export$2e2bcd8739ae039)(injectedTime, (0, $373f86827073914d$export$2e2bcd8739ae039)(injectedTimeValue));
            injectedTime = (0, $e31fea38bddb47f1$export$2e2bcd8739ae039)(injectedTime, (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(injectedTimeValue));
            injectedTime = (0, $9a5c8f3ee6846b06$export$2e2bcd8739ae039)(injectedTime, (0, $f5b59a09917da604$export$2e2bcd8739ae039)(injectedTimeValue));
        }
        var nextTime = (0, $e31fea38bddb47f1$export$2e2bcd8739ae039)(startOfDay, (currentMultiplier + 1) * intervals);
        if ((0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(injectedTime, currentTime) && (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(injectedTime, nextTime) && injectedTimeValue != undefined) times.push(injectedTimeValue);
    }
    return times;
}
/**
 * Adds a leading zero to a number if it's less than 10.
 * @param i The number to add a leading zero to.
 * @returns The number as a string, with a leading zero if it was less than 10.
 */ function $f45070adf3eddf53$var$addZero(i) {
    return i < 10 ? "0".concat(i) : "".concat(i);
}
/**
 * Gets the start and end years for a period.
 * @param date The date to get the period for.
 * @param yearItemNumber The number of years in the period. Defaults to DEFAULT_YEAR_ITEM_NUMBER.
 * @returns An object with the start and end years for the period.
 */ function $f45070adf3eddf53$var$getYearsPeriod(date, yearItemNumber) {
    if (yearItemNumber === void 0) yearItemNumber = $f45070adf3eddf53$var$DEFAULT_YEAR_ITEM_NUMBER;
    var endPeriod = Math.ceil((0, $d3820647cfc034b1$export$2e2bcd8739ae039)(date) / yearItemNumber) * yearItemNumber;
    var startPeriod = endPeriod - (yearItemNumber - 1);
    return {
        startPeriod: startPeriod,
        endPeriod: endPeriod
    };
}
/**
 * Gets the number of hours in a day.
 * @param d The date to get the number of hours for.
 * @returns The number of hours in the day.
 */ function $f45070adf3eddf53$var$getHoursInDay(d) {
    var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
    return Math.round((+startOfTheNextDay - +startOfDay) / 3600000);
}
/**
 * Returns the start of the minute for the given date
 *
 * NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
 * do not make changes unless you know what you're doing
 *
 * See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
 * for more details
 *
 * @param d date
 * @returns start of the minute
 */ function $f45070adf3eddf53$var$startOfMinute(d) {
    var seconds = d.getSeconds();
    var milliseconds = d.getMilliseconds();
    return (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(d.getTime() - seconds * 1000 - milliseconds);
}
/**
 * Returns whether the given dates are in the same minute
 *
 * This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
 *
 * @param d1
 * @param d2
 * @returns
 */ function $f45070adf3eddf53$var$isSameMinute(d1, d2) {
    return $f45070adf3eddf53$var$startOfMinute(d1).getTime() === $f45070adf3eddf53$var$startOfMinute(d2).getTime();
}
/**
 * Returns a new datetime object representing the input date with midnight time
 * @param date The date to get the midnight time for
 * @returns A new datetime object representing the input date with midnight time
 */ function $f45070adf3eddf53$var$getMidnightDate(date) {
    if (!(0, $6bf94078b78e666b$export$2e2bcd8739ae039)(date)) throw new Error("Invalid date");
    var dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    return dateWithoutTime;
}
/**
 * Is the first date before the second one?
 * @param date The date that should be before the other one to return true
 * @param dateToCompare The date to compare with
 * @returns The first date is before the second date
 *
 * Note:
 *  This function considers the mid-night of the given dates for comparison.
 *  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
 */ function $f45070adf3eddf53$var$isDateBefore(date, dateToCompare) {
    if (!(0, $6bf94078b78e666b$export$2e2bcd8739ae039)(date) || !(0, $6bf94078b78e666b$export$2e2bcd8739ae039)(dateToCompare)) throw new Error("Invalid date received");
    var midnightDate = $f45070adf3eddf53$var$getMidnightDate(date);
    var midnightDateToCompare = $f45070adf3eddf53$var$getMidnightDate(dateToCompare);
    return (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(midnightDate, midnightDateToCompare);
}
/**
 * Checks if the space key was pressed down.
 *
 * @param event - The keyboard event.
 * @returns - Returns true if the space key was pressed down, false otherwise.
 */ function $f45070adf3eddf53$var$isSpaceKeyDown(event) {
    return event.key === $f45070adf3eddf53$var$KeyType.Space;
}
/**
 * `InputTime` is a React component that manages time input.
 *
 * @component
 * @example
 * <InputTime timeString="12:00" />
 *
 * @param props - The properties that define the `InputTime` component.
 * @param props.onChange - Function that is called when the date changes.
 * @param props.date - The initial date value.
 * @param props.timeString - The initial time string value.
 * @param props.timeInputLabel - The label for the time input.
 * @param props.customTimeInput - An optional custom time input element.
 *
 * @returns The `InputTime` component.
 */ var $f45070adf3eddf53$var$InputTime = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(InputTime, _super);
    function InputTime(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        _this.onTimeChange = function(time) {
            var _a, _b;
            _this.setState({
                time: time
            });
            var propDate = _this.props.date;
            var isPropDateValid = propDate instanceof Date && !isNaN(+propDate);
            var date = isPropDateValid ? propDate : new Date();
            if (time === null || time === void 0 ? void 0 : time.includes(":")) {
                var _c = time.split(":"), hours = _c[0], minutes = _c[1];
                date.setHours(Number(hours));
                date.setMinutes(Number(minutes));
            }
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, date);
        };
        _this.renderTimeInput = function() {
            var time = _this.state.time;
            var _a = _this.props, date = _a.date, timeString = _a.timeString, customTimeInput = _a.customTimeInput;
            if (customTimeInput) return (0, $cQmXV.cloneElement)(customTimeInput, {
                date: date,
                value: time,
                onChange: _this.onTimeChange
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("input", {
                type: "time",
                className: "react-datepicker-time__input",
                placeholder: "Time",
                name: "time-input",
                ref: _this.inputRef,
                onClick: function() {
                    var _a;
                    (_a = _this.inputRef.current) === null || _a === void 0 || _a.focus();
                },
                required: true,
                value: time,
                onChange: function(event) {
                    _this.onTimeChange(event.target.value || timeString);
                }
            });
        };
        _this.state = {
            time: _this.props.timeString
        };
        return _this;
    }
    InputTime.getDerivedStateFromProps = function(props, state) {
        if (props.timeString !== state.time) return {
            time: props.timeString
        };
        // Return null to indicate no change to state.
        return null;
    };
    InputTime.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__input-time-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker-time__input-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
    };
    return InputTime;
}((0, $cQmXV.Component));
/**
 * `Day` is a React component that represents a single day in a date picker.
 * It handles the rendering and interaction of a day.
 *
 * @prop ariaLabelPrefixWhenEnabled - Aria label prefix when the day is enabled.
 * @prop ariaLabelPrefixWhenDisabled - Aria label prefix when the day is disabled.
 * @prop disabledKeyboardNavigation - Whether keyboard navigation is disabled.
 * @prop day - The day to be displayed.
 * @prop dayClassName - Function to customize the CSS class of the day.
 * @prop endDate - The end date in a range.
 * @prop highlightDates - Map of dates to be highlighted.
 * @prop holidays - Map of holiday dates.
 * @prop inline - Whether the date picker is inline.
 * @prop shouldFocusDayInline - Whether the day should be focused when date picker is inline.
 * @prop month - The month the day belongs to.
 * @prop onClick - Click event handler.
 * @prop onMouseEnter - Mouse enter event handler.
 * @prop handleOnKeyDown - Key down event handler.
 * @prop usePointerEvent - Whether to use pointer events.
 * @prop preSelection - The date that is currently selected.
 * @prop selected - The selected date.
 * @prop selectingDate - The date currently being selected.
 * @prop selectsEnd - Whether the day can be the end date in a range.
 * @prop selectsStart - Whether the day can be the start date in a range.
 * @prop selectsRange - Whether the day can be in a range.
 * @prop showWeekPicker - Whether to show week picker.
 * @prop showWeekNumber - Whether to show week numbers.
 * @prop selectsDisabledDaysInRange - Whether to select disabled days in a range.
 * @prop selectsMultiple - Whether to allow multiple date selection.
 * @prop selectedDates - Array of selected dates.
 * @prop startDate - The start date in a range.
 * @prop renderDayContents - Function to customize the rendering of the day's contents.
 * @prop containerRef - Ref for the container.
 * @prop excludeDates - Array of dates to be excluded.
 * @prop calendarStartDay - The start day of the week.
 * @prop locale - The locale object.
 * @prop monthShowsDuplicateDaysEnd - Whether to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Whether to show duplicate days at the start of the month.
 * @prop includeDates - Array of dates to be included.
 * @prop includeDateIntervals - Array of date intervals to be included.
 * @prop minDate - The minimum date that can be selected.
 * @prop maxDate - The maximum date that can be selected.
 *
 * @example
 * ```tsx
 * import React from 'react';
 * import Day from './day';
 *
 * function MyComponent() {
 *   const handleDayClick = (event) => {
 *     console.log('Day clicked', event);
 *   };
 *
 *   const handleDayMouseEnter = (event) => {
 *     console.log('Mouse entered day', event);
 *   };
 *
 *   const renderDayContents = (date) => {
 *     return <div>{date.getDate()}</div>;
 *   };
 *
 *   return (
 *     <Day
 *       day={new Date()}
 *       onClick={handleDayClick}
 *       onMouseEnter={handleDayMouseEnter}
 *       renderDayContents={renderDayContents}
 *     />
 *   );
 * }
 *
 * export default MyComponent;
 * ```
 */ var $f45070adf3eddf53$var$Day = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dayEl = (0, $cQmXV.createRef)();
        _this.handleClick = function(event) {
            if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
        };
        _this.handleMouseEnter = function(event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $f45070adf3eddf53$var$KeyType.Space) {
                event.preventDefault();
                event.key = $f45070adf3eddf53$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isSameDay = function(other) {
            return $f45070adf3eddf53$var$isSameDay(_this.props.day, other);
        };
        _this.isKeyboardSelected = function() {
            var _a;
            if (_this.props.disabledKeyboardNavigation) return false;
            var isSelectedDate = _this.props.selectsMultiple ? (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            }) : _this.isSameDayOrWeek(_this.props.selected);
            var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
            return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
        };
        _this.isDisabled = function(day) {
            if (day === void 0) day = _this.props.day;
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $f45070adf3eddf53$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function() {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $f45070adf3eddf53$var$isDayExcluded(_this.props.day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.isStartOfWeek = function() {
            return $f45070adf3eddf53$var$isSameDay(_this.props.day, $f45070adf3eddf53$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameWeek = function(other) {
            return _this.props.showWeekPicker && $f45070adf3eddf53$var$isSameDay(other, $f45070adf3eddf53$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameDayOrWeek = function(other) {
            return _this.isSameDay(other) || _this.isSameWeek(other);
        };
        _this.getHighLightedClass = function() {
            var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
            if (!highlightDates) return false;
            // Looking for className in the Map of {'day string, 'className'}
            var dayStr = $f45070adf3eddf53$var$formatDate(day, "MM.dd.yyyy");
            return highlightDates.get(dayStr);
        };
        // Function to return the array containing className associated to the date
        _this.getHolidaysClass = function() {
            var _a;
            var _b = _this.props, day = _b.day, holidays = _b.holidays;
            if (!holidays) // For type consistency no other reasons
            return [
                undefined
            ];
            var dayStr = $f45070adf3eddf53$var$formatDate(day, "MM.dd.yyyy");
            // Looking for className in the Map of {day string: {className, holidayName}}
            if (holidays.has(dayStr)) return [
                (_a = holidays.get(dayStr)) === null || _a === void 0 ? void 0 : _a.className
            ];
            // For type consistency no other reasons
            return [
                undefined
            ];
        };
        _this.isInRange = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $f45070adf3eddf53$var$isDayInRange(day, startDate, endDate);
        };
        _this.isInSelectingRange = function() {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, swapRange = _b.swapRange, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) return false;
            if (selectsStart && endDate && ((0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(selectingDate, endDate) || $f45070adf3eddf53$var$isEqual(selectingDate, endDate))) return $f45070adf3eddf53$var$isDayInRange(day, selectingDate, endDate);
            if (selectsEnd && startDate && ((0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(selectingDate, startDate) || $f45070adf3eddf53$var$isEqual(selectingDate, startDate))) return $f45070adf3eddf53$var$isDayInRange(day, startDate, selectingDate);
            if (selectsRange && startDate && !endDate) {
                if ($f45070adf3eddf53$var$isEqual(selectingDate, startDate)) return $f45070adf3eddf53$var$isDayInRange(day, startDate, selectingDate);
                if ((0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(selectingDate, startDate)) return $f45070adf3eddf53$var$isDayInRange(day, startDate, selectingDate);
                if (swapRange && (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(selectingDate, startDate)) return $f45070adf3eddf53$var$isDayInRange(day, selectingDate, startDate);
            }
            return false;
        };
        _this.isSelectingRangeStart = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart, swapRange = _b.swapRange, selectsRange = _b.selectsRange;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $f45070adf3eddf53$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $f45070adf3eddf53$var$isSameDay(day, (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(selectingDate, startDate) ? selectingDate : startDate);
            return $f45070adf3eddf53$var$isSameDay(day, startDate);
        };
        _this.isSelectingRangeEnd = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, swapRange = _b.swapRange, startDate = _b.startDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd) return $f45070adf3eddf53$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $f45070adf3eddf53$var$isSameDay(day, (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(selectingDate, startDate) ? startDate : selectingDate);
            if (selectsRange) return $f45070adf3eddf53$var$isSameDay(day, selectingDate);
            return $f45070adf3eddf53$var$isSameDay(day, endDate);
        };
        _this.isRangeStart = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $f45070adf3eddf53$var$isSameDay(startDate, day);
        };
        _this.isRangeEnd = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $f45070adf3eddf53$var$isSameDay(endDate, day);
        };
        _this.isWeekend = function() {
            var weekday = (0, $d5cc598bb4539215$export$2e2bcd8739ae039)(_this.props.day);
            return weekday === 0 || weekday === 6;
        };
        _this.isAfterMonth = function() {
            return _this.props.month !== undefined && (_this.props.month + 1) % 12 === (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(_this.props.day);
        };
        _this.isBeforeMonth = function() {
            return _this.props.month !== undefined && ((0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(_this.props.day) + 1) % 12 === _this.props.month;
        };
        _this.isCurrentDay = function() {
            return _this.isSameDay($f45070adf3eddf53$var$newDate());
        };
        _this.isSelected = function() {
            var _a;
            if (_this.props.selectsMultiple) return (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            });
            return _this.isSameDayOrWeek(_this.props.selected);
        };
        _this.getClassNames = function(date) {
            var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
            return (0, $jYj5L.clsx)("react-datepicker__day", dayClassName, "react-datepicker__day--" + $f45070adf3eddf53$var$getDayOfWeekCode(_this.props.day), {
                "react-datepicker__day--disabled": _this.isDisabled(),
                "react-datepicker__day--excluded": _this.isExcluded(),
                "react-datepicker__day--selected": _this.isSelected(),
                "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
                "react-datepicker__day--range-start": _this.isRangeStart(),
                "react-datepicker__day--range-end": _this.isRangeEnd(),
                "react-datepicker__day--in-range": _this.isInRange(),
                "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
                "react-datepicker__day--today": _this.isCurrentDay(),
                "react-datepicker__day--weekend": _this.isWeekend(),
                "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
            }, _this.getHighLightedClass(), _this.getHolidaysClass());
        };
        _this.getAriaLabel = function() {
            var _a = _this.props, day = _a.day, _b = _a.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
            var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
            return "".concat(prefix, " ").concat($f45070adf3eddf53$var$formatDate(day, "PPPP", _this.props.locale));
        };
        // A function to return the holiday's name as title's content
        _this.getTitle = function() {
            var _a = _this.props, day = _a.day, _b = _a.holidays, holidays = _b === void 0 ? new Map() : _b, excludeDates = _a.excludeDates;
            var compareDt = $f45070adf3eddf53$var$formatDate(day, "MM.dd.yyyy");
            var titles = [];
            if (holidays.has(compareDt)) titles.push.apply(titles, holidays.get(compareDt).holidayNames);
            if (_this.isExcluded()) titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
                if (excludeDate instanceof Date) return $f45070adf3eddf53$var$isSameDay(excludeDate, day);
                return $f45070adf3eddf53$var$isSameDay(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
            }).map(function(excludeDate) {
                if (excludeDate instanceof Date) return undefined;
                return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
            }));
            // I'm not sure that this is a right output, but all tests are green
            return titles.join(", ");
        };
        _this.getTabIndex = function() {
            var selectedDay = _this.props.selected;
            var preSelectionDay = _this.props.preSelection;
            var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && $f45070adf3eddf53$var$isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
            return tabIndex;
        };
        // various cases when we need to apply focus to the preselected day
        // focus the day on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusDay = function() {
            var _a;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            _this.shouldFocusDay() && ((_a = _this.dayEl.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            }));
        };
        _this.renderDayContents = function() {
            if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
            if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
            return _this.props.renderDayContents ? _this.props.renderDayContents((0, $95441081375ffd7b$export$2e2bcd8739ae039)(_this.props.day), _this.props.day) : (0, $95441081375ffd7b$export$2e2bcd8739ae039)(_this.props.day);
        };
        _this.render = function() {
            return(// TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
            (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                ref: _this.dayEl,
                className: _this.getClassNames(_this.props.day),
                onKeyDown: _this.handleOnKeyDown,
                onClick: _this.handleClick,
                onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                tabIndex: _this.getTabIndex(),
                "aria-label": _this.getAriaLabel(),
                role: "gridcell",
                title: _this.getTitle(),
                "aria-disabled": _this.isDisabled(),
                "aria-current": _this.isCurrentDay() ? "date" : undefined,
                "aria-selected": _this.isSelected() || _this.isInRange()
            }, _this.renderDayContents(), _this.getTitle() !== "" && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "overlay"
            }, _this.getTitle())));
        };
        return _this;
    }
    Day.prototype.componentDidMount = function() {
        this.handleFocusDay();
    };
    Day.prototype.componentDidUpdate = function() {
        this.handleFocusDay();
    };
    Day.prototype.shouldFocusDay = function() {
        var shouldFocusDay = false;
        if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
            // there is currently no activeElement and not inline
            if (!document.activeElement || document.activeElement === document.body) shouldFocusDay = true;
            // inline version:
            // do not focus on initial render to prevent autoFocus issue
            // focus after month has changed via keyboard
            if (this.props.inline && !this.props.shouldFocusDayInline) shouldFocusDay = false;
            if (this.isDayActiveElement()) shouldFocusDay = true;
            if (this.isDuplicateDay()) shouldFocusDay = false;
        }
        return shouldFocusDay;
    };
    // the activeElement is in the container, and it is another instance of Day
    Day.prototype.isDayActiveElement = function() {
        var _a, _b, _c;
        return ((_b = (_a = this.props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
    };
    Day.prototype.isDuplicateDay = function() {
        return(//day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth());
    };
    return Day;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$WeekNumber = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(WeekNumber, _super);
    function WeekNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.weekNumberEl = (0, $cQmXV.createRef)();
        _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $f45070adf3eddf53$var$KeyType.Space) {
                event.preventDefault();
                event.key = $f45070adf3eddf53$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$f45070adf3eddf53$var$isSameDay(_this.props.date, _this.props.selected) && $f45070adf3eddf53$var$isSameDay(_this.props.date, _this.props.preSelection);
        };
        _this.getTabIndex = function() {
            return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || $f45070adf3eddf53$var$isSameDay(_this.props.date, _this.props.selected) && $f45070adf3eddf53$var$isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
        };
        // various cases when we need to apply focus to the preselected week-number
        // focus the week-number on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusWeekNumber = function(prevProps) {
            var shouldFocusWeekNumber = false;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && $f45070adf3eddf53$var$isSameDay(_this.props.date, _this.props.preSelection)) {
                // there is currently no activeElement and not inline
                if (!document.activeElement || document.activeElement === document.body) shouldFocusWeekNumber = true;
                // inline version:
                // do not focus on initial render to prevent autoFocus issue
                // focus after month has changed via keyboard
                if (_this.props.inline && !_this.props.shouldFocusDayInline) shouldFocusWeekNumber = false;
                // the activeElement is in the container, and it is another instance of WeekNumber
                if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) shouldFocusWeekNumber = true;
            }
            shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
                preventScroll: true
            });
        };
        return _this;
    }
    Object.defineProperty(WeekNumber, "defaultProps", {
        get: function() {
            return {
                ariaLabelPrefix: "week "
            };
        },
        enumerable: false,
        configurable: true
    });
    WeekNumber.prototype.componentDidMount = function() {
        this.handleFocusWeekNumber();
    };
    WeekNumber.prototype.componentDidUpdate = function(prevProps) {
        this.handleFocusWeekNumber(prevProps);
    };
    WeekNumber.prototype.render = function() {
        var _a = this.props, weekNumber = _a.weekNumber, isWeekDisabled = _a.isWeekDisabled, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber.defaultProps.ariaLabelPrefix : _b, onClick = _a.onClick;
        var weekNumberClasses = {
            "react-datepicker__week-number": true,
            "react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
            "react-datepicker__week-number--selected": !!onClick && $f45070adf3eddf53$var$isSameDay(this.props.date, this.props.selected)
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            ref: this.weekNumberEl,
            className: (0, $jYj5L.clsx)(weekNumberClasses),
            "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
            onClick: this.handleClick,
            onKeyDown: this.handleOnKeyDown,
            tabIndex: this.getTabIndex(),
            role: "gridcell"
        }, weekNumber);
    };
    return WeekNumber;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$Week = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDisabled = function(day) {
            return $f45070adf3eddf53$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        };
        _this.handleWeekClick = function(day, weekNumber, event) {
            var _a, _b, _c;
            var enabledWeekDay = new Date(day);
            for(var i = 0; i < 7; i++){
                var processingDay = new Date(day);
                processingDay.setDate(processingDay.getDate() + i);
                var isEnabled = !_this.isDisabled(processingDay);
                if (isEnabled) {
                    enabledWeekDay = processingDay;
                    break;
                }
            }
            if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
            if (_this.props.showWeekPicker) _this.handleDayClick(enabledWeekDay, event);
            if ((_a = _this.props.shouldCloseOnSelect) !== null && _a !== void 0 ? _a : Week.defaultProps.shouldCloseOnSelect) (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, false);
        };
        _this.formatWeekNumber = function(date) {
            if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
            return $f45070adf3eddf53$var$getWeek(date);
        };
        _this.isWeekDisabled = function() {
            var startOfWeek = _this.startOfWeek();
            var endOfWeek = (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(startOfWeek, 6);
            var processingDate = new Date(startOfWeek);
            while(processingDate <= endOfWeek){
                if (!_this.isDisabled(processingDate)) return false;
                processingDate = (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(processingDate, 1);
            }
            return true;
        };
        _this.renderDays = function() {
            var startOfWeek = _this.startOfWeek();
            var days = [];
            var weekNumber = _this.formatWeekNumber(startOfWeek);
            if (_this.props.showWeekNumber) {
                var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
                days.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$WeekNumber, $f45070adf3eddf53$var$_assign({
                    key: "W"
                }, Week.defaultProps, _this.props, {
                    weekNumber: weekNumber,
                    isWeekDisabled: _this.isWeekDisabled(),
                    date: startOfWeek,
                    onClick: onClickAction
                })));
            }
            return days.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(startOfWeek, offset);
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Day, $f45070adf3eddf53$var$_assign({}, Week.defaultProps, _this.props, {
                    ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
                    ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
                    key: day.valueOf(),
                    day: day,
                    onClick: _this.handleDayClick.bind(_this, day),
                    onMouseEnter: _this.handleDayMouseEnter.bind(_this, day)
                }));
            }));
        };
        _this.startOfWeek = function() {
            return $f45070adf3eddf53$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$f45070adf3eddf53$var$isSameDay(_this.startOfWeek(), _this.props.selected) && $f45070adf3eddf53$var$isSameDay(_this.startOfWeek(), _this.props.preSelection);
        };
        return _this;
    }
    Object.defineProperty(Week, "defaultProps", {
        get: function() {
            return {
                shouldCloseOnSelect: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Week.prototype.render = function() {
        var weekNumberClasses = {
            "react-datepicker__week": true,
            "react-datepicker__week--selected": $f45070adf3eddf53$var$isSameDay(this.startOfWeek(), this.props.selected),
            "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
        };
        var customWeekClassName = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: (0, $jYj5L.clsx)(weekNumberClasses, customWeekClassName),
            role: "row"
        }, this.renderDays());
    };
    return Week;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$_a;
var $f45070adf3eddf53$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var $f45070adf3eddf53$var$MONTH_COLUMNS_LAYOUT = {
    TWO_COLUMNS: "two_columns",
    THREE_COLUMNS: "three_columns",
    FOUR_COLUMNS: "four_columns"
};
var $f45070adf3eddf53$var$MONTH_COLUMNS = ($f45070adf3eddf53$var$_a = {}, $f45070adf3eddf53$var$_a[$f45070adf3eddf53$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
    grid: [
        [
            0,
            1
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            6,
            7
        ],
        [
            8,
            9
        ],
        [
            10,
            11
        ]
    ],
    verticalNavigationOffset: 2
}, $f45070adf3eddf53$var$_a[$f45070adf3eddf53$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 3
}, $f45070adf3eddf53$var$_a[$f45070adf3eddf53$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ],
        [
            8,
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 4
}, $f45070adf3eddf53$var$_a);
var $f45070adf3eddf53$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function $f45070adf3eddf53$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
    if (showFourColumnMonthYearPicker) return $f45070adf3eddf53$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
    if (showTwoColumnMonthYearPicker) return $f45070adf3eddf53$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
    return $f45070adf3eddf53$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
/**
 * `Month` is a React component that represents a month in a calendar.
 * It accepts a `MonthProps` object as props which provides various configurations and event handlers.
 *
 * @prop dayClassName - Function to determine the class name for a day.
 * @prop monthClassName - Function to determine the class name for a month.
 * @prop filterDate - Function to filter dates.
 * @prop formatWeekNumber - Function to format the week number.
 * @prop onDayClick - Function to handle day click events.
 * @prop onDayMouseEnter - Function to handle mouse enter events on a day.
 * @prop onMouseLeave - Function to handle mouse leave events.
 * @prop onWeekSelect - Function to handle week selection.
 * @prop setPreSelection - Function to set pre-selection.
 * @prop setOpen - Function to set open state.
 * @prop renderDayContents - Function to render day contents.
 * @prop renderMonthContent - Function to render month content.
 * @prop renderQuarterContent - Function to render quarter content.
 * @prop handleOnKeyDown - Function to handle key down events.
 * @prop handleOnMonthKeyDown - Function to handle key down events on a month.
 * @prop ariaLabelPrefix - Aria label prefix.
 * @prop chooseDayAriaLabelPrefix - Aria label prefix for choosing a day.
 * @prop disabledDayAriaLabelPrefix - Aria label prefix for disabled day.
 * @prop disabledKeyboardNavigation - Flag to disable keyboard navigation.
 * @prop day - The day.
 * @prop endDate - The end date.
 * @prop orderInDisplay - The order in display.
 * @prop excludeDates - Dates to exclude.
 * @prop excludeDateIntervals - Date intervals to exclude.
 * @prop fixedHeight - Flag to set fixed height.
 * @prop highlightDates - Dates to highlight.
 * @prop holidays - Holidays.
 * @prop includeDates - Dates to include.
 * @prop includeDateIntervals - Date intervals to include.
 * @prop inline - Flag to set inline.
 * @prop shouldFocusDayInline - Flag to set focus on day inline.
 * @prop locale - The locale.
 * @prop maxDate - The maximum date.
 * @prop minDate - The minimum date.
 * @prop usePointerEvent - Flag to use pointer event.
 * @prop peekNextMonth - Flag to peek next month.
 * @prop preSelection - The pre-selection.
 * @prop selected - The selected date.
 * @prop selectingDate - The selecting date.
 * @prop calendarStartDay - The calendar start day.
 * @prop selectsEnd - Flag to select end.
 * @prop selectsStart - Flag to select start.
 * @prop selectsRange - Flag to select range.
 * @prop selectsDisabledDaysInRange - Flag to select disabled days in range.
 * @prop selectsMultiple - Flag to select multiple.
 * @prop selectedDates - The selected dates.
 * @prop showWeekNumbers - Flag to show week numbers.
 * @prop startDate - The start date.
 * @prop shouldCloseOnSelect - Flag to close on select.
 * @prop showMonthYearPicker - Flag to show month year picker.
 * @prop showFullMonthYearPicker - Flag to show full month year picker.
 * @prop showTwoColumnMonthYearPicker - Flag to show two column month year picker.
 * @prop showFourColumnMonthYearPicker - Flag to show four column month year picker.
 * @prop showQuarterYearPicker - Flag to show quarter year picker.
 * @prop showWeekPicker - Flag to show week picker.
 * @prop isInputFocused - Flag to set input focus.
 * @prop weekAriaLabelPrefix - Aria label prefix for week.
 * @prop containerRef - The container reference.
 * @prop monthShowsDuplicateDaysEnd - Flag to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Flag to show duplicate days at the start of the month.
 *
 * @example
 * ```tsx
 * function App() {
 *  const handleDayClick = (date) => {
 *     console.log('Day clicked: ', date);
 *   };
 *
 *   const handleDayMouseEnter = (date) => {
 *     console.log('Mouse entered on day: ', date);
 *   };
 *
 *   return (
 *     <div>
 *       <Month
 *         day={new Date()}
 *         endDate={new Date()}
 *         onDayClick={handleDayClick}
 *         onDayMouseEnter={handleDayMouseEnter}
 *         disabledKeyboardNavigation={false}
 *         showWeekNumbers={true}
 *         showMonthYearPicker={false}
 *       />
 *     </div>
 *   );
 * }
 * ```
 */ var $f45070adf3eddf53$var$Month = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MONTH_REFS = $f45070adf3eddf53$var$__spreadArray([], Array(12), true).map(function() {
            return (0, $cQmXV.createRef)();
        });
        _this.QUARTER_REFS = $f45070adf3eddf53$var$__spreadArray([], Array(4), true).map(function() {
            return (0, $cQmXV.createRef)();
        });
        _this.isDisabled = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $f45070adf3eddf53$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $f45070adf3eddf53$var$isDayExcluded(day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.handleDayClick = function(day, event) {
            var _a, _b;
            (_b = (_a = _this.props).onDayClick) === null || _b === void 0 || _b.call(_a, day, event, _this.props.orderInDisplay);
        };
        _this.handleDayMouseEnter = function(day) {
            var _a, _b;
            (_b = (_a = _this.props).onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day);
        };
        _this.handleMouseLeave = function() {
            var _a, _b;
            (_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a);
        };
        _this.isRangeStartMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $f45070adf3eddf53$var$isSameMonth((0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, m), startDate);
        };
        _this.isRangeStartQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $f45070adf3eddf53$var$isSameQuarter((0, $c6e017e14073270e$export$2e2bcd8739ae039)(day, q), startDate);
        };
        _this.isRangeEndMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $f45070adf3eddf53$var$isSameMonth((0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, m), endDate);
        };
        _this.isRangeEndQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $f45070adf3eddf53$var$isSameQuarter((0, $c6e017e14073270e$export$2e2bcd8739ae039)(day, q), endDate);
        };
        _this.isInSelectingRangeMonth = function(m) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $f45070adf3eddf53$var$isMonthInRange(selectingDate, endDate, m, day);
            if (selectsEnd && startDate) return $f45070adf3eddf53$var$isMonthInRange(startDate, selectingDate, m, day);
            if (selectsRange && startDate && !endDate) return $f45070adf3eddf53$var$isMonthInRange(startDate, selectingDate, m, day);
            return false;
        };
        _this.isSelectingMonthRangeStart = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _month = (0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $f45070adf3eddf53$var$isSameMonth(_month, selectingDate);
            else return $f45070adf3eddf53$var$isSameMonth(_month, startDate);
        };
        _this.isSelectingMonthRangeEnd = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _month = (0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd || selectsRange) return $f45070adf3eddf53$var$isSameMonth(_month, selectingDate);
            else return $f45070adf3eddf53$var$isSameMonth(_month, endDate);
        };
        _this.isInSelectingRangeQuarter = function(q) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $f45070adf3eddf53$var$isQuarterInRange(selectingDate, endDate, q, day);
            if (selectsEnd && startDate) return $f45070adf3eddf53$var$isQuarterInRange(startDate, selectingDate, q, day);
            if (selectsRange && startDate && !endDate) return $f45070adf3eddf53$var$isQuarterInRange(startDate, selectingDate, q, day);
            return false;
        };
        _this.isWeekInMonth = function(startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(startOfWeek, 6);
            return $f45070adf3eddf53$var$isSameMonth(startOfWeek, day) || $f45070adf3eddf53$var$isSameMonth(endOfWeek, day);
        };
        _this.isCurrentMonth = function(day, m) {
            return (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(day) === (0, $d3820647cfc034b1$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate()) && m === (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate());
        };
        _this.isCurrentQuarter = function(day, q) {
            return (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(day) === (0, $d3820647cfc034b1$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate()) && q === (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate());
        };
        _this.isSelectedMonth = function(day, m, selected) {
            return (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(selected) === m && (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(day) === (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(selected);
        };
        _this.isSelectMonthInList = function(day, m, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedMonth(day, m, selectedDate);
            });
        };
        _this.isSelectedQuarter = function(day, q, selected) {
            return (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)(selected) === q && (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(day) === (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(selected);
        };
        _this.isSelectQuarterInList = function(day, q, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, q, selectedDate);
            });
        };
        _this.isMonthSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var monthIdx = (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return _this.isSelectedMonth(day, monthIdx, date);
            });
            return !!selected && _this.isSelectedMonth(day, monthIdx, selected);
        };
        _this.isQuarterSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var quarterIdx = (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, quarterIdx, selectedDate);
            });
            return !!selected && _this.isSelectedQuarter(day, quarterIdx, selected);
        };
        _this.renderWeeks = function() {
            // Return empty array if day is invalid
            if (!$f45070adf3eddf53$var$isValid(_this.props.day)) return [];
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var i = 0;
            var breakAfterNextPush = false;
            var currentWeekStart = $f45070adf3eddf53$var$getStartOfWeek($f45070adf3eddf53$var$getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
            var isPreSelected = function(preSelection) {
                return _this.props.showWeekPicker ? $f45070adf3eddf53$var$getStartOfWeek(preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
            };
            var isSelected = function(selected) {
                return _this.props.showWeekPicker ? $f45070adf3eddf53$var$getStartOfWeek(selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
            };
            var selected = _this.props.selected ? isSelected(_this.props.selected) : undefined;
            var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : undefined;
            while(true){
                weeks.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Week, $f45070adf3eddf53$var$_assign({}, _this.props, {
                    ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
                    key: i,
                    day: currentWeekStart,
                    month: (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(_this.props.day),
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    selected: selected,
                    preSelection: preSelection,
                    showWeekNumber: _this.props.showWeekNumbers
                })));
                if (breakAfterNextPush) break;
                i++;
                currentWeekStart = (0, $445df110012de010$export$2e2bcd8739ae039)(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= $f45070adf3eddf53$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) breakAfterNextPush = true;
                    else break;
                }
            }
            return weeks;
        };
        _this.onMonthClick = function(event, m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayClick($f45070adf3eddf53$var$getStartOfMonth(labelDate), event);
        };
        _this.onMonthMouseEnter = function(m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayMouseEnter($f45070adf3eddf53$var$getStartOfMonth(labelDate));
        };
        _this.handleMonthNavigation = function(newMonth, newDate) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.handleKeyboardNavigation = function(event, eventKey, month) {
            var _a;
            var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
            if (!preSelection) return;
            var monthColumnsLayout = $f45070adf3eddf53$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
            var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
            var monthsGrid = (_a = $f45070adf3eddf53$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.grid;
            var calculateNewDateAndMonth = function(eventKey, date, month) {
                var _a, _b;
                var newCalculatedDate = date;
                var newCalculatedMonth = month;
                switch(eventKey){
                    case $f45070adf3eddf53$var$KeyType.ArrowRight:
                        newCalculatedDate = (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(date, $f45070adf3eddf53$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 11 ? 0 : month + $f45070adf3eddf53$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $f45070adf3eddf53$var$KeyType.ArrowLeft:
                        newCalculatedDate = (0, $9450df79fe1987af$export$2e2bcd8739ae039)(date, $f45070adf3eddf53$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 0 ? 11 : month - $f45070adf3eddf53$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $f45070adf3eddf53$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $9450df79fe1987af$export$2e2bcd8739ae039)(date, verticalOffset);
                        newCalculatedMonth = ((_a = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a === void 0 ? void 0 : _a.includes(month)) ? month + 12 - verticalOffset : month - verticalOffset;
                        break;
                    case $f45070adf3eddf53$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(date, verticalOffset);
                        newCalculatedMonth = ((_b = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b === void 0 ? void 0 : _b.includes(month)) ? month - 12 + verticalOffset : month + verticalOffset;
                        break;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            var getNewDateAndMonth = function(eventKey, selectedDate, month) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var _a = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month), newCalculatedDate = _a.newCalculatedDate, newCalculatedMonth = _a.newCalculatedMonth;
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newCalculatedDate = selectedDate;
                        newCalculatedMonth = month;
                        break;
                    }
                    // if minDate exists and the new month is before the minimum month, it will try to find the next available month after
                    if (minDate && newCalculatedDate < minDate) {
                        eventKeyCopy = $f45070adf3eddf53$var$KeyType.ArrowRight;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    // if maxDate exists and the new month is after the maximum month, it will try to find the next available month before
                    if (maxDate && newCalculatedDate > maxDate) {
                        eventKeyCopy = $f45070adf3eddf53$var$KeyType.ArrowLeft;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    if ($f45070adf3eddf53$var$isMonthYearDisabled(newCalculatedDate, _this.props)) {
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    } else validDateFound = true;
                    iterations++;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            if (eventKey === $f45070adf3eddf53$var$KeyType.Enter) {
                if (!_this.isMonthDisabled(month)) {
                    _this.onMonthClick(event, month);
                    setPreSelection === null || setPreSelection === void 0 || setPreSelection(selected);
                }
                return;
            }
            var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
            switch(eventKey){
                case $f45070adf3eddf53$var$KeyType.ArrowRight:
                case $f45070adf3eddf53$var$KeyType.ArrowLeft:
                case $f45070adf3eddf53$var$KeyType.ArrowUp:
                case $f45070adf3eddf53$var$KeyType.ArrowDown:
                    _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
                    break;
            }
        };
        _this.getVerticalOffset = function(monthColumnsLayout) {
            var _a, _b;
            return (_b = (_a = $f45070adf3eddf53$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
        };
        _this.onMonthKeyDown = function(event, month) {
            var _a = _this.props, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, handleOnMonthKeyDown = _a.handleOnMonthKeyDown;
            var eventKey = event.key;
            if (eventKey !== $f45070adf3eddf53$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!disabledKeyboardNavigation) _this.handleKeyboardNavigation(event, eventKey, month);
            handleOnMonthKeyDown && handleOnMonthKeyDown(event);
        };
        _this.onQuarterClick = function(event, q) {
            var labelDate = (0, $c6e017e14073270e$export$2e2bcd8739ae039)(_this.props.day, q);
            if ($f45070adf3eddf53$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayClick($f45070adf3eddf53$var$getStartOfQuarter(labelDate), event);
        };
        _this.onQuarterMouseEnter = function(q) {
            var labelDate = (0, $c6e017e14073270e$export$2e2bcd8739ae039)(_this.props.day, q);
            if ($f45070adf3eddf53$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayMouseEnter($f45070adf3eddf53$var$getStartOfQuarter(labelDate));
        };
        _this.handleQuarterNavigation = function(newQuarter, newDate) {
            var _a, _b, _c, _d;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.onQuarterKeyDown = function(event, quarter) {
            var _a, _b;
            var eventKey = event.key;
            if (!_this.props.disabledKeyboardNavigation) switch(eventKey){
                case $f45070adf3eddf53$var$KeyType.Enter:
                    _this.onQuarterClick(event, quarter);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $f45070adf3eddf53$var$KeyType.ArrowRight:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, (0, $89d674319e089593$export$2e2bcd8739ae039)(_this.props.preSelection, 1));
                    break;
                case $f45070adf3eddf53$var$KeyType.ArrowLeft:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, (0, $7913aededcc910d4$export$2e2bcd8739ae039)(_this.props.preSelection, 1));
                    break;
            }
        };
        _this.isMonthDisabledForLabelDate = function(month) {
            var _a;
            var _b = _this.props, day = _b.day, disabled = _b.disabled, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
            var labelDate = (0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, month);
            if (disabled) return {
                isDisabled: true,
                labelDate: (0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, month)
            };
            return {
                isDisabled: (_a = (minDate || maxDate || excludeDates || includeDates) && $f45070adf3eddf53$var$isMonthDisabled(labelDate, _this.props)) !== null && _a !== void 0 ? _a : false,
                labelDate: labelDate
            };
        };
        _this.isMonthDisabled = function(month) {
            var isDisabled = _this.isMonthDisabledForLabelDate(month).isDisabled;
            return isDisabled;
        };
        _this.getMonthClassNames = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, preSelection = _a.preSelection, monthClassName = _a.monthClassName;
            var _monthClassName = monthClassName ? monthClassName((0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, m)) : undefined;
            var selection = _this.getSelection();
            return (0, $jYj5L.clsx)("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
                "react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
                "react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m, selection) : undefined,
                "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m, preSelection) && !_this.isMonthSelected() && !_this.isMonthDisabled(m),
                "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
                "react-datepicker__month-text--in-range": startDate && endDate ? $f45070adf3eddf53$var$isMonthInRange(startDate, endDate, m, day) : undefined,
                "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
                "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
                "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
                "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
                "react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
            });
        };
        _this.getTabIndex = function(m) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedMonth = (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(_this.props.preSelection);
            var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
            var tabIndex = m === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getQuarterTabIndex = function(q) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedQuarter = (0, $36bfab3978e1f56e$export$2e2bcd8739ae039)(_this.props.preSelection);
            var isCurrentQuarterDisabled = $f45070adf3eddf53$var$isQuarterDisabled(_this.props.day, _this.props);
            var tabIndex = q === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getAriaLabel = function(month) {
            var _a = _this.props, _b = _a.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a.day, locale = _a.locale;
            var labelDate = (0, $0f0a320b378f0016$export$2e2bcd8739ae039)(day, month);
            var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
            return "".concat(prefix, " ").concat($f45070adf3eddf53$var$formatDate(labelDate, "MMMM yyyy", locale));
        };
        _this.getQuarterClassNames = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, preSelection = _a.preSelection, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, disabled = _a.disabled;
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $f45070adf3eddf53$var$isQuarterDisabled((0, $c6e017e14073270e$export$2e2bcd8739ae039)(day, q), _this.props);
            var selection = _this.getSelection();
            return (0, $jYj5L.clsx)("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
                "react-datepicker__quarter-text--disabled": isDisabled,
                "react-datepicker__quarter-text--selected": selection ? _this.isSelectQuarterInList(day, q, selection) : undefined,
                "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q, preSelection) && !_this.isQuarterSelected() && !isDisabled,
                "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
                "react-datepicker__quarter-text--in-range": startDate && endDate ? $f45070adf3eddf53$var$isQuarterInRange(startDate, endDate, q, day) : undefined,
                "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
                "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q),
                "react-datepicker__quarter-text--today": _this.isCurrentQuarter(day, q)
            });
        };
        _this.getMonthContent = function(m) {
            var _a = _this.props, showFullMonthYearPicker = _a.showFullMonthYearPicker, renderMonthContent = _a.renderMonthContent, locale = _a.locale, day = _a.day;
            var shortMonthText = $f45070adf3eddf53$var$getMonthShortInLocale(m, locale);
            var fullMonthText = $f45070adf3eddf53$var$getMonthInLocale(m, locale);
            if (renderMonthContent) return renderMonthContent(m, shortMonthText, fullMonthText, day);
            return showFullMonthYearPicker ? fullMonthText : shortMonthText;
        };
        _this.getQuarterContent = function(q) {
            var _a;
            var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
            var shortQuarter = $f45070adf3eddf53$var$getQuarterShortInLocale(q, locale);
            return (_a = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q, shortQuarter)) !== null && _a !== void 0 ? _a : shortQuarter;
        };
        _this.renderMonths = function() {
            var _a;
            var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
            var monthColumns = (_a = $f45070adf3eddf53$var$MONTH_COLUMNS[$f45070adf3eddf53$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a === void 0 ? void 0 : _a.grid;
            return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: i
                }, month.map(function(m, j) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                        ref: _this.MONTH_REFS[m],
                        key: j,
                        onClick: function(event) {
                            _this.onMonthClick(event, m);
                        },
                        onKeyDown: function(event) {
                            if ($f45070adf3eddf53$var$isSpaceKeyDown(event)) {
                                event.preventDefault();
                                event.key = $f45070adf3eddf53$var$KeyType.Enter;
                            }
                            _this.onMonthKeyDown(event, m);
                        },
                        onMouseEnter: !_this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        onPointerEnter: _this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        tabIndex: Number(_this.getTabIndex(m)),
                        className: _this.getMonthClassNames(m),
                        "aria-disabled": _this.isMonthDisabled(m),
                        role: "option",
                        "aria-label": _this.getAriaLabel(m),
                        "aria-current": _this.isCurrentMonth(day, m) ? "date" : undefined,
                        "aria-selected": selected ? _this.isSelectedMonth(day, m, selected) : undefined
                    }, _this.getMonthContent(m));
                }));
            });
        };
        _this.renderQuarters = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected;
            var quarters = [
                1,
                2,
                3,
                4
            ];
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__quarter-wrapper"
            }, quarters.map(function(q, j) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    key: j,
                    ref: _this.QUARTER_REFS[j],
                    role: "option",
                    onClick: function(event) {
                        _this.onQuarterClick(event, q);
                    },
                    onKeyDown: function(event) {
                        _this.onQuarterKeyDown(event, q);
                    },
                    onMouseEnter: !_this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    onPointerEnter: _this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    className: _this.getQuarterClassNames(q),
                    "aria-selected": selected ? _this.isSelectedQuarter(day, q, selected) : undefined,
                    tabIndex: Number(_this.getQuarterTabIndex(q)),
                    "aria-current": _this.isCurrentQuarter(day, q) ? "date" : undefined
                }, _this.getQuarterContent(q));
            }));
        };
        _this.getClassNames = function() {
            var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, showWeekPicker = _a.showWeekPicker;
            return (0, $jYj5L.clsx)("react-datepicker__month", {
                "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
            }, {
                "react-datepicker__monthPicker": showMonthYearPicker
            }, {
                "react-datepicker__quarterPicker": showQuarterYearPicker
            }, {
                "react-datepicker__weekPicker": showWeekPicker
            });
        };
        return _this;
    }
    Month.prototype.getSelection = function() {
        var _a = this.props, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
        if (selectsMultiple) return selectedDates;
        if (selected) return [
            selected
        ];
        return undefined;
    };
    Month.prototype.render = function() {
        var _a = this.props, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, day = _a.day, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
        var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
        // Format aria-label, return empty string if date is invalid
        var formattedAriaLabel = $f45070adf3eddf53$var$isValid(day) ? "".concat(formattedAriaLabelPrefix).concat($f45070adf3eddf53$var$formatDate(day, "MMMM, yyyy", this.props.locale)) : "";
        var shouldUseListboxRole = showMonthYearPicker || showQuarterYearPicker;
        if (shouldUseListboxRole) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "listbox"
        }, showMonthYearPicker ? this.renderMonths() : this.renderQuarters());
        // For regular calendar view, use table structure
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            role: "table"
        }, this.props.dayNamesHeader && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            role: "rowgroup"
        }, this.props.dayNamesHeader), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "rowgroup"
        }, this.renderWeeks()));
    };
    return Month;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$MonthDropdownOptions = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(MonthDropdownOptions, _super);
    function MonthDropdownOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.monthOptionButtonsRef = {};
        _this.isSelectedMonth = function(i) {
            return _this.props.month === i;
        };
        _this.handleOptionKeyDown = function(i, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(i);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newMonth = (i + (e.key === "ArrowUp" ? -1 : 1) + _this.props.monthNames.length) % _this.props.monthNames.length;
                    (_a = _this.monthOptionButtonsRef[newMonth]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.monthOptionButtonsRef = {};
            return _this.props.monthNames.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    ref: function(el) {
                        _this.monthOptionButtonsRef[i] = el;
                        if (_this.isSelectedMonth(i)) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                    key: month,
                    onClick: _this.onChange.bind(_this, i),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, i),
                    "aria-selected": _this.isSelectedMonth(i) ? "true" : undefined
                }, _this.isSelectedMonth(i) ? (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", month);
            });
        };
        _this.onChange = function(month) {
            return _this.props.onChange(month);
        };
        _this.handleClickOutside = function() {
            return _this.props.onCancel();
        };
        return _this;
    }
    MonthDropdownOptions.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$ClickOutsideWrapper, {
            className: "react-datepicker__month-dropdown",
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthDropdownOptions;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$MonthDropdown = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(MonthDropdown, _super);
    function MonthDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function(monthNames) {
            return monthNames.map(function(m, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("option", {
                    key: m,
                    value: i
                }, m);
            });
        };
        _this.renderSelectMode = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("select", {
                value: _this.props.month,
                className: "react-datepicker__month-select",
                onChange: function(e) {
                    return _this.onChange(parseInt(e.target.value));
                }
            }, _this.renderSelectOptions(monthNames));
        };
        _this.renderReadView = function(visible, monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, monthNames[_this.props.month]));
        };
        _this.renderDropdown = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$MonthDropdownOptions, $f45070adf3eddf53$var$_assign({
                key: "dropdown"
            }, _this.props, {
                monthNames: monthNames,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function(monthNames) {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible, monthNames)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
            return result;
        };
        _this.onChange = function(month) {
            _this.toggleDropdown();
            if (month !== _this.props.month) _this.props.onChange(month);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthDropdown.prototype.render = function() {
        var _this = this;
        var monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? function(m) {
            return $f45070adf3eddf53$var$getMonthShortInLocale(m, _this.props.locale);
        } : function(m) {
            return $f45070adf3eddf53$var$getMonthInLocale(m, _this.props.locale);
        });
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case "select":
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthDropdown;
}((0, $cQmXV.Component));
function $f45070adf3eddf53$var$generateMonthYears(minDate, maxDate) {
    var list = [];
    var currDate = $f45070adf3eddf53$var$getStartOfMonth(minDate);
    var lastDate = $f45070adf3eddf53$var$getStartOfMonth(maxDate);
    while(!(0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(currDate, lastDate)){
        list.push($f45070adf3eddf53$var$newDate(currDate));
        currDate = (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(currDate, 1);
    }
    return list;
}
var $f45070adf3eddf53$var$MonthYearDropdownOptions = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(MonthYearDropdownOptions, _super);
    function MonthYearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function() {
            return _this.state.monthYearsList.map(function(monthYear) {
                var monthYearPoint = (0, $994a08207c4a21f1$export$2e2bcd8739ae039)(monthYear);
                var isSameMonthYear = $f45070adf3eddf53$var$isSameYear(_this.props.date, monthYear) && $f45070adf3eddf53$var$isSameMonth(_this.props.date, monthYear);
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                    key: monthYearPoint,
                    onClick: _this.onChange.bind(_this, monthYearPoint),
                    "aria-selected": isSameMonthYear ? "true" : undefined
                }, isSameMonthYear ? (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $f45070adf3eddf53$var$formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
            });
        };
        _this.onChange = function(monthYear) {
            return _this.props.onChange(monthYear);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.state = {
            monthYearsList: $f45070adf3eddf53$var$generateMonthYears(_this.props.minDate, _this.props.maxDate)
        };
        return _this;
    }
    MonthYearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $jYj5L.clsx)({
            "react-datepicker__month-year-dropdown": true,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$ClickOutsideWrapper, {
            className: dropdownClass,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$MonthYearDropdown = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(MonthYearDropdown, _super);
    function MonthYearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var currDate = $f45070adf3eddf53$var$getStartOfMonth(_this.props.minDate);
            var lastDate = $f45070adf3eddf53$var$getStartOfMonth(_this.props.maxDate);
            var options = [];
            while(!(0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(currDate, lastDate)){
                var timePoint = (0, $994a08207c4a21f1$export$2e2bcd8739ae039)(currDate);
                options.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("option", {
                    key: timePoint,
                    value: timePoint
                }, $f45070adf3eddf53$var$formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
                currDate = (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(currDate, 1);
            }
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("select", {
                value: (0, $994a08207c4a21f1$export$2e2bcd8739ae039)($f45070adf3eddf53$var$getStartOfMonth(_this.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            var yearMonth = $f45070adf3eddf53$var$formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, yearMonth));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$MonthYearDropdownOptions, $f45070adf3eddf53$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(monthYearPoint) {
            _this.toggleDropdown();
            var changedDate = $f45070adf3eddf53$var$newDate(monthYearPoint);
            if ($f45070adf3eddf53$var$isSameYear(_this.props.date, changedDate) && $f45070adf3eddf53$var$isSameMonth(_this.props.date, changedDate)) return;
            _this.props.onChange(changedDate);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthYearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthYearDropdown;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$Time = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null
        };
        _this.scrollToTheSelectedTime = function() {
            requestAnimationFrame(function() {
                var _a, _b, _c;
                if (!_this.list) return;
                _this.list.scrollTop = (_c = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a = _this.header) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
            });
        };
        _this.handleClick = function(time) {
            var _a, _b;
            if ((_this.props.minTime || _this.props.maxTime) && $f45070adf3eddf53$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $f45070adf3eddf53$var$isTimeDisabled(time, _this.props)) return;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, time);
        };
        _this.isSelectedTime = function(time) {
            return _this.props.selected && $f45070adf3eddf53$var$isSameMinute(_this.props.selected, time);
        };
        _this.isDisabledTime = function(time) {
            return (_this.props.minTime || _this.props.maxTime) && $f45070adf3eddf53$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $f45070adf3eddf53$var$isTimeDisabled(time, _this.props);
        };
        _this.liClasses = function(time) {
            var _a;
            var classes = [
                "react-datepicker__time-list-item",
                _this.props.timeClassName ? _this.props.timeClassName(time) : undefined
            ];
            if (_this.isSelectedTime(time)) classes.push("react-datepicker__time-list-item--selected");
            if (_this.isDisabledTime(time)) classes.push("react-datepicker__time-list-item--disabled");
            //convert this.props.intervals and the relevant time to seconds and check if it it's a clean multiple of the interval
            if (_this.props.injectTimes && ((0, $373f86827073914d$export$2e2bcd8739ae039)(time) * 3600 + (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(time) * 60 + (0, $f5b59a09917da604$export$2e2bcd8739ae039)(time)) % (((_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals) * 60) !== 0) classes.push("react-datepicker__time-list-item--injected");
            return classes.join(" ");
        };
        _this.handleOnKeyDown = function(event, time) {
            var _a, _b;
            if (event.key === $f45070adf3eddf53$var$KeyType.Space) {
                event.preventDefault();
                event.key = $f45070adf3eddf53$var$KeyType.Enter;
            }
            if ((event.key === $f45070adf3eddf53$var$KeyType.ArrowUp || event.key === $f45070adf3eddf53$var$KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
                event.preventDefault();
                event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
            }
            if ((event.key === $f45070adf3eddf53$var$KeyType.ArrowDown || event.key === $f45070adf3eddf53$var$KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
                event.preventDefault();
                event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
            }
            if (event.key === $f45070adf3eddf53$var$KeyType.Enter) _this.handleClick(time);
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.renderTimes = function() {
            var _a;
            var times = [];
            var format = typeof _this.props.format === "string" ? _this.props.format : "p";
            var intervals = (_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals;
            var activeDate = _this.props.selected || _this.props.openToDate || $f45070adf3eddf53$var$newDate();
            var base = $f45070adf3eddf53$var$getStartOfDay(activeDate);
            var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
            var minutesInDay = 60 * $f45070adf3eddf53$var$getHoursInDay(activeDate);
            var multiplier = minutesInDay / intervals;
            for(var i = 0; i < multiplier; i++){
                var currentTime = (0, $e31fea38bddb47f1$export$2e2bcd8739ae039)(base, i * intervals);
                times.push(currentTime);
                if (sortedInjectTimes) {
                    var timesToInject = $f45070adf3eddf53$var$timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
                    times = times.concat(timesToInject);
                }
            }
            // Determine which time to focus and scroll into view when component mounts
            var timeToFocus = times.reduce(function(prev, time) {
                if (time.getTime() <= activeDate.getTime()) return time;
                return prev;
            }, times[0]);
            return times.map(function(time) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                    key: time.valueOf(),
                    onClick: _this.handleClick.bind(_this, time),
                    className: _this.liClasses(time),
                    ref: function(li) {
                        if (time === timeToFocus) _this.centerLi = li;
                    },
                    onKeyDown: function(event) {
                        _this.handleOnKeyDown(event, time);
                    },
                    tabIndex: time === timeToFocus ? 0 : -1,
                    role: "option",
                    "aria-selected": _this.isSelectedTime(time) ? "true" : undefined,
                    "aria-disabled": _this.isDisabledTime(time) ? "true" : undefined
                }, $f45070adf3eddf53$var$formatDate(time, format, _this.props.locale));
            });
        };
        _this.renderTimeCaption = function() {
            if (_this.props.showTimeCaption === false) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null);
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function(header) {
                    _this.header = header;
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker-time__header"
            }, _this.props.timeCaption));
        };
        return _this;
    }
    Object.defineProperty(Time, "defaultProps", {
        get: function() {
            return {
                intervals: 30,
                todayButton: null,
                timeCaption: "Time",
                showTimeCaption: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Time.prototype.componentDidMount = function() {
        // code to ensure selected time will always be in focus within time window when it first appears
        this.scrollToTheSelectedTime();
        this.observeDatePickerHeightChanges();
    };
    Time.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
    };
    Time.prototype.observeDatePickerHeightChanges = function() {
        var _this = this;
        var monthRef = this.props.monthRef;
        this.updateContainerHeight();
        if (monthRef) {
            this.resizeObserver = new ResizeObserver(function() {
                _this.updateContainerHeight();
            });
            this.resizeObserver.observe(monthRef);
        }
    };
    Time.prototype.updateContainerHeight = function() {
        if (this.props.monthRef && this.header) this.setState({
            height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
    };
    Time.prototype.render = function() {
        var _this = this;
        var _a;
        var height = this.state.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__time-container ".concat(((_a = this.props.todayButton) !== null && _a !== void 0 ? _a : Time.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
        }, this.renderTimeCaption(), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__time"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__time-box"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function(list) {
                _this.list = list;
            },
            style: height ? {
                height: height
            } : {},
            role: "listbox",
            "aria-label": this.props.timeCaption
        }, this.renderTimes()))));
    };
    Time.calcCenterPosition = function(listHeight, centerLiRef) {
        return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
    };
    return Time;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$VERTICAL_NAVIGATION_OFFSET = 3;
/**
 * `Year` is a component that represents a year in a date picker.
 *
 * @class
 * @param {YearProps} props - The properties that define the `Year` component.
 * @property {VoidFunction} [props.clearSelectingDate] - Function to clear the selected date.
 * @property {Date} [props.date] - The currently selected date.
 * @property {boolean} [props.disabledKeyboardNavigation] - If true, keyboard navigation is disabled.
 * @property {Date} [props.endDate] - The end date in a range selection.
 * @property {(date: Date) => void} props.onDayClick - Function to handle day click events.
 * @property {Date} props.preSelection - The date that is currently in focus.
 * @property {(date: Date) => void} props.setPreSelection - Function to set the pre-selected date.
 * @property {{ [key: string]: any }} props.selected - The selected date(s).
 * @property {boolean} props.inline - If true, the date picker is displayed inline.
 * @property {Date} props.maxDate - The maximum selectable date.
 * @property {Date} props.minDate - The minimum selectable date.
 * @property {boolean} props.usePointerEvent - If true, pointer events are used instead of mouse events.
 * @property {(date: Date) => void} props.onYearMouseEnter - Function to handle mouse enter events on a year.
 * @property {(date: Date) => void} props.onYearMouseLeave - Function to handle mouse leave events on a year.
 */ var $f45070adf3eddf53$var$Year = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(Year, _super);
    function Year(props) {
        var _this = _super.call(this, props) || this;
        _this.YEAR_REFS = $f45070adf3eddf53$var$__spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
            return (0, $cQmXV.createRef)();
        });
        _this.isDisabled = function(date) {
            return $f45070adf3eddf53$var$isDayDisabled(date, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function(date) {
            return $f45070adf3eddf53$var$isDayExcluded(date, {
                excludeDates: _this.props.excludeDates
            });
        };
        _this.selectingDate = function() {
            var _a;
            return (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
        };
        _this.updateFocusOnPaginate = function(refIndex) {
            var waitForReRender = function() {
                var _a, _b;
                (_b = (_a = _this.YEAR_REFS[refIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 || _b.focus();
            };
            window.requestAnimationFrame(waitForReRender);
        };
        _this.handleYearClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleYearNavigation = function(newYear, newDate) {
            var _a, _b, _c, _d;
            var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
            if (date === undefined || yearItemNumber === undefined) return;
            var startPeriod = $f45070adf3eddf53$var$getYearsPeriod(date, yearItemNumber).startPeriod;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            if (newYear - startPeriod < 0) _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
            else if (newYear - startPeriod >= yearItemNumber) _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
            else (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.isSameDay = function(y, other) {
            return $f45070adf3eddf53$var$isSameDay(y, other);
        };
        _this.isCurrentYear = function(y) {
            return y === (0, $d3820647cfc034b1$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate());
        };
        _this.isRangeStart = function(y) {
            return _this.props.startDate && _this.props.endDate && $f45070adf3eddf53$var$isSameYear((0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), y), _this.props.startDate);
        };
        _this.isRangeEnd = function(y) {
            return _this.props.startDate && _this.props.endDate && $f45070adf3eddf53$var$isSameYear((0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), y), _this.props.endDate);
        };
        _this.isInRange = function(y) {
            return $f45070adf3eddf53$var$isYearInRange(y, _this.props.startDate, _this.props.endDate);
        };
        _this.isInSelectingRange = function(y) {
            var _a = _this.props, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectsRange = _a.selectsRange, startDate = _a.startDate, endDate = _a.endDate;
            if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) return false;
            if (selectsStart && endDate) return $f45070adf3eddf53$var$isYearInRange(y, _this.selectingDate(), endDate);
            if (selectsEnd && startDate) return $f45070adf3eddf53$var$isYearInRange(y, startDate, _this.selectingDate());
            if (selectsRange && startDate && !endDate) return $f45070adf3eddf53$var$isYearInRange(y, startDate, _this.selectingDate());
            return false;
        };
        _this.isSelectingRangeStart = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _year = (0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), y);
            if (selectsStart) return $f45070adf3eddf53$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $f45070adf3eddf53$var$isSameYear(_year, startDate !== null && startDate !== void 0 ? startDate : null);
        };
        _this.isSelectingRangeEnd = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _year = (0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), y);
            if (selectsEnd || selectsRange) return $f45070adf3eddf53$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $f45070adf3eddf53$var$isSameYear(_year, endDate !== null && endDate !== void 0 ? endDate : null);
        };
        _this.isKeyboardSelected = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.date === undefined || _this.props.preSelection == null) return;
            var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, selected = _a.selected;
            var date = $f45070adf3eddf53$var$getStartOfYear((0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)(_this.props.date, y));
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && $f45070adf3eddf53$var$isYearDisabled(y, _this.props);
            var isSelectedDay = !!selected && $f45070adf3eddf53$var$isSameDay(date, $f45070adf3eddf53$var$getStartOfYear(selected));
            var isKeyboardSelectedDay = $f45070adf3eddf53$var$isSameDay(date, $f45070adf3eddf53$var$getStartOfYear(_this.props.preSelection));
            return !_this.props.inline && !isSelectedDay && isKeyboardSelectedDay && !isDisabled;
        };
        _this.isSelectedYear = function(year) {
            var _a = _this.props, selectsMultiple = _a.selectsMultiple, selected = _a.selected, selectedDates = _a.selectedDates;
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return year === (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(date);
            });
            return !!selected && year === (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(selected);
        };
        _this.onYearClick = function(event, y) {
            var date = _this.props.date;
            if (date === undefined) return;
            _this.handleYearClick($f45070adf3eddf53$var$getStartOfYear((0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)(date, y)), event);
        };
        _this.onYearKeyDown = function(event, y) {
            var _a, _b;
            var key = event.key;
            var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
            if (key !== $f45070adf3eddf53$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!_this.props.disabledKeyboardNavigation) switch(key){
                case $f45070adf3eddf53$var$KeyType.Enter:
                    if (_this.props.selected == null) break;
                    _this.onYearClick(event, y);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $f45070adf3eddf53$var$KeyType.ArrowRight:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y + 1, (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(_this.props.preSelection, 1));
                    break;
                case $f45070adf3eddf53$var$KeyType.ArrowLeft:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y - 1, (0, $a2cd0767d0b3f015$export$2e2bcd8739ae039)(_this.props.preSelection, 1));
                    break;
                case $f45070adf3eddf53$var$KeyType.ArrowUp:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var startPeriod = $f45070adf3eddf53$var$getYearsPeriod(date, yearItemNumber).startPeriod;
                    var offset = $f45070adf3eddf53$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y - offset;
                    if (newYear < startPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y >= startPeriod && y < startPeriod + leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y - offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $a2cd0767d0b3f015$export$2e2bcd8739ae039)(_this.props.preSelection, offset));
                    break;
                case $f45070adf3eddf53$var$KeyType.ArrowDown:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var endPeriod = $f45070adf3eddf53$var$getYearsPeriod(date, yearItemNumber).endPeriod;
                    var offset = $f45070adf3eddf53$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y + offset;
                    if (newYear > endPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y <= endPeriod && y > endPeriod - leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y + offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(_this.props.preSelection, offset));
                    break;
            }
            handleOnKeyDown && handleOnKeyDown(event);
        };
        _this.getYearClassNames = function(y) {
            var _a = _this.props, date = _a.date, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, yearClassName = _a.yearClassName;
            return (0, $jYj5L.clsx)("react-datepicker__year-text", "react-datepicker__year-".concat(y), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName((0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)(date, y)) : undefined, {
                "react-datepicker__year-text--selected": _this.isSelectedYear(y),
                "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $f45070adf3eddf53$var$isYearDisabled(y, _this.props),
                "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
                "react-datepicker__year-text--range-start": _this.isRangeStart(y),
                "react-datepicker__year-text--range-end": _this.isRangeEnd(y),
                "react-datepicker__year-text--in-range": _this.isInRange(y),
                "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
                "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
                "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
                "react-datepicker__year-text--today": _this.isCurrentYear(y)
            });
        };
        _this.getYearTabIndex = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) return "-1";
            var preSelected = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.props.preSelection);
            var isPreSelectedYearDisabled = $f45070adf3eddf53$var$isYearDisabled(y, _this.props);
            return y === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
        };
        _this.getYearContent = function(y) {
            return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
        };
        return _this;
    }
    Year.prototype.render = function() {
        var _this = this;
        var yearsList = [];
        var _a = this.props, date = _a.date, yearItemNumber = _a.yearItemNumber, onYearMouseEnter = _a.onYearMouseEnter, onYearMouseLeave = _a.onYearMouseLeave;
        if (date === undefined) return null;
        var _b = $f45070adf3eddf53$var$getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
        var _loop_1 = function(y) {
            yearsList.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                ref: this_1.YEAR_REFS[y - startPeriod],
                onClick: function(event) {
                    _this.onYearClick(event, y);
                },
                onKeyDown: function(event) {
                    if ($f45070adf3eddf53$var$isSpaceKeyDown(event)) {
                        event.preventDefault();
                        event.key = $f45070adf3eddf53$var$KeyType.Enter;
                    }
                    _this.onYearKeyDown(event, y);
                },
                tabIndex: Number(this_1.getYearTabIndex(y)),
                className: this_1.getYearClassNames(y),
                onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onPointerEnter: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                onPointerLeave: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                key: y,
                "aria-current": this_1.isCurrentYear(y) ? "date" : undefined
            }, this_1.getYearContent(y)));
        };
        var this_1 = this;
        for(var y = startPeriod; y <= endPeriod; y++)_loop_1(y);
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__year"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__year-wrapper",
            onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : undefined
        }, yearsList));
    };
    return Year;
}((0, $cQmXV.Component));
function $f45070adf3eddf53$var$generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for(var i = 0; i < 2 * noOfYear + 1; i++){
        var newYear = year + noOfYear - i;
        var isInRange = true;
        if (minDate) isInRange = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(minDate) <= newYear;
        if (maxDate && isInRange) isInRange = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(maxDate) >= newYear;
        if (isInRange) list.push(newYear);
    }
    return list;
}
var $f45070adf3eddf53$var$YearDropdownOptions = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(YearDropdownOptions, _super);
    function YearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.yearOptionButtonsRef = {};
        _this.handleOptionKeyDown = function(year, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(year);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newYear = year + (e.key === "ArrowUp" ? 1 : -1);
                    // Add bounds checking to ensure the year exists in our refs
                    if (_this.yearOptionButtonsRef[newYear]) (_a = _this.yearOptionButtonsRef[newYear]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.yearOptionButtonsRef = {};
            var selectedYear = _this.props.year;
            var options = _this.state.yearsList.map(function(year) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    ref: function(el) {
                        _this.yearOptionButtonsRef[year] = el;
                        if (year === selectedYear) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: year,
                    onClick: _this.onChange.bind(_this, year),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, year),
                    "aria-selected": selectedYear === year ? "true" : undefined
                }, selectedYear === year ? (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", year);
            });
            var minYear = _this.props.minDate ? (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.props.minDate) : null;
            var maxYear = _this.props.maxDate ? (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.props.maxDate) : null;
            if (!maxYear || !_this.state.yearsList.find(function(year) {
                return year === maxYear;
            })) options.unshift((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "upcoming",
                onClick: _this.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
            if (!minYear || !_this.state.yearsList.find(function(year) {
                return year === minYear;
            })) options.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "previous",
                onClick: _this.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
            return options;
        };
        _this.onChange = function(year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.shiftYears = function(amount) {
            var years = _this.state.yearsList.map(function(year) {
                return year + amount;
            });
            _this.setState({
                yearsList: years
            });
        };
        _this.incrementYears = function() {
            return _this.shiftYears(1);
        };
        _this.decrementYears = function() {
            return _this.shiftYears(-1);
        };
        var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
        var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        _this.state = {
            yearsList: $f45070adf3eddf53$var$generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
        };
        _this.dropdownRef = (0, $cQmXV.createRef)();
        return _this;
    }
    YearDropdownOptions.prototype.componentDidMount = function() {
        var dropdownCurrent = this.dropdownRef.current;
        if (dropdownCurrent) {
            // Get array from HTMLCollection
            var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
            var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
                return childEl.ariaSelected;
            }) : null;
            dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
        }
    };
    YearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $jYj5L.clsx)({
            "react-datepicker__year-dropdown": true,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$ClickOutsideWrapper, {
            className: dropdownClass,
            containerRef: this.dropdownRef,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return YearDropdownOptions;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$YearDropdown = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(YearDropdown, _super);
    function YearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var minYear = _this.props.minDate ? (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.props.minDate) : 1900;
            var maxYear = _this.props.maxDate ? (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.props.maxDate) : 2100;
            var options = [];
            for(var i = minYear; i <= maxYear; i++)options.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("option", {
                key: i,
                value: i
            }, i));
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("select", {
                value: _this.props.year,
                className: "react-datepicker__year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, _this.props.year));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$YearDropdownOptions, $f45070adf3eddf53$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(year) {
            _this.toggleDropdown();
            if (year === _this.props.year) return;
            _this.props.onChange(year);
        };
        _this.toggleDropdown = function(event) {
            _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            }, function() {
                if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
            });
        };
        _this.handleYearChange = function(date, event) {
            var _a;
            (_a = _this.onSelect) === null || _a === void 0 || _a.call(_this, date, event);
            _this.setOpen();
        };
        _this.onSelect = function(date, event) {
            var _a, _b;
            (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, date, event);
        };
        _this.setOpen = function() {
            var _a, _b;
            (_b = (_a = _this.props).setOpen) === null || _b === void 0 || _b.call(_a, true);
        };
        return _this;
    }
    YearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return YearDropdown;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$DROPDOWN_FOCUS_CLASSNAMES = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
];
var $f45070adf3eddf53$var$OUTSIDE_CLICK_IGNORE_CLASS = "react-datepicker-ignore-onclickoutside";
var $f45070adf3eddf53$var$isDropdownSelect = function(element) {
    var classNames = (element.className || "").split(/\s+/);
    return $f45070adf3eddf53$var$DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
        return classNames.indexOf(testClassname) >= 0;
    });
};
var $f45070adf3eddf53$var$Calendar = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.monthContainer = undefined;
        _this.handleClickOutside = function(event) {
            _this.props.onClickOutside(event);
        };
        _this.setClickOutsideRef = function() {
            return _this.containerRef.current;
        };
        _this.handleDropdownFocus = function(event) {
            var _a, _b;
            if ($f45070adf3eddf53$var$isDropdownSelect(event.target)) (_b = (_a = _this.props).onDropdownFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.getDateInView = function() {
            var _a = _this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
            var minDate = $f45070adf3eddf53$var$getEffectiveMinDate(_this.props);
            var maxDate = $f45070adf3eddf53$var$getEffectiveMaxDate(_this.props);
            var current = $f45070adf3eddf53$var$newDate();
            var initialDate = openToDate || selected || preSelection;
            if (initialDate) return initialDate;
            else {
                if (minDate && (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(current, minDate)) return minDate;
                else if (maxDate && (0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(current, maxDate)) return maxDate;
            }
            return current;
        };
        _this.increaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.decreaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $9450df79fe1987af$export$2e2bcd8739ae039)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.handleDayClick = function(day, event, monthSelectedIn) {
            _this.props.onSelect(day, event, monthSelectedIn);
            _this.props.setPreSelection && _this.props.setPreSelection(day);
        };
        _this.handleDayMouseEnter = function(day) {
            _this.setState({
                selectingDate: day
            });
            _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
        };
        _this.handleMonthMouseLeave = function() {
            _this.setState({
                selectingDate: undefined
            });
            _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
        };
        _this.handleYearMouseEnter = function(event, year) {
            _this.setState({
                selectingDate: (0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)($f45070adf3eddf53$var$newDate(), year)
            });
            !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
        };
        _this.handleYearMouseLeave = function(event, year) {
            !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
        };
        _this.handleYearChange = function(date) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).onYearChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(date);
                (_d = (_c = _this.props).setOpen) === null || _d === void 0 || _d.call(_c, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(date);
        };
        _this.getEnabledPreSelectionDateForMonth = function(date) {
            if (!$f45070adf3eddf53$var$isDayDisabled(date, _this.props)) return date;
            var startOfMonth = $f45070adf3eddf53$var$getStartOfMonth(date);
            var endOfMonth = $f45070adf3eddf53$var$getEndOfMonth(date);
            var totalDays = (0, $7804a10fe760ec3b$export$2e2bcd8739ae039)(endOfMonth, startOfMonth);
            var preSelectedDate = null;
            for(var dayIdx = 0; dayIdx <= totalDays; dayIdx++){
                var processingDate = (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(startOfMonth, dayIdx);
                if (!$f45070adf3eddf53$var$isDayDisabled(processingDate, _this.props)) {
                    preSelectedDate = processingDate;
                    break;
                }
            }
            return preSelectedDate;
        };
        _this.handleMonthChange = function(date) {
            var _a, _b, _c;
            var enabledPreSelectionDate = (_a = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a !== void 0 ? _a : date;
            _this.handleCustomMonthChange(enabledPreSelectionDate);
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(enabledPreSelectionDate);
                (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
        };
        _this.handleCustomMonthChange = function(date) {
            var _a, _b;
            (_b = (_a = _this.props).onMonthChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
        };
        _this.handleMonthYearChange = function(date) {
            _this.handleYearChange(date);
            _this.handleMonthChange(date);
        };
        _this.changeYear = function(year) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)(date, Number(year))
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.changeMonth = function(month) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $0f0a320b378f0016$export$2e2bcd8739ae039)(date, Number(month))
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.changeMonthYear = function(monthYear) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $b7d4ce01e5e313b8$export$2e2bcd8739ae039)((0, $0f0a320b378f0016$export$2e2bcd8739ae039)(date, (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(monthYear)), (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(monthYear))
                };
            }, function() {
                return _this.handleMonthYearChange(_this.state.date);
            });
        };
        _this.header = function(date) {
            if (date === void 0) date = _this.state.date;
            // Return empty array if date is invalid
            if (!$f45070adf3eddf53$var$isValid(date)) return [];
            var disabled = _this.props.disabled;
            var startOfWeek = $f45070adf3eddf53$var$getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
            var dayNames = [];
            if (_this.props.showWeekNumbers) dayNames.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name ".concat(disabled ? "react-datepicker__day-name--disabled" : ""),
                role: "columnheader"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: "react-datepicker__sr-only"
            }, "Week number"), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                "aria-hidden": "true"
            }, _this.props.weekLabel || "#")));
            return dayNames.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(startOfWeek, offset);
                var weekDayName = _this.formatWeekday(day, _this.props.locale);
                var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : undefined;
                return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    key: offset,
                    role: "columnheader",
                    className: (0, $jYj5L.clsx)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "react-datepicker__sr-only"
                }, $f45070adf3eddf53$var$formatDate(day, "EEEE", _this.props.locale)), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    "aria-hidden": "true"
                }, weekDayName));
            }));
        };
        _this.formatWeekday = function(day, locale) {
            if (_this.props.formatWeekDay) return $f45070adf3eddf53$var$getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
            return _this.props.useWeekdaysShort ? $f45070adf3eddf53$var$getWeekdayShortInLocale(day, locale) : $f45070adf3eddf53$var$getWeekdayMinInLocale(day, locale);
        };
        _this.decreaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $a2cd0767d0b3f015$export$2e2bcd8739ae039)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.clearSelectingDate = function() {
            _this.setState({
                selectingDate: undefined
            });
        };
        _this.renderPreviousButton = function() {
            var _a, _b, _c;
            if (_this.props.renderCustomHeader) return;
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            var fromMonthDate = (0, $9450df79fe1987af$export$2e2bcd8739ae039)(_this.state.date, monthSelectedIn);
            var allPrevDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allPrevDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allPrevDaysDisabled = $f45070adf3eddf53$var$yearDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allPrevDaysDisabled = $f45070adf3eddf53$var$yearsDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allPrevDaysDisabled = $f45070adf3eddf53$var$quarterDisabledBefore(_this.state.date, _this.props);
                    break;
                default:
                    allPrevDaysDisabled = $f45070adf3eddf53$var$monthDisabledBefore(fromMonthDate, _this.props);
                    break;
            }
            if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--previous"
            ];
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--previous"
            ];
            var clickHandler = _this.decreaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.decreaseYear;
            if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--previous--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar.defaultProps.previousYearButtonLabel : _f;
            var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel));
        };
        _this.increaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderNextButton = function() {
            var _a;
            if (_this.props.renderCustomHeader) return;
            var allNextDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allNextDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allNextDaysDisabled = $f45070adf3eddf53$var$yearDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allNextDaysDisabled = $f45070adf3eddf53$var$yearsDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allNextDaysDisabled = $f45070adf3eddf53$var$quarterDisabledAfter(_this.state.date, _this.props);
                    break;
                default:
                    allNextDaysDisabled = $f45070adf3eddf53$var$monthDisabledAfter(_this.state.date, _this.props);
                    break;
            }
            if (!((_a = _this.props.forceShowMonthNavigation) !== null && _a !== void 0 ? _a : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--next"
            ];
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--next"
            ];
            if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
            if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
            var clickHandler = _this.increaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.increaseYear;
            if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--next--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar.defaultProps.nextYearButtonLabel : _d;
            var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel));
        };
        _this.renderCurrentMonth = function(date) {
            if (date === void 0) date = _this.state.date;
            var classes = [
                "react-datepicker__current-month"
            ];
            if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
            if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
            if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("h2", {
                className: classes.join(" ")
            }, $f45070adf3eddf53$var$isValid(date) ? $f45070adf3eddf53$var$formatDate(date, _this.props.dateFormat, _this.props.locale) : "");
        };
        _this.renderYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$YearDropdown, $f45070adf3eddf53$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeYear,
                year: (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.state.date)
            }));
        };
        _this.renderMonthDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$MonthDropdown, $f45070adf3eddf53$var$_assign({}, Calendar.defaultProps, _this.props, {
                month: (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(_this.state.date),
                onChange: _this.changeMonth
            }));
        };
        _this.renderMonthYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$MonthYearDropdown, $f45070adf3eddf53$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeMonthYear
            }));
        };
        _this.handleTodayButtonClick = function(event) {
            _this.props.onSelect($f45070adf3eddf53$var$getStartOfToday(), event);
            _this.props.setPreSelection && _this.props.setPreSelection($f45070adf3eddf53$var$getStartOfToday());
        };
        _this.renderTodayButton = function() {
            if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: _this.handleTodayButtonClick
            }, _this.props.todayButton);
        };
        _this.renderDayNamesHeader = function(monthDate) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__day-names",
                role: "row"
            }, _this.header(monthDate));
        };
        _this.renderDefaultHeader = function(_a) {
            var monthDate = _a.monthDate, i = _a.i;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__header ".concat(_this.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
            }, _this.renderCurrentMonth(monthDate), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
                onFocus: _this.handleDropdownFocus
            }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)));
        };
        _this.renderCustomHeader = function(headerArgs) {
            var _a, _b;
            var monthDate = headerArgs.monthDate, i = headerArgs.i;
            if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) return null;
            var _c = _this.props, showYearPicker = _c.showYearPicker, yearItemNumber = _c.yearItemNumber;
            var visibleYearsRange;
            if (showYearPicker) {
                var _d = $f45070adf3eddf53$var$getYearsPeriod(monthDate, yearItemNumber), startYear = _d.startPeriod, endYear = _d.endPeriod;
                visibleYearsRange = {
                    startYear: startYear,
                    endYear: endYear
                };
            }
            var prevMonthButtonDisabled = $f45070adf3eddf53$var$monthDisabledBefore(_this.state.date, _this.props);
            var nextMonthButtonDisabled = $f45070adf3eddf53$var$monthDisabledAfter(_this.state.date, _this.props);
            var prevYearButtonDisabled = $f45070adf3eddf53$var$yearDisabledBefore(_this.state.date, _this.props);
            var nextYearButtonDisabled = $f45070adf3eddf53$var$yearDisabledAfter(_this.state.date, _this.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: _this.props.onDropdownFocus
            }, (_b = (_a = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a, $f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign({}, _this.state), showYearPicker && {
                visibleYearsRange: visibleYearsRange
            }), {
                customHeaderCount: i,
                monthDate: monthDate,
                changeMonth: _this.changeMonth,
                changeYear: _this.changeYear,
                decreaseMonth: _this.decreaseMonth,
                increaseMonth: _this.increaseMonth,
                decreaseYear: _this.decreaseYear,
                increaseYear: _this.increaseYear,
                prevMonthButtonDisabled: prevMonthButtonDisabled,
                nextMonthButtonDisabled: nextMonthButtonDisabled,
                prevYearButtonDisabled: prevYearButtonDisabled,
                nextYearButtonDisabled: nextYearButtonDisabled
            })));
        };
        _this.renderYearHeader = function(_a) {
            var monthDate = _a.monthDate;
            var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? Calendar.defaultProps.yearItemNumber : _c;
            var _d = $f45070adf3eddf53$var$getYearsPeriod(monthDate, yearItemNumber), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(monthDate));
        };
        _this.renderHeader = function(_a) {
            var monthDate = _a.monthDate, _b = _a.i, i = _b === void 0 ? 0 : _b;
            var headerArgs = {
                monthDate: monthDate,
                i: i
            };
            switch(true){
                case _this.props.renderCustomHeader !== undefined:
                    return _this.renderCustomHeader(headerArgs);
                case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker:
                    return _this.renderYearHeader(headerArgs);
                default:
                    return _this.renderDefaultHeader(headerArgs);
            }
        };
        _this.renderMonths = function() {
            var _a, _b;
            if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) return;
            var monthList = [];
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(_this.state.date, monthsToSubtract) : (0, $9450df79fe1987af$export$2e2bcd8739ae039)(_this.state.date, monthsToSubtract);
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            for(var i = 0; i < monthsShown; ++i){
                var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
                var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(fromMonthDate, monthsToAdd) : (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(fromMonthDate, monthsToAdd);
                var monthKey = "month-".concat(i);
                var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
                var monthShowsDuplicateDaysStart = i > 0;
                monthList.push((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    key: monthKey,
                    ref: function(div) {
                        _this.monthContainer = div !== null && div !== void 0 ? div : undefined;
                    },
                    className: "react-datepicker__month-container"
                }, _this.renderHeader({
                    monthDate: monthDate,
                    i: i
                }), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Month, $f45070adf3eddf53$var$_assign({}, Calendar.defaultProps, _this.props, {
                    containerRef: _this.containerRef,
                    ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
                    day: monthDate,
                    onDayClick: _this.handleDayClick,
                    handleOnKeyDown: _this.props.handleOnDayKeyDown,
                    handleOnMonthKeyDown: _this.props.handleOnKeyDown,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onMouseLeave: _this.handleMonthMouseLeave,
                    orderInDisplay: i,
                    selectingDate: _this.state.selectingDate,
                    monthShowsDuplicateDaysEnd: monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: monthShowsDuplicateDaysStart,
                    dayNamesHeader: _this.renderDayNamesHeader(monthDate)
                }))));
            }
            return monthList;
        };
        _this.renderYears = function() {
            if (_this.props.showTimeSelectOnly) return;
            if (_this.props.showYearPicker) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__year--container"
            }, _this.renderHeader({
                monthDate: _this.state.date
            }), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Year, $f45070adf3eddf53$var$_assign({}, Calendar.defaultProps, _this.props, {
                selectingDate: _this.state.selectingDate,
                date: _this.state.date,
                onDayClick: _this.handleDayClick,
                clearSelectingDate: _this.clearSelectingDate,
                onYearMouseEnter: _this.handleYearMouseEnter,
                onYearMouseLeave: _this.handleYearMouseLeave
            })));
            return;
        };
        _this.renderTimeSection = function() {
            if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Time, $f45070adf3eddf53$var$_assign({}, Calendar.defaultProps, _this.props, {
                onChange: _this.props.onTimeChange,
                format: _this.props.timeFormat,
                intervals: _this.props.timeIntervals,
                monthRef: _this.state.monthContainer
            }));
            return;
        };
        _this.renderInputTimeSection = function() {
            var time = _this.props.selected ? new Date(_this.props.selected) : undefined;
            var timeValid = time && $f45070adf3eddf53$var$isValid(time) && Boolean(_this.props.selected);
            var timeString = timeValid ? "".concat($f45070adf3eddf53$var$addZero(time.getHours()), ":").concat($f45070adf3eddf53$var$addZero(time.getMinutes())) : "";
            if (_this.props.showTimeInput) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$InputTime, $f45070adf3eddf53$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: time,
                timeString: timeString,
                onChange: _this.props.onTimeChange
            }));
            return;
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            // Don't render aria-live message if date is invalid
            if (!$f45070adf3eddf53$var$isValid(_this.state.date)) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            });
            var _b = $f45070adf3eddf53$var$getYearsPeriod(_this.state.date, (_a = _this.props.yearItemNumber) !== null && _a !== void 0 ? _a : Calendar.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
            var ariaLiveMessage;
            if (_this.props.showYearPicker) ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
            else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) ariaLiveMessage = (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.state.date);
            else ariaLiveMessage = "".concat($f45070adf3eddf53$var$getMonthInLocale((0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(_this.state.date), _this.props.locale), " ").concat((0, $d3820647cfc034b1$export$2e2bcd8739ae039)(_this.state.date));
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
        };
        _this.renderChildren = function() {
            if (_this.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__children-container"
            }, _this.props.children);
            return;
        };
        _this.containerRef = (0, $cQmXV.createRef)();
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: undefined,
            monthContainer: undefined,
            isRenderAriaLiveMessage: false
        };
        return _this;
    }
    Object.defineProperty(Calendar, "defaultProps", {
        get: function() {
            return {
                monthsShown: 1,
                forceShowMonthNavigation: false,
                outsideClickIgnoreClass: $f45070adf3eddf53$var$OUTSIDE_CLICK_IGNORE_CLASS,
                timeCaption: "Time",
                previousYearButtonLabel: "Previous Year",
                nextYearButtonLabel: "Next Year",
                previousMonthButtonLabel: "Previous Month",
                nextMonthButtonLabel: "Next Month",
                yearItemNumber: $f45070adf3eddf53$var$DEFAULT_YEAR_ITEM_NUMBER
            };
        },
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.componentDidMount = function() {
        var _this = this;
        // monthContainer height is needed in time component
        // to determine the height for the ul in the time component
        // setState here so height is given after final component
        // layout is rendered
        if (this.props.showTimeSelect) this.assignMonthContainer = function() {
            _this.setState({
                monthContainer: _this.monthContainer
            });
        }();
    };
    Calendar.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.preSelection && $f45070adf3eddf53$var$isValid(this.props.preSelection) && (!$f45070adf3eddf53$var$isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
            var hasMonthChanged_1 = !$f45070adf3eddf53$var$isSameMonth(this.state.date, this.props.preSelection);
            this.setState({
                date: this.props.preSelection
            }, function() {
                return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
            });
        } else if (this.props.openToDate && !$f45070adf3eddf53$var$isSameDay(this.props.openToDate, prevProps.openToDate)) this.setState({
            date: this.props.openToDate
        });
    };
    Calendar.prototype.render = function() {
        var Container = this.props.container || $f45070adf3eddf53$export$946daa762919616e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$ClickOutsideWrapper, {
            onClickOutside: this.handleClickOutside,
            style: {
                display: "contents"
            },
            ignoreClass: this.props.outsideClickIgnoreClass
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            style: {
                display: "contents"
            },
            ref: this.containerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Container, {
            className: (0, $jYj5L.clsx)("react-datepicker", this.props.className, {
                "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showTime: this.props.showTimeSelect || this.props.showTimeInput,
            showTimeSelectOnly: this.props.showTimeSelectOnly,
            inline: this.props.inline
        }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
    };
    return Calendar;
}((0, $cQmXV.Component));
/**
 * `CalendarIcon` is a React component that renders an icon for a calendar.
 * The icon can be a string representing a CSS class, a React node, or a default SVG icon.
 *
 * @component
 * @prop  icon - The icon to be displayed. This can be a string representing a CSS class or a React node.
 * @prop  className - An optional string representing additional CSS classes to be applied to the icon.
 * @prop  onClick - An optional function to be called when the icon is clicked.
 *
 * @example
 * // To use a CSS class as the icon
 * <CalendarIcon icon="my-icon-class" onClick={myClickHandler} />
 *
 * @example
 * // To use a React node as the icon
 * <CalendarIcon icon={<MyIconComponent />} onClick={myClickHandler} />
 *
 * @returns  The `CalendarIcon` component.
 */ var $f45070adf3eddf53$var$CalendarIcon = function(_a) {
    var icon = _a.icon, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
    var defaultClass = "react-datepicker__calendar-icon";
    if (typeof icon === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("i", {
        className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
        "aria-hidden": "true",
        onClick: onClick
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(icon)) {
        // Because we are checking that typeof icon is string first, we can safely cast icon as React.ReactElement on types level and code level
        var iconElement_1 = icon;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(iconElement_1, {
            className: "".concat(iconElement_1.props.className || "", " ").concat(defaultClass, " ").concat(className),
            onClick: function(event) {
                if (typeof iconElement_1.props.onClick === "function") iconElement_1.props.onClick(event);
                if (typeof onClick === "function") onClick(event);
            }
        });
    }
    // Default SVG Icon
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("svg", {
        className: "".concat(defaultClass, " ").concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    }));
};
/**
 * `Portal` is a React component that allows you to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * @class
 * @param {PortalProps} props - The properties that define the `Portal` component.
 * @property {React.ReactNode} props.children - The children to be rendered into the `Portal`.
 * @property {string} props.portalId - The id of the DOM node into which the `Portal` will render.
 * @property {ShadowRoot} [props.portalHost] - The DOM node to host the `Portal`.
 */ var $f45070adf3eddf53$var$Portal = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalRoot = null;
        _this.el = document.createElement("div");
        return _this;
    }
    Portal.prototype.componentDidMount = function() {
        this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
        if (!this.portalRoot) {
            this.portalRoot = document.createElement("div");
            this.portalRoot.setAttribute("id", this.props.portalId);
            (this.props.portalHost || document.body).appendChild(this.portalRoot);
        }
        this.portalRoot.appendChild(this.el);
    };
    Portal.prototype.componentWillUnmount = function() {
        if (this.portalRoot) this.portalRoot.removeChild(this.el);
    };
    Portal.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).createPortal(this.props.children, this.el);
    };
    return Portal;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var $f45070adf3eddf53$var$focusableFilter = function(node) {
    if (node instanceof HTMLAnchorElement) return node.tabIndex !== -1;
    return !node.disabled && node.tabIndex !== -1;
};
/**
 * `TabLoop` is a React component that manages tabbing behavior for its children.
 *
 * TabLoop prevents the user from tabbing outside of the popper
 * It creates a tabindex loop so that "Tab" on the last element will focus the first element
 * and "Shift Tab" on the first element will focus the last element
 *
 * @component
 * @example
 * <TabLoop enableTabLoop={true}>
 *   <ChildComponent />
 * </TabLoop>
 *
 * @param props - The properties that define the `TabLoop` component.
 * @param props.children - The child components.
 * @param props.enableTabLoop - Whether to enable the tab loop.
 *
 * @returns The `TabLoop` component.
 */ var $f45070adf3eddf53$var$TabLoop = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(TabLoop, _super);
    function TabLoop(props) {
        var _this = _super.call(this, props) || this;
        /**
         * `getTabChildren` is a method of the `TabLoop` class that retrieves all tabbable children of the component.
         *
         * This method uses the `tabbable` library to find all tabbable elements within the `TabLoop` component.
         * It then filters out any elements that are not visible.
         *
         * @returns An array of all tabbable and visible children of the `TabLoop` component.
         */ _this.getTabChildren = function() {
            var _a;
            return Array.prototype.slice.call((_a = _this.tabLoopRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll($f45070adf3eddf53$var$focusableElementsSelector), 1, -1).filter($f45070adf3eddf53$var$focusableFilter);
        };
        _this.handleFocusStart = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
        };
        _this.handleFocusEnd = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
        };
        _this.tabLoopRef = (0, $cQmXV.createRef)();
        return _this;
    }
    TabLoop.prototype.render = function() {
        var _a;
        if (!((_a = this.props.enableTabLoop) !== null && _a !== void 0 ? _a : TabLoop.defaultProps.enableTabLoop)) return this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: 0,
            onFocus: this.handleFocusStart
        }), this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: 0,
            onFocus: this.handleFocusEnd
        }));
    };
    TabLoop.defaultProps = {
        enableTabLoop: true
    };
    return TabLoop;
}((0, $cQmXV.Component));
/**
 * `withFloating` is a higher-order component that adds floating behavior to a component.
 *
 * @param Component - The component to enhance.
 *
 * @example
 * const FloatingComponent = withFloating(MyComponent);
 * <FloatingComponent popperModifiers={[]} popperProps={{}} hidePopper={true} />
 *
 * @param popperModifiers - The modifiers to use for the popper.
 * @param popperProps - The props to pass to the popper.
 * @param hidePopper - Whether to hide the popper.
 * @param popperPlacement - The placement of the popper.
 *
 * @returns A new component with floating behavior.
 */ function $f45070adf3eddf53$var$withFloating(Component) {
    function WithFloating(props) {
        var _a;
        var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
        var arrowRef = (0, $cQmXV.useRef)(null);
        var floatingProps = (0, $b4dc2c56860261c6$export$4e02a5c1d08bac65)($f45070adf3eddf53$var$_assign({
            open: !hidePopper,
            whileElementsMounted: (0, $ac9032e133ae40c9$export$deee3a793edee05f),
            placement: props.popperPlacement,
            middleware: $f45070adf3eddf53$var$__spreadArray([
                (0, $c729ef3ccf3d54b8$export$8a83211c878a3f1f)({
                    padding: 15
                }),
                (0, $c729ef3ccf3d54b8$export$cc800923e997bb8)(10),
                // eslint-disable-next-line react-hooks/refs -- Floating UI requires refs to be passed during render
                (0, $c729ef3ccf3d54b8$export$f2120bbfa5450bd2)({
                    element: arrowRef
                })
            ], (_a = props.popperModifiers) !== null && _a !== void 0 ? _a : [], true)
        }, props.popperProps));
        var componentProps = $f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign({}, props), {
            hidePopper: hidePopper,
            popperProps: $f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign({}, floatingProps), {
                arrowRef: arrowRef
            })
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Component, $f45070adf3eddf53$var$_assign({}, componentProps));
    }
    WithFloating.displayName = "withFloating(".concat(Component.displayName || Component.name || "Component", ")");
    return WithFloating;
}
// Exported for testing purposes
var $f45070adf3eddf53$var$PopperComponent$1 = function(props) {
    var className = props.className, wrapperClassName = props.wrapperClassName, _a = props.hidePopper, hidePopper = _a === void 0 ? true : _a, popperComponent = props.popperComponent, targetComponent = props.targetComponent, enableTabLoop = props.enableTabLoop, popperOnKeyDown = props.popperOnKeyDown, portalId = props.portalId, portalHost = props.portalHost, popperProps = props.popperProps, showArrow = props.showArrow;
    var popper = undefined;
    if (!hidePopper) {
        var classes = (0, $jYj5L.clsx)("react-datepicker-popper", className);
        popper = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$TabLoop, {
            enableTabLoop: enableTabLoop
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            ref: popperProps.refs.setFloating,
            style: popperProps.floatingStyles,
            className: classes,
            "data-placement": popperProps.placement,
            onKeyDown: popperOnKeyDown
        }, popperComponent, showArrow && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b4dc2c56860261c6$export$33511391554732bc), {
            ref: popperProps.arrowRef,
            context: popperProps.context,
            fill: "currentColor",
            strokeWidth: 1,
            height: 8,
            width: 16,
            style: {
                transform: "translateY(-1px)"
            },
            className: "react-datepicker__triangle"
        })));
    }
    if (props.popperContainer) popper = (0, $cQmXV.createElement)(props.popperContainer, {}, popper);
    if (portalId && !hidePopper) popper = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Portal, {
        portalId: portalId,
        portalHost: portalHost
    }, popper);
    var wrapperClasses = (0, $jYj5L.clsx)("react-datepicker-wrapper", wrapperClassName);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ref: popperProps.refs.setReference,
        className: wrapperClasses
    }, targetComponent), popper);
};
var $f45070adf3eddf53$var$PopperComponent = $f45070adf3eddf53$var$withFloating($f45070adf3eddf53$var$PopperComponent$1);
// Compares dates year+month combinations
function $f45070adf3eddf53$var$hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) return (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(date1) !== (0, $e9c247d1af5f4312$export$2e2bcd8739ae039)(date2) || (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(date1) !== (0, $d3820647cfc034b1$export$2e2bcd8739ae039)(date2);
    return date1 !== date2;
}
/**
 * General datepicker component.
 */ var $f45070adf3eddf53$var$INPUT_ERR_1 = "Date input not valid.";
var $f45070adf3eddf53$export$5109c6dd95d8fb00 = /** @class */ function(_super) {
    $f45070adf3eddf53$var$__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.calendar = null;
        _this.input = null;
        _this.getPreSelection = function() {
            return _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : $f45070adf3eddf53$var$newDate();
        };
        // Convert the date from string format to standard Date format
        _this.modifyHolidays = function() {
            var _a;
            return (_a = _this.props.holidays) === null || _a === void 0 ? void 0 : _a.reduce(function(accumulator, holiday) {
                var date = new Date(holiday.date);
                if (!$f45070adf3eddf53$var$isValid(date)) return accumulator;
                return $f45070adf3eddf53$var$__spreadArray($f45070adf3eddf53$var$__spreadArray([], accumulator, true), [
                    $f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign({}, holiday), {
                        date: date
                    })
                ], false);
            }, []);
        };
        _this.calcInitialState = function() {
            var _a;
            var defaultPreSelection = _this.getPreSelection();
            var minDate = $f45070adf3eddf53$var$getEffectiveMinDate(_this.props);
            var maxDate = $f45070adf3eddf53$var$getEffectiveMaxDate(_this.props);
            var boundedPreSelection = minDate && (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(defaultPreSelection, $f45070adf3eddf53$var$getStartOfDay(minDate)) ? minDate : maxDate && (0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(defaultPreSelection, $f45070adf3eddf53$var$getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
            return {
                open: _this.props.startOpen || false,
                preventFocus: false,
                inputValue: null,
                preSelection: (_a = _this.props.selectsRange ? _this.props.startDate : _this.props.selected) !== null && _a !== void 0 ? _a : boundedPreSelection,
                // transforming highlighted days (perhaps nested array)
                // to flat Map for faster access in day.jsx
                highlightDates: $f45070adf3eddf53$var$getHighLightDaysMap(_this.props.highlightDates),
                focused: false,
                // used to focus day in inline version after month has changed, but not on
                // initial render
                shouldFocusDayInline: false,
                isRenderAriaLiveMessage: false,
                wasHidden: false
            };
        };
        _this.getInputValue = function() {
            var _a;
            var _b = _this.props, locale = _b.locale, startDate = _b.startDate, endDate = _b.endDate, rangeSeparator = _b.rangeSeparator, selected = _b.selected, selectedDates = _b.selectedDates, selectsMultiple = _b.selectsMultiple, selectsRange = _b.selectsRange, value = _b.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var inputValue = _this.state.inputValue;
            if (typeof value === "string") return value;
            else if (typeof inputValue === "string") return inputValue;
            else if (selectsRange) return $f45070adf3eddf53$var$safeDateRangeFormat(startDate, endDate, {
                dateFormat: dateFormat,
                locale: locale,
                rangeSeparator: rangeSeparator
            });
            else if (selectsMultiple) return $f45070adf3eddf53$var$safeMultipleDatesFormat(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], {
                dateFormat: dateFormat,
                locale: locale
            });
            return $f45070adf3eddf53$var$safeDateFormat(selected, {
                dateFormat: dateFormat,
                locale: locale
            });
        };
        _this.resetHiddenStatus = function() {
            _this.setState($f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign({}, _this.state), {
                wasHidden: false
            }));
        };
        _this.setHiddenStatus = function() {
            _this.setState($f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign({}, _this.state), {
                wasHidden: true
            }));
        };
        _this.setHiddenStateOnVisibilityHidden = function() {
            if (document.visibilityState !== "hidden") return;
            _this.setHiddenStatus();
        };
        _this.clearPreventFocusTimeout = function() {
            if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
        };
        _this.setFocus = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a, {
                preventScroll: true
            });
        };
        _this.setBlur = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 || _b.call(_a);
            _this.cancelFocusInput();
        };
        _this.deferBlur = function() {
            requestAnimationFrame(function() {
                _this.setBlur();
            });
        };
        _this.setOpen = function(open, skipSetBlur) {
            if (skipSetBlur === void 0) skipSetBlur = false;
            _this.setState({
                open: open,
                preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
                lastPreSelectChange: $f45070adf3eddf53$var$PRESELECT_CHANGE_VIA_NAVIGATE
            }, function() {
                if (!open) _this.setState(function(prev) {
                    return {
                        focused: skipSetBlur ? prev.focused : false
                    };
                }, function() {
                    !skipSetBlur && _this.deferBlur();
                    _this.setState({
                        inputValue: null
                    });
                });
            });
        };
        _this.inputOk = function() {
            return (0, $6bf94078b78e666b$export$2e2bcd8739ae039)(_this.state.preSelection);
        };
        _this.isCalendarOpen = function() {
            return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
        };
        _this.handleFocus = function(event) {
            var _a, _b;
            var isAutoReFocus = _this.state.wasHidden;
            var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
            if (isAutoReFocus) _this.resetHiddenStatus();
            if (!_this.state.preventFocus) {
                (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, event);
                if (isOpenAllowed && !_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
            }
            _this.setState({
                focused: true
            });
        };
        _this.sendFocusBackToInput = function() {
            // Clear previous timeout if it exists
            if (_this.preventFocusTimeout) _this.clearPreventFocusTimeout();
            // close the popper and refocus the input
            // stop the input from auto opening onFocus
            // setFocus to the input
            _this.setState({
                preventFocus: true
            }, function() {
                _this.preventFocusTimeout = setTimeout(function() {
                    _this.setFocus();
                    _this.setState({
                        preventFocus: false
                    });
                });
            });
        };
        _this.cancelFocusInput = function() {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = undefined;
        };
        _this.deferFocusInput = function() {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = setTimeout(function() {
                return _this.setFocus();
            }, 1);
        };
        _this.handleDropdownFocus = function() {
            _this.cancelFocusInput();
        };
        _this.resetInputValue = function() {
            _this.setState($f45070adf3eddf53$var$_assign($f45070adf3eddf53$var$_assign({}, _this.state), {
                inputValue: null
            }));
        };
        _this.handleBlur = function(event) {
            var _a, _b;
            if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, event);
            _this.resetInputValue();
            if (_this.state.open && _this.props.open === false) _this.setOpen(false);
            _this.setState({
                focused: false
            });
        };
        _this.handleCalendarClickOutside = function(event) {
            var _a, _b;
            if (!_this.props.inline) _this.setOpen(false);
            (_b = (_a = _this.props).onClickOutside) === null || _b === void 0 || _b.call(_a, event);
            if (_this.props.withPortal) event.preventDefault();
        };
        // handleChange is called when user types in the textbox
        _this.handleChange = function() {
            var _a, _b, _c, _d, _e;
            var allArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)allArgs[_i] = arguments[_i];
            var event = allArgs[0];
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw.apply(_this, allArgs);
                if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
            }
            _this.setState({
                inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
                lastPreSelectChange: $f45070adf3eddf53$var$PRESELECT_CHANGE_VIA_INPUT
            });
            var _f = _this.props, selectsRange = _f.selectsRange, startDate = _f.startDate, endDate = _f.endDate;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var strictParsing = (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.strictParsing;
            var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
            if (selectsRange) {
                var rangeSeparator = _this.props.rangeSeparator;
                var trimmedRangeSeparator = rangeSeparator.trim();
                var _g = value.split(dateFormat.includes(trimmedRangeSeparator) ? rangeSeparator : trimmedRangeSeparator, 2).map(function(val) {
                    return val.trim();
                }), valueStart = _g[0], valueEnd = _g[1];
                var startDateNew = $f45070adf3eddf53$var$parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
                var endDateNew = startDateNew ? $f45070adf3eddf53$var$parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing) : null;
                var startChanged = (startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
                var endChanged = (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
                if (!startChanged && !endChanged) return;
                if (startDateNew && $f45070adf3eddf53$var$isDayDisabled(startDateNew, _this.props)) return;
                if (endDateNew && $f45070adf3eddf53$var$isDayDisabled(endDateNew, _this.props)) return;
                (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, [
                    startDateNew,
                    endDateNew
                ], event);
            } else {
                // not selectsRange
                var date = $f45070adf3eddf53$var$parseDate(value, dateFormat, _this.props.locale, strictParsing, (_e = _this.props.selected) !== null && _e !== void 0 ? _e : undefined);
                // Update selection if either (1) date was successfully parsed, or (2) input field is empty
                if (date || !value) _this.setSelected(date, event, true);
            }
        };
        _this.handleSelect = function(date, event, monthSelectedIn) {
            var _a;
            if (_this.props.readOnly) return;
            var _b = _this.props, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate, locale = _b.locale, swapRange = _b.swapRange;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isDateSelectionComplete = !selectsRange || startDate && !endDate && (swapRange || !$f45070adf3eddf53$var$isDateBefore(date, startDate));
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect && isDateSelectionComplete) // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.sendFocusBackToInput();
            if (_this.props.onChangeRaw) {
                var formattedDate = $f45070adf3eddf53$var$safeDateFormat(date, {
                    dateFormat: dateFormat,
                    locale: locale
                });
                _this.props.onChangeRaw(event, {
                    date: date,
                    formattedDate: formattedDate
                });
            }
            _this.setSelected(date, event, false, monthSelectedIn);
            if (_this.props.showDateSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
            else if (isDateSelectionComplete) _this.setOpen(false);
        };
        // setSelected is called either from handleChange (user typed date into textbox and it was parsed) or handleSelect (user selected date from calendar using mouse or keyboard)
        _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
            var _a, _b;
            var changedDate = date;
            // Early return if selected year/month/day is disabled
            if (_this.props.showYearPicker) {
                if (changedDate !== null && $f45070adf3eddf53$var$isYearDisabled((0, $d3820647cfc034b1$export$2e2bcd8739ae039)(changedDate), _this.props)) return;
            } else if (_this.props.showMonthYearPicker) {
                if (changedDate !== null && $f45070adf3eddf53$var$isMonthDisabled(changedDate, _this.props)) return;
            } else {
                if (changedDate !== null && $f45070adf3eddf53$var$isDayDisabled(changedDate, _this.props)) return;
            }
            var _c = _this.props, onChange = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
            if (!$f45070adf3eddf53$var$isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
                if (changedDate !== null) {
                    // Preserve previously selected time if only date is currently being changed
                    if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) changedDate = $f45070adf3eddf53$var$setTime(changedDate, {
                        hour: (0, $373f86827073914d$export$2e2bcd8739ae039)(_this.props.selected),
                        minute: (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(_this.props.selected),
                        second: (0, $f5b59a09917da604$export$2e2bcd8739ae039)(_this.props.selected)
                    });
                    // If minTime is present then set the time to minTime
                    if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
                        if (minTime) changedDate = $f45070adf3eddf53$var$setTime(changedDate, {
                            hour: minTime.getHours(),
                            minute: minTime.getMinutes(),
                            second: minTime.getSeconds()
                        });
                    }
                    if (!_this.props.inline) _this.setState({
                        preSelection: changedDate
                    });
                    if (!_this.props.focusSelectedMonth) _this.setState({
                        monthSelectedIn: monthSelectedIn
                    });
                }
                if (selectsRange) {
                    var noRanges = !startDate && !endDate;
                    var hasStartRange = startDate && !endDate;
                    var hasOnlyEndRange = !startDate && !!endDate;
                    var isRangeFilled = startDate && endDate;
                    if (noRanges) onChange === null || onChange === void 0 || onChange([
                        changedDate,
                        null
                    ], event);
                    else if (hasStartRange) {
                        if (changedDate === null) onChange === null || onChange === void 0 || onChange([
                            null,
                            null
                        ], event);
                        else if ($f45070adf3eddf53$var$isDateBefore(changedDate, startDate)) {
                            if (swapRange) onChange === null || onChange === void 0 || onChange([
                                changedDate,
                                startDate
                            ], event);
                            else onChange === null || onChange === void 0 || onChange([
                                changedDate,
                                null
                            ], event);
                        } else onChange === null || onChange === void 0 || onChange([
                            startDate,
                            changedDate
                        ], event);
                    } else if (hasOnlyEndRange) {
                        if (changedDate && $f45070adf3eddf53$var$isDateBefore(changedDate, endDate)) onChange === null || onChange === void 0 || onChange([
                            changedDate,
                            endDate
                        ], event);
                        else onChange === null || onChange === void 0 || onChange([
                            changedDate,
                            null
                        ], event);
                    }
                    if (isRangeFilled) onChange === null || onChange === void 0 || onChange([
                        changedDate,
                        null
                    ], event);
                } else if (selectsMultiple) {
                    if (changedDate !== null) {
                        if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) onChange === null || onChange === void 0 || onChange([
                            changedDate
                        ], event);
                        else {
                            var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
                                return $f45070adf3eddf53$var$isSameDay(selectedDate, changedDate);
                            });
                            if (isChangedDateAlreadySelected) {
                                var nextDates = selectedDates.filter(function(selectedDate) {
                                    return !$f45070adf3eddf53$var$isSameDay(selectedDate, changedDate);
                                });
                                onChange === null || onChange === void 0 || onChange(nextDates, event);
                            } else onChange === null || onChange === void 0 || onChange($f45070adf3eddf53$var$__spreadArray($f45070adf3eddf53$var$__spreadArray([], selectedDates, true), [
                                changedDate
                            ], false), event);
                        }
                    }
                } else onChange === null || onChange === void 0 || onChange(changedDate, event);
            }
            if (!keepInput) {
                (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, changedDate, event);
                _this.setState({
                    inputValue: null
                });
            }
        };
        // When checking preSelection via min/maxDate, times need to be manipulated via getStartOfDay/getEndOfDay
        _this.setPreSelection = function(date) {
            if (_this.props.readOnly) return;
            var hasMinDate = (0, $6bf94078b78e666b$export$2e2bcd8739ae039)(_this.props.minDate);
            var hasMaxDate = (0, $6bf94078b78e666b$export$2e2bcd8739ae039)(_this.props.maxDate);
            var isValidDateSelection = true;
            if (date) {
                var dateStartOfDay = $f45070adf3eddf53$var$getStartOfDay(date);
                if (hasMinDate && hasMaxDate) // isDayInRange uses getStartOfDay internally, so not necessary to manipulate times here
                isValidDateSelection = $f45070adf3eddf53$var$isDayInRange(date, _this.props.minDate, _this.props.maxDate);
                else if (hasMinDate) {
                    var minDateStartOfDay = $f45070adf3eddf53$var$getStartOfDay(_this.props.minDate);
                    isValidDateSelection = (0, $391444e1d96e3f3c$export$2e2bcd8739ae039)(date, minDateStartOfDay) || $f45070adf3eddf53$var$isEqual(dateStartOfDay, minDateStartOfDay);
                } else if (hasMaxDate) {
                    var maxDateEndOfDay = $f45070adf3eddf53$var$getEndOfDay(_this.props.maxDate);
                    isValidDateSelection = (0, $ae272f68d81c87cd$export$2e2bcd8739ae039)(date, maxDateEndOfDay) || $f45070adf3eddf53$var$isEqual(dateStartOfDay, maxDateEndOfDay);
                }
            }
            if (isValidDateSelection) _this.setState({
                preSelection: date
            });
        };
        _this.toggleCalendar = function() {
            _this.setOpen(!_this.state.open);
        };
        _this.handleTimeChange = function(time) {
            var _a, _b;
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? time : $f45070adf3eddf53$var$setTime(selected, {
                hour: (0, $373f86827073914d$export$2e2bcd8739ae039)(time),
                minute: (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(time)
            });
            _this.setState({
                preSelection: changedDate
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, changedDate);
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
            if (_this.props.showTimeInput) _this.setOpen(true);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            _this.setState({
                inputValue: null
            });
        };
        _this.onInputClick = function() {
            var _a, _b;
            if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
            (_b = (_a = _this.props).onInputClick) === null || _b === void 0 || _b.call(_a);
        };
        _this.handleTimeOnlyArrowKey = function(eventKey) {
            var _a, _b, _c, _d;
            var currentTime = _this.props.selected || _this.state.preSelection || $f45070adf3eddf53$var$newDate();
            var timeIntervals = (_a = _this.props.timeIntervals) !== null && _a !== void 0 ? _a : 30;
            var dateFormat = (_b = _this.props.dateFormat) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dateFormat;
            var formatStr = Array.isArray(dateFormat) ? dateFormat[0] : dateFormat;
            var baseDate = $f45070adf3eddf53$var$getStartOfDay(currentTime);
            var currentMinutes = (0, $373f86827073914d$export$2e2bcd8739ae039)(currentTime) * 60 + (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(currentTime);
            var maxMinutes = 1440 - timeIntervals; // Cap at last valid interval of the day
            var newTime;
            if (eventKey === $f45070adf3eddf53$var$KeyType.ArrowUp) {
                var newMinutes = Math.max(0, currentMinutes - timeIntervals);
                newTime = (0, $e31fea38bddb47f1$export$2e2bcd8739ae039)(baseDate, newMinutes);
            } else {
                var newMinutes = Math.min(maxMinutes, currentMinutes + timeIntervals);
                newTime = (0, $e31fea38bddb47f1$export$2e2bcd8739ae039)(baseDate, newMinutes);
            }
            var formattedTime = $f45070adf3eddf53$var$formatDate(newTime, formatStr || DatePicker.defaultProps.dateFormat, _this.props.locale);
            _this.setState({
                preSelection: newTime,
                inputValue: formattedTime
            });
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? newTime : $f45070adf3eddf53$var$setTime(selected, {
                hour: (0, $373f86827073914d$export$2e2bcd8739ae039)(newTime),
                minute: (0, $0c41b951b8dcebdb$export$2e2bcd8739ae039)(newTime)
            });
            (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, changedDate);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            requestAnimationFrame(function() {
                _this.scrollToTimeOption(newTime);
            });
        };
        _this.handleTimeOnlyEnterKey = function(event) {
            var _a, _b, _c, _d;
            var inputElement = event.target;
            var inputValue = inputElement.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var timeFormat = _this.props.timeFormat || "p";
            var defaultTime = _this.state.preSelection || _this.props.selected || $f45070adf3eddf53$var$newDate();
            var parsedDate = $f45070adf3eddf53$var$parseDate(inputValue, dateFormat, _this.props.locale, (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : false, defaultTime);
            var timeToCommit = defaultTime;
            if (parsedDate && $f45070adf3eddf53$var$isValid(parsedDate)) timeToCommit = parsedDate;
            else {
                var highlightedItem = ((_c = _this.calendar) === null || _c === void 0 ? void 0 : _c.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(".react-datepicker__time-list-item[tabindex='0']");
                if (highlightedItem instanceof HTMLElement) {
                    var itemText = (_d = highlightedItem.textContent) === null || _d === void 0 ? void 0 : _d.trim();
                    if (itemText) {
                        var itemTime = $f45070adf3eddf53$var$parseDate(itemText, timeFormat, _this.props.locale, false, defaultTime);
                        if (itemTime && $f45070adf3eddf53$var$isValid(itemTime)) timeToCommit = itemTime;
                    }
                }
            }
            _this.handleTimeChange(timeToCommit);
            _this.setOpen(false);
            _this.sendFocusBackToInput();
        };
        _this.scrollToTimeOption = function(time) {
            var _a, _b;
            if (!((_a = _this.calendar) === null || _a === void 0 ? void 0 : _a.containerRef.current)) return;
            var container = _this.calendar.containerRef.current;
            var timeListItems = Array.from(container.querySelectorAll(".react-datepicker__time-list-item"));
            var targetItem = null;
            var closestTimeDiff = Infinity;
            var timeFormat = _this.props.timeFormat || "p";
            for(var _i = 0, timeListItems_1 = timeListItems; _i < timeListItems_1.length; _i++){
                var item = timeListItems_1[_i];
                var itemText = (_b = item.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                if (itemText) {
                    var itemTime = $f45070adf3eddf53$var$parseDate(itemText, timeFormat, _this.props.locale, false, time);
                    if (itemTime && $f45070adf3eddf53$var$isValid(itemTime)) {
                        if ($f45070adf3eddf53$var$isSameMinute(itemTime, time)) {
                            targetItem = item;
                            break;
                        }
                        var timeDiff = Math.abs(itemTime.getTime() - time.getTime());
                        if (timeDiff < closestTimeDiff) {
                            closestTimeDiff = timeDiff;
                            targetItem = item;
                        }
                    }
                }
            }
            if (targetItem) {
                timeListItems.forEach(function(item) {
                    item.setAttribute("tabindex", "-1");
                });
                targetItem.setAttribute("tabindex", "0");
                targetItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        };
        _this.onInputKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            var eventKey = event.key;
            if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
                if (eventKey === $f45070adf3eddf53$var$KeyType.ArrowDown || eventKey === $f45070adf3eddf53$var$KeyType.ArrowUp || eventKey === $f45070adf3eddf53$var$KeyType.Enter) (_c = _this.onInputClick) === null || _c === void 0 || _c.call(_this);
                return;
            }
            if (_this.state.open && _this.props.showTimeSelectOnly) {
                if (eventKey === $f45070adf3eddf53$var$KeyType.ArrowDown || eventKey === $f45070adf3eddf53$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    _this.handleTimeOnlyArrowKey(eventKey);
                    return;
                }
                if (eventKey === $f45070adf3eddf53$var$KeyType.Enter) {
                    event.preventDefault();
                    _this.handleTimeOnlyEnterKey(event);
                    return;
                }
            }
            // if calendar is open, these keys will focus the selected item
            if (_this.state.open) {
                if (eventKey === $f45070adf3eddf53$var$KeyType.ArrowDown || eventKey === $f45070adf3eddf53$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
                    var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
                    selectedItem instanceof HTMLElement && selectedItem.focus({
                        preventScroll: true
                    });
                    return;
                }
                var copy = $f45070adf3eddf53$var$newDate(_this.state.preSelection);
                if (eventKey === $f45070adf3eddf53$var$KeyType.Enter) {
                    event.preventDefault();
                    event.target.blur();
                    if (_this.inputOk() && _this.state.lastPreSelectChange === $f45070adf3eddf53$var$PRESELECT_CHANGE_VIA_NAVIGATE) {
                        _this.handleSelect(copy, event);
                        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
                    } else _this.setOpen(false);
                } else if (eventKey === $f45070adf3eddf53$var$KeyType.Escape) {
                    event.preventDefault();
                    event.target.blur();
                    _this.sendFocusBackToInput();
                    _this.setOpen(false);
                } else if (eventKey === $f45070adf3eddf53$var$KeyType.Tab) _this.setOpen(false);
                if (!_this.inputOk()) (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $f45070adf3eddf53$var$INPUT_ERR_1
                });
            }
        };
        _this.onPortalKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $f45070adf3eddf53$var$KeyType.Escape) {
                event.preventDefault();
                _this.setState({
                    preventFocus: true
                }, function() {
                    _this.setOpen(false);
                    setTimeout(function() {
                        _this.setFocus();
                        _this.setState({
                            preventFocus: false
                        });
                    });
                });
            }
        };
        // keyDown events passed down to day.jsx
        _this.onDayKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            if (disabledKeyboardNavigation) return;
            var eventKey = event.key;
            var isShiftKeyActive = event.shiftKey;
            var copy = $f45070adf3eddf53$var$newDate(_this.state.preSelection);
            var calculateNewDate = function(eventKey, date) {
                var newCalculatedDate = date;
                switch(eventKey){
                    case $f45070adf3eddf53$var$KeyType.ArrowRight:
                        newCalculatedDate = showWeekPicker ? (0, $445df110012de010$export$2e2bcd8739ae039)(date, 1) : (0, $7673c17aa450eb5a$export$2e2bcd8739ae039)(date, 1);
                        break;
                    case $f45070adf3eddf53$var$KeyType.ArrowLeft:
                        newCalculatedDate = showWeekPicker ? (0, $431b62272382e5d5$export$2e2bcd8739ae039)(date, 1) : (0, $904a2da106dc6f87$export$2e2bcd8739ae039)(date, 1);
                        break;
                    case $f45070adf3eddf53$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $431b62272382e5d5$export$2e2bcd8739ae039)(date, 1);
                        break;
                    case $f45070adf3eddf53$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $445df110012de010$export$2e2bcd8739ae039)(date, 1);
                        break;
                    case $f45070adf3eddf53$var$KeyType.PageUp:
                        newCalculatedDate = isShiftKeyActive ? (0, $a2cd0767d0b3f015$export$2e2bcd8739ae039)(date, 1) : (0, $9450df79fe1987af$export$2e2bcd8739ae039)(date, 1);
                        break;
                    case $f45070adf3eddf53$var$KeyType.PageDown:
                        newCalculatedDate = isShiftKeyActive ? (0, $3be43e7bd0fc6a53$export$2e2bcd8739ae039)(date, 1) : (0, $7c9b1f48527a8c80$export$2e2bcd8739ae039)(date, 1);
                        break;
                    case $f45070adf3eddf53$var$KeyType.Home:
                        newCalculatedDate = $f45070adf3eddf53$var$getStartOfWeek(date, locale, calendarStartDay);
                        break;
                    case $f45070adf3eddf53$var$KeyType.End:
                        newCalculatedDate = $f45070adf3eddf53$var$getEndOfWeek(date);
                        break;
                }
                return newCalculatedDate;
            };
            var getNewDate = function(eventKey, date) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var newSelection = calculateNewDate(eventKey, date);
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newSelection = date;
                        break;
                    }
                    // if minDate exists and the new selection is before the min date, get the nearest date that isn't disabled
                    if (minDate && newSelection < minDate) {
                        eventKeyCopy = $f45070adf3eddf53$var$KeyType.ArrowRight;
                        newSelection = $f45070adf3eddf53$var$isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : minDate;
                    }
                    // if maxDate exists and the new selection is after the max date, get the nearest date that isn't disabled
                    if (maxDate && newSelection > maxDate) {
                        eventKeyCopy = $f45070adf3eddf53$var$KeyType.ArrowLeft;
                        newSelection = $f45070adf3eddf53$var$isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : maxDate;
                    }
                    if ($f45070adf3eddf53$var$isDayDisabled(newSelection, _this.props)) {
                        // if PageUp and Home is pressed to a disabled date, it will try to find the next available date after
                        if (eventKeyCopy === $f45070adf3eddf53$var$KeyType.PageUp || eventKeyCopy === $f45070adf3eddf53$var$KeyType.Home) eventKeyCopy = $f45070adf3eddf53$var$KeyType.ArrowRight;
                        // if PageDown and End is pressed to a disabled date, it will try to find the next available date before
                        if (eventKeyCopy === $f45070adf3eddf53$var$KeyType.PageDown || eventKeyCopy === $f45070adf3eddf53$var$KeyType.End) eventKeyCopy = $f45070adf3eddf53$var$KeyType.ArrowLeft;
                        newSelection = calculateNewDate(eventKeyCopy, newSelection);
                    } else validDateFound = true;
                    iterations++;
                }
                return newSelection;
            };
            if (eventKey === $f45070adf3eddf53$var$KeyType.Enter) {
                event.preventDefault();
                _this.handleSelect(copy, event);
                !shouldCloseOnSelect && _this.setPreSelection(copy);
                return;
            } else if (eventKey === $f45070adf3eddf53$var$KeyType.Escape) {
                event.preventDefault();
                _this.setOpen(false);
                if (!_this.inputOk()) (_d = (_c = _this.props).onInputError) === null || _d === void 0 || _d.call(_c, {
                    code: 1,
                    msg: $f45070adf3eddf53$var$INPUT_ERR_1
                });
                return;
            }
            var newSelection = null;
            switch(eventKey){
                case $f45070adf3eddf53$var$KeyType.ArrowLeft:
                case $f45070adf3eddf53$var$KeyType.ArrowRight:
                case $f45070adf3eddf53$var$KeyType.ArrowUp:
                case $f45070adf3eddf53$var$KeyType.ArrowDown:
                case $f45070adf3eddf53$var$KeyType.PageUp:
                case $f45070adf3eddf53$var$KeyType.PageDown:
                case $f45070adf3eddf53$var$KeyType.Home:
                case $f45070adf3eddf53$var$KeyType.End:
                    newSelection = getNewDate(eventKey, copy);
                    break;
            }
            if (!newSelection) {
                (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $f45070adf3eddf53$var$INPUT_ERR_1
                });
                return;
            }
            event.preventDefault();
            _this.setState({
                lastPreSelectChange: $f45070adf3eddf53$var$PRESELECT_CHANGE_VIA_NAVIGATE
            });
            if (adjustDateOnChange) _this.setSelected(newSelection);
            _this.setPreSelection(newSelection);
            // In inline mode, always set shouldFocusDayInline to true when navigating via keyboard.
            // This ensures focus is properly transferred to the new day element regardless of
            // whether the month changed. The user initiated this navigation from a focused day,
            // so we should always focus the destination day.
            if (inline) _this.setState({
                shouldFocusDayInline: true
            });
        };
        // handle generic key down events in the popper that do not adjust or select dates
        // ex: while focusing prev and next month buttons
        _this.onPopperKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $f45070adf3eddf53$var$KeyType.Escape) {
                event.preventDefault();
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
        };
        _this.onClearClick = function(event) {
            if (event) {
                if (event.preventDefault) event.preventDefault();
            }
            _this.sendFocusBackToInput();
            var _a = _this.props, selectsRange = _a.selectsRange, onChange = _a.onChange;
            if (selectsRange) onChange === null || onChange === void 0 || onChange([
                null,
                null
            ], event);
            else onChange === null || onChange === void 0 || onChange(null, event);
            _this.setState({
                inputValue: null
            });
        };
        _this.clear = function() {
            _this.onClearClick();
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
                if (event.target === document || event.target === document.documentElement || event.target === document.body) _this.setOpen(false);
            } else if (typeof _this.props.closeOnScroll === "function") {
                if (_this.props.closeOnScroll(event)) _this.setOpen(false);
            }
        };
        _this.renderCalendar = function() {
            var _a, _b;
            if (!_this.props.inline && !_this.isCalendarOpen()) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Calendar, $f45070adf3eddf53$var$_assign({
                showMonthYearDropdown: undefined,
                ref: function(elem) {
                    _this.calendar = elem;
                }
            }, _this.props, _this.state, {
                setOpen: _this.setOpen,
                dateFormat: (_a = _this.props.dateFormatCalendar) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormatCalendar,
                onSelect: _this.handleSelect,
                onClickOutside: _this.handleCalendarClickOutside,
                holidays: $f45070adf3eddf53$var$getHolidaysMap(_this.modifyHolidays()),
                outsideClickIgnoreClass: _this.props.outsideClickIgnoreClass,
                onDropdownFocus: _this.handleDropdownFocus,
                onTimeChange: _this.handleTimeChange,
                className: _this.props.calendarClassName,
                container: _this.props.calendarContainer,
                handleOnKeyDown: _this.props.onKeyDown,
                handleOnDayKeyDown: _this.onDayKeyDown,
                setPreSelection: _this.setPreSelection,
                dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dropdownMode
            }), _this.props.children);
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            var locale = _this.props.locale;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
            var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
            var ariaLiveMessage;
            if (_this.props.selectsRange) ariaLiveMessage = "Selected start date: ".concat($f45070adf3eddf53$var$safeDateFormat(_this.props.startDate, {
                dateFormat: longDateFormat,
                locale: locale
            }), ". ").concat(_this.props.endDate ? "End date: " + $f45070adf3eddf53$var$safeDateFormat(_this.props.endDate, {
                dateFormat: longDateFormat,
                locale: locale
            }) : "");
            else {
                if (_this.props.showTimeSelectOnly) ariaLiveMessage = "Selected time: ".concat($f45070adf3eddf53$var$safeDateFormat(_this.props.selected, {
                    dateFormat: dateFormat,
                    locale: locale
                }));
                else if (_this.props.showYearPicker) ariaLiveMessage = "Selected year: ".concat($f45070adf3eddf53$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy",
                    locale: locale
                }));
                else if (_this.props.showMonthYearPicker) ariaLiveMessage = "Selected month: ".concat($f45070adf3eddf53$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: locale
                }));
                else if (_this.props.showQuarterYearPicker) ariaLiveMessage = "Selected quarter: ".concat($f45070adf3eddf53$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: locale
                }));
                else ariaLiveMessage = "Selected date: ".concat($f45070adf3eddf53$var$safeDateFormat(_this.props.selected, {
                    dateFormat: longDateFormat,
                    locale: locale
                }));
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, ariaLiveMessage);
        };
        _this.renderDateInput = function() {
            var _a, _b;
            var _c, _d, _e, _f;
            var className = (0, $jYj5L.clsx)(_this.props.className, (_a = {}, _a[_this.props.outsideClickIgnoreClass || DatePicker.defaultProps.outsideClickIgnoreClass] = _this.state.open, _a));
            var customInput = _this.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("input", {
                type: "text"
            });
            var customInputRef = _this.props.customInputRef || "ref";
            // Build aria props object, only including defined values to avoid
            // overwriting aria attributes that may be set on the custom input
            var ariaProps = {};
            var ariaDescribedBy = (_c = _this.props["aria-describedby"]) !== null && _c !== void 0 ? _c : _this.props.ariaDescribedBy;
            var ariaInvalid = (_d = _this.props["aria-invalid"]) !== null && _d !== void 0 ? _d : _this.props.ariaInvalid;
            var ariaLabelledBy = (_e = _this.props["aria-labelledby"]) !== null && _e !== void 0 ? _e : _this.props.ariaLabelledBy;
            var ariaRequired = (_f = _this.props["aria-required"]) !== null && _f !== void 0 ? _f : _this.props.ariaRequired;
            if (ariaDescribedBy != null) ariaProps["aria-describedby"] = ariaDescribedBy;
            if (ariaInvalid != null) ariaProps["aria-invalid"] = ariaInvalid;
            if (ariaLabelledBy != null) ariaProps["aria-labelledby"] = ariaLabelledBy;
            if (ariaRequired != null) ariaProps["aria-required"] = ariaRequired;
            return (0, $cQmXV.cloneElement)(customInput, $f45070adf3eddf53$var$_assign((_b = {}, _b[customInputRef] = function(input) {
                _this.input = input;
            }, _b.value = _this.getInputValue(), _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = (0, $jYj5L.clsx)(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b), ariaProps));
        };
        _this.renderClearButton = function() {
            var _a = _this.props, isClearable = _a.isClearable, disabled = _a.disabled, selected = _a.selected, startDate = _a.startDate, endDate = _a.endDate, clearButtonTitle = _a.clearButtonTitle, _b = _a.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a.selectedDates, readOnly = _a.readOnly;
            if (isClearable && !readOnly && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                type: "button",
                className: (0, $jYj5L.clsx)("react-datepicker__close-icon", clearButtonClassName, {
                    "react-datepicker__close-icon--disabled": disabled
                }),
                disabled: disabled,
                "aria-label": ariaLabelClose,
                onClick: _this.onClearClick,
                title: clearButtonTitle,
                tabIndex: -1
            });
            else return null;
        };
        _this.state = _this.calcInitialState();
        _this.preventFocusTimeout = undefined;
        return _this;
    }
    Object.defineProperty(DatePicker, "defaultProps", {
        get: function() {
            return {
                allowSameDay: false,
                dateFormat: "MM/dd/yyyy",
                dateFormatCalendar: "LLLL yyyy",
                disabled: false,
                disabledKeyboardNavigation: false,
                dropdownMode: "scroll",
                preventOpenOnFocus: false,
                monthsShown: 1,
                outsideClickIgnoreClass: $f45070adf3eddf53$var$OUTSIDE_CLICK_IGNORE_CLASS,
                readOnly: false,
                rangeSeparator: $f45070adf3eddf53$var$DATE_RANGE_SEPARATOR,
                withPortal: false,
                selectsDisabledDaysInRange: false,
                shouldCloseOnSelect: true,
                showTimeSelect: false,
                showTimeInput: false,
                showPreviousMonths: false,
                showMonthYearPicker: false,
                showFullMonthYearPicker: false,
                showTwoColumnMonthYearPicker: false,
                showFourColumnMonthYearPicker: false,
                showYearPicker: false,
                showQuarterYearPicker: false,
                showWeekPicker: false,
                strictParsing: false,
                swapRange: false,
                timeIntervals: 30,
                timeCaption: "Time",
                previousMonthAriaLabel: "Previous Month",
                previousMonthButtonLabel: "Previous Month",
                nextMonthAriaLabel: "Next Month",
                nextMonthButtonLabel: "Next Month",
                previousYearAriaLabel: "Previous Year",
                previousYearButtonLabel: "Previous Year",
                nextYearAriaLabel: "Next Year",
                nextYearButtonLabel: "Next Year",
                timeInputLabel: "Time",
                enableTabLoop: true,
                yearItemNumber: $f45070adf3eddf53$var$DEFAULT_YEAR_ITEM_NUMBER,
                focusSelectedMonth: false,
                showPopperArrow: true,
                excludeScrollbar: true,
                customTimeInput: null,
                calendarStartDay: undefined,
                toggleCalendarOnIconClick: false,
                usePointerEvent: false
            };
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.componentDidMount = function() {
        window.addEventListener("scroll", this.onScroll, true);
        document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d;
        if (prevProps.inline && $f45070adf3eddf53$var$hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
        if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) this.setState({
            monthSelectedIn: 0
        });
        if (this.props.selectsRange && this.state.monthSelectedIn !== 0) this.setState({
            monthSelectedIn: 0
        });
        if (prevProps.highlightDates !== this.props.highlightDates) this.setState({
            highlightDates: $f45070adf3eddf53$var$getHighLightDaysMap(this.props.highlightDates)
        });
        if (!prevState.focused && !$f45070adf3eddf53$var$isEqual(prevProps.selected, this.props.selected)) this.setState({
            inputValue: null
        });
        if (prevState.open !== this.state.open) {
            if (prevState.open === false && this.state.open === true) (_b = (_a = this.props).onCalendarOpen) === null || _b === void 0 || _b.call(_a);
            if (prevState.open === true && this.state.open === false) (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 || _d.call(_c);
        }
    };
    DatePicker.prototype.componentWillUnmount = function() {
        this.clearPreventFocusTimeout();
        window.removeEventListener("scroll", this.onScroll, true);
        document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.renderInputContainer = function() {
        var _a = this.props, showIcon = _a.showIcon, icon = _a.icon, calendarIconClassname = _a.calendarIconClassname, calendarIconClassName = _a.calendarIconClassName, toggleCalendarOnIconClick = _a.toggleCalendarOnIconClick;
        var open = this.state.open;
        if (calendarIconClassname) console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
        }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$CalendarIcon, $f45070adf3eddf53$var$_assign({
            icon: icon,
            className: (0, $jYj5L.clsx)(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside")
        }, toggleCalendarOnIconClick ? {
            onClick: this.toggleCalendar
        } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    };
    DatePicker.prototype.render = function() {
        var calendar = this.renderCalendar();
        if (this.props.inline) return calendar;
        if (this.props.withPortal) {
            var portalContainer = this.state.open ? (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$TabLoop, {
                enableTabLoop: this.props.enableTabLoop
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: "react-datepicker__portal",
                tabIndex: -1,
                onKeyDown: this.onPortalKeyDown
            }, calendar)) : null;
            if (this.state.open && this.props.portalId) portalContainer = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$Portal, $f45070adf3eddf53$var$_assign({
                portalId: this.props.portalId
            }, this.props), portalContainer);
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", null, this.renderInputContainer(), portalContainer);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($f45070adf3eddf53$var$PopperComponent, $f45070adf3eddf53$var$_assign({}, this.props, {
            className: this.props.popperClassName,
            hidePopper: !this.isCalendarOpen(),
            targetComponent: this.renderInputContainer(),
            popperComponent: calendar,
            popperOnKeyDown: this.onPopperKeyDown,
            showArrow: this.props.showPopperArrow
        }));
    };
    return DatePicker;
}((0, $cQmXV.Component));
var $f45070adf3eddf53$var$PRESELECT_CHANGE_VIA_INPUT = "input";
var $f45070adf3eddf53$var$PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


function $0360a903a093e47c$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $0360a903a093e47c$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $0360a903a093e47c$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $0360a903a093e47c$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $0360a903a093e47c$var$declension(scheme.past, count);
                else return $0360a903a093e47c$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $0360a903a093e47c$var$declension(scheme.regular, count);
    };
}
var $0360a903a093e47c$var$halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var $0360a903a093e47c$var$formatDistanceLocale = {
    lessThanXSeconds: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $0360a903a093e47c$var$halfAtMinute,
    lessThanXMinutes: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $0360a903a093e47c$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var $0360a903a093e47c$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $0360a903a093e47c$var$formatDistanceLocale[token](count, options);
};
var $0360a903a093e47c$export$2e2bcd8739ae039 = $0360a903a093e47c$var$formatDistance;



var $d8b40c99144aabfe$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: "dd.MM.y"
};
var $d8b40c99144aabfe$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $d8b40c99144aabfe$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d8b40c99144aabfe$var$formatLong = {
    date: (0, $6261bd4ca8ae4123$export$2e2bcd8739ae039)({
        formats: $d8b40c99144aabfe$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6261bd4ca8ae4123$export$2e2bcd8739ae039)({
        formats: $d8b40c99144aabfe$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6261bd4ca8ae4123$export$2e2bcd8739ae039)({
        formats: $d8b40c99144aabfe$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d8b40c99144aabfe$export$2e2bcd8739ae039 = $d8b40c99144aabfe$var$formatLong;





function $41fdeb041a14c4a6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfWeek = (0, $9e846820c0405309$export$2e2bcd8739ae039)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $9e846820c0405309$export$2e2bcd8739ae039)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}


var $b83bbff865ac5bfb$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $b83bbff865ac5bfb$var$lastWeek(day) {
    var weekday = $b83bbff865ac5bfb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $b83bbff865ac5bfb$var$thisWeek(day) {
    var weekday = $b83bbff865ac5bfb$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $b83bbff865ac5bfb$var$nextWeek(day) {
    var weekday = $b83bbff865ac5bfb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var $b83bbff865ac5bfb$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $41fdeb041a14c4a6$export$2e2bcd8739ae039)(date, baseDate, options)) return $b83bbff865ac5bfb$var$thisWeek(day);
    else return $b83bbff865ac5bfb$var$lastWeek(day);
};
var $b83bbff865ac5bfb$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $41fdeb041a14c4a6$export$2e2bcd8739ae039)(date, baseDate, options)) return $b83bbff865ac5bfb$var$thisWeek(day);
    else return $b83bbff865ac5bfb$var$nextWeek(day);
};
var $b83bbff865ac5bfb$var$formatRelativeLocale = {
    lastWeek: $b83bbff865ac5bfb$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $b83bbff865ac5bfb$var$nextWeekFormat,
    other: "P"
};
var $b83bbff865ac5bfb$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $b83bbff865ac5bfb$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $b83bbff865ac5bfb$export$2e2bcd8739ae039 = $b83bbff865ac5bfb$var$formatRelative;



var $6d52c39fbf87b1f9$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var $6d52c39fbf87b1f9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $6d52c39fbf87b1f9$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var $6d52c39fbf87b1f9$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var $6d52c39fbf87b1f9$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $6d52c39fbf87b1f9$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var $6d52c39fbf87b1f9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var $6d52c39fbf87b1f9$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === "date") {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === "minute" || unit === "second" || unit === "hour") suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var $6d52c39fbf87b1f9$var$localize = {
    ordinalNumber: $6d52c39fbf87b1f9$var$ordinalNumber,
    era: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $6d52c39fbf87b1f9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $6d52c39fbf87b1f9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $6d52c39fbf87b1f9$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $6d52c39fbf87b1f9$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $6d52c39fbf87b1f9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $a9c9c2bfe829ca54$export$2e2bcd8739ae039)({
        values: $6d52c39fbf87b1f9$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $6d52c39fbf87b1f9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6d52c39fbf87b1f9$export$2e2bcd8739ae039 = $6d52c39fbf87b1f9$var$localize;




var $9beda241ee465de5$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var $9beda241ee465de5$var$parseOrdinalNumberPattern = /\d+/i;
var $9beda241ee465de5$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var $9beda241ee465de5$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $9beda241ee465de5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var $9beda241ee465de5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9beda241ee465de5$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var $9beda241ee465de5$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var $9beda241ee465de5$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var $9beda241ee465de5$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var $9beda241ee465de5$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var $9beda241ee465de5$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $9beda241ee465de5$var$match = {
    ordinalNumber: (0, $a51d42a24daf46ae$export$2e2bcd8739ae039)({
        matchPattern: $9beda241ee465de5$var$matchOrdinalNumberPattern,
        parsePattern: $9beda241ee465de5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $9beda241ee465de5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9beda241ee465de5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $9beda241ee465de5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9beda241ee465de5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $9beda241ee465de5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9beda241ee465de5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $9beda241ee465de5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9beda241ee465de5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $bcaf83ab272105ab$export$2e2bcd8739ae039)({
        matchPatterns: $9beda241ee465de5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9beda241ee465de5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $9beda241ee465de5$export$2e2bcd8739ae039 = $9beda241ee465de5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var $477c23b676297aaa$var$locale = {
    code: "uk",
    formatDistance: (0, $0360a903a093e47c$export$2e2bcd8739ae039),
    formatLong: (0, $d8b40c99144aabfe$export$2e2bcd8739ae039),
    formatRelative: (0, $b83bbff865ac5bfb$export$2e2bcd8739ae039),
    localize: (0, $6d52c39fbf87b1f9$export$2e2bcd8739ae039),
    match: (0, $9beda241ee465de5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $477c23b676297aaa$export$2e2bcd8739ae039 = $477c23b676297aaa$var$locale;



// react-datepicker v8 formats the incoming date with no validity guard, so an
// Invalid Date (e.g. from `new Date(undefined)` when a field is missing) makes
// date-fns throw `RangeError: Invalid time value` during render — a crash the older
// v3 tolerated. Coerce any invalid/unparseable date prop to null before it reaches
// the picker. Every date picker in the app routes through this wrapper, so this one
// guard covers all call sites.
const $6214b59a73de52c6$var$toValidDate = (value)=>{
    if (value == null) return null;
    const date = value instanceof Date ? value : new Date(value);
    return isNaN(date.getTime()) ? null : date;
};
const $6214b59a73de52c6$var$DATE_PROPS = [
    "startDate",
    "endDate",
    "minDate",
    "maxDate",
    "openToDate"
];
const $6214b59a73de52c6$export$5109c6dd95d8fb00 = ({ selected: selected, onChange: onChange, className: className, ...rest })=>{
    const sanitized = {
        ...rest
    };
    $6214b59a73de52c6$var$DATE_PROPS.forEach((key)=>{
        if (key in sanitized) sanitized[key] = $6214b59a73de52c6$var$toValidDate(sanitized[key]);
    });
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $f45070adf3eddf53$export$5109c6dd95d8fb00), {
        locale: (0, $477c23b676297aaa$export$2e2bcd8739ae039),
        dateFormat: "dd/MM/yyyy",
        selected: $6214b59a73de52c6$var$toValidDate(selected),
        className: className,
        onChange: onChange,
        ...sanitized
    });
};



var $Yxlsx = parcelRequire("Yxlsx");


function $02dc85def57bbdda$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $b56093cb51bf02b1$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $956338a9e9c125d6$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $07bfc70c3f0251dd$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $956338a9e9c125d6$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $956338a9e9c125d6$export$2e2bcd8739ae039)(o, minLen);
}


function $5ddfc925ae0af29a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $6b65fc3b4acde7f2$export$2e2bcd8739ae039(arr, i) {
    return (0, $02dc85def57bbdda$export$2e2bcd8739ae039)(arr) || (0, $b56093cb51bf02b1$export$2e2bcd8739ae039)(arr, i) || (0, $07bfc70c3f0251dd$export$2e2bcd8739ae039)(arr, i) || (0, $5ddfc925ae0af29a$export$2e2bcd8739ae039)();
}



function $89c7ad5d109a1176$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $cQmXV = parcelRequire("cQmXV");
var $e7b1f27543b51422$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $e7b1f27543b51422$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_ref, $e7b1f27543b51422$var$_excluded);
    var _useState = (0, $cQmXV.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $cQmXV.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $cQmXV.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $cQmXV.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $cQmXV.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $cQmXV.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $cQmXV.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}



var $jNuvi = parcelRequire("jNuvi");

var $cQmXV = parcelRequire("cQmXV");

var $jNuvi = parcelRequire("jNuvi");

function $07be749aeca07699$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $c180160353ceabc3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $8f99ccc7d9abb291$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $c180160353ceabc3$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $c180160353ceabc3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c180160353ceabc3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $97a7799c9b277eb6$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $e9bcd870dc67024b$export$2e2bcd8739ae039)(subClass, superClass);
}


function $5b4fe65c74408c52$export$2e2bcd8739ae039(o) {
    $5b4fe65c74408c52$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5b4fe65c74408c52$export$2e2bcd8739ae039(o);
}


function $5d696402a43f7962$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $220785158be974ce$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $33c3c70a2b283b30$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $220785158be974ce$export$2e2bcd8739ae039)(self);
}


function $0d52efb306ead7d6$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $5d696402a43f7962$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(this, result);
    };
}



function $1301bbb20b42149f$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $956338a9e9c125d6$export$2e2bcd8739ae039)(arr);
}


function $76a0531dbf122754$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $e51b862fe4e76988$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $68381b18b974dc9f$export$2e2bcd8739ae039(arr) {
    return (0, $1301bbb20b42149f$export$2e2bcd8739ae039)(arr) || (0, $76a0531dbf122754$export$2e2bcd8739ae039)(arr) || (0, $07bfc70c3f0251dd$export$2e2bcd8739ae039)(arr) || (0, $e51b862fe4e76988$export$2e2bcd8739ae039)();
}



var $cQmXV = parcelRequire("cQmXV");


var $jNuvi = parcelRequire("jNuvi");

var $cQmXV = parcelRequire("cQmXV");
var $6c563fd97818ca21$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $6c563fd97818ca21$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $6c563fd97818ca21$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $6c563fd97818ca21$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$6c563fd97818ca21$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($6c563fd97818ca21$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $6c563fd97818ca21$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $c149225b3871bfad$export$71ad59f2e432cfe8 = "-ms-";
var $c149225b3871bfad$export$2c0f367103c8d01c = "-moz-";
var $c149225b3871bfad$export$39dfd62a25e0fe93 = "-webkit-";
var $c149225b3871bfad$export$a29989082612d0d9 = "comm";
var $c149225b3871bfad$export$aa3a2e812ca8570d = "rule";
var $c149225b3871bfad$export$527d108ccf083c2b = "decl";
var $c149225b3871bfad$export$d3d35020fa5b54f0 = "@page";
var $c149225b3871bfad$export$500415a86c544f73 = "@media";
var $c149225b3871bfad$export$a763edbf796b780a = "@import";
var $c149225b3871bfad$export$2790aeb8b4e5c826 = "@charset";
var $c149225b3871bfad$export$1cc683e23b84b133 = "@viewport";
var $c149225b3871bfad$export$9447a5efea57e862 = "@supports";
var $c149225b3871bfad$export$ef011b4e114b1fba = "@document";
var $c149225b3871bfad$export$6aad947bda0f3f46 = "@namespace";
var $c149225b3871bfad$export$b44a8529a35fcb60 = "@keyframes";
var $c149225b3871bfad$export$2c16de31893252e6 = "@font-face";
var $c149225b3871bfad$export$3d846dd52e150c6f = "@counter-style";
var $c149225b3871bfad$export$22314bfbb57653fe = "@font-feature-values";
var $c149225b3871bfad$export$d773506282b3cfe6 = "@layer";
var $c149225b3871bfad$export$2335f513bbd82c6d = Math.abs;
var $c149225b3871bfad$export$6788812c4e6611e6 = String.fromCharCode;
var $c149225b3871bfad$export$e6e34fd1f2686227 = Object.assign;
function $c149225b3871bfad$export$d6af199866bfb566(e, r) {
    return $c149225b3871bfad$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c149225b3871bfad$export$a9db5e087081082d(e, 0)) << 2 ^ $c149225b3871bfad$export$a9db5e087081082d(e, 1)) << 2 ^ $c149225b3871bfad$export$a9db5e087081082d(e, 2)) << 2 ^ $c149225b3871bfad$export$a9db5e087081082d(e, 3) : 0;
}
function $c149225b3871bfad$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c149225b3871bfad$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c149225b3871bfad$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c149225b3871bfad$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $c149225b3871bfad$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c149225b3871bfad$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c149225b3871bfad$export$36776f635604f274(e) {
    return e.length;
}
function $c149225b3871bfad$export$f9084667e487ed46(e) {
    return e.length;
}
function $c149225b3871bfad$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c149225b3871bfad$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $c149225b3871bfad$export$53f1d5ea8de3d7c = 1;
var $c149225b3871bfad$export$4e0c71f277ca26b3 = 1;
var $c149225b3871bfad$export$f24224f1c91d8156 = 0;
var $c149225b3871bfad$export$5880b8b5730aff45 = 0;
var $c149225b3871bfad$export$c0306caf338ac095 = 0;
var $c149225b3871bfad$export$30a86d91af8ff6e6 = "";
function $c149225b3871bfad$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c149225b3871bfad$export$53f1d5ea8de3d7c,
        column: $c149225b3871bfad$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $c149225b3871bfad$export$784d13d8ee351f07(e, r) {
    return $c149225b3871bfad$export$e6e34fd1f2686227($c149225b3871bfad$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $c149225b3871bfad$export$eba6f6f03b0a92e7() {
    return $c149225b3871bfad$export$c0306caf338ac095;
}
function $c149225b3871bfad$export$232faf9add678146() {
    $c149225b3871bfad$export$c0306caf338ac095 = $c149225b3871bfad$export$5880b8b5730aff45 > 0 ? $c149225b3871bfad$export$a9db5e087081082d($c149225b3871bfad$export$30a86d91af8ff6e6, --$c149225b3871bfad$export$5880b8b5730aff45) : 0;
    if ($c149225b3871bfad$export$4e0c71f277ca26b3--, $c149225b3871bfad$export$c0306caf338ac095 === 10) $c149225b3871bfad$export$4e0c71f277ca26b3 = 1, $c149225b3871bfad$export$53f1d5ea8de3d7c--;
    return $c149225b3871bfad$export$c0306caf338ac095;
}
function $c149225b3871bfad$export$48cfd1e771a65c4f() {
    $c149225b3871bfad$export$c0306caf338ac095 = $c149225b3871bfad$export$5880b8b5730aff45 < $c149225b3871bfad$export$f24224f1c91d8156 ? $c149225b3871bfad$export$a9db5e087081082d($c149225b3871bfad$export$30a86d91af8ff6e6, $c149225b3871bfad$export$5880b8b5730aff45++) : 0;
    if ($c149225b3871bfad$export$4e0c71f277ca26b3++, $c149225b3871bfad$export$c0306caf338ac095 === 10) $c149225b3871bfad$export$4e0c71f277ca26b3 = 1, $c149225b3871bfad$export$53f1d5ea8de3d7c++;
    return $c149225b3871bfad$export$c0306caf338ac095;
}
function $c149225b3871bfad$export$4d3fb11e950abb9e() {
    return $c149225b3871bfad$export$a9db5e087081082d($c149225b3871bfad$export$30a86d91af8ff6e6, $c149225b3871bfad$export$5880b8b5730aff45);
}
function $c149225b3871bfad$export$e88cb2efb12ae807() {
    return $c149225b3871bfad$export$5880b8b5730aff45;
}
function $c149225b3871bfad$export$58adb3bec8346d0f(e, r) {
    return $c149225b3871bfad$export$2f35ab04d2335697($c149225b3871bfad$export$30a86d91af8ff6e6, e, r);
}
function $c149225b3871bfad$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c149225b3871bfad$export$2de70f21292aac9e(e) {
    return $c149225b3871bfad$export$53f1d5ea8de3d7c = $c149225b3871bfad$export$4e0c71f277ca26b3 = 1, $c149225b3871bfad$export$f24224f1c91d8156 = $c149225b3871bfad$export$36776f635604f274($c149225b3871bfad$export$30a86d91af8ff6e6 = e), $c149225b3871bfad$export$5880b8b5730aff45 = 0, [];
}
function $c149225b3871bfad$export$45918ac1574455b1(e) {
    return $c149225b3871bfad$export$30a86d91af8ff6e6 = "", e;
}
function $c149225b3871bfad$export$410ac95b9ec204b8(e) {
    return $c149225b3871bfad$export$87c2784dc9fc4ab($c149225b3871bfad$export$58adb3bec8346d0f($c149225b3871bfad$export$5880b8b5730aff45 - 1, $c149225b3871bfad$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c149225b3871bfad$export$660b2ee2d4fb4eff(e) {
    return $c149225b3871bfad$export$45918ac1574455b1($c149225b3871bfad$export$5f8c09e3ae6f64e1($c149225b3871bfad$export$2de70f21292aac9e(e)));
}
function $c149225b3871bfad$export$7af1228ff777d175(e) {
    while($c149225b3871bfad$export$c0306caf338ac095 = $c149225b3871bfad$export$4d3fb11e950abb9e())if ($c149225b3871bfad$export$c0306caf338ac095 < 33) $c149225b3871bfad$export$48cfd1e771a65c4f();
    else break;
    return $c149225b3871bfad$export$9e1725a4cfeada27(e) > 2 || $c149225b3871bfad$export$9e1725a4cfeada27($c149225b3871bfad$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c149225b3871bfad$export$5f8c09e3ae6f64e1(e) {
    while($c149225b3871bfad$export$48cfd1e771a65c4f())switch($c149225b3871bfad$export$9e1725a4cfeada27($c149225b3871bfad$export$c0306caf338ac095)){
        case 0:
            $c149225b3871bfad$export$10d8903dec122b9d($c149225b3871bfad$export$c2ab62c7bf24634($c149225b3871bfad$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c149225b3871bfad$export$10d8903dec122b9d($c149225b3871bfad$export$410ac95b9ec204b8($c149225b3871bfad$export$c0306caf338ac095), e);
            break;
        default:
            $c149225b3871bfad$export$10d8903dec122b9d($c149225b3871bfad$export$6788812c4e6611e6($c149225b3871bfad$export$c0306caf338ac095), e);
    }
    return e;
}
function $c149225b3871bfad$export$955ba06d119e085e(e, r) {
    while(--r && $c149225b3871bfad$export$48cfd1e771a65c4f())if ($c149225b3871bfad$export$c0306caf338ac095 < 48 || $c149225b3871bfad$export$c0306caf338ac095 > 102 || $c149225b3871bfad$export$c0306caf338ac095 > 57 && $c149225b3871bfad$export$c0306caf338ac095 < 65 || $c149225b3871bfad$export$c0306caf338ac095 > 70 && $c149225b3871bfad$export$c0306caf338ac095 < 97) break;
    return $c149225b3871bfad$export$58adb3bec8346d0f(e, $c149225b3871bfad$export$e88cb2efb12ae807() + (r < 6 && $c149225b3871bfad$export$4d3fb11e950abb9e() == 32 && $c149225b3871bfad$export$48cfd1e771a65c4f() == 32));
}
function $c149225b3871bfad$export$c889f2fcc19dbf12(e) {
    while($c149225b3871bfad$export$48cfd1e771a65c4f())switch($c149225b3871bfad$export$c0306caf338ac095){
        case e:
            return $c149225b3871bfad$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c149225b3871bfad$export$c889f2fcc19dbf12($c149225b3871bfad$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c149225b3871bfad$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c149225b3871bfad$export$48cfd1e771a65c4f();
            break;
    }
    return $c149225b3871bfad$export$5880b8b5730aff45;
}
function $c149225b3871bfad$export$4254d4e2b3745c4c(e, r) {
    while($c149225b3871bfad$export$48cfd1e771a65c4f())if (e + $c149225b3871bfad$export$c0306caf338ac095 === 57) break;
    else if (e + $c149225b3871bfad$export$c0306caf338ac095 === 84 && $c149225b3871bfad$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c149225b3871bfad$export$58adb3bec8346d0f(r, $c149225b3871bfad$export$5880b8b5730aff45 - 1) + "*" + $c149225b3871bfad$export$6788812c4e6611e6(e === 47 ? e : $c149225b3871bfad$export$48cfd1e771a65c4f());
}
function $c149225b3871bfad$export$c2ab62c7bf24634(e) {
    while(!$c149225b3871bfad$export$9e1725a4cfeada27($c149225b3871bfad$export$4d3fb11e950abb9e()))$c149225b3871bfad$export$48cfd1e771a65c4f();
    return $c149225b3871bfad$export$58adb3bec8346d0f(e, $c149225b3871bfad$export$5880b8b5730aff45);
}
function $c149225b3871bfad$export$ef7acd7185315e22(e) {
    return $c149225b3871bfad$export$45918ac1574455b1($c149225b3871bfad$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c149225b3871bfad$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c149225b3871bfad$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $c149225b3871bfad$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c149225b3871bfad$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($c149225b3871bfad$export$f8e21b1e77979a08(j += $c149225b3871bfad$export$77ad94ebf1c2b9ed($c149225b3871bfad$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $c149225b3871bfad$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $c149225b3871bfad$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $c149225b3871bfad$export$955ba06d119e085e($c149225b3871bfad$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c149225b3871bfad$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c149225b3871bfad$export$10d8903dec122b9d($c149225b3871bfad$export$4a34f930e789283c($c149225b3871bfad$export$4254d4e2b3745c4c($c149225b3871bfad$export$48cfd1e771a65c4f(), $c149225b3871bfad$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c149225b3871bfad$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $c149225b3871bfad$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $c149225b3871bfad$export$36776f635604f274(j) - l) $c149225b3871bfad$export$10d8903dec122b9d(p > 32 ? $c149225b3871bfad$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $c149225b3871bfad$export$f8483753829ec8f3($c149225b3871bfad$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $c149225b3871bfad$export$10d8903dec122b9d(y = $c149225b3871bfad$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $c149225b3871bfad$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $c149225b3871bfad$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c149225b3871bfad$export$98e6a39c04603d36(e, y, y, n && $c149225b3871bfad$export$10d8903dec122b9d($c149225b3871bfad$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $c149225b3871bfad$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $c149225b3871bfad$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $c149225b3871bfad$export$232faf9add678146() == 125) continue;
            }
            switch(j += $c149225b3871bfad$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c149225b3871bfad$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c149225b3871bfad$export$4d3fb11e950abb9e() === 45) j += $c149225b3871bfad$export$410ac95b9ec204b8($c149225b3871bfad$export$48cfd1e771a65c4f());
                    v = $c149225b3871bfad$export$4d3fb11e950abb9e(), o = l = $c149225b3871bfad$export$36776f635604f274(g = j += $c149225b3871bfad$export$c2ab62c7bf24634($c149225b3871bfad$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $c149225b3871bfad$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $c149225b3871bfad$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $c149225b3871bfad$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $c149225b3871bfad$export$2f35ab04d2335697(e, v + 1, v = $c149225b3871bfad$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $c149225b3871bfad$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $c149225b3871bfad$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $c149225b3871bfad$export$35059013cd4a06db(e, r, a, s === 0 ? $c149225b3871bfad$export$aa3a2e812ca8570d : i, f, o, l);
}
function $c149225b3871bfad$export$4a34f930e789283c(e, r, a) {
    return $c149225b3871bfad$export$35059013cd4a06db(e, r, a, $c149225b3871bfad$export$a29989082612d0d9, $c149225b3871bfad$export$6788812c4e6611e6($c149225b3871bfad$export$eba6f6f03b0a92e7()), $c149225b3871bfad$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $c149225b3871bfad$export$f8483753829ec8f3(e, r, a, n) {
    return $c149225b3871bfad$export$35059013cd4a06db(e, r, a, $c149225b3871bfad$export$527d108ccf083c2b, $c149225b3871bfad$export$2f35ab04d2335697(e, 0, n), $c149225b3871bfad$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $c149225b3871bfad$export$82e9f45cca5ba907(n, c, s) {
    switch($c149225b3871bfad$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c149225b3871bfad$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$2c0f367103c8d01c + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c149225b3871bfad$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c149225b3871bfad$export$39dfd62a25e0fe93 + "box-$1$2" + $c149225b3871bfad$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + "flex-item-" + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c149225b3871bfad$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c149225b3871bfad$export$71ad59f2e432cfe8 + "grid-row-" + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + "flex-line-pack" + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + "box-" + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c149225b3871bfad$export$39dfd62a25e0fe93 + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c149225b3871bfad$export$39dfd62a25e0fe93 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c149225b3871bfad$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c149225b3871bfad$export$77ad94ebf1c2b9ed($c149225b3871bfad$export$77ad94ebf1c2b9ed($c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c149225b3871bfad$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c149225b3871bfad$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c149225b3871bfad$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c149225b3871bfad$export$77ad94ebf1c2b9ed($c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c149225b3871bfad$export$39dfd62a25e0fe93 + "box-pack:$3" + $c149225b3871bfad$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c149225b3871bfad$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c149225b3871bfad$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c149225b3871bfad$export$71ad59f2e432cfe8 + "grid-column-align" + $c149225b3871bfad$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c149225b3871bfad$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c149225b3871bfad$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c149225b3871bfad$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c149225b3871bfad$export$f8e21b1e77979a08(s, "span") ? $c149225b3871bfad$export$4659b591c19bdf3d(s, /\d+/) : +$c149225b3871bfad$export$4659b591c19bdf3d(s, /\d+/) - +$c149225b3871bfad$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c149225b3871bfad$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c149225b3871bfad$export$71ad59f2e432cfe8 + $c149225b3871bfad$export$77ad94ebf1c2b9ed($c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c149225b3871bfad$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c149225b3871bfad$export$36776f635604f274(n) - 1 - c > 6) switch($c149225b3871bfad$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c149225b3871bfad$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c149225b3871bfad$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c149225b3871bfad$export$2c0f367103c8d01c + ($c149225b3871bfad$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c149225b3871bfad$export$f8e21b1e77979a08(n, "stretch") ? $c149225b3871bfad$export$82e9f45cca5ba907($c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c149225b3871bfad$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c149225b3871bfad$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c149225b3871bfad$export$a9db5e087081082d(n, c + 6) === 121) return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, ":", ":" + $c149225b3871bfad$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c149225b3871bfad$export$a9db5e087081082d(n, $c149225b3871bfad$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c149225b3871bfad$export$39dfd62a25e0fe93 + ($c149225b3871bfad$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c149225b3871bfad$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c149225b3871bfad$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, ":", ":" + $c149225b3871bfad$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c149225b3871bfad$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c149225b3871bfad$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $c149225b3871bfad$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $c149225b3871bfad$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c149225b3871bfad$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c149225b3871bfad$export$a763edbf796b780a:
        case $c149225b3871bfad$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c149225b3871bfad$export$a29989082612d0d9:
            return "";
        case $c149225b3871bfad$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c149225b3871bfad$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c149225b3871bfad$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $c149225b3871bfad$export$36776f635604f274(a = $c149225b3871bfad$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c149225b3871bfad$export$5a7767152ae0305f(e) {
    var r = $c149225b3871bfad$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c149225b3871bfad$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c149225b3871bfad$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c149225b3871bfad$export$527d108ccf083c2b:
                n.return = $c149225b3871bfad$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c149225b3871bfad$export$b44a8529a35fcb60:
                return $c149225b3871bfad$export$dfdc1655ccc5b9cb([
                    $c149225b3871bfad$export$784d13d8ee351f07(n, {
                        value: $c149225b3871bfad$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c149225b3871bfad$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c149225b3871bfad$export$aa3a2e812ca8570d:
                if (n.length) return $c149225b3871bfad$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($c149225b3871bfad$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $c149225b3871bfad$export$dfdc1655ccc5b9cb([
                                $c149225b3871bfad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c149225b3871bfad$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c149225b3871bfad$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $c149225b3871bfad$export$dfdc1655ccc5b9cb([
                                $c149225b3871bfad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c149225b3871bfad$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c149225b3871bfad$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $c149225b3871bfad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c149225b3871bfad$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c149225b3871bfad$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $c149225b3871bfad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c149225b3871bfad$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c149225b3871bfad$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $c149225b3871bfad$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c149225b3871bfad$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c149225b3871bfad$export$1be1fc439b849fdf($c149225b3871bfad$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c149225b3871bfad$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c149225b3871bfad$export$2f35ab04d2335697(r, 1, $c149225b3871bfad$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c149225b3871bfad$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c149225b3871bfad$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c149225b3871bfad$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $f347769164ce0266$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6152c3318d8e2536$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $c8d9b1b49f3041ad$var$isBrowser = typeof document !== "undefined";
var $c8d9b1b49f3041ad$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $c149225b3871bfad$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $c149225b3871bfad$export$9e1725a4cfeada27)(character)) break;
        (0, $c149225b3871bfad$export$48cfd1e771a65c4f)();
    }
    return (0, $c149225b3871bfad$export$58adb3bec8346d0f)(begin, (0, $c149225b3871bfad$export$5880b8b5730aff45));
};
var $c8d9b1b49f3041ad$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $c149225b3871bfad$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $c149225b3871bfad$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $c8d9b1b49f3041ad$var$identifierWithPointTracking((0, $c149225b3871bfad$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $c149225b3871bfad$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $c149225b3871bfad$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $c149225b3871bfad$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $c149225b3871bfad$export$48cfd1e771a65c4f)());
    return parsed;
};
var $c8d9b1b49f3041ad$var$getRules = function getRules(value, points) {
    return (0, $c149225b3871bfad$export$45918ac1574455b1)($c8d9b1b49f3041ad$var$toRules((0, $c149225b3871bfad$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $c8d9b1b49f3041ad$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $c8d9b1b49f3041ad$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$c8d9b1b49f3041ad$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $c8d9b1b49f3041ad$var$fixedElements.set(element, true);
    var points = [];
    var rules = $c8d9b1b49f3041ad$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $c8d9b1b49f3041ad$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $c8d9b1b49f3041ad$var$prefix(value, length) {
    switch((0, $c149225b3871bfad$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$2c0f367103c8d01c) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + "flex-item-" + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "box-" + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)((0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)((0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)((0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $c149225b3871bfad$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $c149225b3871bfad$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $c149225b3871bfad$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $c149225b3871bfad$export$2c0f367103c8d01c) + ((0, $c149225b3871bfad$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $c149225b3871bfad$export$f8e21b1e77979a08)(value, "stretch") ? $c8d9b1b49f3041ad$var$prefix((0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $c149225b3871bfad$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $c149225b3871bfad$export$a9db5e087081082d)(value, (0, $c149225b3871bfad$export$36776f635604f274)(value) - 3 - (~(0, $c149225b3871bfad$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $c149225b3871bfad$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + ((0, $c149225b3871bfad$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $c149225b3871bfad$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + value + (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $c8d9b1b49f3041ad$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $c149225b3871bfad$export$527d108ccf083c2b:
                element["return"] = $c8d9b1b49f3041ad$var$prefix(element.value, element.length);
                break;
            case 0, $c149225b3871bfad$export$b44a8529a35fcb60:
                return (0, $c149225b3871bfad$export$dfdc1655ccc5b9cb)([
                    (0, $c149225b3871bfad$export$784d13d8ee351f07)(element, {
                        value: (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $c149225b3871bfad$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $c149225b3871bfad$export$aa3a2e812ca8570d:
                if (element.length) return (0, $c149225b3871bfad$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $c149225b3871bfad$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $c149225b3871bfad$export$dfdc1655ccc5b9cb)([
                                (0, $c149225b3871bfad$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $c149225b3871bfad$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $c149225b3871bfad$export$dfdc1655ccc5b9cb)([
                                (0, $c149225b3871bfad$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $c149225b3871bfad$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $c149225b3871bfad$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $c149225b3871bfad$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $c149225b3871bfad$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $c149225b3871bfad$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $c149225b3871bfad$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $c8d9b1b49f3041ad$var$getServerStylisCache = $c8d9b1b49f3041ad$var$isBrowser ? undefined : (0, $f347769164ce0266$export$2e2bcd8739ae039)(function() {
    return (0, $6152c3318d8e2536$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $c8d9b1b49f3041ad$var$defaultStylisPlugins = [
    $c8d9b1b49f3041ad$var$prefixer
];
var $c8d9b1b49f3041ad$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($c8d9b1b49f3041ad$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $c8d9b1b49f3041ad$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($c8d9b1b49f3041ad$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $c8d9b1b49f3041ad$var$compat,
        $c8d9b1b49f3041ad$var$removeLabel
    ];
    if (!$c8d9b1b49f3041ad$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $c149225b3871bfad$export$fac44ee5b035f737),
            (0, $c149225b3871bfad$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $c149225b3871bfad$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $c149225b3871bfad$export$dfdc1655ccc5b9cb)((0, $c149225b3871bfad$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $c149225b3871bfad$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $c149225b3871bfad$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $c149225b3871bfad$export$dfdc1655ccc5b9cb)((0, $c149225b3871bfad$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $c8d9b1b49f3041ad$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $6c563fd97818ca21$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};



var $jNuvi = parcelRequire("jNuvi");


var $iSQ8t = parcelRequire("iSQ8t");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $142f969454987e8b$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSQ8t)))(targetComponent, sourceComponent);
};


var $4d077f47ad5de488$var$isBrowser = typeof document !== "undefined";
function $4d077f47ad5de488$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $4d077f47ad5de488$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $4d077f47ad5de488$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $4d077f47ad5de488$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $4d077f47ad5de488$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$4d077f47ad5de488$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$4d077f47ad5de488$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $2856e95c52676786$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $1996e19e8a537c3c$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $e04473a50b1c2421$var$isDevelopment = false;
var $e04473a50b1c2421$var$hyphenateRegex = /[A-Z]|^ms/g;
var $e04473a50b1c2421$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $e04473a50b1c2421$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $e04473a50b1c2421$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $e04473a50b1c2421$var$processStyleName = /* #__PURE__ */ (0, $6152c3318d8e2536$export$2e2bcd8739ae039)(function(styleName) {
    return $e04473a50b1c2421$var$isCustomProperty(styleName) ? styleName : styleName.replace($e04473a50b1c2421$var$hyphenateRegex, "-$&").toLowerCase();
});
var $e04473a50b1c2421$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($e04473a50b1c2421$var$animationRegex, function(match, p1, p2) {
                $e04473a50b1c2421$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $e04473a50b1c2421$var$cursor
                };
                return p1;
            });
    }
    if ((0, $1996e19e8a537c3c$export$2e2bcd8739ae039)[key] !== 1 && !$e04473a50b1c2421$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $e04473a50b1c2421$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $e04473a50b1c2421$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $e04473a50b1c2421$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $e04473a50b1c2421$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $e04473a50b1c2421$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $e04473a50b1c2421$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $e04473a50b1c2421$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $e04473a50b1c2421$var$cursor;
                var result = interpolation(mergedProps);
                $e04473a50b1c2421$var$cursor = previousCursor;
                return $e04473a50b1c2421$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $e04473a50b1c2421$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $e04473a50b1c2421$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($e04473a50b1c2421$var$isProcessableValue(asString)) string += $e04473a50b1c2421$var$processStyleName(key) + ":" + $e04473a50b1c2421$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $e04473a50b1c2421$var$isDevelopment) throw new Error($e04473a50b1c2421$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($e04473a50b1c2421$var$isProcessableValue(value[_i])) string += $e04473a50b1c2421$var$processStyleName(key) + ":" + $e04473a50b1c2421$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $e04473a50b1c2421$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $e04473a50b1c2421$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $e04473a50b1c2421$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $e04473a50b1c2421$var$cursor;
function $e04473a50b1c2421$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $e04473a50b1c2421$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $e04473a50b1c2421$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $e04473a50b1c2421$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $e04473a50b1c2421$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $e04473a50b1c2421$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $2856e95c52676786$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $e04473a50b1c2421$var$cursor
    };
}



var $cQmXV = parcelRequire("cQmXV");
var $d2fe84768dff7733$var$isBrowser = typeof document !== "undefined";
var $d2fe84768dff7733$var$syncFallback = function syncFallback(create) {
    return create();
};
var $d2fe84768dff7733$var$useInsertionEffect = $cQmXV.useInsertionEffect ? $cQmXV.useInsertionEffect : false;
var $d2fe84768dff7733$export$db21c7ffa21794e7 = !$d2fe84768dff7733$var$isBrowser ? $d2fe84768dff7733$var$syncFallback : $d2fe84768dff7733$var$useInsertionEffect || $d2fe84768dff7733$var$syncFallback;
var $d2fe84768dff7733$export$811a713a7276cb9d = $d2fe84768dff7733$var$useInsertionEffect || $cQmXV.useLayoutEffect;


var $176d799fde64267c$export$407448d2b89b1813 = false;
var $176d799fde64267c$export$23f2a1d2818174ef = typeof document !== "undefined";
var $176d799fde64267c$var$EmotionCacheContext = /* #__PURE__ */ $cQmXV.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $c8d9b1b49f3041ad$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $176d799fde64267c$export$e7094788287c5e9b = $176d799fde64267c$var$EmotionCacheContext.Provider;
var $176d799fde64267c$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $cQmXV.useContext)($176d799fde64267c$var$EmotionCacheContext);
};
var $176d799fde64267c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $cQmXV.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $cQmXV.useContext)($176d799fde64267c$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$176d799fde64267c$export$23f2a1d2818174ef) $176d799fde64267c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $cQmXV.useContext)($176d799fde64267c$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $c8d9b1b49f3041ad$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $cQmXV.createElement($176d799fde64267c$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $176d799fde64267c$export$971d5caa766a69d7 = /* #__PURE__ */ $cQmXV.createContext({});
var $176d799fde64267c$export$3b14a55fb2447963 = function useTheme() {
    return $cQmXV.useContext($176d799fde64267c$export$971d5caa766a69d7);
};
var $176d799fde64267c$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $jNuvi.default)({}, outerTheme, theme);
};
var $176d799fde64267c$var$createCacheWithTheme = /* #__PURE__ */ (0, $f347769164ce0266$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $f347769164ce0266$export$2e2bcd8739ae039)(function(theme) {
        return $176d799fde64267c$var$getTheme(outerTheme, theme);
    });
});
var $176d799fde64267c$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $cQmXV.useContext($176d799fde64267c$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $176d799fde64267c$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $cQmXV.createElement($176d799fde64267c$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $176d799fde64267c$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $cQmXV.forwardRef(function render(props, ref) {
        var theme = $cQmXV.useContext($176d799fde64267c$export$971d5caa766a69d7);
        return /*#__PURE__*/ $cQmXV.createElement(Component, (0, $jNuvi.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $142f969454987e8b$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $176d799fde64267c$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $176d799fde64267c$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $176d799fde64267c$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($176d799fde64267c$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$176d799fde64267c$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $176d799fde64267c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $4d077f47ad5de488$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $d2fe84768dff7733$export$db21c7ffa21794e7)(function() {
        return (0, $4d077f47ad5de488$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$176d799fde64267c$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $cQmXV.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $176d799fde64267c$var$Emotion = /* #__PURE__ */ $176d799fde64267c$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$176d799fde64267c$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $4d077f47ad5de488$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $e04473a50b1c2421$export$6321afa313b251b5)(registeredStyles, undefined, $cQmXV.useContext($176d799fde64267c$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($176d799fde64267c$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $176d799fde64267c$var$typePropName && !$176d799fde64267c$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement($176d799fde64267c$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $cQmXV.createElement(WrappedComponent, newProps));
});
var $176d799fde64267c$export$a9c23c6ac3fc3eca = $176d799fde64267c$var$Emotion;



var $cQmXV = parcelRequire("cQmXV");




parcelRequire("b68Mk");


parcelRequire("iSQ8t");
var $7352cc6d8330e007$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $176d799fde64267c$export$dda1d9f60106f0e9).call(props, "css")) return $cQmXV.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $176d799fde64267c$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $176d799fde64267c$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $cQmXV.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($7352cc6d8330e007$export$c8a8987d4410bf2d || ($7352cc6d8330e007$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7352cc6d8330e007$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $176d799fde64267c$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $e04473a50b1c2421$export$6321afa313b251b5)([
        styles
    ], undefined, $cQmXV.useContext((0, $176d799fde64267c$export$971d5caa766a69d7)));
    if (!(0, $176d799fde64267c$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $cQmXV.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $cQmXV.useRef();
    (0, $d2fe84768dff7733$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $d2fe84768dff7733$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $4d077f47ad5de488$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $7352cc6d8330e007$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $e04473a50b1c2421$export$6321afa313b251b5)(args);
}
function $7352cc6d8330e007$export$d25ddfdf17c3ad3e() {
    var insertable = $7352cc6d8330e007$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $7352cc6d8330e007$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7352cc6d8330e007$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $4d077f47ad5de488$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7352cc6d8330e007$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $d2fe84768dff7733$export$db21c7ffa21794e7)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $4d077f47ad5de488$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $176d799fde64267c$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $176d799fde64267c$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $176d799fde64267c$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $cQmXV.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7352cc6d8330e007$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $176d799fde64267c$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $176d799fde64267c$export$407448d2b89b1813)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $e04473a50b1c2421$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $4d077f47ad5de488$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $176d799fde64267c$export$407448d2b89b1813)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7352cc6d8330e007$var$merge(cache.registered, css, $7352cc6d8330e007$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $cQmXV.useContext((0, $176d799fde64267c$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement($7352cc6d8330e007$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});





function $076b9caee306fcaa$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");


var $cQmXV = parcelRequire("cQmXV");
var $3278bb50a73083cc$export$2e2bcd8739ae039 = (0, $cQmXV.useLayoutEffect);


var $66ac58ed5b1ea838$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $66ac58ed5b1ea838$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $66ac58ed5b1ea838$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $66ac58ed5b1ea838$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($66ac58ed5b1ea838$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $66ac58ed5b1ea838$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($66ac58ed5b1ea838$var$isArray(value)) return value.filter(Boolean);
    if ((0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $66ac58ed5b1ea838$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(props, $66ac58ed5b1ea838$var$_excluded$4);
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $66ac58ed5b1ea838$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $66ac58ed5b1ea838$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $66ac58ed5b1ea838$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $66ac58ed5b1ea838$var$normalizedHeight(el) {
    if ($66ac58ed5b1ea838$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $66ac58ed5b1ea838$var$getScrollTop(el) {
    if ($66ac58ed5b1ea838$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $66ac58ed5b1ea838$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($66ac58ed5b1ea838$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $66ac58ed5b1ea838$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $66ac58ed5b1ea838$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $66ac58ed5b1ea838$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $66ac58ed5b1ea838$export$b4171a6734a65d42;
    var start = $66ac58ed5b1ea838$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $66ac58ed5b1ea838$var$easeOutCubic(currentTime, start, change, duration);
        $66ac58ed5b1ea838$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $66ac58ed5b1ea838$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $66ac58ed5b1ea838$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $66ac58ed5b1ea838$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $66ac58ed5b1ea838$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $66ac58ed5b1ea838$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $66ac58ed5b1ea838$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $66ac58ed5b1ea838$var$passiveOptionAccessed = false;
var $66ac58ed5b1ea838$var$options = {
    get passive () {
        return $66ac58ed5b1ea838$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $66ac58ed5b1ea838$var$w = typeof window !== "undefined" ? window : {};
if ($66ac58ed5b1ea838$var$w.addEventListener && $66ac58ed5b1ea838$var$w.removeEventListener) {
    $66ac58ed5b1ea838$var$w.addEventListener("p", $66ac58ed5b1ea838$export$b4171a6734a65d42, $66ac58ed5b1ea838$var$options);
    $66ac58ed5b1ea838$var$w.removeEventListener("p", $66ac58ed5b1ea838$export$b4171a6734a65d42, false);
}
var $66ac58ed5b1ea838$export$2408f22a0fab9ae5 = $66ac58ed5b1ea838$var$passiveOptionAccessed;
function $66ac58ed5b1ea838$export$3466f893ebf79586(item) {
    return item != null;
}
function $66ac58ed5b1ea838$var$isArray(arg) {
    return Array.isArray(arg);
}
function $66ac58ed5b1ea838$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $66ac58ed5b1ea838$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $66ac58ed5b1ea838$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $66ac58ed5b1ea838$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $66ac58ed5b1ea838$var$_excluded$3 = [
    "children",
    "innerProps"
], $66ac58ed5b1ea838$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $66ac58ed5b1ea838$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $66ac58ed5b1ea838$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $66ac58ed5b1ea838$var$normalizedHeight(scrollParent);
    var scrollTop = $66ac58ed5b1ea838$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $66ac58ed5b1ea838$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $66ac58ed5b1ea838$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $66ac58ed5b1ea838$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $66ac58ed5b1ea838$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $66ac58ed5b1ea838$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $66ac58ed5b1ea838$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $66ac58ed5b1ea838$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $66ac58ed5b1ea838$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_objectSpread2, $66ac58ed5b1ea838$var$alignToControl(placement), "100%"), (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $66ac58ed5b1ea838$var$PortalPlacementContext = /*#__PURE__*/ (0, $cQmXV.createContext)(null);
// NOTE: internal only
var $66ac58ed5b1ea838$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $cQmXV.useContext)($66ac58ed5b1ea838$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $cQmXV.useRef)(null);
    var _useState = (0, $cQmXV.useState)(maxMenuHeight), _useState2 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $cQmXV.useState)(null), _useState4 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $3278bb50a73083cc$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $66ac58ed5b1ea838$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $66ac58ed5b1ea838$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $66ac58ed5b1ea838$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $66ac58ed5b1ea838$var$Menu$1 = $66ac58ed5b1ea838$var$Menu;
// ==============================
// Menu List
// ==============================
var $66ac58ed5b1ea838$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $66ac58ed5b1ea838$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $66ac58ed5b1ea838$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $66ac58ed5b1ea838$export$3b14a55fb2447963 = $66ac58ed5b1ea838$var$noticeCSS;
var $66ac58ed5b1ea838$export$342063e11d6c3cad = $66ac58ed5b1ea838$var$noticeCSS;
var $66ac58ed5b1ea838$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_ref6, $66ac58ed5b1ea838$var$_excluded$3);
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $66ac58ed5b1ea838$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_ref7, $66ac58ed5b1ea838$var$_excluded2$1);
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $66ac58ed5b1ea838$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $66ac58ed5b1ea838$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $cQmXV.useRef)(null);
    var cleanupRef = (0, $cQmXV.useRef)(null);
    var _useState5 = (0, $cQmXV.useState)($66ac58ed5b1ea838$var$coercePlacement(menuPlacement)), _useState6 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $cQmXV.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $cQmXV.useState)(null), _useState8 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $cQmXV.useCallback)(function() {
        if (!controlElement) return;
        var rect = $66ac58ed5b1ea838$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $3278bb50a73083cc$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $cQmXV.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $ac9032e133ae40c9$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $3278bb50a73083cc$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $cQmXV.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({
        ref: setMenuPortalElement
    }, $66ac58ed5b1ea838$var$getStyleProps((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $3h5eW.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $66ac58ed5b1ea838$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $66ac58ed5b1ea838$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $66ac58ed5b1ea838$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $66ac58ed5b1ea838$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $66ac58ed5b1ea838$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $66ac58ed5b1ea838$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $66ac58ed5b1ea838$var$_templateObject;
var $66ac58ed5b1ea838$var$_excluded$2 = [
    "size"
], $66ac58ed5b1ea838$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $66ac58ed5b1ea838$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $66ac58ed5b1ea838$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $66ac58ed5b1ea838$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_ref, $66ac58ed5b1ea838$var$_excluded$2);
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("svg", (0, $jNuvi.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $66ac58ed5b1ea838$var$_ref2
    }, props));
};
var $66ac58ed5b1ea838$var$CrossIcon = function CrossIcon(props) {
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$Svg, (0, $jNuvi.default)({
        size: 20
    }, props), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $66ac58ed5b1ea838$var$DownChevron = function DownChevron(props) {
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$Svg, (0, $jNuvi.default)({
        size: 20
    }, props), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $66ac58ed5b1ea838$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $66ac58ed5b1ea838$export$f1e1789686576879 = $66ac58ed5b1ea838$var$baseCSS;
var $66ac58ed5b1ea838$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$DownChevron, null));
};
var $66ac58ed5b1ea838$export$407448d2b89b1813 = $66ac58ed5b1ea838$var$baseCSS;
var $66ac58ed5b1ea838$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $66ac58ed5b1ea838$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $66ac58ed5b1ea838$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("span", (0, $jNuvi.default)({}, innerProps, $66ac58ed5b1ea838$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $66ac58ed5b1ea838$var$loadingDotAnimations = (0, $7352cc6d8330e007$export$d25ddfdf17c3ad3e)($66ac58ed5b1ea838$var$_templateObject || ($66ac58ed5b1ea838$var$_templateObject = (0, $076b9caee306fcaa$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $66ac58ed5b1ea838$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $66ac58ed5b1ea838$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $7352cc6d8330e007$export$dbf350e5966cf602)({
            animation: "".concat($66ac58ed5b1ea838$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $66ac58ed5b1ea838$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_ref7, $66ac58ed5b1ea838$var$_excluded2);
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $66ac58ed5b1ea838$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $66ac58ed5b1ea838$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({
        ref: innerRef
    }, $66ac58ed5b1ea838$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $66ac58ed5b1ea838$var$Control$1 = $66ac58ed5b1ea838$var$Control;
var $66ac58ed5b1ea838$var$_excluded$1 = [
    "data"
];
var $66ac58ed5b1ea838$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $66ac58ed5b1ea838$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)(Heading, (0, $jNuvi.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", null, children));
};
var $66ac58ed5b1ea838$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $66ac58ed5b1ea838$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $66ac58ed5b1ea838$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_cleanCommonProps, $66ac58ed5b1ea838$var$_excluded$1);
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $66ac58ed5b1ea838$var$Group$1 = $66ac58ed5b1ea838$var$Group;
var $66ac58ed5b1ea838$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $66ac58ed5b1ea838$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $66ac58ed5b1ea838$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $66ac58ed5b1ea838$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $66ac58ed5b1ea838$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $66ac58ed5b1ea838$var$spacingStyle)
};
var $66ac58ed5b1ea838$var$inputStyle = function inputStyle(isHidden) {
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $66ac58ed5b1ea838$var$spacingStyle);
};
var $66ac58ed5b1ea838$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $66ac58ed5b1ea838$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_cleanCommonProps, $66ac58ed5b1ea838$var$_excluded);
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("input", (0, $jNuvi.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $66ac58ed5b1ea838$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $66ac58ed5b1ea838$var$Input$1 = $66ac58ed5b1ea838$var$Input;
var $66ac58ed5b1ea838$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $66ac58ed5b1ea838$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $66ac58ed5b1ea838$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $66ac58ed5b1ea838$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $66ac58ed5b1ea838$var$MultiValueContainer = $66ac58ed5b1ea838$var$MultiValueGeneric;
var $66ac58ed5b1ea838$var$MultiValueLabel = $66ac58ed5b1ea838$var$MultiValueGeneric;
function $66ac58ed5b1ea838$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({
        role: "button"
    }, innerProps), children || (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($66ac58ed5b1ea838$var$CrossIcon, {
        size: 14
    }));
}
var $66ac58ed5b1ea838$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $66ac58ed5b1ea838$var$MultiValue$1 = $66ac58ed5b1ea838$var$MultiValue;
var $66ac58ed5b1ea838$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $66ac58ed5b1ea838$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $66ac58ed5b1ea838$var$Option$1 = $66ac58ed5b1ea838$var$Option;
var $66ac58ed5b1ea838$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $66ac58ed5b1ea838$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $66ac58ed5b1ea838$var$Placeholder$1 = $66ac58ed5b1ea838$var$Placeholder;
var $66ac58ed5b1ea838$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $66ac58ed5b1ea838$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", (0, $jNuvi.default)({}, $66ac58ed5b1ea838$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $66ac58ed5b1ea838$var$SingleValue$1 = $66ac58ed5b1ea838$var$SingleValue;
var $66ac58ed5b1ea838$export$db3b6bfb95261072 = {
    ClearIndicator: $66ac58ed5b1ea838$var$ClearIndicator,
    Control: $66ac58ed5b1ea838$var$Control$1,
    DropdownIndicator: $66ac58ed5b1ea838$var$DropdownIndicator,
    DownChevron: $66ac58ed5b1ea838$var$DownChevron,
    CrossIcon: $66ac58ed5b1ea838$var$CrossIcon,
    Group: $66ac58ed5b1ea838$var$Group$1,
    GroupHeading: $66ac58ed5b1ea838$var$GroupHeading,
    IndicatorsContainer: $66ac58ed5b1ea838$var$IndicatorsContainer,
    IndicatorSeparator: $66ac58ed5b1ea838$var$IndicatorSeparator,
    Input: $66ac58ed5b1ea838$var$Input$1,
    LoadingIndicator: $66ac58ed5b1ea838$var$LoadingIndicator,
    Menu: $66ac58ed5b1ea838$var$Menu$1,
    MenuList: $66ac58ed5b1ea838$var$MenuList,
    MenuPortal: $66ac58ed5b1ea838$var$MenuPortal,
    LoadingMessage: $66ac58ed5b1ea838$var$LoadingMessage,
    NoOptionsMessage: $66ac58ed5b1ea838$var$NoOptionsMessage,
    MultiValue: $66ac58ed5b1ea838$var$MultiValue$1,
    MultiValueContainer: $66ac58ed5b1ea838$var$MultiValueContainer,
    MultiValueLabel: $66ac58ed5b1ea838$var$MultiValueLabel,
    MultiValueRemove: $66ac58ed5b1ea838$var$MultiValueRemove,
    Option: $66ac58ed5b1ea838$var$Option$1,
    Placeholder: $66ac58ed5b1ea838$var$Placeholder$1,
    SelectContainer: $66ac58ed5b1ea838$var$SelectContainer,
    SingleValue: $66ac58ed5b1ea838$var$SingleValue$1,
    ValueContainer: $66ac58ed5b1ea838$var$ValueContainer
};
var $66ac58ed5b1ea838$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, $66ac58ed5b1ea838$export$db3b6bfb95261072), props.components);
};



var $131865440b62e30f$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $131865440b62e30f$var$isEqual(first, second) {
    if (first === second) return true;
    if ($131865440b62e30f$var$safeIsNaN(first) && $131865440b62e30f$var$safeIsNaN(second)) return true;
    return false;
}
function $131865440b62e30f$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$131865440b62e30f$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $131865440b62e30f$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $131865440b62e30f$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $4d787bf2c3872ec9$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $4d787bf2c3872ec9$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $4d787bf2c3872ec9$var$A11yText = function A11yText(props) {
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("span", (0, $jNuvi.default)({
        css: $4d787bf2c3872ec9$var$_ref
    }, props));
};
var $4d787bf2c3872ec9$var$A11yText$1 = $4d787bf2c3872ec9$var$A11yText;
var $4d787bf2c3872ec9$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $4d787bf2c3872ec9$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $cQmXV.useMemo)(function() {
        return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, $4d787bf2c3872ec9$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $cQmXV.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $cQmXV.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $cQmXV.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $cQmXV.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)((0, $cQmXV.Fragment), null, (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)((0, $cQmXV.Fragment), null, (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($4d787bf2c3872ec9$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)($4d787bf2c3872ec9$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $4d787bf2c3872ec9$var$LiveRegion$1 = $4d787bf2c3872ec9$var$LiveRegion;
var $4d787bf2c3872ec9$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $4d787bf2c3872ec9$var$anyDiacritic = new RegExp("[" + $4d787bf2c3872ec9$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $4d787bf2c3872ec9$var$diacriticToBase = {};
for(var $4d787bf2c3872ec9$var$i = 0; $4d787bf2c3872ec9$var$i < $4d787bf2c3872ec9$var$diacritics.length; $4d787bf2c3872ec9$var$i++){
    var $4d787bf2c3872ec9$var$diacritic = $4d787bf2c3872ec9$var$diacritics[$4d787bf2c3872ec9$var$i];
    for(var $4d787bf2c3872ec9$var$j = 0; $4d787bf2c3872ec9$var$j < $4d787bf2c3872ec9$var$diacritic.letters.length; $4d787bf2c3872ec9$var$j++)$4d787bf2c3872ec9$var$diacriticToBase[$4d787bf2c3872ec9$var$diacritic.letters[$4d787bf2c3872ec9$var$j]] = $4d787bf2c3872ec9$var$diacritic.base;
}
var $4d787bf2c3872ec9$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($4d787bf2c3872ec9$var$anyDiacritic, function(match) {
        return $4d787bf2c3872ec9$var$diacriticToBase[match];
    });
};
var $4d787bf2c3872ec9$var$memoizedStripDiacriticsForInput = (0, $131865440b62e30f$export$2e2bcd8739ae039)($4d787bf2c3872ec9$var$stripDiacritics);
var $4d787bf2c3872ec9$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $4d787bf2c3872ec9$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $4d787bf2c3872ec9$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $4d787bf2c3872ec9$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $4d787bf2c3872ec9$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $4d787bf2c3872ec9$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $4d787bf2c3872ec9$var$memoizedStripDiacriticsForInput(input);
            candidate = $4d787bf2c3872ec9$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $4d787bf2c3872ec9$var$_excluded = [
    "innerRef"
];
function $4d787bf2c3872ec9$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_ref, $4d787bf2c3872ec9$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $66ac58ed5b1ea838$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("input", (0, $jNuvi.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $7352cc6d8330e007$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $4d787bf2c3872ec9$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $4d787bf2c3872ec9$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $cQmXV.useRef)(false);
    var isTop = (0, $cQmXV.useRef)(false);
    var touchStart = (0, $cQmXV.useRef)(0);
    var scrollTarget = (0, $cQmXV.useRef)(null);
    var handleEventDelta = (0, $cQmXV.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $4d787bf2c3872ec9$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $cQmXV.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $cQmXV.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $cQmXV.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $cQmXV.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $66ac58ed5b1ea838$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $cQmXV.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $cQmXV.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $4d787bf2c3872ec9$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $4d787bf2c3872ec9$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $4d787bf2c3872ec9$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $4d787bf2c3872ec9$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4d787bf2c3872ec9$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4d787bf2c3872ec9$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $4d787bf2c3872ec9$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $4d787bf2c3872ec9$var$activeScrollLocks = 0;
var $4d787bf2c3872ec9$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4d787bf2c3872ec9$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $cQmXV.useRef)({});
    var scrollTarget = (0, $cQmXV.useRef)(null);
    var addScrollLock = (0, $cQmXV.useCallback)(function(touchScrollTarget) {
        if (!$4d787bf2c3872ec9$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4d787bf2c3872ec9$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4d787bf2c3872ec9$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4d787bf2c3872ec9$var$LOCK_STYLES).forEach(function(key) {
                var val = $4d787bf2c3872ec9$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $4d787bf2c3872ec9$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $4d787bf2c3872ec9$var$preventTouchMove, $4d787bf2c3872ec9$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $4d787bf2c3872ec9$var$preventInertiaScroll, $4d787bf2c3872ec9$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $4d787bf2c3872ec9$var$allowTouchMove, $4d787bf2c3872ec9$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4d787bf2c3872ec9$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $cQmXV.useCallback)(function(touchScrollTarget) {
        if (!$4d787bf2c3872ec9$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4d787bf2c3872ec9$var$activeScrollLocks = Math.max($4d787bf2c3872ec9$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4d787bf2c3872ec9$var$activeScrollLocks < 1) $4d787bf2c3872ec9$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4d787bf2c3872ec9$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $4d787bf2c3872ec9$var$preventTouchMove, $4d787bf2c3872ec9$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $4d787bf2c3872ec9$var$preventInertiaScroll, $4d787bf2c3872ec9$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $4d787bf2c3872ec9$var$allowTouchMove, $4d787bf2c3872ec9$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $cQmXV.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $4d787bf2c3872ec9$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4d787bf2c3872ec9$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $4d787bf2c3872ec9$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $4d787bf2c3872ec9$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $4d787bf2c3872ec9$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $4d787bf2c3872ec9$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)((0, $cQmXV.Fragment), null, lockEnabled && (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("div", {
        onClick: $4d787bf2c3872ec9$var$blurSelectInput,
        css: $4d787bf2c3872ec9$var$_ref2$1
    }), children(targetRef));
}
function $4d787bf2c3872ec9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4d787bf2c3872ec9$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $4d787bf2c3872ec9$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $7352cc6d8330e007$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $4d787bf2c3872ec9$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $4d787bf2c3872ec9$var$RequiredInput$1 = $4d787bf2c3872ec9$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $4d787bf2c3872ec9$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $4d787bf2c3872ec9$var$isIPhone() {
    return $4d787bf2c3872ec9$var$testPlatform(/^iPhone/i);
}
function $4d787bf2c3872ec9$var$isMac() {
    return $4d787bf2c3872ec9$var$testPlatform(/^Mac/i);
}
function $4d787bf2c3872ec9$var$isIPad() {
    return $4d787bf2c3872ec9$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $4d787bf2c3872ec9$var$isMac() && navigator.maxTouchPoints > 1;
}
function $4d787bf2c3872ec9$var$isIOS() {
    return $4d787bf2c3872ec9$var$isIPhone() || $4d787bf2c3872ec9$var$isIPad();
}
function $4d787bf2c3872ec9$var$isAppleDevice() {
    return $4d787bf2c3872ec9$var$isMac() || $4d787bf2c3872ec9$var$isIOS();
}
var $4d787bf2c3872ec9$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $4d787bf2c3872ec9$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $4d787bf2c3872ec9$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $4d787bf2c3872ec9$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $4d787bf2c3872ec9$var$defaultStyles = {
    clearIndicator: (0, $66ac58ed5b1ea838$export$407448d2b89b1813),
    container: (0, $66ac58ed5b1ea838$export$8b22cf2602fb60ce),
    control: (0, $66ac58ed5b1ea838$export$4368d992c4eafac0),
    dropdownIndicator: (0, $66ac58ed5b1ea838$export$f1e1789686576879),
    group: (0, $66ac58ed5b1ea838$export$39b482c5e57630a8),
    groupHeading: (0, $66ac58ed5b1ea838$export$2d1720544b23b823),
    indicatorsContainer: (0, $66ac58ed5b1ea838$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $66ac58ed5b1ea838$export$dda1d9f60106f0e9),
    input: (0, $66ac58ed5b1ea838$export$35e795649ee09318),
    loadingIndicator: (0, $66ac58ed5b1ea838$export$882b5998b3b9117c),
    loadingMessage: (0, $66ac58ed5b1ea838$export$342063e11d6c3cad),
    menu: (0, $66ac58ed5b1ea838$export$953cecd6e717a553),
    menuList: (0, $66ac58ed5b1ea838$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $66ac58ed5b1ea838$export$ae1af26003f05816),
    multiValue: (0, $66ac58ed5b1ea838$export$ffb5f4729a158638),
    multiValueLabel: (0, $66ac58ed5b1ea838$export$9e5f44173e64f162),
    multiValueRemove: (0, $66ac58ed5b1ea838$export$625550452a3fa3ec),
    noOptionsMessage: (0, $66ac58ed5b1ea838$export$3b14a55fb2447963),
    option: (0, $66ac58ed5b1ea838$export$90a7f3efeed30595),
    placeholder: (0, $66ac58ed5b1ea838$export$efccba1c4a2ef57b),
    singleValue: (0, $66ac58ed5b1ea838$export$d141bba7fdc215a3),
    valueContainer: (0, $66ac58ed5b1ea838$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $4d787bf2c3872ec9$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $4d787bf2c3872ec9$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $4d787bf2c3872ec9$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $4d787bf2c3872ec9$var$baseUnit = 4;
// The minimum height of the control
var $4d787bf2c3872ec9$var$controlHeight = 38;
// The amount of space between the control and menu */
var $4d787bf2c3872ec9$var$menuGutter = $4d787bf2c3872ec9$var$baseUnit * 2;
var $4d787bf2c3872ec9$var$spacing = {
    baseUnit: $4d787bf2c3872ec9$var$baseUnit,
    controlHeight: $4d787bf2c3872ec9$var$controlHeight,
    menuGutter: $4d787bf2c3872ec9$var$menuGutter
};
var $4d787bf2c3872ec9$export$4368d992c4eafac0 = {
    borderRadius: $4d787bf2c3872ec9$var$borderRadius,
    colors: $4d787bf2c3872ec9$var$colors,
    spacing: $4d787bf2c3872ec9$var$spacing
};
var $4d787bf2c3872ec9$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $66ac58ed5b1ea838$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $66ac58ed5b1ea838$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $4d787bf2c3872ec9$export$db3b6bfb95261072(),
    formatGroupLabel: $4d787bf2c3872ec9$var$formatGroupLabel,
    getOptionLabel: $4d787bf2c3872ec9$export$8b22cf2602fb60ce,
    getOptionValue: $4d787bf2c3872ec9$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $4d787bf2c3872ec9$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $66ac58ed5b1ea838$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $4d787bf2c3872ec9$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $4d787bf2c3872ec9$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $4d787bf2c3872ec9$var$_isOptionSelected(props, option, selectValue);
    var label = $4d787bf2c3872ec9$var$getOptionLabel(props, option);
    var value = $4d787bf2c3872ec9$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $4d787bf2c3872ec9$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $4d787bf2c3872ec9$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $4d787bf2c3872ec9$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $4d787bf2c3872ec9$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $4d787bf2c3872ec9$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $66ac58ed5b1ea838$export$3466f893ebf79586));
}
function $4d787bf2c3872ec9$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $4d787bf2c3872ec9$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $4d787bf2c3872ec9$var$buildFocusableOptions(props, selectValue) {
    return $4d787bf2c3872ec9$var$buildFocusableOptionsFromCategorizedOptions($4d787bf2c3872ec9$var$buildCategorizedOptions(props, selectValue));
}
function $4d787bf2c3872ec9$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$4d787bf2c3872ec9$var$shouldHideSelectedOptions(props) || !isSelected) && $4d787bf2c3872ec9$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $4d787bf2c3872ec9$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $4d787bf2c3872ec9$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $4d787bf2c3872ec9$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $4d787bf2c3872ec9$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $4d787bf2c3872ec9$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $4d787bf2c3872ec9$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $4d787bf2c3872ec9$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $4d787bf2c3872ec9$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $4d787bf2c3872ec9$var$getOptionValue(props, i) === candidate;
    });
}
function $4d787bf2c3872ec9$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $4d787bf2c3872ec9$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $4d787bf2c3872ec9$var$instanceId = 1;
var $4d787bf2c3872ec9$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $0d52efb306ead7d6$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: "",
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $66ac58ed5b1ea838$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $66ac58ed5b1ea838$export$ef35774e6d314e91)([].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $66ac58ed5b1ea838$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $66ac58ed5b1ea838$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $66ac58ed5b1ea838$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $66ac58ed5b1ea838$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $66ac58ed5b1ea838$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $4d787bf2c3872ec9$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $4d787bf2c3872ec9$var$buildFocusableOptionsWithIds($4d787bf2c3872ec9$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $66ac58ed5b1ea838$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $4d787bf2c3872ec9$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $4d787bf2c3872ec9$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $4d787bf2c3872ec9$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $66ac58ed5b1ea838$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $4d787bf2c3872ec9$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $4d787bf2c3872ec9$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $66ac58ed5b1ea838$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $4d787bf2c3872ec9$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$4d787bf2c3872ec9$var$instanceId);
        _this.state.selectValue = (0, $66ac58ed5b1ea838$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $4d787bf2c3872ec9$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $c180160353ceabc3$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $66ac58ed5b1ea838$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                if ($4d787bf2c3872ec9$var$isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $66ac58ed5b1ea838$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $4d787bf2c3872ec9$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($4d787bf2c3872ec9$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, $4d787bf2c3872ec9$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $4d787bf2c3872ec9$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $4d787bf2c3872ec9$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $4d787bf2c3872ec9$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $cQmXV.createElement($4d787bf2c3872ec9$var$DummyInput, (0, $jNuvi.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $66ac58ed5b1ea838$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $cQmXV.createElement(Input, (0, $jNuvi.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $cQmXV.createElement(Placeholder, (0, $jNuvi.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $cQmXV.createElement(MultiValue, (0, $jNuvi.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $cQmXV.createElement(SingleValue, (0, $jNuvi.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $cQmXV.createElement(ClearIndicator, (0, $jNuvi.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $cQmXV.createElement(LoadingIndicator, (0, $jNuvi.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $cQmXV.createElement(IndicatorSeparator, (0, $jNuvi.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $cQmXV.createElement(DropdownIndicator, (0, $jNuvi.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $cQmXV.createElement(Option, (0, $jNuvi.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $cQmXV.createElement(Group, (0, $jNuvi.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $cQmXV.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $cQmXV.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $cQmXV.createElement((0, $66ac58ed5b1ea838$export$3a1a48c8f6ef640e), (0, $jNuvi.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $cQmXV.createElement(Menu, (0, $jNuvi.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $cQmXV.createElement($4d787bf2c3872ec9$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $cQmXV.createElement(MenuList, (0, $jNuvi.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $cQmXV.createElement(MenuPortal, (0, $jNuvi.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $cQmXV.createElement($4d787bf2c3872ec9$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $cQmXV.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $cQmXV.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $cQmXV.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $cQmXV.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $cQmXV.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $cQmXV.createElement($4d787bf2c3872ec9$var$LiveRegion$1, (0, $jNuvi.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $cQmXV.createElement(SelectContainer, (0, $jNuvi.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $cQmXV.createElement(Control, (0, $jNuvi.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $cQmXV.createElement(ValueContainer, (0, $jNuvi.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $cQmXV.createElement(IndicatorsContainer, (0, $jNuvi.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $66ac58ed5b1ea838$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $4d787bf2c3872ec9$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $4d787bf2c3872ec9$var$buildFocusableOptionsWithIds($4d787bf2c3872ec9$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $4d787bf2c3872ec9$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $4d787bf2c3872ec9$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $4d787bf2c3872ec9$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $66ac58ed5b1ea838$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $cQmXV.Component));
$4d787bf2c3872ec9$export$25ce5a424b770e84.defaultProps = $4d787bf2c3872ec9$export$407448d2b89b1813;




var $6hsLN = parcelRequire("6hsLN");

var $094a32588e28b628$exports = {};
var $0b43e070152093b4$exports = {};
var $3e8da5e2791e2158$exports = {};
var $1fadc115ae165114$exports = {};
function $1fadc115ae165114$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1fadc115ae165114$exports = $1fadc115ae165114$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1fadc115ae165114$exports.__esModule = true, $1fadc115ae165114$exports["default"] = $1fadc115ae165114$exports, $1fadc115ae165114$var$_typeof(obj);
}
$1fadc115ae165114$exports = $1fadc115ae165114$var$_typeof, $1fadc115ae165114$exports.__esModule = true, $1fadc115ae165114$exports["default"] = $1fadc115ae165114$exports;


var $3e8da5e2791e2158$var$_typeof = $1fadc115ae165114$exports.default;
var $8b069487b861d45d$exports = {};

var $8b069487b861d45d$var$_typeof = $1fadc115ae165114$exports.default;
function $8b069487b861d45d$var$_toPrimitive(input, hint) {
    if ($8b069487b861d45d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8b069487b861d45d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$8b069487b861d45d$exports = $8b069487b861d45d$var$_toPrimitive, $8b069487b861d45d$exports.__esModule = true, $8b069487b861d45d$exports["default"] = $8b069487b861d45d$exports;


function $3e8da5e2791e2158$var$_toPropertyKey(arg) {
    var key = $8b069487b861d45d$exports(arg, "string");
    return $3e8da5e2791e2158$var$_typeof(key) === "symbol" ? key : String(key);
}
$3e8da5e2791e2158$exports = $3e8da5e2791e2158$var$_toPropertyKey, $3e8da5e2791e2158$exports.__esModule = true, $3e8da5e2791e2158$exports["default"] = $3e8da5e2791e2158$exports;


function $0b43e070152093b4$var$_defineProperty(obj, key, value) {
    key = $3e8da5e2791e2158$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$0b43e070152093b4$exports = $0b43e070152093b4$var$_defineProperty, $0b43e070152093b4$exports.__esModule = true, $0b43e070152093b4$exports["default"] = $0b43e070152093b4$exports;


function $094a32588e28b628$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $094a32588e28b628$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $094a32588e28b628$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0b43e070152093b4$exports(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $094a32588e28b628$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
$094a32588e28b628$exports = $094a32588e28b628$var$_objectSpread2, $094a32588e28b628$exports.__esModule = true, $094a32588e28b628$exports["default"] = $094a32588e28b628$exports;


var $a765d9a9f5dc8c5c$exports = {};
var $c6b99e1f4de879e7$exports = {};
function $c6b99e1f4de879e7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$c6b99e1f4de879e7$exports = $c6b99e1f4de879e7$var$_arrayWithHoles, $c6b99e1f4de879e7$exports.__esModule = true, $c6b99e1f4de879e7$exports["default"] = $c6b99e1f4de879e7$exports;


var $3d3d8231872ce558$exports = {};
function $3d3d8231872ce558$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$3d3d8231872ce558$exports = $3d3d8231872ce558$var$_iterableToArrayLimit, $3d3d8231872ce558$exports.__esModule = true, $3d3d8231872ce558$exports["default"] = $3d3d8231872ce558$exports;


var $787ba62d7c399a5b$exports = {};
var $bfbce13b9790a9c5$exports = {};
function $bfbce13b9790a9c5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$bfbce13b9790a9c5$exports = $bfbce13b9790a9c5$var$_arrayLikeToArray, $bfbce13b9790a9c5$exports.__esModule = true, $bfbce13b9790a9c5$exports["default"] = $bfbce13b9790a9c5$exports;


function $787ba62d7c399a5b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bfbce13b9790a9c5$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bfbce13b9790a9c5$exports(o, minLen);
}
$787ba62d7c399a5b$exports = $787ba62d7c399a5b$var$_unsupportedIterableToArray, $787ba62d7c399a5b$exports.__esModule = true, $787ba62d7c399a5b$exports["default"] = $787ba62d7c399a5b$exports;


var $50c4642624551063$exports = {};
function $50c4642624551063$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$50c4642624551063$exports = $50c4642624551063$var$_nonIterableRest, $50c4642624551063$exports.__esModule = true, $50c4642624551063$exports["default"] = $50c4642624551063$exports;


function $a765d9a9f5dc8c5c$var$_slicedToArray(arr, i) {
    return $c6b99e1f4de879e7$exports(arr) || $3d3d8231872ce558$exports(arr, i) || $787ba62d7c399a5b$exports(arr, i) || $50c4642624551063$exports();
}
$a765d9a9f5dc8c5c$exports = $a765d9a9f5dc8c5c$var$_slicedToArray, $a765d9a9f5dc8c5c$exports.__esModule = true, $a765d9a9f5dc8c5c$exports["default"] = $a765d9a9f5dc8c5c$exports;


var $96584b85927f484c$exports = {};
var $6cf880f961de4b7c$exports = {};
function $6cf880f961de4b7c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$6cf880f961de4b7c$exports = $6cf880f961de4b7c$var$_objectWithoutPropertiesLoose, $6cf880f961de4b7c$exports.__esModule = true, $6cf880f961de4b7c$exports["default"] = $6cf880f961de4b7c$exports;


function $96584b85927f484c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6cf880f961de4b7c$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$96584b85927f484c$exports = $96584b85927f484c$var$_objectWithoutProperties, $96584b85927f484c$exports.__esModule = true, $96584b85927f484c$exports["default"] = $96584b85927f484c$exports;


var $b52c6f40fad7c206$exports = {};
function $b52c6f40fad7c206$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b52c6f40fad7c206$exports = $b52c6f40fad7c206$var$_classCallCheck, $b52c6f40fad7c206$exports.__esModule = true, $b52c6f40fad7c206$exports["default"] = $b52c6f40fad7c206$exports;


var $a1714f0e5ac9606f$exports = {};

function $a1714f0e5ac9606f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3e8da5e2791e2158$exports(descriptor.key), descriptor);
    }
}
function $a1714f0e5ac9606f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a1714f0e5ac9606f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a1714f0e5ac9606f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$a1714f0e5ac9606f$exports = $a1714f0e5ac9606f$var$_createClass, $a1714f0e5ac9606f$exports.__esModule = true, $a1714f0e5ac9606f$exports["default"] = $a1714f0e5ac9606f$exports;


var $5576d3ec98792625$exports = {};
var $0ca20105bc4beead$exports = {};
function $0ca20105bc4beead$var$_setPrototypeOf(o, p) {
    $0ca20105bc4beead$exports = $0ca20105bc4beead$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $0ca20105bc4beead$exports.__esModule = true, $0ca20105bc4beead$exports["default"] = $0ca20105bc4beead$exports;
    return $0ca20105bc4beead$var$_setPrototypeOf(o, p);
}
$0ca20105bc4beead$exports = $0ca20105bc4beead$var$_setPrototypeOf, $0ca20105bc4beead$exports.__esModule = true, $0ca20105bc4beead$exports["default"] = $0ca20105bc4beead$exports;


function $5576d3ec98792625$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0ca20105bc4beead$exports(subClass, superClass);
}
$5576d3ec98792625$exports = $5576d3ec98792625$var$_inherits, $5576d3ec98792625$exports.__esModule = true, $5576d3ec98792625$exports["default"] = $5576d3ec98792625$exports;


var $3675b70f55b0c7a4$exports = {};
var $e09d43b1bfc8a96c$exports = {};
function $e09d43b1bfc8a96c$var$_getPrototypeOf(o) {
    $e09d43b1bfc8a96c$exports = $e09d43b1bfc8a96c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $e09d43b1bfc8a96c$exports.__esModule = true, $e09d43b1bfc8a96c$exports["default"] = $e09d43b1bfc8a96c$exports;
    return $e09d43b1bfc8a96c$var$_getPrototypeOf(o);
}
$e09d43b1bfc8a96c$exports = $e09d43b1bfc8a96c$var$_getPrototypeOf, $e09d43b1bfc8a96c$exports.__esModule = true, $e09d43b1bfc8a96c$exports["default"] = $e09d43b1bfc8a96c$exports;


var $1a242f5a8e90ad16$exports = {};
function $1a242f5a8e90ad16$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$1a242f5a8e90ad16$exports = $1a242f5a8e90ad16$var$_isNativeReflectConstruct, $1a242f5a8e90ad16$exports.__esModule = true, $1a242f5a8e90ad16$exports["default"] = $1a242f5a8e90ad16$exports;


var $ae8df7c1bb88bb22$exports = {};

var $ae8df7c1bb88bb22$var$_typeof = $1fadc115ae165114$exports.default;
var $1516f6e855cfe96f$exports = {};
function $1516f6e855cfe96f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$1516f6e855cfe96f$exports = $1516f6e855cfe96f$var$_assertThisInitialized, $1516f6e855cfe96f$exports.__esModule = true, $1516f6e855cfe96f$exports["default"] = $1516f6e855cfe96f$exports;


function $ae8df7c1bb88bb22$var$_possibleConstructorReturn(self, call) {
    if (call && ($ae8df7c1bb88bb22$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1516f6e855cfe96f$exports(self);
}
$ae8df7c1bb88bb22$exports = $ae8df7c1bb88bb22$var$_possibleConstructorReturn, $ae8df7c1bb88bb22$exports.__esModule = true, $ae8df7c1bb88bb22$exports["default"] = $ae8df7c1bb88bb22$exports;


function $3675b70f55b0c7a4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1a242f5a8e90ad16$exports();
    return function _createSuperInternal() {
        var Super = $e09d43b1bfc8a96c$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e09d43b1bfc8a96c$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ae8df7c1bb88bb22$exports(this, result);
    };
}
$3675b70f55b0c7a4$exports = $3675b70f55b0c7a4$var$_createSuper, $3675b70f55b0c7a4$exports.__esModule = true, $3675b70f55b0c7a4$exports["default"] = $3675b70f55b0c7a4$exports;


var $a3822c3daeff0685$exports = {};
var $2c9ec30cade5873b$exports = {};

function $2c9ec30cade5873b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bfbce13b9790a9c5$exports(arr);
}
$2c9ec30cade5873b$exports = $2c9ec30cade5873b$var$_arrayWithoutHoles, $2c9ec30cade5873b$exports.__esModule = true, $2c9ec30cade5873b$exports["default"] = $2c9ec30cade5873b$exports;


var $c4b1bfc30bec1e46$exports = {};
function $c4b1bfc30bec1e46$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$c4b1bfc30bec1e46$exports = $c4b1bfc30bec1e46$var$_iterableToArray, $c4b1bfc30bec1e46$exports.__esModule = true, $c4b1bfc30bec1e46$exports["default"] = $c4b1bfc30bec1e46$exports;



var $1cded0a931f877d7$exports = {};
function $1cded0a931f877d7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$1cded0a931f877d7$exports = $1cded0a931f877d7$var$_nonIterableSpread, $1cded0a931f877d7$exports.__esModule = true, $1cded0a931f877d7$exports["default"] = $1cded0a931f877d7$exports;


function $a3822c3daeff0685$var$_toConsumableArray(arr) {
    return $2c9ec30cade5873b$exports(arr) || $c4b1bfc30bec1e46$exports(arr) || $787ba62d7c399a5b$exports(arr) || $1cded0a931f877d7$exports();
}
$a3822c3daeff0685$exports = $a3822c3daeff0685$var$_toConsumableArray, $a3822c3daeff0685$exports.__esModule = true, $a3822c3daeff0685$exports["default"] = $a3822c3daeff0685$exports;




var $24eae605f6f35ee6$exports = {};
function $24eae605f6f35ee6$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$24eae605f6f35ee6$exports = $24eae605f6f35ee6$var$_taggedTemplateLiteral, $24eae605f6f35ee6$exports.__esModule = true, $24eae605f6f35ee6$exports["default"] = $24eae605f6f35ee6$exports;



parcelRequire("3h5eW");


var $e9e80384c89540c4$var$StateManagedSelect = /*#__PURE__*/ (0, $cQmXV.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $e7b1f27543b51422$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $cQmXV.createElement((0, $4d787bf2c3872ec9$export$25ce5a424b770e84), (0, $jNuvi.default)({
        ref: ref
    }, baseSelectProps));
});
var $e9e80384c89540c4$export$2e2bcd8739ae039 = $e9e80384c89540c4$var$StateManagedSelect;
var $e9e80384c89540c4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $cQmXV.useMemo)(function() {
        return (0, $6hsLN.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $176d799fde64267c$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



// src/index.ts


var $cQmXV = parcelRequire("cQmXV");
var $ddbaec811f2479ef$exports = {};
"use strict";
Object.defineProperty($ddbaec811f2479ef$exports, "__esModule", {
    value: true
});
function $ddbaec811f2479ef$var$composeRefs() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    if (refs.length === 2) return $ddbaec811f2479ef$var$composeTwoRefs(refs[0], refs[1]) || null;
    var composedRef = refs.slice(1).reduce(function(semiCombinedRef, refToInclude) {
        return $ddbaec811f2479ef$var$composeTwoRefs(semiCombinedRef, refToInclude);
    }, refs[0]);
    return composedRef || null;
}
$ddbaec811f2479ef$exports.default = $ddbaec811f2479ef$var$composeRefs;
var $ddbaec811f2479ef$var$composedRefCache = new WeakMap();
function $ddbaec811f2479ef$var$composeTwoRefs(ref1, ref2) {
    if (ref1 && ref2) {
        var ref1Cache = $ddbaec811f2479ef$var$composedRefCache.get(ref1) || new WeakMap();
        $ddbaec811f2479ef$var$composedRefCache.set(ref1, ref1Cache);
        var composedRef = ref1Cache.get(ref2) || function(instance) {
            $ddbaec811f2479ef$var$updateRef(ref1, instance);
            $ddbaec811f2479ef$var$updateRef(ref2, instance);
        };
        ref1Cache.set(ref2, composedRef);
        return composedRef;
    }
    if (!ref1) return ref2;
    else return ref1;
}
function $ddbaec811f2479ef$var$updateRef(ref, instance) {
    if (typeof ref === "function") ref(instance);
    else ref.current = instance;
}



var $7uT18 = parcelRequire("7uT18");
// src/index.ts

var $cQmXV = parcelRequire("cQmXV");
var $0f3b2da115c44f9b$var$EMPTY_VALUE = Symbol("useLazyRef empty value");
var $0f3b2da115c44f9b$export$fd27aa36f007ec3d = (init)=>{
    const resultRef = (0, $cQmXV.useRef)($0f3b2da115c44f9b$var$EMPTY_VALUE);
    if (resultRef.current === $0f3b2da115c44f9b$var$EMPTY_VALUE) resultRef.current = init();
    return resultRef;
};



var $cQmXV = parcelRequire("cQmXV");
function $af58c99b2a45b384$export$2e2bcd8739ae039() {
    var isMountedRef = (0, $cQmXV.useRef)(false);
    (0, $cQmXV.useEffect)(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}



var $cQmXV = parcelRequire("cQmXV");

var $1145bf148db4d4ce$export$2e2bcd8739ae039 = function useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(value);
    (0, $3278bb50a73083cc$export$2e2bcd8739ae039)(function() {
        ref.current = value;
    });
    return ref;
};


// src/option_result.ts
function $ead4261cb9659cee$export$8146e38189b4f4dc(result) {
    const self = {
        isOk: ()=>true,
        isOkAnd: (fn)=>fn(result),
        isErr: ()=>false,
        isErrAnd: ()=>false,
        ok: ()=>$ead4261cb9659cee$export$9f9d0139d032da4f(result),
        err: ()=>$ead4261cb9659cee$export$57ca7e07b341709d(),
        map: (fn)=>$ead4261cb9659cee$export$8146e38189b4f4dc(fn(result)),
        mapOr: (_, fn)=>fn(result),
        mapOrElse: (_, fn)=>fn(result),
        mapErr: ()=>$ead4261cb9659cee$export$8146e38189b4f4dc(result),
        expect: ()=>result,
        expectErr: (msg)=>{
            throw new Error(msg);
        },
        unwrap: ()=>result,
        unwrapErr: ()=>{
            throw new Error(`${result}`);
        },
        unwrapOr: ()=>result,
        unwrapOrElse: ()=>result,
        and: (res)=>res,
        andThen: (getRes)=>getRes(result),
        or: ()=>$ead4261cb9659cee$export$8146e38189b4f4dc(result),
        orElse: ()=>$ead4261cb9659cee$export$8146e38189b4f4dc(result)
    };
    return self;
}
function $ead4261cb9659cee$export$3659d3f2d3dfceb8(err) {
    const self = {
        isOk: ()=>false,
        isOkAnd: ()=>false,
        isErr: ()=>true,
        isErrAnd: (fn)=>fn(err),
        ok: ()=>$ead4261cb9659cee$export$57ca7e07b341709d(),
        err: ()=>$ead4261cb9659cee$export$9f9d0139d032da4f(err),
        map: ()=>$ead4261cb9659cee$export$3659d3f2d3dfceb8(err),
        mapOr: (defaultValue)=>defaultValue,
        mapOrElse: (getDefaultValue)=>getDefaultValue(err),
        mapErr: (fn)=>$ead4261cb9659cee$export$3659d3f2d3dfceb8(fn(err)),
        expect: (msg)=>{
            throw new Error(msg);
        },
        expectErr: ()=>err,
        unwrap: ()=>{
            throw new Error(`${err}`);
        },
        unwrapErr: ()=>err,
        unwrapOr: (defaultValue)=>defaultValue,
        unwrapOrElse: (getDefaultValue)=>getDefaultValue(err),
        and: ()=>$ead4261cb9659cee$export$3659d3f2d3dfceb8(err),
        andThen: ()=>$ead4261cb9659cee$export$3659d3f2d3dfceb8(err),
        or: (res)=>res,
        orElse: (getRes)=>getRes(err)
    };
    return self;
}
function $ead4261cb9659cee$export$57ca7e07b341709d() {
    const self = {
        and: ()=>$ead4261cb9659cee$export$57ca7e07b341709d(),
        andThen: ()=>$ead4261cb9659cee$export$57ca7e07b341709d(),
        expect: (msg)=>{
            throw new Error(msg);
        },
        filter: ()=>self,
        isSome: ()=>false,
        isSomeAnd: ()=>false,
        isNone: ()=>true,
        map: ()=>$ead4261cb9659cee$export$57ca7e07b341709d(),
        mapOr: (defaultValue)=>defaultValue,
        mapOrElse: (getDefaultValue)=>getDefaultValue(),
        okOr: (err)=>$ead4261cb9659cee$export$3659d3f2d3dfceb8(err),
        okOrElse: (getErr)=>$ead4261cb9659cee$export$3659d3f2d3dfceb8(getErr()),
        or: (opt)=>opt,
        orElse: (fn)=>fn(),
        unwrap: ()=>{
            throw new Error("panic! call `unwrap` on a `None` value");
        },
        unwrapOr: (defaultValue)=>defaultValue,
        unwrapOrElse: (getDefaultValue)=>getDefaultValue(),
        xor: (opt)=>{
            if (opt.isSome()) return opt;
            return self;
        }
    };
    return self;
}
function $ead4261cb9659cee$export$9f9d0139d032da4f(value) {
    const self = {
        and: (opt)=>opt,
        andThen: (fn)=>fn(value),
        expect: ()=>value,
        filter: (fn)=>{
            if (fn(value)) return self;
            return $ead4261cb9659cee$export$57ca7e07b341709d();
        },
        isSome: ()=>true,
        isSomeAnd: (fn)=>fn(value),
        isNone: ()=>false,
        map: (fn)=>$ead4261cb9659cee$export$9f9d0139d032da4f(fn(value)),
        mapOr: (_, fn)=>fn(value),
        mapOrElse: (_, fn)=>fn(value),
        okOr: ()=>$ead4261cb9659cee$export$8146e38189b4f4dc(value),
        okOrElse: ()=>$ead4261cb9659cee$export$8146e38189b4f4dc(value),
        or: ()=>self,
        orElse: ()=>self,
        unwrap: ()=>value,
        unwrapOr: ()=>value,
        unwrapOrElse: ()=>value,
        xor: (opt)=>{
            if (opt.isNone()) return self;
            return $ead4261cb9659cee$export$57ca7e07b341709d();
        }
    };
    return self;
}
// src/to_option.ts
function $ead4261cb9659cee$export$d12b31a3d4a86d64(arg) {
    if (arg === null || arg === void 0) return $ead4261cb9659cee$export$57ca7e07b341709d();
    return $ead4261cb9659cee$export$9f9d0139d032da4f(arg);
}
// src/get_result.ts
function $ead4261cb9659cee$export$ec795fdf61e2a255(promise) {
    return promise.then((response)=>$ead4261cb9659cee$export$8146e38189b4f4dc(response), (err)=>$ead4261cb9659cee$export$3659d3f2d3dfceb8(err));
}
// src/unwrap.ts
function $ead4261cb9659cee$export$debb760848ca95a(value) {
    if (value === null || value === void 0) throw new Error(`panic! call \`unwrap\` on a \`${value}\` value`);
    return value;
}
// src/unwrap_or.ts
function $ead4261cb9659cee$export$4b9b4f9ad6fb7d88(value, defaultValue) {
    if (value === null || value === void 0) return defaultValue;
    return value;
}
// src/unwrap_or_else.ts
function $ead4261cb9659cee$export$aa9d84ec3ba69607(value, getDefaultValue) {
    if (value === null || value === void 0) return getDefaultValue();
    return value;
}
// src/try_catch.ts
function $ead4261cb9659cee$export$d234c058d1d4e435(fn) {
    let result;
    try {
        result = fn();
    } catch (e) {
        return $ead4261cb9659cee$export$3659d3f2d3dfceb8(e);
    }
    return $ead4261cb9659cee$export$8146e38189b4f4dc(result);
}


var $615c34c1a47f7d7b$var$e = setTimeout;
function $615c34c1a47f7d7b$var$t(t, n) {
    var u = n.useCachedSetTimeout ? $615c34c1a47f7d7b$var$e : setTimeout;
    return new Promise(function(e) {
        u(e, t);
    });
}
function $615c34c1a47f7d7b$var$n(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, u = n.useCachedSetTimeout, r = $615c34c1a47f7d7b$var$t(e, {
        useCachedSetTimeout: u
    });
    function o(e) {
        return r.then(function() {
            return e;
        });
    }
    return o.then = function() {
        return r.then.apply(r, arguments);
    }, o.catch = Promise.resolve().catch, o;
}
var $615c34c1a47f7d7b$export$2e2bcd8739ae039 = $615c34c1a47f7d7b$var$n;


var $b43b108995e2bf6c$var$CHECK_TIMEOUT = 300;
function $b43b108995e2bf6c$export$6221d452fabeeca6(MenuList2) {
    function WrappedMenuList(props) {
        const { selectProps: selectProps, innerRef: innerRef } = props;
        const { handleScrolledToBottom: handleScrolledToBottom, shouldLoadMore: shouldLoadMore } = selectProps;
        const checkTimeoutRef = (0, $cQmXV.useRef)(null);
        const menuListRef = (0, $cQmXV.useRef)(null);
        const shouldHandle = (0, $cQmXV.useCallback)(()=>{
            const el = menuListRef.current;
            if (!el) return false;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = el;
            return shouldLoadMore(scrollHeight, clientHeight, scrollTop);
        }, [
            shouldLoadMore
        ]);
        const checkAndHandle = (0, $cQmXV.useCallback)(()=>{
            if (shouldHandle()) {
                if (handleScrolledToBottom) handleScrolledToBottom();
            }
        }, [
            shouldHandle,
            handleScrolledToBottom
        ]);
        const setCheckAndHandleTimeout = (0, $cQmXV.useMemo)(()=>{
            const res = ()=>{
                checkAndHandle();
                checkTimeoutRef.current = setTimeout(res, $b43b108995e2bf6c$var$CHECK_TIMEOUT);
            };
            return res;
        }, [
            checkAndHandle
        ]);
        (0, $cQmXV.useEffect)(()=>{
            setCheckAndHandleTimeout();
            return ()=>{
                if (checkTimeoutRef.current) clearTimeout(checkTimeoutRef.current);
            };
        }, []);
        return /* @__PURE__ */ (0, $7uT18.jsx)(MenuList2, {
            ...props,
            innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($ddbaec811f2479ef$exports)))(innerRef, menuListRef)
        });
    }
    return WrappedMenuList;
}
// src/components/useComponents.ts
var $b43b108995e2bf6c$var$MenuList = $b43b108995e2bf6c$export$6221d452fabeeca6(// biome-ignore lint/suspicious/noExplicitAny: fix types
(0, $66ac58ed5b1ea838$export$db3b6bfb95261072).MenuList);
var $b43b108995e2bf6c$export$7c355de7fd01eb66 = (components)=>(0, $cQmXV.useMemo)(()=>({
            MenuList: $b43b108995e2bf6c$var$MenuList,
            ...components
        }), [
        components
    ]);
// src/defaultReduceOptions.ts
var $b43b108995e2bf6c$var$defaultReduceOptions = (prevOptions, loadedOptions)=>[
        ...prevOptions,
        ...loadedOptions
    ];
// src/defaultShouldLoadMore.ts
var $b43b108995e2bf6c$var$AVAILABLE_DELTA = 10;
var $b43b108995e2bf6c$var$defaultShouldLoadMore = (scrollHeight, clientHeight, scrollTop)=>{
    const bottomBorder = scrollHeight - clientHeight - $b43b108995e2bf6c$var$AVAILABLE_DELTA;
    return bottomBorder < scrollTop;
};
// src/getInitialCache.ts
var $b43b108995e2bf6c$var$getInitialCache = (params)=>({
        isFirstLoad: true,
        options: [],
        hasMore: true,
        isLoading: false,
        lockedUntil: 0,
        additional: params.additional
    });
// src/getInitialOptionsCache.ts
var $b43b108995e2bf6c$var$getInitialOptionsCache = ({ options: options, defaultOptions: defaultOptions, additional: additional, defaultAdditional: defaultAdditional })=>{
    const initialOptions = defaultOptions === true ? null : Array.isArray(defaultOptions) ? defaultOptions : options;
    if (initialOptions) return {
        "": {
            isFirstLoad: false,
            isLoading: false,
            options: initialOptions,
            hasMore: true,
            lockedUntil: 0,
            additional: defaultAdditional || additional
        }
    };
    return {};
};
// src/validateResponse.ts
var $b43b108995e2bf6c$var$errorText = '[react-select-async-paginate] response of "loadOptions" should be an object with "options" prop, which contains array of options.';
var $b43b108995e2bf6c$export$52cda85d683ca4e2 = (response)=>{
    if (!response) return false;
    const { options: options, hasMore: hasMore } = response;
    if (!Array.isArray(options)) return false;
    if (typeof hasMore !== "boolean" && typeof hasMore !== "undefined") return false;
    return true;
};
var $b43b108995e2bf6c$export$fcee8a88e10e2f31 = (response)=>{
    if (!$b43b108995e2bf6c$export$52cda85d683ca4e2(response)) {
        console.error($b43b108995e2bf6c$var$errorText, "Received:", response);
        throw new Error($b43b108995e2bf6c$var$errorText);
    }
    return true;
};
// src/requestOptions.ts
var $b43b108995e2bf6c$var$requestOptions = async (caller, paramsRef, optionsCacheRef, debounceTimeout, setOptionsCache, reduceOptions, isMountedRef, clearCacheOnSearchChange)=>{
    const currentInputValue = paramsRef.current.inputValue;
    const isCacheEmpty = !optionsCacheRef.current[currentInputValue];
    const currentOptions = isCacheEmpty ? $b43b108995e2bf6c$var$getInitialCache(paramsRef.current) : optionsCacheRef.current[currentInputValue];
    if (currentOptions.isLoading || !currentOptions.hasMore || currentOptions.lockedUntil > Date.now()) return;
    setOptionsCache((prevOptionsCache)=>{
        if (clearCacheOnSearchChange && caller === "input-change") return {
            [currentInputValue]: {
                ...currentOptions,
                isLoading: true
            }
        };
        return {
            ...prevOptionsCache,
            [currentInputValue]: {
                ...currentOptions,
                isLoading: true
            }
        };
    });
    if (debounceTimeout > 0 && caller === "input-change") {
        await (0, $615c34c1a47f7d7b$export$2e2bcd8739ae039)(debounceTimeout);
        const newInputValue = paramsRef.current.inputValue;
        if (currentInputValue !== newInputValue) {
            setOptionsCache((prevOptionsCache)=>{
                if (isCacheEmpty) {
                    const { [currentInputValue]: _itemForDelete, ...restCache } = prevOptionsCache;
                    return restCache;
                }
                return {
                    ...prevOptionsCache,
                    [currentInputValue]: {
                        ...currentOptions,
                        isLoading: false
                    }
                };
            });
            return;
        }
    }
    const { loadOptions: loadOptions, reloadOnErrorTimeout: reloadOnErrorTimeout = 0 } = paramsRef.current;
    const result = await (0, $ead4261cb9659cee$export$ec795fdf61e2a255)(Promise.resolve().then(()=>loadOptions(currentInputValue, currentOptions.options, currentOptions.additional)));
    if (!isMountedRef.current) return;
    if (result.isErr()) {
        setOptionsCache((prevOptionsCache)=>({
                ...prevOptionsCache,
                [currentInputValue]: {
                    ...currentOptions,
                    isLoading: false,
                    lockedUntil: Date.now() + reloadOnErrorTimeout
                }
            }));
        return;
    }
    const response = result.unwrap();
    if ($b43b108995e2bf6c$export$fcee8a88e10e2f31(response)) {
        const { options: options, hasMore: hasMore } = response;
        const newAdditional = Object.hasOwn(response, "additional") ? response.additional : currentOptions.additional;
        setOptionsCache((prevOptionsCache)=>({
                ...prevOptionsCache,
                [currentInputValue]: {
                    ...currentOptions,
                    options: reduceOptions(currentOptions.options, options, newAdditional),
                    hasMore: !!hasMore,
                    isLoading: false,
                    isFirstLoad: false,
                    additional: newAdditional
                }
            }));
    }
};
// src/useAsyncPaginateBase.ts
var $b43b108995e2bf6c$var$increaseStateId = (prevStateId)=>prevStateId + 1;
var $b43b108995e2bf6c$export$1bc6bc7e15a5c0d3 = (params, deps = [])=>{
    const { clearCacheOnSearchChange: clearCacheOnSearchChange = false, clearCacheOnMenuClose: clearCacheOnMenuClose = false, defaultOptions: defaultOptions, loadOptionsOnMenuOpen: loadOptionsOnMenuOpen = true, debounceTimeout: debounceTimeout = 0, inputValue: inputValue, menuIsOpen: menuIsOpen, filterOption: filterOption = null, reduceOptions: reduceOptions = $b43b108995e2bf6c$var$defaultReduceOptions, shouldLoadMore: shouldLoadMore = $b43b108995e2bf6c$var$defaultShouldLoadMore, mapOptionsForMenu: mapOptionsForMenu } = params;
    const menuIsOpenRef = (0, $1145bf148db4d4ce$export$2e2bcd8739ae039)(menuIsOpen);
    const isMountedRef = (0, $af58c99b2a45b384$export$2e2bcd8739ae039)();
    const reduceOptionsRef = (0, $1145bf148db4d4ce$export$2e2bcd8739ae039)(reduceOptions);
    const loadOptionsOnMenuOpenRef = (0, $1145bf148db4d4ce$export$2e2bcd8739ae039)(loadOptionsOnMenuOpen);
    const isInitRef = (0, $cQmXV.useRef)(true);
    const paramsRef = (0, $cQmXV.useRef)(params);
    paramsRef.current = params;
    const [_stateId, setStateId] = (0, $cQmXV.useState)(0);
    const optionsCacheRef = (0, $0f3b2da115c44f9b$export$fd27aa36f007ec3d)(()=>$b43b108995e2bf6c$var$getInitialOptionsCache(params));
    const callRequestOptionsRef = (0, $1145bf148db4d4ce$export$2e2bcd8739ae039)((caller)=>{
        $b43b108995e2bf6c$var$requestOptions(caller, paramsRef, optionsCacheRef, debounceTimeout, (reduceState)=>{
            optionsCacheRef.current = reduceState(optionsCacheRef.current);
            if (isMountedRef.current) setStateId($b43b108995e2bf6c$var$increaseStateId);
        }, reduceOptionsRef.current, isMountedRef, clearCacheOnSearchChange);
    });
    const handleScrolledToBottom = (0, $cQmXV.useCallback)(()=>{
        const currentInputValue = paramsRef.current.inputValue;
        const currentOptions2 = optionsCacheRef.current[currentInputValue];
        if (currentOptions2) callRequestOptionsRef.current("menu-scroll");
    }, [
        callRequestOptionsRef,
        optionsCacheRef
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (isInitRef.current) isInitRef.current = false;
        else {
            optionsCacheRef.current = {};
            setStateId($b43b108995e2bf6c$var$increaseStateId);
        }
        if (defaultOptions === true) callRequestOptionsRef.current("autoload");
    }, deps);
    (0, $cQmXV.useEffect)(()=>{
        if (menuIsOpenRef.current && !optionsCacheRef.current[inputValue]) callRequestOptionsRef.current("input-change");
    }, [
        callRequestOptionsRef,
        inputValue,
        menuIsOpenRef,
        optionsCacheRef
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (menuIsOpen) {
            if (!optionsCacheRef.current[""] && loadOptionsOnMenuOpenRef.current) {
                callRequestOptionsRef.current("menu-toggle");
                return;
            }
            return;
        }
        if (clearCacheOnMenuClose) {
            optionsCacheRef.current = {};
            setStateId($b43b108995e2bf6c$var$increaseStateId);
        }
    }, [
        callRequestOptionsRef,
        loadOptionsOnMenuOpenRef,
        menuIsOpen,
        optionsCacheRef,
        clearCacheOnMenuClose
    ]);
    const currentOptions = optionsCacheRef.current[inputValue] || $b43b108995e2bf6c$var$getInitialCache(params);
    const options = (0, $cQmXV.useMemo)(()=>{
        if (!mapOptionsForMenu) return currentOptions.options;
        return mapOptionsForMenu(currentOptions.options);
    }, [
        currentOptions.options,
        mapOptionsForMenu
    ]);
    return {
        handleScrolledToBottom: handleScrolledToBottom,
        shouldLoadMore: shouldLoadMore,
        filterOption: filterOption,
        isLoading: currentOptions.isLoading || currentOptions.lockedUntil > Date.now(),
        isFirstLoad: currentOptions.isFirstLoad,
        options: options
    };
};
// src/useAsyncPaginate.ts
var $b43b108995e2bf6c$export$59c1df8d705d4a91 = (params, deps = [])=>{
    const { inputValue: inputValueParam, menuIsOpen: menuIsOpenParam, defaultInputValue: defaultInputValueParam, defaultMenuIsOpen: defaultMenuIsOpenParam, onInputChange: onInputChangeParam, onMenuClose: onMenuCloseParam, onMenuOpen: onMenuOpenParam } = params;
    const [inputValueState, setInputValue] = (0, $cQmXV.useState)(defaultInputValueParam || "");
    const [menuIsOpenState, setMenuIsOpen] = (0, $cQmXV.useState)(!!defaultMenuIsOpenParam);
    const inputValue = typeof inputValueParam === "string" ? inputValueParam : inputValueState;
    const menuIsOpen = typeof menuIsOpenParam === "boolean" ? menuIsOpenParam : menuIsOpenState;
    const onInputChange = (0, $cQmXV.useCallback)((nextInputValue, actionMeta)=>{
        if (onInputChangeParam) onInputChangeParam(nextInputValue, actionMeta);
        setInputValue(nextInputValue);
    }, [
        onInputChangeParam
    ]);
    const onMenuClose = (0, $cQmXV.useCallback)(()=>{
        if (onMenuCloseParam) onMenuCloseParam();
        setMenuIsOpen(false);
    }, [
        onMenuCloseParam
    ]);
    const onMenuOpen = (0, $cQmXV.useCallback)(()=>{
        if (onMenuOpenParam) onMenuOpenParam();
        setMenuIsOpen(true);
    }, [
        onMenuOpenParam
    ]);
    const baseResult = $b43b108995e2bf6c$export$1bc6bc7e15a5c0d3({
        ...params,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen
    }, deps);
    return {
        ...baseResult,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen
    };
};
var $b43b108995e2bf6c$var$defaultCacheUniqs = [];
var $b43b108995e2bf6c$var$defaultComponents2 = {};
function $b43b108995e2bf6c$export$cfb48882cd279b8a(SelectComponent) {
    function WithAsyncPaginate(props) {
        const { components: components = $b43b108995e2bf6c$var$defaultComponents2, selectRef: selectRef, isLoading: isLoadingProp, cacheUniqs: cacheUniqs = $b43b108995e2bf6c$var$defaultCacheUniqs, menuPlacement: menuPlacement, menuShouldScrollIntoView: menuShouldScrollIntoView, ...rest } = props;
        const asyncPaginateProps = $b43b108995e2bf6c$export$59c1df8d705d4a91(rest, cacheUniqs);
        const processedComponents = $b43b108995e2bf6c$export$7c355de7fd01eb66(components);
        const isLoading = typeof isLoadingProp === "boolean" ? isLoadingProp : asyncPaginateProps.isLoading;
        return /* @__PURE__ */ (0, $7uT18.jsx)(SelectComponent, {
            ...props,
            ...asyncPaginateProps,
            menuPlacement: menuPlacement,
            menuShouldScrollIntoView: menuPlacement === "auto" ? isLoading ? false : menuShouldScrollIntoView : menuShouldScrollIntoView,
            isLoading: isLoading,
            components: processedComponents,
            ref: selectRef
        });
    }
    return WithAsyncPaginate;
}
// src/reduceGroupedOptions.ts
var $b43b108995e2bf6c$var$checkGroup = (group)=>{
    if (!group) return false;
    const { label: label, options: options } = group;
    if (typeof label !== "string" && typeof label !== "undefined") return false;
    if (!Array.isArray(options)) return false;
    return true;
};
var $b43b108995e2bf6c$export$ae55ee42145434d8 = (prevOptions, loadedOptions)=>{
    const res = prevOptions.slice();
    const mapLabelToIndex = {};
    let prevOptionsIndex = 0;
    const prevOptionsLength = prevOptions.length;
    for (const optionOrGroup of loadedOptions){
        const group = $b43b108995e2bf6c$var$checkGroup(optionOrGroup) ? optionOrGroup : {
            options: [
                optionOrGroup
            ]
        };
        const { label: label = "" } = group;
        let groupIndex = mapLabelToIndex[label];
        if (typeof groupIndex !== "number") {
            for(; prevOptionsIndex < prevOptionsLength && typeof mapLabelToIndex[label] !== "number"; ++prevOptionsIndex){
                const prevGroup = prevOptions[prevOptionsIndex];
                if ($b43b108995e2bf6c$var$checkGroup(prevGroup)) mapLabelToIndex[prevGroup.label || ""] = prevOptionsIndex;
            }
            groupIndex = mapLabelToIndex[label];
        }
        if (typeof groupIndex !== "number") {
            mapLabelToIndex[label] = res.length;
            res.push(group);
        } else res[groupIndex] = {
            ...res[groupIndex],
            options: [
                ...res[groupIndex].options,
                ...group.options
            ]
        };
    }
    return res;
};
// src/index.ts
var $b43b108995e2bf6c$export$62ae509949bd1704 = $b43b108995e2bf6c$export$cfb48882cd279b8a((0, $e9e80384c89540c4$export$2e2bcd8739ae039));









// Entities whose options are built locally (no server list to page/search through).
const $288f67596d327d69$var$LOCAL_ENTITIES = [
    "task_negative",
    "task_status",
    "task_deadline",
    "date_range",
    "language"
];
class $288f67596d327d69$var$EntityDropdown extends (0, $cQmXV.Component) {
    static defaultProps = {
        asynch: false,
        useFullOptionObject: false
    };
    constructor(props){
        super(props);
        this.state = {
            list: [],
            searchTerm: "",
            keyTrick: 1,
            loading: false,
            loaded: false
        };
        this.customStyles = {
            menu: (base)=>({
                    ...base,
                    zIndex: 9999,
                    minWidth: "220px"
                }),
            menuList: (base)=>({
                    ...base,
                    maxHeight: "260px"
                }),
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        };
    }
    componentDidMount() {
        // Parent supplies the list directly (e.g. photo-review "filters") — use it as-is, no fetch.
        if (this.props.updatedList) {
            this.setState({
                list: this.props.updatedList,
                loaded: true
            });
            return;
        }
        if (this.usesPagination()) {
            // AsyncPaginate fetches its first page lazily when the menu opens. Only seed via the API
            // when we have a bare-id value that must be resolved to a label — a predetermined value
            // passed as a full object renders directly (see formatValue), with no API call.
            if (this.needsApiSeed()) this.loadPaginatedOptions("", [], {
                page: 1
            });
            return;
        }
        // Simple Select path (local/static lists + "template"): load eagerly only when needed;
        // otherwise the list is built on the first menu open (see handleMenuOpen).
        if (this.shouldLoadEagerly()) this.fetchData();
    }
    // Network-backed list entities use the paginated + searchable AsyncPaginate select.
    // Kept on the simple Select path: locally-built lists (static + language), "template"
    // (defaultTemplate side effect + useDefaultValue), and parent-injected lists (updatedList).
    usesPagination = ()=>{
        const { entity: entity, updatedList: updatedList } = this.props;
        return !updatedList && entity !== "template" && !$288f67596d327d69$var$LOCAL_ENTITIES.includes(entity);
    };
    // Eager-load conditions for the simple Select path: a value is already selected (so its label
    // can render), or the "template" entity (defaultTemplate side effect + useDefaultValue).
    shouldLoadEagerly = ()=>{
        const v = this.props.value;
        const hasValue = Array.isArray(v) ? v.length > 0 : v !== "" && v !== null && v !== undefined;
        return this.props.entity === "template" || hasValue;
    };
    // True only for a bare-id/primitive preselected value that must be resolved to a label via the
    // API. A predetermined value given as a full object (or array of objects) is self-describing
    // and renders with no request.
    needsApiSeed = ()=>{
        const v = this.props.value;
        if (v === "" || v === null || v === undefined) return false;
        if (Array.isArray(v)) return v.length > 0 && typeof v[0] !== "object";
        return typeof v !== "object";
    };
    // Simple Select path only: build/fetch the list the first time the menu opens, then reuse it.
    handleMenuOpen = ()=>{
        if (!this.usesPagination() && !this.props.updatedList && !this.state.loaded && !this.state.loading) this.fetchData();
    };
    // Merge freshly loaded options into the cache used by formatValue for label lookup.
    mergeOptions = (existing, incoming)=>{
        const byValue = new Map((existing || []).map((o)=>[
                o.value,
                o
            ]));
        incoming.forEach((o)=>byValue.set(o.value, o));
        return Array.from(byValue.values());
    };
    componentDidUpdate(prevProps) {
        const { county: county, moduleFilter: moduleFilter, updatedList: updatedList } = this.props;
        if (prevProps.county !== county || prevProps.moduleFilter !== moduleFilter) this.setState((prevState)=>({
                keyTrick: prevState.keyTrick + 1
            }));
        if (prevProps.updatedList !== updatedList) this.setState({
            list: updatedList
        });
    }
    fetchData = ()=>{
        let { entity: entity } = this.props;
        if ([
            "task_negative",
            "task_status",
            "task_deadline"
        ].includes(entity)) {
            this.setState({
                list: (0, $3b579ca6158bc61b$export$b25c9bd295a2cb07)((0, $91ea30cb49819b9a$export$a6a26ddb3e5b4d30)[entity], entity),
                loaded: true
            });
            return;
        }
        let url = (0, $91ea30cb49819b9a$export$da688e121885cf48)[entity];
        // Note: point/points and brands are no longer served here — they use the paginated,
        // searchable AsyncPaginate path (DROPDOWN_PAGE_SIZE per page), so the old
        // "?page_size=1000" fetch-everything shortcut for brands has been removed.
        if (entity == "language") url = "users/";
        //Custom Select Data for Date Range on Visit section
        if (entity == "date_range") {
            const dateAgoList = [
                {
                    id: 0,
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_today", this.props.me?.language ? this.props.me.language : "en"),
                    value: this.props.setDateAgo("today"),
                    name: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_today", this.props.me?.language ? this.props.me.language : "en")
                },
                {
                    id: 1,
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_yesterday", this.props.me?.language ? this.props.me.language : "en"),
                    value: this.props.setDateAgo("yesterday"),
                    name: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_yesterday", this.props.me?.language ? this.props.me.language : "en")
                },
                {
                    id: 2,
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_current_week", this.props.me?.language ? this.props.me.language : "en"),
                    value: this.props.setDateAgo("current_week"),
                    name: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_current_week", this.props.me?.language ? this.props.me.language : "en")
                },
                {
                    id: 3,
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_last_week", this.props.me?.language ? this.props.me.language : "en"),
                    value: this.props.setDateAgo("last_week"),
                    name: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_last_week", this.props.me?.language ? this.props.me.language : "en")
                },
                {
                    id: 4,
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_\u0441urrent_month", this.props.me?.language ? this.props.me.language : "en"),
                    value: this.props.setDateAgo("current_month"),
                    name: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_\u0441urrent_month", this.props.me?.language ? this.props.me.language : "en")
                },
                {
                    id: 5,
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_last_month", this.props.me?.language ? this.props.me.language : "en"),
                    value: this.props.setDateAgo("last_month"),
                    name: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_last_month", this.props.me?.language ? this.props.me.language : "en")
                },
                {
                    id: 6,
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_last_half_year", this.props.me?.language ? this.props.me.language : "en"),
                    value: this.props.setDateAgo("last_half_a_year"),
                    name: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_last_half_year", this.props.me?.language ? this.props.me.language : "en")
                }
            ];
            this.setState({
                list: dateAgoList,
                loaded: true
            });
        } else {
            this.setState({
                loading: true
            });
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "GET",
                url: url
            }, (response)=>{
                if (entity == "filters" || entity == "absence_reason_templates" || entity == "users" || entity == "task" || entity == "visit" || entity == "point" || entity == "points" || entity == "point_groups" || entity == "brand" || entity == "brands" || entity == "product" || entity == "products" || entity == "categories" || entity == "subcategory" || entity == "subcategories") response = response.results;
                if (entity === "language") //Set languages as default
                response = [
                    {
                        id: 1,
                        code: "uk",
                        name: "\u0423\u043A\u0440\u0430\u0456\u0308\u043D\u0441\u044C\u043A\u0430"
                    },
                    {
                        id: 2,
                        code: "en",
                        name: "English"
                    },
                    {
                        id: 3,
                        code: "hy",
                        name: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576"
                    },
                    {
                        id: 4,
                        code: "ka",
                        name: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8"
                    }
                ];
                response = (0, $3b579ca6158bc61b$export$b25c9bd295a2cb07)(response, entity);
                this.setState({
                    list: response,
                    loading: false,
                    loaded: true
                });
                if (entity === "template") {
                    let defaultOption = response?.find((item)=>item.is_default);
                    (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().dispatch((0, $cca4416321e611bf$export$d81a4a2300dc817f)(defaultOption));
                    (0, $67f64b78c4102acd$export$fb931cd598921492)({
                        ...(0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState(),
                        defaultTemplate: defaultOption?.id
                    });
                }
            });
        }
    };
    formatValue = (value)=>{
        if (this.props.isMulti) {
            const userEntities = [
                "created_by",
                "supervisor",
                "supervisors",
                "merchandiser",
                "merchandisers"
            ];
            return (value || []).map((i)=>{
                // Tolerate bare ids/null: resolve ids against loaded options, drop what we can't build.
                if (i === null || i === undefined) return null;
                if (typeof i !== "object") {
                    const found = (this.state.list || []).find((o)=>o.id === i);
                    if (!found) return null;
                    i = found;
                }
                if (i.name) return {
                    ...i,
                    value: i.id,
                    label: i.name
                };
                else if (userEntities.includes(this.props.entity) && (i.first_name || i.last_name)) return {
                    ...i,
                    value: i.id,
                    label: (i.first_name || "") + " " + (i.last_name || "")
                };
                else return {
                    ...i,
                    value: i.id ?? i.value,
                    label: i.label
                };
            }).filter(Boolean);
        }
        // A predetermined value passed as a full object is self-describing: render it directly from
        // the object (no state.list lookup, no API call). Bare ids/strings fall back to a lookup.
        const valueIsObject = value !== null && value !== undefined && typeof value === "object";
        let defaultOption = this.state.list?.find((item)=>item.is_default);
        let option = valueIsObject ? value : this.state.list.find((o)=>o.id === value);
        if (!valueIsObject && this.props.entity == "language" && value) option = this.state.list.find((o)=>o.code === value);
        if (!valueIsObject && this.props.entity == "date_range" && value) option = this.state.list.find((o)=>o.value === value);
        if (this.props.useFullOptionObject) option = value;
        if (this.props.useDefaultValue && value === "") option = defaultOption;
        if (!valueIsObject && this.props.entity == "absence_reason_templates") option = this.state.list.find((o)=>o.label === value);
        if (option) {
            let label = option.name || option.label || "";
            if (this.props.entity == "supervisors") label = option.first_name + " " + option.last_name;
            if (this.props.entity == "merchandiser") label = option.first_name + " " + option.last_name;
            if (this.props.entity == "merchandisers") label = option.first_name + " " + option.last_name;
            if (this.props.entity == "supervisor") label = option.first_name + " " + option.last_name;
            if (this.props.entity == "created_by") label = option.first_name + " " + option.last_name;
            if (this.props.entity == "point") label = option.name + ", " + option.locality?.name;
            if (this.props.entity == "points") label = option.name + ", " + option.locality?.name;
            if (this.props.entity == "absence_reason_templates") label = option.label;
            return {
                value: option.id ?? option.value,
                label: label
            };
        } else return null;
    };
    // Paginated + searchable loader for AsyncPaginate: fetches one page (DROPDOWN_PAGE_SIZE)
    // at a time, searching server-side via `?search=`, and reports whether more pages exist
    // so the menu can load the next page on scroll.
    loadPaginatedOptions = async (search, loadedOptions, additional)=>{
        const page = additional && additional.page || 1;
        const { entity: entity, county: county, moduleFilter: moduleFilter } = this.props;
        const base = String((0, $91ea30cb49819b9a$export$da688e121885cf48)[entity] || entity).replace(/\/+$/, "");
        let url = `${base}?page=${page}&page_size=${(0, $91ea30cb49819b9a$export$be750171172fb886)}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (entity === "point" || entity === "points") url += `&locality__county=${county || ""}&network=${moduleFilter || ""}`;
        const response = await new Promise((resolve)=>(0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "GET",
                url: url
            }, resolve));
        const rawItems = Array.isArray(response) ? response : response && response.results || [];
        const options = (0, $3b579ca6158bc61b$export$b25c9bd295a2cb07)(rawItems.slice(), entity) || [];
        // Keep every option we've loaded so formatValue can resolve the selected value's label.
        this.setState((prev)=>({
                list: this.mergeOptions(prev.list, options)
            }));
        const hasMore = Array.isArray(response) ? false : Boolean(response && response.next);
        return {
            options: options,
            hasMore: hasMore,
            additional: {
                page: page + 1
            }
        };
    };
    render() {
        const { keyTrick: keyTrick } = this.state;
        let className = this.props.className ? this.props.className : "";
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: `react-dropdown-container ${className}`,
            children: this.usesPagination() ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $b43b108995e2bf6c$export$62ae509949bd1704), {
                value: this.formatValue(this.props.value) || null,
                loadOptions: this.loadPaginatedOptions,
                additional: {
                    page: 1
                },
                debounceTimeout: (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316),
                isMulti: this.props.isMulti || false,
                placeholder: this.props.placeholder ? this.props.placeholder : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), (0, $91ea30cb49819b9a$export$846d38fa3865c245)[this.props.entity]?.selectTitle, this.props.me?.language ? this.props.me.language : "en"),
                onChange: this.props.onChange,
                isClearable: this.props.isClearable ?? true,
                isDisabled: this.props.isDisabled,
                styles: this.customStyles,
                menuPortalTarget: document.body,
                menuPosition: "fixed",
                className: "react-select-custom-container",
                classNamePrefix: "custom-react-select"
            }, keyTrick) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $e9e80384c89540c4$export$2e2bcd8739ae039), {
                options: this.state.list,
                onMenuOpen: this.handleMenuOpen,
                isLoading: this.state.loading,
                isMulti: this.props.isMulti,
                value: this.formatValue(this.props.value) || [],
                // placeholder={this.props.placeholder ? this.props.placeholder : EntityDropDownSettings[this.props.entity]?.selectTitle}
                placeholder: this.props.placeholder ? this.props.placeholder : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), (0, $91ea30cb49819b9a$export$846d38fa3865c245)[this.props.entity]?.selectTitle, this.props.me?.language ? this.props.me.language : "en"),
                onChange: this.props.onChange,
                isClearable: this.props.isClearable ?? true,
                isDisabled: this.props.isDisabled,
                styles: this.customStyles,
                menuPortalTarget: document.body,
                menuPosition: "fixed",
                className: "react-select-custom-container",
                classNamePrefix: "custom-react-select"
            })
        });
    }
}
var $288f67596d327d69$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($288f67596d327d69$var$EntityDropdown));







const $271c159bb7207c78$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $271c159bb7207c78$var$View extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            items: [],
            totalDataSize: 0,
            sizePerPage: 10,
            pageAmount: 1,
            page: 1,
            components: []
        };
    }
    componentDidMount() {
        // this.load();
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "templates/"
        }, (r)=>{
            let t = r.find((i)=>i.id == 1);
            if (t) this.setState({
                components: t.components.map((i)=>i.id)
            });
        });
    }
    load = ()=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "tasks?template=2&page=" + this.state.page
        }, (r)=>{
            let pageAmount = Math.ceil(r.count / this.state.sizePerPage);
            this.setState({
                items: this.prepareItemsToLoad(r.results),
                pagination: true,
                count: r.count,
                loading: false,
                pageAmount: pageAmount
            });
        });
    };
    loadPage = (page)=>{
        this.setState({
            page: page
        }, ()=>{
            this.load();
        });
    };
    submit = ()=>{
        let items = this.prepareItemsToSend(this.state.items);
        console.log("items post bulk", items);
        console.log("items post bulk", JSON.stringify(items));
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "tasks/",
            post: items
        }, (r)=>{
            console.log("response", r);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Items successfully saved", {
                position: "bottom-right"
            });
        // this.setState({items:r});
        // if (r &&  r.id) {
        //     Alert.success('Task successfully saved', {position: 'bottom-right'});
        // } else {
        //     Alert.warning('Error while saving task. Error: '+JSON.stringify(r), {position: 'bottom-right'});
        // }
        });
    // items.map(this.submitOne);
    };
    submitOne = (item, idx)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: item && item.id ? "PATCH" : "POST",
            url: item && item.id ? "tasks/" + item.id + "/" : "tasks/",
            post: item
        }, (r)=>{
            console.log("item post", item);
            console.log("result", r);
            if (r && r.id) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Task successfully saved", {
                position: "bottom-right"
            });
            else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving task. Error: " + JSON.stringify(r), {
                position: "bottom-right"
            });
        });
    };
    prepareItemsToLoad = (items)=>{
        let ai = {};
        items.forEach((i, idx)=>{
            // A single malformed additional_info must not abort the whole load.
            try {
                ai = JSON.parse(i.additional_info) || {};
            } catch (e) {
                ai = {};
            }
            i.kam = ai.kam ? ai.kam : "";
            i.channel = ai.channel ? ai.channel : "";
            i.brand = ai.brand ? ai.brand : "";
            i.product = ai.product ? ai.product : "";
            i.promo = ai.promo ? ai.promo : "";
            i.price = ai.price ? ai.price : "";
            i.discount = ai.discount ? ai.discount : "";
            i.info = ai.info ? ai.info : "";
            items[idx] = {
                ...i
            };
        });
        return items;
    };
    prepareItemsToSend = (items)=>{
        let item = {};
        let additional_info = null;
        items.forEach((i, idx)=>{
            additional_info = {
                kam: i.kam,
                channel: i.channel,
                brand: i.brand,
                product: i.product,
                promo: i.promo,
                price: i.price,
                discount: i.discount,
                info: i.info
            };
            additional_info = JSON.stringify(additional_info);
            item = {
                network: i.network && i.network.id ? i.network.id : null,
                title: "\u0411\u0420\u0415\u041D\u0414: " + i.brand + ", \u041F\u0420\u041E\u0414\u0423\u041A\u0422 \u041B\u0406\u041D\u0406\u0419\u041A\u0418: " + i.product + ", \u0422\u0418\u041F \u041F\u0420\u041E\u041C\u041E: " + i.promo + ", \u0417\u041D\u0418\u0416\u041A\u0410 %:" + i.price + ", \u0426\u0406\u041D\u0410:" + i.discount,
                template: 1,
                created_by: $271c159bb7207c78$var$me.id,
                company: $271c159bb7207c78$var$me.company && $271c159bb7207c78$var$me.company.id ? $271c159bb7207c78$var$me.company.id : null,
                start: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(i.start).format("yyyy-MM-DDT00:00"),
                end: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(i.end).format("yyyy-MM-DDT00:00"),
                additional_info: additional_info,
                components: this.state.components
            };
            if (i.id) item.id = i.id;
            items[idx] = item;
        });
        return items;
    };
    deleteRow = (idx)=>{
        let items = this.state.items;
        delete items[idx];
        this.setState({
            items: items
        });
    };
    addRow = (i)=>{
        let items = this.state.items;
        items.push({
            network: null,
            nka: null,
            kam: "",
            start: new Date(),
            end: new Date(),
            brand: "",
            product: "",
            promo: "",
            discount: "",
            price: "",
            info: ""
        });
        this.setState({
            items: items
        });
    };
    onChange = (property, value, idx)=>{
        let items = this.state.items;
        items[idx][property] = value;
        this.setState({
            items: items
        });
    };
    renderRow = (item, idx)=>{
        return /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("td", {
                    className: "KForm-firstRow td1",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                            className: "KFormDelete fa fa-minus-square",
                            onClick: ()=>this.deleteRow(idx)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                            entity: "network",
                            value: item.network && item.network.id,
                            onChange: (o)=>this.onChange("network", o, idx),
                            placeholder: "Select"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td2",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $e9e80384c89540c4$export$2e2bcd8739ae039), {
                        options: (0, $6f1c09625235f1f0$export$d473fe3206ac7fed),
                        value: (0, $3b579ca6158bc61b$export$9df10f3a4586f4ff)(item.channel, (0, $6f1c09625235f1f0$export$d473fe3206ac7fed)),
                        onChange: (o)=>this.onChange("channel", o.value, idx),
                        placeholder: "Select"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td3",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: item.kam,
                        className: "kform-kam",
                        onChange: (o)=>this.onChange("kam", o.target.value, idx)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td4",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                        selected: new Date(item.start),
                        onChange: (date)=>this.onChange("start", date, idx),
                        className: "datePicker kform-date"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td5",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                        selected: new Date(item.end),
                        onChange: (date)=>this.onChange("end", date, idx),
                        className: "datePicker kform-date"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td6",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: item.brand,
                        className: "kform-discount",
                        onChange: (o)=>this.onChange("brand", o.target.value, idx)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td7",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: item.product,
                        className: "kform-discount",
                        onChange: (o)=>this.onChange("product", o.target.value, idx)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td8",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: item.promo,
                        onChange: (o)=>this.onChange("promo", o.target.value, idx)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td9",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: item.discount,
                        className: "kform-discount",
                        onChange: (o)=>this.onChange("discount", o.target.value, idx)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td10",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: item.price,
                        className: "kform-price",
                        onChange: (o)=>this.onChange("price", o.target.value, idx)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    className: "td11",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("textarea", {
                        onChange: (o)=>this.onChange("info", o.target.value, idx),
                        children: item.info
                    })
                })
            ]
        });
    };
    render() {
        const { page: page } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9b4ba9aeb2db83c0$export$53f1cd6809577fc5), {
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9b4ba9aeb2db83c0$export$7f365262018175ea), {
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "faIcon",
                                children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                    className: "fa fa-table"
                                })
                            }),
                            "\u041A\u0410\u041C-\u0424\u043E\u0440\u043C\u0438"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "box p-4",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "table-scroll-x",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                                className: "table table-hover table-bordered tableKForm",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("thead", {
                                        className: "primary text-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        rowspan: "2",
                                                        children: "\u041A\u043B\u0456\u0454\u043D\u0442"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        rowspan: "2",
                                                        children: "\u041A\u0430\u043D\u0430\u043B"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        rowspan: "2",
                                                        children: "KAM|KAE|RSM"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        colspan: "2",
                                                        children: "\u041F\u0435\u0440\u0456\u043E\u0434"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        colspan: "2",
                                                        children: "\u0413\u0440\u0443\u043F\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0446\u0456\u0457"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        rowspan: "2",
                                                        children: "\u0422\u0438\u043F \u043F\u0440\u043E\u043C\u043E"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        rowspan: "2",
                                                        children: "\u0417\u043D\u0438\u0436\u043A\u0430 %"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        rowspan: "2",
                                                        children: "\u0426\u0456\u043D\u0430"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        rowspan: "2",
                                                        children: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: "\u0421\u0442\u0430\u0440\u0442"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: "\u0411\u0440\u0435\u043D\u0434"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442 \u043B\u0456\u043D\u0456\u0439\u043A\u0438"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    this.state.items.map((i, idx)=>{
                                        return this.renderRow(i, idx);
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "col-xs-12",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("ul", {
                                className: "react-bootstrap-table-page-btns-ul pagination d-inline-block",
                                children: new Array(this.state.pageAmount).fill(this.state.pageAmount).map((i, idx)=>{
                                // return <li className={"page-item "+(page==(idx+1)?'active':'')}><a onClick={()=>this.loadPage(idx+1)}  className="page-link">{idx+1}</a></li>
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "col-md-12 text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "btn btn-outline-primary",
                                        onClick: (e)=>this.addRow(),
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                className: "fa fa-plus"
                                            }),
                                            " \u0414\u043E\u0434\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0441",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "btn btn-primary  ml-3",
                                        onClick: (e)=>this.submit(),
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                className: "fa fa-save"
                                            }),
                                            " \u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $271c159bb7207c78$export$2e2bcd8739ae039 = $271c159bb7207c78$var$View;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
function $9ad5e71e0db52327$export$857b1c90a79ee78e() {
    return null;
}
function $9ad5e71e0db52327$var$normalizeWidth(w) {
    if (w == null) return undefined;
    return typeof w === "number" || /^\d+$/.test(String(w)) ? `${parseInt(w, 10)}px` : String(w);
}
function $9ad5e71e0db52327$var$columnsFromChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(child)).map((child)=>{
        const p = child.props || {};
        return {
            dataField: p.dataField,
            dataFormat: p.dataFormat,
            isKey: !!p.isKey,
            width: $9ad5e71e0db52327$var$normalizeWidth(p.width),
            dataAlign: p.dataAlign,
            hidden: !!p.hidden,
            columnClassName: p.columnClassName,
            header: p.children
        };
    });
}
function $9ad5e71e0db52327$var$resolveClass(value, cell, row, rowIndex) {
    if (typeof value === "function") return value(cell, row, rowIndex) || "";
    return value || "";
}
function $9ad5e71e0db52327$export$f75afe4574aa8f4f(props) {
    const { data: data = [], children: children, className: className = "", tableHeaderClass: tableHeaderClass = "", trClassName: trClassName, options: options = {}, striped: striped, hover: hover, bordered: bordered } = props;
    // Resolve the key column from ALL columns (a hidden isKey column, e.g. task-review's
    // "id", still gives stable row keys) but render only the visible ones.
    const allColumns = $9ad5e71e0db52327$var$columnsFromChildren(children);
    const keyCol = allColumns.find((c)=>c.isKey);
    const columns = allColumns.filter((c)=>!c.hidden);
    const onRowClick = options.onRowClick;
    const rowKey = (row, i)=>{
        const k = keyCol && keyCol.dataField ? row[keyCol.dataField] : undefined;
        return k != null ? k : i;
    };
    // Single auto-layout table (thead + tbody together): header and body columns align
    // natively without JS width-syncing, and the declared column widths act as soft hints
    // the browser honours when there's room. When the columns need more room than the
    // container has, `.react-bs-table` scrolls sideways rather than crushing them — see
    // layout/styles/tables.scss. The CSS targets `.react-bs-table table thead/tbody`.
    // `tableHeaderClass` styles the header only (react-bootstrap-table applied it there,
    // not to the whole table) — putting it on <table> bled the `.primary` teal fill onto
    // every cell.
    const tableClass = [
        "table",
        striped && "table-striped",
        hover && "table-hover",
        bordered && "table-bordered"
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: `react-bs-table-container ${className}`.trim(),
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "react-bs-table",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                className: tableClass,
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("colgroup", {
                        children: columns.map((c, i)=>/*#__PURE__*/ (0, $7uT18.jsx)("col", {
                                style: c.width ? {
                                    width: c.width
                                } : undefined
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                        className: tableHeaderClass || undefined,
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                            children: columns.map((c, i)=>/*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                    style: c.dataAlign ? {
                                        textAlign: c.dataAlign
                                    } : undefined,
                                    children: c.header
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                        children: data.map((row, i)=>/*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                                className: $9ad5e71e0db52327$var$resolveClass(trClassName, row, row, i),
                                onClick: onRowClick ? (e)=>onRowClick(row, undefined, i, e) : undefined,
                                style: onRowClick ? {
                                    cursor: "pointer"
                                } : undefined,
                                children: columns.map((c, ci)=>{
                                    const cell = c.dataField ? row[c.dataField] : undefined;
                                    const content = c.dataFormat ? c.dataFormat(cell, row, undefined, i) : cell;
                                    return /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                        className: $9ad5e71e0db52327$var$resolveClass(c.columnClassName, cell, row, i),
                                        style: c.dataAlign ? {
                                            textAlign: c.dataAlign
                                        } : undefined,
                                        children: content
                                    }, ci);
                                })
                            }, rowKey(row, i)))
                    })
                ]
            })
        })
    });
}
var $9ad5e71e0db52327$export$2e2bcd8739ae039 = $9ad5e71e0db52327$export$f75afe4574aa8f4f;




var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $1Spf6 = parcelRequire("1Spf6");

var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");

var $2rvNX = parcelRequire("2rvNX");

var $l4G5A = parcelRequire("l4G5A");
var $aRKlE = parcelRequire("aRKlE");

var $7AgjI = parcelRequire("7AgjI");
const $0ffdb13224038525$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $7AgjI.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $0ffdb13224038525$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $0ffdb13224038525$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $aRKlE.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}



var $lGH00 = parcelRequire("lGH00");

var $cQmXV = parcelRequire("cQmXV");
parcelRequire("gUe5M");
var $5XE8m = parcelRequire("5XE8m");
"use client";
function $79dd9d2ef5a04e31$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $79dd9d2ef5a04e31$var$useTheme(defaultTheme = null) {
    const contextTheme = $cQmXV.useContext((0, $5XE8m.T));
    return !contextTheme || $79dd9d2ef5a04e31$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $79dd9d2ef5a04e31$export$2e2bcd8739ae039 = $79dd9d2ef5a04e31$var$useTheme;


"use client";
const $2864c7b3a0802331$export$35e57303dbd8a66 = (0, $lGH00.default)();
function $2864c7b3a0802331$var$useTheme(defaultTheme = $2864c7b3a0802331$export$35e57303dbd8a66) {
    return (0, $79dd9d2ef5a04e31$export$2e2bcd8739ae039)(defaultTheme);
}
var $2864c7b3a0802331$export$2e2bcd8739ae039 = $2864c7b3a0802331$var$useTheme;



var $7uT18 = parcelRequire("7uT18");
"use client";
function $c00cf4a206918182$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $2rvNX.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $l4G5A.default));
    const Box = /*#__PURE__*/ $cQmXV.forwardRef(function Box(inProps, ref) {
        const theme = (0, $2864c7b3a0802331$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = "div", ...other } = (0, $0ffdb13224038525$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $7uT18.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $jYj5L.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}




var $62K0D = parcelRequire("62K0D");

var $7LQic = parcelRequire("7LQic");

var $dUHEu = parcelRequire("dUHEu");

var $9FFKn = parcelRequire("9FFKn");
const $23c2a56db5ece57d$var$boxClasses = (0, $9FFKn.default)("MuiBox", [
    "root"
]);
var $23c2a56db5ece57d$export$2e2bcd8739ae039 = $23c2a56db5ece57d$var$boxClasses;


"use client";
const $7022a2be733b2a79$var$defaultTheme = (0, $7LQic.default)();
const $7022a2be733b2a79$var$Box = (0, $c00cf4a206918182$export$2e2bcd8739ae039)({
    themeId: (0, $dUHEu.default),
    defaultTheme: $7022a2be733b2a79$var$defaultTheme,
    defaultClassName: (0, $23c2a56db5ece57d$export$2e2bcd8739ae039).root,
    generateClassName: (0, $62K0D.default).generate
});
var $7022a2be733b2a79$export$2e2bcd8739ae039 = $7022a2be733b2a79$var$Box;



var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");

var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");



var $iryXh = parcelRequire("iryXh");
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $4673a682829ca047$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(":focus-visible");
    } catch (error) {}
    return false;
}



var $kZnRZ = parcelRequire("kZnRZ");

var $9acxQ = parcelRequire("9acxQ");

var $cQmXV = parcelRequire("cQmXV");
"use client";
function $9a137d8a34f7c4e6$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $cQmXV.useRef(undefined);
    const refEffect = $cQmXV.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === "function") {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === "function" ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $cQmXV.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $ca6d5d8361d1622f$export$2e2bcd8739ae039 = (0, $9a137d8a34f7c4e6$export$2e2bcd8739ae039);



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $231bc2cf00a53453$var$useEnhancedEffect = typeof window !== "undefined" ? $cQmXV.useLayoutEffect : $cQmXV.useEffect;
var $231bc2cf00a53453$export$2e2bcd8739ae039 = $231bc2cf00a53453$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $9c0eaca3a51a3f8e$var$useEventCallback(fn) {
    const ref = $cQmXV.useRef(fn);
    (0, $231bc2cf00a53453$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $cQmXV.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $9c0eaca3a51a3f8e$export$2e2bcd8739ae039 = $9c0eaca3a51a3f8e$var$useEventCallback;


"use client";
var $75d3b7d855158be1$export$2e2bcd8739ae039 = (0, $9c0eaca3a51a3f8e$export$2e2bcd8739ae039);



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
"use client";
const $be98606980f2dbb1$var$UNINITIALIZED = {};
function $be98606980f2dbb1$export$2e2bcd8739ae039(init, initArg) {
    const ref = $cQmXV.useRef($be98606980f2dbb1$var$UNINITIALIZED);
    if (ref.current === $be98606980f2dbb1$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


"use client";
class $718e8d769f15bd86$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $718e8d769f15bd86$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $be98606980f2dbb1$export$2e2bcd8739ae039)($718e8d769f15bd86$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $cQmXV.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $cQmXV.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $718e8d769f15bd86$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $718e8d769f15bd86$export$2e2bcd8739ae039() {
    return $718e8d769f15bd86$export$f5de0641c7db4154.use();
}
function $718e8d769f15bd86$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $cQmXV = parcelRequire("cQmXV");



var $jNuvi = parcelRequire("jNuvi");




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $1aa60e50228dee77$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(null);



var $cQmXV = parcelRequire("cQmXV");
function $f87816b92b8b70a8$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $cQmXV.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $cQmXV.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $f87816b92b8b70a8$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $f87816b92b8b70a8$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $f87816b92b8b70a8$export$fa71e2345c31d7a2(props, onExited) {
    return $f87816b92b8b70a8$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $cQmXV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $f87816b92b8b70a8$var$getProp(child, "appear", props),
            enter: $f87816b92b8b70a8$var$getProp(child, "enter", props),
            exit: $f87816b92b8b70a8$var$getProp(child, "exit", props)
        });
    });
}
function $f87816b92b8b70a8$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $f87816b92b8b70a8$export$bbc8a025727ea824(nextProps.children);
    var children = $f87816b92b8b70a8$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $cQmXV.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $cQmXV.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $cQmXV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $f87816b92b8b70a8$var$getProp(child, "exit", nextProps),
            enter: $f87816b92b8b70a8$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $cQmXV.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $cQmXV.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $cQmXV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $f87816b92b8b70a8$var$getProp(child, "exit", nextProps),
            enter: $f87816b92b8b70a8$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $efe906d0503711a5$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $efe906d0503711a5$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $efe906d0503711a5$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $220785158be974ce$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $f87816b92b8b70a8$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $f87816b92b8b70a8$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $f87816b92b8b70a8$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $jNuvi.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $efe906d0503711a5$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1aa60e50228dee77$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1aa60e50228dee77$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
$efe906d0503711a5$var$TransitionGroup.propTypes = {};
$efe906d0503711a5$var$TransitionGroup.defaultProps = $efe906d0503711a5$var$defaultProps;
var $efe906d0503711a5$export$2e2bcd8739ae039 = $efe906d0503711a5$var$TransitionGroup;



var $jYj5L = parcelRequire("jYj5L");


var $cQmXV = parcelRequire("cQmXV");
"use client";
const $72d9d298e5a74a00$var$EMPTY = [];
function $72d9d298e5a74a00$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $cQmXV.useEffect(fn, $72d9d298e5a74a00$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $8cdcbd38b2555407$export$786b4da70f00938b {
    static create() {
        return new $8cdcbd38b2555407$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $8cdcbd38b2555407$export$2e2bcd8739ae039() {
    const timeout = (0, $be98606980f2dbb1$export$2e2bcd8739ae039)($8cdcbd38b2555407$export$786b4da70f00938b.create).current;
    (0, $72d9d298e5a74a00$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}



var $gUe5M = parcelRequire("gUe5M");
var $kZnRZ = parcelRequire("kZnRZ");

var $9acxQ = parcelRequire("9acxQ");

var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $7uT18 = parcelRequire("7uT18");
"use client";
function $045cac24137939d2$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $cQmXV.useState(false);
    const rippleClassName = (0, $jYj5L.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $jYj5L.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $cQmXV.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: childClassName
        })
    });
}
var $045cac24137939d2$export$2e2bcd8739ae039 = $045cac24137939d2$var$Ripple;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $a5866b922d2aafd6$export$b464606f735ab902(slot) {
    return (0, $jQsHx.default)("MuiTouchRipple", slot);
}
const $a5866b922d2aafd6$var$touchRippleClasses = (0, $9FFKn.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $a5866b922d2aafd6$export$2e2bcd8739ae039 = $a5866b922d2aafd6$var$touchRippleClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $ad918f2e78842adc$var$DURATION = 550;
const $ad918f2e78842adc$export$95d0c9356b2231a3 = 80;
const $ad918f2e78842adc$var$enterKeyframe = (0, $gUe5M.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $ad918f2e78842adc$var$exitKeyframe = (0, $gUe5M.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $ad918f2e78842adc$var$pulsateKeyframe = (0, $gUe5M.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $ad918f2e78842adc$export$f6b7418508c72c25 = (0, $kZnRZ.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $ad918f2e78842adc$export$676cfe7b12693c4b = (0, $kZnRZ.default)((0, $045cac24137939d2$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${(0, $a5866b922d2aafd6$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$ad918f2e78842adc$var$enterKeyframe};
    animation-duration: ${$ad918f2e78842adc$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $a5866b922d2aafd6$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $a5866b922d2aafd6$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $a5866b922d2aafd6$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$ad918f2e78842adc$var$exitKeyframe};
    animation-duration: ${$ad918f2e78842adc$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $a5866b922d2aafd6$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$ad918f2e78842adc$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $ad918f2e78842adc$var$TouchRipple = /*#__PURE__*/ $cQmXV.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $cQmXV.useState([]);
    const nextKey = $cQmXV.useRef(0);
    const rippleCallback = $cQmXV.useRef(null);
    $cQmXV.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $cQmXV.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $8cdcbd38b2555407$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $cQmXV.useRef(null);
    const container = $cQmXV.useRef(null);
    const startCommit = $cQmXV.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $7uT18.jsx)($ad918f2e78842adc$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $jYj5L.default)(classes.ripple, (0, $a5866b922d2aafd6$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $jYj5L.default)(classes.rippleVisible, (0, $a5866b922d2aafd6$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $jYj5L.default)(classes.ripplePulsate, (0, $a5866b922d2aafd6$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $jYj5L.default)(classes.child, (0, $a5866b922d2aafd6$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $jYj5L.default)(classes.childLeaving, (0, $a5866b922d2aafd6$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $jYj5L.default)(classes.childPulsate, (0, $a5866b922d2aafd6$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $ad918f2e78842adc$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $cQmXV.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($ad918f2e78842adc$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $cQmXV.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $cQmXV.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $cQmXV.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)($ad918f2e78842adc$export$f6b7418508c72c25, {
        className: (0, $jYj5L.default)((0, $a5866b922d2aafd6$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $efe906d0503711a5$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $ad918f2e78842adc$export$2e2bcd8739ae039 = $ad918f2e78842adc$var$TouchRipple;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $05c8260a1bb023f3$export$fccb0498dcd99783(slot) {
    return (0, $jQsHx.default)("MuiButtonBase", slot);
}
const $05c8260a1bb023f3$var$buttonBaseClasses = (0, $9FFKn.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $05c8260a1bb023f3$export$2e2bcd8739ae039 = $05c8260a1bb023f3$var$buttonBaseClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $f06c8c49488afe70$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $iryXh.default)(slots, (0, $05c8260a1bb023f3$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $f06c8c49488afe70$export$7ec0dcc5e3cdcd36 = (0, $kZnRZ.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $05c8260a1bb023f3$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $f06c8c49488afe70$var$ButtonBase = /*#__PURE__*/ $cQmXV.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $cQmXV.useRef(null);
    const ripple = (0, $718e8d769f15bd86$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $ca6d5d8361d1622f$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $cQmXV.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $cQmXV.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $cQmXV.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $f06c8c49488afe70$var$useRippleHandler(ripple, "start", onMouseDown, disableTouchRipple);
    const handleContextMenu = $f06c8c49488afe70$var$useRippleHandler(ripple, "stop", onContextMenu, disableTouchRipple);
    const handleDragLeave = $f06c8c49488afe70$var$useRippleHandler(ripple, "stop", onDragLeave, disableTouchRipple);
    const handleMouseUp = $f06c8c49488afe70$var$useRippleHandler(ripple, "stop", onMouseUp, disableTouchRipple);
    const handleMouseLeave = $f06c8c49488afe70$var$useRippleHandler(ripple, "stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $f06c8c49488afe70$var$useRippleHandler(ripple, "start", onTouchStart, disableTouchRipple);
    const handleTouchEnd = $f06c8c49488afe70$var$useRippleHandler(ripple, "stop", onTouchEnd, disableTouchRipple);
    const handleTouchMove = $f06c8c49488afe70$var$useRippleHandler(ripple, "stop", onTouchMove, disableTouchRipple);
    const handleBlur = $f06c8c49488afe70$var$useRippleHandler(ripple, "stop", (event)=>{
        if (!(0, $4673a682829ca047$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $75d3b7d855158be1$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $4673a682829ca047$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    const handleKeyDown = (0, $75d3b7d855158be1$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === " ") ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $75d3b7d855158be1$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $ca6d5d8361d1622f$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $f06c8c49488afe70$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7uT18.jsxs)($f06c8c49488afe70$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $jYj5L.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $ad918f2e78842adc$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $f06c8c49488afe70$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $75d3b7d855158be1$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $f06c8c49488afe70$export$2e2bcd8739ae039 = $f06c8c49488afe70$var$ButtonBase;



var $7U6VQ = parcelRequire("7U6VQ");

var $kZnRZ = parcelRequire("kZnRZ");

var $dGUQw = parcelRequire("dGUQw");

var $9acxQ = parcelRequire("9acxQ");


var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $9b9d28a9e98d6fb3$export$72aef224d6115253(slot) {
    return (0, $jQsHx.default)("MuiTab", slot);
}
const $9b9d28a9e98d6fb3$var$tabClasses = (0, $9FFKn.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper",
    "icon"
]);
var $9b9d28a9e98d6fb3$export$2e2bcd8739ae039 = $9b9d28a9e98d6fb3$var$tabClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $c2fc2e502fe795cd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $7U6VQ.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        icon: [
            "iconWrapper",
            "icon"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $9b9d28a9e98d6fb3$export$72aef224d6115253), classes);
};
const $c2fc2e502fe795cd$var$TabRoot = (0, $kZnRZ.default)((0, $f06c8c49488afe70$export$2e2bcd8739ae039), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $7U6VQ.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).icon}`]: styles.icon
            }
        ];
    }
})((0, $dGUQw.default)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center",
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom"),
                style: {
                    flexDirection: "column"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== "top" && ownerState.iconPosition !== "bottom",
                style: {
                    flexDirection: "row"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === "top",
                style: {
                    [`& > .${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === "bottom",
                style: {
                    [`& > .${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === "start",
                style: {
                    [`& > .${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === "end",
                style: {
                    [`& > .${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: "inherit"
                },
                style: {
                    color: "inherit",
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: "primary"
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: "secondary"
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $9b9d28a9e98d6fb3$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: "none"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $c2fc2e502fe795cd$var$Tab = /*#__PURE__*/ $cQmXV.forwardRef(function Tab(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $c2fc2e502fe795cd$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $cQmXV.isValidElement(iconProp) ? /*#__PURE__*/ $cQmXV.cloneElement(iconProp, {
        className: (0, $jYj5L.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)($c2fc2e502fe795cd$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $jYj5L.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $7uT18.jsxs)($cQmXV.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $7uT18.jsxs)($cQmXV.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $c2fc2e502fe795cd$export$2e2bcd8739ae039 = $c2fc2e502fe795cd$var$Tab;



var $cQmXV = parcelRequire("cQmXV");



var $jYj5L = parcelRequire("jYj5L");


var $iryXh = parcelRequire("iryXh");

var $cQmXV = parcelRequire("cQmXV");


var $7uT18 = parcelRequire("7uT18");
"use client";
const $f72a8065b49cc3d6$var$RtlContext = /*#__PURE__*/ $cQmXV.createContext();
function $f72a8065b49cc3d6$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $7uT18.jsx)($f72a8065b49cc3d6$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $f72a8065b49cc3d6$export$b2dd014b6c321cb = ()=>{
    const value = $cQmXV.useContext($f72a8065b49cc3d6$var$RtlContext);
    return value ?? false;
};
var $f72a8065b49cc3d6$export$2e2bcd8739ae039 = $f72a8065b49cc3d6$var$RtlProvider;



/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $66a5fb7f8a93a275$var$isHostComponent(element) {
    return typeof element === "string";
}
var $66a5fb7f8a93a275$export$2e2bcd8739ae039 = $66a5fb7f8a93a275$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $9cb4de6d8813671a$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $66a5fb7f8a93a275$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $9cb4de6d8813671a$export$2e2bcd8739ae039 = $9cb4de6d8813671a$var$appendOwnerState;



var $jYj5L = parcelRequire("jYj5L");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $aed310e7cd7f17e7$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $aed310e7cd7f17e7$export$2e2bcd8739ae039 = $aed310e7cd7f17e7$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $8d6b5c86e5828b78$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $8d6b5c86e5828b78$export$2e2bcd8739ae039 = $8d6b5c86e5828b78$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $819ee29ec5105d66$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $jYj5L.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $aed310e7cd7f17e7$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $8d6b5c86e5828b78$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $8d6b5c86e5828b78$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $jYj5L.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $819ee29ec5105d66$export$2e2bcd8739ae039 = $819ee29ec5105d66$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $773e0a3b5375e927$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $773e0a3b5375e927$export$2e2bcd8739ae039 = $773e0a3b5375e927$var$resolveComponentProps;


"use client";
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $60d67c48e0ec431c$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $773e0a3b5375e927$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $819ee29ec5105d66$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $9a137d8a34f7c4e6$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $9cb4de6d8813671a$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $60d67c48e0ec431c$export$2e2bcd8739ae039 = $60d67c48e0ec431c$var$useSlotProps;



var $kZnRZ = parcelRequire("kZnRZ");parcelRequire("cQmXV");


var $bnMBi = parcelRequire("bnMBi");

var $dUHEu = parcelRequire("dUHEu");
"use client";
function $6e330efe521cf043$export$2e2bcd8739ae039() {
    const theme = (0, $2864c7b3a0802331$export$2e2bcd8739ae039)((0, $bnMBi.default));
    return theme[0, $dUHEu.default] || theme;
}



var $dGUQw = parcelRequire("dGUQw");

var $9acxQ = parcelRequire("9acxQ");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $564e6bd14b3d9760$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $bf21fc82f771e47b$export$2e2bcd8739ae039 = (0, $564e6bd14b3d9760$export$2e2bcd8739ae039);


function $68d597f163ea68c8$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $68d597f163ea68c8$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $68d597f163ea68c8$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $cQmXV = parcelRequire("cQmXV");


function $0a9753fa19441ed9$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $072c43b837841e08$export$2e2bcd8739ae039(node) {
    const doc = (0, $0a9753fa19441ed9$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $0249870df7ab56c2$export$2e2bcd8739ae039 = (0, $072c43b837841e08$export$2e2bcd8739ae039);


"use client";
var $fb180c71a776d7cb$export$2e2bcd8739ae039 = (0, $231bc2cf00a53453$export$2e2bcd8739ae039);



var $7uT18 = parcelRequire("7uT18");
"use client";
const $f9da43a3ab99c6f6$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $f9da43a3ab99c6f6$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $cQmXV.useRef();
    const nodeRef = $cQmXV.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $fb180c71a776d7cb$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $bf21fc82f771e47b$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $0249870df7ab56c2$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $cQmXV.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        style: $f9da43a3ab99c6f6$var$styles,
        ...other,
        ref: nodeRef
    });
}



var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");


parcelRequire("cQmXV");

var $60KC5 = parcelRequire("60KC5");

var $7uT18 = parcelRequire("7uT18");
"use client";
var $78749e277eeaf032$export$2e2bcd8739ae039 = (0, $60KC5.default)(/*#__PURE__*/ (0, $7uT18.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("cQmXV");

var $60KC5 = parcelRequire("60KC5");

var $7uT18 = parcelRequire("7uT18");
"use client";
var $7c94f792d6e06656$export$2e2bcd8739ae039 = (0, $60KC5.default)(/*#__PURE__*/ (0, $7uT18.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");




var $kZnRZ = parcelRequire("kZnRZ");

var $9acxQ = parcelRequire("9acxQ");

var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $30cfcd7664801e26$export$34861783d3c2eef8(slot) {
    return (0, $jQsHx.default)("MuiTabScrollButton", slot);
}
const $30cfcd7664801e26$var$tabScrollButtonClasses = (0, $9FFKn.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $30cfcd7664801e26$export$2e2bcd8739ae039 = $30cfcd7664801e26$var$tabScrollButtonClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $e25d9b73dac5173f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $30cfcd7664801e26$export$34861783d3c2eef8), classes);
};
const $e25d9b73dac5173f$var$TabScrollButtonRoot = (0, $kZnRZ.default)((0, $f06c8c49488afe70$export$2e2bcd8739ae039), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $30cfcd7664801e26$export$2e2bcd8739ae039).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: "vertical"
            },
            style: {
                width: "100%",
                height: 40,
                "& svg": {
                    transform: "var(--TabScrollButton-svgRotate)"
                }
            }
        }
    ]
});
const $e25d9b73dac5173f$var$TabScrollButton = /*#__PURE__*/ $cQmXV.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $f72a8065b49cc3d6$export$b2dd014b6c321cb)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $e25d9b73dac5173f$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $78749e277eeaf032$export$2e2bcd8739ae039);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $7c94f792d6e06656$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $60d67c48e0ec431c$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $60d67c48e0ec431c$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7uT18.jsx)($e25d9b73dac5173f$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $jYj5L.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === "vertical" && {
                "--TabScrollButton-svgRotate": `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === "left" ? /*#__PURE__*/ (0, $7uT18.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $7uT18.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $e25d9b73dac5173f$export$2e2bcd8739ae039 = $e25d9b73dac5173f$var$TabScrollButton;




var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $f8dae3aa5d10654d$export$cdd93bd054dec359(slot) {
    return (0, $jQsHx.default)("MuiTabs", slot);
}
const $f8dae3aa5d10654d$var$tabsClasses = (0, $9FFKn.default)("MuiTabs", [
    "root",
    "vertical",
    "list",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $f8dae3aa5d10654d$export$2e2bcd8739ae039 = $f8dae3aa5d10654d$var$tabsClasses;



var $01d449693793c717$export$2e2bcd8739ae039 = (0, $0a9753fa19441ed9$export$2e2bcd8739ae039);







"use client";
function $4e2f37edc5e8d927$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $773e0a3b5375e927$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $819ee29ec5105d66$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $9a137d8a34f7c4e6$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $9cb4de6d8813671a$export$2e2bcd8739ae039)(elementType, {
        ...name === "root" && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== "root" && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



var $7uT18 = parcelRequire("7uT18");
"use client";
const $e992d5427be5c438$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $e992d5427be5c438$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $e992d5427be5c438$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $e992d5427be5c438$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        list: [
            "list",
            "flexContainer",
            vertical && "flexContainerVertical",
            vertical && "vertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $f8dae3aa5d10654d$export$cdd93bd054dec359), classes);
};
const $e992d5427be5c438$var$TabsRoot = (0, $kZnRZ.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f8dae3aa5d10654d$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $f8dae3aa5d10654d$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $dGUQw.default)(({ theme: theme })=>({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex",
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: "column"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $f8dae3aa5d10654d$export$2e2bcd8739ae039).scrollButtons}`]: {
                        [theme.breakpoints.down("sm")]: {
                            display: "none"
                        }
                    }
                }
            }
        ]
    })));
const $e992d5427be5c438$var$TabsScroller = (0, $kZnRZ.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: "relative",
    display: "inline-block",
    flex: "1 1 auto",
    whiteSpace: "nowrap",
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: "hidden",
                width: "100%"
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: "none",
                // Firefox
                "&::-webkit-scrollbar": {
                    display: "none" // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: "auto",
                overflowY: "hidden"
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: "auto",
                overflowX: "hidden"
            }
        }
    ]
});
const $e992d5427be5c438$var$List = (0, $kZnRZ.default)("div", {
    name: "MuiTabs",
    slot: "List",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: "flex",
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: "column"
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: "center"
            }
        }
    ]
});
const $e992d5427be5c438$var$TabsIndicator = (0, $kZnRZ.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})((0, $dGUQw.default)(({ theme: theme })=>({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: "primary"
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: "secondary"
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: "100%",
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $e992d5427be5c438$var$TabsScrollbarSize = (0, $kZnRZ.default)((0, $f9da43a3ab99c6f6$export$2e2bcd8739ae039))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $e992d5427be5c438$var$defaultIndicatorStyle = {};
let $e992d5427be5c438$var$warnedOnceTabPresent = false;
const $e992d5427be5c438$var$Tabs = /*#__PURE__*/ $cQmXV.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $6e330efe521cf043$export$2e2bcd8739ae039)();
    const isRtl = (0, $f72a8065b49cc3d6$export$b2dd014b6c321cb)();
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $e992d5427be5c438$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $60d67c48e0ec431c$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $60d67c48e0ec431c$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $cQmXV.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $cQmXV.useState($e992d5427be5c438$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $cQmXV.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $cQmXV.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $cQmXV.useState(false);
    const [scrollerStyle, setScrollerStyle] = $cQmXV.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $cQmXV.useRef(null);
    const tabListRef = $cQmXV.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $75d3b7d855158be1$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== "number" || typeof indicatorStyle[size] !== "number") setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $68d597f163ea68c8$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("scrollbar", {
        className: (0, $jYj5L.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $e992d5427be5c438$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $cQmXV.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("scrollButtons", {
        className: (0, $jYj5L.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $e25d9b73dac5173f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $7uT18.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $7uT18.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $7uT18.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $75d3b7d855158be1$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $75d3b7d855158be1$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $cQmXV.useEffect(()=>{
        const handleResize = (0, $bf21fc82f771e47b$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $0249870df7ab56c2$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $cQmXV.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $cQmXV.useEffect(()=>{
        setMounted(true);
    }, []);
    $cQmXV.useEffect(()=>{
        updateIndicatorState();
    });
    $cQmXV.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($e992d5427be5c438$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $cQmXV.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("indicator", {
        className: (0, $jYj5L.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $e992d5427be5c438$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $7uT18.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $cQmXV.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $cQmXV.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $cQmXV.cloneElement(child, {
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $01d449693793c717$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $e992d5427be5c438$var$moveFocus(list, currentFocus, $e992d5427be5c438$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $e992d5427be5c438$var$moveFocus(list, currentFocus, $e992d5427be5c438$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $e992d5427be5c438$var$moveFocus(list, null, $e992d5427be5c438$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $e992d5427be5c438$var$moveFocus(list, null, $e992d5427be5c438$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("root", {
        ref: ref,
        className: (0, $jYj5L.default)(classes.root, className),
        elementType: $e992d5427be5c438$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("scroller", {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $e992d5427be5c438$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("list", {
        ref: tabListRef,
        className: (0, $jYj5L.default)(classes.list, classes.flexContainer),
        elementType: $e992d5427be5c438$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $7uT18.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $7uT18.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $e992d5427be5c438$export$2e2bcd8739ae039 = $e992d5427be5c438$var$Tabs;



function $79a08f0c966164e4$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `simple-tabpanel-${index}`,
        "aria-labelledby": `simple-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $7uT18.jsx)((0, $7022a2be733b2a79$export$2e2bcd8739ae039), {
            sx: {
                p: 3
            },
            children: children
        })
    });
}
$79a08f0c966164e4$var$TabPanel.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).node,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number.isRequired
};
function $79a08f0c966164e4$var$a11yProps(index) {
    return {
        "id": `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}
function $79a08f0c966164e4$export$2e2bcd8739ae039({ labels: labels, tabs: tabs, activeTab: activeTab = 0, className: className = "" }) {
    const [value, setValue] = $cQmXV.useState(activeTab);
    const handleChange = (event, newValue)=>{
        setValue(newValue);
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7022a2be733b2a79$export$2e2bcd8739ae039), {
        sx: {
            width: "100%"
        },
        className: className,
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $7022a2be733b2a79$export$2e2bcd8739ae039), {
                sx: {
                    borderBottom: 1,
                    borderColor: "divider"
                },
                children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $e992d5427be5c438$export$2e2bcd8739ae039), {
                    value: value,
                    onChange: handleChange,
                    "aria-label": "bulk create tasks",
                    children: labels?.map((item, index)=>/*#__PURE__*/ (0, $7uT18.jsx)((0, $c2fc2e502fe795cd$export$2e2bcd8739ae039), {
                            label: item,
                            ...$79a08f0c966164e4$var$a11yProps(index)
                        }, index))
                })
            }),
            tabs?.map((item, index)=>/*#__PURE__*/ (0, $7uT18.jsx)($79a08f0c966164e4$var$TabPanel, {
                    value: value,
                    index: index,
                    children: item
                }, index))
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");






var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
class $cb7aa011a1acb993$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    render() {
        const { loading: loading, disP: disP = false, type: type = "loader" } = this.props;
        return loading && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: `data-loader${type === "spinner" ? " data-loader--spinner" : ""}`,
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: `data-loader-content text-center ${disP ? "" : "pl-5"}`,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                        className: "fa fa-spinner fa-pulse fa-2x fa-fw"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "sr-only",
                        children: "Loading..."
                    })
                ]
            })
        });
    }
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



const $1ce364701ea3e4d9$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $1ce364701ea3e4d9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
    constructor(props){
        super(props);
        this.state = {
            pager: {}
        };
    }
    getPager = (totalItems, currentPage, pageSize)=>{
        // default to first page
        currentPage = currentPage || 1;
        // default page size is 10
        pageSize = pageSize || 10;
        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);
        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }
        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        // create an array of pages to ng-repeat in the pager control
        var pages = [
            ...Array(endPage + 1 - startPage).keys()
        ].map((i)=>startPage + i);
        // return object with all pager properties required by the view
        let pager = {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
        this.setState({
            pager: pager
        });
    };
    componentDidMount() {}
    UNSAFE_componentWillReceiveProps(props) {
        const { pagination: pagination } = props;
        if (!pagination || !pagination.state) return;
        this.getPager(pagination.count, pagination.page, pagination.sizePerPage);
    }
    update = (page)=>{
        const { pagination: pagination } = this.props;
        this.getPager(pagination.count, page, pagination.sizePerPage);
        this.props.updatePage(page, ()=>{});
    };
    render() {
        const { pagination: pagination } = this.props;
        const { pager: pager } = this.state;
        if (!pagination || !pagination.state) return null;
        if (pagination.count == 0) return null;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "col-md-12",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("ul", {
                className: "pagination",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                        className: pager.currentPage === 1 ? "disabled" : "",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                            onClick: ()=>{
                                if (pager.currentPage === 1) return;
                                this.update(1);
                            },
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "first_page", $1ce364701ea3e4d9$var$me.language)
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                        className: pager.currentPage === 1 ? "disabled" : "",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                            onClick: ()=>{
                                if (pager.currentPage === 1) return;
                                this.update(pager.currentPage - 1);
                            },
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "previous_page", $1ce364701ea3e4d9$var$me.language)
                        })
                    }),
                    pager?.pages?.map((page, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("li", {
                            className: pager.currentPage === page ? "active" : "",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                onClick: ()=>this.update(page),
                                children: page
                            })
                        }, index)),
                    /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                        className: pager.currentPage === pager.totalPages ? "disabled" : "",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                            onClick: ()=>{
                                if (pager.currentPage === pager.totalPages) return;
                                this.update(pager.currentPage + 1);
                            },
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "next_page", $1ce364701ea3e4d9$var$me.language)
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                        className: pager.currentPage === pager.totalPages ? "disabled" : "",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                            onClick: ()=>{
                                if (pager.currentPage === pager.totalPages) return;
                                this.update(pager.totalPages);
                            },
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "last_page", $1ce364701ea3e4d9$var$me.language)
                        })
                    })
                ]
            })
        });
    }
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



class $d4b6a9d27c93fbb2$var$PointFilter extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            county: ""
        };
    }
    componentDidMount = ()=>{
        let { me: me } = this.props;
        if (me) {
            let county = "";
            county = me?.county?.id;
            if (Number.isInteger(me.county)) county = me.county;
            this.setState({
                county: county
            });
        }
    };
    changeCounty = (option)=>{
        //remove these comments after testing
        //let initCounty = this.props.me?.county;
        /*     if (!option) {
      option = {
        ...initCounty,
        value: this.state.county,
        label: "",
      };
    } */ if (!option) option = {
            id: "",
            country: "",
            value: "",
            label: ""
        };
        this.setState({
            county: ""
        }, ()=>{
            this.setState({
                county: option?.id
            });
        });
        if (typeof this.props.onChangeRegion === "function") this.props.onChangeRegion(option);
    };
    render() {
        let { isDisabled: isDisabled, moduleFilter: moduleFilter, isMulti: isMulti } = this.props;
        let className = this.props.className || "";
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "pointFilter " + className,
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                    entity: "county",
                    value: this.props.saveValue ? this.props.saveValue : this.state.county,
                    asynch: false,
                    onChange: this.changeCounty,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                    entity: "points",
                    value: this.props.value,
                    moduleFilter: moduleFilter,
                    county: this.state.county,
                    asynch: true,
                    isMulti: isMulti,
                    onChange: this.props.onChange,
                    isDisabled: isDisabled,
                    useFullOptionObject: this.props.useFullOptionObject
                })
            ]
        });
    }
}
var $d4b6a9d27c93fbb2$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($d4b6a9d27c93fbb2$var$PointFilter));






// import Input from './Input';
class $81b6b064afbc82da$var$EntityTable extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.defaultCreatedFromDate = new Date(new Date().setDate(new Date().getDate() - 14));
        const start = new Date();
        this.toDayDate = new Date().setHours(0, 0, 0, 0);
        // current week start
        this.curWeekStart = new Date(start);
        const day = start.getDay(); //Weekday (0 - Sunday, 1 - Monday, ..., 6 - Saturday)
        const diff = day === 0 ? -6 : 1 - day; // If Sunday (0), then shift by -6 days
        this.curWeekStart.setDate(start.getDate() + diff);
        this.curWeekStart.setHours(0, 0, 0, 1);
        this.EndDate = start.getTime();
        this.state = {
            data: [],
            count: 0,
            loading: false,
            valid: false,
            pagination: {
                state: false,
                count: 0,
                sizePerPage: this.props.sizePerPage || 25,
                pageAmount: 1,
                page: 1
            },
            getFilterUrlKey: props.getFilterUrlKey,
            filter: {
                merchandiser: {
                    search: ""
                },
                route: {
                    user: "",
                    day_of_the_week: ""
                },
                task: {
                    start: null,
                    end: null,
                    createdDateFrom: this.defaultCreatedFromDate,
                    createdDateTo: null,
                    user: "",
                    no_answers: "",
                    task_status: "",
                    task_deadline: "",
                    task_negative: "",
                    network: "",
                    point__network: "",
                    created_by: "",
                    point: "",
                    point__responsible_supervisor: "",
                    template: "",
                    point__locality__county: this.props.me?.county?.id,
                    searchText: ""
                },
                visit: {
                    user: "",
                    supervisor: "",
                    network: "",
                    point__network: "",
                    point: "",
                    county: "",
                    start: this.curWeekStart,
                    end: this.EndDate,
                    date_range: ""
                },
                point: {
                    network: "",
                    county: "",
                    locality: ""
                }
            }
        };
    }
    filterToParams = (entity, filter)=>{
        const params = new URLSearchParams();
        const f = filter[entity];
        const dateStr = (v)=>{
            if (!v) return null;
            const d = new Date(v);
            if (isNaN(d)) return null;
            return d.toISOString().slice(0, 10);
        };
        const set = (key, val)=>{
            if (val != null && val !== "" && val !== false) params.set(key, String(val));
        };
        if (entity === "task") {
            if (dateStr(f.start)) params.set("start", dateStr(f.start));
            if (dateStr(f.end)) params.set("end", dateStr(f.end));
            if (dateStr(f.createdDateFrom)) params.set("createdFrom", dateStr(f.createdDateFrom));
            if (dateStr(f.createdDateTo)) params.set("createdTo", dateStr(f.createdDateTo));
            set("supervisor", f.point__responsible_supervisor);
            set("network", f.point__network);
            set("template", f.template);
            set("status", f.task_status);
            set("created_by", f.created_by);
            set("point", f.point);
            set("county", f.point__locality__county);
            set("search", f.searchText);
            if (f.task_deadline) params.set("deadline", "1");
            if (f.task_negative) params.set("negative", "1");
        } else if (entity === "visit") {
            if (dateStr(f.start)) params.set("start", dateStr(f.start));
            if (dateStr(f.end)) params.set("end", dateStr(f.end));
            set("user", f.user);
            set("network", f.point__network);
            set("point", f.point);
            set("county", f.county);
            set("date_range", f.date_range);
        } else if (entity === "point") {
            set("network", f.network);
            set("county", f.county);
            set("locality", f.locality);
        } else if (entity === "merchandiser") set("search", f.search);
        else if (entity === "route") set("user", f.user);
        return params;
    };
    paramsToFilter = (entity, search)=>{
        const params = new URLSearchParams(search);
        const filter = structuredClone(this.state.filter);
        const get = (key)=>params.get(key);
        const getNum = (key)=>{
            const v = params.get(key);
            return v ? isNaN(v) ? v : Number(v) : null;
        };
        if (entity === "task") {
            if (get("start")) filter.task.start = get("start");
            if (get("end")) filter.task.end = get("end");
            if (get("createdFrom")) filter.task.createdDateFrom = get("createdFrom");
            if (get("createdTo")) filter.task.createdDateTo = get("createdTo");
            if (get("supervisor")) filter.task.point__responsible_supervisor = getNum("supervisor");
            if (get("network")) filter.task.point__network = getNum("network");
            if (get("template")) filter.task.template = getNum("template");
            if (get("status")) filter.task.task_status = getNum("status");
            if (get("created_by")) filter.task.created_by = getNum("created_by");
            if (get("point")) filter.task.point = getNum("point");
            if (get("county")) filter.task.point__locality__county = getNum("county");
            if (get("search")) filter.task.searchText = get("search");
            if (get("deadline")) filter.task.task_deadline = true;
            if (get("negative")) filter.task.task_negative = true;
        } else if (entity === "visit") {
            if (get("start")) filter.visit.start = get("start");
            if (get("end")) filter.visit.end = get("end");
            if (get("user")) filter.visit.user = getNum("user");
            if (get("network")) filter.visit.point__network = getNum("network");
            if (get("point")) filter.visit.point = getNum("point");
            if (get("county")) filter.visit.county = getNum("county");
            if (get("date_range")) filter.visit.date_range = get("date_range");
        } else if (entity === "point") {
            if (get("network")) filter.point.network = getNum("network");
            if (get("county")) filter.point.county = getNum("county");
            if (get("locality")) filter.point.locality = getNum("locality");
        } else if (entity === "merchandiser") {
            if (get("search")) filter.merchandiser.search = get("search");
        } else if (entity === "route") {
            if (get("user")) filter.route.user = getNum("user");
        }
        return filter;
    };
    syncUrl = ()=>{
        const params = this.filterToParams(this.props.entity, this.state.filter);
        this.props.history.replace({
            search: params.toString()
        });
    };
    componentDidMount() {
        const { entity: entity } = this.props;
        const search = this.props.location?.search;
        if (search) {
            const filter = this.paramsToFilter(entity, search);
            this.setState({
                filter: filter
            }, ()=>this.load());
            return;
        }
        if (this.props.entity === "visit") {
            if (this.props.history.action === "POP") {
                localStorage.getItem("visitCurrentPage") && localStorage.removeItem("visitCurrentPage");
                localStorage.getItem("visitCurrentFilter") && localStorage.removeItem("visitCurrentFilter");
                this.load();
            } else if ([
                "REPLACE",
                "PUSH"
            ].includes(this.props.history.action) && !localStorage.getItem("visitCurrentFilter")) this.load();
            else {
                const currentVisitPage = localStorage.getItem("visitCurrentPage") ? Number(localStorage.getItem("visitCurrentPage")) : 1;
                localStorage.getItem("visitCurrentFilter") && this.updatePaging(currentVisitPage);
            }
        } else this.load();
    }
    componentDidUpdate(prevProps, prevState) {
        //set current visit page filter for page after component reload
        if (this.props.entity !== "visit") return;
        const currentVisitPage = localStorage.getItem("visitCurrentPage") && this.props.entity === "visit" ? Number(localStorage.getItem("visitCurrentPage")) : 1;
        let filter = this.state.filter;
        const savedFilterOption = localStorage.getItem("visitCurrentFilter");
        if (savedFilterOption && savedFilterOption !== JSON.stringify(prevState.filter["visit"])) {
            let savedFilter = null;
            try {
                savedFilter = JSON.parse(savedFilterOption); // corrupt/legacy value must not crash the update
            } catch (e) {
                savedFilter = null;
            }
            if (savedFilter) {
                Object.entries(savedFilter).forEach(([key, value])=>{
                    filter["visit"][key] = value;
                });
                this.setState({
                    filter: filter
                });
            }
        }
        //set current visit page for correct navigation from visit page after component reload
        if (currentVisitPage && prevState.pagination.page !== currentVisitPage) setTimeout(()=>{
            this.updatePaging(currentVisitPage);
        }, 250);
    }
    load = ()=>{
        this.setState({
            loading: true
        });
        if (this.props.type && this.props.type === "data") {
            this.setState({
                data: this.props.data,
                loading: false,
                count: this.props.data.length
            });
            return;
        }
        let { entity: entity } = this.props;
        let { pagination: pagination } = this.state;
        let url = entity + "s/";
        if (entity === "merchandiser") {
            // Merchandiser list: request a page and (optionally) a server search term.
            url += "?page=" + pagination.page;
            const search = this.state.filter.merchandiser?.search;
            if (search) url += "&search=" + encodeURIComponent(search);
        } else {
            let urlFilter = (0, $3b579ca6158bc61b$export$728929c44bc0c14b)(entity, this.state.filter[entity]);
            if (entity === "task" || entity === "visit" || entity === "point" || entity === "task-review") {
                url += "?page=" + pagination.page;
                // Send an explicit page_size for visits so the client pager (sizePerPage)
                // stays in sync with the server instead of relying on its default.
                if (entity === "visit") url += "&page_size=" + pagination.sizePerPage;
            }
            if (urlFilter) url += urlFilter;
        }
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            if (entity === "task" || entity === "visit" || entity === "point" || entity === "task-review") {
                const count = response.count || 0;
                const results = response.results || [];
                const newPagination = {
                    state: true,
                    pageAmount: Math.ceil(count / pagination.sizePerPage),
                    count: count,
                    page: pagination.page,
                    sizePerPage: pagination.sizePerPage
                };
                this.setState({
                    data: results,
                    count: count,
                    loading: false,
                    pagination: newPagination
                });
                if (this.props.dataPoints) this.props.dataPoints(results);
            } else if (entity === "merchandiser") {
                // Support both a server-paginated response ({ results, count }) and a plain array
                // (endpoint returns the full list) — in the latter case, paginate on the client.
                const isServerPaged = response && !Array.isArray(response) && Array.isArray(response.results);
                const all = isServerPaged ? response.results : Array.isArray(response) ? response : [];
                const count = isServerPaged ? response.count : all.length;
                const start = isServerPaged ? 0 : (pagination.page - 1) * pagination.sizePerPage;
                const pageItems = isServerPaged ? all : all.slice(start, start + pagination.sizePerPage);
                this.setState({
                    data: pageItems,
                    count: count,
                    loading: false,
                    pagination: {
                        ...pagination,
                        state: true,
                        count: count,
                        pageAmount: Math.ceil(count / pagination.sizePerPage)
                    }
                });
            } else if (response.length > 0) this.setState({
                data: response,
                count: response.count,
                loading: false
            });
            else this.setState({
                data: [],
                count: 0,
                loading: false
            });
        });
    };
    setDateAgo = (option = "today")=>{
        const today = new Date();
        let date;
        switch(option){
            case "today":
                date = new Date(this.toDayDate);
                break;
            case "yesterday":
                {
                    const todayFromStart = new Date(this.toDayDate);
                    date = new Date(todayFromStart.setDate(today.getDate() - 1));
                    break;
                }
            case "current_week":
                date = this.curWeekStart;
                break;
            case "last_week":
                {
                    const lastWeekStart = new Date(today);
                    lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
                    lastWeekStart.setHours(23, 59, 59, 999);
                    date = lastWeekStart;
                    break;
                }
            case "current_month":
                {
                    const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
                    date = currentMonthStart;
                    break;
                }
            case "last_month":
                {
                    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    date = lastMonthStart;
                    break;
                }
            case "last_half_a_year":
                {
                    const lastHalfYear = new Date(this.toDayDate);
                    lastHalfYear.setMonth(today.getMonth() - 6);
                    date = lastHalfYear;
                    break;
                }
            default:
                throw new Error("Invalid option");
        }
        return date.getTime();
    };
    prepareSavedFilterOption = (filter)=>{
        for(const key in filter)if (filter[key] === null || filter[key] === undefined) filter[key] = "";
    };
    changeFilter = (entity, filterEntity, item)=>{
        let filter = this.state.filter;
        const dateAndTextFilters = [
            "start",
            "end",
            "createdDateFrom",
            "createdDateTo",
            "searchText"
        ];
        const now = new Date();
        const startOfWeek = new Date(now); //copy for start of the week
        switch(true){
            case entity === "merchandiser" && filterEntity === "search":
                filter[entity][filterEntity] = item.target.value;
                break;
            case entity === "task" && dateAndTextFilters.includes(filterEntity):
                filter[entity][filterEntity] = item;
                break;
            case entity === "task" && filterEntity === "task_deadline":
                filter[entity][filterEntity] = item.target?.checked;
                break;
            case entity === "task" && filterEntity === "task_negative":
                filter[entity][filterEntity] = item.target?.checked;
                break;
            case entity === "visit" && filterEntity === "point":
                // filter[entity][filterEntity] = item; //if need to multiple points
                if (!item) filter[entity][filterEntity] = "";
                else filter[entity][filterEntity] = item.id;
                break;
            case entity === "visit" && filterEntity === "start" || entity === "visit" && filterEntity === "end":
                filter[entity][filterEntity] = item;
                break;
            case entity === "visit" && filterEntity === "date_range":
                if (item) {
                    filter[entity][filterEntity] = item.value;
                    filter[entity]["start"] = item.value;
                    if (item.id === 1) //yesterday
                    filter[entity]["end"] = this.toDayDate;
                    else if (item.id === 3) {
                        //last_week
                        startOfWeek.setDate(now.getDate() - now.getDay());
                        filter[entity]["end"] = startOfWeek.setHours(23, 59, 59, 999);
                    } else if (item.id === 5) //last_month
                    filter[entity]["end"] = new Date(now.getFullYear(), now.getMonth(), 1);
                    else // if (item.id != 1) filter[entity]["end"] = this.EndDate;
                    filter[entity]["end"] = this.EndDate;
                } else filter[entity][filterEntity] = "";
                break;
            default:
                filter[entity][filterEntity] = item?.id;
                break;
        }
        if (entity === "visit") {
            this.prepareSavedFilterOption(filter.visit);
            localStorage.setItem("visitCurrentFilter", JSON.stringify(filter.visit));
        }
        if (entity === "point") this.state.getFilterUrlKey({
            key: filterEntity,
            value: item?.id
        });
        if (entity === "point" && this.props.onBeforeChange) this.props.onBeforeChange(()=>{
            this.setState({
                filter: filter
            }, ()=>{
                this.syncUrl();
                this.updatePaging(1, undefined, true);
            });
        });
        else this.setState({
            filter: filter
        }, ()=>{
            if (entity !== "visit") {
                this.syncUrl();
                // Free-text search fields fire on every keystroke — debounce the fetch. Selects,
                // dates and checkboxes apply immediately.
                const isTextSearch = filterEntity === "searchText" || filterEntity === "search";
                if (isTextSearch) {
                    clearTimeout(this.searchDebounceTimer);
                    this.searchDebounceTimer = setTimeout(()=>this.updatePaging(1), (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
                } else this.updatePaging(1);
            }
        });
    };
    componentWillUnmount() {
        clearTimeout(this.searchDebounceTimer);
    }
    submit = ()=>{
        this.syncUrl();
        this.updatePaging(1);
    };
    clearFilter = ()=>{
        let filter = structuredClone(this.state.filter);
        Object.keys(filter[this.props.entity])?.map((item)=>{
            if (this.props.entity === "visit") {
                localStorage.getItem("visitCurrentPage") && localStorage.removeItem("visitCurrentPage");
                localStorage.getItem("visitCurrentFilter") && localStorage.removeItem("visitCurrentFilter");
                filter[this.props.entity][item] = null;
            } else filter[this.props.entity][item] = null;
            if (item === "createdDateFrom") filter[this.props.entity][item] = this.defaultCreatedFromDate;
            if (this.props.entity === "visit" && item === "start") filter[this.props.entity][item] = this.curWeekStart;
            if (this.props.entity === "visit" && item === "end") filter[this.props.entity][item] = this.EndDate;
            if (item === "task_deadline" || item === "task_negative") filter[this.props.entity][item] = false;
        });
        if (this.props.entity === "point") this.state.getFilterUrlKey(null);
        this.props.history.replace({
            search: ""
        });
        this.setState({
            filter: filter
        }, ()=>{
            this.updatePaging(1);
        });
    };
    // PAGINATION
    updatePaging = (page, cb, skipBeforeChange = false)=>{
        const applyChange = ()=>{
            let { pagination: pagination } = this.state;
            pagination.page = page;
            //set current visit page for correct navigation from visit page
            if (this.props.entity === "visit") localStorage.setItem("visitCurrentPage", pagination.page);
            this.setState({
                pagination: pagination
            }, ()=>{
                this.load();
                if (cb) cb();
                //scroll to top after change navigation
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            });
        };
        if (this.props.entity === "point" && this.props.onBeforeChange && !skipBeforeChange) this.props.onBeforeChange(applyChange);
        else applyChange();
    };
    render() {
        if (!this.props.me) return null;
        const { data: data, loading: loading, filter: filter } = this.state;
        const { entity: entity, me: me, openVisitFn: openVisitFn, rowClassName: rowClassName } = this.props;
        let isNewBtn = [
            "merchandiser",
            "task"
        ].indexOf(this.props.entity) != -1;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "container-fluid",
            children: [
                isNewBtn && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "row mb-2",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "col-12 text-right",
                        children: [
                            this.props.entity !== "task" && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                                to: "/" + this.props.entity + "/new",
                                className: "md-create-btn",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "add"
                                    }),
                                    " ",
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "create_btn", me.language)
                                ]
                            }),
                            this.props.entity === "task" && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                                to: "/task/new/point",
                                className: "md-create-btn",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "add"
                                    }),
                                    " ",
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "to_point_btn", me.language)
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "md-filter-panel",
                    children: [
                        entity === "merchandiser" && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "md-search-wrap",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                type: "text",
                                className: "md-search-input",
                                placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "search_placeholder", me.language),
                                value: filter.merchandiser.search,
                                onChange: (e)=>this.changeFilter("merchandiser", "search", e)
                            })
                        }),
                        entity === "route" && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "md-filter-grid",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-filter-field",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "md-filter-label",
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "merchandiser", me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                        entity: "merchandiser",
                                        value: filter.route.user,
                                        onChange: (o)=>this.changeFilter("route", "user", o)
                                    })
                                ]
                            })
                        }),
                        entity === "task" && /*#__PURE__*/ (0, $7uT18.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field md-filter-field--dates",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "start_date", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                    selected: filter.task.start,
                                                    className: "datePicker",
                                                    onChange: (date)=>this.changeFilter("task", "start", date),
                                                    placeholderText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "start_date", me.language),
                                                    isClearable: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field md-filter-field--dates",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "creation_date_from", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                    selected: filter.task.createdDateFrom,
                                                    className: "datePicker",
                                                    onChange: (date)=>this.changeFilter("task", "createdDateFrom", date),
                                                    placeholderText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "creation_date_from", me.language),
                                                    isClearable: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field md-filter-field--dates",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "creation_date_to", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                    selected: filter.task.createdDateTo,
                                                    className: "datePicker",
                                                    onChange: (date)=>this.changeFilter("task", "createdDateTo", date),
                                                    placeholderText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "creation_date_to", me.language),
                                                    isClearable: true
                                                })
                                            ]
                                        }),
                                        me.role === "supervisor_manager" && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "supervisor", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "supervisor",
                                                    value: filter.task.point__responsible_supervisor,
                                                    onChange: (o)=>this.changeFilter("task", "point__responsible_supervisor", o)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "network", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "point__network",
                                                    value: filter.task.point__network,
                                                    onChange: (o)=>this.changeFilter("task", "point__network", o)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "template", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "template",
                                                    value: filter.task.template,
                                                    onChange: (o)=>this.changeFilter("task", "template", o)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "task_status", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "task_status",
                                                    value: filter.task.task_status,
                                                    onChange: (o)=>this.changeFilter("task", "task_status", o)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "created_by", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "created_by",
                                                    value: filter.task.created_by,
                                                    onChange: (o)=>this.changeFilter("task", "created_by", o)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "md-filter-grid md-filter-grid--point",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $d4b6a9d27c93fbb2$export$2e2bcd8739ae039), {
                                        value: filter.task.point,
                                        moduleFilter: filter.task?.point__network,
                                        onChange: (option)=>this.changeFilter("task", "point", option),
                                        onChangeRegion: (option)=>this.changeFilter("task", "point__locality__county", option)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-actions-left",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "task-form-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                                    type: "checkbox",
                                                                    name: "task_deadline",
                                                                    className: "form-filter-checkbox",
                                                                    checked: filter.task.task_deadline,
                                                                    value: filter.task.task_deadline,
                                                                    onChange: (e)=>this.changeFilter("task", "task_deadline", e)
                                                                }),
                                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "filter_overdue_tasks", me.language)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                                    type: "checkbox",
                                                                    name: "task_negative",
                                                                    className: "form-filter-checkbox",
                                                                    checked: filter.task.task_negative,
                                                                    value: filter.task.task_negative,
                                                                    onChange: (e)=>this.changeFilter("task", "task_negative", e)
                                                                }),
                                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "filter_tasks_with_negative_responses", me.language)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    style: {
                                                        width: "200px"
                                                    },
                                                    placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "search_placeholder", me.language),
                                                    value: filter.task.searchText,
                                                    onChange: (e)=>this.changeFilter("task", "searchText", e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "md-filter-actions-right",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                className: "btn btn-outline-primary",
                                                onClick: this.clearFilter,
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "filter_reset_btn", me.language)
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        entity === "visit" && /*#__PURE__*/ (0, $7uT18.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field md-filter-field--dates",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: "\u0414\u0430\u0442\u0430"
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "md-filter-dates",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                            selected: filter.visit.start ? new Date(filter.visit.start) : null,
                                                            className: "datePicker",
                                                            onChange: (date)=>this.changeFilter("visit", "start", date)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "md-filter-date-sep",
                                                            children: "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                            selected: filter.visit.end ? new Date(filter.visit.end) : null,
                                                            className: "datePicker",
                                                            onChange: (date)=>this.changeFilter("visit", "end", date)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_range", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    setDateAgo: this.setDateAgo,
                                                    entity: "date_range",
                                                    placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "date_current_week", me.language),
                                                    value: filter.visit.date_range,
                                                    onChange: (o)=>this.changeFilter("visit", "date_range", o)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "merchandiser", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "merchandiser",
                                                    value: filter.visit.user,
                                                    onChange: (o)=>this.changeFilter("visit", "user", o)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "network", me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "network",
                                                    value: filter.visit.point__network,
                                                    onChange: (o)=>this.changeFilter("visit", "point__network", o)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "md-filter-grid md-filter-grid--point",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $d4b6a9d27c93fbb2$export$2e2bcd8739ae039), {
                                        saveValue: filter.visit.county,
                                        value: filter.visit.point,
                                        onChange: (o)=>this.changeFilter("visit", "point", o),
                                        onChangeRegion: (o)=>this.changeFilter("visit", "county", o),
                                        isMulti: false,
                                        moduleFilter: filter.visit.point__network
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "md-filter-actions",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "md-filter-actions-left",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                className: "btn btn-primary",
                                                onClick: this.submit,
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "apply_btn", me.language)
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                className: "btn btn-outline-primary",
                                                onClick: this.clearFilter,
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_reset", me.language)
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        entity === "point" && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "md-filter-grid",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "network", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "network",
                                            value: filter.point.network,
                                            onChange: (o)=>this.changeFilter("point", "network", o)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "region", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "county",
                                            value: filter.point.county,
                                            onChange: (o)=>this.changeFilter("point", "county", o)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "city", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "locality",
                                            value: filter.point.locality,
                                            onChange: (o)=>this.changeFilter("point", "locality", o)
                                        })
                                    ]
                                }),
                                (filter.point.network || filter.point.county || filter.point.locality) && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "md-filter-field",
                                    style: {
                                        flex: "0 0 auto",
                                        justifyContent: "flex-end"
                                    },
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                        className: "btn btn-outline-secondary btn-sm",
                                        onClick: ()=>this.clearFilter(),
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                className: "fa fa-times"
                                            }),
                                            " ",
                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f8552c1840a0c709), "filter_reset_btn", me.language)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "filtered-task-data",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                            loading: loading
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                            data: data,
                            version: "4",
                            striped: true,
                            hover: true,
                            bordered: false,
                            pagination: false,
                            search: false,
                            multiColumnSearch: true,
                            options: {
                                ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186),
                                onRowClick: openVisitFn
                            },
                            className: "themed-main-table-container",
                            trClassName: rowClassName ? rowClassName : "",
                            tableHeaderClass: "primary",
                            children: this.props.children
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $1ce364701ea3e4d9$export$2e2bcd8739ae039), {
                            pagination: this.state.pagination,
                            updatePage: (page)=>{
                                this.updatePaging(page);
                            }
                        })
                    ]
                })
            ]
        });
    }
}
var $81b6b064afbc82da$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($81b6b064afbc82da$var$EntityTable));




var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");








const $94d5ec6a0156546a$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $94d5ec6a0156546a$var$Absence extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            item: {
                start: new Date(),
                end: new Date(),
                reason: ""
            },
            changedItem: false,
            items: []
        };
    }
    submit = ()=>{
        let { item: item } = this.state;
        item.created_by = $94d5ec6a0156546a$var$me.id;
        item.merchandiser = this.props.user.id;
        setTimeout(()=>{
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "POST",
                url: "absences/",
                post: item
            }, (r)=>{
                if (r && r.id) {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456", {
                        position: "bottom-right"
                    });
                    let cleanItem = {
                        reason: "",
                        start: new Date(),
                        end: new Date()
                    };
                    this.setState({
                        item: cleanItem
                    });
                    this.load();
                } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving item. Error: " + JSON.stringify(r), {
                    position: "bottom-right"
                });
            });
        }, 3000);
        this.setState({
            changedItem: true
        });
    };
    onChange = (property, value)=>{
        let item = this.state.item;
        item[property] = value;
        this.setState({
            item: item,
            changedItem: false
        });
    };
    componentDidMount() {
        this.load();
    }
    load = ()=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "absences?merchandiser=" + this.props.user.id
        }, (r)=>{
            this.setState({
                items: r
            });
        });
    };
    render() {
        let { item: item } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "mp-absence",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "mp-absence-form-card",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("h3", {
                            className: "mp-absence-title",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "query", $94d5ec6a0156546a$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-absence-form-grid",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                            className: "mp-form-label",
                                            children: [
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "date_from", $94d5ec6a0156546a$var$me.language),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                            selected: new Date(item.start),
                                            className: "mp-form-input",
                                            onChange: (date)=>this.onChange("start", date)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                            className: "mp-form-label",
                                            children: [
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "date_to", $94d5ec6a0156546a$var$me.language),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                            selected: new Date(item.end),
                                            className: "mp-form-input",
                                            onChange: (date)=>this.onChange("end", date)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-form-group",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                    className: "mp-form-label",
                                    children: [
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "reason", $94d5ec6a0156546a$var$me.language),
                                        " *"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                    type: "text",
                                    className: "mp-form-input",
                                    placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "absence_reason", $94d5ec6a0156546a$var$me.language),
                                    value: item.reason,
                                    onChange: (e)=>this.onChange("reason", e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-form-group",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                    className: "mp-form-label",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "absence_short_reason_title", $94d5ec6a0156546a$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                    entity: "absence_reason_templates",
                                    placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "absence_short_reason", $94d5ec6a0156546a$var$me.language),
                                    value: item.reason,
                                    onChange: (e)=>{
                                        this.onChange("reason", e.label);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "mp-absence-form-actions",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                className: `mp-save-btn ${this.state.changedItem ? "mp-save-btn--disabled" : ""}`,
                                onClick: ()=>this.submit(),
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "add"
                                    }),
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "add_btn", $94d5ec6a0156546a$var$me.language)
                                ]
                            })
                        })
                    ]
                }),
                this.state.items.length > 0 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "mp-absence-history",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("h3", {
                            className: "mp-absence-title",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "absence_history", $94d5ec6a0156546a$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-absence-table",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-absence-table-head",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "date_from", $94d5ec6a0156546a$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "date_to", $94d5ec6a0156546a$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), "reason", $94d5ec6a0156546a$var$me.language)
                                        })
                                    ]
                                }),
                                this.state.items.map((i)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "mp-absence-table-row",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                children: (0, $b79edb411f97c469$export$1718d4b40b6ea71e)("", i)
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                children: (0, $b79edb411f97c469$export$450de2dd43fb03)("", i)
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                children: i.reason
                                            })
                                        ]
                                    }, i.id))
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $94d5ec6a0156546a$export$2e2bcd8739ae039 = $94d5ec6a0156546a$var$Absence;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");





class $61747ae11cbcb916$var$Edit extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            imgError: false
        };
    }
    render() {
        let { item: item, me: me } = this.props;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "mp-edit",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "mp-edit-avatar-section",
                    children: item?.photo && !this.state.imgError ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                        src: item.photo,
                        className: "mp-edit-avatar",
                        onError: ()=>this.setState({
                                imgError: true
                            })
                    }) : /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "mp-edit-avatar-fallback",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "material-symbols-outlined",
                            children: "person"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "mp-edit-grid",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-edit-col",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "name", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "mp-form-input",
                                            placeholder: "Enter first name",
                                            value: item && item.first_name,
                                            onChange: (e)=>this.props.onChange("first_name", e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "surname", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "mp-form-input",
                                            placeholder: "Enter last name",
                                            value: item && item.last_name,
                                            onChange: (e)=>this.props.onChange("last_name", e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "phone_number", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "mp-form-input",
                                            value: item && item.phone_number,
                                            onChange: (e)=>this.props.onChange("phone_number", e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "movement", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $e9e80384c89540c4$export$2e2bcd8739ae039), {
                                            options: (0, $6f1c09625235f1f0$export$dd427c62fc59153a),
                                            value: (0, $3b579ca6158bc61b$export$9df10f3a4586f4ff)(item.movement, (0, $6f1c09625235f1f0$export$dd427c62fc59153a)),
                                            onChange: (o)=>this.props.onChange("movement", o.value),
                                            className: "mp-select"
                                        })
                                    ]
                                }),
                                this.props.isNew && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "password", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "mp-form-input",
                                            placeholder: "Password",
                                            value: item && item.password,
                                            onChange: (e)=>this.props.onChange("password", e.target.value)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-edit-col",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "date_of_enrollment", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                            selected: new Date(item.date_joined),
                                            className: "mp-form-input",
                                            onChange: (date)=>this.props.onChange("date_joined", date)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "deactivation_date", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                            selected: new Date(item.date_deactivated),
                                            className: "mp-form-input",
                                            onChange: (date)=>this.props.onChange("date_deactivated", date)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "date_till_newbie", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                            selected: new Date(item.date_till_newbie),
                                            className: "mp-form-input",
                                            onChange: (date)=>this.props.onChange("date_till_newbie", date)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "status", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $e9e80384c89540c4$export$2e2bcd8739ae039), {
                                            options: (0, $6f1c09625235f1f0$export$fcbd761be6b3946e),
                                            value: (0, $3b579ca6158bc61b$export$9df10f3a4586f4ff)(item.is_active, (0, $6f1c09625235f1f0$export$fcbd761be6b3946e)),
                                            onChange: (o)=>this.props.onChange("is_active", o.value),
                                            className: "mp-select"
                                        })
                                    ]
                                }),
                                this.props.isNew && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "mp-form-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "repeat_password", me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "mp-form-input",
                                            placeholder: "Repeat password",
                                            value: item && item.password2,
                                            onChange: (e)=>this.props.onChange("password2", e.target.value)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                this.props.errors.length > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "mp-edit-errors",
                    children: this.props.errors.join(", ")
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "mp-edit-actions",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "mp-save-btn",
                        onClick: ()=>this.props.submit(),
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "save"
                            }),
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7066f9cb49bf9586), "save_changes_btn", me.language)
                        ]
                    })
                })
            ]
        });
    }
}
var $61747ae11cbcb916$export$2e2bcd8739ae039 = $61747ae11cbcb916$var$Edit;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");






var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");




const $46bcdae26abfb3ba$export$1dad1ee41cc975c4 = "application/x-picsell-point";
function $46bcdae26abfb3ba$export$2e2bcd8739ae039({ lang: lang }) {
    const [term, setTerm] = (0, $cQmXV.useState)("");
    const [results, setResults] = (0, $cQmXV.useState)([]);
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const debounceRef = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(()=>{
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(()=>{
            setLoading(true);
            const q = term ? `&search=${encodeURIComponent(term)}` : "";
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "GET",
                url: `points/?page=1&page_size=${(0, $91ea30cb49819b9a$export$be750171172fb886)}${q}`
            }, (resp)=>{
                setResults(Array.isArray(resp) ? resp : resp?.results || []);
                setLoading(false);
            });
        }, (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
        return ()=>debounceRef.current && clearTimeout(debounceRef.current);
    }, [
        term
    ]);
    const onDragStart = (e, point)=>{
        // Carry only the fields the calendar/save path needs.
        const payload = {
            id: point.id,
            name: point.name,
            address: point.address,
            locality: point.locality
        };
        e.dataTransfer.setData($46bcdae26abfb3ba$export$1dad1ee41cc975c4, JSON.stringify(payload));
        e.dataTransfer.effectAllowed = "copy";
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "rc-points-panel",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "rc-points-search",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "search"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: term,
                        onChange: (e)=>setTerm(e.target.value),
                        placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "search_placeholder", lang)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "rc-points-list",
                children: [
                    loading && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "rc-points-hint",
                        children: "\u2026"
                    }),
                    !loading && results.length === 0 && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "rc-points-hint",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "no_points_found", lang)
                    }),
                    results.map((point)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "rc-point-chip",
                            draggable: true,
                            onDragStart: (e)=>onDragStart(e, point),
                            title: point.address || "",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined rc-drag-handle",
                                    children: "drag_indicator"
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                    className: "rc-point-chip-body",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "rc-point-chip-name",
                                            children: point.name
                                        }),
                                        (point.locality?.name || point.address) && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "rc-point-chip-sub",
                                            children: point.locality?.name || point.address
                                        })
                                    ]
                                })
                            ]
                        }, point.id))
                ]
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


// Date helpers for the route calendar.
//
// The backend `Route.day_of_the_week` is Monday=0 … Sunday=6, and the Nth-of-month
// resolution mirrors the server filter exactly: nth = (day - 1) // 7 + 1.
// JS `Date.getDay()` is Sunday=0 … Saturday=6, so we convert to the Monday-based index.
const $7d0f78de0b68a104$var$pad = (n)=>String(n).padStart(2, "0");
const $7d0f78de0b68a104$export$56c97ca1cde8c5bb = (date)=>(date.getDay() + 6) % 7;
const $7d0f78de0b68a104$export$83a45ae2ed9f0324 = (date)=>Math.floor((date.getDate() - 1) / 7) + 1;
const $7d0f78de0b68a104$export$6dce03e22a5971e7 = (date)=>`${date.getFullYear()}-${$7d0f78de0b68a104$var$pad(date.getMonth() + 1)}-${$7d0f78de0b68a104$var$pad(date.getDate())}`;
const $7d0f78de0b68a104$export$a1081e8ce57742a4 = (date)=>new Date(date.getFullYear(), date.getMonth(), 1);
const $7d0f78de0b68a104$export$17c93e242b2d3a22 = (date, n)=>new Date(date.getFullYear(), date.getMonth() + n, 1);
const $7d0f78de0b68a104$export$a18c89cbd24170ff = (a, b)=>a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
const $7d0f78de0b68a104$var$today = ()=>{
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};
const $7d0f78de0b68a104$export$629b0a497aa65267 = (date)=>date.getTime() === $7d0f78de0b68a104$var$today().getTime();
const $7d0f78de0b68a104$export$2cb1dca7fa4861ea = (monthDate)=>{
    const first = $7d0f78de0b68a104$export$a1081e8ce57742a4(monthDate);
    const start = new Date(first);
    start.setDate(first.getDate() - $7d0f78de0b68a104$export$56c97ca1cde8c5bb(first)); // back up to the Monday on/before the 1st
    const weeks = [];
    const cursor = new Date(start);
    for(let w = 0; w < 6; w++){
        const row = [];
        for(let d = 0; d < 7; d++){
            row.push(new Date(cursor));
            cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(row);
    }
    return weeks;
};
// Locale for Intl month/weekday names, keyed by the app's language codes.
const $7d0f78de0b68a104$var$INTL_LOCALE = {
    uk: "uk",
    en: "en-GB",
    hy: "hy",
    ka: "ka"
};
const $7d0f78de0b68a104$var$localeFor = (lang)=>$7d0f78de0b68a104$var$INTL_LOCALE[lang] || "en-GB";
const $7d0f78de0b68a104$export$4f81354ee858acb4 = (monthDate, lang)=>new Intl.DateTimeFormat($7d0f78de0b68a104$var$localeFor(lang), {
        month: "long",
        year: "numeric"
    }).format(monthDate);
const $7d0f78de0b68a104$export$8d7bfd7870d0d02 = (lang)=>{
    const fmt = new Intl.DateTimeFormat($7d0f78de0b68a104$var$localeFor(lang), {
        weekday: "short"
    });
    // 2024-01-01 is a Monday.
    return Array.from({
        length: 7
    }, (_, i)=>fmt.format(new Date(2024, 0, 1 + i)));
};
const $7d0f78de0b68a104$export$39af906a0f4e17a1 = (date, lang)=>new Intl.DateTimeFormat($7d0f78de0b68a104$var$localeFor(lang), {
        day: "numeric",
        month: "short"
    }).format(date);


// Layered model for the route calendar.
//
// A merchandiser's schedule is edited as three ADDITIVE layers (not self-contained buckets):
//   base[wd]            recurring weekly stops for weekday wd (Mon=0..Sun=6)
//   weekAdd[wd][nth]    EXTRA stops layered on top of base for the Nth occurrence of wd
//   dateAdd[YYYY-MM-DD] EXTRA stops layered on top of base(+weekAdd) for one specific date
//
// The stops a merchandiser actually visits on a date = base ++ weekAdd(that Nth) ++ dateAdd,
// concatenated in that order and de-duplicated by point id. So periodic points always apply
// to every day they recur on, and one-off points are pure additions on a single date.
//
// The mobile API still reads one self-contained route per date (GET /routes then /order, no
// date on /order). So on save we MATERIALIZE each occurrence that has additions into a route
// carrying the full merged stop list, keyed so the server filter resolves the right one:
//   base  -> "w{wd}"        (day_of_the_week=wd, week_of_month=NULL)
//   nth   -> "n{wd}_{nth}"  (day_of_the_week=wd, week_of_month=nth) stops = base+weekAdd
//   date  -> "d{date}"      (day_of_the_week=NULL, start/end=date)  stops = base+weekAdd+dateAdd

const $29ff8c829ff33c74$export$4565335787d39d1e = (wd)=>`w${wd}`;
const $29ff8c829ff33c74$export$1c909ebeb219bebc = (wd, nth)=>`n${wd}_${nth}`;
const $29ff8c829ff33c74$export$b77d6fb52904647d = (ds)=>`d${ds}`;
const $29ff8c829ff33c74$export$57946e615fde2ef9 = (key)=>key[0] === "w";
const $29ff8c829ff33c74$export$5970e27c1aba6f13 = (key)=>key[0] === "n";
const $29ff8c829ff33c74$export$58e5ef6625e9cc03 = (key)=>key[0] === "d";
const $29ff8c829ff33c74$var$emptyLayers = ()=>({
        base: {},
        week: {},
        date: {}
    });
// Ordered list of point-stops from a route's nested order_set.
const $29ff8c829ff33c74$var$stopsFromRoute = (route)=>(route.points || []).filter((o)=>o && o.point).slice().sort((a, b)=>(a.order ?? 0) - (b.order ?? 0)).map((o)=>({
            point: o.point
        }));
const $29ff8c829ff33c74$export$5c77ee1a952795e1 = (route)=>{
    if (route.start) return $29ff8c829ff33c74$export$b77d6fb52904647d(route.start.slice(0, 10));
    if (route.week_of_month != null && route.day_of_the_week != null) return $29ff8c829ff33c74$export$1c909ebeb219bebc(route.day_of_the_week, route.week_of_month);
    if (route.day_of_the_week != null) return $29ff8c829ff33c74$export$4565335787d39d1e(route.day_of_the_week);
    return null;
};
const $29ff8c829ff33c74$var$appendUnique = (arr, stops)=>{
    const seen = new Set(arr.map((s)=>s.point.id));
    stops.forEach((s)=>{
        if (!seen.has(s.point.id)) {
            arr.push(s);
            seen.add(s.point.id);
        }
    });
};
const $29ff8c829ff33c74$export$65638ff2f6061a77 = (routes)=>{
    const layers = $29ff8c829ff33c74$var$emptyLayers();
    const loaded = {};
    const extraDeletedIds = [];
    const list = (routes || []).filter((r)=>$29ff8c829ff33c74$export$5c77ee1a952795e1(r));
    const byKind = (kindTest)=>list.filter((r)=>kindTest($29ff8c829ff33c74$export$5c77ee1a952795e1(r)));
    const register = (key, route)=>{
        if (!loaded[key]) loaded[key] = {
            id: route.id || null,
            pointIds: $29ff8c829ff33c74$var$stopsFromRoute(route).map((s)=>s.point.id)
        };
        else if (route.id) extraDeletedIds.push(route.id); // duplicate slot -> delete extra on save
    };
    // 1) base (week_of_month = NULL)
    byKind($29ff8c829ff33c74$export$57946e615fde2ef9).forEach((route)=>{
        const wd = route.day_of_the_week;
        layers.base[wd] = layers.base[wd] || [];
        $29ff8c829ff33c74$var$appendUnique(layers.base[wd], $29ff8c829ff33c74$var$stopsFromRoute(route));
        register($29ff8c829ff33c74$export$4565335787d39d1e(wd), route);
    });
    // 2) Nth-weekday: extras = route stops not already in base[wd]
    byKind($29ff8c829ff33c74$export$5970e27c1aba6f13).forEach((route)=>{
        const wd = route.day_of_the_week;
        const nth = route.week_of_month;
        const baseIds = new Set((layers.base[wd] || []).map((s)=>s.point.id));
        layers.week[wd] = layers.week[wd] || {};
        layers.week[wd][nth] = layers.week[wd][nth] || [];
        $29ff8c829ff33c74$var$appendUnique(layers.week[wd][nth], $29ff8c829ff33c74$var$stopsFromRoute(route).filter((s)=>!baseIds.has(s.point.id)));
        register($29ff8c829ff33c74$export$1c909ebeb219bebc(wd, nth), route);
    });
    // 3) one-off date: extras = route stops not already in base(+weekAdd for that occurrence)
    byKind($29ff8c829ff33c74$export$58e5ef6625e9cc03).forEach((route)=>{
        const ds = route.start.slice(0, 10);
        const [y, m, d] = ds.split("-").map(Number);
        const dt = new Date(y, m - 1, d);
        const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(dt);
        const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(dt);
        const covered = new Set([
            ...(layers.base[wd] || []).map((s)=>s.point.id),
            ...(layers.week[wd] && layers.week[wd][nth] || []).map((s)=>s.point.id)
        ]);
        layers.date[ds] = layers.date[ds] || [];
        $29ff8c829ff33c74$var$appendUnique(layers.date[ds], $29ff8c829ff33c74$var$stopsFromRoute(route).filter((s)=>!covered.has(s.point.id)));
        register($29ff8c829ff33c74$export$b77d6fb52904647d(ds), route);
    });
    return {
        layers: layers,
        loaded: loaded,
        extraDeletedIds: extraDeletedIds
    };
};
const $29ff8c829ff33c74$export$2a8916ca8520a9cf = (date, layers)=>{
    const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(date);
    const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date);
    const ds = (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(date);
    const out = [];
    const seen = new Set();
    const take = (arr, layer, layerKey)=>(arr || []).forEach((s)=>{
            if (!seen.has(s.point.id)) {
                seen.add(s.point.id);
                out.push({
                    point: s.point,
                    layer: layer,
                    layerKey: layerKey
                });
            }
        });
    take(layers.base[wd], "base", $29ff8c829ff33c74$export$4565335787d39d1e(wd));
    take(layers.week[wd] && layers.week[wd][nth], "week", $29ff8c829ff33c74$export$1c909ebeb219bebc(wd, nth));
    take(layers.date[ds], "date", $29ff8c829ff33c74$export$b77d6fb52904647d(ds));
    return out;
};
const $29ff8c829ff33c74$export$7a2b93116fc1d87 = (key, { userId: userId, createdBy: createdBy, title: title })=>{
    const spec = {
        title: title || "",
        user: userId,
        created_by: createdBy ?? null,
        day_of_the_week: null,
        week_of_month: null,
        start: null,
        end: null
    };
    if ($29ff8c829ff33c74$export$57946e615fde2ef9(key)) spec.day_of_the_week = Number(key.slice(1));
    else if ($29ff8c829ff33c74$export$5970e27c1aba6f13(key)) {
        const [wd, nth] = key.slice(1).split("_").map(Number);
        spec.day_of_the_week = wd;
        spec.week_of_month = nth;
    } else if ($29ff8c829ff33c74$export$58e5ef6625e9cc03(key)) {
        const d = key.slice(1);
        spec.start = `${d}T00:00:00`;
        spec.end = `${d}T23:59:59`;
    }
    return spec;
};
const $29ff8c829ff33c74$var$mergeStops = (...lists)=>{
    const out = [];
    const seen = new Set();
    lists.forEach((list)=>(list || []).forEach((s)=>{
            if (!seen.has(s.point.id)) {
                seen.add(s.point.id);
                out.push({
                    point: s.point
                });
            }
        }));
    return out;
};
const $29ff8c829ff33c74$export$9f54b2050a902133 = (layers)=>{
    const out = [];
    Object.entries(layers.base).forEach(([wd, stops])=>{
        if (stops && stops.length) out.push({
            key: $29ff8c829ff33c74$export$4565335787d39d1e(Number(wd)),
            stops: stops.slice()
        });
    });
    Object.entries(layers.week).forEach(([wd, byNth])=>Object.entries(byNth || {}).forEach(([nth, stops])=>{
            if (stops && stops.length) out.push({
                key: $29ff8c829ff33c74$export$1c909ebeb219bebc(Number(wd), Number(nth)),
                stops: $29ff8c829ff33c74$var$mergeStops(layers.base[wd], stops)
            });
        }));
    Object.entries(layers.date).forEach(([ds, stops])=>{
        if (stops && stops.length) {
            const [y, m, d] = ds.split("-").map(Number);
            const dt = new Date(y, m - 1, d);
            const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(dt);
            const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(dt);
            out.push({
                key: $29ff8c829ff33c74$export$b77d6fb52904647d(ds),
                stops: $29ff8c829ff33c74$var$mergeStops(layers.base[wd], layers.week[wd] && layers.week[wd][nth], stops)
            });
        }
    });
    return out;
};
const $29ff8c829ff33c74$export$3e8e9e58c013b76b = (routeId, stops)=>(stops || []).map((s, idx)=>({
            route: routeId,
            point: s.point.id,
            order: idx
        }));
// ---- immutable layer edits -------------------------------------------------
const $29ff8c829ff33c74$var$cloneLayers = (layers)=>({
        base: {
            ...layers.base
        },
        week: Object.fromEntries(Object.entries(layers.week).map(([wd, byNth])=>[
                wd,
                {
                    ...byNth
                }
            ])),
        date: {
            ...layers.date
        }
    });
// Which layer array a scope writes to for a given date.
const $29ff8c829ff33c74$var$containerFor = (layers, scope, wd, nth, ds)=>{
    if (scope === "every") return {
        get: ()=>layers.base[wd],
        set: (v)=>layers.base[wd] = v
    };
    if (scope === "nth") {
        layers.week[wd] = {
            ...layers.week[wd] || {}
        };
        return {
            get: ()=>layers.week[wd][nth],
            set: (v)=>layers.week[wd][nth] = v
        };
    }
    return {
        get: ()=>layers.date[ds],
        set: (v)=>layers.date[ds] = v
    };
};
// True if the point is already effective for `scope` on `date` (avoids cross-layer dupes).
const $29ff8c829ff33c74$var$alreadyPresent = (layers, scope, wd, nth, ds, pointId)=>{
    const inArr = (arr)=>(arr || []).some((s)=>s.point.id === pointId);
    if (inArr(layers.base[wd])) return true;
    if (scope === "every") return false;
    if (inArr(layers.week[wd] && layers.week[wd][nth])) return true;
    if (scope === "nth") return false;
    return inArr(layers.date[ds]);
};
const $29ff8c829ff33c74$export$7ed91a9c68d5a769 = (layers, scope, date, point)=>{
    const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(date);
    const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date);
    const ds = (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(date);
    if ($29ff8c829ff33c74$var$alreadyPresent(layers, scope, wd, nth, ds, point.id)) return layers;
    const next = $29ff8c829ff33c74$var$cloneLayers(layers);
    const c = $29ff8c829ff33c74$var$containerFor(next, scope, wd, nth, ds);
    c.set([
        ...c.get() || [],
        {
            point: point
        }
    ]);
    return next;
};
const $29ff8c829ff33c74$var$parseLayerKey = (key)=>{
    if ($29ff8c829ff33c74$export$57946e615fde2ef9(key)) return {
        kind: "base",
        wd: Number(key.slice(1))
    };
    if ($29ff8c829ff33c74$export$5970e27c1aba6f13(key)) {
        const [wd, nth] = key.slice(1).split("_").map(Number);
        return {
            kind: "week",
            wd: wd,
            nth: nth
        };
    }
    return {
        kind: "date",
        ds: key.slice(1)
    };
};
const $29ff8c829ff33c74$var$layerArray = (layers, layerKey)=>{
    const p = $29ff8c829ff33c74$var$parseLayerKey(layerKey);
    if (p.kind === "base") return layers.base[p.wd] || [];
    if (p.kind === "week") return layers.week[p.wd] && layers.week[p.wd][p.nth] || [];
    return layers.date[p.ds] || [];
};
const $29ff8c829ff33c74$var$setLayerArray = (layers, layerKey, arr)=>{
    const p = $29ff8c829ff33c74$var$parseLayerKey(layerKey);
    if (p.kind === "base") {
        if (arr.length) layers.base[p.wd] = arr;
        else delete layers.base[p.wd];
    } else if (p.kind === "week") {
        layers.week[p.wd] = {
            ...layers.week[p.wd] || {}
        };
        if (arr.length) layers.week[p.wd][p.nth] = arr;
        else delete layers.week[p.wd][p.nth];
    } else if (arr.length) layers.date[p.ds] = arr;
    else delete layers.date[p.ds];
};
const $29ff8c829ff33c74$export$60c41cdd2b94234a = (layers, layerKey, pointId)=>{
    const next = $29ff8c829ff33c74$var$cloneLayers(layers);
    $29ff8c829ff33c74$var$setLayerArray(next, layerKey, $29ff8c829ff33c74$var$layerArray(next, layerKey).filter((s)=>s.point.id !== pointId));
    return next;
};
const $29ff8c829ff33c74$export$31938668dbeb9fa6 = (layers, layerKey, pointId, dir)=>{
    const arr = $29ff8c829ff33c74$var$layerArray(layers, layerKey).slice();
    const i = arr.findIndex((s)=>s.point.id === pointId);
    const j = i + dir;
    if (i < 0 || j < 0 || j >= arr.length) return layers;
    const next = $29ff8c829ff33c74$var$cloneLayers(layers);
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
    $29ff8c829ff33c74$var$setLayerArray(next, layerKey, arr);
    return next;
};



const $32cae9e7215e741e$var$ORDINAL_KEY = {
    1: "ord_first",
    2: "ord_second",
    3: "ord_third",
    4: "ord_fourth",
    5: "ord_fifth"
};
// Short label for a stop's layer, shown as a small badge (weekly / Nth / one-off).
const $32cae9e7215e741e$var$layerBadge = (stop, date, lang)=>{
    if ((0, $29ff8c829ff33c74$export$58e5ef6625e9cc03)(stop.layerKey)) return {
        text: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "badge_date", lang),
        cls: "rc-badge-date"
    };
    if ((0, $29ff8c829ff33c74$export$5970e27c1aba6f13)(stop.layerKey)) return {
        text: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), $32cae9e7215e741e$var$ORDINAL_KEY[(0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date)], lang),
        cls: "rc-badge-nth"
    };
    return {
        text: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "badge_weekly", lang),
        cls: "rc-badge-weekly"
    };
};
function $32cae9e7215e741e$var$DayCell({ date: date, monthDate: monthDate, layers: layers, lang: lang, onDrop: onDrop, onRemove: onRemove, onMove: onMove }) {
    const [over, setOver] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    const inMonth = (0, $7d0f78de0b68a104$export$a18c89cbd24170ff)(date, monthDate);
    const stops = inMonth ? (0, $29ff8c829ff33c74$export$2a8916ca8520a9cf)(date, layers) : [];
    const handleDrop = (e)=>{
        e.preventDefault();
        setOver(false);
        if (!inMonth) return;
        const raw = e.dataTransfer.getData((0, $46bcdae26abfb3ba$export$1dad1ee41cc975c4));
        if (!raw) return;
        try {
            onDrop(date, JSON.parse(raw));
        } catch (_) {
        /* ignore malformed payloads */ }
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "rc-cell" + (inMonth ? "" : " rc-cell-muted") + ((0, $7d0f78de0b68a104$export$629b0a497aa65267)(date) ? " rc-cell-today" : "") + (over ? " rc-cell-over" : ""),
        onDragOver: (e)=>{
            if (!inMonth) return;
            e.preventDefault();
            e.dataTransfer.dropEffect = "copy";
            if (!over) setOver(true);
        },
        onDragLeave: ()=>over && setOver(false),
        onDrop: handleDrop,
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "rc-cell-head",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "rc-cell-date",
                    children: date.getDate()
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "rc-cell-stops",
                children: stops.map((stop, idx)=>{
                    const badge = $32cae9e7215e741e$var$layerBadge(stop, date, lang);
                    const canUp = idx > 0 && stops[idx - 1].layerKey === stop.layerKey;
                    const canDown = idx < stops.length - 1 && stops[idx + 1].layerKey === stop.layerKey;
                    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "rc-stop " + badge.cls,
                        title: stop.point.address || stop.point.name,
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "rc-stop-badge",
                                children: badge.text
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "rc-stop-name",
                                children: stop.point.name
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                className: "rc-stop-actions",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        type: "button",
                                        className: "rc-stop-btn",
                                        disabled: !canUp,
                                        onClick: ()=>onMove(stop.layerKey, stop.point.id, -1),
                                        "aria-label": "move up",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "arrow_upward"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        type: "button",
                                        className: "rc-stop-btn",
                                        disabled: !canDown,
                                        onClick: ()=>onMove(stop.layerKey, stop.point.id, 1),
                                        "aria-label": "move down",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "arrow_downward"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        type: "button",
                                        className: "rc-stop-btn rc-stop-remove",
                                        onClick: ()=>onRemove(stop.layerKey, stop.point.id),
                                        "aria-label": "remove",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "close"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, stop.layerKey + "_" + stop.point.id);
                })
            })
        ]
    });
}
function $32cae9e7215e741e$export$2e2bcd8739ae039({ monthDate: monthDate, layers: layers, lang: lang, onPrev: onPrev, onNext: onNext, onDrop: onDrop, onRemove: onRemove, onMove: onMove }) {
    const weeks = (0, $7d0f78de0b68a104$export$2cb1dca7fa4861ea)(monthDate);
    const headers = (0, $7d0f78de0b68a104$export$8d7bfd7870d0d02)(lang);
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "rc-calendar",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "rc-cal-header",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        type: "button",
                        className: "rc-nav-btn",
                        onClick: onPrev,
                        "aria-label": "previous month",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "material-symbols-outlined",
                            children: "chevron_left"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "rc-month-label",
                        children: (0, $7d0f78de0b68a104$export$4f81354ee858acb4)(monthDate, lang)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        type: "button",
                        className: "rc-nav-btn",
                        onClick: onNext,
                        "aria-label": "next month",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "material-symbols-outlined",
                            children: "chevron_right"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "rc-grid rc-grid-headers",
                children: headers.map((h, i)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "rc-weekday",
                        children: h
                    }, i))
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "rc-grid rc-grid-days",
                children: weeks.map((row, wi)=>row.map((date, di)=>/*#__PURE__*/ (0, $7uT18.jsx)($32cae9e7215e741e$var$DayCell, {
                            date: date,
                            monthDate: monthDate,
                            layers: layers,
                            lang: lang,
                            onDrop: onDrop,
                            onRemove: onRemove,
                            onMove: onMove
                        }, wi + "_" + di)))
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");



const $977a580fdf6cb607$var$ORDINAL_KEY = {
    1: "ord_first",
    2: "ord_second",
    3: "ord_third",
    4: "ord_fourth",
    5: "ord_fifth"
};
const $977a580fdf6cb607$var$fill = (template, vars)=>(template || "").replace(/\{(\w+)\}/g, (_, k)=>vars[k] ?? "");
function $977a580fdf6cb607$export$2e2bcd8739ae039({ date: date, point: point, lang: lang, onChoose: onChoose, onCancel: onCancel }) {
    const localeWeekday = new Intl.DateTimeFormat({
        uk: "uk",
        en: "en-GB",
        hy: "hy",
        ka: "ka"
    }[lang] || "en-GB", {
        weekday: "long"
    }).format(date);
    const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date);
    const ordinal = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), $977a580fdf6cb607$var$ORDINAL_KEY[nth], lang);
    const dateStr = (0, $7d0f78de0b68a104$export$39af906a0f4e17a1)(date, lang);
    const options = [
        {
            type: "every",
            label: $977a580fdf6cb607$var$fill((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "scope_every", lang), {
                day: localeWeekday
            }),
            icon: "event_repeat"
        },
        {
            type: "nth",
            label: $977a580fdf6cb607$var$fill((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "scope_nth", lang), {
                ord: ordinal,
                day: localeWeekday
            }),
            icon: "calendar_month"
        },
        {
            type: "date",
            label: $977a580fdf6cb607$var$fill((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "scope_date", lang), {
                date: dateStr
            }),
            icon: "today"
        }
    ];
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "rc-scope-backdrop",
        onClick: onCancel,
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "rc-scope-menu",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "rc-scope-header",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "rc-scope-title",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "scope_title", lang)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "rc-scope-point",
                            children: point?.name
                        })
                    ]
                }),
                options.map((opt)=>/*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "rc-scope-option",
                        onClick: ()=>onChoose(opt.type),
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: opt.icon
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                children: opt.label
                            })
                        ]
                    }, opt.type)),
                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                    className: "rc-scope-cancel",
                    onClick: onCancel,
                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "cancel", lang)
                })
            ]
        })
    });
}





const $8d3742188f51b6e5$var$callP = (body)=>new Promise((resolve)=>(0, $c9936523dc38c641$export$848feb93d8f32b9b)(body, resolve));
const $8d3742188f51b6e5$var$enWeekday = (wd)=>new Intl.DateTimeFormat("en", {
        weekday: "long"
    }).format(new Date(2024, 0, 1 + wd));
const $8d3742188f51b6e5$var$sameIds = (a, b)=>a.length === b.length && a.every((v, i)=>v === b[i]);
const $8d3742188f51b6e5$var$titleForKey = (key)=>{
    if ((0, $29ff8c829ff33c74$export$57946e615fde2ef9)(key)) return $8d3742188f51b6e5$var$enWeekday(Number(key.slice(1)));
    if ((0, $29ff8c829ff33c74$export$5970e27c1aba6f13)(key)) {
        const [wd, nth] = key.slice(1).split("_").map(Number);
        return `${nth} ${$8d3742188f51b6e5$var$enWeekday(wd)}`;
    }
    return key.slice(1);
};
// Diff the layers against the routes as loaded → routes to (re)create and ids to delete.
const $8d3742188f51b6e5$var$computeReconcile = (layers, loaded, extraDeletedIds)=>{
    const desired = (0, $29ff8c829ff33c74$export$9f54b2050a902133)(layers);
    const desiredKeys = new Set(desired.map((r)=>r.key));
    const toDelete = new Set(extraDeletedIds);
    const toCreate = [];
    desired.forEach(({ key: key, stops: stops })=>{
        const want = stops.map((s)=>s.point.id);
        const prev = loaded[key];
        if (prev && $8d3742188f51b6e5$var$sameIds(want, prev.pointIds)) return; // unchanged
        if (prev && prev.id) toDelete.add(prev.id); // replace: recreate with new stops/order
        toCreate.push({
            key: key,
            stops: stops
        });
    });
    Object.keys(loaded).forEach((key)=>{
        if (!desiredKeys.has(key) && loaded[key].id) toDelete.add(loaded[key].id);
    });
    return {
        toCreate: toCreate,
        toDelete: [
            ...toDelete
        ]
    };
};
function $8d3742188f51b6e5$export$2e2bcd8739ae039({ user: user }) {
    const me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
    const lang = me?.language || "en";
    const [layers, setLayers] = (0, $cQmXV.useState)({
        base: {},
        week: {},
        date: {}
    });
    const [loaded, setLoaded] = (0, $cQmXV.useState)({});
    const [extraDeletedIds, setExtraDeletedIds] = (0, $cQmXV.useState)([]);
    const [monthDate, setMonthDate] = (0, $cQmXV.useState)(()=>(0, $7d0f78de0b68a104$export$a1081e8ce57742a4)(new Date()));
    const [pendingDrop, setPendingDrop] = (0, $cQmXV.useState)(null);
    const [saving, setSaving] = (0, $cQmXV.useState)(false);
    const load = (0, $cQmXV.useCallback)(()=>{
        if (!user?.id) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "routes?user=" + user.id
        }, (resp)=>{
            const list = Array.isArray(resp) ? resp : resp?.results || [];
            const { layers: l, loaded: ld, extraDeletedIds: ex } = (0, $29ff8c829ff33c74$export$65638ff2f6061a77)(list);
            setLayers(l);
            setLoaded(ld);
            setExtraDeletedIds(ex);
        });
    }, [
        user?.id
    ]);
    (0, $cQmXV.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const { toCreate: toCreate, toDelete: toDelete } = (0, $cQmXV.useMemo)(()=>$8d3742188f51b6e5$var$computeReconcile(layers, loaded, extraDeletedIds), [
        layers,
        loaded,
        extraDeletedIds
    ]);
    const hasChanges = toCreate.length > 0 || toDelete.length > 0;
    const onDrop = (date, point)=>setPendingDrop({
            date: date,
            point: point
        });
    const addWithScope = (date, point, scope)=>setLayers((l)=>(0, $29ff8c829ff33c74$export$7ed91a9c68d5a769)(l, scope, date, point));
    const removeStop = (layerKey, pointId)=>setLayers((l)=>(0, $29ff8c829ff33c74$export$60c41cdd2b94234a)(l, layerKey, pointId));
    const moveStop = (layerKey, pointId, dir)=>setLayers((l)=>(0, $29ff8c829ff33c74$export$31938668dbeb9fa6)(l, layerKey, pointId, dir));
    const save = async ()=>{
        if (!hasChanges || saving) return;
        setSaving(true);
        try {
            // Create first, then delete — a failed create leaves old routes intact (recoverable
            // duplicate, consolidated on next load) instead of losing data.
            for (const { key: key, stops: stops } of toCreate){
                const spec = (0, $29ff8c829ff33c74$export$7a2b93116fc1d87)(key, {
                    userId: user.id,
                    createdBy: me?.id ?? null,
                    title: $8d3742188f51b6e5$var$titleForKey(key)
                });
                const created = await $8d3742188f51b6e5$var$callP({
                    method: "POST",
                    url: "routes/",
                    post: spec
                });
                if (!created || !created.id) throw new Error("route create failed: " + JSON.stringify(created));
                const orders = (0, $29ff8c829ff33c74$export$3e8e9e58c013b76b)(created.id, stops);
                if (orders.length) await $8d3742188f51b6e5$var$callP({
                    method: "POST",
                    url: "order/",
                    post: orders
                });
            }
            for (const id of toDelete)await $8d3742188f51b6e5$var$callP({
                method: "DELETE",
                url: `routes/${id}/`
            }); // orders cascade-delete
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "data_successfully_saved", lang), {
                position: "bottom-right"
            });
            load();
        } catch (e) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving routes. " + (e?.message || ""), {
                position: "bottom-right"
            });
        } finally{
            setSaving(false);
        }
    };
    const stopCount = (0, $cQmXV.useMemo)(()=>{
        let n = 0;
        Object.values(layers.base).forEach((a)=>n += a.length);
        Object.values(layers.week).forEach((byNth)=>Object.values(byNth).forEach((a)=>n += a.length));
        Object.values(layers.date).forEach((a)=>n += a.length);
        return n;
    }, [
        layers
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "rc-root",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "rc-toolbar",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "rc-toolbar-info",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "calendar_month"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "heading", lang)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "rc-toolbar-count",
                                children: stopCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "mp-save-btn",
                        onClick: save,
                        disabled: !hasChanges || saving,
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "save"
                            }),
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "save_btn", lang)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "rc-layout",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $46bcdae26abfb3ba$export$2e2bcd8739ae039), {
                        lang: lang
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $32cae9e7215e741e$export$2e2bcd8739ae039), {
                        monthDate: monthDate,
                        layers: layers,
                        lang: lang,
                        onPrev: ()=>setMonthDate((m)=>(0, $7d0f78de0b68a104$export$17c93e242b2d3a22)(m, -1)),
                        onNext: ()=>setMonthDate((m)=>(0, $7d0f78de0b68a104$export$17c93e242b2d3a22)(m, 1)),
                        onDrop: onDrop,
                        onRemove: removeStop,
                        onMove: moveStop
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "rc-legend",
                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "legend", lang)
            }),
            pendingDrop && /*#__PURE__*/ (0, $7uT18.jsx)((0, $977a580fdf6cb607$export$2e2bcd8739ae039), {
                date: pendingDrop.date,
                point: pendingDrop.point,
                lang: lang,
                onChoose: (scope)=>{
                    addWithScope(pendingDrop.date, pendingDrop.point, scope);
                    setPendingDrop(null);
                },
                onCancel: ()=>setPendingDrop(null)
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");




class $0ba3b4b5363e88ae$var$View extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            imgError: false
        };
    }
    render() {
        let { item: item, lang: lang } = this.props;
        const isActive = item?.is_active;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "mp-view",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "mp-view-header",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-view-avatar-wrap",
                            children: [
                                item?.photo && !this.state.imgError ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                    src: item.photo,
                                    className: "mp-view-avatar",
                                    onError: ()=>this.setState({
                                            imgError: true
                                        })
                                }) : /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "mp-view-avatar-fallback",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "person"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: `mp-view-status-dot ${isActive ? "mp-view-status-dot--active" : "mp-view-status-dot--inactive"}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-view-name-block",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("h2", {
                                    className: "mp-view-name",
                                    children: item && item.first_name + " " + item.last_name
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: `mp-view-status-chip ${isActive ? "mp-view-status-chip--active" : "mp-view-status-chip--inactive"}`,
                                    children: isActive ? "Active" : "Not Active"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "mp-view-grid",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-view-info-card",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-view-info-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "mp-view-info-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "phone"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "phone_number", lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "mp-view-info-value",
                                            children: item?.phone_number || "\u2014"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-view-info-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "mp-view-info-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "directions_walk"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "movement", lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "mp-view-info-value",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "mp-view-movement-chip",
                                                children: item && (0, $6f1c09625235f1f0$export$8e11240bfd4abd6)[item.movement]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-view-info-card",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-view-info-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "mp-view-info-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "calendar_today"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "connected", lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "mp-view-info-value",
                                            children: item && (0, $b79edb411f97c469$export$6b5a18fc371da38a)("", item)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-view-info-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "mp-view-info-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "event_busy"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "deactivated", lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "mp-view-info-value",
                                            children: item && (0, $b79edb411f97c469$export$531029b4f5a1dc80)("", item) || "\u2014"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "mp-view-info-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "mp-view-info-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "new_releases"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "till_newbie", lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "mp-view-info-value",
                                            children: item && (0, $b79edb411f97c469$export$2615b096aa5889ca)("", item) || "\u2014"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $0ba3b4b5363e88ae$export$2e2bcd8739ae039 = $0ba3b4b5363e88ae$var$View;






class $c99a2835eadd6e89$var$Page extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            mode: "VIEW",
            new: false,
            changedItem: false,
            item: {
                date_joined: new Date(),
                date_deactivated: new Date(),
                date_till_newbie: new Date(),
                password: "",
                password2: "",
                company: null
            },
            errors: [],
            tasks: [],
            routes: [],
            visits: []
        };
    }
    getMe = ()=>{
        const me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
        return me;
    };
    submit = ()=>{
        let { item: item, changedItem: changedItem } = this.state;
        let errors = [];
        const me = this.getMe();
        if (item.password !== item.password2) errors["password"] = "Passwords should match.";
        if (errors.length > 0) {
            this.setState({
                errors: errors
            });
            return;
        }
        if (!changedItem) return;
        let itemCopy = Object.assign(item, {});
        delete itemCopy.photo;
        itemCopy.company = me && me.company ? me.company.id : null;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: item && item.id ? "PATCH" : "POST",
            url: item && item.id ? "merchandisers/" + item.id + "/" : "merchandisers/",
            post: item
        }, (r)=>{
            if (r && r.id) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "data_successfully_saved", me.language), {
                position: "bottom-right"
            });
            else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving item. Error: " + JSON.stringify(r), {
                position: "bottom-right"
            });
        });
        this.setState({
            changedItem: false
        });
    };
    componentDidMount() {
        const { id: id } = this.props.match.params;
        if (id !== "new") this.load(id);
        else this.setState({
            mode: "EDIT",
            new: true
        });
    }
    load = (id)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "merchandisers/" + id + "/"
        }, (r)=>{
            this.setState({
                item: r
            });
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "GET",
                url: "tasks?user=" + id
            }, (r)=>{
                if (r.results) this.setState({
                    tasks: r.results
                });
            });
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "GET",
                url: "visits?user=" + id
            }, (r)=>{
                if (r.results) this.setState({
                    visits: r.results
                });
            });
        });
    };
    onChange = (property, value)=>{
        let item = this.state.item;
        item[property] = value;
        this.setState({
            item: item,
            changedItem: true
        });
    };
    toggleMode = ()=>{
        this.setState({
            mode: this.state.mode == "EDIT" ? "VIEW" : "EDIT"
        });
    };
    handleBack = ()=>{
        this.props.history.replace("/merchandiser");
    };
    openTaskRow = (row)=>{
        window.open(`/task/${row.id}`, "_blank");
    };
    openVisitRow = (row)=>{
        window.open(`/visit/${row.id}`, "_blank");
    };
    render() {
        let { item: item } = this.state;
        const me = this.getMe();
        const tabLabels = [
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "routes", me.language),
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "assignment", me.language),
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "visits", me.language),
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "presence", me.language)
        ];
        const tabContent = [
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $8d3742188f51b6e5$export$2e2bcd8739ae039), {
                user: item
            }, "route-tab"),
            /*#__PURE__*/ (0, $7uT18.jsxs)((0, $81b6b064afbc82da$export$2e2bcd8739ae039), {
                data: this.state.tasks,
                type: "data",
                entity: "merchandiser.task",
                openVisitFn: this.openTaskRow,
                rowClassName: ()=>"merch-clickable-row",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataField: "id",
                        isKey: true,
                        hidden: true
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$6d56db8f73608157),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "network_title", me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataField: "title",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "title_title", me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$1718d4b40b6ea71e),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "start_title", me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$450de2dd43fb03),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "end_title", me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$8ecd76f1dc39c193),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "number_of_images_title", me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$75b1fe4b0cd8c2c9),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "number_of_tags_title", me.language)
                    })
                ]
            }, "task-tab"),
            /*#__PURE__*/ (0, $7uT18.jsxs)((0, $81b6b064afbc82da$export$2e2bcd8739ae039), {
                data: this.state.visits,
                type: "data",
                entity: "merchandiser.visit",
                openVisitFn: this.openVisitRow,
                rowClassName: ()=>"merch-clickable-row",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataField: "id",
                        isKey: true,
                        hidden: true
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$1718d4b40b6ea71e),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "start_title", me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$450de2dd43fb03),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "completion_title", me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$105684a3041cb6f3),
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "point_title", me.language)
                    })
                ]
            }, "visit-tab"),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $94d5ec6a0156546a$export$2e2bcd8739ae039), {
                user: item
            }, "absence-tab")
        ];
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "container-fluid mp-page",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "mp-top-bar",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                            className: "mp-back-btn",
                            onClick: this.handleBack,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "arrow_back"
                                }),
                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "view_btn", me.language)
                            ]
                        }),
                        !this.state.new && /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                            className: "mp-toggle-btn",
                            onClick: this.toggleMode,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: this.state.mode === "EDIT" ? "visibility" : "edit"
                                }),
                                this.state.mode === "EDIT" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "view_btn", me.language) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "edit_btn", me.language)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "mp-profile-card",
                    children: this.state.mode === "VIEW" ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $0ba3b4b5363e88ae$export$2e2bcd8739ae039), {
                        item: item,
                        lang: me.language
                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $61747ae11cbcb916$export$2e2bcd8739ae039), {
                        me: this.getMe(),
                        item: item,
                        isNew: this.state.new,
                        errors: this.state.errors,
                        submit: ()=>this.submit(),
                        onChange: this.onChange
                    })
                }),
                !this.state.new && item && item.id && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "mp-tabs-card",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $79a08f0c966164e4$export$2e2bcd8739ae039), {
                        className: "tabs-list",
                        labels: tabLabels,
                        tabs: tabContent
                    })
                })
            ]
        });
    }
}
var $c99a2835eadd6e89$export$2e2bcd8739ae039 = $c99a2835eadd6e89$var$Page;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");

var $cQmXV = parcelRequire("cQmXV");

var $1Spf6 = parcelRequire("1Spf6");
var $1ecced93815b40e8$exports = {};
(function(global, factory) {
    factory($1ecced93815b40e8$exports);
})($1ecced93815b40e8$exports, function(exports1) {
    "use strict";
    const { getOwnPropertyNames: getOwnPropertyNames, getOwnPropertySymbols: getOwnPropertySymbols } = Object;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { hasOwnProperty: hasOwnProperty } = Object.prototype;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            const { cache: cache } = state;
            const cachedA = cache.get(a);
            const cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            const result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the `@@toStringTag` of the value, if it exists.
     */ function getShortTag(value) {
        return value != null ? value[Symbol.toStringTag] : undefined;
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ const hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    Object.hasOwn || ((object, property)=>hasOwnProperty.call(object, property));
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    const PREACT_VNODE = "__v";
    const PREACT_OWNER = "__o";
    const REACT_OWNER = "_owner";
    const { getOwnPropertyDescriptor: getOwnPropertyDescriptor, keys: keys } = Object;
    /**
     * Whether the array buffers are equal in value.
     */ function areArrayBuffersEqual(a, b) {
        return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
    }
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        let index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dataviews are equal in value.
     */ function areDataViewsEqual(a, b) {
        return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        const size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        const matchedIndices = new Array(size);
        const aIterable = a.entries();
        let aResult;
        let bResult;
        let index = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            const bIterable = b.entries();
            let hasMatch = false;
            let matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                const aEntry = aResult.value;
                const bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ const areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        const properties = keys(a);
        let index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        const properties = getStrictProperties(a);
        let index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        let property;
        let descriptorA;
        let descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        const size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        const matchedIndices = new Array(size);
        const aIterable = a.values();
        let aResult;
        let bResult;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            const bIterable = b.values();
            let hasMatch = false;
            let matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        let index = a.byteLength;
        if (b.byteLength !== index || a.byteOffset !== b.byteOffset) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    const ARRAY_BUFFER_TAG = "[object ArrayBuffer]";
    const ARGUMENTS_TAG = "[object Arguments]";
    const BOOLEAN_TAG = "[object Boolean]";
    const DATA_VIEW_TAG = "[object DataView]";
    const DATE_TAG = "[object Date]";
    const ERROR_TAG = "[object Error]";
    const MAP_TAG = "[object Map]";
    const NUMBER_TAG = "[object Number]";
    const OBJECT_TAG = "[object Object]";
    const REG_EXP_TAG = "[object RegExp]";
    const SET_TAG = "[object Set]";
    const STRING_TAG = "[object String]";
    const TYPED_ARRAY_TAGS = {
        "[object Int8Array]": true,
        "[object Uint8Array]": true,
        "[object Uint8ClampedArray]": true,
        "[object Int16Array]": true,
        "[object Uint16Array]": true,
        "[object Int32Array]": true,
        "[object Uint32Array]": true,
        "[object Float16Array]": true,
        "[object Float32Array]": true,
        "[object Float64Array]": true,
        "[object BigInt64Array]": true,
        "[object BigUint64Array]": true
    };
    const URL_TAG = "[object URL]";
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const toString = Object.prototype.toString;
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator({ areArrayBuffersEqual: areArrayBuffersEqual, areArraysEqual: areArraysEqual, areDataViewsEqual: areDataViewsEqual, areDatesEqual: areDatesEqual, areErrorsEqual: areErrorsEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, areTypedArraysEqual: areTypedArraysEqual, areUrlsEqual: areUrlsEqual, unknownTagComparators: unknownTagComparators }) {
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            const type = typeof a;
            if (type !== typeof b) return false;
            if (type !== "object") {
                if (type === "number") return areNumbersEqual(a, b, state);
                if (type === "function") return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            const constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (Array.isArray(a)) return areArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            const tag = toString.call(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            if (TYPED_ARRAY_TAGS[tag]) return areTypedArraysEqual(a, b, state);
            if (tag === ARRAY_BUFFER_TAG) return areArrayBuffersEqual(a, b, state);
            if (tag === DATA_VIEW_TAG) return areDataViewsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            if (unknownTagComparators) {
                let unknownTagComparator = unknownTagComparators[tag];
                if (!unknownTagComparator) {
                    const shortTag = getShortTag(a);
                    if (shortTag) unknownTagComparator = unknownTagComparators[shortTag];
                }
                // If the custom config has an unknown tag comparator that matches the captured tag or the
                // @@toStringTag, it is the source of truth for whether the values are equal.
                if (unknownTagComparator) return unknownTagComparator(a, b, state);
            }
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig({ circular: circular, createCustomConfig: createCustomConfig, strict: strict }) {
        let config = {
            areArrayBuffersEqual: areArrayBuffersEqual,
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDataViewsEqual: areDataViewsEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? combineComparators(areTypedArraysEqual, areObjectsEqualStrict) : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual,
            unknownTagComparators: undefined
        };
        if (createCustomConfig) config = Object.assign({}, config, createCustomConfig(config));
        if (circular) {
            const areArraysEqual = createIsCircular(config.areArraysEqual);
            const areMapsEqual = createIsCircular(config.areMapsEqual);
            const areObjectsEqual = createIsCircular(config.areObjectsEqual);
            const areSetsEqual = createIsCircular(config.areSetsEqual);
            config = Object.assign({}, config, {
                areArraysEqual: areArraysEqual,
                areMapsEqual: areMapsEqual,
                areObjectsEqual: areObjectsEqual,
                areSetsEqual: areSetsEqual
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict }) {
        if (createState) return function isEqual(a, b) {
            const { cache: cache = circular ? new WeakMap() : undefined, meta: meta } = createState();
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        const state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ const deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ const strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ const circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ const strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ const shallowEqual = createCustomEqual({
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ const strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ const circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ const strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: ()=>sameValueZeroEqual,
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options = {}) {
        const { circular: circular = false, createInternalComparator: createCustomInternalComparator, createState: createState, strict: strict = false } = options;
        const config = createEqualityComparatorConfig(options);
        const comparator = createEqualityComparator(config);
        const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $e7cf07c5e2349a7c$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function $e7cf07c5e2349a7c$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $e7cf07c5e2349a7c$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $4c9a09af22aa3484$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4c9a09af22aa3484$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4c9a09af22aa3484$var$_typeof(o);
}
function $4c9a09af22aa3484$var$_toArray(arr) {
    return $4c9a09af22aa3484$var$_arrayWithHoles(arr) || $4c9a09af22aa3484$var$_iterableToArray(arr) || $4c9a09af22aa3484$var$_unsupportedIterableToArray(arr) || $4c9a09af22aa3484$var$_nonIterableRest();
}
function $4c9a09af22aa3484$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4c9a09af22aa3484$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4c9a09af22aa3484$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4c9a09af22aa3484$var$_arrayLikeToArray(o, minLen);
}
function $4c9a09af22aa3484$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4c9a09af22aa3484$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4c9a09af22aa3484$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4c9a09af22aa3484$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $4c9a09af22aa3484$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $e7cf07c5e2349a7c$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $e7cf07c5e2349a7c$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($4c9a09af22aa3484$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $ac9f9d9da9ff214b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ac9f9d9da9ff214b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ac9f9d9da9ff214b$var$_typeof(o);
}
function $ac9f9d9da9ff214b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac9f9d9da9ff214b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac9f9d9da9ff214b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ac9f9d9da9ff214b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac9f9d9da9ff214b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ac9f9d9da9ff214b$var$_defineProperty(obj, key, value) {
    key = $ac9f9d9da9ff214b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ac9f9d9da9ff214b$var$_toPropertyKey(arg) {
    var key = $ac9f9d9da9ff214b$var$_toPrimitive(arg, "string");
    return $ac9f9d9da9ff214b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ac9f9d9da9ff214b$var$_toPrimitive(input, hint) {
    if ($ac9f9d9da9ff214b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ac9f9d9da9ff214b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ac9f9d9da9ff214b$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $ac9f9d9da9ff214b$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $ac9f9d9da9ff214b$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $ac9f9d9da9ff214b$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $ac9f9d9da9ff214b$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $ac9f9d9da9ff214b$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $ac9f9d9da9ff214b$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $ac9f9d9da9ff214b$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $ac9f9d9da9ff214b$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $ac9f9d9da9ff214b$var$_objectSpread($ac9f9d9da9ff214b$var$_objectSpread({}, res), {}, $ac9f9d9da9ff214b$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $ac9f9d9da9ff214b$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($ac9f9d9da9ff214b$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $ac9f9d9da9ff214b$var$isDev = false;
var $ac9f9d9da9ff214b$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($ac9f9d9da9ff214b$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $10617984cffab340$var$_slicedToArray(arr, i) {
    return $10617984cffab340$var$_arrayWithHoles(arr) || $10617984cffab340$var$_iterableToArrayLimit(arr, i) || $10617984cffab340$var$_unsupportedIterableToArray(arr, i) || $10617984cffab340$var$_nonIterableRest();
}
function $10617984cffab340$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $10617984cffab340$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $10617984cffab340$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $10617984cffab340$var$_toConsumableArray(arr) {
    return $10617984cffab340$var$_arrayWithoutHoles(arr) || $10617984cffab340$var$_iterableToArray(arr) || $10617984cffab340$var$_unsupportedIterableToArray(arr) || $10617984cffab340$var$_nonIterableSpread();
}
function $10617984cffab340$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $10617984cffab340$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $10617984cffab340$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $10617984cffab340$var$_arrayLikeToArray(o, minLen);
}
function $10617984cffab340$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $10617984cffab340$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $10617984cffab340$var$_arrayLikeToArray(arr);
}
function $10617984cffab340$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $10617984cffab340$var$ACCURACY = 1e-4;
var $10617984cffab340$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $10617984cffab340$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $10617984cffab340$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $10617984cffab340$var$cubicBezierFactor(c1, c2);
        return $10617984cffab340$var$multyTime(params, t);
    };
};
var $10617984cffab340$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $10617984cffab340$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($10617984cffab340$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $10617984cffab340$var$multyTime(newParams, t);
    };
};
var $10617984cffab340$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $10617984cffab340$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $ac9f9d9da9ff214b$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $ac9f9d9da9ff214b$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $10617984cffab340$var$cubicBezier(x1, x2);
    var curveY = $10617984cffab340$var$cubicBezier(y1, y2);
    var derCurveX = $10617984cffab340$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $10617984cffab340$var$ACCURACY || derVal < $10617984cffab340$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $10617984cffab340$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $10617984cffab340$var$ACCURACY && Math.abs(newV) < $10617984cffab340$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $10617984cffab340$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $10617984cffab340$export$56c51296f72f0592(easing);
        case "spring":
            return $10617984cffab340$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $10617984cffab340$export$56c51296f72f0592(easing);
            (0, $ac9f9d9da9ff214b$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $ac9f9d9da9ff214b$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $078fe06734a4d822$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $078fe06734a4d822$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $078fe06734a4d822$var$_typeof(o);
}
function $078fe06734a4d822$var$_toConsumableArray(arr) {
    return $078fe06734a4d822$var$_arrayWithoutHoles(arr) || $078fe06734a4d822$var$_iterableToArray(arr) || $078fe06734a4d822$var$_unsupportedIterableToArray(arr) || $078fe06734a4d822$var$_nonIterableSpread();
}
function $078fe06734a4d822$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $078fe06734a4d822$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $078fe06734a4d822$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $078fe06734a4d822$var$_arrayLikeToArray(arr);
}
function $078fe06734a4d822$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $078fe06734a4d822$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $078fe06734a4d822$var$ownKeys(Object(t), !0).forEach(function(r) {
            $078fe06734a4d822$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $078fe06734a4d822$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $078fe06734a4d822$var$_defineProperty(obj, key, value) {
    key = $078fe06734a4d822$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $078fe06734a4d822$var$_toPropertyKey(arg) {
    var key = $078fe06734a4d822$var$_toPrimitive(arg, "string");
    return $078fe06734a4d822$var$_typeof(key) === "symbol" ? key : String(key);
}
function $078fe06734a4d822$var$_toPrimitive(input, hint) {
    if ($078fe06734a4d822$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($078fe06734a4d822$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $078fe06734a4d822$var$_slicedToArray(arr, i) {
    return $078fe06734a4d822$var$_arrayWithHoles(arr) || $078fe06734a4d822$var$_iterableToArrayLimit(arr, i) || $078fe06734a4d822$var$_unsupportedIterableToArray(arr, i) || $078fe06734a4d822$var$_nonIterableRest();
}
function $078fe06734a4d822$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $078fe06734a4d822$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $078fe06734a4d822$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $078fe06734a4d822$var$_arrayLikeToArray(o, minLen);
}
function $078fe06734a4d822$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $078fe06734a4d822$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $078fe06734a4d822$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $078fe06734a4d822$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $078fe06734a4d822$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $078fe06734a4d822$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $ac9f9d9da9ff214b$export$d6051a0f7a227332)(function(key, val) {
        if ($078fe06734a4d822$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $078fe06734a4d822$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $ac9f9d9da9ff214b$export$d6051a0f7a227332)(function(key, val) {
        if ($078fe06734a4d822$var$needContinue(val)) return $078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread({}, val), {}, {
            velocity: $078fe06734a4d822$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $078fe06734a4d822$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$078fe06734a4d822$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $ac9f9d9da9ff214b$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread({}, res), {}, $078fe06734a4d822$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread({}, res), {}, $078fe06734a4d822$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $ac9f9d9da9ff214b$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($078fe06734a4d822$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $078fe06734a4d822$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $ac9f9d9da9ff214b$export$d6051a0f7a227332)(function(key, val) {
            return $078fe06734a4d822$var$alpha.apply(void 0, $078fe06734a4d822$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $ac9f9d9da9ff214b$export$d6051a0f7a227332)(function(key, val) {
                return $078fe06734a4d822$var$alpha.apply(void 0, $078fe06734a4d822$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread($078fe06734a4d822$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $e112106a7cc87421$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e112106a7cc87421$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e112106a7cc87421$var$_typeof(o);
}
var $e112106a7cc87421$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $e112106a7cc87421$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e112106a7cc87421$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e112106a7cc87421$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e112106a7cc87421$var$_toConsumableArray(arr) {
    return $e112106a7cc87421$var$_arrayWithoutHoles(arr) || $e112106a7cc87421$var$_iterableToArray(arr) || $e112106a7cc87421$var$_unsupportedIterableToArray(arr) || $e112106a7cc87421$var$_nonIterableSpread();
}
function $e112106a7cc87421$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e112106a7cc87421$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e112106a7cc87421$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e112106a7cc87421$var$_arrayLikeToArray(o, minLen);
}
function $e112106a7cc87421$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e112106a7cc87421$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e112106a7cc87421$var$_arrayLikeToArray(arr);
}
function $e112106a7cc87421$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e112106a7cc87421$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e112106a7cc87421$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e112106a7cc87421$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e112106a7cc87421$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e112106a7cc87421$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e112106a7cc87421$var$_defineProperty(obj, key, value) {
    key = $e112106a7cc87421$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e112106a7cc87421$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e112106a7cc87421$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e112106a7cc87421$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e112106a7cc87421$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e112106a7cc87421$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e112106a7cc87421$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e112106a7cc87421$var$_toPropertyKey(arg) {
    var key = $e112106a7cc87421$var$_toPrimitive(arg, "string");
    return $e112106a7cc87421$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e112106a7cc87421$var$_toPrimitive(input, hint) {
    if ($e112106a7cc87421$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e112106a7cc87421$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e112106a7cc87421$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e112106a7cc87421$var$_setPrototypeOf(subClass, superClass);
}
function $e112106a7cc87421$var$_setPrototypeOf(o, p) {
    $e112106a7cc87421$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e112106a7cc87421$var$_setPrototypeOf(o, p);
}
function $e112106a7cc87421$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e112106a7cc87421$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e112106a7cc87421$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e112106a7cc87421$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e112106a7cc87421$var$_possibleConstructorReturn(this, result);
    };
}
function $e112106a7cc87421$var$_possibleConstructorReturn(self, call) {
    if (call && ($e112106a7cc87421$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e112106a7cc87421$var$_assertThisInitialized(self);
}
function $e112106a7cc87421$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e112106a7cc87421$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e112106a7cc87421$var$_getPrototypeOf(o) {
    $e112106a7cc87421$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e112106a7cc87421$var$_getPrototypeOf(o);
}
var $e112106a7cc87421$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $e112106a7cc87421$var$_inherits(Animate, _PureComponent);
    var _super = $e112106a7cc87421$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $e112106a7cc87421$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($e112106a7cc87421$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($e112106a7cc87421$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $e112106a7cc87421$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $e112106a7cc87421$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $e112106a7cc87421$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $e112106a7cc87421$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $e112106a7cc87421$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $1ecced93815b40e8$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $e112106a7cc87421$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($e112106a7cc87421$var$_objectSpread($e112106a7cc87421$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $078fe06734a4d822$export$2e2bcd8739ae039)(from, to, (0, $10617984cffab340$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($e112106a7cc87421$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $ac9f9d9da9ff214b$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $e112106a7cc87421$var$_objectSpread($e112106a7cc87421$var$_objectSpread($e112106a7cc87421$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($e112106a7cc87421$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $ac9f9d9da9ff214b$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($e112106a7cc87421$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $4c9a09af22aa3484$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $e112106a7cc87421$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $ac9f9d9da9ff214b$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $e112106a7cc87421$var$_objectSpread($e112106a7cc87421$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $e112106a7cc87421$var$_objectWithoutProperties(_this$props4, $e112106a7cc87421$var$_excluded);
                var count = (0, $cQmXV.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $cQmXV.cloneElement)(container, $e112106a7cc87421$var$_objectSpread($e112106a7cc87421$var$_objectSpread({}, others), {}, {
                        style: $e112106a7cc87421$var$_objectSpread($e112106a7cc87421$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $cQmXV.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", null, (0, $cQmXV.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $cQmXV.PureComponent));
$e112106a7cc87421$var$Animate.displayName = "Animate";
$e112106a7cc87421$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$e112106a7cc87421$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func
};
var $e112106a7cc87421$export$2e2bcd8739ae039 = $e112106a7cc87421$var$Animate;




var $835ae81331d3c901$export$2e2bcd8739ae039 = (0, $e112106a7cc87421$export$2e2bcd8739ae039);


var $35887ca5f067dffa$exports = {};
var $d92048f5b28963ed$exports = {};
var $8c247c0dab27c1b0$exports = {};

var $hA3PB = parcelRequire("hA3PB");
/** Built-in value references. */ var $8c247c0dab27c1b0$var$Symbol = $hA3PB.Symbol;
$8c247c0dab27c1b0$exports = $8c247c0dab27c1b0$var$Symbol;


var $910f9a44c73f7b2e$exports = {};

/** Used for built-in method references. */ var $910f9a44c73f7b2e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $910f9a44c73f7b2e$var$hasOwnProperty = $910f9a44c73f7b2e$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $910f9a44c73f7b2e$var$nativeObjectToString = $910f9a44c73f7b2e$var$objectProto.toString;
/** Built-in value references. */ var $910f9a44c73f7b2e$var$symToStringTag = $8c247c0dab27c1b0$exports ? $8c247c0dab27c1b0$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $910f9a44c73f7b2e$var$getRawTag(value) {
    var isOwn = $910f9a44c73f7b2e$var$hasOwnProperty.call(value, $910f9a44c73f7b2e$var$symToStringTag), tag = value[$910f9a44c73f7b2e$var$symToStringTag];
    try {
        value[$910f9a44c73f7b2e$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $910f9a44c73f7b2e$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$910f9a44c73f7b2e$var$symToStringTag] = tag;
        else delete value[$910f9a44c73f7b2e$var$symToStringTag];
    }
    return result;
}
$910f9a44c73f7b2e$exports = $910f9a44c73f7b2e$var$getRawTag;


var $39ca6dc2707e3397$exports = {};
/** Used for built-in method references. */ var $39ca6dc2707e3397$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $39ca6dc2707e3397$var$nativeObjectToString = $39ca6dc2707e3397$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $39ca6dc2707e3397$var$objectToString(value) {
    return $39ca6dc2707e3397$var$nativeObjectToString.call(value);
}
$39ca6dc2707e3397$exports = $39ca6dc2707e3397$var$objectToString;


/** `Object#toString` result references. */ var $d92048f5b28963ed$var$nullTag = "[object Null]", $d92048f5b28963ed$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $d92048f5b28963ed$var$symToStringTag = $8c247c0dab27c1b0$exports ? $8c247c0dab27c1b0$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d92048f5b28963ed$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d92048f5b28963ed$var$undefinedTag : $d92048f5b28963ed$var$nullTag;
    return $d92048f5b28963ed$var$symToStringTag && $d92048f5b28963ed$var$symToStringTag in Object(value) ? $910f9a44c73f7b2e$exports(value) : $39ca6dc2707e3397$exports(value);
}
$d92048f5b28963ed$exports = $d92048f5b28963ed$var$baseGetTag;


var $cefe2712cc3cf6f1$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cefe2712cc3cf6f1$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$cefe2712cc3cf6f1$exports = $cefe2712cc3cf6f1$var$isObject;


/** `Object#toString` result references. */ var $35887ca5f067dffa$var$asyncTag = "[object AsyncFunction]", $35887ca5f067dffa$var$funcTag = "[object Function]", $35887ca5f067dffa$var$genTag = "[object GeneratorFunction]", $35887ca5f067dffa$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $35887ca5f067dffa$var$isFunction(value) {
    if (!$cefe2712cc3cf6f1$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $d92048f5b28963ed$exports(value);
    return tag == $35887ca5f067dffa$var$funcTag || tag == $35887ca5f067dffa$var$genTag || tag == $35887ca5f067dffa$var$asyncTag || tag == $35887ca5f067dffa$var$proxyTag;
}
$35887ca5f067dffa$exports = $35887ca5f067dffa$var$isFunction;


var $f13ef07c8d3a7469$exports = {};
var $aba5d093737cc29c$exports = {};
var $43b47a6ca78760ab$exports = {};

var $23d15efa9df98feb$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $23d15efa9df98feb$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$23d15efa9df98feb$exports = $23d15efa9df98feb$var$isObjectLike;


/** `Object#toString` result references. */ var $43b47a6ca78760ab$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $43b47a6ca78760ab$var$isSymbol(value) {
    return typeof value == "symbol" || $23d15efa9df98feb$exports(value) && $d92048f5b28963ed$exports(value) == $43b47a6ca78760ab$var$symbolTag;
}
$43b47a6ca78760ab$exports = $43b47a6ca78760ab$var$isSymbol;


/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $aba5d093737cc29c$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$43b47a6ca78760ab$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$aba5d093737cc29c$exports = $aba5d093737cc29c$var$baseExtremum;


var $01085770e04187e1$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $01085770e04187e1$var$baseGt(value, other) {
    return value > other;
}
$01085770e04187e1$exports = $01085770e04187e1$var$baseGt;


var $6d89377597b01df5$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $6d89377597b01df5$var$identity(value) {
    return value;
}
$6d89377597b01df5$exports = $6d89377597b01df5$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $f13ef07c8d3a7469$var$max(array) {
    return array && array.length ? $aba5d093737cc29c$exports(array, $6d89377597b01df5$exports, $01085770e04187e1$exports) : undefined;
}
$f13ef07c8d3a7469$exports = $f13ef07c8d3a7469$var$max;


var $80faf5e2a7d54edd$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $80faf5e2a7d54edd$var$isNil(value) {
    return value == null;
}
$80faf5e2a7d54edd$exports = $80faf5e2a7d54edd$var$isNil;


var $c17678deab4d3b44$exports = {};
var $31cdf12d0101ea0f$exports = {};


/** `Object#toString` result references. */ var $31cdf12d0101ea0f$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $31cdf12d0101ea0f$var$isNumber(value) {
    return typeof value == "number" || $23d15efa9df98feb$exports(value) && $d92048f5b28963ed$exports(value) == $31cdf12d0101ea0f$var$numberTag;
}
$31cdf12d0101ea0f$exports = $31cdf12d0101ea0f$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $c17678deab4d3b44$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $31cdf12d0101ea0f$exports(value) && value != +value;
}
$c17678deab4d3b44$exports = $c17678deab4d3b44$var$isNaN;


var $594a31a4f2e6aa3c$exports = {};
var $8efa82404d6ff061$exports = {};
var $c777c75f7ef90fed$exports = {};
var $8f85326b0834f020$exports = {};
var $72ce8eb992d211da$exports = {};
var $686745abbe430172$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $686745abbe430172$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$686745abbe430172$exports = $686745abbe430172$var$listCacheClear;


var $695d7f09908a91e8$exports = {};
var $f215c95b03c8a973$exports = {};
var $74c2ecb2e761e5c6$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $74c2ecb2e761e5c6$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$74c2ecb2e761e5c6$exports = $74c2ecb2e761e5c6$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f215c95b03c8a973$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($74c2ecb2e761e5c6$exports(array[length][0], key)) return length;
    }
    return -1;
}
$f215c95b03c8a973$exports = $f215c95b03c8a973$var$assocIndexOf;


/** Used for built-in method references. */ var $695d7f09908a91e8$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $695d7f09908a91e8$var$splice = $695d7f09908a91e8$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $695d7f09908a91e8$var$listCacheDelete(key) {
    var data = this.__data__, index = $f215c95b03c8a973$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $695d7f09908a91e8$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$695d7f09908a91e8$exports = $695d7f09908a91e8$var$listCacheDelete;


var $f987f8a6bc732f77$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f987f8a6bc732f77$var$listCacheGet(key) {
    var data = this.__data__, index = $f215c95b03c8a973$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$f987f8a6bc732f77$exports = $f987f8a6bc732f77$var$listCacheGet;


var $7a1360e92e1b6b09$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7a1360e92e1b6b09$var$listCacheHas(key) {
    return $f215c95b03c8a973$exports(this.__data__, key) > -1;
}
$7a1360e92e1b6b09$exports = $7a1360e92e1b6b09$var$listCacheHas;


var $e3e0c99a89f94194$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e3e0c99a89f94194$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f215c95b03c8a973$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$e3e0c99a89f94194$exports = $e3e0c99a89f94194$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $72ce8eb992d211da$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$72ce8eb992d211da$var$ListCache.prototype.clear = $686745abbe430172$exports;
$72ce8eb992d211da$var$ListCache.prototype["delete"] = $695d7f09908a91e8$exports;
$72ce8eb992d211da$var$ListCache.prototype.get = $f987f8a6bc732f77$exports;
$72ce8eb992d211da$var$ListCache.prototype.has = $7a1360e92e1b6b09$exports;
$72ce8eb992d211da$var$ListCache.prototype.set = $e3e0c99a89f94194$exports;
$72ce8eb992d211da$exports = $72ce8eb992d211da$var$ListCache;


var $ef5b16493867edf4$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $ef5b16493867edf4$var$stackClear() {
    this.__data__ = new $72ce8eb992d211da$exports;
    this.size = 0;
}
$ef5b16493867edf4$exports = $ef5b16493867edf4$var$stackClear;


var $6fa27d52c342a2da$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6fa27d52c342a2da$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$6fa27d52c342a2da$exports = $6fa27d52c342a2da$var$stackDelete;


var $ddab02234325bb16$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ddab02234325bb16$var$stackGet(key) {
    return this.__data__.get(key);
}
$ddab02234325bb16$exports = $ddab02234325bb16$var$stackGet;


var $4551d77adb0989eb$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4551d77adb0989eb$var$stackHas(key) {
    return this.__data__.has(key);
}
$4551d77adb0989eb$exports = $4551d77adb0989eb$var$stackHas;


var $875a6f096d134321$exports = {};

var $3ef7ba4202d4f020$exports = {};
var $84200a7be5477948$exports = {};
var $935737d85de9ae9e$exports = {};

var $0a38bbd373d346b3$exports = {};
var $1e859241359fe196$exports = {};

var $hA3PB = parcelRequire("hA3PB");
/** Used to detect overreaching core-js shims. */ var $1e859241359fe196$var$coreJsData = $hA3PB["__core-js_shared__"];
$1e859241359fe196$exports = $1e859241359fe196$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $0a38bbd373d346b3$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1e859241359fe196$exports && $1e859241359fe196$exports.keys && $1e859241359fe196$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0a38bbd373d346b3$var$isMasked(func) {
    return !!$0a38bbd373d346b3$var$maskSrcKey && $0a38bbd373d346b3$var$maskSrcKey in func;
}
$0a38bbd373d346b3$exports = $0a38bbd373d346b3$var$isMasked;



var $d9408a1e58bc4a70$exports = {};
/** Used for built-in method references. */ var $d9408a1e58bc4a70$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $d9408a1e58bc4a70$var$funcToString = $d9408a1e58bc4a70$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $d9408a1e58bc4a70$var$toSource(func) {
    if (func != null) {
        try {
            return $d9408a1e58bc4a70$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$d9408a1e58bc4a70$exports = $d9408a1e58bc4a70$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $935737d85de9ae9e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $935737d85de9ae9e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $935737d85de9ae9e$var$funcProto = Function.prototype, $935737d85de9ae9e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $935737d85de9ae9e$var$funcToString = $935737d85de9ae9e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $935737d85de9ae9e$var$hasOwnProperty = $935737d85de9ae9e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $935737d85de9ae9e$var$reIsNative = RegExp("^" + $935737d85de9ae9e$var$funcToString.call($935737d85de9ae9e$var$hasOwnProperty).replace($935737d85de9ae9e$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $935737d85de9ae9e$var$baseIsNative(value) {
    if (!$cefe2712cc3cf6f1$exports(value) || $0a38bbd373d346b3$exports(value)) return false;
    var pattern = $35887ca5f067dffa$exports(value) ? $935737d85de9ae9e$var$reIsNative : $935737d85de9ae9e$var$reIsHostCtor;
    return pattern.test($d9408a1e58bc4a70$exports(value));
}
$935737d85de9ae9e$exports = $935737d85de9ae9e$var$baseIsNative;


var $b5ce3c7a8438cd6a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b5ce3c7a8438cd6a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$b5ce3c7a8438cd6a$exports = $b5ce3c7a8438cd6a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $84200a7be5477948$var$getNative(object, key) {
    var value = $b5ce3c7a8438cd6a$exports(object, key);
    return $935737d85de9ae9e$exports(value) ? value : undefined;
}
$84200a7be5477948$exports = $84200a7be5477948$var$getNative;



var $hA3PB = parcelRequire("hA3PB");
/* Built-in method references that are verified to be native. */ var $3ef7ba4202d4f020$var$Map = $84200a7be5477948$exports($hA3PB, "Map");
$3ef7ba4202d4f020$exports = $3ef7ba4202d4f020$var$Map;


var $3e78c518278be37b$exports = {};
var $4e1daa1bb855ed3b$exports = {};
var $9e829c5ed70d72d0$exports = {};
var $80aeedf546d3efbf$exports = {};
var $b68cb93efb8761d4$exports = {};

/* Built-in method references that are verified to be native. */ var $b68cb93efb8761d4$var$nativeCreate = $84200a7be5477948$exports(Object, "create");
$b68cb93efb8761d4$exports = $b68cb93efb8761d4$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80aeedf546d3efbf$var$hashClear() {
    this.__data__ = $b68cb93efb8761d4$exports ? $b68cb93efb8761d4$exports(null) : {};
    this.size = 0;
}
$80aeedf546d3efbf$exports = $80aeedf546d3efbf$var$hashClear;


var $db2d74c3a3e57e43$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $db2d74c3a3e57e43$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$db2d74c3a3e57e43$exports = $db2d74c3a3e57e43$var$hashDelete;


var $045123adebef31a6$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $045123adebef31a6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $045123adebef31a6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $045123adebef31a6$var$hasOwnProperty = $045123adebef31a6$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $045123adebef31a6$var$hashGet(key) {
    var data = this.__data__;
    if ($b68cb93efb8761d4$exports) {
        var result = data[key];
        return result === $045123adebef31a6$var$HASH_UNDEFINED ? undefined : result;
    }
    return $045123adebef31a6$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$045123adebef31a6$exports = $045123adebef31a6$var$hashGet;


var $9ec5d0b65de97e95$exports = {};

/** Used for built-in method references. */ var $9ec5d0b65de97e95$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9ec5d0b65de97e95$var$hasOwnProperty = $9ec5d0b65de97e95$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9ec5d0b65de97e95$var$hashHas(key) {
    var data = this.__data__;
    return $b68cb93efb8761d4$exports ? data[key] !== undefined : $9ec5d0b65de97e95$var$hasOwnProperty.call(data, key);
}
$9ec5d0b65de97e95$exports = $9ec5d0b65de97e95$var$hashHas;


var $4d5542ec0771cf5c$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $4d5542ec0771cf5c$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4d5542ec0771cf5c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $b68cb93efb8761d4$exports && value === undefined ? $4d5542ec0771cf5c$var$HASH_UNDEFINED : value;
    return this;
}
$4d5542ec0771cf5c$exports = $4d5542ec0771cf5c$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9e829c5ed70d72d0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$9e829c5ed70d72d0$var$Hash.prototype.clear = $80aeedf546d3efbf$exports;
$9e829c5ed70d72d0$var$Hash.prototype["delete"] = $db2d74c3a3e57e43$exports;
$9e829c5ed70d72d0$var$Hash.prototype.get = $045123adebef31a6$exports;
$9e829c5ed70d72d0$var$Hash.prototype.has = $9ec5d0b65de97e95$exports;
$9e829c5ed70d72d0$var$Hash.prototype.set = $4d5542ec0771cf5c$exports;
$9e829c5ed70d72d0$exports = $9e829c5ed70d72d0$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $4e1daa1bb855ed3b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $9e829c5ed70d72d0$exports,
        "map": new ($3ef7ba4202d4f020$exports || $72ce8eb992d211da$exports),
        "string": new $9e829c5ed70d72d0$exports
    };
}
$4e1daa1bb855ed3b$exports = $4e1daa1bb855ed3b$var$mapCacheClear;


var $27ea47fc983c6879$exports = {};
var $8d3123ea071dc218$exports = {};
var $91ae5e377910618b$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $91ae5e377910618b$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$91ae5e377910618b$exports = $91ae5e377910618b$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $8d3123ea071dc218$var$getMapData(map, key) {
    var data = map.__data__;
    return $91ae5e377910618b$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$8d3123ea071dc218$exports = $8d3123ea071dc218$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $27ea47fc983c6879$var$mapCacheDelete(key) {
    var result = $8d3123ea071dc218$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$27ea47fc983c6879$exports = $27ea47fc983c6879$var$mapCacheDelete;


var $da55c99aad6aeff7$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $da55c99aad6aeff7$var$mapCacheGet(key) {
    return $8d3123ea071dc218$exports(this, key).get(key);
}
$da55c99aad6aeff7$exports = $da55c99aad6aeff7$var$mapCacheGet;


var $a62cda353c97cdeb$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a62cda353c97cdeb$var$mapCacheHas(key) {
    return $8d3123ea071dc218$exports(this, key).has(key);
}
$a62cda353c97cdeb$exports = $a62cda353c97cdeb$var$mapCacheHas;


var $64d3030b6f57a0dd$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $64d3030b6f57a0dd$var$mapCacheSet(key, value) {
    var data = $8d3123ea071dc218$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$64d3030b6f57a0dd$exports = $64d3030b6f57a0dd$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3e78c518278be37b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3e78c518278be37b$var$MapCache.prototype.clear = $4e1daa1bb855ed3b$exports;
$3e78c518278be37b$var$MapCache.prototype["delete"] = $27ea47fc983c6879$exports;
$3e78c518278be37b$var$MapCache.prototype.get = $da55c99aad6aeff7$exports;
$3e78c518278be37b$var$MapCache.prototype.has = $a62cda353c97cdeb$exports;
$3e78c518278be37b$var$MapCache.prototype.set = $64d3030b6f57a0dd$exports;
$3e78c518278be37b$exports = $3e78c518278be37b$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $875a6f096d134321$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $875a6f096d134321$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $72ce8eb992d211da$exports) {
        var pairs = data.__data__;
        if (!$3ef7ba4202d4f020$exports || pairs.length < $875a6f096d134321$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $3e78c518278be37b$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$875a6f096d134321$exports = $875a6f096d134321$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8f85326b0834f020$var$Stack(entries) {
    var data = this.__data__ = new $72ce8eb992d211da$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8f85326b0834f020$var$Stack.prototype.clear = $ef5b16493867edf4$exports;
$8f85326b0834f020$var$Stack.prototype["delete"] = $6fa27d52c342a2da$exports;
$8f85326b0834f020$var$Stack.prototype.get = $ddab02234325bb16$exports;
$8f85326b0834f020$var$Stack.prototype.has = $4551d77adb0989eb$exports;
$8f85326b0834f020$var$Stack.prototype.set = $875a6f096d134321$exports;
$8f85326b0834f020$exports = $8f85326b0834f020$var$Stack;


var $68988c4fa4342962$exports = {};
var $3d006af530d60c97$exports = {};

var $7efcb9bdd93cbacc$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $7efcb9bdd93cbacc$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $7efcb9bdd93cbacc$var$setCacheAdd(value) {
    this.__data__.set(value, $7efcb9bdd93cbacc$var$HASH_UNDEFINED);
    return this;
}
$7efcb9bdd93cbacc$exports = $7efcb9bdd93cbacc$var$setCacheAdd;


var $6d1566eb1f2875c6$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $6d1566eb1f2875c6$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$6d1566eb1f2875c6$exports = $6d1566eb1f2875c6$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $3d006af530d60c97$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $3e78c518278be37b$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$3d006af530d60c97$var$SetCache.prototype.add = $3d006af530d60c97$var$SetCache.prototype.push = $7efcb9bdd93cbacc$exports;
$3d006af530d60c97$var$SetCache.prototype.has = $6d1566eb1f2875c6$exports;
$3d006af530d60c97$exports = $3d006af530d60c97$var$SetCache;


var $61660d90f3320dcd$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $61660d90f3320dcd$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$61660d90f3320dcd$exports = $61660d90f3320dcd$var$arraySome;


var $41c81debd2b371c7$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $41c81debd2b371c7$var$cacheHas(cache, key) {
    return cache.has(key);
}
$41c81debd2b371c7$exports = $41c81debd2b371c7$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $68988c4fa4342962$var$COMPARE_PARTIAL_FLAG = 1, $68988c4fa4342962$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $68988c4fa4342962$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $68988c4fa4342962$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $68988c4fa4342962$var$COMPARE_UNORDERED_FLAG ? new $3d006af530d60c97$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$61660d90f3320dcd$exports(other, function(othValue, othIndex) {
                if (!$41c81debd2b371c7$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$68988c4fa4342962$exports = $68988c4fa4342962$var$equalArrays;


var $14376e5e7246b536$exports = {};

var $457838cac08898de$exports = {};

var $hA3PB = parcelRequire("hA3PB");
/** Built-in value references. */ var $457838cac08898de$var$Uint8Array = $hA3PB.Uint8Array;
$457838cac08898de$exports = $457838cac08898de$var$Uint8Array;




var $2277d9d0907b644c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $2277d9d0907b644c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$2277d9d0907b644c$exports = $2277d9d0907b644c$var$mapToArray;


var $5974dd07043eebb5$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5974dd07043eebb5$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$5974dd07043eebb5$exports = $5974dd07043eebb5$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $14376e5e7246b536$var$COMPARE_PARTIAL_FLAG = 1, $14376e5e7246b536$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $14376e5e7246b536$var$boolTag = "[object Boolean]", $14376e5e7246b536$var$dateTag = "[object Date]", $14376e5e7246b536$var$errorTag = "[object Error]", $14376e5e7246b536$var$mapTag = "[object Map]", $14376e5e7246b536$var$numberTag = "[object Number]", $14376e5e7246b536$var$regexpTag = "[object RegExp]", $14376e5e7246b536$var$setTag = "[object Set]", $14376e5e7246b536$var$stringTag = "[object String]", $14376e5e7246b536$var$symbolTag = "[object Symbol]";
var $14376e5e7246b536$var$arrayBufferTag = "[object ArrayBuffer]", $14376e5e7246b536$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $14376e5e7246b536$var$symbolProto = $8c247c0dab27c1b0$exports ? $8c247c0dab27c1b0$exports.prototype : undefined, $14376e5e7246b536$var$symbolValueOf = $14376e5e7246b536$var$symbolProto ? $14376e5e7246b536$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $14376e5e7246b536$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $14376e5e7246b536$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $14376e5e7246b536$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $457838cac08898de$exports(object), new $457838cac08898de$exports(other))) return false;
            return true;
        case $14376e5e7246b536$var$boolTag:
        case $14376e5e7246b536$var$dateTag:
        case $14376e5e7246b536$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $74c2ecb2e761e5c6$exports(+object, +other);
        case $14376e5e7246b536$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $14376e5e7246b536$var$regexpTag:
        case $14376e5e7246b536$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $14376e5e7246b536$var$mapTag:
            var convert = $2277d9d0907b644c$exports;
        case $14376e5e7246b536$var$setTag:
            var isPartial = bitmask & $14376e5e7246b536$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $5974dd07043eebb5$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $14376e5e7246b536$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $68988c4fa4342962$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $14376e5e7246b536$var$symbolTag:
            if ($14376e5e7246b536$var$symbolValueOf) return $14376e5e7246b536$var$symbolValueOf.call(object) == $14376e5e7246b536$var$symbolValueOf.call(other);
    }
    return false;
}
$14376e5e7246b536$exports = $14376e5e7246b536$var$equalByTag;


var $66d2a50fa2ea149e$exports = {};
var $7e70487281c88e08$exports = {};
var $0f0406272fc88800$exports = {};
var $320ddc1cfd7259e7$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $320ddc1cfd7259e7$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$320ddc1cfd7259e7$exports = $320ddc1cfd7259e7$var$arrayPush;


var $d3cd128394c0afcd$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d3cd128394c0afcd$var$isArray = Array.isArray;
$d3cd128394c0afcd$exports = $d3cd128394c0afcd$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0f0406272fc88800$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $d3cd128394c0afcd$exports(object) ? result : $320ddc1cfd7259e7$exports(result, symbolsFunc(object));
}
$0f0406272fc88800$exports = $0f0406272fc88800$var$baseGetAllKeys;


var $dfc53e78dd561ac1$exports = {};
var $b804c891644a4711$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $b804c891644a4711$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$b804c891644a4711$exports = $b804c891644a4711$var$arrayFilter;


var $70fc6b41c2ae28a0$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $70fc6b41c2ae28a0$var$stubArray() {
    return [];
}
$70fc6b41c2ae28a0$exports = $70fc6b41c2ae28a0$var$stubArray;


/** Used for built-in method references. */ var $dfc53e78dd561ac1$var$objectProto = Object.prototype;
/** Built-in value references. */ var $dfc53e78dd561ac1$var$propertyIsEnumerable = $dfc53e78dd561ac1$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dfc53e78dd561ac1$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $dfc53e78dd561ac1$var$getSymbols = !$dfc53e78dd561ac1$var$nativeGetSymbols ? $70fc6b41c2ae28a0$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $b804c891644a4711$exports($dfc53e78dd561ac1$var$nativeGetSymbols(object), function(symbol) {
        return $dfc53e78dd561ac1$var$propertyIsEnumerable.call(object, symbol);
    });
};
$dfc53e78dd561ac1$exports = $dfc53e78dd561ac1$var$getSymbols;


var $767b9cae0f938981$exports = {};
var $306b93288416c598$exports = {};
var $6ff917d231bc96b7$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $6ff917d231bc96b7$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$6ff917d231bc96b7$exports = $6ff917d231bc96b7$var$baseTimes;


var $60d32cc4b8713ffd$exports = {};
var $9aebac0972973b9b$exports = {};


/** `Object#toString` result references. */ var $9aebac0972973b9b$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $9aebac0972973b9b$var$baseIsArguments(value) {
    return $23d15efa9df98feb$exports(value) && $d92048f5b28963ed$exports(value) == $9aebac0972973b9b$var$argsTag;
}
$9aebac0972973b9b$exports = $9aebac0972973b9b$var$baseIsArguments;



/** Used for built-in method references. */ var $60d32cc4b8713ffd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $60d32cc4b8713ffd$var$hasOwnProperty = $60d32cc4b8713ffd$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $60d32cc4b8713ffd$var$propertyIsEnumerable = $60d32cc4b8713ffd$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $60d32cc4b8713ffd$var$isArguments = $9aebac0972973b9b$exports(function() {
    return arguments;
}()) ? $9aebac0972973b9b$exports : function(value) {
    return $23d15efa9df98feb$exports(value) && $60d32cc4b8713ffd$var$hasOwnProperty.call(value, "callee") && !$60d32cc4b8713ffd$var$propertyIsEnumerable.call(value, "callee");
};
$60d32cc4b8713ffd$exports = $60d32cc4b8713ffd$var$isArguments;




var $7VD5U = parcelRequire("7VD5U");
var $b3ca8c4c277ecf4b$exports = {};
/** Used as references for various `Number` constants. */ var $b3ca8c4c277ecf4b$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $b3ca8c4c277ecf4b$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $b3ca8c4c277ecf4b$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $b3ca8c4c277ecf4b$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $b3ca8c4c277ecf4b$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$b3ca8c4c277ecf4b$exports = $b3ca8c4c277ecf4b$var$isIndex;


var $837f1545dbec6d1c$exports = {};
var $c83ae364688fbffd$exports = {};

var $d63e5a50f9d1c4cd$exports = {};
/** Used as references for various `Number` constants. */ var $d63e5a50f9d1c4cd$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d63e5a50f9d1c4cd$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d63e5a50f9d1c4cd$var$MAX_SAFE_INTEGER;
}
$d63e5a50f9d1c4cd$exports = $d63e5a50f9d1c4cd$var$isLength;



/** `Object#toString` result references. */ var $c83ae364688fbffd$var$argsTag = "[object Arguments]", $c83ae364688fbffd$var$arrayTag = "[object Array]", $c83ae364688fbffd$var$boolTag = "[object Boolean]", $c83ae364688fbffd$var$dateTag = "[object Date]", $c83ae364688fbffd$var$errorTag = "[object Error]", $c83ae364688fbffd$var$funcTag = "[object Function]", $c83ae364688fbffd$var$mapTag = "[object Map]", $c83ae364688fbffd$var$numberTag = "[object Number]", $c83ae364688fbffd$var$objectTag = "[object Object]", $c83ae364688fbffd$var$regexpTag = "[object RegExp]", $c83ae364688fbffd$var$setTag = "[object Set]", $c83ae364688fbffd$var$stringTag = "[object String]", $c83ae364688fbffd$var$weakMapTag = "[object WeakMap]";
var $c83ae364688fbffd$var$arrayBufferTag = "[object ArrayBuffer]", $c83ae364688fbffd$var$dataViewTag = "[object DataView]", $c83ae364688fbffd$var$float32Tag = "[object Float32Array]", $c83ae364688fbffd$var$float64Tag = "[object Float64Array]", $c83ae364688fbffd$var$int8Tag = "[object Int8Array]", $c83ae364688fbffd$var$int16Tag = "[object Int16Array]", $c83ae364688fbffd$var$int32Tag = "[object Int32Array]", $c83ae364688fbffd$var$uint8Tag = "[object Uint8Array]", $c83ae364688fbffd$var$uint8ClampedTag = "[object Uint8ClampedArray]", $c83ae364688fbffd$var$uint16Tag = "[object Uint16Array]", $c83ae364688fbffd$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $c83ae364688fbffd$var$typedArrayTags = {};
$c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$float32Tag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$float64Tag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$int8Tag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$int16Tag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$int32Tag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$uint8Tag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$uint8ClampedTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$uint16Tag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$uint32Tag] = true;
$c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$argsTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$arrayTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$arrayBufferTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$boolTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$dataViewTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$dateTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$errorTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$funcTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$mapTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$numberTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$objectTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$regexpTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$setTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$stringTag] = $c83ae364688fbffd$var$typedArrayTags[$c83ae364688fbffd$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $c83ae364688fbffd$var$baseIsTypedArray(value) {
    return $23d15efa9df98feb$exports(value) && $d63e5a50f9d1c4cd$exports(value.length) && !!$c83ae364688fbffd$var$typedArrayTags[$d92048f5b28963ed$exports(value)];
}
$c83ae364688fbffd$exports = $c83ae364688fbffd$var$baseIsTypedArray;


var $985fe0e94448a6b2$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $985fe0e94448a6b2$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$985fe0e94448a6b2$exports = $985fe0e94448a6b2$var$baseUnary;



var $5xpOJ = parcelRequire("5xpOJ");
/* Node.js helper references. */ var $837f1545dbec6d1c$var$nodeIsTypedArray = $5xpOJ && $5xpOJ.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $837f1545dbec6d1c$var$isTypedArray = $837f1545dbec6d1c$var$nodeIsTypedArray ? $985fe0e94448a6b2$exports($837f1545dbec6d1c$var$nodeIsTypedArray) : $c83ae364688fbffd$exports;
$837f1545dbec6d1c$exports = $837f1545dbec6d1c$var$isTypedArray;


/** Used for built-in method references. */ var $306b93288416c598$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $306b93288416c598$var$hasOwnProperty = $306b93288416c598$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $306b93288416c598$var$arrayLikeKeys(value, inherited) {
    var isArr = $d3cd128394c0afcd$exports(value), isArg = !isArr && $60d32cc4b8713ffd$exports(value), isBuff = !isArr && !isArg && $7VD5U(value), isType = !isArr && !isArg && !isBuff && $837f1545dbec6d1c$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $6ff917d231bc96b7$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $306b93288416c598$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $b3ca8c4c277ecf4b$exports(key, length)))) result.push(key);
    return result;
}
$306b93288416c598$exports = $306b93288416c598$var$arrayLikeKeys;


var $6b0c0c98838dd2a3$exports = {};
var $e8a29c6bb6568d46$exports = {};
/** Used for built-in method references. */ var $e8a29c6bb6568d46$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e8a29c6bb6568d46$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $e8a29c6bb6568d46$var$objectProto;
    return value === proto;
}
$e8a29c6bb6568d46$exports = $e8a29c6bb6568d46$var$isPrototype;


var $c23be440816bebce$exports = {};
var $1711a73c9485885d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $1711a73c9485885d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$1711a73c9485885d$exports = $1711a73c9485885d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c23be440816bebce$var$nativeKeys = $1711a73c9485885d$exports(Object.keys, Object);
$c23be440816bebce$exports = $c23be440816bebce$var$nativeKeys;


/** Used for built-in method references. */ var $6b0c0c98838dd2a3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6b0c0c98838dd2a3$var$hasOwnProperty = $6b0c0c98838dd2a3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6b0c0c98838dd2a3$var$baseKeys(object) {
    if (!$e8a29c6bb6568d46$exports(object)) return $c23be440816bebce$exports(object);
    var result = [];
    for(var key in Object(object))if ($6b0c0c98838dd2a3$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$6b0c0c98838dd2a3$exports = $6b0c0c98838dd2a3$var$baseKeys;


var $762eed9717dbe83d$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $762eed9717dbe83d$var$isArrayLike(value) {
    return value != null && $d63e5a50f9d1c4cd$exports(value.length) && !$35887ca5f067dffa$exports(value);
}
$762eed9717dbe83d$exports = $762eed9717dbe83d$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $767b9cae0f938981$var$keys(object) {
    return $762eed9717dbe83d$exports(object) ? $306b93288416c598$exports(object) : $6b0c0c98838dd2a3$exports(object);
}
$767b9cae0f938981$exports = $767b9cae0f938981$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7e70487281c88e08$var$getAllKeys(object) {
    return $0f0406272fc88800$exports(object, $767b9cae0f938981$exports, $dfc53e78dd561ac1$exports);
}
$7e70487281c88e08$exports = $7e70487281c88e08$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $66d2a50fa2ea149e$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $66d2a50fa2ea149e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $66d2a50fa2ea149e$var$hasOwnProperty = $66d2a50fa2ea149e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $66d2a50fa2ea149e$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $66d2a50fa2ea149e$var$COMPARE_PARTIAL_FLAG, objProps = $7e70487281c88e08$exports(object), objLength = objProps.length, othProps = $7e70487281c88e08$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $66d2a50fa2ea149e$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$66d2a50fa2ea149e$exports = $66d2a50fa2ea149e$var$equalObjects;


var $6b746f571eaeab5c$exports = {};
var $e6048f57f7181068$exports = {};


var $hA3PB = parcelRequire("hA3PB");
/* Built-in method references that are verified to be native. */ var $e6048f57f7181068$var$DataView = $84200a7be5477948$exports($hA3PB, "DataView");
$e6048f57f7181068$exports = $e6048f57f7181068$var$DataView;



var $60664751b6a96082$exports = {};


var $hA3PB = parcelRequire("hA3PB");
/* Built-in method references that are verified to be native. */ var $60664751b6a96082$var$Promise = $84200a7be5477948$exports($hA3PB, "Promise");
$60664751b6a96082$exports = $60664751b6a96082$var$Promise;


var $d9c8d6cff739d502$exports = {};


var $hA3PB = parcelRequire("hA3PB");
/* Built-in method references that are verified to be native. */ var $d9c8d6cff739d502$var$Set = $84200a7be5477948$exports($hA3PB, "Set");
$d9c8d6cff739d502$exports = $d9c8d6cff739d502$var$Set;


var $d1290a31e8df8a1f$exports = {};


var $hA3PB = parcelRequire("hA3PB");
/* Built-in method references that are verified to be native. */ var $d1290a31e8df8a1f$var$WeakMap = $84200a7be5477948$exports($hA3PB, "WeakMap");
$d1290a31e8df8a1f$exports = $d1290a31e8df8a1f$var$WeakMap;




/** `Object#toString` result references. */ var $6b746f571eaeab5c$var$mapTag = "[object Map]", $6b746f571eaeab5c$var$objectTag = "[object Object]", $6b746f571eaeab5c$var$promiseTag = "[object Promise]", $6b746f571eaeab5c$var$setTag = "[object Set]", $6b746f571eaeab5c$var$weakMapTag = "[object WeakMap]";
var $6b746f571eaeab5c$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $6b746f571eaeab5c$var$dataViewCtorString = $d9408a1e58bc4a70$exports($e6048f57f7181068$exports), $6b746f571eaeab5c$var$mapCtorString = $d9408a1e58bc4a70$exports($3ef7ba4202d4f020$exports), $6b746f571eaeab5c$var$promiseCtorString = $d9408a1e58bc4a70$exports($60664751b6a96082$exports), $6b746f571eaeab5c$var$setCtorString = $d9408a1e58bc4a70$exports($d9c8d6cff739d502$exports), $6b746f571eaeab5c$var$weakMapCtorString = $d9408a1e58bc4a70$exports($d1290a31e8df8a1f$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $6b746f571eaeab5c$var$getTag = $d92048f5b28963ed$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($e6048f57f7181068$exports && $6b746f571eaeab5c$var$getTag(new $e6048f57f7181068$exports(new ArrayBuffer(1))) != $6b746f571eaeab5c$var$dataViewTag || $3ef7ba4202d4f020$exports && $6b746f571eaeab5c$var$getTag(new $3ef7ba4202d4f020$exports) != $6b746f571eaeab5c$var$mapTag || $60664751b6a96082$exports && $6b746f571eaeab5c$var$getTag($60664751b6a96082$exports.resolve()) != $6b746f571eaeab5c$var$promiseTag || $d9c8d6cff739d502$exports && $6b746f571eaeab5c$var$getTag(new $d9c8d6cff739d502$exports) != $6b746f571eaeab5c$var$setTag || $d1290a31e8df8a1f$exports && $6b746f571eaeab5c$var$getTag(new $d1290a31e8df8a1f$exports) != $6b746f571eaeab5c$var$weakMapTag) $6b746f571eaeab5c$var$getTag = function(value) {
    var result = $d92048f5b28963ed$exports(value), Ctor = result == $6b746f571eaeab5c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $d9408a1e58bc4a70$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $6b746f571eaeab5c$var$dataViewCtorString:
            return $6b746f571eaeab5c$var$dataViewTag;
        case $6b746f571eaeab5c$var$mapCtorString:
            return $6b746f571eaeab5c$var$mapTag;
        case $6b746f571eaeab5c$var$promiseCtorString:
            return $6b746f571eaeab5c$var$promiseTag;
        case $6b746f571eaeab5c$var$setCtorString:
            return $6b746f571eaeab5c$var$setTag;
        case $6b746f571eaeab5c$var$weakMapCtorString:
            return $6b746f571eaeab5c$var$weakMapTag;
    }
    return result;
};
$6b746f571eaeab5c$exports = $6b746f571eaeab5c$var$getTag;




var $7VD5U = parcelRequire("7VD5U");

/** Used to compose bitmasks for value comparisons. */ var $c777c75f7ef90fed$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c777c75f7ef90fed$var$argsTag = "[object Arguments]", $c777c75f7ef90fed$var$arrayTag = "[object Array]", $c777c75f7ef90fed$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c777c75f7ef90fed$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c777c75f7ef90fed$var$hasOwnProperty = $c777c75f7ef90fed$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c777c75f7ef90fed$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $d3cd128394c0afcd$exports(object), othIsArr = $d3cd128394c0afcd$exports(other), objTag = objIsArr ? $c777c75f7ef90fed$var$arrayTag : $6b746f571eaeab5c$exports(object), othTag = othIsArr ? $c777c75f7ef90fed$var$arrayTag : $6b746f571eaeab5c$exports(other);
    objTag = objTag == $c777c75f7ef90fed$var$argsTag ? $c777c75f7ef90fed$var$objectTag : objTag;
    othTag = othTag == $c777c75f7ef90fed$var$argsTag ? $c777c75f7ef90fed$var$objectTag : othTag;
    var objIsObj = objTag == $c777c75f7ef90fed$var$objectTag, othIsObj = othTag == $c777c75f7ef90fed$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $7VD5U(object)) {
        if (!$7VD5U(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $8f85326b0834f020$exports);
        return objIsArr || $837f1545dbec6d1c$exports(object) ? $68988c4fa4342962$exports(object, other, bitmask, customizer, equalFunc, stack) : $14376e5e7246b536$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c777c75f7ef90fed$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c777c75f7ef90fed$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $c777c75f7ef90fed$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $8f85326b0834f020$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $8f85326b0834f020$exports);
    return $66d2a50fa2ea149e$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$c777c75f7ef90fed$exports = $c777c75f7ef90fed$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8efa82404d6ff061$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$23d15efa9df98feb$exports(value) && !$23d15efa9df98feb$exports(other)) return value !== value && other !== other;
    return $c777c75f7ef90fed$exports(value, other, bitmask, customizer, $8efa82404d6ff061$var$baseIsEqual, stack);
}
$8efa82404d6ff061$exports = $8efa82404d6ff061$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $594a31a4f2e6aa3c$var$isEqual(value, other) {
    return $8efa82404d6ff061$exports(value, other);
}
$594a31a4f2e6aa3c$exports = $594a31a4f2e6aa3c$var$isEqual;



var $cQmXV = parcelRequire("cQmXV");
var $488ac17ac3f42c02$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$488ac17ac3f42c02$exports = (parcelRequire("4Z9A5"));


var $b2438c361198a09a$exports = {};
var $ba9d5fee693a6835$exports = {};
var $ff6768590c7dcbab$exports = {};
var $b54e1f9944d9c2e0$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $b54e1f9944d9c2e0$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$b54e1f9944d9c2e0$exports = $b54e1f9944d9c2e0$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $ff6768590c7dcbab$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $b54e1f9944d9c2e0$exports(array, start, end);
}
$ff6768590c7dcbab$exports = $ff6768590c7dcbab$var$castSlice;


var $2c09954cfd417fd6$exports = {};
/** Used to compose unicode character classes. */ var $2c09954cfd417fd6$var$rsAstralRange = "\ud800-\udfff", $2c09954cfd417fd6$var$rsComboMarksRange = "\\u0300-\\u036f", $2c09954cfd417fd6$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $2c09954cfd417fd6$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $2c09954cfd417fd6$var$rsComboRange = $2c09954cfd417fd6$var$rsComboMarksRange + $2c09954cfd417fd6$var$reComboHalfMarksRange + $2c09954cfd417fd6$var$rsComboSymbolsRange, $2c09954cfd417fd6$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $2c09954cfd417fd6$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $2c09954cfd417fd6$var$reHasUnicode = RegExp("[" + $2c09954cfd417fd6$var$rsZWJ + $2c09954cfd417fd6$var$rsAstralRange + $2c09954cfd417fd6$var$rsComboRange + $2c09954cfd417fd6$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $2c09954cfd417fd6$var$hasUnicode(string) {
    return $2c09954cfd417fd6$var$reHasUnicode.test(string);
}
$2c09954cfd417fd6$exports = $2c09954cfd417fd6$var$hasUnicode;


var $0302740a7c28d04b$exports = {};
var $4c900c745ae5ad78$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $4c900c745ae5ad78$var$asciiToArray(string) {
    return string.split("");
}
$4c900c745ae5ad78$exports = $4c900c745ae5ad78$var$asciiToArray;



var $b01cace33625c630$exports = {};
/** Used to compose unicode character classes. */ var $b01cace33625c630$var$rsAstralRange = "\ud800-\udfff", $b01cace33625c630$var$rsComboMarksRange = "\\u0300-\\u036f", $b01cace33625c630$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $b01cace33625c630$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $b01cace33625c630$var$rsComboRange = $b01cace33625c630$var$rsComboMarksRange + $b01cace33625c630$var$reComboHalfMarksRange + $b01cace33625c630$var$rsComboSymbolsRange, $b01cace33625c630$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $b01cace33625c630$var$rsAstral = "[" + $b01cace33625c630$var$rsAstralRange + "]", $b01cace33625c630$var$rsCombo = "[" + $b01cace33625c630$var$rsComboRange + "]", $b01cace33625c630$var$rsFitz = "\ud83c[\udffb-\udfff]", $b01cace33625c630$var$rsModifier = "(?:" + $b01cace33625c630$var$rsCombo + "|" + $b01cace33625c630$var$rsFitz + ")", $b01cace33625c630$var$rsNonAstral = "[^" + $b01cace33625c630$var$rsAstralRange + "]", $b01cace33625c630$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $b01cace33625c630$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $b01cace33625c630$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $b01cace33625c630$var$reOptMod = $b01cace33625c630$var$rsModifier + "?", $b01cace33625c630$var$rsOptVar = "[" + $b01cace33625c630$var$rsVarRange + "]?", $b01cace33625c630$var$rsOptJoin = "(?:" + $b01cace33625c630$var$rsZWJ + "(?:" + [
    $b01cace33625c630$var$rsNonAstral,
    $b01cace33625c630$var$rsRegional,
    $b01cace33625c630$var$rsSurrPair
].join("|") + ")" + $b01cace33625c630$var$rsOptVar + $b01cace33625c630$var$reOptMod + ")*", $b01cace33625c630$var$rsSeq = $b01cace33625c630$var$rsOptVar + $b01cace33625c630$var$reOptMod + $b01cace33625c630$var$rsOptJoin, $b01cace33625c630$var$rsSymbol = "(?:" + [
    $b01cace33625c630$var$rsNonAstral + $b01cace33625c630$var$rsCombo + "?",
    $b01cace33625c630$var$rsCombo,
    $b01cace33625c630$var$rsRegional,
    $b01cace33625c630$var$rsSurrPair,
    $b01cace33625c630$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $b01cace33625c630$var$reUnicode = RegExp($b01cace33625c630$var$rsFitz + "(?=" + $b01cace33625c630$var$rsFitz + ")|" + $b01cace33625c630$var$rsSymbol + $b01cace33625c630$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b01cace33625c630$var$unicodeToArray(string) {
    return string.match($b01cace33625c630$var$reUnicode) || [];
}
$b01cace33625c630$exports = $b01cace33625c630$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0302740a7c28d04b$var$stringToArray(string) {
    return $2c09954cfd417fd6$exports(string) ? $b01cace33625c630$exports(string) : $4c900c745ae5ad78$exports(string);
}
$0302740a7c28d04b$exports = $0302740a7c28d04b$var$stringToArray;


var $6e12ceb78c99c52b$exports = {};
var $59f8e70094574c50$exports = {};

var $764a4fa73651e760$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $764a4fa73651e760$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$764a4fa73651e760$exports = $764a4fa73651e760$var$arrayMap;




/** Used as references for various `Number` constants. */ var $59f8e70094574c50$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $59f8e70094574c50$var$symbolProto = $8c247c0dab27c1b0$exports ? $8c247c0dab27c1b0$exports.prototype : undefined, $59f8e70094574c50$var$symbolToString = $59f8e70094574c50$var$symbolProto ? $59f8e70094574c50$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $59f8e70094574c50$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($d3cd128394c0afcd$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $764a4fa73651e760$exports(value, $59f8e70094574c50$var$baseToString) + "";
    if ($43b47a6ca78760ab$exports(value)) return $59f8e70094574c50$var$symbolToString ? $59f8e70094574c50$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$59f8e70094574c50$var$INFINITY ? "-0" : result;
}
$59f8e70094574c50$exports = $59f8e70094574c50$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $6e12ceb78c99c52b$var$toString(value) {
    return value == null ? "" : $59f8e70094574c50$exports(value);
}
$6e12ceb78c99c52b$exports = $6e12ceb78c99c52b$var$toString;


/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $ba9d5fee693a6835$var$createCaseFirst(methodName) {
    return function(string) {
        string = $6e12ceb78c99c52b$exports(string);
        var strSymbols = $2c09954cfd417fd6$exports(string) ? $0302740a7c28d04b$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ff6768590c7dcbab$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$ba9d5fee693a6835$exports = $ba9d5fee693a6835$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $b2438c361198a09a$var$upperFirst = $ba9d5fee693a6835$exports("toUpperCase");
$b2438c361198a09a$exports = $b2438c361198a09a$var$upperFirst;




var $jYj5L = parcelRequire("jYj5L");

var $cQmXV = parcelRequire("cQmXV");

function $d0c9e9f30a5b8447$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d0c9e9f30a5b8447$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d0c9e9f30a5b8447$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $d0c9e9f30a5b8447$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $d0c9e9f30a5b8447$export$190f430946f96110 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $d0c9e9f30a5b8447$var$PolyElementKeys = [
    "points",
    "pathLength"
];
var $d0c9e9f30a5b8447$export$2b22758266a6fa48 = {
    svg: $d0c9e9f30a5b8447$var$SVGContainerPropKeys,
    polygon: $d0c9e9f30a5b8447$var$PolyElementKeys,
    polyline: $d0c9e9f30a5b8447$var$PolyElementKeys
};
var $d0c9e9f30a5b8447$export$f30789245f2c4d11 = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var $d0c9e9f30a5b8447$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cefe2712cc3cf6f1$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($d0c9e9f30a5b8447$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $d0c9e9f30a5b8447$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $d0c9e9f30a5b8447$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cefe2712cc3cf6f1$exports)))(props) || $d0c9e9f30a5b8447$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($d0c9e9f30a5b8447$export$f30789245f2c4d11.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $d0c9e9f30a5b8447$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $68f87bdfec72f252$exports = {};
var $303b1dbd84811040$exports = {};
var $e4c699823161c838$exports = {};

var $7052b034f39e12f7$exports = {};


/** Used to match property names within property paths. */ var $7052b034f39e12f7$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $7052b034f39e12f7$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $7052b034f39e12f7$var$isKey(value, object) {
    if ($d3cd128394c0afcd$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $43b47a6ca78760ab$exports(value)) return true;
    return $7052b034f39e12f7$var$reIsPlainProp.test(value) || !$7052b034f39e12f7$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$7052b034f39e12f7$exports = $7052b034f39e12f7$var$isKey;


var $ccd4a05c97eaa29b$exports = {};
var $5bab2468cdaf165e$exports = {};
var $ef662daaa8c650bd$exports = {};

/** Error message constants. */ var $ef662daaa8c650bd$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $ef662daaa8c650bd$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($ef662daaa8c650bd$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($ef662daaa8c650bd$var$memoize.Cache || $3e78c518278be37b$exports);
    return memoized;
}
// Expose `MapCache`.
$ef662daaa8c650bd$var$memoize.Cache = $3e78c518278be37b$exports;
$ef662daaa8c650bd$exports = $ef662daaa8c650bd$var$memoize;


/** Used as the maximum memoize cache size. */ var $5bab2468cdaf165e$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $5bab2468cdaf165e$var$memoizeCapped(func) {
    var result = $ef662daaa8c650bd$exports(func, function(key) {
        if (cache.size === $5bab2468cdaf165e$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$5bab2468cdaf165e$exports = $5bab2468cdaf165e$var$memoizeCapped;


/** Used to match property names within property paths. */ var $ccd4a05c97eaa29b$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $ccd4a05c97eaa29b$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $ccd4a05c97eaa29b$var$stringToPath = $5bab2468cdaf165e$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($ccd4a05c97eaa29b$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($ccd4a05c97eaa29b$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$ccd4a05c97eaa29b$exports = $ccd4a05c97eaa29b$var$stringToPath;



/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $e4c699823161c838$var$castPath(value, object) {
    if ($d3cd128394c0afcd$exports(value)) return value;
    return $7052b034f39e12f7$exports(value, object) ? [
        value
    ] : $ccd4a05c97eaa29b$exports($6e12ceb78c99c52b$exports(value));
}
$e4c699823161c838$exports = $e4c699823161c838$var$castPath;


var $e3b33b4b88700394$exports = {};

/** Used as references for various `Number` constants. */ var $e3b33b4b88700394$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e3b33b4b88700394$var$toKey(value) {
    if (typeof value == "string" || $43b47a6ca78760ab$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$e3b33b4b88700394$var$INFINITY ? "-0" : result;
}
$e3b33b4b88700394$exports = $e3b33b4b88700394$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $303b1dbd84811040$var$baseGet(object, path) {
    path = $e4c699823161c838$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$e3b33b4b88700394$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$303b1dbd84811040$exports = $303b1dbd84811040$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $68f87bdfec72f252$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $303b1dbd84811040$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$68f87bdfec72f252$exports = $68f87bdfec72f252$var$get;



var $09baa17b9dbfd114$exports = {};



/** `Object#toString` result references. */ var $09baa17b9dbfd114$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $09baa17b9dbfd114$var$isString(value) {
    return typeof value == "string" || !$d3cd128394c0afcd$exports(value) && $23d15efa9df98feb$exports(value) && $d92048f5b28963ed$exports(value) == $09baa17b9dbfd114$var$stringTag;
}
$09baa17b9dbfd114$exports = $09baa17b9dbfd114$var$isString;





var $cQmXV = parcelRequire("cQmXV");
var $3b8d6660eddd7cf7$exports = {};
"use strict";

$3b8d6660eddd7cf7$exports = (parcelRequire("1Ixht"));







var $79dc871ee192b9d5$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $79dc871ee192b9d5$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($09baa17b9dbfd114$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $79dc871ee192b9d5$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($31cdf12d0101ea0f$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($c17678deab4d3b44$exports)))(value);
};
var $79dc871ee192b9d5$export$b931b78cbb3caf86 = function isNullish(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(value);
};
var $79dc871ee192b9d5$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $79dc871ee192b9d5$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($09baa17b9dbfd114$exports)))(value);
};
var $79dc871ee192b9d5$var$idCounter = 0;
var $79dc871ee192b9d5$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$79dc871ee192b9d5$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $79dc871ee192b9d5$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$79dc871ee192b9d5$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($09baa17b9dbfd114$exports)))(percent)) return defaultValue;
    var value;
    if ($79dc871ee192b9d5$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($c17678deab4d3b44$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $79dc871ee192b9d5$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $79dc871ee192b9d5$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $79dc871ee192b9d5$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($79dc871ee192b9d5$export$7e4aa119212bc614(numberA) && $79dc871ee192b9d5$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $79dc871ee192b9d5$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $79dc871ee192b9d5$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $79dc871ee192b9d5$export$6ab1df3197f7c641 = function compareValues(a, b) {
    if ($79dc871ee192b9d5$export$7e4aa119212bc614(a) && $79dc871ee192b9d5$export$7e4aa119212bc614(b)) return a - b;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($09baa17b9dbfd114$exports)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($09baa17b9dbfd114$exports)))(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};


function $221ea5494c34ef3a$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $965140f0fb236676$var$_excluded = [
    "children"
], $965140f0fb236676$var$_excluded2 = [
    "children"
];
function $965140f0fb236676$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $965140f0fb236676$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $965140f0fb236676$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $965140f0fb236676$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $965140f0fb236676$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $965140f0fb236676$var$_typeof(o);
}
var $965140f0fb236676$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart",
    contextmenu: "onContextMenu",
    dblclick: "onDoubleClick"
};
var $965140f0fb236676$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $965140f0fb236676$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $965140f0fb236676$export$59a4d7d024cf1025 = [
    "none"
];
var $965140f0fb236676$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $965140f0fb236676$var$lastChildren = null;
var $965140f0fb236676$var$lastResult = null;
var $965140f0fb236676$export$45b10814cc054894 = function toArray(children) {
    if (children === $965140f0fb236676$var$lastChildren && Array.isArray($965140f0fb236676$var$lastResult)) return $965140f0fb236676$var$lastResult;
    var result = [];
    (0, $cQmXV.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(child)) return;
        if ((0, $3b8d6660eddd7cf7$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $965140f0fb236676$var$lastResult = result;
    $965140f0fb236676$var$lastChildren = children;
    return result;
};
function $965140f0fb236676$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $965140f0fb236676$export$be63e0664592e141(t);
    });
    else types = [
        $965140f0fb236676$export$be63e0664592e141(type)
    ];
    $965140f0fb236676$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $965140f0fb236676$export$64c61536a2b72e0f(children, type) {
    var result = $965140f0fb236676$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $965140f0fb236676$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $965140f0fb236676$export$be63e0664592e141(t);
    });
    else types = [
        $965140f0fb236676$export$be63e0664592e141(type)
    ];
    $965140f0fb236676$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $965140f0fb236676$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $965140f0fb236676$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $965140f0fb236676$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($09baa17b9dbfd114$exports)))(child.type) && $965140f0fb236676$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $965140f0fb236676$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $965140f0fb236676$var$_typeof(dot) === "object" && "clipDot" in dot;
};
var $965140f0fb236676$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $d0c9e9f30a5b8447$export$2b22758266a6fa48) === null || (0, $d0c9e9f30a5b8447$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $d0c9e9f30a5b8447$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith("data-") || !(0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $d0c9e9f30a5b8447$export$190f430946f96110).includes(key)) || includeEvents && (0, $d0c9e9f30a5b8447$export$f30789245f2c4d11).includes(key);
};
var $965140f0fb236676$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $965140f0fb236676$export$45b10814cc054894(children).forEach(function(entry) {
        if ($965140f0fb236676$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $965140f0fb236676$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cefe2712cc3cf6f1$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($965140f0fb236676$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $965140f0fb236676$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $cQmXV.Children).count(nextChildren);
    if (count !== (0, $cQmXV.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $965140f0fb236676$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$965140f0fb236676$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $965140f0fb236676$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $965140f0fb236676$var$_objectWithoutProperties(_ref, $965140f0fb236676$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $965140f0fb236676$var$_objectWithoutProperties(_ref2, $965140f0fb236676$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $221ea5494c34ef3a$export$d36bdfa510afb180)(nextProps, prevProps) && $965140f0fb236676$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $221ea5494c34ef3a$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $965140f0fb236676$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $965140f0fb236676$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($965140f0fb236676$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $965140f0fb236676$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $965140f0fb236676$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $965140f0fb236676$var$REACT_BROWSER_EVENT_MAP[type]) return $965140f0fb236676$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $965140f0fb236676$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $965140f0fb236676$export$45b10814cc054894(children).indexOf(child);
};



function $dadf1ea33698de40$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dadf1ea33698de40$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dadf1ea33698de40$var$_typeof(o);
}
function $dadf1ea33698de40$var$_extends() {
    $dadf1ea33698de40$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dadf1ea33698de40$var$_extends.apply(this, arguments);
}
function $dadf1ea33698de40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dadf1ea33698de40$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dadf1ea33698de40$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dadf1ea33698de40$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dadf1ea33698de40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dadf1ea33698de40$var$_defineProperty(obj, key, value) {
    key = $dadf1ea33698de40$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dadf1ea33698de40$var$_toPropertyKey(t) {
    var i = $dadf1ea33698de40$var$_toPrimitive(t, "string");
    return "symbol" == $dadf1ea33698de40$var$_typeof(i) ? i : i + "";
}
function $dadf1ea33698de40$var$_toPrimitive(t, r) {
    if ("object" != $dadf1ea33698de40$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dadf1ea33698de40$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dadf1ea33698de40$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $488ac17ac3f42c02$exports.curveBasisClosed),
    curveBasisOpen: (0, $488ac17ac3f42c02$exports.curveBasisOpen),
    curveBasis: (0, $488ac17ac3f42c02$exports.curveBasis),
    curveBumpX: (0, $488ac17ac3f42c02$exports.curveBumpX),
    curveBumpY: (0, $488ac17ac3f42c02$exports.curveBumpY),
    curveLinearClosed: (0, $488ac17ac3f42c02$exports.curveLinearClosed),
    curveLinear: (0, $488ac17ac3f42c02$exports.curveLinear),
    curveMonotoneX: (0, $488ac17ac3f42c02$exports.curveMonotoneX),
    curveMonotoneY: (0, $488ac17ac3f42c02$exports.curveMonotoneY),
    curveNatural: (0, $488ac17ac3f42c02$exports.curveNatural),
    curveStep: (0, $488ac17ac3f42c02$exports.curveStep),
    curveStepAfter: (0, $488ac17ac3f42c02$exports.curveStepAfter),
    curveStepBefore: (0, $488ac17ac3f42c02$exports.curveStepBefore)
};
var $dadf1ea33698de40$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $dadf1ea33698de40$var$getX = function getX(p) {
    return p.x;
};
var $dadf1ea33698de40$var$getY = function getY(p) {
    return p.y;
};
var $dadf1ea33698de40$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($b2438c361198a09a$exports)))(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return $dadf1ea33698de40$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $dadf1ea33698de40$var$CURVE_FACTORIES[name] || (0, $488ac17ac3f42c02$exports.curveLinear);
};
var $dadf1ea33698de40$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $dadf1ea33698de40$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $dadf1ea33698de40$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $dadf1ea33698de40$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $dadf1ea33698de40$var$_objectSpread($dadf1ea33698de40$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, $488ac17ac3f42c02$exports.area)().y($dadf1ea33698de40$var$getY).x1($dadf1ea33698de40$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $488ac17ac3f42c02$exports.area)().x($dadf1ea33698de40$var$getX).y1($dadf1ea33698de40$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($dadf1ea33698de40$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $488ac17ac3f42c02$exports.area)().y($dadf1ea33698de40$var$getY).x1($dadf1ea33698de40$var$getX).x0(baseLine);
    else if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $488ac17ac3f42c02$exports.area)().x($dadf1ea33698de40$var$getX).y1($dadf1ea33698de40$var$getY).y0(baseLine);
    else lineFunction = (0, $488ac17ac3f42c02$exports.line)().x($dadf1ea33698de40$var$getX).y($dadf1ea33698de40$var$getY);
    lineFunction.defined($dadf1ea33698de40$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $dadf1ea33698de40$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $dadf1ea33698de40$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ $cQmXV.createElement("path", $dadf1ea33698de40$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(props, false), (0, $d0c9e9f30a5b8447$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $jYj5L.default)("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};



var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");


function $79400970f1e9c5ee$var$_extends() {
    $79400970f1e9c5ee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $79400970f1e9c5ee$var$_extends.apply(this, arguments);
}
var $79400970f1e9c5ee$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $jYj5L.default)("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ $cQmXV.createElement("circle", $79400970f1e9c5ee$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(props, false), (0, $d0c9e9f30a5b8447$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};



var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");

var $889cf7caffaee974$var$_excluded = [
    "children",
    "className"
];
function $889cf7caffaee974$var$_extends() {
    $889cf7caffaee974$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $889cf7caffaee974$var$_extends.apply(this, arguments);
}
function $889cf7caffaee974$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $889cf7caffaee974$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $889cf7caffaee974$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $889cf7caffaee974$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $889cf7caffaee974$var$_objectWithoutProperties(props, $889cf7caffaee974$var$_excluded);
    var layerClass = (0, $jYj5L.default)("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", $889cf7caffaee974$var$_extends({
        className: layerClass
    }, (0, $965140f0fb236676$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $cQmXV = parcelRequire("cQmXV");



var $c44dc7e5546d4c8d$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c44dc7e5546d4c8d$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$c44dc7e5546d4c8d$exports = $c44dc7e5546d4c8d$var$last;



var $cQmXV = parcelRequire("cQmXV");




var $jYj5L = parcelRequire("jYj5L");

var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $783cbc8e17e1e389$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $783cbc8e17e1e389$export$98f03c5d19621d70 = {
    isSsr: $783cbc8e17e1e389$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $783cbc8e17e1e389$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $783cbc8e17e1e389$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $783cbc8e17e1e389$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $fd8f41d0bb15fb8e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fd8f41d0bb15fb8e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fd8f41d0bb15fb8e$var$_typeof(o);
}
function $fd8f41d0bb15fb8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd8f41d0bb15fb8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd8f41d0bb15fb8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fd8f41d0bb15fb8e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd8f41d0bb15fb8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fd8f41d0bb15fb8e$var$_defineProperty(obj, key, value) {
    key = $fd8f41d0bb15fb8e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fd8f41d0bb15fb8e$var$_toPropertyKey(t) {
    var i = $fd8f41d0bb15fb8e$var$_toPrimitive(t, "string");
    return "symbol" == $fd8f41d0bb15fb8e$var$_typeof(i) ? i : i + "";
}
function $fd8f41d0bb15fb8e$var$_toPrimitive(t, r) {
    if ("object" != $fd8f41d0bb15fb8e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fd8f41d0bb15fb8e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fd8f41d0bb15fb8e$var$_toConsumableArray(arr) {
    return $fd8f41d0bb15fb8e$var$_arrayWithoutHoles(arr) || $fd8f41d0bb15fb8e$var$_iterableToArray(arr) || $fd8f41d0bb15fb8e$var$_unsupportedIterableToArray(arr) || $fd8f41d0bb15fb8e$var$_nonIterableSpread();
}
function $fd8f41d0bb15fb8e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fd8f41d0bb15fb8e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fd8f41d0bb15fb8e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fd8f41d0bb15fb8e$var$_arrayLikeToArray(o, minLen);
}
function $fd8f41d0bb15fb8e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $fd8f41d0bb15fb8e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $fd8f41d0bb15fb8e$var$_arrayLikeToArray(arr);
}
function $fd8f41d0bb15fb8e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $fd8f41d0bb15fb8e$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $fd8f41d0bb15fb8e$var$MAX_CACHE_NUM = 2000;
var $fd8f41d0bb15fb8e$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $fd8f41d0bb15fb8e$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $fd8f41d0bb15fb8e$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $fd8f41d0bb15fb8e$var$autoCompleteStyle(name, value) {
    if ($fd8f41d0bb15fb8e$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $fd8f41d0bb15fb8e$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($fd8f41d0bb15fb8e$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($fd8f41d0bb15fb8e$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $fd8f41d0bb15fb8e$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($fd8f41d0bb15fb8e$var$camelToMiddleLine(s), ":").concat($fd8f41d0bb15fb8e$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
function $fd8f41d0bb15fb8e$var$removeInvalidKeys(obj) {
    var copyObj = $fd8f41d0bb15fb8e$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $fd8f41d0bb15fb8e$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $783cbc8e17e1e389$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $fd8f41d0bb15fb8e$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($fd8f41d0bb15fb8e$var$stringCache.widthCache[cacheKey]) return $fd8f41d0bb15fb8e$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($fd8f41d0bb15fb8e$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $fd8f41d0bb15fb8e$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $fd8f41d0bb15fb8e$var$_objectSpread($fd8f41d0bb15fb8e$var$_objectSpread({}, $fd8f41d0bb15fb8e$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $fd8f41d0bb15fb8e$var$stringCache.widthCache[cacheKey] = result;
        if (++$fd8f41d0bb15fb8e$var$stringCache.cacheCount > $fd8f41d0bb15fb8e$var$MAX_CACHE_NUM) {
            $fd8f41d0bb15fb8e$var$stringCache.cacheCount = 0;
            $fd8f41d0bb15fb8e$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $fd8f41d0bb15fb8e$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $5169db7ce52e1780$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5169db7ce52e1780$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5169db7ce52e1780$var$_typeof(o);
}
function $5169db7ce52e1780$var$_slicedToArray(arr, i) {
    return $5169db7ce52e1780$var$_arrayWithHoles(arr) || $5169db7ce52e1780$var$_iterableToArrayLimit(arr, i) || $5169db7ce52e1780$var$_unsupportedIterableToArray(arr, i) || $5169db7ce52e1780$var$_nonIterableRest();
}
function $5169db7ce52e1780$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5169db7ce52e1780$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5169db7ce52e1780$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5169db7ce52e1780$var$_arrayLikeToArray(o, minLen);
}
function $5169db7ce52e1780$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5169db7ce52e1780$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5169db7ce52e1780$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5169db7ce52e1780$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5169db7ce52e1780$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5169db7ce52e1780$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5169db7ce52e1780$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5169db7ce52e1780$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5169db7ce52e1780$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5169db7ce52e1780$var$_toPropertyKey(t) {
    var i = $5169db7ce52e1780$var$_toPrimitive(t, "string");
    return "symbol" == $5169db7ce52e1780$var$_typeof(i) ? i : i + "";
}
function $5169db7ce52e1780$var$_toPrimitive(t, r) {
    if ("object" != $5169db7ce52e1780$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5169db7ce52e1780$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5169db7ce52e1780$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $5169db7ce52e1780$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $5169db7ce52e1780$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $5169db7ce52e1780$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $5169db7ce52e1780$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $5169db7ce52e1780$var$FIXED_CSS_LENGTH_UNITS = Object.keys($5169db7ce52e1780$var$CONVERSION_RATES);
var $5169db7ce52e1780$var$STR_NAN = "NaN";
function $5169db7ce52e1780$var$convertToPx(value, unit) {
    return value * $5169db7ce52e1780$var$CONVERSION_RATES[unit];
}
var $5169db7ce52e1780$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $5169db7ce52e1780$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = "";
        if (unit !== "" && !$5169db7ce52e1780$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = "";
        }
        if ($5169db7ce52e1780$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $5169db7ce52e1780$var$convertToPx(num, unit);
            this.unit = "px";
        }
    }
    return $5169db7ce52e1780$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $5169db7ce52e1780$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $5169db7ce52e1780$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : "");
            }
        }
    ]);
}();
function $5169db7ce52e1780$var$calculateArithmetic(expr) {
    if (expr.includes($5169db7ce52e1780$var$STR_NAN)) return $5169db7ce52e1780$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes("*") || newExpr.includes("/")){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $5169db7ce52e1780$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $5169db7ce52e1780$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $5169db7ce52e1780$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
        var rTs = $5169db7ce52e1780$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
        var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $5169db7ce52e1780$var$STR_NAN;
        newExpr = newExpr.replace($5169db7ce52e1780$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $5169db7ce52e1780$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $5169db7ce52e1780$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $5169db7ce52e1780$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
        var _rTs = $5169db7ce52e1780$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
        var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $5169db7ce52e1780$var$STR_NAN;
        newExpr = newExpr.replace($5169db7ce52e1780$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $5169db7ce52e1780$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $5169db7ce52e1780$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes("(")){
        var _PARENTHESES_REGEX$ex = $5169db7ce52e1780$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $5169db7ce52e1780$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($5169db7ce52e1780$var$PARENTHESES_REGEX, $5169db7ce52e1780$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $5169db7ce52e1780$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, "");
    newExpr = $5169db7ce52e1780$var$calculateParentheses(newExpr);
    newExpr = $5169db7ce52e1780$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $5169db7ce52e1780$export$c891f73c9c6d00c9(expression) {
    try {
        return $5169db7ce52e1780$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $5169db7ce52e1780$var$STR_NAN;
    }
}
function $5169db7ce52e1780$export$254eac204f89fd7d(expression) {
    var result = $5169db7ce52e1780$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $5169db7ce52e1780$var$STR_NAN) // notify the user
    return "";
    return result;
}


var $a9394abe12cd4740$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $a9394abe12cd4740$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $a9394abe12cd4740$var$_extends() {
    $a9394abe12cd4740$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9394abe12cd4740$var$_extends.apply(this, arguments);
}
function $a9394abe12cd4740$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a9394abe12cd4740$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a9394abe12cd4740$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a9394abe12cd4740$var$_slicedToArray(arr, i) {
    return $a9394abe12cd4740$var$_arrayWithHoles(arr) || $a9394abe12cd4740$var$_iterableToArrayLimit(arr, i) || $a9394abe12cd4740$var$_unsupportedIterableToArray(arr, i) || $a9394abe12cd4740$var$_nonIterableRest();
}
function $a9394abe12cd4740$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a9394abe12cd4740$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a9394abe12cd4740$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a9394abe12cd4740$var$_arrayLikeToArray(o, minLen);
}
function $a9394abe12cd4740$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a9394abe12cd4740$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a9394abe12cd4740$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a9394abe12cd4740$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $a9394abe12cd4740$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split($a9394abe12cd4740$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $fd8f41d0bb15fb8e$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $fd8f41d0bb15fb8e$export$e5560531f057ad5d)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $a9394abe12cd4740$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $a9394abe12cd4740$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $a9394abe12cd4740$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $a9394abe12cd4740$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $a9394abe12cd4740$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(children) ? children.toString().split($a9394abe12cd4740$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $a9394abe12cd4740$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $783cbc8e17e1e389$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $a9394abe12cd4740$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $a9394abe12cd4740$var$getWordsWithoutCalculate(children);
        return $a9394abe12cd4740$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $a9394abe12cd4740$var$getWordsWithoutCalculate(children);
};
var $a9394abe12cd4740$var$DEFAULT_FILL = "#808080";
var $a9394abe12cd4740$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $a9394abe12cd4740$var$DEFAULT_FILL : _ref5$fill, props = $a9394abe12cd4740$var$_objectWithoutProperties(_ref5, $a9394abe12cd4740$var$_excluded);
    var wordsByLines = (0, $cQmXV.useMemo)(function() {
        return $a9394abe12cd4740$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $a9394abe12cd4740$var$_objectWithoutProperties(props, $a9394abe12cd4740$var$_excluded2);
    if (!(0, $79dc871ee192b9d5$export$402a499e1ea44294)(propsX) || !(0, $79dc871ee192b9d5$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, $5169db7ce52e1780$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, $5169db7ce52e1780$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $5169db7ce52e1780$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("text", $a9394abe12cd4740$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $jYj5L.default)("recharts-text", className),
        textAnchor: textAnchor,
        fill: fill.includes("url") ? $a9394abe12cd4740$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? "" : " ");
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $cQmXV = parcelRequire("cQmXV");


var $a70289b49733dd80$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$a70289b49733dd80$exports = (parcelRequire("f4CML"));




var $e1472da5b8436167$exports = {};

var $f83eddc391e64e90$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $f83eddc391e64e90$var$baseLt(value, other) {
    return value < other;
}
$f83eddc391e64e90$exports = $f83eddc391e64e90$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $e1472da5b8436167$var$min(array) {
    return array && array.length ? $aba5d093737cc29c$exports(array, $6d89377597b01df5$exports, $f83eddc391e64e90$exports) : undefined;
}
$e1472da5b8436167$exports = $e1472da5b8436167$var$min;






var $5c3d6654a3dae2e6$exports = {};
var $6a292bbe9e6d2ca2$exports = {};

var $54f53b51e6db03fd$exports = {};



/** Built-in value references. */ var $54f53b51e6db03fd$var$spreadableSymbol = $8c247c0dab27c1b0$exports ? $8c247c0dab27c1b0$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $54f53b51e6db03fd$var$isFlattenable(value) {
    return $d3cd128394c0afcd$exports(value) || $60d32cc4b8713ffd$exports(value) || !!($54f53b51e6db03fd$var$spreadableSymbol && value && value[$54f53b51e6db03fd$var$spreadableSymbol]);
}
$54f53b51e6db03fd$exports = $54f53b51e6db03fd$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $6a292bbe9e6d2ca2$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $54f53b51e6db03fd$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $6a292bbe9e6d2ca2$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $320ddc1cfd7259e7$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$6a292bbe9e6d2ca2$exports = $6a292bbe9e6d2ca2$var$baseFlatten;


var $7f9fb3d3579d18f5$exports = {};

var $4f634fb3ab11bd8f$exports = {};
var $950ce0e187d8b7ee$exports = {};
var $24269c510f08bed2$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $24269c510f08bed2$var$COMPARE_PARTIAL_FLAG = 1, $24269c510f08bed2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $24269c510f08bed2$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $8f85326b0834f020$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $8efa82404d6ff061$exports(srcValue, objValue, $24269c510f08bed2$var$COMPARE_PARTIAL_FLAG | $24269c510f08bed2$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$24269c510f08bed2$exports = $24269c510f08bed2$var$baseIsMatch;


var $b143acf945f8fb17$exports = {};
var $aef1eb37ab76a981$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $aef1eb37ab76a981$var$isStrictComparable(value) {
    return value === value && !$cefe2712cc3cf6f1$exports(value);
}
$aef1eb37ab76a981$exports = $aef1eb37ab76a981$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $b143acf945f8fb17$var$getMatchData(object) {
    var result = $767b9cae0f938981$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $aef1eb37ab76a981$exports(value)
        ];
    }
    return result;
}
$b143acf945f8fb17$exports = $b143acf945f8fb17$var$getMatchData;


var $7ae92443af79c20d$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7ae92443af79c20d$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$7ae92443af79c20d$exports = $7ae92443af79c20d$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $950ce0e187d8b7ee$var$baseMatches(source) {
    var matchData = $b143acf945f8fb17$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $7ae92443af79c20d$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $24269c510f08bed2$exports(object, source, matchData);
    };
}
$950ce0e187d8b7ee$exports = $950ce0e187d8b7ee$var$baseMatches;


var $9fedd7f462281517$exports = {};


var $bb9198bf5a0f014d$exports = {};
var $71fdfa1e13eae2e2$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $71fdfa1e13eae2e2$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$71fdfa1e13eae2e2$exports = $71fdfa1e13eae2e2$var$baseHasIn;


var $e4c3172c6b04fbee$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $e4c3172c6b04fbee$var$hasPath(object, path, hasFunc) {
    path = $e4c699823161c838$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $e3b33b4b88700394$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $d63e5a50f9d1c4cd$exports(length) && $b3ca8c4c277ecf4b$exports(key, length) && ($d3cd128394c0afcd$exports(object) || $60d32cc4b8713ffd$exports(object));
}
$e4c3172c6b04fbee$exports = $e4c3172c6b04fbee$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $bb9198bf5a0f014d$var$hasIn(object, path) {
    return object != null && $e4c3172c6b04fbee$exports(object, path, $71fdfa1e13eae2e2$exports);
}
$bb9198bf5a0f014d$exports = $bb9198bf5a0f014d$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $9fedd7f462281517$var$COMPARE_PARTIAL_FLAG = 1, $9fedd7f462281517$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9fedd7f462281517$var$baseMatchesProperty(path, srcValue) {
    if ($7052b034f39e12f7$exports(path) && $aef1eb37ab76a981$exports(srcValue)) return $7ae92443af79c20d$exports($e3b33b4b88700394$exports(path), srcValue);
    return function(object) {
        var objValue = $68f87bdfec72f252$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $bb9198bf5a0f014d$exports(object, path) : $8efa82404d6ff061$exports(srcValue, objValue, $9fedd7f462281517$var$COMPARE_PARTIAL_FLAG | $9fedd7f462281517$var$COMPARE_UNORDERED_FLAG);
    };
}
$9fedd7f462281517$exports = $9fedd7f462281517$var$baseMatchesProperty;




var $9bc6aea23c976198$exports = {};
var $e4cf0886e2eabd91$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e4cf0886e2eabd91$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$e4cf0886e2eabd91$exports = $e4cf0886e2eabd91$var$baseProperty;


var $0fd2f1190f9e7f6e$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $0fd2f1190f9e7f6e$var$basePropertyDeep(path) {
    return function(object) {
        return $303b1dbd84811040$exports(object, path);
    };
}
$0fd2f1190f9e7f6e$exports = $0fd2f1190f9e7f6e$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $9bc6aea23c976198$var$property(path) {
    return $7052b034f39e12f7$exports(path) ? $e4cf0886e2eabd91$exports($e3b33b4b88700394$exports(path)) : $0fd2f1190f9e7f6e$exports(path);
}
$9bc6aea23c976198$exports = $9bc6aea23c976198$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $4f634fb3ab11bd8f$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $6d89377597b01df5$exports;
    if (typeof value == "object") return $d3cd128394c0afcd$exports(value) ? $9fedd7f462281517$exports(value[0], value[1]) : $950ce0e187d8b7ee$exports(value);
    return $9bc6aea23c976198$exports(value);
}
$4f634fb3ab11bd8f$exports = $4f634fb3ab11bd8f$var$baseIteratee;


var $c097bc7fb6458b5c$exports = {};
var $600291cb91f5bc7d$exports = {};
var $6fe420c571a6ae1a$exports = {};
var $f4a4ea6b64fefa66$exports = {};
var $2f0fce963392ad57$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $2f0fce963392ad57$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$2f0fce963392ad57$exports = $2f0fce963392ad57$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $f4a4ea6b64fefa66$var$baseFor = $2f0fce963392ad57$exports();
$f4a4ea6b64fefa66$exports = $f4a4ea6b64fefa66$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $6fe420c571a6ae1a$var$baseForOwn(object, iteratee) {
    return object && $f4a4ea6b64fefa66$exports(object, iteratee, $767b9cae0f938981$exports);
}
$6fe420c571a6ae1a$exports = $6fe420c571a6ae1a$var$baseForOwn;


var $f7470941cf84cfdd$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f7470941cf84cfdd$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$762eed9717dbe83d$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f7470941cf84cfdd$exports = $f7470941cf84cfdd$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $600291cb91f5bc7d$var$baseEach = $f7470941cf84cfdd$exports($6fe420c571a6ae1a$exports);
$600291cb91f5bc7d$exports = $600291cb91f5bc7d$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $c097bc7fb6458b5c$var$baseMap(collection, iteratee) {
    var index = -1, result = $762eed9717dbe83d$exports(collection) ? Array(collection.length) : [];
    $600291cb91f5bc7d$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$c097bc7fb6458b5c$exports = $c097bc7fb6458b5c$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $7f9fb3d3579d18f5$var$map(collection, iteratee) {
    var func = $d3cd128394c0afcd$exports(collection) ? $764a4fa73651e760$exports : $c097bc7fb6458b5c$exports;
    return func(collection, $4f634fb3ab11bd8f$exports(iteratee, 3));
}
$7f9fb3d3579d18f5$exports = $7f9fb3d3579d18f5$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $5c3d6654a3dae2e6$var$flatMap(collection, iteratee) {
    return $6a292bbe9e6d2ca2$exports($7f9fb3d3579d18f5$exports(collection, iteratee), 1);
}
$5c3d6654a3dae2e6$exports = $5c3d6654a3dae2e6$var$flatMap;





var $61042b531d0b8b0c$exports = {};

var $08c7cce0437a6da6$exports = {};




var $e55ed7e4b8dbff73$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $e55ed7e4b8dbff73$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$e55ed7e4b8dbff73$exports = $e55ed7e4b8dbff73$var$baseSortBy;



var $3704b766a24e2127$exports = {};
var $39c7ce93542e53c2$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $39c7ce93542e53c2$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $43b47a6ca78760ab$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $43b47a6ca78760ab$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$39c7ce93542e53c2$exports = $39c7ce93542e53c2$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $3704b766a24e2127$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $39c7ce93542e53c2$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$3704b766a24e2127$exports = $3704b766a24e2127$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $08c7cce0437a6da6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $764a4fa73651e760$exports(iteratees, function(iteratee) {
        if ($d3cd128394c0afcd$exports(iteratee)) return function(value) {
            return $303b1dbd84811040$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $6d89377597b01df5$exports
    ];
    var index = -1;
    iteratees = $764a4fa73651e760$exports(iteratees, $985fe0e94448a6b2$exports($4f634fb3ab11bd8f$exports));
    var result = $c097bc7fb6458b5c$exports(collection, function(value, key, collection) {
        var criteria = $764a4fa73651e760$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $e55ed7e4b8dbff73$exports(result, function(object, other) {
        return $3704b766a24e2127$exports(object, other, orders);
    });
}
$08c7cce0437a6da6$exports = $08c7cce0437a6da6$var$baseOrderBy;


var $f4a1d6300faacfb1$exports = {};

var $488cc9aab381086c$exports = {};
var $d509af287e466da0$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $d509af287e466da0$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$d509af287e466da0$exports = $d509af287e466da0$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $488cc9aab381086c$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $488cc9aab381086c$var$overRest(func, start, transform) {
    start = $488cc9aab381086c$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $488cc9aab381086c$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $d509af287e466da0$exports(func, this, otherArgs);
    };
}
$488cc9aab381086c$exports = $488cc9aab381086c$var$overRest;


var $4fb04b36c8509d0c$exports = {};
var $04635e984506b37c$exports = {};
var $7f5759c4a5a1ce65$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7f5759c4a5a1ce65$var$constant(value) {
    return function() {
        return value;
    };
}
$7f5759c4a5a1ce65$exports = $7f5759c4a5a1ce65$var$constant;


var $3bc2bdb7db5363fe$exports = {};

var $3bc2bdb7db5363fe$var$defineProperty = function() {
    try {
        var func = $84200a7be5477948$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$3bc2bdb7db5363fe$exports = $3bc2bdb7db5363fe$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $04635e984506b37c$var$baseSetToString = !$3bc2bdb7db5363fe$exports ? $6d89377597b01df5$exports : function(func, string) {
    return $3bc2bdb7db5363fe$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $7f5759c4a5a1ce65$exports(string),
        "writable": true
    });
};
$04635e984506b37c$exports = $04635e984506b37c$var$baseSetToString;


var $325016b03e861056$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $325016b03e861056$var$HOT_COUNT = 800, $325016b03e861056$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $325016b03e861056$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $325016b03e861056$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $325016b03e861056$var$nativeNow(), remaining = $325016b03e861056$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $325016b03e861056$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$325016b03e861056$exports = $325016b03e861056$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4fb04b36c8509d0c$var$setToString = $325016b03e861056$exports($04635e984506b37c$exports);
$4fb04b36c8509d0c$exports = $4fb04b36c8509d0c$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $f4a1d6300faacfb1$var$baseRest(func, start) {
    return $4fb04b36c8509d0c$exports($488cc9aab381086c$exports(func, start, $6d89377597b01df5$exports), func + "");
}
$f4a1d6300faacfb1$exports = $f4a1d6300faacfb1$var$baseRest;


var $2ba98363d8e92e85$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $2ba98363d8e92e85$var$isIterateeCall(value, index, object) {
    if (!$cefe2712cc3cf6f1$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $762eed9717dbe83d$exports(object) && $b3ca8c4c277ecf4b$exports(index, object.length) : type == "string" && index in object) return $74c2ecb2e761e5c6$exports(object[index], value);
    return false;
}
$2ba98363d8e92e85$exports = $2ba98363d8e92e85$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $61042b531d0b8b0c$var$sortBy = $f4a1d6300faacfb1$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $2ba98363d8e92e85$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $2ba98363d8e92e85$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $08c7cce0437a6da6$exports(collection, $6a292bbe9e6d2ca2$exports(iteratees, 1), []);
});
$61042b531d0b8b0c$exports = $61042b531d0b8b0c$var$sortBy;


var $02f83c81dec00897$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $02f83c81dec00897$exports) $02f83c81dec00897$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($02f83c81dec00897$exports);


function $0f82a2d96d5c1b5a$var$_toConsumableArray(arr) {
    return $0f82a2d96d5c1b5a$var$_arrayWithoutHoles(arr) || $0f82a2d96d5c1b5a$var$_iterableToArray(arr) || $0f82a2d96d5c1b5a$var$_unsupportedIterableToArray(arr) || $0f82a2d96d5c1b5a$var$_nonIterableSpread();
}
function $0f82a2d96d5c1b5a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0f82a2d96d5c1b5a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0f82a2d96d5c1b5a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0f82a2d96d5c1b5a$var$_arrayLikeToArray(o, minLen);
}
function $0f82a2d96d5c1b5a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $0f82a2d96d5c1b5a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0f82a2d96d5c1b5a$var$_arrayLikeToArray(arr);
}
function $0f82a2d96d5c1b5a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0f82a2d96d5c1b5a$var$identity = function identity(i) {
    return i;
};
var $0f82a2d96d5c1b5a$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $0f82a2d96d5c1b5a$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $0f82a2d96d5c1b5a$export$ca73b6d700d0505;
};
var $0f82a2d96d5c1b5a$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $0f82a2d96d5c1b5a$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $0f82a2d96d5c1b5a$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $0f82a2d96d5c1b5a$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $0f82a2d96d5c1b5a$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $0f82a2d96d5c1b5a$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $0f82a2d96d5c1b5a$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $0f82a2d96d5c1b5a$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $0f82a2d96d5c1b5a$export$c3095a23b368d1f2 = function curry(fn) {
    return $0f82a2d96d5c1b5a$var$curryN(fn.length, fn);
};
var $0f82a2d96d5c1b5a$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $0f82a2d96d5c1b5a$export$871de8747c9eaa88 = $0f82a2d96d5c1b5a$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $0f82a2d96d5c1b5a$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $0f82a2d96d5c1b5a$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $0f82a2d96d5c1b5a$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $0f82a2d96d5c1b5a$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $fb56c55856133818$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $fb56c55856133818$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $fb56c55856133818$var$interpolateNumber = (0, $0f82a2d96d5c1b5a$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $fb56c55856133818$var$uninterpolateNumber = (0, $0f82a2d96d5c1b5a$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $fb56c55856133818$var$uninterpolateTruncation = (0, $0f82a2d96d5c1b5a$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $fb56c55856133818$export$2e2bcd8739ae039 = {
    rangeStep: $fb56c55856133818$var$rangeStep,
    getDigitCount: $fb56c55856133818$var$getDigitCount,
    interpolateNumber: $fb56c55856133818$var$interpolateNumber,
    uninterpolateNumber: $fb56c55856133818$var$uninterpolateNumber,
    uninterpolateTruncation: $fb56c55856133818$var$uninterpolateTruncation
};


function $9bdaeaa965bed1d3$var$_toConsumableArray(arr) {
    return $9bdaeaa965bed1d3$var$_arrayWithoutHoles(arr) || $9bdaeaa965bed1d3$var$_iterableToArray(arr) || $9bdaeaa965bed1d3$var$_unsupportedIterableToArray(arr) || $9bdaeaa965bed1d3$var$_nonIterableSpread();
}
function $9bdaeaa965bed1d3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9bdaeaa965bed1d3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $9bdaeaa965bed1d3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9bdaeaa965bed1d3$var$_arrayLikeToArray(arr);
}
function $9bdaeaa965bed1d3$var$_slicedToArray(arr, i) {
    return $9bdaeaa965bed1d3$var$_arrayWithHoles(arr) || $9bdaeaa965bed1d3$var$_iterableToArrayLimit(arr, i) || $9bdaeaa965bed1d3$var$_unsupportedIterableToArray(arr, i) || $9bdaeaa965bed1d3$var$_nonIterableRest();
}
function $9bdaeaa965bed1d3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9bdaeaa965bed1d3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9bdaeaa965bed1d3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9bdaeaa965bed1d3$var$_arrayLikeToArray(o, minLen);
}
function $9bdaeaa965bed1d3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9bdaeaa965bed1d3$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9bdaeaa965bed1d3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $9bdaeaa965bed1d3$var$getValidInterval(_ref) {
    var _ref2 = $9bdaeaa965bed1d3$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $9bdaeaa965bed1d3$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(0);
    var digitCount = (0, $fb56c55856133818$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $9bdaeaa965bed1d3$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(10).pow((0, $fb56c55856133818$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $0f82a2d96d5c1b5a$export$f672e0b6f7222cd7)((0, $0f82a2d96d5c1b5a$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $0f82a2d96d5c1b5a$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $9bdaeaa965bed1d3$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $9bdaeaa965bed1d3$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $9bdaeaa965bed1d3$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $9bdaeaa965bed1d3$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $9bdaeaa965bed1d3$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $9bdaeaa965bed1d3$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $9bdaeaa965bed1d3$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($9bdaeaa965bed1d3$var$_toConsumableArray((0, $0f82a2d96d5c1b5a$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($9bdaeaa965bed1d3$var$_toConsumableArray((0, $0f82a2d96d5c1b5a$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $0f82a2d96d5c1b5a$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $9bdaeaa965bed1d3$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $9bdaeaa965bed1d3$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $fb56c55856133818$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $0f82a2d96d5c1b5a$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $9bdaeaa965bed1d3$var$getTickValuesFn(_ref5) {
    var _ref6 = $9bdaeaa965bed1d3$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $9bdaeaa965bed1d3$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $9bdaeaa965bed1d3$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $9bdaeaa965bed1d3$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $9bdaeaa965bed1d3$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $0f82a2d96d5c1b5a$export$f672e0b6f7222cd7)((0, $0f82a2d96d5c1b5a$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(n).mul(step)).toNumber();
    }), (0, $0f82a2d96d5c1b5a$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $0f82a2d96d5c1b5a$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $9bdaeaa965bed1d3$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $9bdaeaa965bed1d3$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $9bdaeaa965bed1d3$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $9bdaeaa965bed1d3$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $9bdaeaa965bed1d3$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($9bdaeaa965bed1d3$var$_toConsumableArray((0, $fb56c55856133818$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($02f83c81dec00897$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $0f82a2d96d5c1b5a$export$66c1ae025e96b4bc)(values) : values;
}
var $9bdaeaa965bed1d3$export$b84e75ccbfe6a612 = (0, $0f82a2d96d5c1b5a$export$fc10aeed3a532e2a)($9bdaeaa965bed1d3$var$getNiceTickValuesFn);
var $9bdaeaa965bed1d3$export$4cc7a216492b1f53 = (0, $0f82a2d96d5c1b5a$export$fc10aeed3a532e2a)($9bdaeaa965bed1d3$var$getTickValuesFn);
var $9bdaeaa965bed1d3$export$e9d28da780436e98 = (0, $0f82a2d96d5c1b5a$export$fc10aeed3a532e2a)($9bdaeaa965bed1d3$var$getTickValuesFixedDomainFn);





var $cQmXV = parcelRequire("cQmXV");



var $892666b59896889a$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $892666b59896889a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $892666b59896889a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $892666b59896889a$var$_typeof(o);
}
function $892666b59896889a$var$_extends() {
    $892666b59896889a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $892666b59896889a$var$_extends.apply(this, arguments);
}
function $892666b59896889a$var$_slicedToArray(arr, i) {
    return $892666b59896889a$var$_arrayWithHoles(arr) || $892666b59896889a$var$_iterableToArrayLimit(arr, i) || $892666b59896889a$var$_unsupportedIterableToArray(arr, i) || $892666b59896889a$var$_nonIterableRest();
}
function $892666b59896889a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $892666b59896889a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $892666b59896889a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $892666b59896889a$var$_arrayLikeToArray(o, minLen);
}
function $892666b59896889a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $892666b59896889a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $892666b59896889a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $892666b59896889a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $892666b59896889a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $892666b59896889a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $892666b59896889a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $892666b59896889a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $892666b59896889a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $892666b59896889a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $892666b59896889a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $892666b59896889a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $892666b59896889a$var$_callSuper(t, o, e) {
    return o = $892666b59896889a$var$_getPrototypeOf(o), $892666b59896889a$var$_possibleConstructorReturn(t, $892666b59896889a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $892666b59896889a$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $892666b59896889a$var$_possibleConstructorReturn(self, call) {
    if (call && ($892666b59896889a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $892666b59896889a$var$_assertThisInitialized(self);
}
function $892666b59896889a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $892666b59896889a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($892666b59896889a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $892666b59896889a$var$_getPrototypeOf(o) {
    $892666b59896889a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $892666b59896889a$var$_getPrototypeOf(o);
}
function $892666b59896889a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $892666b59896889a$var$_setPrototypeOf(subClass, superClass);
}
function $892666b59896889a$var$_setPrototypeOf(o, p) {
    $892666b59896889a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $892666b59896889a$var$_setPrototypeOf(o, p);
}
function $892666b59896889a$var$_defineProperty(obj, key, value) {
    key = $892666b59896889a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $892666b59896889a$var$_toPropertyKey(t) {
    var i = $892666b59896889a$var$_toPrimitive(t, "string");
    return "symbol" == $892666b59896889a$var$_typeof(i) ? i : i + "";
}
function $892666b59896889a$var$_toPrimitive(t, r) {
    if ("object" != $892666b59896889a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $892666b59896889a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $892666b59896889a$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $892666b59896889a$var$_classCallCheck(this, ErrorBar);
        return $892666b59896889a$var$_callSuper(this, ErrorBar, arguments);
    }
    $892666b59896889a$var$_inherits(ErrorBar, _React$Component);
    return $892666b59896889a$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $892666b59896889a$var$_objectWithoutProperties(_this$props, $892666b59896889a$var$_excluded);
                var svgProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === "x" && xAxis.type !== "number") && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $892666b59896889a$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === "vertical") {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === "horizontal") {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), $892666b59896889a$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", $892666b59896889a$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
$892666b59896889a$var$_defineProperty($892666b59896889a$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
});
$892666b59896889a$var$_defineProperty($892666b59896889a$export$4f4d7676bdf949e5, "displayName", "ErrorBar");





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");
/* eslint no-console: 0 */ var $42f81b1da17a28f1$var$isDev = false;
var $42f81b1da17a28f1$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($42f81b1da17a28f1$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");

var $17588da4b0ad5146$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $17588da4b0ad5146$var$_extends() {
    $17588da4b0ad5146$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17588da4b0ad5146$var$_extends.apply(this, arguments);
}
function $17588da4b0ad5146$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $17588da4b0ad5146$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $17588da4b0ad5146$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $17588da4b0ad5146$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $17588da4b0ad5146$var$_objectWithoutProperties(props, $17588da4b0ad5146$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $jYj5L.default)("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("svg", $17588da4b0ad5146$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("desc", null, desc), children);
}



var $cQmXV = parcelRequire("cQmXV");



var $jYj5L = parcelRequire("jYj5L");

function $b71690cdc8027025$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b71690cdc8027025$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b71690cdc8027025$var$_typeof(o);
}
var $b71690cdc8027025$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $b71690cdc8027025$var$_extends() {
    $b71690cdc8027025$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b71690cdc8027025$var$_extends.apply(this, arguments);
}
function $b71690cdc8027025$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b71690cdc8027025$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b71690cdc8027025$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b71690cdc8027025$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b71690cdc8027025$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b71690cdc8027025$var$_defineProperty(obj, key, value) {
    key = $b71690cdc8027025$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b71690cdc8027025$var$_toPropertyKey(t) {
    var i = $b71690cdc8027025$var$_toPrimitive(t, "string");
    return "symbol" == $b71690cdc8027025$var$_typeof(i) ? i : i + "";
}
function $b71690cdc8027025$var$_toPrimitive(t, r) {
    if ("object" != $b71690cdc8027025$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b71690cdc8027025$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b71690cdc8027025$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b71690cdc8027025$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b71690cdc8027025$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b71690cdc8027025$var$symbolFactories = {
    symbolCircle: (0, $488ac17ac3f42c02$exports.symbolCircle),
    symbolCross: (0, $488ac17ac3f42c02$exports.symbolCross),
    symbolDiamond: (0, $488ac17ac3f42c02$exports.symbolDiamond),
    symbolSquare: (0, $488ac17ac3f42c02$exports.symbolSquare),
    symbolStar: (0, $488ac17ac3f42c02$exports.symbolStar),
    symbolTriangle: (0, $488ac17ac3f42c02$exports.symbolTriangle),
    symbolWye: (0, $488ac17ac3f42c02$exports.symbolWye)
};
var $b71690cdc8027025$var$RADIAN = Math.PI / 180;
var $b71690cdc8027025$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($b2438c361198a09a$exports)))(type));
    return $b71690cdc8027025$var$symbolFactories[name] || (0, $488ac17ac3f42c02$exports.symbolCircle);
};
var $b71690cdc8027025$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $b71690cdc8027025$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $b71690cdc8027025$var$registerSymbol = function registerSymbol(key, factory) {
    $b71690cdc8027025$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($b2438c361198a09a$exports)))(key))] = factory;
};
var $b71690cdc8027025$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = $b71690cdc8027025$var$_objectWithoutProperties(_ref, $b71690cdc8027025$var$_excluded);
    var props = $b71690cdc8027025$var$_objectSpread($b71690cdc8027025$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $b71690cdc8027025$var$getSymbolFactory(type);
        var symbol = (0, $488ac17ac3f42c02$exports.symbol)().type(symbolFactory).size($b71690cdc8027025$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", $b71690cdc8027025$var$_extends({}, filteredProps, {
        className: (0, $jYj5L.default)("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$b71690cdc8027025$export$fa456266707bf4e4.registerSymbol = $b71690cdc8027025$var$registerSymbol;



function $1a69bb932cdefa19$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1a69bb932cdefa19$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1a69bb932cdefa19$var$_typeof(o);
}
function $1a69bb932cdefa19$var$_extends() {
    $1a69bb932cdefa19$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a69bb932cdefa19$var$_extends.apply(this, arguments);
}
function $1a69bb932cdefa19$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a69bb932cdefa19$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a69bb932cdefa19$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1a69bb932cdefa19$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a69bb932cdefa19$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a69bb932cdefa19$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1a69bb932cdefa19$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1a69bb932cdefa19$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1a69bb932cdefa19$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1a69bb932cdefa19$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1a69bb932cdefa19$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1a69bb932cdefa19$var$_callSuper(t, o, e) {
    return o = $1a69bb932cdefa19$var$_getPrototypeOf(o), $1a69bb932cdefa19$var$_possibleConstructorReturn(t, $1a69bb932cdefa19$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1a69bb932cdefa19$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1a69bb932cdefa19$var$_possibleConstructorReturn(self, call) {
    if (call && ($1a69bb932cdefa19$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1a69bb932cdefa19$var$_assertThisInitialized(self);
}
function $1a69bb932cdefa19$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1a69bb932cdefa19$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1a69bb932cdefa19$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1a69bb932cdefa19$var$_getPrototypeOf(o) {
    $1a69bb932cdefa19$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1a69bb932cdefa19$var$_getPrototypeOf(o);
}
function $1a69bb932cdefa19$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1a69bb932cdefa19$var$_setPrototypeOf(subClass, superClass);
}
function $1a69bb932cdefa19$var$_setPrototypeOf(o, p) {
    $1a69bb932cdefa19$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1a69bb932cdefa19$var$_setPrototypeOf(o, p);
}
function $1a69bb932cdefa19$var$_defineProperty(obj, key, value) {
    key = $1a69bb932cdefa19$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a69bb932cdefa19$var$_toPropertyKey(t) {
    var i = $1a69bb932cdefa19$var$_toPrimitive(t, "string");
    return "symbol" == $1a69bb932cdefa19$var$_typeof(i) ? i : i + "";
}
function $1a69bb932cdefa19$var$_toPrimitive(t, r) {
    if ("object" != $1a69bb932cdefa19$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1a69bb932cdefa19$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1a69bb932cdefa19$var$SIZE = 32;
var $1a69bb932cdefa19$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $1a69bb932cdefa19$var$_classCallCheck(this, DefaultLegendContent);
        return $1a69bb932cdefa19$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $1a69bb932cdefa19$var$_inherits(DefaultLegendContent, _PureComponent);
    return $1a69bb932cdefa19$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $1a69bb932cdefa19$var$SIZE / 2;
                var sixthSize = $1a69bb932cdefa19$var$SIZE / 6;
                var thirdSize = $1a69bb932cdefa19$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $1a69bb932cdefa19$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($1a69bb932cdefa19$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($1a69bb932cdefa19$var$SIZE / 8, "h").concat($1a69bb932cdefa19$var$SIZE, "v").concat($1a69bb932cdefa19$var$SIZE * 3 / 4, "h").concat(-$1a69bb932cdefa19$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(data.legendIcon)) {
                    var iconProps = $1a69bb932cdefa19$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b71690cdc8027025$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $1a69bb932cdefa19$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $1a69bb932cdefa19$var$SIZE,
                    height: $1a69bb932cdefa19$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $jYj5L.default)($1a69bb932cdefa19$var$_defineProperty($1a69bb932cdefa19$var$_defineProperty({
                        "recharts-legend-item": true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === "none") return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(entry.value) ? entry.value : null;
                    (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(entry.value), 'The name property is also required when using a function for the dataKey of a chart\'s cartesian components. Ex: <Bar name="Name of my Data"/>' // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", $1a69bb932cdefa19$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $d0c9e9f30a5b8447$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $17588da4b0ad5146$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $cQmXV.PureComponent));
$1a69bb932cdefa19$var$_defineProperty($1a69bb932cdefa19$export$99f8d96ed0cededa, "displayName", "Legend");
$1a69bb932cdefa19$var$_defineProperty($1a69bb932cdefa19$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});



var $28ee28fe5fdb1c14$exports = {};

var $ad012fb056ab8f92$exports = {};

var $c393aa02cc1afadb$exports = {};
var $44bcbe5a7dad45c6$exports = {};
var $f598e57fcb0efd87$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f598e57fcb0efd87$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$f598e57fcb0efd87$exports = $f598e57fcb0efd87$var$baseFindIndex;


var $84616c968094985d$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $84616c968094985d$var$baseIsNaN(value) {
    return value !== value;
}
$84616c968094985d$exports = $84616c968094985d$var$baseIsNaN;


var $7ea692ac95818b0d$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7ea692ac95818b0d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$7ea692ac95818b0d$exports = $7ea692ac95818b0d$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $44bcbe5a7dad45c6$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $7ea692ac95818b0d$exports(array, value, fromIndex) : $f598e57fcb0efd87$exports(array, $84616c968094985d$exports, fromIndex);
}
$44bcbe5a7dad45c6$exports = $44bcbe5a7dad45c6$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $c393aa02cc1afadb$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $44bcbe5a7dad45c6$exports(array, value, 0) > -1;
}
$c393aa02cc1afadb$exports = $c393aa02cc1afadb$var$arrayIncludes;


var $2531e53e473cf4d9$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $2531e53e473cf4d9$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$2531e53e473cf4d9$exports = $2531e53e473cf4d9$var$arrayIncludesWith;



var $a580e3fcdca6ea07$exports = {};

var $140bc1ba13a534ac$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $140bc1ba13a534ac$var$noop() {
// No operation performed.
}
$140bc1ba13a534ac$exports = $140bc1ba13a534ac$var$noop;



/** Used as references for various `Number` constants. */ var $a580e3fcdca6ea07$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $a580e3fcdca6ea07$var$createSet = !($d9c8d6cff739d502$exports && 1 / $5974dd07043eebb5$exports(new $d9c8d6cff739d502$exports([
    ,
    -0
]))[1] == $a580e3fcdca6ea07$var$INFINITY) ? $140bc1ba13a534ac$exports : function(values) {
    return new $d9c8d6cff739d502$exports(values);
};
$a580e3fcdca6ea07$exports = $a580e3fcdca6ea07$var$createSet;



/** Used as the size to enable large array optimizations. */ var $ad012fb056ab8f92$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $ad012fb056ab8f92$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $c393aa02cc1afadb$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $2531e53e473cf4d9$exports;
    } else if (length >= $ad012fb056ab8f92$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $a580e3fcdca6ea07$exports(array);
        if (set) return $5974dd07043eebb5$exports(set);
        isCommon = false;
        includes = $41c81debd2b371c7$exports;
        seen = new $3d006af530d60c97$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$ad012fb056ab8f92$exports = $ad012fb056ab8f92$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $28ee28fe5fdb1c14$var$uniqBy(array, iteratee) {
    return array && array.length ? $ad012fb056ab8f92$exports(array, $4f634fb3ab11bd8f$exports(iteratee, 2)) : [];
}
$28ee28fe5fdb1c14$exports = $28ee28fe5fdb1c14$var$uniqBy;



function $b0d467970f1faa83$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($28ee28fe5fdb1c14$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($28ee28fe5fdb1c14$exports)))(payload, option);
    return payload;
}


function $81272ed3f26141a8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $81272ed3f26141a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $81272ed3f26141a8$var$_typeof(o);
}
var $81272ed3f26141a8$var$_excluded = [
    "ref"
];
function $81272ed3f26141a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $81272ed3f26141a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $81272ed3f26141a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $81272ed3f26141a8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $81272ed3f26141a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $81272ed3f26141a8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $81272ed3f26141a8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $81272ed3f26141a8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $81272ed3f26141a8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $81272ed3f26141a8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $81272ed3f26141a8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $81272ed3f26141a8$var$_callSuper(t, o, e) {
    return o = $81272ed3f26141a8$var$_getPrototypeOf(o), $81272ed3f26141a8$var$_possibleConstructorReturn(t, $81272ed3f26141a8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $81272ed3f26141a8$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $81272ed3f26141a8$var$_possibleConstructorReturn(self, call) {
    if (call && ($81272ed3f26141a8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $81272ed3f26141a8$var$_assertThisInitialized(self);
}
function $81272ed3f26141a8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $81272ed3f26141a8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($81272ed3f26141a8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $81272ed3f26141a8$var$_getPrototypeOf(o) {
    $81272ed3f26141a8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81272ed3f26141a8$var$_getPrototypeOf(o);
}
function $81272ed3f26141a8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $81272ed3f26141a8$var$_setPrototypeOf(subClass, superClass);
}
function $81272ed3f26141a8$var$_setPrototypeOf(o, p) {
    $81272ed3f26141a8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $81272ed3f26141a8$var$_setPrototypeOf(o, p);
}
function $81272ed3f26141a8$var$_defineProperty(obj, key, value) {
    key = $81272ed3f26141a8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $81272ed3f26141a8$var$_toPropertyKey(t) {
    var i = $81272ed3f26141a8$var$_toPrimitive(t, "string");
    return "symbol" == $81272ed3f26141a8$var$_typeof(i) ? i : i + "";
}
function $81272ed3f26141a8$var$_toPrimitive(t, r) {
    if ("object" != $81272ed3f26141a8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $81272ed3f26141a8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $81272ed3f26141a8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $81272ed3f26141a8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $81272ed3f26141a8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $81272ed3f26141a8$var$defaultUniqBy(entry) {
    return entry.value;
}
function $81272ed3f26141a8$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(content, props);
    var ref = props.ref, otherProps = $81272ed3f26141a8$var$_objectWithoutProperties(props, $81272ed3f26141a8$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1a69bb932cdefa19$export$99f8d96ed0cededa), otherProps);
}
var $81272ed3f26141a8$var$EPS = 1;
var $81272ed3f26141a8$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $81272ed3f26141a8$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $81272ed3f26141a8$var$_callSuper(this, Legend, [].concat(args));
        $81272ed3f26141a8$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $81272ed3f26141a8$var$_inherits(Legend, _PureComponent);
    return $81272ed3f26141a8$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $81272ed3f26141a8$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $81272ed3f26141a8$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $81272ed3f26141a8$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $81272ed3f26141a8$var$_objectSpread($81272ed3f26141a8$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $81272ed3f26141a8$var$_objectSpread($81272ed3f26141a8$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $81272ed3f26141a8$var$renderContent(content, $81272ed3f26141a8$var$_objectSpread($81272ed3f26141a8$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $b0d467970f1faa83$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $81272ed3f26141a8$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $81272ed3f26141a8$var$_objectSpread($81272ed3f26141a8$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === "vertical" && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $cQmXV.PureComponent));
$81272ed3f26141a8$var$_defineProperty($81272ed3f26141a8$export$ed247974535929c7, "displayName", "Legend");
$81272ed3f26141a8$var$_defineProperty($81272ed3f26141a8$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});




function $170743ee91188a38$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $170743ee91188a38$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $170743ee91188a38$var$_typeof(o);
}
function $170743ee91188a38$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $170743ee91188a38$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $170743ee91188a38$var$ownKeys(Object(t), !0).forEach(function(r) {
            $170743ee91188a38$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $170743ee91188a38$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $170743ee91188a38$var$_defineProperty(obj, key, value) {
    key = $170743ee91188a38$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $170743ee91188a38$var$_toPropertyKey(t) {
    var i = $170743ee91188a38$var$_toPrimitive(t, "string");
    return "symbol" == $170743ee91188a38$var$_typeof(i) ? i : i + "";
}
function $170743ee91188a38$var$_toPrimitive(t, r) {
    if ("object" != $170743ee91188a38$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $170743ee91188a38$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $170743ee91188a38$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $81272ed3f26141a8$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $81272ed3f26141a8$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $170743ee91188a38$var$_objectSpread($170743ee91188a38$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $170743ee91188a38$var$_objectSpread($170743ee91188a38$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || "square",
            color: (0, $f6dbe45301cbc2ff$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $170743ee91188a38$var$_objectSpread($170743ee91188a38$var$_objectSpread($170743ee91188a38$var$_objectSpread({}, legendProps), (0, $81272ed3f26141a8$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $f6dbe45301cbc2ff$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f6dbe45301cbc2ff$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f6dbe45301cbc2ff$var$_typeof(o);
}
function $f6dbe45301cbc2ff$var$_toConsumableArray(arr) {
    return $f6dbe45301cbc2ff$var$_arrayWithoutHoles(arr) || $f6dbe45301cbc2ff$var$_iterableToArray(arr) || $f6dbe45301cbc2ff$var$_unsupportedIterableToArray(arr) || $f6dbe45301cbc2ff$var$_nonIterableSpread();
}
function $f6dbe45301cbc2ff$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f6dbe45301cbc2ff$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f6dbe45301cbc2ff$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f6dbe45301cbc2ff$var$_arrayLikeToArray(o, minLen);
}
function $f6dbe45301cbc2ff$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f6dbe45301cbc2ff$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f6dbe45301cbc2ff$var$_arrayLikeToArray(arr);
}
function $f6dbe45301cbc2ff$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f6dbe45301cbc2ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6dbe45301cbc2ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6dbe45301cbc2ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f6dbe45301cbc2ff$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6dbe45301cbc2ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f6dbe45301cbc2ff$var$_defineProperty(obj, key, value) {
    key = $f6dbe45301cbc2ff$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f6dbe45301cbc2ff$var$_toPropertyKey(t) {
    var i = $f6dbe45301cbc2ff$var$_toPrimitive(t, "string");
    return "symbol" == $f6dbe45301cbc2ff$var$_typeof(i) ? i : i + "";
}
function $f6dbe45301cbc2ff$var$_toPrimitive(t, r) {
    if ("object" != $f6dbe45301cbc2ff$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f6dbe45301cbc2ff$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f6dbe45301cbc2ff$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(dataKey)) return defaultValue;
    if ((0, $79dc871ee192b9d5$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $f6dbe45301cbc2ff$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($5c3d6654a3dae2e6$exports)))(data, function(entry) {
        return $f6dbe45301cbc2ff$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($e1472da5b8436167$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $79dc871ee192b9d5$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $f6dbe45301cbc2ff$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $79dc871ee192b9d5$export$9d334328eb75e624)(cur - before) !== (0, $79dc871ee192b9d5$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $79dc871ee192b9d5$export$9d334328eb75e624)(after - cur) === (0, $79dc871ee192b9d5$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $f6dbe45301cbc2ff$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $f6dbe45301cbc2ff$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $965140f0fb236676$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(barSize) ? undefined : (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $f6dbe45301cbc2ff$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($f6dbe45301cbc2ff$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($f6dbe45301cbc2ff$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $f6dbe45301cbc2ff$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $170743ee91188a38$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(offset[align])) return $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, offset), {}, $f6dbe45301cbc2ff$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(offset[verticalAlign])) return $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, offset), {}, $f6dbe45301cbc2ff$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $f6dbe45301cbc2ff$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $f6dbe45301cbc2ff$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, (0, $892666b59896889a$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $f6dbe45301cbc2ff$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $f6dbe45301cbc2ff$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($e1472da5b8436167$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $f6dbe45301cbc2ff$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $f6dbe45301cbc2ff$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $f6dbe45301cbc2ff$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $f6dbe45301cbc2ff$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $f6dbe45301cbc2ff$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $f6dbe45301cbc2ff$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $f6dbe45301cbc2ff$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $f6dbe45301cbc2ff$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $f6dbe45301cbc2ff$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $f6dbe45301cbc2ff$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $79dc871ee192b9d5$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($c17678deab4d3b44$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $f6dbe45301cbc2ff$var$handlerWeakMap = new WeakMap();
var $f6dbe45301cbc2ff$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== "function") return defaultHandler;
    if (!$f6dbe45301cbc2ff$var$handlerWeakMap.has(defaultHandler)) $f6dbe45301cbc2ff$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $f6dbe45301cbc2ff$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $f6dbe45301cbc2ff$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $a70289b49733dd80$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $a70289b49733dd80$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $a70289b49733dd80$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $a70289b49733dd80$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $a70289b49733dd80$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($09baa17b9dbfd114$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($b2438c361198a09a$exports)))(scale));
        return {
            scale: ($a70289b49733dd80$exports[name] || $a70289b49733dd80$exports.scalePoint)(),
            realScaleType: $a70289b49733dd80$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $a70289b49733dd80$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $f6dbe45301cbc2ff$var$EPS = 1e-4;
var $f6dbe45301cbc2ff$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $f6dbe45301cbc2ff$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $f6dbe45301cbc2ff$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $f6dbe45301cbc2ff$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $f6dbe45301cbc2ff$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(domain[0]) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $f6dbe45301cbc2ff$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($c17678deab4d3b44$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $f6dbe45301cbc2ff$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($c17678deab4d3b44$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $f6dbe45301cbc2ff$var$STACK_OFFSET_MAP = {
    sign: $f6dbe45301cbc2ff$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $488ac17ac3f42c02$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $488ac17ac3f42c02$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $488ac17ac3f42c02$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $488ac17ac3f42c02$exports.stackOffsetWiggle),
    positive: $f6dbe45301cbc2ff$export$9f2c6ead70935022
};
var $f6dbe45301cbc2ff$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $f6dbe45301cbc2ff$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $488ac17ac3f42c02$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$f6dbe45301cbc2ff$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $488ac17ac3f42c02$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $f6dbe45301cbc2ff$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $79dc871ee192b9d5$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $79dc871ee192b9d5$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, result), {}, $f6dbe45301cbc2ff$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, res), {}, $f6dbe45301cbc2ff$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $f6dbe45301cbc2ff$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, result), {}, $f6dbe45301cbc2ff$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $f6dbe45301cbc2ff$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $9bdaeaa965bed1d3$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($e1472da5b8436167$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $9bdaeaa965bed1d3$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $f6dbe45301cbc2ff$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $79dc871ee192b9d5$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $f6dbe45301cbc2ff$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(value) ? axis.scale(value) : null;
}
var $f6dbe45301cbc2ff$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $f6dbe45301cbc2ff$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $f6dbe45301cbc2ff$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $f6dbe45301cbc2ff$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $79dc871ee192b9d5$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $f6dbe45301cbc2ff$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($e1472da5b8436167$exports)))(entry.concat([
                result[0]
            ]).filter((0, $79dc871ee192b9d5$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(entry.concat([
                result[1]
            ]).filter((0, $79dc871ee192b9d5$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $f6dbe45301cbc2ff$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $f6dbe45301cbc2ff$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $f6dbe45301cbc2ff$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $f6dbe45301cbc2ff$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $f6dbe45301cbc2ff$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($f6dbe45301cbc2ff$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$f6dbe45301cbc2ff$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($f6dbe45301cbc2ff$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$f6dbe45301cbc2ff$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $f6dbe45301cbc2ff$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($61042b531d0b8b0c$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $f6dbe45301cbc2ff$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($594a31a4f2e6aa3c$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $f6dbe45301cbc2ff$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $f6dbe45301cbc2ff$var$_objectSpread($f6dbe45301cbc2ff$var$_objectSpread({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $f6dbe45301cbc2ff$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $f6dbe45301cbc2ff$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $2bae62bd6f9484f1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2bae62bd6f9484f1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2bae62bd6f9484f1$var$_typeof(o);
}
function $2bae62bd6f9484f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bae62bd6f9484f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bae62bd6f9484f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2bae62bd6f9484f1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bae62bd6f9484f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2bae62bd6f9484f1$var$_defineProperty(obj, key, value) {
    key = $2bae62bd6f9484f1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2bae62bd6f9484f1$var$_toPropertyKey(t) {
    var i = $2bae62bd6f9484f1$var$_toPrimitive(t, "string");
    return "symbol" == $2bae62bd6f9484f1$var$_typeof(i) ? i : i + "";
}
function $2bae62bd6f9484f1$var$_toPrimitive(t, r) {
    if ("object" != $2bae62bd6f9484f1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2bae62bd6f9484f1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2bae62bd6f9484f1$var$_slicedToArray(arr, i) {
    return $2bae62bd6f9484f1$var$_arrayWithHoles(arr) || $2bae62bd6f9484f1$var$_iterableToArrayLimit(arr, i) || $2bae62bd6f9484f1$var$_unsupportedIterableToArray(arr, i) || $2bae62bd6f9484f1$var$_nonIterableRest();
}
function $2bae62bd6f9484f1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2bae62bd6f9484f1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2bae62bd6f9484f1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2bae62bd6f9484f1$var$_arrayLikeToArray(o, minLen);
}
function $2bae62bd6f9484f1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2bae62bd6f9484f1$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2bae62bd6f9484f1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2bae62bd6f9484f1$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $2bae62bd6f9484f1$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $2bae62bd6f9484f1$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $2bae62bd6f9484f1$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$2bae62bd6f9484f1$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$2bae62bd6f9484f1$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $2bae62bd6f9484f1$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $2bae62bd6f9484f1$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $2bae62bd6f9484f1$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $2bae62bd6f9484f1$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $f6dbe45301cbc2ff$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $f6dbe45301cbc2ff$export$9d80152e23bae434)(scale);
        var ticks = (0, $f6dbe45301cbc2ff$export$ac086aaa4358d590)(scale, $2bae62bd6f9484f1$var$_objectSpread($2bae62bd6f9484f1$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $2bae62bd6f9484f1$var$_objectSpread($2bae62bd6f9484f1$var$_objectSpread($2bae62bd6f9484f1$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $2bae62bd6f9484f1$var$_objectSpread($2bae62bd6f9484f1$var$_objectSpread({}, result), {}, $2bae62bd6f9484f1$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $2bae62bd6f9484f1$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $2bae62bd6f9484f1$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $2bae62bd6f9484f1$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $2bae62bd6f9484f1$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $2bae62bd6f9484f1$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $2bae62bd6f9484f1$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $2bae62bd6f9484f1$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $2bae62bd6f9484f1$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $2bae62bd6f9484f1$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $2bae62bd6f9484f1$var$_objectSpread($2bae62bd6f9484f1$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $2bae62bd6f9484f1$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $2bae62bd6f9484f1$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $cQmXV.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(tick) && typeof tick !== "boolean" ? tick.className : "";
};


function $9562285a10d8e530$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9562285a10d8e530$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9562285a10d8e530$var$_typeof(o);
}
var $9562285a10d8e530$var$_excluded = [
    "offset"
];
function $9562285a10d8e530$var$_toConsumableArray(arr) {
    return $9562285a10d8e530$var$_arrayWithoutHoles(arr) || $9562285a10d8e530$var$_iterableToArray(arr) || $9562285a10d8e530$var$_unsupportedIterableToArray(arr) || $9562285a10d8e530$var$_nonIterableSpread();
}
function $9562285a10d8e530$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9562285a10d8e530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9562285a10d8e530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9562285a10d8e530$var$_arrayLikeToArray(o, minLen);
}
function $9562285a10d8e530$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9562285a10d8e530$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9562285a10d8e530$var$_arrayLikeToArray(arr);
}
function $9562285a10d8e530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9562285a10d8e530$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9562285a10d8e530$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9562285a10d8e530$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9562285a10d8e530$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9562285a10d8e530$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9562285a10d8e530$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9562285a10d8e530$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9562285a10d8e530$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9562285a10d8e530$var$_defineProperty(obj, key, value) {
    key = $9562285a10d8e530$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9562285a10d8e530$var$_toPropertyKey(t) {
    var i = $9562285a10d8e530$var$_toPrimitive(t, "string");
    return "symbol" == $9562285a10d8e530$var$_typeof(i) ? i : i + "";
}
function $9562285a10d8e530$var$_toPrimitive(t, r) {
    if ("object" != $9562285a10d8e530$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9562285a10d8e530$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9562285a10d8e530$var$_extends() {
    $9562285a10d8e530$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9562285a10d8e530$var$_extends.apply(this, arguments);
}
var $9562285a10d8e530$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(formatter)) return formatter(label);
    return label;
};
var $9562285a10d8e530$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $79dc871ee192b9d5$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $9562285a10d8e530$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $9562285a10d8e530$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(labelProps.id) ? (0, $79dc871ee192b9d5$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("text", $9562285a10d8e530$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $jYj5L.default)("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $9562285a10d8e530$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $9562285a10d8e530$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $9562285a10d8e530$var$_objectSpread($9562285a10d8e530$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $9562285a10d8e530$var$_objectSpread($9562285a10d8e530$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $9562285a10d8e530$var$_objectSpread($9562285a10d8e530$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $9562285a10d8e530$var$_objectSpread($9562285a10d8e530$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $9562285a10d8e530$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $9562285a10d8e530$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $9562285a10d8e530$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $9562285a10d8e530$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $9562285a10d8e530$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $9562285a10d8e530$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $9562285a10d8e530$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $9562285a10d8e530$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cefe2712cc3cf6f1$exports)))(position) && ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(position.x) || (0, $79dc871ee192b9d5$export$e50269385c77c348)(position.x)) && ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(position.y) || (0, $79dc871ee192b9d5$export$e50269385c77c348)(position.y))) return $9562285a10d8e530$var$_objectSpread({
        x: x + (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $9562285a10d8e530$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $9562285a10d8e530$var$isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(viewBox.cx);
};
function $9562285a10d8e530$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $9562285a10d8e530$var$_objectWithoutProperties(_ref4, $9562285a10d8e530$var$_excluded);
    var props = $9562285a10d8e530$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(children) && !/*#__PURE__*/ (0, $cQmXV.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(content)) return /*#__PURE__*/ (0, $cQmXV.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(content)) {
        label = /*#__PURE__*/ (0, $cQmXV.createElement)(content, props);
        if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(label)) return label;
    } else label = $9562285a10d8e530$var$getLabel(props);
    var isPolarLabel = $9562285a10d8e530$var$isPolar(viewBox);
    var attrs = (0, $965140f0fb236676$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $9562285a10d8e530$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $9562285a10d8e530$var$getAttrsOfPolarLabel(props) : $9562285a10d8e530$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $a9394abe12cd4740$export$5f1af8db9871e1d6), $9562285a10d8e530$var$_extends({
        className: (0, $jYj5L.default)("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$9562285a10d8e530$export$b04be29aa201d4f5.displayName = "Label";
var $9562285a10d8e530$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(width) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(height)) {
        if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(x) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(top) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(x) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(cx) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $9562285a10d8e530$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9562285a10d8e530$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $79dc871ee192b9d5$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9562285a10d8e530$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(label)) {
        if (label.type === $9562285a10d8e530$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $cQmXV.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9562285a10d8e530$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9562285a10d8e530$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cefe2712cc3cf6f1$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9562285a10d8e530$export$b04be29aa201d4f5, $9562285a10d8e530$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $9562285a10d8e530$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $9562285a10d8e530$var$parseViewBox(parentProps);
    var explicitChildren = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, $9562285a10d8e530$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $cQmXV.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $9562285a10d8e530$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($9562285a10d8e530$var$_toConsumableArray(explicitChildren));
};
$9562285a10d8e530$export$b04be29aa201d4f5.parseViewBox = $9562285a10d8e530$var$parseViewBox;
$9562285a10d8e530$export$b04be29aa201d4f5.renderCallByParent = $9562285a10d8e530$var$renderCallByParent;





function $1db8c985faa453da$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1db8c985faa453da$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1db8c985faa453da$var$_typeof(o);
}
var $1db8c985faa453da$var$_excluded = [
    "valueAccessor"
], $1db8c985faa453da$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $1db8c985faa453da$var$_toConsumableArray(arr) {
    return $1db8c985faa453da$var$_arrayWithoutHoles(arr) || $1db8c985faa453da$var$_iterableToArray(arr) || $1db8c985faa453da$var$_unsupportedIterableToArray(arr) || $1db8c985faa453da$var$_nonIterableSpread();
}
function $1db8c985faa453da$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1db8c985faa453da$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1db8c985faa453da$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1db8c985faa453da$var$_arrayLikeToArray(o, minLen);
}
function $1db8c985faa453da$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1db8c985faa453da$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1db8c985faa453da$var$_arrayLikeToArray(arr);
}
function $1db8c985faa453da$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1db8c985faa453da$var$_extends() {
    $1db8c985faa453da$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1db8c985faa453da$var$_extends.apply(this, arguments);
}
function $1db8c985faa453da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1db8c985faa453da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1db8c985faa453da$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1db8c985faa453da$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1db8c985faa453da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1db8c985faa453da$var$_defineProperty(obj, key, value) {
    key = $1db8c985faa453da$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1db8c985faa453da$var$_toPropertyKey(t) {
    var i = $1db8c985faa453da$var$_toPrimitive(t, "string");
    return "symbol" == $1db8c985faa453da$var$_typeof(i) ? i : i + "";
}
function $1db8c985faa453da$var$_toPrimitive(t, r) {
    if ("object" != $1db8c985faa453da$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1db8c985faa453da$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1db8c985faa453da$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1db8c985faa453da$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1db8c985faa453da$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1db8c985faa453da$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($c44dc7e5546d4c8d$exports)))(entry.value) : entry.value;
};
function $1db8c985faa453da$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $1db8c985faa453da$var$defaultAccessor : _ref$valueAccessor, restProps = $1db8c985faa453da$var$_objectWithoutProperties(_ref, $1db8c985faa453da$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $1db8c985faa453da$var$_objectWithoutProperties(restProps, $1db8c985faa453da$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $f6dbe45301cbc2ff$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $9562285a10d8e530$export$b04be29aa201d4f5), $1db8c985faa453da$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $9562285a10d8e530$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(clockWise) ? entry : $1db8c985faa453da$var$_objectSpread($1db8c985faa453da$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$1db8c985faa453da$export$835fcf23ab7bf88.displayName = "LabelList";
function $1db8c985faa453da$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($1db8c985faa453da$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($1db8c985faa453da$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cefe2712cc3cf6f1$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($1db8c985faa453da$export$835fcf23ab7bf88, $1db8c985faa453da$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $1db8c985faa453da$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, $1db8c985faa453da$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $cQmXV.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $1db8c985faa453da$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($1db8c985faa453da$var$_toConsumableArray(explicitChildren));
}
$1db8c985faa453da$export$835fcf23ab7bf88.renderCallByParent = $1db8c985faa453da$var$renderCallByParent;






var $885b4e8e91d1b519$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
], $885b4e8e91d1b519$var$_excluded2 = [
    "key"
];
var $885b4e8e91d1b519$var$_Area;
function $885b4e8e91d1b519$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $885b4e8e91d1b519$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $885b4e8e91d1b519$var$_typeof(o);
}
function $885b4e8e91d1b519$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $885b4e8e91d1b519$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $885b4e8e91d1b519$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $885b4e8e91d1b519$var$_extends() {
    $885b4e8e91d1b519$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $885b4e8e91d1b519$var$_extends.apply(this, arguments);
}
function $885b4e8e91d1b519$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $885b4e8e91d1b519$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $885b4e8e91d1b519$var$ownKeys(Object(t), !0).forEach(function(r) {
            $885b4e8e91d1b519$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $885b4e8e91d1b519$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $885b4e8e91d1b519$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $885b4e8e91d1b519$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $885b4e8e91d1b519$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $885b4e8e91d1b519$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $885b4e8e91d1b519$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $885b4e8e91d1b519$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $885b4e8e91d1b519$var$_callSuper(t, o, e) {
    return o = $885b4e8e91d1b519$var$_getPrototypeOf(o), $885b4e8e91d1b519$var$_possibleConstructorReturn(t, $885b4e8e91d1b519$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $885b4e8e91d1b519$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $885b4e8e91d1b519$var$_possibleConstructorReturn(self, call) {
    if (call && ($885b4e8e91d1b519$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $885b4e8e91d1b519$var$_assertThisInitialized(self);
}
function $885b4e8e91d1b519$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $885b4e8e91d1b519$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($885b4e8e91d1b519$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $885b4e8e91d1b519$var$_getPrototypeOf(o) {
    $885b4e8e91d1b519$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $885b4e8e91d1b519$var$_getPrototypeOf(o);
}
function $885b4e8e91d1b519$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $885b4e8e91d1b519$var$_setPrototypeOf(subClass, superClass);
}
function $885b4e8e91d1b519$var$_setPrototypeOf(o, p) {
    $885b4e8e91d1b519$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $885b4e8e91d1b519$var$_setPrototypeOf(o, p);
}
function $885b4e8e91d1b519$var$_defineProperty(obj, key, value) {
    key = $885b4e8e91d1b519$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $885b4e8e91d1b519$var$_toPropertyKey(t) {
    var i = $885b4e8e91d1b519$var$_toPrimitive(t, "string");
    return "symbol" == $885b4e8e91d1b519$var$_typeof(i) ? i : i + "";
}
function $885b4e8e91d1b519$var$_toPrimitive(t, r) {
    if ("object" != $885b4e8e91d1b519$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $885b4e8e91d1b519$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $885b4e8e91d1b519$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    function Area() {
        var _this;
        $885b4e8e91d1b519$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $885b4e8e91d1b519$var$_callSuper(this, Area, [].concat(args));
        $885b4e8e91d1b519$var$_defineProperty(_this, "state", {
            isAnimationFinished: true
        });
        $885b4e8e91d1b519$var$_defineProperty(_this, "id", (0, $79dc871ee192b9d5$export$8b15d37bc3f197d4)("recharts-area-"));
        $885b4e8e91d1b519$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $885b4e8e91d1b519$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $885b4e8e91d1b519$var$_inherits(Area, _PureComponent);
    return $885b4e8e91d1b519$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $885b4e8e91d1b519$var$_objectSpread($885b4e8e91d1b519$var$_objectSpread($885b4e8e91d1b519$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), $885b4e8e91d1b519$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($f13ef07c8d3a7469$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === "vertical") return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $885b4e8e91d1b519$var$_objectWithoutProperties(_this$props4, $885b4e8e91d1b519$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $dadf1ea33698de40$export$b0e83c3ef8d2db1), $885b4e8e91d1b519$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== "none" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $dadf1ea33698de40$export$b0e83c3ef8d2db1), $885b4e8e91d1b519$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== "none" && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $dadf1ea33698de40$export$b0e83c3ef8d2db1), $885b4e8e91d1b519$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $835ae81331d3c901$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $885b4e8e91d1b519$var$_objectSpread($885b4e8e91d1b519$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") {
                            var interpolator = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($c17678deab4d3b44$exports)))(baseLine)) {
                            var _interpolator = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $885b4e8e91d1b519$var$_objectSpread($885b4e8e91d1b519$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($594a31a4f2e6aa3c$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($594a31a4f2e6aa3c$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $jYj5L.default)("recharts-area", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $965140f0fb236676$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $1db8c985faa453da$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
}((0, $cQmXV.PureComponent));
$885b4e8e91d1b519$var$_Area = $885b4e8e91d1b519$export$ea1a111407f37557;
$885b4e8e91d1b519$var$_defineProperty($885b4e8e91d1b519$export$ea1a111407f37557, "displayName", "Area");
$885b4e8e91d1b519$var$_defineProperty($885b4e8e91d1b519$export$ea1a111407f37557, "defaultProps", {
    stroke: "#3182bd",
    fill: "#3182bd",
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: "line",
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $783cbc8e17e1e389$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
});
$885b4e8e91d1b519$var$_defineProperty($885b4e8e91d1b519$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(baseValue) && typeof baseValue === "number") return baseValue;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === "dataMin") return domainMin;
        if (baseValue === "dataMax") return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === "dataMin") return domain[0];
    if (baseValue === "dataMax") return domain[1];
    return domain[0];
});
$885b4e8e91d1b519$var$_defineProperty($885b4e8e91d1b519$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $885b4e8e91d1b519$var$_Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === "horizontal";
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, $f6dbe45301cbc2ff$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, $f6dbe45301cbc2ff$export$f97fc4a450f29a)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, $f6dbe45301cbc2ff$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $f6dbe45301cbc2ff$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return $885b4e8e91d1b519$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$885b4e8e91d1b519$var$_defineProperty($885b4e8e91d1b519$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) dotItem = option(props);
    else {
        var className = (0, $jYj5L.default)("recharts-area-dot", typeof option !== "boolean" ? option.className : "");
        var key = props.key, rest = $885b4e8e91d1b519$var$_objectWithoutProperties(props, $885b4e8e91d1b519$var$_excluded2);
        dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $79400970f1e9c5ee$export$d046b3c4a416f60d), $885b4e8e91d1b519$var$_extends({}, rest, {
            key: key,
            className: className
        }));
    }
    return dotItem;
});

/**
 * @fileOverview Area Chart
 */ 
var $cQmXV = parcelRequire("cQmXV");


var $7bdcae63dd739032$exports = {};
var $23e80e1d04c1db87$exports = {};
var $7b63efea74d8b0c0$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b63efea74d8b0c0$var$nativeCeil = Math.ceil, $7b63efea74d8b0c0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $7b63efea74d8b0c0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $7b63efea74d8b0c0$var$nativeMax($7b63efea74d8b0c0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$7b63efea74d8b0c0$exports = $7b63efea74d8b0c0$var$baseRange;



var $8de00c578a9503ba$exports = {};
var $ff14f0ff9847f4f6$exports = {};
var $fda213c40c076823$exports = {};
var $4092bd38f19a4869$exports = {};
/** Used to match a single whitespace character. */ var $4092bd38f19a4869$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $4092bd38f19a4869$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $4092bd38f19a4869$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$4092bd38f19a4869$exports = $4092bd38f19a4869$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $fda213c40c076823$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $fda213c40c076823$var$baseTrim(string) {
    return string ? string.slice(0, $4092bd38f19a4869$exports(string) + 1).replace($fda213c40c076823$var$reTrimStart, "") : string;
}
$fda213c40c076823$exports = $fda213c40c076823$var$baseTrim;




/** Used as references for various `Number` constants. */ var $ff14f0ff9847f4f6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $ff14f0ff9847f4f6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ff14f0ff9847f4f6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ff14f0ff9847f4f6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ff14f0ff9847f4f6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ff14f0ff9847f4f6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($43b47a6ca78760ab$exports(value)) return $ff14f0ff9847f4f6$var$NAN;
    if ($cefe2712cc3cf6f1$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $cefe2712cc3cf6f1$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $fda213c40c076823$exports(value);
    var isBinary = $ff14f0ff9847f4f6$var$reIsBinary.test(value);
    return isBinary || $ff14f0ff9847f4f6$var$reIsOctal.test(value) ? $ff14f0ff9847f4f6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ff14f0ff9847f4f6$var$reIsBadHex.test(value) ? $ff14f0ff9847f4f6$var$NAN : +value;
}
$ff14f0ff9847f4f6$exports = $ff14f0ff9847f4f6$var$toNumber;


/** Used as references for various `Number` constants. */ var $8de00c578a9503ba$var$INFINITY = 1 / 0, $8de00c578a9503ba$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $8de00c578a9503ba$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $ff14f0ff9847f4f6$exports(value);
    if (value === $8de00c578a9503ba$var$INFINITY || value === -$8de00c578a9503ba$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $8de00c578a9503ba$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$8de00c578a9503ba$exports = $8de00c578a9503ba$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $23e80e1d04c1db87$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $2ba98363d8e92e85$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $8de00c578a9503ba$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $8de00c578a9503ba$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $8de00c578a9503ba$exports(step);
        return $7b63efea74d8b0c0$exports(start, end, step, fromRight);
    };
}
$23e80e1d04c1db87$exports = $23e80e1d04c1db87$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $7bdcae63dd739032$var$range = $23e80e1d04c1db87$exports();
$7bdcae63dd739032$exports = $7bdcae63dd739032$var$range;




var $cb6c7ff4ad5eb4d8$exports = {};
var $d69b09471e32b8e1$exports = {};

var $7dae1ae89eef64d6$exports = {};

var $hA3PB = parcelRequire("hA3PB");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7dae1ae89eef64d6$var$now = function() {
    return $hA3PB.Date.now();
};
$7dae1ae89eef64d6$exports = $7dae1ae89eef64d6$var$now;



/** Error message constants. */ var $d69b09471e32b8e1$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d69b09471e32b8e1$var$nativeMax = Math.max, $d69b09471e32b8e1$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d69b09471e32b8e1$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($d69b09471e32b8e1$var$FUNC_ERROR_TEXT);
    wait = $ff14f0ff9847f4f6$exports(wait) || 0;
    if ($cefe2712cc3cf6f1$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $d69b09471e32b8e1$var$nativeMax($ff14f0ff9847f4f6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d69b09471e32b8e1$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7dae1ae89eef64d6$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7dae1ae89eef64d6$exports());
    }
    function debounced() {
        var time = $7dae1ae89eef64d6$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d69b09471e32b8e1$exports = $d69b09471e32b8e1$var$debounce;



/** Error message constants. */ var $cb6c7ff4ad5eb4d8$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $cb6c7ff4ad5eb4d8$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($cb6c7ff4ad5eb4d8$var$FUNC_ERROR_TEXT);
    if ($cefe2712cc3cf6f1$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $d69b09471e32b8e1$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$cb6c7ff4ad5eb4d8$exports = $cb6c7ff4ad5eb4d8$var$throttle;



var $jYj5L = parcelRequire("jYj5L");




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");



var $jYj5L = parcelRequire("jYj5L");

function $95b76a8f1516b9e4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $95b76a8f1516b9e4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $95b76a8f1516b9e4$var$_typeof(o);
}
function $95b76a8f1516b9e4$var$_extends() {
    $95b76a8f1516b9e4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $95b76a8f1516b9e4$var$_extends.apply(this, arguments);
}
function $95b76a8f1516b9e4$var$_slicedToArray(arr, i) {
    return $95b76a8f1516b9e4$var$_arrayWithHoles(arr) || $95b76a8f1516b9e4$var$_iterableToArrayLimit(arr, i) || $95b76a8f1516b9e4$var$_unsupportedIterableToArray(arr, i) || $95b76a8f1516b9e4$var$_nonIterableRest();
}
function $95b76a8f1516b9e4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $95b76a8f1516b9e4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $95b76a8f1516b9e4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $95b76a8f1516b9e4$var$_arrayLikeToArray(o, minLen);
}
function $95b76a8f1516b9e4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $95b76a8f1516b9e4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $95b76a8f1516b9e4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $95b76a8f1516b9e4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95b76a8f1516b9e4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95b76a8f1516b9e4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $95b76a8f1516b9e4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95b76a8f1516b9e4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $95b76a8f1516b9e4$var$_defineProperty(obj, key, value) {
    key = $95b76a8f1516b9e4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $95b76a8f1516b9e4$var$_toPropertyKey(t) {
    var i = $95b76a8f1516b9e4$var$_toPrimitive(t, "string");
    return "symbol" == $95b76a8f1516b9e4$var$_typeof(i) ? i : i + "";
}
function $95b76a8f1516b9e4$var$_toPrimitive(t, r) {
    if ("object" != $95b76a8f1516b9e4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $95b76a8f1516b9e4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $95b76a8f1516b9e4$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $79dc871ee192b9d5$export$402a499e1ea44294)(value[0]) && (0, $79dc871ee192b9d5$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $95b76a8f1516b9e4$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($61042b531d0b8b0c$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = $95b76a8f1516b9e4$var$_objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $95b76a8f1516b9e4$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $95b76a8f1516b9e4$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $79dc871ee192b9d5$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $79dc871ee192b9d5$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $95b76a8f1516b9e4$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = $95b76a8f1516b9e4$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, $jYj5L.default)("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, $jYj5L.default)("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: "status",
        "aria-live": "assertive"
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", $95b76a8f1516b9e4$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");

function $4680348eb5b56142$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4680348eb5b56142$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4680348eb5b56142$var$_typeof(o);
}
function $4680348eb5b56142$var$_defineProperty(obj, key, value) {
    key = $4680348eb5b56142$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4680348eb5b56142$var$_toPropertyKey(t) {
    var i = $4680348eb5b56142$var$_toPrimitive(t, "string");
    return "symbol" == $4680348eb5b56142$var$_typeof(i) ? i : i + "";
}
function $4680348eb5b56142$var$_toPrimitive(t, r) {
    if ("object" != $4680348eb5b56142$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4680348eb5b56142$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4680348eb5b56142$var$CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var $4680348eb5b56142$var$TOOLTIP_HIDDEN = {
    visibility: "hidden"
};
function $4680348eb5b56142$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $jYj5L.default)($4680348eb5b56142$var$CSS_CLASS_PREFIX, $4680348eb5b56142$var$_defineProperty($4680348eb5b56142$var$_defineProperty($4680348eb5b56142$var$_defineProperty($4680348eb5b56142$var$_defineProperty({}, "".concat($4680348eb5b56142$var$CSS_CLASS_PREFIX, "-right"), (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(translateX) && coordinate && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($4680348eb5b56142$var$CSS_CLASS_PREFIX, "-left"), (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(translateX) && coordinate && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($4680348eb5b56142$var$CSS_CLASS_PREFIX, "-bottom"), (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(translateY) && coordinate && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($4680348eb5b56142$var$CSS_CLASS_PREFIX, "-top"), (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(translateY) && coordinate && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $4680348eb5b56142$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $4680348eb5b56142$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $4680348eb5b56142$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $4680348eb5b56142$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "x",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $4680348eb5b56142$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "y",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $4680348eb5b56142$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $4680348eb5b56142$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $4680348eb5b56142$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $fcf97d258b9aab8e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fcf97d258b9aab8e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fcf97d258b9aab8e$var$_typeof(o);
}
function $fcf97d258b9aab8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcf97d258b9aab8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcf97d258b9aab8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fcf97d258b9aab8e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcf97d258b9aab8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fcf97d258b9aab8e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fcf97d258b9aab8e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fcf97d258b9aab8e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fcf97d258b9aab8e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fcf97d258b9aab8e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcf97d258b9aab8e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fcf97d258b9aab8e$var$_callSuper(t, o, e) {
    return o = $fcf97d258b9aab8e$var$_getPrototypeOf(o), $fcf97d258b9aab8e$var$_possibleConstructorReturn(t, $fcf97d258b9aab8e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $fcf97d258b9aab8e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $fcf97d258b9aab8e$var$_possibleConstructorReturn(self, call) {
    if (call && ($fcf97d258b9aab8e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fcf97d258b9aab8e$var$_assertThisInitialized(self);
}
function $fcf97d258b9aab8e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fcf97d258b9aab8e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fcf97d258b9aab8e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fcf97d258b9aab8e$var$_getPrototypeOf(o) {
    $fcf97d258b9aab8e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fcf97d258b9aab8e$var$_getPrototypeOf(o);
}
function $fcf97d258b9aab8e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $fcf97d258b9aab8e$var$_setPrototypeOf(subClass, superClass);
}
function $fcf97d258b9aab8e$var$_setPrototypeOf(o, p) {
    $fcf97d258b9aab8e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fcf97d258b9aab8e$var$_setPrototypeOf(o, p);
}
function $fcf97d258b9aab8e$var$_defineProperty(obj, key, value) {
    key = $fcf97d258b9aab8e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fcf97d258b9aab8e$var$_toPropertyKey(t) {
    var i = $fcf97d258b9aab8e$var$_toPrimitive(t, "string");
    return "symbol" == $fcf97d258b9aab8e$var$_typeof(i) ? i : i + "";
}
function $fcf97d258b9aab8e$var$_toPrimitive(t, r) {
    if ("object" != $fcf97d258b9aab8e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fcf97d258b9aab8e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fcf97d258b9aab8e$var$EPSILON = 1;
var $fcf97d258b9aab8e$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $fcf97d258b9aab8e$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $fcf97d258b9aab8e$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $fcf97d258b9aab8e$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $fcf97d258b9aab8e$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === "Escape") {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $fcf97d258b9aab8e$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $fcf97d258b9aab8e$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $fcf97d258b9aab8e$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $fcf97d258b9aab8e$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("keydown", this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $4680348eb5b56142$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $fcf97d258b9aab8e$var$_objectSpread($fcf97d258b9aab8e$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $cQmXV.PureComponent));




function $ed7cfa2289a9738b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ed7cfa2289a9738b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ed7cfa2289a9738b$var$_typeof(o);
}
function $ed7cfa2289a9738b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed7cfa2289a9738b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed7cfa2289a9738b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ed7cfa2289a9738b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed7cfa2289a9738b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ed7cfa2289a9738b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ed7cfa2289a9738b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ed7cfa2289a9738b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ed7cfa2289a9738b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ed7cfa2289a9738b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ed7cfa2289a9738b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ed7cfa2289a9738b$var$_callSuper(t, o, e) {
    return o = $ed7cfa2289a9738b$var$_getPrototypeOf(o), $ed7cfa2289a9738b$var$_possibleConstructorReturn(t, $ed7cfa2289a9738b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ed7cfa2289a9738b$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ed7cfa2289a9738b$var$_possibleConstructorReturn(self, call) {
    if (call && ($ed7cfa2289a9738b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ed7cfa2289a9738b$var$_assertThisInitialized(self);
}
function $ed7cfa2289a9738b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ed7cfa2289a9738b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ed7cfa2289a9738b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ed7cfa2289a9738b$var$_getPrototypeOf(o) {
    $ed7cfa2289a9738b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ed7cfa2289a9738b$var$_getPrototypeOf(o);
}
function $ed7cfa2289a9738b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ed7cfa2289a9738b$var$_setPrototypeOf(subClass, superClass);
}
function $ed7cfa2289a9738b$var$_setPrototypeOf(o, p) {
    $ed7cfa2289a9738b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ed7cfa2289a9738b$var$_setPrototypeOf(o, p);
}
function $ed7cfa2289a9738b$var$_defineProperty(obj, key, value) {
    key = $ed7cfa2289a9738b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ed7cfa2289a9738b$var$_toPropertyKey(t) {
    var i = $ed7cfa2289a9738b$var$_toPrimitive(t, "string");
    return "symbol" == $ed7cfa2289a9738b$var$_typeof(i) ? i : i + "";
}
function $ed7cfa2289a9738b$var$_toPrimitive(t, r) {
    if ("object" != $ed7cfa2289a9738b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ed7cfa2289a9738b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ed7cfa2289a9738b$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $ed7cfa2289a9738b$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $95b76a8f1516b9e4$export$6fe33945eebf9ac8), props);
}
var $ed7cfa2289a9738b$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $ed7cfa2289a9738b$var$_classCallCheck(this, Tooltip);
        return $ed7cfa2289a9738b$var$_callSuper(this, Tooltip, arguments);
    }
    $ed7cfa2289a9738b$var$_inherits(Tooltip, _PureComponent);
    return $ed7cfa2289a9738b$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $b0d467970f1faa83$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $ed7cfa2289a9738b$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $fcf97d258b9aab8e$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $ed7cfa2289a9738b$var$renderContent(content, $ed7cfa2289a9738b$var$_objectSpread($ed7cfa2289a9738b$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $cQmXV.PureComponent));
$ed7cfa2289a9738b$var$_defineProperty($ed7cfa2289a9738b$export$28c660c63b792dea, "displayName", "Tooltip");
$ed7cfa2289a9738b$var$_defineProperty($ed7cfa2289a9738b$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $783cbc8e17e1e389$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});





var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");


function $1ecd0fe698309bfc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1ecd0fe698309bfc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1ecd0fe698309bfc$var$_typeof(o);
}
function $1ecd0fe698309bfc$var$_extends() {
    $1ecd0fe698309bfc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ecd0fe698309bfc$var$_extends.apply(this, arguments);
}
function $1ecd0fe698309bfc$var$_slicedToArray(arr, i) {
    return $1ecd0fe698309bfc$var$_arrayWithHoles(arr) || $1ecd0fe698309bfc$var$_iterableToArrayLimit(arr, i) || $1ecd0fe698309bfc$var$_unsupportedIterableToArray(arr, i) || $1ecd0fe698309bfc$var$_nonIterableRest();
}
function $1ecd0fe698309bfc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1ecd0fe698309bfc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1ecd0fe698309bfc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1ecd0fe698309bfc$var$_arrayLikeToArray(o, minLen);
}
function $1ecd0fe698309bfc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1ecd0fe698309bfc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1ecd0fe698309bfc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1ecd0fe698309bfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ecd0fe698309bfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ecd0fe698309bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1ecd0fe698309bfc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ecd0fe698309bfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1ecd0fe698309bfc$var$_defineProperty(obj, key, value) {
    key = $1ecd0fe698309bfc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ecd0fe698309bfc$var$_toPropertyKey(t) {
    var i = $1ecd0fe698309bfc$var$_toPrimitive(t, "string");
    return "symbol" == $1ecd0fe698309bfc$var$_typeof(i) ? i : i + "";
}
function $1ecd0fe698309bfc$var$_toPrimitive(t, r) {
    if ("object" != $1ecd0fe698309bfc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1ecd0fe698309bfc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1ecd0fe698309bfc$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $1ecd0fe698309bfc$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $1ecd0fe698309bfc$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $1ecd0fe698309bfc$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $1ecd0fe698309bfc$var$_objectSpread($1ecd0fe698309bfc$var$_objectSpread({}, $1ecd0fe698309bfc$var$defaultProps), rectangleProps);
    var pathRef = (0, $cQmXV.useRef)();
    var _useState = (0, $cQmXV.useState)(-1), _useState2 = $1ecd0fe698309bfc$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $cQmXV.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $jYj5L.default)("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", $1ecd0fe698309bfc$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $1ecd0fe698309bfc$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $835ae81331d3c901$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $835ae81331d3c901$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", $1ecd0fe698309bfc$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $1ecd0fe698309bfc$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};




var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");







function $17b94ff3fe5312ca$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $17b94ff3fe5312ca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $17b94ff3fe5312ca$var$_typeof(o);
}
function $17b94ff3fe5312ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17b94ff3fe5312ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17b94ff3fe5312ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $17b94ff3fe5312ca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17b94ff3fe5312ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $17b94ff3fe5312ca$var$_defineProperty(obj, key, value) {
    key = $17b94ff3fe5312ca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17b94ff3fe5312ca$var$_toPropertyKey(t) {
    var i = $17b94ff3fe5312ca$var$_toPrimitive(t, "string");
    return "symbol" == $17b94ff3fe5312ca$var$_typeof(i) ? i : i + "";
}
function $17b94ff3fe5312ca$var$_toPrimitive(t, r) {
    if ("object" != $17b94ff3fe5312ca$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $17b94ff3fe5312ca$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $17b94ff3fe5312ca$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $17b94ff3fe5312ca$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $17b94ff3fe5312ca$var$PREFIX_LIST.reduce(function(res, entry) {
        return $17b94ff3fe5312ca$var$_objectSpread($17b94ff3fe5312ca$var$_objectSpread({}, res), {}, $17b94ff3fe5312ca$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $e86a127d716d0c82$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e86a127d716d0c82$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e86a127d716d0c82$var$_typeof(o);
}
function $e86a127d716d0c82$var$_extends() {
    $e86a127d716d0c82$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e86a127d716d0c82$var$_extends.apply(this, arguments);
}
function $e86a127d716d0c82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e86a127d716d0c82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e86a127d716d0c82$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e86a127d716d0c82$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e86a127d716d0c82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e86a127d716d0c82$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e86a127d716d0c82$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e86a127d716d0c82$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e86a127d716d0c82$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e86a127d716d0c82$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e86a127d716d0c82$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e86a127d716d0c82$var$_callSuper(t, o, e) {
    return o = $e86a127d716d0c82$var$_getPrototypeOf(o), $e86a127d716d0c82$var$_possibleConstructorReturn(t, $e86a127d716d0c82$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e86a127d716d0c82$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e86a127d716d0c82$var$_possibleConstructorReturn(self, call) {
    if (call && ($e86a127d716d0c82$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e86a127d716d0c82$var$_assertThisInitialized(self);
}
function $e86a127d716d0c82$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e86a127d716d0c82$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e86a127d716d0c82$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e86a127d716d0c82$var$_getPrototypeOf(o) {
    $e86a127d716d0c82$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e86a127d716d0c82$var$_getPrototypeOf(o);
}
function $e86a127d716d0c82$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e86a127d716d0c82$var$_setPrototypeOf(subClass, superClass);
}
function $e86a127d716d0c82$var$_setPrototypeOf(o, p) {
    $e86a127d716d0c82$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e86a127d716d0c82$var$_setPrototypeOf(o, p);
}
function $e86a127d716d0c82$var$_defineProperty(obj, key, value) {
    key = $e86a127d716d0c82$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e86a127d716d0c82$var$_toPropertyKey(t) {
    var i = $e86a127d716d0c82$var$_toPrimitive(t, "string");
    return "symbol" == $e86a127d716d0c82$var$_typeof(i) ? i : i + "";
}
function $e86a127d716d0c82$var$_toPrimitive(t, r) {
    if ("object" != $e86a127d716d0c82$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e86a127d716d0c82$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e86a127d716d0c82$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $a70289b49733dd80$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($7bdcae63dd739032$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $e86a127d716d0c82$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $e86a127d716d0c82$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $e86a127d716d0c82$var$_classCallCheck(this, Brush);
        _this = $e86a127d716d0c82$var$_callSuper(this, Brush, [
            props
        ]);
        $e86a127d716d0c82$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $e86a127d716d0c82$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $e86a127d716d0c82$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $e86a127d716d0c82$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $e86a127d716d0c82$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $e86a127d716d0c82$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $e86a127d716d0c82$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $e86a127d716d0c82$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, "startX"),
            endX: _this.handleTravellerDragStart.bind(_this, "endX")
        };
        _this.state = {};
        return _this;
    }
    $e86a127d716d0c82$var$_inherits(Brush, _PureComponent);
    return $e86a127d716d0c82$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $f6dbe45301cbc2ff$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $e86a127d716d0c82$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($e86a127d716d0c82$var$_defineProperty($e86a127d716d0c82$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === "startX" && newScaleValue >= endX || id === "endX" && newScaleValue <= startX) return;
                this.setState($e86a127d716d0c82$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $cQmXV.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $e86a127d716d0c82$var$_objectSpread($e86a127d716d0c82$var$_objectSpread({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === "ArrowRight" ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $a9394abe12cd4740$export$5f1af8db9871e1d6), $e86a127d716d0c82$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $a9394abe12cd4740$export$5f1af8db9871e1d6), $e86a127d716d0c82$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(x) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(y) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(width) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $jYj5L.default)("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(children) === 1;
                var style = (0, $17b94ff3fe5312ca$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $e86a127d716d0c82$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $e86a127d716d0c82$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $cQmXV.PureComponent));
$e86a127d716d0c82$var$_defineProperty($e86a127d716d0c82$export$59bc2e3533b384a0, "displayName", "Brush");
$e86a127d716d0c82$var$_defineProperty($e86a127d716d0c82$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");




var $5bb5d8f737aa8160$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};


var $77add4b30caf1e46$exports = {};
var $401e883f5e081d29$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $401e883f5e081d29$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $3bc2bdb7db5363fe$exports) $3bc2bdb7db5363fe$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$401e883f5e081d29$exports = $401e883f5e081d29$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $77add4b30caf1e46$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $4f634fb3ab11bd8f$exports(iteratee, 3);
    $6fe420c571a6ae1a$exports(object, function(value, key, object) {
        $401e883f5e081d29$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$77add4b30caf1e46$exports = $77add4b30caf1e46$var$mapValues;


var $aefda18ebee3a3a6$exports = {};
var $cfea472610efbefe$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $cfea472610efbefe$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$cfea472610efbefe$exports = $cfea472610efbefe$var$arrayEvery;


var $747436bd2e745cad$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $747436bd2e745cad$var$baseEvery(collection, predicate) {
    var result = true;
    $600291cb91f5bc7d$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$747436bd2e745cad$exports = $747436bd2e745cad$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $aefda18ebee3a3a6$var$every(collection, predicate, guard) {
    var func = $d3cd128394c0afcd$exports(collection) ? $cfea472610efbefe$exports : $747436bd2e745cad$exports;
    if (guard && $2ba98363d8e92e85$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $4f634fb3ab11bd8f$exports(predicate, 3));
}
$aefda18ebee3a3a6$exports = $aefda18ebee3a3a6$var$every;






var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");





/**
 * @fileOverview Cross
 */ var $00195d1dff24caf4$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$00195d1dff24caf4$export$f6f0c3fe4ec306ea.displayName = "Cell";









var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");

var $5b75a8eb6d5b02db$exports = {};

var $700c4b0878059682$exports = {};

/** Built-in value references. */ var $700c4b0878059682$var$getPrototype = $1711a73c9485885d$exports(Object.getPrototypeOf, Object);
$700c4b0878059682$exports = $700c4b0878059682$var$getPrototype;



/** `Object#toString` result references. */ var $5b75a8eb6d5b02db$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $5b75a8eb6d5b02db$var$funcProto = Function.prototype, $5b75a8eb6d5b02db$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5b75a8eb6d5b02db$var$funcToString = $5b75a8eb6d5b02db$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5b75a8eb6d5b02db$var$hasOwnProperty = $5b75a8eb6d5b02db$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $5b75a8eb6d5b02db$var$objectCtorString = $5b75a8eb6d5b02db$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $5b75a8eb6d5b02db$var$isPlainObject(value) {
    if (!$23d15efa9df98feb$exports(value) || $d92048f5b28963ed$exports(value) != $5b75a8eb6d5b02db$var$objectTag) return false;
    var proto = $700c4b0878059682$exports(value);
    if (proto === null) return true;
    var Ctor = $5b75a8eb6d5b02db$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $5b75a8eb6d5b02db$var$funcToString.call(Ctor) == $5b75a8eb6d5b02db$var$objectCtorString;
}
$5b75a8eb6d5b02db$exports = $5b75a8eb6d5b02db$var$isPlainObject;


var $2305e740298cd3d4$exports = {};


/** `Object#toString` result references. */ var $2305e740298cd3d4$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $2305e740298cd3d4$var$isBoolean(value) {
    return value === true || value === false || $23d15efa9df98feb$exports(value) && $d92048f5b28963ed$exports(value) == $2305e740298cd3d4$var$boolTag;
}
$2305e740298cd3d4$exports = $2305e740298cd3d4$var$isBoolean;





var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");


function $841daef198c9e876$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $841daef198c9e876$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $841daef198c9e876$var$_typeof(o);
}
function $841daef198c9e876$var$_extends() {
    $841daef198c9e876$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $841daef198c9e876$var$_extends.apply(this, arguments);
}
function $841daef198c9e876$var$_slicedToArray(arr, i) {
    return $841daef198c9e876$var$_arrayWithHoles(arr) || $841daef198c9e876$var$_iterableToArrayLimit(arr, i) || $841daef198c9e876$var$_unsupportedIterableToArray(arr, i) || $841daef198c9e876$var$_nonIterableRest();
}
function $841daef198c9e876$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $841daef198c9e876$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $841daef198c9e876$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $841daef198c9e876$var$_arrayLikeToArray(o, minLen);
}
function $841daef198c9e876$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $841daef198c9e876$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $841daef198c9e876$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $841daef198c9e876$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $841daef198c9e876$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $841daef198c9e876$var$ownKeys(Object(t), !0).forEach(function(r) {
            $841daef198c9e876$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $841daef198c9e876$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $841daef198c9e876$var$_defineProperty(obj, key, value) {
    key = $841daef198c9e876$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $841daef198c9e876$var$_toPropertyKey(t) {
    var i = $841daef198c9e876$var$_toPrimitive(t, "string");
    return "symbol" == $841daef198c9e876$var$_typeof(i) ? i : i + "";
}
function $841daef198c9e876$var$_toPrimitive(t, r) {
    if ("object" != $841daef198c9e876$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $841daef198c9e876$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $841daef198c9e876$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $841daef198c9e876$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $841daef198c9e876$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $841daef198c9e876$var$_objectSpread($841daef198c9e876$var$_objectSpread({}, $841daef198c9e876$var$defaultProps), props);
    var pathRef = (0, $cQmXV.useRef)();
    var _useState = (0, $cQmXV.useState)(-1), _useState2 = $841daef198c9e876$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $cQmXV.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $jYj5L.default)("recharts-trapezoid", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", $841daef198c9e876$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $841daef198c9e876$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $835ae81331d3c901$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $835ae81331d3c901$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", $841daef198c9e876$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $841daef198c9e876$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");



function $8af17cf8f6c51679$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8af17cf8f6c51679$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8af17cf8f6c51679$var$_typeof(o);
}
function $8af17cf8f6c51679$var$_extends() {
    $8af17cf8f6c51679$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8af17cf8f6c51679$var$_extends.apply(this, arguments);
}
function $8af17cf8f6c51679$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8af17cf8f6c51679$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8af17cf8f6c51679$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8af17cf8f6c51679$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8af17cf8f6c51679$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8af17cf8f6c51679$var$_defineProperty(obj, key, value) {
    key = $8af17cf8f6c51679$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8af17cf8f6c51679$var$_toPropertyKey(t) {
    var i = $8af17cf8f6c51679$var$_toPrimitive(t, "string");
    return "symbol" == $8af17cf8f6c51679$var$_typeof(i) ? i : i + "";
}
function $8af17cf8f6c51679$var$_toPrimitive(t, r) {
    if ("object" != $8af17cf8f6c51679$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8af17cf8f6c51679$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8af17cf8f6c51679$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $79dc871ee192b9d5$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $8af17cf8f6c51679$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $2bae62bd6f9484f1$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $2bae62bd6f9484f1$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $8af17cf8f6c51679$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $8af17cf8f6c51679$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $8af17cf8f6c51679$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $79dc871ee192b9d5$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $8af17cf8f6c51679$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $8af17cf8f6c51679$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $8af17cf8f6c51679$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $8af17cf8f6c51679$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $8af17cf8f6c51679$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $8af17cf8f6c51679$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $8af17cf8f6c51679$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $8af17cf8f6c51679$var$_objectSpread($8af17cf8f6c51679$var$_objectSpread({}, $8af17cf8f6c51679$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $jYj5L.default)("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $8af17cf8f6c51679$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $8af17cf8f6c51679$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", $8af17cf8f6c51679$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $69bb41748f50bfe4$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $69bb41748f50bfe4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $69bb41748f50bfe4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $69bb41748f50bfe4$var$_typeof(o);
}
function $69bb41748f50bfe4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $69bb41748f50bfe4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $69bb41748f50bfe4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $69bb41748f50bfe4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $69bb41748f50bfe4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $69bb41748f50bfe4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $69bb41748f50bfe4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $69bb41748f50bfe4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $69bb41748f50bfe4$var$_defineProperty(obj, key, value) {
    key = $69bb41748f50bfe4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $69bb41748f50bfe4$var$_toPropertyKey(t) {
    var i = $69bb41748f50bfe4$var$_toPrimitive(t, "string");
    return "symbol" == $69bb41748f50bfe4$var$_typeof(i) ? i : i + "";
}
function $69bb41748f50bfe4$var$_toPrimitive(t, r) {
    if ("object" != $69bb41748f50bfe4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $69bb41748f50bfe4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $69bb41748f50bfe4$var$defaultPropTransformer(option, props) {
    return $69bb41748f50bfe4$var$_objectSpread($69bb41748f50bfe4$var$_objectSpread({}, props), option);
}
function $69bb41748f50bfe4$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === "symbols";
}
function $69bb41748f50bfe4$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case "rectangle":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1ecd0fe698309bfc$export$4617fb02663045ef), elementProps);
        case "trapezoid":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $841daef198c9e876$export$d1ed33dc592f5337), elementProps);
        case "sector":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $8af17cf8f6c51679$export$e98c2c7eb2b14f45), elementProps);
        case "symbols":
            if ($69bb41748f50bfe4$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b71690cdc8027025$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $69bb41748f50bfe4$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(option)) return option.props;
    return option;
}
function $69bb41748f50bfe4$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $69bb41748f50bfe4$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = $69bb41748f50bfe4$var$_objectWithoutProperties(_ref2, $69bb41748f50bfe4$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(option)) shape = /*#__PURE__*/ (0, $cQmXV.cloneElement)(option, $69bb41748f50bfe4$var$_objectSpread($69bb41748f50bfe4$var$_objectSpread({}, props), $69bb41748f50bfe4$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($5b75a8eb6d5b02db$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($2305e740298cd3d4$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($69bb41748f50bfe4$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($69bb41748f50bfe4$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $69bb41748f50bfe4$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && "trapezoids" in graphicalItem.props;
}
function $69bb41748f50bfe4$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && "sectors" in graphicalItem.props;
}
function $69bb41748f50bfe4$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && "points" in graphicalItem.props;
}
function $69bb41748f50bfe4$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $69bb41748f50bfe4$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $69bb41748f50bfe4$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $69bb41748f50bfe4$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($69bb41748f50bfe4$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $69bb41748f50bfe4$export$7c9a98b3f068686f;
    else if ($69bb41748f50bfe4$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $69bb41748f50bfe4$export$b356b51e8337a02f;
    else if ($69bb41748f50bfe4$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $69bb41748f50bfe4$export$559c3a78b4889350;
    return comparison;
}
function $69bb41748f50bfe4$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($69bb41748f50bfe4$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = "trapezoids";
    else if ($69bb41748f50bfe4$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = "sectors";
    else if ($69bb41748f50bfe4$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = "points";
    return shapeKey;
}
function $69bb41748f50bfe4$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($69bb41748f50bfe4$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($69bb41748f50bfe4$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($69bb41748f50bfe4$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $69bb41748f50bfe4$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $69bb41748f50bfe4$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $69bb41748f50bfe4$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($594a31a4f2e6aa3c$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $69bb41748f50bfe4$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}



var $6104d9a5d939da63$var$_excluded = [
    "x",
    "y"
];
function $6104d9a5d939da63$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6104d9a5d939da63$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6104d9a5d939da63$var$_typeof(o);
}
function $6104d9a5d939da63$var$_extends() {
    $6104d9a5d939da63$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6104d9a5d939da63$var$_extends.apply(this, arguments);
}
function $6104d9a5d939da63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6104d9a5d939da63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6104d9a5d939da63$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6104d9a5d939da63$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6104d9a5d939da63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6104d9a5d939da63$var$_defineProperty(obj, key, value) {
    key = $6104d9a5d939da63$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6104d9a5d939da63$var$_toPropertyKey(t) {
    var i = $6104d9a5d939da63$var$_toPrimitive(t, "string");
    return "symbol" == $6104d9a5d939da63$var$_typeof(i) ? i : i + "";
}
function $6104d9a5d939da63$var$_toPrimitive(t, r) {
    if ("object" != $6104d9a5d939da63$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6104d9a5d939da63$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6104d9a5d939da63$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6104d9a5d939da63$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6104d9a5d939da63$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $6104d9a5d939da63$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $6104d9a5d939da63$var$_objectWithoutProperties(_ref, $6104d9a5d939da63$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $6104d9a5d939da63$var$_objectSpread($6104d9a5d939da63$var$_objectSpread($6104d9a5d939da63$var$_objectSpread($6104d9a5d939da63$var$_objectSpread($6104d9a5d939da63$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $6104d9a5d939da63$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $69bb41748f50bfe4$export$6428a7f2611ef1fa), $6104d9a5d939da63$var$_extends({
        shapeType: "rectangle",
        propTransformer: $6104d9a5d939da63$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $6104d9a5d939da63$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === "number") return minPointSize;
        var isValueNumberOrNil = (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(value) || (0, $79dc871ee192b9d5$export$b931b78cbb3caf86)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $bce1568d73f81eb0$var$_excluded = [
    "value",
    "background"
];
var $bce1568d73f81eb0$var$_Bar;
function $bce1568d73f81eb0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bce1568d73f81eb0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bce1568d73f81eb0$var$_typeof(o);
}
function $bce1568d73f81eb0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bce1568d73f81eb0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bce1568d73f81eb0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bce1568d73f81eb0$var$_extends() {
    $bce1568d73f81eb0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bce1568d73f81eb0$var$_extends.apply(this, arguments);
}
function $bce1568d73f81eb0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bce1568d73f81eb0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bce1568d73f81eb0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bce1568d73f81eb0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bce1568d73f81eb0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bce1568d73f81eb0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bce1568d73f81eb0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bce1568d73f81eb0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bce1568d73f81eb0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bce1568d73f81eb0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bce1568d73f81eb0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bce1568d73f81eb0$var$_callSuper(t, o, e) {
    return o = $bce1568d73f81eb0$var$_getPrototypeOf(o), $bce1568d73f81eb0$var$_possibleConstructorReturn(t, $bce1568d73f81eb0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $bce1568d73f81eb0$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $bce1568d73f81eb0$var$_possibleConstructorReturn(self, call) {
    if (call && ($bce1568d73f81eb0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bce1568d73f81eb0$var$_assertThisInitialized(self);
}
function $bce1568d73f81eb0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bce1568d73f81eb0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bce1568d73f81eb0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bce1568d73f81eb0$var$_getPrototypeOf(o) {
    $bce1568d73f81eb0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bce1568d73f81eb0$var$_getPrototypeOf(o);
}
function $bce1568d73f81eb0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bce1568d73f81eb0$var$_setPrototypeOf(subClass, superClass);
}
function $bce1568d73f81eb0$var$_setPrototypeOf(o, p) {
    $bce1568d73f81eb0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bce1568d73f81eb0$var$_setPrototypeOf(o, p);
}
function $bce1568d73f81eb0$var$_defineProperty(obj, key, value) {
    key = $bce1568d73f81eb0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bce1568d73f81eb0$var$_toPropertyKey(t) {
    var i = $bce1568d73f81eb0$var$_toPrimitive(t, "string");
    return "symbol" == $bce1568d73f81eb0$var$_typeof(i) ? i : i + "";
}
function $bce1568d73f81eb0$var$_toPrimitive(t, r) {
    if ("object" != $bce1568d73f81eb0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bce1568d73f81eb0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bce1568d73f81eb0$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $bce1568d73f81eb0$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $bce1568d73f81eb0$var$_callSuper(this, Bar, [].concat(args));
        $bce1568d73f81eb0$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $bce1568d73f81eb0$var$_defineProperty(_this, "id", (0, $79dc871ee192b9d5$export$8b15d37bc3f197d4)("recharts-bar-"));
        $bce1568d73f81eb0$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $bce1568d73f81eb0$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $bce1568d73f81eb0$var$_inherits(Bar, _PureComponent);
    return $bce1568d73f81eb0$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), $bce1568d73f81eb0$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $d0c9e9f30a5b8447$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6104d9a5d939da63$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $835ae81331d3c901$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $79dc871ee192b9d5$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($594a31a4f2e6aa3c$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $bce1568d73f81eb0$var$_objectWithoutProperties(entry, $bce1568d73f81eb0$var$_excluded);
                    if (!background) return null;
                    var props = $bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, $d0c9e9f30a5b8447$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: "recharts-bar-background-rectangle"
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6104d9a5d939da63$export$f19074a6842f9217), $bce1568d73f81eb0$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, (0, $892666b59896889a$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $f6dbe45301cbc2ff$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $jYj5L.default)("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $1db8c985faa453da$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $cQmXV.PureComponent));
$bce1568d73f81eb0$var$_Bar = $bce1568d73f81eb0$export$bbc6c6369b38e3d1;
$bce1568d73f81eb0$var$_defineProperty($bce1568d73f81eb0$export$bbc6c6369b38e3d1, "displayName", "Bar");
$bce1568d73f81eb0$var$_defineProperty($bce1568d73f81eb0$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    data: [],
    layout: "vertical",
    activeBar: false,
    isAnimationActive: !(0, $783cbc8e17e1e389$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $bce1568d73f81eb0$var$_defineProperty($bce1568d73f81eb0$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $f6dbe45301cbc2ff$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $f6dbe45301cbc2ff$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, (0, $00195d1dff24caf4$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $f6dbe45301cbc2ff$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $f6dbe45301cbc2ff$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $6104d9a5d939da63$export$c20d73790de171f0)(minPointSizeProp, $bce1568d73f81eb0$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $f6dbe45301cbc2ff$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $79dc871ee192b9d5$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $f6dbe45301cbc2ff$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $79dc871ee192b9d5$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread($bce1568d73f81eb0$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $f6dbe45301cbc2ff$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $bce1568d73f81eb0$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $5fe31a8e04253623$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5fe31a8e04253623$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5fe31a8e04253623$var$_typeof(o);
}
function $5fe31a8e04253623$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5fe31a8e04253623$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5fe31a8e04253623$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5fe31a8e04253623$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5fe31a8e04253623$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5fe31a8e04253623$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5fe31a8e04253623$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fe31a8e04253623$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fe31a8e04253623$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5fe31a8e04253623$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fe31a8e04253623$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5fe31a8e04253623$var$_defineProperty(obj, key, value) {
    key = $5fe31a8e04253623$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5fe31a8e04253623$var$_toPropertyKey(t) {
    var i = $5fe31a8e04253623$var$_toPrimitive(t, "string");
    return "symbol" == $5fe31a8e04253623$var$_typeof(i) ? i : i + "";
}
function $5fe31a8e04253623$var$_toPrimitive(t, r) {
    if ("object" != $5fe31a8e04253623$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5fe31a8e04253623$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5fe31a8e04253623$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $bce1568d73f81eb0$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, $79dc871ee192b9d5$export$6ab1df3197f7c641));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
                if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === "no-gap") {
                    var gap = (0, $79dc871ee192b9d5$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $f6dbe45301cbc2ff$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $f6dbe45301cbc2ff$export$9d80152e23bae434)(scale);
        var ticks = (0, $f6dbe45301cbc2ff$export$ac086aaa4358d590)(scale, $5fe31a8e04253623$var$_objectSpread($5fe31a8e04253623$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $5fe31a8e04253623$var$_objectSpread($5fe31a8e04253623$var$_objectSpread($5fe31a8e04253623$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $f6dbe45301cbc2ff$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $5fe31a8e04253623$var$_objectSpread($5fe31a8e04253623$var$_objectSpread({}, result), {}, $5fe31a8e04253623$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $5fe31a8e04253623$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $5fe31a8e04253623$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $5fe31a8e04253623$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $5fe31a8e04253623$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $5fe31a8e04253623$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $5fe31a8e04253623$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$5fe31a8e04253623$var$_defineProperty($5fe31a8e04253623$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $5fe31a8e04253623$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $5fe31a8e04253623$var$_objectSpread($5fe31a8e04253623$var$_objectSpread({}, res), {}, $5fe31a8e04253623$var$_defineProperty({}, key, $5fe31a8e04253623$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $5fe31a8e04253623$var$_objectSpread($5fe31a8e04253623$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($77add4b30caf1e46$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($aefda18ebee3a3a6$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $5fe31a8e04253623$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $5fe31a8e04253623$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $5fe31a8e04253623$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $40b6d809c89a243a$var$_extends() {
    $40b6d809c89a243a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $40b6d809c89a243a$var$_extends.apply(this, arguments);
}
function $40b6d809c89a243a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $40b6d809c89a243a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $40b6d809c89a243a$var$_typeof(o);
}
function $40b6d809c89a243a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40b6d809c89a243a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40b6d809c89a243a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $40b6d809c89a243a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40b6d809c89a243a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $40b6d809c89a243a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $40b6d809c89a243a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $40b6d809c89a243a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $40b6d809c89a243a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $40b6d809c89a243a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $40b6d809c89a243a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $40b6d809c89a243a$var$_callSuper(t, o, e) {
    return o = $40b6d809c89a243a$var$_getPrototypeOf(o), $40b6d809c89a243a$var$_possibleConstructorReturn(t, $40b6d809c89a243a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $40b6d809c89a243a$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $40b6d809c89a243a$var$_possibleConstructorReturn(self, call) {
    if (call && ($40b6d809c89a243a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $40b6d809c89a243a$var$_assertThisInitialized(self);
}
function $40b6d809c89a243a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $40b6d809c89a243a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($40b6d809c89a243a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $40b6d809c89a243a$var$_getPrototypeOf(o) {
    $40b6d809c89a243a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $40b6d809c89a243a$var$_getPrototypeOf(o);
}
function $40b6d809c89a243a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $40b6d809c89a243a$var$_setPrototypeOf(subClass, superClass);
}
function $40b6d809c89a243a$var$_setPrototypeOf(o, p) {
    $40b6d809c89a243a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $40b6d809c89a243a$var$_setPrototypeOf(o, p);
}
function $40b6d809c89a243a$var$_defineProperty(obj, key, value) {
    key = $40b6d809c89a243a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $40b6d809c89a243a$var$_toPropertyKey(t) {
    var i = $40b6d809c89a243a$var$_toPrimitive(t, "string");
    return "symbol" == $40b6d809c89a243a$var$_typeof(i) ? i : i + "";
}
function $40b6d809c89a243a$var$_toPrimitive(t, r) {
    if ("object" != $40b6d809c89a243a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $40b6d809c89a243a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $40b6d809c89a243a$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $5fe31a8e04253623$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $5bb5d8f737aa8160$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
var $40b6d809c89a243a$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $40b6d809c89a243a$var$_classCallCheck(this, ReferenceDot);
        return $40b6d809c89a243a$var$_callSuper(this, ReferenceDot, arguments);
    }
    $40b6d809c89a243a$var$_inherits(ReferenceDot, _React$Component);
    return $40b6d809c89a243a$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(x);
                var isY = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(y);
                (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $40b6d809c89a243a$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $5bb5d8f737aa8160$export$3fb112445eb31879)(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $40b6d809c89a243a$var$_objectSpread($40b6d809c89a243a$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: (0, $jYj5L.default)("recharts-reference-dot", className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $9562285a10d8e530$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
$40b6d809c89a243a$var$_defineProperty($40b6d809c89a243a$export$aa7f0b0106bff39, "displayName", "ReferenceDot");
$40b6d809c89a243a$var$_defineProperty($40b6d809c89a243a$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
});
$40b6d809c89a243a$var$_defineProperty($40b6d809c89a243a$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $79400970f1e9c5ee$export$d046b3c4a416f60d), $40b6d809c89a243a$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $cQmXV = parcelRequire("cQmXV");

var $7604b2cab047631b$exports = {};


var $84f27af3f0134009$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $84f27af3f0134009$var$baseSome(collection, predicate) {
    var result;
    $600291cb91f5bc7d$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$84f27af3f0134009$exports = $84f27af3f0134009$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $7604b2cab047631b$var$some(collection, predicate, guard) {
    var func = $d3cd128394c0afcd$exports(collection) ? $61660d90f3320dcd$exports : $84f27af3f0134009$exports;
    if (guard && $2ba98363d8e92e85$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $4f634fb3ab11bd8f$exports(predicate, 3));
}
$7604b2cab047631b$exports = $7604b2cab047631b$var$some;



var $jYj5L = parcelRequire("jYj5L");








var $cQmXV = parcelRequire("cQmXV");

var $be60d6220e774de1$exports = {};
var $1e997082b252301c$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $1e997082b252301c$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$762eed9717dbe83d$exports(collection)) {
            var iteratee = $4f634fb3ab11bd8f$exports(predicate, 3);
            collection = $767b9cae0f938981$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$1e997082b252301c$exports = $1e997082b252301c$var$createFind;


var $c8cec8da830415ce$exports = {};


var $c1273a269d43d067$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $c1273a269d43d067$var$toInteger(value) {
    var result = $8de00c578a9503ba$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$c1273a269d43d067$exports = $c1273a269d43d067$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c8cec8da830415ce$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c8cec8da830415ce$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $c1273a269d43d067$exports(fromIndex);
    if (index < 0) index = $c8cec8da830415ce$var$nativeMax(length + index, 0);
    return $f598e57fcb0efd87$exports(array, $4f634fb3ab11bd8f$exports(predicate, 3), index);
}
$c8cec8da830415ce$exports = $c8cec8da830415ce$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $be60d6220e774de1$var$find = $1e997082b252301c$exports($c8cec8da830415ce$exports);
$be60d6220e774de1$exports = $be60d6220e774de1$var$find;




var $cddc1aa0adb76ba4$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($ef662daaa8c650bd$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        "l",
        offset.left,
        "t",
        offset.top,
        "w",
        offset.width,
        "h",
        offset.height
    ].join("");
});



function $9af926f5cfd576a1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9af926f5cfd576a1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9af926f5cfd576a1$var$_typeof(o);
}
var $9af926f5cfd576a1$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $cQmXV.createContext)(undefined);
var $9af926f5cfd576a1$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $cQmXV.createContext)(undefined);
var $9af926f5cfd576a1$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $cQmXV.createContext)(undefined);
var $9af926f5cfd576a1$export$482c85f2026f212e = /*#__PURE__*/ (0, $cQmXV.createContext)({});
var $9af926f5cfd576a1$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $cQmXV.createContext)(undefined);
var $9af926f5cfd576a1$export$b18854f928720bc8 = /*#__PURE__*/ (0, $cQmXV.createContext)(0);
var $9af926f5cfd576a1$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $cQmXV.createContext)(0);
var $9af926f5cfd576a1$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $cddc1aa0adb76ba4$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9af926f5cfd576a1$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9af926f5cfd576a1$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9af926f5cfd576a1$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9af926f5cfd576a1$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9af926f5cfd576a1$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9af926f5cfd576a1$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($9af926f5cfd576a1$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $9af926f5cfd576a1$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $cQmXV.useContext)($9af926f5cfd576a1$export$e42cfe3f3988c70f);
};
function $9af926f5cfd576a1$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "There are no available ids.";
    return "Available ids are: ".concat(keys, ".");
}
var $9af926f5cfd576a1$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $cQmXV.useContext)($9af926f5cfd576a1$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $9af926f5cfd576a1$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $cQmXV.useContext)($9af926f5cfd576a1$export$92c2a2c8239475bf);
    return (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(xAxisMap);
};
var $9af926f5cfd576a1$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $cQmXV.useContext)($9af926f5cfd576a1$export$40ceabe61e17c4dc);
    return (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(yAxisMap);
};
var $9af926f5cfd576a1$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $cQmXV.useContext)($9af926f5cfd576a1$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($be60d6220e774de1$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aefda18ebee3a3a6$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(yAxisMap);
};
var $9af926f5cfd576a1$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $cQmXV.useContext)($9af926f5cfd576a1$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $9af926f5cfd576a1$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $cQmXV.useContext)($9af926f5cfd576a1$export$29b7735f8b5653b2);
    return viewBox;
};
var $9af926f5cfd576a1$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $cQmXV.useContext)($9af926f5cfd576a1$export$482c85f2026f212e);
};
var $9af926f5cfd576a1$export$8854f7ece606854b = function useChartWidth() {
    return (0, $cQmXV.useContext)($9af926f5cfd576a1$export$3c3f0c9338cf7530);
};
var $9af926f5cfd576a1$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $cQmXV.useContext)($9af926f5cfd576a1$export$b18854f928720bc8);
};


function $309e5de50d4b709a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $309e5de50d4b709a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $309e5de50d4b709a$var$_typeof(o);
}
function $309e5de50d4b709a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $309e5de50d4b709a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $309e5de50d4b709a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $309e5de50d4b709a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $309e5de50d4b709a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $309e5de50d4b709a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $309e5de50d4b709a$var$_callSuper(t, o, e) {
    return o = $309e5de50d4b709a$var$_getPrototypeOf(o), $309e5de50d4b709a$var$_possibleConstructorReturn(t, $309e5de50d4b709a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $309e5de50d4b709a$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $309e5de50d4b709a$var$_possibleConstructorReturn(self, call) {
    if (call && ($309e5de50d4b709a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $309e5de50d4b709a$var$_assertThisInitialized(self);
}
function $309e5de50d4b709a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $309e5de50d4b709a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($309e5de50d4b709a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $309e5de50d4b709a$var$_getPrototypeOf(o) {
    $309e5de50d4b709a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $309e5de50d4b709a$var$_getPrototypeOf(o);
}
function $309e5de50d4b709a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $309e5de50d4b709a$var$_setPrototypeOf(subClass, superClass);
}
function $309e5de50d4b709a$var$_setPrototypeOf(o, p) {
    $309e5de50d4b709a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $309e5de50d4b709a$var$_setPrototypeOf(o, p);
}
function $309e5de50d4b709a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $309e5de50d4b709a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $309e5de50d4b709a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $309e5de50d4b709a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $309e5de50d4b709a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $309e5de50d4b709a$var$_defineProperty(obj, key, value) {
    key = $309e5de50d4b709a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $309e5de50d4b709a$var$_toPropertyKey(t) {
    var i = $309e5de50d4b709a$var$_toPrimitive(t, "string");
    return "symbol" == $309e5de50d4b709a$var$_typeof(i) ? i : i + "";
}
function $309e5de50d4b709a$var$_toPrimitive(t, r) {
    if ("object" != $309e5de50d4b709a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $309e5de50d4b709a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $309e5de50d4b709a$var$_slicedToArray(arr, i) {
    return $309e5de50d4b709a$var$_arrayWithHoles(arr) || $309e5de50d4b709a$var$_iterableToArrayLimit(arr, i) || $309e5de50d4b709a$var$_unsupportedIterableToArray(arr, i) || $309e5de50d4b709a$var$_nonIterableRest();
}
function $309e5de50d4b709a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $309e5de50d4b709a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $309e5de50d4b709a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $309e5de50d4b709a$var$_arrayLikeToArray(o, minLen);
}
function $309e5de50d4b709a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $309e5de50d4b709a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $309e5de50d4b709a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $309e5de50d4b709a$var$_extends() {
    $309e5de50d4b709a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $309e5de50d4b709a$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $309e5de50d4b709a$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", $309e5de50d4b709a$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $309e5de50d4b709a$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $5bb5d8f737aa8160$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $5bb5d8f737aa8160$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $5bb5d8f737aa8160$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($7604b2cab047631b$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $309e5de50d4b709a$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $9af926f5cfd576a1$export$71e825c43eae6ca6)();
    var xAxis = (0, $9af926f5cfd576a1$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $9af926f5cfd576a1$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $9af926f5cfd576a1$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $5fe31a8e04253623$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(fixedX);
    var isY = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $309e5de50d4b709a$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $309e5de50d4b709a$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $5bb5d8f737aa8160$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $309e5de50d4b709a$var$_objectSpread($309e5de50d4b709a$var$_objectSpread({
        clipPath: clipPath
    }, (0, $965140f0fb236676$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
        className: (0, $jYj5L.default)("recharts-reference-line", className)
    }, $309e5de50d4b709a$var$renderLine(shape, lineProps), (0, $9562285a10d8e530$export$b04be29aa201d4f5).renderCallByParent(props, (0, $5fe31a8e04253623$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $309e5de50d4b709a$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $309e5de50d4b709a$var$_classCallCheck(this, ReferenceLine);
        return $309e5de50d4b709a$var$_callSuper(this, ReferenceLine, arguments);
    }
    $309e5de50d4b709a$var$_inherits(ReferenceLine, _React$Component);
    return $309e5de50d4b709a$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($309e5de50d4b709a$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
$309e5de50d4b709a$var$_defineProperty($309e5de50d4b709a$export$b2f28e248e7838eb, "displayName", "ReferenceLine");
$309e5de50d4b709a$var$_defineProperty($309e5de50d4b709a$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
});



var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");








function $ded4202e4056c649$var$_extends() {
    $ded4202e4056c649$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ded4202e4056c649$var$_extends.apply(this, arguments);
}
function $ded4202e4056c649$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ded4202e4056c649$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ded4202e4056c649$var$_typeof(o);
}
function $ded4202e4056c649$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ded4202e4056c649$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ded4202e4056c649$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ded4202e4056c649$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ded4202e4056c649$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ded4202e4056c649$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ded4202e4056c649$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ded4202e4056c649$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ded4202e4056c649$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ded4202e4056c649$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ded4202e4056c649$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ded4202e4056c649$var$_callSuper(t, o, e) {
    return o = $ded4202e4056c649$var$_getPrototypeOf(o), $ded4202e4056c649$var$_possibleConstructorReturn(t, $ded4202e4056c649$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ded4202e4056c649$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ded4202e4056c649$var$_possibleConstructorReturn(self, call) {
    if (call && ($ded4202e4056c649$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ded4202e4056c649$var$_assertThisInitialized(self);
}
function $ded4202e4056c649$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ded4202e4056c649$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ded4202e4056c649$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ded4202e4056c649$var$_getPrototypeOf(o) {
    $ded4202e4056c649$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ded4202e4056c649$var$_getPrototypeOf(o);
}
function $ded4202e4056c649$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ded4202e4056c649$var$_setPrototypeOf(subClass, superClass);
}
function $ded4202e4056c649$var$_setPrototypeOf(o, p) {
    $ded4202e4056c649$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ded4202e4056c649$var$_setPrototypeOf(o, p);
}
function $ded4202e4056c649$var$_defineProperty(obj, key, value) {
    key = $ded4202e4056c649$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ded4202e4056c649$var$_toPropertyKey(t) {
    var i = $ded4202e4056c649$var$_toPrimitive(t, "string");
    return "symbol" == $ded4202e4056c649$var$_typeof(i) ? i : i + "";
}
function $ded4202e4056c649$var$_toPrimitive(t, r) {
    if ("object" != $ded4202e4056c649$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ded4202e4056c649$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ded4202e4056c649$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $5fe31a8e04253623$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $5bb5d8f737aa8160$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $5fe31a8e04253623$export$c7964a5b9439ae62)(p1, p2);
};
var $ded4202e4056c649$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $ded4202e4056c649$var$_classCallCheck(this, ReferenceArea);
        return $ded4202e4056c649$var$_callSuper(this, ReferenceArea, arguments);
    }
    $ded4202e4056c649$var$_inherits(ReferenceArea, _React$Component);
    return $ded4202e4056c649$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $79dc871ee192b9d5$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $ded4202e4056c649$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $5bb5d8f737aa8160$export$3fb112445eb31879)(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: (0, $jYj5L.default)("recharts-reference-area", className)
                }, ReferenceArea.renderRect(shape, $ded4202e4056c649$var$_objectSpread($ded4202e4056c649$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $9562285a10d8e530$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
$ded4202e4056c649$var$_defineProperty($ded4202e4056c649$export$b4ec4f050ce240b9, "displayName", "ReferenceArea");
$ded4202e4056c649$var$_defineProperty($ded4202e4056c649$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
});
$ded4202e4056c649$var$_defineProperty($ded4202e4056c649$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1ecd0fe698309bfc$export$4617fb02663045ef), $ded4202e4056c649$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $ac6c249a7a4eaa43$var$_toConsumableArray(arr) {
    return $ac6c249a7a4eaa43$var$_arrayWithoutHoles(arr) || $ac6c249a7a4eaa43$var$_iterableToArray(arr) || $ac6c249a7a4eaa43$var$_unsupportedIterableToArray(arr) || $ac6c249a7a4eaa43$var$_nonIterableSpread();
}
function $ac6c249a7a4eaa43$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ac6c249a7a4eaa43$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ac6c249a7a4eaa43$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ac6c249a7a4eaa43$var$_arrayLikeToArray(o, minLen);
}
function $ac6c249a7a4eaa43$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ac6c249a7a4eaa43$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ac6c249a7a4eaa43$var$_arrayLikeToArray(arr);
}
function $ac6c249a7a4eaa43$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ac6c249a7a4eaa43$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, (0, $309e5de50d4b709a$export$b2f28e248e7838eb));
    var dots = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, (0, $40b6d809c89a243a$export$aa7f0b0106bff39));
    var elements = [].concat($ac6c249a7a4eaa43$var$_toConsumableArray(lines), $ac6c249a7a4eaa43$var$_toConsumableArray(dots));
    var areas = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, (0, $ded4202e4056c649$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $5bb5d8f737aa8160$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $5bb5d8f737aa8160$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(el.props[key1]) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};





var $1cb5b69797ed5055$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($3b0df4630db937bd$exports)))();
var $1cb5b69797ed5055$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents";



function $fa49ebb71ccbe8c6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fa49ebb71ccbe8c6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fa49ebb71ccbe8c6$var$_typeof(o);
}
function $fa49ebb71ccbe8c6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fa49ebb71ccbe8c6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fa49ebb71ccbe8c6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fa49ebb71ccbe8c6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fa49ebb71ccbe8c6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fa49ebb71ccbe8c6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fa49ebb71ccbe8c6$var$_defineProperty(obj, key, value) {
    key = $fa49ebb71ccbe8c6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fa49ebb71ccbe8c6$var$_toPropertyKey(t) {
    var i = $fa49ebb71ccbe8c6$var$_toPrimitive(t, "string");
    return "symbol" == $fa49ebb71ccbe8c6$var$_typeof(i) ? i : i + "";
}
function $fa49ebb71ccbe8c6$var$_toPrimitive(t, r) {
    if ("object" != $fa49ebb71ccbe8c6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fa49ebb71ccbe8c6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fa49ebb71ccbe8c6$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $fa49ebb71ccbe8c6$var$_classCallCheck(this, AccessibilityManager);
        $fa49ebb71ccbe8c6$var$_defineProperty(this, "activeIndex", 0);
        $fa49ebb71ccbe8c6$var$_defineProperty(this, "coordinateList", []);
        $fa49ebb71ccbe8c6$var$_defineProperty(this, "layout", "horizontal");
    }
    return $fa49ebb71ccbe8c6$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $761b32d9d3474747$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(domainStart) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");


var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");


function $66e18d0f6df79b3c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $66e18d0f6df79b3c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $66e18d0f6df79b3c$var$_typeof(o);
}
var $66e18d0f6df79b3c$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $66e18d0f6df79b3c$var$_extends() {
    $66e18d0f6df79b3c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $66e18d0f6df79b3c$var$_extends.apply(this, arguments);
}
function $66e18d0f6df79b3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66e18d0f6df79b3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66e18d0f6df79b3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $66e18d0f6df79b3c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66e18d0f6df79b3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $66e18d0f6df79b3c$var$_defineProperty(obj, key, value) {
    key = $66e18d0f6df79b3c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $66e18d0f6df79b3c$var$_toPropertyKey(t) {
    var i = $66e18d0f6df79b3c$var$_toPrimitive(t, "string");
    return "symbol" == $66e18d0f6df79b3c$var$_typeof(i) ? i : i + "";
}
function $66e18d0f6df79b3c$var$_toPrimitive(t, r) {
    if ("object" != $66e18d0f6df79b3c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $66e18d0f6df79b3c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $66e18d0f6df79b3c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $66e18d0f6df79b3c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $66e18d0f6df79b3c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $66e18d0f6df79b3c$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $66e18d0f6df79b3c$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $66e18d0f6df79b3c$var$_objectWithoutProperties(_ref, $66e18d0f6df79b3c$var$_excluded);
    var props = $66e18d0f6df79b3c$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(x) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(y) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(width) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(height) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(top) || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", $66e18d0f6df79b3c$var$_extends({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(props, true), {
        className: (0, $jYj5L.default)("recharts-cross", className),
        d: $66e18d0f6df79b3c$var$getPath(x, y, width, height, top, left)
    }));
};


function $594d87b6df0384eb$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: "none",
        fill: "#ccc",
        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $61eab4b2c5c70a10$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $7e45c4c1b8617d06$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === "horizontal") {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === "vertical") {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === "centric") {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $61eab4b2c5c70a10$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $c1d9c4c33cb89bef$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c1d9c4c33cb89bef$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c1d9c4c33cb89bef$var$_typeof(o);
}
function $c1d9c4c33cb89bef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1d9c4c33cb89bef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1d9c4c33cb89bef$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c1d9c4c33cb89bef$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1d9c4c33cb89bef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c1d9c4c33cb89bef$var$_defineProperty(obj, key, value) {
    key = $c1d9c4c33cb89bef$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c1d9c4c33cb89bef$var$_toPropertyKey(t) {
    var i = $c1d9c4c33cb89bef$var$_toPrimitive(t, "string");
    return "symbol" == $c1d9c4c33cb89bef$var$_typeof(i) ? i : i + "";
}
function $c1d9c4c33cb89bef$var$_toPrimitive(t, r) {
    if ("object" != $c1d9c4c33cb89bef$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c1d9c4c33cb89bef$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c1d9c4c33cb89bef$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
    var restProps;
    var cursorComp = (0, $dadf1ea33698de40$export$b0e83c3ef8d2db1);
    if (chartName === "ScatterChart") {
        restProps = activeCoordinate;
        cursorComp = (0, $66e18d0f6df79b3c$export$3c877bb842c36952);
    } else if (chartName === "BarChart") {
        restProps = (0, $594d87b6df0384eb$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $1ecd0fe698309bfc$export$4617fb02663045ef);
    } else if (layout === "radial") {
        var _getRadialCursorPoint = (0, $61eab4b2c5c70a10$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $8af17cf8f6c51679$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $7e45c4c1b8617d06$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $dadf1ea33698de40$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $c1d9c4c33cb89bef$var$_objectSpread($c1d9c4c33cb89bef$var$_objectSpread($c1d9c4c33cb89bef$var$_objectSpread($c1d9c4c33cb89bef$var$_objectSpread({
        stroke: "#ccc",
        pointerEvents: "none"
    }, offset), restProps), (0, $965140f0fb236676$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $jYj5L.default)("recharts-tooltip-cursor", elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $cQmXV.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $cQmXV.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $cQmXV.createElement)(cursorComp, cursorProps);
}



var $27ce949e79d40f57$var$_excluded = [
    "item"
], $27ce949e79d40f57$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $27ce949e79d40f57$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $27ce949e79d40f57$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $27ce949e79d40f57$var$_typeof(o);
}
function $27ce949e79d40f57$var$_extends() {
    $27ce949e79d40f57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $27ce949e79d40f57$var$_extends.apply(this, arguments);
}
function $27ce949e79d40f57$var$_slicedToArray(arr, i) {
    return $27ce949e79d40f57$var$_arrayWithHoles(arr) || $27ce949e79d40f57$var$_iterableToArrayLimit(arr, i) || $27ce949e79d40f57$var$_unsupportedIterableToArray(arr, i) || $27ce949e79d40f57$var$_nonIterableRest();
}
function $27ce949e79d40f57$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $27ce949e79d40f57$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $27ce949e79d40f57$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $27ce949e79d40f57$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $27ce949e79d40f57$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $27ce949e79d40f57$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $27ce949e79d40f57$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $27ce949e79d40f57$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $27ce949e79d40f57$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $27ce949e79d40f57$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $27ce949e79d40f57$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $27ce949e79d40f57$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $27ce949e79d40f57$var$_callSuper(t, o, e) {
    return o = $27ce949e79d40f57$var$_getPrototypeOf(o), $27ce949e79d40f57$var$_possibleConstructorReturn(t, $27ce949e79d40f57$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $27ce949e79d40f57$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $27ce949e79d40f57$var$_possibleConstructorReturn(self, call) {
    if (call && ($27ce949e79d40f57$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $27ce949e79d40f57$var$_assertThisInitialized(self);
}
function $27ce949e79d40f57$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $27ce949e79d40f57$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($27ce949e79d40f57$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $27ce949e79d40f57$var$_getPrototypeOf(o) {
    $27ce949e79d40f57$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $27ce949e79d40f57$var$_getPrototypeOf(o);
}
function $27ce949e79d40f57$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $27ce949e79d40f57$var$_setPrototypeOf(subClass, superClass);
}
function $27ce949e79d40f57$var$_setPrototypeOf(o, p) {
    $27ce949e79d40f57$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $27ce949e79d40f57$var$_setPrototypeOf(o, p);
}
function $27ce949e79d40f57$var$_toConsumableArray(arr) {
    return $27ce949e79d40f57$var$_arrayWithoutHoles(arr) || $27ce949e79d40f57$var$_iterableToArray(arr) || $27ce949e79d40f57$var$_unsupportedIterableToArray(arr) || $27ce949e79d40f57$var$_nonIterableSpread();
}
function $27ce949e79d40f57$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $27ce949e79d40f57$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $27ce949e79d40f57$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $27ce949e79d40f57$var$_arrayLikeToArray(o, minLen);
}
function $27ce949e79d40f57$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $27ce949e79d40f57$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $27ce949e79d40f57$var$_arrayLikeToArray(arr);
}
function $27ce949e79d40f57$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $27ce949e79d40f57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27ce949e79d40f57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27ce949e79d40f57$var$ownKeys(Object(t), !0).forEach(function(r) {
            $27ce949e79d40f57$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27ce949e79d40f57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $27ce949e79d40f57$var$_defineProperty(obj, key, value) {
    key = $27ce949e79d40f57$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27ce949e79d40f57$var$_toPropertyKey(t) {
    var i = $27ce949e79d40f57$var$_toPrimitive(t, "string");
    return "symbol" == $27ce949e79d40f57$var$_typeof(i) ? i : i + "";
}
function $27ce949e79d40f57$var$_toPrimitive(t, r) {
    if ("object" != $27ce949e79d40f57$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $27ce949e79d40f57$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $27ce949e79d40f57$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $27ce949e79d40f57$var$FULL_WIDTH_AND_HEIGHT = {
    width: "100%",
    height: "100%"
};
var $27ce949e79d40f57$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $27ce949e79d40f57$var$renderAsIs(element) {
    return element;
}
var $27ce949e79d40f57$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $27ce949e79d40f57$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, rangeObj), (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, rangeObj), (0, $2bae62bd6f9484f1$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $27ce949e79d40f57$var$originCoordinate;
};
var $27ce949e79d40f57$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($27ce949e79d40f57$var$_toConsumableArray(result), $27ce949e79d40f57$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(dataStartIndex) && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $27ce949e79d40f57$var$getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $27ce949e79d40f57$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $27ce949e79d40f57$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $79dc871ee192b9d5$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($27ce949e79d40f57$var$_toConsumableArray(result), [
            (0, $f6dbe45301cbc2ff$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $27ce949e79d40f57$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $27ce949e79d40f57$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $f6dbe45301cbc2ff$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $27ce949e79d40f57$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $27ce949e79d40f57$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $27ce949e79d40f57$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $f6dbe45301cbc2ff$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $27ce949e79d40f57$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $761b32d9d3474747$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $f6dbe45301cbc2ff$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $f6dbe45301cbc2ff$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $27ce949e79d40f57$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $f6dbe45301cbc2ff$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $79dc871ee192b9d5$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($7bdcae63dd739032$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $f6dbe45301cbc2ff$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($27ce949e79d40f57$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $f6dbe45301cbc2ff$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(entry) ? finalDomain : [].concat($27ce949e79d40f57$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $f6dbe45301cbc2ff$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $f6dbe45301cbc2ff$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($7bdcae63dd739032$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $f6dbe45301cbc2ff$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $f6dbe45301cbc2ff$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = "hide" in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $ac6c249a7a4eaa43$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $f6dbe45301cbc2ff$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, result), {}, $27ce949e79d40f57$var$_defineProperty({}, axisId, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $27ce949e79d40f57$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $27ce949e79d40f57$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $f6dbe45301cbc2ff$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $27ce949e79d40f57$var$getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($7bdcae63dd739032$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $f6dbe45301cbc2ff$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $ac6c249a7a4eaa43$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $f6dbe45301cbc2ff$export$a0bc8660980558a0)(originalDomain, (0, $f6dbe45301cbc2ff$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $ac6c249a7a4eaa43$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, result), {}, $27ce949e79d40f57$var$_defineProperty({}, axisId, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))($27ce949e79d40f57$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $27ce949e79d40f57$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $27ce949e79d40f57$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $27ce949e79d40f57$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $27ce949e79d40f57$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($61042b531d0b8b0c$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $f6dbe45301cbc2ff$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $27ce949e79d40f57$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $e86a127d716d0c82$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $27ce949e79d40f57$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $965140f0fb236676$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $27ce949e79d40f57$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $27ce949e79d40f57$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $e86a127d716d0c82$export$59bc2e3533b384a0));
    var legendItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $81272ed3f26141a8$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, result), {}, $27ce949e79d40f57$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, result), {}, $27ce949e79d40f57$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $e86a127d716d0c82$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $f6dbe45301cbc2ff$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $27ce949e79d40f57$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === "xAxis") return axisObj[axisName].width;
    if (axisName === "yAxis") return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $27ce949e79d40f57$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $27ce949e79d40f57$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $27ce949e79d40f57$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $27ce949e79d40f57$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === "zAxis") && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, result), {}, $27ce949e79d40f57$var$_defineProperty($27ce949e79d40f57$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $f6dbe45301cbc2ff$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $965140f0fb236676$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $f6dbe45301cbc2ff$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $f6dbe45301cbc2ff$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $27ce949e79d40f57$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $f6dbe45301cbc2ff$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $f6dbe45301cbc2ff$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, pos), {}, {
                        position: $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, composedFn($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $27ce949e79d40f57$var$_defineProperty($27ce949e79d40f57$var$_defineProperty($27ce949e79d40f57$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $965140f0fb236676$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $965140f0fb236676$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $27ce949e79d40f57$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $965140f0fb236676$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $f6dbe45301cbc2ff$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, result), {}, $27ce949e79d40f57$var$_defineProperty({}, name, $27ce949e79d40f57$var$getAxisMap(props, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $27ce949e79d40f57$var$calculateOffset($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $27ce949e79d40f57$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $27ce949e79d40f57$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $27ce949e79d40f57$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $27ce949e79d40f57$var$_defineProperty(_this, "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
            $27ce949e79d40f57$var$_defineProperty(_this, "accessibilityManager", new (0, $fa49ebb71ccbe8c6$export$a2c2de1efa8671eb)());
            $27ce949e79d40f57$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($27ce949e79d40f57$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") return;
                    _this.applySyncEvent(data);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $27ce949e79d40f57$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $27ce949e79d40f57$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $27ce949e79d40f57$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $27ce949e79d40f57$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $27ce949e79d40f57$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $27ce949e79d40f57$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $965140f0fb236676$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $1cb5b69797ed5055$export$9bcdfe5f29bb33).emit((0, $1cb5b69797ed5055$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($27ce949e79d40f57$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === "value") {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $27ce949e79d40f57$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $27ce949e79d40f57$var$originCoordinate;
                    _this.setState($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || "_recharts-cursor";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $c1d9c4c33cb89bef$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $cQmXV.cloneElement)(element, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $jYj5L.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $cQmXV.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $27ce949e79d40f57$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $170743ee91188a38$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $27ce949e79d40f57$var$_objectWithoutProperties(props, $27ce949e79d40f57$var$_excluded);
                return /*#__PURE__*/ (0, $cQmXV.cloneElement)(item, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $27ce949e79d40f57$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $ed7cfa2289a9738b$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $cQmXV.cloneElement)(tooltipItem, {
                    viewBox: $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $cQmXV.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $f6dbe45301cbc2ff$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $cQmXV.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $f6dbe45301cbc2ff$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $965140f0fb236676$export$d697c39a2985a4c)(activeDot, false)), (0, $d0c9e9f30a5b8447$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $ed7cfa2289a9738b$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $f6dbe45301cbc2ff$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $f6dbe45301cbc2ff$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $f6dbe45301cbc2ff$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $cQmXV.cloneElement)(element, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $79dc871ee192b9d5$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $79dc871ee192b9d5$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $cQmXV.cloneElement)(element, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($27ce949e79d40f57$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $cQmXV.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $cQmXV.cloneElement)(element, $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $27ce949e79d40f57$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $27ce949e79d40f57$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $27ce949e79d40f57$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $27ce949e79d40f57$var$renderAsIs
                },
                YAxis: {
                    handler: $27ce949e79d40f57$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $79dc871ee192b9d5$export$8b15d37bc3f197d4)("recharts"), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($cb6c7ff4ad5eb4d8$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $27ce949e79d40f57$var$_inherits(CategoricalChartWrapper, _Component);
        return $27ce949e79d40f57$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $ed7cfa2289a9738b$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== "number" || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $27ce949e79d40f57$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === "horizontal";
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === "Scatter";
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $965140f0fb236676$export$acdc716e08572f94)([
                        (0, $965140f0fb236676$export$64c61536a2b72e0f)(prevProps.children, (0, $ed7cfa2289a9738b$export$28c660c63b792dea))
                    ], [
                        (0, $965140f0fb236676$export$64c61536a2b72e0f)(this.props.children, (0, $ed7cfa2289a9738b$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(this.props.children, (0, $ed7cfa2289a9738b$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === "boolean") {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $fd8f41d0bb15fb8e$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $27ce949e79d40f57$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $79dc871ee192b9d5$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $2bae62bd6f9484f1$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $ed7cfa2289a9738b$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $d0c9e9f30a5b8447$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $1cb5b69797ed5055$export$9bcdfe5f29bb33).on((0, $1cb5b69797ed5055$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $1cb5b69797ed5055$export$9bcdfe5f29bb33).removeListener((0, $1cb5b69797ed5055$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $965140f0fb236676$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $27ce949e79d40f57$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, res), {}, $27ce949e79d40f57$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $27ce949e79d40f57$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, res), {}, $27ce949e79d40f57$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $965140f0fb236676$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $1ecd0fe698309bfc$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $2bae62bd6f9484f1$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $69bb41748f50bfe4$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $69bb41748f50bfe4$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $69bb41748f50bfe4$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $69bb41748f50bfe4$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $69bb41748f50bfe4$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $965140f0fb236676$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $27ce949e79d40f57$var$_objectWithoutProperties(_this$props6, $27ce949e79d40f57$var$_excluded2);
                    var attrs = (0, $965140f0fb236676$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $9af926f5cfd576a1$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $17588da4b0ad5146$export$7b92b459e668cb21), $27ce949e79d40f57$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $965140f0fb236676$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "application";
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $9af926f5cfd576a1$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", $27ce949e79d40f57$var$_extends({
                        className: (0, $jYj5L.default)("recharts-wrapper", className),
                        style: $27ce949e79d40f57$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $17588da4b0ad5146$export$7b92b459e668cb21), $27ce949e79d40f57$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $27ce949e79d40f57$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $965140f0fb236676$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $cQmXV.Component));
    $27ce949e79d40f57$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $27ce949e79d40f57$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $27ce949e79d40f57$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps));
    $27ce949e79d40f57$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $27ce949e79d40f57$export$e5182fb58612e577(nextProps);
            return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $221ea5494c34ef3a$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $27ce949e79d40f57$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, $27ce949e79d40f57$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($27ce949e79d40f57$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $965140f0fb236676$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $965140f0fb236676$export$64c61536a2b72e0f)(children, (0, $e86a127d716d0c82$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($80faf5e2a7d54edd$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($27ce949e79d40f57$var$_objectSpread($27ce949e79d40f57$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $27ce949e79d40f57$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(option)) dot = /*#__PURE__*/ (0, $cQmXV.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $79400970f1e9c5ee$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $cQmXV.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(CategoricalChartWrapper, $27ce949e79d40f57$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");


var $cQmXV = parcelRequire("cQmXV");



var $jYj5L = parcelRequire("jYj5L");












/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $0d96971d0d29aa59$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $9da2ac4cdbc07a72$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $5fe31a8e04253623$export$3ee78d51cffc2b68)(size, angle);
}
function $9da2ac4cdbc07a72$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === "width";
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $9da2ac4cdbc07a72$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $9da2ac4cdbc07a72$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $0d96971d0d29aa59$export$41514b9f058a6886)(ticks, interval + 1);
}




function $176651ee666a6d0c$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $0d96971d0d29aa59$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $9da2ac4cdbc07a72$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $b2266e28842b38a5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b2266e28842b38a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b2266e28842b38a5$var$_typeof(o);
}
function $b2266e28842b38a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2266e28842b38a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2266e28842b38a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b2266e28842b38a5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2266e28842b38a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b2266e28842b38a5$var$_defineProperty(obj, key, value) {
    key = $b2266e28842b38a5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b2266e28842b38a5$var$_toPropertyKey(t) {
    var i = $b2266e28842b38a5$var$_toPrimitive(t, "string");
    return "symbol" == $b2266e28842b38a5$var$_typeof(i) ? i : i + "";
}
function $b2266e28842b38a5$var$_toPrimitive(t, r) {
    if ("object" != $b2266e28842b38a5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b2266e28842b38a5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b2266e28842b38a5$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $9da2ac4cdbc07a72$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $b2266e28842b38a5$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $9da2ac4cdbc07a72$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $9da2ac4cdbc07a72$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $b2266e28842b38a5$var$_objectSpread($b2266e28842b38a5$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $b2266e28842b38a5$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $79dc871ee192b9d5$export$7e4aa119212bc614)(interval) || (0, $783cbc8e17e1e389$export$98f03c5d19621d70).isSsr) return (0, $9da2ac4cdbc07a72$export$beeebbe3ff1b306b)(ticks, typeof interval === "number" && (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var unitSize = unit && sizeKey === "width" ? (0, $fd8f41d0bb15fb8e$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === "width" ? (0, $9da2ac4cdbc07a72$export$a1966f4ad955c82b)((0, $fd8f41d0bb15fb8e$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $fd8f41d0bb15fb8e$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $79dc871ee192b9d5$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $9da2ac4cdbc07a72$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === "equidistantPreserveStart") return (0, $176651ee666a6d0c$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = $b2266e28842b38a5$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === "preserveStartEnd");
    else candidates = $b2266e28842b38a5$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $c4042b71e1a23913$var$_excluded = [
    "viewBox"
], $c4042b71e1a23913$var$_excluded2 = [
    "viewBox"
], $c4042b71e1a23913$var$_excluded3 = [
    "ticks"
];
function $c4042b71e1a23913$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c4042b71e1a23913$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c4042b71e1a23913$var$_typeof(o);
}
function $c4042b71e1a23913$var$_extends() {
    $c4042b71e1a23913$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c4042b71e1a23913$var$_extends.apply(this, arguments);
}
function $c4042b71e1a23913$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4042b71e1a23913$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4042b71e1a23913$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c4042b71e1a23913$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4042b71e1a23913$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c4042b71e1a23913$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c4042b71e1a23913$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c4042b71e1a23913$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c4042b71e1a23913$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c4042b71e1a23913$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c4042b71e1a23913$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c4042b71e1a23913$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c4042b71e1a23913$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c4042b71e1a23913$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c4042b71e1a23913$var$_callSuper(t, o, e) {
    return o = $c4042b71e1a23913$var$_getPrototypeOf(o), $c4042b71e1a23913$var$_possibleConstructorReturn(t, $c4042b71e1a23913$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c4042b71e1a23913$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c4042b71e1a23913$var$_possibleConstructorReturn(self, call) {
    if (call && ($c4042b71e1a23913$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c4042b71e1a23913$var$_assertThisInitialized(self);
}
function $c4042b71e1a23913$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c4042b71e1a23913$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c4042b71e1a23913$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c4042b71e1a23913$var$_getPrototypeOf(o) {
    $c4042b71e1a23913$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c4042b71e1a23913$var$_getPrototypeOf(o);
}
function $c4042b71e1a23913$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c4042b71e1a23913$var$_setPrototypeOf(subClass, superClass);
}
function $c4042b71e1a23913$var$_setPrototypeOf(o, p) {
    $c4042b71e1a23913$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c4042b71e1a23913$var$_setPrototypeOf(o, p);
}
function $c4042b71e1a23913$var$_defineProperty(obj, key, value) {
    key = $c4042b71e1a23913$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c4042b71e1a23913$var$_toPropertyKey(t) {
    var i = $c4042b71e1a23913$var$_toPrimitive(t, "string");
    return "symbol" == $c4042b71e1a23913$var$_typeof(i) ? i : i + "";
}
function $c4042b71e1a23913$var$_toPrimitive(t, r) {
    if ("object" != $c4042b71e1a23913$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c4042b71e1a23913$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c4042b71e1a23913$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $c4042b71e1a23913$var$_classCallCheck(this, CartesianAxis);
        _this = $c4042b71e1a23913$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    $c4042b71e1a23913$var$_inherits(CartesianAxis, _Component);
    return $c4042b71e1a23913$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $c4042b71e1a23913$var$_objectWithoutProperties(_ref, $c4042b71e1a23913$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $c4042b71e1a23913$var$_objectWithoutProperties(_this$props, $c4042b71e1a23913$var$_excluded2);
                return !(0, $221ea5494c34ef3a$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $221ea5494c34ef3a$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $221ea5494c34ef3a$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({}, (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, false)), (0, $965140f0fb236676$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", $c4042b71e1a23913$var$_extends({}, props, {
                    className: (0, $jYj5L.default)("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $b2266e28842b38a5$export$3d27d42b1034de5c)($c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $965140f0fb236676$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), $c4042b71e1a23913$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $d0c9e9f30a5b8447$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", $c4042b71e1a23913$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $jYj5L.default)("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($68f87bdfec72f252$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $c4042b71e1a23913$var$_objectWithoutProperties(_this$props8, $c4042b71e1a23913$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $889cf7caffaee974$export$936d0764594b6eb3), {
                    className: (0, $jYj5L.default)("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $9562285a10d8e530$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                var combinedClassName = (0, $jYj5L.default)(props.className, "recharts-cartesian-axis-tick-value");
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(option, $c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) tickItem = option($c4042b71e1a23913$var$_objectSpread($c4042b71e1a23913$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $a9394abe12cd4740$export$5f1af8db9871e1d6), $c4042b71e1a23913$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $cQmXV.Component));
$c4042b71e1a23913$var$_defineProperty($c4042b71e1a23913$export$bdd99f2cdf352bae, "displayName", "CartesianAxis");
$c4042b71e1a23913$var$_defineProperty($c4042b71e1a23913$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});



function $495abb3f1d04b5fb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $495abb3f1d04b5fb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $495abb3f1d04b5fb$var$_typeof(o);
}
function $495abb3f1d04b5fb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $495abb3f1d04b5fb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $495abb3f1d04b5fb$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $495abb3f1d04b5fb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $495abb3f1d04b5fb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $495abb3f1d04b5fb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $495abb3f1d04b5fb$var$_callSuper(t, o, e) {
    return o = $495abb3f1d04b5fb$var$_getPrototypeOf(o), $495abb3f1d04b5fb$var$_possibleConstructorReturn(t, $495abb3f1d04b5fb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $495abb3f1d04b5fb$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $495abb3f1d04b5fb$var$_possibleConstructorReturn(self, call) {
    if (call && ($495abb3f1d04b5fb$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $495abb3f1d04b5fb$var$_assertThisInitialized(self);
}
function $495abb3f1d04b5fb$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $495abb3f1d04b5fb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($495abb3f1d04b5fb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $495abb3f1d04b5fb$var$_getPrototypeOf(o) {
    $495abb3f1d04b5fb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $495abb3f1d04b5fb$var$_getPrototypeOf(o);
}
function $495abb3f1d04b5fb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $495abb3f1d04b5fb$var$_setPrototypeOf(subClass, superClass);
}
function $495abb3f1d04b5fb$var$_setPrototypeOf(o, p) {
    $495abb3f1d04b5fb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $495abb3f1d04b5fb$var$_setPrototypeOf(o, p);
}
function $495abb3f1d04b5fb$var$_defineProperty(obj, key, value) {
    key = $495abb3f1d04b5fb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $495abb3f1d04b5fb$var$_toPropertyKey(t) {
    var i = $495abb3f1d04b5fb$var$_toPrimitive(t, "string");
    return "symbol" == $495abb3f1d04b5fb$var$_typeof(i) ? i : i + "";
}
function $495abb3f1d04b5fb$var$_toPrimitive(t, r) {
    if ("object" != $495abb3f1d04b5fb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $495abb3f1d04b5fb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $495abb3f1d04b5fb$var$_extends() {
    $495abb3f1d04b5fb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $495abb3f1d04b5fb$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $495abb3f1d04b5fb$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $9af926f5cfd576a1$export$8854f7ece606854b)();
    var height = (0, $9af926f5cfd576a1$export$369ae257969c6f9f)();
    var axisOptions = (0, $9af926f5cfd576a1$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $cQmXV.createElement((0, $c4042b71e1a23913$export$bdd99f2cdf352bae), $495abb3f1d04b5fb$var$_extends({}, axisOptions, {
        className: (0, $jYj5L.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $495abb3f1d04b5fb$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $495abb3f1d04b5fb$var$_classCallCheck(this, XAxis);
        return $495abb3f1d04b5fb$var$_callSuper(this, XAxis, arguments);
    }
    $495abb3f1d04b5fb$var$_inherits(XAxis, _React$Component);
    return $495abb3f1d04b5fb$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $cQmXV.createElement($495abb3f1d04b5fb$var$XAxisImpl, this.props);
            }
        }
    ]);
}($cQmXV.Component);
$495abb3f1d04b5fb$var$_defineProperty($495abb3f1d04b5fb$export$ea77231de273b52d, "displayName", "XAxis");
$495abb3f1d04b5fb$var$_defineProperty($495abb3f1d04b5fb$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
});



var $cQmXV = parcelRequire("cQmXV");

var $jYj5L = parcelRequire("jYj5L");



function $88cb171c719dd9d9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $88cb171c719dd9d9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $88cb171c719dd9d9$var$_typeof(o);
}
function $88cb171c719dd9d9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $88cb171c719dd9d9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $88cb171c719dd9d9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $88cb171c719dd9d9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $88cb171c719dd9d9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $88cb171c719dd9d9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $88cb171c719dd9d9$var$_callSuper(t, o, e) {
    return o = $88cb171c719dd9d9$var$_getPrototypeOf(o), $88cb171c719dd9d9$var$_possibleConstructorReturn(t, $88cb171c719dd9d9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $88cb171c719dd9d9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $88cb171c719dd9d9$var$_possibleConstructorReturn(self, call) {
    if (call && ($88cb171c719dd9d9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $88cb171c719dd9d9$var$_assertThisInitialized(self);
}
function $88cb171c719dd9d9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $88cb171c719dd9d9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($88cb171c719dd9d9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $88cb171c719dd9d9$var$_getPrototypeOf(o) {
    $88cb171c719dd9d9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $88cb171c719dd9d9$var$_getPrototypeOf(o);
}
function $88cb171c719dd9d9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $88cb171c719dd9d9$var$_setPrototypeOf(subClass, superClass);
}
function $88cb171c719dd9d9$var$_setPrototypeOf(o, p) {
    $88cb171c719dd9d9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $88cb171c719dd9d9$var$_setPrototypeOf(o, p);
}
function $88cb171c719dd9d9$var$_defineProperty(obj, key, value) {
    key = $88cb171c719dd9d9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88cb171c719dd9d9$var$_toPropertyKey(t) {
    var i = $88cb171c719dd9d9$var$_toPrimitive(t, "string");
    return "symbol" == $88cb171c719dd9d9$var$_typeof(i) ? i : i + "";
}
function $88cb171c719dd9d9$var$_toPrimitive(t, r) {
    if ("object" != $88cb171c719dd9d9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $88cb171c719dd9d9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $88cb171c719dd9d9$var$_extends() {
    $88cb171c719dd9d9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $88cb171c719dd9d9$var$_extends.apply(this, arguments);
}
var $88cb171c719dd9d9$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $9af926f5cfd576a1$export$8854f7ece606854b)();
    var height = (0, $9af926f5cfd576a1$export$369ae257969c6f9f)();
    var axisOptions = (0, $9af926f5cfd576a1$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $cQmXV.createElement((0, $c4042b71e1a23913$export$bdd99f2cdf352bae), $88cb171c719dd9d9$var$_extends({}, axisOptions, {
        className: (0, $jYj5L.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $88cb171c719dd9d9$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $88cb171c719dd9d9$var$_classCallCheck(this, YAxis);
        return $88cb171c719dd9d9$var$_callSuper(this, YAxis, arguments);
    }
    $88cb171c719dd9d9$var$_inherits(YAxis, _React$Component);
    return $88cb171c719dd9d9$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $cQmXV.createElement($88cb171c719dd9d9$var$YAxisImpl, this.props);
            }
        }
    ]);
}($cQmXV.Component);
$88cb171c719dd9d9$var$_defineProperty($88cb171c719dd9d9$export$f96c4024c52de8f4, "displayName", "YAxis");
$88cb171c719dd9d9$var$_defineProperty($88cb171c719dd9d9$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
});



var $7e4a81f7141d4477$export$f510429275d6f1a8 = (0, $27ce949e79d40f57$export$77871aede60e6838)({
    chartName: "AreaChart",
    GraphicalChild: (0, $885b4e8e91d1b519$export$ea1a111407f37557),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $495abb3f1d04b5fb$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $88cb171c719dd9d9$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $5fe31a8e04253623$export$ece7de1383db5ac)
});

/**
 * @fileOverview Bar Chart
 */ 




var $e75b1b171602674b$export$94aefc399ef206a9 = (0, $27ce949e79d40f57$export$77871aede60e6838)({
    chartName: "BarChart",
    GraphicalChild: (0, $bce1568d73f81eb0$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: "axis",
    validateTooltipEventTypes: [
        "axis",
        "item"
    ],
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $495abb3f1d04b5fb$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $88cb171c719dd9d9$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $5fe31a8e04253623$export$ece7de1383db5ac)
});


var $cQmXV = parcelRequire("cQmXV");








var $41997b411fa4e9c8$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $41997b411fa4e9c8$var$_excluded2 = [
    "offset"
];
function $41997b411fa4e9c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $41997b411fa4e9c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $41997b411fa4e9c8$var$_typeof(o);
}
function $41997b411fa4e9c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41997b411fa4e9c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41997b411fa4e9c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41997b411fa4e9c8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41997b411fa4e9c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41997b411fa4e9c8$var$_defineProperty(obj, key, value) {
    key = $41997b411fa4e9c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41997b411fa4e9c8$var$_toPropertyKey(t) {
    var i = $41997b411fa4e9c8$var$_toPrimitive(t, "string");
    return "symbol" == $41997b411fa4e9c8$var$_typeof(i) ? i : i + "";
}
function $41997b411fa4e9c8$var$_toPrimitive(t, r) {
    if ("object" != $41997b411fa4e9c8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $41997b411fa4e9c8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $41997b411fa4e9c8$var$_extends() {
    $41997b411fa4e9c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41997b411fa4e9c8$var$_extends.apply(this, arguments);
}
function $41997b411fa4e9c8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $41997b411fa4e9c8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $41997b411fa4e9c8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $41997b411fa4e9c8$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === "none") return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $41997b411fa4e9c8$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $41997b411fa4e9c8$var$_objectWithoutProperties(props, $41997b411fa4e9c8$var$_excluded);
        var _filterProps = (0, $965140f0fb236676$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $41997b411fa4e9c8$var$_objectWithoutProperties(_filterProps, $41997b411fa4e9c8$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("line", $41997b411fa4e9c8$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $41997b411fa4e9c8$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $41997b411fa4e9c8$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $41997b411fa4e9c8$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $41997b411fa4e9c8$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $41997b411fa4e9c8$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $41997b411fa4e9c8$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $41997b411fa4e9c8$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $f6dbe45301cbc2ff$export$846dc5ac5fecff74)((0, $b2266e28842b38a5$export$3d27d42b1034de5c)($41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread({}, (0, $c4042b71e1a23913$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $41997b411fa4e9c8$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $f6dbe45301cbc2ff$export$846dc5ac5fecff74)((0, $b2266e28842b38a5$export$3d27d42b1034de5c)($41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread({}, (0, $c4042b71e1a23913$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $f6dbe45301cbc2ff$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $41997b411fa4e9c8$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $41997b411fa4e9c8$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $9af926f5cfd576a1$export$8854f7ece606854b)();
    var chartHeight = (0, $9af926f5cfd576a1$export$369ae257969c6f9f)();
    var offset = (0, $9af926f5cfd576a1$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $41997b411fa4e9c8$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $41997b411fa4e9c8$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $41997b411fa4e9c8$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $41997b411fa4e9c8$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $41997b411fa4e9c8$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $41997b411fa4e9c8$var$defaultProps.verticalFill,
        x: (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $79dc871ee192b9d5$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $9af926f5cfd576a1$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $9af926f5cfd576a1$export$631ee617f1052e16)();
    if (!(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(x) || x !== +x || !(0, $79dc871ee192b9d5$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $41997b411fa4e9c8$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $41997b411fa4e9c8$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($41997b411fa4e9c8$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($35887ca5f067dffa$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $41997b411fa4e9c8$var$_objectSpread($41997b411fa4e9c8$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($41997b411fa4e9c8$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($41997b411fa4e9c8$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($41997b411fa4e9c8$var$HorizontalGridLines, $41997b411fa4e9c8$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($41997b411fa4e9c8$var$VerticalGridLines, $41997b411fa4e9c8$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($41997b411fa4e9c8$var$HorizontalStripes, $41997b411fa4e9c8$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($41997b411fa4e9c8$var$VerticalStripes, $41997b411fa4e9c8$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$41997b411fa4e9c8$export$6440e27b9f186856.displayName = "CartesianGrid";


var $jYj5L = parcelRequire("jYj5L");

var $cQmXV = parcelRequire("cQmXV");




function $73306b6e867f0316$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $73306b6e867f0316$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73306b6e867f0316$var$_typeof(o);
}
function $73306b6e867f0316$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73306b6e867f0316$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73306b6e867f0316$var$ownKeys(Object(t), !0).forEach(function(r) {
            $73306b6e867f0316$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73306b6e867f0316$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $73306b6e867f0316$var$_defineProperty(obj, key, value) {
    key = $73306b6e867f0316$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73306b6e867f0316$var$_toPropertyKey(t) {
    var i = $73306b6e867f0316$var$_toPrimitive(t, "string");
    return "symbol" == $73306b6e867f0316$var$_typeof(i) ? i : i + "";
}
function $73306b6e867f0316$var$_toPrimitive(t, r) {
    if ("object" != $73306b6e867f0316$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $73306b6e867f0316$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $73306b6e867f0316$var$_slicedToArray(arr, i) {
    return $73306b6e867f0316$var$_arrayWithHoles(arr) || $73306b6e867f0316$var$_iterableToArrayLimit(arr, i) || $73306b6e867f0316$var$_unsupportedIterableToArray(arr, i) || $73306b6e867f0316$var$_nonIterableRest();
}
function $73306b6e867f0316$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $73306b6e867f0316$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $73306b6e867f0316$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $73306b6e867f0316$var$_arrayLikeToArray(o, minLen);
}
function $73306b6e867f0316$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $73306b6e867f0316$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $73306b6e867f0316$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $73306b6e867f0316$export$e60a4704009a0009 = /*#__PURE__*/ (0, $cQmXV.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $cQmXV.useRef)(null);
    var onResizeRef = (0, $cQmXV.useRef)();
    onResizeRef.current = onResize;
    (0, $cQmXV.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, "current", {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn("The usage of ref.current.current is deprecated and will no longer be supported.");
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $cQmXV.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $73306b6e867f0316$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $cQmXV.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $cQmXV.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($cb6c7ff4ad5eb4d8$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $cQmXV.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)((0, $79dc871ee192b9d5$export$e50269385c77c348)(width) || (0, $79dc871ee192b9d5$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $79dc871ee192b9d5$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $79dc871ee192b9d5$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $42f81b1da17a28f1$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $965140f0fb236676$export$be63e0664592e141)(children.type).endsWith("Chart");
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(child)) return /*#__PURE__*/ (0, $cQmXV.cloneElement)(child, $73306b6e867f0316$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $73306b6e867f0316$var$_objectSpread({
                    height: "100%",
                    width: "100%",
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $jYj5L.default)("recharts-responsive-container", className),
        style: $73306b6e867f0316$var$_objectSpread($73306b6e867f0316$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});






// Design-token colours (kept in sync with :root --md-* in modern-theme.css)
const $1aa6f1d8358888de$var$C = {
    primary: "#00ABEB",
    tertiary: "#6672B0",
    secondary: "#5B7A8A",
    grid: "rgba(0, 40, 80, 0.08)",
    axis: "#6B7680"
};
const $1aa6f1d8358888de$var$PAGE_SIZE = 10;
const $1aa6f1d8358888de$var$KPI_META = [
    {
        key: "active_merchandisers",
        icon: "badge",
        color: $1aa6f1d8358888de$var$C.primary
    },
    {
        key: "active_supervisors",
        icon: "supervisor_account",
        color: $1aa6f1d8358888de$var$C.tertiary
    },
    {
        key: "visits",
        icon: "location_on",
        color: $1aa6f1d8358888de$var$C.secondary
    },
    {
        key: "reports",
        icon: "bar_chart",
        color: $1aa6f1d8358888de$var$C.primary
    },
    {
        key: "answers",
        icon: "quiz",
        color: $1aa6f1d8358888de$var$C.tertiary
    }
];
const $1aa6f1d8358888de$var$TREND_SERIES = [
    {
        key: "visits",
        color: $1aa6f1d8358888de$var$C.primary
    },
    {
        key: "reports",
        color: $1aa6f1d8358888de$var$C.tertiary
    },
    {
        key: "answers",
        color: $1aa6f1d8358888de$var$C.secondary
    }
];
const $1aa6f1d8358888de$var$LOCALE = {
    uk: "uk-UA",
    en: "en-US",
    hy: "hy-AM",
    ka: "ka-GE"
};
function $1aa6f1d8358888de$var$pad2(n) {
    return String(n).padStart(2, "0");
}
function $1aa6f1d8358888de$var$currentMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${$1aa6f1d8358888de$var$pad2(d.getMonth() + 1)}`;
}
function $1aa6f1d8358888de$var$addMonths(ym, delta) {
    const [y, m] = ym.split("-").map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    return `${d.getFullYear()}-${$1aa6f1d8358888de$var$pad2(d.getMonth() + 1)}`;
}
function $1aa6f1d8358888de$var$computeDelta(current, previous) {
    if (!previous) {
        if (!current) return {
            pct: 0,
            dir: "flat"
        };
        return {
            pct: 100,
            dir: "up"
        };
    }
    const raw = Math.round((current - previous) / previous * 100);
    return {
        pct: Math.abs(raw),
        dir: raw > 0 ? "up" : raw < 0 ? "down" : "flat"
    };
}
// Merge per-metric daily arrays into a single [{ day, visits, reports, answers }]
function $1aa6f1d8358888de$var$mergeTimeseries(ts) {
    const byDay = {};
    [
        "visits",
        "reports",
        "answers"
    ].forEach((metric)=>{
        (ts[metric] || []).forEach(({ date: date, count: count })=>{
            if (!byDay[date]) byDay[date] = {
                date: date
            };
            byDay[date][metric] = count;
        });
    });
    return Object.keys(byDay).sort().map((date)=>({
            day: Number(date.slice(8, 10)),
            visits: 0,
            reports: 0,
            answers: 0,
            ...byDay[date]
        }));
}
class $1aa6f1d8358888de$var$OverviewView extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            stats: null,
            loading: true,
            busy: false,
            error: false,
            month: $1aa6f1d8358888de$var$currentMonth(),
            search: "",
            page: 1
        };
        this.searchTimer = null;
    }
    componentDidMount() {
        this.load();
    }
    componentWillUnmount() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
    }
    load = ()=>{
        const { month: month, search: search, page: page } = this.state;
        this.setState({
            busy: true,
            error: false
        });
        const params = new URLSearchParams();
        if (month) params.set("month", month);
        if (search) params.set("search", search);
        params.set("page", page);
        params.set("page_size", $1aa6f1d8358888de$var$PAGE_SIZE);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `stats/dashboard/?${params.toString()}`
        }, (res)=>{
            if (res && res.kpis) this.setState({
                stats: res,
                loading: false,
                busy: false
            });
            else this.setState({
                loading: false,
                busy: false,
                error: true
            });
        });
    };
    changeMonth = (delta)=>{
        if (this.state.busy) return;
        const next = $1aa6f1d8358888de$var$addMonths(this.state.month, delta);
        if (delta > 0 && next > $1aa6f1d8358888de$var$currentMonth()) return; // no future months
        this.setState({
            month: next,
            page: 1
        }, this.load);
    };
    onSearch = (e)=>{
        const value = e.target.value;
        this.setState({
            search: value,
            page: 1
        });
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(this.load, 400);
    };
    changePage = (delta)=>{
        const { by_merchandiser: by_merchandiser } = this.state.stats;
        const next = this.state.page + delta;
        if (this.state.busy || next < 1 || next > by_merchandiser.num_pages) return;
        this.setState({
            page: next
        }, this.load);
    };
    lang() {
        return this.props.me && this.props.me.language || "en";
    }
    t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$9cbb0f231a0ab7ea), key, this.lang());
    periodLabel() {
        const { stats: stats } = this.state;
        if (!stats) return "";
        const d = new Date(stats.period.current.from);
        try {
            return d.toLocaleDateString($1aa6f1d8358888de$var$LOCALE[this.lang()] || "en-US", {
                month: "long",
                year: "numeric"
            });
        } catch (e) {
            return stats.period.current.from;
        }
    }
    renderMonthNav() {
        const atCurrent = this.state.month >= $1aa6f1d8358888de$var$currentMonth();
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "ov-month-nav",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                    type: "button",
                    className: "ov-month-btn",
                    onClick: ()=>this.changeMonth(-1),
                    disabled: this.state.busy,
                    "aria-label": "previous month",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "chevron_left"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    className: "ov-month-label",
                    children: this.periodLabel()
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                    type: "button",
                    className: "ov-month-btn",
                    onClick: ()=>this.changeMonth(1),
                    disabled: this.state.busy || atCurrent,
                    "aria-label": "next month",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "chevron_right"
                    })
                })
            ]
        });
    }
    renderKpis() {
        const { kpis: kpis } = this.state.stats;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "ov-kpi-grid",
            children: $1aa6f1d8358888de$var$KPI_META.map((meta)=>{
                const item = kpis[meta.key] || {
                    current: 0,
                    previous: 0
                };
                const d = $1aa6f1d8358888de$var$computeDelta(item.current, item.previous);
                const dirIcon = d.dir === "up" ? "trending_up" : d.dir === "down" ? "trending_down" : "trending_flat";
                const chipClass = d.dir === "up" ? "pt-status-active" : d.dir === "down" ? "pt-status-removed" : "ov-chip-flat";
                return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "ov-kpi-card",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "ov-kpi-icon",
                            style: {
                                color: meta.color,
                                background: `${meta.color}1a`
                            },
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: meta.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "ov-kpi-body",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "ov-kpi-value",
                                    children: item.current.toLocaleString()
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "ov-kpi-label",
                                    children: this.t(meta.key)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "ov-kpi-chip pt-status-pill " + chipClass,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: dirIcon
                                }),
                                d.pct,
                                "%"
                            ]
                        })
                    ]
                }, meta.key);
            })
        });
    }
    renderTrend() {
        const data = $1aa6f1d8358888de$var$mergeTimeseries(this.state.stats.timeseries);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "ov-card",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "ov-card-head",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
                            children: this.t("trend_title")
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "ov-legend",
                            children: $1aa6f1d8358888de$var$TREND_SERIES.map((s)=>/*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                    className: "ov-legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                            style: {
                                                background: s.color
                                            }
                                        }),
                                        this.t(s.key)
                                    ]
                                }, s.key))
                        })
                    ]
                }),
                data.length === 0 ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "ov-empty",
                    children: this.t("empty")
                }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $73306b6e867f0316$export$e60a4704009a0009), {
                    width: "100%",
                    height: 300,
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7e4a81f7141d4477$export$f510429275d6f1a8), {
                        data: data,
                        margin: {
                            top: 8,
                            right: 12,
                            left: -12,
                            bottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("defs", {
                                children: $1aa6f1d8358888de$var$TREND_SERIES.map((s)=>/*#__PURE__*/ (0, $7uT18.jsxs)("linearGradient", {
                                        id: `ov-grad-${s.key}`,
                                        x1: "0",
                                        y1: "0",
                                        x2: "0",
                                        y2: "1",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("stop", {
                                                offset: "0%",
                                                stopColor: s.color,
                                                stopOpacity: 0.28
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("stop", {
                                                offset: "100%",
                                                stopColor: s.color,
                                                stopOpacity: 0
                                            })
                                        ]
                                    }, s.key))
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $41997b411fa4e9c8$export$6440e27b9f186856), {
                                vertical: false,
                                stroke: $1aa6f1d8358888de$var$C.grid
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $495abb3f1d04b5fb$export$ea77231de273b52d), {
                                dataKey: "day",
                                tick: {
                                    fontSize: 12,
                                    fill: $1aa6f1d8358888de$var$C.axis
                                },
                                tickLine: false,
                                axisLine: false
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $88cb171c719dd9d9$export$f96c4024c52de8f4), {
                                tick: {
                                    fontSize: 12,
                                    fill: $1aa6f1d8358888de$var$C.axis
                                },
                                tickLine: false,
                                axisLine: false,
                                width: 40,
                                allowDecimals: false
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $ed7cfa2289a9738b$export$28c660c63b792dea), {
                                contentStyle: {
                                    borderRadius: 12,
                                    border: "none",
                                    boxShadow: "var(--md-elevation-2)"
                                }
                            }),
                            $1aa6f1d8358888de$var$TREND_SERIES.map((s)=>/*#__PURE__*/ (0, $7uT18.jsx)((0, $885b4e8e91d1b519$export$ea1a111407f37557), {
                                    type: "monotone",
                                    dataKey: s.key,
                                    name: this.t(s.key),
                                    stroke: s.color,
                                    strokeWidth: 2,
                                    fill: `url(#ov-grad-${s.key})`
                                }, s.key))
                        ]
                    })
                })
            ]
        });
    }
    renderTopMerchandisers() {
        const top = this.state.stats.top_merchandisers || [];
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "ov-card",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "ov-card-head",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
                        children: this.t("top_merchandisers")
                    })
                }),
                top.length === 0 ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "ov-empty",
                    children: this.t("empty")
                }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $73306b6e867f0316$export$e60a4704009a0009), {
                    width: "100%",
                    height: 300,
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $e75b1b171602674b$export$94aefc399ef206a9), {
                        data: top,
                        layout: "vertical",
                        margin: {
                            top: 8,
                            right: 16,
                            left: 8,
                            bottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $41997b411fa4e9c8$export$6440e27b9f186856), {
                                horizontal: false,
                                stroke: $1aa6f1d8358888de$var$C.grid
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $495abb3f1d04b5fb$export$ea77231de273b52d), {
                                type: "number",
                                tick: {
                                    fontSize: 12,
                                    fill: $1aa6f1d8358888de$var$C.axis
                                },
                                tickLine: false,
                                axisLine: false,
                                allowDecimals: false
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $88cb171c719dd9d9$export$f96c4024c52de8f4), {
                                type: "category",
                                dataKey: "name",
                                width: 140,
                                tick: {
                                    fontSize: 12,
                                    fill: $1aa6f1d8358888de$var$C.axis
                                },
                                tickLine: false,
                                axisLine: false
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $ed7cfa2289a9738b$export$28c660c63b792dea), {
                                cursor: {
                                    fill: "rgba(0,40,80,0.04)"
                                },
                                contentStyle: {
                                    borderRadius: 12,
                                    border: "none",
                                    boxShadow: "var(--md-elevation-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $bce1568d73f81eb0$export$bbc6c6369b38e3d1), {
                                dataKey: "visits",
                                name: this.t("visits"),
                                radius: [
                                    0,
                                    6,
                                    6,
                                    0
                                ],
                                children: top.map((entry, i)=>/*#__PURE__*/ (0, $7uT18.jsx)((0, $00195d1dff24caf4$export$f6f0c3fe4ec306ea), {
                                        fill: $1aa6f1d8358888de$var$C.primary
                                    }, i))
                            })
                        ]
                    })
                })
            ]
        });
    }
    renderTable() {
        const table = this.state.stats.by_merchandiser;
        const rows = table.results;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "ov-card",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "ov-card-head",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
                            children: this.t("by_merchandiser")
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "ov-search",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "search"
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                    type: "text",
                                    value: this.state.search,
                                    onChange: this.onSearch,
                                    placeholder: this.t("search_ph")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "pt-table-wrap table-scroll-x",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                        className: "table table-hover",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            children: this.t("col_merchandiser")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            className: "ov-num",
                                            children: this.t("col_visits")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            className: "ov-num",
                                            children: this.t("col_reports")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            className: "ov-num",
                                            children: this.t("col_answers")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                                children: rows.length === 0 ? /*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                        colSpan: 4,
                                        className: "ov-empty",
                                        children: this.t("empty")
                                    })
                                }) : rows.map((r)=>/*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                children: r.name
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                className: "ov-num",
                                                children: r.visits.toLocaleString()
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                className: "ov-num",
                                                children: r.reports.toLocaleString()
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                className: "ov-num",
                                                children: r.answers.toLocaleString()
                                            })
                                        ]
                                    }, r.id))
                            })
                        ]
                    })
                }),
                table.num_pages > 1 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "ov-pagination",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            type: "button",
                            className: "ov-month-btn",
                            onClick: ()=>this.changePage(-1),
                            disabled: this.state.busy || table.page <= 1,
                            "aria-label": "previous page",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "chevron_left"
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                            className: "ov-page-info",
                            children: [
                                table.page,
                                " / ",
                                table.num_pages,
                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                    className: "ov-page-count",
                                    children: [
                                        " \xb7 ",
                                        table.count
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            type: "button",
                            className: "ov-month-btn",
                            onClick: ()=>this.changePage(1),
                            disabled: this.state.busy || table.page >= table.num_pages,
                            "aria-label": "next page",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "chevron_right"
                            })
                        })
                    ]
                })
            ]
        });
    }
    render() {
        const { loading: loading, error: error, stats: stats, busy: busy } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "box p-4 ov-root" + (busy ? " ov-busy" : ""),
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "ov-header",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("h3", {
                                        className: "ov-title",
                                        children: this.t("title")
                                    }),
                                    stats && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "ov-subtitle",
                                        children: this.periodLabel()
                                    })
                                ]
                            }),
                            stats && this.renderMonthNav()
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "ov-empty ov-loading",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-spinner fa-spin"
                            }),
                            " ",
                            this.t("loading")
                        ]
                    }),
                    !loading && error && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "ov-empty",
                        children: [
                            this.t("error"),
                            " ",
                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                className: "btn btn-sm btn-link",
                                onClick: this.load,
                                children: this.t("retry")
                            })
                        ]
                    }),
                    !loading && !error && stats && /*#__PURE__*/ (0, $7uT18.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, {
                        children: [
                            this.renderKpis(),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "ov-charts",
                                children: [
                                    this.renderTrend(),
                                    this.renderTopMerchandisers()
                                ]
                            }),
                            this.renderTable()
                        ]
                    })
                ]
            })
        });
    }
}
const $1aa6f1d8358888de$var$mapStateToProps = (state)=>({
        me: state.me
    });
var $1aa6f1d8358888de$export$2e2bcd8739ae039 = (0, $b83e93e5ef3de8b0$export$64605811ab45167f)($1aa6f1d8358888de$var$mapStateToProps)($1aa6f1d8358888de$var$OverviewView);



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


class $ec5347b150ba521a$export$4c12a832a2e7f99f {
    constructor(data){
        this.id = data.id; // string
        this.meta = data.meta; // string (included an array of coordinates)
        this.point = data.point; // object
        this.start = data.start; // string
        this.end = data.end; // string
        this.user = data.user;
    }
}


var $aa2d6dc1bd01cabc$exports = {};
$aa2d6dc1bd01cabc$exports = new URL("no_photo.e6da4db4.jpg", import.meta.url).toString();


/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $2a0f535cbe281dd6$export$e4c823724462c3fd;
var $2a0f535cbe281dd6$export$48d2c0a44ea41a2f;
var $2a0f535cbe281dd6$export$8019223850b8bf78;
var $2a0f535cbe281dd6$export$1b45514b112dd749;
var $2a0f535cbe281dd6$export$cc3e2d3244e01b7f;
var $2a0f535cbe281dd6$export$dfc7155ac0343b8;
var $2a0f535cbe281dd6$export$b14ad400b1d09e0f;
"use strict";
var $6b496156e4d3d65d$exports = {};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 */ 
$6b496156e4d3d65d$exports = (parcelRequire("bdrlo"));


var $e60c8a8b864d4b98$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4dBQg = parcelRequire("4dBQg");
"use strict";
function $e60c8a8b864d4b98$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $e60c8a8b864d4b98$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $e60c8a8b864d4b98$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $e60c8a8b864d4b98$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $4dBQg.cwd();
                path = cwd;
            }
            $e60c8a8b864d4b98$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $e60c8a8b864d4b98$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $e60c8a8b864d4b98$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $e60c8a8b864d4b98$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $e60c8a8b864d4b98$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $e60c8a8b864d4b98$var$assertPath(from);
        $e60c8a8b864d4b98$var$assertPath(to);
        if (from === to) return "";
        from = $e60c8a8b864d4b98$var$posix.resolve(from);
        to = $e60c8a8b864d4b98$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $e60c8a8b864d4b98$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $e60c8a8b864d4b98$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$e60c8a8b864d4b98$var$posix.posix = $e60c8a8b864d4b98$var$posix;
$e60c8a8b864d4b98$exports = $e60c8a8b864d4b98$var$posix;


var $2a0f535cbe281dd6$require$extname = $e60c8a8b864d4b98$exports.extname;
/**
 * Module variables.
 * @private
 */ var $2a0f535cbe281dd6$var$EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
var $2a0f535cbe281dd6$var$TEXT_TYPE_REGEXP = /^text\//i;
$2a0f535cbe281dd6$export$e4c823724462c3fd = $2a0f535cbe281dd6$var$charset;
$2a0f535cbe281dd6$export$48d2c0a44ea41a2f = {
    lookup: $2a0f535cbe281dd6$var$charset
};
$2a0f535cbe281dd6$export$8019223850b8bf78 = $2a0f535cbe281dd6$var$contentType;
$2a0f535cbe281dd6$export$1b45514b112dd749 = $2a0f535cbe281dd6$var$extension;
$2a0f535cbe281dd6$export$cc3e2d3244e01b7f = Object.create(null);
$2a0f535cbe281dd6$export$dfc7155ac0343b8 = $2a0f535cbe281dd6$var$lookup;
$2a0f535cbe281dd6$export$b14ad400b1d09e0f = Object.create(null);
// Populate the extensions/types maps
$2a0f535cbe281dd6$var$populateMaps($2a0f535cbe281dd6$export$cc3e2d3244e01b7f, $2a0f535cbe281dd6$export$b14ad400b1d09e0f);
/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$charset(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $2a0f535cbe281dd6$var$EXTRACT_TYPE_REGEXP.exec(type);
    var mime = match && $6b496156e4d3d65d$exports[match[1].toLowerCase()];
    if (mime && mime.charset) return mime.charset;
    // default text/* to utf-8
    if (match && $2a0f535cbe281dd6$var$TEXT_TYPE_REGEXP.test(match[1])) return "UTF-8";
    return false;
}
/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$contentType(str) {
    // TODO: should this even be in this module?
    if (!str || typeof str !== "string") return false;
    var mime = str.indexOf("/") === -1 ? $2a0f535cbe281dd6$export$dfc7155ac0343b8(str) : str;
    if (!mime) return false;
    // TODO: use content-type or other module
    if (mime.indexOf("charset") === -1) {
        var charset = $2a0f535cbe281dd6$export$e4c823724462c3fd(mime);
        if (charset) mime += "; charset=" + charset.toLowerCase();
    }
    return mime;
}
/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$extension(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $2a0f535cbe281dd6$var$EXTRACT_TYPE_REGEXP.exec(type);
    // get extensions
    var exts = match && $2a0f535cbe281dd6$export$cc3e2d3244e01b7f[match[1].toLowerCase()];
    if (!exts || !exts.length) return false;
    return exts[0];
}
/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$lookup(path) {
    if (!path || typeof path !== "string") return false;
    // get the extension ("ext" or ".ext" or full path)
    var extension = $2a0f535cbe281dd6$require$extname("x." + path).toLowerCase().substr(1);
    if (!extension) return false;
    return $2a0f535cbe281dd6$export$b14ad400b1d09e0f[extension] || false;
}
/**
 * Populate the extensions and types maps.
 * @private
 */ function $2a0f535cbe281dd6$var$populateMaps(extensions, types) {
    // source preference (least -> most)
    var preference = [
        "nginx",
        "apache",
        undefined,
        "iana"
    ];
    Object.keys($6b496156e4d3d65d$exports).forEach(function forEachMimeType(type) {
        var mime = $6b496156e4d3d65d$exports[type];
        var exts = mime.extensions;
        if (!exts || !exts.length) return;
        // mime -> extensions
        extensions[type] = exts;
        // extension -> mime
        for(var i = 0; i < exts.length; i++){
            var extension = exts[i];
            if (types[extension]) {
                var from = preference.indexOf($6b496156e4d3d65d$exports[types[extension]].source);
                var to = preference.indexOf(mime.source);
                if (types[extension] !== "application/octet-stream" && (from > to || from === to && types[extension].substr(0, 12) === "application/")) continue;
            }
            // set the extension -> mime
            types[extension] = type;
        }
    });
}


const $dd80b063693a1e94$export$bef94a5618bf18bf = (urlString)=>{
    urlString = urlString ? urlString : "NEW ITEM NOT EXIST";
    try {
        new URL(urlString);
        return true;
    } catch (err) {
        console.error("Error on getting photo url", err);
        return false;
    }
};
function $dd80b063693a1e94$export$fb85bc5d6d9ef19b(url) {
    const mimeType = $2a0f535cbe281dd6$export$dfc7155ac0343b8(url);
    return mimeType && mimeType.startsWith("image/");
}


class $4e9873a13607b352$export$29d24e359e2fdff9 {
    constructor(data){
        this.id = data.id; // number
        this.additional_info = data.ticket_contents && data.ticket_contents.length > 0 ? data.ticket_contents[0].additional_info : data.additional_info ? data.additional_info : null; // object
        this.picsell_info = data.picsell_info || {}; // obj 
        this.approval = data.approval || {}; // obj 
        this.ticket = data.ticket || ""; // string
        this.ticket_additional_info = data.ticket_additional_info || null; // object
        this.tip = data.tip || ""; // string
        // this.photo = data.url_photo && isValidUrl(data.url_photo) ? data.url_photo : ""; // string ${PHOTO_REVIEW_IMAGE_URL_BASE}
        this.photo = this.imgGroup(data);
        this.visit = data.visit && new (0, $ec5347b150ba521a$export$4c12a832a2e7f99f)(data.visit);
        this.visit_id = data.visit_id; // string
    }
    imgGroup(data) {
        const arrPhotos = [];
        if (data.ticket_contents && data.ticket_contents.length > 0) {
            data.ticket_contents.forEach((item)=>{
                (0, $dd80b063693a1e94$export$fb85bc5d6d9ef19b)(item.url_photo) ? arrPhotos.push(item.url_photo) : arrPhotos.push((0, (/*@__PURE__*/$parcel$interopDefault($aa2d6dc1bd01cabc$exports))));
            });
            return arrPhotos;
        } else {
            (0, $dd80b063693a1e94$export$fb85bc5d6d9ef19b)(data.url_photo) ? arrPhotos.push(data.url_photo) : arrPhotos.push((0, (/*@__PURE__*/$parcel$interopDefault($aa2d6dc1bd01cabc$exports))));
            return arrPhotos;
        }
    }
}






var $Yxlsx = parcelRequire("Yxlsx");





var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");





function $d9c93569c1a96362$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}




function $be9b111f7b278fac$export$2e2bcd8739ae039(object) {
    return (0, $101a6bb002d60c43$export$2e2bcd8739ae039)({}, object);
}





var $4442830c7ca79fe3$var$MILLISECONDS_IN_MINUTE = 60000;
var $4442830c7ca79fe3$var$MINUTES_IN_DAY = 1440;
var $4442830c7ca79fe3$var$MINUTES_IN_MONTH = $4442830c7ca79fe3$var$MINUTES_IN_DAY * 30;
var $4442830c7ca79fe3$var$MINUTES_IN_YEAR = $4442830c7ca79fe3$var$MINUTES_IN_DAY * 365;
function $4442830c7ca79fe3$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _options$roundingMeth;
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $c247dce96e65a454$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $0c24da20d808f530$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain localize.formatDistance property");
    var comparison = (0, $d9c93569c1a96362$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $101a6bb002d60c43$export$2e2bcd8739ae039)((0, $be9b111f7b278fac$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $4a2c59df8ce8ec4a$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : "round");
    var roundingMethodFn;
    if (roundingMethod === "floor") roundingMethodFn = Math.floor;
    else if (roundingMethod === "ceil") roundingMethodFn = Math.ceil;
    else if (roundingMethod === "round") roundingMethodFn = Math.round;
    else throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / $4442830c7ca79fe3$var$MILLISECONDS_IN_MINUTE;
    var timezoneOffset = (0, $77119a34c3522634$export$2e2bcd8739ae039)(dateRight) - (0, $77119a34c3522634$export$2e2bcd8739ae039)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / $4442830c7ca79fe3$var$MILLISECONDS_IN_MINUTE;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $4442830c7ca79fe3$var$MINUTES_IN_DAY) unit = "hour";
        else if (dstNormalizedMinutes < $4442830c7ca79fe3$var$MINUTES_IN_MONTH) unit = "day";
        else if (dstNormalizedMinutes < $4442830c7ca79fe3$var$MINUTES_IN_YEAR) unit = "month";
        else unit = "year";
    } else unit = String(defaultUnit);
    // 0 up to 60 seconds
    if (unit === "second") {
        var seconds = roundingMethodFn(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        var roundedMinutes = roundingMethodFn(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        var hours = roundingMethodFn(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        var days = roundingMethodFn(dstNormalizedMinutes / $4442830c7ca79fe3$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        var months = roundingMethodFn(dstNormalizedMinutes / $4442830c7ca79fe3$var$MINUTES_IN_MONTH);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else if (unit === "year") {
        var years = roundingMethodFn(dstNormalizedMinutes / $4442830c7ca79fe3$var$MINUTES_IN_YEAR);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}



function $f2e1ac9462152a95$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6fa742dea810721f$export$2e2bcd8739ae039)(1, arguments);
    return (0, $4442830c7ca79fe3$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}



var $gOYUZ = parcelRequire("gOYUZ");


var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $556beaf760cd698d$exports = {};
$556beaf760cd698d$exports = new URL("spinner.209e8c85.gif", import.meta.url).toString();






const $36fe633d5abec772$var$Downloader = (props)=>{
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const [loadingAll, setLoadingAll] = (0, $cQmXV.useState)(false);
    const TranslationDownloader = {
        export: "export",
        download: "download",
        downloadAll: "downloadAll",
        downloading: "downloading"
    };
    const translateFn = (name)=>{
        const lang = props.me?.language ? props.me.language : "en";
        return (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), name, lang);
    };
    const exportFiles = async (urls, exportCallback)=>{
        setLoading(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/export/",
            post: {
                images: urls
            }
        }, (result)=>{
            try {
                exportCallback?.();
            } catch (e) {
                console.error({
                    ...e
                });
            }
        }, {}, true);
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "downloader-container",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                className: `btn ${props.options.exportMode ? "btn-primary" : "btn-outline-primary"} mr-1`,
                onClick: props.options.handleExportMode,
                disabled: !!props.options?.disabled,
                children: translateFn(TranslationDownloader.export)
            }),
            props.options.exportMode && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        className: "btn btn-outline-primary mr-1",
                        onClick: ()=>{
                            setLoading(true);
                            exportFiles(props.options.selectedImages, ()=>{
                                setLoading(false);
                            });
                        },
                        disabled: !props.options?.selectedImages?.length || loading,
                        children: loading ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($556beaf760cd698d$exports))),
                                    alt: "loading spinner",
                                    className: "downloader-spinner"
                                }),
                                " ",
                                translateFn(TranslationDownloader.downloading)
                            ]
                        }) : translateFn(TranslationDownloader.download)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        className: "btn btn-outline-primary",
                        onClick: ()=>{
                            setLoadingAll(true);
                            exportFiles(props.options.urls, ()=>{
                                setLoadingAll(false);
                            });
                        },
                        disabled: loadingAll,
                        children: loadingAll ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($556beaf760cd698d$exports))),
                                    alt: "loading spinner",
                                    className: "downloader-spinner"
                                }),
                                " ",
                                translateFn(TranslationDownloader.downloading)
                            ]
                        }) : translateFn(TranslationDownloader.downloadAll)
                    })
                ]
            })
        ]
    });
};
var // export { Downloader };
$36fe633d5abec772$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($36fe633d5abec772$var$Downloader));



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $1ZXxd = parcelRequire("1ZXxd");
const $6b81634eed285b20$export$f2697cee648344e = ({ onScroll: onScroll, loading: loading, scrollContainer: scrollContainer = window })=>{
    const lazyLoadingElementRef = $cQmXV.useRef(null);
    const isInViewport = (element)=>{
        const rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    };
    const handleScrollElement = ()=>{
        if (lazyLoadingElementRef.current) {
            if (isInViewport(lazyLoadingElementRef.current) && !loading) onScroll?.();
        }
    };
    const debouncedHandleScrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($1ZXxd))).debounce(handleScrollElement, 300);
    $cQmXV.useLayoutEffect(()=>{
        scrollContainer.addEventListener("scroll", debouncedHandleScrollElement);
        return ()=>{
            scrollContainer?.removeEventListener("scroll", debouncedHandleScrollElement);
        };
    }, [
        loading
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "lazy-loading-container",
        style: {
            flex: "none",
            height: "12px",
            width: "100%"
        },
        ref: lazyLoadingElementRef
    });
};




var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
function $5588f76353c86461$var$PhotoTaskSlider({ photos: photos, activePhotoIndex: activePhotoIndex, quickItemPhotoIndex: quickItemPhotoIndex, clickCallback: clickCallback = ()=>{}, isDeepArray: isDeepArray, loadPhotoReviewFn: loadPhotoReviewFn = ()=>{}, viewMode: viewMode }) {
    const [slideIndex, setSlideIndex] = (0, $cQmXV.useState)(1);
    const [loadedImages, setLoadedImages] = (0, $cQmXV.useState)([]);
    const quickOpenTrigger = (0, $cQmXV.useRef)(true);
    const nextButtonHandler = ()=>{
        if (slideIndex < photos.length) {
            setSlideIndex((prev)=>prev + 1);
            if (activePhotoIndex instanceof Object) activePhotoIndex(slideIndex);
        }
    };
    const prevButtonHandler = ()=>{
        if (slideIndex > 1) {
            setSlideIndex((prev)=>prev - 1);
            if (activePhotoIndex instanceof Object) activePhotoIndex(slideIndex - 2);
        }
    };
    (0, $cQmXV.useEffect)(()=>{
        quickItemPhotoIndex > 0 && quickOpenTrigger.current ? (setSlideIndex(quickItemPhotoIndex + 1), quickOpenTrigger.current = false) : setSlideIndex(1);
    }, [
        photos
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
        children: [
            viewMode === "group" ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "dot-list",
                children: photos?.map((el, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: `dot ${index === slideIndex - 1 ? "active" : ""}`
                    }, index))
            }) : null,
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "photo-list",
                "data-photo-current-index": slideIndex - 1,
                children: photos?.map((photo, index)=>{
                    // Only the active slide and its immediate neighbors actually need to be
                    // requested. Previously every photo in the array loaded eagerly (only
                    // hidden visually via the translateX transform) — on a multi-photo card
                    // that meant N network requests for 1 visible image, multiplied across
                    // every row in the list.
                    const isActive = index === slideIndex - 1;
                    const isNeighbor = index === slideIndex - 2 || index === slideIndex;
                    const shouldLoad = isActive || isNeighbor;
                    const src = shouldLoad ? isDeepArray ? photo : photo.photo_url : undefined;
                    return /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                        src: src,
                        loading: isActive ? undefined : "lazy",
                        "data-index": index,
                        onClick: ()=>clickCallback(slideIndex - 1),
                        style: {
                            transform: `translateX(-${index * 100}%)`
                        },
                        onLoad: ()=>{
                            loadPhotoReviewFn();
                        },
                        className: `previewImage img-placeholder ${index === slideIndex - 1 ? "active" : ""} ${photos?.length === 1 ? "photo-visible" : ""}`
                    }, index);
                })
            }),
            photos?.length > 0 && viewMode === "group" ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "carousel-navigations",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "side-nav side-nav-prev",
                        onClick: prevButtonHandler,
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            className: "slide-arrow",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-chevron-circle-left"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "side-nav side-nav-next",
                        onClick: nextButtonHandler,
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            className: "slide-arrow",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-chevron-circle-right"
                            })
                        })
                    })
                ]
            }) : null
        ]
    });
}
var $5588f76353c86461$export$2e2bcd8739ae039 = $5588f76353c86461$var$PhotoTaskSlider;




function $642c103cd5563540$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}




class $105fabe664da7e8a$var$Table extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.imgRefs = [];
        this.myGroupBtnRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        this.mySingleBtnRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        this.containerRefs = [];
        this.state = {
            overflowStates: []
        };
        this.state = {
            loading: false,
            // Keyed by item.id (not array index) so state stays correct if the list is
            // ever reordered or trimmed (e.g. evicting old infinite-scroll pages) —
            // an index-keyed array would silently point at the wrong item after a shift.
            loadedImages: {},
            selectedImages: {},
            exportMode: false,
            isActiveAccordion: false,
            isIOS: false,
            imdData: [],
            photoIndex: 0,
            gridModeView: "single"
        };
    }
    componentDidMount() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        this.checkOverflow();
        if (/iPad|iPhone|iPod|Macintosh|Mac OS/.test(userAgent) && !window.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) this.setState({
            isIOS: true
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) this.checkOverflow();
    }
    checkOverflow = ()=>{
        const { data: data } = this.props;
        if (Array.isArray(data)) {
            if (this.state.overflowStates?.length !== data.length) this.setState({
                overflowStates: new Array(data.length).fill(false)
            });
            const overflowStates = data.map((item, index)=>{
                const container = this.containerRefs[index];
                return container && container.offsetWidth > 188;
            });
            this.setState({
                overflowStates: overflowStates
            });
        }
    };
    loadPhotoReviewFull = (id)=>{
        this.setState((prevState)=>({
                loadedImages: {
                    ...prevState.loadedImages,
                    [id]: true
                }
            }));
    };
    loadProductsList = (event, entity)=>{
        // event: Event, entity: string
        this.props.changeFilter(entity, event);
    };
    handleSelectedImages = (e, id, url)=>{
        const checked = e.target?.checked;
        this.setState((prevState)=>({
                selectedImages: {
                    ...prevState.selectedImages,
                    [id]: checked ? url : undefined
                }
            }));
    };
    handleExportMode = ()=>{
        this.setState((prevState)=>({
                exportMode: !prevState.exportMode
            }), ()=>{
            console.log("exportMode", this.state.exportMode);
        });
    };
    handlerAccordion = ()=>{
        this.setState({
            isActiveAccordion: !this.state.isActiveAccordion
        });
    };
    handleExImg = (index)=>{
        let orientation = null;
        let thumbnail = null;
        const self = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($gOYUZ))).getData(this.imgRefs[index], function() {
            orientation = (0, (/*@__PURE__*/$parcel$interopDefault($gOYUZ))).getTag(this, "Orientation");
            thumbnail = (0, (/*@__PURE__*/$parcel$interopDefault($gOYUZ))).getTag(this, "thumbnail");
            if (JSON.stringify(orientation) !== "6" && JSON.stringify(thumbnail?.Orientation) == "6") self.setState((prevState)=>({
                    imdData: [
                        ...prevState.imdData,
                        Number(index)
                    ]
                }));
        });
    };
    checkIosImgInArr = (index)=>{
        return [
            ...new Set(this.state.imdData)
        ].includes(Number(index)) ? true : false;
    };
    translate = (name, entity = (0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac))=>{
        const lang = this.props.lang ? this.props.lang : "en";
        return (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(entity, name, lang);
    };
    handleGridChangeButtonClick = (e, type)=>{
        // e.target.className += " btn-active";
        //reset loadedImages data before change view type
        if (this.state.gridModeView === type) return;
        e.target.closest(".switch-view").setAttribute("data-view-type", type);
        this.props.gridPhotoView(type);
        if (type === "single") {
            this.myGroupBtnRef.current.classList.remove("btn-active");
            this.mySingleBtnRef.current.classList.add("btn-active");
        } else {
            this.mySingleBtnRef.current.classList.remove("btn-active");
            this.myGroupBtnRef.current.classList.add("btn-active");
        }
        this.setState({
            gridModeView: type,
            loading: true
        });
    };
    activePhotoIndex = (index = 0)=>{
        this.setState({
            photoIndex: index
        });
        return index;
    };
    render() {
        const { data: data, openTask: openTask, filter: filter, changeFilter: changeFilter, resetFilter: resetFilter, createNewFilter: createNewFilter, addNewFilterName: addNewFilterName, list: list, removeUserFilterPopup: removeUserFilterPopup, acceptRejectAnswer: acceptRejectAnswer } = this.props;
        const { selectedImages: selectedImages, loadedImages: loadedImages, exportMode: exportMode } = this.state;
        const { overflowStates: overflowStates } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "row photo-review",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "md-filter-panel",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "md-filter-grid",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field md-filter-field--dates",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: this.translate("date_range")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-dates",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                    selected: filter.start ? new Date(filter.start) : null,
                                                    className: "datePicker",
                                                    onChange: (date)=>changeFilter("start", date)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-date-sep",
                                                    children: "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                    selected: filter.end ? new Date(filter.end) : null,
                                                    className: "datePicker",
                                                    onChange: (date)=>changeFilter("end", date)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field md-filter-field-custom_filter",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: this.translate("custom_filter")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "filters",
                                            value: filter?.filters?.id,
                                            updatedList: list,
                                            onChange: (o)=>changeFilter("filters", o)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field md-filter-field-clients",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: this.translate("clients")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "clients",
                                            value: filter.clients,
                                            onChange: (o)=>changeFilter("clients", o)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field md-filter-field-merchandisers is-multi-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: this.translate("merchandisers")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "merchandisers",
                                            value: filter.users,
                                            onChange: (o)=>changeFilter("users", o),
                                            isMulti: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field md-filter-field-network",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: this.translate("network")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "network",
                                            value: filter.point__network,
                                            onChange: (o)=>changeFilter("point__network", o)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "md-filter-grid md-filter-grid--point",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "md-filter-label",
                                    children: this.translate("region")
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $d4b6a9d27c93fbb2$export$2e2bcd8739ae039), {
                                    saveValue: filter.county,
                                    value: filter.points,
                                    onChange: (o)=>changeFilter("points", o),
                                    onChangeRegion: (o)=>changeFilter("county", o),
                                    isMulti: true,
                                    moduleFilter: filter.point__network
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "md-filter-section",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "md-filter-section-toggle",
                                    onClick: this.handlerAccordion,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-nav-icon",
                                            children: this.state.isActiveAccordion ? "expand_less" : "expand_more"
                                        }),
                                        this.translate("additional_filters")
                                    ]
                                }),
                                this.state.isActiveAccordion && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-grid md-filter-grid--extra",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "md-filter-field",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                entity: "categories",
                                                value: filter?.categories,
                                                onChange: (o)=>changeFilter("categories", o),
                                                isMulti: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "md-filter-field",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                entity: "subcategories",
                                                value: filter?.subcategories,
                                                onChange: (o)=>changeFilter("subcategories", o),
                                                isMulti: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "md-filter-field",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                entity: "brands",
                                                value: filter?.brands,
                                                onChange: (o)=>changeFilter("brands", o),
                                                isMulti: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "md-filter-field",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                entity: "products",
                                                value: filter?.products,
                                                asynch: true,
                                                onChange: (o)=>this.loadProductsList(o, "products"),
                                                isMulti: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "md-filter-field",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                entity: "tags",
                                                value: filter?.tags,
                                                onChange: (o)=>changeFilter("tags", o),
                                                isMulti: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "md-filter-field md-filter-field-comment",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                type: "text",
                                                className: "form-control",
                                                placeholder: this.translate("comment"),
                                                value: filter.comment,
                                                onChange: (e)=>changeFilter("comment", e.target.value)
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "md-filter-actions",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-actions-left",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                            className: "btn btn-primary",
                                            onClick: this.props.submit,
                                            children: this.translate("apply")
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                            className: "btn btn-outline-primary",
                                            onClick: resetFilter,
                                            children: this.translate("filter_reset")
                                        }),
                                        this.state.gridModeView === "single" && /*#__PURE__*/ (0, $7uT18.jsx)((0, $36fe633d5abec772$export$2e2bcd8739ae039), {
                                            options: {
                                                url: data[0]?.photo,
                                                urls: data?.map((img)=>img.photo[0]),
                                                selectedImages: Object.values(selectedImages || {}).filter((url)=>!!url),
                                                disabled: !Object.keys(loadedImages || {}).length,
                                                handleExportMode: this.handleExportMode,
                                                exportMode: exportMode
                                            }
                                        }),
                                        filter.isChange && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-save",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    placeholder: this.translate("filter_name_placeholder"),
                                                    value: filter?.newFilter,
                                                    onChange: (e)=>addNewFilterName(e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                    className: "btn btn-outline-primary",
                                                    onClick: ()=>createNewFilter("filters", filter?.newFilter),
                                                    children: this.translate("filter_save")
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                    className: "btn btn-danger",
                                                    onClick: ()=>removeUserFilterPopup("filters"),
                                                    children: this.translate("filter_remove")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "md-filter-actions-right",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                        htmlFor: "photo-filter-view",
                                        className: "switch-view",
                                        "data-view-type": this.state.gridModeView,
                                        "aria-label": "Toggle Photo Filter",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "switch-btn",
                                                ref: this.mySingleBtnRef,
                                                onClick: (e)=>this.handleGridChangeButtonClick(e, "single"),
                                                children: this.translate("photo_review_type_single")
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "switch-btn",
                                                ref: this.myGroupBtnRef,
                                                onClick: (e)=>this.handleGridChangeButtonClick(e, "group"),
                                                children: this.translate("photo_review_type_group")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "photo-review-list-wrap",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                            loading: this.props.loading,
                            disP: true
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "col-md-12 p-4 photo-review-list",
                            children: data.map((item, index)=>{
                                const tagValues = Array.isArray(item?.additional_info?.tags) ? item.additional_info.tags : [];
                                const hasLocation = !!(item?.visit?.point?.locality?.name || item?.visit?.point?.name);
                                const hasUser = !!(item?.visit?.user?.first_name || item?.visit?.user?.last_name);
                                const hasInfo = hasLocation || tagValues.length > 0 || hasUser;
                                const openItem = (e)=>{
                                    if (loadedImages[item.id] && !exportMode) openTask(item, false, 0);
                                };
                                return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: `photo-review-item${exportMode ? " photo-review-item--export-mode" : ""}${index === this.props.currentIndex ? " photo-review-item--active" : ""}${!hasInfo ? " photo-review-item--full-image" : ""}`,
                                    title: `/photo-review/${item.id}/view`,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "root-container",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                                    loading: !loadedImages?.[item.id],
                                                    disP: true
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: (0, $642c103cd5563540$export$ce4ab0c55987d1ff)("photo-review-item-wrapper", index === this.props.currentIndex && "photo-review-item-wrapper--active"),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $5588f76353c86461$export$2e2bcd8739ae039), {
                                                            activePhotoIndex: this.activePhotoIndex,
                                                            photos: item.photo,
                                                            clickCallback: (photoIndex)=>{
                                                                if (loadedImages[item.id] && !exportMode) openTask(item, false, photoIndex);
                                                            },
                                                            isDeepArray: true,
                                                            loadPhotoReviewFn: ()=>this.loadPhotoReviewFull(item.id),
                                                            viewMode: this.state.gridModeView
                                                        }),
                                                        this.state.gridModeView === "single" ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "card-action-overlay single-details-buttons",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                    className: `card-action-btn card-action-btn--approve${item.approval?.is_approved === true ? " card-action-btn--active" : ""}`,
                                                                    title: this.translate("approv_btn", (0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0)),
                                                                    onClick: ()=>{
                                                                        acceptRejectAnswer("ACCEPT", item, true);
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "check_circle"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                    className: `card-action-btn card-action-btn--reject${item.approval?.is_approved === false ? " card-action-btn--active" : ""}`,
                                                                    title: this.translate("reject_btn", (0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0)),
                                                                    onClick: ()=>{
                                                                        openTask(item, true, 0);
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "cancel"
                                                                    })
                                                                })
                                                            ]
                                                        }) : null,
                                                        this.state.gridModeView === "group" ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "card-action-overlay",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                    className: `card-action-btn card-action-btn--approve${item.approval?.is_approved === true ? " card-action-btn--active" : ""}`,
                                                                    onClick: ()=>{
                                                                        acceptRejectAnswer("ACCEPT", item, true);
                                                                    },
                                                                    title: this.translate("approv_btn", (0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0)),
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "check_circle"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                    className: `card-action-btn card-action-btn--reject${item.approval?.is_approved === false ? " card-action-btn--active" : ""}`,
                                                                    onClick: ()=>{
                                                                        if (loadedImages[item.id] && !exportMode) openTask(item, true, this.state.photoIndex);
                                                                    },
                                                                    title: this.translate("reject_btn", (0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0)),
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "cancel"
                                                                    })
                                                                })
                                                            ]
                                                        }) : null,
                                                        !hasInfo && item.approval?.is_approved != null && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: `status-square status-square--overlay ${item.approval.is_approved === true ? "approved" : "rejected"}`,
                                                            children: item.approval.is_approved === true ? "\u2714" : "\u2716"
                                                        })
                                                    ]
                                                }),
                                                hasInfo && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "review-item",
                                                            onClick: openItem,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                    className: "review-item-text",
                                                                    children: [
                                                                        item?.visit?.point?.locality?.name && /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                                            className: "photo-review-item-content first-item",
                                                                            children: item.visit.point.locality.name
                                                                        }),
                                                                        item?.visit?.point?.name && /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                                            className: "photo-review-item-content",
                                                                            children: item.visit.point.name
                                                                        })
                                                                    ]
                                                                }),
                                                                item.approval?.is_approved != null ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: `status-square ${item.approval.is_approved === true ? "approved" : "rejected"}`,
                                                                    children: item.approval.is_approved === true ? "\u2714" : "\u2716"
                                                                }) : null
                                                            ]
                                                        }),
                                                        tagValues.length > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "tags-form-group tags-group-content",
                                                            onClick: openItem,
                                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                className: "tags-scroll",
                                                                ref: (el)=>this.containerRefs[index] = el,
                                                                children: tagValues.map((tag, idx)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "tag-label",
                                                                        children: tag
                                                                    }, idx))
                                                            })
                                                        }),
                                                        hasUser && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "visit-info",
                                                            onClick: openItem,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                    className: "user-name",
                                                                    children: [
                                                                        item?.visit?.user?.first_name,
                                                                        " ",
                                                                        item?.visit?.user?.last_name
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "time-elapsed",
                                                                    children: item?.visit?.start ? (0, $f2e1ac9462152a95$export$2e2bcd8739ae039)(new Date(item.visit.start), {
                                                                        addSuffix: true
                                                                    }) : ""
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        exportMode && /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            className: "photo-review-item-to-download",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                type: "checkbox",
                                                name: `photo-review-selected[${item.id}]`,
                                                className: "form-filter-checkbox",
                                                checked: !!selectedImages[item.id],
                                                value: selectedImages[item.id] || "",
                                                onChange: (e)=>{
                                                    this.handleSelectedImages(e, item.id, item.photo[0]);
                                                }
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                this.props.loadingMore && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "photo-review-loading-more",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                        className: "fa fa-spinner fa-pulse fa-2x fa-fw"
                    })
                }),
                !this.props.loading && !this.props.loadingMore && /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $6b81634eed285b20$export$f2697cee648344e), {
                        loading: false,
                        onScroll: async ()=>{
                            this.props.updatePaging();
                        }
                    })
                })
            ]
        });
    }
}
var $105fabe664da7e8a$export$2e2bcd8739ae039 = $105fabe664da7e8a$var$Table;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

var $1Spf6 = parcelRequire("1Spf6");
var $6e543bc5477d2d4a$exports = {};
"use strict";
Object.defineProperty($6e543bc5477d2d4a$exports, "__esModule", {
    value: true
});
var $83bbd306529af132$exports = {};
"use strict";
Object.defineProperty($83bbd306529af132$exports, "__esModule", {
    value: true
});
$83bbd306529af132$exports.bodyOpenClassName = $83bbd306529af132$exports.portalClassName = undefined;
var $83bbd306529af132$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $83bbd306529af132$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cQmXV = parcelRequire("cQmXV");
var $83bbd306529af132$var$_react2 = $83bbd306529af132$var$_interopRequireDefault($cQmXV);

var $3h5eW = parcelRequire("3h5eW");
var $83bbd306529af132$var$_reactDom2 = $83bbd306529af132$var$_interopRequireDefault($3h5eW);

var $1Spf6 = parcelRequire("1Spf6");
var $83bbd306529af132$var$_propTypes2 = $83bbd306529af132$var$_interopRequireDefault($1Spf6);
var $fe6e9e7962b43644$exports = {};
"use strict";
Object.defineProperty($fe6e9e7962b43644$exports, "__esModule", {
    value: true
});
var $fe6e9e7962b43644$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $fe6e9e7962b43644$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $fe6e9e7962b43644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cQmXV = parcelRequire("cQmXV");

var $1Spf6 = parcelRequire("1Spf6");
var $fe6e9e7962b43644$var$_propTypes2 = $fe6e9e7962b43644$var$_interopRequireDefault($1Spf6);
var $1d0ee62ead4b3c86$exports = {};
"use strict";
Object.defineProperty($1d0ee62ead4b3c86$exports, "__esModule", {
    value: true
});
$1d0ee62ead4b3c86$exports.resetState = $1d0ee62ead4b3c86$var$resetState;
$1d0ee62ead4b3c86$exports.log = $1d0ee62ead4b3c86$var$log;
$1d0ee62ead4b3c86$exports.handleBlur = $1d0ee62ead4b3c86$var$handleBlur;
$1d0ee62ead4b3c86$exports.handleFocus = $1d0ee62ead4b3c86$var$handleFocus;
$1d0ee62ead4b3c86$exports.markForFocusLater = $1d0ee62ead4b3c86$var$markForFocusLater;
$1d0ee62ead4b3c86$exports.returnFocus = $1d0ee62ead4b3c86$var$returnFocus;
$1d0ee62ead4b3c86$exports.popWithoutFocus = $1d0ee62ead4b3c86$var$popWithoutFocus;
$1d0ee62ead4b3c86$exports.setupScopedFocus = $1d0ee62ead4b3c86$var$setupScopedFocus;
$1d0ee62ead4b3c86$exports.teardownScopedFocus = $1d0ee62ead4b3c86$var$teardownScopedFocus;
var $835d0e18962e076b$exports = {};
"use strict";
Object.defineProperty($835d0e18962e076b$exports, "__esModule", {
    value: true
});
$835d0e18962e076b$exports.default = $835d0e18962e076b$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $835d0e18962e076b$var$DISPLAY_NONE = "none";
var $835d0e18962e076b$var$DISPLAY_CONTENTS = "contents";
var $835d0e18962e076b$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $835d0e18962e076b$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $835d0e18962e076b$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $835d0e18962e076b$var$DISPLAY_CONTENTS && $835d0e18962e076b$var$isNotOverflowing(element, style) : displayValue === $835d0e18962e076b$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $835d0e18962e076b$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($835d0e18962e076b$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $835d0e18962e076b$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $835d0e18962e076b$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $835d0e18962e076b$var$visible(element);
}
function $835d0e18962e076b$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $835d0e18962e076b$var$focusable(element, !isTabIndexNaN);
}
function $835d0e18962e076b$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $835d0e18962e076b$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($835d0e18962e076b$var$tabbable);
}
$835d0e18962e076b$exports = $835d0e18962e076b$exports["default"];


var $1d0ee62ead4b3c86$var$_tabbable2 = $1d0ee62ead4b3c86$var$_interopRequireDefault($835d0e18962e076b$exports);
function $1d0ee62ead4b3c86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1d0ee62ead4b3c86$var$focusLaterElements = [];
var $1d0ee62ead4b3c86$var$modalElement = null;
var $1d0ee62ead4b3c86$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $1d0ee62ead4b3c86$var$resetState() {
    $1d0ee62ead4b3c86$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $1d0ee62ead4b3c86$var$log() {}
/* eslint-enable no-console */ function $1d0ee62ead4b3c86$var$handleBlur() {
    $1d0ee62ead4b3c86$var$needToFocus = true;
}
function $1d0ee62ead4b3c86$var$handleFocus() {
    if ($1d0ee62ead4b3c86$var$needToFocus) {
        $1d0ee62ead4b3c86$var$needToFocus = false;
        if (!$1d0ee62ead4b3c86$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($1d0ee62ead4b3c86$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $1d0ee62ead4b3c86$var$_tabbable2.default)($1d0ee62ead4b3c86$var$modalElement)[0] || $1d0ee62ead4b3c86$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $1d0ee62ead4b3c86$var$markForFocusLater() {
    $1d0ee62ead4b3c86$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $1d0ee62ead4b3c86$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($1d0ee62ead4b3c86$var$focusLaterElements.length !== 0) {
            toFocus = $1d0ee62ead4b3c86$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $1d0ee62ead4b3c86$var$popWithoutFocus() {
    $1d0ee62ead4b3c86$var$focusLaterElements.length > 0 && $1d0ee62ead4b3c86$var$focusLaterElements.pop();
}
function $1d0ee62ead4b3c86$var$setupScopedFocus(element) {
    $1d0ee62ead4b3c86$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $1d0ee62ead4b3c86$var$handleBlur, false);
        document.addEventListener("focus", $1d0ee62ead4b3c86$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $1d0ee62ead4b3c86$var$handleBlur);
        document.attachEvent("onFocus", $1d0ee62ead4b3c86$var$handleFocus);
    }
}
function $1d0ee62ead4b3c86$var$teardownScopedFocus() {
    $1d0ee62ead4b3c86$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $1d0ee62ead4b3c86$var$handleBlur);
        document.removeEventListener("focus", $1d0ee62ead4b3c86$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $1d0ee62ead4b3c86$var$handleBlur);
        document.detachEvent("onFocus", $1d0ee62ead4b3c86$var$handleFocus);
    }
}


var $fe6e9e7962b43644$var$focusManager = $fe6e9e7962b43644$var$_interopRequireWildcard($1d0ee62ead4b3c86$exports);
var $7047002ebda0e2d4$exports = {};
"use strict";
Object.defineProperty($7047002ebda0e2d4$exports, "__esModule", {
    value: true
});
$7047002ebda0e2d4$exports.default = $7047002ebda0e2d4$var$scopeTab;

var $7047002ebda0e2d4$var$_tabbable2 = $7047002ebda0e2d4$var$_interopRequireDefault($835d0e18962e076b$exports);
function $7047002ebda0e2d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7047002ebda0e2d4$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $7047002ebda0e2d4$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $7047002ebda0e2d4$var$scopeTab(node, event) {
    var tabbable = (0, $7047002ebda0e2d4$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $7047002ebda0e2d4$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$7047002ebda0e2d4$exports = $7047002ebda0e2d4$exports["default"];


var $fe6e9e7962b43644$var$_scopeTab2 = $fe6e9e7962b43644$var$_interopRequireDefault($7047002ebda0e2d4$exports);
var $341cc4f9bb3dd827$exports = {};
"use strict";
Object.defineProperty($341cc4f9bb3dd827$exports, "__esModule", {
    value: true
});
$341cc4f9bb3dd827$exports.resetState = $341cc4f9bb3dd827$var$resetState;
$341cc4f9bb3dd827$exports.log = $341cc4f9bb3dd827$var$log;
$341cc4f9bb3dd827$exports.assertNodeList = $341cc4f9bb3dd827$var$assertNodeList;
$341cc4f9bb3dd827$exports.setElement = $341cc4f9bb3dd827$var$setElement;
$341cc4f9bb3dd827$exports.validateElement = $341cc4f9bb3dd827$var$validateElement;
$341cc4f9bb3dd827$exports.hide = $341cc4f9bb3dd827$var$hide;
$341cc4f9bb3dd827$exports.show = $341cc4f9bb3dd827$var$show;
$341cc4f9bb3dd827$exports.documentNotReadyOrSSRTesting = $341cc4f9bb3dd827$var$documentNotReadyOrSSRTesting;
var $031413f5e1011182$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $031413f5e1011182$var$__DEV__ = false;
var $031413f5e1011182$var$warning = function() {};
if ($031413f5e1011182$var$__DEV__) {
    var $031413f5e1011182$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $031413f5e1011182$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $031413f5e1011182$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$031413f5e1011182$exports = $031413f5e1011182$var$warning;


var $341cc4f9bb3dd827$var$_warning2 = $341cc4f9bb3dd827$var$_interopRequireDefault($031413f5e1011182$exports);
var $0f43c847b8bb231e$exports = {};
"use strict";
Object.defineProperty($0f43c847b8bb231e$exports, "__esModule", {
    value: true
});
$0f43c847b8bb231e$exports.canUseDOM = $0f43c847b8bb231e$exports.SafeNodeList = $0f43c847b8bb231e$exports.SafeHTMLCollection = undefined;
var $41e18661da49e748$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $41e18661da49e748$exports) $41e18661da49e748$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $0f43c847b8bb231e$var$_exenv2 = $0f43c847b8bb231e$var$_interopRequireDefault($41e18661da49e748$exports);
function $0f43c847b8bb231e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0f43c847b8bb231e$var$EE = $0f43c847b8bb231e$var$_exenv2.default;
var $0f43c847b8bb231e$var$SafeHTMLElement = $0f43c847b8bb231e$var$EE.canUseDOM ? window.HTMLElement : {};
var $0f43c847b8bb231e$var$SafeHTMLCollection = $0f43c847b8bb231e$exports.SafeHTMLCollection = $0f43c847b8bb231e$var$EE.canUseDOM ? window.HTMLCollection : {};
var $0f43c847b8bb231e$var$SafeNodeList = $0f43c847b8bb231e$exports.SafeNodeList = $0f43c847b8bb231e$var$EE.canUseDOM ? window.NodeList : {};
var $0f43c847b8bb231e$var$canUseDOM = $0f43c847b8bb231e$exports.canUseDOM = $0f43c847b8bb231e$var$EE.canUseDOM;
$0f43c847b8bb231e$exports.default = $0f43c847b8bb231e$var$SafeHTMLElement;


function $341cc4f9bb3dd827$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $341cc4f9bb3dd827$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $341cc4f9bb3dd827$var$resetState() {
    if ($341cc4f9bb3dd827$var$globalElement) {
        if ($341cc4f9bb3dd827$var$globalElement.removeAttribute) $341cc4f9bb3dd827$var$globalElement.removeAttribute("aria-hidden");
        else if ($341cc4f9bb3dd827$var$globalElement.length != null) $341cc4f9bb3dd827$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($341cc4f9bb3dd827$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $341cc4f9bb3dd827$var$globalElement = null;
}
/* istanbul ignore next */ function $341cc4f9bb3dd827$var$log() {
    var check;
}
/* eslint-enable no-console */ function $341cc4f9bb3dd827$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $341cc4f9bb3dd827$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $0f43c847b8bb231e$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $341cc4f9bb3dd827$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $341cc4f9bb3dd827$var$globalElement = useElement || $341cc4f9bb3dd827$var$globalElement;
    return $341cc4f9bb3dd827$var$globalElement;
}
function $341cc4f9bb3dd827$var$validateElement(appElement) {
    var el = appElement || $341cc4f9bb3dd827$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $341cc4f9bb3dd827$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $341cc4f9bb3dd827$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $341cc4f9bb3dd827$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $341cc4f9bb3dd827$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $341cc4f9bb3dd827$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $341cc4f9bb3dd827$var$documentNotReadyOrSSRTesting() {
    $341cc4f9bb3dd827$var$globalElement = null;
}


var $fe6e9e7962b43644$var$ariaAppHider = $fe6e9e7962b43644$var$_interopRequireWildcard($341cc4f9bb3dd827$exports);
var $07ba34362d02a0be$exports = {};
"use strict";
Object.defineProperty($07ba34362d02a0be$exports, "__esModule", {
    value: true
});
$07ba34362d02a0be$exports.resetState = $07ba34362d02a0be$var$resetState;
$07ba34362d02a0be$exports.log = $07ba34362d02a0be$var$log;
var $07ba34362d02a0be$var$htmlClassList = {};
var $07ba34362d02a0be$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $07ba34362d02a0be$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $07ba34362d02a0be$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $07ba34362d02a0be$var$htmlClassList)$07ba34362d02a0be$var$removeClass(htmlElement, $07ba34362d02a0be$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $07ba34362d02a0be$var$docBodyClassList)$07ba34362d02a0be$var$removeClass(body, $07ba34362d02a0be$var$docBodyClassList[_cls]);
    $07ba34362d02a0be$var$htmlClassList = {};
    $07ba34362d02a0be$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $07ba34362d02a0be$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $07ba34362d02a0be$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $07ba34362d02a0be$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $07ba34362d02a0be$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $07ba34362d02a0be$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $07ba34362d02a0be$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $07ba34362d02a0be$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $07ba34362d02a0be$var$add = $07ba34362d02a0be$exports.add = function add(element, classString) {
    return $07ba34362d02a0be$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $07ba34362d02a0be$var$htmlClassList : $07ba34362d02a0be$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $07ba34362d02a0be$var$remove = $07ba34362d02a0be$exports.remove = function remove(element, classString) {
    return $07ba34362d02a0be$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $07ba34362d02a0be$var$htmlClassList : $07ba34362d02a0be$var$docBodyClassList, classString.split(" "));
};


var $fe6e9e7962b43644$var$classList = $fe6e9e7962b43644$var$_interopRequireWildcard($07ba34362d02a0be$exports);

var $fe6e9e7962b43644$var$_safeHTMLElement2 = $fe6e9e7962b43644$var$_interopRequireDefault($0f43c847b8bb231e$exports);
var $032f87df91792009$exports = {};
"use strict";
Object.defineProperty($032f87df91792009$exports, "__esModule", {
    value: true
});
$032f87df91792009$exports.log = $032f87df91792009$var$log;
$032f87df91792009$exports.resetState = $032f87df91792009$var$resetState;
function $032f87df91792009$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $032f87df91792009$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $032f87df91792009$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $032f87df91792009$var$portalOpenInstances = new $032f87df91792009$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $032f87df91792009$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($032f87df91792009$var$portalOpenInstances.openInstances.length);
    $032f87df91792009$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $032f87df91792009$var$resetState() {
    $032f87df91792009$var$portalOpenInstances = new $032f87df91792009$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $032f87df91792009$exports.default = $032f87df91792009$var$portalOpenInstances;


var $fe6e9e7962b43644$var$_portalOpenInstances2 = $fe6e9e7962b43644$var$_interopRequireDefault($032f87df91792009$exports);
var $163e40373cb6870d$exports = {};
"use strict";
Object.defineProperty($163e40373cb6870d$exports, "__esModule", {
    value: true
});
$163e40373cb6870d$exports.resetState = $163e40373cb6870d$var$resetState;
$163e40373cb6870d$exports.log = $163e40373cb6870d$var$log;

var $163e40373cb6870d$var$_portalOpenInstances2 = $163e40373cb6870d$var$_interopRequireDefault($032f87df91792009$exports);
function $163e40373cb6870d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $163e40373cb6870d$var$before = void 0, $163e40373cb6870d$var$after = void 0, $163e40373cb6870d$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $163e40373cb6870d$var$resetState() {
    var _arr = [
        $163e40373cb6870d$var$before,
        $163e40373cb6870d$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $163e40373cb6870d$var$before = $163e40373cb6870d$var$after = null;
    $163e40373cb6870d$var$instances = [];
}
/* istanbul ignore next */ function $163e40373cb6870d$var$log() {
    console.log("bodyTrap ----------");
    console.log($163e40373cb6870d$var$instances.length);
    var _arr2 = [
        $163e40373cb6870d$var$before,
        $163e40373cb6870d$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $163e40373cb6870d$var$focusContent() {
    if ($163e40373cb6870d$var$instances.length === 0) return;
    $163e40373cb6870d$var$instances[$163e40373cb6870d$var$instances.length - 1].focusContent();
}
function $163e40373cb6870d$var$bodyTrap(eventType, openInstances) {
    if (!$163e40373cb6870d$var$before && !$163e40373cb6870d$var$after) {
        $163e40373cb6870d$var$before = document.createElement("div");
        $163e40373cb6870d$var$before.setAttribute("data-react-modal-body-trap", "");
        $163e40373cb6870d$var$before.style.position = "absolute";
        $163e40373cb6870d$var$before.style.opacity = "0";
        $163e40373cb6870d$var$before.setAttribute("tabindex", "0");
        $163e40373cb6870d$var$before.addEventListener("focus", $163e40373cb6870d$var$focusContent);
        $163e40373cb6870d$var$after = $163e40373cb6870d$var$before.cloneNode();
        $163e40373cb6870d$var$after.addEventListener("focus", $163e40373cb6870d$var$focusContent);
    }
    $163e40373cb6870d$var$instances = openInstances;
    if ($163e40373cb6870d$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $163e40373cb6870d$var$before) document.body.insertBefore($163e40373cb6870d$var$before, document.body.firstChild);
        if (document.body.lastChild !== $163e40373cb6870d$var$after) document.body.appendChild($163e40373cb6870d$var$after);
    } else {
        // Remove focus trap
        if ($163e40373cb6870d$var$before.parentElement) $163e40373cb6870d$var$before.parentElement.removeChild($163e40373cb6870d$var$before);
        if ($163e40373cb6870d$var$after.parentElement) $163e40373cb6870d$var$after.parentElement.removeChild($163e40373cb6870d$var$after);
    }
}
$163e40373cb6870d$var$_portalOpenInstances2.default.subscribe($163e40373cb6870d$var$bodyTrap);


function $fe6e9e7962b43644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $fe6e9e7962b43644$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe6e9e7962b43644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fe6e9e7962b43644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fe6e9e7962b43644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $fe6e9e7962b43644$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $fe6e9e7962b43644$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $fe6e9e7962b43644$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $fe6e9e7962b43644$var$ariaHiddenInstances = 0;
var $fe6e9e7962b43644$var$ModalPortal = function(_Component) {
    $fe6e9e7962b43644$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $fe6e9e7962b43644$var$_classCallCheck(this, ModalPortal);
        var _this = $fe6e9e7962b43644$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $fe6e9e7962b43644$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $fe6e9e7962b43644$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $fe6e9e7962b43644$var$ariaHiddenInstances > 0) {
                $fe6e9e7962b43644$var$ariaHiddenInstances -= 1;
                if ($fe6e9e7962b43644$var$ariaHiddenInstances === 0) $fe6e9e7962b43644$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $fe6e9e7962b43644$var$focusManager.returnFocus(_this.props.preventScroll);
                    $fe6e9e7962b43644$var$focusManager.teardownScopedFocus();
                } else $fe6e9e7962b43644$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $fe6e9e7962b43644$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $fe6e9e7962b43644$var$focusManager.setupScopedFocus(_this.node);
                    $fe6e9e7962b43644$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($fe6e9e7962b43644$var$isTabKey(event)) (0, $fe6e9e7962b43644$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $fe6e9e7962b43644$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $fe6e9e7962b43644$var$_typeof(additional)) === "object" ? additional : {
                base: $fe6e9e7962b43644$var$CLASS_NAMES[which],
                afterOpen: $fe6e9e7962b43644$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $fe6e9e7962b43644$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $fe6e9e7962b43644$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $fe6e9e7962b43644$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $fe6e9e7962b43644$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $fe6e9e7962b43644$var$ariaHiddenInstances += 1;
                    $fe6e9e7962b43644$var$ariaAppHider.hide(appElement);
                }
                $fe6e9e7962b43644$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $fe6e9e7962b43644$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $fe6e9e7962b43644$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $fe6e9e7962b43644$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $fe6e9e7962b43644$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($cQmXV.Component);
$fe6e9e7962b43644$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$fe6e9e7962b43644$var$ModalPortal.propTypes = {
    isOpen: $fe6e9e7962b43644$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $fe6e9e7962b43644$var$_propTypes2.default.shape({
        content: $fe6e9e7962b43644$var$_propTypes2.default.object,
        overlay: $fe6e9e7962b43644$var$_propTypes2.default.object
    }),
    style: $fe6e9e7962b43644$var$_propTypes2.default.shape({
        content: $fe6e9e7962b43644$var$_propTypes2.default.object,
        overlay: $fe6e9e7962b43644$var$_propTypes2.default.object
    }),
    className: $fe6e9e7962b43644$var$_propTypes2.default.oneOfType([
        $fe6e9e7962b43644$var$_propTypes2.default.string,
        $fe6e9e7962b43644$var$_propTypes2.default.object
    ]),
    overlayClassName: $fe6e9e7962b43644$var$_propTypes2.default.oneOfType([
        $fe6e9e7962b43644$var$_propTypes2.default.string,
        $fe6e9e7962b43644$var$_propTypes2.default.object
    ]),
    parentSelector: $fe6e9e7962b43644$var$_propTypes2.default.func,
    bodyOpenClassName: $fe6e9e7962b43644$var$_propTypes2.default.string,
    htmlOpenClassName: $fe6e9e7962b43644$var$_propTypes2.default.string,
    ariaHideApp: $fe6e9e7962b43644$var$_propTypes2.default.bool,
    appElement: $fe6e9e7962b43644$var$_propTypes2.default.oneOfType([
        $fe6e9e7962b43644$var$_propTypes2.default.instanceOf($fe6e9e7962b43644$var$_safeHTMLElement2.default),
        $fe6e9e7962b43644$var$_propTypes2.default.instanceOf($0f43c847b8bb231e$exports.SafeHTMLCollection),
        $fe6e9e7962b43644$var$_propTypes2.default.instanceOf($0f43c847b8bb231e$exports.SafeNodeList),
        $fe6e9e7962b43644$var$_propTypes2.default.arrayOf($fe6e9e7962b43644$var$_propTypes2.default.instanceOf($fe6e9e7962b43644$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $fe6e9e7962b43644$var$_propTypes2.default.func,
    onAfterClose: $fe6e9e7962b43644$var$_propTypes2.default.func,
    onRequestClose: $fe6e9e7962b43644$var$_propTypes2.default.func,
    closeTimeoutMS: $fe6e9e7962b43644$var$_propTypes2.default.number,
    shouldFocusAfterRender: $fe6e9e7962b43644$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $fe6e9e7962b43644$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $fe6e9e7962b43644$var$_propTypes2.default.bool,
    preventScroll: $fe6e9e7962b43644$var$_propTypes2.default.bool,
    role: $fe6e9e7962b43644$var$_propTypes2.default.string,
    contentLabel: $fe6e9e7962b43644$var$_propTypes2.default.string,
    aria: $fe6e9e7962b43644$var$_propTypes2.default.object,
    data: $fe6e9e7962b43644$var$_propTypes2.default.object,
    children: $fe6e9e7962b43644$var$_propTypes2.default.node,
    shouldCloseOnEsc: $fe6e9e7962b43644$var$_propTypes2.default.bool,
    overlayRef: $fe6e9e7962b43644$var$_propTypes2.default.func,
    contentRef: $fe6e9e7962b43644$var$_propTypes2.default.func,
    id: $fe6e9e7962b43644$var$_propTypes2.default.string,
    overlayElement: $fe6e9e7962b43644$var$_propTypes2.default.func,
    contentElement: $fe6e9e7962b43644$var$_propTypes2.default.func,
    testId: $fe6e9e7962b43644$var$_propTypes2.default.string
};
$fe6e9e7962b43644$exports.default = $fe6e9e7962b43644$var$ModalPortal;
$fe6e9e7962b43644$exports = $fe6e9e7962b43644$exports["default"];


var $83bbd306529af132$var$_ModalPortal2 = $83bbd306529af132$var$_interopRequireDefault($fe6e9e7962b43644$exports);

var $83bbd306529af132$var$ariaAppHider = $83bbd306529af132$var$_interopRequireWildcard($341cc4f9bb3dd827$exports);

var $83bbd306529af132$var$_safeHTMLElement2 = $83bbd306529af132$var$_interopRequireDefault($0f43c847b8bb231e$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $fd624b67ca307006$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $fd624b67ca307006$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $fd624b67ca307006$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$fd624b67ca307006$var$componentWillMount.__suppressDeprecationWarning = true;
$fd624b67ca307006$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$fd624b67ca307006$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $fd624b67ca307006$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $fd624b67ca307006$var$componentWillMount;
        prototype.componentWillReceiveProps = $fd624b67ca307006$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $fd624b67ca307006$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $83bbd306529af132$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $83bbd306529af132$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $83bbd306529af132$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $83bbd306529af132$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $83bbd306529af132$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $83bbd306529af132$var$portalClassName = $83bbd306529af132$exports.portalClassName = "ReactModalPortal";
var $83bbd306529af132$var$bodyOpenClassName = $83bbd306529af132$exports.bodyOpenClassName = "ReactModal__Body--open";
var $83bbd306529af132$var$isReact16 = $0f43c847b8bb231e$exports.canUseDOM && $83bbd306529af132$var$_reactDom2.default.createPortal !== undefined;
var $83bbd306529af132$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $83bbd306529af132$var$getCreatePortal = function getCreatePortal() {
    return $83bbd306529af132$var$isReact16 ? $83bbd306529af132$var$_reactDom2.default.createPortal : $83bbd306529af132$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $83bbd306529af132$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $83bbd306529af132$var$Modal = function(_Component) {
    $83bbd306529af132$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $83bbd306529af132$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $83bbd306529af132$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$83bbd306529af132$var$isReact16 && $83bbd306529af132$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $83bbd306529af132$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $83bbd306529af132$var$getCreatePortal();
            var portal = createPortal(_this, $83bbd306529af132$var$_react2.default.createElement($83bbd306529af132$var$_ModalPortal2.default, $83bbd306529af132$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $83bbd306529af132$var$_possibleConstructorReturn(_this, _ret);
    }
    $83bbd306529af132$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$0f43c847b8bb231e$exports.canUseDOM) return;
                if (!$83bbd306529af132$var$isReact16) this.node = $83bbd306529af132$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $83bbd306529af132$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$83bbd306529af132$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $83bbd306529af132$var$getParentElement(prevProps.parentSelector);
                var nextParent = $83bbd306529af132$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$0f43c847b8bb231e$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$83bbd306529af132$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$0f43c847b8bb231e$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$0f43c847b8bb231e$exports.canUseDOM || !$83bbd306529af132$var$isReact16) return null;
                if (!this.node && $83bbd306529af132$var$isReact16) this.node = $83bbd306529af132$var$createHTMLElement("div");
                var createPortal = $83bbd306529af132$var$getCreatePortal();
                return createPortal($83bbd306529af132$var$_react2.default.createElement($83bbd306529af132$var$_ModalPortal2.default, $83bbd306529af132$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $83bbd306529af132$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($cQmXV.Component);
$83bbd306529af132$var$Modal.propTypes = {
    isOpen: $83bbd306529af132$var$_propTypes2.default.bool.isRequired,
    style: $83bbd306529af132$var$_propTypes2.default.shape({
        content: $83bbd306529af132$var$_propTypes2.default.object,
        overlay: $83bbd306529af132$var$_propTypes2.default.object
    }),
    portalClassName: $83bbd306529af132$var$_propTypes2.default.string,
    bodyOpenClassName: $83bbd306529af132$var$_propTypes2.default.string,
    htmlOpenClassName: $83bbd306529af132$var$_propTypes2.default.string,
    className: $83bbd306529af132$var$_propTypes2.default.oneOfType([
        $83bbd306529af132$var$_propTypes2.default.string,
        $83bbd306529af132$var$_propTypes2.default.shape({
            base: $83bbd306529af132$var$_propTypes2.default.string.isRequired,
            afterOpen: $83bbd306529af132$var$_propTypes2.default.string.isRequired,
            beforeClose: $83bbd306529af132$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $83bbd306529af132$var$_propTypes2.default.oneOfType([
        $83bbd306529af132$var$_propTypes2.default.string,
        $83bbd306529af132$var$_propTypes2.default.shape({
            base: $83bbd306529af132$var$_propTypes2.default.string.isRequired,
            afterOpen: $83bbd306529af132$var$_propTypes2.default.string.isRequired,
            beforeClose: $83bbd306529af132$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $83bbd306529af132$var$_propTypes2.default.oneOfType([
        $83bbd306529af132$var$_propTypes2.default.instanceOf($83bbd306529af132$var$_safeHTMLElement2.default),
        $83bbd306529af132$var$_propTypes2.default.instanceOf($0f43c847b8bb231e$exports.SafeHTMLCollection),
        $83bbd306529af132$var$_propTypes2.default.instanceOf($0f43c847b8bb231e$exports.SafeNodeList),
        $83bbd306529af132$var$_propTypes2.default.arrayOf($83bbd306529af132$var$_propTypes2.default.instanceOf($83bbd306529af132$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $83bbd306529af132$var$_propTypes2.default.func,
    onRequestClose: $83bbd306529af132$var$_propTypes2.default.func,
    closeTimeoutMS: $83bbd306529af132$var$_propTypes2.default.number,
    ariaHideApp: $83bbd306529af132$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $83bbd306529af132$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $83bbd306529af132$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $83bbd306529af132$var$_propTypes2.default.bool,
    preventScroll: $83bbd306529af132$var$_propTypes2.default.bool,
    parentSelector: $83bbd306529af132$var$_propTypes2.default.func,
    aria: $83bbd306529af132$var$_propTypes2.default.object,
    data: $83bbd306529af132$var$_propTypes2.default.object,
    role: $83bbd306529af132$var$_propTypes2.default.string,
    contentLabel: $83bbd306529af132$var$_propTypes2.default.string,
    shouldCloseOnEsc: $83bbd306529af132$var$_propTypes2.default.bool,
    overlayRef: $83bbd306529af132$var$_propTypes2.default.func,
    contentRef: $83bbd306529af132$var$_propTypes2.default.func,
    id: $83bbd306529af132$var$_propTypes2.default.string,
    overlayElement: $83bbd306529af132$var$_propTypes2.default.func,
    contentElement: $83bbd306529af132$var$_propTypes2.default.func
};
$83bbd306529af132$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $83bbd306529af132$var$portalClassName,
    bodyOpenClassName: $83bbd306529af132$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $83bbd306529af132$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $83bbd306529af132$var$_react2.default.createElement("div", props, children);
    }
};
$83bbd306529af132$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $fd624b67ca307006$export$cea1c58a6db52bca)($83bbd306529af132$var$Modal);
$83bbd306529af132$exports.default = $83bbd306529af132$var$Modal;


var $6e543bc5477d2d4a$var$_Modal2 = $6e543bc5477d2d4a$var$_interopRequireDefault($83bbd306529af132$exports);
function $6e543bc5477d2d4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$6e543bc5477d2d4a$exports.default = $6e543bc5477d2d4a$var$_Modal2.default;
$6e543bc5477d2d4a$exports = $6e543bc5477d2d4a$exports["default"];


function $863febd3c37c55c4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $863febd3c37c55c4$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $863febd3c37c55c4$var$ownKeys(Object(source), true).forEach(function(key) {
            $863febd3c37c55c4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $863febd3c37c55c4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $863febd3c37c55c4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $863febd3c37c55c4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $863febd3c37c55c4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $863febd3c37c55c4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $863febd3c37c55c4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $863febd3c37c55c4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $863febd3c37c55c4$var$_extends() {
    $863febd3c37c55c4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $863febd3c37c55c4$var$_extends.apply(this, arguments);
}
function $863febd3c37c55c4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $863febd3c37c55c4$var$_setPrototypeOf(subClass, superClass);
}
function $863febd3c37c55c4$var$_getPrototypeOf(o) {
    $863febd3c37c55c4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $863febd3c37c55c4$var$_getPrototypeOf(o);
}
function $863febd3c37c55c4$var$_setPrototypeOf(o, p) {
    $863febd3c37c55c4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $863febd3c37c55c4$var$_setPrototypeOf(o, p);
}
function $863febd3c37c55c4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $863febd3c37c55c4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $863febd3c37c55c4$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $863febd3c37c55c4$var$_assertThisInitialized(self);
}
function $863febd3c37c55c4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $863febd3c37c55c4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $863febd3c37c55c4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $863febd3c37c55c4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $863febd3c37c55c4$var$_possibleConstructorReturn(this, result);
    };
}
function $863febd3c37c55c4$var$_slicedToArray(arr, i) {
    return $863febd3c37c55c4$var$_arrayWithHoles(arr) || $863febd3c37c55c4$var$_iterableToArrayLimit(arr, i) || $863febd3c37c55c4$var$_unsupportedIterableToArray(arr, i) || $863febd3c37c55c4$var$_nonIterableRest();
}
function $863febd3c37c55c4$var$_toConsumableArray(arr) {
    return $863febd3c37c55c4$var$_arrayWithoutHoles(arr) || $863febd3c37c55c4$var$_iterableToArray(arr) || $863febd3c37c55c4$var$_unsupportedIterableToArray(arr) || $863febd3c37c55c4$var$_nonIterableSpread();
}
function $863febd3c37c55c4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $863febd3c37c55c4$var$_arrayLikeToArray(arr);
}
function $863febd3c37c55c4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $863febd3c37c55c4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $863febd3c37c55c4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $863febd3c37c55c4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $863febd3c37c55c4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $863febd3c37c55c4$var$_arrayLikeToArray(o, minLen);
}
function $863febd3c37c55c4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $863febd3c37c55c4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $863febd3c37c55c4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Placeholder for future translate functionality
 */ function $863febd3c37c55c4$var$translate(str) {
    var replaceStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!str) return "";
    var translated = str;
    if (replaceStrings) Object.keys(replaceStrings).forEach(function(placeholder) {
        translated = translated.replace(placeholder, replaceStrings[placeholder]);
    });
    return translated;
}
function $863febd3c37c55c4$var$getWindowWidth() {
    return typeof $parcel$global.window !== "undefined" ? $parcel$global.window.innerWidth : 0;
}
function $863febd3c37c55c4$var$getWindowHeight() {
    return typeof $parcel$global.window !== "undefined" ? $parcel$global.window.innerHeight : 0;
}
var $863febd3c37c55c4$var$isCrossOriginFrame = function isCrossOriginFrame() {
    try {
        return $parcel$global.window.location.hostname !== $parcel$global.window.parent.location.hostname;
    } catch (e) {
        return true;
    }
}; // Get the highest window context that isn't cross-origin
// (When in an iframe)
function $863febd3c37c55c4$var$getHighestSafeWindowContext() {
    var self = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $parcel$global.window.self;
    // If we reached the top level, return self
    if (self === $parcel$global.window.top) return self;
     // If parent is the same origin, we can move up one context
    // Reference: https://stackoverflow.com/a/21965342/1601953
    if (!$863febd3c37c55c4$var$isCrossOriginFrame()) return $863febd3c37c55c4$var$getHighestSafeWindowContext(self.parent);
     // If a different origin, we consider the current level
    // as the top reachable one
    return self;
}
// Min image zoom level
var $863febd3c37c55c4$var$MIN_ZOOM_LEVEL = 0; // Max image zoom level
var $863febd3c37c55c4$var$MAX_ZOOM_LEVEL = 300; // Size ratio between previous and next zoom levels
var $863febd3c37c55c4$var$ZOOM_RATIO = 1.007; // How much to increase/decrease the zoom level when the zoom buttons are clicked
var $863febd3c37c55c4$var$ZOOM_BUTTON_INCREMENT_SIZE = 100; // Used to judge the amount of horizontal scroll needed to initiate a image move
var $863febd3c37c55c4$var$WHEEL_MOVE_X_THRESHOLD = 200; // Used to judge the amount of vertical scroll needed to initiate a zoom action
var $863febd3c37c55c4$var$WHEEL_MOVE_Y_THRESHOLD = 1;
var $863febd3c37c55c4$var$KEYS = {
    ESC: 27,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39
}; // Actions
var $863febd3c37c55c4$var$ACTION_NONE = 0;
var $863febd3c37c55c4$var$ACTION_MOVE = 1;
var $863febd3c37c55c4$var$ACTION_SWIPE = 2;
var $863febd3c37c55c4$var$ACTION_PINCH = 3;
var $863febd3c37c55c4$var$SOURCE_ANY = 0;
var $863febd3c37c55c4$var$SOURCE_MOUSE = 1;
var $863febd3c37c55c4$var$SOURCE_TOUCH = 2;
var $863febd3c37c55c4$var$SOURCE_POINTER = 3; // Minimal swipe distance
var $863febd3c37c55c4$var$MIN_SWIPE_DISTANCE = 200;
var $863febd3c37c55c4$var$ReactImageLightbox = /*#__PURE__*/ function(_Component) {
    $863febd3c37c55c4$var$_inherits(ReactImageLightbox, _Component);
    var _super = $863febd3c37c55c4$var$_createSuper(ReactImageLightbox);
    function ReactImageLightbox(props) {
        var _this;
        $863febd3c37c55c4$var$_classCallCheck(this, ReactImageLightbox);
        _this = _super.call(this, props);
        _this.state = {
            //-----------------------------
            // Animation
            //-----------------------------
            // Lightbox is closing
            // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
            isClosing: !props.animationDisabled,
            // Component parts should animate (e.g., when images are moving, or image is being zoomed)
            shouldAnimate: false,
            //-----------------------------
            // Zoom settings
            //-----------------------------
            // Zoom level of image
            zoomLevel: $863febd3c37c55c4$var$MIN_ZOOM_LEVEL,
            //-----------------------------
            // Image position settings
            //-----------------------------
            // Horizontal offset from center
            offsetX: 0,
            // Vertical offset from center
            offsetY: 0,
            // image load error for srcType
            loadErrorStatus: {}
        }; // Refs
        _this.outerEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        _this.zoomInBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        _this.zoomOutBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        _this.caption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        _this.closeIfClickInner = _this.closeIfClickInner.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleKeyInput = _this.handleKeyInput.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleMouseUp = _this.handleMouseUp.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleMouseDown = _this.handleMouseDown.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleMouseMove = _this.handleMouseMove.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleTouchStart = _this.handleTouchStart.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleTouchMove = _this.handleTouchMove.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleTouchEnd = _this.handleTouchEnd.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handlePointerEvent = _this.handlePointerEvent.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleWindowResize = _this.handleWindowResize.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.requestClose = _this.requestClose.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.requestMoveNext = _this.requestMoveNext.bind($863febd3c37c55c4$var$_assertThisInitialized(_this));
        _this.requestMovePrev = _this.requestMovePrev.bind($863febd3c37c55c4$var$_assertThisInitialized(_this)); // Timeouts - always clear it before umount
        _this.timeouts = []; // Current action
        _this.currentAction = $863febd3c37c55c4$var$ACTION_NONE; // Events source
        _this.eventsSource = $863febd3c37c55c4$var$SOURCE_ANY; // Empty pointers list
        _this.pointerList = []; // Prevent inner close
        _this.preventInnerClose = false;
        _this.preventInnerCloseTimeout = null; // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc
        _this.keyPressed = false; // Used to store load state / dimensions of images
        _this.imageCache = {}; // Time the last keydown event was called (used in keyboard action rate limiting)
        _this.lastKeyDownTime = 0; // Used for debouncing window resize event
        _this.resizeTimeout = null; // Used to determine when actions are triggered by the scroll wheel
        _this.wheelActionTimeout = null;
        _this.resetScrollTimeout = null;
        _this.scrollX = 0;
        _this.scrollY = 0; // Used in panning zoomed images
        _this.moveStartX = 0;
        _this.moveStartY = 0;
        _this.moveStartOffsetX = 0;
        _this.moveStartOffsetY = 0; // Used to swipe
        _this.swipeStartX = 0;
        _this.swipeStartY = 0;
        _this.swipeEndX = 0;
        _this.swipeEndY = 0; // Used to pinch
        _this.pinchTouchList = null;
        _this.pinchDistance = 0; // Used to differentiate between images with identical src
        _this.keyCounter = 0; // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)
        _this.moveRequested = false;
        return _this;
    }
    $863febd3c37c55c4$var$_createClass(ReactImageLightbox, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (!this.props.animationDisabled) // Make opening animation play
                this.setState({
                    isClosing: false
                });
                 // Prevents cross-origin errors when using a cross-origin iframe
                this.windowContext = $863febd3c37c55c4$var$getHighestSafeWindowContext();
                this.listeners = {
                    resize: this.handleWindowResize,
                    mouseup: this.handleMouseUp,
                    touchend: this.handleTouchEnd,
                    touchcancel: this.handleTouchEnd,
                    pointerdown: this.handlePointerEvent,
                    pointermove: this.handlePointerEvent,
                    pointerup: this.handlePointerEvent,
                    pointercancel: this.handlePointerEvent
                };
                Object.keys(this.listeners).forEach(function(type) {
                    _this2.windowContext.addEventListener(type, _this2.listeners[type]);
                });
                this.loadAllImages();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this3 = this;
                this.getSrcTypes().forEach(function(srcType) {
                    if (_this3.props[srcType.name] !== nextProps[srcType.name]) _this3.moveRequested = false;
                }); // Wait for move...
                return !this.moveRequested;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this4 = this;
                var sourcesChanged = false;
                var prevSrcDict = {};
                var nextSrcDict = {};
                this.getSrcTypes().forEach(function(srcType) {
                    if (prevProps[srcType.name] !== _this4.props[srcType.name]) {
                        sourcesChanged = true;
                        prevSrcDict[prevProps[srcType.name]] = true;
                        nextSrcDict[_this4.props[srcType.name]] = true;
                    }
                });
                if (sourcesChanged || this.moveRequested) {
                    // Reset the loaded state for images not rendered next
                    Object.keys(prevSrcDict).forEach(function(prevSrc) {
                        if (!(prevSrc in nextSrcDict) && prevSrc in _this4.imageCache) _this4.imageCache[prevSrc].loaded = false;
                    });
                    this.moveRequested = false; // Load any new images
                    this.loadAllImages(this.props);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this5 = this;
                this.didUnmount = true;
                Object.keys(this.listeners).forEach(function(type) {
                    _this5.windowContext.removeEventListener(type, _this5.listeners[type]);
                });
                this.timeouts.forEach(function(tid) {
                    return clearTimeout(tid);
                });
            }
        },
        {
            key: "setTimeout",
            value: function(_setTimeout) {
                function setTimeout1(_x, _x2) {
                    return _setTimeout.apply(this, arguments);
                }
                setTimeout1.toString = function() {
                    return _setTimeout.toString();
                };
                return setTimeout1;
            }(function(func, time) {
                var _this6 = this;
                var id = setTimeout(function() {
                    _this6.timeouts = _this6.timeouts.filter(function(tid) {
                        return tid !== id;
                    });
                    func();
                }, time);
                this.timeouts.push(id);
                return id;
            })
        },
        {
            key: "setPreventInnerClose",
            value: function setPreventInnerClose() {
                var _this7 = this;
                if (this.preventInnerCloseTimeout) this.clearTimeout(this.preventInnerCloseTimeout);
                this.preventInnerClose = true;
                this.preventInnerCloseTimeout = this.setTimeout(function() {
                    _this7.preventInnerClose = false;
                    _this7.preventInnerCloseTimeout = null;
                }, 100);
            } // Get info for the best suited image to display with the given srcType
        },
        {
            key: "getBestImageForType",
            value: function getBestImageForType(srcType) {
                var imageSrc = this.props[srcType];
                var fitSizes = {};
                if (this.isImageLoaded(imageSrc)) // Use full-size image if available
                fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height);
                else if (this.isImageLoaded(this.props["".concat(srcType, "Thumbnail")])) {
                    // Fall back to using thumbnail if the image has not been loaded
                    imageSrc = this.props["".concat(srcType, "Thumbnail")];
                    fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, true);
                } else return null;
                return {
                    src: imageSrc,
                    height: this.imageCache[imageSrc].height,
                    width: this.imageCache[imageSrc].width,
                    targetHeight: fitSizes.height,
                    targetWidth: fitSizes.width
                };
            } // Get sizing for when an image is larger than the window
        },
        {
            key: "getFitSizes",
            value: function getFitSizes(width, height, stretch) {
                var boxSize = this.getLightboxRect();
                var maxHeight = boxSize.height - this.props.imagePadding * 2;
                var maxWidth = boxSize.width - this.props.imagePadding * 2;
                if (!stretch) {
                    maxHeight = Math.min(maxHeight, height);
                    maxWidth = Math.min(maxWidth, width);
                }
                var maxRatio = maxWidth / maxHeight;
                var srcRatio = width / height;
                if (maxRatio > srcRatio) // height is the constraining dimension of the photo
                return {
                    width: width * maxHeight / height,
                    height: maxHeight
                };
                return {
                    width: maxWidth,
                    height: height * maxWidth / width
                };
            }
        },
        {
            key: "getMaxOffsets",
            value: function getMaxOffsets() {
                var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
                var currentImageInfo = this.getBestImageForType("mainSrc");
                if (currentImageInfo === null) return {
                    maxX: 0,
                    minX: 0,
                    maxY: 0,
                    minY: 0
                };
                var boxSize = this.getLightboxRect();
                var zoomMultiplier = this.getZoomMultiplier(zoomLevel);
                var maxX = 0;
                if (zoomMultiplier * currentImageInfo.width - boxSize.width < 0) // if there is still blank space in the X dimension, don't limit except to the opposite edge
                maxX = (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2;
                else maxX = (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
                var maxY = 0;
                if (zoomMultiplier * currentImageInfo.height - boxSize.height < 0) // if there is still blank space in the Y dimension, don't limit except to the opposite edge
                maxY = (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2;
                else maxY = (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2;
                return {
                    maxX: maxX,
                    maxY: maxY,
                    minX: -1 * maxX,
                    minY: -1 * maxY
                };
            } // Get image src types
        },
        {
            key: "getSrcTypes",
            value: function getSrcTypes() {
                return [
                    {
                        name: "mainSrc",
                        keyEnding: "i".concat(this.keyCounter)
                    },
                    {
                        name: "mainSrcThumbnail",
                        keyEnding: "t".concat(this.keyCounter)
                    },
                    {
                        name: "nextSrc",
                        keyEnding: "i".concat(this.keyCounter + 1)
                    },
                    {
                        name: "nextSrcThumbnail",
                        keyEnding: "t".concat(this.keyCounter + 1)
                    },
                    {
                        name: "prevSrc",
                        keyEnding: "i".concat(this.keyCounter - 1)
                    },
                    {
                        name: "prevSrcThumbnail",
                        keyEnding: "t".concat(this.keyCounter - 1)
                    }
                ];
            }
        },
        {
            key: "getZoomMultiplier",
            value: function getZoomMultiplier() {
                var zoomLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.zoomLevel;
                return Math.pow($863febd3c37c55c4$var$ZOOM_RATIO, zoomLevel);
            }
        },
        {
            key: "getLightboxRect",
            value: function getLightboxRect() {
                if (this.outerEl.current) return this.outerEl.current.getBoundingClientRect();
                return {
                    width: $863febd3c37c55c4$var$getWindowWidth(),
                    height: $863febd3c37c55c4$var$getWindowHeight(),
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
            }
        },
        {
            key: "clearTimeout",
            value: function(_clearTimeout) {
                function clearTimeout1(_x3) {
                    return _clearTimeout.apply(this, arguments);
                }
                clearTimeout1.toString = function() {
                    return _clearTimeout.toString();
                };
                return clearTimeout1;
            }(function(id) {
                this.timeouts = this.timeouts.filter(function(tid) {
                    return tid !== id;
                });
                clearTimeout(id);
            } // Change zoom level
            )
        },
        {
            key: "changeZoom",
            value: function changeZoom(zoomLevel, clientX, clientY) {
                // Ignore if zoom disabled
                if (!this.props.enableZoom) return;
                 // Constrain zoom level to the set bounds
                var nextZoomLevel = Math.max($863febd3c37c55c4$var$MIN_ZOOM_LEVEL, Math.min($863febd3c37c55c4$var$MAX_ZOOM_LEVEL, zoomLevel)); // Ignore requests that don't change the zoom level
                if (nextZoomLevel === this.state.zoomLevel) return;
                if (nextZoomLevel === $863febd3c37c55c4$var$MIN_ZOOM_LEVEL) {
                    // Snap back to center if zoomed all the way out
                    this.setState({
                        zoomLevel: nextZoomLevel,
                        offsetX: 0,
                        offsetY: 0
                    });
                    return;
                }
                var imageBaseSize = this.getBestImageForType("mainSrc");
                if (imageBaseSize === null) return;
                var currentZoomMultiplier = this.getZoomMultiplier();
                var nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel); // Default to the center of the image to zoom when no mouse position specified
                var boxRect = this.getLightboxRect();
                var pointerX = typeof clientX !== "undefined" ? clientX - boxRect.left : boxRect.width / 2;
                var pointerY = typeof clientY !== "undefined" ? clientY - boxRect.top : boxRect.height / 2;
                var currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2;
                var currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2;
                var currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX;
                var currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY;
                var currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier;
                var currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier;
                var nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier;
                var nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier;
                var nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2;
                var nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2;
                var nextOffsetX = nextImageOffsetX - nextImageRealOffsetX;
                var nextOffsetY = nextImageOffsetY - nextImageRealOffsetY; // When zooming out, limit the offset so things don't get left askew
                if (this.currentAction !== $863febd3c37c55c4$var$ACTION_PINCH) {
                    var maxOffsets = this.getMaxOffsets();
                    if (this.state.zoomLevel > nextZoomLevel) {
                        nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX));
                        nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY));
                    }
                }
                this.setState({
                    zoomLevel: nextZoomLevel,
                    offsetX: nextOffsetX,
                    offsetY: nextOffsetY
                });
            }
        },
        {
            key: "closeIfClickInner",
            value: function closeIfClickInner(event) {
                if (!this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1) this.requestClose(event);
            }
        },
        {
            key: "handleKeyInput",
            value: function handleKeyInput(event) {
                event.stopPropagation(); // Ignore key input during animations
                if (this.isAnimating()) return;
                 // Allow slightly faster navigation through the images when user presses keys repeatedly
                if (event.type === "keyup") {
                    this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus;
                    return;
                }
                var keyCode = event.which || event.keyCode; // Ignore key presses that happen too close to each other (when rapid fire key pressing or holding down the key)
                // But allow it if it's a lightbox closing action
                var currentTime = new Date();
                if (currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== $863febd3c37c55c4$var$KEYS.ESC) return;
                this.lastKeyDownTime = currentTime.getTime();
                switch(keyCode){
                    // ESC key closes the lightbox
                    case $863febd3c37c55c4$var$KEYS.ESC:
                        event.preventDefault();
                        this.requestClose(event);
                        break;
                    // Left arrow key moves to previous image
                    case $863febd3c37c55c4$var$KEYS.LEFT_ARROW:
                        if (!this.props.prevSrc) return;
                        event.preventDefault();
                        this.keyPressed = true;
                        this.requestMovePrev(event);
                        break;
                    // Right arrow key moves to next image
                    case $863febd3c37c55c4$var$KEYS.RIGHT_ARROW:
                        if (!this.props.nextSrc) return;
                        event.preventDefault();
                        this.keyPressed = true;
                        this.requestMoveNext(event);
                        break;
                }
            }
        },
        {
            key: "handleOuterMousewheel",
            value: function handleOuterMousewheel(event) {
                var _this8 = this;
                // Prevent scrolling of the background
                event.stopPropagation();
                var xThreshold = $863febd3c37c55c4$var$WHEEL_MOVE_X_THRESHOLD;
                var actionDelay = 0;
                var imageMoveDelay = 500;
                this.clearTimeout(this.resetScrollTimeout);
                this.resetScrollTimeout = this.setTimeout(function() {
                    _this8.scrollX = 0;
                    _this8.scrollY = 0;
                }, 300); // Prevent rapid-fire zoom behavior
                if (this.wheelActionTimeout !== null || this.isAnimating()) return;
                if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
                    // handle horizontal scrolls with image moves
                    this.scrollY = 0;
                    this.scrollX += event.deltaX;
                    var bigLeapX = xThreshold / 2; // If the scroll amount has accumulated sufficiently, or a large leap was taken
                    if (this.scrollX >= xThreshold || event.deltaX >= bigLeapX) {
                        // Scroll right moves to next
                        this.requestMoveNext(event);
                        actionDelay = imageMoveDelay;
                        this.scrollX = 0;
                    } else if (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) {
                        // Scroll left moves to previous
                        this.requestMovePrev(event);
                        actionDelay = imageMoveDelay;
                        this.scrollX = 0;
                    }
                } // Allow successive actions after the set delay
                if (actionDelay !== 0) this.wheelActionTimeout = this.setTimeout(function() {
                    _this8.wheelActionTimeout = null;
                }, actionDelay);
            }
        },
        {
            key: "handleImageMouseWheel",
            value: function handleImageMouseWheel(event) {
                var yThreshold = $863febd3c37c55c4$var$WHEEL_MOVE_Y_THRESHOLD;
                if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
                    event.stopPropagation(); // If the vertical scroll amount was large enough, perform a zoom
                    if (Math.abs(event.deltaY) < yThreshold) return;
                    this.scrollX = 0;
                    this.scrollY += event.deltaY;
                    this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
                }
            }
        },
        {
            key: "handleImageDoubleClick",
            value: function handleImageDoubleClick(event) {
                if (this.state.zoomLevel > $863febd3c37c55c4$var$MIN_ZOOM_LEVEL) // A double click when zoomed in zooms all the way out
                this.changeZoom($863febd3c37c55c4$var$MIN_ZOOM_LEVEL, event.clientX, event.clientY);
                else // A double click when zoomed all the way out zooms in
                this.changeZoom(this.state.zoomLevel + $863febd3c37c55c4$var$ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
            }
        },
        {
            key: "shouldHandleEvent",
            value: function shouldHandleEvent(source) {
                if (this.eventsSource === source) return true;
                if (this.eventsSource === $863febd3c37c55c4$var$SOURCE_ANY) {
                    this.eventsSource = source;
                    return true;
                }
                switch(source){
                    case $863febd3c37c55c4$var$SOURCE_MOUSE:
                        return false;
                    case $863febd3c37c55c4$var$SOURCE_TOUCH:
                        this.eventsSource = $863febd3c37c55c4$var$SOURCE_TOUCH;
                        this.filterPointersBySource();
                        return true;
                    case $863febd3c37c55c4$var$SOURCE_POINTER:
                        if (this.eventsSource === $863febd3c37c55c4$var$SOURCE_MOUSE) {
                            this.eventsSource = $863febd3c37c55c4$var$SOURCE_POINTER;
                            this.filterPointersBySource();
                            return true;
                        }
                        return false;
                    default:
                        return false;
                }
            }
        },
        {
            key: "addPointer",
            value: function addPointer(pointer) {
                this.pointerList.push(pointer);
            }
        },
        {
            key: "removePointer",
            value: function removePointer(pointer) {
                this.pointerList = this.pointerList.filter(function(_ref) {
                    var id = _ref.id;
                    return id !== pointer.id;
                });
            }
        },
        {
            key: "filterPointersBySource",
            value: function filterPointersBySource() {
                var _this9 = this;
                this.pointerList = this.pointerList.filter(function(_ref2) {
                    var source = _ref2.source;
                    return source === _this9.eventsSource;
                });
            }
        },
        {
            key: "handleMouseDown",
            value: function handleMouseDown(event) {
                if (this.shouldHandleEvent($863febd3c37c55c4$var$SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target)) {
                    this.addPointer(ReactImageLightbox.parseMouseEvent(event));
                    this.multiPointerStart(event);
                }
            }
        },
        {
            key: "handleMouseMove",
            value: function handleMouseMove(event) {
                if (this.shouldHandleEvent($863febd3c37c55c4$var$SOURCE_MOUSE)) this.multiPointerMove(event, [
                    ReactImageLightbox.parseMouseEvent(event)
                ]);
            }
        },
        {
            key: "handleMouseUp",
            value: function handleMouseUp(event) {
                if (this.shouldHandleEvent($863febd3c37c55c4$var$SOURCE_MOUSE)) {
                    this.removePointer(ReactImageLightbox.parseMouseEvent(event));
                    this.multiPointerEnd(event);
                }
            }
        },
        {
            key: "handlePointerEvent",
            value: function handlePointerEvent(event) {
                if (this.shouldHandleEvent($863febd3c37c55c4$var$SOURCE_POINTER)) switch(event.type){
                    case "pointerdown":
                        if (ReactImageLightbox.isTargetMatchImage(event.target)) {
                            this.addPointer(ReactImageLightbox.parsePointerEvent(event));
                            this.multiPointerStart(event);
                        }
                        break;
                    case "pointermove":
                        this.multiPointerMove(event, [
                            ReactImageLightbox.parsePointerEvent(event)
                        ]);
                        break;
                    case "pointerup":
                    case "pointercancel":
                        this.removePointer(ReactImageLightbox.parsePointerEvent(event));
                        this.multiPointerEnd(event);
                        break;
                }
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart(event) {
                var _this10 = this;
                if (this.shouldHandleEvent($863febd3c37c55c4$var$SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target)) {
                    [].forEach.call(event.changedTouches, function(eventTouch) {
                        return _this10.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
                    });
                    this.multiPointerStart(event);
                }
            }
        },
        {
            key: "handleTouchMove",
            value: function handleTouchMove(event) {
                if (this.shouldHandleEvent($863febd3c37c55c4$var$SOURCE_TOUCH)) this.multiPointerMove(event, [].map.call(event.changedTouches, function(eventTouch) {
                    return ReactImageLightbox.parseTouchPointer(eventTouch);
                }));
            }
        },
        {
            key: "handleTouchEnd",
            value: function handleTouchEnd(event) {
                var _this11 = this;
                if (this.shouldHandleEvent($863febd3c37c55c4$var$SOURCE_TOUCH)) {
                    [].map.call(event.changedTouches, function(touch) {
                        return _this11.removePointer(ReactImageLightbox.parseTouchPointer(touch));
                    });
                    this.multiPointerEnd(event);
                }
            }
        },
        {
            key: "decideMoveOrSwipe",
            value: function decideMoveOrSwipe(pointer) {
                if (this.state.zoomLevel <= $863febd3c37c55c4$var$MIN_ZOOM_LEVEL) this.handleSwipeStart(pointer);
                else this.handleMoveStart(pointer);
            }
        },
        {
            key: "multiPointerStart",
            value: function multiPointerStart(event) {
                this.handleEnd(null);
                switch(this.pointerList.length){
                    case 1:
                        event.preventDefault();
                        this.decideMoveOrSwipe(this.pointerList[0]);
                        break;
                    case 2:
                        event.preventDefault();
                        this.handlePinchStart(this.pointerList);
                        break;
                }
            }
        },
        {
            key: "multiPointerMove",
            value: function multiPointerMove(event, pointerList) {
                switch(this.currentAction){
                    case $863febd3c37c55c4$var$ACTION_MOVE:
                        event.preventDefault();
                        this.handleMove(pointerList[0]);
                        break;
                    case $863febd3c37c55c4$var$ACTION_SWIPE:
                        event.preventDefault();
                        this.handleSwipe(pointerList[0]);
                        break;
                    case $863febd3c37c55c4$var$ACTION_PINCH:
                        event.preventDefault();
                        this.handlePinch(pointerList);
                        break;
                }
            }
        },
        {
            key: "multiPointerEnd",
            value: function multiPointerEnd(event) {
                if (this.currentAction !== $863febd3c37c55c4$var$ACTION_NONE) {
                    this.setPreventInnerClose();
                    this.handleEnd(event);
                }
                switch(this.pointerList.length){
                    case 0:
                        this.eventsSource = $863febd3c37c55c4$var$SOURCE_ANY;
                        break;
                    case 1:
                        event.preventDefault();
                        this.decideMoveOrSwipe(this.pointerList[0]);
                        break;
                    case 2:
                        event.preventDefault();
                        this.handlePinchStart(this.pointerList);
                        break;
                }
            }
        },
        {
            key: "handleEnd",
            value: function handleEnd(event) {
                switch(this.currentAction){
                    case $863febd3c37c55c4$var$ACTION_MOVE:
                        this.handleMoveEnd(event);
                        break;
                    case $863febd3c37c55c4$var$ACTION_SWIPE:
                        this.handleSwipeEnd(event);
                        break;
                    case $863febd3c37c55c4$var$ACTION_PINCH:
                        this.handlePinchEnd(event);
                        break;
                }
            } // Handle move start over the lightbox container
        },
        {
            key: "handleMoveStart",
            value: function handleMoveStart(_ref3) {
                var clientX = _ref3.x, clientY = _ref3.y;
                if (!this.props.enableZoom) return;
                this.currentAction = $863febd3c37c55c4$var$ACTION_MOVE;
                this.moveStartX = clientX;
                this.moveStartY = clientY;
                this.moveStartOffsetX = this.state.offsetX;
                this.moveStartOffsetY = this.state.offsetY;
            } // Handle dragging over the lightbox container
        },
        {
            key: "handleMove",
            value: function handleMove(_ref4) {
                var clientX = _ref4.x, clientY = _ref4.y;
                var newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX;
                var newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;
                if (this.state.offsetX !== newOffsetX || this.state.offsetY !== newOffsetY) this.setState({
                    offsetX: newOffsetX,
                    offsetY: newOffsetY
                });
            }
        },
        {
            key: "handleMoveEnd",
            value: function handleMoveEnd() {
                var _this12 = this;
                this.currentAction = $863febd3c37c55c4$var$ACTION_NONE;
                this.moveStartX = 0;
                this.moveStartY = 0;
                this.moveStartOffsetX = 0;
                this.moveStartOffsetY = 0; // Snap image back into frame if outside max offset range
                var maxOffsets = this.getMaxOffsets();
                var nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX));
                var nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));
                if (nextOffsetX !== this.state.offsetX || nextOffsetY !== this.state.offsetY) {
                    this.setState({
                        offsetX: nextOffsetX,
                        offsetY: nextOffsetY,
                        shouldAnimate: true
                    });
                    this.setTimeout(function() {
                        _this12.setState({
                            shouldAnimate: false
                        });
                    }, this.props.animationDuration);
                }
            }
        },
        {
            key: "handleSwipeStart",
            value: function handleSwipeStart(_ref5) {
                var clientX = _ref5.x, clientY = _ref5.y;
                this.currentAction = $863febd3c37c55c4$var$ACTION_SWIPE;
                this.swipeStartX = clientX;
                this.swipeStartY = clientY;
                this.swipeEndX = clientX;
                this.swipeEndY = clientY;
            }
        },
        {
            key: "handleSwipe",
            value: function handleSwipe(_ref6) {
                var clientX = _ref6.x, clientY = _ref6.y;
                this.swipeEndX = clientX;
                this.swipeEndY = clientY;
            }
        },
        {
            key: "handleSwipeEnd",
            value: function handleSwipeEnd(event) {
                var xDiff = this.swipeEndX - this.swipeStartX;
                var xDiffAbs = Math.abs(xDiff);
                var yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
                this.currentAction = $863febd3c37c55c4$var$ACTION_NONE;
                this.swipeStartX = 0;
                this.swipeStartY = 0;
                this.swipeEndX = 0;
                this.swipeEndY = 0;
                if (!event || this.isAnimating() || xDiffAbs < yDiffAbs * 1.5) return;
                if (xDiffAbs < $863febd3c37c55c4$var$MIN_SWIPE_DISTANCE) {
                    var boxRect = this.getLightboxRect();
                    if (xDiffAbs < boxRect.width / 4) return;
                }
                if (xDiff > 0 && this.props.prevSrc) {
                    event.preventDefault();
                    this.requestMovePrev();
                } else if (xDiff < 0 && this.props.nextSrc) {
                    event.preventDefault();
                    this.requestMoveNext();
                }
            }
        },
        {
            key: "calculatePinchDistance",
            value: function calculatePinchDistance() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList, _ref8 = $863febd3c37c55c4$var$_slicedToArray(_ref7, 2), a = _ref8[0], b = _ref8[1];
                return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
            }
        },
        {
            key: "calculatePinchCenter",
            value: function calculatePinchCenter() {
                var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pinchTouchList, _ref10 = $863febd3c37c55c4$var$_slicedToArray(_ref9, 2), a = _ref10[0], b = _ref10[1];
                return {
                    x: a.x - (a.x - b.x) / 2,
                    y: a.y - (a.y - b.y) / 2
                };
            }
        },
        {
            key: "handlePinchStart",
            value: function handlePinchStart(pointerList) {
                if (!this.props.enableZoom) return;
                this.currentAction = $863febd3c37c55c4$var$ACTION_PINCH;
                this.pinchTouchList = pointerList.map(function(_ref11) {
                    var id = _ref11.id, x = _ref11.x, y = _ref11.y;
                    return {
                        id: id,
                        x: x,
                        y: y
                    };
                });
                this.pinchDistance = this.calculatePinchDistance();
            }
        },
        {
            key: "handlePinch",
            value: function handlePinch(pointerList) {
                this.pinchTouchList = this.pinchTouchList.map(function(oldPointer) {
                    for(var i = 0; i < pointerList.length; i += 1){
                        if (pointerList[i].id === oldPointer.id) return pointerList[i];
                    }
                    return oldPointer;
                });
                var newDistance = this.calculatePinchDistance();
                var zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
                this.pinchDistance = newDistance;
                var _this$calculatePinchC = this.calculatePinchCenter(this.pinchTouchList), clientX = _this$calculatePinchC.x, clientY = _this$calculatePinchC.y;
                this.changeZoom(zoomLevel, clientX, clientY);
            }
        },
        {
            key: "handlePinchEnd",
            value: function handlePinchEnd() {
                this.currentAction = $863febd3c37c55c4$var$ACTION_NONE;
                this.pinchTouchList = null;
                this.pinchDistance = 0;
            } // Handle the window resize event
        },
        {
            key: "handleWindowResize",
            value: function handleWindowResize() {
                this.clearTimeout(this.resizeTimeout);
                this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
            }
        },
        {
            key: "handleZoomInButtonClick",
            value: function handleZoomInButtonClick() {
                var nextZoomLevel = this.state.zoomLevel + $863febd3c37c55c4$var$ZOOM_BUTTON_INCREMENT_SIZE;
                this.changeZoom(nextZoomLevel);
                if (nextZoomLevel === $863febd3c37c55c4$var$MAX_ZOOM_LEVEL) this.zoomOutBtn.current.focus();
            }
        },
        {
            key: "handleZoomOutButtonClick",
            value: function handleZoomOutButtonClick() {
                var nextZoomLevel = this.state.zoomLevel - $863febd3c37c55c4$var$ZOOM_BUTTON_INCREMENT_SIZE;
                this.changeZoom(nextZoomLevel);
                if (nextZoomLevel === $863febd3c37c55c4$var$MIN_ZOOM_LEVEL) this.zoomInBtn.current.focus();
            }
        },
        {
            key: "handleCaptionMousewheel",
            value: function handleCaptionMousewheel(event) {
                event.stopPropagation();
                if (!this.caption.current) return;
                var _this$caption$current = this.caption.current.getBoundingClientRect(), height = _this$caption$current.height;
                var _this$caption$current2 = this.caption.current, scrollHeight = _this$caption$current2.scrollHeight, scrollTop = _this$caption$current2.scrollTop;
                if (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) event.preventDefault();
            } // Detach key and mouse input events
        },
        {
            key: "isAnimating",
            value: function isAnimating() {
                return this.state.shouldAnimate || this.state.isClosing;
            } // Check if image is loaded
        },
        {
            key: "isImageLoaded",
            value: function isImageLoaded(imageSrc) {
                return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
            } // Load image from src and call callback with image width and height on load
        },
        {
            key: "loadImage",
            value: function loadImage(srcType, imageSrc, done) {
                var _this13 = this;
                // Return the image info if it is already cached
                if (this.isImageLoaded(imageSrc)) {
                    this.setTimeout(function() {
                        done();
                    }, 1);
                    return;
                }
                var inMemoryImage = new $parcel$global.Image();
                if (this.props.imageCrossOrigin) inMemoryImage.crossOrigin = this.props.imageCrossOrigin;
                inMemoryImage.onerror = function(errorEvent) {
                    _this13.props.onImageLoadError(imageSrc, srcType, errorEvent); // failed to load so set the state loadErrorStatus
                    _this13.setState(function(prevState) {
                        return {
                            loadErrorStatus: $863febd3c37c55c4$var$_objectSpread2($863febd3c37c55c4$var$_objectSpread2({}, prevState.loadErrorStatus), {}, $863febd3c37c55c4$var$_defineProperty({}, srcType, true))
                        };
                    });
                    done(errorEvent);
                };
                inMemoryImage.onload = function() {
                    _this13.props.onImageLoad(imageSrc, srcType, inMemoryImage);
                    _this13.imageCache[imageSrc] = {
                        loaded: true,
                        width: inMemoryImage.width,
                        height: inMemoryImage.height
                    };
                    done();
                };
                inMemoryImage.src = imageSrc;
            } // Load all images and their thumbnails
        },
        {
            key: "loadAllImages",
            value: function loadAllImages() {
                var _this14 = this;
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var generateLoadDoneCallback = function generateLoadDoneCallback(srcType, imageSrc) {
                    return function(err) {
                        // Give up showing image on error
                        if (err) return;
                         // Don't rerender if the src is not the same as when the load started
                        // or if the component has unmounted
                        if (_this14.props[srcType] !== imageSrc || _this14.didUnmount) return;
                         // Force rerender with the new image
                        _this14.forceUpdate();
                    };
                }; // Load the images
                this.getSrcTypes().forEach(function(srcType) {
                    var type = srcType.name; // there is no error when we try to load it initially
                    if (props[type] && _this14.state.loadErrorStatus[type]) _this14.setState(function(prevState) {
                        return {
                            loadErrorStatus: $863febd3c37c55c4$var$_objectSpread2($863febd3c37c55c4$var$_objectSpread2({}, prevState.loadErrorStatus), {}, $863febd3c37c55c4$var$_defineProperty({}, type, false))
                        };
                    });
                     // Load unloaded images
                    if (props[type] && !_this14.isImageLoaded(props[type])) _this14.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
                });
            } // Request that the lightbox be closed
        },
        {
            key: "requestClose",
            value: function requestClose(event) {
                var _this15 = this;
                // Call the parent close request
                var closeLightbox = function closeLightbox() {
                    return _this15.props.onCloseRequest(event);
                };
                if (this.props.animationDisabled || event.type === "keydown" && !this.props.animationOnKeyInput) {
                    // No animation
                    closeLightbox();
                    return;
                } // With animation
                // Start closing animation
                this.setState({
                    isClosing: true
                }); // Perform the actual closing at the end of the animation
                this.setTimeout(closeLightbox, this.props.animationDuration);
            }
        },
        {
            key: "requestMove",
            value: function requestMove(direction, event) {
                var _this16 = this;
                // Reset the zoom level on image move
                var nextState = {
                    zoomLevel: $863febd3c37c55c4$var$MIN_ZOOM_LEVEL,
                    offsetX: 0,
                    offsetY: 0
                }; // Enable animated states
                if (!this.props.animationDisabled && (!this.keyPressed || this.props.animationOnKeyInput)) {
                    nextState.shouldAnimate = true;
                    this.setTimeout(function() {
                        return _this16.setState({
                            shouldAnimate: false
                        });
                    }, this.props.animationDuration);
                }
                this.keyPressed = false;
                this.moveRequested = true;
                if (direction === "prev") {
                    this.keyCounter -= 1;
                    this.setState(nextState);
                    this.props.onMovePrevRequest(event);
                } else {
                    this.keyCounter += 1;
                    this.setState(nextState);
                    this.props.onMoveNextRequest(event);
                }
            } // Request to transition to the next image
        },
        {
            key: "requestMoveNext",
            value: function requestMoveNext(event) {
                this.requestMove("next", event);
            } // Request to transition to the previous image
        },
        {
            key: "requestMovePrev",
            value: function requestMovePrev(event) {
                this.requestMove("prev", event);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this17 = this;
                var _this$props = this.props, animationDisabled = _this$props.animationDisabled, animationDuration = _this$props.animationDuration, clickOutsideToClose = _this$props.clickOutsideToClose, discourageDownloads = _this$props.discourageDownloads, enableZoom = _this$props.enableZoom, imageTitle = _this$props.imageTitle, nextSrc = _this$props.nextSrc, prevSrc = _this$props.prevSrc, toolbarButtons = _this$props.toolbarButtons, reactModalStyle = _this$props.reactModalStyle, _onAfterOpen = _this$props.onAfterOpen, imageCrossOrigin = _this$props.imageCrossOrigin, reactModalProps = _this$props.reactModalProps, loader = _this$props.loader;
                var _this$state = this.state, zoomLevel = _this$state.zoomLevel, offsetX = _this$state.offsetX, offsetY = _this$state.offsetY, isClosing = _this$state.isClosing, loadErrorStatus = _this$state.loadErrorStatus;
                var boxSize = this.getLightboxRect();
                var transitionStyle = {}; // Transition settings for sliding animations
                if (!animationDisabled && this.isAnimating()) transitionStyle = $863febd3c37c55c4$var$_objectSpread2($863febd3c37c55c4$var$_objectSpread2({}, transitionStyle), {}, {
                    transition: "transform ".concat(animationDuration, "ms")
                });
                 // Key endings to differentiate between images with the same src
                var keyEndings = {};
                this.getSrcTypes().forEach(function(_ref12) {
                    var name = _ref12.name, keyEnding = _ref12.keyEnding;
                    keyEndings[name] = keyEnding;
                }); // Images to be displayed
                var images = [];
                var addImage = function addImage(srcType, imageClass, transforms) {
                    // Ignore types that have no source defined for their full size image
                    if (!_this17.props[srcType]) return;
                    var bestImageInfo = _this17.getBestImageForType(srcType);
                    var imageStyle = $863febd3c37c55c4$var$_objectSpread2($863febd3c37c55c4$var$_objectSpread2({}, transitionStyle), ReactImageLightbox.getTransform($863febd3c37c55c4$var$_objectSpread2($863febd3c37c55c4$var$_objectSpread2({}, transforms), bestImageInfo)));
                    if (zoomLevel > $863febd3c37c55c4$var$MIN_ZOOM_LEVEL) imageStyle.cursor = "move";
                     // support IE 9 and 11
                    var hasTrueValue = function hasTrueValue(object) {
                        return Object.keys(object).some(function(key) {
                            return object[key];
                        });
                    }; // when error on one of the loads then push custom error stuff
                    if (bestImageInfo === null && hasTrueValue(loadErrorStatus)) {
                        images.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            className: "".concat(imageClass, " ril__image ril-errored"),
                            style: imageStyle,
                            key: _this17.props[srcType] + keyEndings[srcType]
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            className: "ril__errorContainer"
                        }, _this17.props.imageLoadErrorMessage)));
                        return;
                    }
                    if (bestImageInfo === null) {
                        var loadingIcon = loader !== undefined ? loader : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            className: "ril-loading-circle ril__loadingCircle ril__loadingContainer__icon"
                        }, $863febd3c37c55c4$var$_toConsumableArray(new Array(12)).map(function(_, index) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                                // eslint-disable-next-line react/no-array-index-key
                                key: index,
                                className: "ril-loading-circle-point ril__loadingCirclePoint"
                            });
                        })); // Fall back to loading icon if the thumbnail has not been loaded
                        images.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            className: "".concat(imageClass, " ril__image ril-not-loaded"),
                            style: imageStyle,
                            key: _this17.props[srcType] + keyEndings[srcType]
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            className: "ril__loadingContainer"
                        }, loadingIcon)));
                        return;
                    }
                    var imageSrc = bestImageInfo.src;
                    if (discourageDownloads) {
                        imageStyle.backgroundImage = "url('".concat(imageSrc, "')");
                        images.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            className: "".concat(imageClass, " ril__image ril__imageDiscourager"),
                            onDoubleClick: _this17.handleImageDoubleClick,
                            onWheel: _this17.handleImageMouseWheel,
                            style: imageStyle,
                            key: imageSrc + keyEndings[srcType]
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            className: "ril-download-blocker ril__downloadBlocker"
                        })));
                    } else images.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("img", $863febd3c37c55c4$var$_extends({}, imageCrossOrigin ? {
                        crossOrigin: imageCrossOrigin
                    } : {}, {
                        className: "".concat(imageClass, " ril__image"),
                        onDoubleClick: _this17.handleImageDoubleClick,
                        onWheel: _this17.handleImageMouseWheel,
                        onDragStart: function onDragStart(e) {
                            return e.preventDefault();
                        },
                        style: imageStyle,
                        src: imageSrc,
                        key: imageSrc + keyEndings[srcType],
                        alt: typeof imageTitle === "string" ? imageTitle : $863febd3c37c55c4$var$translate("Image"),
                        draggable: false
                    })));
                };
                var zoomMultiplier = this.getZoomMultiplier(); // Next Image (displayed on the right)
                addImage("nextSrc", "ril-image-next ril__imageNext", {
                    x: boxSize.width
                }); // Main Image
                addImage("mainSrc", "ril-image-current", {
                    x: -1 * offsetX,
                    y: -1 * offsetY,
                    zoom: zoomMultiplier
                }); // Previous Image (displayed on the left)
                addImage("prevSrc", "ril-image-prev ril__imagePrev", {
                    x: -1 * boxSize.width
                });
                var modalStyle = {
                    overlay: $863febd3c37c55c4$var$_objectSpread2({
                        zIndex: 1000,
                        backgroundColor: "transparent"
                    }, reactModalStyle.overlay),
                    content: $863febd3c37c55c4$var$_objectSpread2({
                        backgroundColor: "transparent",
                        overflow: "hidden",
                        // Needed, otherwise keyboard shortcuts scroll the page
                        border: "none",
                        borderRadius: 0,
                        padding: 0,
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    }, reactModalStyle.content)
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6e543bc5477d2d4a$exports))), $863febd3c37c55c4$var$_extends({
                    isOpen: true,
                    onRequestClose: clickOutsideToClose ? this.requestClose : undefined,
                    onAfterOpen: function onAfterOpen() {
                        // Focus on the div with key handlers
                        if (_this17.outerEl.current) _this17.outerEl.current.focus();
                        _onAfterOpen();
                    },
                    style: modalStyle,
                    contentLabel: $863febd3c37c55c4$var$translate("Lightbox"),
                    appElement: typeof $parcel$global.window !== "undefined" ? $parcel$global.window.document.body : undefined
                }, reactModalProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    // eslint-disable-line jsx-a11y/no-static-element-interactions
                    // Floating modal with closing animations
                    className: "ril-outer ril__outer ril__outerAnimating ".concat(this.props.wrapperClassName, " ").concat(isClosing ? "ril-closing ril__outerClosing" : ""),
                    style: {
                        transition: "opacity ".concat(animationDuration, "ms"),
                        animationDuration: "".concat(animationDuration, "ms"),
                        animationDirection: isClosing ? "normal" : "reverse"
                    },
                    ref: this.outerEl,
                    onWheel: this.handleOuterMousewheel,
                    onMouseMove: this.handleMouseMove,
                    onMouseDown: this.handleMouseDown,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    tabIndex: "-1" // Enables key handlers on div
                    ,
                    onKeyDown: this.handleKeyInput,
                    onKeyUp: this.handleKeyInput
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    // eslint-disable-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                    // Image holder
                    className: "ril-inner ril__inner",
                    onClick: clickOutsideToClose ? this.closeIfClickInner : undefined
                }, images), prevSrc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                    // Move to previous image button
                    type: "button",
                    className: "ril-prev-button ril__navButtons ril__navButtonPrev",
                    key: "prev",
                    "aria-label": this.props.prevLabel,
                    title: this.props.prevLabel,
                    onClick: !this.isAnimating() ? this.requestMovePrev : undefined // Ignore clicks during animation
                }), nextSrc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                    // Move to next image button
                    type: "button",
                    className: "ril-next-button ril__navButtons ril__navButtonNext",
                    key: "next",
                    "aria-label": this.props.nextLabel,
                    title: this.props.nextLabel,
                    onClick: !this.isAnimating() ? this.requestMoveNext : undefined // Ignore clicks during animation
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    // Lightbox toolbar
                    className: "ril-toolbar ril__toolbar"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("ul", {
                    className: "ril-toolbar-left ril__toolbarSide ril__toolbarLeftSide"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                    className: "ril-toolbar__item ril__toolbarItem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                    className: "ril-toolbar__item__child ril__toolbarItemChild"
                }, imageTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("ul", {
                    className: "ril-toolbar-right ril__toolbarSide ril__toolbarRightSide"
                }, toolbarButtons && toolbarButtons.map(function(button, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                        key: "button_".concat(i + 1),
                        className: "ril-toolbar__item ril__toolbarItem"
                    }, button);
                }), enableZoom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                    className: "ril-toolbar__item ril__toolbarItem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                    // Lightbox zoom in button
                    type: "button",
                    key: "zoom-in",
                    "aria-label": this.props.zoomInLabel,
                    title: this.props.zoomInLabel,
                    className: [
                        "ril-zoom-in",
                        "ril__toolbarItemChild",
                        "ril__builtinButton",
                        "ril__zoomInButton"
                    ].concat($863febd3c37c55c4$var$_toConsumableArray(zoomLevel === $863febd3c37c55c4$var$MAX_ZOOM_LEVEL ? [
                        "ril__builtinButtonDisabled"
                    ] : [])).join(" "),
                    ref: this.zoomInBtn,
                    disabled: this.isAnimating() || zoomLevel === $863febd3c37c55c4$var$MAX_ZOOM_LEVEL,
                    onClick: !this.isAnimating() && zoomLevel !== $863febd3c37c55c4$var$MAX_ZOOM_LEVEL ? this.handleZoomInButtonClick : undefined
                })), enableZoom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                    className: "ril-toolbar__item ril__toolbarItem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                    // Lightbox zoom out button
                    type: "button",
                    key: "zoom-out",
                    "aria-label": this.props.zoomOutLabel,
                    title: this.props.zoomOutLabel,
                    className: [
                        "ril-zoom-out",
                        "ril__toolbarItemChild",
                        "ril__builtinButton",
                        "ril__zoomOutButton"
                    ].concat($863febd3c37c55c4$var$_toConsumableArray(zoomLevel === $863febd3c37c55c4$var$MIN_ZOOM_LEVEL ? [
                        "ril__builtinButtonDisabled"
                    ] : [])).join(" "),
                    ref: this.zoomOutBtn,
                    disabled: this.isAnimating() || zoomLevel === $863febd3c37c55c4$var$MIN_ZOOM_LEVEL,
                    onClick: !this.isAnimating() && zoomLevel !== $863febd3c37c55c4$var$MIN_ZOOM_LEVEL ? this.handleZoomOutButtonClick : undefined
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                    className: "ril-toolbar__item ril__toolbarItem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                    // Lightbox close button
                    type: "button",
                    key: "close",
                    "aria-label": this.props.closeLabel,
                    title: this.props.closeLabel,
                    className: "ril-close ril-toolbar__item__child ril__toolbarItemChild ril__builtinButton ril__closeButton",
                    onClick: !this.isAnimating() ? this.requestClose : undefined // Ignore clicks during animation
                })))), this.props.imageCaption && /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    // Image caption
                    onWheel: this.handleCaptionMousewheel,
                    onMouseDown: function onMouseDown(event) {
                        return event.stopPropagation();
                    },
                    className: "ril-caption ril__caption",
                    ref: this.caption
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                    className: "ril-caption-content ril__captionContent"
                }, this.props.imageCaption))));
            }
        }
    ], [
        {
            key: "isTargetMatchImage",
            value: function isTargetMatchImage(target) {
                return target && /ril-image-current/.test(target.className);
            }
        },
        {
            key: "parseMouseEvent",
            value: function parseMouseEvent(mouseEvent) {
                return {
                    id: "mouse",
                    source: $863febd3c37c55c4$var$SOURCE_MOUSE,
                    x: parseInt(mouseEvent.clientX, 10),
                    y: parseInt(mouseEvent.clientY, 10)
                };
            }
        },
        {
            key: "parseTouchPointer",
            value: function parseTouchPointer(touchPointer) {
                return {
                    id: touchPointer.identifier,
                    source: $863febd3c37c55c4$var$SOURCE_TOUCH,
                    x: parseInt(touchPointer.clientX, 10),
                    y: parseInt(touchPointer.clientY, 10)
                };
            }
        },
        {
            key: "parsePointerEvent",
            value: function parsePointerEvent(pointerEvent) {
                return {
                    id: pointerEvent.pointerId,
                    source: $863febd3c37c55c4$var$SOURCE_POINTER,
                    x: parseInt(pointerEvent.clientX, 10),
                    y: parseInt(pointerEvent.clientY, 10)
                };
            } // Request to transition to the previous image
        },
        {
            key: "getTransform",
            value: function getTransform(_ref13) {
                var _ref13$x = _ref13.x, x = _ref13$x === void 0 ? 0 : _ref13$x, _ref13$y = _ref13.y, y = _ref13$y === void 0 ? 0 : _ref13$y, _ref13$zoom = _ref13.zoom, zoom = _ref13$zoom === void 0 ? 1 : _ref13$zoom, width = _ref13.width, targetWidth = _ref13.targetWidth;
                var nextX = x;
                var windowWidth = $863febd3c37c55c4$var$getWindowWidth();
                if (width > windowWidth) nextX += (windowWidth - width) / 2;
                var scaleFactor = zoom * (targetWidth / width);
                return {
                    transform: "translate3d(".concat(nextX, "px,").concat(y, "px,0) scale3d(").concat(scaleFactor, ",").concat(scaleFactor, ",1)")
                };
            }
        }
    ]);
    return ReactImageLightbox;
}((0, $cQmXV.Component));
$863febd3c37c55c4$var$ReactImageLightbox.propTypes = {
    //-----------------------------
    // Image sources
    //-----------------------------
    // Main display image url
    mainSrc: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string.isRequired,
    // eslint-disable-line react/no-unused-prop-types
    // Previous display image url (displayed to the left)
    // If left undefined, movePrev actions will not be performed, and the button not displayed
    prevSrc: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    // Next display image url (displayed to the right)
    // If left undefined, moveNext actions will not be performed, and the button not displayed
    nextSrc: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    //-----------------------------
    // Image thumbnail sources
    //-----------------------------
    // Thumbnail image url corresponding to props.mainSrc
    mainSrcThumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    // eslint-disable-line react/no-unused-prop-types
    // Thumbnail image url corresponding to props.prevSrc
    prevSrcThumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    // eslint-disable-line react/no-unused-prop-types
    // Thumbnail image url corresponding to props.nextSrc
    nextSrcThumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    // eslint-disable-line react/no-unused-prop-types
    //-----------------------------
    // Event Handlers
    //-----------------------------
    // Close window event
    // Should change the parent state such that the lightbox is not rendered
    onCloseRequest: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func.isRequired,
    // Move to previous image event
    // Should change the parent state such that props.prevSrc becomes props.mainSrc,
    //  props.mainSrc becomes props.nextSrc, etc.
    onMovePrevRequest: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    // Move to next image event
    // Should change the parent state such that props.nextSrc becomes props.mainSrc,
    //  props.mainSrc becomes props.prevSrc, etc.
    onMoveNextRequest: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    // Called when an image fails to load
    // (imageSrc: string, srcType: string, errorEvent: object): void
    onImageLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    // Called when image successfully loads
    onImageLoad: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    // Open window event
    onAfterOpen: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    //-----------------------------
    // Download discouragement settings
    //-----------------------------
    // Enable download discouragement (prevents [right-click -> Save Image As...])
    discourageDownloads: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    //-----------------------------
    // Animation settings
    //-----------------------------
    // Disable all animation
    animationDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    // Disable animation on actions performed with keyboard shortcuts
    animationOnKeyInput: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    // Animation duration (ms)
    animationDuration: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    //-----------------------------
    // Keyboard shortcut settings
    //-----------------------------
    // Required interval of time (ms) between key actions
    // (prevents excessively fast navigation of images)
    keyRepeatLimit: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    // Amount of time (ms) restored after each keyup
    // (makes rapid key presses slightly faster than holding down the key to navigate images)
    keyRepeatKeyupBonus: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    //-----------------------------
    // Image info
    //-----------------------------
    // Image title
    imageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).node,
    // Image caption
    imageCaption: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).node,
    // Optional crossOrigin attribute
    imageCrossOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    //-----------------------------
    // Lightbox style
    //-----------------------------
    // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
    reactModalStyle: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).shape({}),
    // Padding (px) between the edge of the window and the lightbox
    imagePadding: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).number,
    wrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    //-----------------------------
    // Other
    //-----------------------------
    // Array of custom toolbar buttons
    toolbarButtons: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).node),
    // When true, clicks outside of the image close the lightbox
    clickOutsideToClose: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    // Set to false to disable zoom functionality and hide zoom buttons
    enableZoom: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    // Override props set on react-modal (https://github.com/reactjs/react-modal)
    reactModalProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).shape({}),
    // Aria-labels
    nextLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    prevLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    zoomInLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    zoomOutLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    closeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    imageLoadErrorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).node,
    // custom loader
    loader: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).node
};
$863febd3c37c55c4$var$ReactImageLightbox.defaultProps = {
    imageTitle: null,
    imageCaption: null,
    toolbarButtons: null,
    reactModalProps: {},
    animationDisabled: false,
    animationDuration: 300,
    animationOnKeyInput: false,
    clickOutsideToClose: true,
    closeLabel: "Close lightbox",
    discourageDownloads: false,
    enableZoom: true,
    imagePadding: 10,
    imageCrossOrigin: null,
    keyRepeatKeyupBonus: 40,
    keyRepeatLimit: 180,
    mainSrcThumbnail: null,
    nextLabel: "Next image",
    nextSrc: null,
    nextSrcThumbnail: null,
    onAfterOpen: function onAfterOpen() {},
    onImageLoadError: function onImageLoadError() {},
    onImageLoad: function onImageLoad() {},
    onMoveNextRequest: function onMoveNextRequest() {},
    onMovePrevRequest: function onMovePrevRequest() {},
    prevLabel: "Previous image",
    prevSrc: null,
    prevSrcThumbnail: null,
    reactModalStyle: {},
    wrapperClassName: "",
    zoomInLabel: "Zoom in",
    zoomOutLabel: "Zoom out",
    imageLoadErrorMessage: "This image failed to load",
    loader: undefined
};
var $863febd3c37c55c4$export$2e2bcd8739ae039 = $863febd3c37c55c4$var$ReactImageLightbox;




var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



class $c2e3a9fdd09c4f82$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
    constructor(props){
        super(props);
        this.imageEditorRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        this.canvasLayerArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        // this.testRef = React.createRef();
        // this.test = React.createRef();
        this.typesDraw = {
            line: "line",
            rect: "rect",
            text: "text",
            arrow: "arrow",
            curve: "curve"
        };
        this.maxWidth = 325.33;
        this.state = {
            canvas: null,
            ctx: null,
            img: {
                src: "",
                width: 0,
                height: 0
            },
            typeDraw: this.typesDraw.curve,
            cursor: {
                x: 0,
                y: 0
            },
            resultImg: null,
            isDown: false,
            startX: 0,
            startY: 0,
            textContainer: null,
            modeEditText: false,
            isOpenModal: false,
            imageData: null,
            canvasLayer: null,
            canvasLayerCtx: null,
            canvasImgLoading: false,
            pathsry: [],
            points: [],
            drawColor: "red",
            showColorPicker: false
        };
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
    }
    componentDidMount() {
        if (this.state.isOpenModal) this.initCanvasEditor(); // TODO split init to some parts
    }
    async componentDidUpdate(prevProps, prevState, snapshot) {
        const { isOpenModal: isOpenModal } = this.state;
        if (prevState.isOpenModal !== isOpenModal && isOpenModal) await this.initCanvasEditor();
    }
    initCanvasEditor = async ()=>{
        const img = new Image();
        const cachedSrc = `${this.props.src}?chunk=cached`;
        let isImageCached = false;
        let chunksCached = [];
        img.crossOrigin = "anonymous";
        try {
            const currentChunksCached = JSON.parse(localStorage.getItem("chunks"));
            isImageCached = currentChunksCached?.length && currentChunksCached.includes(cachedSrc);
            if (!isImageCached) {
                chunksCached.push(cachedSrc);
                localStorage.setItem("chunks", JSON.stringify(chunksCached));
            }
            img.src = cachedSrc;
            this.setState({
                canvasImgLoading: true
            });
            img.addEventListener("load", ()=>{
                this.loadCanvasData(img);
            });
        } catch (error) {
            console.dir(error);
            img.src = `${this.props.src}?chunk=${new Date().getTime()}`; // reload new image from cdn to fix server's restriction
            this.setState({
                canvasImgLoading: true
            });
            img.addEventListener("load", ()=>{
                this.loadCanvasData(img);
            });
        }
    };
    loadCanvasData = (img)=>{
        try {
            const width = img.width > this.maxWidth ? this.maxWidth : img.width;
            const height = img.width > this.maxWidth ? img.height / (img.width / this.maxWidth) : img.height;
            /*       const width = 325;
      const height = "100%"; */ const canvas = this.imageEditorRef.current;
            const ctx = canvas?.getContext("2d");
            const canvasLayer = this.canvasLayerArrow.current;
            const canvasLayerCtx = canvasLayer?.getContext("2d");
            const textContainer = document.createElement("div");
            img.width = width;
            img.height = height;
            textContainer.contentEditable = "true";
            textContainer.classList.add("image-editor-text-container");
            textContainer.style.display = "none";
            canvas?.parentNode?.insertBefore(textContainer, canvas);
            this.setState(()=>{
                return {
                    img: img,
                    canvas: canvas,
                    ctx: ctx,
                    textContainer: textContainer,
                    canvasLayer: canvasLayer,
                    canvasLayerCtx: canvasLayerCtx
                };
            }, ()=>{
                this.draw(img);
            });
            this.setState({
                canvasImgLoading: false
            });
        } catch (e) {
            console.error({
                ...e
            });
        }
    };
    draw = (img)=>{
        const { canvas: canvas, ctx: ctx, canvasLayerCtx: canvasLayerCtx } = this.state;
        ctx.drawImage(img, 0, 0, this.state.img?.width, this.state.img?.height);
        ctx.strokeStyle = this.state.drawColor;
        ctx.lineWidth = 3;
        ctx.lineCap = "round";
        canvasLayerCtx.strokeStyle = this.state.drawColor;
        canvasLayerCtx.lineWidth = 3;
        canvasLayerCtx.lineCap = "round";
        ctx.save();
        this.setState({
            resultImg: canvas.toDataURL()
        });
    };
    drawRect = (x, y, w, h)=>{
        const { canvasLayerCtx: ctx, canvasLayer: canvas } = this.state;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = this.state.drawColor;
        ctx.strokeRect(x, y, w, h);
        ctx.save();
    };
    drawText = (text = "", x = 0, y = 0)=>{
        const { canvas: canvas, ctx: ctx } = this.state;
        ctx.fillStyle = this.state.drawColor;
        ctx.font = "20px / 1.3 sans-serif";
        ctx.textBaseline = "hanging";
        ctx.lineWidth = 1;
        ctx.fillText(text, x, y + 5);
        ctx.save();
    };
    drawLineWithArrowhead = (p0, p1, headLength)=>{
        const { canvasLayerCtx: ctx, canvasLayer: canvas } = this.state;
        let PI = Math.PI;
        let degreesInRadians225 = 1.1 * PI;
        let degreesInRadians135 = 0.9 * PI;
        // calc the angle of the line
        let dx = p1.x - p0.x;
        let dy = p1.y - p0.y;
        let angle = Math.atan2(dy, dx);
        // calc arrowhead points
        let x225 = p1.x + headLength * Math.cos(angle + degreesInRadians225);
        let y225 = p1.y + headLength * Math.sin(angle + degreesInRadians225);
        let x135 = p1.x + headLength * Math.cos(angle + degreesInRadians135);
        let y135 = p1.y + headLength * Math.sin(angle + degreesInRadians135);
        ctx.save();
        ctx.strokeStyle = this.state.drawColor;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        // draw line plus arrowhead
        ctx.beginPath();
        // draw the line from p0 to p1
        ctx.moveTo(p0.x, p0.y);
        ctx.lineTo(p1.x, p1.y);
        // draw partial arrowhead at 225 degrees
        ctx.moveTo(p1.x, p1.y);
        ctx.lineTo(x225, y225);
        // draw partial arrowhead at 135 degrees
        ctx.moveTo(p1.x, p1.y);
        ctx.lineTo(x135, y135);
        // stroke the line and arrowhead
        ctx.closePath();
        ctx.stroke();
    };
    handleMouseDown(event) {
        const { textContainer: textContainer, canvas: canvas, modeEditText: modeEditText, ctx: ctx, canvasLayer: canvasLayer, canvasLayerCtx: canvasLayerCtx } = this.state;
        let points = this.state.points;
        this.setState({
            isDown: true,
            startX: event.offsetX,
            startY: event.offsetY,
            imageData: ctx.getImageData(0, 0, canvas.width, canvas.height)
        }, ()=>{
            const { canvas: canvas, ctx: ctx, typeDraw: typeDraw } = this.state;
            let x = event.offsetX;
            let y = event.offsetY;
            // typeDraw === this.typesDraw.line ||
            if (typeDraw === this.typesDraw.rect || typeDraw === this.typesDraw.arrow) {
                canvasLayer.classList.add("canvas-layer--active");
                canvasLayerCtx.moveTo(x, y);
                canvasLayerCtx.lineTo(x + 1, y + 1);
                canvasLayerCtx.stroke();
                canvasLayerCtx.save();
            }
            if (typeDraw === this.typesDraw.curve) {
                ctx.strokeStyle = this.state.drawColor;
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.save();
                points?.push({
                    x: event.offsetX,
                    y: event.offsetY
                });
            }
            if (typeDraw === this.typesDraw.text) {
                if (!modeEditText) {
                    textContainer.style.top = `${y}px`;
                    textContainer.style.left = `${x}px`;
                    textContainer.style.width = `${300}px`;
                    textContainer.style.height = `${100}px`;
                    textContainer.style.display = "block";
                } else {
                    this.drawText(textContainer.innerText, parseInt(textContainer.style.left), parseInt(textContainer.style.top));
                    textContainer.style.display = "none";
                    textContainer.innerText = "";
                }
                this.setState({
                    modeEditText: !modeEditText
                });
            }
            this.setState({
                resultImg: canvas.toDataURL(),
                points: points
            });
        });
    }
    handleMouseMove(event) {
        if (this.state.isDown) {
            const { canvas: canvas, ctx: ctx, typeDraw: typeDraw, startX: startX, startY: startY } = this.state;
            let points = this.state.points;
            let x = event.offsetX;
            let y = event.offsetY;
            if (typeDraw === this.typesDraw.curve) {
                ctx.strokeStyle = this.state.drawColor;
                ctx.lineTo(x, y);
                ctx.stroke();
                points?.push({
                    x: event.offsetX,
                    y: event.offsetY
                });
            }
            if (typeDraw === this.typesDraw.arrow) this.drawLineWithArrowhead({
                x: startX,
                y: startY
            }, {
                x: x,
                y: y
            }, 25);
            if (typeDraw === this.typesDraw.rect) {
                let width = parseInt(startX - x);
                let height = parseInt(startY - y);
                this.drawRect(x, y, width, height);
            }
            this.setState({
                points: points
            });
        }
    }
    handleMouseUp(event) {
        let pathsry = this.state.pathsry;
        this.setState({
            isDown: false
        });
        const { canvas: canvas, ctx: ctx, typeDraw: typeDraw, canvasLayer: canvasLayer, canvasLayerCtx: canvasLayerCtx } = this.state;
        if (typeDraw === this.typesDraw.curve) {
            pathsry?.push({
                path: this.state.points,
                typeDraw: typeDraw
            });
            ctx.closePath();
            ctx.save();
        }
        if (typeDraw === this.typesDraw.arrow || typeDraw === this.typesDraw.rect) {
            const imgData = new Image();
            imgData.src = canvasLayer.toDataURL();
            pathsry?.push({
                imgData: imgData,
                typeDraw: typeDraw
            });
            ctx.drawImage(canvasLayer, 0, 0, this.state.img?.width, this.state.img?.height);
            canvasLayerCtx.clearRect(0, 0, canvas.width, canvas.height);
        }
        this.setState({
            resultImg: canvas.toDataURL(),
            pathsry: pathsry,
            ctx: ctx,
            points: [],
            canvasLayerCtx: canvasLayerCtx
        });
    }
    drawPaths = ()=>{
        // delete everything
        const { canvas: canvas, ctx: ctx, typeDraw: typeDraw, pathsry: pathsry, img: img } = this.state;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, this.state.img?.width, this.state.img?.height);
        pathsry?.forEach((shape)=>{
            if (shape.typeDraw === this.typesDraw.rect || shape.typeDraw === this.typesDraw.arrow) ctx.drawImage(shape.imgData, 0, 0, this.state.img?.width, this.state.img?.height);
            if (shape.typeDraw === this.typesDraw.curve) {
                ctx.beginPath();
                ctx.moveTo(shape.path[0].x, shape.path[0].y);
                for(let i = 1; i < shape.path.length; i++)ctx.lineTo(shape.path[i].x, shape.path[i].y);
                ctx.stroke();
            }
        });
        this.setState({
            resultImg: canvas.toDataURL()
        });
    };
    onModalToggle = ()=>{
        this.setState({
            isOpenModal: !this.state.isOpenModal
        });
        document.body.setAttribute("data-edit-modal-open", !this.state.isOpenModal);
    };
    onUndo = ()=>{
        let pathsry = this.state.pathsry;
        pathsry?.pop();
        this.setState({
            pathsry: pathsry
        });
        this.drawPaths();
    };
    render() {
        const { isOpenModal: isOpenModal, canvasImgLoading: canvasImgLoading } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "image-editor-wrapper",
            children: [
                !isOpenModal && /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                    type: "button",
                    className: "btn-sm white button-edit-img",
                    onClick: this.onModalToggle,
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                        className: "fa fa-edit"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
                    isShow: isOpenModal,
                    onClose: this.onModalToggle,
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "canvas-container",
                            style: {
                                width: `${this.state.img?.width}px; height: ${this.state.img?.height}px`
                            },
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                    loading: canvasImgLoading,
                                    disP: true
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("canvas", {
                                    ref: this.imageEditorRef,
                                    width: this.state.img?.width,
                                    height: this.state.img?.height,
                                    onMouseDown: (e)=>{
                                        let nativeEvent = e.nativeEvent;
                                        this.handleMouseDown(nativeEvent);
                                    },
                                    onMouseMove: (e)=>{
                                        let nativeEvent = e.nativeEvent;
                                        this.handleMouseMove(nativeEvent);
                                    },
                                    onMouseUp: (e)=>{
                                        let nativeEvent = e.nativeEvent;
                                        this.handleMouseUp(nativeEvent);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("canvas", {
                                    ref: this.canvasLayerArrow,
                                    className: "canvas-layer canvas-layer--arrow",
                                    width: this.state.img?.width,
                                    height: this.state.img?.height,
                                    onMouseDown: (e)=>{
                                        let nativeEvent = e.nativeEvent;
                                        this.handleMouseDown(nativeEvent);
                                    },
                                    onMouseMove: (e)=>{
                                        let nativeEvent = e.nativeEvent;
                                        this.handleMouseMove(nativeEvent);
                                    },
                                    onMouseUp: (e)=>{
                                        let nativeEvent = e.nativeEvent;
                                        this.handleMouseUp(nativeEvent);
                                    }
                                })
                            ]
                        }),
                        this.state.resultImg && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "details-buttons-container",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "btn white m-b",
                                    onClick: ()=>{
                                        this.setState({
                                            typeDraw: this.typesDraw.arrow
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-long-arrow-left"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "btn white m-b",
                                    onClick: ()=>{
                                        this.setState({
                                            typeDraw: this.typesDraw.curve
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-paint-brush"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "btn white m-b",
                                    onClick: ()=>{
                                        this.setState({
                                            typeDraw: this.typesDraw.rect
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-square"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "btn white m-b",
                                    onClick: this.onUndo,
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-step-backward"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "btn white m-b color-picker-btn-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "color-picker-trigger",
                                            onClick: ()=>this.setState((prev)=>({
                                                        showColorPicker: !prev.showColorPicker
                                                    })),
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "color-swatch",
                                                style: {
                                                    background: this.state.drawColor
                                                }
                                            })
                                        }),
                                        this.state.showColorPicker && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "color-picker-popup",
                                            children: [
                                                "red",
                                                "black",
                                                "white",
                                                "green",
                                                "blue"
                                            ].map((color)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: `color-option${this.state.drawColor === color ? " active" : ""}`,
                                                    style: {
                                                        background: color
                                                    },
                                                    onClick: ()=>this.setState({
                                                            drawColor: color,
                                                            showColorPicker: false
                                                        })
                                                }, color))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "btn white m-b",
                                    onClick: ()=>{
                                        this.props.onSaveImage?.(this.props.id, this.state.resultImg);
                                        this.onModalToggle();
                                    },
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-save"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}





var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
class $12fe0cc8efccca9d$var$TaskPriority extends (0, $cQmXV.Component) {
    renderPriority(priority) {
        if (priority === null || priority === undefined || typeof priority !== "number") return {
            text: "Unknown",
            color: "black"
        };
        const priorityMap = {
            0: {
                text: "Required",
                color: "red"
            },
            1: {
                text: "High",
                color: "darkorange"
            },
            2: {
                text: "Medium",
                color: "darkgreen"
            },
            3: {
                text: "Low",
                color: "darkgrey"
            }
        };
        return priorityMap[priority] || {
            text: "Unknown",
            color: "black"
        };
    }
    render() {
        const { priority: priority } = this.props;
        const { text: text, color: color } = this.renderPriority(priority);
        return /*#__PURE__*/ (0, $7uT18.jsx)("p", {
            style: {
                color: color,
                fontWeight: "bold"
            },
            children: text
        });
    }
}
var $12fe0cc8efccca9d$export$2e2bcd8739ae039 = $12fe0cc8efccca9d$var$TaskPriority;





var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $1ZXxd = parcelRequire("1ZXxd");

var $1Spf6 = parcelRequire("1Spf6");








const $d1774b39c619190c$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $d1774b39c619190c$export$fee3520bdfbfe55c extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
    constructor(props){
        super(props);
        this.state = {
            tags: [],
            points: [],
            components: []
        };
    }
    deleteImage = (idx)=>{
        let images = this.props.item.images;
        let id = images[idx].id;
        // delete images[idx];
        this.props.onChange("images", []);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: "images/" + id + "/",
            body: {}
        }, (image)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Image successfully deleted", {
                position: "top"
            });
        });
    };
    uploadFile = (acceptedFiles)=>{
        let file = acceptedFiles[0];
        let reader = new FileReader();
        reader.onload = (e)=>{
            let { result: result } = e.target;
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "POST",
                url: "images/",
                post: {
                    owner: $d1774b39c619190c$var$me.id,
                    image: result
                }
            }, (image)=>{
                if (image?.id) {
                    // Alert.success('Image successfully saved', {position: 'bottom-right'});
                    let images = this.props.item.images;
                    images.push(image);
                    this.props.onChange("images", images);
                } else {
                    console.log("Error while saving image. Error: " + JSON.stringify(r), {
                        position: "bottom-right"
                    });
                    console.log(image);
                }
            });
        };
        reader.readAsDataURL(file);
    };
    closeEditImgBlock = ()=>{
        this.props.closeModal();
    };
    render() {
        let { item: item, type: type, newTaskFromReview: newTaskFromReview = false, newTaskFromReviewPhoto: newTaskFromReviewPhoto = false } = this.props;
        let endDate = new Date(item.end).setHours(23, 59, 59);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "new-task-wrapper box  box-body boxForm " + (!newTaskFromReview && !newTaskFromReviewPhoto ? "boxEdit" : ""),
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "edit-images-block col-md-5 pr-2",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "taskImagesEdit",
                            children: item?.images?.map((image, idx)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "d-inline-block",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                            src: image.image,
                                            onClick: this.props.setOpen
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "editPhotoNav",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "deleteImage",
                                                    onClick: ()=>this.deleteImage(idx),
                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                        className: "fa fa-minus-square-o"
                                                    })
                                                }),
                                                this.props.isImageEditable && /*#__PURE__*/ (0, $7uT18.jsx)((0, $c2e3a9fdd09c4f82$export$2e2bcd8739ae039), {
                                                    src: image.image,
                                                    id: idx,
                                                    onSaveImage: this.props.onSaveEditorImage
                                                })
                                            ]
                                        })
                                    ]
                                }, idx))
                        }),
                        !item?.images?.length && /*#__PURE__*/ (0, $7uT18.jsx)((0, $c89956014bc8c37c$export$2e2bcd8739ae039), {
                            onDrop: (acceptedFiles)=>this.uploadFile(acceptedFiles),
                            accept: "image/jpeg, image/png",
                            styles: {
                                dropzone: {
                                    minHeight: 150,
                                    maxHeight: 250
                                }
                            },
                            multiple: false,
                            children: ({ getRootProps: getRootProps, getInputProps: getInputProps })=>/*#__PURE__*/ (0, $7uT18.jsx)("section", {
                                    className: "dropzone mt-3",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        ...getRootProps(),
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                ...getInputProps()
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d84a8a9f170b88dd), "drag_msg", $d1774b39c619190c$var$me.language)
                                            })
                                        ]
                                    })
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "task-main-row col-md-7 py-4",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("h4", {
                            className: "pt-4 px-4",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d84a8a9f170b88dd), "new_order", $d1774b39c619190c$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "task-main-content",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "col-md-12",
                                    children: [
                                        type === "network" && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "network", $d1774b39c619190c$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                    entity: "network",
                                                    value: item?.network?.id,
                                                    onChange: (o)=>{
                                                        this.props.onChange("network", o);
                                                    }
                                                })
                                            ]
                                        }),
                                        type === "point" && !newTaskFromReview && !newTaskFromReviewPhoto && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: `action-task-group-points ${this.props.selectTaskPointType.type === "single" ? "single-btn" : "group-btn"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "action-task-group-item btn action-task-single-btn",
                                                            onClick: ()=>this.props.selectTaskPointType.fn("single"),
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "new_task_single_btn_text", $d1774b39c619190c$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "action-task-group-item btn action-task-group-btn",
                                                            onClick: ()=>{
                                                                this.props.selectTaskPointType.fn("point_groups");
                                                            },
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "new_task_group_btn_text", $d1774b39c619190c$var$me.language)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: `form-group points-type ${this.props.selectTaskPointType.type === "point_groups" ? "is-active" : "is-hidden"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "form-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "task_group_points_title", $d1774b39c619190c$var$me.language)
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                                    type: "text",
                                                                    className: "form-control",
                                                                    placeholder: "",
                                                                    value: item.title_group_uploads,
                                                                    onChange: (e)=>this.props.onChange("title_group_uploads", e.target.value)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d84a8a9f170b88dd), "group_point_label", $d1774b39c619190c$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                            entity: "point_groups",
                                                            value: item?.point_groups?.id,
                                                            onChange: (o)=>{
                                                                this.props.onChange("point_groups", o);
                                                            },
                                                            asynch: false
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: `form-group points-type ${this.props.selectTaskPointType.type === "single" ? "is-active" : "is-hidden"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "point", $d1774b39c619190c$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                            entity: "point",
                                                            value: item?.point?.id,
                                                            onChange: (o)=>{
                                                                this.props.onChange("point", o);
                                                            },
                                                            asynch: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "task_title", $d1774b39c619190c$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    placeholder: "",
                                                    value: item.title,
                                                    onChange: (e)=>this.props.onChange("title", e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "description", $d1774b39c619190c$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    placeholder: "",
                                                    value: item?.description,
                                                    onChange: (e)=>this.props.onChange("description", e.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "col-md-12 template-field",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d84a8a9f170b88dd), "task_template", $d1774b39c619190c$var$me.language)
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                entity: "template",
                                                value: item.template,
                                                onChange: (o)=>this.props.onChange("template", o?.value),
                                                useDefaultValue: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d84a8a9f170b88dd), "start_date", $d1774b39c619190c$var$me.language)
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                selected: new Date(item.start),
                                                popperPlacement: "top",
                                                className: "datePicker",
                                                onChange: (date)=>this.props.onChange("start", date)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d84a8a9f170b88dd), "end_date", $d1774b39c619190c$var$me.language)
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                selected: new Date(endDate),
                                                popperPlacement: "top",
                                                className: "datePicker",
                                                onChange: (date)=>this.props.onChange("end", date)
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        !(0, (/*@__PURE__*/$parcel$interopDefault($1ZXxd))).isEmpty(this.props.errors) && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "col-md-12 error mt-2",
                            children: this.props.errors && Object.values(this.props.errors).map((error, index)=>{
                                return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    children: error
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "col-md-12 mt-3 mb-3 actions-block",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    type: "button",
                                    className: "btn-primary save-image-popup",
                                    onClick: this.props.submit,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                            className: "fa fa-save"
                                        }),
                                        " ",
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d84a8a9f170b88dd), "save_btn", $d1774b39c619190c$var$me.language)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    type: "button",
                                    className: "btn-primary cancel-image-popup",
                                    onClick: this.closeEditImgBlock,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                            className: "fa fa-mail-reply"
                                        }),
                                        " ",
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "cancel_btn", $d1774b39c619190c$var$me.language)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$d1774b39c619190c$export$fee3520bdfbfe55c.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).object,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).oneOf([
        "point",
        "network"
    ])
};







const $4cb165d7f5a45221$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $4cb165d7f5a45221$var$Preview extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            photoIndex: 0,
            isOpen: false,
            apiAnswerData: null,
            answerLoading: false,
            logoError: false
        };
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    componentDidMount = ()=>{
        document.addEventListener("keydown", this.handleKeyDown, false);
        const { item: item } = this.props;
        if (item.picsell_info?.object_type === "answer") this.fetchAnswerData();
        this.setState({
            logoError: false
        });
    };
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown, false);
    }
    componentDidUpdate(prevProps) {
        const { item: item } = this.props;
        if (prevProps.item?.id !== item?.id) this.setState({
            logoError: false
        });
        if (item.picsell_info?.object_type === "answer" && prevProps.item.picsell_info?.object_id !== item.picsell_info?.object_id) {
            this.setState({
                apiAnswerData: null
            });
            this.fetchAnswerData();
        }
        if (this.props.isResetPhotoItem !== prevProps.isResetPhotoItem && this.props.gridViewMode === "group") this.setState({
            photoIndex: 0
        });
    }
    handleKeyDown = (e)=>{
        let { acceptRejectAnswer: acceptRejectAnswer, passTaskToModal: passTaskToModal, moveNext: moveNext } = this.props;
        switch(e.code){
            case "ArrowLeft":
                moveNext(-1);
                break;
            case "ArrowRight":
                moveNext(1);
                break;
            case "ArrowUp":
                acceptRejectAnswer("ACCEPT");
                break;
            case "ArrowDown":
                passTaskToModal();
                break;
        }
    };
    deleteImage = (idx)=>{
        let images = this.props.editBlockData.item.images;
        let id = images[idx].id;
        // delete images[idx];
        this.props.editBlockData.onChange("images", []);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: "images/" + id + "/",
            body: {}
        }, ()=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Image successfully deleted", {
                position: "top"
            });
        });
    };
    handleDownlodDetailsPhoto = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const image = await fetch(`${e.currentTarget?.href}?chunk=${Date.now()}`); // expected <a href> link  or this.props.item.photo
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);
        // const imageName = imageURL.substring(imageURL.lastIndexOf("/") + 1);
        const imageName = this.getPhotoName();
        const link = document.createElement("a");
        link.href = imageURL;
        link.download = `${imageName}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    getPhotoName = ()=>{
        const dateString = (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(this.props.item.visit?.start) || "";
        const [datePart = "", timePart = ""] = dateString.split(" ");
        const [day = "", month = "", year = ""] = datePart.split("/");
        const [hours = "", minutes = ""] = timePart.split(":");
        const pointName = this.props.item.visit?.point?.name || "photo";
        const pointNameString = pointName.replace(/\s+/g, "_");
        const formattedDate = `${day}_${month}_${year}_${hours}_${minutes}_${pointNameString}`;
        return formattedDate;
    };
    isMonitoringData = ()=>{
        const item = this.props.item;
        return (0, $b79edb411f97c469$export$18a83674ba417afe)("", item) || (0, $b79edb411f97c469$export$990db37eaff487f0)("", item) ? true : false;
    };
    activePhotoIndex = (index = 0)=>{
        this.setState({
            photoIndex: index
        });
        return index;
    };
    //check if value is function or object
    isFunctionOrObject = (value)=>{
        return value !== null && typeof value === "function";
    };
    fetchAnswerData = async ()=>{
        this.setState({
            answerLoading: true
        });
        let { item: item } = this.props;
        let answerId = item.picsell_info?.object_id;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `answers/${answerId}/`
        }, (data)=>{
            this.setState({
                apiAnswerData: data,
                answerLoading: false
            });
        });
    };
    render() {
        let { item: item, acceptRejectAnswer: acceptRejectAnswer, passTaskToModal: passTaskToModal, editBlockData: editBlockData, isLoading: isLoading, gridViewMode: gridViewMode, openFullPhotoList: openFullPhotoList } = this.props;
        const { apiAnswerData: apiAnswerData, answerLoading: answerLoading } = this.state;
        editBlockData = this.isFunctionOrObject(editBlockData) ? editBlockData() : editBlockData;
        if (!item) return null;
        const tagList = Array.isArray(item?.additional_info?.tags) ? item.additional_info.tags : typeof item?.additional_info?.tags === "string" && item.additional_info.tags ? [
            item.additional_info.tags
        ] : [];
        let siteUrl = (0, $91ea30cb49819b9a$export$498d10c55d12eec5);
        siteUrl = siteUrl.replace("/login/", "");
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "item taskBlock",
            "data-photo-current-index": this.state.photoIndex,
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                    loading: isLoading,
                    disP: true,
                    type: "spinner"
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "col-md-5 pr-2 photoContainer photo-carousel",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: `original-photo-cover ${editBlockData.isModal > 0 ? "hidden" : ""}`,
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: `original-photo original-photos-wrapper ${editBlockData.isModal > 0 ? "hidden" : ""}`,
                                children: [
                                    gridViewMode === "single" ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "photo-review-list",
                                        children: item.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                            src: item.photo[item.quickItemPhotoIndex] ? item.photo[item.quickItemPhotoIndex] : item.photo[0],
                                            className: "previewImage"
                                        }) : item.url_photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                            src: item.url_photo,
                                            className: "previewImage"
                                        }) : /*#__PURE__*/ (0, $7uT18.jsx)("h5", {
                                            children: "Photo Not found"
                                        })
                                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $5588f76353c86461$export$2e2bcd8739ae039), {
                                        activePhotoIndex: this.activePhotoIndex,
                                        quickItemPhotoIndex: item.quickItemPhotoIndex,
                                        photos: item.photo,
                                        isDeepArray: true,
                                        clickCallback: (index)=>{
                                            openFullPhotoList(index);
                                        },
                                        viewMode: gridViewMode
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "pr-photo-nav",
                                        children: (()=>{
                                            const photos = item.photo ? item.photo : item.url_photo ? [
                                                item.url_photo
                                            ] : [];
                                            const activePhoto = photos[this.state.photoIndex] || photos[0];
                                            if (!activePhoto) return null;
                                            return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "pr-photo-nav-btns",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                                        href: activePhoto,
                                                        target: "_blank",
                                                        className: "pr-icon-btn",
                                                        title: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "material-symbols-outlined",
                                                            children: "open_in_full"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                                        href: activePhoto,
                                                        download: true,
                                                        className: "pr-icon-btn",
                                                        title: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
                                                        onClick: this.handleDownlodDetailsPhoto,
                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "material-symbols-outlined",
                                                            children: "cloud_download"
                                                        })
                                                    })
                                                ]
                                            });
                                        })()
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: `pr-action-bar ${editBlockData.isModal > 0 ? "hidden" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: `pr-action-btn pr-action-btn--approve${item.approval?.is_approved === true ? " pr-action-btn--active" : ""}`,
                                    onClick: ()=>acceptRejectAnswer("ACCEPT"),
                                    title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approv_btn", $4cb165d7f5a45221$var$me.language),
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "check_circle"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approv_btn", $4cb165d7f5a45221$var$me.language)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: `pr-action-btn pr-action-btn--reject${item.approval?.is_approved === false ? " pr-action-btn--active" : ""}`,
                                    onClick: ()=>passTaskToModal(this.state.photoIndex),
                                    title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "reject_btn", $4cb165d7f5a45221$var$me.language),
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "cancel"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "reject_btn", $4cb165d7f5a45221$var$me.language)
                                        })
                                    ]
                                })
                            ]
                        }),
                        editBlockData.item?.images?.length > 0 && editBlockData.isModal ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "taskImagesEdit",
                            children: editBlockData.item?.images?.map((image, idx)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                            src: image.image,
                                            onClick: editBlockData.setOpen
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "previewPhotoNav",
                                            children: [
                                                editBlockData.isImageEditable && /*#__PURE__*/ (0, $7uT18.jsx)((0, $c2e3a9fdd09c4f82$export$2e2bcd8739ae039), {
                                                    src: image.image,
                                                    id: idx,
                                                    onSaveImage: editBlockData.onSaveEditorImage
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>this.deleteImage(idx),
                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                        className: "fa fa-minus-square-o"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, idx))
                        }) : ""
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "col-md-7 pr-detail-col",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: `pr-detail ${editBlockData.isModal ? "hidden" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "pr-detail-header",
                                    children: [
                                        item.visit?.point?.image && !this.state.logoError ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                            src: `${siteUrl}${item.visit.point.image}`,
                                            className: "pr-detail-logo",
                                            alt: item.visit?.point?.name,
                                            loading: "lazy",
                                            onError: ()=>this.setState({
                                                    logoError: true
                                                })
                                        }) : /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "pr-detail-logo-fallback",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "material-symbols-outlined",
                                                children: "store"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-detail-location",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-detail-storename",
                                                    children: (0, $b79edb411f97c469$export$991779a709c15111)("", item)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-detail-locality",
                                                    children: item.visit?.point?.locality?.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                tagList.length > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "pr-chips",
                                    children: tagList.map((t)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "pr-chip",
                                            children: t
                                        }, t))
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "pr-info-card",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "pr-info-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "merchendiser", $4cb165d7f5a45221$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-info-value",
                                                    children: (0, $b79edb411f97c469$export$542a0fc0e045874)("", item)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "pr-info-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "responsible_supervisor", $4cb165d7f5a45221$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-info-value",
                                                    children: (0, $b79edb411f97c469$export$fa1c0d6984eb64ab)("", item)
                                                })
                                            ]
                                        }),
                                        item.approval?.approved_at && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "pr-info-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approve_reject_label_block", $4cb165d7f5a45221$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-value",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: `pr-status-chip${item.approval.is_approved === true ? " pr-status-chip--approved" : item.approval.is_approved === false ? " pr-status-chip--rejected" : ""}`,
                                                            children: item.approval.is_approved === true ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approved", $4cb165d7f5a45221$var$me.language) : item.approval.is_approved === false ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "rejected", $4cb165d7f5a45221$var$me.language) : ""
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                            className: "pr-info-meta",
                                                            children: [
                                                                (0, $b79edb411f97c469$export$ed8c8c6a3de01cc6)("name", item.approval),
                                                                " (",
                                                                (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.approval.approved_at),
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "pr-info-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "linkedVisit", $4cb165d7f5a45221$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-info-value",
                                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
                                                        href: `${window.location.origin}/visit/${item.visit_id}`,
                                                        className: "pr-link",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                className: "material-symbols-outlined pr-link-icon",
                                                                children: "link"
                                                            }),
                                                            item.visit?.point?.locality?.name,
                                                            " ",
                                                            item.visit?.point?.name
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "pr-info-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "start_visit", $4cb165d7f5a45221$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-info-value",
                                                    children: (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.visit?.start)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "pr-info-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "end_visit", $4cb165d7f5a45221$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-info-value",
                                                    children: (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.visit?.end)
                                                })
                                            ]
                                        }),
                                        item?.additional_info?.comment && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "pr-info-label",
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "comment", $4cb165d7f5a45221$var$me.language)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "pr-info-value",
                                                    children: item.additional_info.comment
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                this.isMonitoringData() && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "pr-section-title",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "price_monitoring", $4cb165d7f5a45221$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-card",
                                            children: [
                                                (0, $b79edb411f97c469$export$18a83674ba417afe)("", item) && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "price", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "pr-info-value",
                                                            children: (0, $b79edb411f97c469$export$18a83674ba417afe)("", item)
                                                        })
                                                    ]
                                                }),
                                                (0, $b79edb411f97c469$export$990db37eaff487f0)("", item) && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "sales_price", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "pr-info-value",
                                                            children: (0, $b79edb411f97c469$export$990db37eaff487f0)("", item)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                item.picsell_info?.object_type === "answer" && !answerLoading && apiAnswerData !== null && apiAnswerData?.task != null && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "pr-section-title",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "answer", $4cb165d7f5a45221$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "pr-info-card",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "linkedTasks", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
                                                            href: `${window.location.origin}/task/${apiAnswerData?.task.id}`,
                                                            className: "pr-link",
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined pr-link-icon",
                                                                    children: "link"
                                                                }),
                                                                apiAnswerData?.task.id,
                                                                " \u2014 ",
                                                                apiAnswerData?.task.title
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "description", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-value",
                                                            children: apiAnswerData?.answer
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "created_by", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-value",
                                                            children: (0, $b79edb411f97c469$export$3db7e6804ccca05c)(apiAnswerData)
                                                        })
                                                    ]
                                                }),
                                                apiAnswerData?.boolean_answer !== null && apiAnswerData?.boolean_answer !== undefined && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "answer", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-value",
                                                            children: apiAnswerData.boolean_answer ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "yes", $4cb165d7f5a45221$var$me.language) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "no", $4cb165d7f5a45221$var$me.language)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "priority", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-value",
                                                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $12fe0cc8efccca9d$export$2e2bcd8739ae039), {
                                                                priority: apiAnswerData?.task.priority
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pr-info-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-info-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "status", $4cb165d7f5a45221$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pr-status-chip static-status-color",
                                                            children: apiAnswerData?.task.status
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        editBlockData.isModal ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "text-left new-task-wrapper p-2",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                    loading: editBlockData.newTaskLoading,
                                    disP: true,
                                    type: "spinner"
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $d1774b39c619190c$export$fee3520bdfbfe55c), {
                                    ...editBlockData
                                })
                            ]
                        }) : ""
                    ]
                })
            ]
        });
    }
}
var $4cb165d7f5a45221$export$2e2bcd8739ae039 = $4cb165d7f5a45221$var$Preview;








const $a11cc2758244e822$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
// Caps how many infinite-scroll rows stay mounted at once (see lazyLoad below).
const $a11cc2758244e822$var$MAX_MOUNTED_ITEMS = 100;
class $a11cc2758244e822$var$PhotoReviewPage extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.modeTypes = {
            view: "view",
            list: "list"
        };
        this.state = {
            mode: this.props.match.params?.id ? this.modeTypes.view : this.modeTypes.list,
            gridViewMode: "single",
            item: null,
            currentIndex: 0,
            data: [],
            count: 0,
            isModal: false,
            isModalAsq: false,
            isModalSingle: false,
            isResetPhotoItem: false,
            loading: false,
            loadingMore: false,
            isOpenFullList: false,
            loadedImagesList: {},
            pagination: {
                state: false,
                count: 0,
                sizePerPage: 50,
                pageAmount: 1,
                page: 1
            },
            filter: {
                start: new Date(),
                end: new Date(),
                filters: [],
                newFilter: "",
                point__network: "",
                point__networks: [],
                point: "",
                points: [],
                user: "",
                users: [],
                brand: "",
                brands: [],
                tag: "",
                tags: [],
                product: "",
                products: [],
                categories: [],
                subcategory: "",
                subcategories: [],
                comment: "",
                county: "",
                clients: "",
                isChange: false
            },
            newTask: this.setInitTask(),
            newTaskLoading: false,
            prevY: 0,
            itemPost: [],
            lazyPagination: {
                page: 1,
                isNext: false
            },
            scrollPosition: 0
        };
    }
    async componentDidMount() {
        const { id: id } = this.props.match.params;
        const { search: search } = this.props.location;
        if (id) this.setState({
            mode: this.modeTypes.view
        });
        if (search && search.length > 1) {
            const filter = this.paramsToFilter(search);
            this.setState({
                filter: filter
            }, ()=>this.load());
        } else this.setStartDate();
    }
    async componentDidUpdate(prevProps, prevState, snapshot) {
        const { id: id } = this.props.match.params;
        const { item: item, data: data } = this.state;
        if (id && !item) {
            if (prevState.data !== data && data?.length) this.setState({
                item: data?.find((review)=>review.id === +id)
            });
        }
    }
    setInitTask = ()=>({
            images: [],
            company: null,
            title: "",
            start: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(new Date()).format("yyyy-MM-DDT00:00:00"),
            end: new Date(new Date().setHours(23, 59, 59)),
            tags: [],
            components: [],
            priority: 2,
            template: ""
        });
    setStartDate = ()=>{
        let filter = this.state.filter;
        let start = new Date();
        start = start.setDate(start.getDate() - 14);
        filter.start = (0, $b79edb411f97c469$export$7611a908c607f975)(start);
        this.setState({
            filter: filter
        }, ()=>{
            this.load();
        });
    };
    load = (viewType)=>{
        let { pagination: pagination } = this.state;
        let url = "visits/photos_from_reports/?page=" + pagination.page;
        let groupUrl = viewType === "group" ? "&report_type=grouped" : ""; //custom url attr for get grouped photos
        let urlFilter = (0, $3b579ca6158bc61b$export$728929c44bc0c14b)("visits/photos_from_reports", this.state.filter) + groupUrl;
        if (urlFilter) url += urlFilter;
        this.setState({
            loading: true
        });
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            if (!response.results) {
                console.log("error on getting filtered photo list");
                this.setState({
                    loading: false
                });
                return;
            }
            // let count = response.count;
            let count = 9223372036854776000; // TODO hotfix after removing harcoded value from backend
            let sizePerPage = response.results.length < count && pagination.page === 1 ? response.results.length : pagination.sizePerPage;
            let isNext = response.next || false;
            let isPrev = response.previous || false;
            const newPagination = {
                state: true,
                pageAmount: Math.ceil(count / pagination.sizePerPage),
                count: count,
                page: pagination.page,
                sizePerPage: sizePerPage,
                isNext: isNext,
                isPrev: isPrev
            };
            const data = response.results.map((photoData)=>new (0, $4e9873a13607b352$export$29d24e359e2fdff9)(photoData));
            this.setState({
                data: data,
                count: count,
                loading: false,
                pagination: newPagination,
                lazyPagination: {
                    ...this.state.lazyPagination,
                    // Prefer the backend's real "is there another page" signal now that
                    // photos_from_reports returns it; fall back to inferring from result
                    // length for response shapes that don't (e.g. report_type=grouped).
                    isNext: response.next !== undefined ? !!response.next : !!response.results?.length
                }
            });
        });
    };
    lazyLoad = ()=>{
        let { lazyPagination: lazyPagination } = this.state;
        if (!lazyPagination.isNext) return;
        let url = "visits/photos_from_reports/?page=" + (lazyPagination.page + 1);
        let groupUrl = this.state.gridViewMode === "group" ? "&report_type=grouped" : "";
        let urlFilter = (0, $3b579ca6158bc61b$export$728929c44bc0c14b)("visits/photos_from_reports", this.state.filter) + groupUrl;
        if (urlFilter) url += urlFilter;
        this.setState({
            loadingMore: true
        });
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            if (!response.results) {
                console.log("error on getting filtered photo list");
                this.setState({
                    loadingMore: false
                });
                return;
            }
            let isNext = response.next !== undefined ? !!response.next : !!response.results.length;
            const newPagination = {
                page: response.results.length ? lazyPagination.page + 1 : lazyPagination.page,
                isNext: isNext
            };
            const data = response.results.map((photoData)=>new (0, $4e9873a13607b352$export$29d24e359e2fdff9)(photoData));
            let accumulatedDataList = data?.length ? [
                ...this.state.data,
                ...data
            ] : this.state.data;
            // Bound how many rows stay mounted during infinite scroll — without this, DOM
            // node count (and per-update costs like Table's overflow check) grow for as
            // long as the session lasts. Evicting from the front only ever drops rows the
            // user has already scrolled well past; Table keys its per-row state by item.id,
            // not array index, so this can't desync with images already marked loaded/selected.
            if (accumulatedDataList.length > $a11cc2758244e822$var$MAX_MOUNTED_ITEMS) accumulatedDataList = accumulatedDataList.slice(-$a11cc2758244e822$var$MAX_MOUNTED_ITEMS);
            this.setState({
                data: accumulatedDataList,
                loadingMore: false,
                lazyPagination: newPagination
            });
        });
    };
    // ── URL ↔ filter sync ──────────────────────────────────────
    filterToParams = (filter)=>{
        const params = new URLSearchParams();
        const dateStr = (v)=>{
            if (!v) return null;
            const d = v instanceof Date ? v : new Date(v);
            return isNaN(d) ? null : d.toISOString().slice(0, 10);
        };
        if (dateStr(filter.start)) params.set("start", dateStr(filter.start));
        if (dateStr(filter.end)) params.set("end", dateStr(filter.end));
        if (filter.point__network) params.set("network", filter.point__network);
        if (filter.county) params.set("county", filter.county);
        if (filter.clients) params.set("clients", filter.clients);
        if (filter.comment) params.set("comment", filter.comment);
        [
            "users",
            "points",
            "brands",
            "tags",
            "products",
            "categories",
            "subcategories"
        ].forEach((key)=>{
            const arr = filter[key];
            if (Array.isArray(arr) && arr.length) arr.forEach((item)=>{
                const id = item?.id != null ? item.id : item;
                if (id != null && id !== "") params.append(key, id);
            });
        });
        return params;
    };
    paramsToFilter = (search)=>{
        const params = new URLSearchParams(search);
        const filter = {
            ...this.state.filter
        };
        if (params.get("start")) filter.start = params.get("start");
        if (params.get("end")) filter.end = params.get("end");
        if (params.get("network")) filter.point__network = params.get("network");
        if (params.get("county")) filter.county = params.get("county");
        if (params.get("clients")) filter.clients = params.get("clients");
        if (params.get("comment")) filter.comment = params.get("comment");
        [
            "users",
            "points",
            "brands",
            "tags",
            "products",
            "categories",
            "subcategories"
        ].forEach((key)=>{
            const vals = params.getAll(key);
            if (vals.length) filter[key] = vals.map((v)=>({
                    id: isNaN(v) ? v : parseInt(v, 10)
                }));
        });
        return filter;
    };
    // ─────────────────────────────────────────────────────────
    submit = ()=>{
        const params = this.filterToParams(this.state.filter);
        this.props.history.replace({
            search: params.toString()
        });
        this.updatePaging(1, ()=>{}, this.state.gridViewMode);
    };
    changeFilter = (filterEntity, item)=>{
        let filter = this.state.filter;
        if (filterEntity === "start" || filterEntity === "end") filter[filterEntity] = item;
        else filter[filterEntity] = item?.id;
        if ([
            "filters",
            "users",
            "tag",
            "tags",
            "point__networks",
            "points",
            "brand",
            "brands",
            "product",
            "products",
            "categories",
            "subcategory",
            "subcategories",
            "comment",
            "client"
        ].includes(filterEntity)) filter[filterEntity] = item;
        if (filterEntity === "filters" && item) filter = this.loadingUserFilter(filter.filters);
        else if (filterEntity === "filters" && !item) this.resetFilter();
        this.showHideAddFilterBlock(filter);
        this.setState({
            filter: filter
        });
    };
    showHideAddFilterBlock = (filter)=>{
        filter.isChange = false;
        [
            "users",
            "tags",
            "point__networks",
            "points",
            "brands",
            "products",
            "categories",
            "subcategories",
            "comment"
        ].forEach((i)=>{
            if (filter[i]?.length > 0) filter.isChange = true;
        });
    };
    resetFilter = ()=>{
        let filter = this.state.filter;
        Object.keys(filter).map((i)=>{
            filter[i] = [];
            if (i === "start" || i === "end") filter[i] = new Date();
        });
        this.props.history.replace({
            search: ""
        });
        this.setState({
            filter: filter
        }, ()=>{
            this.setStartDate();
            this.load();
        });
    };
    setApproveRejectState = (type, photoObj, quickView)=>{
        let photoItem = quickView ? photoObj : this.state.item ? this.state.item : null;
        if (!photoItem?.picsell_info?.object_id || !photoItem?.picsell_info?.object_type) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_object_item_id_msg", this.props.me.language));
            return;
        }
        const approveRejectStatus = type === "ACCEPT" ? true : false;
        const approveRejectObject = {
            object_id: photoItem.picsell_info.object_id,
            object_type: photoItem.picsell_info.object_type,
            is_approved: approveRejectStatus,
            comment: ""
        };
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "approvals/",
            post: approveRejectObject
        }, (response)=>{
            if (response) {
                approveRejectStatus ? (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_accept_msg", this.props.me.language)) : (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_reject_msg", this.props.me.language));
                this.moveNext();
            } else {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error: " + type + JSON.stringify(response));
                console.log(response);
            }
        });
    };
    acceptRejectAnswer = (type, photoObj, quickView)=>{
        this.setApproveRejectState(type, photoObj, quickView);
    };
    moveNext = (DIRECTION = 1)=>{
        let { currentIndex: currentIndex, data: data, count: count, pagination: pagination } = this.state;
        const el = document.querySelector(".photo-review-item-wrapper--active");
        const rect = el.getBoundingClientRect();
        if (count === 0) {
            this.setState({
                mode: this.modeTypes.list
            });
            return;
        }
        if (DIRECTION === 1 && currentIndex === count - 1) {
            if (pagination.isNext) this.updatePaging(pagination.page + 1);
        }
        if (DIRECTION === -1 && currentIndex === 0) {
            if (pagination.isPrev) this.updatePaging(pagination.page - 1, ()=>{
                let newItem = data[pagination.count - 1];
                this.setState({
                    currentIndex: pagination.count - 1,
                    item: newItem
                });
            });
        }
        let newIndex = 0;
        if (currentIndex + DIRECTION < count) newIndex = currentIndex + DIRECTION;
        else newIndex = 0;
        if (newIndex === -1 && DIRECTION === -1) newIndex = count - 1;
        if (data.length === newIndex + 1) this.lazyLoad();
        if (!data[newIndex]) {
            console.log("NEW ITEM NOT EXIST. NewIndex", newIndex);
            return;
        }
        // if (!data[newIndex] && DIRECTION === +1) {
        //   console.log("NEW ITEM NOT EXIST. NewIndex", newIndex);
        //   this.lazyLoad();
        //   // this.moveNext(+1);
        //
        //   return;
        // }
        let newItem = data[newIndex];
        this.setState({
            currentIndex: newIndex,
            item: newItem,
            newTask: this.setInitTask(),
            isModal: false,
            scrollPosition: rect.top - 150,
            isResetPhotoItem: !this.state.isResetPhotoItem
        });
    //this.props.history.push(`/photo-review/${newItem.id}/view`);
    };
    openTask = (item, autoRunPassTask = false, quickItemPhotoIndex = null)=>{
        let currentIndex = this.state.data?.indexOf(item);
        item.quickItemPhotoIndex = quickItemPhotoIndex || 0;
        this.setState((state)=>{
            return {
                item: item,
                currentIndex: currentIndex,
                scrollPosition: window.scrollY || 0,
                quickItemPhotoIndex: quickItemPhotoIndex
            };
        }, ()=>{
            this.setState({
                mode: this.modeTypes.list
            });
        //this.props.history.push(`/photo-review/${item.id}/view`);
        });
        this.modalOpenSinglePhoto();
        if (autoRunPassTask && quickItemPhotoIndex !== null) this.passTaskToModal(quickItemPhotoIndex, item);
    };
    back = ()=>{
        this.setState({
            mode: this.modeTypes.list
        });
        this.props.history.push(`/photo-review/`);
        setTimeout(()=>{
            window.scrollTo(0, this.state.scrollPosition);
        }, 100);
    };
    modalOpenSinglePhoto = ()=>{
        this.setState({
            isModalSingle: true
        });
    };
    modalCloseSinglePhoto = ()=>{
        this.setState({
            isModalSingle: false,
            isModal: false
        });
        this.back();
    };
    modalOpen = ()=>{
        this.setState({
            isModal: true
        });
    };
    modalClose = ()=>{
        this.setState({
            isModal: false
        });
    };
    modalFilterClose = ()=>{
        this.setState({
            isModalAsq: false
        });
    };
    newTaskOnChange = (property, value)=>{
        let item = this.state.newTask;
        item[property] = property === "start" ? (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(value).format("yyyy-MM-DDT00:00:00") : value;
        this.setState({
            newTask: item
        });
    };
    passTaskToModal = (photoIndex, el)=>{
        let { newTask: newTask, item: item } = this.state;
        if (el) item = el; // for quick open reject order from grid
        newTask.point = item?.visit?.point?.id || null;
        newTask.end = (0, $3b579ca6158bc61b$export$f996c1bb09f018d3)(newTask.start, 30); // TODO rewrite dateChangeFormat
        newTask.components = [
            {
                id: 3,
                name: (0, $6f1c09625235f1f0$export$a32e78025ed8daad)["photo"],
                value: 3,
                label: (0, $6f1c09625235f1f0$export$a32e78025ed8daad)["photo"]
            }
        ];
        item.photo[photoIndex] ? photoIndex : photoIndex = 0;
        if (item.photo[photoIndex]) {
            newTask.images = [
                {
                    image: item.photo[photoIndex]
                }
            ];
            newTask.imageFromReview = {
                image: item.photo[photoIndex]
            };
        }
        this.setState({
            newTask: newTask,
            isModal: true
        });
    };
    onSaveEditorImage = (index, image)=>{
        //index: number; image: base64 data image
        const { newTask: newTask } = this.state;
        if (!image) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: this.props.me,
                image: image
            }
        }, (image)=>{
            if (image?.id) this.setState({
                newTask: {
                    ...newTask,
                    images: [
                        image
                    ]
                }
            });
            else console.log(image);
        });
    };
    newTaskSubmit = async (status)=>{
        let { newTask: newTask } = this.state;
        let itemPost = Object.assign({}, newTask);
        let queueLoadingTimer = 0;
        let queueLoadingStep = 8000;
        if (!this.state.item?.picsell_info?.object_id || !this.state.item?.picsell_info?.object_type) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_object_item_id_msg", this.props.me.language));
            return;
        }
        itemPost.components = newTask.components.map((i)=>i.id);
        itemPost.network = newTask?.network?.id || null;
        itemPost.end = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(itemPost.end).format("yyyy-MM-DDT23:59:59");
        itemPost.created_by = newTask.created_by?.id || $a11cc2758244e822$var$me?.id || null;
        itemPost.template = itemPost.template === "" ? (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().defaultTemplate : itemPost.template;
        itemPost.visit_id = this.state.item?.visit_id || 0;
        const { validate: validate, errors: errors } = (0, $3b579ca6158bc61b$export$6daeeb4cea31fc5)("photo-review", itemPost);
        if (!validate) {
            this.setState({
                errors: errors
            });
            return;
        }
        if (itemPost.images.every((image)=>image.id)) {
            itemPost.images = newTask.images?.map((image)=>image.id);
            this.createNewTask(itemPost);
        } else {
            this.setState({
                newTaskLoading: true
            });
            itemPost.images = newTask.images?.map((image, index)=>{
                if (image.id) {
                    itemPost.images = [
                        image.id
                    ];
                    this.createNewTask(itemPost);
                    this.setState({
                        itemPost: itemPost,
                        newTaskLoading: false,
                        mode: this.modeTypes.list,
                        isModal: false
                    });
                    return image.id;
                } else {
                    setTimeout((args)=>{
                        (0, $3b579ca6158bc61b$export$d6f5c7e166773679)(image.image, this.props.me, (createdImg)=>{
                            if (createdImg.id) {
                                itemPost.images.push(createdImg.id);
                                if (index === newTask.images.length - 1) {
                                    itemPost.images = itemPost.images?.filter((item)=>!!item);
                                    this.createNewTask(itemPost);
                                    this.setState({
                                        itemPost: itemPost,
                                        newTaskLoading: false,
                                        mode: this.modeTypes.list,
                                        isModal: false
                                    });
                                }
                            } else console.error("image was not created");
                        });
                    }, queueLoadingTimer);
                    queueLoadingTimer += queueLoadingStep;
                }
            });
        }
    };
    createNewTask = (data)=>{
        if (!data) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "tasks/",
            post: data
        }, (response)=>{
            if (response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "newtask_success_msg", this.props.me.language));
                this.setState({
                    mode: this.modeTypes.list,
                    isModal: false,
                    errors: {}
                });
                this.acceptRejectAnswer("REJECT");
                this.setState({
                    newTask: this.setInitTask()
                });
            } else {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving item. Error: " + JSON.stringify(response));
                console.log(response);
            }
        });
    };
    loadingUserFilter = (item)=>{
        // A malformed saved-filter string must not take down the page — fall back to {}.
        let parsed = {};
        try {
            parsed = JSON.parse(item?.filters_string) || {};
        } catch (e) {
            parsed = {};
        }
        let lastDate = (0, $3b579ca6158bc61b$export$ed8107b92751e3f2)();
        // A saved filter's JSON may omit fields (older saves, or fields never set). Start from a
        // clean copy of the full filter shape so downstream code never reads an undefined field.
        let base = {
            ...this.state.filter
        };
        Object.keys(base).forEach((key)=>{
            base[key] = Array.isArray(base[key]) ? [] : typeof base[key] === "string" ? "" : base[key];
        });
        let filter = {
            ...base,
            ...parsed
        };
        filter.filters = item;
        filter.start = lastDate.start;
        filter.end = lastDate.end;
        return filter;
    };
    addNewFilterName = (name)=>{
        let filter = this.state.filter;
        filter.newFilter = name;
        this.setState({
            filter: filter
        });
    };
    validateFilterName = (name)=>{
        if (name.length) return name;
        else {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "valid_error_msg", this.props.me.language), {
                position: "top"
            });
            return false;
        }
    };
    removeUserFilterPopup = (entity)=>{
        this.setState({
            isModalAsq: true
        });
        return entity;
    };
    removeUserFilter = (entity = "filters")=>{
        let filter = this.state.filter;
        let idFilter = filter.filters.id;
        let url = (0, $91ea30cb49819b9a$export$da688e121885cf48)[entity] + idFilter + "/";
        this.setState({
            isModalAsq: false
        });
        if (idFilter) (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: url
        }, (response)=>{
            if (response.ok === true) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "remove_success_msg", this.props.me.language), {
                    position: "top"
                });
                this.updateUserFilter(entity, (0, $91ea30cb49819b9a$export$da688e121885cf48)[entity]);
                this.resetFilter();
            }
        });
        else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "remove_confirmation_msg", this.props.me.language), {
            position: "top"
        });
    };
    updateUserFilter = (entity, url)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            response = response.results;
            response = (0, $3b579ca6158bc61b$export$b25c9bd295a2cb07)(response, entity);
            this.setState({
                list: response
            });
        });
    };
    removeUnnecesaryData = (filter, keys = [])=>{
        let cloneFilter = {
            ...filter
        };
        keys.forEach((el)=>{
            delete cloneFilter[el];
        });
        return cloneFilter;
    };
    createNewFilter = (entity, filterName)=>{
        let filterState = this.removeUnnecesaryData(this.state.filter, [
            "start",
            "end"
        ]);
        let name = this.validateFilterName(filterName);
        let url = (0, $91ea30cb49819b9a$export$da688e121885cf48)[entity];
        this.state.filter.newFilter = "";
        let item = {
            name: name,
            is_active: true,
            filters_string: JSON.stringify(filterState)
        };
        if (!name) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: url,
            post: item
        }, (response)=>{
            if (response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("\u0424\u0456\u043B\u044C\u0442\u0435\u0440 \u0437\u0431\u0435\u0440e\u0436\u0435\u043D\u043E");
                this.setState({
                    errors: {}
                });
                this.updateUserFilter(entity, url);
                this.submit();
            } else {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving item. Error: " + JSON.stringify(response));
                console.log(response);
            }
        });
    };
    // PAGINATION
    updatePaging = (page, cb, viewType)=>{
        let { pagination: pagination } = this.state;
        pagination.page = page;
        this.setState({
            pagination: Object.assign({}, pagination)
        }, ()=>{
            this.load(viewType);
            if (cb) cb();
        });
    };
    //Group Photo View
    gridPhotoView = (type)=>{
        this.setState({
            gridViewMode: type
        }, ()=>{
            this.load(type);
        });
    };
    handleImageLoad = (index)=>{
        this.setState((prevState)=>({
                loadedImagesList: {
                    ...prevState.loadedImagesList,
                    [index]: true
                }
            }));
    };
    handleImageCloseFullView = ()=>{
        this.setState({
            isOpenFullList: false,
            loadedImagesList: {}
        });
    };
    openFullPhotoList = ()=>{
        this.setState({
            isOpenFullList: true
        });
    };
    render() {
        const { mode: mode, isModal: isModal, isModalAsq: isModalAsq, isModalSingle: isModalSingle, pagination: pagination, item: item, currentIndex: currentIndex, data: data, newTaskLoading: newTaskLoading, gridViewMode: gridViewMode } = this.state;
        const previewNavigationData = {
            currentIndex: currentIndex || 0,
            lastIndex: data?.length || 0
        };
        const editBlockData = {
            item: this.state.newTask,
            type: "point",
            newTaskFromReviewPhoto: true,
            onChange: this.newTaskOnChange,
            onSaveEditorImage: this.onSaveEditorImage,
            submit: this.newTaskSubmit,
            setOpen: ()=>this.setState({
                    isOpen: true
                }),
            closeModal: this.modalClose,
            errors: this.state.errors,
            isImageEditable: true,
            newTaskLoading: newTaskLoading,
            isModal: isModal,
            currentPhotoIndex: this.state.quickItemPhotoIndex || 0
        };
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: `container-fluid photo-review-container`,
            onKeyDown: this.handleKeyDown,
            children: [
                mode === this.modeTypes.view && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9b4ba9aeb2db83c0$export$53f1cd6809577fc5), {
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9b4ba9aeb2db83c0$export$7f365262018175ea), {
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "faIcon",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-camera"
                                    })
                                }),
                                mode === this.modeTypes.list && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    children: "\u0424\u041E\u0422\u041E \u0417\u0432\u0456\u0442"
                                }),
                                mode === this.modeTypes.view && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    children: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9b4ba9aeb2db83c0$export$dc78206a797fc4b8), {
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "btn btn-primary",
                                onClick: this.back,
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-arrow-left"
                                    }),
                                    " ",
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "back", this.props.me.language)
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "box p-4",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: `${mode === this.modeTypes.list ? "h-show" : "h-hide"}`,
                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $105fabe664da7e8a$export$2e2bcd8739ae039), {
                                ...this.state,
                                lang: this.props.me?.language ? this.props.me?.language : "en",
                                changeFilter: this.changeFilter,
                                resetFilter: this.resetFilter,
                                submit: this.submit,
                                openTask: this.openTask,
                                pagination: pagination,
                                updatePaging: this.lazyLoad,
                                createNewFilter: this.createNewFilter,
                                removeUserFilterPopup: this.removeUserFilterPopup,
                                addNewFilterName: this.addNewFilterName,
                                gridPhotoView: this.gridPhotoView,
                                acceptRejectAnswer: this.acceptRejectAnswer
                            })
                        }),
                        isModalSingle && /*#__PURE__*/ (0, $7uT18.jsx)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
                            isShow: isModalSingle,
                            isSingle: isModalSingle,
                            isSupervised: !item.is_supervised,
                            moveNext: this.moveNext,
                            previewNavigationData: previewNavigationData,
                            onClose: ()=>this.modalCloseSinglePhoto(),
                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $4cb165d7f5a45221$export$2e2bcd8739ae039), {
                                item: item,
                                acceptRejectAnswer: this.acceptRejectAnswer,
                                passTaskToModal: this.passTaskToModal,
                                moveNext: this.moveNext,
                                previewNavigationData: previewNavigationData,
                                editBlockData: editBlockData,
                                isLoading: this.state.loading,
                                gridViewMode: gridViewMode,
                                isResetPhotoItem: this.state.isResetPhotoItem,
                                openFullPhotoList: this.openFullPhotoList
                            })
                        }),
                        this.state.isOpenFullList && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "full-photo-list",
                            onClick: this.handleImageCloseFullView,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                    className: "fa fa-times"
                                }),
                                item.photo.length > 0 && item.photo.map((photoItem, index)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: `full-photo-item ${this.state.loadedImagesList[index] ? "" : "loading"}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                                loading: this.state.loadedImagesList[index] ? false : true
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                                src: photoItem,
                                                alt: "images",
                                                loading: "lazy",
                                                style: !this.state.loadedImagesList[index] ? {
                                                    display: "none"
                                                } : {},
                                                onLoad: ()=>this.handleImageLoad(index)
                                            })
                                        ]
                                    }, photoItem + index))
                            ]
                        }),
                        isModalAsq && /*#__PURE__*/ (0, $7uT18.jsx)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
                            isShow: isModalAsq,
                            customClass: "asq-modal",
                            onClose: ()=>this.modalFilterClose(),
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "asq-popup",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                        loading: newTaskLoading,
                                        disP: true,
                                        type: "spinner"
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "confirmation_msg", this.props.me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        className: "asq-popup yes-asq",
                                        onClick: ()=>this.removeUserFilter(),
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "yes", this.props.me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        className: "asq-popup no-asq",
                                        onClick: ()=>this.modalFilterClose(),
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", this.props.me.language)
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $a11cc2758244e822$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($a11cc2758244e822$var$PhotoReviewPage));



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


function $da70838858bfad8a$export$7212735dbabb867d(descriptor, { page: page = 1, search: search = "", filters: filters = {}, ordering: ordering = "" } = {}) {
    const parts = [
        `page=${page}`
    ];
    parts.push("page_size=25"); // keep in sync with ResourceTable PAGE_SIZE (matches API StandardResultsSetPagination default)
    if (search) parts.push(`search=${encodeURIComponent(search)}`);
    if (ordering) parts.push(`ordering=${encodeURIComponent(ordering)}`);
    Object.entries(filters).forEach(([k, v])=>{
        if (v !== undefined && v !== null && v !== "") parts.push(`${k}=${encodeURIComponent(v)}`);
    });
    return `${descriptor.endpoint}?${parts.join("&")}`;
}
function $da70838858bfad8a$export$3dddb10616f03c3a(descriptor, params, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "GET",
        url: $da70838858bfad8a$export$7212735dbabb867d(descriptor, params)
    }, (r)=>{
        if (Array.isArray(r)) return cb({
            results: r,
            count: r.length
        });
        if (r && Array.isArray(r.results)) return cb({
            results: r.results,
            count: r.count ?? r.results.length
        });
        cb({
            results: [],
            count: 0
        });
    });
}
function $da70838858bfad8a$export$78af959256a39335(descriptor, id, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "GET",
        url: `${descriptor.endpoint}${id}/`
    }, cb);
}
function $da70838858bfad8a$export$488773977679fb92(descriptor, item, me, cb) {
    const isNew = !item.id;
    let payload = {
        ...item
    };
    if (isNew && typeof descriptor.injectOnCreate === "function") payload = descriptor.injectOnCreate(payload, me);
    (descriptor.fields || []).forEach((f)=>{
        if (f.type !== "entity") return;
        const v = payload[f.name];
        if (v == null) return;
        if (Array.isArray(v)) payload[f.name] = v.map((x)=>x && typeof x === "object" ? x.id ?? x.value ?? x : x);
        else if (typeof v === "object") payload[f.name] = v.id ?? v.value ?? v;
    });
    // Image fields: only resend a File (new upload) or "" (explicit clear).
    // An unchanged value is a URL string (or null) fetched from GET — the API can't accept that back.
    (descriptor.fields || []).forEach((f)=>{
        if (f.type !== "image") return;
        const v = payload[f.name];
        if (typeof File !== "undefined" && v instanceof File) return;
        if (v === "") return;
        delete payload[f.name];
    });
    const hasFile = Object.values(payload).some((v)=>typeof File !== "undefined" && v instanceof File);
    if (hasFile) {
        const fd = new FormData();
        Object.entries(payload).forEach(([k, v])=>{
            if (v === undefined || v === null) return;
            if (typeof File !== "undefined" && v instanceof File) fd.append(k, v);
            else if (Array.isArray(v)) v.forEach((item)=>fd.append(k, item));
            else if (typeof v === "object") fd.append(k, JSON.stringify(v));
            else fd.append(k, v);
        });
        (0, $c9936523dc38c641$export$e9af2f996ea0b059)({
            method: isNew ? "POST" : "PATCH",
            url: isNew ? descriptor.endpoint : `${descriptor.endpoint}${item.id}/`,
            post: fd
        }, cb);
        return;
    }
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: isNew ? "POST" : "PATCH",
        url: isNew ? descriptor.endpoint : `${descriptor.endpoint}${item.id}/`,
        post: payload
    }, cb);
}
function $da70838858bfad8a$export$8d8542dbbc23fe1a(descriptor, id, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "DELETE",
        url: `${descriptor.endpoint}${id}/`
    }, (r)=>cb(!!r && r.status === 204));
}
function $da70838858bfad8a$export$43fc4be2c4b87d49(descriptor, id, data, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "PATCH",
        url: `${descriptor.endpoint}${id}/`,
        post: data
    }, cb);
}
function $da70838858bfad8a$export$13b0757be3ff9c68(descriptor) {
    if (descriptor.deactivation) {
        const d = descriptor.deactivation;
        return {
            field: d.field,
            activeValue: d.activeValue,
            inactiveValue: "inactiveValue" in d ? d.inactiveValue : !d.activeValue,
            via: d.via || "patch"
        };
    }
    if (descriptor.softDelete) return {
        field: "is_removed",
        activeValue: false,
        inactiveValue: true,
        via: "delete"
    };
    return null;
}
function $da70838858bfad8a$export$bb7ceb464758d5fe(item, cfg) {
    return cfg ? item[cfg.field] !== cfg.activeValue : false;
}
async function $da70838858bfad8a$export$45fc6b2d335e3c39(response) {
    const out = {
        __ok: false,
        fields: {},
        message: ""
    };
    try {
        const body = await response.json();
        if (body && typeof body === "object") {
            Object.entries(body).forEach(([k, v])=>{
                out.fields[k] = Array.isArray(v) ? v.join(", ") : String(v);
            });
            out.message = Object.values(out.fields).join("; ");
        }
    } catch (e) {}
    return out;
}





const $cec7e23dedd0f8c4$var$PAGE_SIZE = 25;
class $cec7e23dedd0f8c4$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    state = {
        rows: [],
        count: 0,
        page: 1,
        search: "",
        filters: {},
        loading: false,
        checked: [],
        ordering: this.props.descriptor.defaultOrdering || "name"
    };
    _debounce = null;
    componentDidMount() {
        this._isMounted = true;
        this.load();
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this._debounce);
    }
    load = ()=>{
        const { descriptor: descriptor } = this.props;
        const { page: page, search: search, filters: filters, ordering: ordering } = this.state;
        this.setState({
            loading: true
        });
        (0, $da70838858bfad8a$export$3dddb10616f03c3a)(descriptor, {
            page: page,
            search: search,
            filters: filters,
            ordering: ordering
        }, ({ results: results, count: count })=>{
            if (!this._isMounted) return;
            this.setState({
                rows: results,
                count: count,
                loading: false
            });
        });
    };
    // Cycle a column's ordering: asc -> desc -> cleared (reverts to the API default).
    toggleSort = (key)=>{
        this.setState((s)=>{
            let ordering;
            if (s.ordering === key) ordering = "-" + key;
            else if (s.ordering === "-" + key) ordering = "";
            else ordering = key;
            return {
                ordering: ordering,
                page: 1
            };
        }, this.load);
    };
    onSearch = (e)=>{
        const search = e.target.value;
        this.setState({
            search: search,
            page: 1
        });
        clearTimeout(this._debounce);
        this._debounce = setTimeout(this.load, (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
    };
    setFilter = (name, option)=>{
        this.setState((s)=>{
            const filters = {
                ...s.filters,
                [name]: option ? option.id : ""
            };
            (this.props.descriptor.filters || []).forEach((f)=>{
                if (f.scopeBy === name) filters[f.name] = "";
            });
            return {
                filters: filters,
                page: 1
            };
        }, this.load);
    };
    goPage = (page)=>this.setState({
            page: page
        }, this.load);
    toggleCheck = (row)=>this.setState((s)=>({
                checked: s.checked.some((c)=>c.id === row.id) ? s.checked.filter((c)=>c.id !== row.id) : [
                    ...s.checked,
                    {
                        id: row.id,
                        name: row.name
                    }
                ]
            }));
    clearChecked = ()=>{
        if (this._isMounted) this.setState({
            checked: []
        });
    };
    render() {
        const { descriptor: descriptor, currentUser: currentUser, onOpen: onOpen } = this.props;
        const { rows: rows, count: count, page: page, search: search, loading: loading, checked: checked, ordering: ordering } = this.state;
        const G = (0, $fc3f36407bc5ec6c$export$ac552071080927b0), lang = currentUser.language;
        const pages = Math.max(1, Math.ceil(count / $cec7e23dedd0f8c4$var$PAGE_SIZE));
        const hasBulk = Array.isArray(descriptor.bulkActions) && descriptor.bulkActions.length > 0;
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "pt-table-wrap",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "pt-toolbar",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "pt-search",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "search"
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                    className: "mp-form-input",
                                    value: search,
                                    placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "search_ph", lang),
                                    onChange: this.onSearch
                                })
                            ]
                        }),
                        (descriptor.filters || []).map((f)=>f.type === "me" ? /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                className: "pt-filter-check",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        type: "checkbox",
                                        checked: !!this.state.filters[f.name],
                                        onChange: (e)=>this.setFilter(f.name, e.target.checked ? {
                                                id: currentUser.id
                                            } : null)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, f.label, lang)
                                    })
                                ]
                            }, f.name) : /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "pt-filter",
                                children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                    entity: f.entity,
                                    value: this.state.filters[f.name] || "",
                                    county: f.scopeBy ? this.state.filters[f.scopeBy] : undefined,
                                    placeholder: f.label ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, f.label, lang) : undefined,
                                    onChange: (o)=>this.setFilter(f.name, o)
                                })
                            }, f.name)),
                        !descriptor.readOnly && /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                            className: "mp-save-btn pt-new",
                            onClick: ()=>onOpen("new"),
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "add"
                                }),
                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "new_btn", lang)
                            ]
                        })
                    ]
                }),
                hasBulk && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "pt-bulk-actions",
                    children: descriptor.bulkActions.map((a)=>/*#__PURE__*/ (0, $7uT18.jsx)(a.Component, {
                            checked: checked,
                            rows: rows,
                            currentUser: currentUser,
                            onDone: ()=>{
                                this.clearChecked();
                                this.load();
                            }
                        }, a.key))
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "pt-table-area",
                    children: [
                        loading && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "pt-loading-overlay",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-spinner fa-pulse fa-2x fa-fw"
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                            className: "table table-hover",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                        children: [
                                            hasBulk && /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                                className: "pt-check-col"
                                            }),
                                            descriptor.columns.map((c, idx)=>{
                                                const key = c.sort || (c.field === "name" ? "name" : null);
                                                const arrow = key && ordering === key ? " \u2191" : key && ordering === "-" + key ? " \u2193" : "";
                                                return /*#__PURE__*/ (0, $7uT18.jsxs)("th", {
                                                    className: key ? "pt-sortable" : undefined,
                                                    onClick: key ? ()=>this.toggleSort(key) : undefined,
                                                    children: [
                                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, c.label, lang) || c.label,
                                                        key && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pt-sort-arrow",
                                                            children: arrow
                                                        })
                                                    ]
                                                }, c.field || c.label || idx);
                                            }),
                                            deact && /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "f_status", lang)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("tbody", {
                                    children: [
                                        rows.map((row)=>/*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                className: "merch-clickable-row" + (deact && (0, $da70838858bfad8a$export$bb7ceb464758d5fe)(row, deact) ? " pt-row-removed" : ""),
                                                onClick: ()=>onOpen(row.id),
                                                children: [
                                                    hasBulk && /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        className: "pt-check-col",
                                                        onClick: (e)=>e.stopPropagation(),
                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: checked.some((c)=>c.id === row.id),
                                                            onChange: ()=>this.toggleCheck(row)
                                                        })
                                                    }),
                                                    descriptor.columns.map((c, idx)=>/*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                            children: c.format ? c.format(row, lang) : row[c.field]
                                                        }, c.field || c.label || idx)),
                                                    deact && /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "pt-status-pill " + ((0, $da70838858bfad8a$export$bb7ceb464758d5fe)(row, deact) ? "pt-status-removed" : "pt-status-active"),
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, (0, $da70838858bfad8a$export$bb7ceb464758d5fe)(row, deact) ? "inactive" : "active", lang)
                                                        })
                                                    })
                                                ]
                                            }, row.id)),
                                        !loading && rows.length === 0 && /*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                className: "pt-empty",
                                                colSpan: descriptor.columns.length + (hasBulk ? 1 : 0) + (deact ? 1 : 0),
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "empty", lang)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                pages > 1 && /*#__PURE__*/ (0, $7uT18.jsxs)("ul", {
                    className: "pagination",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                            className: page <= 1 ? "disabled" : "",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                onClick: ()=>this.goPage(page - 1),
                                children: "\u2039"
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                            className: "active",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
                                children: [
                                    page,
                                    " / ",
                                    pages
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("li", {
                            className: page >= pages ? "disabled" : "",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                onClick: ()=>this.goPage(page + 1),
                                children: "\u203A"
                            })
                        })
                    ]
                })
            ]
        });
    }
}




function $c92f0e47dd84f4f9$export$2e2bcd8739ae039({ descriptor: descriptor, currentUser: currentUser, history: history }) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "container-fluid",
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "box p-4",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("h2", {
                    className: "pt-list-title",
                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), descriptor.titleKey, currentUser.language)
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $cec7e23dedd0f8c4$export$2e2bcd8739ae039), {
                    descriptor: descriptor,
                    currentUser: currentUser,
                    onOpen: (id)=>history.push(id === "new" ? descriptor.newPath || `/${descriptor.slug}/new` : descriptor.detailPath ? descriptor.detailPath(id) : `/${descriptor.slug}/${id}`)
                })
            ]
        })
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
function $8ab0a5ff7c5b526c$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                className: "mp-form-label",
                children: [
                    field._label,
                    field.required && " *"
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                type: "text",
                className: "mp-form-input",
                value: value ?? "",
                placeholder: field.placeholder || "",
                onChange: (e)=>onChange(field.name, e.target.value)
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
function $2ec2d0e23c24ce52$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                className: "mp-form-label",
                children: [
                    field._label,
                    field.required && " *"
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                type: "number",
                className: "mp-form-input",
                value: value ?? "",
                onChange: (e)=>onChange(field.name, e.target.value === "" ? null : Number(e.target.value))
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
function $c63a8eb75f76f029$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    const display = field.json && value && typeof value !== "string" ? JSON.stringify(value, null, 2) : value ?? "";
    const handle = (e)=>{
        const raw = e.target.value;
        if (!field.json) return onChange(field.name, raw);
        try {
            onChange(field.name, raw ? JSON.parse(raw) : {});
        } catch  {
            onChange(field.name, raw);
        } // keep raw; server validates
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                className: "mp-form-label",
                children: field._label
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("textarea", {
                className: `mp-form-input pt-form-textarea${field.json ? " pt-form-textarea--code" : ""}`,
                rows: 4,
                value: display,
                onChange: handle
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
function $7391c7def2587363$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "mp-form-group pt-checkbox",
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                    type: "checkbox",
                    checked: !!value,
                    onChange: (e)=>onChange(field.name, e.target.checked)
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    children: field._label
                })
            ]
        })
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

function $3f35eb033bcc08a0$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    const opts = field.options || [];
    const selected = opts.find((o)=>o.value === value) || null;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                className: "mp-form-label",
                children: [
                    field._label,
                    field.required && " *"
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $e9e80384c89540c4$export$2e2bcd8739ae039), {
                className: "mp-select",
                options: opts,
                value: selected,
                isClearable: !field.required,
                onChange: (o)=>onChange(field.name, o ? o.value : null)
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

function $bb83f1a52e933cf8$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, item: item = {} }) {
    const handle = (o)=>{
        // isMulti: keep the selected option OBJECTS so EntityDropdown can render their labels
        // on re-render (mapping to bare ids makes its isMulti formatValue produce undefined
        // entries on the next pick). saveItem normalizes objects -> ids before POST/PATCH.
        if (field.isMulti) onChange(field.name, o || []);
        else onChange(field.name, o ? o.id ?? o.value : null);
    };
    // county scope (only applied by EntityDropdown for point/points entities)
    const county = field.scopeBy ? item[field.scopeBy] : undefined;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                className: "mp-form-label",
                children: [
                    field._label,
                    field.required && " *"
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                entity: field.entity,
                value: value,
                isMulti: !!field.isMulti,
                county: county,
                placeholder: field.placeholder,
                onChange: handle
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
const $9ca4377bf068c205$var$toLatLng = (v)=>{
    if (v && (v.latitude !== undefined || v.longitude !== undefined)) return {
        lat: v.latitude,
        lng: v.longitude
    };
    return {
        lng: "",
        lat: ""
    };
};
function $9ca4377bf068c205$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, labels: labels = {} }) {
    const { lat: lat, lng: lng } = $9ca4377bf068c205$var$toLatLng(value);
    const emit = (nextLat, nextLng)=>{
        if (nextLat === "" && nextLng === "") return onChange(field.name, null);
        onChange(field.name, {
            latitude: Number(nextLat),
            longitude: Number(nextLng)
        });
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                className: "mp-form-label",
                children: field._label
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "pt-coord-row",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "number",
                        step: "any",
                        className: "mp-form-input",
                        placeholder: labels.lat,
                        value: lat,
                        onChange: (e)=>emit(e.target.value, lng)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "number",
                        step: "any",
                        className: "mp-form-input",
                        placeholder: labels.lng,
                        value: lng,
                        onChange: (e)=>emit(lat, e.target.value)
                    })
                ]
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

function $b726eec519e5aa1c$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    const opts = field.options || [];
    const selected = opts.filter((o)=>(value || []).includes(o.value));
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                className: "mp-form-label",
                children: field._label
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $e9e80384c89540c4$export$2e2bcd8739ae039), {
                isMulti: true,
                className: "mp-select",
                options: opts,
                value: selected,
                onChange: (list)=>onChange(field.name, (list || []).map((o)=>o.value))
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $3af2dca0564538a0$exports = {};
$3af2dca0564538a0$exports = new URL("marker-icon.3f7d3721.png", import.meta.url).toString();


const $6967b95453f7bc7e$var$LEAFLET_SRC = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
const $6967b95453f7bc7e$var$LEAFLET_INTEGRITY = "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=";
let $6967b95453f7bc7e$var$leafletPromise = null;
function $6967b95453f7bc7e$var$ensureLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if ($6967b95453f7bc7e$var$leafletPromise) return $6967b95453f7bc7e$var$leafletPromise;
    $6967b95453f7bc7e$var$leafletPromise = new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = $6967b95453f7bc7e$var$LEAFLET_SRC;
        script.integrity = $6967b95453f7bc7e$var$LEAFLET_INTEGRITY;
        script.crossOrigin = "";
        script.async = true;
        script.onload = ()=>resolve(window.L);
        script.onerror = (err)=>reject(err);
        document.body.appendChild(script);
    });
    return $6967b95453f7bc7e$var$leafletPromise;
}
class $6967b95453f7bc7e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
    constructor(props){
        super(props);
        this.containerId = `pt-map-${Math.random().toString(36).slice(2)}`;
        this.map = null;
        this.marker = null;
        this._destroyed = false;
    }
    componentDidMount() {
        $6967b95453f7bc7e$var$ensureLeaflet().then((L)=>{
            if (!this._destroyed) this.init(L);
        });
    }
    init(L) {
        const { lat: lat, lng: lng, zoom: zoom = 13, editable: editable } = this.props;
        const center = [
            lat ?? 0,
            lng ?? 0
        ];
        this.L = L;
        this.map = L.map(this.containerId).setView(center, zoom);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        const icon = L.icon({
            iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3af2dca0564538a0$exports))),
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ]
        });
        this.marker = L.marker(center, {
            icon: icon,
            draggable: !!editable
        }).addTo(this.map);
        if (editable) {
            this.marker.on("dragend", ()=>{
                const { lat: newLat, lng: newLng } = this.marker.getLatLng();
                if (this.props.onChange) this.props.onChange({
                    lat: newLat,
                    lng: newLng
                });
            });
            this.map.on("click", (e)=>{
                this.marker.setLatLng(e.latlng);
                if (this.props.onChange) this.props.onChange({
                    lat: e.latlng.lat,
                    lng: e.latlng.lng
                });
            });
        }
        setTimeout(()=>this.map && this.map.invalidateSize(), 0);
    }
    componentDidUpdate(prevProps) {
        const { lat: lat, lng: lng } = this.props;
        if (!this.map || !this.marker) return;
        if (lat === null || lat === undefined || lng === null || lng === undefined) return;
        if (prevProps.lat === lat && prevProps.lng === lng) return;
        this.marker.setLatLng([
            lat,
            lng
        ]);
        this.map.setView([
            lat,
            lng
        ], this.map.getZoom());
    }
    componentWillUnmount() {
        this._destroyed = true;
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
    }
    render() {
        const { height: height = 320 } = this.props;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            id: this.containerId,
            className: "pt-map",
            style: {
                height: height,
                width: "100%"
            }
        });
    }
}




async function $7a4a9b6d201c3830$var$geocodeSearch(query) {
    const url = "https://nominatim.openstreetmap.org/search?format=json&limit=1&q=" + encodeURIComponent(query);
    const res = await fetch(url);
    const results = await res.json();
    return results && results[0] ? results[0] : null;
}
async function $7a4a9b6d201c3830$var$geocodeReverse(lat, lng) {
    const url = "https://nominatim.openstreetmap.org/reverse?format=json&lat=" + lat + "&lon=" + lng;
    const res = await fetch(url);
    return res.json();
}
function $7a4a9b6d201c3830$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, item: item, labels: labels = {}, lang: lang }) {
    const G = (0, $fc3f36407bc5ec6c$export$ac552071080927b0);
    const [searchText, setSearchText] = (0, $cQmXV.useState)(item && item.address || "");
    const [status, setStatus] = (0, $cQmXV.useState)(null);
    const lat = value ? value.latitude : "";
    const lng = value ? value.longitude : "";
    const emitCoords = (nextLat, nextLng)=>{
        if (nextLat === "" && nextLng === "") return onChange(field.name, null);
        onChange(field.name, {
            latitude: Number(nextLat),
            longitude: Number(nextLng)
        });
    };
    const runSearch = async ()=>{
        if (!searchText || !searchText.trim()) return;
        setStatus("searching");
        try {
            const result = await $7a4a9b6d201c3830$var$geocodeSearch(searchText);
            if (result) {
                onChange(field.name, {
                    latitude: Number(result.lat),
                    longitude: Number(result.lon)
                });
                onChange("address", result.display_name);
                setStatus(null);
            } else setStatus("not_found");
        } catch (e) {
            setStatus("not_found");
        }
    };
    const reverseGeocode = async (rLat, rLng)=>{
        try {
            const result = await $7a4a9b6d201c3830$var$geocodeReverse(rLat, rLng);
            if (result && result.display_name) onChange("address", result.display_name);
        } catch (e) {
        // ignore reverse geocode failures, never crash the form
        }
    };
    const handleSearchKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            runSearch();
        }
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                className: "mp-form-label",
                children: field._label
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "pt-loc-search",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        className: "mp-form-input",
                        placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "search_address", lang) || "Search address",
                        value: searchText,
                        onChange: (e)=>setSearchText(e.target.value),
                        onKeyDown: handleSearchKeyDown
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        type: "button",
                        className: "mp-toggle-btn",
                        onClick: runSearch,
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "search_btn", lang) || "Search"
                    })
                ]
            }),
            status && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "pt-loc-status",
                children: status === "searching" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "searching", lang) || "Searching\u2026" : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "not_found", lang) || "Not found"
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "pt-loc-coords",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "number",
                        step: "any",
                        className: "mp-form-input",
                        placeholder: labels.lat,
                        value: lat,
                        onChange: (e)=>emitCoords(e.target.value, lng)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "number",
                        step: "any",
                        className: "mp-form-input",
                        placeholder: labels.lng,
                        value: lng,
                        onChange: (e)=>emitCoords(lat, e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $6967b95453f7bc7e$export$2e2bcd8739ae039), {
                lat: value && value.latitude,
                lng: value && value.longitude,
                zoom: value ? 15 : 6,
                editable: true,
                onChange: ({ lat: newLat, lng: newLng })=>{
                    onChange(field.name, {
                        latitude: newLat,
                        longitude: newLng
                    });
                    setStatus(null);
                    reverseGeocode(newLat, newLng);
                },
                height: 300
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
function $7e7c319001ede09b$var$clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
}
class $7e7c319001ede09b$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.imgRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        this.state = {
            url: URL.createObjectURL(props.file),
            natural: null,
            display: null,
            sel: null,
            drag: null
        };
    }
    componentWillUnmount() {
        if (this.state.url) URL.revokeObjectURL(this.state.url);
    }
    onImgLoad = ()=>{
        const img = this.imgRef.current;
        const display = {
            w: img.clientWidth,
            h: img.clientHeight
        };
        const natural = {
            w: img.naturalWidth,
            h: img.naturalHeight
        };
        // Square selection (1:1), centered, sized to 60% of the shorter side.
        const side = Math.round(Math.min(display.w, display.h) * 0.6);
        this.setState({
            natural: natural,
            display: display,
            sel: {
                x: Math.round((display.w - side) / 2),
                y: Math.round((display.h - side) / 2),
                w: side,
                h: side
            }
        });
    };
    startDrag = (mode, e)=>{
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            drag: {
                mode: mode,
                startX: e.clientX,
                startY: e.clientY,
                orig: {
                    ...this.state.sel
                }
            }
        });
    };
    onMove = (e)=>{
        const { drag: drag, display: display } = this.state;
        if (!drag || !display) return;
        const dx = e.clientX - drag.startX, dy = e.clientY - drag.startY, MIN = 20;
        const o = drag.orig;
        // Move: shift the square within the image bounds (size unchanged).
        if (drag.mode === "move") {
            const x = $7e7c319001ede09b$var$clamp(o.x + dx, 0, display.w - o.w);
            const y = $7e7c319001ede09b$var$clamp(o.y + dy, 0, display.h - o.h);
            this.setState({
                sel: {
                    x: x,
                    y: y,
                    w: o.w,
                    h: o.h
                }
            });
            return;
        }
        // Corner resize: keep a perfect square (1:1). The opposite corner stays fixed,
        // and the side grows/shrinks with the drag, clamped to the image bounds.
        let grow, maxSide;
        if (drag.mode === "se") {
            grow = Math.max(dx, dy);
            maxSide = Math.min(display.w - o.x, display.h - o.y);
        } else if (drag.mode === "nw") {
            grow = Math.max(-dx, -dy);
            maxSide = Math.min(o.x + o.w, o.y + o.h);
        } else if (drag.mode === "ne") {
            grow = Math.max(dx, -dy);
            maxSide = Math.min(display.w - o.x, o.y + o.h);
        } else {
            grow = Math.max(-dx, dy);
            maxSide = Math.min(o.x + o.w, display.h - o.y);
        } // sw
        const side = $7e7c319001ede09b$var$clamp(o.w + grow, MIN, maxSide);
        let x = o.x, y = o.y; // se anchors at top-left
        if (drag.mode === "nw") {
            x = o.x + o.w - side;
            y = o.y + o.h - side;
        } else if (drag.mode === "ne") y = o.y + o.h - side;
        else if (drag.mode === "sw") x = o.x + o.w - side;
        this.setState({
            sel: {
                x: x,
                y: y,
                w: side,
                h: side
            }
        });
    };
    endDrag = ()=>{
        if (this.state.drag) this.setState({
            drag: null
        });
    };
    confirm = ()=>{
        const { natural: natural, display: display, sel: sel } = this.state;
        const sx = sel.x / display.w * natural.w, sy = sel.y / display.h * natural.h;
        const sw = sel.w / display.w * natural.w, sh = sel.h / display.h * natural.h;
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(sw));
        canvas.height = Math.max(1, Math.round(sh));
        canvas.getContext("2d").drawImage(this.imgRef.current, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
        const type = this.props.file.type || "image/png";
        canvas.toBlob((blob)=>{
            const cropped = new File([
                blob
            ], this.props.file.name || "logo.png", {
                type: type
            });
            this.props.onConfirm(cropped);
        }, type, 0.92);
    };
    render() {
        const { url: url, sel: sel } = this.state;
        const L = this.props.labels || {};
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "pt-cropper-overlay",
            role: "dialog",
            "aria-modal": "true",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "pt-cropper",
                onPointerMove: this.onMove,
                onPointerUp: this.endDrag,
                onPointerLeave: this.endDrag,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "pt-cropper-stage",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                ref: this.imgRef,
                                src: url,
                                onLoad: this.onImgLoad,
                                className: "pt-cropper-img",
                                alt: "",
                                draggable: false
                            }),
                            sel && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "pt-cropper-sel",
                                style: {
                                    left: sel.x,
                                    top: sel.y,
                                    width: sel.w,
                                    height: sel.h
                                },
                                onPointerDown: (e)=>this.startDrag("move", e),
                                children: [
                                    "nw",
                                    "ne",
                                    "sw",
                                    "se"
                                ].map((hd)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "pt-cropper-handle pt-cropper-handle-" + hd,
                                        onPointerDown: (e)=>this.startDrag(hd, e)
                                    }, hd))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "pt-cropper-actions",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                type: "button",
                                className: "mp-toggle-btn",
                                onClick: this.props.onCancel,
                                children: L.cropCancel || "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                type: "button",
                                className: "mp-save-btn",
                                onClick: this.confirm,
                                children: L.cropConfirm || "Crop"
                            })
                        ]
                    })
                ]
            })
        });
    }
}


function $28744222778d38c2$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, labels: labels = {} }) {
    const [rawFile, setRawFile] = (0, $cQmXV.useState)(null);
    const isFile = typeof File !== "undefined" && value instanceof File;
    const url = isFile ? URL.createObjectURL(value) : typeof value === "string" && value ? value : null;
    const onPick = (e)=>{
        const f = e.target.files && e.target.files[0];
        if (f) setRawFile(f);
        e.target.value = "";
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                className: "mp-form-label",
                children: field._label
            }),
            url && /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                src: url,
                alt: "",
                className: "pt-image-preview"
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "pt-image-actions",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "file",
                        accept: "image/*",
                        className: "pt-image-input",
                        onChange: onPick
                    }),
                    isFile && /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        type: "button",
                        className: "pt-image-crop",
                        onClick: ()=>setRawFile(value),
                        children: labels.crop || "Crop"
                    }),
                    url && /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        type: "button",
                        className: "pt-image-remove",
                        onClick: ()=>onChange(field.name, ""),
                        children: labels.removeImage || "Remove"
                    })
                ]
            }),
            rawFile && /*#__PURE__*/ (0, $7uT18.jsx)((0, $7e7c319001ede09b$export$2e2bcd8739ae039), {
                file: rawFile,
                labels: labels,
                onConfirm: (cf)=>{
                    onChange(field.name, cf);
                    setRawFile(null);
                },
                onCancel: ()=>{
                    // Cropping is mandatory: cancelling discards the pick and leaves the
                    // current value unchanged — an uncropped file is never uploaded.
                    setRawFile(null);
                }
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


// A simple editor for a JSON object field: rows of { label -> value } that the
// user can add/remove. The stored value is a plain object { key: value }.
const $7c1dda5e4574a6ab$var$toRows = (v)=>v && typeof v === "object" && !Array.isArray(v) ? Object.entries(v).map(([key, value])=>({
            key: key,
            value: value == null ? "" : String(value)
        })) : [];
const $7c1dda5e4574a6ab$var$toObject = (rows)=>rows.reduce((o, r)=>{
        const k = r.key.trim();
        if (k) o[k] = r.value;
        return o;
    }, {});
function $7c1dda5e4574a6ab$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, lang: lang }) {
    const [rows, setRows] = (0, $cQmXV.useState)(()=>$7c1dda5e4574a6ab$var$toRows(value));
    const sync = (next)=>{
        setRows(next);
        onChange(field.name, $7c1dda5e4574a6ab$var$toObject(next));
    };
    const update = (i, key, val)=>sync(rows.map((r, idx)=>idx === i ? {
                ...r,
                [key]: val
            } : r));
    const add = ()=>setRows([
            ...rows,
            {
                key: "",
                value: ""
            }
        ]);
    const remove = (i)=>sync(rows.filter((_, idx)=>idx !== i));
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "pt-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                className: "pt-form-label",
                children: field._label
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "pt-kv",
                children: [
                    rows.map((row, i)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "pt-kv-row",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                    className: "mp-form-input",
                                    placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "kv_key", lang),
                                    value: row.key,
                                    onChange: (e)=>update(i, "key", e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                    className: "mp-form-input",
                                    placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "kv_value", lang),
                                    value: row.value,
                                    onChange: (e)=>update(i, "value", e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    type: "button",
                                    className: "pt-kv-remove",
                                    "aria-label": "remove",
                                    onClick: ()=>remove(i),
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "close"
                                    })
                                })
                            ]
                        }, i)),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        type: "button",
                        className: "pt-kv-add",
                        onClick: add,
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "add"
                            }),
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "kv_add", lang)
                        ]
                    })
                ]
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");
function $6c1a868478667937$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-form-group",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                className: "mp-form-label",
                children: [
                    field._label,
                    field.required && " *"
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                type: "datetime-local",
                className: "mp-form-input",
                value: value ?? "",
                onChange: (e)=>onChange(field.name, e.target.value)
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");



// Shared option lists + i18n keys for the "questions" field type, used by both the edit-mode
// repeater (QuestionsField) and the read-only view (ResourceView) so labels stay in sync.
const $fc5e81b33777a483$export$cfa61bd69ae51266 = [
    "numeric",
    "text",
    "photo",
    "dropdown",
    "date",
    "boolean"
];
const $fc5e81b33777a483$export$81b4e28637de863c = {
    numeric: "answer_numeric",
    text: "answer_text",
    photo: "answer_photo",
    dropdown: "answer_dropdown",
    date: "answer_date",
    boolean: "answer_boolean"
};
const $fc5e81b33777a483$export$19868e2467c966ad = [
    0,
    1,
    2
];
const $fc5e81b33777a483$export$2a8cdb37ef652224 = {
    0: "priority_low",
    1: "priority_medium",
    2: "priority_high"
};
const $fc5e81b33777a483$export$83a015f6589bb8cf = [
    "products",
    "brands",
    "categories",
    "subcategories"
];
const $fc5e81b33777a483$export$4ed51751d1746b72 = {
    products: "mode_products",
    brands: "mode_brands",
    categories: "mode_categories",
    subcategories: "mode_subcategories"
};
const $fc5e81b33777a483$export$be5830653d73dd2d = [
    "all",
    "assortment_matrix"
];
const $fc5e81b33777a483$export$724501524e89eac8 = {
    all: "source_all",
    assortment_matrix: "source_assortment_matrix"
};
const $fc5e81b33777a483$export$69d5f3de0d42532 = [
    {
        key: "products",
        allKey: "all_products",
        entity: "products",
        labelKey: "f_products",
        allLabelKey: "f_all_products"
    },
    {
        key: "brands",
        allKey: "all_brands",
        entity: "brands",
        labelKey: "f_brands",
        allLabelKey: "f_all_brands"
    },
    {
        key: "categories",
        allKey: "all_categories",
        entity: "categories",
        labelKey: "f_categories",
        allLabelKey: "f_all_categories"
    },
    {
        key: "subcategories",
        allKey: "all_subcategories",
        entity: "subcategories",
        labelKey: "f_subcategories",
        allLabelKey: "f_all_subcategories"
    }
];
const $fc5e81b33777a483$export$2941c0a502c64c7f = [
    {
        key: "points",
        entity: "point",
        labelKey: "target_points"
    },
    {
        key: "point_groups",
        entity: "point_groups",
        labelKey: "target_point_groups"
    },
    {
        key: "networks",
        entity: "networks",
        labelKey: "target_networks"
    }
];


// A survey targets exactly one of points / point_groups / networks (enforced server-side).
// This field shows a single target-type selector plus one multi-select for whichever type is
// active, and clears the other two keys on change so the invalid multi-target combination can
// never be produced from this UI. It writes directly into item.points/point_groups/networks
// rather than into its own "audience" key.
const $ab22bdf68594384e$var$hasValue = (v)=>Array.isArray(v) && v.length > 0;
function $ab22bdf68594384e$export$2e2bcd8739ae039({ item: item = {}, onChange: onChange, lang: lang }) {
    const activeKey = ((0, $fc5e81b33777a483$export$2941c0a502c64c7f).find((t)=>$ab22bdf68594384e$var$hasValue(item[t.key])) || (0, $fc5e81b33777a483$export$2941c0a502c64c7f)[0]).key;
    const active = (0, $fc5e81b33777a483$export$2941c0a502c64c7f).find((t)=>t.key === activeKey);
    const setTargetType = (key)=>{
        (0, $fc5e81b33777a483$export$2941c0a502c64c7f).forEach((t)=>onChange(t.key, t.key === key ? item[t.key] || [] : []));
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "pt-audience",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                className: "mp-form-label",
                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "audience_target_type", lang)
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("select", {
                className: "mp-form-input pt-audience-select",
                value: activeKey,
                onChange: (e)=>setTargetType(e.target.value),
                children: (0, $fc5e81b33777a483$export$2941c0a502c64c7f).map((t)=>/*#__PURE__*/ (0, $7uT18.jsx)("option", {
                        value: t.key,
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), t.labelKey, lang)
                    }, t.key))
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                entity: active.entity,
                value: item[active.key] || [],
                isMulti: true,
                onChange: (o)=>onChange(active.key, o || [])
            })
        ]
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");




const $509bf78f41ee3bf0$var$emptyQuestion = ()=>({
        text: "",
        answer_type: "text",
        required: false,
        priority: 0,
        question_mode: null,
        products_source: null,
        all_products: false,
        all_brands: false,
        all_categories: false,
        all_subcategories: false,
        products: [],
        brands: [],
        categories: [],
        subcategories: [],
        dropdown_options: []
    });
const $509bf78f41ee3bf0$var$emptyOption = ()=>({
        label: "",
        value: ""
    });
// EntityDropdown reports selections as option OBJECTS (so labels keep rendering); this repeater
// isn't covered by useResource.js's top-level "entity" field normalization (it only inspects
// descriptor.fields, not values nested inside a "questions" array), so ids are normalized here.
const $509bf78f41ee3bf0$var$toIds = (list)=>(list || []).map((x)=>x && typeof x === "object" ? x.id ?? x.value ?? x : x);
const $509bf78f41ee3bf0$var$withOrder = (list)=>list.map((row, i)=>({
            ...row,
            order: i
        }));
function $509bf78f41ee3bf0$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, lang: lang }) {
    const [questions, setQuestions] = (0, $cQmXV.useState)(()=>value || []);
    const [expandedTargeting, setExpandedTargeting] = (0, $cQmXV.useState)({});
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const sync = (next)=>{
        setQuestions(next);
        onChange(field.name, $509bf78f41ee3bf0$var$withOrder(next));
    };
    const updateQuestion = (qi, patch)=>sync(questions.map((q, idx)=>idx === qi ? {
                ...q,
                ...patch
            } : q));
    const addQuestion = ()=>sync([
            ...questions,
            $509bf78f41ee3bf0$var$emptyQuestion()
        ]);
    const removeQuestion = (qi)=>sync(questions.filter((_, idx)=>idx !== qi));
    const updateOptions = (qi, options)=>updateQuestion(qi, {
            dropdown_options: $509bf78f41ee3bf0$var$withOrder(options)
        });
    const addOption = (qi)=>updateOptions(qi, [
            ...questions[qi].dropdown_options || [],
            $509bf78f41ee3bf0$var$emptyOption()
        ]);
    const removeOption = (qi, oi)=>updateOptions(qi, questions[qi].dropdown_options.filter((_, idx)=>idx !== oi));
    const updateOption = (qi, oi, patch)=>updateOptions(qi, questions[qi].dropdown_options.map((o, idx)=>idx === oi ? {
                ...o,
                ...patch
            } : o));
    const toggleTargeting = (qi)=>setExpandedTargeting((s)=>({
                ...s,
                [qi]: !s[qi]
            }));
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "pt-questions",
        children: [
            !questions.length && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "pt-questions-empty",
                children: t("no_questions")
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "pt-question-list",
                children: questions.map((q, qi)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "pt-question-card",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "pt-question-card-header",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "pt-question-index",
                                        children: qi + 1
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        className: "mp-form-input pt-question-text",
                                        placeholder: t("f_question_text"),
                                        value: q.text,
                                        onChange: (e)=>updateQuestion(qi, {
                                                text: e.target.value
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        type: "button",
                                        className: "pt-kv-remove",
                                        "aria-label": "remove",
                                        onClick: ()=>removeQuestion(qi),
                                        title: t("question_remove_btn"),
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "close"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "pt-question-grid",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "mp-form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                className: "mp-form-label",
                                                children: t("f_answer_type")
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("select", {
                                                className: "mp-form-input",
                                                value: q.answer_type,
                                                onChange: (e)=>updateQuestion(qi, {
                                                        answer_type: e.target.value
                                                    }),
                                                children: (0, $fc5e81b33777a483$export$cfa61bd69ae51266).map((v)=>/*#__PURE__*/ (0, $7uT18.jsx)("option", {
                                                        value: v,
                                                        children: t((0, $fc5e81b33777a483$export$81b4e28637de863c)[v])
                                                    }, v))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "mp-form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                className: "mp-form-label",
                                                children: t("f_priority")
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("select", {
                                                className: "mp-form-input",
                                                value: q.priority,
                                                onChange: (e)=>updateQuestion(qi, {
                                                        priority: Number(e.target.value)
                                                    }),
                                                children: (0, $fc5e81b33777a483$export$19868e2467c966ad).map((v)=>/*#__PURE__*/ (0, $7uT18.jsx)("option", {
                                                        value: v,
                                                        children: t((0, $fc5e81b33777a483$export$2a8cdb37ef652224)[v])
                                                    }, v))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "mp-form-group pt-checkbox",
                                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: !!q.required,
                                                    onChange: (e)=>updateQuestion(qi, {
                                                            required: e.target.checked
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    children: t("f_required")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            q.answer_type === "dropdown" && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "pt-question-subsection",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("h4", {
                                        className: "pt-question-subsection-title",
                                        children: t("f_dropdown_options")
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "pt-kv",
                                        children: [
                                            (q.dropdown_options || []).map((opt, oi)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "pt-kv-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                            className: "mp-form-input",
                                                            placeholder: t("option_label_ph"),
                                                            value: opt.label,
                                                            onChange: (e)=>updateOption(qi, oi, {
                                                                    label: e.target.value
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                            className: "mp-form-input",
                                                            placeholder: t("option_value_ph"),
                                                            value: opt.value,
                                                            onChange: (e)=>updateOption(qi, oi, {
                                                                    value: e.target.value
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                            type: "button",
                                                            className: "pt-kv-remove",
                                                            "aria-label": "remove",
                                                            onClick: ()=>removeOption(qi, oi),
                                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                className: "material-symbols-outlined",
                                                                children: "close"
                                                            })
                                                        })
                                                    ]
                                                }, oi)),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                                type: "button",
                                                className: "pt-kv-add",
                                                onClick: ()=>addOption(qi),
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "material-symbols-outlined",
                                                        children: "add"
                                                    }),
                                                    t("option_add_btn")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "pt-question-subsection",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                        type: "button",
                                        className: "pt-question-subsection-toggle",
                                        onClick: ()=>toggleTargeting(qi),
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "material-symbols-outlined",
                                                children: expandedTargeting[qi] ? "expand_less" : "expand_more"
                                            }),
                                            t("sec_targeting")
                                        ]
                                    }),
                                    expandedTargeting[qi] && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "pt-question-grid",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "mp-form-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                                className: "mp-form-label",
                                                                children: t("f_question_mode")
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("select", {
                                                                className: "mp-form-input",
                                                                value: q.question_mode || "",
                                                                onChange: (e)=>updateQuestion(qi, {
                                                                        question_mode: e.target.value || null
                                                                    }),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("option", {
                                                                        value: "",
                                                                        children: "\u2014"
                                                                    }),
                                                                    (0, $fc5e81b33777a483$export$83a015f6589bb8cf).map((v)=>/*#__PURE__*/ (0, $7uT18.jsx)("option", {
                                                                            value: v,
                                                                            children: t((0, $fc5e81b33777a483$export$4ed51751d1746b72)[v])
                                                                        }, v))
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "mp-form-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                                className: "mp-form-label",
                                                                children: t("f_products_source")
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("select", {
                                                                className: "mp-form-input",
                                                                value: q.products_source || "",
                                                                onChange: (e)=>updateQuestion(qi, {
                                                                        products_source: e.target.value || null
                                                                    }),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("option", {
                                                                        value: "",
                                                                        children: "\u2014"
                                                                    }),
                                                                    (0, $fc5e81b33777a483$export$be5830653d73dd2d).map((v)=>/*#__PURE__*/ (0, $7uT18.jsx)("option", {
                                                                            value: v,
                                                                            children: t((0, $fc5e81b33777a483$export$724501524e89eac8)[v])
                                                                        }, v))
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "pt-question-targeting",
                                                children: (0, $fc5e81b33777a483$export$69d5f3de0d42532).map((grp)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "pt-question-targeting-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                                                className: "pt-checkbox pt-all-toggle",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: !!q[grp.allKey],
                                                                        onChange: (e)=>updateQuestion(qi, {
                                                                                [grp.allKey]: e.target.checked,
                                                                                ...e.target.checked ? {
                                                                                    [grp.key]: []
                                                                                } : {}
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        children: t(grp.allLabelKey)
                                                                    })
                                                                ]
                                                            }),
                                                            !q[grp.allKey] && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                className: "mp-form-group pt-question-entity",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                                        className: "mp-form-label",
                                                                        children: t(grp.labelKey)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                                                        entity: grp.entity,
                                                                        value: q[grp.key] || [],
                                                                        isMulti: true,
                                                                        onChange: (o)=>updateQuestion(qi, {
                                                                                [grp.key]: $509bf78f41ee3bf0$var$toIds(o)
                                                                            })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, grp.key))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, qi))
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                type: "button",
                className: "pt-kv-add pt-question-add",
                onClick: addQuestion,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "add"
                    }),
                    t("question_add_btn")
                ]
            })
        ]
    });
}


const $ae419e9c69a502cf$export$810990d4fe683121 = {
    text: (0, $8ab0a5ff7c5b526c$export$2e2bcd8739ae039),
    number: (0, $2ec2d0e23c24ce52$export$2e2bcd8739ae039),
    textarea: (0, $c63a8eb75f76f029$export$2e2bcd8739ae039),
    checkbox: (0, $7391c7def2587363$export$2e2bcd8739ae039),
    select: (0, $3f35eb033bcc08a0$export$2e2bcd8739ae039),
    entity: (0, $bb83f1a52e933cf8$export$2e2bcd8739ae039),
    coordinate: (0, $9ca4377bf068c205$export$2e2bcd8739ae039),
    chips: (0, $b726eec519e5aa1c$export$2e2bcd8739ae039),
    location: (0, $7a4a9b6d201c3830$export$2e2bcd8739ae039),
    image: (0, $28744222778d38c2$export$2e2bcd8739ae039),
    keyvalue: (0, $7c1dda5e4574a6ab$export$2e2bcd8739ae039),
    datetime: (0, $6c1a868478667937$export$2e2bcd8739ae039),
    audience: (0, $ab22bdf68594384e$export$2e2bcd8739ae039),
    questions: (0, $509bf78f41ee3bf0$export$2e2bcd8739ae039)
};
function $ae419e9c69a502cf$export$49e47a0ff457b5eb(field) {
    switch(field.type){
        case "checkbox":
            return false;
        case "number":
            return null;
        case "chips":
            return [];
        case "entity":
            return field.isMulti ? [] : null;
        case "coordinate":
            return null;
        case "location":
            return null;
        case "image":
            return null;
        case "keyvalue":
            return {};
        case "datetime":
            return "";
        case "audience":
            return null;
        case "questions":
            return [];
        default:
            return "";
    }
}




function $4be72c690417f76e$var$renderField(field, { item: item, errors: errors, onChange: onChange, lang: lang, labels: labels, G: G }) {
    const Renderer = (0, $ae419e9c69a502cf$export$810990d4fe683121)[field.type];
    if (!Renderer) return null;
    const _label = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, field.label, lang) || field.label;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: field.wide ? "pt-form-cell-wide" : undefined,
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)(Renderer, {
                field: {
                    ...field,
                    _label: _label
                },
                value: item[field.name],
                item: item,
                lang: lang,
                labels: labels,
                onChange: onChange,
                error: errors[field.name]
            }),
            errors[field.name] && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "pt-field-error",
                children: errors[field.name]
            })
        ]
    }, field.name);
}
function $4be72c690417f76e$export$2e2bcd8739ae039({ descriptor: descriptor, item: item, errors: errors = {}, onChange: onChange, lang: lang }) {
    const G = (0, $fc3f36407bc5ec6c$export$ac552071080927b0);
    const labels = {
        lat: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "f_lat", lang),
        lng: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "f_lng", lang),
        removeImage: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "remove_image", lang),
        crop: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "crop_confirm", lang),
        cropConfirm: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "crop_confirm", lang),
        cropCancel: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "crop_cancel", lang)
    };
    const ctx = {
        item: item,
        errors: errors,
        onChange: onChange,
        lang: lang,
        labels: labels,
        G: G
    };
    if (Array.isArray(descriptor.sections) && descriptor.sections.length) {
        const fieldsByName = {};
        descriptor.fields.forEach((field)=>{
            fieldsByName[field.name] = field;
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "mp-edit",
            children: descriptor.sections.map((section)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "pt-form-section",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("h3", {
                            className: "pt-form-section-title",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, section.title, lang) || section.title
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "mp-edit-grid",
                            children: section.fields.map((name)=>fieldsByName[name]).filter(Boolean).map((field)=>$4be72c690417f76e$var$renderField(field, ctx))
                        })
                    ]
                }, section.title))
        });
    }
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "mp-edit",
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "mp-edit-grid",
            children: descriptor.fields.map((field)=>$4be72c690417f76e$var$renderField(field, ctx))
        })
    });
}



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");



// Resolve a readable label from an FK/M2M value that may be a full object
// (name, or first/last name for users) or a bare id.
function $369a4a7b38bafb19$var$entityLabel(v) {
    if (v === null || v === undefined) return "";
    if (typeof v !== "object") return String(v);
    if (v.name) return v.name;
    if (v.first_name || v.last_name) return `${v.first_name || ""} ${v.last_name || ""}`.trim();
    return v.label || v.title || (v.id != null ? String(v.id) : "");
}
// Per-entity targeting chips for one survey question ("All products" / "Brands: 3" / …).
function $369a4a7b38bafb19$var$targetingChips(q, lang, G) {
    return (0, $fc5e81b33777a483$export$69d5f3de0d42532).map((grp)=>{
        if (q[grp.allKey]) return (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, grp.allLabelKey, lang);
        if (Array.isArray(q[grp.key]) && q[grp.key].length) return `${(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, grp.labelKey, lang)}: ${q[grp.key].length}`;
        return null;
    }).filter(Boolean);
}
function $369a4a7b38bafb19$var$questionsView(questions, lang, G) {
    if (!Array.isArray(questions) || !questions.length) return "\u2014";
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "pt-questions-view",
        children: questions.map((q, i)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "pt-question-view-card",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "pt-question-view-header",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "pt-question-index",
                                children: i + 1
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "pt-question-view-text",
                                children: q.text || "\u2014"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "pt-chips-view",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "pt-chip",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, (0, $fc5e81b33777a483$export$81b4e28637de863c)[q.answer_type], lang) || q.answer_type
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "pt-chip",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, (0, $fc5e81b33777a483$export$2a8cdb37ef652224)[q.priority], lang)
                            }),
                            q.required && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "pt-chip",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "f_required", lang)
                            }),
                            $369a4a7b38bafb19$var$targetingChips(q, lang, G).map((s, si)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "pt-chip",
                                    children: s
                                }, si))
                        ]
                    }),
                    q.answer_type === "dropdown" && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "pt-chips-view",
                        children: (q.dropdown_options || []).length ? q.dropdown_options.map((o, oi)=>/*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                className: "pt-chip",
                                children: [
                                    o.label,
                                    o.value ? ` (${o.value})` : ""
                                ]
                            }, oi)) : /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "pt-question-view-empty",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "no_dropdown_options", lang)
                        })
                    })
                ]
            }, q.id || i))
    });
}
function $369a4a7b38bafb19$var$audienceView(item, lang, G) {
    const active = (0, $fc5e81b33777a483$export$2941c0a502c64c7f).find((t)=>Array.isArray(item[t.key]) && item[t.key].length);
    if (!active) return "\u2014";
    return `${(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, active.labelKey, lang)}: ${item[active.key].length}`;
}
function $369a4a7b38bafb19$var$display(field, value, lang, item) {
    if (field.type === "questions") return $369a4a7b38bafb19$var$questionsView(value, lang, (0, $fc3f36407bc5ec6c$export$ac552071080927b0));
    if (field.type === "audience") return $369a4a7b38bafb19$var$audienceView(item || {}, lang, (0, $fc3f36407bc5ec6c$export$ac552071080927b0));
    if (value === null || value === undefined || value === "") return "\u2014";
    if (field.type === "checkbox") return value ? "\u2713" : "\u2014";
    if (field.type === "entity") {
        if (Array.isArray(value)) {
            if (!value.length) return "\u2014";
            // If the API returned full objects, list their names; if only ids, show the count.
            if (value.every((it)=>it && typeof it === "object")) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "pt-chips-view",
                children: value.map((it, i)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "pt-chip",
                        children: $369a4a7b38bafb19$var$entityLabel(it)
                    }, it.id != null ? it.id : i))
            });
            return `${value.length}`;
        }
        return $369a4a7b38bafb19$var$entityLabel(value) || "\u2014";
    }
    if (field.type === "coordinate" || field.type === "location") return value.latitude !== undefined && value.longitude !== undefined ? value.latitude + ", " + value.longitude : "\u2014";
    if (field.type === "chips") return (value || []).join(", ") || "\u2014";
    if (field.type === "keyvalue") {
        const entries = value && typeof value === "object" ? Object.entries(value) : [];
        return entries.length ? entries.map(([k, v])=>`${k}: ${v}`).join(", ") : "\u2014";
    }
    if (field.type === "image") return value ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
        src: value,
        className: "pt-image-preview",
        alt: ""
    }) : "\u2014";
    if (field.type === "textarea" && typeof value === "object") {
        const s = JSON.stringify(value);
        return s === "{}" || s === "[]" ? "\u2014" : s;
    }
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}
function $369a4a7b38bafb19$export$2e2bcd8739ae039({ descriptor: descriptor, item: item, lang: lang }) {
    const G = (0, $fc3f36407bc5ec6c$export$ac552071080927b0);
    const Panel = descriptor.detailPanel;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "mp-view",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "mp-view-grid",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "mp-view-info-card",
                    children: descriptor.fields.map((f)=>{
                        // "questions" renders a tall block; stack label-over-value full width
                        // instead of the default label-left / value-right row.
                        const block = f.type === "questions";
                        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "mp-view-info-row" + (block ? " pt-view-block-row" : ""),
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "mp-view-info-label",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, f.label, lang) || f.label
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "mp-view-info-value",
                                    children: $369a4a7b38bafb19$var$display(f, item[f.name], lang, item)
                                })
                            ]
                        }, f.name);
                    })
                })
            }),
            Panel && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "pt-view-panel",
                children: /*#__PURE__*/ (0, $7uT18.jsx)(Panel, {
                    item: item,
                    lang: lang
                })
            })
        ]
    });
}







const $bbfa4fbd0e8cac16$var$seed = (descriptor)=>{
    const item = {};
    descriptor.fields.forEach((f)=>{
        item[f.name] = (0, $ae419e9c69a502cf$export$49e47a0ff457b5eb)(f);
    });
    return item;
};
class $bbfa4fbd0e8cac16$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            mode: "VIEW",
            isNew: false,
            item: {},
            errors: {},
            changed: false,
            saving: false
        };
    }
    get me() {
        return this.props.currentUser || (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
    }
    get lang() {
        return this.me.language;
    }
    get listPath() {
        return "/" + this.props.descriptor.slug;
    }
    componentDidMount() {
        this._isMounted = true;
        const { id: id } = this.props.match.params;
        const { descriptor: descriptor } = this.props;
        if (id === "new") this.setState({
            mode: "EDIT",
            isNew: true,
            item: $bbfa4fbd0e8cac16$var$seed(descriptor)
        });
        else (0, $da70838858bfad8a$export$78af959256a39335)(descriptor, id, (item)=>this.safeSetState({
                item: item || {}
            }));
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    safeSetState = (...args)=>{
        if (this._isMounted) this.setState(...args);
    };
    onChange = (name, value)=>{
        this.setState((s)=>({
                item: {
                    ...s.item,
                    [name]: value
                },
                changed: true,
                errors: {
                    ...s.errors,
                    [name]: undefined
                }
            }));
    };
    submit = ()=>{
        const { descriptor: descriptor } = this.props;
        const { item: item } = this.state;
        const wasNew = !item.id;
        // required-field validation
        const errors = {};
        descriptor.fields.forEach((f)=>{
            if (f.required) {
                const v = item[f.name];
                if (v === null || v === undefined || v === "") errors[f.name] = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "required", this.lang);
            }
        });
        if (Object.keys(errors).length) return this.setState({
            errors: errors
        });
        this.setState({
            saving: true
        });
        (0, $da70838858bfad8a$export$488773977679fb92)(descriptor, item, this.me, (r)=>{
            if (r && r.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "saved", this.lang), {
                    position: "bottom-right"
                });
                this.safeSetState({
                    item: r,
                    mode: "VIEW",
                    isNew: false,
                    changed: false,
                    errors: {},
                    saving: false
                });
                if (wasNew) this.props.history.replace(`${this.listPath}/${r.id}`);
            } else if (r && typeof r.json === "function") (0, $da70838858bfad8a$export$45fc6b2d335e3c39)(r).then((parsed)=>{
                this.safeSetState({
                    errors: parsed.fields
                });
                this.safeSetState({
                    saving: false
                });
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(parsed.message || (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "save_error", this.lang), {
                    position: "bottom-right"
                });
            });
            else {
                this.safeSetState({
                    saving: false
                });
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "save_error", this.lang), {
                    position: "bottom-right"
                });
            }
        });
    };
    remove = ()=>{
        const { descriptor: descriptor } = this.props;
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
        const confirmKey = deact ? "confirm_deactivate" : "confirm_delete";
        if (!window.confirm((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), confirmKey, this.lang))) return;
        if (deact && deact.via === "patch") {
            (0, $da70838858bfad8a$export$43fc4be2c4b87d49)(descriptor, this.state.item.id, {
                [deact.field]: deact.inactiveValue
            }, (r)=>{
                if (r && r.id) {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "deleted", this.lang), {
                        position: "bottom-right"
                    });
                    this.safeSetState({
                        item: r
                    });
                } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "save_error", this.lang), {
                    position: "bottom-right"
                });
            });
            return;
        }
        (0, $da70838858bfad8a$export$8d8542dbbc23fe1a)(descriptor, this.state.item.id, (ok)=>{
            if (ok) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "deleted", this.lang), {
                    position: "bottom-right"
                });
                if (deact) (0, $da70838858bfad8a$export$78af959256a39335)(descriptor, this.state.item.id, (it)=>this.safeSetState({
                        item: it || this.state.item
                    }));
                else this.props.history.replace(this.listPath);
            } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "save_error", this.lang), {
                position: "bottom-right"
            });
        });
    };
    activate = ()=>{
        const { descriptor: descriptor } = this.props;
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
        if (!deact) return;
        (0, $da70838858bfad8a$export$43fc4be2c4b87d49)(descriptor, this.state.item.id, {
            [deact.field]: deact.activeValue
        }, (r)=>{
            if (r && r.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "saved", this.lang), {
                    position: "bottom-right"
                });
                this.safeSetState({
                    item: r
                });
            } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "save_error", this.lang), {
                position: "bottom-right"
            });
        });
    };
    toggleMode = ()=>this.setState((s)=>({
                mode: s.mode === "EDIT" ? "VIEW" : "EDIT"
            }));
    render() {
        const { descriptor: descriptor } = this.props;
        const { item: item, mode: mode, isNew: isNew, errors: errors, saving: saving } = this.state;
        const G = (0, $fc3f36407bc5ec6c$export$ac552071080927b0), lang = this.lang;
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
        const readOnly = descriptor.readOnly === true;
        const editing = mode === "EDIT" && !readOnly;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "container-fluid mp-page",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "mp-top-bar",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                            className: "mp-back-btn",
                            onClick: ()=>this.props.history.replace(this.listPath),
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "arrow_back"
                                }),
                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "back_btn", lang)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "pt-top-actions",
                            children: [
                                !isNew && !readOnly && /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "mp-toggle-btn",
                                    onClick: this.toggleMode,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: mode === "EDIT" ? "visibility" : "edit"
                                        }),
                                        mode === "EDIT" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "view_btn", lang) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "edit_btn", lang)
                                    ]
                                }),
                                !isNew && deact && ((0, $da70838858bfad8a$export$bb7ceb464758d5fe)(item, deact) ? /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "mp-toggle-btn pt-activate-btn",
                                    onClick: this.activate,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "restore"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "activate_btn", lang)
                                    ]
                                }) : /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "mp-toggle-btn pt-delete-btn",
                                    onClick: this.remove,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "delete"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "deactivate_btn", lang)
                                    ]
                                })),
                                !isNew && !deact && /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "mp-toggle-btn pt-delete-btn",
                                    onClick: this.remove,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "delete"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "delete_btn", lang)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "mp-profile-card",
                    children: editing ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $4be72c690417f76e$export$2e2bcd8739ae039), {
                                descriptor: descriptor,
                                item: item,
                                errors: errors,
                                onChange: this.onChange,
                                lang: lang
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "mp-edit-actions",
                                children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: `mp-save-btn${saving ? " mp-save-btn--disabled" : ""}`,
                                    onClick: this.submit,
                                    disabled: this.state.saving,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "save"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(G, "save_btn", lang)
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $369a4a7b38bafb19$export$2e2bcd8739ae039), {
                        descriptor: descriptor,
                        item: item,
                        lang: lang
                    })
                })
            ]
        });
    }
}



var $cQmXV = parcelRequire("cQmXV");
var $eb2083f4ff5cb21c$export$2e2bcd8739ae039 = {
    slug: "networks",
    endpoint: "networks/",
    titleKey: "networks_title",
    columns: [
        {
            label: "f_logo",
            format: (row)=>row.image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("img", {
                    src: row.image,
                    className: "pt-image-thumb",
                    alt: ""
                }) : "\u2014"
        },
        {
            field: "name",
            label: "f_name"
        },
        {
            field: "code",
            label: "f_code"
        }
    ],
    fields: [
        {
            name: "image",
            type: "image",
            label: "f_logo",
            wide: true
        },
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "code",
            type: "text",
            label: "f_code"
        }
    ],
    injectOnCreate: (item, me)=>({
            ...item,
            company: me && me.company ? me.company.id : null
        }),
    softDelete: true
};


var $d76a7d555b424545$export$2e2bcd8739ae039 = {
    slug: "countries",
    endpoint: "countries/",
    titleKey: "countries_title",
    columns: [
        {
            field: "name",
            label: "f_name"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        }
    ],
    injectOnCreate: (item, me)=>({
            ...item,
            company: me && me.company ? me.company.id : null
        }),
    softDelete: true
};


const $d2380bc640409603$var$countyCountry = (row)=>row.country && row.country.name || "\u2014";
var $d2380bc640409603$export$2e2bcd8739ae039 = {
    slug: "counties",
    endpoint: "counties/",
    titleKey: "counties_title",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_country",
            format: $d2380bc640409603$var$countyCountry
        }
    ],
    filters: [
        {
            name: "country",
            entity: "countries"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "country",
            type: "entity",
            entity: "countries",
            label: "f_country",
            required: true
        }
    ],
    softDelete: true
};


const $142d23eb1e534931$var$localityCounty = (row)=>row.county && row.county.name || "\u2014";
var $142d23eb1e534931$export$2e2bcd8739ae039 = {
    slug: "localities",
    endpoint: "localities/",
    titleKey: "localities_title",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_county",
            format: $142d23eb1e534931$var$localityCounty
        }
    ],
    filters: [
        {
            name: "county",
            entity: "county"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "county",
            type: "entity",
            entity: "county",
            label: "f_county",
            required: true
        },
        {
            name: "additional_info",
            type: "keyvalue",
            label: "f_additional_info",
            wide: true
        }
    ],
    softDelete: true
};



const $b7158dc819ea8c2e$var$yesNo = (row)=>row.price_monitoring ? "\u2713" : "\u2014";
var $b7158dc819ea8c2e$export$2e2bcd8739ae039 = {
    slug: "categories",
    endpoint: "categories_point/",
    titleKey: "categories_title",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_price_monitoring",
            format: $b7158dc819ea8c2e$var$yesNo
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "price_monitoring",
            type: "checkbox",
            label: "f_price_monitoring"
        },
        {
            name: "price_monitoring_components",
            type: "chips",
            label: "f_pm_components",
            options: (0, $6f1c09625235f1f0$export$9fa78f64b50a636c)
        },
        {
            name: "price_monitoring_required_components",
            type: "chips",
            label: "f_pm_required",
            options: (0, $6f1c09625235f1f0$export$9fa78f64b50a636c)
        },
        {
            name: "send_to_outforz",
            type: "checkbox",
            label: "f_send_outforz"
        },
        {
            name: "is_auto_approve_price_monitoring_reports",
            type: "checkbox",
            label: "f_auto_approve"
        },
        {
            name: "status_to_send_to_outforz",
            type: "select",
            label: "f_status_outforz",
            options: (0, $6f1c09625235f1f0$export$18af5ff50af8d1b5)
        },
        {
            name: "default_tags",
            type: "entity",
            entity: "tags",
            isMulti: true,
            label: "f_default_tags",
            wide: true
        }
    ],
    injectOnCreate: (item, me)=>({
            ...item,
            company: me && me.company ? me.company.id : null
        })
};



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

function $b766a4766771e97d$export$2e2bcd8739ae039({ item: item, lang: lang }) {
    if (!item || !item.location) return null;
    const { latitude: latitude, longitude: longitude } = item.location;
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $6967b95453f7bc7e$export$2e2bcd8739ae039), {
        lat: latitude,
        lng: longitude,
        zoom: 13,
        editable: false,
        height: 320
    });
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");







var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
function $cec83a254593e541$var$CreateMsgPopup({ setIsMsg: setIsMsg, isMsg: isMsg }) {
    (0, $cQmXV.useEffect)(()=>{
        setTimeout(()=>{
            setIsMsg({
                status: false,
                message: ""
            });
        }, 1500);
    }, []);
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: `custom-error-block s-alert-box s-alert-top s-alert-show s-alert-${isMsg.type === "success" ? "success" : isMsg.type === "error" ? "error" : "warning"}`,
            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "s-alert-box-inner",
                children: isMsg.message
            })
        })
    });
}
var $cec83a254593e541$export$2e2bcd8739ae039 = $cec83a254593e541$var$CreateMsgPopup;




const $15120be802a960f7$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $15120be802a960f7$var$AddGroup({ backToGroupList: backToGroupList, type: type, group: group, updateCheckboxIds: updateCheckboxIds, filterUrlKeys: filterUrlKeys, onAllPointsAdded: onAllPointsAdded, clearPointsTrigger: clearPointsTrigger }) {
    const [activeGroup, setActiveGroup] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({});
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        status: false
    });
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        type: ""
    });
    const [validate, setValidate] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        status: false,
        type: "",
        message: ""
    });
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState("");
    const [submitting, setSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    (0, $cQmXV.useEffect)(()=>{
        if (group && group.id && type === "edit") setActiveGroup((prevGroup)=>{
            return {
                ...group,
                name: prevGroup && prevGroup.name ? prevGroup.name : group.name,
                available_for_supervisors: prevGroup && prevGroup.available_for_supervisors ? prevGroup.available_for_supervisors : group.available_for_supervisors
            };
        });
        else if (group && group.points && group.points.length > 0) setActiveGroup((prev)=>({
                ...prev,
                ...group
            }));
        else if (group && group.points?.length === 0) setActiveGroup((prev)=>({
                ...prev,
                points: group.points
            }));
        else setActiveGroup({});
        setStatus((prev)=>({
                ...prev,
                type: type
            }));
    }, [
        group,
        type
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (activeGroup.points) updateCheckboxIds("edit", activeGroup.points);
    }, [
        activeGroup.points
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (clearPointsTrigger > 0) setActiveGroup((prev)=>({
                ...prev,
                points: []
            }));
    }, [
        clearPointsTrigger
    ]);
    const filteredData = (0, $cQmXV.useMemo)(()=>{
        const lowerCaseQuery = query.toLowerCase().trim();
        if (lowerCaseQuery.length < 3) return activeGroup.points;
        return activeGroup.points?.filter((item)=>item.name.toLowerCase().includes(lowerCaseQuery));
    }, [
        query,
        activeGroup.points
    ]);
    const fetchGroupData = (data, type)=>{
        if (!data && !type) throw new Error("data or type is required");
        const callObject = type === "edit" ? {
            method: "PUT",
            url: "point_groups/" + data?.id + "/",
            post: data
        } : type === "delete" ? {
            method: "DELETE",
            url: "point_groups/" + data?.id + "/"
        } : type === "new" ? {
            method: "POST",
            url: "point_groups/",
            post: data
        } : null;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)(callObject, (response)=>{
            const isSuccess = !!response?.id;
            if (!isSuccess) {
                setSubmitting(false);
                setValidate({
                    status: true,
                    type: "error",
                    message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_error_update_text", $15120be802a960f7$var$me.language)
                });
                throw new Error("Response is not 204", response);
            } else setValidate({
                status: false,
                type: "success",
                message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_success_save_text", $15120be802a960f7$var$me.language)
            });
            setTimeout(()=>{
                backToGroupList();
            }, isSuccess ? 1500 : 500);
        });
    };
    const handleInputNameChange = (e)=>{
        setActiveGroup((prevGroup)=>({
                ...prevGroup,
                name: e.target.value
            }));
        setValidate({
            status: false,
            type: "",
            message: ""
        });
    };
    const onChangeUsersListChange = (name, item)=>{
        const supervisorsIdArray = item.map((s)=>({
                id: s.id,
                name: s?.first_name + " " + s?.last_name
            }));
        setActiveGroup((prevGroup)=>({
                ...prevGroup,
                available_for_supervisors: supervisorsIdArray
            }));
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (submitting) return;
        let updatedData = {};
        if (!activeGroup.name?.trim()) {
            setValidate({
                status: false,
                type: "error",
                message: "new_group_popup_error_text"
            });
            return;
        }
        if (activeGroup.name?.trim().length < 5) {
            setValidate({
                status: false,
                type: "error",
                message: "new_group_popup_error_text_minimum"
            });
            return;
        }
        const supervisorsIdArray = activeGroup.available_for_supervisors?.map((s)=>s.id);
        const pointsIdArray = activeGroup.points?.map((row)=>row.id);
        if (status.type === "edit") updatedData = {
            id: activeGroup.id || "",
            name: activeGroup.name || "",
            available_for_supervisors: supervisorsIdArray || [],
            points: pointsIdArray || []
        };
        else if (status.type === "new") updatedData = {
            name: activeGroup.name || "",
            available_for_supervisors: supervisorsIdArray || [],
            points: pointsIdArray || []
        };
        setSubmitting(true);
        fetchGroupData(updatedData, status.type);
    };
    const getAllPoints = ()=>{
        setLoading({
            status: true
        });
        const params = new URLSearchParams(filterUrlKeys).toString();
        const dynamicUrl = `points/all-points/${params ? `?${params}` : ""}`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: dynamicUrl
        }, (response)=>{
            setActiveGroup((prevGroup)=>({
                    ...prevGroup,
                    points: response.points
                }));
            if (onAllPointsAdded) onAllPointsAdded();
            setLoading({
                status: false
            });
        });
    };
    const removeItemFromGroup = (pointId)=>{
        setActiveGroup((prevGroup)=>({
                ...prevGroup,
                points: prevGroup.points.filter((point)=>point.id !== pointId)
            }));
    };
    const uploadFile = (acceptedFiles)=>{
        let file = acceptedFiles[0];
        if (!file) return;
        const formData = new FormData();
        formData.append("file", file);
        setLoading({
            status: true
        });
        (0, $c9936523dc38c641$export$a3c8e1472dc2ed84)({
            method: "POST",
            url: "point_groups/points-ids-from-file/",
            post: formData
        }, (response)=>{
            if (!!response && response.errors.length > 0) {
                const errortext = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "file_error_uploaded", $15120be802a960f7$var$me.language) + " ( " + response?.errors[0]?.reason + " )";
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(errortext, {
                    position: "top"
                });
            }
            if (response && response.valid_ids && (response.errors.length === 0 || response.failed_count === 0)) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "file_successfully_uploaded", $15120be802a960f7$var$me.language), {
                    position: "top"
                });
                setActiveGroup((prevGroup)=>({
                        ...prevGroup,
                        points: response.valid_ids
                    }));
            }
            setLoading({
                status: false
            });
        });
        setTimeout(()=>{
            setLoading({
                status: false
            });
        }, 5000);
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "ag-wrapper",
        children: [
            validate.status && /*#__PURE__*/ (0, $7uT18.jsx)((0, $cec83a254593e541$export$2e2bcd8739ae039), {
                setIsMsg: setValidate,
                isMsg: validate
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: `ag-field ${validate.type === "error" ? "ag-field--error" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("label", {
                                className: "ag-label",
                                htmlFor: "group-name",
                                children: [
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_field_name", $15120be802a960f7$var$me.language),
                                    "*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                className: "ag-input",
                                value: activeGroup.name || "",
                                onChange: (e)=>handleInputNameChange(e),
                                id: "group-name",
                                type: "text",
                                placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_field_name_placeholder", $15120be802a960f7$var$me.language)
                            }),
                            validate.type === "error" && /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                className: "ag-error-msg",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), validate.message, $15120be802a960f7$var$me.language)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "ag-field",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "ag-points-header",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                        className: "ag-label",
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_field_group_textarea_name", $15120be802a960f7$var$me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        className: "ag-filter-input",
                                        value: query || "",
                                        onChange: (e)=>setQuery(e.target.value),
                                        type: "text",
                                        placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "group_popup_filter_name_placeholder", $15120be802a960f7$var$me.language)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "ag-points-list dddd",
                                children: [
                                    loading.status ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                        loading: loading.status
                                    }) : null,
                                    !filteredData?.length > 0 && activeGroup.points?.length > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                        className: "ag-placeholder",
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "group_popup_filter_name_empty_placeholder", $15120be802a960f7$var$me.language)
                                    }),
                                    filteredData?.map((point)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "ag-point-chip",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "ag-point-chip-label",
                                                    children: point.name
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                    type: "button",
                                                    className: "ag-point-chip-remove",
                                                    onClick: ()=>removeItemFromGroup(point.id),
                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "material-symbols-outlined",
                                                        children: "close"
                                                    })
                                                })
                                            ]
                                        }, point.id)),
                                    !activeGroup.points?.length > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "ag-dropzone-block",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $c89956014bc8c37c$export$2e2bcd8739ae039), {
                                            onDrop: (acceptedFiles)=>uploadFile(acceptedFiles),
                                            accept: "text/csv, .csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsx",
                                            multiple: false,
                                            children: ({ getRootProps: getRootProps, getInputProps: getInputProps })=>/*#__PURE__*/ (0, $7uT18.jsx)("section", {
                                                    className: "dropzone",
                                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        ...getRootProps(),
                                                        className: "dropzone-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                                ...getInputProps()
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "import_group_dragdrop_label", $15120be802a960f7$var$me.language)
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                                className: "approve-file",
                                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "import_group_dragdrop_approve_file_text", $15120be802a960f7$var$me.language)
                                                            })
                                                        ]
                                                    })
                                                })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "ag-points-footer",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                        className: "ag-counter",
                                        children: [
                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "added_points_text_label_suf", $15120be802a960f7$var$me.language) + " ",
                                            filteredData?.length > 0 ? filteredData.length : 0,
                                            " " + (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "added_points_text_label_pref", $15120be802a960f7$var$me.language)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                        type: "button",
                                        className: "ag-add-all-btn",
                                        onClick: getAllPoints,
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "material-symbols-outlined",
                                                children: "playlist_add"
                                            }),
                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_field_group_add_all_btn_text", $15120be802a960f7$var$me.language)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "ag-field ag-field--users",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                className: "ag-label",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_field_group_available_users", $15120be802a960f7$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                entity: "created_by",
                                value: activeGroup.available_for_supervisors,
                                onChange: (o)=>{
                                    onChangeUsersListChange("users", o);
                                },
                                placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_field_users_placeholder", $15120be802a960f7$var$me.language),
                                className: "react-dropdown-container--multiselect",
                                isMulti: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "ag-actions",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                type: "submit",
                                className: "ag-save-btn",
                                disabled: validate.type === "error" || submitting,
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "save"
                                    }),
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_btn_save_name", $15120be802a960f7$var$me.language)
                                ]
                            }),
                            validate.type === "success" && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                className: "ag-success-msg",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "check_circle"
                                    }),
                                    validate.message
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $15120be802a960f7$export$2e2bcd8739ae039 = $15120be802a960f7$var$AddGroup;







const $ac04f6f1df40ac34$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $ac04f6f1df40ac34$var$Grouping({ isActive: isActive = false, handleGroupPopup: handleGroupPopup, checkedRowsIds: checkedRowsIds = [], getCurrentGroupData: getCurrentGroupData, filterUrlKeys: filterUrlKeys, onAllPointsAdded: onAllPointsAdded, clearPointsTrigger: clearPointsTrigger }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        points: [],
        loading: false
    });
    const [group, setGroup] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        activeGroup: {},
        loading: false
    });
    const [selectedGroupType, setSelectedGroupType] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        type: "list"
    });
    const [isMsgStatus, setIsMsgStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        status: false,
        type: "error",
        message: ""
    });
    (0, $cQmXV.useEffect)(()=>{
        if (!isActive) return;
        let isMounted = true;
        getPointGroupList(isMounted);
        return ()=>{
            isMounted = false;
        };
    }, [
        isActive
    ]);
    (0, $cQmXV.useEffect)(()=>{
        setGroup((prev)=>({
                ...prev,
                activeGroup: {
                    ...prev.activeGroup,
                    points: checkedRowsIds
                }
            }));
    }, [
        checkedRowsIds
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (selectedGroupType.type === "clone") {
            setSelectedGroupType({
                type: "new"
            });
            getCurrentGroupData("new", group.activeGroup.points);
        }
    }, [
        group.activeGroup
    ]);
    const userValidation = (createdBy)=>{
        return $ac04f6f1df40ac34$var$me.id === createdBy || $ac04f6f1df40ac34$var$me.role === "supervisor_manager" ? true : false;
    };
    const getPointGroupList = (isMounted = true)=>{
        setState((prev)=>({
                ...prev,
                loading: true
            }));
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "point_groups/"
        }, (response)=>{
            if (!isMounted) return;
            setState((prev)=>({
                    ...prev,
                    points: response.results,
                    loading: false
                }));
        });
    };
    const fetchPointGroupById = (id, method, options)=>{
        if (!id && !method) throw new Error("id or type is required");
        //check user access
        if (method === "DELETE" && !userValidation(options.author_id) || !userValidation(options.author_id) && options.type === "edit") {
            setIsMsgStatus({
                status: true,
                type: "error",
                message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_user_validate_error_text", $ac04f6f1df40ac34$var$me.language)
            });
            return;
        }
        if (method === "GET") setGroup((prev)=>({
                ...prev,
                loading: true
            }));
        // end check user access
        if (method === "GET") setGroup((prev)=>({
                ...prev,
                loading: true
            }));
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: method,
            url: "point_groups/" + id + "/"
        }, (response)=>{
            if (method === "GET") {
                const type = options?.operation && options?.operation === "clone" ? "clone" : "edit";
                setGroup((prev)=>({
                        ...prev,
                        activeGroup: {
                            ...response,
                            name: `${response.name}${type === "clone" ? " (clone)" : ""}`
                        },
                        loading: false
                    }));
                setSelectedGroupType({
                    type: type
                });
                if (response.points && type === "edit") getCurrentGroupData("edit", response.points);
                else if (response.points && type === "clone") getCurrentGroupData("new", response.points);
            } else if (method === "DELETE") {
                if (response.status === 204) {
                    setSelectedGroupType({
                        type: "list"
                    });
                    getPointGroupList();
                    setIsMsgStatus({
                        status: true,
                        type: "success",
                        message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_success_deleted_text", $ac04f6f1df40ac34$var$me.language)
                    });
                } else {
                    setIsMsgStatus({
                        status: true,
                        type: "error",
                        message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_failed_deleted_text", $ac04f6f1df40ac34$var$me.language)
                    });
                    throw new Error("Response is not 204", response);
                }
            }
        });
    };
    const handleEdit = (id, created_by)=>{
        fetchPointGroupById(id, "GET", {
            author_id: created_by,
            type: "edit"
        });
    };
    const handleCopy = (id)=>{
        fetchPointGroupById(id, "GET", {
            operation: "clone"
        });
    };
    const handleDelete = (id, created_by)=>{
        const confirmed = window.confirm((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_delete_approve_text", $ac04f6f1df40ac34$var$me.language));
        if (confirmed) fetchPointGroupById(id, "DELETE", {
            author_id: created_by
        });
    };
    const handleNewGroup = ()=>{
        setSelectedGroupType({
            type: "new"
        });
        getCurrentGroupData("new", []);
        setGroup({
            activeGroup: {},
            loading: false
        });
    };
    const handleBackToGroupList = ()=>{
        setSelectedGroupType({
            type: "list"
        });
        getCurrentGroupData("list", []);
        getPointGroupList();
    };
    const handleClose = ()=>{
        handleGroupPopup(false);
        handleBackToGroupList();
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
        children: [
            isMsgStatus.status && /*#__PURE__*/ (0, $7uT18.jsx)((0, $cec83a254593e541$export$2e2bcd8739ae039), {
                setIsMsg: setIsMsgStatus,
                isMsg: isMsgStatus
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: `grouping-popup-wrapper ${isActive ? "active" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        className: "gp-close-btn",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "material-symbols-outlined",
                            children: "close"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: `gp-header ${selectedGroupType.type !== "list" ? "gp-header--inner" : ""}`,
                        children: [
                            selectedGroupType.type !== "list" && /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                className: "gp-back-btn",
                                onClick: handleBackToGroupList,
                                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "arrow_back"
                                })
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("h3", {
                                className: "gp-title",
                                children: selectedGroupType.type === "new" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_new_title", $ac04f6f1df40ac34$var$me.language) : selectedGroupType.type === "edit" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_popup_edit_title", $ac04f6f1df40ac34$var$me.language) : selectedGroupType.type === "list" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "grouping_popup_title", $ac04f6f1df40ac34$var$me.language) : "Undefined Status"
                            }),
                            selectedGroupType.type === "list" && /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                className: "gp-new-btn",
                                onClick: handleNewGroup,
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "add"
                                    }),
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "new_group_btn_name", $ac04f6f1df40ac34$var$me.language)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "gp-content-scroll",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "gp-content",
                            children: state.loading || group.loading ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                loading: state.loading || group.loading
                            }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                children: [
                                    selectedGroupType.type === "list" && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "gp-list",
                                        children: state.points?.map((point)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "gp-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "gp-item-info",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                className: "gp-item-id",
                                                                children: [
                                                                    "#",
                                                                    point.id
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                className: "gp-item-name",
                                                                children: point.name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "gp-item-actions",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                className: "gp-item-btn gp-item-btn--edit",
                                                                onClick: ()=>handleEdit(point.id, point.created_by?.id),
                                                                title: "Edit",
                                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined",
                                                                    children: "edit"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                className: "gp-item-btn gp-item-btn--copy",
                                                                onClick: ()=>handleCopy(point.id),
                                                                title: "Clone",
                                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined",
                                                                    children: "content_copy"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                                className: "gp-item-btn gp-item-btn--delete",
                                                                onClick: ()=>handleDelete(point.id, point.created_by?.id),
                                                                title: "Delete",
                                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined",
                                                                    children: "delete"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, point.id))
                                    }),
                                    selectedGroupType.type !== "list" && /*#__PURE__*/ (0, $7uT18.jsx)((0, $15120be802a960f7$export$2e2bcd8739ae039), {
                                        backToGroupList: handleBackToGroupList,
                                        type: selectedGroupType.type,
                                        group: group.activeGroup,
                                        updateCheckboxIds: getCurrentGroupData,
                                        filterUrlKeys: filterUrlKeys,
                                        onAllPointsAdded: onAllPointsAdded,
                                        clearPointsTrigger: clearPointsTrigger
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $ac04f6f1df40ac34$export$2e2bcd8739ae039 = $ac04f6f1df40ac34$var$Grouping;




function $45d48ce51ec76860$export$2e2bcd8739ae039({ checked: checked, rows: rows, currentUser: currentUser, onDone: onDone }) {
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const [clearPointsTrigger, setClearPointsTrigger] = (0, $cQmXV.useState)(0);
    const checkedRowsIds = checked;
    const handleGroupPopup = ()=>{
        setOpen((prev)=>{
            const next = !prev;
            if (!next) {
                // popup closed: reset and let the table refresh
                setClearPointsTrigger((t)=>t + 1);
                if (onDone) onDone();
            }
            return next;
        });
    };
    const getCurrentGroupData = ()=>{};
    return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                className: "mp-toggle-btn pt-bulk-btn",
                disabled: checked.length === 0,
                onClick: handleGroupPopup,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "workspaces"
                    }),
                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "grouping_btn_name", currentUser.language)
                ]
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $ac04f6f1df40ac34$export$2e2bcd8739ae039), {
                isActive: open,
                handleGroupPopup: handleGroupPopup,
                checkedRowsIds: checkedRowsIds,
                getCurrentGroupData: getCurrentGroupData,
                filterUrlKeys: {},
                onAllPointsAdded: ()=>{},
                clearPointsTrigger: clearPointsTrigger
            })
        ]
    });
}



var $557b82e5c7a8bf8a$export$2e2bcd8739ae039 = {
    slug: "points",
    endpoint: "points/",
    titleKey: "points_title",
    columns: [
        {
            label: "f_network",
            format: (row)=>(0, $b79edb411f97c469$export$c2dc1fe4fd2f6ef2)(null, row)
        },
        {
            field: "name",
            label: "f_name"
        },
        {
            field: "address",
            label: "f_address"
        },
        {
            field: "code",
            label: "f_code"
        },
        {
            label: "f_locality",
            format: (row)=>(0, $b79edb411f97c469$export$2a939cfc6449d94d)(null, row)
        }
    ],
    filters: [
        {
            name: "network",
            entity: "network"
        },
        {
            name: "locality__county",
            entity: "county"
        },
        {
            name: "locality",
            entity: "locality",
            scopeBy: "locality__county"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "code",
            type: "text",
            label: "f_code"
        },
        {
            name: "address",
            type: "text",
            label: "f_address",
            wide: true
        },
        {
            name: "network",
            type: "entity",
            entity: "network",
            label: "f_network"
        },
        {
            name: "category",
            type: "entity",
            entity: "categories_point",
            label: "f_category"
        },
        {
            name: "locality",
            type: "entity",
            entity: "locality",
            label: "f_locality"
        },
        {
            name: "location",
            type: "location",
            label: "f_location",
            wide: true
        },
        {
            name: "minutes_recommended",
            type: "number",
            label: "f_minutes"
        },
        {
            name: "responsible_merchandiser",
            type: "entity",
            entity: "merchandiser",
            label: "f_merchandiser"
        },
        {
            name: "responsible_supervisors",
            type: "entity",
            entity: "supervisor",
            isMulti: true,
            label: "f_supervisors"
        },
        {
            name: "is_active",
            type: "checkbox",
            label: "f_is_active"
        },
        {
            name: "is_available_for_task_creation",
            type: "checkbox",
            label: "f_available_tasks"
        }
    ],
    sections: [
        {
            title: "sec_basic",
            fields: [
                "name",
                "code",
                "network",
                "category"
            ]
        },
        {
            title: "sec_location",
            fields: [
                "address",
                "locality",
                "location"
            ]
        },
        {
            title: "sec_assignment",
            fields: [
                "responsible_merchandiser",
                "responsible_supervisors"
            ]
        },
        {
            title: "sec_options",
            fields: [
                "minutes_recommended",
                "is_active",
                "is_available_for_task_creation"
            ]
        }
    ],
    detailPanel: (0, $b766a4766771e97d$export$2e2bcd8739ae039),
    bulkActions: [
        {
            key: "grouping",
            Component: (0, $45d48ce51ec76860$export$2e2bcd8739ae039)
        }
    ],
    softDelete: true
};



var $138b5278448c8637$export$2e2bcd8739ae039 = {
    slug: "point_groups",
    endpoint: "point_groups/",
    titleKey: "point_groups_title",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_created_by",
            format: (row)=>row.created_by ? (0, $b79edb411f97c469$export$99f62f7c9ad8c7ce)(null, row) : "\u2014"
        }
    ],
    filters: [
        {
            name: "created_by",
            type: "me",
            label: "filter_created_by_me"
        },
        {
            name: "available_for_supervisors",
            entity: "created_by",
            label: "f_available_supervisors"
        },
        {
            name: "points",
            entity: "point",
            label: "f_points"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "available_for_supervisors",
            type: "entity",
            entity: "created_by",
            isMulti: true,
            label: "f_available_supervisors",
            wide: true
        },
        {
            name: "points",
            type: "entity",
            entity: "point",
            isMulti: true,
            label: "f_points",
            wide: true
        }
    ],
    softDelete: true
};



var $f385a83456e8df3b$export$2e2bcd8739ae039 = {
    slug: "merchandisers",
    endpoint: "merchandisers/",
    titleKey: "merchandisers_title",
    defaultOrdering: "first_name",
    columns: [
        {
            label: "f_name",
            format: (row)=>(0, $b79edb411f97c469$export$c86d3ca66f38ed60)(null, row),
            sort: "first_name"
        },
        {
            field: "phone_number",
            label: "f_phone"
        },
        {
            label: "f_movement",
            format: (row)=>(0, $b79edb411f97c469$export$c1c72f42e43ef7e9)(null, row)
        }
    ],
    deactivation: {
        field: "is_active",
        activeValue: true,
        via: "patch"
    },
    // detail + create stay in the existing rich merchandiser module:
    detailPath: (id)=>`/merchandiser/${id}`,
    newPath: "/merchandiser/new"
};



var $fb0bbfe211d2dc0d$export$2e2bcd8739ae039 = {
    slug: "supervisors",
    endpoint: "supervisors/",
    titleKey: "supervisors_title",
    defaultOrdering: "first_name",
    readOnly: true,
    columns: [
        {
            label: "f_name",
            format: (row)=>(0, $b79edb411f97c469$export$c86d3ca66f38ed60)(null, row),
            sort: "first_name"
        },
        {
            field: "phone_number",
            label: "f_phone"
        }
    ],
    deactivation: {
        field: "is_active",
        activeValue: true,
        via: "patch"
    },
    // read-only detail view (no editing) — shown by ResourceView; activate/deactivate available
    fields: [
        {
            name: "first_name",
            type: "text",
            label: "f_first_name"
        },
        {
            name: "last_name",
            type: "text",
            label: "f_last_name"
        },
        {
            name: "phone_number",
            type: "text",
            label: "f_phone"
        }
    ]
};



var $Yxlsx = parcelRequire("Yxlsx");
const $082b55e2d33186f5$var$fmtDate = (v)=>v ? (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(v).format("DD.MM.yyyy HH:mm") : "\u2014";
var $082b55e2d33186f5$export$2e2bcd8739ae039 = {
    slug: "surveys",
    endpoint: "surveys/",
    titleKey: "surveys_title",
    columns: [
        {
            field: "title",
            label: "f_title"
        },
        {
            label: "f_active_from",
            format: (row)=>$082b55e2d33186f5$var$fmtDate(row.active_from)
        },
        {
            label: "f_active_to",
            format: (row)=>$082b55e2d33186f5$var$fmtDate(row.active_to)
        }
    ],
    fields: [
        {
            name: "title",
            type: "text",
            label: "f_title",
            required: true
        },
        {
            name: "description",
            type: "textarea",
            label: "f_description",
            wide: true
        },
        {
            name: "active_from",
            type: "datetime",
            label: "f_active_from",
            required: true
        },
        {
            name: "active_to",
            type: "datetime",
            label: "f_active_to",
            required: true
        },
        {
            name: "form_organization_mode",
            type: "select",
            label: "f_form_organization_mode",
            options: [
                {
                    value: "products",
                    label: "Products"
                },
                {
                    value: "brands",
                    label: "Brands"
                },
                {
                    value: "categories",
                    label: "Categories"
                },
                {
                    value: "subcategories",
                    label: "Subcategories"
                }
            ]
        },
        {
            name: "audience",
            type: "audience",
            label: "f_audience",
            wide: true
        },
        {
            name: "questions",
            type: "questions",
            label: "f_questions",
            wide: true
        }
    ],
    sections: [
        {
            title: "sec_basic",
            fields: [
                "title",
                "description"
            ]
        },
        {
            title: "sec_schedule",
            fields: [
                "active_from",
                "active_to",
                "form_organization_mode"
            ]
        },
        {
            title: "sec_audience",
            fields: [
                "audience"
            ]
        },
        {
            title: "sec_questions",
            fields: [
                "questions"
            ]
        }
    ],
    softDelete: true
};


const $beba70bdcd76b688$export$4e841128923ef26 = {
    networks: $eb2083f4ff5cb21c$export$2e2bcd8739ae039,
    countries: $d76a7d555b424545$export$2e2bcd8739ae039,
    counties: $d2380bc640409603$export$2e2bcd8739ae039,
    localities: $142d23eb1e534931$export$2e2bcd8739ae039,
    categories: $b7158dc819ea8c2e$export$2e2bcd8739ae039,
    points: $557b82e5c7a8bf8a$export$2e2bcd8739ae039,
    point_groups: $138b5278448c8637$export$2e2bcd8739ae039,
    merchandisers: $f385a83456e8df3b$export$2e2bcd8739ae039,
    supervisors: $fb0bbfe211d2dc0d$export$2e2bcd8739ae039,
    surveys: $082b55e2d33186f5$export$2e2bcd8739ae039
};
function $beba70bdcd76b688$export$dd068f9289a3efeb(slug) {
    return $beba70bdcd76b688$export$4e841128923ef26[slug];
}



function $e3e209289ea60a84$export$5636abe024a9e6a3(slug) {
    return function Bound(props) {
        return /*#__PURE__*/ (0, $7uT18.jsx)((0, $c92f0e47dd84f4f9$export$2e2bcd8739ae039), {
            descriptor: (0, $beba70bdcd76b688$export$dd068f9289a3efeb)(slug),
            ...props
        });
    };
}
function $e3e209289ea60a84$export$fd0f57f0ca46c3d2(slug) {
    return function Bound(props) {
        return /*#__PURE__*/ (0, $7uT18.jsx)((0, $bbfa4fbd0e8cac16$export$2e2bcd8739ae039), {
            descriptor: (0, $beba70bdcd76b688$export$dd068f9289a3efeb)(slug),
            ...props
        });
    };
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");









class $464b3d7a8ec63582$var$Edit extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            item: {
                first_name: "",
                last_name: "",
                email: "",
                county: "",
                telegram_id: "",
                position: ""
            },
            imgError: false
        };
    }
    static contextType = (0, $422de08ffd33db6b$export$214e5fb64d34c1fc);
    componentDidMount() {
        const { item: item } = this.state;
        const { me: me } = this.props;
        this.setState({
            item: {
                ...item,
                ...me
            }
        });
    }
    onChange = (property, value)=>{
        this.setState((prev)=>({
                item: {
                    ...prev.item,
                    [property]: value
                }
            }));
    };
    translate = (name)=>{
        const lang = this.state.item.language;
        return (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), name, lang);
    };
    submit = ()=>{
        const { dispatch: dispatch } = this.props;
        const { item: item } = this.state;
        // Work on a shallow copy so we never mutate state
        const payload = {
            ...item
        };
        // Strip photo — not editable here
        delete payload.photo;
        // Always send county as a plain ID (it may be a full object if unchanged)
        if (payload.county && typeof payload.county === "object") payload.county = payload.county.id || null;
        if (!payload.county) delete payload.county;
        const prevLanguage = this.props.me.language;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PUT",
            url: "users/" + payload.id + "/",
            post: payload
        }, (r)=>{
            if (r && r.id) {
                dispatch((0, $cca4416321e611bf$export$953a134f6e0e87ac)({
                    ...this.props.me,
                    ...r
                }));
                if (r.language !== prevLanguage) {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(this.translate("save_success_reload"), {
                        position: "bottom-right",
                        timeout: 1000
                    });
                    setTimeout(()=>window.location.reload(), 250);
                } else {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(this.translate("save_success"), {
                        position: "bottom-right"
                    });
                    this.context.updateLangFn();
                }
            } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving. " + JSON.stringify(r), {
                position: "bottom-right"
            });
        });
    };
    render() {
        const { item: item, imgError: imgError } = this.state;
        const fullName = `${item.first_name || ""} ${item.last_name || ""}`.trim();
        const roleLabel = item.role === "supervisor_manager" ? "Supervisor Manager" : item.role === "supervisor" ? "Supervisor" : item.role || "";
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "md-profile-page",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "md-profile-card",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "md-profile-hero",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "md-profile-avatar",
                                children: item.photo && !imgError ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                    src: item.photo,
                                    alt: fullName,
                                    onError: ()=>this.setState({
                                            imgError: true
                                        })
                                }) : /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "md-nav-icon md-profile-avatar-icon",
                                    children: "person"
                                })
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "md-profile-fullname",
                                children: fullName || "\u2014"
                            }),
                            roleLabel && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "md-profile-role-badge",
                                children: roleLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "md-profile-form",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-profile-row",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "md-profile-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                className: "md-profile-label",
                                                children: this.translate("name")
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                type: "text",
                                                className: "md-profile-input",
                                                placeholder: this.translate("name"),
                                                value: item.first_name || "",
                                                onChange: (e)=>this.onChange("first_name", e.target.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "md-profile-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                className: "md-profile-label",
                                                children: this.translate("surname")
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                type: "text",
                                                className: "md-profile-input",
                                                placeholder: this.translate("surname"),
                                                value: item.last_name || "",
                                                onChange: (e)=>this.onChange("last_name", e.target.value)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                        className: "md-profile-label",
                                        children: this.translate("position")
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        type: "text",
                                        className: "md-profile-input",
                                        placeholder: this.translate("position"),
                                        value: item.position || "",
                                        onChange: (e)=>this.onChange("position", e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                        className: "md-profile-label",
                                        children: this.translate("my_region")
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                        entity: "county",
                                        value: item.county && item.county.id ? item.county.id : item.county,
                                        onChange: (e)=>this.onChange("county", e?.id)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                        className: "md-profile-label",
                                        children: this.translate("telegram")
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        type: "text",
                                        className: "md-profile-input",
                                        placeholder: "@username",
                                        value: item.telegram_id || "",
                                        onChange: (e)=>this.onChange("telegram_id", e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                        className: "md-profile-label",
                                        children: this.translate("language")
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                        entity: "language",
                                        id: item.id ? item.id : null,
                                        value: item.id && item.language ? item.language : 1,
                                        onChange: (e)=>this.onChange("language", e?.code)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "md-profile-actions",
                                children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "btn btn-primary md-profile-save-btn",
                                    onClick: ()=>this.submit(),
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-nav-icon",
                                            style: {
                                                fontSize: "20px"
                                            },
                                            children: "save"
                                        }),
                                        this.translate("save")
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}
var $464b3d7a8ec63582$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($464b3d7a8ec63582$var$Edit));



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");




class $cd7d87f1cc671f57$var$List extends (0, $cQmXV.Component) {
    open = (id, item)=>{
    // return <a href="#" className="btn btn-sm btn-outline-primary"> <i className='fa fa-external-link can_open' /> View </a>
    };
    render() {
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "box px-4 py-1",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("h5", {
                        className: "mt-3 mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                className: "faIcon",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                        className: "fa fa-route"
                                    }),
                                    " "
                                ]
                            }),
                            " ",
                            "Routes"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "box p-4",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $81b6b064afbc82da$export$2e2bcd8739ae039), {
                        entity: "route",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataField: "id",
                                dataFormat: this.open,
                                isKey: true,
                                width: "82px"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$7f6290e025a69ad2),
                                children: "Merchandiser"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$d2d39d1adcc883a2),
                                children: "Day"
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$ae8c54d47e00baf9),
                                children: "Amount of points"
                            })
                        ]
                    })
                })
            ]
        });
    }
}
var $cd7d87f1cc671f57$export$2e2bcd8739ae039 = $cd7d87f1cc671f57$var$List;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");





var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");
class $7b1c3823ce6be8c8$var$Edit extends (0, $cQmXV.Component) {
    render() {
        let { item: item } = this.props;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "row m-t",
            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "col-md-12",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "box boxEdit",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "box-body",
                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("form", {
                            role: "form",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            children: "Title"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "form-control",
                                            placeholder: "",
                                            value: item && item.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            children: "Start"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "form-control",
                                            placeholder: "",
                                            value: item && item.start
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            children: "End"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "form-control",
                                            placeholder: "",
                                            value: item && item.end
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                            children: "Day of the week"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "text",
                                            className: "form-control",
                                            placeholder: "",
                                            value: item && item.day_of_the_week
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "btn btn-primary white m-b",
                                    onClick: ()=>this.submit(),
                                    children: "Save changes"
                                })
                            ]
                        })
                    })
                })
            })
        });
    }
}
var $7b1c3823ce6be8c8$export$2e2bcd8739ae039 = $7b1c3823ce6be8c8$var$Edit;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


class $8222b7ab80d0f0ed$var$View extends (0, $cQmXV.Component) {
    render() {
        let { item: item } = this.props;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "row m-t",
            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "col-sm-12",
                children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "clear m-b",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("h4", {
                            className: "m-0 m-b-xs",
                            children: item && item.title
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("h4", {
                            className: "m-0 m-b-xs",
                            children: item && item.subtitle
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("p", {
                            className: "text-muted",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("small", {
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                            className: "fa fa-calendar m-r-xs"
                                        }),
                                        "Star: ",
                                        item && (0, $b79edb411f97c469$export$1718d4b40b6ea71e)("", item)
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, $7uT18.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("small", {
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                            className: "fa fa-calendar m-r-xs"
                                        }),
                                        "End: ",
                                        item && (0, $b79edb411f97c469$export$450de2dd43fb03)("", item)
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, $7uT18.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                    className: "m-r",
                                    children: [
                                        "Day of the week: ",
                                        item && (0, $6f1c09625235f1f0$export$3241045aa1844a20)[item.day_of_the_week]
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
}
var $8222b7ab80d0f0ed$export$2e2bcd8739ae039 = $8222b7ab80d0f0ed$var$View;


class $982a478d060e3bae$var$Page extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            mode: "VIEW"
        };
    }
    componentDidMount() {
        const { id: id } = this.props.match.params;
        if (id !== "new") this.load(id);
        else this.setState({
            mode: "EDIT"
        });
    }
    load = (id)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "routes/" + id + "/"
        }, (r)=>{
            this.setState({
                item: r
            });
        });
    };
    toggleMode = ()=>{
        this.setState({
            mode: this.state.mode == "EDIT" ? "VIEW" : "EDIT"
        });
    };
    render() {
        let { item: item } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "box p-4",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("h5", {
                        className: "mt-3 mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "faIcon",
                                children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                    className: "fa fa-route"
                                })
                            }),
                            "View Route #",
                            item && item.id
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "item taskBlock",
                        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "p-a-md",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "row pull-right",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "btn btn-outline-primary d-inline-block",
                                        onClick: this.toggleMode,
                                        children: this.state.mode == "EDIT" ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                    className: "fa fa-eye"
                                                }),
                                                " View"
                                            ]
                                        }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                    className: "fa fa-edit"
                                                }),
                                                " Edit"
                                            ]
                                        })
                                    })
                                }),
                                this.state.mode == "VIEW" ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $8222b7ab80d0f0ed$export$2e2bcd8739ae039), {
                                    item: item
                                }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $7b1c3823ce6be8c8$export$2e2bcd8739ae039), {
                                    item: item
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "row m-t",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "col-sm-12 taskTags mt-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("h4", {
                                                children: "Points"
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)((0, $81b6b064afbc82da$export$2e2bcd8739ae039), {
                                                data: item && item.points,
                                                type: "data",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                        dataField: "id",
                                                        width: "82px",
                                                        isKey: true
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                        dataFormat: (0, $b79edb411f97c469$export$105684a3041cb6f3),
                                                        dataSort: true,
                                                        children: "Point"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                        dataField: "start",
                                                        dataSort: true,
                                                        children: "Start"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                        dataField: "end",
                                                        dataSort: true,
                                                        children: "End"
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                        dataField: "order",
                                                        dataSort: true,
                                                        children: "Order"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
var $982a478d060e3bae$export$2e2bcd8739ae039 = $982a478d060e3bae$var$Page;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $Yxlsx = parcelRequire("Yxlsx");






var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");










const $423f9827acb02168$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $423f9827acb02168$var$Table extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            valid: false
        };
    }
    onRowClick = (row)=>{
        this.props.openTask(row);
    };
    render() {
        const { data: data, totalDataSize: totalDataSize, count: count, filter: filter, changeFilter: changeFilter, submit: submit, resetFilter: resetFilter } = this.props;
        const tableOptions = {
            ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186),
            onRowClick: this.onRowClick
        };
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "row answers-page",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "md-filter-panel",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "md-filter-grid",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field md-filter-field--dates",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: "\u0414\u0430\u0442\u0430"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "md-filter-dates",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                    selected: filter.start ? new Date(filter.start) : null,
                                                    className: "datePicker",
                                                    onChange: (date)=>changeFilter("start", date)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "md-filter-date-sep",
                                                    children: "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                                                    selected: filter.end ? new Date(filter.end) : null,
                                                    className: "datePicker",
                                                    onChange: (date)=>changeFilter("end", date)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "city", $423f9827acb02168$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "locality",
                                            value: filter.visit__point__locality,
                                            onChange: (o)=>changeFilter("visit__point__locality", o)
                                        })
                                    ]
                                }),
                                (0, $3b579ca6158bc61b$export$e5432d4c8eb97ea7)() && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "supervisor", $423f9827acb02168$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "supervisor",
                                            value: filter.visit__point__responsible_supervisor,
                                            onChange: (o)=>changeFilter("visit__point__responsible_supervisor", o)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "network", $423f9827acb02168$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "network",
                                            value: filter.visit__point__network,
                                            onChange: (o)=>changeFilter("visit__point__network", o)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "template", $423f9827acb02168$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "template",
                                            value: filter.task__template,
                                            asynch: true,
                                            onChange: (o)=>changeFilter("task__template", o)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "md-filter-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "md-filter-label",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "merchandiser", $423f9827acb02168$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                                            entity: "merchandiser",
                                            value: filter.visit__user,
                                            onChange: (o)=>changeFilter("visit__user", o)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "md-filter-grid md-filter-grid--point",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $d4b6a9d27c93fbb2$export$2e2bcd8739ae039), {
                                value: filter.visit__point,
                                onChange: (o)=>changeFilter("visit__point", o),
                                moduleFilter: filter.visit__point__network
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "md-filter-actions",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "md-filter-actions-left",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        className: "btn btn-primary",
                                        onClick: ()=>submit(),
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "apply_btn", $423f9827acb02168$var$me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                        className: "btn btn-outline-primary",
                                        onClick: ()=>resetFilter(),
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "reset_filters_btn", $423f9827acb02168$var$me.language)
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "col-md-12 answers-table-wrap",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                        data: data,
                        version: "4",
                        hover: true,
                        bordered: false,
                        pagination: false,
                        search: false,
                        multiColumnSearch: true,
                        options: tableOptions,
                        fetchInfo: {
                            dataTotalSize: totalDataSize
                        },
                        className: "themed-main-table-container",
                        tableHeaderClass: "primary",
                        trClassName: "answers-row-item",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataField: "id",
                                isKey: true,
                                hidden: true
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$fb4d46cce654803b),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "point", $423f9827acb02168$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$4f500e0c26949ef4),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "network", $423f9827acb02168$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$e11fec1cbe9a7ef6),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "priority", $423f9827acb02168$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$542a0fc0e045874),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "merchandiser", $423f9827acb02168$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (0, $b79edb411f97c469$export$fa1c0d6984eb64ab),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "responsible_supervisor", $423f9827acb02168$var$me.language)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $1ce364701ea3e4d9$export$2e2bcd8739ae039), {
                    pagination: this.props.pagination,
                    updatePage: this.props.updatePage
                })
            ]
        });
    }
}
var $423f9827acb02168$export$2e2bcd8739ae039 = $423f9827acb02168$var$Table;




var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $e223cdd37b7e8f69$exports = {};
"use strict";
"use client";
var $2f820f80dc550ce2$exports = {};
function $2f820f80dc550ce2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$2f820f80dc550ce2$exports = $2f820f80dc550ce2$var$_interopRequireDefault, $2f820f80dc550ce2$exports.__esModule = true, $2f820f80dc550ce2$exports["default"] = $2f820f80dc550ce2$exports;


var $e223cdd37b7e8f69$require$_interopRequireDefault = $2f820f80dc550ce2$exports.default;
Object.defineProperty($e223cdd37b7e8f69$exports, "__esModule", {
    value: true
});
$e223cdd37b7e8f69$exports.default = void 0;

var $e223cdd37b7e8f69$var$_createSvgIcon = $e223cdd37b7e8f69$require$_interopRequireDefault((parcelRequire("aEGIN")));

var $7uT18 = parcelRequire("7uT18");
var $e223cdd37b7e8f69$var$_default = $e223cdd37b7e8f69$exports.default = (0, $e223cdd37b7e8f69$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $7uT18.jsx)("path", {
    d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "RadioButtonChecked");


var $a87f005b50c1f609$exports = {};
"use strict";
"use client";

var $a87f005b50c1f609$require$_interopRequireDefault = $2f820f80dc550ce2$exports.default;
Object.defineProperty($a87f005b50c1f609$exports, "__esModule", {
    value: true
});
$a87f005b50c1f609$exports.default = void 0;

var $a87f005b50c1f609$var$_createSvgIcon = $a87f005b50c1f609$require$_interopRequireDefault((parcelRequire("aEGIN")));

var $7uT18 = parcelRequire("7uT18");
var $a87f005b50c1f609$var$_default = $a87f005b50c1f609$exports.default = (0, $a87f005b50c1f609$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $7uT18.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "RadioButtonUnchecked");








const $0b45e62fa7ef1e45$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $0b45e62fa7ef1e45$export$d33911818020cf8a extends (0, $cQmXV.Component) {
    state = {
        fullscreenPhoto: null,
        fullscreenIndex: null
    };
    openFullscreen = (index)=>{
        this.setState({
            fullscreenPhoto: this.props.item.photos[index],
            fullscreenIndex: index
        });
    };
    closeFullscreen = ()=>{
        this.setState({
            fullscreenPhoto: null,
            fullscreenIndex: null
        });
    };
    lightboxPrev = (e)=>{
        e.stopPropagation();
        const { fullscreenIndex: fullscreenIndex } = this.state;
        const photos = this.props.item.photos;
        const newIndex = fullscreenIndex - 1;
        if (newIndex >= 0) this.setState({
            fullscreenPhoto: photos[newIndex],
            fullscreenIndex: newIndex
        });
    };
    lightboxNext = (e)=>{
        e.stopPropagation();
        const { fullscreenIndex: fullscreenIndex } = this.state;
        const photos = this.props.item.photos;
        const newIndex = fullscreenIndex + 1;
        if (newIndex < photos.length) this.setState({
            fullscreenPhoto: photos[newIndex],
            fullscreenIndex: newIndex
        });
    };
    componentDidMount = ()=>{
        let { acceptRejectAnswer: acceptRejectAnswer, passTaskToModal: passTaskToModal, moveNext: moveNext } = this.props;
        const closeFullscreen = ()=>this.closeFullscreen();
        const handleArrow = (dir)=>{
            if (this.state.fullscreenPhoto) {
                const { fullscreenIndex: fullscreenIndex } = this.state;
                const photos = this.props.item.photos;
                const newIndex = fullscreenIndex + dir;
                if (newIndex >= 0 && newIndex < photos.length) this.setState({
                    fullscreenPhoto: photos[newIndex],
                    fullscreenIndex: newIndex
                });
            } else moveNext(dir);
        };
        document.addEventListener("keydown", function(e) {
            switch(e.keyCode){
                case 27:
                    closeFullscreen();
                    break;
                case 37:
                    handleArrow(-1);
                    break;
                case 39:
                    handleArrow(1);
                    break;
                case 38:
                    acceptRejectAnswer("ACCEPT");
                    break;
                case 40:
                    passTaskToModal();
                    break;
            }
        });
    };
    render() {
        let { item: item, acceptRejectAnswer: acceptRejectAnswer, passTaskToModal: passTaskToModal, activePhotoIndex: activePhotoIndex } = this.props;
        const { fullscreenPhoto: fullscreenPhoto, fullscreenIndex: fullscreenIndex } = this.state;
        const task = item.task;
        const tags = item.selected_tags;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "ar-details",
            children: [
                fullscreenPhoto && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "ar-photo-lightbox",
                    onClick: this.closeFullscreen,
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            className: "ar-photo-lightbox__close",
                            onClick: this.closeFullscreen,
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-times"
                            })
                        }),
                        fullscreenIndex > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            className: "ar-photo-lightbox__nav ar-photo-lightbox__nav--prev",
                            onClick: this.lightboxPrev,
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-chevron-circle-left"
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                            src: fullscreenPhoto.photo_url,
                            className: "ar-photo-lightbox__img",
                            onClick: (e)=>e.stopPropagation()
                        }),
                        fullscreenIndex < item.photos.length - 1 && /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            className: "ar-photo-lightbox__nav ar-photo-lightbox__nav--next",
                            onClick: this.lightboxNext,
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                className: "fa fa-chevron-circle-right"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "ar-layout",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "ar-photo-card",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("h3", {
                                    className: "ar-card-title",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "photo_library"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "photo_title", $0b45e62fa7ef1e45$var$me.language)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "ar-photo-canvas",
                                    children: item.photos.length > 0 ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $5588f76353c86461$export$2e2bcd8739ae039), {
                                        activePhotoIndex: activePhotoIndex,
                                        photos: item.photos,
                                        viewMode: "group",
                                        clickCallback: this.openFullscreen
                                    }) : item.photo && /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                        src: item.photo,
                                        className: "ar-preview-img"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "ar-info-col",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "ar-card",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("h3", {
                                            className: "ar-card-title",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "assignment"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "details_task", $0b45e62fa7ef1e45$var$me.language)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "ar-fields-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "title_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: task?.title || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "point", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: (0, $b79edb411f97c469$export$ecb8412bb70195a7)("", item)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "priority", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: task && (0, $6f1c09625235f1f0$export$bb34f3538ba26c7e)[task.priority]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "deadline_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: task && (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(task.end)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field ar-field--full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "description_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: task?.description || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                task?.tags?.length > 0 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field ar-field--full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "tags_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "ar-tags",
                                                            children: task.tags.map((t, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "ar-tag",
                                                                    children: t.name
                                                                }, index))
                                                        })
                                                    ]
                                                }),
                                                task?.images?.length > 0 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field ar-field--full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "images_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "ar-image-links",
                                                            children: task.images.map((img, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                                                    href: img.image,
                                                                    target: "_blank",
                                                                    className: "ar-image-link",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "image"
                                                                    })
                                                                }, index))
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "ar-card",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("h3", {
                                            className: "ar-card-title",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "chat_bubble"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "details_response_task", $0b45e62fa7ef1e45$var$me.language)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "ar-fields-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "merchandiser", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: (0, $b79edb411f97c469$export$542a0fc0e045874)("", item)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "supervisor", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: (0, $b79edb411f97c469$export$fa1c0d6984eb64ab)("", item)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "date_response_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.created)
                                                        })
                                                    ]
                                                }),
                                                item.answer && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field ar-field--full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "text_response_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: item.answer
                                                        })
                                                    ]
                                                }),
                                                item.photo && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "photo_response_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                                            href: item.photo,
                                                            target: "_blank",
                                                            className: "ar-image-link",
                                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                className: "material-symbols-outlined",
                                                                children: "image"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                item.boolean_answer !== null ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "ar-field ar-field--full",
                                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "ar-boolean-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                className: "ar-boolean-option",
                                                                children: [
                                                                    item?.boolean_answer ? /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e223cdd37b7e8f69$exports))), {
                                                                        color: "info"
                                                                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a87f005b50c1f609$exports))), {
                                                                        color: "info"
                                                                    }),
                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "yes", $0b45e62fa7ef1e45$var$me.language)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                className: "ar-boolean-option",
                                                                children: [
                                                                    !item?.boolean_answer ? /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e223cdd37b7e8f69$exports))), {
                                                                        color: "info"
                                                                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a87f005b50c1f609$exports))), {
                                                                        color: "info"
                                                                    }),
                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "no", $0b45e62fa7ef1e45$var$me.language)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : null,
                                                item.visit && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "visit_id", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-value",
                                                            children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                                                                to: "visit/" + item.visit.id,
                                                                target: "_blank",
                                                                className: "ar-link",
                                                                children: [
                                                                    "#",
                                                                    item.visit.id
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                tags && tags.length > 0 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "ar-field ar-field--full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "ar-field-label",
                                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "tags_task", $0b45e62fa7ef1e45$var$me.language)
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "ar-tags",
                                                            children: tags.map((t, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "ar-tag",
                                                                    children: t
                                                                }, index))
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !item.is_supervised && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "ar-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                            className: "ar-action-btn ar-action-btn--accept",
                                            onClick: ()=>acceptRejectAnswer("ACCEPT"),
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "check_circle"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "apply_btn", $0b45e62fa7ef1e45$var$me.language)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                            className: "ar-action-btn ar-action-btn--reject",
                                            onClick: passTaskToModal,
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "cancel"
                                                }),
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "reject_btn", $0b45e62fa7ef1e45$var$me.language)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}







const $04b52f7cd217d9e1$var$defaultTemplate = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().defaultTemplate;
class $04b52f7cd217d9e1$var$View extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            VIEW: "LIST",
            item: {},
            newTask: {},
            activePhotoIndex: 0,
            currentIndex: 0,
            data: [],
            count: 0,
            isModal: false,
            loading: false,
            pagination: {
                state: false,
                count: 0,
                sizePerPage: 50,
                pageAmount: 1,
                page: 1
            },
            filter: {
                start: new Date(),
                end: new Date(),
                visit__point__locality: "",
                visit__point__network: "",
                visit__point: "",
                visit__user: "",
                task__template: "",
                visit__point__responsible_supervisor: ""
            },
            newTaskLoading: false,
            errors: {}
        };
    }
    filterToParams = (filter)=>{
        const params = new URLSearchParams();
        const dateStr = (v)=>{
            if (!v) return null;
            const d = new Date(v);
            if (isNaN(d)) return null;
            return d.toISOString().slice(0, 10);
        };
        if (dateStr(filter.start)) params.set("start", dateStr(filter.start));
        if (dateStr(filter.end)) params.set("end", dateStr(filter.end));
        if (filter.visit__point__locality) params.set("locality", filter.visit__point__locality);
        if (filter.visit__point__network) params.set("network", filter.visit__point__network);
        if (filter.visit__point) params.set("point", filter.visit__point);
        if (filter.visit__user) params.set("user", filter.visit__user);
        if (filter.task__template) params.set("template", filter.task__template);
        if (filter.visit__point__responsible_supervisor) params.set("supervisor", filter.visit__point__responsible_supervisor);
        return params;
    };
    paramsToFilter = (search)=>{
        const params = new URLSearchParams(search);
        const filter = {
            ...this.state.filter
        };
        if (params.get("start")) filter.start = params.get("start");
        if (params.get("end")) filter.end = params.get("end");
        if (params.get("locality")) filter.visit__point__locality = params.get("locality");
        if (params.get("network")) filter.visit__point__network = params.get("network");
        if (params.get("point")) filter.visit__point = params.get("point");
        if (params.get("user")) filter.visit__user = params.get("user");
        if (params.get("template")) filter.task__template = params.get("template");
        if (params.get("supervisor")) filter.visit__point__responsible_supervisor = params.get("supervisor");
        return filter;
    };
    setStartDate = ()=>{
        var start = new Date();
        start = start.setDate(start.getDate() - 7);
        let filter = this.state.filter;
        filter.start = start;
        this.setState({
            filter: filter
        }, ()=>{
            this.load();
        });
    };
    componentDidMount = ()=>{
        window.addEventListener("popstate", this.handleBrowserBack);
        const { location: location } = this.props;
        if (location?.search) {
            const filter = this.paramsToFilter(location.search);
            this.setState({
                filter: filter
            }, ()=>this.load());
        } else this.setStartDate();
    };
    componentWillUnmount = ()=>{
        window.removeEventListener("popstate", this.handleBrowserBack);
    };
    handleBrowserBack = ()=>{
        if (this.state.VIEW === "VIEW") this.setState({
            VIEW: "LIST",
            activePhotoIndex: 0,
            isModal: false,
            newTask: {}
        });
    };
    load = ()=>{
        let { pagination: pagination } = this.state;
        let url = "answers/photos_on_review/?page=" + pagination.page;
        let urlFilter = (0, $3b579ca6158bc61b$export$728929c44bc0c14b)("answers/photos_on_review", this.state.filter);
        if (urlFilter) url += urlFilter;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (r)=>{
            const newPagination = {
                state: true,
                pageAmount: Math.ceil(r.count / pagination.sizePerPage),
                count: r.count,
                page: pagination.page,
                sizePerPage: pagination.sizePerPage
            };
            let list = r.results.map((i, j)=>{
                i.index = j;
                return i;
            });
            this.setState({
                data: list,
                count: r.count,
                loading: false,
                pagination: newPagination
            });
        });
    };
    submit = ()=>{
        const params = this.filterToParams(this.state.filter);
        this.props.history.replace({
            search: params.toString()
        });
        this.updatePaging(1);
    };
    changeFilter = (filterEntity, item)=>{
        let filter = this.state.filter;
        if (filterEntity == "start" || filterEntity == "end") filter[filterEntity] = item;
        else filter[filterEntity] = item?.id;
        this.setState({
            filter: filter
        });
    };
    resetFilter = ()=>{
        let { filter: filter } = this.state;
        Object.keys(filter).map((i)=>{
            filter[i] = null;
            if (i == "start") filter[i] = new Date();
            if (i == "end") filter[i] = new Date();
        });
        this.props.history.replace({
            search: ""
        });
        this.setState({
            filter: filter
        }, ()=>{
            this.setStartDate();
            this.load();
        });
    };
    openTask = (item)=>{
        this.setState({
            VIEW: "VIEW",
            item: {
                ...item,
                task: {
                    ...item.task,
                    template: ""
                }
            }
        });
        window.history.pushState({
            picsellTaskReviewDetail: true
        }, "");
    };
    back = ()=>{
        if (this.state.VIEW === "VIEW") {
            window.history.go(-1);
            return;
        }
        if (this.state.VIEW === "NEW") this.setState({
            VIEW: "VIEW"
        });
        this.setState({
            activePhotoIndex: 0
        });
    };
    callUpdateAnswer = (body, cb)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "approvals/",
            post: body
        }, (r)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0430");
            // this.setState({ item: r });
            this.load();
            cb();
        });
    };
    acceptRejectAnswer = (type)=>{
        let { item: item } = this.state;
        const body = {
            object_id: item.id,
            object_type: "answer",
            is_approved: null
        };
        if (type == "REJECT") {
            body.is_approved = false;
            this.callUpdateAnswer(body, ()=>{
                this.moveNext();
            });
        }
        if (type == "ACCEPT") {
            body.is_approved = true;
            this.callUpdateAnswer(body, ()=>{
                this.moveNext();
            });
        }
    };
    activePhotoIndex = (index = 0)=>{
        this.setState({
            activePhotoIndex: index
        });
        return index;
    };
    passTaskToModal = ()=>{
        let { item: item } = this.state;
        const newTask = Object.assign({}, item.task);
        let date = new Date(newTask.end);
        // newTask.template = "";
        newTask.start = new Date();
        newTask.end = new Date(new Date().setDate(new Date().getDate() + 14));
        const photo = item.photos.length > 0 ? item.photos[this.state.activePhotoIndex].photo_url : item.photo;
        if (photo) {
            newTask.images = [
                {
                    image: photo
                }
            ];
            newTask.imageFromReview = {
                image: photo
            };
        }
        this.setState({
            newTask: newTask,
            isModal: true
        });
    };
    onSaveEditorImage = (index, image)=>{
        const { newTask: newTask } = this.state;
        if (!image) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: this.props.me,
                image: image
            }
        }, (image)=>{
            if (image?.id) this.setState({
                newTask: {
                    ...newTask,
                    images: [
                        image
                    ]
                }
            });
        });
    };
    newTaskSubmit = ()=>{
        let { newTask: newTask } = this.state;
        let queueLoadingTimer = 0;
        let queueLoadingStep = 8000;
        let itemPost = Object.assign({}, newTask);
        itemPost.id = null; // we always create new task if use Reject button on task-review
        itemPost.components = newTask.components.map((i)=>i.id);
        itemPost.tags = newTask.tags?.map((i)=>i.id);
        itemPost.network = newTask?.network?.id || null;
        itemPost.point = newTask?.point?.id || null;
        itemPost.end = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(itemPost.end).format("yyyy-MM-DDT23:59:59");
        itemPost.images = newTask.images.map((i)=>i.id ? i.id : i);
        itemPost.created_by = newTask.created_by?.id || null;
        itemPost.template = itemPost.template === "" ? $04b52f7cd217d9e1$var$defaultTemplate : itemPost.template;
        const { validate: validate, errors: errors } = (0, $3b579ca6158bc61b$export$6daeeb4cea31fc5)("task-review", itemPost);
        if (!validate) {
            this.setState({
                errors: errors
            });
            return;
        }
        if (itemPost.images.every((image)=>image.id)) {
            itemPost.images = newTask.images?.map((image)=>image.id);
            this.createNewTask(itemPost);
        } else {
            this.setState({
                newTaskLoading: true
            });
            itemPost.images = newTask.images?.map((image, index)=>{
                if (image.id) {
                    itemPost.images = [
                        image.id
                    ];
                    this.createNewTask(itemPost);
                    this.setState({
                        itemPost: itemPost,
                        newTaskLoading: false
                    });
                    this.modalClose();
                    return image.id;
                } else {
                    setTimeout((args)=>{
                        (0, $3b579ca6158bc61b$export$d6f5c7e166773679)(image.image, this.props.me, (createdImg)=>{
                            if (createdImg.id) {
                                itemPost.images.push(createdImg.id);
                                if (index === newTask.images.length - 1) {
                                    itemPost.images = itemPost.images?.filter((item)=>!!item);
                                    this.createNewTask(itemPost);
                                    this.setState({
                                        itemPost: itemPost,
                                        newTaskLoading: false
                                    });
                                    this.modalClose();
                                }
                            } else console.error("image was not created");
                        });
                    }, queueLoadingTimer);
                    queueLoadingTimer += queueLoadingStep;
                }
            });
        }
    };
    createNewTask = (data)=>{
        if (!data) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "tasks/",
            post: data
        }, (response)=>{
            if (response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0435");
                this.setState({
                    VIEW: "VIEW",
                    errors: {}
                });
                this.modalClose();
                this.acceptRejectAnswer("REJECT");
            } else {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving item. Error: " + JSON.stringify(response));
                console.log(response);
            }
        });
    };
    moveNext = (DIRECTION = 1)=>{
        let { currentIndex: currentIndex, data: data, count: count } = this.state;
        if (count === 0) {
            this.setState({
                VIEW: "LIST"
            });
            return;
        }
        let newIndex = 0;
        if (currentIndex + DIRECTION < count) newIndex = currentIndex + DIRECTION;
        else newIndex = 0;
        if (newIndex == -1 && DIRECTION == -1) newIndex = count - 1;
        if (!data[newIndex]) {
            console.log("NEW ITEM NOT EXIST. newIndex", newIndex);
            return;
        }
        let newItem = data[newIndex];
        newItem["template"] = "";
        this.setState({
            currentIndex: newIndex,
            item: newItem
        });
    };
    modalOpen = ()=>{
        this.setState({
            isModal: true
        });
    };
    modalClose = ()=>this.setState({
            isModal: false,
            newTask: {}
        });
    newTaskOnChange = (property, value)=>{
        let item = this.state.newTask;
        item[property] = value;
        this.setState({
            newTask: item
        });
    };
    // PAGINATION
    updatePaging = (page, cb)=>{
        let { pagination: pagination } = this.state;
        pagination.page = page;
        this.setState({
            pagination: pagination
        }, ()=>{
            this.load();
            if (cb) cb();
        });
    };
    render() {
        const { isModal: isModal, VIEW: VIEW, newTaskLoading: newTaskLoading } = this.state;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "container-fluid",
            onKeyDown: this.handleKeyDown,
            children: [
                VIEW == "VIEW" && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "ar-fullscreen-overlay",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "ar-fullscreen-header",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                className: "ar-back-btn",
                                onClick: this.back,
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "arrow_back"
                                    }),
                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d35a16c4e31da536), "import_tab", this.props.me.language)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "ar-fullscreen-body",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $0b45e62fa7ef1e45$export$d33911818020cf8a), {
                                ...this.state,
                                acceptRejectAnswer: this.acceptRejectAnswer,
                                passTaskToModal: this.passTaskToModal,
                                activePhotoIndex: this.activePhotoIndex,
                                moveNext: this.moveNext
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "box p-4 answers-page-list",
                    children: [
                        VIEW == "LIST" && /*#__PURE__*/ (0, $7uT18.jsx)((0, $423f9827acb02168$export$2e2bcd8739ae039), {
                            ...this.state,
                            changeFilter: this.changeFilter,
                            resetFilter: this.resetFilter,
                            submit: this.submit,
                            openTask: this.openTask,
                            pagination: Object.assign({}, this.state.pagination),
                            updatePage: (page)=>{
                                this.updatePaging(page);
                            }
                        }),
                        isModal && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
                            isShow: isModal,
                            onClose: this.modalClose,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                    loading: newTaskLoading,
                                    disP: true,
                                    type: "spinner"
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $d1774b39c619190c$export$fee3520bdfbfe55c), {
                                    item: this.state.newTask,
                                    type: "point",
                                    newTaskFromReview: true,
                                    onChange: this.newTaskOnChange,
                                    onSaveEditorImage: this.onSaveEditorImage,
                                    submit: this.newTaskSubmit,
                                    setOpen: ()=>this.setState({
                                            isOpen: true
                                        }),
                                    errors: this.state.errors,
                                    isImageEditable: true
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $04b52f7cd217d9e1$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($04b52f7cd217d9e1$var$View));



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");







class $30ad5da16ca1f695$var$TaskList extends (0, $cQmXV.Component) {
    openRow = (row)=>{
        const url = `/task/${row.id}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };
    render() {
        const lang = this.props.currentUser.language;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid task-list task-page",
            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "box p-4 task-page-list",
                children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $81b6b064afbc82da$export$2e2bcd8739ae039), {
                    entity: "task",
                    pagination: true,
                    openVisitFn: this.openRow,
                    rowClassName: "task-row-item",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataField: "id",
                            isKey: true,
                            hidden: true
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (0, $b79edb411f97c469$export$105684a3041cb6f3),
                            width: "300px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "point", lang)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (0, $b79edb411f97c469$export$99f62f7c9ad8c7ce),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "created_by", lang)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (0, $b79edb411f97c469$export$43d108cb566ddefd),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "supervisor", lang)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (0, $b79edb411f97c469$export$7f6290e025a69ad2),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "merchendiser", lang)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataField: "title",
                            width: "200px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "name", lang)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (0, $b79edb411f97c469$export$450de2dd43fb03),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "finishing", lang)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (0, $b79edb411f97c469$export$1664ae65e1862c28),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "status", lang)
                        })
                    ]
                })
            })
        });
    }
}
const $30ad5da16ca1f695$export$771a55a10b0a40ae = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)($30ad5da16ca1f695$var$TaskList);



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $Yxlsx = parcelRequire("Yxlsx");





var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $Yxlsx = parcelRequire("Yxlsx");





var $cbd0ad7d0024bb33$exports = {};
"use strict";
"use client";

var $cbd0ad7d0024bb33$require$_interopRequireDefault = $2f820f80dc550ce2$exports.default;
Object.defineProperty($cbd0ad7d0024bb33$exports, "__esModule", {
    value: true
});
$cbd0ad7d0024bb33$exports.default = void 0;

var $cbd0ad7d0024bb33$var$_createSvgIcon = $cbd0ad7d0024bb33$require$_interopRequireDefault((parcelRequire("aEGIN")));

var $7uT18 = parcelRequire("7uT18");
var $cbd0ad7d0024bb33$var$_default = $cbd0ad7d0024bb33$exports.default = (0, $cbd0ad7d0024bb33$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $7uT18.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle");


var $9ea3e066c07add16$exports = {};
"use strict";
"use client";

var $9ea3e066c07add16$require$_interopRequireDefault = $2f820f80dc550ce2$exports.default;
Object.defineProperty($9ea3e066c07add16$exports, "__esModule", {
    value: true
});
$9ea3e066c07add16$exports.default = void 0;

var $9ea3e066c07add16$var$_createSvgIcon = $9ea3e066c07add16$require$_interopRequireDefault((parcelRequire("aEGIN")));

var $7uT18 = parcelRequire("7uT18");
var $9ea3e066c07add16$var$_default = $9ea3e066c07add16$exports.default = (0, $9ea3e066c07add16$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $7uT18.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHoriz");





var $cQmXV = parcelRequire("cQmXV");



var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");




var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");

var $kZnRZ = parcelRequire("kZnRZ");

var $9acxQ = parcelRequire("9acxQ");

var $cQmXV = parcelRequire("cQmXV");
"use client";
/**
 * @ignore - internal component.
 */ const $c14e2cca981dfbcf$var$ListContext = /*#__PURE__*/ $cQmXV.createContext({});
var $c14e2cca981dfbcf$export$2e2bcd8739ae039 = $c14e2cca981dfbcf$var$ListContext;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $5878895a673f6494$export$c6bd6795ed6e3203(slot) {
    return (0, $jQsHx.default)("MuiList", slot);
}
const $5878895a673f6494$var$listClasses = (0, $9FFKn.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $5878895a673f6494$export$2e2bcd8739ae039 = $5878895a673f6494$var$listClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $3b38bc19ddf11847$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $5878895a673f6494$export$c6bd6795ed6e3203), classes);
};
const $3b38bc19ddf11847$var$ListRoot = (0, $kZnRZ.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative",
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $3b38bc19ddf11847$var$List = /*#__PURE__*/ $cQmXV.forwardRef(function List(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $cQmXV.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $3b38bc19ddf11847$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $c14e2cca981dfbcf$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7uT18.jsxs)($3b38bc19ddf11847$var$ListRoot, {
            as: component,
            className: (0, $jYj5L.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $3b38bc19ddf11847$export$2e2bcd8739ae039 = $3b38bc19ddf11847$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $a712248698066ed0$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


var $0bb38b80b0818b7d$export$2e2bcd8739ae039 = (0, $a712248698066ed0$export$2e2bcd8739ae039);






var $7uT18 = parcelRequire("7uT18");
"use client";
function $fcd033271128b17f$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fcd033271128b17f$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fcd033271128b17f$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(""));
}
function $fcd033271128b17f$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$fcd033271128b17f$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fcd033271128b17f$var$MenuList = /*#__PURE__*/ $cQmXV.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu", ...other } = props;
    const listRef = $cQmXV.useRef(null);
    const textCriteriaRef = $cQmXV.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $fb180c71a776d7cb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $cQmXV.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $0bb38b80b0818b7d$export$2e2bcd8739ae039)((0, $0249870df7ab56c2$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $01d449693793c717$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $fcd033271128b17f$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fcd033271128b17f$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $fcd033271128b17f$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fcd033271128b17f$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $fcd033271128b17f$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fcd033271128b17f$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $fcd033271128b17f$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fcd033271128b17f$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fcd033271128b17f$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fcd033271128b17f$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fcd033271128b17f$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $ca6d5d8361d1622f$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $cQmXV.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $cQmXV.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $cQmXV.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $cQmXV.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $3b38bc19ddf11847$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $fcd033271128b17f$export$2e2bcd8739ae039 = $fcd033271128b17f$var$MenuList;



var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");





/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $b225d1766cd6a0c4$var$isHostComponent(element) {
    return typeof element === "string";
}
var $b225d1766cd6a0c4$export$2e2bcd8739ae039 = $b225d1766cd6a0c4$var$isHostComponent;



var $kZnRZ = parcelRequire("kZnRZ");

var $9acxQ = parcelRequire("9acxQ");




var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
function $77865d91837f7fd1$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($cQmXV.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}






var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");
var $b755c769148ada0d$export$2e2bcd8739ae039 = {
    disabled: false
};




var $74c47fd2ce921e9f$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $150f73bb4e7e2d0c$export$bb38bb9a1161268 = "unmounted";
var $150f73bb4e7e2d0c$export$84cbff306f539230 = "exited";
var $150f73bb4e7e2d0c$export$df38205c966be359 = "entering";
var $150f73bb4e7e2d0c$export$78e9e6e3e014d60a = "entered";
var $150f73bb4e7e2d0c$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $150f73bb4e7e2d0c$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $17897257a8e91c2f$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $150f73bb4e7e2d0c$export$84cbff306f539230;
                _this.appearStatus = $150f73bb4e7e2d0c$export$df38205c966be359;
            } else initialStatus = $150f73bb4e7e2d0c$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $150f73bb4e7e2d0c$export$bb38bb9a1161268;
        else initialStatus = $150f73bb4e7e2d0c$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $150f73bb4e7e2d0c$export$bb38bb9a1161268) return {
            status: $150f73bb4e7e2d0c$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $150f73bb4e7e2d0c$export$df38205c966be359 && status !== $150f73bb4e7e2d0c$export$78e9e6e3e014d60a) nextStatus = $150f73bb4e7e2d0c$export$df38205c966be359;
            } else if (status === $150f73bb4e7e2d0c$export$df38205c966be359 || status === $150f73bb4e7e2d0c$export$78e9e6e3e014d60a) nextStatus = $150f73bb4e7e2d0c$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $150f73bb4e7e2d0c$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $74c47fd2ce921e9f$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $150f73bb4e7e2d0c$export$84cbff306f539230) this.setState({
            status: $150f73bb4e7e2d0c$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $b755c769148ada0d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $150f73bb4e7e2d0c$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $150f73bb4e7e2d0c$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $150f73bb4e7e2d0c$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $b755c769148ada0d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $150f73bb4e7e2d0c$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $150f73bb4e7e2d0c$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $150f73bb4e7e2d0c$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $150f73bb4e7e2d0c$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1aa60e50228dee77$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
$150f73bb4e7e2d0c$var$Transition.contextType = (0, $1aa60e50228dee77$export$2e2bcd8739ae039);
$150f73bb4e7e2d0c$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $150f73bb4e7e2d0c$var$noop() {}
$150f73bb4e7e2d0c$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $150f73bb4e7e2d0c$var$noop,
    onEntering: $150f73bb4e7e2d0c$var$noop,
    onEntered: $150f73bb4e7e2d0c$var$noop,
    onExit: $150f73bb4e7e2d0c$var$noop,
    onExiting: $150f73bb4e7e2d0c$var$noop,
    onExited: $150f73bb4e7e2d0c$var$noop
};
$150f73bb4e7e2d0c$var$Transition.UNMOUNTED = $150f73bb4e7e2d0c$export$bb38bb9a1161268;
$150f73bb4e7e2d0c$var$Transition.EXITED = $150f73bb4e7e2d0c$export$84cbff306f539230;
$150f73bb4e7e2d0c$var$Transition.ENTERING = $150f73bb4e7e2d0c$export$df38205c966be359;
$150f73bb4e7e2d0c$var$Transition.ENTERED = $150f73bb4e7e2d0c$export$78e9e6e3e014d60a;
$150f73bb4e7e2d0c$var$Transition.EXITING = $150f73bb4e7e2d0c$export$4aacc83d4d59139f;
var $150f73bb4e7e2d0c$export$2e2bcd8739ae039 = $150f73bb4e7e2d0c$var$Transition;



const $82ffa5ebd7adf651$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $82ffa5ebd7adf651$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === "number" ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === "object" ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




var $7uT18 = parcelRequire("7uT18");
"use client";
function $2c2ec68e98eef83a$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $2c2ec68e98eef83a$var$styles = {
    entering: {
        opacity: 1,
        transform: $2c2ec68e98eef83a$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $2c2ec68e98eef83a$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $2c2ec68e98eef83a$var$Grow = /*#__PURE__*/ $cQmXV.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $150f73bb4e7e2d0c$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $8cdcbd38b2555407$export$2e2bcd8739ae039)();
    const autoTimeout = $cQmXV.useRef();
    const theme = (0, $6e330efe521cf043$export$2e2bcd8739ae039)();
    const nodeRef = $cQmXV.useRef(null);
    const handleRef = (0, $ca6d5d8361d1622f$export$2e2bcd8739ae039)(nodeRef, (0, $77865d91837f7fd1$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $82ffa5ebd7adf651$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $82ffa5ebd7adf651$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $2c2ec68e98eef83a$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $82ffa5ebd7adf651$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $2c2ec68e98eef83a$var$isWebKit154 ? duration : duration * 0.666,
                delay: $2c2ec68e98eef83a$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $2c2ec68e98eef83a$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $cQmXV.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $2c2ec68e98eef83a$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined,
                    ...$2c2ec68e98eef83a$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($2c2ec68e98eef83a$var$Grow) $2c2ec68e98eef83a$var$Grow.muiSupportAuto = true;
var $2c2ec68e98eef83a$export$2e2bcd8739ae039 = $2c2ec68e98eef83a$var$Grow;



var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");



var $iryXh = parcelRequire("iryXh");

var $cQmXV = parcelRequire("cQmXV");



var $7uT18 = parcelRequire("7uT18");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $25eccff9b8fef268$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $25eccff9b8fef268$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $25eccff9b8fef268$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $25eccff9b8fef268$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $25eccff9b8fef268$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $25eccff9b8fef268$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($25eccff9b8fef268$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $25eccff9b8fef268$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$25eccff9b8fef268$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $25eccff9b8fef268$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $25eccff9b8fef268$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $25eccff9b8fef268$var$defaultGetTabbable, isEnabled: isEnabled = $25eccff9b8fef268$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $cQmXV.useRef(false);
    const sentinelStart = $cQmXV.useRef(null);
    const sentinelEnd = $cQmXV.useRef(null);
    const nodeToRestore = $cQmXV.useRef(null);
    const reactFocusEventTarget = $cQmXV.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $cQmXV.useRef(false);
    const rootRef = $cQmXV.useRef(null);
    const handleRef = (0, $9a137d8a34f7c4e6$export$2e2bcd8739ae039)((0, $77865d91837f7fd1$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $cQmXV.useRef(null);
    $cQmXV.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $cQmXV.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $0a9753fa19441ed9$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $cQmXV.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $0a9753fa19441ed9$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)($cQmXV.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $cQmXV.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $25eccff9b8fef268$export$2e2bcd8739ae039 = $25eccff9b8fef268$var$FocusTrap;



var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");

/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $1a79b9537019882c$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $c0ac4e57f306667f$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $c0ac4e57f306667f$var$Portal = /*#__PURE__*/ $cQmXV.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $cQmXV.useState(null);
    const handleRef = (0, $9a137d8a34f7c4e6$export$2e2bcd8739ae039)(/*#__PURE__*/ $cQmXV.isValidElement(children) ? (0, $77865d91837f7fd1$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $231bc2cf00a53453$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($c0ac4e57f306667f$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $231bc2cf00a53453$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $1a79b9537019882c$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $1a79b9537019882c$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $cQmXV.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $cQmXV.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $3h5eW.createPortal(children, mountNode) : mountNode;
});
var $c0ac4e57f306667f$export$2e2bcd8739ae039 = $c0ac4e57f306667f$var$Portal;



var $kZnRZ = parcelRequire("kZnRZ");

var $dGUQw = parcelRequire("dGUQw");

var $9acxQ = parcelRequire("9acxQ");

var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");

var $kZnRZ = parcelRequire("kZnRZ");

var $9acxQ = parcelRequire("9acxQ");


var $cQmXV = parcelRequire("cQmXV");








var $7uT18 = parcelRequire("7uT18");
"use client";
const $787a0a18a0658623$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $787a0a18a0658623$var$Fade = /*#__PURE__*/ $cQmXV.forwardRef(function Fade(props, ref) {
    const theme = (0, $6e330efe521cf043$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $150f73bb4e7e2d0c$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $cQmXV.useRef(null);
    const handleRef = (0, $ca6d5d8361d1622f$export$2e2bcd8739ae039)(nodeRef, (0, $77865d91837f7fd1$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $82ffa5ebd7adf651$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $82ffa5ebd7adf651$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $82ffa5ebd7adf651$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $cQmXV.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined,
                    ...$787a0a18a0658623$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $787a0a18a0658623$export$2e2bcd8739ae039 = $787a0a18a0658623$var$Fade;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $1832b2d32bbab974$export$9927a91fd93152bd(slot) {
    return (0, $jQsHx.default)("MuiBackdrop", slot);
}
const $1832b2d32bbab974$var$backdropClasses = (0, $9FFKn.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $1832b2d32bbab974$export$2e2bcd8739ae039 = $1832b2d32bbab974$var$backdropClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $c74949ca5e5dbf66$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $1832b2d32bbab974$export$9927a91fd93152bd), classes);
};
const $c74949ca5e5dbf66$var$BackdropRoot = (0, $kZnRZ.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent",
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: "transparent"
            }
        }
    ]
});
const $c74949ca5e5dbf66$var$Backdrop = /*#__PURE__*/ $cQmXV.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $c74949ca5e5dbf66$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("root", {
        elementType: $c74949ca5e5dbf66$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $jYj5L.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("transition", {
        elementType: (0, $787a0a18a0658623$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7uT18.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $7uT18.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $c74949ca5e5dbf66$export$2e2bcd8739ae039 = $c74949ca5e5dbf66$var$Backdrop;



var $cQmXV = parcelRequire("cQmXV");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $18ab50c02be6cabf$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $395d9d89b957807f$var$isOverflowing(container) {
    const doc = (0, $0a9753fa19441ed9$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $072c43b837841e08$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $395d9d89b957807f$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $395d9d89b957807f$var$getPaddingRight(element) {
    return parseInt((0, $072c43b837841e08$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $395d9d89b957807f$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $395d9d89b957807f$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$395d9d89b957807f$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $395d9d89b957807f$export$e1bd0c6150f13d96(element, hide);
    });
}
function $395d9d89b957807f$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $395d9d89b957807f$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($395d9d89b957807f$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $a712248698066ed0$export$2e2bcd8739ae039)((0, $072c43b837841e08$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$395d9d89b957807f$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $0a9753fa19441ed9$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$395d9d89b957807f$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $0a9753fa19441ed9$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $072c43b837841e08$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $395d9d89b957807f$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $395d9d89b957807f$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $395d9d89b957807f$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $395d9d89b957807f$var$getHiddenSiblings(container);
        $395d9d89b957807f$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $395d9d89b957807f$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $395d9d89b957807f$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $395d9d89b957807f$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $395d9d89b957807f$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $395d9d89b957807f$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $395d9d89b957807f$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $395d9d89b957807f$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $16d2924d9be0bc43$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $16d2924d9be0bc43$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
const $16d2924d9be0bc43$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $16d2924d9be0bc43$var$manager = new (0, $395d9d89b957807f$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $16d2924d9be0bc43$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $cQmXV.useRef({});
    const mountNodeRef = $cQmXV.useRef(null);
    const modalRef = $cQmXV.useRef(null);
    const handleRef = (0, $9a137d8a34f7c4e6$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $cQmXV.useState(!open);
    const hasTransition = $16d2924d9be0bc43$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $0a9753fa19441ed9$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $16d2924d9be0bc43$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $9c0eaca3a51a3f8e$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $16d2924d9be0bc43$var$getContainer(container) || getDoc().body;
        $16d2924d9be0bc43$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$16d2924d9be0bc43$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $9c0eaca3a51a3f8e$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $395d9d89b957807f$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $cQmXV.useCallback(()=>{
        $16d2924d9be0bc43$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $cQmXV.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $cQmXV.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $aed310e7cd7f17e7$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: "presentation",
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            "aria-hidden": true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $18ab50c02be6cabf$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $16d2924d9be0bc43$var$noop),
            onExited: (0, $18ab50c02be6cabf$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $16d2924d9be0bc43$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $16d2924d9be0bc43$export$2e2bcd8739ae039 = $16d2924d9be0bc43$var$useModal;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $3d7a3d5dcbcdaacb$export$67960e22b12a638d(slot) {
    return (0, $jQsHx.default)("MuiModal", slot);
}
const $3d7a3d5dcbcdaacb$var$modalClasses = (0, $9FFKn.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $3d7a3d5dcbcdaacb$export$2e2bcd8739ae039 = $3d7a3d5dcbcdaacb$var$modalClasses;




var $7uT18 = parcelRequire("7uT18");
"use client";
const $56a58aa34b9f0d1a$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $3d7a3d5dcbcdaacb$export$67960e22b12a638d), classes);
};
const $56a58aa34b9f0d1a$var$ModalRoot = (0, $kZnRZ.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $dGUQw.default)(({ theme: theme })=>({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: "hidden"
                }
            }
        ]
    })));
const $56a58aa34b9f0d1a$var$ModalBackdrop = (0, $kZnRZ.default)((0, $c74949ca5e5dbf66$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $56a58aa34b9f0d1a$var$Modal = /*#__PURE__*/ $cQmXV.forwardRef(function Modal(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $56a58aa34b9f0d1a$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $16d2924d9be0bc43$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $56a58aa34b9f0d1a$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("root", {
        ref: ref,
        elementType: $56a58aa34b9f0d1a$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $jYj5L.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("backdrop", {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $jYj5L.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $c0ac4e57f306667f$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $7uT18.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $7uT18.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $7uT18.jsx)((0, $25eccff9b8fef268$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $cQmXV.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $56a58aa34b9f0d1a$export$2e2bcd8739ae039 = $56a58aa34b9f0d1a$var$Modal;



var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");



var $iryXh = parcelRequire("iryXh");

var $kMbdT = parcelRequire("kMbdT");

var $kZnRZ = parcelRequire("kZnRZ");

var $dGUQw = parcelRequire("dGUQw");

var $9acxQ = parcelRequire("9acxQ");

var $kQVC1 = parcelRequire("kQVC1");

var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $350072bdf0b35d3c$export$29cdb466b9b6f20b(slot) {
    return (0, $jQsHx.default)("MuiPaper", slot);
}
const $350072bdf0b35d3c$var$paperClasses = (0, $9FFKn.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $350072bdf0b35d3c$export$2e2bcd8739ae039 = $350072bdf0b35d3c$var$paperClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $db095609a3dfbbe5$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $iryXh.default)(slots, (0, $350072bdf0b35d3c$export$29cdb466b9b6f20b), classes);
};
const $db095609a3dfbbe5$var$PaperRoot = (0, $kZnRZ.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $dGUQw.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow"),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: "elevation"
                },
                style: {
                    boxShadow: "var(--Paper-shadow)",
                    backgroundImage: "var(--Paper-overlay)"
                }
            }
        ]
    })));
const $db095609a3dfbbe5$var$Paper = /*#__PURE__*/ $cQmXV.forwardRef(function Paper(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiPaper"
    });
    const theme = (0, $6e330efe521cf043$export$2e2bcd8739ae039)();
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation", ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $db095609a3dfbbe5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7uT18.jsx)($db095609a3dfbbe5$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $jYj5L.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === "elevation" && {
                "--Paper-shadow": (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    "--Paper-overlay": theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === "dark" && {
                    "--Paper-overlay": `linear-gradient(${(0, $kMbdT.alpha)("#fff", (0, $kQVC1.default)(elevation))}, ${(0, $kMbdT.alpha)("#fff", (0, $kQVC1.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $db095609a3dfbbe5$export$2e2bcd8739ae039 = $db095609a3dfbbe5$var$Paper;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $6cb8ff226efb8570$export$88f455dd56c95edb(slot) {
    return (0, $jQsHx.default)("MuiPopover", slot);
}
const $6cb8ff226efb8570$var$popoverClasses = (0, $9FFKn.default)("MuiPopover", [
    "root",
    "paper"
]);
var $6cb8ff226efb8570$export$2e2bcd8739ae039 = $6cb8ff226efb8570$var$popoverClasses;




var $jYj5L = parcelRequire("jYj5L");
function $54ad27af1c6ce3ee$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === "function" || typeof defaultSlotProps === "function") return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === "function" ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === "function" ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $jYj5L.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $jYj5L.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



var $7uT18 = parcelRequire("7uT18");
"use client";
function $0544d013f1b6ee02$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $0544d013f1b6ee02$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $0544d013f1b6ee02$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $0544d013f1b6ee02$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $0544d013f1b6ee02$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $6cb8ff226efb8570$export$88f455dd56c95edb), classes);
};
const $0544d013f1b6ee02$export$bcce13685275fc99 = (0, $kZnRZ.default)((0, $56a58aa34b9f0d1a$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $0544d013f1b6ee02$export$821346c38a2d9390 = (0, $kZnRZ.default)((0, $db095609a3dfbbe5$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0544d013f1b6ee02$var$Popover = /*#__PURE__*/ $cQmXV.forwardRef(function Popover(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = "auto", TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $cQmXV.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $0544d013f1b6ee02$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $cQmXV.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $0544d013f1b6ee02$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $01d449693793c717$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $0544d013f1b6ee02$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $0544d013f1b6ee02$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $cQmXV.useCallback((elemRect)=>{
        return {
            vertical: $0544d013f1b6ee02$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $0544d013f1b6ee02$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $cQmXV.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $0544d013f1b6ee02$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $0249870df7ab56c2$export$2e2bcd8739ae039)($0544d013f1b6ee02$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $0544d013f1b6ee02$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $cQmXV.useState(open);
    const setPositioningStyles = $cQmXV.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty("top", positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $cQmXV.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $cQmXV.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $cQmXV.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $cQmXV.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $bf21fc82f771e47b$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $0249870df7ab56c2$export$2e2bcd8739ae039)($0544d013f1b6ee02$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("transition", {
        elementType: (0, $2c2ec68e98eef83a$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === "auto" && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $01d449693793c717$export$2e2bcd8739ae039)($0544d013f1b6ee02$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("root", {
        ref: ref,
        elementType: $0544d013f1b6ee02$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $54ad27af1c6ce3ee$export$2e2bcd8739ae039)(typeof slotProps.backdrop === "function" ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $jYj5L.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("paper", {
        ref: paperRef,
        className: classes.paper,
        elementType: $0544d013f1b6ee02$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7uT18.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $b225d1766cd6a0c4$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $7uT18.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $7uT18.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $0544d013f1b6ee02$export$2e2bcd8739ae039 = $0544d013f1b6ee02$var$Popover;



var $k8hCU = parcelRequire("k8hCU");

var $kZnRZ = parcelRequire("kZnRZ");

var $9acxQ = parcelRequire("9acxQ");

var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $061b93424da093a2$export$2cf86a63a84fe23d(slot) {
    return (0, $jQsHx.default)("MuiMenu", slot);
}
const $061b93424da093a2$var$menuClasses = (0, $9FFKn.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $061b93424da093a2$export$2e2bcd8739ae039 = $061b93424da093a2$var$menuClasses;




var $7uT18 = parcelRequire("7uT18");
"use client";
const $c8a6a6db5cfaceac$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $c8a6a6db5cfaceac$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $c8a6a6db5cfaceac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $iryXh.default)(slots, (0, $061b93424da093a2$export$2cf86a63a84fe23d), classes);
};
const $c8a6a6db5cfaceac$var$MenuRoot = (0, $kZnRZ.default)((0, $0544d013f1b6ee02$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $k8hCU.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $c8a6a6db5cfaceac$export$4f7c51a5920c9f33 = (0, $kZnRZ.default)((0, $0544d013f1b6ee02$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $c8a6a6db5cfaceac$var$MenuMenuList = (0, $kZnRZ.default)((0, $fcd033271128b17f$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c8a6a6db5cfaceac$var$Menu = /*#__PURE__*/ $cQmXV.forwardRef(function Menu(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $f72a8065b49cc3d6$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $c8a6a6db5cfaceac$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $cQmXV.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $cQmXV.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $cQmXV.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $60d67c48e0ec431c$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("paper", {
        className: classes.paper,
        elementType: $c8a6a6db5cfaceac$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $4e2f37edc5e8d927$export$2e2bcd8739ae039)("list", {
        className: (0, $jYj5L.default)(classes.list, MenuListProps.className),
        elementType: $c8a6a6db5cfaceac$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === "function" ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $7uT18.jsx)($c8a6a6db5cfaceac$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $c8a6a6db5cfaceac$var$RTL_ORIGIN : $c8a6a6db5cfaceac$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === "function" ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $7uT18.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $c8a6a6db5cfaceac$export$2e2bcd8739ae039 = $c8a6a6db5cfaceac$var$Menu;



var $cQmXV = parcelRequire("cQmXV");


var $jYj5L = parcelRequire("jYj5L");

var $iryXh = parcelRequire("iryXh");

var $kMbdT = parcelRequire("kMbdT");

var $k8hCU = parcelRequire("k8hCU");

var $kZnRZ = parcelRequire("kZnRZ");

var $dGUQw = parcelRequire("dGUQw");

var $9acxQ = parcelRequire("9acxQ");





var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $746a373a9b1f1dbf$export$46f01d01378ec5a2(slot) {
    return (0, $jQsHx.default)("MuiDivider", slot);
}
const $746a373a9b1f1dbf$var$dividerClasses = (0, $9FFKn.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $746a373a9b1f1dbf$export$2e2bcd8739ae039 = $746a373a9b1f1dbf$var$dividerClasses;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $697ef7ade40ff4b2$export$81478e24460c57f2(slot) {
    return (0, $jQsHx.default)("MuiListItemIcon", slot);
}
const $697ef7ade40ff4b2$var$listItemIconClasses = (0, $9FFKn.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $697ef7ade40ff4b2$export$2e2bcd8739ae039 = $697ef7ade40ff4b2$var$listItemIconClasses;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $b8de7815c88ffe7f$export$1061006a0db3aeb5(slot) {
    return (0, $jQsHx.default)("MuiListItemText", slot);
}
const $b8de7815c88ffe7f$var$listItemTextClasses = (0, $9FFKn.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $b8de7815c88ffe7f$export$2e2bcd8739ae039 = $b8de7815c88ffe7f$var$listItemTextClasses;



var $9FFKn = parcelRequire("9FFKn");

var $jQsHx = parcelRequire("jQsHx");
function $f9c54624ec0e0fff$export$515f8c67b5305377(slot) {
    return (0, $jQsHx.default)("MuiMenuItem", slot);
}
const $f9c54624ec0e0fff$var$menuItemClasses = (0, $9FFKn.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $f9c54624ec0e0fff$export$2e2bcd8739ae039 = $f9c54624ec0e0fff$var$menuItemClasses;



var $7uT18 = parcelRequire("7uT18");
"use client";
const $5d20fc9119f94fa4$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $5d20fc9119f94fa4$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $iryXh.default)(slots, (0, $f9c54624ec0e0fff$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $5d20fc9119f94fa4$var$MenuItemRoot = (0, $kZnRZ.default)((0, $f06c8c49488afe70$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $k8hCU.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $5d20fc9119f94fa4$export$4334bb34c76fef24
})((0, $dGUQw.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap",
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $f9c54624ec0e0fff$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kMbdT.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $f9c54624ec0e0fff$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kMbdT.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $f9c54624ec0e0fff$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kMbdT.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kMbdT.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $f9c54624ec0e0fff$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $f9c54624ec0e0fff$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $746a373a9b1f1dbf$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $746a373a9b1f1dbf$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $b8de7815c88ffe7f$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $b8de7815c88ffe7f$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $697ef7ade40ff4b2$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: "padding-box"
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up("sm")]: {
                        minHeight: "auto"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $697ef7ade40ff4b2$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: "1.25rem"
                    }
                }
            }
        ]
    })));
const $5d20fc9119f94fa4$var$MenuItem = /*#__PURE__*/ $cQmXV.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $9acxQ.useDefaultProps)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $cQmXV.useContext((0, $c14e2cca981dfbcf$export$2e2bcd8739ae039));
    const childContext = $cQmXV.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $cQmXV.useRef(null);
    (0, $fb180c71a776d7cb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $5d20fc9119f94fa4$var$useUtilityClasses(props);
    const handleRef = (0, $ca6d5d8361d1622f$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $c14e2cca981dfbcf$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $7uT18.jsx)($5d20fc9119f94fa4$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $jYj5L.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $jYj5L.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $5d20fc9119f94fa4$export$2e2bcd8739ae039 = $5d20fc9119f94fa4$var$MenuItem;










const $d9fe6e94c1acda17$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
const $d9fe6e94c1acda17$var$defaultTemplate = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().defaultTemplate;
const $d9fe6e94c1acda17$var$label = {
    inputProps: {
        "aria-label": "Switch demo"
    }
};
const $d9fe6e94c1acda17$export$b6ec2c76874cb633 = ({ item: item, acceptRejectAnswer: acceptRejectAnswer, photoIndex: photoIndex })=>{
    const [anchorEl, setAnchorEl] = (0, $cQmXV.useState)(null);
    const [menuButtonClassNames, setMenuButtonClassNames] = (0, $cQmXV.useState)("task-answer-menu-button");
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const getPhotoName = ()=>{
        const dateString = (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.task?.created);
        const [datePart, timePart] = dateString.split(" ");
        const [day, month, year] = datePart.split("/");
        const [hours, minutes] = timePart.split(":");
        const pointName = item.task?.point?.name;
        const pointNameString = pointName.replace(/\s+/g, "_");
        const formattedDate = `${day}_${month}_${year}_${hours}_${minutes}_${pointNameString}`;
        return formattedDate;
    };
    const downloadAnswerPhoto = async (e, answer)=>{
        e.preventDefault();
        e.stopPropagation();
        //
        const status = answer.photos.length > 0 ? false : answer.photo ? false : true;
        if (status) return;
        setMenuButtonClassNames("task-answer-menu-button task-answer-menu-button--in-progress");
        const photo = answer.photos.length ? answer.photos[photoIndex]?.photo_url : answer.photo;
        const image = await fetch(`${photo}?chunk=${Date.now()}`);
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);
        const imageNameOrigin = getPhotoName();
        const link = document.createElement("a");
        link.href = imageURL;
        link.download = `${imageNameOrigin}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setMenuButtonClassNames("task-answer-menu-button");
        handleClose();
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "task-answer-menu",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: menuButtonClassNames,
                children: /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ea3e066c07add16$exports))), {
                    id: "basic-button",
                    "aria-controls": "basic-menu",
                    "aria-haspopup": "true",
                    "aria-expanded": open ? "true" : undefined,
                    onClick: handleClick
                })
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)((0, $c8a6a6db5cfaceac$export$2e2bcd8739ae039), {
                id: "basic-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    "aria-labelledby": "basic-button"
                },
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $5d20fc9119f94fa4$export$2e2bcd8739ae039), {
                        onClick: (e)=>{
                            downloadAnswerPhoto(e, item);
                        },
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "download_btn", $d9fe6e94c1acda17$var$me?.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $5d20fc9119f94fa4$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            acceptRejectAnswer("ACCEPT", item);
                            handleClose();
                        },
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "approv_btn", $d9fe6e94c1acda17$var$me?.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $5d20fc9119f94fa4$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            acceptRejectAnswer("REJECT", item);
                            handleClose();
                        },
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "reject_btn", $d9fe6e94c1acda17$var$me?.language)
                    })
                ]
            })
        ]
    });
};
class $d9fe6e94c1acda17$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            photoIndex: 0,
            answerIndex: 0,
            isOpen: false,
            isModal: false,
            newTask: {},
            newTaskLoading: false,
            networkTaskName: ""
        };
    }
    async componentDidUpdate(prevProps, prevState) {
        const { item: item } = this.props;
        const { networkTaskName: networkTaskName } = this.state;
        const networkId = item?.point?.network;
        if (networkId && !networkTaskName) (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: (0, $91ea30cb49819b9a$export$da688e121885cf48)["network"]
        }, (response)=>{
            // networks/ returns paginated { results, count } (and failedResponse() is the same
            // shape), never a bare array — read .results before searching.
            const list = Array.isArray(response) ? response : response?.results || [];
            const networkTaskName = list.find((item)=>item.id === networkId)?.name || "\u2014";
            this.setState({
                networkTaskName: networkTaskName
            });
        });
    }
    modalOpen = ()=>{
        this.setState({
            isModal: true
        });
    };
    modalClose = ()=>{
        this.setState({
            isModal: false
        });
    };
    newTaskOnChange = (property, value)=>{
        // let item = this.state.newTask;
        // item[property] = value;
        // this.setState({ newTask: item });
        this.setState((prevState)=>({
                newTask: {
                    ...prevState.newTask,
                    [property]: value
                }
            }));
    };
    onSaveEditorImage = (index, image)=>{
        const { newTask: newTask } = this.state;
        if (!image) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: this.props.me,
                image: image
            }
        }, (image)=>{
            if (image?.id) this.setState({
                newTask: {
                    ...newTask,
                    images: [
                        image
                    ]
                }
            });
        });
    };
    newTaskSubmit = ()=>{
        let { newTask: newTask } = this.state;
        let queueLoadingTimer = 0;
        let queueLoadingStep = 8000;
        let itemPost = Object.assign({}, newTask);
        itemPost.components = newTask.components.map((i)=>i.id);
        itemPost.tags = newTask.tags?.map((i)=>i.id);
        itemPost.network = newTask?.network?.id || null;
        itemPost.point = newTask?.point?.id || null;
        itemPost.end = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(itemPost.end).format("yyyy-MM-DDT23:59:59");
        itemPost.images = newTask.images.map((i)=>i.id ? i.id : i);
        itemPost.created_by = newTask.created_by?.id || $d9fe6e94c1acda17$var$me?.id || null;
        itemPost.template = itemPost.template === "" ? $d9fe6e94c1acda17$var$defaultTemplate : itemPost.template;
        const { validate: validate, errors: errors } = (0, $3b579ca6158bc61b$export$6daeeb4cea31fc5)("task", itemPost);
        if (!validate) {
            this.setState({
                errors: errors
            });
            return;
        }
        if (itemPost.images.every((image)=>image.id)) {
            itemPost.images = newTask.images?.map((image)=>image.id);
            this.createNewTask(itemPost);
        } else {
            this.setState({
                newTaskLoading: true
            });
            itemPost.images = newTask.images?.map((image, index)=>{
                if (image.id) {
                    itemPost.images = [
                        image.id
                    ];
                    this.createNewTask(itemPost);
                    this.setState({
                        itemPost: itemPost,
                        newTaskLoading: false,
                        isModal: false
                    });
                    return image.id;
                } else {
                    setTimeout((args)=>{
                        (0, $3b579ca6158bc61b$export$d6f5c7e166773679)(image.image, this.props.me, (createdImg)=>{
                            if (createdImg.id) {
                                itemPost.images.push(createdImg.id);
                                if (index === newTask.images.length - 1) {
                                    itemPost.images = itemPost.images?.filter((item)=>!!item);
                                    this.createNewTask(itemPost);
                                    this.setState({
                                        itemPost: itemPost,
                                        newTaskLoading: false,
                                        isModal: false
                                    });
                                }
                            } else console.error("image was not created");
                        });
                    }, queueLoadingTimer);
                    queueLoadingTimer += queueLoadingStep;
                }
            });
        }
    };
    sendRejectAnswer = (answerId)=>{
        const body = {
            object_id: answerId,
            object_type: "answer",
            is_approved: false
        };
        this.callUpdateAnswer(body, ()=>{
            this.props.loadTask(this.props.item?.id);
        });
    };
    createNewTask = (data)=>{
        if (!data) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "tasks/",
            post: data
        }, (response)=>{
            if (response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "task_saved", $d9fe6e94c1acda17$var$me?.language));
                this.setState({
                    VIEW: "VIEW",
                    isModal: false,
                    errors: {}
                });
                this.sendRejectAnswer(data.answer_id); //true for send reject answer
            } else {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving item. Error: " + JSON.stringify(response));
                console.log(response);
            }
        });
    };
    printReport = (e)=>{
        e.preventDefault();
        // let printContents = document.querySelector(".task-container").innerHTML;
        // let originalContents = document.body.innerHTML;
        // document.body.innerHTML = printContents;
        window.print();
    // document.body.innerHTML = originalContents;
    };
    showBigImg = (answerIndex)=>{
        this.setState({
            isOpen: true,
            answerIndex: answerIndex
        });
    };
    callUpdateAnswer = (body, cb)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "approvals/",
            post: body
        }, (r)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "answer_saved", $d9fe6e94c1acda17$var$me?.language));
            cb();
        });
    };
    activePhotoIndex = (index = 0)=>{
        this.setState({
            photoIndex: index
        });
        return index;
    };
    acceptRejectAnswer = (type, answer)=>{
        const { item: item } = this.props;
        const { photoIndex: photoIndex } = this.state;
        const body = {
            object_id: answer.id,
            object_type: "answer",
            is_approved: null
        };
        if (type == "REJECT") {
            const newTask = Object.assign({}, item);
            body.is_approved = false;
            let date = new Date(newTask.end);
            date = date.setDate(date.getDate() + 7);
            newTask.end = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(date).format("yyyy-MM-DDT23:59:59");
            newTask.template = "";
            newTask.answer_id = answer.id;
            // newTask.status = "rejected";
            if (answer.photos.length > 0) {
                newTask.images = [
                    {
                        image: answer.photos[photoIndex]?.photo_url
                    }
                ];
                newTask.imageFromReview = {
                    image: answer.photos[photoIndex]?.photo_url
                };
            } else if (answer.photo) {
                newTask.images = [
                    {
                        image: answer.photo
                    }
                ];
                newTask.imageFromReview = {
                    image: answer.photo
                };
            }
            this.setState({
                newTask: newTask,
                isModal: true
            });
        } else if (type == "ACCEPT") {
            body.is_approved = true;
            this.callUpdateAnswer(body, ()=>{
                this.props.loadTask(this.props.item?.id);
            });
        }
    };
    render() {
        let { item: item, answers: answers } = this.props;
        const { isOpen: isOpen, isModal: isModal, photoIndex: photoIndex, newTaskLoading: newTaskLoading, networkTaskName: networkTaskName } = this.state;
        const lang = $d9fe6e94c1acda17$var$me?.language;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "task-content",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "task-info",
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "row text-left",
                                children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "col-md-12",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "name", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: item && item.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "description", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: item.description || "\u2014"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "addresses", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: (0, $b79edb411f97c469$export$a985788839f3e1fb)(item)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "network", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: networkTaskName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "date_creation", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: item && (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.created)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "created_by", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: (0, $b79edb411f97c469$export$99f62f7c9ad8c7ce)("", item)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "supervisor", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: (0, $b79edb411f97c469$export$43d108cb566ddefd)("", item)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "merchendiser", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: (0, $b79edb411f97c469$export$7f6290e025a69ad2)("", item)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("label", {
                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "status", lang)
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                    children: (0, $b79edb411f97c469$export$1664ae65e1862c28)("", item)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "mt-3 print-report-container",
                                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
                                                href: "#",
                                                target: "_blank",
                                                onClick: this.printReport,
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                        className: "fa fa-print"
                                                    }),
                                                    " ",
                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "print_report", lang)
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "task-photo",
                            children: item?.images?.length > 0 ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                src: item?.images?.[0]?.image || "",
                                onClick: this.props.setOpen
                            }) : null
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "col-md-12",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("h3", {
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "responses", lang)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "task-answers-list",
                                children: answers.map((answer, index)=>{
                                    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        "data-answer-id": index,
                                        className: "task-answer photo-carousel",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "task-answer-photo-container",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)($d9fe6e94c1acda17$export$b6ec2c76874cb633, {
                                                        item: answer,
                                                        photoIndex: this.state.photoIndex,
                                                        acceptRejectAnswer: this.acceptRejectAnswer
                                                    }),
                                                    answer.photos !== null ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                        className: "answer-photo-wrapper",
                                                        children: answer.photos.length > 0 ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $5588f76353c86461$export$2e2bcd8739ae039), {
                                                            photos: answer.photos,
                                                            answerId: index,
                                                            clickCallback: ()=>this.showBigImg(index),
                                                            activePhotoIndex: this.activePhotoIndex,
                                                            viewMode: "group"
                                                        }) : answer.photo && /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                                            src: answer.photo,
                                                            className: "img-placeholder",
                                                            onClick: ()=>answer.photo && this.setState({
                                                                    isOpen: true,
                                                                    photoIndex: index
                                                                })
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "task-answer-info",
                                                children: [
                                                    answer.boolean_answer !== null ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "answer-info-radio-wrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                className: "mr-2",
                                                                children: [
                                                                    answer.boolean_answer ? /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e223cdd37b7e8f69$exports))), {
                                                                        color: "info"
                                                                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a87f005b50c1f609$exports))), {
                                                                        color: "info"
                                                                    }),
                                                                    " ",
                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "yes", $d9fe6e94c1acda17$var$me?.language)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                children: [
                                                                    !answer.boolean_answer ? /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e223cdd37b7e8f69$exports))), {
                                                                        color: "info"
                                                                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a87f005b50c1f609$exports))), {
                                                                        color: "info"
                                                                    }),
                                                                    " ",
                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "no", $d9fe6e94c1acda17$var$me?.language)
                                                                ]
                                                            })
                                                        ]
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                                        children: answer.answer
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "d-flex task-answer-info-checking",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                children: [
                                                                    !!answer.visit?.user && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                        children: answer.visit?.user?.first_name + " " + answer.visit?.user?.last_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                        children: (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(answer.created)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    children: answer.is_supervised && /*#__PURE__*/ (0, $7uT18.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cbd0ad7d0024bb33$exports))), {
                                                                        color: "success"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                        className: "tags-wrapper mt-3",
                                                        children: answer.selected_tags.map((tag, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                className: "label rounded",
                                                                children: tag
                                                            }, index))
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            isOpen && /*#__PURE__*/ (0, $7uT18.jsx)((0, $863febd3c37c55c4$export$2e2bcd8739ae039), {
                                mainSrc: answers[this.state.answerIndex]?.photos[photoIndex]?.photo_url || answers[photoIndex].photo,
                                nextSrc: answers[this.state.answerIndex]?.photos[(photoIndex + 1) % answers.length]?.photo_url || answers[(photoIndex + 1) % answers.length]?.photo,
                                prevSrc: answers[this.state.answerIndex]?.photos[(photoIndex - 1) % answers.length]?.photo_url || answers[(photoIndex - 1) % answers.length]?.photo,
                                onCloseRequest: ()=>this.setState({
                                        isOpen: false
                                    }),
                                onMovePrevRequest: ()=>this.setState({
                                        photoIndex: answers[this.state.answerIndex]?.photos.length > 0 ? (photoIndex + answers[this.state.answerIndex]?.photos?.length - 1) % answers[this.state.answerIndex]?.photos?.length : (photoIndex + answers.length - 1) % answers.length
                                    }),
                                onMoveNextRequest: ()=>this.setState({
                                        photoIndex: answers[this.state.answerIndex]?.photos.length > 0 ? (photoIndex + answers[this.state.answerIndex]?.photos?.length - 1) % answers[this.state.answerIndex]?.photos?.length : (photoIndex + answers.length + 1) % answers.length
                                    })
                            }),
                            isModal && /*#__PURE__*/ (0, $7uT18.jsxs)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
                                isShow: isModal,
                                onClose: this.modalClose,
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                        loading: newTaskLoading,
                                        disP: true,
                                        type: "spinner"
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $d1774b39c619190c$export$fee3520bdfbfe55c), {
                                        item: this.state.newTask,
                                        type: "point",
                                        newTaskFromReview: true,
                                        onChange: this.newTaskOnChange,
                                        onSaveEditorImage: this.onSaveEditorImage,
                                        submit: this.newTaskSubmit,
                                        setOpen: ()=>this.setState({
                                                isOpen: true
                                            }),
                                        errors: this.state.errors,
                                        isImageEditable: true
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}








const $51ef8b1748b26f2f$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
const $51ef8b1748b26f2f$var$defaultTemplate = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().defaultTemplate;
class $51ef8b1748b26f2f$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.modeTypes = {
            view: "view",
            edit: "edit"
        };
        this.state = {
            mode: this.props.match.params?.id ? this.modeTypes.view : this.modeTypes.edit,
            new: false,
            type: "point",
            createTaskWith: "single",
            item: {
                images: [],
                company: null,
                title: "",
                start: new Date(),
                end: new Date(new Date().setHours(23, 59, 59)),
                tags: [],
                components: [],
                priority: 2,
                template: ""
            },
            photoIndex: 0,
            isOpen: false,
            answers: [],
            errors: {}
        };
    }
    componentDidMount() {
        const { id: id, type: type } = this.props.match.params;
        const { pathname: pathname, hash: hash } = this.props.location;
        if (id) {
            let mode = this.modeTypes.view;
            if (~hash.indexOf(this.modeTypes.edit)) mode = this.modeTypes.edit;
            this.setState({
                mode: mode
            });
        }
        if (type === "point" || type === "network") this.setState((prevState)=>{
            return {
                mode: this.modeTypes.edit,
                new: true,
                type: type,
                item: {
                    ...this.state.item,
                    end: (0, $3b579ca6158bc61b$export$f996c1bb09f018d3)(prevState.item.end, 14)
                }
            };
        });
        else if (id) this.load(id);
    }
    submit = ()=>{
        let { item: item, createTaskWith: createTaskWith } = this.state;
        let itemPost = {
            ...item
        };
        let itemPostGroup = {};
        itemPost.components = item.components?.map((i)=>i.id);
        itemPost.images = item.images?.map((i)=>i?.id);
        itemPost.network = item?.network?.id || null;
        itemPost.point = item?.point?.id || null;
        itemPost.point_groups = item?.point_groups?.id || null;
        itemPost.user = itemPost?.user?.id || $51ef8b1748b26f2f$var$me?.id || null;
        itemPost.created_by = itemPost.user; // save both fields to compatibility
        itemPost.is_active = true;
        itemPost.start = item.new ? new Date() : (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(item.start).format("yyyy-MM-DDT00:00");
        itemPost.end = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(itemPost.end).format("yyyy-MM-DDT23:59:59");
        itemPost.company = $51ef8b1748b26f2f$var$me?.company?.id || null;
        itemPost.template = itemPost.template === "" ? $51ef8b1748b26f2f$var$defaultTemplate : itemPost.template;
        itemPost.title_group_uploads = item?.title_group_uploads || "";
        if (itemPost.point_groups) {
            itemPostGroup.action_name = itemPost.title_group_uploads;
            itemPostGroup.group_id = item?.point_groups?.id;
            itemPostGroup.template = itemPost.template;
            itemPostGroup.tasks = [
                {
                    title: item?.title,
                    description: item?.description || "",
                    start: itemPost.start,
                    end: itemPost.end,
                    images: itemPost.images
                }
            ];
        }
        const { validate: validate, errors: errors } = (0, $3b579ca6158bc61b$export$6daeeb4cea31fc5)("task", itemPost, createTaskWith);
        if (!validate) {
            this.setState({
                errors: errors
            });
            return;
        }
        const url = item?.id ? `tasks/${item.id}/` : itemPost.point_groups ? "tasks/bulk-create-by-group/" : "tasks/";
        // const url = item?.id ? `tasks/${item.id}/` : "tasks/bulk_create/";
        const method = item?.id ? "PATCH" : "POST";
        const postBody = itemPost.point_groups && itemPostGroup ? itemPostGroup : itemPost;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: method,
            url: url,
            post: postBody
        }, (response)=>{
            if (response.action?.trim().length > 0) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "create_success_group_task_msg", $51ef8b1748b26f2f$var$me?.language));
                setTimeout(()=>{
                    window.location.replace("/task/");
                    document.location.reload();
                }, 1000);
            } else if (response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "date_saved", $51ef8b1748b26f2f$var$me?.language));
                if (this.state.new) {
                    window.location.replace("/task/" + response.id);
                    document.location.reload();
                }
            } else {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving item. Error: " + JSON.stringify(response), {
                    position: "top"
                });
                console.log(response);
            }
        });
    };
    loadAnswers = (id)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "answers/?task=" + id
        }, (response)=>{
            const answersWithDefaultTemplate = response.results?.map((el)=>({
                    ...el,
                    task: {
                        ...el.task,
                        template: ""
                    }
                }));
            this.setState({
                answers: answersWithDefaultTemplate
            });
        });
    };
    load = (id)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "tasks/" + id + "/"
        }, (r)=>{
            let type = "point";
            if (r.point) type = "point";
            if (r.network) type = "network";
            this.loadAnswers(id);
            this.setState({
                item: r,
                type: type
            });
        });
    };
    removeTask = ()=>{
        const { history: history } = this.props;
        if (this.state.item.created_by.id !== $51ef8b1748b26f2f$var$me.id) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "task_created_by_err_msg", $51ef8b1748b26f2f$var$me?.language));
        else (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: "tasks/" + this.props.match.params?.id + "/"
        }, (r)=>{
            history.push("/task/");
        });
    };
    onChange = (property, value)=>{
        let item = this.state.item;
        item[property] = value;
        this.setState({
            item: item
        });
    };
    onSaveEditorImage = (index, image)=>{
        const { item: item } = this.state;
        if (!image) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: $51ef8b1748b26f2f$var$me,
                image: image
            }
        }, (image)=>{
            if (image?.id) this.setState({
                item: {
                    ...item,
                    images: [
                        image
                    ]
                }
            });
        });
    };
    selectTaskPointType = (type)=>{
        /*  this.setState({ createTaskWith: type }); */ this.setState((prevState)=>({
                createTaskWith: type,
                item: {
                    ...prevState.item,
                    point: type === "point_groups" ? undefined : prevState.item.point,
                    point_groups: type === "single" ? undefined : prevState.item.point_groups
                }
            }));
    };
    render() {
        let { item: item, photoIndex: photoIndex, isOpen: isOpen, type: type, answers: answers } = this.state;
        let images = item?.images?.map((i)=>i.image) || [];
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid single-task-container",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "task-container",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "row task-header",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                className: "col-md-8 d-flex align-items-center",
                                children: /*#__PURE__*/ (0, $7uT18.jsx)("h1", {
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "task_details_title", $51ef8b1748b26f2f$var$me?.language)
                                })
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "col-md-4 text-right",
                                children: [
                                    !this.state.new && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "btn btn-outline-primary d-inline-block",
                                        onClick: this.removeTask,
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                className: "fa fa-remove"
                                            }),
                                            " ",
                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "remove_btn", $51ef8b1748b26f2f$var$me?.language)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                                        className: "btn btn-primary ml-2",
                                        to: "/task/",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                className: "fa fa-arrow-left"
                                            }),
                                            " ",
                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b56eeb2175b87a73), "back_btn", $51ef8b1748b26f2f$var$me?.language)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    this.state.mode === this.modeTypes.view ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $d9fe6e94c1acda17$export$2e2bcd8739ae039), {
                        item: item,
                        type: type,
                        setOpen: ()=>this.setState({
                                isOpen: true
                            }),
                        answers: answers,
                        loadTask: this.load
                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $d1774b39c619190c$export$fee3520bdfbfe55c), {
                        item: item,
                        type: type,
                        onChange: this.onChange,
                        submit: ()=>this.submit(),
                        setOpen: ()=>this.setState({
                                isOpen: true
                            }),
                        onSaveEditorImage: this.onSaveEditorImage,
                        isImageEditable: true,
                        errors: this.state.errors,
                        selectTaskPointType: {
                            type: this.state.createTaskWith,
                            fn: this.selectTaskPointType
                        }
                    }),
                    isOpen && /*#__PURE__*/ (0, $7uT18.jsx)((0, $863febd3c37c55c4$export$2e2bcd8739ae039), {
                        mainSrc: images[photoIndex],
                        onCloseRequest: ()=>this.setState({
                                isOpen: false
                            }),
                        onMovePrevRequest: ()=>this.setState({
                                photoIndex: (photoIndex + images.length - 1) % images.length
                            }),
                        onMoveNextRequest: ()=>this.setState({
                                photoIndex: (photoIndex + 1) % images.length
                            })
                    })
                ]
            })
        });
    }
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");




var $Yxlsx = parcelRequire("Yxlsx");






const $975ee123f7d0c690$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $975ee123f7d0c690$export$81351f0394755609 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.dataTypeList = [
            {
                id: 1,
                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "network_label", $975ee123f7d0c690$var$me.language),
                value: "network"
            },
            {
                id: 2,
                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "point_label", $975ee123f7d0c690$var$me.language),
                value: "point"
            }
        ];
        this.state = {
            totalDataSize: 0,
            sizePerPage: 10,
            pageAmount: 1,
            page: 1,
            errorList: [
                ""
            ],
            errors: {
                name: "",
                point: "",
                network: "",
                template: "",
                tasks: []
            },
            filter: {
                dataType: null,
                network: null,
                point: null,
                template: null,
                bulkName: ""
            },
            tasks: [],
            uploadFile: null,
            fileDataToSend: [],
            uploadLogs: [],
            nextUploadPage: null
        };
    }
    componentDidMount() {}
    validate = (formValues)=>{
        let errors = {
            ...this.state.errors
        };
        let hasErrors = false;
        const errMsg = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "complete_at_least_one_task_msg", $975ee123f7d0c690$var$me.language);
        if (!formValues.tasks?.length) {
            this.setState({
                errorList: [
                    (0, $3b579ca6158bc61b$export$ddec11078e1d813a)(errMsg)
                ]
            });
            hasErrors = true;
        } else {
            this.setState({
                errorList: []
            });
            formValues.tasks.map((task, taskIndex)=>{
                errors["tasks"][taskIndex] = {
                    title: "",
                    description: "",
                    start: null,
                    end: null,
                    point: "",
                    network: ""
                };
                Object.entries(task).map((entry, index)=>{
                    if (!entry[1]?.length && entry[0] !== "point" && entry[0] !== "network") {
                        errors["tasks"][taskIndex][entry[0]] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
                        hasErrors = true;
                    }
                });
            });
        }
        if (!formValues.action_name) errors["name"] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
        if (!formValues.template) errors["template"] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
        this.setState({
            errors: errors
        });
        console.log("formValues", formValues);
        return !hasErrors;
    };
    submit = (fileDataToSend = [])=>{
        let tasks = this.prepareItemsToSend(this.state, fileDataToSend);
        if (!this.validate(tasks)) return;
        this.setState({
            errorList: [
                ""
            ],
            errors: {
                name: "",
                point: "",
                network: "",
                template: "",
                tasks: []
            }
        });
        (0, $c9936523dc38c641$export$46f383001bf60e04)({
            method: "POST",
            url: "tasks/bulk_create/",
            post: tasks
        }, async (response)=>{
            const result = await response.json();
            if (response.status === 200) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Items successfully saved", {
                    position: "bottom-right"
                });
                this.setState({
                    tasks: [],
                    uploadFile: null,
                    fileDataToSend: []
                });
            }
            if (response.status === 400) this.setState({
                errorList: [
                    result.details
                ]
            });
        });
    };
    prepareItemsToSend = (state, fileDataToSend)=>{
        const points = fileDataToSend.map((item)=>item.point).filter((point)=>!!point) || [];
        const networks = fileDataToSend.map((item)=>item.network).filter((network)=>!!network) || [];
        return {
            action_name: state.filter.bulkName,
            networks: networks,
            points: points,
            template: state.filter.template,
            tasks: fileDataToSend.length ? fileDataToSend : state.tasks?.map((item, idx)=>({
                    title: item.title || "",
                    description: item.info || "",
                    start: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(item.start).format("yyyy-MM-DDT00:00"),
                    end: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(item.end).format("yyyy-MM-DDT00:00"),
                    point: item.point || "",
                    network: item.network || ""
                }))
        };
    };
    onChange = (property, value, idx)=>{
        let tasks = this.state.tasks;
        tasks[idx][property] = value;
        this.setState({
            tasks: tasks
        });
    };
    changeFilter = (filterEntity, item)=>{
        let filter = {
            ...this.state.filter
        };
        filter[filterEntity] = item?.id;
        this.setState((prevState)=>({
                filter: filter
            }));
    };
    handleCangeDataType = (option)=>{
        this.setState((prevState)=>({
                filter: {
                    ...prevState.filter,
                    dataType: option.value
                }
            }));
    };
    handleChangeBulkName = (e)=>{
        this.setState((prevState)=>({
                filter: {
                    ...prevState.filter,
                    bulkName: e.target.value || ""
                }
            }));
    };
    uploadFile = (acceptedFiles)=>{
        let file = acceptedFiles[0];
        let reader = new FileReader();
        reader.onload = (e)=>{
            const uploadFile = reader.result.split(/\r?\n/).filter((item)=>item?.length);
            this.getUploadData(uploadFile);
            this.setState({
                uploadFile: file
            });
        };
        reader.readAsText(file);
    };
    getUploadData = (stringArray = [
        ""
    ])=>{
        stringArray.shift();
        const preparedUploadData = stringArray.map((row, index)=>{
            const fields = stringArray[index].split(",");
            return {
                title: fields[0] || "",
                description: fields[1] || "",
                start: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(fields[2], "DD/MM/YYYY").format("yyyy-MM-DDT00:00"),
                end: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(fields[3], "DD/MM/YYYY").format("yyyy-MM-DDT00:00"),
                point: fields[4] || "",
                network: fields[5] || ""
            };
        });
        this.setState({
            fileDataToSend: preparedUploadData
        });
        return preparedUploadData;
    };
    renderErrors = (errors = {})=>{
        const RenderErrorHead = ()=>/*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "line_title", $975ee123f7d0c690$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "name_title", $975ee123f7d0c690$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "description_title", $975ee123f7d0c690$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "start_date_title", $975ee123f7d0c690$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "end_date_title", $975ee123f7d0c690$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "point_label", $975ee123f7d0c690$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "network_label", $975ee123f7d0c690$var$me.language)
                    })
                ]
            });
        const RenderErrorBody = ()=>{
            return errors?.tasks?.map((taskError, index)=>/*#__PURE__*/ (0, $7uT18.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: index
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.title
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.description
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.start
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.end
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.point
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.network
                        })
                    ]
                }, index)) || null;
        };
        return errors.tasks?.length && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "error-task-list",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)(RenderErrorHead, {}),
                /*#__PURE__*/ (0, $7uT18.jsx)(RenderErrorBody, {})
            ]
        });
    };
    render() {
        const { errorList: errorList, filter: filter, uploadFile: uploadFile, fileDataToSend: fileDataToSend, errors: errors } = this.state;
        const isShowErrorList = errorList.some((item)=>!!item);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "imp-page",
            children: [
                isShowErrorList && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "imp-error-box",
                    children: errorList?.map((error, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: error
                        }, index))
                }),
                !!errors.tasks?.length && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "imp-error-box",
                    children: this.renderErrors(errors)
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "imp-filter-bar",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                            type: "text",
                            className: "imp-name-input",
                            placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_name", $975ee123f7d0c690$var$me.language),
                            value: filter.bulkName,
                            onChange: this.handleChangeBulkName
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                            entity: "template",
                            value: filter.template,
                            asynch: true,
                            onChange: (o)=>this.changeFilter("template", o)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "imp-dropzone-row",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $c89956014bc8c37c$export$2e2bcd8739ae039), {
                                    onDrop: (acceptedFiles)=>this.uploadFile(acceptedFiles),
                                    accept: ".csv",
                                    multiple: false,
                                    children: ({ getRootProps: getRootProps, getInputProps: getInputProps })=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "imp-dropzone",
                                            ...getRootProps(),
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    ...getInputProps()
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "upload_file"
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    children: uploadFile?.name || (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "click_or_drag_file", $975ee123f7d0c690$var$me.language)
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "imp-btn imp-btn--primary",
                                    disabled: !fileDataToSend?.length,
                                    onClick: ()=>this.submit(fileDataToSend),
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "save"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_btn", $975ee123f7d0c690$var$me.language)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



var $1ZXxd = parcelRequire("1ZXxd");






const $ec0f988d07352ede$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
// export const crateFileXLSX = (data: any, fileName: string) => {
//     return new File([data], fileName, {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
// };
class $ec0f988d07352ede$export$127c3e2ceac11eb2 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.dataTypeList = [
            {
                id: 1,
                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "network_label", $ec0f988d07352ede$var$me.language),
                value: "network"
            },
            {
                id: 2,
                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "point_label", $ec0f988d07352ede$var$me.language),
                value: "point"
            }
        ];
        this.state = {
            totalDataSize: 0,
            sizePerPage: 10,
            pageAmount: 1,
            page: 1,
            errorList: [
                ""
            ],
            errors: {
                name: "",
                point: "",
                network: "",
                template: "",
                tasks: []
            },
            filter: {
                dataType: null,
                network: null,
                point: null,
                template: null,
                bulkName: ""
            },
            tasks: [],
            uploadFile: null,
            fileDataToSend: {}
        };
    }
    componentDidMount() {}
    validate = (formValues)=>{
        let { errors: errors } = this.state;
        let hasErrors = false;
        if (!formValues.tasks?.length) errors["tasks"] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
        else formValues.tasks.map((task, taskIndex)=>{
            errors["tasks"][taskIndex] = {
                title: "",
                description: "",
                start: null,
                end: null
            };
            Object.entries(task).map((entry, index)=>{
                if (!entry[1]?.length) {
                    errors["tasks"][taskIndex][entry[0]] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
                    hasErrors = true;
                }
            });
        });
        if (!formValues.action_name) errors["name"] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
        if (!formValues.template) errors["template"] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
        // console.log("formValues", formValues);
        return !hasErrors;
    };
    submit = (fileDataToSend = [])=>{
        let tasks = this.prepareItemsToSend(this.state, fileDataToSend);
        if (!this.validate(tasks)) return;
        this.setState({
            errorList: [
                ""
            ]
        });
        (0, $c9936523dc38c641$export$46f383001bf60e04)({
            method: "POST",
            url: "assortment_matrix/bulk_create/",
            post: tasks
        }, async (response)=>{
            const result = await response.json();
            if (response.status === 200) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Items successfully saved", {
                    position: "bottom-right"
                });
                this.setState({
                    tasks: [],
                    uploadFile: null,
                    fileDataToSend: {}
                });
            }
            if (response.status === 400) this.setState({
                errorList: [
                    result.details
                ]
            });
        });
    };
    prepareItemsToSend = (state, fileDataToSend)=>{
        return {
            action_name: state.filter.bulkName,
            points: fileDataToSend.pointCodes,
            assortment_matrix_list: fileDataToSend.assortmentMatrix
        };
    };
    deleteRow = (idx)=>{
        this.setState((prevState)=>({
                tasks: prevState.tasks.filter((item, index)=>index !== idx)
            }));
    };
    addRow = (i)=>{
        this.setState({
            tasks: [
                ...this.state.tasks,
                {
                    title: "",
                    info: "",
                    start: new Date(),
                    end: new Date()
                }
            ]
        });
    };
    onChange = (property, value, idx)=>{
        let tasks = this.state.tasks;
        tasks[idx][property] = value;
        this.setState({
            tasks: tasks
        });
    };
    changeFilter = (filterEntity, item)=>{
        let filter = {
            ...this.state.filter
        };
        filter[filterEntity] = item?.id;
        this.setState((prevState)=>({
                filter: filter
            }));
    };
    handleCangeDataType = (option)=>{
        this.setState((prevState)=>({
                filter: {
                    ...prevState.filter,
                    dataType: option.value
                }
            }));
    };
    handleChangeBulkName = (e)=>{
        this.setState((prevState)=>({
                filter: {
                    ...prevState.filter,
                    bulkName: e.target.value || ""
                }
            }));
    };
    uploadFile = (acceptedFiles)=>{
        let file = acceptedFiles[0];
        let reader = new FileReader();
        reader.onload = (e)=>{
            // console.log("reader.result", reader.result, file);
            // return;
            const uploadFile = reader.result.split(/\r?\n/).filter((item)=>item?.length);
            this.getUploadData(uploadFile);
            this.setState({
                uploadFile: file
            });
        };
        reader.readAsText(file);
        reader.readAsBinaryString(file);
        reader.readAsDataURL(file);
    };
    getUploadData = (stringArray = [
        ""
    ])=>{
        let pointCodes = stringArray.shift();
        let productCodes = [];
        let nonEmptyFields = [];
        let assortmentMatrix = {};
        pointCodes = pointCodes.split(",").filter((item, index)=>!!index);
        productCodes = stringArray.map((row, rowIndex)=>row.split(",")[0]);
        const preparedUploadData = stringArray.map((row, index)=>{
            let fields = row.split(",");
            let nonEmptyProductCodes = [];
            fields.shift();
            fields.map((field, fieldIndex)=>{
                if (!!field.trim()?.length) {
                    nonEmptyProductCodes.push(fields[0]);
                    nonEmptyFields.push([
                        fieldIndex,
                        index
                    ]);
                    if (!!assortmentMatrix[pointCodes[fieldIndex]]) assortmentMatrix[pointCodes[fieldIndex]].push(productCodes[index]);
                    else assortmentMatrix[pointCodes[fieldIndex]] = [
                        productCodes[index]
                    ];
                }
            });
        });
        this.setState({
            fileDataToSend: {
                assortmentMatrix: assortmentMatrix,
                pointCodes: pointCodes
            }
        });
        return preparedUploadData;
    };
    renderUploadFileResult = (stringArray = [
        ""
    ])=>{
        const titles = stringArray.shift();
        const renderHead = (numRow = 0)=>/*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                className: "primary text-center",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                    children: titles?.split(",").map((field, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("th", {
                            children: field
                        }, index))
                })
            });
        const renderList = (numRow = 0)=>{
            return /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                children: stringArray.map((row, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                        children: stringArray[index].split(",").map((field, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                children: field
                            }, index))
                    }, index))
            });
        };
        return stringArray.some((item)=>!!item) && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "table-scroll-x",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                className: "table table-hover table-bordered table-tasks-import",
                children: [
                    renderHead(),
                    renderList()
                ]
            })
        });
    };
    render() {
        const { errorList: errorList, filter: filter, uploadFile: uploadFile, fileDataToSend: fileDataToSend } = this.state;
        const isShowErrorList = errorList.some((item)=>!!item);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "imp-page",
            children: [
                isShowErrorList && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "imp-error-box",
                    children: errorList?.map((error, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: error
                        }, index))
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "imp-filter-bar",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                            type: "text",
                            className: "imp-name-input",
                            placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_name", $ec0f988d07352ede$var$me.language),
                            value: filter.bulkName,
                            onChange: this.handleChangeBulkName
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "imp-dropzone-row",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $c89956014bc8c37c$export$2e2bcd8739ae039), {
                                    onDrop: (acceptedFiles)=>this.uploadFile(acceptedFiles),
                                    accept: ".csv, .xlsx",
                                    multiple: false,
                                    children: ({ getRootProps: getRootProps, getInputProps: getInputProps })=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "imp-dropzone",
                                            ...getRootProps(),
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    ...getInputProps()
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "upload_file"
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    children: uploadFile?.name || (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "click_or_drag_file", $ec0f988d07352ede$var$me.language)
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "imp-btn imp-btn--primary",
                                    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1ZXxd))).isEmpty(fileDataToSend),
                                    onClick: ()=>this.submit(fileDataToSend),
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "save"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_btn", $ec0f988d07352ede$var$me.language)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



var $7uT18 = parcelRequire("7uT18");
parcelRequire("cQmXV");

const $47bab1813fff772a$export$a455218a85c89869 = ({ className: className = "", children: children })=>{
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: `field-container ${className}`,
        children: children
    });
};




var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


var $jNuvi = parcelRequire("jNuvi");

var $cQmXV = parcelRequire("cQmXV");







var $cQmXV = parcelRequire("cQmXV");

var $857b4eaa7b9cc320$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $857b4eaa7b9cc320$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(_ref, $857b4eaa7b9cc320$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $cQmXV.useRef)(undefined);
    var mounted = (0, $cQmXV.useRef)(false);
    var _useState = (0, $cQmXV.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $cQmXV.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $cQmXV.useState)(propsDefaultOptions === true), _useState6 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $cQmXV.useState)(undefined), _useState8 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $cQmXV.useState)([]), _useState10 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $cQmXV.useState)(false), _useState12 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $cQmXV.useState)({}), _useState14 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $cQmXV.useState)(undefined), _useState16 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $cQmXV.useState)(undefined), _useState18 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $cQmXV.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $cQmXV.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $cQmXV.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $cQmXV.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $66ac58ed5b1ea838$export$61196ced6d74a310)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, optionsCache), {}, (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}















parcelRequire("3h5eW");



var $03db2c708f724e45$var$AsyncSelect = /*#__PURE__*/ (0, $cQmXV.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $857b4eaa7b9cc320$export$3b14a55fb2447963)(props);
    var selectProps = (0, $e7b1f27543b51422$export$3b14a55fb2447963)(stateManagedProps);
    return /*#__PURE__*/ $cQmXV.createElement((0, $4d787bf2c3872ec9$export$25ce5a424b770e84), (0, $jNuvi.default)({
        ref: ref
    }, selectProps));
});
var $03db2c708f724e45$export$2e2bcd8739ae039 = $03db2c708f724e45$var$AsyncSelect;



var $1Spf6 = parcelRequire("1Spf6");



class $7f76693712ba171d$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    static defaultProps = {
        async: false
    };
    constructor(props){
        super(props);
        this.state = {
            list: [],
            searchTerm: "",
            selectedOption: null
        };
        this.customStyles = {
            menu: ()=>({
                    boxShadow: "none",
                    position: "absolute",
                    zIndex: 99,
                    top: "100%",
                    width: "100%"
                }),
            menuList: ()=>({
                    background: "#fff",
                    maxHeight: "260px",
                    overflow: "auto",
                    border: "1px solid #eee"
                })
        };
    }
    componentDidMount() {}
    formatValue = (value)=>{
        if (this.props.isMulti) return value?.map((i)=>{
            return {
                ...i,
                value: i.id,
                label: i.name
            };
        });
        let r = this.state.list.find((o)=>{
            return o.id === value;
        });
        if (r) {
            let label = r.name ? r.name : "";
            if (this.props.entity == "merchandiser") label = r.first_name + " " + r.last_name;
            if (this.props.entity == "supervisor") label = r.first_name + " " + r.last_name;
            if (this.props.entity == "point") label = r.name + ", " + r.locality.name;
            return {
                value: r.id,
                label: label
            };
        } else return null;
    };
    asynchLoadOptions = (inputValue)=>{
        return new Promise((resolve)=>{
            let url = this.props.entity + "s/?search=" + inputValue; // s in"s/?search=" - it is just a simple letter "s" was added to entity name, i.e: "product" + "s" = "products" ://
            if (this.props.county && this.props.entity == "point") url = "points/?locality__county=" + this.props.county + "&search=" + inputValue;
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "GET",
                url: url
            }, (r)=>{
                let list = r.results;
                if (this.props.entity == "template") list = r;
                list = (0, $3b579ca6158bc61b$export$b25c9bd295a2cb07)(list, this.props.entity);
                this.setState({
                    list: list
                });
                resolve(list);
            });
        });
    };
    onAsynchInputChange = (newValue)=>{
        // this.asynchLoadOptions(newValue);
        // this.setState({ searchTerm: newValue });
        return newValue;
    };
    handleChange = (selectedOption)=>{
        this.setState({
            selectedOption: selectedOption
        });
        this.props.onChange?.(selectedOption);
    };
    render() {
        const { selectedOption: selectedOption } = this.state;
        let className = this.props.className ? this.props.className : "";
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: `react-dropdown-container ${className}`,
            children: !!this.props.async ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $03db2c708f724e45$export$2e2bcd8739ae039), {
                cacheOptions: true,
                defaultOptions: true,
                action: [
                    "clear"
                ],
                value: this.formatValue(this.props.value) || null,
                loadOptions: this.props.options,
                onInputChange: this.onAsynchInputChange,
                placeholder: this.props.placeholder ? this.props.placeholder : (0, $91ea30cb49819b9a$export$846d38fa3865c245)[this.props.entity].selectTitle,
                onChange: this.props.onChange,
                isClearable: this.props.isClearable ?? true,
                isDisabled: this.props.isDisabled,
                styles: this.customStyles
            }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $e9e80384c89540c4$export$2e2bcd8739ae039), {
                options: this.props.options,
                isMulti: this.props.isMulti,
                value: selectedOption,
                placeholder: this.props.placeholder ? this.props.placeholder : (0, $91ea30cb49819b9a$export$846d38fa3865c245)[this.props.entity]?.selectTitle,
                onChange: this.handleChange,
                isClearable: this.props.isClearable ?? true,
                isDisabled: this.props.isDisabled,
                styles: this.customStyles
            })
        });
    }
}
$7f76693712ba171d$export$2e2bcd8739ae039.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).any,
    async: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).object),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).func,
    isMulti: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).string,
    isClearable: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Spf6))).bool
};






var $Yxlsx = parcelRequire("Yxlsx");





const $2c6702af6a3b1482$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $2c6702af6a3b1482$var$ImportCore extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.dataTypeList = [
            {
                id: 1,
                label: "\u041C\u0435\u0440\u0435\u0436\u0430",
                value: "network"
            },
            {
                id: 2,
                label: "\u0422\u043E\u0447\u043A\u0430",
                value: "point"
            }
        ];
        this.state = {
            totalDataSize: 0,
            sizePerPage: 10,
            pageAmount: 1,
            page: 1,
            errorList: [
                ""
            ],
            errors: {
                name: "",
                point: "",
                network: "",
                template: "",
                tasks: []
            },
            filter: {
                dataType: null,
                network: null,
                point: null,
                template: null,
                bulkName: ""
            },
            tasks: [],
            uploadFile: null,
            fileDataToSend: [],
            formValues: null
        };
    }
    componentDidMount() {}
    validate = (formValues)=>{
        let errors = {
            ...this.state.errors
        };
        let hasErrors = false;
        if (!formValues.tasks?.length) {
            const stringTranslate = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "complete_at_least_one_task_msg", $2c6702af6a3b1482$var$me.language);
            this.setState({
                errorList: [
                    (0, $3b579ca6158bc61b$export$ddec11078e1d813a)(stringTranslate)
                ]
            });
            hasErrors = true;
        } else {
            this.setState({
                errorList: []
            });
            formValues.tasks.map((task, taskIndex)=>{
                errors["tasks"][taskIndex] = {
                    title: "",
                    description: "",
                    start: null,
                    end: null,
                    point: "",
                    network: "",
                    images: []
                };
                Object.entries(task).map((entry)=>{
                    if (!entry[1]?.length && entry[0] !== "point" && entry[0] !== "network" && entry[0] !== "images") {
                        errors["tasks"][taskIndex][entry[0]] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
                        hasErrors = true;
                    }
                });
            });
        }
        if (!formValues.action_name) errors["name"] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
        if (!formValues.template) errors["template"] = (0, $3b579ca6158bc61b$export$ddec11078e1d813a)();
        this.setState({
            errors: errors
        });
        return !hasErrors;
    };
    submit = (fileDataToSend = [])=>{
        let tasks = this.prepareItemsToSend(this.state, fileDataToSend);
        if (!this.validate(tasks)) return;
        this.setState({
            errorList: [
                ""
            ],
            errors: {
                name: "",
                point: "",
                network: "",
                template: "",
                tasks: []
            }
        });
        (0, $c9936523dc38c641$export$46f383001bf60e04)({
            method: "POST",
            url: "tasks/bulk_create/",
            post: tasks
        }, async (response)=>{
            const result = await response.json();
            if (response.status === 200) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Items successfully saved", {
                    position: "bottom-right"
                });
                this.setState({
                    tasks: [],
                    uploadFile: null,
                    fileDataToSend: [],
                    filter: {
                        dataType: null,
                        network: null,
                        point: null,
                        template: null,
                        bulkName: ""
                    }
                });
            }
            if (response.status === 400) this.setState({
                errorList: [
                    result.details
                ]
            });
        });
    };
    prepareItemsToSend = (state, fileDataToSend)=>{
        const tasks = fileDataToSend.length ? fileDataToSend.map((item)=>({
                ...item,
                point: state.filter.point?.code || "",
                network: state.filter.network?.code || ""
            })) : state.tasks?.map((item)=>({
                title: item.title || "",
                description: item.info || "",
                start: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(item.start).format("yyyy-MM-DDT00:00"),
                end: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(item.end).format("yyyy-MM-DDT00:00"),
                point: state.filter.point?.code || "",
                network: state.filter.network?.code || "",
                images: item.images?.map((item)=>item.id)
            }));
        return {
            action_name: state.filter.bulkName,
            points: state.filter.point?.code ? [
                state.filter.point.code
            ] : [],
            networks: state.filter.network?.code ? [
                state.filter.network?.code
            ] : [],
            template: state.filter.template?.id,
            tasks: tasks
        };
    };
    deleteRow = (idx)=>{
        this.setState((prevState)=>({
                tasks: prevState.tasks.filter((item, index)=>index !== idx)
            }));
    };
    addRow = ()=>{
        this.setState({
            tasks: [
                ...this.state.tasks,
                {
                    title: "",
                    info: "",
                    images: [],
                    start: new Date(),
                    end: new Date(new Date().setDate(new Date().getDate() + 14))
                }
            ]
        });
    };
    onChange = (property, value, idx)=>{
        let tasks = this.state.tasks;
        tasks[idx][property] = value;
        this.setState({
            tasks: tasks
        });
    };
    changeFilter = (filterEntity, item)=>{
        let filter = {
            ...this.state.filter
        };
        filter[filterEntity] = item;
        this.setState((prevState)=>({
                filter: filter
            }));
    };
    handleChangeDataType = (option)=>{
        this.setState((prevState)=>({
                filter: {
                    ...prevState.filter,
                    dataType: option?.value || null
                }
            }));
    };
    handleChangeBulkName = (e)=>{
        this.setState((prevState)=>({
                filter: {
                    ...prevState.filter,
                    bulkName: e.target.value || ""
                }
            }));
    };
    uploadFile = (acceptedFiles)=>{
        let file = acceptedFiles[0];
        let reader = new FileReader();
        reader.onload = (e)=>{
            const uploadFile = reader.result.split(/\r?\n/).filter((item)=>item?.length);
            this.getUploadData(uploadFile);
            this.setState({
                uploadFile: file
            });
        };
        reader.readAsText(file);
    };
    getUploadData = (stringArray = [
        ""
    ])=>{
        stringArray.shift();
        const preparedUploadData = stringArray.map((row, index)=>{
            const fields = stringArray[index].split(",");
            return {
                title: fields[0] || "",
                description: fields[1] || "",
                start: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(fields[2], "DD/MM/YYYY").format("yyyy-MM-DDT00:00"),
                end: (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(fields[3], "DD/MM/YYYY").format("yyyy-MM-DDT00:00")
            };
        });
        this.setState({
            fileDataToSend: preparedUploadData
        });
        return preparedUploadData;
    };
    uploadImages = (acceptedFiles, rowIndex)=>{
        let file = acceptedFiles[0];
        let reader = new FileReader();
        reader.onload = (e)=>{
            let { result: result } = e.target;
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "POST",
                url: "images/",
                post: {
                    owner: $2c6702af6a3b1482$var$me.id,
                    image: result
                }
            }, (image)=>{
                if (image?.id) this.setState((prevState)=>({
                        tasks: prevState.tasks.map((task, index)=>index === rowIndex ? {
                                ...task,
                                images: [
                                    image
                                ]
                            } : task)
                    }));
                else {
                    console.log("Error while saving image. Error: " + JSON.stringify(image), {
                        position: "bottom-right"
                    });
                    console.log(image);
                }
            });
        };
        reader.readAsDataURL(file);
    };
    deleteImage = (rowIndex, imageIndex)=>{
        let images = this.state.tasks[rowIndex].images;
        let id = images[imageIndex]?.id; // we could upload only one file in 'images' field in row now
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: "images/" + id + "/",
            body: {}
        }, ()=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("Image successfully deleted", {
                position: "top"
            });
        });
        this.setState((prevState)=>({
                tasks: prevState.tasks.map((task, taskIndex)=>rowIndex === taskIndex ? {
                        ...task,
                        images: []
                    } : task)
            }));
    };
    renderUploadFileResult = (stringArray = [
        ""
    ])=>{
        const titles = stringArray.shift();
        const renderHead = (numRow = 0)=>/*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                className: "primary text-center",
                children: /*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                    children: titles?.split(",").map((field, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("th", {
                            children: field
                        }, index))
                })
            });
        const renderList = (numRow = 0)=>{
            return /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                children: stringArray.map((row, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("tr", {
                        children: stringArray[index].split(",").map((field, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                children: field
                            }, index))
                    }, index))
            });
        };
        return stringArray.some((item)=>!!item) && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "table-scroll-x",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                className: "table table-hover table-bordered table-tasks-import",
                children: [
                    renderHead(),
                    renderList()
                ]
            })
        });
    };
    renderErrors = (errors = {})=>{
        const RenderErrorHead = ()=>/*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "line_title", $2c6702af6a3b1482$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "name_title", $2c6702af6a3b1482$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "description_title", $2c6702af6a3b1482$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "start_date_title", $2c6702af6a3b1482$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "end_date_title", $2c6702af6a3b1482$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "point_label", $2c6702af6a3b1482$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "network_label", $2c6702af6a3b1482$var$me.language)
                    })
                ]
            });
        const RenderErrorBody = ()=>{
            return errors?.tasks?.map((taskError, index)=>/*#__PURE__*/ (0, $7uT18.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: index
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.title
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            children: [
                                " ",
                                taskError.description
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.start
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.end
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.point
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: taskError.network
                        })
                    ]
                }, index)) || null;
        };
        return errors.tasks?.length && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "error-task-list",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)(RenderErrorHead, {}),
                /*#__PURE__*/ (0, $7uT18.jsx)(RenderErrorBody, {})
            ]
        });
    };
    renderRow = (item, index)=>{
        return /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                        type: "text",
                        value: item.title,
                        className: "form-control",
                        onChange: (o)=>this.onChange("title", o.target.value, index)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                        selected: new Date(item.start),
                        onChange: (date)=>this.onChange("start", date, index),
                        className: "datePicker form-control"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $6214b59a73de52c6$export$5109c6dd95d8fb00), {
                        selected: new Date(item.end),
                        onChange: (date)=>this.onChange("end", date, index),
                        className: "datePicker form-control"
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    children: index === 0 || this.state.filter.dataType === "network" ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        children: this.state.tasks[index].images?.length ? /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "mt-1 taskImagesEdit",
                            children: this.state.tasks[index].images?.map((image, idx)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "d-inline-block",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                            src: image.image,
                                            style: {
                                                maxHeight: 40
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "deleteImage",
                                            onClick: ()=>this.deleteImage(index, idx),
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                                className: "fa fa-minus-square-o"
                                            })
                                        })
                                    ]
                                }, idx))
                        }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $c89956014bc8c37c$export$2e2bcd8739ae039), {
                            onDrop: (acceptedFiles)=>this.uploadImages(acceptedFiles, index),
                            accept: "image/jpeg, image/png",
                            styles: {
                                dropzone: {
                                    minHeight: 50,
                                    maxHeight: 150
                                }
                            },
                            multiple: false,
                            children: ({ getRootProps: getRootProps, getInputProps: getInputProps })=>/*#__PURE__*/ (0, $7uT18.jsx)("section", {
                                    className: "dropzone-flex",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        ...getRootProps(),
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                ...getInputProps()
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "select_download_type", $2c6702af6a3b1482$var$me.language)
                                            })
                                        ]
                                    })
                                })
                        })
                    }) : this.state.filter.dataType === null ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "click_drag_img", $2c6702af6a3b1482$var$me.language)
                    }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "only_one_photo_allowed_for_type_point", $2c6702af6a3b1482$var$me.language)
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("textarea", {
                        className: "form-control",
                        onChange: (o)=>this.onChange("info", o.target.value, index),
                        defaultValue: item.info
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        className: "imp-btn imp-btn--danger",
                        onClick: ()=>this.deleteRow(index),
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "material-symbols-outlined",
                            children: "delete"
                        })
                    })
                })
            ]
        }, index);
    };
    render() {
        const { errorList: errorList, filter: filter, uploadFile: uploadFile, fileDataToSend: fileDataToSend, errors: errors } = this.state;
        const isShowErrorList = errorList.some((item)=>!!item);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "imp-page",
            children: [
                isShowErrorList && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "imp-error-box",
                    children: errorList?.map((error, index)=>/*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            children: error
                        }, index))
                }),
                !!errors.tasks?.length && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "imp-error-box",
                    children: this.renderErrors(errors)
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "imp-filter-bar",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $47bab1813fff772a$export$a455218a85c89869), {
                            className: "import-title",
                            error: errors.name,
                            style: {
                                flex: "1 1 200px"
                            },
                            children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                name: "bulkName",
                                type: "text",
                                className: "imp-name-input",
                                placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_name", $2c6702af6a3b1482$var$me.language),
                                value: filter.bulkName,
                                onChange: this.handleChangeBulkName
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                            entity: "template",
                            value: filter.template,
                            asynch: true,
                            onChange: (o)=>this.changeFilter("template", o),
                            useFullOptionObject: true
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $7f76693712ba171d$export$2e2bcd8739ae039), {
                            name: "dataTypeList",
                            entity: "dataTypeList",
                            options: this.dataTypeList,
                            onChange: this.handleChangeDataType,
                            placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "type_loading", $2c6702af6a3b1482$var$me.language)
                        }),
                        filter.dataType === "network" && /*#__PURE__*/ (0, $7uT18.jsx)((0, $288f67596d327d69$export$2e2bcd8739ae039), {
                            entity: "network",
                            value: filter.network,
                            onChange: (o)=>this.changeFilter("network", o),
                            useFullOptionObject: true
                        }),
                        filter.dataType === "point" && /*#__PURE__*/ (0, $7uT18.jsx)((0, $d4b6a9d27c93fbb2$export$2e2bcd8739ae039), {
                            value: filter.point,
                            onChange: (o)=>this.changeFilter("point", o),
                            useFullOptionObject: true
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "imp-dropzone-row",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $c89956014bc8c37c$export$2e2bcd8739ae039), {
                                    onDrop: (acceptedFiles)=>this.uploadFile(acceptedFiles),
                                    accept: ".csv",
                                    multiple: false,
                                    children: ({ getRootProps: getRootProps, getInputProps: getInputProps })=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "imp-dropzone",
                                            ...getRootProps(),
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                    ...getInputProps()
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "upload_file"
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    children: uploadFile?.name || (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "click_or_drag_file", $2c6702af6a3b1482$var$me.language)
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "imp-btn imp-btn--primary",
                                    disabled: !fileDataToSend?.length,
                                    onClick: ()=>this.submit(fileDataToSend),
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "save"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_btn", $2c6702af6a3b1482$var$me.language)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "table-scroll-x",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                        className: "imp-table",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "name_title", $2c6702af6a3b1482$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "start_date_title", $2c6702af6a3b1482$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "end_date_title", $2c6702af6a3b1482$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "photo_title", $2c6702af6a3b1482$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "description_title", $2c6702af6a3b1482$var$me.language)
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                            style: {
                                                width: 40
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                                children: this.state.tasks.map((item, index)=>this.renderRow(item, index))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "imp-table-actions",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                            className: "imp-btn imp-btn--outline",
                            onClick: ()=>this.addRow(),
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "add"
                                }),
                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "add_record_btn", $2c6702af6a3b1482$var$me.language)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                            className: "imp-btn imp-btn--primary",
                            onClick: ()=>this.submit(),
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "save"
                                }),
                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "save_btn", $2c6702af6a3b1482$var$me.language)
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $2c6702af6a3b1482$export$2e2bcd8739ae039 = $2c6702af6a3b1482$var$ImportCore;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $1ZXxd = parcelRequire("1ZXxd");

var $Yxlsx = parcelRequire("Yxlsx");





const $01190fac37d4847b$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
const $01190fac37d4847b$var$ITEMS_PER_PAGE = 50;
const $01190fac37d4847b$export$d2c40faa7b0c0266 = ()=>{
    const [uploadLogs, setUploadLogs] = (0, $cQmXV.useState)([]);
    const [currentPage, setCurrentPage] = (0, $cQmXV.useState)(1);
    const [totalCount, setTotalCount] = (0, $cQmXV.useState)(0);
    const totalPages = Math.ceil(totalCount / $01190fac37d4847b$var$ITEMS_PER_PAGE);
    // Server-side pagination: fetch only the requested page (page_size honored by the
    // actions/ endpoint's LargeResultsSetPagination), using the server's count for paging.
    (0, $cQmXV.useEffect)(()=>{
        getUploadLogs(currentPage);
    }, [
        currentPage
    ]);
    const getUploadLogs = (page)=>(0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `actions/?page=${page}&page_size=${$01190fac37d4847b$var$ITEMS_PER_PAGE}`
        }, (data)=>{
            setUploadLogs(Array.isArray(data?.results) ? data.results : []);
            setTotalCount(data?.count || 0);
        });
    /*
   * @params data any
   * @return string
   */ const getAMatrixLogData = (data)=>{
        let preparedLogData = "";
        let points = [];
        let productCodes = [];
        const table = [];
        data?.invalid_matrices.map((item, index)=>{
            points.push(item.point);
            productCodes.push(...item.products);
        });
        productCodes = [
            ...new Set(productCodes)
        ];
        preparedLogData = `,${points.join()}\n`;
        productCodes?.map((code)=>{
            let row = [];
            row.push(String(code));
            data?.invalid_matrices.map((item, index)=>{
                if (item.products?.includes(code)) row.push("1");
                else row.push("");
            });
            table.push(row.join());
        });
        preparedLogData += `${table.join("\n")}`;
        // console.log("table", table);
        // console.log("productCodes", productCodes);
        // console.log("preparedLogData", preparedLogData);
        return preparedLogData;
    };
    /*
   * @params data any
   * @return string
  //  */ const geTaskImportLogData = (data)=>{
        let preparedLogData = "";
        if (data.invalid_tasks?.length) {
            preparedLogData = "Title,Description,Start date,End Date, Point, Network\n";
            preparedLogData += data.invalid_tasks.map((logItem)=>`${logItem.title},${logItem.start},${logItem.end},${logItem.description},${logItem.point},${logItem.network}\n`).join("");
        }
        return preparedLogData;
    };
    const downloadLogs = (data, dataType, fileName, fileType)=>{
        let logData = "";
        switch(dataType){
            case "ASSORTMENT_MATRIX_CREATION":
                logData = getAMatrixLogData(data);
                break;
            case "TASKS_CREATION":
                logData = geTaskImportLogData(data);
                break;
            default:
                console.log(data);
        }
        if (!logData) return;
        let file = new Blob([
            logData
        ], {
            type: fileType
        });
        if (window.navigator.msSaveOrOpenBlob) // IE10+
        window.navigator.msSaveOrOpenBlob(file, fileName);
        else {
            // Others
            let a = document.createElement("a"), url = URL.createObjectURL(file);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    };
    const deleteImport = (id)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: `actions/${id}/delete_action_data/`
        }, ()=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_was_delete_msg", $01190fac37d4847b$var$me.language), {
                position: "bottom-right"
            });
            // The row isn't removed server-side (its status becomes "deleted"), so refetch the
            // current page to reflect the new status.
            getUploadLogs(currentPage);
        });
    };
    const getStatusClass = (status)=>{
        if (!status) return "";
        const s = status.toLowerCase().replace(/\s/g, "-");
        if ([
            "done",
            "completed",
            "success"
        ].includes(s)) return "imp-status-chip--success";
        if (s === "deleted") return "imp-status-chip--deleted";
        return "imp-status-chip--pending";
    };
    if (!uploadLogs.length) return null;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "imp-page",
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "table-scroll-x",
                children: /*#__PURE__*/ (0, $7uT18.jsxs)("table", {
                    className: "imp-logs-table",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "name_title", $01190fac37d4847b$var$me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "type_tasks_title", $01190fac37d4847b$var$me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_date_title", $01190fac37d4847b$var$me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "loading_errors_title", $01190fac37d4847b$var$me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                        className: "imp-logs-th--sm",
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "status", $01190fac37d4847b$var$me.language)
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("th", {
                                        className: "imp-logs-th--actions",
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "remove_btn", $01190fac37d4847b$var$me.language)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                            children: uploadLogs?.map((item, index)=>/*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                            children: item.name || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                            children: item.type || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                            children: item.created ? (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(item.created).format("DD.MM.YYYY HH:mm") : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                            children: item.type !== "TASKS_CREATION" && !(0, (/*@__PURE__*/$parcel$interopDefault($1ZXxd))).isEmpty(item.logs) || item.type === "TASKS_CREATION" && item.logs.invalid_tasks?.length ? /*#__PURE__*/ (0, $7uT18.jsxs)("a", {
                                                className: "imp-download-link",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    downloadLogs(item.logs, item.type, `${item.created ? (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(item.created).format("DD.MM.YYYY HH:mm") : "upload"}-logs.csv`, "csv");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "material-symbols-outlined",
                                                        children: "download"
                                                    }),
                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "download_btn", $01190fac37d4847b$var$me.language)
                                                ]
                                            }) : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                            children: item.status ? /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: `imp-status-chip ${getStatusClass(item.status)}`,
                                                children: item.status
                                            }) : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                            className: "imp-logs-td--actions",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                                className: "imp-btn imp-btn--danger",
                                                onClick: ()=>deleteImport(item.id),
                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "delete"
                                                })
                                            })
                                        })
                                    ]
                                }, index))
                        })
                    ]
                })
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "imp-pagination",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        className: "imp-pagination-btn",
                        disabled: currentPage === 1,
                        onClick: ()=>setCurrentPage((prev)=>prev - 1),
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "material-symbols-outlined",
                            children: "chevron_left"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                        className: "imp-pagination-counter",
                        children: [
                            currentPage,
                            " / ",
                            totalPages
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                        className: "imp-pagination-btn",
                        disabled: currentPage === totalPages,
                        onClick: ()=>setCurrentPage((prev)=>prev + 1),
                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                            className: "material-symbols-outlined",
                            children: "chevron_right"
                        })
                    })
                ]
            })
        ]
    });
};





class $cce5ca651488d6ad$var$TasksImport extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            valid: false
        };
    }
    componentDidMount = ()=>{
        this.userValidate();
    };
    userValidate = ()=>{
        const { currentUser: currentUser } = this.props;
        if (currentUser.role === "supervisor_manager") this.setState({
            valid: true
        });
    };
    render() {
        const { uploadLogs: uploadLogs } = this.state;
        const { currentUser: currentUser } = this.props;
        const { id: id } = this.props.match.params;
        return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "box p-4",
                children: this.state.valid ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $79a08f0c966164e4$export$2e2bcd8739ae039), {
                    activeTab: Number(id) || 0,
                    labels: [
                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "import_tab", currentUser.language),
                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "import_advanced_tab", currentUser.language),
                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "import_matrix_tab", currentUser.language),
                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "import_downloads_tab", currentUser.language)
                    ],
                    tabs: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $2c6702af6a3b1482$export$2e2bcd8739ae039), {}, "import"),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $975ee123f7d0c690$export$81351f0394755609), {}, "advance-import"),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $ec0f988d07352ede$export$127c3e2ceac11eb2), {}, "import-matrix"),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $01190fac37d4847b$export$d2c40faa7b0c0266), {
                            uploadLogs: uploadLogs
                        }, "my-uploads")
                    ]
                }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9b4ba9aeb2db83c0$export$53f1cd6809577fc5), {
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9b4ba9aeb2db83c0$export$7f365262018175ea), {
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "faIcon",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("i", {
                                            className: "fa fa-download"
                                        })
                                    }),
                                    "Page Not Found"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                            href: "/",
                            className: "btn btn-primary mt-5 ml-4",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "back_btn", currentUser.language)
                        })
                    ]
                })
            })
        });
    }
}
var $cce5ca651488d6ad$export$2e2bcd8739ae039 = $cce5ca651488d6ad$var$TasksImport;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");









const $199198b5a2e0dacc$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
const $199198b5a2e0dacc$var$List = ()=>{
    // const history = useHistory();
    // Bumping this key remounts EntityTable, which re-fetches the visits list —
    // used after approve/reject instead of a full window.location.reload().
    const [reloadKey, setReloadKey] = (0, $cQmXV.useState)(0);
    const approveVisit = async (item)=>{
        if (item.is_approved) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "already_approve_visit_msg", $199198b5a2e0dacc$var$me.language), {
                position: "top-right"
            });
            return;
        }
        let body = {
            is_approved: true,
            approved_by: $199198b5a2e0dacc$var$me.id
        };
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PATCH",
            url: "visits/" + item.id + "/",
            post: body
        }, (r)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "approve_visit_msg", $199198b5a2e0dacc$var$me.language), {
                position: "top-right"
            });
            setReloadKey((k)=>k + 1);
        });
    };
    const rejectVisit = (item)=>{
        if (item.is_approved === false) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "already_reject_visit_msg", $199198b5a2e0dacc$var$me.language), {
                position: "top-right"
            });
            return;
        }
        let body = {
            is_approved: false,
            approved_by: $199198b5a2e0dacc$var$me.id
        };
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PATCH",
            url: "visits/" + item.id + "/",
            post: body
        }, (r)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "reject_visit_msg", $199198b5a2e0dacc$var$me.language), {
                position: "top-right"
            });
            setReloadKey((k)=>k + 1);
        });
    };
    const triggerQuickVisitAction = (item, type)=>{
        type === "approve" ? approveVisit(item) : rejectVisit(item);
    };
    //uncomment to open visit row if need open visit in same page and added this fn to init dataFormat on TableHeaderColumn
    // const onRowClick = id => {
    //   openVisitRow(id, history);
    // };
    const rowClassNameFormat = function() {
        return "active-row";
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)("div", {
        className: "container-fluid visit-page",
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "box p-4",
            children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $81b6b064afbc82da$export$2e2bcd8739ae039), {
                entity: "visit",
                rowClassName: rowClassNameFormat,
                sizePerPage: "10",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$bba4d72e1a6638cc),
                        isKey: true,
                        width: "37px"
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (i, item)=>{
                            return (0, $b79edb411f97c469$export$3470fb9eaf0b9df3)(i, item);
                        },
                        dataField: "id",
                        isKey: true,
                        width: "280px",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "point", $199198b5a2e0dacc$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (i, item)=>{
                            return (0, $b79edb411f97c469$export$43d108cb566ddefd)(i, item);
                        },
                        width: "220px",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "supervisor", $199198b5a2e0dacc$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (i, item)=>{
                            return (0, $b79edb411f97c469$export$d12cdf29102185cf)(i, item);
                        },
                        width: "220px",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "approved_by", $199198b5a2e0dacc$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (i, item)=>{
                            return (0, $b79edb411f97c469$export$829751009cf59fbd)(i, item);
                        },
                        width: "220px",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "author_way", $199198b5a2e0dacc$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$4f156e78e4624fdc),
                        width: "120px",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "table_timespent", $199198b5a2e0dacc$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$8bafef2117b24af6),
                        width: "120px",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "status_label", $199198b5a2e0dacc$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (0, $b79edb411f97c469$export$4e1468365cefb5e6),
                        width: "100px",
                        dataAlign: "center",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "progress_label", $199198b5a2e0dacc$var$me.language)
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                        dataFormat: (i, item)=>{
                            return (0, $b79edb411f97c469$export$1ca6f3165be21213)(i, item, triggerQuickVisitAction);
                        },
                        width: "100px"
                    })
                ]
            }, reloadKey)
        })
    });
};
var $199198b5a2e0dacc$export$2e2bcd8739ae039 = $199198b5a2e0dacc$var$List;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");







const $7b102d9d0a799dc7$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $7b102d9d0a799dc7$var$LogEvents({ data: data }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        logs: "",
        loading: false
    });
    const [brokenAvatars, setBrokenAvatars] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({});
    (0, $cQmXV.useEffect)(()=>{
        setState({
            loading: true
        });
        let url = `visits/${data.id}/events/`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            setState({
                logs: response.results,
                loading: false
            });
        });
    }, [
        data
    ]);
    const isObjectEmpty = (obj)=>{
        return obj && Object.keys(obj).length === 0;
    };
    const getUserName = (item)=>{
        let name = item.user?.first_name ? item.user.first_name : "";
        let lastName = item.user?.last_name ? item.user.last_name : "";
        return name + " " + lastName;
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "visit-events-tab-wrapper",
            children: state.logs ? state.logs.map((item)=>{
                return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "visit-events-item",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "photo-user",
                            children: [
                                (0, $dd80b063693a1e94$export$fb85bc5d6d9ef19b)(item?.user?.photo) && !brokenAvatars[item.id] ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                    src: item.user.photo,
                                    alt: getUserName(item),
                                    className: "w-62 visit-item-author-avatar",
                                    onError: ()=>setBrokenAvatars((prev)=>({
                                                ...prev,
                                                [item.id]: true
                                            }))
                                }) : /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "vs-log-avatar-fallback",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "person"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                    className: `user-status ${item.user?.is_active ? "active" : "inactive"}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "event-user-data",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                    className: "event-user-event-time",
                                    children: (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.timestamp)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("p", {
                                    className: "visit-events-item-author-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "visit-events-item-author",
                                            children: [
                                                getUserName(item),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "visit-events-item-action",
                                            children: item.additional_info?.event
                                        }),
                                        item.action === "create" && item.changes?.new_task ? /*#__PURE__*/ (0, $7uT18.jsx)("a", {
                                            className: "visit-events-item-task-link",
                                            href: `/task/${item.changes?.new_task[1]}`,
                                            target: "_blank",
                                            children: item.changes?.new_task[1]
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "visit-events-statistic-list",
                                    children: item.additional_info?.statistic && !isObjectEmpty(item.additional_info.statistic) ? Object.keys(item.additional_info.statistic).map((key, index)=>{
                                        const name = key === "monitoring" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_monitoring_label", $7b102d9d0a799dc7$var$me.language) : key === "photos_in_answers" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_photos_in_answers_label", $7b102d9d0a799dc7$var$me.language) : key === "photos_in_reports" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_photos_in_reports_label", $7b102d9d0a799dc7$var$me.language) : key === "reports_done" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_reports_done_label", $7b102d9d0a799dc7$var$me.language) : key === "tasks_done" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_tasks_done_label", $7b102d9d0a799dc7$var$me.language) : key === "tasks_not_done" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_tasks_not_done_label", $7b102d9d0a799dc7$var$me.language) : key === "answers_not_supervised" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_answers_not_supervised_label", $7b102d9d0a799dc7$var$me.language) : key === "answers_supervised" ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_event_answers_supervised_label", $7b102d9d0a799dc7$var$me.language) : "";
                                        return /*#__PURE__*/ (0, $7uT18.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "visit-events-item-statistic-name",
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "visit-events-item-statistic-value",
                                                    children: item.additional_info.statistic[key]
                                                })
                                            ]
                                        }, item + index);
                                    }) : null
                                })
                            ]
                        })
                    ]
                }, item.id);
            }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                loading: state.loading
            })
        })
    });
}
var $7b102d9d0a799dc7$export$2e2bcd8739ae039 = $7b102d9d0a799dc7$var$LogEvents;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");


// import MapRender from "../../dashboard/_/map_block/Map";
function $a99cf2984ca06e8c$var$Map({ location: location, zoomLevel: zoomLevel, isModal: isModal, modalClose: modalClose }) {
    const mapRef = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(()=>{
        const script = document.createElement("script");
        script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
        script.integrity = "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=";
        script.crossOrigin = "";
        script.async = true;
        script.onload = ()=>{
            if (!mapRef.current) {
                mapRef.current = window.L.map("map-container").setView([
                    location.lat,
                    location.lng
                ], zoomLevel);
                window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(mapRef.current);
                const myIcon = window.L.icon({
                    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3af2dca0564538a0$exports))),
                    iconSize: [
                        25,
                        41
                    ]
                });
                window.L.marker([
                    location.lat,
                    location.lng
                ], {
                    icon: myIcon
                }).addTo(mapRef.current);
            }
        };
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script);
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
            isShow: isModal,
            onClose: modalClose,
            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                id: "map-container",
                style: {
                    height: "600px",
                    width: "100%"
                }
            })
        })
    });
}
var $a99cf2984ca06e8c$export$2e2bcd8739ae039 = $a99cf2984ca06e8c$var$Map;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");









const $5b1884b6ec98d715$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $5b1884b6ec98d715$var$Monitoring({ data: data }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        monitoring: "",
        loading: false
    });
    const [checkedRows, setCheckedRows] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState([]);
    const [isMsgStatus, setIsMsgStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        status: false,
        type: "error",
        message: ""
    });
    const [updatedData, getUpdatedData] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    //default object for approve or reject the task
    const approveRejectObject = {
        object_type: "pricemonitoringreport",
        is_approved: null,
        comment: ""
    };
    (0, $cQmXV.useEffect)(()=>{
        setState({
            loading: true
        });
        let url = `visits/${data.id}/price_monitoring_in_visit/`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            setState({
                monitoring: response.results,
                loading: false
            });
        });
    }, [
        data,
        updatedData
    ]);
    const getImgObj = (src)=>{
        if (!src) return /*#__PURE__*/ (0, $7uT18.jsx)("p", {
            className: "monitoring-product-empty-img",
            children: "No photo"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("a", {
            href: src,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                src: src,
                className: "monitoring-product-img",
                alt: "Click to open in new window"
            })
        });
    };
    const handleCheckboxChange = (e, row)=>{
        const isChecked = e.target.checked;
        if (isChecked) setCheckedRows((prev)=>[
                ...prev,
                row.id
            ]);
        else setCheckedRows((prev)=>prev.filter((id)=>id !== row.id));
    };
    const prepareData = (data)=>{
        return checkedRows.length === 1 ? data[0] : checkedRows.length > 1 ? data : null;
    };
    const sentAnswer = (type, body, isArray)=>{
        const approveRejectStatus = type === "ACCEPT" ? true : false;
        const isInValid = isArray ? body.object_ids?.length < 1 : !body.object_id;
        if (isInValid) {
            setIsMsgStatus({
                status: true,
                type: "error",
                message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_has_empty_error", $5b1884b6ec98d715$var$me.language)
            });
            return;
        }
        const url = isArray ? "approvals/bulk_approval/" : "approvals/";
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: url,
            post: body
        }, (response)=>{
            if (response) {
                const msg = approveRejectStatus ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_accept_msg", $5b1884b6ec98d715$var$me.language) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_reject_msg", $5b1884b6ec98d715$var$me.language);
                setIsMsgStatus({
                    status: true,
                    type: "success",
                    message: msg
                });
                setCheckedRows([]);
                getUpdatedData(!updatedData);
            } else {
                setIsMsgStatus({
                    status: true,
                    type: "warning",
                    message: JSON.stringify(response)
                });
                console.log(response);
            }
        });
    };
    const approveRejectTaskHandler = (type)=>{
        const data = prepareData(checkedRows);
        const objSize = Array.isArray(data) ? "object_ids" : "object_id";
        approveRejectObject[objSize] = data;
        approveRejectObject.is_approved = type === "REJECT" ? false : type === "ACCEPT" ? true : null;
        sentAnswer(type, approveRejectObject, Array.isArray(data));
    };
    const approveRejectTaskQuickHandler = (item, type)=>{
        const data = item.id;
        approveRejectObject.object_id = data;
        approveRejectObject.is_approved = type === "REJECT" ? false : type === "ACCEPT" ? true : null;
        sentAnswer(type, approveRejectObject, Array.isArray(data));
    };
    const getApprovalInfo = (item)=>{
        if (!item?.approved_by) return;
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7uT18.jsxs)("p", {
                    children: [
                        item.approved_by.first_name,
                        " ",
                        item.approved_by.last_name
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                    children: (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(item.approved_at)
                })
            ]
        });
    };
    const getApprovalStatus = (item)=>{
        if (!item) return;
        const statusClass = item.is_approved ? "task-status-approved" : item.is_approved === false ? "task-status-rejected" : item.is_approved === null ? "pending" : "";
        const label = item.is_approved ? "Approved" : item.is_approved === false ? "Rejected" : item.is_approved === null ? "Pending" : "";
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: `visit-task-status ${statusClass}`,
            children: label
        });
    };
    const handleSelectAll = ()=>{
        if (checkedRows.length > 0) {
            setCheckedRows([]);
            return;
        }
        const validRowIds = state.monitoring.filter((row)=>row.id).map((row)=>row.id);
        if (validRowIds.length === 0) setIsMsgStatus({
            status: true,
            type: "error",
            message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_has_answer_error", $5b1884b6ec98d715$var$me.language)
        });
        setCheckedRows(validRowIds);
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "visit-monitoring-tab-wrapper",
            children: [
                isMsgStatus.status && /*#__PURE__*/ (0, $7uT18.jsx)((0, $cec83a254593e541$export$2e2bcd8739ae039), {
                    setIsMsg: setIsMsgStatus,
                    isMsg: isMsgStatus
                }),
                state.monitoring ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: `visit-single-btn-wrapper mb-4 ${checkedRows.length > 0 ? "visible" : "hidden"}`,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                    children: [
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_selected_label", $5b1884b6ec98d715$var$me.language),
                                        ": ",
                                        checkedRows.length
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-default approve-visit",
                                    onClick: ()=>approveRejectTaskHandler("ACCEPT"),
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {})
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-default reject-visit",
                                    onClick: ()=>approveRejectTaskHandler("REJECT"),
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        children: "\xd7"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                            data: state.monitoring,
                            version: "4",
                            striped: true,
                            hover: true,
                            bordered: false,
                            pagination: false,
                            search: false,
                            multiColumnSearch: true,
                            columnFilter: false,
                            options: {
                                ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186)
                            },
                            className: "themed-main-table-container",
                            trClassName: "visit-monitoring-tab-item",
                            tableHeaderClass: "primary",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "checkbox",
                                    dataFormat: (cell, row)=>/*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "checkbox",
                                            checked: checkedRows.includes(row.id),
                                            onChange: (e)=>handleCheckboxChange(e, row)
                                        }),
                                    width: "50px",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        type: "checkbox",
                                        checked: checkedRows.length > 0,
                                        onChange: handleSelectAll
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "product_name",
                                    isKey: true,
                                    width: "80px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_pname_label", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "product_code",
                                    width: "120px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_pcode_label", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "price",
                                    width: "100px",
                                    dataAlign: "center",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_price_label", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "sale_price",
                                    width: "100px",
                                    dataAlign: "center",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_sale_price_label", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: getImgObj,
                                    dataField: "photo_url",
                                    columnClassName: "monitoring-product-img-col",
                                    width: "240px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_photo_label", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "comment",
                                    width: "180px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_comment_label", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "approval",
                                    dataFormat: getApprovalInfo,
                                    width: "120px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "approved_by", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "approval",
                                    dataFormat: getApprovalStatus,
                                    width: "120px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_status_label", $5b1884b6ec98d715$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: (i, item)=>{
                                        return (0, $b79edb411f97c469$export$907f4281a0c616d7)(i, item, approveRejectTaskQuickHandler);
                                    },
                                    width: "80px"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                    loading: state.loading
                })
            ]
        })
    });
}
var $5b1884b6ec98d715$export$2e2bcd8739ae039 = $5b1884b6ec98d715$var$Monitoring;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");








const $77f8e7c52574ca26$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $77f8e7c52574ca26$var$Orders({ data: data }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        orders: "",
        loading: false
    });
    const [orderList, setOrderList] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({});
    const [activeObj, setActiveObj] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        isVisible: false,
        orderId: null
    });
    const extendedOptions = {
        ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186),
        onRowClick: (order)=>getFetchOrderDetails(order)
    };
    (0, $cQmXV.useEffect)(()=>{
        setState((prev)=>({
                ...prev,
                loading: true
            }));
        let url = `visits/${data.id}/orders_in_visit/`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            setState((prev)=>({
                    ...prev,
                    orders: response,
                    loading: false
                }));
        });
    }, [
        data.id
    ]);
    const getDateChange = (item, obj)=>{
        if (!item) return;
        let newDate = new Date(item);
        const date = (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(newDate);
        return date;
    };
    const getTaskRowStatusClass = (item)=>{
        if (!item.status) return;
        const str = item.status.toLowerCase();
        const result = str.replace(/ /g, "-");
        return result;
    };
    const getFetchOrderDetails = (order)=>{
        setActiveObj((prev)=>({
                ...prev,
                isVisible: true
            }));
        if (orderList[order.id]) {
            showPopupOrder(orderList[order.id]);
            return;
        }
        let url = `excalibur/orders/${order.id}/`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            addOrUpdateOrder(response);
            showPopupOrder(response);
        });
    };
    const totalProductTableCalculate = ()=>{
        if (orderList[activeObj.orderId].items) {
            const total = orderList[activeObj.orderId].items.reduce((acc, item)=>acc + (item.amount || 0) * item.quantity, 0);
            return total.toFixed(4);
        }
    };
    const addOrUpdateOrder = (order)=>{
        setOrderList((prev)=>{
            if (prev[order.id]) return prev;
            return {
                ...prev,
                [order.id]: order
            };
        });
    };
    const showPopupOrder = (order)=>{
        if (!order) return;
        setActiveObj((prev)=>({
                ...prev,
                orderId: order.id
            }));
    };
    const prepareOrderFormat = (item)=>{
        if (item === null || item === undefined) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            children: [
                item,
                " \u0433\u0440\u043D."
            ]
        });
    };
    const getDataNameField = (item)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: item.name
        });
    };
    const getItemStatus = (item, place = "list")=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        const text = item.toLowerCase();
        const formattedLabelText = text.replaceAll("_", " ");
        const label = text === "new" ? "new" : text === "processing" ? "processing" : text.includes("delivering") ? "delivering" : text === "canceled" ? "canceled" : text === "closed" ? "closed" : "empty";
        // "popup" callers use this as a bare class name, not as rendered content.
        if (place === "popup") return `order-popup-item-label-${label}`;
        else return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: `orders-task-status-label orders-task-status-label-${label}`,
            children: formattedLabelText
        });
    };
    const getDataNameFieldTable = (item)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: "orders-task-popup-item-name",
            children: item.name
        });
    };
    const preparePopupOrderTotal = (item, obj)=>{
        if (!obj) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        const total = obj.amount * obj.quantity;
        total.toFixed(4);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            className: "orders-task-popup-item-name",
            children: [
                total,
                " ",
                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_currency_total", $77f8e7c52574ca26$var$me.language)
            ]
        });
    };
    const handleClose = ()=>{
        setActiveObj((prev)=>({
                ...prev,
                isVisible: false
            }));
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "orders-task-tab-wrapper",
            children: [
                state?.orders ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                        data: state.orders,
                        version: "4",
                        striped: true,
                        hover: true,
                        bordered: false,
                        pagination: false,
                        search: false,
                        multiColumnSearch: true,
                        columnFilter: false,
                        options: extendedOptions,
                        className: "themed-main-table-container",
                        trClassName: (row)=>`orders-task-tab-item ${getTaskRowStatusClass(row)}`,
                        tableHeaderClass: "primary",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataField: "name",
                                isKey: true,
                                width: "60px",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_product_name", $77f8e7c52574ca26$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: getDataNameField,
                                dataField: "counterparty",
                                width: "60px",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_counterparty_label", $77f8e7c52574ca26$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (item, obj)=>getDateChange(item, obj),
                                dataField: "datetime",
                                width: "60px",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_product_status_date", $77f8e7c52574ca26$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: getItemStatus,
                                dataField: "status",
                                width: "60px",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_product_status", $77f8e7c52574ca26$var$me.language)
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                dataFormat: (item, obj)=>prepareOrderFormat(item, obj),
                                dataField: "order_total",
                                width: "60px",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_product_total", $77f8e7c52574ca26$var$me.language)
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                    loading: state.loading
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: `popup-item-order-wrapper ${activeObj.isVisible ? "is-active" : ""}`,
                    children: [
                        activeObj.isVisible && orderList[activeObj.orderId] ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "popup-item-order",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "close-order-popup",
                                    onClick: handleClose
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "order-popup-header",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("h3", {
                                            children: [
                                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_order_id_title", $77f8e7c52574ca26$var$me.language),
                                                ": ",
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    children: orderList[activeObj.orderId].id
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("p", {
                                            className: "order-sub-title",
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_details_title", $77f8e7c52574ca26$var$me.language)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "order-popup-content-wrapper",
                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "order-popup-content",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_sales_rep_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: [
                                                            orderList[activeObj.orderId].created_by?.first_name ? orderList[activeObj.orderId].created_by.first_name : "",
                                                            " ",
                                                            orderList[activeObj.orderId].created_by?.last_name ? orderList[activeObj.orderId].created_by.last_name : "",
                                                            !orderList[activeObj.orderId].created_by?.first_name && !orderList[activeObj.orderId].created_by?.last_name ? "-" : ""
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item  order-popup-created-by",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_order_status_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: `order-popup-content-item-value ${getItemStatus(orderList[activeObj.orderId].status, "popup")}`,
                                                        children: orderList[activeObj.orderId].status ? orderList[activeObj.orderId].status : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_counterparty_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].counterparty?.name ? orderList[activeObj.orderId].counterparty?.name : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_created_time_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].datetime ? getDateChange(orderList[activeObj.orderId].datetime) : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_order_type_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].order_type?.name ? orderList[activeObj.orderId].order_type?.name : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_delivery_time_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].delivery_date ? getDateChange(orderList[activeObj.orderId].delivery_date) : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_tracked_geolocation_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].tracked_geolocation.latitude && orderList[activeObj.orderId].tracked_geolocation.longitude ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "order-popup-content-value-color",
                                                                    children: "lat:"
                                                                }),
                                                                " ",
                                                                orderList[activeObj.orderId].tracked_geolocation.latitude,
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("br", {}),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "order-popup-content-value-color",
                                                                    children: "lng:"
                                                                }),
                                                                " ",
                                                                orderList[activeObj.orderId].tracked_geolocation.longitude
                                                            ]
                                                        }) : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_custom_fields_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].custom_fields ? orderList[activeObj.orderId].custom_fields : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_comment_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].comments ? orderList[activeObj.orderId].comments : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-label",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_visit_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: orderList[activeObj.orderId].visit ? orderList[activeObj.orderId].visit : "-"
                                                    })
                                                ]
                                            }),
                                            orderList[activeObj.orderId]?.items && orderList[activeObj.orderId].items?.length > 0 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                className: "order-popup-content-item full-cell",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "order-popup-content-item-value",
                                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_order_table_label", $77f8e7c52574ca26$var$me.language)
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                                                        data: orderList[activeObj.orderId].items,
                                                        version: "4",
                                                        striped: true,
                                                        hover: true,
                                                        bordered: false,
                                                        pagination: false,
                                                        search: false,
                                                        multiColumnSearch: true,
                                                        columnFilter: false,
                                                        options: {
                                                            ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186)
                                                        },
                                                        className: "themed-main-table-container",
                                                        trClassName: (row)=>`orders-task-tab-item orders-popup-table-item-row`,
                                                        tableHeaderClass: "primary",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                                dataFormat: getDataNameFieldTable,
                                                                isKey: true,
                                                                dataField: "product",
                                                                width: "60",
                                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_order_table_name", $77f8e7c52574ca26$var$me.language)
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                                dataField: "quantity",
                                                                width: "60px",
                                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_order_table_quantity", $77f8e7c52574ca26$var$me.language)
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                                dataField: "amount",
                                                                width: "60px",
                                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_order_table_amount", $77f8e7c52574ca26$var$me.language)
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                                                dataFormat: (item, obj)=>preparePopupOrderTotal(item, obj),
                                                                dataField: "amount",
                                                                width: "60px",
                                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_product_total", $77f8e7c52574ca26$var$me.language)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "orders-task-tab-item custom-total-cell",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                className: "custom-total-cell-title",
                                                                children: [
                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_product_total", $77f8e7c52574ca26$var$me.language),
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                className: "custom-total-cell-last",
                                                                children: [
                                                                    totalProductTableCalculate(),
                                                                    " ",
                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_currency_total", $77f8e7c52574ca26$var$me.language)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: `order-popup-overlay ${activeObj.isVisible ? "is-active" : ""}`,
                            onClick: handleClose
                        })
                    ]
                })
            ]
        })
    });
}
var $77f8e7c52574ca26$export$2e2bcd8739ae039 = $77f8e7c52574ca26$var$Orders;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");






const $0328b429a87f2283$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
const $0328b429a87f2283$var$formatDate = (dateStr)=>{
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("uk-UA", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    });
};
const $0328b429a87f2283$var$TAB_CONFIG = [
    {
        key: "products",
        icon: "inventory_2",
        labelKey: "surveys_tab_products"
    },
    {
        key: "brands",
        icon: "label",
        labelKey: "surveys_tab_brands"
    },
    {
        key: "categories",
        icon: "category",
        labelKey: "surveys_tab_categories"
    },
    {
        key: "other",
        icon: "help_outline",
        labelKey: "surveys_tab_other"
    }
];
const $0328b429a87f2283$var$ANSWER_TYPE_META = {
    boolean: {
        icon: "toggle_on",
        labelKey: "surveys_answer_type_bool"
    },
    numeric: {
        icon: "tag",
        labelKey: "surveys_answer_type_numeric"
    },
    dropdown: {
        icon: "list",
        labelKey: "surveys_answer_type_dropdown"
    },
    text: {
        icon: "notes",
        labelKey: "surveys_answer_type_text"
    },
    date: {
        icon: "event",
        labelKey: "surveys_answer_type_date"
    },
    photo: {
        icon: "image",
        labelKey: "surveys_answer_type_photo"
    }
};
const $0328b429a87f2283$var$renderAnswerCell = (answer, onOpenPhoto)=>{
    if (!answer.question) return null;
    switch(answer.question.answer_type){
        case "boolean":
            return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                className: `visit-a-bool ${answer.answer_boolean ? "yes" : "no"}`,
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: answer.answer_boolean ? "check_circle" : "cancel"
                    }),
                    answer.answer_boolean ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_answer_bool_yes", $0328b429a87f2283$var$me.language) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_answer_bool_no", $0328b429a87f2283$var$me.language)
                ]
            });
        case "numeric":
            return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "visit-a-numeric",
                children: answer.answer_numeric
            });
        case "dropdown":
            return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "visit-a-dropdown",
                children: answer.answer_dropdown?.label
            });
        case "text":
            return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                className: "visit-a-text",
                children: answer.answer_text
            });
        case "date":
            return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                className: "visit-a-date",
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                        className: "material-symbols-outlined",
                        children: "event"
                    }),
                    answer.answer_date
                ]
            });
        case "photo":
            {
                const photos = answer.photos || [];
                return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "visit-a-photos",
                    children: [
                        photos.map((photo, i)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "visit-photo-mini",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onOpenPhoto(photos, i, answer.question?.text);
                                },
                                children: [
                                    photo.photo ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                        src: photo.photo,
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "image"
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "visit-photo-mini-overlay",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "zoom_in"
                                        })
                                    })
                                ]
                            }, photo.id || i)),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                            className: "visit-photo-label",
                            children: [
                                photos.length,
                                " ",
                                (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_photo_label", $0328b429a87f2283$var$me.language)
                            ]
                        })
                    ]
                });
            }
        default:
            return null;
    }
};
const $0328b429a87f2283$var$Surveys = ({ data: data })=>{
    const [state, setState] = (0, $cQmXV.useState)({
        summary: null,
        surveys: [],
        loading: false
    });
    const [expandedCards, setExpandedCards] = (0, $cQmXV.useState)({});
    const [surveyDetails, setSurveyDetails] = (0, $cQmXV.useState)({});
    const [surveyDetailLoading, setSurveyDetailLoading] = (0, $cQmXV.useState)({});
    const [activeTabs, setActiveTabs] = (0, $cQmXV.useState)({});
    const [collapsedEntities, setCollapsedEntities] = (0, $cQmXV.useState)({});
    const [searchQuery, setSearchQuery] = (0, $cQmXV.useState)("");
    const [entitySearchDebounced, setEntitySearchDebounced] = (0, $cQmXV.useState)({});
    const entitySearchTimers = (0, $cQmXV.useRef)({});
    const [entityLimit, setEntityLimit] = (0, $cQmXV.useState)({});
    const ENTITY_PAGE = 5;
    const getLimit = (surveyId, groupKey)=>entityLimit[`${surveyId}-${groupKey}`] || ENTITY_PAGE;
    const showMore = (surveyId, groupKey)=>setEntityLimit((prev)=>({
                ...prev,
                [`${surveyId}-${groupKey}`]: (prev[`${surveyId}-${groupKey}`] || ENTITY_PAGE) + ENTITY_PAGE
            }));
    const [photoModal, setPhotoModal] = (0, $cQmXV.useState)(null);
    const handleEntitySearch = (surveyId, value)=>{
        clearTimeout(entitySearchTimers.current[surveyId]);
        entitySearchTimers.current[surveyId] = setTimeout(()=>{
            setEntitySearchDebounced((prev)=>({
                    ...prev,
                    [surveyId]: value
                }));
        }, (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
    };
    const openPhotoModal = (photos, index, question)=>setPhotoModal({
            photos: photos,
            index: index,
            question: question
        });
    const closePhotoModal = ()=>setPhotoModal(null);
    const prevPhoto = ()=>setPhotoModal((prev)=>({
                ...prev,
                index: prev.index - 1
            }));
    const nextPhoto = ()=>setPhotoModal((prev)=>({
                ...prev,
                index: prev.index + 1
            }));
    (0, $cQmXV.useEffect)(()=>{
        let isMounted = true;
        setState({
            summary: null,
            surveys: [],
            loading: true
        });
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `visits/${data.id}/surveys_in_visit/`
        }, (response)=>{
            if (!isMounted) return;
            const surveys = (response.surveys || []).filter((s)=>(s.answers_count ?? 0) > 0 || (s.photos_count ?? 0) > 0);
            setState({
                summary: response.summary,
                surveys: surveys,
                loading: false
            });
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        data.id
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const timers = entitySearchTimers.current;
        return ()=>{
            Object.values(timers).forEach(clearTimeout);
        };
    }, []);
    const toggleCard = (id)=>{
        const willExpand = !expandedCards[id];
        setExpandedCards((prev)=>({
                ...prev,
                [id]: willExpand
            }));
        if (willExpand && !surveyDetails[id]) {
            setSurveyDetailLoading((prev)=>({
                    ...prev,
                    [id]: true
                }));
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "GET",
                url: `visit_surveys/${id}/?visit_id=${data.id}`
            }, (response)=>{
                setSurveyDetails((prev)=>({
                        ...prev,
                        [id]: response
                    }));
                setSurveyDetailLoading((prev)=>({
                        ...prev,
                        [id]: false
                    }));
            });
        }
    };
    const switchTab = (surveyId, tab, e)=>{
        e.stopPropagation();
        setActiveTabs((prev)=>({
                ...prev,
                [surveyId]: tab
            }));
    };
    const toggleEntity = (entityId, e)=>{
        e.stopPropagation();
        setCollapsedEntities((prev)=>({
                ...prev,
                [entityId]: !prev[entityId]
            }));
    };
    const { summary: summary, surveys: surveys, loading: loading } = state;
    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        className: "visit-surveys-tab-wrapper",
        children: [
            summary ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "visit-surveys-stats-row",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "visit-surveys-stat-card",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "visit-surveys-stat-icon visit-surveys-stat-icon--primary",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "quiz"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "visit-surveys-stat-value",
                                                children: summary.surveys ?? "-"
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "visit-surveys-stat-label",
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_summary_surveys_label", $0328b429a87f2283$var$me.language)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "visit-surveys-stat-card",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "visit-surveys-stat-icon visit-surveys-stat-icon--secondary",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "check_circle"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "visit-surveys-stat-value",
                                                children: summary.answers ?? "-"
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "visit-surveys-stat-label",
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_summary_answers_label", $0328b429a87f2283$var$me.language)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "visit-surveys-stat-card",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "visit-surveys-stat-icon visit-surveys-stat-icon--tertiary",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "photo_library"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "visit-surveys-stat-value",
                                                children: summary.photos ?? "-"
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "visit-surveys-stat-label",
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_summary_photos_label", $0328b429a87f2283$var$me.language)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "visit-filter-bar",
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "visit-search-bar",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "search"
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        type: "text",
                                        placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_search_placeholder", $0328b429a87f2283$var$me.language),
                                        value: searchQuery,
                                        onChange: (e)=>setSearchQuery(e.target.value)
                                    })
                                ]
                            }),
                            searchQuery && /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                className: "visit-btn-text",
                                onClick: ()=>setSearchQuery(""),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_reset_btn", $0328b429a87f2283$var$me.language)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                        className: "visit-record-count",
                        children: [
                            surveys.filter((s)=>s.title.toLowerCase().includes(searchQuery.toLowerCase())).length,
                            "\xa0",
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_summary_surveys_label", $0328b429a87f2283$var$me.language),
                            "\xa0\u2022\xa0",
                            summary.answers,
                            "\xa0",
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_summary_answers_label", $0328b429a87f2283$var$me.language)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "visit-survey-list",
                        children: (()=>{
                            const filteredSurveys = surveys.filter((s)=>s.title.toLowerCase().includes(searchQuery.toLowerCase()));
                            if (filteredSurveys.length === 0) return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "visit-empty-state",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "search_off"
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "visit-empty-state-title",
                                        children: [
                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_no_results", $0328b429a87f2283$var$me.language),
                                            searchQuery && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                className: "visit-empty-state-query",
                                                children: [
                                                    " \xab",
                                                    searchQuery,
                                                    "\xbb"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            });
                            return filteredSurveys.map((survey)=>{
                                const isExpanded = !!expandedCards[survey.id];
                                const isDetailLoading = !!surveyDetailLoading[survey.id];
                                const detail = surveyDetails[survey.id];
                                const groups = detail?.groups || {};
                                const products = groups.products || [];
                                const brands = groups.brands || [];
                                const categories = groups.categories || [];
                                const other = groups.other || [];
                                const groupCounts = {
                                    products: products.length,
                                    brands: brands.length,
                                    categories: categories.length,
                                    other: other.length
                                };
                                const tab = activeTabs[survey.id] || (detail ? $0328b429a87f2283$var$TAB_CONFIG.find((t)=>groupCounts[t.key] > 0)?.key || "products" : "products");
                                const entityQuery = (entitySearchDebounced[survey.id] || "").toLowerCase();
                                const isEmpty = detail && !isDetailLoading && products.length === 0 && brands.length === 0 && categories.length === 0 && other.length === 0;
                                if (isEmpty) return null;
                                const filteredProducts = entityQuery ? products.filter((p)=>(p.product?.name || "").toLowerCase().includes(entityQuery) || (p.product?.code || "").toLowerCase().includes(entityQuery)) : products;
                                const filteredBrands = entityQuery ? brands.filter((b)=>(b.brand?.name || "").toLowerCase().includes(entityQuery)) : brands;
                                const filteredCategories = entityQuery ? categories.filter((c)=>(c.category?.name || "").toLowerCase().includes(entityQuery)) : categories;
                                const filteredOther = entityQuery ? other.filter((a)=>(a.question?.text || "").toLowerCase().includes(entityQuery)) : other;
                                const tabs = $0328b429a87f2283$var$TAB_CONFIG.map((t)=>({
                                        ...t,
                                        count: t.key === "products" ? filteredProducts.length : t.key === "brands" ? filteredBrands.length : t.key === "categories" ? filteredCategories.length : filteredOther.length
                                    }));
                                return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: `visit-survey-card${isExpanded ? " expanded" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "visit-survey-card-header",
                                            onClick: ()=>toggleCard(survey.id),
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "visit-survey-icon",
                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "material-symbols-outlined",
                                                        children: "assignment"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                    className: "visit-survey-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                            className: "visit-survey-title",
                                                            children: survey.title
                                                        }),
                                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "visit-survey-meta",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                    className: "visit-badge visit-badge-completed",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                            className: "material-symbols-outlined",
                                                                            style: {
                                                                                fontSize: "12px"
                                                                            },
                                                                            children: "check"
                                                                        }),
                                                                        survey.answers_count
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                    className: "visit-badge visit-badge-photos",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                            className: "material-symbols-outlined",
                                                                            style: {
                                                                                fontSize: "12px"
                                                                            },
                                                                            children: "photo"
                                                                        }),
                                                                        survey.photos_count
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                    className: "visit-survey-meta-item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                            className: "material-symbols-outlined",
                                                                            children: "person"
                                                                        }),
                                                                        (data.user?.first_name || "") + " " + (data.user?.last_name || "")
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                    className: "visit-survey-chevron",
                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "material-symbols-outlined",
                                                        children: "expand_more"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "visit-survey-detail",
                                            children: isDetailLoading ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                                                loading: true
                                            }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                        className: "visit-inner-tabs",
                                                        children: [
                                                            tabs.map((t)=>/*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                                                    className: `visit-inner-tab${tab === t.key ? " active" : ""}`,
                                                                    onClick: (e)=>switchTab(survey.id, t.key, e),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                            className: "material-symbols-outlined",
                                                                            children: t.icon
                                                                        }),
                                                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), t.labelKey, $0328b429a87f2283$var$me.language),
                                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                            className: "visit-itc",
                                                                            children: t.count
                                                                        })
                                                                    ]
                                                                }, t.key)),
                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                className: "visit-inner-search",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                        className: "material-symbols-outlined",
                                                                        children: "search"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                                                        type: "text",
                                                                        placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_entity_search_placeholder", $0328b429a87f2283$var$me.language),
                                                                        defaultValue: "",
                                                                        onChange: (e)=>handleEntitySearch(survey.id, e.target.value)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                        className: `visit-inner-tab-panel${tab === "products" ? " active" : ""}`,
                                                        children: filteredProducts.length === 0 ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "visit-empty-state",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined",
                                                                    children: "inventory_2"
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-empty-state-title",
                                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_empty_products", $0328b429a87f2283$var$me.language)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                                            children: [
                                                                filteredProducts.slice(0, getLimit(survey.id, "products")).map((prod)=>{
                                                                    const entityId = `${survey.id}-p${prod.product.id}`;
                                                                    const isCollapsed = !collapsedEntities[entityId];
                                                                    const photoCount = prod.answers.reduce((sum, a)=>sum + (a.photos?.length || 0), 0);
                                                                    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                        className: `visit-entity-item${isCollapsed ? " collapsed" : ""}`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                                className: "visit-entity-row",
                                                                                onClick: (e)=>toggleEntity(entityId, e),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                        className: "material-symbols-outlined visit-chevron",
                                                                                        children: "expand_more"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                                        className: "visit-entity-icon-sm",
                                                                                        style: {
                                                                                            background: "var(--md-primary-container)",
                                                                                            color: "var(--md-on-primary-container)"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                            className: "material-symbols-outlined",
                                                                                            children: "inventory_2"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                        className: "visit-entity-name",
                                                                                        children: prod.product.name
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                        className: "visit-entity-sub",
                                                                                        children: prod.product.code
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                        className: "visit-entity-answer-count",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                className: "material-symbols-outlined",
                                                                                                children: "question_answer"
                                                                                            }),
                                                                                            prod.answers.length
                                                                                        ]
                                                                                    }),
                                                                                    photoCount > 0 && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                        className: "visit-entity-photo-count",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                className: "material-symbols-outlined",
                                                                                                children: "photo_camera"
                                                                                            }),
                                                                                            photoCount
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                                className: "visit-entity-answers",
                                                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("table", {
                                                                                    className: "visit-qa-table",
                                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                                                                                        children: prod.answers.map((answer)=>{
                                                                                            const meta = $0328b429a87f2283$var$ANSWER_TYPE_META[answer.question?.answer_type];
                                                                                            return /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("td", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                                className: "visit-q-text",
                                                                                                                children: answer.question?.text
                                                                                                            }),
                                                                                                            meta && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                                                className: "visit-q-type",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                                        className: "material-symbols-outlined",
                                                                                                                        children: meta.icon
                                                                                                                    }),
                                                                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), meta.labelKey, $0328b429a87f2283$var$me.language)
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                                                                        children: $0328b429a87f2283$var$renderAnswerCell(answer, openPhotoModal)
                                                                                                    })
                                                                                                ]
                                                                                            }, answer.id);
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, entityId);
                                                                }),
                                                                filteredProducts.length > getLimit(survey.id, "products") && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-show-more-row",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                                                        className: "visit-btn-ghost",
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            showMore(survey.id, "products");
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                className: "material-symbols-outlined",
                                                                                children: "expand_more"
                                                                            }),
                                                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_show_more", $0328b429a87f2283$var$me.language),
                                                                            " ",
                                                                            filteredProducts.length - getLimit(survey.id, "products")
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                        className: `visit-inner-tab-panel${tab === "brands" ? " active" : ""}`,
                                                        children: filteredBrands.length === 0 ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "visit-empty-state",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined",
                                                                    children: "label_off"
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-empty-state-title",
                                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_empty_brands", $0328b429a87f2283$var$me.language)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                                            children: [
                                                                filteredBrands.slice(0, getLimit(survey.id, "brands")).map((item)=>{
                                                                    const entityId = `${survey.id}-b${item.brand.id}`;
                                                                    const isCollapsed = !collapsedEntities[entityId];
                                                                    const photoCount = item.answers.reduce((sum, a)=>sum + (a.photos?.length || 0), 0);
                                                                    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                        className: `visit-entity-item${isCollapsed ? " collapsed" : ""}`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                                className: "visit-entity-row",
                                                                                onClick: (e)=>toggleEntity(entityId, e),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                        className: "material-symbols-outlined visit-chevron",
                                                                                        children: "expand_more"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                                        className: "visit-entity-icon-sm",
                                                                                        style: {
                                                                                            background: "#FFF3E0",
                                                                                            color: "#E65100"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                            className: "material-symbols-outlined",
                                                                                            children: "label"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                        className: "visit-entity-name",
                                                                                        children: item.brand.name
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                        className: "visit-entity-answer-count",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                className: "material-symbols-outlined",
                                                                                                children: "question_answer"
                                                                                            }),
                                                                                            item.answers.length
                                                                                        ]
                                                                                    }),
                                                                                    photoCount > 0 && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                        className: "visit-entity-photo-count",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                className: "material-symbols-outlined",
                                                                                                children: "photo_camera"
                                                                                            }),
                                                                                            photoCount
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                                className: "visit-entity-answers",
                                                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("table", {
                                                                                    className: "visit-qa-table",
                                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                                                                                        children: item.answers.map((answer)=>{
                                                                                            const meta = $0328b429a87f2283$var$ANSWER_TYPE_META[answer.question?.answer_type];
                                                                                            return /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("td", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                                className: "visit-q-text",
                                                                                                                children: answer.question?.text
                                                                                                            }),
                                                                                                            meta && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                                                className: "visit-q-type",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                                        className: "material-symbols-outlined",
                                                                                                                        children: meta.icon
                                                                                                                    }),
                                                                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), meta.labelKey, $0328b429a87f2283$var$me.language)
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                                                                        children: $0328b429a87f2283$var$renderAnswerCell(answer, openPhotoModal)
                                                                                                    })
                                                                                                ]
                                                                                            }, answer.id);
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, entityId);
                                                                }),
                                                                filteredBrands.length > getLimit(survey.id, "brands") && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-show-more-row",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                                                        className: "visit-btn-ghost",
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            showMore(survey.id, "brands");
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                className: "material-symbols-outlined",
                                                                                children: "expand_more"
                                                                            }),
                                                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_show_more", $0328b429a87f2283$var$me.language),
                                                                            " ",
                                                                            filteredBrands.length - getLimit(survey.id, "brands")
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                        className: `visit-inner-tab-panel${tab === "categories" ? " active" : ""}`,
                                                        children: filteredCategories.length === 0 ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "visit-empty-state",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined",
                                                                    children: "category"
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-empty-state-title",
                                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_empty_categories", $0328b429a87f2283$var$me.language)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                                            children: [
                                                                filteredCategories.slice(0, getLimit(survey.id, "categories")).map((item)=>{
                                                                    const entityId = `${survey.id}-c${item.category.id}`;
                                                                    const isCollapsed = !collapsedEntities[entityId];
                                                                    return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                        className: `visit-entity-item${isCollapsed ? " collapsed" : ""}`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                                                className: "visit-entity-row",
                                                                                onClick: (e)=>toggleEntity(entityId, e),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                        className: "material-symbols-outlined visit-chevron",
                                                                                        children: "expand_more"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                                        className: "visit-entity-icon-sm",
                                                                                        style: {
                                                                                            background: "#E8F5E9",
                                                                                            color: "#2E7D32"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                            className: "material-symbols-outlined",
                                                                                            children: "category"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                        className: "visit-entity-name",
                                                                                        children: item.category.name
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                        className: "visit-entity-answer-count",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                className: "material-symbols-outlined",
                                                                                                children: "question_answer"
                                                                                            }),
                                                                                            item.answers.length
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                                className: "visit-entity-answers",
                                                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("table", {
                                                                                    className: "visit-qa-table",
                                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                                                                                        children: item.answers.map((answer)=>{
                                                                                            const meta = $0328b429a87f2283$var$ANSWER_TYPE_META[answer.question?.answer_type];
                                                                                            return /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("td", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                                className: "visit-q-text",
                                                                                                                children: answer.question?.text
                                                                                                            }),
                                                                                                            meta && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                                                className: "visit-q-type",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                                        className: "material-symbols-outlined",
                                                                                                                        children: meta.icon
                                                                                                                    }),
                                                                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), meta.labelKey, $0328b429a87f2283$var$me.language)
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                                                                        children: $0328b429a87f2283$var$renderAnswerCell(answer, openPhotoModal)
                                                                                                    })
                                                                                                ]
                                                                                            }, answer.id);
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, entityId);
                                                                }),
                                                                filteredCategories.length > getLimit(survey.id, "categories") && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-show-more-row",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                                                        className: "visit-btn-ghost",
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            showMore(survey.id, "categories");
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                className: "material-symbols-outlined",
                                                                                children: "expand_more"
                                                                            }),
                                                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_show_more", $0328b429a87f2283$var$me.language),
                                                                            " ",
                                                                            filteredCategories.length - getLimit(survey.id, "categories")
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                        className: `visit-inner-tab-panel${tab === "other" ? " active" : ""}`,
                                                        children: filteredOther.length === 0 ? /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                                            className: "visit-empty-state",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                    className: "material-symbols-outlined",
                                                                    children: "help_outline"
                                                                }),
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-empty-state-title",
                                                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_empty_other", $0328b429a87f2283$var$me.language)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7uT18.jsx)("table", {
                                                                    className: "visit-other-qa-table",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("tbody", {
                                                                        children: filteredOther.slice(0, getLimit(survey.id, "other")).map((answer)=>{
                                                                            const meta = $0328b429a87f2283$var$ANSWER_TYPE_META[answer.question?.answer_type];
                                                                            return /*#__PURE__*/ (0, $7uT18.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7uT18.jsxs)("td", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                className: "visit-q-text",
                                                                                                children: answer.question?.text
                                                                                            }),
                                                                                            meta && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                                                                className: "visit-q-type",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                                        className: "material-symbols-outlined",
                                                                                                        children: meta.icon
                                                                                                    }),
                                                                                                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), meta.labelKey, $0328b429a87f2283$var$me.language)
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7uT18.jsx)("td", {
                                                                                        children: $0328b429a87f2283$var$renderAnswerCell(answer, openPhotoModal)
                                                                                    })
                                                                                ]
                                                                            }, answer.id);
                                                                        })
                                                                    })
                                                                }),
                                                                filteredOther.length > getLimit(survey.id, "other") && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                                    className: "visit-show-more-row",
                                                                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                                                        className: "visit-btn-ghost",
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            showMore(survey.id, "other");
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                                                className: "material-symbols-outlined",
                                                                                children: "expand_more"
                                                                            }),
                                                                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_show_more", $0328b429a87f2283$var$me.language),
                                                                            " ",
                                                                            filteredOther.length - getLimit(survey.id, "other")
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, survey.id);
                            });
                        })()
                    })
                ]
            }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                loading: loading
            }),
            photoModal && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                className: "visit-photo-modal-backdrop",
                onClick: closePhotoModal,
                children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "visit-photo-modal-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "visit-photo-modal-img",
                            children: photoModal.photos[photoModal.index] && /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                src: photoModal.photos[photoModal.index].photo,
                                alt: ""
                            })
                        }),
                        photoModal.photos.length > 1 && /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "visit-photo-modal-nav-row",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    className: "visit-photo-modal-nav",
                                    onClick: prevPhoto,
                                    disabled: photoModal.index === 0,
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "chevron_left"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                    className: "visit-photo-modal-counter",
                                    children: [
                                        photoModal.index + 1,
                                        " / ",
                                        photoModal.photos.length
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    className: "visit-photo-modal-nav",
                                    onClick: nextPhoto,
                                    disabled: photoModal.index === photoModal.photos.length - 1,
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "chevron_right"
                                    })
                                })
                            ]
                        }),
                        photoModal.question && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "visit-photo-modal-question",
                            children: photoModal.question
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                            className: "visit-photo-modal-close",
                            onClick: closePhotoModal,
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_modal_close", $0328b429a87f2283$var$me.language)
                        })
                    ]
                })
            })
        ]
    });
};
var $0328b429a87f2283$export$2e2bcd8739ae039 = $0328b429a87f2283$var$Surveys;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");








const $509e0d8f4acc2e7c$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $509e0d8f4acc2e7c$var$Payments({ data: data }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        payments: "",
        loading: false
    });
    (0, $cQmXV.useEffect)(()=>{
        setState((prev)=>({
                ...prev,
                loading: true
            }));
        let url = `visits/${data.id}/payments_in_visit/`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            setState((prev)=>({
                    ...prev,
                    payments: response,
                    loading: false
                }));
        });
    }, [
        data.id
    ]);
    const getDateChange = (item, obj)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        let newDate = new Date(item);
        const date = (0, $b79edb411f97c469$export$4e4cb19dd88cd821)(newDate);
        return date;
    };
    const getTaskRowStatusClass = (item)=>{
        if (!item.status) return;
        const str = item.status.toLowerCase();
        const result = str.replace(/ /g, "-");
        return result;
    };
    const getCounterpartyInfo = (item)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: item.name
        });
    };
    const getStringReturn = (item)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: item
        });
    };
    const getStringDebt = (item)=>{
        if (!item?.name_of_the_document) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: item.name_of_the_document
        });
    };
    const prepareOrderFormat = (item)=>{
        if (item === null || item === undefined) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
            children: [
                item,
                " \u0433\u0440\u043D."
            ]
        });
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "returns-task-tab-wrapper",
            children: state?.payments ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
                children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                    data: state.payments,
                    version: "4",
                    striped: true,
                    hover: true,
                    bordered: false,
                    pagination: false,
                    search: false,
                    multiColumnSearch: true,
                    columnFilter: false,
                    options: {
                        ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186)
                    },
                    className: "themed-main-table-container",
                    trClassName: (row)=>`returns-task-tab-item ${getTaskRowStatusClass(row)}`,
                    tableHeaderClass: "primary",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataField: "id",
                            isKey: true,
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_payment_id_label", $509e0d8f4acc2e7c$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: getCounterpartyInfo,
                            dataField: "counterparty",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_counterparty_label", $509e0d8f4acc2e7c$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: prepareOrderFormat,
                            dataField: "amount",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_payment_amount_label", $509e0d8f4acc2e7c$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: getStringDebt,
                            dataField: "debt",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_payment_debt_label", $509e0d8f4acc2e7c$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: getStringReturn,
                            dataField: "comment",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_comment_label", $509e0d8f4acc2e7c$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (item, obj)=>getDateChange(item, obj),
                            dataField: "datetime",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_return_crated_label", $509e0d8f4acc2e7c$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataField: "visit",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_visit_label", $509e0d8f4acc2e7c$var$me.language)
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                loading: state.loading
            })
        })
    });
}
var $509e0d8f4acc2e7c$export$2e2bcd8739ae039 = $509e0d8f4acc2e7c$var$Payments;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $Yxlsx = parcelRequire("Yxlsx");











const $60b19c25b33bb649$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
const $60b19c25b33bb649$var$defaultTemplate = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().defaultTemplate;
function $60b19c25b33bb649$var$Report({ data: data }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        reports: "",
        loading: false,
        isModalSingle: false,
        isResetPhotoItem: false,
        mode: "list",
        currentIndex: 0,
        data: [],
        count: 0,
        pagination: {
            state: false,
            count: 0,
            sizePerPage: 25,
            pageAmount: 1,
            page: 1
        },
        lazyPagination: {
            page: 1,
            isNext: false
        },
        scrollPosition: 0,
        newTask: {},
        newTaskLoading: false,
        isModal: false,
        itemPost: []
    });
    const [isMsgStatus, setIsMsgStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        status: false,
        type: "error",
        message: ""
    });
    const modeTypes = {
        view: "view",
        list: "list"
    };
    const previewNavigationData = {
        currentIndex: state.currentIndex || 0,
        lastIndex: state.reports?.length || 0
    };
    const editBlockData = ()=>{
        return {
            item: state.newTask,
            type: "point",
            newTaskFromReviewPhoto: true,
            onChange: (title, property)=>newTaskOnChange(title, property),
            onSaveEditorImage: (index, image)=>onSaveEditorImage(index, image),
            submit: (status)=>newTaskSubmit(status),
            setOpen: ()=>setState((prevState)=>({
                        ...prevState,
                        isOpen: true
                    })),
            closeModal: ()=>setState((prevState)=>({
                        ...prevState,
                        isModal: false
                    })),
            errors: state.errors,
            isImageEditable: true,
            newTaskLoading: state.newTaskLoading,
            isModal: state.isModal,
            currentPhotoIndex: state.quickItemPhotoIndex || 0
        };
    };
    const loadReports = ()=>{
        setState((prevState)=>({
                ...prevState,
                loading: true
            }));
        let url = `visits/${data.id}/photos_in_visit?page=${state.pagination.page}`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            const results = response?.results || [];
            setState((prevState)=>({
                    ...prevState,
                    reports: results,
                    loading: false,
                    count: results.length,
                    newTask: setInitTask(),
                    lazyPagination: {
                        ...prevState.lazyPagination,
                        isNext: !!results.length
                    }
                }));
        });
    };
    // Only fetch reports when the browser tab is actually visible. Visit details
    // open in new tabs (window.open "_blank"); without this guard, opening many
    // rows would fire a photos_in_visit request from every background tab at once
    // and hammer the backend. Background tabs defer the fetch until first shown.
    (0, $cQmXV.useEffect)(()=>{
        if (typeof document !== "undefined" && document.visibilityState === "hidden") {
            const onVisible = ()=>{
                if (document.visibilityState === "visible") {
                    document.removeEventListener("visibilitychange", onVisible);
                    loadReports();
                }
            };
            document.addEventListener("visibilitychange", onVisible);
            return ()=>document.removeEventListener("visibilitychange", onVisible);
        }
        loadReports();
    }, [
        data
    ]);
    const lazyLoad = ()=>{
        let { lazyPagination: lazyPagination } = state;
        if (!lazyPagination.isNext) return;
        let url = `visits/${data.id}/photos_in_visit?page=${lazyPagination.page + 1}`;
        setState((prevState)=>({
                ...prevState,
                loading: true
            }));
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            if (!response.results) {
                console.log("error on getting filtered photo list");
                return;
            }
            let isNext = !!response.results.length || false;
            const newPagination = {
                page: response.results.length ? lazyPagination.page + 1 : lazyPagination.page,
                isNext: isNext
            };
            const accumulatedDataList = response.results.length ? [
                ...state.reports,
                ...response.results
            ] : state.reports;
            setState((prevState)=>({
                    ...prevState,
                    reports: accumulatedDataList,
                    loading: false,
                    count: state.reports.length + response.results.length,
                    lazyPagination: newPagination
                }));
        });
    };
    const setInitTask = ()=>({
            images: [],
            company: null,
            title: "",
            start: new Date(),
            end: new Date(new Date().setHours(23, 59, 59)),
            tags: [],
            components: [],
            priority: 2,
            template: ""
        });
    const newTaskOnChange = (property, value)=>{
        let item = state.newTask;
        item[property] = value;
        setState((prevState)=>({
                ...prevState,
                newTask: item
            }));
    };
    const onSaveEditorImage = (index, image)=>{
        const { newTask: newTask } = state;
        if (!image) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: $60b19c25b33bb649$var$me,
                image: image
            }
        }, (image)=>{
            if (image?.id) setState((prevState)=>({
                    ...prevState,
                    newTask: {
                        ...newTask,
                        images: [
                            image
                        ]
                    }
                }));
            else console.log(image, "image doesnt have id");
        });
    };
    const openTask = (item, indexPhoto)=>{
        const el = document.querySelectorAll(".vr-card");
        const rect = el[indexPhoto].getBoundingClientRect();
        setState((prevState)=>({
                ...prevState,
                item: item,
                isModalSingle: true,
                isModal: false,
                newTask: setInitTask(),
                currentIndex: indexPhoto,
                scrollPosition: rect.top + window.scrollY - 150
            }));
    };
    const createNewTask = (data)=>{
        if (!data) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "tasks/",
            post: data
        }, (response)=>{
            if (response?.id) {
                // Alert.success(translate(TRANSLATION_DOWNLOADER, "newtask_success_msg", me.language));
                setIsMsgStatus({
                    status: true,
                    type: "success",
                    message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "newtask_success_msg", $60b19c25b33bb649$var$me.language)
                });
                setState((prevState)=>({
                        ...prevState,
                        mode: modeTypes.list,
                        isModal: false,
                        errors: {},
                        newTask: setInitTask()
                    }));
                setApproveRejectState("REJECT");
            } else {
                setIsMsgStatus({
                    status: true,
                    type: "warning",
                    message: "Error while saving item. Error: " + JSON.stringify(response)
                });
                console.log(response);
            }
        });
    };
    const newTaskSubmit = async (status)=>{
        let { newTask: newTask } = state;
        let itemPost = Object.assign({}, newTask);
        let queueLoadingTimer = 0;
        let queueLoadingStep = 8000;
        itemPost.components = newTask.components.map((i)=>i.id);
        itemPost.network = newTask?.network?.id || null;
        itemPost.end = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(itemPost.end).format("yyyy-MM-DDT23:59:59");
        itemPost.created_by = newTask.created_by?.id || $60b19c25b33bb649$var$me?.id || null;
        itemPost.template = itemPost.template === "" ? $60b19c25b33bb649$var$defaultTemplate : itemPost.template;
        itemPost.visit_id = state.item?.visit_id || 0;
        const { validate: validate, errors: errors } = (0, $3b579ca6158bc61b$export$6daeeb4cea31fc5)("visit-photo", itemPost);
        if (!validate) {
            setState((prevState)=>({
                    ...prevState,
                    errors: errors
                }));
            return;
        }
        if (itemPost.images.every((image)=>image.id)) {
            itemPost.images = newTask.images?.map((image)=>image.id);
            createNewTask(itemPost);
        } else {
            setState((prevState)=>({
                    ...prevState,
                    newTaskLoading: true
                }));
            itemPost.images = newTask.images?.map((image, index)=>{
                if (image.id) {
                    itemPost.images = [
                        image.id
                    ];
                    createNewTask(itemPost);
                    setState((prevState)=>({
                            ...prevState,
                            itemPost: itemPost,
                            newTaskLoading: false,
                            mode: modeTypes.list,
                            isModal: false
                        }));
                    return image.id;
                } else {
                    setTimeout((args)=>{
                        (0, $3b579ca6158bc61b$export$d6f5c7e166773679)(image.image, $60b19c25b33bb649$var$me, (createdImg)=>{
                            if (createdImg.id) {
                                itemPost.images.push(createdImg.id);
                                if (index === newTask.images.length - 1) {
                                    itemPost.images = itemPost.images?.filter((item)=>!!item);
                                    createNewTask(itemPost);
                                    setState((prevState)=>({
                                            ...prevState,
                                            itemPost: itemPost,
                                            newTaskLoading: false,
                                            mode: modeTypes.list,
                                            isModal: false
                                        }));
                                }
                            } else console.error("image was not created");
                        });
                    }, queueLoadingTimer);
                    queueLoadingTimer += queueLoadingStep;
                }
            });
        }
    };
    const moveNext = (DIRECTION = 1)=>{
        const el = document.querySelector(".vr-card.vr-card--active");
        if (!el) return;
        const rect = el.getBoundingClientRect();
        setState((prevState)=>{
            const { currentIndex: currentIndex, reports: reports, count: count } = prevState;
            if (count === 0) return prevState;
            let newIndex;
            if (DIRECTION === 1 && currentIndex < count - 1) newIndex = currentIndex + 1;
            else if (DIRECTION === -1 && currentIndex > 0) newIndex = currentIndex - 1;
            else return prevState;
            if (newIndex === count - 1) lazyLoad();
            return {
                ...prevState,
                currentIndex: newIndex,
                item: reports[newIndex],
                newTask: setInitTask(),
                isModal: false,
                scrollPosition: rect.top + window.scrollY - 150
            };
        });
    };
    const setApproveRejectState = (type)=>{
        const item = state.reports[state.currentIndex];
        if (!item.picsell_info.object_id || !item.picsell_info.object_type) {
            setIsMsgStatus({
                status: true,
                type: "error",
                message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_object_item_id_msg", $60b19c25b33bb649$var$me.language)
            });
            return;
        }
        const approveRejectStatus = type === "ACCEPT" ? true : false;
        const approveRejectObject = {
            object_id: item.picsell_info.object_id,
            object_type: item.picsell_info.object_type,
            is_approved: approveRejectStatus,
            comment: ""
        };
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "approvals/",
            post: approveRejectObject
        }, (response)=>{
            if (response) {
                approveRejectStatus ? setIsMsgStatus({
                    status: true,
                    type: "success",
                    message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_accept_msg", $60b19c25b33bb649$var$me.language)
                }) : setIsMsgStatus({
                    status: true,
                    type: "success",
                    message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_reject_msg", $60b19c25b33bb649$var$me.language)
                });
                moveNext();
            } else {
                setIsMsgStatus({
                    status: true,
                    type: "warning",
                    message: "Error: " + type + JSON.stringify(response)
                });
                console.log(response);
            }
        });
    };
    const passTaskToModal = (photoIndex)=>{
        let { newTask: newTask, item: item } = state;
        newTask.point = item?.visit?.point?.id || null;
        newTask.end = (0, $3b579ca6158bc61b$export$f996c1bb09f018d3)(newTask.start, 30); // TODO rewrite dateChangeFormat
        newTask.components = [
            {
                id: 3,
                name: (0, $6f1c09625235f1f0$export$a32e78025ed8daad)["photo"],
                value: 3,
                label: (0, $6f1c09625235f1f0$export$a32e78025ed8daad)["photo"]
            }
        ];
        if (item?.url_photo) {
            newTask.images = [
                {
                    image: item.url_photo
                }
            ];
            newTask.imageFromReview = {
                image: item.url_photo
            };
        }
        setState((prevState)=>({
                ...prevState,
                newTask: newTask,
                isModal: true
            }));
    };
    const back = ()=>{
        setState((prevState)=>({
                ...prevState,
                mode: modeTypes.list
            }));
        setTimeout(()=>{
            window.scrollTo(0, state.scrollPosition);
        }, 100);
    };
    const modalCloseSinglePhoto = ()=>{
        setState((prevState)=>({
                ...prevState,
                isModalSingle: false,
                isModal: false,
                loading: false
            }));
        back();
    };
    return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                className: "vr-grid",
                children: [
                    isMsgStatus.status && /*#__PURE__*/ (0, $7uT18.jsx)((0, $cec83a254593e541$export$2e2bcd8739ae039), {
                        setIsMsg: setIsMsgStatus,
                        isMsg: isMsgStatus
                    }),
                    state.reports ? state.reports.map((item, index)=>/*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: `vr-card${state.currentIndex === index ? " vr-card--active" : ""}`,
                            onClick: ()=>openTask(item, index),
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "vr-card-img-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                            src: item.url_photo,
                                            alt: item.id,
                                            className: "vr-card-img"
                                        }),
                                        item.approval && item.approval.is_approved !== null && item.approval.is_approved !== undefined && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "vr-card-status-badge",
                                            children: item.approval.is_approved ? /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "material-symbols-outlined vr-badge--approved",
                                                children: "check_circle"
                                            }) : /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "material-symbols-outlined vr-badge--rejected",
                                                children: "cancel"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "vr-card-info",
                                    children: [
                                        item.additional_info?.tags?.length > 0 && /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                            className: "vr-card-info-tags",
                                            children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "vr-card-info-tags-inn",
                                                children: item.additional_info.tags.map((tag, i)=>/*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "tag-label",
                                                        children: tag
                                                    }, i))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "vr-card-text",
                                            children: [
                                                item.visit?.point?.address,
                                                " ",
                                                item.visit?.point?.name
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item.id)) : null
                ]
            }),
            state.isModalSingle && /*#__PURE__*/ (0, $7uT18.jsx)((0, $fb116da65c30f288$export$2e2bcd8739ae039), {
                isShow: state.isModalSingle,
                isSingle: state.isModalSingle,
                isSupervised: true,
                moveNext: moveNext,
                previewNavigationData: previewNavigationData,
                onClose: modalCloseSinglePhoto,
                children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $4cb165d7f5a45221$export$2e2bcd8739ae039), {
                    item: state.reports[state.currentIndex],
                    acceptRejectAnswer: setApproveRejectState,
                    passTaskToModal: passTaskToModal,
                    moveNext: moveNext,
                    previewNavigationData: previewNavigationData,
                    editBlockData: editBlockData,
                    isLoading: state.loading,
                    gridViewMode: "single",
                    isResetPhotoItem: false
                }, state.reports[state.currentIndex]?.id || state.currentIndex)
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)("p", {
                className: "lazy-visit-downloading",
                style: {
                    display: state.loading ? "block" : "none"
                },
                children: [
                    (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "downloading", $60b19c25b33bb649$var$me?.language ? $60b19c25b33bb649$var$me?.language : "en"),
                    "..."
                ]
            }),
            !state.loading && /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
                children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $6b81634eed285b20$export$f2697cee648344e), {
                    loading: false,
                    onScroll: async ()=>{
                        lazyLoad();
                    }
                })
            })
        ]
    });
}
var $60b19c25b33bb649$export$2e2bcd8739ae039 = $60b19c25b33bb649$var$Report;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $Yxlsx = parcelRequire("Yxlsx");







const $104b11320aab5b3b$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $104b11320aab5b3b$var$Returns({ data: data }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        returns: "",
        loading: false
    });
    (0, $cQmXV.useEffect)(()=>{
        setState((prev)=>({
                ...prev,
                loading: true
            }));
        let url = `visits/${data.id}/returns_in_visit/`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            setState((prev)=>({
                    ...prev,
                    returns: response,
                    loading: false
                }));
        });
    }, [
        data.id
    ]);
    const getDateChange = (item, obj)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        let newDate = new Date(item);
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(newDate).format("DD/MM/yyyy");
        return date;
    };
    const getTaskRowStatusClass = (item)=>{
        if (!item.status) return;
        const str = item.status.toLowerCase();
        const result = str.replace(/ /g, "-");
        return result;
    };
    const getCounterpartyInfo = (item)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: item.name
        });
    };
    const getPhysicalReturn = (string)=>{
        if (!string) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: string
        });
    };
    const getCommentReturn = (item)=>{
        if (!item) return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: "-"
        });
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            children: item
        });
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
            className: "returns-task-tab-wrapper",
            children: state?.returns ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
                children: /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                    data: state.returns,
                    version: "4",
                    striped: true,
                    hover: true,
                    bordered: false,
                    pagination: false,
                    search: false,
                    multiColumnSearch: true,
                    columnFilter: false,
                    options: {
                        ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186)
                    },
                    className: "themed-main-table-container",
                    trClassName: (row)=>`returns-task-tab-item ${getTaskRowStatusClass(row)}`,
                    tableHeaderClass: "primary",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataField: "id",
                            isKey: true,
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_return_id_label", $104b11320aab5b3b$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataField: "status",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_status_return_label", $104b11320aab5b3b$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: getCounterpartyInfo,
                            dataField: "counterparty",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_counterparty_label", $104b11320aab5b3b$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: (item, obj)=>getDateChange(item, obj),
                            dataField: "created",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_return_crated_label", $104b11320aab5b3b$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: getPhysicalReturn,
                            dataField: "date_of_physical_return",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_physical_return_label", $104b11320aab5b3b$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataFormat: getCommentReturn,
                            dataField: "comment",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_comment_label", $104b11320aab5b3b$var$me.language)
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                            dataField: "visit",
                            width: "60px",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_popup_visit_label", $104b11320aab5b3b$var$me.language)
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                loading: state.loading
            })
        })
    });
}
var $104b11320aab5b3b$export$2e2bcd8739ae039 = $104b11320aab5b3b$var$Returns;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

var $Yxlsx = parcelRequire("Yxlsx");










const $1dcd38d87050e439$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $1dcd38d87050e439$var$Tasks({ data: data }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        visits: "",
        loading: false,
        isSelected: false
    });
    const [checkedRows, setCheckedRows] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState([]);
    const [updatedData, getUpdatedData] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    const [isMsgStatus, setIsMsgStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({
        status: false,
        type: "error",
        message: ""
    });
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const statusOrder = {
        "In Progress": 1,
        "Completed": 2,
        "Not Completed": 3
    };
    //default object for approve or reject the task
    const approveRejectObject = {
        object_type: "answer",
        is_approved: null,
        comment: ""
    };
    //Function for sorting  an array
    const sortDataByStatus = (data)=>{
        if (!data) return;
        return data.sort((a, b)=>statusOrder[a.status] - statusOrder[b.status]);
    };
    (0, $cQmXV.useEffect)(()=>{
        setState({
            loading: true
        });
        let url = `visits/${data.id}/tasks_in_visit/`;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: url
        }, (response)=>{
            setState({
                visits: response,
                loading: false
            });
        });
    }, [
        data,
        updatedData
    ]);
    const getTaskAnswerStatus = (answers)=>{
        if (!answers) return;
        return answers.boolean_answer ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_answer_status_yes_label", $1dcd38d87050e439$var$me.language) : answers.boolean_answer === false ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_answer_status_no_label", $1dcd38d87050e439$var$me.language) : null;
    };
    const getType = (item, obj)=>{
        if (!item.name) return;
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: "task-type-name",
            onClick: ()=>onRowClick(obj),
            children: item.name
        });
    };
    const getTitle = (title, obj)=>{
        if (!title) return;
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: "task-title-name",
            onClick: ()=>onRowClick(obj),
            children: title
        });
    };
    const getDescription = (description, obj)=>{
        if (!description) return;
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: "task-title-name",
            onClick: ()=>onRowClick(obj),
            children: description
        });
    };
    const getTaskPriority = (item, obj)=>{
        if (!item) return;
        const statusClass = obj?.status ? `visit-${obj.status.toLowerCase().replace(/ /g, "-")}` : "";
        return /*#__PURE__*/ (0, $7uT18.jsx)("p", {
            className: `visit-task-priority ${statusClass}`,
            onClick: ()=>onRowClick(obj)
        });
    };
    const getTaskAnswerText = (answer)=>{
        if (!answer) return;
        return /*#__PURE__*/ (0, $7uT18.jsx)("p", {
            className: "visit-task-answer-text",
            children: answer.answer
        });
    };
    const getTaskTags = (answers)=>{
        if (!answers) return;
        let tags = null;
        const setTextTagWrapper = (clientTags)=>{
            return clientTags.tags.map((tag, idx)=>/*#__PURE__*/ (0, $7uT18.jsx)("p", {
                    className: "visit-task-tag rounded",
                    children: tag
                }, idx));
        };
        answers.client_and_tags.forEach((items)=>{
            tags = items.tags ? setTextTagWrapper(items) : "";
        });
        return tags;
    };
    const getDeadline = (item, obj)=>{
        if (!item) return;
        let newDate = new Date(item);
        const currentDate = new Date();
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($Yxlsx)))(newDate).format("DD/MM/yyyy");
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: `visit-task-date ${newDate < currentDate ? "deadline" : ""}`,
            onClick: ()=>onRowClick(obj),
            children: date
        });
    };
    const getTaskStatus = (item)=>{
        if (!item) return;
        const str = item.toLowerCase();
        const result = str.replace(/ /g, "-");
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: `visit-task-status visit-${result}`,
            children: item === "In Progress" ? "On review" : item
        });
    };
    const getTaskRowStatusClass = (item)=>{
        if (!item.status) return;
        const str = item.status.toLowerCase();
        const result = str.replace(/ /g, "-");
        return result;
    };
    const createdBy = (item, obj)=>{
        if (!item.id) return;
        return /*#__PURE__*/ (0, $7uT18.jsx)("span", {
            className: "task-title-name",
            onClick: ()=>onRowClick(obj),
            children: item?.first_name + " " + item?.last_name?.toLowerCase()
        });
    };
    const onRowClick = (task)=>{
        (0, $b79edb411f97c469$export$740e95a8bcb6fc23)(task.id, history);
    };
    const handleCheckboxChange = (e, row)=>{
        const isChecked = e.target.checked;
        if (!row.answer?.id) {
            setIsMsgStatus({
                status: true,
                type: "error",
                message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_has_answer_error", $1dcd38d87050e439$var$me.language)
            });
            return;
        }
        if (isChecked) setCheckedRows((prev)=>[
                ...prev,
                row.answer.id
            ]);
        else setCheckedRows((prev)=>prev.filter((id)=>id !== row.answer.id));
    };
    const prepareData = (data)=>{
        return checkedRows.length === 1 ? data[0] : checkedRows.length > 1 ? data : null;
    };
    const approveTask = ()=>{
        const data = prepareData(checkedRows);
        const objSize = Array.isArray(data) ? "object_ids" : "object_id";
        approveRejectObject[objSize] = data;
        approveRejectObject.is_approved = true;
        sentAnswer("ACCEPT", approveRejectObject, Array.isArray(data));
    };
    const rejectTask = ()=>{
        const data = prepareData(checkedRows);
        const objSize = Array.isArray(data) ? "object_ids" : "object_id";
        approveRejectObject[objSize] = data;
        approveRejectObject.is_approved = false;
        sentAnswer("REJECT", approveRejectObject, Array.isArray(data));
    };
    const sentAnswer = (type, body, isArray)=>{
        const approveRejectStatus = type === "ACCEPT" ? true : false;
        const isInValid = isArray ? body.object_ids?.length < 1 : !body.object_id;
        if (isInValid) {
            setIsMsgStatus({
                status: true,
                type: "error",
                message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_has_empty_error", $1dcd38d87050e439$var$me.language)
            });
            return;
        }
        const url = isArray ? "approvals/bulk_approval/" : "approvals/";
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: url,
            post: body
        }, (response)=>{
            if (response) {
                const msg = approveRejectStatus ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_accept_msg", $1dcd38d87050e439$var$me.language) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_reject_msg", $1dcd38d87050e439$var$me.language);
                setIsMsgStatus({
                    status: true,
                    type: "success",
                    message: msg
                });
                setCheckedRows([]);
                getUpdatedData(!updatedData);
            } else {
                setIsMsgStatus({
                    status: true,
                    type: "warning",
                    message: JSON.stringify(response)
                });
                console.log(response);
            }
        });
    };
    const handleSelectAll = ()=>{
        if (checkedRows.length > 0) {
            setCheckedRows([]);
            return;
        }
        const validRowIds = state.visits.filter((row)=>row.answer?.id).map((row)=>row.answer.id);
        if (validRowIds.length === 0) setIsMsgStatus({
            status: true,
            type: "error",
            message: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_has_answer_error", $1dcd38d87050e439$var$me.language)
        });
        setCheckedRows(validRowIds);
    };
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $7uT18.Fragment), {
        children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "visit-task-tab-wrapper",
            children: [
                isMsgStatus.status && /*#__PURE__*/ (0, $7uT18.jsx)((0, $cec83a254593e541$export$2e2bcd8739ae039), {
                    setIsMsg: setIsMsgStatus,
                    isMsg: isMsgStatus
                }),
                state.visits ? /*#__PURE__*/ (0, $7uT18.jsxs)((0, $7uT18.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: `visit-single-btn-wrapper mb-4 ${checkedRows.length > 0 ? "visible" : "hidden"}`,
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                    children: [
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_selected_label", $1dcd38d87050e439$var$me.language),
                                        ": ",
                                        checkedRows.length
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-default approve-visit",
                                    onClick: approveTask,
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {})
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-default reject-visit",
                                    onClick: rejectTask,
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        children: "\xd7"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)((0, $9ad5e71e0db52327$export$f75afe4574aa8f4f), {
                            data: sortDataByStatus(state.visits),
                            version: "4",
                            striped: true,
                            hover: true,
                            bordered: false,
                            pagination: false,
                            search: false,
                            multiColumnSearch: true,
                            columnFilter: false,
                            options: {
                                ...(0, $91ea30cb49819b9a$export$7ac3753ee4f78186)
                            },
                            className: "themed-main-table-container",
                            trClassName: (row)=>`visit-task-tab-item ${getTaskRowStatusClass(row)}`,
                            tableHeaderClass: "primary",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "checkbox",
                                    dataFormat: (cell, row)=>/*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                            type: "checkbox",
                                            checked: checkedRows.includes(row.answer?.id),
                                            onChange: (e)=>handleCheckboxChange(e, row)
                                        }),
                                    width: "50px",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("input", {
                                        type: "checkbox",
                                        checked: checkedRows.length > 0,
                                        onChange: handleSelectAll
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "template",
                                    dataFormat: (item, obj)=>getTaskPriority(item, obj),
                                    isKey: true,
                                    width: "60px"
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: (item, obj)=>getType(item, obj),
                                    dataField: "template",
                                    width: "180px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_type_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "title",
                                    dataFormat: (item, obj)=>getTitle(item, obj),
                                    width: "280px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_task_name_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "description",
                                    dataFormat: (item, obj)=>getDescription(item, obj),
                                    width: "220px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_info_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: (item, obj)=>createdBy(item, obj),
                                    dataField: "created_by",
                                    width: "200px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_createdby_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: (item, obj)=>getDeadline(item, obj),
                                    dataField: "end",
                                    width: "100px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_deadline_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataField: "image_count",
                                    width: "146px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_count_photo_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: getTaskStatus,
                                    dataField: "status",
                                    width: "120px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_status_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: getTaskAnswerStatus,
                                    dataField: "answer",
                                    width: "100px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_answer_status_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: getTaskAnswerText,
                                    dataField: "answer",
                                    width: "100px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_answer_comment_label", $1dcd38d87050e439$var$me.language)
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)((0, $9ad5e71e0db52327$export$857b1c90a79ee78e), {
                                    dataFormat: getTaskTags,
                                    dataField: "answer",
                                    width: "100px",
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_answer_tags_label", $1dcd38d87050e439$var$me.language)
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $cb7aa011a1acb993$export$2e2bcd8739ae039), {
                    loading: state.loading
                })
            ]
        })
    });
}
var $1dcd38d87050e439$export$2e2bcd8739ae039 = $1dcd38d87050e439$var$Tasks;









const $8dae7032dddf1d05$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
class $8dae7032dddf1d05$var$View extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            location: {
                lat: 50.4021379,
                lng: 30.3678885
            },
            showMapItem: false,
            isApprovedTask: false
        };
        this.showMap = this.showMap.bind(this);
        this.approveVisit = this.approveVisit.bind(this);
        this.rejectVisit = this.rejectVisit.bind(this);
    }
    componentDidMount() {
        const { id: id } = this.props.match.params;
        if (id !== "new") this.load(id);
    }
    load = (id)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "visits/" + id + "/"
        }, (item)=>{
            // Guard against a failed/empty response (the API client hands back a benign
            // sentinel without an id) and against a visit whose point has no coordinates.
            if (!item || !item.id) return;
            const location = item.point?.location ? {
                address: item.point.address,
                lat: item.point.location.latitude,
                lng: item.point.location.longitude
            } : this.state.location;
            this.setState({
                item: item,
                location: location
            });
        });
    };
    getVisitInfo() {
        if (!this.state.item?.id) return;
        const visit = this.state.item ? (0, $b79edb411f97c469$export$13ebfc76bc2797eb)(this.state.item.id, this.state.item) : "";
        visit && (visit.spentTime = (0, $b79edb411f97c469$export$59c169eede4fa7cb)(this.state.item));
        visit && (visit.taskStatus = this.state.item.is_approved);
        return visit;
    }
    handleBackClick = ()=>{
        this.props.history.replace("/visit");
    };
    copyToClipboard = ()=>{
        const currentUrl = window.location.origin + this.props.location.pathname;
        navigator.clipboard.writeText(currentUrl).then(()=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success("URL copied to clipboard!");
        }).catch((err)=>{
            console.error("Error: ", err);
        });
    };
    showMap = ()=>{
        this.setState({
            showMapItem: true
        });
    };
    approveVisit = ()=>{
        let { item: item } = this.state;
        if (item.is_approved) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "already_approve_visit_msg", $8dae7032dddf1d05$var$me.language));
            return;
        }
        let body = {
            is_approved: true,
            approved_by: $8dae7032dddf1d05$var$me.id
        };
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PATCH",
            url: "visits/" + item.id + "/",
            post: body
        }, (r)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "approve_visit_msg", $8dae7032dddf1d05$var$me.language));
            this.setState({
                isApprovedTask: true
            });
            this.load(item.id);
        });
    };
    rejectVisit = ()=>{
        let { item: item } = this.state;
        if (item.is_approved === false) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "already_reject_visit_msg", $8dae7032dddf1d05$var$me.language));
            return;
        }
        let body = {
            is_approved: false,
            approved_by: $8dae7032dddf1d05$var$me.id
        };
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PATCH",
            url: "visits/" + item.id + "/",
            post: body
        }, (r)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "reject_visit_msg", $8dae7032dddf1d05$var$me.language));
            this.setState({
                isApprovedTask: false
            });
            this.load(item.id);
        });
    };
    tabValidator = (name)=>{
        let { item: item } = this.state;
        const visitTabTitles = [
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "zvit_tab_name", $8dae7032dddf1d05$var$me.language),
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "task_tab_name", $8dae7032dddf1d05$var$me.language),
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "monitoring_tab_name", $8dae7032dddf1d05$var$me.language),
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_tab_name", $8dae7032dddf1d05$var$me.language),
            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "log_tab_name", $8dae7032dddf1d05$var$me.language)
        ];
        const visitComponents = [
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $60b19c25b33bb649$export$2e2bcd8739ae039), {
                data: item
            }, "report-visit-tab"),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $1dcd38d87050e439$export$2e2bcd8739ae039), {
                data: item
            }, "task-visit-tab"),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $5b1884b6ec98d715$export$2e2bcd8739ae039), {
                data: item
            }, "monitoring-visit-tab"),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $0328b429a87f2283$export$2e2bcd8739ae039), {
                data: item
            }, "surveys-visit-tab"),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $7b102d9d0a799dc7$export$2e2bcd8739ae039), {
                data: item
            }, "log-visit-tab")
        ];
        if ($8dae7032dddf1d05$var$me.company?.features && $8dae7032dddf1d05$var$me.company?.features.includes("orders")) {
            visitTabTitles.unshift((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "orders_tab_name", $8dae7032dddf1d05$var$me.language), (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "returns_tab_name", $8dae7032dddf1d05$var$me.language), (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "payments_tab_name", $8dae7032dddf1d05$var$me.language));
            visitComponents.unshift(/*#__PURE__*/ (0, $7uT18.jsx)((0, $77f8e7c52574ca26$export$2e2bcd8739ae039), {
                data: item
            }, "orders-visit-tab"), /*#__PURE__*/ (0, $7uT18.jsx)((0, $104b11320aab5b3b$export$2e2bcd8739ae039), {
                data: item
            }, "returns-visit-tab"), /*#__PURE__*/ (0, $7uT18.jsx)((0, $509e0d8f4acc2e7c$export$2e2bcd8739ae039), {
                data: item
            }, "payments-visit-tab"));
        }
        return name === "label" ? visitTabTitles : visitComponents;
    };
    modalClose = ()=>this.setState({
            showMapItem: false
        });
    render() {
        let { item: item } = this.state;
        const visit = this.getVisitInfo();
        const statusClass = visit?.taskStatus ? "vs-status--approved" : visit?.taskStatus === false ? "vs-status--rejected" : "vs-status--pending";
        const statusText = visit?.taskStatus ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "approved_single_visit_name", $8dae7032dddf1d05$var$me.language) : visit?.taskStatus === false ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "no_approved_single_visit_name", $8dae7032dddf1d05$var$me.language) : (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "on_verification_single_visit_name", $8dae7032dddf1d05$var$me.language);
        return /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
            className: "container-fluid visit-single-page vs-page",
            children: [
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "vs-top-bar",
                    children: /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                        className: "vs-back-btn",
                        onClick: this.handleBackClick,
                        children: [
                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: "arrow_back"
                            }),
                            (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "back_to_btn_label", $8dae7032dddf1d05$var$me.language)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "vs-hero-card",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "vs-hero-left",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                    className: "vs-point-img-wrap",
                                    children: (0, $dd80b063693a1e94$export$fb85bc5d6d9ef19b)(item?.point?.image) ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                        src: item.point.image,
                                        alt: visit?.name || "",
                                        className: "vs-point-img"
                                    }) : /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                        className: "vs-point-img-fallback",
                                        children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "store"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                    className: "vs-point-info",
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("h2", {
                                            className: "vs-point-name",
                                            children: visit ? visit.name : ""
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                            className: "vs-point-date",
                                            children: [
                                                /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "calendar_today"
                                                }),
                                                visit ? visit.date : ""
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                            className: "vs-hero-meta",
                                            children: [
                                                visit && /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: `vs-status-chip ${statusClass}`,
                                                    children: statusText
                                                }),
                                                visit?.spentTime && /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                    className: "vs-time-chip",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                            className: "material-symbols-outlined",
                                                            children: "schedule"
                                                        }),
                                                        visit.spentTime
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                            className: "vs-hero-right",
                            children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                className: "vs-author-card",
                                children: [
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "vs-author-avatar-wrap",
                                        children: [
                                            (0, $dd80b063693a1e94$export$fb85bc5d6d9ef19b)(item?.user?.photo) ? /*#__PURE__*/ (0, $7uT18.jsx)("img", {
                                                src: item.user.photo,
                                                alt: visit?.author || "",
                                                className: "vs-author-avatar"
                                            }) : /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                                                className: "vs-avatar-fallback",
                                                children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                    className: "material-symbols-outlined",
                                                    children: "person"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: `vs-author-status ${item?.user?.is_active ? "vs-author-status--active" : "vs-author-status--inactive"}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                                        className: "vs-author-info",
                                        children: [
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "vs-author-name",
                                                children: visit ? visit.author : "None"
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                className: "vs-author-role",
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "merchandiser", $8dae7032dddf1d05$var$me.language)
                                            }),
                                            /*#__PURE__*/ (0, $7uT18.jsxs)("span", {
                                                className: "vs-author-phone",
                                                children: [
                                                    /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                                        className: "material-symbols-outlined",
                                                        children: "phone"
                                                    }),
                                                    item?.user?.phone_number || "None"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                    className: "vs-actions-bar",
                    children: [
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "vs-actions-left",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "vs-action-btn vs-action-btn--approve",
                                    onClick: this.approveVisit,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "check_circle"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "approv_btn", $8dae7032dddf1d05$var$me.language)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsxs)("button", {
                                    className: "vs-action-btn vs-action-btn--reject",
                                    onClick: this.rejectVisit,
                                    children: [
                                        /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "cancel"
                                        }),
                                        (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "reject_btn", $8dae7032dddf1d05$var$me.language)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
                            className: "vs-actions-right",
                            children: [
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    className: "vs-icon-action",
                                    onClick: this.copyToClipboard,
                                    title: "Copy link",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "content_copy"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7uT18.jsx)("button", {
                                    className: "vs-icon-action",
                                    onClick: this.showMap,
                                    title: "Show on map",
                                    children: /*#__PURE__*/ (0, $7uT18.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "location_on"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                    className: "vs-tabs-card",
                    children: /*#__PURE__*/ (0, $7uT18.jsx)("div", {
                        className: "tabs-wrapper",
                        children: item ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $79a08f0c966164e4$export$2e2bcd8739ae039), {
                            className: "tabs-list",
                            labels: this.tabValidator("label"),
                            tabs: this.tabValidator("content")
                        }) : null
                    })
                }),
                this.state.showMapItem ? /*#__PURE__*/ (0, $7uT18.jsx)((0, $a99cf2984ca06e8c$export$2e2bcd8739ae039), {
                    location: this.state.location,
                    zoomLevel: 12,
                    isModal: this.state.showMapItem,
                    modalClose: this.modalClose
                }, "map-visit-tab") : null
            ]
        });
    }
}
var $8dae7032dddf1d05$export$2e2bcd8739ae039 = $8dae7032dddf1d05$var$View;



var $7uT18 = parcelRequire("7uT18");

var $cQmXV = parcelRequire("cQmXV");

const $0cb9602690f12a91$export$552522b64eb5db81 = (allowedRoles)=>(WrappedComponent)=>{
        return class WithAuthorization extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
            constructor(props){
                super(props);
            }
            render() {
                const { me: me } = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState();
                if (me) return /*#__PURE__*/ (0, $7uT18.jsx)(WrappedComponent, {
                    ...this.props,
                    currentUser: me
                });
                else {
                    window.location.replace("/");
                    return null;
                }
            }
        };
    };


const $576021dafcea8b48$export$1f44aaf2ec115b54 = (0, $0cb9602690f12a91$export$552522b64eb5db81)([
    1
]);



const $8b71911a3e78f725$var$PrivateRoute = ({ component: Component, ...rest })=>{
    let me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
    return /*#__PURE__*/ (0, $7uT18.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
        ...rest,
        render: (props)=>me ? /*#__PURE__*/ (0, $7uT18.jsx)(Component, {
                ...props,
                ...rest
            }) : /*#__PURE__*/ (0, $7uT18.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                to: "/login"
            })
    });
};
const $8b71911a3e78f725$var$AppRouter = ()=>{
    return /*#__PURE__*/ (0, $7uT18.jsxs)((0, $6f5d68f762d5488a$export$b5d5cf8927ab7262), {
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/login",
                component: (0, $d840257e31fd14f4$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/forgot-password",
                component: (0, $0c0a79c705228dbe$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $7uT18.jsxs)((0, $a1d7e4e3ae62364a$export$c84671f46d6a1ca), {
                children: [
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/",
                        children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                            to: "/merchandiser"
                        })
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/dashboard",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $fac304098907a952$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/overview",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $1aa6f1d8358888de$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/profile",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $464b3d7a8ec63582$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/merchandiser",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("merchandisers"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/merchandiser/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $c99a2835eadd6e89$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $30ad5da16ca1f695$export$771a55a10b0a40ae))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task/new/:type",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $51ef8b1748b26f2f$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $51ef8b1748b26f2f$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task/:id/edit",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $51ef8b1748b26f2f$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task/:id/view",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $51ef8b1748b26f2f$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task-review",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $04b52f7cd217d9e1$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/tasks-import",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $cce5ca651488d6ad$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/tasks-import/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $cce5ca651488d6ad$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        path: "/photo-review",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $a11cc2758244e822$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/document",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $8410c4bcf771fa83$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/k-form",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $271c159bb7207c78$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/bi-report",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $d24c7edf7011cb65$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/route",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $cd7d87f1cc671f57$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/route/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $982a478d060e3bae$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/visit",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $199198b5a2e0dacc$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/visit/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $8dae7032dddf1d05$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/points",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("points"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/points/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("points"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/networks",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("networks"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/networks/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("networks"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/categories",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("categories"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/categories/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("categories"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/countries",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("countries"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/countries/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("countries"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/counties",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("counties"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/counties/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("counties"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/localities",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("localities"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/localities/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("localities"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point_groups",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("point_groups"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point_groups/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("point_groups"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/surveys",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("surveys"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/surveys/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("surveys"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("points"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("points"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/supervisors",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("supervisors"))
                    }),
                    /*#__PURE__*/ (0, $7uT18.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/supervisors/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("supervisors"))
                    })
                ]
            })
        ]
    });
};
var $8b71911a3e78f725$export$2e2bcd8739ae039 = $8b71911a3e78f725$var$AppRouter;


const $aeaaa25a0de5f5fe$var$store = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)();
$aeaaa25a0de5f5fe$var$store.subscribe(()=>{
    const { me: me } = $aeaaa25a0de5f5fe$var$store.getState();
    (0, $67f64b78c4102acd$export$fb931cd598921492)({
        me: me
    });
});
// Last line of defence for async throws that never reach a React boundary
// (rejected promises, event-handler errors). No remote reporting configured — log only.
window.addEventListener("unhandledrejection", (event)=>{
    console.error("Unhandled promise rejection:", event.reason);
});
window.addEventListener("error", (event)=>{
    console.error("Uncaught error:", event.error || event.message);
});
const $aeaaa25a0de5f5fe$var$application = /*#__PURE__*/ (0, $7uT18.jsx)((0, $b83e93e5ef3de8b0$export$2881499e37b75b9a), {
    store: $aeaaa25a0de5f5fe$var$store,
    children: /*#__PURE__*/ (0, $7uT18.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $896e8f74d1491439$export$f2815235e76a62b9), {
                position: "top-center",
                autoClose: 5000,
                limit: 3
            }),
            /*#__PURE__*/ (0, $7uT18.jsx)((0, $c4ecd91a3fcb0ac8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $50f22649d61cdefc$export$9ba4e89fdfa1fc54), {
                    children: /*#__PURE__*/ (0, $7uT18.jsx)((0, $8b71911a3e78f725$export$2e2bcd8739ae039), {})
                })
            })
        ]
    })
});
const $aeaaa25a0de5f5fe$var$root = (0, $3e75b56ae88591f4$exports.createRoot)(document.getElementById("app"));
$aeaaa25a0de5f5fe$var$root.render($aeaaa25a0de5f5fe$var$application);


//# sourceMappingURL=index.49ede36f.js.map
